const dict: Record<number, string> = {};

dict[0x3007] = "líng,xīng"; /* 〇: https://zh.m.wiktionary.org/wiki/%E3%80%87 */
dict[0x3400] = "qiū"; /* 㐀 */
dict[0x3401] = "tiǎn,tiàn"; /* 㐁 */
dict[0x3402] = "xǐ"; /* 㐂 */
dict[0x3405] = "wǔ"; /* 㐅 */
dict[0x3406] = "yǐn,yī"; /* 㐆 */
dict[0x3407] = "jiǔ"; /* 㐇 */
dict[0x3408] = "rù"; /* 㐈 */
dict[0x3409] = "dīng"; /* 㐉 */
dict[0x340a] = "shì"; /* 㐊 */
dict[0x340b] = "tǔ"; /* 㐋 */
dict[0x340c] = "sì,yí"; /* 㐌 */
dict[0x340d] = "zhǎo"; /* 㐍 */
dict[0x340e] = "wén"; /* 㐎 */
dict[0x340f] = "wǔ"; /* 㐏 */
dict[0x3410] = "nú"; /* 㐐 */
dict[0x3411] = "dōng"; /* 㐑 */
dict[0x3412] = "zhào"; /* 㐒 */
dict[0x3413] = "kě"; /* 㐓 */
dict[0x3414] = "xiǎng"; /* 㐔 */
dict[0x3416] = "yè"; /* 㐖 */
dict[0x3417] = "lǎo"; /* 㐗 */
dict[0x3418] = "mǐ"; /* 㐘 */
dict[0x3419] = "dòu"; /* 㐙 */
dict[0x341a] = "wú"; /* 㐚 */
dict[0x341c] = "chóu"; /* 㐜 */
dict[0x341d] = "jū"; /* 㐝 */
dict[0x341e] = "qí"; /* 㐞 */
dict[0x341f] = "fēi"; /* 㐟 */
dict[0x3421] = "nuò"; /* 㐡 */
dict[0x3422] = "fú"; /* 㐢 */
dict[0x3423] = "kù"; /* 㐣 */
dict[0x3424] = "qiú"; /* 㐤 */
dict[0x3425] = "chú"; /* 㐥 */
dict[0x3426] = "jǔ"; /* 㐦 */
dict[0x3428] = "xù"; /* 㐨 */
dict[0x3429] = "xíng"; /* 㐩 */
dict[0x342b] = "xiōng"; /* 㐫 */
dict[0x342c] = "liú"; /* 㐬 */
dict[0x342d] = "lǐn"; /* 㐭 */
dict[0x3430] = "xìn"; /* 㐰 */
dict[0x3431] = "zhěn"; /* 㐱 */
dict[0x3432] = "dài,fú"; /* 㐲 */
dict[0x3433] = "wù"; /* 㐳 */
dict[0x3437] = "mǎ,mà,mián"; /* 㐷 */
dict[0x3438] = "qiàn"; /* 㐸 */
dict[0x3439] = "yì"; /* 㐹 */
dict[0x343a] = "zhòng,yín"; /* 㐺 */
dict[0x343b] = "nèi"; /* 㐻 */
dict[0x343c] = "chèng,zhěng"; /* 㐼 */
dict[0x343e] = "ruǎn,yuàn"; /* 㐾 */
dict[0x3440] = "tài"; /* 㑀 */
dict[0x3442] = "fǎng,páng"; /* 㑂 */
dict[0x3443] = "ǎo"; /* 㑃 */
dict[0x3444] = "wǔ"; /* 㑄 */
dict[0x3445] = "zuò"; /* 㑅 */
dict[0x3447] = "zhòu"; /* 㑇 */
dict[0x3448] = "dòng"; /* 㑈 */
dict[0x3449] = "sù"; /* 㑉 */
dict[0x344a] = "yì"; /* 㑊 */
dict[0x344b] = "jiòng,kǒng,qióng"; /* 㑋 */
dict[0x344d] = "lěi,lèi"; /* 㑍 */
dict[0x344e] = "nǎo"; /* 㑎 */
dict[0x344f] = "zhù"; /* 㑏 */
dict[0x3451] = "lǎn,jì"; /* 㑑 */
dict[0x3454] = "xǔ"; /* 㑔 */
dict[0x3457] = "shēn"; /* 㑗 */
dict[0x3458] = "jiè"; /* 㑘 */
dict[0x3459] = "dié,yǒng"; /* 㑙 */
dict[0x345a] = "nuó"; /* 㑚 */
dict[0x345b] = "sù"; /* 㑛 */
dict[0x345c] = "yì,chì"; /* 㑜 */
dict[0x345d] = "lòng"; /* 㑝 */
dict[0x345e] = "yìng"; /* 㑞 */
dict[0x345f] = "běng,bó,pěng"; /* 㑟 */
dict[0x3463] = "lán"; /* 㑣 */
dict[0x3464] = "miáo"; /* 㑤 */
dict[0x3465] = "yì"; /* 㑥 */
dict[0x3466] = "lì"; /* 㑦 */
dict[0x3467] = "jì"; /* 㑧 */
dict[0x3468] = "yǔ"; /* 㑨 */
dict[0x3469] = "luó"; /* 㑩 */
dict[0x346a] = "chái"; /* 㑪 */
dict[0x346e] = "hún,wén"; /* 㑮 */
dict[0x346f] = "xǔ"; /* 㑯 */
dict[0x3470] = "huì"; /* 㑰 */
dict[0x3471] = "rǎo"; /* 㑱 */
dict[0x3473] = "zhòu"; /* 㑳 */
dict[0x3475] = "hàn,jí,jié,zhǎ,zí"; /* 㑵 */
dict[0x3476] = "xì"; /* 㑶 */
dict[0x3477] = "tài"; /* 㑷 */
dict[0x3478] = "ǎi,yáo,yóu"; /* 㑸 */
dict[0x3479] = "huì"; /* 㑹 */
dict[0x347a] = "jùn"; /* 㑺 */
dict[0x347b] = "mà"; /* 㑻 */
dict[0x347d] = "táng"; /* 㑽 */
dict[0x347e] = "xiáo,yáo"; /* 㑾 */
dict[0x347f] = "zhào"; /* 㑿 */
dict[0x3480] = "zhǎ"; /* 㒀 */
dict[0x3481] = "yǔ,yùn"; /* 㒁 */
dict[0x3482] = "kù,zhuó"; /* 㒂 */
dict[0x3483] = "èr"; /* 㒃 */
dict[0x3484] = "nàng,nèn,rǎn"; /* 㒄 */
dict[0x3485] = "qǐ"; /* 㒅 */
dict[0x3486] = "chì,kè,xì,xiào,yàn"; /* 㒆 */
dict[0x3487] = "mù,wǔ"; /* 㒇 */
dict[0x3488] = "hàn"; /* 㒈 */
dict[0x3489] = "tǎng"; /* 㒉 */
dict[0x348a] = "sè"; /* 㒊 */
dict[0x348c] = "qióng"; /* 㒌 */
dict[0x348d] = "léi,lěi"; /* 㒍 */
dict[0x348e] = "sǎ,sà,tàn"; /* 㒎 */
dict[0x3490] = "xùn"; /* 㒐 */
dict[0x3491] = "huì,kuǐ"; /* 㒑 */
dict[0x3492] = "pú"; /* 㒒 */
dict[0x3493] = "tà"; /* 㒓 */
dict[0x3494] = "shǔ"; /* 㒔 */
dict[0x3496] = "ǒu"; /* 㒖 */
dict[0x3497] = "tái"; /* 㒗 */
dict[0x3499] = "mián"; /* 㒙 */
dict[0x349a] = "wěn"; /* 㒚 */
dict[0x349b] = "diào"; /* 㒛 */
dict[0x349c] = "yú,yǔ"; /* 㒜 */
dict[0x349d] = "miè,wà"; /* 㒝 */
dict[0x349e] = "jùn,kě"; /* 㒞 */
dict[0x349f] = "niǎo"; /* 㒟 */
dict[0x34a0] = "xiè"; /* 㒠 */
dict[0x34a1] = "yóu"; /* 㒡 */
dict[0x34a4] = "shè,chè"; /* 㒤 */
dict[0x34a6] = "lěi"; /* 㒦 */
dict[0x34a7] = "lì"; /* 㒧 */
dict[0x34a9] = "luǒ"; /* 㒩 */
dict[0x34ab] = "jì"; /* 㒫 */
dict[0x34b0] = "quán"; /* 㒰 */
dict[0x34b1] = "mèng"; /* 㒱 */
dict[0x34b2] = "cái"; /* 㒲 */
dict[0x34b3] = "liǎng"; /* 㒳 */
dict[0x34b4] = "gǔ"; /* 㒴 */
dict[0x34b5] = "mào"; /* 㒵 */
dict[0x34b7] = "guǎ,xìng,xǔ"; /* 㒷 */
dict[0x34b8] = "suì,xuán"; /* 㒸 */
dict[0x34b9] = "diān"; /* 㒹 */
dict[0x34bb] = "mào"; /* 㒻 */
dict[0x34bc] = "mán"; /* 㒼 */
dict[0x34be] = "shì"; /* 㒾 */
dict[0x34bf] = "lí"; /* 㒿 */
dict[0x34c1] = "wǎng"; /* 㓁 */
dict[0x34c2] = "kòu"; /* 㓂 */
dict[0x34c3] = "chuí,dù,zhà"; /* 㓃 */
dict[0x34c4] = "zhèn"; /* 㓄 */
dict[0x34c8] = "bèi,bìng,fèi,yè"; /* 㓈 */
dict[0x34c9] = "huàn,huó,huò"; /* 㓉 */
dict[0x34ca] = "dòng"; /* 㓊 */
dict[0x34cb] = "gòng"; /* 㓋 */
dict[0x34ce] = "qīn,qǐn,qìn"; /* 㓎 */
dict[0x34cf] = "jiǒng"; /* 㓏 */
dict[0x34d0] = "lù"; /* 㓐 */
dict[0x34d1] = "xìng"; /* 㓑 */
dict[0x34d3] = "nán"; /* 㓓 */
dict[0x34d4] = "xiè"; /* 㓔 */
dict[0x34d6] = "bì,bié"; /* 㓖 */
dict[0x34d7] = "jié,qǐ"; /* 㓗 */
dict[0x34d8] = "sù"; /* 㓘 */
dict[0x34dc] = "yòu"; /* 㓜 */
dict[0x34dd] = "xíng"; /* 㓝 */
dict[0x34de] = "qì,qià,yáo"; /* 㓞 */
dict[0x34df] = "pí"; /* 㓟 */
dict[0x34e0] = "diàn"; /* 㓠 */
dict[0x34e1] = "fǔ,fǒu"; /* 㓡 */
dict[0x34e2] = "luò"; /* 㓢 */
dict[0x34e3] = "qià"; /* 㓣 */
dict[0x34e4] = "jié,qià"; /* 㓤 */
dict[0x34e6] = "bāi"; /* 㓦 */
dict[0x34e7] = "yǎn"; /* 㓧 */
dict[0x34e8] = "cí,cì"; /* 㓨 */
dict[0x34ea] = "lǎng"; /* 㓪 */
dict[0x34ed] = "hé"; /* 㓭 */
dict[0x34ef] = "lí"; /* 㓯 */
dict[0x34f0] = "huà"; /* 㓰 */
dict[0x34f1] = "tóu"; /* 㓱 */
dict[0x34f2] = "piàn"; /* 㓲 */
dict[0x34f4] = "jùn,ruǎn"; /* 㓴 */
dict[0x34f5] = "è"; /* 㓵 */
dict[0x34f6] = "qiè"; /* 㓶 */
dict[0x34f7] = "yì"; /* 㓷 */
dict[0x34f8] = "jué,zhuó"; /* 㓸 */
dict[0x34f9] = "ruì"; /* 㓹 */
dict[0x34fa] = "jiàn"; /* 㓺 */
dict[0x34fc] = "chì,chòng"; /* 㓼 */
dict[0x34fd] = "chóng"; /* 㓽 */
dict[0x34fe] = "chí"; /* 㓾 */
dict[0x3500] = "lüè,qíng"; /* 㔀 */
dict[0x3502] = "lín"; /* 㔂 */
dict[0x3503] = "jué,pì"; /* 㔃 */
dict[0x3504] = "sù"; /* 㔄 */
dict[0x3505] = "xiào"; /* 㔅 */
dict[0x3506] = "zàn"; /* 㔆 */
dict[0x3507] = "pō"; /* 㔇 */
dict[0x3509] = "zhú"; /* 㔉 */
dict[0x350a] = "dǎn"; /* 㔊 */
dict[0x350b] = "jiàn,lán,làn"; /* 㔋 */
dict[0x350c] = "zhòu"; /* 㔌 */
dict[0x350d] = "duǒ,zhá"; /* 㔍 */
dict[0x350e] = "xiè,yì"; /* 㔎 */
dict[0x350f] = "lì"; /* 㔏 */
dict[0x3511] = "chì,dào,qì,shuì"; /* 㔑 */
dict[0x3512] = "xí"; /* 㔒 */
dict[0x3513] = "jiǎn,xiàn"; /* 㔓 */
dict[0x3515] = "jí,yì"; /* 㔕 */
dict[0x3516] = "jiā"; /* 㔖 */
dict[0x3517] = "fèi"; /* 㔗 */
dict[0x3518] = "chù"; /* 㔘 */
dict[0x3519] = "bǎng,péng"; /* 㔙 */
dict[0x351a] = "kǒu"; /* 㔚 */
dict[0x351b] = "jié"; /* 㔛 */
dict[0x351c] = "bá,bó"; /* 㔜 */
dict[0x351d] = "liǎng"; /* 㔝 */
dict[0x351e] = "kuài,kuàng,wàng"; /* 㔞 */
dict[0x3520] = "hé,jiá"; /* 㔠 */
dict[0x3522] = "jué"; /* 㔢 */
dict[0x3523] = "léi,lèi"; /* 㔣 */
dict[0x3524] = "shěn"; /* 㔤 */
dict[0x3525] = "pí"; /* 㔥 */
dict[0x3526] = "yǎng"; /* 㔦 */
dict[0x3527] = "xuè"; /* 㔧 */
dict[0x3528] = "bèi"; /* 㔨 */
dict[0x3529] = "è"; /* 㔩 */
dict[0x352a] = "lǔ"; /* 㔪 */
dict[0x352d] = "chè,chí,yí"; /* 㔭 */
dict[0x352e] = "nuó"; /* 㔮 */
dict[0x352f] = "suǎn,xuán"; /* 㔯 */
dict[0x3530] = "héng"; /* 㔰 */
dict[0x3531] = "yǔ"; /* 㔱 */
dict[0x3533] = "guǐ,gùn,huán,jué"; /* 㔳 */
dict[0x3534] = "yì"; /* 㔴 */
dict[0x3535] = "xiàn,xuǎn"; /* 㔵 */
dict[0x3536] = "gòng"; /* 㔶 */
dict[0x3537] = "lòu"; /* 㔷 */
dict[0x3539] = "lè"; /* 㔹 */
dict[0x353a] = "shì"; /* 㔺 */
dict[0x353b] = "pī"; /* 㔻 */
dict[0x353c] = "sǔn"; /* 㔼 */
dict[0x353d] = "yào,yǒu"; /* 㔽 */
dict[0x353e] = "jié"; /* 㔾 */
dict[0x353f] = "zòu"; /* 㔿 */
dict[0x3541] = "què"; /* 㕁 */
dict[0x3542] = "yín"; /* 㕂 */
dict[0x3544] = "zhì"; /* 㕄 */
dict[0x3545] = "jiǎ"; /* 㕅 */
dict[0x3546] = "hù"; /* 㕆 */
dict[0x3547] = "lá,lā"; /* 㕇 */
dict[0x3548] = "hòu,yǐ"; /* 㕈 */
dict[0x3549] = "kè"; /* 㕉 */
dict[0x354a] = "fū"; /* 㕊 */
dict[0x354b] = "jìng,qín"; /* 㕋 */
dict[0x354c] = "ài"; /* 㕌 */
dict[0x354e] = "è,kè,kǔn"; /* 㕎 */
dict[0x354f] = "chú"; /* 㕏 */
dict[0x3550] = "xiě"; /* 㕐 */
dict[0x3551] = "chú"; /* 㕑 */
dict[0x3552] = "wéi,wěi,wēi"; /* 㕒 */
dict[0x3555] = "huàn"; /* 㕕 */
dict[0x3556] = "sù"; /* 㕖 */
dict[0x3557] = "yòu"; /* 㕗 */
dict[0x3558] = "cān"; /* 㕘 */
dict[0x3559] = "jùn,ruì"; /* 㕙 */
dict[0x355a] = "zhǎo"; /* 㕚 */
dict[0x355b] = "xù,yǒu,yòu"; /* 㕛 */
dict[0x355c] = "shǐ"; /* 㕜 */
dict[0x355e] = "shuā"; /* 㕞 */
dict[0x355f] = "kuì"; /* 㕟 */
dict[0x3560] = "shuāng"; /* 㕠 */
dict[0x3561] = "hé,hè,huò"; /* 㕡 */
dict[0x3562] = "gài,hài,jù,lǔn,nǒu"; /* 㕢 */
dict[0x3563] = "yǎn,yàn"; /* 㕣 */
dict[0x3564] = "qiú"; /* 㕤 */
dict[0x3565] = "yǐ"; /* 㕥 */
dict[0x3566] = "huà"; /* 㕦 */
dict[0x3567] = "xī"; /* 㕧 */
dict[0x3568] = "fàn"; /* 㕨 */
dict[0x3569] = "zhàng"; /* 㕩 */
dict[0x356a] = "dǎn"; /* 㕪 */
dict[0x356b] = "fǎng"; /* 㕫 */
dict[0x356c] = "sòng"; /* 㕬 */
dict[0x356d] = "ào,bì"; /* 㕭 */
dict[0x356e] = "fǔ,tiào"; /* 㕮 */
dict[0x356f] = "nè"; /* 㕯 */
dict[0x3570] = "hè"; /* 㕰 */
dict[0x3571] = "yóu"; /* 㕱 */
dict[0x3572] = "huá,yíng"; /* 㕲 */
dict[0x3574] = "chén"; /* 㕴 */
dict[0x3575] = "guó,hún,luǒ"; /* 㕵 */
dict[0x3576] = "ň,ňg"; /* 㕶 */
dict[0x3577] = "huà"; /* 㕷 */
dict[0x3578] = "lì"; /* 㕸 */
dict[0x3579] = "fá"; /* 㕹 */
dict[0x357a] = "háo"; /* 㕺 */
dict[0x357b] = "tòu"; /* 㕻 */
dict[0x357d] = "sì"; /* 㕽 */
dict[0x357e] = "xiǎo"; /* 㕾 */
dict[0x3580] = "lè,luò"; /* 㖀 */
dict[0x3581] = "lìn"; /* 㖁 */
dict[0x3582] = "yì"; /* 㖂 */
dict[0x3583] = "hǒu,hòu"; /* 㖃 */
dict[0x3585] = "xù"; /* 㖅 */
dict[0x3586] = "qú,qǔ"; /* 㖆 */
dict[0x3587] = "ér"; /* 㖇 */
dict[0x358f] = "nèi"; /* 㖏 */
dict[0x3590] = "wěi"; /* 㖐 */
dict[0x3591] = "xiè"; /* 㖑 */
dict[0x3592] = "tí"; /* 㖒 */
dict[0x3593] = "hóng"; /* 㖓 */
dict[0x3594] = "tǔn"; /* 㖔 */
dict[0x3595] = "bò,niè"; /* 㖕 */
dict[0x3596] = "niè"; /* 㖖 */
dict[0x3597] = "yín"; /* 㖗 */
dict[0x359c] = "xiǎng"; /* 㖜 */
dict[0x359e] = "wāi"; /* 㖞 */
dict[0x359f] = "shòu"; /* 㖟 */
dict[0x35a0] = "bà,nuò"; /* 㖠 */
dict[0x35a1] = "yè"; /* 㖡 */
dict[0x35a2] = "jí,qí"; /* 㖢 */
dict[0x35a3] = "tòu"; /* 㖣 */
dict[0x35a4] = "hán"; /* 㖤 */
dict[0x35a5] = "jiǒng"; /* 㖥 */
dict[0x35a6] = "dǒng"; /* 㖦 */
dict[0x35a7] = "wěn"; /* 㖧 */
dict[0x35a8] = "lù"; /* 㖨 */
dict[0x35a9] = "sǒu"; /* 㖩 */
dict[0x35aa] = "guó"; /* 㖪 */
dict[0x35ab] = "líng"; /* 㖫 */
dict[0x35ad] = "tiǎn"; /* 㖭 */
dict[0x35ae] = "lún"; /* 㖮 */
dict[0x35b6] = "yè"; /* 㖶 */
dict[0x35b7] = "shí,tí"; /* 㖷 */
dict[0x35b8] = "xué"; /* 㖸 */
dict[0x35b9] = "fèn"; /* 㖹 */
dict[0x35ba] = "chǔn"; /* 㖺 */
dict[0x35bb] = "róu"; /* 㖻 */
dict[0x35bc] = "duǒ,lín,móu"; /* 㖼 */
dict[0x35bd] = "zé,zéi"; /* 㖽 */
dict[0x35be] = "è"; /* 㖾 */
dict[0x35bf] = "xié"; /* 㖿 */
dict[0x35c1] = "è"; /* 㗁 */
dict[0x35c2] = "shěng"; /* 㗂 */
dict[0x35c3] = "wěn,yìn"; /* 㗃 */
dict[0x35c4] = "mán,màn"; /* 㗄 */
dict[0x35c5] = "hú"; /* 㗅 */
dict[0x35c6] = "gé,kài"; /* 㗆 */
dict[0x35c7] = "xiá,ya"; /* 㗇 */
dict[0x35c8] = "màn"; /* 㗈 */
dict[0x35c9] = "bì,è,lüè"; /* 㗉 */
dict[0x35ca] = "jí,qì,bī,léi"; /* 㗊 */
dict[0x35cb] = "hóu"; /* 㗋 */
dict[0x35cc] = "zhì"; /* 㗌 */
dict[0x35d1] = "bài"; /* 㗑 */
dict[0x35d2] = "ài"; /* 㗒 */
dict[0x35d5] = "gòu"; /* 㗕 */
dict[0x35d6] = "dàn"; /* 㗖 */
dict[0x35d7] = "bǎi"; /* 㗗 */
dict[0x35d8] = "bó,fù"; /* 㗘 */
dict[0x35d9] = "nà,chú,zhōu"; /* 㗙 */
dict[0x35da] = "lì"; /* 㗚 */
dict[0x35db] = "xiào"; /* 㗛 */
dict[0x35dc] = "xiù"; /* 㗜 */
dict[0x35e2] = "dòng,hóng"; /* 㗢 */
dict[0x35e3] = "tì"; /* 㗣 */
dict[0x35e4] = "cù"; /* 㗤 */
dict[0x35e5] = "kuò"; /* 㗥 */
dict[0x35e6] = "láo"; /* 㗦 */
dict[0x35e7] = "zhì"; /* 㗧 */
dict[0x35e8] = "ǎi"; /* 㗨 */
dict[0x35e9] = "xī"; /* 㗩 */
dict[0x35eb] = "qiè"; /* 㗫 */
dict[0x35ec] = "zhā"; /* 㗬 */
dict[0x35f0] = "chù,cóng"; /* 㗰 */
dict[0x35f1] = "jí"; /* 㗱 */
dict[0x35f2] = "huò,xì"; /* 㗲 */
dict[0x35f3] = "tǎ"; /* 㗳 */
dict[0x35f4] = "yán"; /* 㗴 */
dict[0x35f5] = "xù"; /* 㗵 */
dict[0x35f7] = "sǎi"; /* 㗷 */
dict[0x35fb] = "guō"; /* 㗻 */
dict[0x35fc] = "yè"; /* 㗼 */
dict[0x35fd] = "xiǎng"; /* 㗽 */
dict[0x35fe] = "xué"; /* 㗾 */
dict[0x35ff] = "hé,xià,xiā"; /* 㗿 */
dict[0x3600] = "zuò"; /* 㘀 */
dict[0x3601] = "yì"; /* 㘁 */
dict[0x3602] = "cí"; /* 㘂 */
dict[0x3603] = "ruò"; /* 㘃 */
dict[0x3604] = "lēng"; /* 㘄 */
dict[0x3605] = "xián"; /* 㘅 */
dict[0x3606] = "tái"; /* 㘆 */
dict[0x3607] = "róng"; /* 㘇 */
dict[0x3608] = "yī,yì"; /* 㘈 */
dict[0x3609] = "zhì"; /* 㘉 */
dict[0x360a] = "yì"; /* 㘊 */
dict[0x360b] = "xián"; /* 㘋 */
dict[0x360c] = "jù"; /* 㘌 */
dict[0x360d] = "jí,qì"; /* 㘍 */
dict[0x360e] = "hǎn,hàn"; /* 㘎 */
dict[0x3610] = "pào,pěng"; /* 㘐 */
dict[0x3611] = "lì"; /* 㘑 */
dict[0x3613] = "lán"; /* 㘓 */
dict[0x3614] = "cǎn,sǎi"; /* 㘔 */
dict[0x3615] = "hǎn,lán"; /* 㘕 */
dict[0x3616] = "yán"; /* 㘖 */
dict[0x3619] = "yán,yǎn"; /* 㘙 */
dict[0x361a] = "hǎn"; /* 㘚 */
dict[0x361c] = "chǐ,chóu,chù"; /* 㘜 */
dict[0x361d] = "niǎn,niè,nà,lǎn"; /* 㘝 */
dict[0x361e] = "huò"; /* 㘞 */
dict[0x3620] = "bì,mì"; /* 㘠 */
dict[0x3621] = "xiá"; /* 㘡 */
dict[0x3622] = "wěng"; /* 㘢 */
dict[0x3623] = "xuán,yuán"; /* 㘣 */
dict[0x3625] = "yóu"; /* 㘥 */
dict[0x3626] = "qín"; /* 㘦 */
dict[0x3627] = "xù"; /* 㘧 */
dict[0x3628] = "nèi"; /* 㘨 */
dict[0x3629] = "bì"; /* 㘩 */
dict[0x362a] = "hào"; /* 㘪 */
dict[0x362b] = "jǐng"; /* 㘫 */
dict[0x362c] = "ào"; /* 㘬 */
dict[0x362d] = "ào"; /* 㘭 */
dict[0x3632] = "jú"; /* 㘲 */
dict[0x3634] = "zuò"; /* 㘴 */
dict[0x3635] = "bù"; /* 㘵 */
dict[0x3636] = "jié"; /* 㘶 */
dict[0x3637] = "ài"; /* 㘷 */
dict[0x3638] = "zàng"; /* 㘸 */
dict[0x3639] = "cí"; /* 㘹 */
dict[0x363a] = "fá"; /* 㘺 */
dict[0x363f] = "niè"; /* 㘿 */
dict[0x3640] = "liù"; /* 㙀 */
dict[0x3641] = "mǎng,méi,mèi,mù,nà"; /* 㙁 */
dict[0x3642] = "duì"; /* 㙂 */
dict[0x3644] = "bì"; /* 㙄 */
dict[0x3645] = "bǎo"; /* 㙅 */
dict[0x3647] = "chù"; /* 㙇 */
dict[0x3648] = "hán,xià"; /* 㙈 */
dict[0x3649] = "tiǎn"; /* 㙉 */
dict[0x364a] = "cháng,zhàng"; /* 㙊 */
dict[0x364d] = "duō"; /* 㙍 */
dict[0x364f] = "fù"; /* 㙏 */
dict[0x3650] = "duǒ"; /* 㙐 */
dict[0x3651] = "yǔ"; /* 㙑 */
dict[0x3652] = "yě"; /* 㙒 */
dict[0x3653] = "kuí"; /* 㙓 */
dict[0x3654] = "hán"; /* 㙔 */
dict[0x3655] = "kuài"; /* 㙕 */
dict[0x3657] = "kuài"; /* 㙗 */
dict[0x3659] = "lǒng"; /* 㙙 */
dict[0x365a] = "xīng"; /* 㙚 */
dict[0x365b] = "bǔ"; /* 㙛 */
dict[0x365c] = "chí,tái"; /* 㙜 */
dict[0x365d] = "xié"; /* 㙝 */
dict[0x365e] = "niè"; /* 㙞 */
dict[0x365f] = "lǎng"; /* 㙟 */
dict[0x3660] = "yì,yī"; /* 㙠 */
dict[0x3662] = "mán,mén"; /* 㙢 */
dict[0x3663] = "zhàng"; /* 㙣 */
dict[0x3664] = "xià"; /* 㙤 */
dict[0x3665] = "gǔn"; /* 㙥 */
dict[0x3666] = "xié"; /* 㙦 */
dict[0x3668] = "jì,qí"; /* 㙨 */
dict[0x3669] = "liáo"; /* 㙩 */
dict[0x366a] = "yè,yì"; /* 㙪 */
dict[0x366b] = "jí"; /* 㙫 */
dict[0x366c] = "yín"; /* 㙬 */
dict[0x366e] = "dā,da"; /* 㙮 */
dict[0x366f] = "yì"; /* 㙯 */
dict[0x3670] = "xiè"; /* 㙰 */
dict[0x3671] = "hào"; /* 㙱 */
dict[0x3672] = "yǒng"; /* 㙲 */
dict[0x3673] = "hǎn,hé,kǎn"; /* 㙳 */
dict[0x3674] = "chàn,zhàn"; /* 㙴 */
dict[0x3675] = "tái"; /* 㙵 */
dict[0x3676] = "táng"; /* 㙶 */
dict[0x3677] = "zhí"; /* 㙷 */
dict[0x3678] = "bào,bó,pú"; /* 㙸 */
dict[0x3679] = "méng"; /* 㙹 */
dict[0x367a] = "guì,kuí"; /* 㙺 */
dict[0x367b] = "chán,qiè,zàn"; /* 㙻 */
dict[0x367c] = "lěi"; /* 㙼 */
dict[0x367e] = "xì,xué"; /* 㙾 */
dict[0x3681] = "qiáo,qiào,qù"; /* 㚁 */
dict[0x3682] = "ráng"; /* 㚂 */
dict[0x3683] = "yún,yùn,yūn"; /* 㚃 */
dict[0x3685] = "lóng"; /* 㚅 */
dict[0x3686] = "fù"; /* 㚆 */
dict[0x3687] = "zōng"; /* 㚇 */
dict[0x3689] = "gǔ"; /* 㚉 */
dict[0x368a] = "kāi"; /* 㚊 */
dict[0x368c] = "huà,huǒ"; /* 㚌 */
dict[0x368d] = "guó,kuǐ,kuì"; /* 㚍 */
dict[0x368f] = "gǎo"; /* 㚏 */
dict[0x3690] = "tào"; /* 㚐 */
dict[0x3692] = "shǎn"; /* 㚒 */
dict[0x3693] = "lái,lǎi"; /* 㚓 */
dict[0x3694] = "niè"; /* 㚔 */
dict[0x3695] = "fú,bì"; /* 㚕 */
dict[0x3696] = "gǎo"; /* 㚖 */
dict[0x3697] = "qié,xié"; /* 㚗 */
dict[0x3698] = "bàn"; /* 㚘 */
dict[0x369b] = "xì"; /* 㚛 */
dict[0x369c] = "xù,yù"; /* 㚜 */
dict[0x369d] = "kuí"; /* 㚝 */
dict[0x369e] = "měng,shěn,yìng,yùn"; /* 㚞 */
dict[0x369f] = "chuò"; /* 㚟 */
dict[0x36a1] = "jǐ"; /* 㚡 */
dict[0x36a2] = "nú"; /* 㚢 */
dict[0x36a3] = "jiāo,xiáo"; /* 㚣 */
dict[0x36a4] = "yì"; /* 㚤 */
dict[0x36a5] = "yú"; /* 㚥 */
dict[0x36a6] = "yí"; /* 㚦 */
dict[0x36a7] = "yǎn"; /* 㚧 */
dict[0x36a9] = "rǎn"; /* 㚩 */
dict[0x36aa] = "hào"; /* 㚪 */
dict[0x36ab] = "shà,zhà"; /* 㚫 */
dict[0x36ad] = "yóu"; /* 㚭 */
dict[0x36af] = "xín,xún"; /* 㚯 */
dict[0x36b0] = "bǐ"; /* 㚰 */
dict[0x36b2] = "diǎn,shàn,chān"; /* 㚲 */
dict[0x36b4] = "bù"; /* 㚴 */
dict[0x36b6] = "sì"; /* 㚶 */
dict[0x36b7] = "ěr,nǎi"; /* 㚷 */
dict[0x36b8] = "sī"; /* 㚸 */
dict[0x36b9] = "mǎo"; /* 㚹 */
dict[0x36ba] = "yùn"; /* 㚺 */
dict[0x36bb] = "jī"; /* 㚻 */
dict[0x36bd] = "qiǎo"; /* 㚽 */
dict[0x36bf] = "páo"; /* 㚿 */
dict[0x36c2] = "nuǒ"; /* 㛂 */
dict[0x36c3] = "jié"; /* 㛃 */
dict[0x36c4] = "yī"; /* 㛄 */
dict[0x36c5] = "èr"; /* 㛅 */
dict[0x36c6] = "duǒ,duò"; /* 㛆 */
dict[0x36ca] = "duǒ"; /* 㛊 */
dict[0x36cd] = "qiè"; /* 㛍 */
dict[0x36cf] = "òu,qiú"; /* 㛏 */
dict[0x36d0] = "sǎo"; /* 㛐 */
dict[0x36d1] = "càn"; /* 㛑 */
dict[0x36d2] = "dòu"; /* 㛒 */
dict[0x36d4] = "péng"; /* 㛔 */
dict[0x36d5] = "yì"; /* 㛕 */
dict[0x36d6] = "suō"; /* 㛖 */
dict[0x36d7] = "zuò,qiē"; /* 㛗 */
dict[0x36d8] = "pò"; /* 㛘 */
dict[0x36d9] = "qiè,qín,shěn,shèn"; /* 㛙 */
dict[0x36da] = "tǒng"; /* 㛚 */
dict[0x36db] = "xìn,zhèn"; /* 㛛 */
dict[0x36dc] = "yóu"; /* 㛜 */
dict[0x36dd] = "bèi,bèng"; /* 㛝 */
dict[0x36de] = "lòng"; /* 㛞 */
dict[0x36e3] = "yún"; /* 㛣 */
dict[0x36e5] = "tà"; /* 㛥 */
dict[0x36e6] = "lǎn"; /* 㛦 */
dict[0x36e7] = "mǎn"; /* 㛧 */
dict[0x36e8] = "qiǎng"; /* 㛨 */
dict[0x36e9] = "zhóu"; /* 㛩 */
dict[0x36ea] = "yàn,yuán"; /* 㛪 */
dict[0x36ec] = "lù"; /* 㛬 */
dict[0x36ee] = "sǎo"; /* 㛮 */
dict[0x36ef] = "miǎn"; /* 㛯 */
dict[0x36f1] = "ruì,wěi"; /* 㛱 */
dict[0x36f2] = "fà"; /* 㛲 */
dict[0x36f3] = "chà,yì"; /* 㛳 */
dict[0x36f4] = "nǎo"; /* 㛴 */
dict[0x36f6] = "chóu,tán,tàn"; /* 㛶 */
dict[0x36f8] = "shù"; /* 㛸 */
dict[0x36f9] = "pián"; /* 㛹 */
dict[0x36fb] = "kuǐ"; /* 㛻 */
dict[0x36fc] = "shà,chā"; /* 㛼 */
dict[0x36fe] = "xián"; /* 㛾 */
dict[0x36ff] = "zhì"; /* 㛿 */
dict[0x3703] = "liàn,liáo,máng"; /* 㜃 */
dict[0x3704] = "xún"; /* 㜄 */
dict[0x3705] = "xù"; /* 㜅 */
dict[0x3706] = "mì"; /* 㜆 */
dict[0x3707] = "huì,yè"; /* 㜇 */
dict[0x3708] = "mù"; /* 㜈 */
dict[0x370a] = "pàng,zhǎn"; /* 㜊 */
dict[0x370b] = "yì"; /* 㜋 */
dict[0x370c] = "gòu"; /* 㜌 */
dict[0x370d] = "táng"; /* 㜍 */
dict[0x370e] = "xī,xì"; /* 㜎 */
dict[0x370f] = "yún"; /* 㜏 */
dict[0x3710] = "shù"; /* 㜐 */
dict[0x3711] = "fú,pó"; /* 㜑 */
dict[0x3712] = "yì"; /* 㜒 */
dict[0x3713] = "dá"; /* 㜓 */
dict[0x3715] = "lián"; /* 㜕 */
dict[0x3716] = "cáo"; /* 㜖 */
dict[0x3717] = "cǎn,chú,xuàn"; /* 㜗 */
dict[0x3718] = "jù"; /* 㜘 */
dict[0x3719] = "lù"; /* 㜙 */
dict[0x371a] = "sù"; /* 㜚 */
dict[0x371b] = "nèn,ruǎn"; /* 㜛 */
dict[0x371c] = "ào"; /* 㜜 */
dict[0x371d] = "ǎn,àn"; /* 㜝 */
dict[0x371e] = "qiàn"; /* 㜞 */
dict[0x3723] = "rán,niàn"; /* 㜣 */
dict[0x3724] = "shěn,niǎn"; /* 㜤 */
dict[0x3725] = "mái,mó"; /* 㜥 */
dict[0x3726] = "hàn,niè,sì,xié,xín"; /* 㜦 */
dict[0x3727] = "yuè"; /* 㜧 */
dict[0x3728] = "ér,nái"; /* 㜨 */
dict[0x3729] = "ào"; /* 㜩 */
dict[0x372a] = "xiǎn"; /* 㜪 */
dict[0x372b] = "mà,méi,měi"; /* 㜫 */
dict[0x372d] = "dāng"; /* 㜭 */
dict[0x372e] = "làn"; /* 㜮 */
dict[0x3730] = "yuè"; /* 㜰 */
dict[0x3731] = "dòng,zhì"; /* 㜱 */
dict[0x3732] = "wěng,yíng"; /* 㜲 */
dict[0x3733] = "huái"; /* 㜳 */
dict[0x3734] = "mèng"; /* 㜴 */
dict[0x3735] = "niǎo"; /* 㜵 */
dict[0x3736] = "fàn"; /* 㜶 */
dict[0x3737] = "mí,nǎi,xiǎn"; /* 㜷 */
dict[0x3738] = "niè"; /* 㜸 */
dict[0x3739] = "qú"; /* 㜹 */
dict[0x373a] = "zàn"; /* 㜺 */
dict[0x373b] = "liàn"; /* 㜻 */
dict[0x373c] = "zhí,zhì"; /* 㜼 */
dict[0x373d] = "zǐ"; /* 㜽 */
dict[0x373e] = "hái"; /* 㜾 */
dict[0x373f] = "xù"; /* 㜿 */
dict[0x3740] = "hào"; /* 㝀 */
dict[0x3741] = "xún"; /* 㝁 */
dict[0x3742] = "zhì"; /* 㝂 */
dict[0x3743] = "fàn,miǎn,wǎn"; /* 㝃 */
dict[0x3744] = "chún,qì,rùn"; /* 㝄 */
dict[0x3745] = "gòu"; /* 㝅 */
dict[0x3747] = "chún"; /* 㝇 */
dict[0x3748] = "luán"; /* 㝈 */
dict[0x3749] = "zhù"; /* 㝉 */
dict[0x374a] = "shǒu"; /* 㝊 */
dict[0x374b] = "liáo,liǎo,liú"; /* 㝋 */
dict[0x374c] = "jié,jiù,zhòu"; /* 㝌 */
dict[0x374d] = "xiě"; /* 㝍 */
dict[0x374e] = "dìng"; /* 㝎 */
dict[0x374f] = "jiè"; /* 㝏 */
dict[0x3750] = "róng"; /* 㝐 */
dict[0x3751] = "máng,páng"; /* 㝑 */
dict[0x3753] = "gé,kè"; /* 㝓 */
dict[0x3754] = "yào"; /* 㝔 */
dict[0x3755] = "níng"; /* 㝕 */
dict[0x3756] = "yí,yín"; /* 㝖 */
dict[0x3757] = "láng"; /* 㝗 */
dict[0x3758] = "yóng"; /* 㝘 */
dict[0x3759] = "yín"; /* 㝙 */
dict[0x375b] = "sù"; /* 㝛 */
dict[0x375d] = "lín"; /* 㝝 */
dict[0x375e] = "yā"; /* 㝞 */
dict[0x375f] = "máo,mào,kuān"; /* 㝟 */
dict[0x3760] = "míng"; /* 㝠 */
dict[0x3761] = "zuì"; /* 㝡 */
dict[0x3762] = "yǔ"; /* 㝢 */
dict[0x3763] = "yè,yì"; /* 㝣 */
dict[0x3764] = "gòu"; /* 㝤 */
dict[0x3765] = "mǐ"; /* 㝥 */
dict[0x3766] = "jùn,yá"; /* 㝦 */
dict[0x3767] = "wěn"; /* 㝧 */
dict[0x3769] = "kāng"; /* 㝩 */
dict[0x376a] = "diàn,dǐng"; /* 㝪 */
dict[0x376b] = "lóng"; /* 㝫 */
dict[0x376c] = "hú"; /* 㝬 */
dict[0x376d] = "xǐng"; /* 㝭 */
dict[0x376e] = "cuì"; /* 㝮 */
dict[0x376f] = "qiáo"; /* 㝯 */
dict[0x3770] = "mián"; /* 㝰 */
dict[0x3771] = "mèng"; /* 㝱 */
dict[0x3772] = "qǐn"; /* 㝲 */
dict[0x3774] = "wán"; /* 㝴 */
dict[0x3775] = "dé"; /* 㝵 */
dict[0x3776] = "ài,dé"; /* 㝶 */
dict[0x3778] = "biàn"; /* 㝸 */
dict[0x3779] = "nóu"; /* 㝹 */
dict[0x377a] = "lián,lín"; /* 㝺 */
dict[0x377b] = "jǐn"; /* 㝻 */
dict[0x377c] = "yū"; /* 㝼 */
dict[0x377d] = "chuí,shuǐ,zhuǐ"; /* 㝽 */
dict[0x377e] = "zuǒ"; /* 㝾 */
dict[0x377f] = "bó,bǒ,fù,qiàn"; /* 㝿 */
dict[0x3781] = "yào"; /* 㞁 */
dict[0x3782] = "tuǐ"; /* 㞂 */
dict[0x3783] = "jí"; /* 㞃 */
dict[0x3785] = "guǒ"; /* 㞅 */
dict[0x3786] = "jǐ"; /* 㞆 */
dict[0x3787] = "wěi"; /* 㞇 */
dict[0x378a] = "xù"; /* 㞊 */
dict[0x378b] = "niǎn"; /* 㞋 */
dict[0x378c] = "yùn"; /* 㞌 */
dict[0x378e] = "bǎ,fú,pá"; /* 㞎 */
dict[0x378f] = "zhé"; /* 㞏 */
dict[0x3790] = "jū"; /* 㞐 */
dict[0x3791] = "wěi"; /* 㞑 */
dict[0x3792] = "xì,xiè"; /* 㞒 */
dict[0x3793] = "qǐ,qì"; /* 㞓 */
dict[0x3794] = "yí"; /* 㞔 */
dict[0x3795] = "xiè"; /* 㞕 */
dict[0x3796] = "cì"; /* 㞖 */
dict[0x3797] = "qiú"; /* 㞗 */
dict[0x3798] = "tún"; /* 㞘 */
dict[0x3799] = "niào"; /* 㞙 */
dict[0x379a] = "qì,zhǎ"; /* 㞚 */
dict[0x379b] = "jǐ"; /* 㞛 */
dict[0x379e] = "sóng"; /* 㞞 */
dict[0x379f] = "diàn"; /* 㞟 */
dict[0x37a0] = "láo,liáo"; /* 㞠 */
dict[0x37a1] = "zhǎn"; /* 㞡 */
dict[0x37a4] = "yín"; /* 㞤 */
dict[0x37a5] = "cén"; /* 㞥 */
dict[0x37a6] = "jǐ"; /* 㞦 */
dict[0x37a7] = "huì"; /* 㞧 */
dict[0x37a8] = "zǎi,zǐ"; /* 㞨 */
dict[0x37a9] = "lán"; /* 㞩 */
dict[0x37aa] = "náo"; /* 㞪 */
dict[0x37ab] = "jù,zǒu"; /* 㞫 */
dict[0x37ac] = "qìn"; /* 㞬 */
dict[0x37ad] = "dài"; /* 㞭 */
dict[0x37af] = "jié"; /* 㞯 */
dict[0x37b0] = "xǔ"; /* 㞰 */
dict[0x37b2] = "yòng"; /* 㞲 */
dict[0x37b3] = "dǒu"; /* 㞳 */
dict[0x37b4] = "chí"; /* 㞴 */
dict[0x37b6] = "mǐn"; /* 㞶 */
dict[0x37b7] = "huáng"; /* 㞷 */
dict[0x37b8] = "suì"; /* 㞸 */
dict[0x37b9] = "kě"; /* 㞹 */
dict[0x37ba] = "zú"; /* 㞺 */
dict[0x37bb] = "hào"; /* 㞻 */
dict[0x37bc] = "chéng,shèng,zhé"; /* 㞼 */
dict[0x37bd] = "xuè"; /* 㞽 */
dict[0x37be] = "ní,yì"; /* 㞾 */
dict[0x37bf] = "chì,qí"; /* 㞿 */
dict[0x37c0] = "lián"; /* 㟀 */
dict[0x37c1] = "àn"; /* 㟁 */
dict[0x37c2] = "chǐ,mǔ"; /* 㟂 */
dict[0x37c3] = "sī"; /* 㟃 */
dict[0x37c4] = "xiáng"; /* 㟄 */
dict[0x37c5] = "yáng"; /* 㟅 */
dict[0x37c6] = "huá"; /* 㟆 */
dict[0x37c7] = "cuó,cuǒ"; /* 㟇 */
dict[0x37c8] = "qiú"; /* 㟈 */
dict[0x37c9] = "láo"; /* 㟉 */
dict[0x37ca] = "fú"; /* 㟊 */
dict[0x37cb] = "duì"; /* 㟋 */
dict[0x37cc] = "máng"; /* 㟌 */
dict[0x37cd] = "láng"; /* 㟍 */
dict[0x37ce] = "tuǒ"; /* 㟎 */
dict[0x37cf] = "hán"; /* 㟏 */
dict[0x37d0] = "mǎng"; /* 㟐 */
dict[0x37d1] = "bó"; /* 㟑 */
dict[0x37d3] = "qí"; /* 㟓 */
dict[0x37d4] = "hán"; /* 㟔 */
dict[0x37d6] = "lòng"; /* 㟖 */
dict[0x37d8] = "tiáo"; /* 㟘 */
dict[0x37d9] = "lǎo,zé,zhái"; /* 㟙 */
dict[0x37da] = "qí"; /* 㟚 */
dict[0x37db] = "zàn"; /* 㟛 */
dict[0x37dc] = "mí"; /* 㟜 */
dict[0x37dd] = "péi,pǒu"; /* 㟝 */
dict[0x37de] = "zhàn"; /* 㟞 */
dict[0x37df] = "xiàng"; /* 㟟 */
dict[0x37e0] = "gǎng"; /* 㟠 */
dict[0x37e2] = "qí"; /* 㟢 */
dict[0x37e4] = "lù"; /* 㟤 */
dict[0x37e6] = "yùn"; /* 㟦 */
dict[0x37e7] = "è,niè,xùn"; /* 㟧 */
dict[0x37e8] = "quán"; /* 㟨 */
dict[0x37e9] = "mín,mǐn,wěn"; /* 㟩 */
dict[0x37ea] = "wěi"; /* 㟪 */
dict[0x37eb] = "quán"; /* 㟫 */
dict[0x37ec] = "shǔ,sǒu"; /* 㟬 */
dict[0x37ed] = "mín"; /* 㟭 */
dict[0x37ee] = "tū"; /* 㟮 */
dict[0x37ef] = "è"; /* 㟯 */
dict[0x37f0] = "mǐng"; /* 㟰 */
dict[0x37f1] = "yǎo"; /* 㟱 */
dict[0x37f2] = "jué,yuán"; /* 㟲 */
dict[0x37f3] = "lì"; /* 㟳 */
dict[0x37f4] = "kuài,kuǐ,wěi"; /* 㟴 */
dict[0x37f5] = "gǎng"; /* 㟵 */
dict[0x37f6] = "yuán"; /* 㟶 */
dict[0x37f7] = "da"; /* 㟷 */
dict[0x37f9] = "láo"; /* 㟹 */
dict[0x37fa] = "lóu"; /* 㟺 */
dict[0x37fb] = "qiàn"; /* 㟻 */
dict[0x37fc] = "áo"; /* 㟼 */
dict[0x37fd] = "biǎo"; /* 㟽 */
dict[0x37ff] = "máng,mǎng"; /* 㟿 */
dict[0x3800] = "dǎo"; /* 㠀 */
dict[0x3802] = "áo"; /* 㠂 */
dict[0x3804] = "xí"; /* 㠄 */
dict[0x3805] = "fú,fù"; /* 㠅 */
dict[0x3807] = "jiù"; /* 㠇 */
dict[0x3808] = "rùn"; /* 㠈 */
dict[0x3809] = "tóng"; /* 㠉 */
dict[0x380b] = "è"; /* 㠋 */
dict[0x380d] = "jí,jié,qì"; /* 㠍 */
dict[0x380e] = "qì"; /* 㠎 */
dict[0x380f] = "huá"; /* 㠏 */
dict[0x3810] = "jiào"; /* 㠐 */
dict[0x3811] = "zuì"; /* 㠑 */
dict[0x3812] = "biǎo"; /* 㠒 */
dict[0x3813] = "méng"; /* 㠓 */
dict[0x3814] = "bài"; /* 㠔 */
dict[0x3815] = "wěi"; /* 㠕 */
dict[0x3816] = "jì,yǐ"; /* 㠖 */
dict[0x3817] = "ào,wò"; /* 㠗 */
dict[0x3818] = "yǔ"; /* 㠘 */
dict[0x3819] = "háo"; /* 㠙 */
dict[0x381a] = "duì,zhuó"; /* 㠚 */
dict[0x381b] = "wò"; /* 㠛 */
dict[0x381c] = "nì"; /* 㠜 */
dict[0x381d] = "cuán"; /* 㠝 */
dict[0x381f] = "lí"; /* 㠟 */
dict[0x3820] = "lú"; /* 㠠 */
dict[0x3821] = "niǎo"; /* 㠡 */
dict[0x3822] = "huái"; /* 㠢 */
dict[0x3823] = "lài,lì"; /* 㠣 */
dict[0x3825] = "lǜ"; /* 㠥 */
dict[0x3827] = "mí,mǐ"; /* 㠧 */
dict[0x3828] = "yù"; /* 㠨 */
dict[0x382a] = "jù"; /* 㠪 */
dict[0x382b] = "gū"; /* 㠫 */
dict[0x382c] = "gū"; /* 㠬 */
dict[0x382d] = "zhǎn,zhàn"; /* 㠭 */
dict[0x382f] = "yǐ"; /* 㠯 */
dict[0x3831] = "jì,qǐ"; /* 㠱 */
dict[0x3832] = "bǐ"; /* 㠲 */
dict[0x3834] = "rèn"; /* 㠴 */
dict[0x3835] = "huāng"; /* 㠵 */
dict[0x3836] = "fán"; /* 㠶 */
dict[0x3837] = "gé"; /* 㠷 */
dict[0x3838] = "kù"; /* 㠸 */
dict[0x3839] = "jiè"; /* 㠹 */
dict[0x383a] = "miáo"; /* 㠺 */
dict[0x383d] = "tóng"; /* 㠽 */
dict[0x383f] = "cǐ"; /* 㠿 */
dict[0x3840] = "bì"; /* 㡀 */
dict[0x3841] = "kǎi,kuà"; /* 㡁 */
dict[0x3842] = "lì"; /* 㡂 */
dict[0x3844] = "sǔn,xún"; /* 㡄 */
dict[0x3845] = "nuǒ"; /* 㡅 */
dict[0x3846] = "huāng"; /* 㡆 */
dict[0x3847] = "jí,zhé"; /* 㡇 */
dict[0x3848] = "mén,wèn"; /* 㡈 */
dict[0x3849] = "xián,yán"; /* 㡉 */
dict[0x384a] = "qià,qiǎn"; /* 㡊 */
dict[0x384b] = "è,yé"; /* 㡋 */
dict[0x384c] = "mào,mèi"; /* 㡌 */
dict[0x384f] = "tóu,shū"; /* 㡏 */
dict[0x3851] = "qiǎo"; /* 㡑 */
dict[0x3852] = "zhūn"; /* 㡒 */
dict[0x3854] = "wù,mù"; /* 㡔 */
dict[0x3856] = "chuáng"; /* 㡖 */
dict[0x3857] = "tí"; /* 㡗 */
dict[0x3858] = "lián"; /* 㡘 */
dict[0x3859] = "bī,pí"; /* 㡙 */
dict[0x385b] = "máng"; /* 㡛 */
dict[0x385c] = "xuě"; /* 㡜 */
dict[0x385d] = "fèng,fú"; /* 㡝 */
dict[0x385e] = "lěi,lóu"; /* 㡞 */
dict[0x3860] = "zhèng"; /* 㡠 */
dict[0x3861] = "chú"; /* 㡡 */
dict[0x3862] = "màn"; /* 㡢 */
dict[0x3863] = "lóng"; /* 㡣 */
dict[0x3865] = "yǐn"; /* 㡥 */
dict[0x3867] = "zhèng"; /* 㡧 */
dict[0x3868] = "qiān,jiān"; /* 㡨 */
dict[0x3869] = "luán"; /* 㡩 */
dict[0x386a] = "nié"; /* 㡪 */
dict[0x386b] = "yì"; /* 㡫 */
dict[0x386d] = "jì"; /* 㡭 */
dict[0x386e] = "jí"; /* 㡮 */
dict[0x386f] = "zhái,dù"; /* 㡯 */
dict[0x3870] = "yǔ"; /* 㡰 */
dict[0x3871] = "jiǔ"; /* 㡱 */
dict[0x3872] = "huán"; /* 㡲 */
dict[0x3873] = "dǐ,zhé,zhǐ"; /* 㡳 */
dict[0x3875] = "líng"; /* 㡵 */
dict[0x3876] = "zhǐ"; /* 㡶 */
dict[0x3877] = "běn"; /* 㡷 */
dict[0x3878] = "zhǎ,zhà"; /* 㡸 */
dict[0x3879] = "cì,jū"; /* 㡹 */
dict[0x387a] = "dàn"; /* 㡺 */
dict[0x387b] = "liào"; /* 㡻 */
dict[0x387c] = "yì"; /* 㡼 */
dict[0x387d] = "zhào"; /* 㡽 */
dict[0x387e] = "xiàn"; /* 㡾 */
dict[0x387f] = "chì"; /* 㡿 */
dict[0x3880] = "cì,zì"; /* 㢀 */
dict[0x3881] = "chǐ"; /* 㢁 */
dict[0x3882] = "yǎn"; /* 㢂 */
dict[0x3883] = "láng"; /* 㢃 */
dict[0x3884] = "dòu"; /* 㢄 */
dict[0x3885] = "lòng"; /* 㢅 */
dict[0x3886] = "chán"; /* 㢆 */
dict[0x3888] = "tuí"; /* 㢈 */
dict[0x3889] = "chá"; /* 㢉 */
dict[0x388a] = "ǎi"; /* 㢊 */
dict[0x388b] = "chǐ"; /* 㢋 */
dict[0x388d] = "yíng,yǐng"; /* 㢍 */
dict[0x388e] = "chà,zé,zhái,zhé"; /* 㢎 */
dict[0x388f] = "tóu"; /* 㢏 */
dict[0x3891] = "tuí"; /* 㢑 */
dict[0x3892] = "chá"; /* 㢒 */
dict[0x3893] = "yǎo,zhàng"; /* 㢓 */
dict[0x3894] = "zǒng"; /* 㢔 */
dict[0x3897] = "qiào"; /* 㢗 */
dict[0x3898] = "lián"; /* 㢘 */
dict[0x3899] = "qín"; /* 㢙 */
dict[0x389a] = "lǔ"; /* 㢚 */
dict[0x389b] = "yàn"; /* 㢛 */
dict[0x389e] = "yì"; /* 㢞 */
dict[0x389f] = "chǎn,chān"; /* 㢟 */
dict[0x38a0] = "jiǒng,jùn"; /* 㢠 */
dict[0x38a1] = "jiǎng"; /* 㢡 */
dict[0x38a3] = "jìng,qíng"; /* 㢣 */
dict[0x38a5] = "dòng"; /* 㢥 */
dict[0x38a6] = "gē"; /* 㢦 */
dict[0x38a7] = "juàn"; /* 㢧 */
dict[0x38a8] = "hàn"; /* 㢨 */
dict[0x38a9] = "dì"; /* 㢩 */
dict[0x38ac] = "hóng"; /* 㢬 */
dict[0x38ae] = "chí"; /* 㢮 */
dict[0x38af] = "mín"; /* 㢯 */
dict[0x38b0] = "bì,huán"; /* 㢰 */
dict[0x38b2] = "xùn"; /* 㢲 */
dict[0x38b3] = "lú"; /* 㢳 */
dict[0x38b5] = "shè,xié"; /* 㢵 */
dict[0x38b6] = "bì"; /* 㢶 */
dict[0x38b8] = "bì"; /* 㢸 */
dict[0x38ba] = "xián"; /* 㢺 */
dict[0x38bb] = "wěi"; /* 㢻 */
dict[0x38bc] = "biè"; /* 㢼 */
dict[0x38bd] = "ěr"; /* 㢽 */
dict[0x38be] = "juàn"; /* 㢾 */
dict[0x38c0] = "zhèn"; /* 㣀 */
dict[0x38c1] = "bèi"; /* 㣁 */
dict[0x38c2] = "yì"; /* 㣂 */
dict[0x38c3] = "yǔ,yù"; /* 㣃 */
dict[0x38c4] = "qú"; /* 㣄 */
dict[0x38c5] = "zàn"; /* 㣅 */
dict[0x38c6] = "mí,mí,pèi"; /* 㣆 */
dict[0x38c7] = "nǐ,yì"; /* 㣇 */
dict[0x38c8] = "sì"; /* 㣈 */
dict[0x38cc] = "shàn"; /* 㣌 */
dict[0x38cd] = "tái"; /* 㣍 */
dict[0x38ce] = "mù"; /* 㣎 */
dict[0x38cf] = "jìng"; /* 㣏 */
dict[0x38d0] = "biàn"; /* 㣐 */
dict[0x38d1] = "róng"; /* 㣑 */
dict[0x38d2] = "cèng"; /* 㣒 */
dict[0x38d3] = "càn"; /* 㣓 */
dict[0x38d9] = "dí"; /* 㣙 */
dict[0x38da] = "tóng,tǒng"; /* 㣚 */
dict[0x38db] = "tà"; /* 㣛 */
dict[0x38dc] = "xíng"; /* 㣜 */
dict[0x38dd] = "sōng"; /* 㣝 */
dict[0x38de] = "duó,duò"; /* 㣞 */
dict[0x38df] = "xì"; /* 㣟 */
dict[0x38e0] = "tóng"; /* 㣠 */
dict[0x38e2] = "tí"; /* 㣢 */
dict[0x38e3] = "shǎn,shàn"; /* 㣣 */
dict[0x38e4] = "jiàn"; /* 㣤 */
dict[0x38e5] = "zhì"; /* 㣥 */
dict[0x38e7] = "yìn,yǒng"; /* 㣧 */
dict[0x38ea] = "huǎn,kuò"; /* 㣪 */
dict[0x38eb] = "zhǒng"; /* 㣫 */
dict[0x38ec] = "qì"; /* 㣬 */
dict[0x38ef] = "xiè"; /* 㣯 */
dict[0x38f0] = "xiè"; /* 㣰 */
dict[0x38f1] = "zé,zuò"; /* 㣱 */
dict[0x38f2] = "wéi"; /* 㣲 */
dict[0x38f5] = "tà"; /* 㣵 */
dict[0x38f6] = "zhān"; /* 㣶 */
dict[0x38f7] = "nìng"; /* 㣷 */
dict[0x38fb] = "yì"; /* 㣻 */
dict[0x38fc] = "rěn"; /* 㣼 */
dict[0x38fd] = "shù"; /* 㣽 */
dict[0x38fe] = "chà"; /* 㣾 */
dict[0x38ff] = "zhuó"; /* 㣿 */
dict[0x3901] = "miǎn,tiǎn"; /* 㤁 */
dict[0x3902] = "jí"; /* 㤂 */
dict[0x3903] = "fáng"; /* 㤃 */
dict[0x3904] = "pèi"; /* 㤄 */
dict[0x3905] = "ài"; /* 㤅 */
dict[0x3906] = "fàn"; /* 㤆 */
dict[0x3907] = "ǎo,fó,wù"; /* 㤇 */
dict[0x3908] = "qìn"; /* 㤈 */
dict[0x3909] = "qiā,yá"; /* 㤉 */
dict[0x390a] = "xiào,yáo"; /* 㤊 */
dict[0x390d] = "qiǎo"; /* 㤍 */
dict[0x390f] = "tóng"; /* 㤏 */
dict[0x3911] = "yōu"; /* 㤑 */
dict[0x3913] = "bèn"; /* 㤓 */
dict[0x3914] = "fú,fù"; /* 㤔 */
dict[0x3915] = "chù"; /* 㤕 */
dict[0x3916] = "zhù"; /* 㤖 */
dict[0x3918] = "chù,cù,zhòu"; /* 㤘 */
dict[0x391a] = "háng"; /* 㤚 */
dict[0x391b] = "nín,rèn"; /* 㤛 */
dict[0x391c] = "jué,yù"; /* 㤜 */
dict[0x391e] = "chà"; /* 㤞 */
dict[0x391f] = "kǒng,tòu"; /* 㤟 */
dict[0x3920] = "liè"; /* 㤠 */
dict[0x3921] = "lì"; /* 㤡 */
dict[0x3922] = "xù,yù"; /* 㤢 */
dict[0x3924] = "yú,yǔ"; /* 㤤 */
dict[0x3925] = "hài"; /* 㤥 */
dict[0x3926] = "lì"; /* 㤦 */
dict[0x3927] = "hóu,hòu"; /* 㤧 */
dict[0x3928] = "gǒng,qióng"; /* 㤨 */
dict[0x3929] = "kè"; /* 㤩 */
dict[0x392a] = "yuàn"; /* 㤪 */
dict[0x392b] = "dé"; /* 㤫 */
dict[0x392c] = "huì,kuì"; /* 㤬 */
dict[0x392e] = "kuáng,guàng"; /* 㤮 */
dict[0x392f] = "jiǒng,jùn"; /* 㤯 */
dict[0x3930] = "zǎn,zuò"; /* 㤰 */
dict[0x3931] = "fù"; /* 㤱 */
dict[0x3932] = "qiè,qù"; /* 㤲 */
dict[0x3933] = "běi"; /* 㤳 */
dict[0x3934] = "xí"; /* 㤴 */
dict[0x3935] = "cí"; /* 㤵 */
dict[0x3936] = "páng"; /* 㤶 */
dict[0x3938] = "xì"; /* 㤸 */
dict[0x3939] = "qiú"; /* 㤹 */
dict[0x393a] = "huǎng"; /* 㤺 */
dict[0x393b] = "lǔn"; /* 㤻 */
dict[0x393d] = "chóu"; /* 㤽 */
dict[0x393e] = "sàn"; /* 㤾 */
dict[0x3940] = "dé"; /* 㥀 */
dict[0x3941] = "dé,zhí,zhòu"; /* 㥁 */
dict[0x3942] = "tè"; /* 㥂 */
dict[0x3943] = "mèn"; /* 㥃 */
dict[0x3944] = "líng"; /* 㥄 */
dict[0x3945] = "shòu"; /* 㥅 */
dict[0x3946] = "diàn,tuì"; /* 㥆 */
dict[0x3947] = "cán,càn"; /* 㥇 */
dict[0x3948] = "dié"; /* 㥈 */
dict[0x3949] = "chè,chì"; /* 㥉 */
dict[0x394a] = "péng"; /* 㥊 */
dict[0x394b] = "yī"; /* 㥋 */
dict[0x394c] = "jú"; /* 㥌 */
dict[0x394d] = "jì"; /* 㥍 */
dict[0x394e] = "lái,lí"; /* 㥎 */
dict[0x394f] = "tiǎn"; /* 㥏 */
dict[0x3950] = "yuàn"; /* 㥐 */
dict[0x3952] = "cǎi"; /* 㥒 */
dict[0x3953] = "qǐ"; /* 㥓 */
dict[0x3954] = "yú,yù"; /* 㥔 */
dict[0x3955] = "lián"; /* 㥕 */
dict[0x395a] = "yú"; /* 㥚 */
dict[0x395b] = "jí,kè,sù"; /* 㥛 */
dict[0x395c] = "wèi"; /* 㥜 */
dict[0x395d] = "mǐ,miǎn"; /* 㥝 */
dict[0x395e] = "cuì,qiàn,suì"; /* 㥞 */
dict[0x395f] = "xié"; /* 㥟 */
dict[0x3960] = "xǔ"; /* 㥠 */
dict[0x3961] = "xì"; /* 㥡 */
dict[0x3962] = "qiú"; /* 㥢 */
dict[0x3963] = "huì"; /* 㥣 */
dict[0x3965] = "yú"; /* 㥥 */
dict[0x3966] = "qiè,xiá,xiǎn"; /* 㥦 */
dict[0x3967] = "shùn"; /* 㥧 */
dict[0x3968] = "chuí,shuì,wěi"; /* 㥨 */
dict[0x3969] = "duǒ"; /* 㥩 */
dict[0x396a] = "lóu"; /* 㥪 */
dict[0x396b] = "dūn"; /* 㥫 */
dict[0x396c] = "páng"; /* 㥬 */
dict[0x396d] = "tài"; /* 㥭 */
dict[0x396e] = "zhòu"; /* 㥮 */
dict[0x396f] = "yǐn"; /* 㥯 */
dict[0x3971] = "fěi"; /* 㥱 */
dict[0x3972] = "shèn,yín"; /* 㥲 */
dict[0x3973] = "yuán"; /* 㥳 */
dict[0x3974] = "yí,yǐ"; /* 㥴 */
dict[0x3975] = "hùn"; /* 㥵 */
dict[0x3976] = "sè"; /* 㥶 */
dict[0x3977] = "yè,yì"; /* 㥷 */
dict[0x3978] = "mǐn"; /* 㥸 */
dict[0x3979] = "fěn"; /* 㥹 */
dict[0x397a] = "hé,hè"; /* 㥺 */
dict[0x397c] = "yǐn"; /* 㥼 */
dict[0x397d] = "cè,zé"; /* 㥽 */
dict[0x397e] = "nì"; /* 㥾 */
dict[0x397f] = "ào"; /* 㥿 */
dict[0x3980] = "féng"; /* 㦀 */
dict[0x3981] = "lián"; /* 㦁 */
dict[0x3982] = "cháng,tàng"; /* 㦂 */
dict[0x3983] = "chǎn"; /* 㦃 */
dict[0x3984] = "má,mì"; /* 㦄 */
dict[0x3985] = "diē,dì"; /* 㦅 */
dict[0x3987] = "lù"; /* 㦇 */
dict[0x3989] = "yì"; /* 㦉 */
dict[0x398a] = "huá"; /* 㦊 */
dict[0x398c] = "tuì,xù,hū"; /* 㦌 */
dict[0x398d] = "è"; /* 㦍 */
dict[0x398e] = "huà"; /* 㦎 */
dict[0x398f] = "sǔn,xuàn"; /* 㦏 */
dict[0x3990] = "nì"; /* 㦐 */
dict[0x3991] = "liǎn,xiàn"; /* 㦑 */
dict[0x3992] = "lí"; /* 㦒 */
dict[0x3993] = "xiàn"; /* 㦓 */
dict[0x3994] = "yàn"; /* 㦔 */
dict[0x3995] = "lóng"; /* 㦕 */
dict[0x3996] = "mèn"; /* 㦖 */
dict[0x3997] = "jiàn,jìn"; /* 㦗 */
dict[0x399a] = "biǎn"; /* 㦚 */
dict[0x399b] = "yú,yǔ"; /* 㦛 */
dict[0x399c] = "huò,xuè"; /* 㦜 */
dict[0x399d] = "miǎo"; /* 㦝 */
dict[0x399e] = "chóu"; /* 㦞 */
dict[0x399f] = "hài,mái"; /* 㦟 */
dict[0x39a1] = "lè"; /* 㦡 */
dict[0x39a2] = "jié,qì"; /* 㦢 */
dict[0x39a3] = "wèi"; /* 㦣 */
dict[0x39a4] = "yì"; /* 㦤 */
dict[0x39a5] = "huán,xiǎn"; /* 㦥 */
dict[0x39a6] = "hè"; /* 㦦 */
dict[0x39a7] = "cǎn"; /* 㦧 */
dict[0x39a8] = "lán,làn"; /* 㦨 */
dict[0x39a9] = "yǐn"; /* 㦩 */
dict[0x39aa] = "xiè"; /* 㦪 */
dict[0x39ac] = "luǒ"; /* 㦬 */
dict[0x39ad] = "líng"; /* 㦭 */
dict[0x39ae] = "qián"; /* 㦮 */
dict[0x39af] = "huò"; /* 㦯 */
dict[0x39b0] = "jiān"; /* 㦰 */
dict[0x39b1] = "wǒ"; /* 㦱 */
dict[0x39b2] = "zāi"; /* 㦲 */
dict[0x39b4] = "gé,qià"; /* 㦴 */
dict[0x39b6] = "dié"; /* 㦶 */
dict[0x39b7] = "yǒng"; /* 㦷 */
dict[0x39b8] = "jǐ"; /* 㦸 */
dict[0x39b9] = "àng,yáng,yǐng"; /* 㦹 */
dict[0x39ba] = "rǔ,rù"; /* 㦺 */
dict[0x39bb] = "xí,zhé"; /* 㦻 */
dict[0x39bc] = "shuàng"; /* 㦼 */
dict[0x39bd] = "xù,yù"; /* 㦽 */
dict[0x39be] = "yí"; /* 㦾 */
dict[0x39bf] = "hù"; /* 㦿 */
dict[0x39c0] = "jí"; /* 㧀 */
dict[0x39c1] = "qù"; /* 㧁 */
dict[0x39c2] = "tián"; /* 㧂 */
dict[0x39c4] = "qiǎn,qiú"; /* 㧄 */
dict[0x39c5] = "mù,dāo"; /* 㧅 */
dict[0x39c7] = "mǎo"; /* 㧇 */
dict[0x39c8] = "yǐn,yìn"; /* 㧈 */
dict[0x39c9] = "gài,kuì"; /* 㧉 */
dict[0x39ca] = "bá,pō"; /* 㧊 */
dict[0x39cb] = "xiǎn,xuǎn"; /* 㧋 */
dict[0x39cc] = "mào"; /* 㧌 */
dict[0x39cd] = "fǎng"; /* 㧍 */
dict[0x39ce] = "yá,yà,qiā"; /* 㧎 */
dict[0x39cf] = "gāng"; /* 㧏 */
dict[0x39d0] = "sǒng"; /* 㧐 */
dict[0x39d1] = "wéi,wěi"; /* 㧑 */
dict[0x39d2] = "xué,yù,yuè"; /* 㧒 */
dict[0x39d4] = "guài"; /* 㧔 */
dict[0x39d5] = "jiù,liǔ,yú"; /* 㧕 */
dict[0x39d6] = "è"; /* 㧖 */
dict[0x39d7] = "zǐ,jǐ,zhǐ"; /* 㧗 */
dict[0x39d8] = "cuì,nǎo,zì"; /* 㧘 */
dict[0x39d9] = "bì"; /* 㧙 */
dict[0x39da] = "wǎ"; /* 㧚 */
dict[0x39dc] = "liè"; /* 㧜 */
dict[0x39df] = "kuǎi"; /* 㧟 */
dict[0x39e1] = "hài"; /* 㧡 */
dict[0x39e2] = "yīn"; /* 㧢 */
dict[0x39e3] = "zhù"; /* 㧣 */
dict[0x39e4] = "chòng"; /* 㧤 */
dict[0x39e5] = "xiǎn"; /* 㧥 */
dict[0x39e6] = "xuàn"; /* 㧦 */
dict[0x39e8] = "qiú"; /* 㧨 */
dict[0x39e9] = "pèi"; /* 㧩 */
dict[0x39ea] = "guǐ"; /* 㧪 */
dict[0x39eb] = "ér"; /* 㧫 */
dict[0x39ec] = "gǒng"; /* 㧬 */
dict[0x39ed] = "qióng"; /* 㧭 */
dict[0x39ef] = "lǎo"; /* 㧯 */
dict[0x39f0] = "lì"; /* 㧰 */
dict[0x39f1] = "chèn,ná,nì,nì,tiàn"; /* 㧱 */
dict[0x39f2] = "sǎn"; /* 㧲 */
dict[0x39f3] = "bǎi,bó,zhuò"; /* 㧳 */
dict[0x39f4] = "wǒ"; /* 㧴 */
dict[0x39f5] = "póu,pǒu"; /* 㧵 */
dict[0x39f7] = "duò,tùn"; /* 㧷 */
dict[0x39f9] = "tè"; /* 㧹 */
dict[0x39fa] = "tà"; /* 㧺 */
dict[0x39fb] = "zhǐ,zhuó,zú"; /* 㧻 */
dict[0x39fc] = "biào"; /* 㧼 */
dict[0x39fd] = "gù,hú"; /* 㧽 */
dict[0x3a00] = "bǐng"; /* 㨀 */
dict[0x3a01] = "zhí,zhì"; /* 㨁 */
dict[0x3a02] = "dǒng"; /* 㨂 */
dict[0x3a03] = "chéng,duǐ"; /* 㨃 */
dict[0x3a04] = "zhào"; /* 㨄 */
dict[0x3a05] = "nèi,ruì"; /* 㨅 */
dict[0x3a06] = "lǐn"; /* 㨆 */
dict[0x3a07] = "pó"; /* 㨇 */
dict[0x3a08] = "jǐ"; /* 㨈 */
dict[0x3a09] = "mǐn"; /* 㨉 */
dict[0x3a0a] = "wěi"; /* 㨊 */
dict[0x3a0b] = "chě,lè,zhèn"; /* 㨋 */
dict[0x3a0c] = "gòu,rú,rǔ"; /* 㨌 */
dict[0x3a0e] = "rú,ruán"; /* 㨎 */
dict[0x3a10] = "bǔ,péi"; /* 㨐 */
dict[0x3a12] = "kuí,wěi,xié"; /* 㨒 */
dict[0x3a13] = "láo,liáo"; /* 㨓 */
dict[0x3a14] = "hàn"; /* 㨔 */
dict[0x3a15] = "yíng"; /* 㨕 */
dict[0x3a16] = "zhì"; /* 㨖 */
dict[0x3a17] = "jié"; /* 㨗 */
dict[0x3a18] = "xǐng"; /* 㨘 */
dict[0x3a19] = "xié"; /* 㨙 */
dict[0x3a1a] = "xún"; /* 㨚 */
dict[0x3a1b] = "shǎn"; /* 㨛 */
dict[0x3a1c] = "qián"; /* 㨜 */
dict[0x3a1d] = "xiè"; /* 㨝 */
dict[0x3a1e] = "sù"; /* 㨞 */
dict[0x3a1f] = "hái"; /* 㨟 */
dict[0x3a20] = "mì"; /* 㨠 */
dict[0x3a21] = "hún"; /* 㨡 */
dict[0x3a24] = "huì,kuǎi,wài"; /* 㨤 */
dict[0x3a25] = "nà"; /* 㨥 */
dict[0x3a26] = "sǒng"; /* 㨦 */
dict[0x3a27] = "bèn"; /* 㨧 */
dict[0x3a28] = "liù"; /* 㨨 */
dict[0x3a29] = "jié"; /* 㨩 */
dict[0x3a2a] = "huàng"; /* 㨪 */
dict[0x3a2b] = "lǎn"; /* 㨫 */
dict[0x3a2d] = "hù"; /* 㨭 */
dict[0x3a2e] = "dōu"; /* 㨮 */
dict[0x3a2f] = "huò,kuò"; /* 㨯 */
dict[0x3a30] = "gé,gǔn,hùn,huò,jié"; /* 㨰 */
dict[0x3a31] = "yáo"; /* 㨱 */
dict[0x3a32] = "cè"; /* 㨲 */
dict[0x3a33] = "guǐ"; /* 㨳 */
dict[0x3a34] = "jiàn"; /* 㨴 */
dict[0x3a35] = "jiǎn"; /* 㨵 */
dict[0x3a36] = "chóu,dǎo,zhǒu,zhòu"; /* 㨶 */
dict[0x3a37] = "jìn"; /* 㨷 */
dict[0x3a38] = "mà"; /* 㨸 */
dict[0x3a39] = "huì"; /* 㨹 */
dict[0x3a3a] = "mén,mì,miǎn"; /* 㨺 */
dict[0x3a3b] = "cán,shǎn,zàn"; /* 㨻 */
dict[0x3a3c] = "lüè"; /* 㨼 */
dict[0x3a3d] = "pǐ,pì,qiǎo"; /* 㨽 */
dict[0x3a3e] = "yàng"; /* 㨾 */
dict[0x3a3f] = "jù"; /* 㨿 */
dict[0x3a40] = "jù"; /* 㩀 */
dict[0x3a41] = "què"; /* 㩁 */
dict[0x3a43] = "qiān"; /* 㩃 */
dict[0x3a44] = "shāi"; /* 㩄 */
dict[0x3a45] = "chōu"; /* 㩅 */
dict[0x3a46] = "jiù"; /* 㩆 */
dict[0x3a47] = "huà,huò"; /* 㩇 */
dict[0x3a48] = "xiàn,yǔn"; /* 㩈 */
dict[0x3a49] = "xié"; /* 㩉 */
dict[0x3a4b] = "sù,xiāo"; /* 㩋 */
dict[0x3a4c] = "fèi"; /* 㩌 */
dict[0x3a4d] = "cè"; /* 㩍 */
dict[0x3a4e] = "yè"; /* 㩎 */
dict[0x3a50] = "dèn"; /* 㩐 */
dict[0x3a52] = "qín"; /* 㩒 */
dict[0x3a53] = "huǐ"; /* 㩓 */
dict[0x3a54] = "tún"; /* 㩔 */
dict[0x3a56] = "qiáng,tiáo"; /* 㩖 */
dict[0x3a57] = "xí,xié"; /* 㩗 */
dict[0x3a58] = "yǐ"; /* 㩘 */
dict[0x3a5a] = "méng"; /* 㩚 */
dict[0x3a5b] = "tuán"; /* 㩛 */
dict[0x3a5c] = "lǎn"; /* 㩜 */
dict[0x3a5d] = "háo"; /* 㩝 */
dict[0x3a5e] = "cì"; /* 㩞 */
dict[0x3a5f] = "zhài"; /* 㩟 */
dict[0x3a60] = "piǎo"; /* 㩠 */
dict[0x3a61] = "luǒ"; /* 㩡 */
dict[0x3a62] = "mí,miè"; /* 㩢 */
dict[0x3a66] = "xié"; /* 㩦 */
dict[0x3a67] = "bó"; /* 㩧 */
dict[0x3a68] = "huì"; /* 㩨 */
dict[0x3a69] = "qǐ,qǐng"; /* 㩩 */
dict[0x3a6a] = "xié,xìn,yé"; /* 㩪 */
dict[0x3a6d] = "bó,jiǎo,xiào"; /* 㩭 */
dict[0x3a6e] = "qián,xián"; /* 㩮 */
dict[0x3a6f] = "bǎn,pán,pó"; /* 㩯 */
dict[0x3a70] = "jiǎo,qiáo,xiǔ"; /* 㩰 */
dict[0x3a71] = "jué"; /* 㩱 */
dict[0x3a72] = "kǔn,quán"; /* 㩲 */
dict[0x3a73] = "sǒng"; /* 㩳 */
dict[0x3a74] = "jú"; /* 㩴 */
dict[0x3a75] = "è"; /* 㩵 */
dict[0x3a76] = "niè,nǐng"; /* 㩶 */
dict[0x3a78] = "dié"; /* 㩸 */
dict[0x3a79] = "dié,zhá"; /* 㩹 */
dict[0x3a7b] = "guǐ,qī"; /* 㩻 */
dict[0x3a7c] = "zhī"; /* 㩼 */
dict[0x3a7d] = "qí"; /* 㩽 */
dict[0x3a7e] = "chuí"; /* 㩾 */
dict[0x3a80] = "yú"; /* 㪀 */
dict[0x3a81] = "qín"; /* 㪁 */
dict[0x3a83] = "hé"; /* 㪃 */
dict[0x3a84] = "fú"; /* 㪄 */
dict[0x3a86] = "dǐ"; /* 㪆 */
dict[0x3a87] = "xiàn"; /* 㪇 */
dict[0x3a88] = "guì"; /* 㪈 */
dict[0x3a89] = "hé"; /* 㪉 */
dict[0x3a8a] = "qún"; /* 㪊 */
dict[0x3a8b] = "hàn"; /* 㪋 */
dict[0x3a8c] = "tǒng,yú,yǔ"; /* 㪌 */
dict[0x3a8d] = "bó"; /* 㪍 */
dict[0x3a8e] = "shǎn"; /* 㪎 */
dict[0x3a8f] = "bǐ"; /* 㪏 */
dict[0x3a90] = "lù"; /* 㪐 */
dict[0x3a91] = "yè"; /* 㪑 */
dict[0x3a92] = "ní"; /* 㪒 */
dict[0x3a93] = "chuái"; /* 㪓 */
dict[0x3a94] = "sàn,tán"; /* 㪔 */
dict[0x3a95] = "diào"; /* 㪕 */
dict[0x3a96] = "lù"; /* 㪖 */
dict[0x3a97] = "tǒu"; /* 㪗 */
dict[0x3a98] = "liǎn"; /* 㪘 */
dict[0x3a99] = "kě,kè,kuò"; /* 㪙 */
dict[0x3a9a] = "sàn"; /* 㪚 */
dict[0x3a9b] = "zhěn"; /* 㪛 */
dict[0x3a9c] = "chuǎi"; /* 㪜 */
dict[0x3a9d] = "liàn"; /* 㪝 */
dict[0x3a9e] = "mào"; /* 㪞 */
dict[0x3aa0] = "qiàn"; /* 㪠 */
dict[0x3aa1] = "kě"; /* 㪡 */
dict[0x3aa2] = "shǎo"; /* 㪢 */
dict[0x3aa3] = "qiào"; /* 㪣 */
dict[0x3aa4] = "bì"; /* 㪤 */
dict[0x3aa5] = "zhā"; /* 㪥 */
dict[0x3aa6] = "yìn"; /* 㪦 */
dict[0x3aa8] = "shàn"; /* 㪨 */
dict[0x3aa9] = "sù"; /* 㪩 */
dict[0x3aaa] = "sà,xǐ"; /* 㪪 */
dict[0x3aab] = "ruì"; /* 㪫 */
dict[0x3aac] = "zhuó"; /* 㪬 */
dict[0x3aad] = "lú"; /* 㪭 */
dict[0x3aae] = "líng"; /* 㪮 */
dict[0x3aaf] = "chá,jǔ,qú"; /* 㪯 */
dict[0x3ab1] = "huàn"; /* 㪱 */
dict[0x3ab4] = "jiá"; /* 㪴 */
dict[0x3ab5] = "bàn"; /* 㪵 */
dict[0x3ab6] = "hú"; /* 㪶 */
dict[0x3ab7] = "dǒu"; /* 㪷 */
dict[0x3ab9] = "lǒu"; /* 㪹 */
dict[0x3aba] = "jū"; /* 㪺 */
dict[0x3abb] = "juàn"; /* 㪻 */
dict[0x3abc] = "kě"; /* 㪼 */
dict[0x3abd] = "suǒ,suò"; /* 㪽 */
dict[0x3abe] = "gé,luò"; /* 㪾 */
dict[0x3abf] = "zhé,shé"; /* 㪿 */
dict[0x3ac0] = "dǐng"; /* 㫀 */
dict[0x3ac1] = "duàn"; /* 㫁 */
dict[0x3ac2] = "zhù"; /* 㫂 */
dict[0x3ac3] = "yǎn"; /* 㫃 */
dict[0x3ac4] = "páng"; /* 㫄 */
dict[0x3ac5] = "chá,qí,shí"; /* 㫅 */
dict[0x3aca] = "yǐ"; /* 㫊 */
dict[0x3acd] = "yóu"; /* 㫍 */
dict[0x3ace] = "gǔn,kuài"; /* 㫎 */
dict[0x3acf] = "yǎo"; /* 㫏 */
dict[0x3ad0] = "yǎo"; /* 㫐 */
dict[0x3ad1] = "shí,zhǐ"; /* 㫑 */
dict[0x3ad2] = "gǒng"; /* 㫒 */
dict[0x3ad3] = "qǐ,qì"; /* 㫓 */
dict[0x3ad4] = "gèn"; /* 㫔 */
dict[0x3ad6] = "zhǐ"; /* 㫖 */
dict[0x3ad7] = "hòu"; /* 㫗 */
dict[0x3ad8] = "mì,miǎn"; /* 㫘 */
dict[0x3ad9] = "fú"; /* 㫙 */
dict[0x3ada] = "hū"; /* 㫚 */
dict[0x3adb] = "guàng,kuáng,kuàng,mǔ"; /* 㫛 */
dict[0x3adc] = "dàn,tǎn"; /* 㫜 */
dict[0x3adf] = "yán"; /* 㫟 */
dict[0x3ae2] = "qù"; /* 㫢 */
dict[0x3ae4] = "chǎng,zhào"; /* 㫤 */
dict[0x3ae5] = "mǐng"; /* 㫥 */
dict[0x3ae7] = "bào"; /* 㫧 */
dict[0x3aeb] = "xiǎn"; /* 㫫 */
dict[0x3aed] = "shí"; /* 㫭 */
dict[0x3aef] = "mào"; /* 㫯 */
dict[0x3af0] = "lǎng"; /* 㫰 */
dict[0x3af1] = "nǎn"; /* 㫱 */
dict[0x3af2] = "pèi"; /* 㫲 */
dict[0x3af3] = "chén"; /* 㫳 */
dict[0x3af6] = "cǒu,zhǒu"; /* 㫶 */
dict[0x3af8] = "qiè"; /* 㫸 */
dict[0x3af9] = "dài,shù,yú"; /* 㫹 */
dict[0x3afb] = "kùn"; /* 㫻 */
dict[0x3afc] = "dié,zhé,zhì"; /* 㫼 */
dict[0x3afd] = "lù"; /* 㫽 */
dict[0x3b02] = "yú"; /* 㬂 */
dict[0x3b03] = "tái"; /* 㬃 */
dict[0x3b04] = "chàn"; /* 㬄 */
dict[0x3b05] = "màn"; /* 㬅 */
dict[0x3b06] = "mián,miàn,mǐn"; /* 㬆 */
dict[0x3b07] = "huàn"; /* 㬇 */
dict[0x3b09] = "nuǎn,ruò"; /* 㬉 */
dict[0x3b0a] = "huǎn"; /* 㬊 */
dict[0x3b0b] = "hóu"; /* 㬋 */
dict[0x3b0c] = "jìng"; /* 㬌 */
dict[0x3b0d] = "bó"; /* 㬍 */
dict[0x3b0e] = "xiǎn"; /* 㬎 */
dict[0x3b0f] = "lì"; /* 㬏 */
dict[0x3b10] = "jǐn,jìn,xíng,yǐng"; /* 㬐 */
dict[0x3b12] = "mǎng,mào"; /* 㬒 */
dict[0x3b13] = "piào"; /* 㬓 */
dict[0x3b14] = "háo"; /* 㬔 */
dict[0x3b15] = "yáng"; /* 㬕 */
dict[0x3b17] = "xiàn"; /* 㬗 */
dict[0x3b18] = "sù"; /* 㬘 */
dict[0x3b19] = "wěi"; /* 㬙 */
dict[0x3b1a] = "chè"; /* 㬚 */
dict[0x3b1c] = "jìn"; /* 㬜 */
dict[0x3b1d] = "céng"; /* 㬝 */
dict[0x3b1e] = "hè"; /* 㬞 */
dict[0x3b20] = "shài"; /* 㬠 */
dict[0x3b21] = "líng"; /* 㬡 */
dict[0x3b23] = "duì"; /* 㬣 */
dict[0x3b25] = "pù"; /* 㬥 */
dict[0x3b26] = "yuè"; /* 㬦 */
dict[0x3b27] = "bó"; /* 㬧 */
dict[0x3b29] = "huì"; /* 㬩 */
dict[0x3b2a] = "dié,zhì"; /* 㬪 */
dict[0x3b2b] = "yàn"; /* 㬫 */
dict[0x3b2c] = "jù"; /* 㬬 */
dict[0x3b2d] = "jiào,shǎn,yǎo"; /* 㬭 */
dict[0x3b2e] = "kuài,nàn"; /* 㬮 */
dict[0x3b2f] = "liè"; /* 㬯 */
dict[0x3b30] = "yú"; /* 㬰 */
dict[0x3b31] = "tì"; /* 㬱 */
dict[0x3b33] = "wǔ"; /* 㬳 */
dict[0x3b34] = "hǒng"; /* 㬴 */
dict[0x3b35] = "xiáo,jiāo"; /* 㬵 */
dict[0x3b36] = "hào"; /* 㬶 */
dict[0x3b3b] = "huǎng"; /* 㬻 */
dict[0x3b3c] = "fù"; /* 㬼 */
dict[0x3b3f] = "dùn"; /* 㬿 */
dict[0x3b41] = "réng"; /* 㭁 */
dict[0x3b42] = "jiǎo"; /* 㭂 */
dict[0x3b44] = "xìn"; /* 㭄 */
dict[0x3b47] = "yuàn"; /* 㭇 */
dict[0x3b48] = "jué,kuài"; /* 㭈 */
dict[0x3b49] = "huá"; /* 㭉 */
dict[0x3b4b] = "bàng"; /* 㭋 */
dict[0x3b4c] = "móu,yú"; /* 㭌 */
dict[0x3b4e] = "gāng"; /* 㭎 */
dict[0x3b4f] = "wěi"; /* 㭏 */
dict[0x3b51] = "mèi"; /* 㭑 */
dict[0x3b52] = "sì"; /* 㭒 */
dict[0x3b53] = "biàn"; /* 㭓 */
dict[0x3b54] = "lú"; /* 㭔 */
dict[0x3b55] = "qū"; /* 㭕 */
dict[0x3b58] = "hé,gé"; /* 㭘 */
dict[0x3b59] = "shé,zhé"; /* 㭙 */
dict[0x3b5b] = "pài"; /* 㭛 */
dict[0x3b5c] = "róng"; /* 㭜 */
dict[0x3b5d] = "qiú"; /* 㭝 */
dict[0x3b5e] = "liè"; /* 㭞 */
dict[0x3b5f] = "gǒng"; /* 㭟 */
dict[0x3b60] = "xiǎn"; /* 㭠 */
dict[0x3b61] = "xì,xìn"; /* 㭡 */
dict[0x3b64] = "niǎo"; /* 㭤 */
dict[0x3b68] = "yé"; /* 㭨 */
dict[0x3b69] = "lèi,líng,liè"; /* 㭩 */
dict[0x3b6b] = "cuán,cuó,zhèn"; /* 㭫 */
dict[0x3b6c] = "zhuó"; /* 㭬 */
dict[0x3b6d] = "fèi"; /* 㭭 */
dict[0x3b6e] = "zuò"; /* 㭮 */
dict[0x3b6f] = "dié,nà,zhé"; /* 㭯 */
dict[0x3b70] = "jì,jué,zuǐ"; /* 㭰 */
dict[0x3b71] = "hé,xiá"; /* 㭱 */
dict[0x3b72] = "jí"; /* 㭲 */
dict[0x3b78] = "tú"; /* 㭸 */
dict[0x3b79] = "xián"; /* 㭹 */
dict[0x3b7a] = "yǎn"; /* 㭺 */
dict[0x3b7b] = "táng"; /* 㭻 */
dict[0x3b7c] = "tà"; /* 㭼 */
dict[0x3b7d] = "dǐ"; /* 㭽 */
dict[0x3b7e] = "jué,yuè"; /* 㭾 */
dict[0x3b7f] = "áng"; /* 㭿 */
dict[0x3b80] = "hán"; /* 㮀 */
dict[0x3b81] = "yáo"; /* 㮁 */
dict[0x3b82] = "jú"; /* 㮂 */
dict[0x3b83] = "ruí"; /* 㮃 */
dict[0x3b84] = "bǎng,bì,péng"; /* 㮄 */
dict[0x3b86] = "niè"; /* 㮆 */
dict[0x3b87] = "tiàn"; /* 㮇 */
dict[0x3b88] = "nài"; /* 㮈 */
dict[0x3b8b] = "yǒu,yù"; /* 㮋 */
dict[0x3b8c] = "mián,mǐn"; /* 㮌 */
dict[0x3b8f] = "nài"; /* 㮏 */
dict[0x3b90] = "xǐng,shěng"; /* 㮐 */
dict[0x3b91] = "qì"; /* 㮑 */
dict[0x3b93] = "gèn"; /* 㮓 */
dict[0x3b94] = "tóng"; /* 㮔 */
dict[0x3b95] = "ér,ruǎn"; /* 㮕 */
dict[0x3b96] = "jiá,jiá"; /* 㮖 */
dict[0x3b97] = "qín"; /* 㮗 */
dict[0x3b98] = "mào"; /* 㮘 */
dict[0x3b99] = "è"; /* 㮙 */
dict[0x3b9a] = "lì"; /* 㮚 */
dict[0x3b9b] = "chí"; /* 㮛 */
dict[0x3b9d] = "hé,luò"; /* 㮝 */
dict[0x3b9e] = "jié,ní,yá"; /* 㮞 */
dict[0x3b9f] = "jí,niǎn,pèng,ròu,kā"; /* 㮟 */
dict[0x3ba1] = "guàn"; /* 㮡 */
dict[0x3ba2] = "hóu"; /* 㮢 */
dict[0x3ba3] = "gài,zé"; /* 㮣 */
dict[0x3ba5] = "fèn"; /* 㮥 */
dict[0x3ba6] = "sè,suǒ"; /* 㮦 */
dict[0x3ba8] = "jí,jì"; /* 㮨 */
dict[0x3ba9] = "xī"; /* 㮩 */
dict[0x3baa] = "qióng"; /* 㮪 */
dict[0x3bab] = "hé"; /* 㮫 */
dict[0x3bad] = "xián"; /* 㮭 */
dict[0x3bae] = "jié"; /* 㮮 */
dict[0x3baf] = "huá,hún,kuǎn"; /* 㮯 */
dict[0x3bb0] = "bí,pí"; /* 㮰 */
dict[0x3bb3] = "zhèn"; /* 㮳 */
dict[0x3bb6] = "shì,shuò"; /* 㮶 */
dict[0x3bb8] = "sòng"; /* 㮸 */
dict[0x3bb9] = "zhǐ"; /* 㮹 */
dict[0x3bba] = "běn"; /* 㮺 */
dict[0x3bbe] = "lǎng"; /* 㮾 */
dict[0x3bbf] = "bì"; /* 㮿 */
dict[0x3bc0] = "xiǎn,xuàn"; /* 㯀 */
dict[0x3bc1] = "bàng"; /* 㯁 */
dict[0x3bc2] = "dài"; /* 㯂 */
dict[0x3bc5] = "pí"; /* 㯅 */
dict[0x3bc6] = "chǎn"; /* 㯆 */
dict[0x3bc7] = "bì"; /* 㯇 */
dict[0x3bc8] = "sù"; /* 㯈 */
dict[0x3bc9] = "huò,chū"; /* 㯉 */
dict[0x3bca] = "hén"; /* 㯊 */
dict[0x3bcb] = "yǐng"; /* 㯋 */
dict[0x3bcc] = "chuán"; /* 㯌 */
dict[0x3bcd] = "jiǎng"; /* 㯍 */
dict[0x3bce] = "nèn"; /* 㯎 */
dict[0x3bcf] = "gǔ"; /* 㯏 */
dict[0x3bd0] = "fǎng,tuǒ"; /* 㯐 */
dict[0x3bd3] = "tà"; /* 㯓 */
dict[0x3bd4] = "cuì"; /* 㯔 */
dict[0x3bd5] = "xī"; /* 㯕 */
dict[0x3bd6] = "dé"; /* 㯖 */
dict[0x3bd7] = "rǎn,shùn,xián,xiàn"; /* 㯗 */
dict[0x3bd8] = "kuǎn"; /* 㯘 */
dict[0x3bd9] = "chè"; /* 㯙 */
dict[0x3bda] = "dá"; /* 㯚 */
dict[0x3bdb] = "hú,huò"; /* 㯛 */
dict[0x3bdc] = "cuì"; /* 㯜 */
dict[0x3bdd] = "lù"; /* 㯝 */
dict[0x3bde] = "juàn,yuè"; /* 㯞 */
dict[0x3bdf] = "lù"; /* 㯟 */
dict[0x3be0] = "qiàn,xiàn,xún"; /* 㯠 */
dict[0x3be1] = "pào"; /* 㯡 */
dict[0x3be2] = "zhèn"; /* 㯢 */
dict[0x3be4] = "lì"; /* 㯤 */
dict[0x3be5] = "cáo,zāo"; /* 㯥 */
dict[0x3be6] = "qí"; /* 㯦 */
dict[0x3be9] = "tì"; /* 㯩 */
dict[0x3bea] = "líng"; /* 㯪 */
dict[0x3beb] = "qú"; /* 㯫 */
dict[0x3bec] = "liǎn"; /* 㯬 */
dict[0x3bed] = "lǔ"; /* 㯭 */
dict[0x3bee] = "shǔ"; /* 㯮 */
dict[0x3bef] = "gòng"; /* 㯯 */
dict[0x3bf0] = "zhé,zhí"; /* 㯰 */
dict[0x3bf1] = "biǎo,piáo,pāo"; /* 㯱 */
dict[0x3bf2] = "jìn"; /* 㯲 */
dict[0x3bf3] = "qíng"; /* 㯳 */
dict[0x3bf6] = "zōng"; /* 㯶 */
dict[0x3bf7] = "pú"; /* 㯷 */
dict[0x3bf8] = "jǐn"; /* 㯸 */
dict[0x3bf9] = "biǎo"; /* 㯹 */
dict[0x3bfa] = "jiàn"; /* 㯺 */
dict[0x3bfb] = "gǔn,hùn"; /* 㯻 */
dict[0x3bff] = "liè"; /* 㯿 */
dict[0x3c00] = "lí"; /* 㰀 */
dict[0x3c01] = "luǒ"; /* 㰁 */
dict[0x3c02] = "shěn,sǔn"; /* 㰂 */
dict[0x3c03] = "mián"; /* 㰃 */
dict[0x3c04] = "jiàn"; /* 㰄 */
dict[0x3c05] = "dí"; /* 㰅 */
dict[0x3c06] = "bèi"; /* 㰆 */
dict[0x3c08] = "liǎn"; /* 㰈 */
dict[0x3c0a] = "xún"; /* 㰊 */
dict[0x3c0b] = "pín"; /* 㰋 */
dict[0x3c0c] = "què"; /* 㰌 */
dict[0x3c0d] = "lóng"; /* 㰍 */
dict[0x3c0e] = "zuì"; /* 㰎 */
dict[0x3c10] = "jué,kuí,lěi,tuǐ,tuǒ"; /* 㰐 */
dict[0x3c12] = "shé,xué"; /* 㰒 */
dict[0x3c14] = "xiè"; /* 㰔 */
dict[0x3c16] = "lǎn"; /* 㰖 */
dict[0x3c17] = "cù"; /* 㰗 */
dict[0x3c18] = "yí"; /* 㰘 */
dict[0x3c19] = "nuó"; /* 㰙 */
dict[0x3c1a] = "lí"; /* 㰚 */
dict[0x3c1b] = "yuè"; /* 㰛 */
dict[0x3c1d] = "yǐ"; /* 㰝 */
dict[0x3c1f] = "jì,qì"; /* 㰟 */
dict[0x3c20] = "kàng"; /* 㰠 */
dict[0x3c21] = "xiè"; /* 㰡 */
dict[0x3c23] = "zì"; /* 㰣 */
dict[0x3c24] = "hē,qiè"; /* 㰤 */
dict[0x3c25] = "huì"; /* 㰥 */
dict[0x3c26] = "qù"; /* 㰦 */
dict[0x3c2a] = "wá"; /* 㰪 */
dict[0x3c2c] = "xún"; /* 㰬 */
dict[0x3c2e] = "shèn"; /* 㰮 */
dict[0x3c2f] = "tòu,tǒu,hòu"; /* 㰯 */
dict[0x3c30] = "qiè"; /* 㰰 */
dict[0x3c31] = "shà"; /* 㰱 */
dict[0x3c32] = "xù,yù"; /* 㰲 */
dict[0x3c33] = "yà"; /* 㰳 */
dict[0x3c34] = "pó,pǒu"; /* 㰴 */
dict[0x3c35] = "zú"; /* 㰵 */
dict[0x3c36] = "yǒu"; /* 㰶 */
dict[0x3c37] = "zì"; /* 㰷 */
dict[0x3c38] = "liǎn,liàn,luǎn"; /* 㰸 */
dict[0x3c39] = "jìn"; /* 㰹 */
dict[0x3c3a] = "xiá,xià"; /* 㰺 */
dict[0x3c3b] = "yǐ"; /* 㰻 */
dict[0x3c3c] = "qiè"; /* 㰼 */
dict[0x3c3d] = "mǐ,yàn"; /* 㰽 */
dict[0x3c3e] = "jiào"; /* 㰾 */
dict[0x3c40] = "chǐ,chuài"; /* 㱀 */
dict[0x3c41] = "shì"; /* 㱁 */
dict[0x3c42] = "kāng"; /* 㱂 */
dict[0x3c43] = "yǐn"; /* 㱃 */
dict[0x3c44] = "mò"; /* 㱄 */
dict[0x3c45] = "yì"; /* 㱅 */
dict[0x3c47] = "sè,xì"; /* 㱇 */
dict[0x3c48] = "jìn"; /* 㱈 */
dict[0x3c49] = "yè"; /* 㱉 */
dict[0x3c4b] = "què"; /* 㱋 */
dict[0x3c4c] = "chè,yǎn,yé"; /* 㱌 */
dict[0x3c4d] = "luán"; /* 㱍 */
dict[0x3c4f] = "zhèng"; /* 㱏 */
dict[0x3c54] = "xiē,suò"; /* 㱔 */
dict[0x3c56] = "cuì"; /* 㱖 */
dict[0x3c58] = "àn,yǎn"; /* 㱘 */
dict[0x3c59] = "xiǔ"; /* 㱙 */
dict[0x3c5a] = "cán,hài,shàn"; /* 㱚 */
dict[0x3c5b] = "chuǎn"; /* 㱛 */
dict[0x3c5c] = "zhá"; /* 㱜 */
dict[0x3c5e] = "jí"; /* 㱞 */
dict[0x3c5f] = "bó,pí,pǐ"; /* 㱟 */
dict[0x3c60] = "kū"; /* 㱠 */
dict[0x3c62] = "láng"; /* 㱢 */
dict[0x3c63] = "tuǐ"; /* 㱣 */
dict[0x3c65] = "líng"; /* 㱥 */
dict[0x3c66] = "è,guì,jǐ,qī"; /* 㱦 */
dict[0x3c67] = "wò"; /* 㱧 */
dict[0x3c68] = "liàn"; /* 㱨 */
dict[0x3c69] = "dú"; /* 㱩 */
dict[0x3c6a] = "mèn,hūn"; /* 㱪 */
dict[0x3c6b] = "làn"; /* 㱫 */
dict[0x3c6c] = "wěi"; /* 㱬 */
dict[0x3c6d] = "duàn"; /* 㱭 */
dict[0x3c6e] = "kuài,kuì"; /* 㱮 */
dict[0x3c6f] = "ái"; /* 㱯 */
dict[0x3c70] = "zǎi"; /* 㱰 */
dict[0x3c71] = "huì,wù,xì"; /* 㱱 */
dict[0x3c72] = "yì"; /* 㱲 */
dict[0x3c73] = "mò"; /* 㱳 */
dict[0x3c74] = "zì"; /* 㱴 */
dict[0x3c75] = "bèn,fèn"; /* 㱵 */
dict[0x3c76] = "bèng,jiào,péng,qiǎo,rù"; /* 㱶 */
dict[0x3c78] = "bì,bié"; /* 㱸 */
dict[0x3c79] = "lì,suàn,xiàn"; /* 㱹 */
dict[0x3c7a] = "lú"; /* 㱺 */
dict[0x3c7b] = "luǒ,luò"; /* 㱻 */
dict[0x3c7d] = "dàn,qín,zhěn"; /* 㱽 */
dict[0x3c7e] = "gāi,kāi"; /* 㱾 */
dict[0x3c7f] = "què"; /* 㱿 */
dict[0x3c80] = "chén"; /* 㲀 */
dict[0x3c82] = "chéng"; /* 㲂 */
dict[0x3c83] = "jiù"; /* 㲃 */
dict[0x3c84] = "kòu,kū"; /* 㲄 */
dict[0x3c85] = "jì"; /* 㲅 */
dict[0x3c86] = "líng"; /* 㲆 */
dict[0x3c88] = "sháo"; /* 㲈 */
dict[0x3c89] = "què"; /* 㲉 */
dict[0x3c8a] = "ruì"; /* 㲊 */
dict[0x3c8b] = "chuò,zhuó,zú"; /* 㲋 */
dict[0x3c8c] = "nèng"; /* 㲌 */
dict[0x3c8e] = "lóu"; /* 㲎 */
dict[0x3c8f] = "bǎo,piǎo,pín,pìng"; /* 㲏 */
dict[0x3c92] = "bào"; /* 㲒 */
dict[0x3c93] = "róng"; /* 㲓 */
dict[0x3c95] = "lèi"; /* 㲕 */
dict[0x3c98] = "qú"; /* 㲘 */
dict[0x3c9a] = "shā"; /* 㲚 */
dict[0x3c9b] = "zhǐ"; /* 㲛 */
dict[0x3c9c] = "tán,tǎn"; /* 㲜 */
dict[0x3c9d] = "rǒng"; /* 㲝 */
dict[0x3c9e] = "zú"; /* 㲞 */
dict[0x3c9f] = "yǐng"; /* 㲟 */
dict[0x3ca0] = "máo"; /* 㲠 */
dict[0x3ca1] = "nài,nì"; /* 㲡 */
dict[0x3ca2] = "biàn,bié"; /* 㲢 */
dict[0x3ca5] = "táng"; /* 㲥 */
dict[0x3ca6] = "hàn,hě"; /* 㲦 */
dict[0x3ca7] = "zào"; /* 㲧 */
dict[0x3ca8] = "róng"; /* 㲨 */
dict[0x3caa] = "dēng"; /* 㲪 */
dict[0x3cab] = "pú"; /* 㲫 */
dict[0x3cad] = "tǎn"; /* 㲭 */
dict[0x3caf] = "rán"; /* 㲯 */
dict[0x3cb0] = "níng"; /* 㲰 */
dict[0x3cb1] = "liè"; /* 㲱 */
dict[0x3cb2] = "dié,yì"; /* 㲲 */
dict[0x3cb3] = "dié"; /* 㲳 */
dict[0x3cb4] = "zhòng,zhòu"; /* 㲴 */
dict[0x3cb6] = "lǜ"; /* 㲶 */
dict[0x3cb7] = "dàn"; /* 㲷 */
dict[0x3cb9] = "guǐ,qiú"; /* 㲹 */
dict[0x3cba] = "jí,kè,léi"; /* 㲺 */
dict[0x3cbb] = "nì"; /* 㲻 */
dict[0x3cbc] = "yì"; /* 㲼 */
dict[0x3cbd] = "niàn,rěn,xiàn"; /* 㲽 */
dict[0x3cbe] = "yǔ,yù"; /* 㲾 */
dict[0x3cbf] = "wǎng"; /* 㲿 */
dict[0x3cc0] = "guò,kǎi,xì"; /* 㳀 */
dict[0x3cc1] = "zè"; /* 㳁 */
dict[0x3cc2] = "yán"; /* 㳂 */
dict[0x3cc3] = "cuì"; /* 㳃 */
dict[0x3cc4] = "xián"; /* 㳄 */
dict[0x3cc5] = "jiǎo,liú"; /* 㳅 */
dict[0x3cc6] = "shǔ,tǒu"; /* 㳆 */
dict[0x3cc7] = "fù"; /* 㳇 */
dict[0x3cc8] = "pèi"; /* 㳈 */
dict[0x3ccd] = "bù"; /* 㳍 */
dict[0x3cce] = "biàn,fàn"; /* 㳎 */
dict[0x3ccf] = "chǐ,shì"; /* 㳏 */
dict[0x3cd0] = "sà,zhá,zhǎ"; /* 㳐 */
dict[0x3cd1] = "yì"; /* 㳑 */
dict[0x3cd2] = "fǎ"; /* 㳒 */
dict[0x3cd4] = "duì"; /* 㳔 */
dict[0x3cd5] = "lán"; /* 㳕 */
dict[0x3cd7] = "chài"; /* 㳗 */
dict[0x3cd8] = "chōng"; /* 㳘 */
dict[0x3cd9] = "xuàn"; /* 㳙 */
dict[0x3cda] = "yù"; /* 㳚 */
dict[0x3cdb] = "yú"; /* 㳛 */
dict[0x3ce0] = "tà"; /* 㳠 */
dict[0x3ce5] = "jù,lòng"; /* 㳥 */
dict[0x3ce6] = "xiè"; /* 㳦 */
dict[0x3ce7] = "xí"; /* 㳧 */
dict[0x3ce8] = "jiǎn,zá,zǎn"; /* 㳨 */
dict[0x3cea] = "pàn,pì"; /* 㳪 */
dict[0x3ceb] = "tà"; /* 㳫 */
dict[0x3cec] = "xuán"; /* 㳬 */
dict[0x3ced] = "xián"; /* 㳭 */
dict[0x3cee] = "niào"; /* 㳮 */
dict[0x3cf4] = "mì"; /* 㳴 */
dict[0x3cf5] = "jì"; /* 㳵 */
dict[0x3cf6] = "gòu,nǒu"; /* 㳶 */
dict[0x3cf7] = "wěn,hū"; /* 㳷 */
dict[0x3cf9] = "wǎng"; /* 㳹 */
dict[0x3cfa] = "yóu"; /* 㳺 */
dict[0x3cfb] = "zé"; /* 㳻 */
dict[0x3cfc] = "bì"; /* 㳼 */
dict[0x3cfd] = "mǐ"; /* 㳽 */
dict[0x3cff] = "xiè"; /* 㳿 */
dict[0x3d00] = "fàn"; /* 㴀 */
dict[0x3d01] = "yì"; /* 㴁 */
dict[0x3d03] = "lèi,lì"; /* 㴃 */
dict[0x3d04] = "yíng"; /* 㴄 */
dict[0x3d06] = "jìn,xìng"; /* 㴆 */
dict[0x3d07] = "shè"; /* 㴇 */
dict[0x3d08] = "yìn"; /* 㴈 */
dict[0x3d09] = "jǐ"; /* 㴉 */
dict[0x3d0b] = "sù"; /* 㴋 */
dict[0x3d0f] = "wǎng"; /* 㴏 */
dict[0x3d10] = "miàn"; /* 㴐 */
dict[0x3d11] = "sù"; /* 㴑 */
dict[0x3d12] = "yì"; /* 㴒 */
dict[0x3d13] = "zǎi"; /* 㴓 */
dict[0x3d14] = "sè,yì"; /* 㴔 */
dict[0x3d15] = "jí"; /* 㴕 */
dict[0x3d16] = "luò"; /* 㴖 */
dict[0x3d18] = "mào"; /* 㴘 */
dict[0x3d19] = "zhá"; /* 㴙 */
dict[0x3d1a] = "suì"; /* 㴚 */
dict[0x3d1b] = "zhì"; /* 㴛 */
dict[0x3d1c] = "biàn"; /* 㴜 */
dict[0x3d1d] = "lí"; /* 㴝 */
dict[0x3d1e] = "tāo"; /* 㴞 */
dict[0x3d25] = "qiào"; /* 㴥 */
dict[0x3d26] = "guàn"; /* 㴦 */
dict[0x3d28] = "zhèn"; /* 㴨 */
dict[0x3d29] = "yōng"; /* 㴩 */
dict[0x3d2a] = "niè"; /* 㴪 */
dict[0x3d2b] = "jùn"; /* 㴫 */
dict[0x3d2c] = "xiè"; /* 㴬 */
dict[0x3d2d] = "yǎo"; /* 㴭 */
dict[0x3d2e] = "xiè"; /* 㴮 */
dict[0x3d30] = "néng"; /* 㴰 */
dict[0x3d32] = "sī"; /* 㴲 */
dict[0x3d33] = "lǒng"; /* 㴳 */
dict[0x3d34] = "chén"; /* 㴴 */
dict[0x3d35] = "mì"; /* 㴵 */
dict[0x3d36] = "què"; /* 㴶 */
dict[0x3d37] = "dān"; /* 㴷 */
dict[0x3d38] = "nà,shǎn,yè"; /* 㴸 */
dict[0x3d3c] = "sù"; /* 㴼 */
dict[0x3d3d] = "xiè,yìn"; /* 㴽 */
dict[0x3d3e] = "bó"; /* 㴾 */
dict[0x3d3f] = "dǐng"; /* 㴿 */
dict[0x3d40] = "cuàn,zú"; /* 㵀 */
dict[0x3d42] = "chuǎng,shù"; /* 㵂 */
dict[0x3d43] = "shé"; /* 㵃 */
dict[0x3d44] = "hàn,qià,yù"; /* 㵄 */
dict[0x3d45] = "dàn,tàn"; /* 㵅 */
dict[0x3d46] = "hào"; /* 㵆 */
dict[0x3d4a] = "shěn,zhé"; /* 㵊 */
dict[0x3d4b] = "mì"; /* 㵋 */
dict[0x3d4c] = "chàn,qióng,xún"; /* 㵌 */
dict[0x3d4d] = "mèn"; /* 㵍 */
dict[0x3d4e] = "hǎn,jiàn,kǎn"; /* 㵎 */
dict[0x3d4f] = "cuǐ"; /* 㵏 */
dict[0x3d50] = "jué"; /* 㵐 */
dict[0x3d51] = "hè"; /* 㵑 */
dict[0x3d52] = "fèi"; /* 㵒 */
dict[0x3d53] = "shí"; /* 㵓 */
dict[0x3d54] = "chě,chè"; /* 㵔 */
dict[0x3d55] = "shèn"; /* 㵕 */
dict[0x3d57] = "fù,pán,píng"; /* 㵗 */
dict[0x3d58] = "màn"; /* 㵘 */
dict[0x3d5d] = "yì"; /* 㵝 */
dict[0x3d5e] = "chóu"; /* 㵞 */
dict[0x3d61] = "báo"; /* 㵡 */
dict[0x3d62] = "léi,lěi"; /* 㵢 */
dict[0x3d63] = "kě,luǒ"; /* 㵣 */
dict[0x3d64] = "diàn,shà,xiá"; /* 㵤 */
dict[0x3d65] = "bì,mì"; /* 㵥 */
dict[0x3d66] = "suí"; /* 㵦 */
dict[0x3d67] = "gé"; /* 㵧 */
dict[0x3d68] = "bì,pì"; /* 㵨 */
dict[0x3d69] = "yì"; /* 㵩 */
dict[0x3d6a] = "xián"; /* 㵪 */
dict[0x3d6b] = "nǐ,yì"; /* 㵫 */
dict[0x3d6c] = "yíng"; /* 㵬 */
dict[0x3d6d] = "zhǔ"; /* 㵭 */
dict[0x3d6e] = "chún,wěn"; /* 㵮 */
dict[0x3d6f] = "féng"; /* 㵯 */
dict[0x3d70] = "xù"; /* 㵰 */
dict[0x3d71] = "piǎo"; /* 㵱 */
dict[0x3d72] = "wǔ"; /* 㵲 */
dict[0x3d73] = "liáo,liú"; /* 㵳 */
dict[0x3d74] = "cáng"; /* 㵴 */
dict[0x3d75] = "zòu"; /* 㵵 */
dict[0x3d77] = "biàn"; /* 㵷 */
dict[0x3d78] = "yào,yuè"; /* 㵸 */
dict[0x3d79] = "huán"; /* 㵹 */
dict[0x3d7a] = "pái,pài"; /* 㵺 */
dict[0x3d7b] = "sòu"; /* 㵻 */
dict[0x3d7c] = "xiè"; /* 㵼 */
dict[0x3d7d] = "duì,lěi"; /* 㵽 */
dict[0x3d7e] = "jìng,qìng"; /* 㵾 */
dict[0x3d7f] = "xí"; /* 㵿 */
dict[0x3d81] = "guó"; /* 㶁 */
dict[0x3d84] = "yán"; /* 㶄 */
dict[0x3d85] = "xué"; /* 㶅 */
dict[0x3d86] = "chú,zhū"; /* 㶆 */
dict[0x3d87] = "héng"; /* 㶇 */
dict[0x3d88] = "yíng,yìng"; /* 㶈 */
dict[0x3d8c] = "lián"; /* 㶌 */
dict[0x3d8d] = "xiǎn"; /* 㶍 */
dict[0x3d8e] = "huán"; /* 㶎 */
dict[0x3d91] = "liàn"; /* 㶑 */
dict[0x3d92] = "shǎn,shěn,tàn"; /* 㶒 */
dict[0x3d93] = "cáng"; /* 㶓 */
dict[0x3d94] = "bèi"; /* 㶔 */
dict[0x3d95] = "jiǎn"; /* 㶕 */
dict[0x3d96] = "shù"; /* 㶖 */
dict[0x3d97] = "fàn"; /* 㶗 */
dict[0x3d98] = "diàn"; /* 㶘 */
dict[0x3d9a] = "bà"; /* 㶚 */
dict[0x3d9b] = "yú"; /* 㶛 */
dict[0x3d9e] = "nǎng"; /* 㶞 */
dict[0x3d9f] = "lěi"; /* 㶟 */
dict[0x3da0] = "yì"; /* 㶠 */
dict[0x3da1] = "dài,huǒ,zuó"; /* 㶡 */
dict[0x3da3] = "chán"; /* 㶣 */
dict[0x3da4] = "chǎo"; /* 㶤 */
dict[0x3da6] = "jìn"; /* 㶦 */
dict[0x3da7] = "nèn"; /* 㶧 */
dict[0x3dab] = "liǎo,liào"; /* 㶫 */
dict[0x3dac] = "méi,mò"; /* 㶬 */
dict[0x3dad] = "jiù,yǒu"; /* 㶭 */
dict[0x3daf] = "liù"; /* 㶯 */
dict[0x3db0] = "hán"; /* 㶰 */
dict[0x3db2] = "yòng"; /* 㶲 */
dict[0x3db3] = "jìn"; /* 㶳 */
dict[0x3db4] = "chǐ,shǐ"; /* 㶴 */
dict[0x3db5] = "rèn"; /* 㶵 */
dict[0x3db6] = "nóng"; /* 㶶 */
dict[0x3db9] = "hòng"; /* 㶹 */
dict[0x3dba] = "tiàn"; /* 㶺 */
dict[0x3dbf] = "bó"; /* 㶿 */
dict[0x3dc0] = "qióng"; /* 㷀 */
dict[0x3dc2] = "shù"; /* 㷂 */
dict[0x3dc3] = "cuǐ"; /* 㷃 */
dict[0x3dc4] = "huì"; /* 㷄 */
dict[0x3dc5] = "chǎo,miǎo"; /* 㷅 */
dict[0x3dc6] = "dòu,fù"; /* 㷆 */
dict[0x3dc7] = "guài,kuí"; /* 㷇 */
dict[0x3dc8] = "è"; /* 㷈 */
dict[0x3dc9] = "wèi,yù,yùn"; /* 㷉 */
dict[0x3dca] = "fén"; /* 㷊 */
dict[0x3dcb] = "tán,tǎn"; /* 㷋 */
dict[0x3dcd] = "lún"; /* 㷍 */
dict[0x3dce] = "hè,hóng,xié"; /* 㷎 */
dict[0x3dcf] = "yǒng"; /* 㷏 */
dict[0x3dd0] = "huǐ"; /* 㷐 */
dict[0x3dd2] = "yú"; /* 㷒 */
dict[0x3dd3] = "zǒng"; /* 㷓 */
dict[0x3dd4] = "yàn"; /* 㷔 */
dict[0x3dd5] = "qiú"; /* 㷕 */
dict[0x3dd6] = "zhào"; /* 㷖 */
dict[0x3dd7] = "jiǒng"; /* 㷗 */
dict[0x3dd8] = "tái"; /* 㷘 */
dict[0x3ddf] = "tuì"; /* 㷟 */
dict[0x3de0] = "lín"; /* 㷠 */
dict[0x3de1] = "jiǒng"; /* 㷡 */
dict[0x3de2] = "zhǎ"; /* 㷢 */
dict[0x3de4] = "hè,hù,xuè"; /* 㷤 */
dict[0x3de6] = "xù"; /* 㷦 */
dict[0x3de9] = "xī"; /* 㷩 */
dict[0x3dea] = "cuì,zuǎn"; /* 㷪 */
dict[0x3deb] = "qǐng"; /* 㷫 */
dict[0x3dec] = "mò"; /* 㷬 */
dict[0x3ded] = "fēng"; /* 㷭 */
dict[0x3dee] = "zāo"; /* 㷮 */
dict[0x3def] = "bèng"; /* 㷯 */
dict[0x3df0] = "lí"; /* 㷰 */
dict[0x3df3] = "yàn"; /* 㷳 */
dict[0x3df4] = "gé,lì"; /* 㷴 */
dict[0x3df5] = "mò"; /* 㷵 */
dict[0x3df6] = "bèi,bì"; /* 㷶 */
dict[0x3df7] = "juǎn"; /* 㷷 */
dict[0x3df8] = "dié,yè"; /* 㷸 */
dict[0x3df9] = "shào"; /* 㷹 */
dict[0x3dfb] = "wú"; /* 㷻 */
dict[0x3dfc] = "yàn"; /* 㷼 */
dict[0x3dfe] = "jué"; /* 㷾 */
dict[0x3e00] = "tái"; /* 㸀 */
dict[0x3e01] = "hǎn,hàn"; /* 㸁 */
dict[0x3e03] = "diǎn"; /* 㸃 */
dict[0x3e04] = "jì,jié"; /* 㸄 */
dict[0x3e05] = "jié"; /* 㸅 */
dict[0x3e06] = "kào"; /* 㸆 */
dict[0x3e09] = "xiè"; /* 㸉 */
dict[0x3e0a] = "là,lài,liè"; /* 㸊 */
dict[0x3e0b] = "fán"; /* 㸋 */
dict[0x3e0c] = "huò"; /* 㸌 */
dict[0x3e0d] = "xì"; /* 㸍 */
dict[0x3e0e] = "niè"; /* 㸎 */
dict[0x3e0f] = "mí"; /* 㸏 */
dict[0x3e10] = "rán"; /* 㸐 */
dict[0x3e11] = "cuàn"; /* 㸑 */
dict[0x3e12] = "yín"; /* 㸒 */
dict[0x3e13] = "mì"; /* 㸓 */
dict[0x3e14] = "kàn"; /* 㸔 */
dict[0x3e15] = "jué"; /* 㸕 */
dict[0x3e17] = "tóng"; /* 㸗 */
dict[0x3e18] = "wàn"; /* 㸘 */
dict[0x3e1a] = "lǐ"; /* 㸚 */
dict[0x3e1b] = "sháo,shuò"; /* 㸛 */
dict[0x3e1c] = "kòng"; /* 㸜 */
dict[0x3e1d] = "kǎn"; /* 㸝 */
dict[0x3e1e] = "bǎn"; /* 㸞 */
dict[0x3e20] = "tiǎo"; /* 㸠 */
dict[0x3e22] = "bèi"; /* 㸢 */
dict[0x3e23] = "yè,yì"; /* 㸣 */
dict[0x3e24] = "piàn"; /* 㸤 */
dict[0x3e25] = "chán"; /* 㸥 */
dict[0x3e26] = "hù"; /* 㸦 */
dict[0x3e27] = "kèn,yín"; /* 㸧 */
dict[0x3e29] = "àn"; /* 㸩 */
dict[0x3e2a] = "chún"; /* 㸪 */
dict[0x3e2b] = "qián"; /* 㸫 */
dict[0x3e2c] = "bèi,fèi,pèi"; /* 㸬 */
dict[0x3e2e] = "fén"; /* 㸮 */
dict[0x3e30] = "tuó"; /* 㸰 */
dict[0x3e31] = "tuó"; /* 㸱 */
dict[0x3e32] = "zuó,zuò"; /* 㸲 */
dict[0x3e33] = "líng"; /* 㸳 */
dict[0x3e35] = "guǐ,wěi"; /* 㸵 */
dict[0x3e37] = "shì"; /* 㸷 */
dict[0x3e38] = "hǒu,ǒu,kǒu"; /* 㸸 */
dict[0x3e39] = "liè"; /* 㸹 */
dict[0x3e3a] = "shā"; /* 㸺 */
dict[0x3e3b] = "sì"; /* 㸻 */
dict[0x3e3d] = "bèi"; /* 㸽 */
dict[0x3e3e] = "rèn"; /* 㸾 */
dict[0x3e3f] = "dú"; /* 㸿 */
dict[0x3e40] = "bó"; /* 㹀 */
dict[0x3e41] = "liáng"; /* 㹁 */
dict[0x3e42] = "cì,qiǎn"; /* 㹂 */
dict[0x3e43] = "bì,fèi"; /* 㹃 */
dict[0x3e44] = "jì,qì"; /* 㹄 */
dict[0x3e45] = "zǒng"; /* 㹅 */
dict[0x3e47] = "hé"; /* 㹇 */
dict[0x3e48] = "lí,máo"; /* 㹈 */
dict[0x3e49] = "yuán"; /* 㹉 */
dict[0x3e4a] = "yuè"; /* 㹊 */
dict[0x3e4c] = "chǎn,shèng"; /* 㹌 */
dict[0x3e4d] = "dí,dú"; /* 㹍 */
dict[0x3e4e] = "léi"; /* 㹎 */
dict[0x3e4f] = "jǐn"; /* 㹏 */
dict[0x3e50] = "chóng,zhòu"; /* 㹐 */
dict[0x3e51] = "sì,yí"; /* 㹑 */
dict[0x3e52] = "pǔ"; /* 㹒 */
dict[0x3e53] = "yì"; /* 㹓 */
dict[0x3e54] = "jiāng"; /* 㹔 */
dict[0x3e56] = "huàn"; /* 㹖 */
dict[0x3e57] = "táo,tāo"; /* 㹗 */
dict[0x3e58] = "rú,rù,ruí"; /* 㹘 */
dict[0x3e59] = "wěng"; /* 㹙 */
dict[0x3e5a] = "wěng"; /* 㹚 */
dict[0x3e5b] = "ráo,rǎo"; /* 㹛 */
dict[0x3e5c] = "yín"; /* 㹜 */
dict[0x3e5d] = "shì"; /* 㹝 */
dict[0x3e5e] = "yín,yǐn"; /* 㹞 */
dict[0x3e5f] = "jué"; /* 㹟 */
dict[0x3e60] = "tún"; /* 㹠 */
dict[0x3e61] = "xuán,xuàn"; /* 㹡 */
dict[0x3e63] = "zhōng"; /* 㹣 */
dict[0x3e64] = "qiè,què"; /* 㹤 */
dict[0x3e65] = "zhù"; /* 㹥 */
dict[0x3e68] = "yòu"; /* 㹨 */
dict[0x3e6b] = "xì,yí"; /* 㹫 */
dict[0x3e6c] = "shǐ"; /* 㹬 */
dict[0x3e6d] = "yì"; /* 㹭 */
dict[0x3e6e] = "mò"; /* 㹮 */
dict[0x3e71] = "hú,què,rǎn"; /* 㹱 */
dict[0x3e72] = "xiào"; /* 㹲 */
dict[0x3e73] = "wú"; /* 㹳 */
dict[0x3e75] = "jìng"; /* 㹵 */
dict[0x3e76] = "tíng"; /* 㹶 */
dict[0x3e77] = "shǐ,xìn"; /* 㹷 */
dict[0x3e78] = "ní"; /* 㹸 */
dict[0x3e7a] = "tà"; /* 㹺 */
dict[0x3e7c] = "chǔ,jú,yù"; /* 㹼 */
dict[0x3e7d] = "chǎn,shàn"; /* 㹽 */
dict[0x3e7e] = "piǎo"; /* 㹾 */
dict[0x3e7f] = "diǎo,zhào,zhuó"; /* 㹿 */
dict[0x3e80] = "náo"; /* 㺀 */
dict[0x3e81] = "nǎo"; /* 㺁 */
dict[0x3e82] = "gǎn,jiàn,yán"; /* 㺂 */
dict[0x3e83] = "gǒu"; /* 㺃 */
dict[0x3e84] = "yǔ"; /* 㺄 */
dict[0x3e85] = "hóu"; /* 㺅 */
dict[0x3e87] = "sī"; /* 㺇 */
dict[0x3e88] = "chī"; /* 㺈 */
dict[0x3e89] = "hù"; /* 㺉 */
dict[0x3e8a] = "yàng"; /* 㺊 */
dict[0x3e8c] = "xiàn"; /* 㺌 */
dict[0x3e8e] = "róng"; /* 㺎 */
dict[0x3e8f] = "lóu"; /* 㺏 */
dict[0x3e90] = "zhǎo"; /* 㺐 */
dict[0x3e91] = "cán,shǎn"; /* 㺑 */
dict[0x3e92] = "liào,yáo,xiāo"; /* 㺒 */
dict[0x3e93] = "piào"; /* 㺓 */
dict[0x3e94] = "hài,wèi"; /* 㺔 */
dict[0x3e95] = "fán"; /* 㺕 */
dict[0x3e96] = "hǎn"; /* 㺖 */
dict[0x3e97] = "dàn,yán"; /* 㺗 */
dict[0x3e98] = "zhàn"; /* 㺘 */
dict[0x3e9a] = "tǎ"; /* 㺚 */
dict[0x3e9b] = "zhù"; /* 㺛 */
dict[0x3e9c] = "nóng"; /* 㺜 */
dict[0x3e9d] = "jiàn"; /* 㺝 */
dict[0x3e9e] = "yú"; /* 㺞 */
dict[0x3e9f] = "zhuó"; /* 㺟 */
dict[0x3ea0] = "yòu,yù"; /* 㺠 */
dict[0x3ea1] = "lì"; /* 㺡 */
dict[0x3ea3] = "xī"; /* 㺣 */
dict[0x3ea5] = "chán,tán"; /* 㺥 */
dict[0x3ea6] = "lián"; /* 㺦 */
dict[0x3ea8] = "sī"; /* 㺨 */
dict[0x3ea9] = "jiù,sè"; /* 㺩 */
dict[0x3eaa] = "pú"; /* 㺪 */
dict[0x3eab] = "qiú"; /* 㺫 */
dict[0x3eac] = "gǒng"; /* 㺬 */
dict[0x3ead] = "zǐ"; /* 㺭 */
dict[0x3eae] = "yú"; /* 㺮 */
dict[0x3eb1] = "réng"; /* 㺱 */
dict[0x3eb2] = "niǔ"; /* 㺲 */
dict[0x3eb3] = "méi"; /* 㺳 */
dict[0x3eb5] = "jiú"; /* 㺵 */
dict[0x3eb7] = "xù"; /* 㺷 */
dict[0x3eb8] = "píng"; /* 㺸 */
dict[0x3eb9] = "biàn"; /* 㺹 */
dict[0x3eba] = "mào"; /* 㺺 */
dict[0x3ebf] = "yí"; /* 㺿 */
dict[0x3ec0] = "yóu,yú"; /* 㻀 */
dict[0x3ec2] = "píng"; /* 㻂 */
dict[0x3ec3] = "qū"; /* 㻃 */
dict[0x3ec4] = "bǎo"; /* 㻄 */
dict[0x3ec5] = "huì,kuài"; /* 㻅 */
dict[0x3ec9] = "bù"; /* 㻉 */
dict[0x3eca] = "máng,mén,mèng"; /* 㻊 */
dict[0x3ecb] = "là,lèi"; /* 㻋 */
dict[0x3ecc] = "tú"; /* 㻌 */
dict[0x3ecd] = "wú"; /* 㻍 */
dict[0x3ece] = "lì,sè"; /* 㻎 */
dict[0x3ecf] = "líng,lǐng"; /* 㻏 */
dict[0x3ed1] = "jì"; /* 㻑 */
dict[0x3ed2] = "jùn"; /* 㻒 */
dict[0x3ed4] = "duǒ,ruì"; /* 㻔 */
dict[0x3ed5] = "jué"; /* 㻕 */
dict[0x3ed6] = "dài"; /* 㻖 */
dict[0x3ed7] = "bèi"; /* 㻗 */
dict[0x3edd] = "là"; /* 㻝 */
dict[0x3ede] = "biàn,fèn,pìn"; /* 㻞 */
dict[0x3edf] = "suí"; /* 㻟 */
dict[0x3ee0] = "tú"; /* 㻠 */
dict[0x3ee1] = "dié,jué"; /* 㻡 */
dict[0x3ee7] = "duò,hé"; /* 㻧 */
dict[0x3eea] = "suì"; /* 㻪 */
dict[0x3eeb] = "bì"; /* 㻫 */
dict[0x3eec] = "tú"; /* 㻬 */
dict[0x3eed] = "sè,zé"; /* 㻭 */
dict[0x3eee] = "càn"; /* 㻮 */
dict[0x3eef] = "tú"; /* 㻯 */
dict[0x3ef0] = "miǎn,rè,wèi,yù"; /* 㻰 */
dict[0x3ef5] = "zhàn"; /* 㻵 */
dict[0x3ef6] = "bǐ,bì"; /* 㻶 */
dict[0x3ef7] = "jí"; /* 㻷 */
dict[0x3ef8] = "cén,jìn,xín,zēn"; /* 㻸 */
dict[0x3efa] = "lì,liè"; /* 㻺 */
dict[0x3efd] = "suì"; /* 㻽 */
dict[0x3eff] = "shǔ"; /* 㻿 */
dict[0x3f02] = "é,wèn,yuǎn"; /* 㼂 */
dict[0x3f06] = "yíng"; /* 㼆 */
dict[0x3f07] = "qióng"; /* 㼇 */
dict[0x3f08] = "luó"; /* 㼈 */
dict[0x3f09] = "yìn,zhèn"; /* 㼉 */
dict[0x3f0a] = "tún"; /* 㼊 */
dict[0x3f0b] = "gǔ,jiǔ,móu,rǔ"; /* 㼋 */
dict[0x3f0c] = "yǔ"; /* 㼌 */
dict[0x3f0d] = "lěi"; /* 㼍 */
dict[0x3f0e] = "bèi,bó,kě"; /* 㼎 */
dict[0x3f0f] = "něi"; /* 㼏 */
dict[0x3f10] = "pián"; /* 㼐 */
dict[0x3f11] = "liàn,luán"; /* 㼑 */
dict[0x3f12] = "qiǔ,tǎng"; /* 㼒 */
dict[0x3f13] = "lián,liǎn"; /* 㼓 */
dict[0x3f16] = "lì"; /* 㼖 */
dict[0x3f17] = "dǐng,tíng"; /* 㼗 */
dict[0x3f18] = "wǎ"; /* 㼘 */
dict[0x3f19] = "zhòu"; /* 㼙 */
dict[0x3f1b] = "xíng"; /* 㼛 */
dict[0x3f1c] = "àng,póu"; /* 㼜 */
dict[0x3f1d] = "fàn,wǎn"; /* 㼝 */
dict[0x3f1e] = "pèng"; /* 㼞 */
dict[0x3f1f] = "bái"; /* 㼟 */
dict[0x3f20] = "tuó"; /* 㼠 */
dict[0x3f22] = "ě,yí"; /* 㼢 */
dict[0x3f23] = "bǎi,bó"; /* 㼣 */
dict[0x3f24] = "qì,qiè,yà"; /* 㼤 */
dict[0x3f25] = "chú,kǎo,tǒu"; /* 㼥 */
dict[0x3f26] = "gǒng"; /* 㼦 */
dict[0x3f27] = "tóng"; /* 㼧 */
dict[0x3f28] = "hán"; /* 㼨 */
dict[0x3f29] = "chéng"; /* 㼩 */
dict[0x3f2a] = "jiá"; /* 㼪 */
dict[0x3f2b] = "huàn"; /* 㼫 */
dict[0x3f2c] = "xìng"; /* 㼬 */
dict[0x3f2d] = "diàn,niǎo"; /* 㼭 */
dict[0x3f2e] = "chāi,qì"; /* 㼮 */
dict[0x3f2f] = "dòng"; /* 㼯 */
dict[0x3f30] = "é,pí"; /* 㼰 */
dict[0x3f31] = "ruǎn"; /* 㼱 */
dict[0x3f32] = "liè"; /* 㼲 */
dict[0x3f33] = "shěng"; /* 㼳 */
dict[0x3f34] = "ǒu"; /* 㼴 */
dict[0x3f35] = "dì"; /* 㼵 */
dict[0x3f36] = "yú"; /* 㼶 */
dict[0x3f37] = "chuán"; /* 㼷 */
dict[0x3f38] = "róng"; /* 㼸 */
dict[0x3f3a] = "táng"; /* 㼺 */
dict[0x3f3b] = "cóng"; /* 㼻 */
dict[0x3f3c] = "piáo"; /* 㼼 */
dict[0x3f3d] = "shuǎng,chuǎng"; /* 㼽 */
dict[0x3f3e] = "lù"; /* 㼾 */
dict[0x3f3f] = "tóng"; /* 㼿 */
dict[0x3f40] = "zhèng"; /* 㽀 */
dict[0x3f41] = "lì"; /* 㽁 */
dict[0x3f42] = "sà"; /* 㽂 */
dict[0x3f47] = "guài,hú,huí,méng,sè"; /* 㽇 */
dict[0x3f48] = "yì"; /* 㽈 */
dict[0x3f49] = "hǎn,jiàn,xiàn"; /* 㽉 */
dict[0x3f4a] = "xiè"; /* 㽊 */
dict[0x3f4b] = "luó,luò"; /* 㽋 */
dict[0x3f4c] = "liù"; /* 㽌 */
dict[0x3f4e] = "dǎn,tán"; /* 㽎 */
dict[0x3f4f] = "gàn"; /* 㽏 */
dict[0x3f51] = "tán"; /* 㽑 */
dict[0x3f55] = "yóu"; /* 㽕 */
dict[0x3f56] = "nán"; /* 㽖 */
dict[0x3f58] = "gǎng"; /* 㽘 */
dict[0x3f59] = "jùn"; /* 㽙 */
dict[0x3f5a] = "chì"; /* 㽚 */
dict[0x3f5b] = "gōu,qú"; /* 㽛 */
dict[0x3f5c] = "wǎn"; /* 㽜 */
dict[0x3f5d] = "lì"; /* 㽝 */
dict[0x3f5e] = "liú"; /* 㽞 */
dict[0x3f5f] = "liè"; /* 㽟 */
dict[0x3f60] = "xiá"; /* 㽠 */
dict[0x3f61] = "bēi"; /* 㽡 */
dict[0x3f62] = "ǎn,yè"; /* 㽢 */
dict[0x3f63] = "yù"; /* 㽣 */
dict[0x3f64] = "jú"; /* 㽤 */
dict[0x3f65] = "róu"; /* 㽥 */
dict[0x3f66] = "xún"; /* 㽦 */
dict[0x3f68] = "cuó"; /* 㽨 */
dict[0x3f69] = "càn,cào"; /* 㽩 */
dict[0x3f6a] = "zěng,zhǎ"; /* 㽪 */
dict[0x3f6b] = "yǒng"; /* 㽫 */
dict[0x3f6c] = "fù"; /* 㽬 */
dict[0x3f6d] = "ruǎn"; /* 㽭 */
dict[0x3f6f] = "xí"; /* 㽯 */
dict[0x3f70] = "shù"; /* 㽰 */
dict[0x3f71] = "jiǎo,jiū,niú"; /* 㽱 */
dict[0x3f72] = "jiǎo"; /* 㽲 */
dict[0x3f73] = "hàn,xiè,xǔ,yú"; /* 㽳 */
dict[0x3f74] = "zhàng"; /* 㽴 */
dict[0x3f77] = "shuì"; /* 㽷 */
dict[0x3f78] = "chén"; /* 㽸 */
dict[0x3f79] = "fàn,wǎn"; /* 㽹 */
dict[0x3f7a] = "jí"; /* 㽺 */
dict[0x3f7d] = "gù"; /* 㽽 */
dict[0x3f7e] = "wù"; /* 㽾 */
dict[0x3f80] = "qiè"; /* 㾀 */
dict[0x3f81] = "shù"; /* 㾁 */
dict[0x3f83] = "tuó"; /* 㾃 */
dict[0x3f84] = "dú"; /* 㾄 */
dict[0x3f85] = "zǐ"; /* 㾅 */
dict[0x3f86] = "rán,shǎn"; /* 㾆 */
dict[0x3f87] = "mù"; /* 㾇 */
dict[0x3f88] = "fù"; /* 㾈 */
dict[0x3f89] = "líng"; /* 㾉 */
dict[0x3f8a] = "jí"; /* 㾊 */
dict[0x3f8b] = "xiù"; /* 㾋 */
dict[0x3f8c] = "xuǎn"; /* 㾌 */
dict[0x3f8d] = "nái"; /* 㾍 */
dict[0x3f8f] = "jiè"; /* 㾏 */
dict[0x3f90] = "lì"; /* 㾐 */
dict[0x3f91] = "dá"; /* 㾑 */
dict[0x3f92] = "jì,rú,rù"; /* 㾒 */
dict[0x3f93] = "yùn"; /* 㾓 */
dict[0x3f95] = "shěn"; /* 㾕 */
dict[0x3f96] = "lǐ,luó"; /* 㾖 */
dict[0x3f97] = "lǎng,liàng"; /* 㾗 */
dict[0x3f98] = "gěng"; /* 㾘 */
dict[0x3f99] = "yǐn"; /* 㾙 */
dict[0x3f9b] = "qǐn"; /* 㾛 */
dict[0x3f9c] = "qiè"; /* 㾜 */
dict[0x3f9d] = "chè"; /* 㾝 */
dict[0x3f9e] = "yǒu"; /* 㾞 */
dict[0x3f9f] = "bù"; /* 㾟 */
dict[0x3fa0] = "huáng,kuáng,kuì"; /* 㾠 */
dict[0x3fa1] = "què"; /* 㾡 */
dict[0x3fa2] = "lài"; /* 㾢 */
dict[0x3fa5] = "xù"; /* 㾥 */
dict[0x3fa6] = "bàng,pèi,pén"; /* 㾦 */
dict[0x3fa7] = "kè"; /* 㾧 */
dict[0x3fa8] = "qǐ,yǐ"; /* 㾨 */
dict[0x3faa] = "shěng"; /* 㾪 */
dict[0x3fab] = "piān"; /* 㾫 */
dict[0x3fad] = "zhòu"; /* 㾭 */
dict[0x3fae] = "huáng"; /* 㾮 */
dict[0x3faf] = "tuí,wěi"; /* 㾯 */
dict[0x3fb0] = "hú"; /* 㾰 */
dict[0x3fb1] = "bèi,fàn,fèi,fú"; /* 㾱 */
dict[0x3fb5] = "jì"; /* 㾵 */
dict[0x3fb6] = "gǔ"; /* 㾶 */
dict[0x3fb8] = "gǎo"; /* 㾸 */
dict[0x3fb9] = "chái"; /* 㾹 */
dict[0x3fba] = "mà,mò"; /* 㾺 */
dict[0x3fbb] = "zhù"; /* 㾻 */
dict[0x3fbc] = "tuǐ"; /* 㾼 */
dict[0x3fbd] = "tuí,zhuì"; /* 㾽 */
dict[0x3fbe] = "lián"; /* 㾾 */
dict[0x3fbf] = "láng,lǎng"; /* 㾿 */
dict[0x3fc3] = "dài,zhì"; /* 㿃 */
dict[0x3fc4] = "ài"; /* 㿄 */
dict[0x3fc5] = "xiǎn,xuǎn"; /* 㿅 */
dict[0x3fc7] = "xí,xì"; /* 㿇 */
dict[0x3fc9] = "tuí"; /* 㿉 */
dict[0x3fca] = "cǎn"; /* 㿊 */
dict[0x3fcb] = "sào"; /* 㿋 */
dict[0x3fcd] = "jiè"; /* 㿍 */
dict[0x3fce] = "fèn"; /* 㿎 */
dict[0x3fcf] = "qún"; /* 㿏 */
dict[0x3fd1] = "yào"; /* 㿑 */
dict[0x3fd2] = "dǎo"; /* 㿒 */
dict[0x3fd3] = "jiá"; /* 㿓 */
dict[0x3fd4] = "lěi"; /* 㿔 */
dict[0x3fd5] = "yán"; /* 㿕 */
dict[0x3fd6] = "lú"; /* 㿖 */
dict[0x3fd7] = "tuí"; /* 㿗 */
dict[0x3fd8] = "yíng"; /* 㿘 */
dict[0x3fd9] = "pì"; /* 㿙 */
dict[0x3fda] = "luò"; /* 㿚 */
dict[0x3fdb] = "lí,lì"; /* 㿛 */
dict[0x3fdc] = "biě"; /* 㿜 */
dict[0x3fde] = "mào"; /* 㿞 */
dict[0x3fdf] = "bái,jiǎo"; /* 㿟 */
dict[0x3fe0] = "huàng"; /* 㿠 */
dict[0x3fe2] = "yào,zhuì"; /* 㿢 */
dict[0x3fe3] = "hé,xiá"; /* 㿣 */
dict[0x3fe4] = "chǔn"; /* 㿤 */
dict[0x3fe5] = "hú,hé"; /* 㿥 */
dict[0x3fe6] = "nìng"; /* 㿦 */
dict[0x3fe7] = "chóu"; /* 㿧 */
dict[0x3fe8] = "lì"; /* 㿨 */
dict[0x3fe9] = "tǎng"; /* 㿩 */
dict[0x3fea] = "huán"; /* 㿪 */
dict[0x3feb] = "bì"; /* 㿫 */
dict[0x3fed] = "chè"; /* 㿭 */
dict[0x3fee] = "yàng"; /* 㿮 */
dict[0x3fef] = "dá"; /* 㿯 */
dict[0x3ff0] = "áo"; /* 㿰 */
dict[0x3ff1] = "xué"; /* 㿱 */
dict[0x3ff5] = "rǎn"; /* 㿵 */
dict[0x3ff7] = "cuó,cāo"; /* 㿷 */
dict[0x3ff8] = "wǎn,mán"; /* 㿸 */
dict[0x3ff9] = "tà"; /* 㿹 */
dict[0x3ffa] = "báo"; /* 㿺 */
dict[0x3ffc] = "yán"; /* 㿼 */
dict[0x3ffe] = "zhù"; /* 㿾 */
dict[0x3fff] = "yǎ"; /* 㿿 */
dict[0x4000] = "fán"; /* 䀀 */
dict[0x4001] = "yòu"; /* 䀁 */
dict[0x4003] = "tuí"; /* 䀃 */
dict[0x4004] = "méng"; /* 䀄 */
dict[0x4005] = "shè,zhé"; /* 䀅 */
dict[0x4006] = "jìn"; /* 䀆 */
dict[0x4007] = "gǔ,què"; /* 䀇 */
dict[0x4008] = "qì"; /* 䀈 */
dict[0x4009] = "qiáo,shà"; /* 䀉 */
dict[0x400a] = "jiǎo"; /* 䀊 */
dict[0x400b] = "yán"; /* 䀋 */
dict[0x400d] = "kàn"; /* 䀍 */
dict[0x400e] = "miǎn"; /* 䀎 */
dict[0x400f] = "xiàn,xuàn"; /* 䀏 */
dict[0x4010] = "sǎn"; /* 䀐 */
dict[0x4011] = "nà,nì,wò"; /* 䀑 */
dict[0x4013] = "huàn"; /* 䀓 */
dict[0x4014] = "niú,rèn"; /* 䀔 */
dict[0x4015] = "chèng,zhèn"; /* 䀕 */
dict[0x4017] = "jué"; /* 䀗 */
dict[0x4018] = "xí,xié"; /* 䀘 */
dict[0x4019] = "qì"; /* 䀙 */
dict[0x401a] = "áng"; /* 䀚 */
dict[0x401b] = "mèi,wù"; /* 䀛 */
dict[0x401c] = "gǔ,mèi,xué"; /* 䀜 */
dict[0x401f] = "fán,fèi,fèn"; /* 䀟 */
dict[0x4020] = "qú,jù"; /* 䀠 */
dict[0x4021] = "chàn,tàn"; /* 䀡 */
dict[0x4022] = "shùn"; /* 䀢 */
dict[0x4023] = "bì,mà"; /* 䀣 */
dict[0x4024] = "mào"; /* 䀤 */
dict[0x4025] = "shuò"; /* 䀥 */
dict[0x4026] = "gǔ"; /* 䀦 */
dict[0x4027] = "hǒng"; /* 䀧 */
dict[0x4028] = "huàn"; /* 䀨 */
dict[0x4029] = "luò"; /* 䀩 */
dict[0x402a] = "háng"; /* 䀪 */
dict[0x402b] = "jiá"; /* 䀫 */
dict[0x402c] = "quán"; /* 䀬 */
dict[0x402d] = "gāi"; /* 䀭 */
dict[0x402e] = "máng"; /* 䀮 */
dict[0x402f] = "bǔ"; /* 䀯 */
dict[0x4030] = "gǔ,yíng"; /* 䀰 */
dict[0x4032] = "mù"; /* 䀲 */
dict[0x4033] = "ài,là,lài"; /* 䀳 */
dict[0x4034] = "yǐng"; /* 䀴 */
dict[0x4035] = "shùn"; /* 䀵 */
dict[0x4036] = "lǎng,liàng"; /* 䀶 */
dict[0x4037] = "jié"; /* 䀷 */
dict[0x4038] = "dì,zhì"; /* 䀸 */
dict[0x4039] = "jiá,shè,jié"; /* 䀹 */
dict[0x403a] = "chōu"; /* 䀺 */
dict[0x403b] = "pìn"; /* 䀻 */
dict[0x403c] = "rèn,zhěn"; /* 䀼 */
dict[0x403d] = "yán"; /* 䀽 */
dict[0x403e] = "dǔ"; /* 䀾 */
dict[0x403f] = "dì"; /* 䀿 */
dict[0x4041] = "lǎng,liàng"; /* 䁁 */
dict[0x4042] = "xiàn"; /* 䁂 */
dict[0x4044] = "xìng"; /* 䁄 */
dict[0x4045] = "bèi,bì,měng,mèng"; /* 䁅 */
dict[0x4046] = "ǎn,yì"; /* 䁆 */
dict[0x4047] = "mì"; /* 䁇 */
dict[0x4048] = "qì"; /* 䁈 */
dict[0x4049] = "qì"; /* 䁉 */
dict[0x404a] = "wò"; /* 䁊 */
dict[0x404b] = "shé"; /* 䁋 */
dict[0x404c] = "yù"; /* 䁌 */
dict[0x404d] = "jià,kè,qià"; /* 䁍 */
dict[0x404e] = "chéng"; /* 䁎 */
dict[0x404f] = "yǎo"; /* 䁏 */
dict[0x4050] = "yìng"; /* 䁐 */
dict[0x4051] = "yáng"; /* 䁑 */
dict[0x4052] = "jí"; /* 䁒 */
dict[0x4053] = "jiè,zǒng"; /* 䁓 */
dict[0x4054] = "hàn,huǎn,xuān"; /* 䁔 */
dict[0x4055] = "mín"; /* 䁕 */
dict[0x4056] = "lōu"; /* 䁖 */
dict[0x4057] = "kǎi"; /* 䁗 */
dict[0x4058] = "yǎo"; /* 䁘 */
dict[0x4059] = "yǎn,yàn"; /* 䁙 */
dict[0x405a] = "sǔn"; /* 䁚 */
dict[0x405b] = "guǐ,guì,kuì"; /* 䁛 */
dict[0x405c] = "huǎng,huàng"; /* 䁜 */
dict[0x405d] = "yíng"; /* 䁝 */
dict[0x405e] = "shěng"; /* 䁞 */
dict[0x405f] = "chá,duó"; /* 䁟 */
dict[0x4060] = "lián"; /* 䁠 */
dict[0x4062] = "xuán"; /* 䁢 */
dict[0x4063] = "chuán"; /* 䁣 */
dict[0x4064] = "chè,chèng"; /* 䁤 */
dict[0x4065] = "nì"; /* 䁥 */
dict[0x4066] = "qù"; /* 䁦 */
dict[0x4067] = "miáo"; /* 䁧 */
dict[0x4068] = "huò"; /* 䁨 */
dict[0x4069] = "yú"; /* 䁩 */
dict[0x406a] = "nǎn,zhǎn"; /* 䁪 */
dict[0x406b] = "hú"; /* 䁫 */
dict[0x406c] = "céng"; /* 䁬 */
dict[0x406e] = "qián"; /* 䁮 */
dict[0x406f] = "shè,xié"; /* 䁯 */
dict[0x4070] = "jiǎng"; /* 䁰 */
dict[0x4071] = "ào"; /* 䁱 */
dict[0x4072] = "mái"; /* 䁲 */
dict[0x4073] = "mǎng"; /* 䁳 */
dict[0x4074] = "zhǎn"; /* 䁴 */
dict[0x4075] = "biǎn"; /* 䁵 */
dict[0x4076] = "jiǎo"; /* 䁶 */
dict[0x4077] = "jué,wò"; /* 䁷 */
dict[0x4078] = "nóng"; /* 䁸 */
dict[0x4079] = "bì"; /* 䁹 */
dict[0x407a] = "shì"; /* 䁺 */
dict[0x407b] = "lì,shuò"; /* 䁻 */
dict[0x407c] = "mò,mù"; /* 䁼 */
dict[0x407d] = "liè"; /* 䁽 */
dict[0x407e] = "miè"; /* 䁾 */
dict[0x407f] = "mò"; /* 䁿 */
dict[0x4081] = "chán"; /* 䂁 */
dict[0x4082] = "qú"; /* 䂂 */
dict[0x4083] = "jiào,jié"; /* 䂃 */
dict[0x4084] = "huò,kuàng"; /* 䂄 */
dict[0x4086] = "xù"; /* 䂆 */
dict[0x4087] = "náng,niǔ,nǒng,páng"; /* 䂇 */
dict[0x4088] = "tóng"; /* 䂈 */
dict[0x4089] = "hóu"; /* 䂉 */
dict[0x408a] = "yù"; /* 䂊 */
dict[0x408d] = "bó"; /* 䂍 */
dict[0x408e] = "zuǎn"; /* 䂎 */
dict[0x4090] = "chuò"; /* 䂐 */
dict[0x4092] = "jié,qià,yà"; /* 䂒 */
dict[0x4094] = "xìng"; /* 䂔 */
dict[0x4095] = "huì"; /* 䂕 */
dict[0x4096] = "shí,sì"; /* 䂖 */
dict[0x409a] = "yáo,yóu"; /* 䂚 */
dict[0x409b] = "yú"; /* 䂛 */
dict[0x409c] = "bàng,péi"; /* 䂜 */
dict[0x409d] = "jié,zé,zhé"; /* 䂝 */
dict[0x409e] = "zhè"; /* 䂞 */
dict[0x40a0] = "shé,shǐ"; /* 䂠 */
dict[0x40a1] = "dǐ,zhǐ"; /* 䂡 */
dict[0x40a2] = "dǒng"; /* 䂢 */
dict[0x40a3] = "cí"; /* 䂣 */
dict[0x40a4] = "fù,hái"; /* 䂤 */
dict[0x40a5] = "mín"; /* 䂥 */
dict[0x40a6] = "zhěn"; /* 䂦 */
dict[0x40a7] = "zhěn"; /* 䂧 */
dict[0x40a9] = "yàn"; /* 䂩 */
dict[0x40aa] = "diào,tiǎo"; /* 䂪 */
dict[0x40ab] = "hóng"; /* 䂫 */
dict[0x40ac] = "gǒng"; /* 䂬 */
dict[0x40ad] = "qiāo"; /* 䂭 */
dict[0x40af] = "guài,guàn"; /* 䂯 */
dict[0x40b0] = "là"; /* 䂰 */
dict[0x40b1] = "cuì,ruì"; /* 䂱 */
dict[0x40b2] = "fǎ"; /* 䂲 */
dict[0x40b3] = "cuǒ"; /* 䂳 */
dict[0x40b4] = "yán"; /* 䂴 */
dict[0x40b6] = "jié"; /* 䂶 */
dict[0x40b8] = "guó,xù"; /* 䂸 */
dict[0x40b9] = "suǒ"; /* 䂹 */
dict[0x40ba] = "wǎn,wǒ"; /* 䂺 */
dict[0x40bb] = "zhèng"; /* 䂻 */
dict[0x40bc] = "niè"; /* 䂼 */
dict[0x40bd] = "diào,yì"; /* 䂽 */
dict[0x40be] = "lǎi"; /* 䂾 */
dict[0x40bf] = "tà,tiè"; /* 䂿 */
dict[0x40c0] = "cuì,xùn"; /* 䃀 */
dict[0x40c1] = "yā"; /* 䃁 */
dict[0x40c2] = "gǔn,gùn"; /* 䃂 */
dict[0x40c7] = "mián"; /* 䃇 */
dict[0x40c8] = "jiē"; /* 䃈 */
dict[0x40c9] = "mín"; /* 䃉 */
dict[0x40ca] = "jǔ"; /* 䃊 */
dict[0x40cb] = "yú"; /* 䃋 */
dict[0x40cd] = "zhào,zhuì"; /* 䃍 */
dict[0x40ce] = "zhǎ"; /* 䃎 */
dict[0x40d1] = "pán"; /* 䃑 */
dict[0x40d2] = "hé"; /* 䃒 */
dict[0x40d3] = "gòu"; /* 䃓 */
dict[0x40d4] = "hóng"; /* 䃔 */
dict[0x40d5] = "láo,luò"; /* 䃕 */
dict[0x40d6] = "wù"; /* 䃖 */
dict[0x40d7] = "chuò"; /* 䃗 */
dict[0x40d9] = "lù"; /* 䃙 */
dict[0x40da] = "cù"; /* 䃚 */
dict[0x40db] = "lián,qiàn"; /* 䃛 */
dict[0x40dd] = "qiào"; /* 䃝 */
dict[0x40de] = "shú,yì"; /* 䃞 */
dict[0x40e1] = "cén"; /* 䃡 */
dict[0x40e3] = "huǐ"; /* 䃣 */
dict[0x40e4] = "sù"; /* 䃤 */
dict[0x40e5] = "chuáng"; /* 䃥 */
dict[0x40e7] = "lóng"; /* 䃧 */
dict[0x40e9] = "náo"; /* 䃩 */
dict[0x40ea] = "tán"; /* 䃪 */
dict[0x40eb] = "dǎn"; /* 䃫 */
dict[0x40ec] = "wěi"; /* 䃬 */
dict[0x40ed] = "gǎn"; /* 䃭 */
dict[0x40ee] = "dá"; /* 䃮 */
dict[0x40ef] = "lì"; /* 䃯 */
dict[0x40f1] = "xiàn"; /* 䃱 */
dict[0x40f2] = "pán,pàn"; /* 䃲 */
dict[0x40f3] = "là"; /* 䃳 */
dict[0x40f5] = "niǎo"; /* 䃵 */
dict[0x40f6] = "huái"; /* 䃶 */
dict[0x40f7] = "yíng"; /* 䃷 */
dict[0x40f8] = "xiàn"; /* 䃸 */
dict[0x40f9] = "làn,lǎng"; /* 䃹 */
dict[0x40fa] = "mó,mò"; /* 䃺 */
dict[0x40fb] = "bà,pái"; /* 䃻 */
dict[0x40fd] = "fú,guǐ,sì"; /* 䃽 */
dict[0x40fe] = "bǐ"; /* 䃾 */
dict[0x4100] = "huò"; /* 䄀 */
dict[0x4101] = "yì"; /* 䄁 */
dict[0x4102] = "liù"; /* 䄂 */
dict[0x4105] = "juàn"; /* 䄅 */
dict[0x4106] = "huó,kuò"; /* 䄆 */
dict[0x4107] = "chéng"; /* 䄇 */
dict[0x4108] = "dòu"; /* 䄈 */
dict[0x4109] = "é"; /* 䄉 */
dict[0x410b] = "yǎn"; /* 䄋 */
dict[0x410c] = "zhuì"; /* 䄌 */
dict[0x410d] = "dù,duó,zhà"; /* 䄍 */
dict[0x410e] = "qǐ"; /* 䄎 */
dict[0x410f] = "yú,yāo"; /* 䄏 */
dict[0x4110] = "quàn"; /* 䄐 */
dict[0x4111] = "huó,kuò"; /* 䄑 */
dict[0x4112] = "niè,rěn"; /* 䄒 */
dict[0x4113] = "héng,huáng"; /* 䄓 */
dict[0x4114] = "jǔ"; /* 䄔 */
dict[0x4115] = "shè,shèn,tiǎn"; /* 䄕 */
dict[0x4118] = "péng"; /* 䄘 */
dict[0x4119] = "míng"; /* 䄙 */
dict[0x411a] = "cáo"; /* 䄚 */
dict[0x411b] = "lóu"; /* 䄛 */
dict[0x411c] = "lí,chī"; /* 䄜 */
dict[0x411d] = "chǔn"; /* 䄝 */
dict[0x411f] = "cuì"; /* 䄟 */
dict[0x4120] = "shàn"; /* 䄠 */
dict[0x4122] = "qí"; /* 䄢 */
dict[0x4124] = "lài,lán"; /* 䄤 */
dict[0x4125] = "líng"; /* 䄥 */
dict[0x4126] = "liǎo"; /* 䄦 */
dict[0x4127] = "réng,rǒng"; /* 䄧 */
dict[0x4128] = "yú,yǔ"; /* 䄨 */
dict[0x4129] = "náo,yì"; /* 䄩 */
dict[0x412a] = "chuò,diǎo"; /* 䄪 */
dict[0x412b] = "qǐ"; /* 䄫 */
dict[0x412c] = "yí"; /* 䄬 */
dict[0x412d] = "nián"; /* 䄭 */
dict[0x412f] = "jiǎn,xiàn"; /* 䄯 */
dict[0x4130] = "yá,zhá"; /* 䄰 */
dict[0x4132] = "chuí"; /* 䄲 */
dict[0x4136] = "bì"; /* 䄶 */
dict[0x4137] = "dàn,diǎo,shí"; /* 䄷 */
dict[0x4138] = "pò"; /* 䄸 */
dict[0x4139] = "nián,tiǎn"; /* 䄹 */
dict[0x413a] = "zhì"; /* 䄺 */
dict[0x413b] = "cháo,táo,zhào"; /* 䄻 */
dict[0x413c] = "tiǎn"; /* 䄼 */
dict[0x413d] = "tiǎn"; /* 䄽 */
dict[0x413e] = "ròu"; /* 䄾 */
dict[0x413f] = "yì"; /* 䄿 */
dict[0x4140] = "liè"; /* 䅀 */
dict[0x4141] = "àn"; /* 䅁 */
dict[0x4142] = "hé"; /* 䅂 */
dict[0x4143] = "qióng"; /* 䅃 */
dict[0x4144] = "lì"; /* 䅄 */
dict[0x4146] = "zì"; /* 䅆 */
dict[0x4147] = "sù"; /* 䅇 */
dict[0x4148] = "yuàn"; /* 䅈 */
dict[0x4149] = "yà"; /* 䅉 */
dict[0x414a] = "dù"; /* 䅊 */
dict[0x414b] = "wǎn"; /* 䅋 */
dict[0x414c] = "juān"; /* 䅌 */
dict[0x414d] = "dòng,tǐng"; /* 䅍 */
dict[0x414e] = "yǒu"; /* 䅎 */
dict[0x414f] = "huì,wèi"; /* 䅏 */
dict[0x4150] = "jiǎn,qián"; /* 䅐 */
dict[0x4151] = "ruí,suí"; /* 䅑 */
dict[0x4152] = "máng"; /* 䅒 */
dict[0x4153] = "jǔ,qù"; /* 䅓 */
dict[0x4156] = "ǎn"; /* 䅖 */
dict[0x4157] = "suì"; /* 䅗 */
dict[0x4158] = "lái"; /* 䅘 */
dict[0x4159] = "hùn"; /* 䅙 */
dict[0x415a] = "qiǎng,quǎn,zé"; /* 䅚 */
dict[0x415c] = "duò"; /* 䅜 */
dict[0x415e] = "nà,nài,nè"; /* 䅞 */
dict[0x415f] = "cǎn"; /* 䅟 */
dict[0x4160] = "tí"; /* 䅠 */
dict[0x4161] = "xǔ"; /* 䅡 */
dict[0x4162] = "jiù"; /* 䅢 */
dict[0x4163] = "huáng"; /* 䅣 */
dict[0x4164] = "qì"; /* 䅤 */
dict[0x4165] = "jié"; /* 䅥 */
dict[0x4166] = "máo"; /* 䅦 */
dict[0x4167] = "yàn"; /* 䅧 */
dict[0x4169] = "zhǐ"; /* 䅩 */
dict[0x416a] = "tuí"; /* 䅪 */
dict[0x416c] = "ài,yǎn,yè"; /* 䅬 */
dict[0x416d] = "páng"; /* 䅭 */
dict[0x416e] = "càng"; /* 䅮 */
dict[0x416f] = "táng"; /* 䅯 */
dict[0x4170] = "ěn"; /* 䅰 */
dict[0x4171] = "hùn"; /* 䅱 */
dict[0x4172] = "qí"; /* 䅲 */
dict[0x4173] = "chú"; /* 䅳 */
dict[0x4174] = "suǒ"; /* 䅴 */
dict[0x4175] = "zhuó"; /* 䅵 */
dict[0x4176] = "nòu,wǔ"; /* 䅶 */
dict[0x4177] = "tú"; /* 䅷 */
dict[0x4178] = "zú"; /* 䅸 */
dict[0x4179] = "lóu,lǒu"; /* 䅹 */
dict[0x417a] = "miǎo"; /* 䅺 */
dict[0x417b] = "lí"; /* 䅻 */
dict[0x417c] = "mán"; /* 䅼 */
dict[0x417d] = "gǔ"; /* 䅽 */
dict[0x417e] = "cén,qián,qín"; /* 䅾 */
dict[0x417f] = "huá"; /* 䅿 */
dict[0x4180] = "měi"; /* 䆀 */
dict[0x4182] = "lián,qiàn"; /* 䆂 */
dict[0x4183] = "dǎo,dào"; /* 䆃 */
dict[0x4184] = "shàn"; /* 䆄 */
dict[0x4185] = "cí,jǐ,zī"; /* 䆅 */
dict[0x4188] = "zhì"; /* 䆈 */
dict[0x4189] = "bà"; /* 䆉 */
dict[0x418a] = "cuì"; /* 䆊 */
dict[0x418d] = "lóng"; /* 䆍 */
dict[0x418f] = "fèi"; /* 䆏 */
dict[0x4190] = "guó"; /* 䆐 */
dict[0x4191] = "chéng"; /* 䆑 */
dict[0x4192] = "jiù"; /* 䆒 */
dict[0x4193] = "è,ruǎn"; /* 䆓 */
dict[0x4195] = "jué,yuè"; /* 䆕 */
dict[0x4196] = "hóng"; /* 䆖 */
dict[0x4197] = "jiào"; /* 䆗 */
dict[0x4198] = "cuán,yā"; /* 䆘 */
dict[0x4199] = "yáo"; /* 䆙 */
dict[0x419a] = "tóng"; /* 䆚 */
dict[0x419b] = "chá,zhà,zhé"; /* 䆛 */
dict[0x419c] = "yòu"; /* 䆜 */
dict[0x419d] = "shù"; /* 䆝 */
dict[0x419e] = "yǎo"; /* 䆞 */
dict[0x419f] = "gé"; /* 䆟 */
dict[0x41a0] = "huàn"; /* 䆠 */
dict[0x41a1] = "láng,làng"; /* 䆡 */
dict[0x41a2] = "jué,yuè"; /* 䆢 */
dict[0x41a3] = "chén"; /* 䆣 */
dict[0x41a6] = "shèn"; /* 䆦 */
dict[0x41a8] = "míng"; /* 䆨 */
dict[0x41a9] = "míng"; /* 䆩 */
dict[0x41ac] = "yǔn"; /* 䆬 */
dict[0x41ae] = "jìn"; /* 䆮 */
dict[0x41af] = "chuò,zhuó"; /* 䆯 */
dict[0x41b1] = "tǎn"; /* 䆱 */
dict[0x41b3] = "qióng,suì"; /* 䆳 */
dict[0x41b5] = "chéng"; /* 䆵 */
dict[0x41b7] = "yù,xuè"; /* 䆷 */
dict[0x41b8] = "chéng"; /* 䆸 */
dict[0x41b9] = "tǒng"; /* 䆹 */
dict[0x41bb] = "qiào"; /* 䆻 */
dict[0x41bd] = "jù,qú,qún"; /* 䆽 */
dict[0x41be] = "lán"; /* 䆾 */
dict[0x41bf] = "yì"; /* 䆿 */
dict[0x41c0] = "róng,rǒng"; /* 䇀 */
dict[0x41c1] = "sī"; /* 䇁 */
dict[0x41c2] = "qiān"; /* 䇂 */
dict[0x41c3] = "sì,xiào"; /* 䇃 */
dict[0x41c5] = "fá"; /* 䇅 */
dict[0x41c7] = "méng"; /* 䇇 */
dict[0x41c8] = "guì,huà"; /* 䇈 */
dict[0x41cb] = "hài,rǎn,xiè"; /* 䇋 */
dict[0x41cc] = "qiào"; /* 䇌 */
dict[0x41cd] = "chuò"; /* 䇍 */
dict[0x41ce] = "què"; /* 䇎 */
dict[0x41cf] = "duì"; /* 䇏 */
dict[0x41d0] = "lì"; /* 䇐 */
dict[0x41d1] = "bà"; /* 䇑 */
dict[0x41d2] = "jiè,qín,xiàn"; /* 䇒 */
dict[0x41d4] = "luò,nuò"; /* 䇔 */
dict[0x41d6] = "yǔn"; /* 䇖 */
dict[0x41d8] = "hù"; /* 䇘 */
dict[0x41d9] = "yǐn"; /* 䇙 */
dict[0x41db] = "zhǐ"; /* 䇛 */
dict[0x41dc] = "liǎn"; /* 䇜 */
dict[0x41de] = "gǎn"; /* 䇞 */
dict[0x41df] = "jiàn"; /* 䇟 */
dict[0x41e0] = "zhòu,zhù"; /* 䇠 */
dict[0x41e1] = "zhù"; /* 䇡 */
dict[0x41e2] = "kǔ"; /* 䇢 */
dict[0x41e3] = "nà,nèi,yǐ"; /* 䇣 */
dict[0x41e4] = "duì,ruì,sù"; /* 䇤 */
dict[0x41e5] = "zé,zuó"; /* 䇥 */
dict[0x41e6] = "yǎng"; /* 䇦 */
dict[0x41e7] = "zhù"; /* 䇧 */
dict[0x41e8] = "gòng,xiáng"; /* 䇨 */
dict[0x41e9] = "yì"; /* 䇩 */
dict[0x41ea] = "chī"; /* 䇪 */
dict[0x41eb] = "jī"; /* 䇫 */
dict[0x41ec] = "chuǎng,zhū"; /* 䇬 */
dict[0x41ed] = "lǎo"; /* 䇭 */
dict[0x41ee] = "rèn"; /* 䇮 */
dict[0x41ef] = "róng"; /* 䇯 */
dict[0x41f1] = "nà"; /* 䇱 */
dict[0x41f2] = "cè,jiā"; /* 䇲 */
dict[0x41f5] = "yí"; /* 䇵 */
dict[0x41f6] = "jué"; /* 䇶 */
dict[0x41f7] = "bǐ,bié"; /* 䇷 */
dict[0x41f8] = "chéng,shèng,zèng"; /* 䇸 */
dict[0x41f9] = "jùn"; /* 䇹 */
dict[0x41fa] = "chóu,dòu"; /* 䇺 */
dict[0x41fb] = "huì,kuì,wěi"; /* 䇻 */
dict[0x41fc] = "chì,yì"; /* 䇼 */
dict[0x41fd] = "zhì"; /* 䇽 */
dict[0x41fe] = "yán"; /* 䇾 */
dict[0x4201] = "lún,luò"; /* 䈁 */
dict[0x4202] = "bìng,píng"; /* 䈂 */
dict[0x4203] = "zhǎo"; /* 䈃 */
dict[0x4204] = "hán"; /* 䈄 */
dict[0x4205] = "yù"; /* 䈅 */
dict[0x4206] = "dài"; /* 䈆 */
dict[0x4207] = "zhào"; /* 䈇 */
dict[0x4208] = "féi"; /* 䈈 */
dict[0x4209] = "shà"; /* 䈉 */
dict[0x420a] = "líng"; /* 䈊 */
dict[0x420b] = "tà"; /* 䈋 */
dict[0x420d] = "máng"; /* 䈍 */
dict[0x420e] = "yè"; /* 䈎 */
dict[0x420f] = "báo"; /* 䈏 */
dict[0x4210] = "kuì"; /* 䈐 */
dict[0x4211] = "guǎ,jué"; /* 䈑 */
dict[0x4212] = "nǎn"; /* 䈒 */
dict[0x4213] = "gé"; /* 䈓 */
dict[0x4215] = "chí,shi,tí,shí"; /* 䈕 */
dict[0x4217] = "suǒ"; /* 䈗 */
dict[0x4218] = "cí"; /* 䈘 */
dict[0x4219] = "zhòu"; /* 䈙 */
dict[0x421a] = "tái"; /* 䈚 */
dict[0x421b] = "kuài"; /* 䈛 */
dict[0x421c] = "qìn"; /* 䈜 */
dict[0x421e] = "dǔ"; /* 䈞 */
dict[0x421f] = "cè"; /* 䈟 */
dict[0x4220] = "huǎn"; /* 䈠 */
dict[0x4222] = "sǎi"; /* 䈢 */
dict[0x4223] = "zhèng"; /* 䈣 */
dict[0x4224] = "qián"; /* 䈤 */
dict[0x4227] = "wěi"; /* 䈧 */
dict[0x422a] = "xì"; /* 䈪 */
dict[0x422b] = "nà"; /* 䈫 */
dict[0x422c] = "pú"; /* 䈬 */
dict[0x422d] = "huái"; /* 䈭 */
dict[0x422e] = "jǔ,jù,wǎn"; /* 䈮 */
dict[0x4230] = "shāo"; /* 䈰 */
dict[0x4232] = "pán"; /* 䈲 */
dict[0x4233] = "tà"; /* 䈳 */
dict[0x4234] = "qiàn,zhǎn"; /* 䈴 */
dict[0x4235] = "wēng"; /* 䈵 */
dict[0x4236] = "róng"; /* 䈶 */
dict[0x4237] = "luò"; /* 䈷 */
dict[0x4238] = "hú"; /* 䈸 */
dict[0x4239] = "sǒu"; /* 䈹 */
dict[0x423b] = "pú"; /* 䈻 */
dict[0x423c] = "miè,mì"; /* 䈼 */
dict[0x423e] = "shāo,shuò"; /* 䈾 */
dict[0x423f] = "mài,mì"; /* 䈿 */
dict[0x4240] = "shù"; /* 䉀 */
dict[0x4241] = "líng"; /* 䉁 */
dict[0x4242] = "lěi"; /* 䉂 */
dict[0x4243] = "jiǎng"; /* 䉃 */
dict[0x4244] = "léng"; /* 䉄 */
dict[0x4245] = "zhì"; /* 䉅 */
dict[0x4246] = "diǎo"; /* 䉆 */
dict[0x4248] = "sǎn"; /* 䉈 */
dict[0x4249] = "hú"; /* 䉉 */
dict[0x424a] = "fàn,fáng"; /* 䉊 */
dict[0x424b] = "mèi"; /* 䉋 */
dict[0x424c] = "suì"; /* 䉌 */
dict[0x424d] = "jiǎn"; /* 䉍 */
dict[0x424e] = "táng"; /* 䉎 */
dict[0x424f] = "xiè"; /* 䉏 */
dict[0x4251] = "mó,wú"; /* 䉑 */
dict[0x4252] = "fán"; /* 䉒 */
dict[0x4253] = "léi,luò"; /* 䉓 */
dict[0x4255] = "céng"; /* 䉕 */
dict[0x4256] = "líng"; /* 䉖 */
dict[0x4258] = "cóng"; /* 䉘 */
dict[0x4259] = "yún"; /* 䉙 */
dict[0x425a] = "méng"; /* 䉚 */
dict[0x425b] = "yù"; /* 䉛 */
dict[0x425c] = "zhì"; /* 䉜 */
dict[0x425d] = "qǐ"; /* 䉝 */
dict[0x425e] = "dǎn"; /* 䉞 */
dict[0x425f] = "huò"; /* 䉟 */
dict[0x4260] = "wéi"; /* 䉠 */
dict[0x4261] = "tán"; /* 䉡 */
dict[0x4262] = "sè"; /* 䉢 */
dict[0x4263] = "xiè"; /* 䉣 */
dict[0x4264] = "sǒu"; /* 䉤 */
dict[0x4265] = "sǒng"; /* 䉥 */
dict[0x4267] = "liú,liǔ"; /* 䉧 */
dict[0x4268] = "yì"; /* 䉨 */
dict[0x426a] = "lèi"; /* 䉪 */
dict[0x426b] = "lí"; /* 䉫 */
dict[0x426c] = "fèi"; /* 䉬 */
dict[0x426d] = "liè"; /* 䉭 */
dict[0x426e] = "lìn"; /* 䉮 */
dict[0x426f] = "xiàn"; /* 䉯 */
dict[0x4270] = "yáo"; /* 䉰 */
dict[0x4272] = "biè,mí"; /* 䉲 */
dict[0x4273] = "xiǎn"; /* 䉳 */
dict[0x4274] = "ráng,rǎng"; /* 䉴 */
dict[0x4275] = "zhuàn"; /* 䉵 */
dict[0x4277] = "dàn,jìn,yán"; /* 䉷 */
dict[0x4278] = "biàn"; /* 䉸 */
dict[0x4279] = "líng,liǔ"; /* 䉹 */
dict[0x427a] = "hóng"; /* 䉺 */
dict[0x427b] = "qí"; /* 䉻 */
dict[0x427c] = "liào"; /* 䉼 */
dict[0x427d] = "bǎn"; /* 䉽 */
dict[0x427e] = "mì,bì"; /* 䉾 */
dict[0x427f] = "hú,luò"; /* 䉿 */
dict[0x4280] = "hú"; /* 䊀 */
dict[0x4282] = "cè,sè"; /* 䊂 */
dict[0x4283] = "pèi"; /* 䊃 */
dict[0x4284] = "qióng"; /* 䊄 */
dict[0x4285] = "míng"; /* 䊅 */
dict[0x4286] = "jiù,qiǔ"; /* 䊆 */
dict[0x4287] = "bù"; /* 䊇 */
dict[0x4288] = "méi"; /* 䊈 */
dict[0x4289] = "sǎn"; /* 䊉 */
dict[0x428a] = "mèi"; /* 䊊 */
dict[0x428d] = "lí"; /* 䊍 */
dict[0x428e] = "quǎn"; /* 䊎 */
dict[0x4290] = "èn,huá,huàn,hún"; /* 䊐 */
dict[0x4291] = "xiǎng"; /* 䊑 */
dict[0x4293] = "shì"; /* 䊓 */
dict[0x4296] = "lǎn,nǎn"; /* 䊖 */
dict[0x4297] = "huáng,huǎng"; /* 䊗 */
dict[0x4298] = "jiù"; /* 䊘 */
dict[0x4299] = "yán"; /* 䊙 */
dict[0x429a] = "duī"; /* 䊚 */
dict[0x429b] = "sǎ"; /* 䊛 */
dict[0x429c] = "tuán"; /* 䊜 */
dict[0x429d] = "xiè"; /* 䊝 */
dict[0x429e] = "zhé"; /* 䊞 */
dict[0x429f] = "mén"; /* 䊟 */
dict[0x42a0] = "xì"; /* 䊠 */
dict[0x42a1] = "mán"; /* 䊡 */
dict[0x42a3] = "huáng"; /* 䊣 */
dict[0x42a4] = "tán"; /* 䊤 */
dict[0x42a5] = "xiào"; /* 䊥 */
dict[0x42a6] = "yá,yè"; /* 䊦 */
dict[0x42a7] = "bì"; /* 䊧 */
dict[0x42a8] = "luó"; /* 䊨 */
dict[0x42a9] = "fán,fàn"; /* 䊩 */
dict[0x42aa] = "lì"; /* 䊪 */
dict[0x42ab] = "cuǐ,mí"; /* 䊫 */
dict[0x42ac] = "chà"; /* 䊬 */
dict[0x42ad] = "chóu,dào"; /* 䊭 */
dict[0x42ae] = "dí,zhé,zhè"; /* 䊮 */
dict[0x42af] = "kuàng"; /* 䊯 */
dict[0x42b0] = "chǔ"; /* 䊰 */
dict[0x42b2] = "chǎn"; /* 䊲 */
dict[0x42b3] = "mí"; /* 䊳 */
dict[0x42b4] = "qiàn"; /* 䊴 */
dict[0x42b5] = "qiú"; /* 䊵 */
dict[0x42b6] = "zhèn"; /* 䊶 */
dict[0x42ba] = "gǔ,hù"; /* 䊺 */
dict[0x42bb] = "yǎn"; /* 䊻 */
dict[0x42bc] = "chǐ"; /* 䊼 */
dict[0x42bd] = "guài"; /* 䊽 */
dict[0x42be] = "mù"; /* 䊾 */
dict[0x42bf] = "bó,kù"; /* 䊿 */
dict[0x42c0] = "kuà,huà"; /* 䋀 */
dict[0x42c1] = "gěng"; /* 䋁 */
dict[0x42c2] = "yáo"; /* 䋂 */
dict[0x42c3] = "mào"; /* 䋃 */
dict[0x42c4] = "wǎng"; /* 䋄 */
dict[0x42c8] = "rú"; /* 䋈 */
dict[0x42c9] = "jué,kě,xué"; /* 䋉 */
dict[0x42ca] = "zhēng"; /* 䋊 */
dict[0x42cb] = "mín"; /* 䋋 */
dict[0x42cc] = "jiǎng"; /* 䋌 */
dict[0x42ce] = "zhàn"; /* 䋎 */
dict[0x42cf] = "zuò"; /* 䋏 */
dict[0x42d0] = "yuè"; /* 䋐 */
dict[0x42d1] = "bǐng"; /* 䋑 */
dict[0x42d3] = "zhòu"; /* 䋓 */
dict[0x42d4] = "bì"; /* 䋔 */
dict[0x42d5] = "rèn"; /* 䋕 */
dict[0x42d6] = "yù"; /* 䋖 */
dict[0x42d8] = "chuò,zhuì"; /* 䋘 */
dict[0x42d9] = "ěr"; /* 䋙 */
dict[0x42da] = "yì"; /* 䋚 */
dict[0x42db] = "mí,mǐ"; /* 䋛 */
dict[0x42dc] = "qìng"; /* 䋜 */
dict[0x42de] = "wǎng"; /* 䋞 */
dict[0x42df] = "jì"; /* 䋟 */
dict[0x42e0] = "bǔ"; /* 䋠 */
dict[0x42e2] = "biè,biē"; /* 䋢 */
dict[0x42e3] = "fán,pán"; /* 䋣 */
dict[0x42e4] = "yào,yuè"; /* 䋤 */
dict[0x42e5] = "lí"; /* 䋥 */
dict[0x42e6] = "fán"; /* 䋦 */
dict[0x42e7] = "qú"; /* 䋧 */
dict[0x42e8] = "fǔ"; /* 䋨 */
dict[0x42e9] = "ér"; /* 䋩 */
dict[0x42eb] = "zhēng"; /* 䋫 */
dict[0x42ed] = "huò,yù"; /* 䋭 */
dict[0x42ee] = "jìn,qián"; /* 䋮 */
dict[0x42ef] = "qǐ,qìng"; /* 䋯 */
dict[0x42f0] = "jú"; /* 䋰 */
dict[0x42f1] = "lái"; /* 䋱 */
dict[0x42f2] = "chě,shéng,xǐng,zhè"; /* 䋲 */
dict[0x42f3] = "bèi,mì"; /* 䋳 */
dict[0x42f4] = "niù,rǒng,róu,rǔ"; /* 䋴 */
dict[0x42f5] = "yì"; /* 䋵 */
dict[0x42f6] = "xù"; /* 䋶 */
dict[0x42f7] = "liú,móu"; /* 䋷 */
dict[0x42f8] = "xún"; /* 䋸 */
dict[0x42f9] = "fú,fù"; /* 䋹 */
dict[0x42fb] = "nín"; /* 䋻 */
dict[0x42fc] = "tǐng,yíng,tīng"; /* 䋼 */
dict[0x42fd] = "běng,pěng"; /* 䋽 */
dict[0x42fe] = "zhǎ"; /* 䋾 */
dict[0x4302] = "òu"; /* 䌂 */
dict[0x4303] = "shuò"; /* 䌃 */
dict[0x4304] = "gěng"; /* 䌄 */
dict[0x4305] = "táng"; /* 䌅 */
dict[0x4306] = "guì"; /* 䌆 */
dict[0x4307] = "suǒ"; /* 䌇 */
dict[0x4308] = "tà"; /* 䌈 */
dict[0x430a] = "yáo,yóu"; /* 䌊 */
dict[0x430c] = "qì,qiè,qǔ"; /* 䌌 */
dict[0x430d] = "hàn,jǐn"; /* 䌍 */
dict[0x430f] = "mì,miàn"; /* 䌏 */
dict[0x4310] = "mì"; /* 䌐 */
dict[0x4312] = "lù"; /* 䌒 */
dict[0x4313] = "fán"; /* 䌓 */
dict[0x4314] = "òu"; /* 䌔 */
dict[0x4315] = "mí,mó"; /* 䌕 */
dict[0x4316] = "jié"; /* 䌖 */
dict[0x4317] = "fǔ"; /* 䌗 */
dict[0x4318] = "mí"; /* 䌘 */
dict[0x4319] = "huǎng"; /* 䌙 */
dict[0x431a] = "sù"; /* 䌚 */
dict[0x431b] = "yáo"; /* 䌛 */
dict[0x431c] = "niè"; /* 䌜 */
dict[0x431d] = "jìn"; /* 䌝 */
dict[0x431e] = "liǎn"; /* 䌞 */
dict[0x431f] = "bì"; /* 䌟 */
dict[0x4320] = "qìng,yǎn,yìn"; /* 䌠 */
dict[0x4321] = "tǐ"; /* 䌡 */
dict[0x4322] = "líng"; /* 䌢 */
dict[0x4323] = "zuǎn"; /* 䌣 */
dict[0x4324] = "zhǐ"; /* 䌤 */
dict[0x4325] = "yǐn"; /* 䌥 */
dict[0x4326] = "dǎo"; /* 䌦 */
dict[0x4327] = "chóu"; /* 䌧 */
dict[0x4328] = "cài"; /* 䌨 */
dict[0x4329] = "mì,miè"; /* 䌩 */
dict[0x432a] = "yán"; /* 䌪 */
dict[0x432b] = "lǎn"; /* 䌫 */
dict[0x432c] = "chóng"; /* 䌬 */
dict[0x432f] = "guàn,quán"; /* 䌯 */
dict[0x4330] = "shè"; /* 䌰 */
dict[0x4331] = "luò"; /* 䌱 */
dict[0x4333] = "shī"; /* 䌳 */
dict[0x4334] = "luò"; /* 䌴 */
dict[0x4335] = "zhú,zhǔ"; /* 䌵 */
dict[0x4337] = "chōu,chóu"; /* 䌷 */
dict[0x4338] = "juàn"; /* 䌸 */
dict[0x4339] = "jiǒng"; /* 䌹 */
dict[0x433a] = "ěr"; /* 䌺 */
dict[0x433b] = "yì"; /* 䌻 */
dict[0x433c] = "ruì"; /* 䌼 */
dict[0x433d] = "cǎi"; /* 䌽 */
dict[0x433e] = "rén"; /* 䌾 */
dict[0x433f] = "fú"; /* 䌿 */
dict[0x4340] = "lán"; /* 䍀 */
dict[0x4341] = "suì"; /* 䍁 */
dict[0x4342] = "yú"; /* 䍂 */
dict[0x4343] = "yáo,yóu"; /* 䍃 */
dict[0x4344] = "diǎn"; /* 䍄 */
dict[0x4345] = "líng"; /* 䍅 */
dict[0x4346] = "zhù"; /* 䍆 */
dict[0x4347] = "tà"; /* 䍇 */
dict[0x4348] = "píng"; /* 䍈 */
dict[0x4349] = "qián,zhǎi"; /* 䍉 */
dict[0x434a] = "jué"; /* 䍊 */
dict[0x434b] = "chuí"; /* 䍋 */
dict[0x434c] = "bù,fú"; /* 䍌 */
dict[0x434d] = "gǔ,gù,guàng,kòu"; /* 䍍 */
dict[0x434e] = "cùn"; /* 䍎 */
dict[0x4350] = "hǎn,hàn"; /* 䍐 */
dict[0x4351] = "hǎn"; /* 䍑 */
dict[0x4352] = "mǒu"; /* 䍒 */
dict[0x4353] = "hù,yá"; /* 䍓 */
dict[0x4354] = "hóng"; /* 䍔 */
dict[0x4355] = "dǐ"; /* 䍕 */
dict[0x4356] = "fú,fù,hài,xiè"; /* 䍖 */
dict[0x4357] = "xuàn"; /* 䍗 */
dict[0x4358] = "mí"; /* 䍘 */
dict[0x4359] = "méi"; /* 䍙 */
dict[0x435a] = "làng"; /* 䍚 */
dict[0x435b] = "gù"; /* 䍛 */
dict[0x435c] = "zhào"; /* 䍜 */
dict[0x435d] = "tà,zǎn"; /* 䍝 */
dict[0x435e] = "yù"; /* 䍞 */
dict[0x435f] = "zòng"; /* 䍟 */
dict[0x4360] = "lí"; /* 䍠 */
dict[0x4361] = "liào,lù"; /* 䍡 */
dict[0x4362] = "wú,wǔ"; /* 䍢 */
dict[0x4363] = "léi"; /* 䍣 */
dict[0x4364] = "jǐ"; /* 䍤 */
dict[0x4365] = "lèi,lì"; /* 䍥 */
dict[0x4366] = "lí"; /* 䍦 */
dict[0x4368] = "bó,fèi"; /* 䍨 */
dict[0x4369] = "ǎng,yǎng"; /* 䍩 */
dict[0x436a] = "kuì,wà"; /* 䍪 */
dict[0x436b] = "tuó"; /* 䍫 */
dict[0x436e] = "zhào"; /* 䍮 */
dict[0x436f] = "guǐ,jì"; /* 䍯 */
dict[0x4371] = "xú"; /* 䍱 */
dict[0x4372] = "nái,ní,nì"; /* 䍲 */
dict[0x4373] = "chuò,jué,què"; /* 䍳 */
dict[0x4374] = "duò,ruí,wěi,wèi"; /* 䍴 */
dict[0x4376] = "dòng"; /* 䍶 */
dict[0x4377] = "guì,huì,wěi"; /* 䍷 */
dict[0x4378] = "bó"; /* 䍸 */
dict[0x437a] = "huán"; /* 䍺 */
dict[0x437b] = "xuǎn"; /* 䍻 */
dict[0x437c] = "cán"; /* 䍼 */
dict[0x437d] = "lì"; /* 䍽 */
dict[0x437e] = "tuí,yǎn"; /* 䍾 */
dict[0x437f] = "huáng"; /* 䍿 */
dict[0x4380] = "xuè,yuè"; /* 䎀 */
dict[0x4381] = "hú"; /* 䎁 */
dict[0x4382] = "bǎo"; /* 䎂 */
dict[0x4383] = "rǎn"; /* 䎃 */
dict[0x4384] = "tiáo"; /* 䎄 */
dict[0x4385] = "fù,luò,pò"; /* 䎅 */
dict[0x4386] = "liào"; /* 䎆 */
dict[0x4388] = "yì"; /* 䎈 */
dict[0x4389] = "shù,yù"; /* 䎉 */
dict[0x438a] = "pò"; /* 䎊 */
dict[0x438b] = "hè,kào"; /* 䎋 */
dict[0x438c] = "cù"; /* 䎌 */
dict[0x438e] = "nà"; /* 䎎 */
dict[0x438f] = "àn,hán"; /* 䎏 */
dict[0x4390] = "chǎo"; /* 䎐 */
dict[0x4391] = "lù"; /* 䎑 */
dict[0x4392] = "zhǎn"; /* 䎒 */
dict[0x4393] = "tà"; /* 䎓 */
dict[0x4397] = "qiáo"; /* 䎗 */
dict[0x4398] = "sù"; /* 䎘 */
dict[0x439a] = "guàn,huì"; /* 䎚 */
dict[0x439d] = "chú,zhù"; /* 䎝 */
dict[0x439f] = "ér,nuò"; /* 䎟 */
dict[0x43a0] = "ér,nuó"; /* 䎠 */
dict[0x43a1] = "nuǎn,ruǎn"; /* 䎡 */
dict[0x43a2] = "qǐ"; /* 䎢 */
dict[0x43a3] = "sì,xìn"; /* 䎣 */
dict[0x43a4] = "chú,jú"; /* 䎤 */
dict[0x43a6] = "yǎn"; /* 䎦 */
dict[0x43a7] = "bàng,póu"; /* 䎧 */
dict[0x43a8] = "àn,yè"; /* 䎨 */
dict[0x43aa] = "nè"; /* 䎪 */
dict[0x43ab] = "chuàng,zǒng"; /* 䎫 */
dict[0x43ac] = "bēi,bà"; /* 䎬 */
dict[0x43ad] = "cāo"; /* 䎭 */
dict[0x43ae] = "tì"; /* 䎮 */
dict[0x43af] = "hàn"; /* 䎯 */
dict[0x43b0] = "zuó"; /* 䎰 */
dict[0x43b1] = "bēi,bà"; /* 䎱 */
dict[0x43b2] = "zhé"; /* 䎲 */
dict[0x43b3] = "wà,yuè"; /* 䎳 */
dict[0x43b4] = "shèng"; /* 䎴 */
dict[0x43b5] = "bì"; /* 䎵 */
dict[0x43b6] = "èr"; /* 䎶 */
dict[0x43b7] = "zhù"; /* 䎷 */
dict[0x43b8] = "wù"; /* 䎸 */
dict[0x43b9] = "wén"; /* 䎹 */
dict[0x43ba] = "zhǐ,zhì"; /* 䎺 */
dict[0x43bb] = "zhǒu"; /* 䎻 */
dict[0x43bc] = "lù"; /* 䎼 */
dict[0x43bd] = "wén,wèn"; /* 䎽 */
dict[0x43be] = "gǔn"; /* 䎾 */
dict[0x43bf] = "qiú,xiòng"; /* 䎿 */
dict[0x43c0] = "là"; /* 䏀 */
dict[0x43c1] = "zǎi"; /* 䏁 */
dict[0x43c2] = "sǒu"; /* 䏂 */
dict[0x43c3] = "mián"; /* 䏃 */
dict[0x43c4] = "zhì"; /* 䏄 */
dict[0x43c5] = "qì"; /* 䏅 */
dict[0x43c6] = "cáo"; /* 䏆 */
dict[0x43c7] = "piào"; /* 䏇 */
dict[0x43c8] = "lián"; /* 䏈 */
dict[0x43ca] = "lóng"; /* 䏊 */
dict[0x43cb] = "sù"; /* 䏋 */
dict[0x43cc] = "qì,yì"; /* 䏌 */
dict[0x43cd] = "yuàn"; /* 䏍 */
dict[0x43ce] = "féng,hàn"; /* 䏎 */
dict[0x43d0] = "jué,zhuò"; /* 䏐 */
dict[0x43d1] = "dì,zhì"; /* 䏑 */
dict[0x43d2] = "piàn"; /* 䏒 */
dict[0x43d3] = "guǎn"; /* 䏓 */
dict[0x43d4] = "niǔ"; /* 䏔 */
dict[0x43d5] = "rěn,rùn"; /* 䏕 */
dict[0x43d6] = "zhèn"; /* 䏖 */
dict[0x43d7] = "gài,kuì"; /* 䏗 */
dict[0x43d8] = "pǐ,pì"; /* 䏘 */
dict[0x43d9] = "tǎn"; /* 䏙 */
dict[0x43da] = "chǎo,miǎo"; /* 䏚 */
dict[0x43db] = "chǔn"; /* 䏛 */
dict[0x43dd] = "chún,zhuǎn"; /* 䏝 */
dict[0x43de] = "mò"; /* 䏞 */
dict[0x43df] = "biè,bié"; /* 䏟 */
dict[0x43e0] = "qì"; /* 䏠 */
dict[0x43e1] = "shì"; /* 䏡 */
dict[0x43e2] = "bǐ"; /* 䏢 */
dict[0x43e3] = "jué,qù,qū"; /* 䏣 */
dict[0x43e4] = "sì"; /* 䏤 */
dict[0x43e6] = "huá,tián,wǎn"; /* 䏦 */
dict[0x43e7] = "ná"; /* 䏧 */
dict[0x43e8] = "huǐ"; /* 䏨 */
dict[0x43ea] = "èr"; /* 䏪 */
dict[0x43ec] = "móu"; /* 䏬 */
dict[0x43ee] = "xí,xié"; /* 䏮 */
dict[0x43ef] = "zhì"; /* 䏯 */
dict[0x43f0] = "rěn,chǔn"; /* 䏰 */
dict[0x43f1] = "jú"; /* 䏱 */
dict[0x43f2] = "dié"; /* 䏲 */
dict[0x43f3] = "zhè"; /* 䏳 */
dict[0x43f4] = "shào,shè"; /* 䏴 */
dict[0x43f5] = "měng"; /* 䏵 */
dict[0x43f6] = "bì"; /* 䏶 */
dict[0x43f7] = "hàn"; /* 䏷 */
dict[0x43f8] = "yú"; /* 䏸 */
dict[0x43f9] = "xiàn"; /* 䏹 */
dict[0x43fb] = "néng"; /* 䏻 */
dict[0x43fc] = "cán"; /* 䏼 */
dict[0x43fd] = "bù"; /* 䏽 */
dict[0x43ff] = "qǐ"; /* 䏿 */
dict[0x4400] = "jì"; /* 䐀 */
dict[0x4401] = "niǎo,zhuó"; /* 䐁 */
dict[0x4402] = "lù"; /* 䐂 */
dict[0x4403] = "jiǒng"; /* 䐃 */
dict[0x4404] = "hàn,liǎn,xiàn"; /* 䐄 */
dict[0x4405] = "yí"; /* 䐅 */
dict[0x4406] = "cǎi,cài"; /* 䐆 */
dict[0x4407] = "chún"; /* 䐇 */
dict[0x4408] = "zhí"; /* 䐈 */
dict[0x4409] = "zì"; /* 䐉 */
dict[0x440a] = "dá,hún,hùn"; /* 䐊 */
dict[0x440c] = "tiǎn,zhòu"; /* 䐌 */
dict[0x440d] = "zhòu"; /* 䐍 */
dict[0x440f] = "chǔn"; /* 䐏 */
dict[0x4411] = "zhé"; /* 䐑 */
dict[0x4413] = "róu,rù"; /* 䐓 */
dict[0x4414] = "bìn"; /* 䐔 */
dict[0x4415] = "jí"; /* 䐕 */
dict[0x4416] = "yí"; /* 䐖 */
dict[0x4417] = "dǔ"; /* 䐗 */
dict[0x4418] = "jué"; /* 䐘 */
dict[0x4419] = "gé,yì"; /* 䐙 */
dict[0x441a] = "jí,jì"; /* 䐚 */
dict[0x441b] = "dā"; /* 䐛 */
dict[0x441c] = "chēn"; /* 䐜 */
dict[0x441d] = "suǒ,suò"; /* 䐝 */
dict[0x441e] = "ruò"; /* 䐞 */
dict[0x441f] = "xiàng"; /* 䐟 */
dict[0x4420] = "huǎng"; /* 䐠 */
dict[0x4421] = "qí"; /* 䐡 */
dict[0x4422] = "zhù"; /* 䐢 */
dict[0x4423] = "cuò,sǔn"; /* 䐣 */
dict[0x4424] = "chí,cuó,qì,zhàn"; /* 䐤 */
dict[0x4425] = "wěng"; /* 䐥 */
dict[0x4427] = "kào"; /* 䐧 */
dict[0x4428] = "gǔ"; /* 䐨 */
dict[0x4429] = "kǎi"; /* 䐩 */
dict[0x442a] = "fàn,juǎn"; /* 䐪 */
dict[0x442c] = "cáo"; /* 䐬 */
dict[0x442d] = "zhì"; /* 䐭 */
dict[0x442e] = "chǎn"; /* 䐮 */
dict[0x442f] = "léi"; /* 䐯 */
dict[0x4432] = "zhé"; /* 䐲 */
dict[0x4433] = "yú"; /* 䐳 */
dict[0x4434] = "guì"; /* 䐴 */
dict[0x4435] = "huáng"; /* 䐵 */
dict[0x4436] = "jǐn"; /* 䐶 */
dict[0x4438] = "guó,huò"; /* 䐸 */
dict[0x4439] = "sào,sōu"; /* 䐹 */
dict[0x443a] = "tàn"; /* 䐺 */
dict[0x443c] = "xì"; /* 䐼 */
dict[0x443d] = "mán"; /* 䐽 */
dict[0x443e] = "duó"; /* 䐾 */
dict[0x443f] = "áo,ǎo"; /* 䐿 */
dict[0x4440] = "pì"; /* 䑀 */
dict[0x4441] = "wù"; /* 䑁 */
dict[0x4442] = "ǎi,xì"; /* 䑂 */
dict[0x4443] = "méng"; /* 䑃 */
dict[0x4444] = "pì,yì"; /* 䑄 */
dict[0x4445] = "méng"; /* 䑅 */
dict[0x4446] = "yǎng"; /* 䑆 */
dict[0x4447] = "zhì"; /* 䑇 */
dict[0x4448] = "bó"; /* 䑈 */
dict[0x4449] = "yíng"; /* 䑉 */
dict[0x444a] = "wéi,wèi"; /* 䑊 */
dict[0x444b] = "náo,rǎng"; /* 䑋 */
dict[0x444c] = "lán"; /* 䑌 */
dict[0x444d] = "yàn,yǐng"; /* 䑍 */
dict[0x444e] = "chǎn"; /* 䑎 */
dict[0x444f] = "quán"; /* 䑏 */
dict[0x4450] = "zhěn"; /* 䑐 */
dict[0x4451] = "pú"; /* 䑑 */
dict[0x4453] = "tái,tǎi"; /* 䑓 */
dict[0x4454] = "fèi"; /* 䑔 */
dict[0x4455] = "shǔ"; /* 䑕 */
dict[0x4457] = "dàng"; /* 䑗 */
dict[0x4458] = "chá,cuó"; /* 䑘 */
dict[0x4459] = "rán"; /* 䑙 */
dict[0x445a] = "tián"; /* 䑚 */
dict[0x445b] = "chǐ,shì,yì"; /* 䑛 */
dict[0x445c] = "tà"; /* 䑜 */
dict[0x445d] = "jiǎ"; /* 䑝 */
dict[0x445e] = "shùn"; /* 䑞 */
dict[0x445f] = "huáng"; /* 䑟 */
dict[0x4460] = "liǎo"; /* 䑠 */
dict[0x4461] = "chā"; /* 䑡 */
dict[0x4463] = "chēn"; /* 䑣 */
dict[0x4464] = "jìn,jìng"; /* 䑤 */
dict[0x4465] = "è,sà"; /* 䑥 */
dict[0x4466] = "gōu"; /* 䑦 */
dict[0x4467] = "fú"; /* 䑧 */
dict[0x4468] = "duò"; /* 䑨 */
dict[0x446a] = "è"; /* 䑪 */
dict[0x446c] = "yào"; /* 䑬 */
dict[0x446d] = "dì,zhì"; /* 䑭 */
dict[0x446f] = "dì"; /* 䑯 */
dict[0x4470] = "bù"; /* 䑰 */
dict[0x4471] = "mán,wǎn"; /* 䑱 */
dict[0x4472] = "chè,zhái,zhào"; /* 䑲 */
dict[0x4473] = "lún"; /* 䑳 */
dict[0x4474] = "qí"; /* 䑴 */
dict[0x4475] = "mù"; /* 䑵 */
dict[0x4476] = "cán,qiàn"; /* 䑶 */
dict[0x447b] = "yóu"; /* 䑻 */
dict[0x447d] = "dá,tà"; /* 䑽 */
dict[0x447f] = "sù"; /* 䑿 */
dict[0x4480] = "fú"; /* 䒀 */
dict[0x4481] = "jì,xí,xiào,yà"; /* 䒁 */
dict[0x4482] = "jiǎng,xiǎng"; /* 䒂 */
dict[0x4483] = "zào"; /* 䒃 */
dict[0x4484] = "bó,fù"; /* 䒄 */
dict[0x4485] = "téng"; /* 䒅 */
dict[0x4486] = "chè"; /* 䒆 */
dict[0x4487] = "fù"; /* 䒇 */
dict[0x4488] = "bǔ,fèi"; /* 䒈 */
dict[0x4489] = "wǔ"; /* 䒉 */
dict[0x448b] = "yǎng"; /* 䒋 */
dict[0x448c] = "mìng"; /* 䒌 */
dict[0x448d] = "pǎng"; /* 䒍 */
dict[0x448e] = "mǎng"; /* 䒎 */
dict[0x4490] = "méng"; /* 䒐 */
dict[0x4491] = "cǎo"; /* 䒑 */
dict[0x4492] = "tiáo,yǎo,yóu"; /* 䒒 */
dict[0x4493] = "kǎi"; /* 䒓 */
dict[0x4494] = "bài"; /* 䒔 */
dict[0x4495] = "xiǎo"; /* 䒕 */
dict[0x4496] = "xìn"; /* 䒖 */
dict[0x4497] = "qì"; /* 䒗 */
dict[0x449a] = "shǎo"; /* 䒚 */
dict[0x449b] = "héng,huàn"; /* 䒛 */
dict[0x449c] = "niú"; /* 䒜 */
dict[0x449d] = "xiáo"; /* 䒝 */
dict[0x449e] = "chén"; /* 䒞 */
dict[0x44a0] = "fēng,xiá"; /* 䒠 */
dict[0x44a1] = "yǐn"; /* 䒡 */
dict[0x44a2] = "áng,yìng"; /* 䒢 */
dict[0x44a3] = "rǎn"; /* 䒣 */
dict[0x44a4] = "rì"; /* 䒤 */
dict[0x44a5] = "fà,liǔ,mán"; /* 䒥 */
dict[0x44a6] = "fàn"; /* 䒦 */
dict[0x44a7] = "qù"; /* 䒧 */
dict[0x44a8] = "shǐ"; /* 䒨 */
dict[0x44a9] = "hé,xiá"; /* 䒩 */
dict[0x44aa] = "biàn"; /* 䒪 */
dict[0x44ab] = "dài"; /* 䒫 */
dict[0x44ac] = "mò"; /* 䒬 */
dict[0x44ad] = "děng"; /* 䒭 */
dict[0x44b2] = "chà"; /* 䒲 */
dict[0x44b3] = "duǒ"; /* 䒳 */
dict[0x44b4] = "yǒu"; /* 䒴 */
dict[0x44b5] = "hào"; /* 䒵 */
dict[0x44b7] = "guā"; /* 䒷 */
dict[0x44b8] = "xián,xuè,yuè"; /* 䒸 */
dict[0x44b9] = "lèi"; /* 䒹 */
dict[0x44ba] = "jǐn"; /* 䒺 */
dict[0x44bb] = "qǐ"; /* 䒻 */
dict[0x44bc] = "qū"; /* 䒼 */
dict[0x44bd] = "méi,wǎng"; /* 䒽 */
dict[0x44bf] = "liáo"; /* 䒿 */
dict[0x44c2] = "yán"; /* 䓂 */
dict[0x44c3] = "yì"; /* 䓃 */
dict[0x44c4] = "yín"; /* 䓄 */
dict[0x44c5] = "qí"; /* 䓅 */
dict[0x44c6] = "zhé"; /* 䓆 */
dict[0x44c7] = "xì"; /* 䓇 */
dict[0x44c8] = "yì"; /* 䓈 */
dict[0x44c9] = "yé"; /* 䓉 */
dict[0x44ca] = "è,wú,yú"; /* 䓊 */
dict[0x44cc] = "zhì"; /* 䓌 */
dict[0x44cd] = "hǎn"; /* 䓍 */
dict[0x44ce] = "chuò"; /* 䓎 */
dict[0x44d0] = "chún"; /* 䓐 */
dict[0x44d1] = "bǐng,píng"; /* 䓑 */
dict[0x44d2] = "kuǎi"; /* 䓒 */
dict[0x44d3] = "chóu"; /* 䓓 */
dict[0x44d5] = "tuǒ,wěi"; /* 䓕 */
dict[0x44d6] = "qióng"; /* 䓖 */
dict[0x44d8] = "jiù"; /* 䓘 */
dict[0x44da] = "cú"; /* 䓚 */
dict[0x44db] = "fǔ,gǔ,qū"; /* 䓛 */
dict[0x44dc] = "zhī"; /* 䓜 */
dict[0x44dd] = "méng,mèng"; /* 䓝 */
dict[0x44de] = "lì"; /* 䓞 */
dict[0x44df] = "liè"; /* 䓟 */
dict[0x44e0] = "tà"; /* 䓠 */
dict[0x44e1] = "zhī"; /* 䓡 */
dict[0x44e2] = "gù"; /* 䓢 */
dict[0x44e3] = "liǎng"; /* 䓣 */
dict[0x44e5] = "là"; /* 䓥 */
dict[0x44e6] = "diǎn"; /* 䓦 */
dict[0x44e7] = "cì,jí"; /* 䓧 */
dict[0x44eb] = "jì,qí"; /* 䓫 */
dict[0x44ed] = "chà"; /* 䓭 */
dict[0x44ee] = "mào"; /* 䓮 */
dict[0x44ef] = "dú"; /* 䓯 */
dict[0x44f1] = "chái,zhài"; /* 䓱 */
dict[0x44f2] = "ruì,sà"; /* 䓲 */
dict[0x44f3] = "hěn"; /* 䓳 */
dict[0x44f4] = "ruán,ruǎn"; /* 䓴 */
dict[0x44f6] = "lài"; /* 䓶 */
dict[0x44f7] = "xìng"; /* 䓷 */
dict[0x44f9] = "yì"; /* 䓹 */
dict[0x44fa] = "měi,wèi"; /* 䓺 */
dict[0x44fc] = "hè,máng"; /* 䓼 */
dict[0x44fd] = "jì"; /* 䓽 */
dict[0x44fe] = "suō"; /* 䓾 */
dict[0x44ff] = "hǎn,hàn"; /* 䓿 */
dict[0x4501] = "lì"; /* 䔁 */
dict[0x4502] = "zǐ"; /* 䔂 */
dict[0x4503] = "zǔ"; /* 䔃 */
dict[0x4504] = "yáo"; /* 䔄 */
dict[0x4506] = "lí"; /* 䔆 */
dict[0x4507] = "qǐ,yǐ"; /* 䔇 */
dict[0x4508] = "gǎn,gòng,nǒu"; /* 䔈 */
dict[0x4509] = "lì"; /* 䔉 */
dict[0x450c] = "gāo"; /* 䔌 */
dict[0x450e] = "sù"; /* 䔎 */
dict[0x450f] = "chòu"; /* 䔏 */
dict[0x4511] = "xié,yé"; /* 䔑 */
dict[0x4512] = "bèi"; /* 䔒 */
dict[0x4513] = "xǔ"; /* 䔓 */
dict[0x4514] = "jìng,qiǎn,qiú,yǐng"; /* 䔔 */
dict[0x4515] = "pú"; /* 䔕 */
dict[0x4516] = "líng"; /* 䔖 */
dict[0x4517] = "xiáng"; /* 䔗 */
dict[0x4518] = "zuò"; /* 䔘 */
dict[0x4519] = "diào"; /* 䔙 */
dict[0x451a] = "chún"; /* 䔚 */
dict[0x451b] = "qǐng"; /* 䔛 */
dict[0x451c] = "nán"; /* 䔜 */
dict[0x451f] = "chí,chǐ,yí"; /* 䔟 */
dict[0x4520] = "shǎo"; /* 䔠 */
dict[0x4521] = "yú"; /* 䔡 */
dict[0x4522] = "huá,huà"; /* 䔢 */
dict[0x4523] = "lí"; /* 䔣 */
dict[0x4524] = "pā"; /* 䔤 */
dict[0x4527] = "lí,lì"; /* 䔧 */
dict[0x452a] = "duì,shuǎng"; /* 䔪 */
dict[0x452b] = "shū"; /* 䔫 */
dict[0x452c] = "yì"; /* 䔬 */
dict[0x452d] = "nìng,zhǒu"; /* 䔭 */
dict[0x452e] = "sī"; /* 䔮 */
dict[0x452f] = "hú,huà,kù"; /* 䔯 */
dict[0x4530] = "fú,fù"; /* 䔰 */
dict[0x4532] = "chéng,zhuó"; /* 䔲 */
dict[0x4533] = "nǎn,rán"; /* 䔳 */
dict[0x4534] = "cè,cuì"; /* 䔴 */
dict[0x4536] = "tí"; /* 䔶 */
dict[0x4537] = "qín"; /* 䔷 */
dict[0x4538] = "biǎo"; /* 䔸 */
dict[0x4539] = "suì"; /* 䔹 */
dict[0x453a] = "wéi"; /* 䔺 */
dict[0x453c] = "sè"; /* 䔼 */
dict[0x453d] = "ài"; /* 䔽 */
dict[0x453e] = "è,qì,zè"; /* 䔾 */
dict[0x453f] = "jiè,zǔn"; /* 䔿 */
dict[0x4540] = "kuǎn"; /* 䕀 */
dict[0x4541] = "fěi"; /* 䕁 */
dict[0x4543] = "yìn"; /* 䕃 */
dict[0x4545] = "sǎo"; /* 䕅 */
dict[0x4546] = "dòu"; /* 䕆 */
dict[0x4547] = "huì"; /* 䕇 */
dict[0x4548] = "xiè"; /* 䕈 */
dict[0x4549] = "zé"; /* 䕉 */
dict[0x454a] = "tán"; /* 䕊 */
dict[0x454b] = "chǎng,táng"; /* 䕋 */
dict[0x454c] = "zhì"; /* 䕌 */
dict[0x454d] = "yì"; /* 䕍 */
dict[0x454e] = "fú"; /* 䕎 */
dict[0x454f] = "é"; /* 䕏 */
dict[0x4551] = "jùn"; /* 䕑 */
dict[0x4553] = "chá,chuì"; /* 䕓 */
dict[0x4554] = "xián"; /* 䕔 */
dict[0x4555] = "màn"; /* 䕕 */
dict[0x4557] = "bì,pèi"; /* 䕗 */
dict[0x4558] = "líng"; /* 䕘 */
dict[0x4559] = "jié"; /* 䕙 */
dict[0x455a] = "kuì"; /* 䕚 */
dict[0x455b] = "jiá"; /* 䕛 */
dict[0x455e] = "làng,liáo"; /* 䕞 */
dict[0x4560] = "fèi"; /* 䕠 */
dict[0x4561] = "lǘ"; /* 䕡 */
dict[0x4562] = "zhǎ"; /* 䕢 */
dict[0x4563] = "hé,kě,shé"; /* 䕣 */
dict[0x4564] = "qí,jī"; /* 䕤 */
dict[0x4565] = "nǐ,yí"; /* 䕥 */
dict[0x4566] = "yíng"; /* 䕦 */
dict[0x4567] = "xiào"; /* 䕧 */
dict[0x4568] = "téng"; /* 䕨 */
dict[0x4569] = "lǎo"; /* 䕩 */
dict[0x456a] = "zé"; /* 䕪 */
dict[0x456b] = "kuí"; /* 䕫 */
dict[0x456c] = "jiāng"; /* 䕬 */
dict[0x456d] = "qián"; /* 䕭 */
dict[0x456e] = "jú"; /* 䕮 */
dict[0x456f] = "piáo"; /* 䕯 */
dict[0x4570] = "bàn,fán,fàn"; /* 䕰 */
dict[0x4571] = "dǒu,dòu,tóu"; /* 䕱 */
dict[0x4572] = "lǐn"; /* 䕲 */
dict[0x4573] = "mí"; /* 䕳 */
dict[0x4574] = "zhuó"; /* 䕴 */
dict[0x4575] = "xié,xiè"; /* 䕵 */
dict[0x4576] = "hù"; /* 䕶 */
dict[0x4577] = "mí"; /* 䕷 */
dict[0x4579] = "zá"; /* 䕹 */
dict[0x457a] = "cóng"; /* 䕺 */
dict[0x457b] = "gé,lì,lí"; /* 䕻 */
dict[0x457c] = "nán,nàn,rán"; /* 䕼 */
dict[0x457d] = "zhú"; /* 䕽 */
dict[0x457e] = "yán,yín"; /* 䕾 */
dict[0x457f] = "hàn"; /* 䕿 */
dict[0x4581] = "yì"; /* 䖁 */
dict[0x4582] = "luán"; /* 䖂 */
dict[0x4583] = "yuè"; /* 䖃 */
dict[0x4584] = "rán"; /* 䖄 */
dict[0x4585] = "líng"; /* 䖅 */
dict[0x4586] = "niàng"; /* 䖆 */
dict[0x4587] = "yù"; /* 䖇 */
dict[0x4588] = "nüè"; /* 䖈 */
dict[0x458a] = "yí,yì"; /* 䖊 */
dict[0x458b] = "nüè"; /* 䖋 */
dict[0x458c] = "qín,yá,yì"; /* 䖌 */
dict[0x458d] = "qián"; /* 䖍 */
dict[0x458e] = "xiá"; /* 䖎 */
dict[0x458f] = "chǔ"; /* 䖏 */
dict[0x4590] = "jìn,yín"; /* 䖐 */
dict[0x4591] = "mì"; /* 䖑 */
dict[0x4592] = "xī"; /* 䖒 */
dict[0x4593] = "nà"; /* 䖓 */
dict[0x4594] = "hàn,kǎn"; /* 䖔 */
dict[0x4595] = "zǔ"; /* 䖕 */
dict[0x4596] = "xiá"; /* 䖖 */
dict[0x4597] = "yán,yàn"; /* 䖗 */
dict[0x4598] = "tú"; /* 䖘 */
dict[0x459b] = "suǒ"; /* 䖛 */
dict[0x459c] = "yín,yìn"; /* 䖜 */
dict[0x459d] = "chóng"; /* 䖝 */
dict[0x459e] = "zhǒu"; /* 䖞 */
dict[0x459f] = "mǎng,méng"; /* 䖟 */
dict[0x45a0] = "yuán"; /* 䖠 */
dict[0x45a2] = "miáo"; /* 䖢 */
dict[0x45a3] = "zǎo"; /* 䖣 */
dict[0x45a4] = "wǎn,yuán"; /* 䖤 */
dict[0x45a5] = "máo"; /* 䖥 */
dict[0x45a6] = "qū,zhuō"; /* 䖦 */
dict[0x45a7] = "nà"; /* 䖧 */
dict[0x45a8] = "shí"; /* 䖨 */
dict[0x45a9] = "bì,pì"; /* 䖩 */
dict[0x45aa] = "cí"; /* 䖪 */
dict[0x45ab] = "bàng"; /* 䖫 */
dict[0x45ac] = "jiǎ"; /* 䖬 */
dict[0x45ad] = "juàn"; /* 䖭 */
dict[0x45ae] = "xiǎng"; /* 䖮 */
dict[0x45af] = "kuí,wā"; /* 䖯 */
dict[0x45b0] = "pài"; /* 䖰 */
dict[0x45b2] = "xún"; /* 䖲 */
dict[0x45b3] = "zhà"; /* 䖳 */
dict[0x45b4] = "yáo"; /* 䖴 */
dict[0x45b5] = "kūn"; /* 䖵 */
dict[0x45b8] = "é"; /* 䖸 */
dict[0x45b9] = "yáng"; /* 䖹 */
dict[0x45ba] = "tiáo,zhào"; /* 䖺 */
dict[0x45bb] = "yóu"; /* 䖻 */
dict[0x45bc] = "jué,xuè"; /* 䖼 */
dict[0x45bd] = "lí"; /* 䖽 */
dict[0x45bf] = "lí"; /* 䖿 */
dict[0x45c1] = "jì,qī"; /* 䗁 */
dict[0x45c2] = "hǔ"; /* 䗂 */
dict[0x45c3] = "zhàn"; /* 䗃 */
dict[0x45c4] = "fǔ,pì"; /* 䗄 */
dict[0x45c5] = "cháng"; /* 䗅 */
dict[0x45c6] = "guǎn,wěi"; /* 䗆 */
dict[0x45c7] = "jú,qú"; /* 䗇 */
dict[0x45c8] = "méng"; /* 䗈 */
dict[0x45ca] = "chéng,tàn"; /* 䗊 */
dict[0x45cb] = "móu"; /* 䗋 */
dict[0x45cd] = "lǐ"; /* 䗍 */
dict[0x45d0] = "shī"; /* 䗐 */
dict[0x45d1] = "yì"; /* 䗑 */
dict[0x45d2] = "bìng"; /* 䗒 */
dict[0x45d4] = "hóu"; /* 䗔 */
dict[0x45d5] = "wǎn"; /* 䗕 */
dict[0x45d6] = "dì"; /* 䗖 */
dict[0x45d8] = "gé,kè"; /* 䗘 */
dict[0x45d9] = "hán"; /* 䗙 */
dict[0x45da] = "bó"; /* 䗚 */
dict[0x45dc] = "liú"; /* 䗜 */
dict[0x45dd] = "cán"; /* 䗝 */
dict[0x45de] = "cán,chěn,shǎn,yǐn,zàn,zhàn"; /* 䗞 */
dict[0x45df] = "yì"; /* 䗟 */
dict[0x45e0] = "xuán"; /* 䗠 */
dict[0x45e1] = "yán"; /* 䗡 */
dict[0x45e2] = "zǎo"; /* 䗢 */
dict[0x45e3] = "gǎo,hàn"; /* 䗣 */
dict[0x45e4] = "yóng"; /* 䗤 */
dict[0x45e5] = "zōng"; /* 䗥 */
dict[0x45e8] = "yú"; /* 䗨 */
dict[0x45ea] = "zhè"; /* 䗪 */
dict[0x45eb] = "má"; /* 䗫 */
dict[0x45ee] = "shuǎng"; /* 䗮 */
dict[0x45ef] = "jìn"; /* 䗯 */
dict[0x45f0] = "guàn"; /* 䗰 */
dict[0x45f1] = "pú"; /* 䗱 */
dict[0x45f2] = "lìn"; /* 䗲 */
dict[0x45f4] = "tíng"; /* 䗴 */
dict[0x45f6] = "là,lì"; /* 䗶 */
dict[0x45f7] = "yì"; /* 䗷 */
dict[0x45f9] = "cì"; /* 䗹 */
dict[0x45fa] = "yǎn"; /* 䗺 */
dict[0x45fb] = "jié"; /* 䗻 */
dict[0x45fd] = "wèi"; /* 䗽 */
dict[0x45fe] = "xiǎn"; /* 䗾 */
dict[0x45ff] = "níng"; /* 䗿 */
dict[0x4600] = "fù"; /* 䘀 */
dict[0x4601] = "gé,jié,kě"; /* 䘁 */
dict[0x4603] = "mò"; /* 䘃 */
dict[0x4604] = "fù,zhù"; /* 䘄 */
dict[0x4605] = "nái,nài,něng"; /* 䘅 */
dict[0x4606] = "xiǎn"; /* 䘆 */
dict[0x4607] = "wén,wèn"; /* 䘇 */
dict[0x4608] = "lì"; /* 䘈 */
dict[0x4609] = "cán"; /* 䘉 */
dict[0x460a] = "miè"; /* 䘊 */
dict[0x460c] = "nì"; /* 䘌 */
dict[0x460d] = "chài"; /* 䘍 */
dict[0x460f] = "xù"; /* 䘏 */
dict[0x4611] = "mài,mò"; /* 䘑 */
dict[0x4612] = "zuī"; /* 䘒 */
dict[0x4613] = "kàn,kào"; /* 䘓 */
dict[0x4614] = "kā"; /* 䘔 */
dict[0x4615] = "háng"; /* 䘕 */
dict[0x4618] = "yù"; /* 䘘 */
dict[0x4619] = "wèi"; /* 䘙 */
dict[0x461a] = "zú"; /* 䘚 */
dict[0x461d] = "yì"; /* 䘝 */
dict[0x461f] = "diāo"; /* 䘟 */
dict[0x4620] = "fú,pò"; /* 䘠 */
dict[0x4621] = "bǐ"; /* 䘡 */
dict[0x4622] = "zhǔ"; /* 䘢 */
dict[0x4623] = "zǐ"; /* 䘣 */
dict[0x4624] = "shù"; /* 䘤 */
dict[0x4625] = "xiá,jiá"; /* 䘥 */
dict[0x4626] = "ní,nǐ"; /* 䘦 */
dict[0x4628] = "jiǎo"; /* 䘨 */
dict[0x4629] = "xuàn,xún"; /* 䘩 */
dict[0x462b] = "nòu,rú"; /* 䘫 */
dict[0x462c] = "róng"; /* 䘬 */
dict[0x462d] = "dié,zhì"; /* 䘭 */
dict[0x462e] = "sà,sàng,xì"; /* 䘮 */
dict[0x462f] = "shāo"; /* 䘯 */
dict[0x4630] = "shān"; /* 䘰 */
dict[0x4631] = "yù"; /* 䘱 */
dict[0x4633] = "jīn"; /* 䘳 */
dict[0x4635] = "lù"; /* 䘵 */
dict[0x4636] = "hàn,yǎn"; /* 䘶 */
dict[0x4638] = "yì"; /* 䘸 */
dict[0x4639] = "zuì"; /* 䘹 */
dict[0x463a] = "zhàn"; /* 䘺 */
dict[0x463b] = "sù,yù"; /* 䘻 */
dict[0x463c] = "wǎn"; /* 䘼 */
dict[0x463d] = "ní,nǐ,nì"; /* 䘽 */
dict[0x463e] = "guǎn"; /* 䘾 */
dict[0x463f] = "jué"; /* 䘿 */
dict[0x4640] = "běng"; /* 䙀 */
dict[0x4641] = "cán"; /* 䙁 */
dict[0x4643] = "duò,kuò,pán,ruán"; /* 䙃 */
dict[0x4644] = "qì,zhǎ"; /* 䙄 */
dict[0x4645] = "yào"; /* 䙅 */
dict[0x4646] = "guì,kuì"; /* 䙆 */
dict[0x4647] = "nuǎn,ruán"; /* 䙇 */
dict[0x4648] = "hóu"; /* 䙈 */
dict[0x4649] = "xún,zǎn"; /* 䙉 */
dict[0x464a] = "xiè"; /* 䙊 */
dict[0x464c] = "huì,kuì"; /* 䙌 */
dict[0x464e] = "xié"; /* 䙎 */
dict[0x464f] = "bó"; /* 䙏 */
dict[0x4650] = "kè"; /* 䙐 */
dict[0x4652] = "xù"; /* 䙒 */
dict[0x4653] = "bǎi"; /* 䙓 */
dict[0x4654] = "yǔ"; /* 䙔 */
dict[0x4655] = "chù,zǒng"; /* 䙕 */
dict[0x4657] = "tì"; /* 䙗 */
dict[0x4658] = "chǔ,zú"; /* 䙘 */
dict[0x4659] = "chí"; /* 䙙 */
dict[0x465a] = "niǎo"; /* 䙚 */
dict[0x465b] = "guàn,gǔn"; /* 䙛 */
dict[0x465c] = "féng"; /* 䙜 */
dict[0x465d] = "xiè,dié"; /* 䙝 */
dict[0x465f] = "duò,wéi"; /* 䙟 */
dict[0x4660] = "jué,wò"; /* 䙠 */
dict[0x4661] = "huì,kuì"; /* 䙡 */
dict[0x4662] = "zèng"; /* 䙢 */
dict[0x4663] = "sà"; /* 䙣 */
dict[0x4664] = "duǒ,duò"; /* 䙤 */
dict[0x4665] = "líng"; /* 䙥 */
dict[0x4666] = "méng"; /* 䙦 */
dict[0x4668] = "guǒ,luǒ"; /* 䙨 */
dict[0x4669] = "méng"; /* 䙩 */
dict[0x466a] = "lóng,màng,pàn"; /* 䙪 */
dict[0x466c] = "yìng"; /* 䙬 */
dict[0x466e] = "guàn"; /* 䙮 */
dict[0x466f] = "cù,zhuó"; /* 䙯 */
dict[0x4670] = "lí"; /* 䙰 */
dict[0x4671] = "dú,shǔ"; /* 䙱 */
dict[0x4673] = "è"; /* 䙳 */
dict[0x4675] = "xī"; /* 䙵 */
dict[0x4677] = "dé,zhé"; /* 䙷 */
dict[0x4678] = "dé,de"; /* 䙸 */
dict[0x4679] = "jiǎng,nǎo,xiàn,xiǎng"; /* 䙹 */
dict[0x467a] = "lián,liǎn,qiǎn"; /* 䙺 */
dict[0x467c] = "shào"; /* 䙼 */
dict[0x467d] = "xì,xié"; /* 䙽 */
dict[0x467e] = "shī"; /* 䙾 */
dict[0x467f] = "wèi"; /* 䙿 */
dict[0x4682] = "hè,xì"; /* 䚂 */
dict[0x4683] = "yóu"; /* 䚃 */
dict[0x4684] = "lù"; /* 䚄 */
dict[0x4685] = "lái,lài"; /* 䚅 */
dict[0x4686] = "ǒu,yǎo,yǐng"; /* 䚆 */
dict[0x4687] = "shěng,zhì"; /* 䚇 */
dict[0x4688] = "juàn,wù,zhuàn"; /* 䚈 */
dict[0x4689] = "qì,xì"; /* 䚉 */
dict[0x468b] = "yùn"; /* 䚋 */
dict[0x468d] = "qì"; /* 䚍 */
dict[0x468e] = "chuāng"; /* 䚎 */
dict[0x468f] = "lèng,lì,lìn"; /* 䚏 */
dict[0x4690] = "jí"; /* 䚐 */
dict[0x4691] = "mái"; /* 䚑 */
dict[0x4692] = "chuáng,zhuàng"; /* 䚒 */
dict[0x4693] = "niǎn,shěn"; /* 䚓 */
dict[0x4694] = "bìn"; /* 䚔 */
dict[0x4695] = "lì,luán"; /* 䚕 */
dict[0x4696] = "líng"; /* 䚖 */
dict[0x4697] = "gāng"; /* 䚗 */
dict[0x4698] = "chén,chéng"; /* 䚘 */
dict[0x4699] = "xuān"; /* 䚙 */
dict[0x469a] = "xiǎn"; /* 䚚 */
dict[0x469b] = "hú"; /* 䚛 */
dict[0x469d] = "zú"; /* 䚝 */
dict[0x469e] = "dǎi"; /* 䚞 */
dict[0x469f] = "dǎi"; /* 䚟 */
dict[0x46a0] = "hùn"; /* 䚠 */
dict[0x46a1] = "sāi"; /* 䚡 */
dict[0x46a2] = "chè"; /* 䚢 */
dict[0x46a3] = "tí,tì"; /* 䚣 */
dict[0x46a5] = "nuò"; /* 䚥 */
dict[0x46a6] = "zhì"; /* 䚦 */
dict[0x46a7] = "liú"; /* 䚧 */
dict[0x46a8] = "fèi"; /* 䚨 */
dict[0x46a9] = "jiǎo,jiào"; /* 䚩 */
dict[0x46ab] = "áo,xí"; /* 䚫 */
dict[0x46ac] = "lín"; /* 䚬 */
dict[0x46ad] = "xuān"; /* 䚭 */
dict[0x46ae] = "réng"; /* 䚮 */
dict[0x46af] = "tǎo,zhèn"; /* 䚯 */
dict[0x46b0] = "pǐ"; /* 䚰 */
dict[0x46b1] = "xìn"; /* 䚱 */
dict[0x46b2] = "shàn"; /* 䚲 */
dict[0x46b3] = "xiè,zhì"; /* 䚳 */
dict[0x46b4] = "wà"; /* 䚴 */
dict[0x46b5] = "tǒu"; /* 䚵 */
dict[0x46b7] = "xì,yǐ,yì"; /* 䚷 */
dict[0x46b8] = "xiè"; /* 䚸 */
dict[0x46b9] = "pǐ"; /* 䚹 */
dict[0x46ba] = "yáo"; /* 䚺 */
dict[0x46bb] = "yáo"; /* 䚻 */
dict[0x46bd] = "hào"; /* 䚽 */
dict[0x46be] = "nín,rén"; /* 䚾 */
dict[0x46bf] = "yìn"; /* 䚿 */
dict[0x46c0] = "fǎn"; /* 䛀 */
dict[0x46c1] = "nán"; /* 䛁 */
dict[0x46c2] = "chí,chǐ"; /* 䛂 */
dict[0x46c3] = "wàng"; /* 䛃 */
dict[0x46c4] = "yuǎn"; /* 䛄 */
dict[0x46c5] = "xiá"; /* 䛅 */
dict[0x46c6] = "zhòu"; /* 䛆 */
dict[0x46c7] = "yuǎn"; /* 䛇 */
dict[0x46c8] = "shì"; /* 䛈 */
dict[0x46c9] = "mì,miàn"; /* 䛉 */
dict[0x46cb] = "gé,jì"; /* 䛋 */
dict[0x46cc] = "páo,táo"; /* 䛌 */
dict[0x46cd] = "fèi"; /* 䛍 */
dict[0x46ce] = "hù,xuè,yù"; /* 䛎 */
dict[0x46cf] = "ní"; /* 䛏 */
dict[0x46d0] = "cí"; /* 䛐 */
dict[0x46d1] = "mì"; /* 䛑 */
dict[0x46d2] = "biàn"; /* 䛒 */
dict[0x46d4] = "ná"; /* 䛔 */
dict[0x46d5] = "yù"; /* 䛕 */
dict[0x46d6] = "è,yì"; /* 䛖 */
dict[0x46d7] = "zhǐ"; /* 䛗 */
dict[0x46d8] = "nín,rén"; /* 䛘 */
dict[0x46d9] = "xù"; /* 䛙 */
dict[0x46db] = "huì,qì"; /* 䛛 */
dict[0x46dc] = "xùn"; /* 䛜 */
dict[0x46dd] = "náo"; /* 䛝 */
dict[0x46de] = "hǎn,hàn"; /* 䛞 */
dict[0x46df] = "jiá"; /* 䛟 */
dict[0x46e0] = "dòu,xiáng"; /* 䛠 */
dict[0x46e1] = "huà"; /* 䛡 */
dict[0x46e4] = "cù"; /* 䛤 */
dict[0x46e5] = "xì"; /* 䛥 */
dict[0x46e6] = "sòng"; /* 䛦 */
dict[0x46e7] = "mí"; /* 䛧 */
dict[0x46e8] = "xìn"; /* 䛨 */
dict[0x46e9] = "wù"; /* 䛩 */
dict[0x46ea] = "qióng,wěi"; /* 䛪 */
dict[0x46eb] = "zhèng"; /* 䛫 */
dict[0x46ec] = "táo"; /* 䛬 */
dict[0x46ed] = "xìng"; /* 䛭 */
dict[0x46ee] = "jiù"; /* 䛮 */
dict[0x46ef] = "jù"; /* 䛯 */
dict[0x46f0] = "hún,hùn"; /* 䛰 */
dict[0x46f1] = "tí"; /* 䛱 */
dict[0x46f2] = "mán,màn"; /* 䛲 */
dict[0x46f3] = "jiǎn,yàn"; /* 䛳 */
dict[0x46f4] = "qǐ"; /* 䛴 */
dict[0x46f5] = "shòu"; /* 䛵 */
dict[0x46f6] = "lěi"; /* 䛶 */
dict[0x46f7] = "wǎn"; /* 䛷 */
dict[0x46f8] = "chè,shǎn"; /* 䛸 */
dict[0x46f9] = "càn"; /* 䛹 */
dict[0x46fa] = "jiè"; /* 䛺 */
dict[0x46fb] = "yòu"; /* 䛻 */
dict[0x46fc] = "huǐ"; /* 䛼 */
dict[0x46fd] = "zhǎ"; /* 䛽 */
dict[0x46fe] = "sù"; /* 䛾 */
dict[0x46ff] = "gé"; /* 䛿 */
dict[0x4700] = "nǎo"; /* 䜀 */
dict[0x4701] = "xì"; /* 䜁 */
dict[0x4704] = "chí"; /* 䜄 */
dict[0x4705] = "wéi"; /* 䜅 */
dict[0x4706] = "mò,nèi,shé,suì,zhé"; /* 䜆 */
dict[0x4707] = "gǔn,gùn"; /* 䜇 */
dict[0x4708] = "jiǎo"; /* 䜈 */
dict[0x470a] = "zāo,zào"; /* 䜊 */
dict[0x470b] = "huì"; /* 䜋 */
dict[0x470c] = "luán"; /* 䜌 */
dict[0x470d] = "liáo"; /* 䜍 */
dict[0x470e] = "láo,lào"; /* 䜎 */
dict[0x4710] = "huī"; /* 䜐 */
dict[0x4711] = "qià,wù"; /* 䜑 */
dict[0x4712] = "ào"; /* 䜒 */
dict[0x4713] = "niè,shè"; /* 䜓 */
dict[0x4714] = "suí"; /* 䜔 */
dict[0x4715] = "mài"; /* 䜕 */
dict[0x4716] = "tàn"; /* 䜖 */
dict[0x4717] = "xìn"; /* 䜗 */
dict[0x4718] = "jǐng"; /* 䜘 */
dict[0x4719] = "án"; /* 䜙 */
dict[0x471a] = "tà"; /* 䜚 */
dict[0x471b] = "chán,chàn"; /* 䜛 */
dict[0x471c] = "wèi"; /* 䜜 */
dict[0x471d] = "tuǎn"; /* 䜝 */
dict[0x471e] = "jì"; /* 䜞 */
dict[0x471f] = "chén,chèn"; /* 䜟 */
dict[0x4720] = "chè,zhì"; /* 䜠 */
dict[0x4721] = "xù,xuè,yù"; /* 䜡 */
dict[0x4722] = "xiǎn"; /* 䜢 */
dict[0x4723] = "xī,xīn,yín"; /* 䜣 */
dict[0x4727] = "nǎo"; /* 䜧 */
dict[0x4729] = "yàn"; /* 䜩 */
dict[0x472a] = "qiú"; /* 䜪 */
dict[0x472b] = "hóng"; /* 䜫 */
dict[0x472c] = "sǒng,xiù"; /* 䜬 */
dict[0x472d] = "jùn"; /* 䜭 */
dict[0x472e] = "liáo"; /* 䜮 */
dict[0x472f] = "jú"; /* 䜯 */
dict[0x4730] = "hāo"; /* 䜰 */
dict[0x4731] = "mǎn"; /* 䜱 */
dict[0x4732] = "liè"; /* 䜲 */
dict[0x4734] = "chù,shì"; /* 䜴 */
dict[0x4735] = "chǐ,shì"; /* 䜵 */
dict[0x4736] = "xiáng"; /* 䜶 */
dict[0x4738] = "měi"; /* 䜸 */
dict[0x4739] = "shù"; /* 䜹 */
dict[0x473a] = "cè"; /* 䜺 */
dict[0x473b] = "chǐ,shì"; /* 䜻 */
dict[0x473c] = "gú"; /* 䜼 */
dict[0x473d] = "yú"; /* 䜽 */
dict[0x473f] = "shù"; /* 䜿 */
dict[0x4740] = "liáo,liú"; /* 䝀 */
dict[0x4741] = "láo"; /* 䝁 */
dict[0x4742] = "shù"; /* 䝂 */
dict[0x4743] = "zhé"; /* 䝃 */
dict[0x4748] = "è"; /* 䝈 */
dict[0x474a] = "shà"; /* 䝊 */
dict[0x474b] = "zòng"; /* 䝋 */
dict[0x474c] = "jué,jùn"; /* 䝌 */
dict[0x474d] = "jùn"; /* 䝍 */
dict[0x474f] = "lóu,lǒu"; /* 䝏 */
dict[0x4750] = "wéi"; /* 䝐 */
dict[0x4752] = "zhù"; /* 䝒 */
dict[0x4753] = "là,liè"; /* 䝓 */
dict[0x4755] = "zhé"; /* 䝕 */
dict[0x4756] = "zhǎo"; /* 䝖 */
dict[0x4758] = "yì"; /* 䝘 */
dict[0x475a] = "ní"; /* 䝚 */
dict[0x475d] = "yǐ"; /* 䝝 */
dict[0x475e] = "hào"; /* 䝞 */
dict[0x475f] = "yà,yè"; /* 䝟 */
dict[0x4760] = "huán,yuán"; /* 䝠 */
dict[0x4761] = "màn"; /* 䝡 */
dict[0x4762] = "màn,méng"; /* 䝢 */
dict[0x4763] = "qú"; /* 䝣 */
dict[0x4764] = "lǎo,liáo"; /* 䝤 */
dict[0x4765] = "háo"; /* 䝥 */
dict[0x4767] = "mén,mín"; /* 䝧 */
dict[0x4768] = "xián"; /* 䝨 */
dict[0x4769] = "zhèn"; /* 䝩 */
dict[0x476a] = "shú,shǔ"; /* 䝪 */
dict[0x476b] = "zuó"; /* 䝫 */
dict[0x476c] = "zhù"; /* 䝬 */
dict[0x476d] = "gòu"; /* 䝭 */
dict[0x476e] = "xuàn"; /* 䝮 */
dict[0x476f] = "yì"; /* 䝯 */
dict[0x4770] = "tí,zhì"; /* 䝰 */
dict[0x4772] = "jìn"; /* 䝲 */
dict[0x4773] = "cán"; /* 䝳 */
dict[0x4775] = "bù"; /* 䝵 */
dict[0x4776] = "liáng"; /* 䝶 */
dict[0x4777] = "zhì"; /* 䝷 */
dict[0x4778] = "jì"; /* 䝸 */
dict[0x4779] = "wǎn,yuàn"; /* 䝹 */
dict[0x477a] = "guàn"; /* 䝺 */
dict[0x477c] = "qíng"; /* 䝼 */
dict[0x477d] = "ài"; /* 䝽 */
dict[0x477e] = "fù"; /* 䝾 */
dict[0x477f] = "guì"; /* 䝿 */
dict[0x4780] = "gòu,hòu,mǐn"; /* 䞀 */
dict[0x4781] = "xiàn,yàn,yǎng,yàng"; /* 䞁 */
dict[0x4782] = "ruǎn"; /* 䞂 */
dict[0x4783] = "zhì"; /* 䞃 */
dict[0x4784] = "biào"; /* 䞄 */
dict[0x4785] = "yí"; /* 䞅 */
dict[0x4786] = "suǒ"; /* 䞆 */
dict[0x4787] = "dié,zhì"; /* 䞇 */
dict[0x4788] = "guǐ,guì"; /* 䞈 */
dict[0x4789] = "shèng"; /* 䞉 */
dict[0x478a] = "xùn"; /* 䞊 */
dict[0x478b] = "chèn"; /* 䞋 */
dict[0x478c] = "shé"; /* 䞌 */
dict[0x478d] = "qíng"; /* 䞍 */
dict[0x4790] = "chǔn,shǔn"; /* 䞐 */
dict[0x4791] = "hóng"; /* 䞑 */
dict[0x4792] = "dòng"; /* 䞒 */
dict[0x4793] = "chēng"; /* 䞓 */
dict[0x4794] = "wěi"; /* 䞔 */
dict[0x4795] = "dié,nǎ,niè,rú,xiè,yú"; /* 䞕 */
dict[0x4796] = "shǔ"; /* 䞖 */
dict[0x4797] = "cāi"; /* 䞗 */
dict[0x4798] = "jí"; /* 䞘 */
dict[0x4799] = "zá"; /* 䞙 */
dict[0x479a] = "qí"; /* 䞚 */
dict[0x479c] = "fù"; /* 䞜 */
dict[0x479d] = "ǎo,yù"; /* 䞝 */
dict[0x479e] = "fú"; /* 䞞 */
dict[0x479f] = "pò"; /* 䞟 */
dict[0x47a1] = "tǎn"; /* 䞡 */
dict[0x47a2] = "zhà,zuó"; /* 䞢 */
dict[0x47a3] = "chě,chè,qiè"; /* 䞣 */
dict[0x47a4] = "qú"; /* 䞤 */
dict[0x47a5] = "yòu"; /* 䞥 */
dict[0x47a6] = "hé,jié"; /* 䞦 */
dict[0x47a7] = "hòu"; /* 䞧 */
dict[0x47a8] = "guǐ,kuǐ"; /* 䞨 */
dict[0x47a9] = "è,ruí"; /* 䞩 */
dict[0x47aa] = "jiàng"; /* 䞪 */
dict[0x47ab] = "yǔn"; /* 䞫 */
dict[0x47ac] = "tòu"; /* 䞬 */
dict[0x47ad] = "qiǔ,qūn"; /* 䞭 */
dict[0x47af] = "fù"; /* 䞯 */
dict[0x47b0] = "zuó"; /* 䞰 */
dict[0x47b1] = "hú"; /* 䞱 */
dict[0x47b3] = "bó,fèi"; /* 䞳 */
dict[0x47b5] = "juě"; /* 䞵 */
dict[0x47b6] = "dì,tì"; /* 䞶 */
dict[0x47b7] = "jué"; /* 䞷 */
dict[0x47b8] = "fù"; /* 䞸 */
dict[0x47b9] = "huáng"; /* 䞹 */
dict[0x47bb] = "yǒng"; /* 䞻 */
dict[0x47bc] = "chuǐ,cuàn,jiàn,mèi"; /* 䞼 */
dict[0x47bd] = "suǒ"; /* 䞽 */
dict[0x47be] = "chí"; /* 䞾 */
dict[0x47bf] = "qiān"; /* 䞿 */
dict[0x47c2] = "mán"; /* 䟂 */
dict[0x47c3] = "cà,zàn"; /* 䟃 */
dict[0x47c4] = "qì,zuó"; /* 䟄 */
dict[0x47c5] = "jiàn,zàn"; /* 䟅 */
dict[0x47c6] = "bì,bó"; /* 䟆 */
dict[0x47c7] = "jī"; /* 䟇 */
dict[0x47c8] = "zhí"; /* 䟈 */
dict[0x47c9] = "zhú"; /* 䟉 */
dict[0x47ca] = "qú"; /* 䟊 */
dict[0x47cb] = "zhǎn,zhàn"; /* 䟋 */
dict[0x47cc] = "jí,jié"; /* 䟌 */
dict[0x47cd] = "dián"; /* 䟍 */
dict[0x47cf] = "lì"; /* 䟏 */
dict[0x47d0] = "lì"; /* 䟐 */
dict[0x47d1] = "lǎ,yuè"; /* 䟑 */
dict[0x47d2] = "quán"; /* 䟒 */
dict[0x47d4] = "fù"; /* 䟔 */
dict[0x47d5] = "chà"; /* 䟕 */
dict[0x47d6] = "tàng"; /* 䟖 */
dict[0x47d7] = "shì"; /* 䟗 */
dict[0x47d8] = "hàng"; /* 䟘 */
dict[0x47d9] = "qiè"; /* 䟙 */
dict[0x47da] = "qí"; /* 䟚 */
dict[0x47db] = "bó"; /* 䟛 */
dict[0x47dc] = "nà"; /* 䟜 */
dict[0x47dd] = "tòu"; /* 䟝 */
dict[0x47de] = "chú"; /* 䟞 */
dict[0x47df] = "cù"; /* 䟟 */
dict[0x47e0] = "yuè"; /* 䟠 */
dict[0x47e1] = "dì"; /* 䟡 */
dict[0x47e2] = "chén,jiàn,niǎn"; /* 䟢 */
dict[0x47e3] = "chù"; /* 䟣 */
dict[0x47e4] = "bì"; /* 䟤 */
dict[0x47e5] = "máng,méng"; /* 䟥 */
dict[0x47e6] = "bá,bó,yuán"; /* 䟦 */
dict[0x47e7] = "tián"; /* 䟧 */
dict[0x47e8] = "mín"; /* 䟨 */
dict[0x47e9] = "liě"; /* 䟩 */
dict[0x47ea] = "fěng"; /* 䟪 */
dict[0x47ec] = "qiù"; /* 䟬 */
dict[0x47ed] = "tiáo"; /* 䟭 */
dict[0x47ee] = "fú"; /* 䟮 */
dict[0x47ef] = "kuò"; /* 䟯 */
dict[0x47f0] = "jiǎn"; /* 䟰 */
dict[0x47f2] = "còng"; /* 䟲 */
dict[0x47f4] = "zhèn"; /* 䟴 */
dict[0x47f5] = "qiú"; /* 䟵 */
dict[0x47f6] = "cuò,zuò"; /* 䟶 */
dict[0x47f7] = "chì,qì"; /* 䟷 */
dict[0x47f8] = "kuí"; /* 䟸 */
dict[0x47f9] = "liè,lìn"; /* 䟹 */
dict[0x47fa] = "bǎng,bèi,pèi"; /* 䟺 */
dict[0x47fb] = "dù"; /* 䟻 */
dict[0x47fc] = "wǔ"; /* 䟼 */
dict[0x47fd] = "shū"; /* 䟽 */
dict[0x47fe] = "juě,zhuó"; /* 䟾 */
dict[0x47ff] = "lù"; /* 䟿 */
dict[0x4800] = "chǎng"; /* 䠀 */
dict[0x4802] = "chú,chǔ"; /* 䠂 */
dict[0x4803] = "liǎng"; /* 䠃 */
dict[0x4804] = "tiǎn"; /* 䠄 */
dict[0x4805] = "kǔn,tà"; /* 䠅 */
dict[0x4806] = "cháng"; /* 䠆 */
dict[0x4807] = "jué"; /* 䠇 */
dict[0x4808] = "tú"; /* 䠈 */
dict[0x4809] = "huà,huàn,huǐ"; /* 䠉 */
dict[0x480a] = "fèi"; /* 䠊 */
dict[0x480b] = "bǐ,bì,mà"; /* 䠋 */
dict[0x480d] = "qiá,xiā"; /* 䠍 */
dict[0x480e] = "wò"; /* 䠎 */
dict[0x480f] = "jì"; /* 䠏 */
dict[0x4810] = "qù"; /* 䠐 */
dict[0x4811] = "kuǐ"; /* 䠑 */
dict[0x4812] = "hú"; /* 䠒 */
dict[0x4813] = "cù,jiù,qù"; /* 䠓 */
dict[0x4814] = "suì"; /* 䠔 */
dict[0x4817] = "qiù"; /* 䠗 */
dict[0x4818] = "pì"; /* 䠘 */
dict[0x4819] = "bèi,páng,páo"; /* 䠙 */
dict[0x481a] = "wà"; /* 䠚 */
dict[0x481b] = "jiǎo,xiào,yáo"; /* 䠛 */
dict[0x481c] = "róng"; /* 䠜 */
dict[0x481e] = "cù,qí"; /* 䠞 */
dict[0x481f] = "dié,shè"; /* 䠟 */
dict[0x4820] = "chì"; /* 䠠 */
dict[0x4821] = "cuó"; /* 䠡 */
dict[0x4822] = "mèng"; /* 䠢 */
dict[0x4823] = "xuǎn,xuàn"; /* 䠣 */
dict[0x4824] = "duǒ,duò"; /* 䠤 */
dict[0x4825] = "bié"; /* 䠥 */
dict[0x4826] = "zhè,zhì"; /* 䠦 */
dict[0x4827] = "chú"; /* 䠧 */
dict[0x4828] = "chàn,mà"; /* 䠨 */
dict[0x4829] = "guì"; /* 䠩 */
dict[0x482a] = "duàn"; /* 䠪 */
dict[0x482b] = "zòu"; /* 䠫 */
dict[0x482c] = "dèng"; /* 䠬 */
dict[0x482d] = "lái,lài"; /* 䠭 */
dict[0x482e] = "téng"; /* 䠮 */
dict[0x482f] = "yuè"; /* 䠯 */
dict[0x4830] = "quán"; /* 䠰 */
dict[0x4831] = "shǔ,zhú"; /* 䠱 */
dict[0x4832] = "líng"; /* 䠲 */
dict[0x4834] = "qǐn,yǐn,zhěn"; /* 䠴 */
dict[0x4835] = "fù"; /* 䠵 */
dict[0x4836] = "shè"; /* 䠶 */
dict[0x4837] = "tiǎo"; /* 䠷 */
dict[0x4839] = "hái"; /* 䠹 */
dict[0x483b] = "qióng"; /* 䠻 */
dict[0x483c] = "diào,shù,xuè,zhú"; /* 䠼 */
dict[0x483d] = "hái"; /* 䠽 */
dict[0x483e] = "shǎn,shàn"; /* 䠾 */
dict[0x483f] = "wài"; /* 䠿 */
dict[0x4840] = "zhǎn"; /* 䡀 */
dict[0x4841] = "lǒng"; /* 䡁 */
dict[0x4842] = "jiù"; /* 䡂 */
dict[0x4843] = "lì"; /* 䡃 */
dict[0x4845] = "mǐn,xiǎn,xún,zhèn,zuǎn,chūn"; /* 䡅 */
dict[0x4846] = "róng,rǒng"; /* 䡆 */
dict[0x4847] = "yuè"; /* 䡇 */
dict[0x4848] = "jué"; /* 䡈 */
dict[0x4849] = "kǎng"; /* 䡉 */
dict[0x484a] = "fán,fǎn,pèi"; /* 䡊 */
dict[0x484b] = "qí"; /* 䡋 */
dict[0x484c] = "hóng"; /* 䡌 */
dict[0x484d] = "fú,fǔ"; /* 䡍 */
dict[0x484e] = "lú"; /* 䡎 */
dict[0x484f] = "hóng"; /* 䡏 */
dict[0x4850] = "tuó"; /* 䡐 */
dict[0x4851] = "mín"; /* 䡑 */
dict[0x4852] = "tián"; /* 䡒 */
dict[0x4853] = "juàn"; /* 䡓 */
dict[0x4854] = "qǐ"; /* 䡔 */
dict[0x4855] = "zhěng"; /* 䡕 */
dict[0x4856] = "jìng"; /* 䡖 */
dict[0x4857] = "gǒng"; /* 䡗 */
dict[0x4858] = "tián"; /* 䡘 */
dict[0x4859] = "láng"; /* 䡙 */
dict[0x485a] = "mào"; /* 䡚 */
dict[0x485b] = "yìn"; /* 䡛 */
dict[0x485c] = "lù"; /* 䡜 */
dict[0x485d] = "yǔn,yuān"; /* 䡝 */
dict[0x485e] = "jú"; /* 䡞 */
dict[0x485f] = "pì"; /* 䡟 */
dict[0x4861] = "xié"; /* 䡡 */
dict[0x4862] = "biàn"; /* 䡢 */
dict[0x4863] = "hún"; /* 䡣 */
dict[0x4865] = "róng"; /* 䡥 */
dict[0x4866] = "sǎng"; /* 䡦 */
dict[0x4867] = "wǔ"; /* 䡧 */
dict[0x4868] = "chà,chái,yín"; /* 䡨 */
dict[0x4869] = "gǔ,hòu,tǒu,zhěn,kēng"; /* 䡩 */
dict[0x486a] = "chán,shàn"; /* 䡪 */
dict[0x486b] = "péng"; /* 䡫 */
dict[0x486c] = "màn"; /* 䡬 */
dict[0x486f] = "shuàng,zǒng"; /* 䡯 */
dict[0x4870] = "kěng,kēng"; /* 䡰 */
dict[0x4871] = "zhuǎn"; /* 䡱 */
dict[0x4872] = "chán"; /* 䡲 */
dict[0x4874] = "chuáng,chōng"; /* 䡴 */
dict[0x4875] = "suì"; /* 䡵 */
dict[0x4876] = "bèi,pì"; /* 䡶 */
dict[0x4877] = "kài"; /* 䡷 */
dict[0x4879] = "zhì"; /* 䡹 */
dict[0x487a] = "wèi"; /* 䡺 */
dict[0x487b] = "mín"; /* 䡻 */
dict[0x487c] = "líng"; /* 䡼 */
dict[0x487e] = "nèi,niè"; /* 䡾 */
dict[0x487f] = "líng"; /* 䡿 */
dict[0x4880] = "qì"; /* 䢀 */
dict[0x4881] = "yuè"; /* 䢁 */
dict[0x4883] = "yì"; /* 䢃 */
dict[0x4884] = "xǐ,xǐ"; /* 䢄 */
dict[0x4885] = "chén"; /* 䢅 */
dict[0x4887] = "rǒng,rǒu"; /* 䢇 */
dict[0x4888] = "chén,qín"; /* 䢈 */
dict[0x4889] = "nóng"; /* 䢉 */
dict[0x488a] = "yóu"; /* 䢊 */
dict[0x488b] = "jì"; /* 䢋 */
dict[0x488c] = "bó"; /* 䢌 */
dict[0x488d] = "fǎng,fèn"; /* 䢍 */
dict[0x4890] = "cú"; /* 䢐 */
dict[0x4891] = "dǐ"; /* 䢑 */
dict[0x4892] = "jiāo"; /* 䢒 */
dict[0x4893] = "yú"; /* 䢓 */
dict[0x4894] = "gé,hé,jiá"; /* 䢔 */
dict[0x4895] = "xù"; /* 䢕 */
dict[0x4896] = "yù"; /* 䢖 */
dict[0x4897] = "hé,qǔ"; /* 䢗 */
dict[0x4899] = "bài"; /* 䢙 */
dict[0x489a] = "gòng,háng"; /* 䢚 */
dict[0x489b] = "jiǒng"; /* 䢛 */
dict[0x489d] = "yà"; /* 䢝 */
dict[0x489e] = "nù,shù"; /* 䢞 */
dict[0x489f] = "yóu"; /* 䢟 */
dict[0x48a0] = "sòng"; /* 䢠 */
dict[0x48a1] = "xiè"; /* 䢡 */
dict[0x48a2] = "càng"; /* 䢢 */
dict[0x48a3] = "yáo"; /* 䢣 */
dict[0x48a4] = "shù"; /* 䢤 */
dict[0x48a5] = "yán,yàn"; /* 䢥 */
dict[0x48a6] = "shuài"; /* 䢦 */
dict[0x48a7] = "liào,lǐn,què"; /* 䢧 */
dict[0x48a9] = "yù"; /* 䢩 */
dict[0x48aa] = "bó,cuì,jiǎo,nǔ,qián"; /* 䢪 */
dict[0x48ab] = "suí"; /* 䢫 */
dict[0x48ad] = "yàn"; /* 䢭 */
dict[0x48ae] = "lèi"; /* 䢮 */
dict[0x48af] = "lín"; /* 䢯 */
dict[0x48b0] = "tái,tì"; /* 䢰 */
dict[0x48b1] = "dú,zhà"; /* 䢱 */
dict[0x48b2] = "yuè"; /* 䢲 */
dict[0x48b3] = "jǐ,jì"; /* 䢳 */
dict[0x48b5] = "yún"; /* 䢵 */
dict[0x48b8] = "jū"; /* 䢸 */
dict[0x48b9] = "jǔ"; /* 䢹 */
dict[0x48ba] = "chū"; /* 䢺 */
dict[0x48bb] = "chén,jìn,tán"; /* 䢻 */
dict[0x48bc] = "gōng"; /* 䢼 */
dict[0x48bd] = "xiàng"; /* 䢽 */
dict[0x48be] = "xiǎn"; /* 䢾 */
dict[0x48c0] = "guǐ,wéi"; /* 䣀 */
dict[0x48c1] = "yǔ"; /* 䣁 */
dict[0x48c2] = "lěi,lèi"; /* 䣂 */
dict[0x48c4] = "tú"; /* 䣄 */
dict[0x48c5] = "chén"; /* 䣅 */
dict[0x48c6] = "xíng"; /* 䣆 */
dict[0x48c7] = "qiú"; /* 䣇 */
dict[0x48c8] = "hàng,liáo,xiàng"; /* 䣈 */
dict[0x48ca] = "dǎng"; /* 䣊 */
dict[0x48cb] = "cǎi"; /* 䣋 */
dict[0x48cc] = "dǐ"; /* 䣌 */
dict[0x48cd] = "yǎn"; /* 䣍 */
dict[0x48d1] = "chán"; /* 䣑 */
dict[0x48d3] = "lí"; /* 䣓 */
dict[0x48d4] = "suǒ,suò"; /* 䣔 */
dict[0x48d5] = "mǎ,mà"; /* 䣕 */
dict[0x48d6] = "mǎ"; /* 䣖 */
dict[0x48d8] = "táng"; /* 䣘 */
dict[0x48d9] = "péi"; /* 䣙 */
dict[0x48da] = "lóu,lú"; /* 䣚 */
dict[0x48db] = "qī"; /* 䣛 */
dict[0x48dc] = "cuó"; /* 䣜 */
dict[0x48dd] = "tú"; /* 䣝 */
dict[0x48de] = "è"; /* 䣞 */
dict[0x48df] = "cán"; /* 䣟 */
dict[0x48e0] = "jié,tì"; /* 䣠 */
dict[0x48e1] = "tí,yí"; /* 䣡 */
dict[0x48e2] = "jí"; /* 䣢 */
dict[0x48e3] = "dǎng,dào"; /* 䣣 */
dict[0x48e4] = "jiào,jué"; /* 䣤 */
dict[0x48e5] = "bǐ,mì"; /* 䣥 */
dict[0x48e6] = "lèi"; /* 䣦 */
dict[0x48e7] = "yì"; /* 䣧 */
dict[0x48e8] = "chún"; /* 䣨 */
dict[0x48e9] = "chún"; /* 䣩 */
dict[0x48ea] = "pò"; /* 䣪 */
dict[0x48eb] = "lí"; /* 䣫 */
dict[0x48ec] = "zǎi"; /* 䣬 */
dict[0x48ed] = "tài"; /* 䣭 */
dict[0x48ee] = "pò"; /* 䣮 */
dict[0x48ef] = "tiǎn"; /* 䣯 */
dict[0x48f0] = "jù,yuàn"; /* 䣰 */
dict[0x48f1] = "xù,yì"; /* 䣱 */
dict[0x48f2] = "fàn"; /* 䣲 */
dict[0x48f4] = "xù"; /* 䣴 */
dict[0x48f5] = "èr"; /* 䣵 */
dict[0x48f6] = "huó,tián"; /* 䣶 */
dict[0x48f8] = "rǎn"; /* 䣸 */
dict[0x48f9] = "fá"; /* 䣹 */
dict[0x48fa] = "juān"; /* 䣺 */
dict[0x48fc] = "liáng"; /* 䣼 */
dict[0x48fd] = "tǐ"; /* 䣽 */
dict[0x48fe] = "mì"; /* 䣾 */
dict[0x4901] = "cén,chè,shè,yín"; /* 䤁 */
dict[0x4902] = "méi"; /* 䤂 */
dict[0x4903] = "yìn"; /* 䤃 */
dict[0x4904] = "miǎn,zhuàn"; /* 䤄 */
dict[0x4905] = "tú"; /* 䤅 */
dict[0x4906] = "kuí"; /* 䤆 */
dict[0x4909] = "mì,míng,mò,rú"; /* 䤉 */
dict[0x490a] = "róng"; /* 䤊 */
dict[0x490b] = "guó,yù"; /* 䤋 */
dict[0x490d] = "mí"; /* 䤍 */
dict[0x490e] = "jú"; /* 䤎 */
dict[0x490f] = "pǐ"; /* 䤏 */
dict[0x4910] = "jǐn"; /* 䤐 */
dict[0x4911] = "wàng"; /* 䤑 */
dict[0x4912] = "jǐ,jì"; /* 䤒 */
dict[0x4913] = "méng"; /* 䤓 */
dict[0x4914] = "jiàn,niú,xiàng"; /* 䤔 */
dict[0x4915] = "xuè"; /* 䤕 */
dict[0x4916] = "bào"; /* 䤖 */
dict[0x4917] = "gǎn"; /* 䤗 */
dict[0x4918] = "chǎn,qiǎn"; /* 䤘 */
dict[0x4919] = "lì"; /* 䤙 */
dict[0x491a] = "lǐ,lüè"; /* 䤚 */
dict[0x491b] = "qiú"; /* 䤛 */
dict[0x491c] = "dùn"; /* 䤜 */
dict[0x491d] = "yìng"; /* 䤝 */
dict[0x491e] = "yǔn"; /* 䤞 */
dict[0x491f] = "chén"; /* 䤟 */
dict[0x4920] = "jī,zhǐ"; /* 䤠 */
dict[0x4921] = "rǎn"; /* 䤡 */
dict[0x4925] = "guǐ"; /* 䤥 */
dict[0x4926] = "yuè"; /* 䤦 */
dict[0x4927] = "huì"; /* 䤧 */
dict[0x4928] = "pì"; /* 䤨 */
dict[0x4929] = "chá"; /* 䤩 */
dict[0x492a] = "duǒ"; /* 䤪 */
dict[0x492b] = "chán"; /* 䤫 */
dict[0x492d] = "kuàn,shì,suì,yí"; /* 䤭 */
dict[0x492e] = "shè"; /* 䤮 */
dict[0x492f] = "xíng"; /* 䤯 */
dict[0x4930] = "wěng,yíng"; /* 䤰 */
dict[0x4931] = "shì"; /* 䤱 */
dict[0x4932] = "chì"; /* 䤲 */
dict[0x4933] = "yè"; /* 䤳 */
dict[0x4934] = "hán"; /* 䤴 */
dict[0x4935] = "fèi"; /* 䤵 */
dict[0x4936] = "yè"; /* 䤶 */
dict[0x4937] = "yán,yǎn"; /* 䤷 */
dict[0x4938] = "zuàn"; /* 䤸 */
dict[0x493a] = "yǐn"; /* 䤺 */
dict[0x493b] = "duò"; /* 䤻 */
dict[0x493c] = "xiàn"; /* 䤼 */
dict[0x493f] = "qiè"; /* 䤿 */
dict[0x4940] = "chǎn"; /* 䥀 */
dict[0x4941] = "hán"; /* 䥁 */
dict[0x4942] = "mèng"; /* 䥂 */
dict[0x4943] = "yuè"; /* 䥃 */
dict[0x4944] = "cù,zǎn,zàn"; /* 䥄 */
dict[0x4945] = "qiàn,qín"; /* 䥅 */
dict[0x4946] = "jǐn,qín,ròu,wèi"; /* 䥆 */
dict[0x4947] = "shàn"; /* 䥇 */
dict[0x4948] = "mǔ"; /* 䥈 */
dict[0x494c] = "zhèng"; /* 䥌 */
dict[0x494d] = "zhì"; /* 䥍 */
dict[0x494e] = "chún"; /* 䥎 */
dict[0x494f] = "yǔ"; /* 䥏 */
dict[0x4950] = "móu"; /* 䥐 */
dict[0x4951] = "wàn"; /* 䥑 */
dict[0x4952] = "jiàng"; /* 䥒 */
dict[0x4954] = "sù"; /* 䥔 */
dict[0x4955] = "piě"; /* 䥕 */
dict[0x4956] = "tián"; /* 䥖 */
dict[0x4957] = "kuǎn"; /* 䥗 */
dict[0x4958] = "cù,cuò"; /* 䥘 */
dict[0x4959] = "suì"; /* 䥙 */
dict[0x495b] = "jié"; /* 䥛 */
dict[0x495c] = "jiàn"; /* 䥜 */
dict[0x495d] = "áo,āo"; /* 䥝 */
dict[0x495e] = "jiǎo"; /* 䥞 */
dict[0x495f] = "yè"; /* 䥟 */
dict[0x4961] = "yè"; /* 䥡 */
dict[0x4962] = "lóng"; /* 䥢 */
dict[0x4963] = "záo"; /* 䥣 */
dict[0x4964] = "báo,fú"; /* 䥤 */
dict[0x4965] = "lián"; /* 䥥 */
dict[0x4967] = "huán,xuán"; /* 䥧 */
dict[0x4969] = "wéi"; /* 䥩 */
dict[0x496a] = "xiǎn"; /* 䥪 */
dict[0x496b] = "tiě"; /* 䥫 */
dict[0x496c] = "bó"; /* 䥬 */
dict[0x496d] = "zhèng"; /* 䥭 */
dict[0x496e] = "zhú"; /* 䥮 */
dict[0x496f] = "bà,bài,bēi"; /* 䥯 */
dict[0x4970] = "mèng"; /* 䥰 */
dict[0x4971] = "xiě"; /* 䥱 */
dict[0x4974] = "juān"; /* 䥴 */
dict[0x4975] = "xiǎo"; /* 䥵 */
dict[0x4976] = "lì"; /* 䥶 */
dict[0x4977] = "zhá"; /* 䥷 */
dict[0x4978] = "mí"; /* 䥸 */
dict[0x497a] = "yé"; /* 䥺 */
dict[0x497e] = "xiě"; /* 䥾 */
dict[0x4982] = "shàn"; /* 䦂 */
dict[0x4985] = "shàn,zhǎn"; /* 䦅 */
dict[0x4986] = "jué"; /* 䦆 */
dict[0x4987] = "jì"; /* 䦇 */
dict[0x4988] = "fǎng,hǎn,jí,mǒu,zá,zuǒ"; /* 䦈 */
dict[0x498a] = "niǎo"; /* 䦊 */
dict[0x498b] = "áo"; /* 䦋 */
dict[0x498c] = "chù,pò,ruì"; /* 䦌 */
dict[0x498d] = "wù"; /* 䦍 */
dict[0x498e] = "guǎn"; /* 䦎 */
dict[0x498f] = "xiè"; /* 䦏 */
dict[0x4990] = "tǐng"; /* 䦐 */
dict[0x4991] = "xiè"; /* 䦑 */
dict[0x4992] = "dàng"; /* 䦒 */
dict[0x4994] = "tǎn"; /* 䦔 */
dict[0x4996] = "xiá,xié"; /* 䦖 */
dict[0x4997] = "xù"; /* 䦗 */
dict[0x4998] = "bì,xiǎn,xiàn"; /* 䦘 */
dict[0x4999] = "sì"; /* 䦙 */
dict[0x499a] = "huò,kuǎ,kuà"; /* 䦚 */
dict[0x499b] = "zhèng,zhì"; /* 䦛 */
dict[0x499c] = "wú,wù"; /* 䦜 */
dict[0x499e] = "rùn"; /* 䦞 */
dict[0x499f] = "chuài"; /* 䦟 */
dict[0x49a0] = "shǐ"; /* 䦠 */
dict[0x49a1] = "huán"; /* 䦡 */
dict[0x49a2] = "kuò"; /* 䦢 */
dict[0x49a3] = "fù"; /* 䦣 */
dict[0x49a4] = "chuài,wěn"; /* 䦤 */
dict[0x49a5] = "xián"; /* 䦥 */
dict[0x49a6] = "qín"; /* 䦦 */
dict[0x49a7] = "qié,xì,yǎn"; /* 䦧 */
dict[0x49a8] = "lán"; /* 䦨 */
dict[0x49a9] = "wén"; /* 䦩 */
dict[0x49aa] = "yà"; /* 䦪 */
dict[0x49ac] = "què"; /* 䦬 */
dict[0x49ae] = "chǔn"; /* 䦮 */
dict[0x49af] = "zhì"; /* 䦯 */
dict[0x49b1] = "kuǐ,wěi"; /* 䦱 */
dict[0x49b2] = "qiàn,yán"; /* 䦲 */
dict[0x49b3] = "hàng,xiàng"; /* 䦳 */
dict[0x49b4] = "yì"; /* 䦴 */
dict[0x49b5] = "nǐ"; /* 䦵 */
dict[0x49b6] = "zhèng"; /* 䦶 */
dict[0x49b7] = "chuài,wěn"; /* 䦷 */
dict[0x49b9] = "shí"; /* 䦹 */
dict[0x49ba] = "dīng"; /* 䦺 */
dict[0x49bb] = "cì,zǐ"; /* 䦻 */
dict[0x49bc] = "jué"; /* 䦼 */
dict[0x49bd] = "xù"; /* 䦽 */
dict[0x49be] = "yǔn"; /* 䦾 */
dict[0x49c1] = "chù,xǔ"; /* 䧁 */
dict[0x49c2] = "dào,tiǎo,zhào"; /* 䧂 */
dict[0x49c3] = "diàn,tián"; /* 䧃 */
dict[0x49c4] = "gè"; /* 䧄 */
dict[0x49c5] = "tì,yà,yí"; /* 䧅 */
dict[0x49c6] = "hóng,kǒu,qióng"; /* 䧆 */
dict[0x49c7] = "nǐ,yǐ,yī"; /* 䧇 */
dict[0x49c9] = "lǐ"; /* 䧉 */
dict[0x49ca] = "kū"; /* 䧊 */
dict[0x49cb] = "xiǎn"; /* 䧋 */
dict[0x49cd] = "xì"; /* 䧍 */
dict[0x49ce] = "xuàn"; /* 䧎 */
dict[0x49d2] = "lái,lǎn"; /* 䧒 */
dict[0x49d4] = "mù,niàn"; /* 䧔 */
dict[0x49d5] = "chéng,yù"; /* 䧕 */
dict[0x49d6] = "jiàn"; /* 䧖 */
dict[0x49d7] = "bì"; /* 䧗 */
dict[0x49d8] = "qí,zhuàn"; /* 䧘 */
dict[0x49d9] = "líng"; /* 䧙 */
dict[0x49da] = "hào"; /* 䧚 */
dict[0x49db] = "bàng"; /* 䧛 */
dict[0x49dc] = "táng"; /* 䧜 */
dict[0x49dd] = "chī,zhì"; /* 䧝 */
dict[0x49de] = "fù,mà"; /* 䧞 */
dict[0x49df] = "xiàn,xuàn"; /* 䧟 */
dict[0x49e0] = "shuàn"; /* 䧠 */
dict[0x49e2] = "qū"; /* 䧢 */
dict[0x49e4] = "pú"; /* 䧤 */
dict[0x49e5] = "huì"; /* 䧥 */
dict[0x49e6] = "wéi,huī"; /* 䧦 */
dict[0x49e7] = "yǐ"; /* 䧧 */
dict[0x49e8] = "yè"; /* 䧨 */
dict[0x49ea] = "chè,zhé"; /* 䧪 */
dict[0x49eb] = "háo"; /* 䧫 */
dict[0x49ee] = "xiǎn,xiàn"; /* 䧮 */
dict[0x49ef] = "chán,zhàn"; /* 䧯 */
dict[0x49f0] = "hùn"; /* 䧰 */
dict[0x49f2] = "hàn"; /* 䧲 */
dict[0x49f3] = "cí,cǐ"; /* 䧳 */
dict[0x49f4] = "zhī"; /* 䧴 */
dict[0x49f5] = "qí,shěn,zhèn"; /* 䧵 */
dict[0x49f6] = "kuí"; /* 䧶 */
dict[0x49f7] = "róu"; /* 䧷 */
dict[0x49fa] = "xióng"; /* 䧺 */
dict[0x49fc] = "hú"; /* 䧼 */
dict[0x49fd] = "cuǐ"; /* 䧽 */
dict[0x49ff] = "què"; /* 䧿 */
dict[0x4a00] = "dí,dì"; /* 䨀 */
dict[0x4a01] = "chè,wù,yù"; /* 䨁 */
dict[0x4a04] = "yàn,ān"; /* 䨄 */
dict[0x4a05] = "liáo"; /* 䨅 */
dict[0x4a06] = "bí,bì,xù"; /* 䨆 */
dict[0x4a0a] = "yuān"; /* 䨊 */
dict[0x4a0c] = "báo,bó"; /* 䨌 */
dict[0x4a0d] = "yǐng"; /* 䨍 */
dict[0x4a0e] = "hóng"; /* 䨎 */
dict[0x4a0f] = "cí"; /* 䨏 */
dict[0x4a10] = "qià,xiá"; /* 䨐 */
dict[0x4a11] = "tí"; /* 䨑 */
dict[0x4a12] = "yù"; /* 䨒 */
dict[0x4a13] = "léi,lèi"; /* 䨓 */
dict[0x4a14] = "báo"; /* 䨔 */
dict[0x4a16] = "jì"; /* 䨖 */
dict[0x4a17] = "fú"; /* 䨗 */
dict[0x4a18] = "xiàn"; /* 䨘 */
dict[0x4a19] = "cén,yà,yín"; /* 䨙 */
dict[0x4a1b] = "sè"; /* 䨛 */
dict[0x4a1e] = "yǔ,yù"; /* 䨞 */
dict[0x4a20] = "ǎi"; /* 䨠 */
dict[0x4a21] = "hán"; /* 䨡 */
dict[0x4a22] = "dàn,dí,gào,tán"; /* 䨢 */
dict[0x4a23] = "gé,gèng"; /* 䨣 */
dict[0x4a24] = "dí"; /* 䨤 */
dict[0x4a25] = "hù,huò"; /* 䨥 */
dict[0x4a26] = "páng"; /* 䨦 */
dict[0x4a29] = "líng"; /* 䨩 */
dict[0x4a2a] = "mái"; /* 䨪 */
dict[0x4a2b] = "mài,màn"; /* 䨫 */
dict[0x4a2c] = "lián"; /* 䨬 */
dict[0x4a2e] = "xuě"; /* 䨮 */
dict[0x4a2f] = "zhèn"; /* 䨯 */
dict[0x4a30] = "pò"; /* 䨰 */
dict[0x4a31] = "fù"; /* 䨱 */
dict[0x4a32] = "nóu"; /* 䨲 */
dict[0x4a33] = "xì"; /* 䨳 */
dict[0x4a34] = "duì,wèng"; /* 䨴 */
dict[0x4a35] = "dàn"; /* 䨵 */
dict[0x4a36] = "yǔn"; /* 䨶 */
dict[0x4a37] = "xiàn"; /* 䨷 */
dict[0x4a38] = "yǐn"; /* 䨸 */
dict[0x4a3a] = "duì"; /* 䨺 */
dict[0x4a3b] = "bèng"; /* 䨻 */
dict[0x4a3c] = "hù"; /* 䨼 */
dict[0x4a3d] = "fěi"; /* 䨽 */
dict[0x4a3e] = "fěi"; /* 䨾 */
dict[0x4a3f] = "qián,zá"; /* 䨿 */
dict[0x4a40] = "bèi"; /* 䩀 */
dict[0x4a41] = "fēi"; /* 䩁 */
dict[0x4a43] = "shì"; /* 䩃 */
dict[0x4a44] = "tiǎn"; /* 䩄 */
dict[0x4a45] = "zhǎn"; /* 䩅 */
dict[0x4a46] = "jiǎn,zhǎn"; /* 䩆 */
dict[0x4a48] = "huì,wèi,xuě"; /* 䩈 */
dict[0x4a49] = "fǔ"; /* 䩉 */
dict[0x4a4a] = "wǎn,wò"; /* 䩊 */
dict[0x4a4b] = "mǒ"; /* 䩋 */
dict[0x4a4c] = "qiáo,jiāo"; /* 䩌 */
dict[0x4a4d] = "liǎo"; /* 䩍 */
dict[0x4a4f] = "miè"; /* 䩏 */
dict[0x4a50] = "gé,jí"; /* 䩐 */
dict[0x4a51] = "hóng"; /* 䩑 */
dict[0x4a52] = "yú"; /* 䩒 */
dict[0x4a53] = "qí"; /* 䩓 */
dict[0x4a54] = "duò"; /* 䩔 */
dict[0x4a55] = "áng"; /* 䩕 */
dict[0x4a57] = "bà"; /* 䩗 */
dict[0x4a58] = "dì"; /* 䩘 */
dict[0x4a59] = "xuàn"; /* 䩙 */
dict[0x4a5a] = "dì,diàn"; /* 䩚 */
dict[0x4a5b] = "bì"; /* 䩛 */
dict[0x4a5c] = "zhòu"; /* 䩜 */
dict[0x4a5d] = "páo"; /* 䩝 */
dict[0x4a5e] = "nián,tiǎn,tié,wěi"; /* 䩞 */
dict[0x4a5f] = "yí,tì"; /* 䩟 */
dict[0x4a61] = "jiá"; /* 䩡 */
dict[0x4a62] = "dá,zhì"; /* 䩢 */
dict[0x4a63] = "duǒ,tú,tuì"; /* 䩣 */
dict[0x4a64] = "xì,xié"; /* 䩤 */
dict[0x4a65] = "dàn"; /* 䩥 */
dict[0x4a66] = "tiáo,zuò"; /* 䩦 */
dict[0x4a67] = "xiè"; /* 䩧 */
dict[0x4a68] = "chàng"; /* 䩨 */
dict[0x4a69] = "yuǎn"; /* 䩩 */
dict[0x4a6a] = "guǎn"; /* 䩪 */
dict[0x4a6b] = "liǎng"; /* 䩫 */
dict[0x4a6c] = "běng,fěng"; /* 䩬 */
dict[0x4a6e] = "lù"; /* 䩮 */
dict[0x4a6f] = "jí"; /* 䩯 */
dict[0x4a70] = "xuàn"; /* 䩰 */
dict[0x4a71] = "shù"; /* 䩱 */
dict[0x4a73] = "shǔ,sù"; /* 䩳 */
dict[0x4a74] = "hú"; /* 䩴 */
dict[0x4a75] = "yùn"; /* 䩵 */
dict[0x4a76] = "chǎn,chěng"; /* 䩶 */
dict[0x4a78] = "róng,rǒng"; /* 䩸 */
dict[0x4a79] = "é"; /* 䩹 */
dict[0x4a7b] = "bà"; /* 䩻 */
dict[0x4a7c] = "féng"; /* 䩼 */
dict[0x4a7e] = "zhè"; /* 䩾 */
dict[0x4a7f] = "fén"; /* 䩿 */
dict[0x4a80] = "guǎn,ruǎn"; /* 䪀 */
dict[0x4a81] = "bǔ"; /* 䪁 */
dict[0x4a82] = "gé"; /* 䪂 */
dict[0x4a84] = "huáng"; /* 䪄 */
dict[0x4a85] = "dú"; /* 䪅 */
dict[0x4a86] = "tǐ"; /* 䪆 */
dict[0x4a87] = "bó"; /* 䪇 */
dict[0x4a88] = "qiǎn,qiàn"; /* 䪈 */
dict[0x4a89] = "là,liè"; /* 䪉 */
dict[0x4a8a] = "lóng"; /* 䪊 */
dict[0x4a8b] = "wèi"; /* 䪋 */
dict[0x4a8c] = "zhàn"; /* 䪌 */
dict[0x4a8d] = "lán,làn"; /* 䪍 */
dict[0x4a8e] = "suī"; /* 䪎 */
dict[0x4a8f] = "nà,dā"; /* 䪏 */
dict[0x4a90] = "bì,pì"; /* 䪐 */
dict[0x4a91] = "tuó"; /* 䪑 */
dict[0x4a92] = "jiào,zhì,zhù"; /* 䪒 */
dict[0x4a94] = "bǔ"; /* 䪔 */
dict[0x4a95] = "jú"; /* 䪕 */
dict[0x4a96] = "pò"; /* 䪖 */
dict[0x4a97] = "xiá"; /* 䪗 */
dict[0x4a98] = "wěi"; /* 䪘 */
dict[0x4a99] = "fú,pò"; /* 䪙 */
dict[0x4a9a] = "hè,tà"; /* 䪚 */
dict[0x4a9b] = "fán"; /* 䪛 */
dict[0x4a9c] = "chàn"; /* 䪜 */
dict[0x4a9d] = "hù"; /* 䪝 */
dict[0x4a9e] = "zá"; /* 䪞 */
dict[0x4aa2] = "jī"; /* 䪢 */
dict[0x4aa4] = "fán"; /* 䪤 */
dict[0x4aa5] = "xiè"; /* 䪥 */
dict[0x4aa6] = "hóng"; /* 䪦 */
dict[0x4aa7] = "chí"; /* 䪧 */
dict[0x4aa8] = "báo,qú"; /* 䪨 */
dict[0x4aa9] = "yín"; /* 䪩 */
dict[0x4aac] = "bó,pú"; /* 䪬 */
dict[0x4aad] = "ruǎn"; /* 䪭 */
dict[0x4aae] = "chǒu"; /* 䪮 */
dict[0x4aaf] = "yíng"; /* 䪯 */
dict[0x4ab1] = "gǎi"; /* 䪱 */
dict[0x4ab3] = "yǔn"; /* 䪳 */
dict[0x4ab4] = "zhěn"; /* 䪴 */
dict[0x4ab5] = "yǎ"; /* 䪵 */
dict[0x4ab7] = "hòu"; /* 䪷 */
dict[0x4ab8] = "mín"; /* 䪸 */
dict[0x4ab9] = "péi"; /* 䪹 */
dict[0x4aba] = "gé"; /* 䪺 */
dict[0x4abb] = "biàn"; /* 䪻 */
dict[0x4abc] = "zhuō"; /* 䪼 */
dict[0x4abd] = "hào"; /* 䪽 */
dict[0x4abe] = "mí,zhěn"; /* 䪾 */
dict[0x4abf] = "shěng,xìn"; /* 䪿 */
dict[0x4ac0] = "gěn"; /* 䫀 */
dict[0x4ac1] = "bì"; /* 䫁 */
dict[0x4ac2] = "duǒ"; /* 䫂 */
dict[0x4ac3] = "chún"; /* 䫃 */
dict[0x4ac4] = "chuà"; /* 䫄 */
dict[0x4ac5] = "sàn"; /* 䫅 */
dict[0x4ac6] = "chéng,zhèng"; /* 䫆 */
dict[0x4ac7] = "rán"; /* 䫇 */
dict[0x4ac8] = "zèn,cén"; /* 䫈 */
dict[0x4ac9] = "mào"; /* 䫉 */
dict[0x4aca] = "bó,péi"; /* 䫊 */
dict[0x4acb] = "tuí"; /* 䫋 */
dict[0x4acc] = "pǐ"; /* 䫌 */
dict[0x4acd] = "fǔ"; /* 䫍 */
dict[0x4acf] = "qī"; /* 䫏 */
dict[0x4ad0] = "lín"; /* 䫐 */
dict[0x4ad2] = "mén"; /* 䫒 */
dict[0x4ad3] = "wú"; /* 䫓 */
dict[0x4ad4] = "qì,qiè,xì"; /* 䫔 */
dict[0x4ad5] = "zhì"; /* 䫕 */
dict[0x4ad6] = "chěn,huǐ,nòu,shèn,tíng,yà,zhù"; /* 䫖 */
dict[0x4ad7] = "xiá,xià"; /* 䫗 */
dict[0x4ad8] = "hé"; /* 䫘 */
dict[0x4ad9] = "sǎng"; /* 䫙 */
dict[0x4adb] = "hóu"; /* 䫛 */
dict[0x4add] = "fǔ,fù"; /* 䫝 */
dict[0x4ade] = "ráo,qiāo"; /* 䫞 */
dict[0x4adf] = "hùn"; /* 䫟 */
dict[0x4ae0] = "péi,pī"; /* 䫠 */
dict[0x4ae1] = "qiàn,yán"; /* 䫡 */
dict[0x4ae3] = "xí"; /* 䫣 */
dict[0x4ae4] = "míng"; /* 䫤 */
dict[0x4ae5] = "kuǐ,wěi"; /* 䫥 */
dict[0x4ae6] = "gé,kài"; /* 䫦 */
dict[0x4ae8] = "ào"; /* 䫨 */
dict[0x4ae9] = "sǎn"; /* 䫩 */
dict[0x4aea] = "shuǎng"; /* 䫪 */
dict[0x4aeb] = "lóu,lòu"; /* 䫫 */
dict[0x4aec] = "zhěn"; /* 䫬 */
dict[0x4aed] = "huì"; /* 䫭 */
dict[0x4aee] = "cán,cǎn,tì"; /* 䫮 */
dict[0x4af0] = "lìn,lǐn"; /* 䫰 */
dict[0x4af1] = "ná,rú"; /* 䫱 */
dict[0x4af2] = "hàn,kǎn"; /* 䫲 */
dict[0x4af3] = "dú"; /* 䫳 */
dict[0x4af4] = "jìn"; /* 䫴 */
dict[0x4af5] = "mián"; /* 䫵 */
dict[0x4af6] = "fán"; /* 䫶 */
dict[0x4af7] = "è"; /* 䫷 */
dict[0x4af8] = "náo"; /* 䫸 */
dict[0x4af9] = "hóng"; /* 䫹 */
dict[0x4afa] = "hóng,hòu"; /* 䫺 */
dict[0x4afb] = "xué,yù"; /* 䫻 */
dict[0x4afc] = "xuè"; /* 䫼 */
dict[0x4afe] = "bī,bì"; /* 䫾 */
dict[0x4b00] = "yǒu"; /* 䬀 */
dict[0x4b01] = "yí"; /* 䬁 */
dict[0x4b02] = "xuè,yuè"; /* 䬂 */
dict[0x4b03] = "sà"; /* 䬃 */
dict[0x4b04] = "yù"; /* 䬄 */
dict[0x4b05] = "lì,liè,xié"; /* 䬅 */
dict[0x4b06] = "lì"; /* 䬆 */
dict[0x4b07] = "yuàn"; /* 䬇 */
dict[0x4b08] = "duì"; /* 䬈 */
dict[0x4b09] = "hào"; /* 䬉 */
dict[0x4b0a] = "qiè,shà"; /* 䬊 */
dict[0x4b0b] = "léng"; /* 䬋 */
dict[0x4b0d] = "hū"; /* 䬍 */
dict[0x4b0e] = "guó"; /* 䬎 */
dict[0x4b0f] = "bù,fǒu"; /* 䬏 */
dict[0x4b10] = "wěi"; /* 䬐 */
dict[0x4b11] = "wèi"; /* 䬑 */
dict[0x4b12] = "sōu"; /* 䬒 */
dict[0x4b13] = "àn,ǎng"; /* 䬓 */
dict[0x4b14] = "xù,yú"; /* 䬔 */
dict[0x4b15] = "shǎng"; /* 䬕 */
dict[0x4b16] = "héng"; /* 䬖 */
dict[0x4b17] = "yáng"; /* 䬗 */
dict[0x4b19] = "yáo"; /* 䬙 */
dict[0x4b1b] = "bì,yù"; /* 䬛 */
dict[0x4b1c] = "chī"; /* 䬜 */
dict[0x4b1d] = "héng,hòng"; /* 䬝 */
dict[0x4b1e] = "táo"; /* 䬞 */
dict[0x4b1f] = "liú"; /* 䬟 */
dict[0x4b21] = "zhù"; /* 䬡 */
dict[0x4b22] = "tāo"; /* 䬢 */
dict[0x4b23] = "qì"; /* 䬣 */
dict[0x4b24] = "cháo,zàn,zuò"; /* 䬤 */
dict[0x4b25] = "yì"; /* 䬥 */
dict[0x4b26] = "dòu"; /* 䬦 */
dict[0x4b27] = "yuán"; /* 䬧 */
dict[0x4b28] = "cù,jiù,zú"; /* 䬨 */
dict[0x4b2a] = "bó,fù"; /* 䬪 */
dict[0x4b2b] = "cǎn,tí"; /* 䬫 */
dict[0x4b2c] = "yǎng"; /* 䬬 */
dict[0x4b2e] = "yí"; /* 䬮 */
dict[0x4b2f] = "nián"; /* 䬯 */
dict[0x4b30] = "shào"; /* 䬰 */
dict[0x4b31] = "bèn"; /* 䬱 */
dict[0x4b33] = "bǎn"; /* 䬳 */
dict[0x4b34] = "mò"; /* 䬴 */
dict[0x4b35] = "ài"; /* 䬵 */
dict[0x4b36] = "èn"; /* 䬶 */
dict[0x4b37] = "shě"; /* 䬷 */
dict[0x4b39] = "zhì"; /* 䬹 */
dict[0x4b3a] = "yàng"; /* 䬺 */
dict[0x4b3b] = "jiàn,kǎn"; /* 䬻 */
dict[0x4b3c] = "yuàn"; /* 䬼 */
dict[0x4b3d] = "duì,shuì"; /* 䬽 */
dict[0x4b3e] = "tí"; /* 䬾 */
dict[0x4b3f] = "wěi,wèi"; /* 䬿 */
dict[0x4b40] = "xùn"; /* 䭀 */
dict[0x4b41] = "zhì"; /* 䭁 */
dict[0x4b42] = "yì"; /* 䭂 */
dict[0x4b43] = "rěn"; /* 䭃 */
dict[0x4b44] = "shì"; /* 䭄 */
dict[0x4b45] = "hú"; /* 䭅 */
dict[0x4b46] = "nè"; /* 䭆 */
dict[0x4b47] = "yì"; /* 䭇 */
dict[0x4b48] = "jiàn"; /* 䭈 */
dict[0x4b49] = "suǐ"; /* 䭉 */
dict[0x4b4a] = "yǐng"; /* 䭊 */
dict[0x4b4b] = "bǎo"; /* 䭋 */
dict[0x4b4c] = "hú"; /* 䭌 */
dict[0x4b4d] = "hú"; /* 䭍 */
dict[0x4b4e] = "xié,yè"; /* 䭎 */
dict[0x4b50] = "yàng"; /* 䭐 */
dict[0x4b51] = "lián,qiàn,xiàn"; /* 䭑 */
dict[0x4b53] = "èn,wèn"; /* 䭓 */
dict[0x4b55] = "jiàn,zǎn"; /* 䭕 */
dict[0x4b56] = "zhù"; /* 䭖 */
dict[0x4b57] = "yǐng"; /* 䭗 */
dict[0x4b58] = "yàn,yǐng"; /* 䭘 */
dict[0x4b59] = "jǐn"; /* 䭙 */
dict[0x4b5a] = "chuáng,nè"; /* 䭚 */
dict[0x4b5b] = "dàn"; /* 䭛 */
dict[0x4b5d] = "kuài"; /* 䭝 */
dict[0x4b5e] = "yì"; /* 䭞 */
dict[0x4b5f] = "yè"; /* 䭟 */
dict[0x4b60] = "jiǎn,qiàn"; /* 䭠 */
dict[0x4b61] = "èn,wèn"; /* 䭡 */
dict[0x4b62] = "níng"; /* 䭢 */
dict[0x4b63] = "cí"; /* 䭣 */
dict[0x4b64] = "qiǎn"; /* 䭤 */
dict[0x4b65] = "xuè,yàng,yào,zhòu"; /* 䭥 */
dict[0x4b66] = "bó"; /* 䭦 */
dict[0x4b67] = "mǐ"; /* 䭧 */
dict[0x4b68] = "shuì"; /* 䭨 */
dict[0x4b69] = "mì,mó"; /* 䭩 */
dict[0x4b6a] = "liáng"; /* 䭪 */
dict[0x4b6b] = "qǐ"; /* 䭫 */
dict[0x4b6c] = "qǐ"; /* 䭬 */
dict[0x4b6d] = "shǒu,shú,shù,tù"; /* 䭭 */
dict[0x4b6e] = "bì,fú"; /* 䭮 */
dict[0x4b6f] = "bó"; /* 䭯 */
dict[0x4b70] = "běng,bèng"; /* 䭰 */
dict[0x4b71] = "bié"; /* 䭱 */
dict[0x4b72] = "nǐ,yǐ"; /* 䭲 */
dict[0x4b73] = "wèi"; /* 䭳 */
dict[0x4b74] = "huán,yuàn"; /* 䭴 */
dict[0x4b75] = "fán"; /* 䭵 */
dict[0x4b76] = "qí"; /* 䭶 */
dict[0x4b77] = "liú,máo"; /* 䭷 */
dict[0x4b78] = "fù"; /* 䭸 */
dict[0x4b79] = "áng,àng"; /* 䭹 */
dict[0x4b7a] = "áng"; /* 䭺 */
dict[0x4b7c] = "qí"; /* 䭼 */
dict[0x4b7d] = "qún"; /* 䭽 */
dict[0x4b7e] = "tuó"; /* 䭾 */
dict[0x4b7f] = "yì"; /* 䭿 */
dict[0x4b80] = "bó"; /* 䮀 */
dict[0x4b81] = "pián"; /* 䮁 */
dict[0x4b82] = "bó"; /* 䮂 */
dict[0x4b84] = "xuán"; /* 䮄 */
dict[0x4b87] = "yù"; /* 䮇 */
dict[0x4b88] = "chí"; /* 䮈 */
dict[0x4b89] = "lú"; /* 䮉 */
dict[0x4b8a] = "yí"; /* 䮊 */
dict[0x4b8b] = "lì,liè"; /* 䮋 */
dict[0x4b8d] = "niǎo,xìng"; /* 䮍 */
dict[0x4b8e] = "xì"; /* 䮎 */
dict[0x4b8f] = "wú"; /* 䮏 */
dict[0x4b91] = "lèi"; /* 䮑 */
dict[0x4b93] = "zhào"; /* 䮓 */
dict[0x4b94] = "zuǐ,zuī"; /* 䮔 */
dict[0x4b95] = "chuò"; /* 䮕 */
dict[0x4b97] = "àn,niù,yàn"; /* 䮗 */
dict[0x4b98] = "ér,ní,pài,pó"; /* 䮘 */
dict[0x4b99] = "yù"; /* 䮙 */
dict[0x4b9a] = "lèng"; /* 䮚 */
dict[0x4b9b] = "fù"; /* 䮛 */
dict[0x4b9c] = "shà,zhá"; /* 䮜 */
dict[0x4b9d] = "huán,huǎn,hún"; /* 䮝 */
dict[0x4b9e] = "chù,chǔn"; /* 䮞 */
dict[0x4b9f] = "sǒu"; /* 䮟 */
dict[0x4ba1] = "bì"; /* 䮡 */
dict[0x4ba2] = "dié"; /* 䮢 */
dict[0x4ba4] = "dí,hè,hé"; /* 䮤 */
dict[0x4ba5] = "lì"; /* 䮥 */
dict[0x4ba7] = "hán,hàn"; /* 䮧 */
dict[0x4ba8] = "zǎi"; /* 䮨 */
dict[0x4ba9] = "gú,gǔ"; /* 䮩 */
dict[0x4baa] = "chéng"; /* 䮪 */
dict[0x4bab] = "lóu"; /* 䮫 */
dict[0x4bac] = "mò"; /* 䮬 */
dict[0x4bad] = "mì"; /* 䮭 */
dict[0x4bae] = "mài"; /* 䮮 */
dict[0x4baf] = "ào"; /* 䮯 */
dict[0x4bb0] = "zhé"; /* 䮰 */
dict[0x4bb1] = "zhú"; /* 䮱 */
dict[0x4bb2] = "huáng"; /* 䮲 */
dict[0x4bb3] = "fán"; /* 䮳 */
dict[0x4bb4] = "dèng"; /* 䮴 */
dict[0x4bb5] = "tóng,yǒng"; /* 䮵 */
dict[0x4bb7] = "dú"; /* 䮷 */
dict[0x4bb8] = "hú,mú,wò"; /* 䮸 */
dict[0x4bb9] = "wèi"; /* 䮹 */
dict[0x4bba] = "jì"; /* 䮺 */
dict[0x4bbb] = "chì,dǎo,dào,děi"; /* 䮻 */
dict[0x4bbc] = "lín"; /* 䮼 */
dict[0x4bbe] = "páng"; /* 䮾 */
dict[0x4bbf] = "jiǎn"; /* 䮿 */
dict[0x4bc0] = "niè"; /* 䯀 */
dict[0x4bc1] = "luó"; /* 䯁 */
dict[0x4bc2] = "jí,shēn"; /* 䯂 */
dict[0x4bc5] = "niè"; /* 䯅 */
dict[0x4bc6] = "yì"; /* 䯆 */
dict[0x4bc8] = "wán"; /* 䯈 */
dict[0x4bc9] = "yà,wā"; /* 䯉 */
dict[0x4bca] = "qià"; /* 䯊 */
dict[0x4bcb] = "bó"; /* 䯋 */
dict[0x4bcc] = "kāo"; /* 䯌 */
dict[0x4bcd] = "líng"; /* 䯍 */
dict[0x4bce] = "gàn"; /* 䯎 */
dict[0x4bcf] = "huó,guā"; /* 䯏 */
dict[0x4bd0] = "hái"; /* 䯐 */
dict[0x4bd2] = "héng"; /* 䯒 */
dict[0x4bd3] = "kuí"; /* 䯓 */
dict[0x4bd4] = "cén,zé"; /* 䯔 */
dict[0x4bd6] = "láng"; /* 䯖 */
dict[0x4bd7] = "bì"; /* 䯗 */
dict[0x4bd8] = "huàn"; /* 䯘 */
dict[0x4bd9] = "pò"; /* 䯙 */
dict[0x4bda] = "ǒu,yǎo"; /* 䯚 */
dict[0x4bdb] = "jiǎn,wàn"; /* 䯛 */
dict[0x4bdc] = "tì"; /* 䯜 */
dict[0x4bdd] = "suǐ"; /* 䯝 */
dict[0x4bde] = "kuā"; /* 䯞 */
dict[0x4bdf] = "duì,xiá"; /* 䯟 */
dict[0x4be0] = "ǎo,ào"; /* 䯠 */
dict[0x4be1] = "jiǎn,jiàn,qiàn"; /* 䯡 */
dict[0x4be2] = "mó,mǒ"; /* 䯢 */
dict[0x4be3] = "guì,kuì"; /* 䯣 */
dict[0x4be4] = "kuài"; /* 䯤 */
dict[0x4be5] = "àn,qì"; /* 䯥 */
dict[0x4be6] = "mà"; /* 䯦 */
dict[0x4be7] = "qǐng"; /* 䯧 */
dict[0x4be8] = "fén,hè"; /* 䯨 */
dict[0x4bea] = "kǎo"; /* 䯪 */
dict[0x4beb] = "hào,shà"; /* 䯫 */
dict[0x4bec] = "duǒ"; /* 䯬 */
dict[0x4bee] = "nái"; /* 䯮 */
dict[0x4bf0] = "jiè"; /* 䯰 */
dict[0x4bf1] = "fù,pēi,pī"; /* 䯱 */
dict[0x4bf2] = "pá"; /* 䯲 */
dict[0x4bf4] = "cháng"; /* 䯴 */
dict[0x4bf5] = "niè"; /* 䯵 */
dict[0x4bf6] = "mán"; /* 䯶 */
dict[0x4bf8] = "cì"; /* 䯸 */
dict[0x4bfa] = "kuò"; /* 䯺 */
dict[0x4bfc] = "dí"; /* 䯼 */
dict[0x4bfd] = "fǔ,póu"; /* 䯽 */
dict[0x4bfe] = "tiáo"; /* 䯾 */
dict[0x4bff] = "zú,zuó"; /* 䯿 */
dict[0x4c00] = "wǒ"; /* 䰀 */
dict[0x4c01] = "fèi"; /* 䰁 */
dict[0x4c02] = "cài"; /* 䰂 */
dict[0x4c03] = "péng"; /* 䰃 */
dict[0x4c04] = "shì"; /* 䰄 */
dict[0x4c06] = "róu"; /* 䰆 */
dict[0x4c07] = "qí"; /* 䰇 */
dict[0x4c08] = "chǎ,cuó,cuǒ"; /* 䰈 */
dict[0x4c09] = "pán,pàn"; /* 䰉 */
dict[0x4c0a] = "bó"; /* 䰊 */
dict[0x4c0b] = "mán"; /* 䰋 */
dict[0x4c0c] = "zǒng"; /* 䰌 */
dict[0x4c0d] = "cì,qī,xiū"; /* 䰍 */
dict[0x4c0e] = "guì,huǐ,kuì"; /* 䰎 */
dict[0x4c0f] = "jì"; /* 䰏 */
dict[0x4c10] = "lán"; /* 䰐 */
dict[0x4c12] = "méng"; /* 䰒 */
dict[0x4c13] = "mián"; /* 䰓 */
dict[0x4c14] = "pán"; /* 䰔 */
dict[0x4c15] = "lú"; /* 䰕 */
dict[0x4c16] = "cuán"; /* 䰖 */
dict[0x4c17] = "jiū"; /* 䰗 */
dict[0x4c18] = "liú"; /* 䰘 */
dict[0x4c19] = "yǐ"; /* 䰙 */
dict[0x4c1a] = "wén"; /* 䰚 */
dict[0x4c1b] = "lì"; /* 䰛 */
dict[0x4c1c] = "lì"; /* 䰜 */
dict[0x4c1d] = "zèng"; /* 䰝 */
dict[0x4c1e] = "zhǔ"; /* 䰞 */
dict[0x4c1f] = "hún"; /* 䰟 */
dict[0x4c20] = "shén,shēn"; /* 䰠 */
dict[0x4c21] = "chì"; /* 䰡 */
dict[0x4c22] = "xìng"; /* 䰢 */
dict[0x4c23] = "wǎng"; /* 䰣 */
dict[0x4c25] = "huò,jì,shè,yù"; /* 䰥 */
dict[0x4c26] = "pǐ,pì"; /* 䰦 */
dict[0x4c27] = "hū"; /* 䰧 */
dict[0x4c28] = "mèi"; /* 䰨 */
dict[0x4c29] = "chě,chǐ"; /* 䰩 */
dict[0x4c2a] = "mèi"; /* 䰪 */
dict[0x4c2b] = "cháo"; /* 䰫 */
dict[0x4c2c] = "jú"; /* 䰬 */
dict[0x4c2d] = "nòu,rú"; /* 䰭 */
dict[0x4c2f] = "nǐ,rán,yì"; /* 䰯 */
dict[0x4c30] = "rú"; /* 䰰 */
dict[0x4c31] = "líng"; /* 䰱 */
dict[0x4c32] = "yà"; /* 䰲 */
dict[0x4c34] = "qì,zhì"; /* 䰴 */
dict[0x4c37] = "bàng,bó"; /* 䰷 */
dict[0x4c39] = "zé"; /* 䰹 */
dict[0x4c3a] = "jiè"; /* 䰺 */
dict[0x4c3b] = "yú"; /* 䰻 */
dict[0x4c3c] = "xín,qín"; /* 䰼 */
dict[0x4c3d] = "bèi"; /* 䰽 */
dict[0x4c3e] = "bā"; /* 䰾 */
dict[0x4c3f] = "tuó"; /* 䰿 */
dict[0x4c41] = "qiáo"; /* 䱁 */
dict[0x4c42] = "yǒu"; /* 䱂 */
dict[0x4c43] = "dǐ,zhì"; /* 䱃 */
dict[0x4c44] = "jiè"; /* 䱄 */
dict[0x4c45] = "mò"; /* 䱅 */
dict[0x4c46] = "shéng"; /* 䱆 */
dict[0x4c47] = "shàn,táo"; /* 䱇 */
dict[0x4c48] = "qí,yì"; /* 䱈 */
dict[0x4c49] = "shàn"; /* 䱉 */
dict[0x4c4a] = "mǐ"; /* 䱊 */
dict[0x4c4b] = "dǎn,gǒng"; /* 䱋 */
dict[0x4c4c] = "yí"; /* 䱌 */
dict[0x4c4d] = "gèng"; /* 䱍 */
dict[0x4c4e] = "gèng"; /* 䱎 */
dict[0x4c4f] = "tǒu"; /* 䱏 */
dict[0x4c51] = "xué"; /* 䱑 */
dict[0x4c52] = "yì"; /* 䱒 */
dict[0x4c53] = "tíng"; /* 䱓 */
dict[0x4c54] = "tiáo"; /* 䱔 */
dict[0x4c55] = "móu"; /* 䱕 */
dict[0x4c56] = "liú,liǔ"; /* 䱖 */
dict[0x4c58] = "lí"; /* 䱘 */
dict[0x4c5a] = "lù"; /* 䱚 */
dict[0x4c5b] = "huò"; /* 䱛 */
dict[0x4c5c] = "cuò,què"; /* 䱜 */
dict[0x4c5d] = "bà,pái"; /* 䱝 */
dict[0x4c5e] = "liú,nài,wěi"; /* 䱞 */
dict[0x4c5f] = "jù"; /* 䱟 */
dict[0x4c60] = "zhàn"; /* 䱠 */
dict[0x4c61] = "jú"; /* 䱡 */
dict[0x4c63] = "zú"; /* 䱣 */
dict[0x4c64] = "xiàn"; /* 䱤 */
dict[0x4c65] = "zhì,jì"; /* 䱥 */
dict[0x4c68] = "zhì"; /* 䱨 */
dict[0x4c6b] = "là"; /* 䱫 */
dict[0x4c6c] = "xū"; /* 䱬 */
dict[0x4c6d] = "gèng"; /* 䱭 */
dict[0x4c6e] = "é"; /* 䱮 */
dict[0x4c6f] = "mú"; /* 䱯 */
dict[0x4c70] = "zhòng"; /* 䱰 */
dict[0x4c71] = "dì,tí"; /* 䱱 */
dict[0x4c72] = "yán"; /* 䱲 */
dict[0x4c74] = "gèng"; /* 䱴 */
dict[0x4c75] = "wēng"; /* 䱵 */
dict[0x4c76] = "láng"; /* 䱶 */
dict[0x4c77] = "yú"; /* 䱷 */
dict[0x4c78] = "qiū,sōu"; /* 䱸 */
dict[0x4c79] = "nà,zhǎ"; /* 䱹 */
dict[0x4c7a] = "hái"; /* 䱺 */
dict[0x4c7b] = "huá"; /* 䱻 */
dict[0x4c7c] = "zhǎn"; /* 䱼 */
dict[0x4c7e] = "lóu,yú"; /* 䱾 */
dict[0x4c7f] = "chàn"; /* 䱿 */
dict[0x4c80] = "dié,suì,zhì,zòu"; /* 䲀 */
dict[0x4c81] = "wèi"; /* 䲁 */
dict[0x4c82] = "xuán"; /* 䲂 */
dict[0x4c83] = "zǎo"; /* 䲃 */
dict[0x4c84] = "mín,mǐn"; /* 䲄 */
dict[0x4c85] = "guī"; /* 䲅 */
dict[0x4c8a] = "tuǒ,duò"; /* 䲊 */
dict[0x4c8b] = "cén"; /* 䲋 */
dict[0x4c8c] = "kuǎn"; /* 䲌 */
dict[0x4c8d] = "téng"; /* 䲍 */
dict[0x4c8e] = "něi"; /* 䲎 */
dict[0x4c8f] = "láo"; /* 䲏 */
dict[0x4c90] = "lǔ"; /* 䲐 */
dict[0x4c91] = "yí"; /* 䲑 */
dict[0x4c92] = "xiè"; /* 䲒 */
dict[0x4c93] = "yǎn"; /* 䲓 */
dict[0x4c94] = "qíng,qìng,jīng"; /* 䲔 */
dict[0x4c95] = "pǔ,pù"; /* 䲕 */
dict[0x4c96] = "chóu"; /* 䲖 */
dict[0x4c97] = "xián"; /* 䲗 */
dict[0x4c98] = "guǎn,kàng,wéi"; /* 䲘 */
dict[0x4c99] = "jié"; /* 䲙 */
dict[0x4c9a] = "lài,làn"; /* 䲚 */
dict[0x4c9b] = "méng"; /* 䲛 */
dict[0x4c9c] = "yè"; /* 䲜 */
dict[0x4c9e] = "lì,luǒ"; /* 䲞 */
dict[0x4c9f] = "yìn"; /* 䲟 */
dict[0x4ca1] = "qiū"; /* 䲡 */
dict[0x4ca2] = "téng"; /* 䲢 */
dict[0x4ca3] = "yú"; /* 䲣 */
dict[0x4ca6] = "chá,dài,dì,tuǒ"; /* 䲦 */
dict[0x4ca7] = "dù,shuì"; /* 䲧 */
dict[0x4ca8] = "hóng"; /* 䲨 */
dict[0x4ca9] = "shī"; /* 䲩 */
dict[0x4caa] = "xì"; /* 䲪 */
dict[0x4cac] = "qí"; /* 䲬 */
dict[0x4cae] = "yuán"; /* 䲮 */
dict[0x4caf] = "jí"; /* 䲯 */
dict[0x4cb0] = "yùn"; /* 䲰 */
dict[0x4cb1] = "fǎng"; /* 䲱 */
dict[0x4cb3] = "háng"; /* 䲳 */
dict[0x4cb4] = "zhèn"; /* 䲴 */
dict[0x4cb5] = "hù,què"; /* 䲵 */
dict[0x4cb8] = "jiè"; /* 䲸 */
dict[0x4cb9] = "péi"; /* 䲹 */
dict[0x4cba] = "gàn"; /* 䲺 */
dict[0x4cbb] = "xuán,yuán"; /* 䲻 */
dict[0x4cbd] = "dǎo,shí"; /* 䲽 */
dict[0x4cbe] = "qiǎo"; /* 䲾 */
dict[0x4cbf] = "cí"; /* 䲿 */
dict[0x4cc0] = "dié"; /* 䳀 */
dict[0x4cc1] = "bá,bǐn,bó,yuán"; /* 䳁 */
dict[0x4cc2] = "tiáo"; /* 䳂 */
dict[0x4cc3] = "wǎn"; /* 䳃 */
dict[0x4cc4] = "cí"; /* 䳄 */
dict[0x4cc5] = "zhǐ"; /* 䳅 */
dict[0x4cc6] = "bái"; /* 䳆 */
dict[0x4cc7] = "wǔ"; /* 䳇 */
dict[0x4cc8] = "bǎo"; /* 䳈 */
dict[0x4cc9] = "dōng,dàn"; /* 䳉 */
dict[0x4cca] = "bá"; /* 䳊 */
dict[0x4ccb] = "tóng,zhòng"; /* 䳋 */
dict[0x4cce] = "jiù"; /* 䳎 */
dict[0x4ccf] = "guì"; /* 䳏 */
dict[0x4cd0] = "cì"; /* 䳐 */
dict[0x4cd1] = "yǒu,yù"; /* 䳑 */
dict[0x4cd2] = "yuán"; /* 䳒 */
dict[0x4cd3] = "lǎo"; /* 䳓 */
dict[0x4cd4] = "jiù,jú"; /* 䳔 */
dict[0x4cd5] = "fóu"; /* 䳕 */
dict[0x4cd6] = "nèi,yè"; /* 䳖 */
dict[0x4cd7] = "é"; /* 䳗 */
dict[0x4cd8] = "é"; /* 䳘 */
dict[0x4cd9] = "xǐng"; /* 䳙 */
dict[0x4cda] = "hé,kǎn"; /* 䳚 */
dict[0x4cdb] = "yàn"; /* 䳛 */
dict[0x4cdc] = "tú"; /* 䳜 */
dict[0x4cdd] = "bù,diào,fǔ,pǒu"; /* 䳝 */
dict[0x4cde] = "běng"; /* 䳞 */
dict[0x4cdf] = "kòu,míng,mǒ"; /* 䳟 */
dict[0x4ce0] = "chuí,ruì,zhù"; /* 䳠 */
dict[0x4ce2] = "qí"; /* 䳢 */
dict[0x4ce3] = "yuán"; /* 䳣 */
dict[0x4ce7] = "hóu"; /* 䳧 */
dict[0x4ce8] = "huáng"; /* 䳨 */
dict[0x4cea] = "juàn,tuán"; /* 䳪 */
dict[0x4ceb] = "kuí"; /* 䳫 */
dict[0x4cec] = "è,yǎo,yì"; /* 䳬 */
dict[0x4ced] = "jí"; /* 䳭 */
dict[0x4cee] = "mò"; /* 䳮 */
dict[0x4cef] = "chóng,chǒng"; /* 䳯 */
dict[0x4cf0] = "bǎo"; /* 䳰 */
dict[0x4cf1] = "wù"; /* 䳱 */
dict[0x4cf2] = "zhèn"; /* 䳲 */
dict[0x4cf3] = "xù"; /* 䳳 */
dict[0x4cf4] = "dá,tà"; /* 䳴 */
dict[0x4cf5] = "chì"; /* 䳵 */
dict[0x4cf7] = "cóng"; /* 䳷 */
dict[0x4cf8] = "má,mái"; /* 䳸 */
dict[0x4cf9] = "kòu"; /* 䳹 */
dict[0x4cfa] = "yàn"; /* 䳺 */
dict[0x4cfb] = "cán,chán,dié,zhàn"; /* 䳻 */
dict[0x4cfc] = "ōu"; /* 䳼 */
dict[0x4cfd] = "hè"; /* 䳽 */
dict[0x4cff] = "lán,rán"; /* 䳿 */
dict[0x4d00] = "tóng"; /* 䴀 */
dict[0x4d01] = "yù"; /* 䴁 */
dict[0x4d02] = "hàng,xiàng"; /* 䴂 */
dict[0x4d03] = "náo"; /* 䴃 */
dict[0x4d04] = "lì,shùn"; /* 䴄 */
dict[0x4d05] = "fén"; /* 䴅 */
dict[0x4d06] = "pú"; /* 䴆 */
dict[0x4d07] = "líng"; /* 䴇 */
dict[0x4d08] = "ǎo"; /* 䴈 */
dict[0x4d09] = "xuán"; /* 䴉 */
dict[0x4d0a] = "yí"; /* 䴊 */
dict[0x4d0b] = "xuán"; /* 䴋 */
dict[0x4d0c] = "méng"; /* 䴌 */
dict[0x4d0e] = "lěi"; /* 䴎 */
dict[0x4d0f] = "yàn"; /* 䴏 */
dict[0x4d10] = "bǎo"; /* 䴐 */
dict[0x4d11] = "dié"; /* 䴑 */
dict[0x4d12] = "líng"; /* 䴒 */
dict[0x4d13] = "shī"; /* 䴓 */
dict[0x4d14] = "jiāo"; /* 䴔 */
dict[0x4d15] = "liè"; /* 䴕 */
dict[0x4d16] = "jīng"; /* 䴖 */
dict[0x4d17] = "jú"; /* 䴗 */
dict[0x4d18] = "tī"; /* 䴘 */
dict[0x4d19] = "pì"; /* 䴙 */
dict[0x4d1a] = "gǎng"; /* 䴚 */
dict[0x4d1b] = "jiǎo,tú,xì,xiào,yín"; /* 䴛 */
dict[0x4d1c] = "huái"; /* 䴜 */
dict[0x4d1d] = "bù,chuài"; /* 䴝 */
dict[0x4d1e] = "dí"; /* 䴞 */
dict[0x4d1f] = "huán,huàn"; /* 䴟 */
dict[0x4d20] = "yǎo"; /* 䴠 */
dict[0x4d21] = "lì"; /* 䴡 */
dict[0x4d22] = "mí"; /* 䴢 */
dict[0x4d25] = "jiā"; /* 䴥 */
dict[0x4d26] = "rén,yín"; /* 䴦 */
dict[0x4d29] = "piáo"; /* 䴩 */
dict[0x4d2a] = "lù"; /* 䴪 */
dict[0x4d2b] = "líng"; /* 䴫 */
dict[0x4d2c] = "yì"; /* 䴬 */
dict[0x4d2d] = "cái"; /* 䴭 */
dict[0x4d2e] = "shàn"; /* 䴮 */
dict[0x4d30] = "shú"; /* 䴰 */
dict[0x4d31] = "tuō"; /* 䴱 */
dict[0x4d32] = "mò"; /* 䴲 */
dict[0x4d33] = "hè,huá"; /* 䴳 */
dict[0x4d34] = "tiè,nián"; /* 䴴 */
dict[0x4d35] = "bǐng,zhuó"; /* 䴵 */
dict[0x4d36] = "péng"; /* 䴶 */
dict[0x4d37] = "hún"; /* 䴷 */
dict[0x4d39] = "guǒ"; /* 䴹 */
dict[0x4d3a] = "bù,cǎi,chàn"; /* 䴺 */
dict[0x4d3b] = "lí"; /* 䴻 */
dict[0x4d3c] = "chǎn,chàn"; /* 䴼 */
dict[0x4d3d] = "bài,pí"; /* 䴽 */
dict[0x4d3e] = "cuó,cuò,yè,zhěn,zǐ"; /* 䴾 */
dict[0x4d3f] = "méng"; /* 䴿 */
dict[0x4d40] = "suǒ"; /* 䵀 */
dict[0x4d41] = "qiàng"; /* 䵁 */
dict[0x4d42] = "zhí"; /* 䵂 */
dict[0x4d43] = "kuàng"; /* 䵃 */
dict[0x4d44] = "bí,bó,fèng,pěng"; /* 䵄 */
dict[0x4d45] = "áo"; /* 䵅 */
dict[0x4d46] = "méng"; /* 䵆 */
dict[0x4d47] = "xiàn"; /* 䵇 */
dict[0x4d48] = "kù"; /* 䵈 */
dict[0x4d49] = "tóu"; /* 䵉 */
dict[0x4d4b] = "wěi"; /* 䵋 */
dict[0x4d4c] = "xiān"; /* 䵌 */
dict[0x4d4e] = "tuān"; /* 䵎 */
dict[0x4d4f] = "lǎo"; /* 䵏 */
dict[0x4d50] = "chǎn,chàn"; /* 䵐 */
dict[0x4d51] = "nì"; /* 䵑 */
dict[0x4d52] = "nì"; /* 䵒 */
dict[0x4d53] = "lí"; /* 䵓 */
dict[0x4d54] = "dǒng"; /* 䵔 */
dict[0x4d55] = "jù"; /* 䵕 */
dict[0x4d56] = "jiàn,qiàn,xiàn"; /* 䵖 */
dict[0x4d57] = "fú,bó"; /* 䵗 */
dict[0x4d58] = "shà,shài"; /* 䵘 */
dict[0x4d59] = "zhǎ"; /* 䵙 */
dict[0x4d5a] = "tǎo"; /* 䵚 */
dict[0x4d5b] = "jiàn,xiàn"; /* 䵛 */
dict[0x4d5c] = "nǒng"; /* 䵜 */
dict[0x4d5d] = "yà,yì"; /* 䵝 */
dict[0x4d5e] = "jìng,qíng"; /* 䵞 */
dict[0x4d5f] = "gǎn"; /* 䵟 */
dict[0x4d60] = "dí"; /* 䵠 */
dict[0x4d61] = "jiǎn"; /* 䵡 */
dict[0x4d62] = "mèi,wèi"; /* 䵢 */
dict[0x4d63] = "dá,zhǎn"; /* 䵣 */
dict[0x4d64] = "jiǎn"; /* 䵤 */
dict[0x4d65] = "shè,wán,yìng,yù"; /* 䵥 */
dict[0x4d66] = "xiè"; /* 䵦 */
dict[0x4d67] = "zài"; /* 䵧 */
dict[0x4d68] = "máng"; /* 䵨 */
dict[0x4d69] = "lí"; /* 䵩 */
dict[0x4d6a] = "gùn"; /* 䵪 */
dict[0x4d6b] = "yù"; /* 䵫 */
dict[0x4d6c] = "tà"; /* 䵬 */
dict[0x4d6d] = "zhè"; /* 䵭 */
dict[0x4d6e] = "yàng"; /* 䵮 */
dict[0x4d6f] = "tuǎn"; /* 䵯 */
dict[0x4d71] = "hè,xì"; /* 䵱 */
dict[0x4d72] = "diào"; /* 䵲 */
dict[0x4d73] = "wèi"; /* 䵳 */
dict[0x4d74] = "yùn,zèng"; /* 䵴 */
dict[0x4d75] = "zhá,zhuó,chuā"; /* 䵵 */
dict[0x4d76] = "qú"; /* 䵶 */
dict[0x4d77] = "wā"; /* 䵷 */
dict[0x4d79] = "zhī"; /* 䵹 */
dict[0x4d7a] = "tǐng"; /* 䵺 */
dict[0x4d7b] = "gǔ,hú,huì"; /* 䵻 */
dict[0x4d7d] = "cà"; /* 䵽 */
dict[0x4d7e] = "fú"; /* 䵾 */
dict[0x4d7f] = "tiè"; /* 䵿 */
dict[0x4d80] = "tà"; /* 䶀 */
dict[0x4d81] = "tà"; /* 䶁 */
dict[0x4d82] = "zhuó"; /* 䶂 */
dict[0x4d83] = "hán"; /* 䶃 */
dict[0x4d84] = "píng"; /* 䶄 */
dict[0x4d85] = "hé"; /* 䶅 */
dict[0x4d87] = "zhòu"; /* 䶇 */
dict[0x4d88] = "bó"; /* 䶈 */
dict[0x4d89] = "liú"; /* 䶉 */
dict[0x4d8c] = "pào"; /* 䶌 */
dict[0x4d8d] = "dì,tì"; /* 䶍 */
dict[0x4d8e] = "shà"; /* 䶎 */
dict[0x4d8f] = "tǐ,tì"; /* 䶏 */
dict[0x4d90] = "wài,huì"; /* 䶐 */
dict[0x4d91] = "tì"; /* 䶑 */
dict[0x4d92] = "qí"; /* 䶒 */
dict[0x4d93] = "jì,qì"; /* 䶓 */
dict[0x4d94] = "chí,mín"; /* 䶔 */
dict[0x4d95] = "pá"; /* 䶕 */
dict[0x4d96] = "jìn,qín"; /* 䶖 */
dict[0x4d97] = "qiā,qiǎ,kè"; /* 䶗 */
dict[0x4d98] = "lì"; /* 䶘 */
dict[0x4d99] = "jù"; /* 䶙 */
dict[0x4d9a] = "qǔ"; /* 䶚 */
dict[0x4d9b] = "là,liè"; /* 䶛 */
dict[0x4d9c] = "gù"; /* 䶜 */
dict[0x4d9d] = "qià,xiá"; /* 䶝 */
dict[0x4d9e] = "qí"; /* 䶞 */
dict[0x4d9f] = "xiàn"; /* 䶟 */
dict[0x4da0] = "jiǎn,xián"; /* 䶠 */
dict[0x4da1] = "shí,zé,zhì"; /* 䶡 */
dict[0x4da2] = "xián,jiān"; /* 䶢 */
dict[0x4da3] = "ái"; /* 䶣 */
dict[0x4da4] = "huá"; /* 䶤 */
dict[0x4da5] = "jǔ,zhā"; /* 䶥 */
dict[0x4da6] = "zé"; /* 䶦 */
dict[0x4da7] = "yǎo"; /* 䶧 */
dict[0x4da9] = "jì"; /* 䶩 */
dict[0x4daa] = "chá"; /* 䶪 */
dict[0x4dab] = "kǎn,yán,yàn"; /* 䶫 */
dict[0x4dac] = "jiān"; /* 䶬 */
dict[0x4dae] = "yǎn"; /* 䶮 */
dict[0x4db1] = "tóng"; /* 䶱 */
dict[0x4db2] = "nán,nàn,rán"; /* 䶲 */
dict[0x4db3] = "yuè"; /* 䶳 */
dict[0x4db4] = "chuī"; /* 䶴 */
dict[0x4db5] = "chí,shǐ"; /* 䶵 */
dict[0x4e00] = "yī"; /* 一 */
dict[0x4e01] = "dīng,zhēng"; /* 丁 */
dict[0x4e02] = "kǎo,qiǎo,yú"; /* 丂 */
dict[0x4e03] = "qī"; /* 七 */
dict[0x4e04] = "shàng"; /* 丄 */
dict[0x4e05] = "xià"; /* 丅 */
dict[0x4e06] = "hǎn"; /* 丆 */
dict[0x4e07] = "wàn,mò"; /* 万 */
dict[0x4e08] = "zhàng"; /* 丈 */
dict[0x4e09] = "sān"; /* 三 */
dict[0x4e0a] = "shàng,shǎng"; /* 上 */
dict[0x4e0b] = "xià"; /* 下 */
dict[0x4e0c] = "qí,jī"; /* 丌 */
dict[0x4e0d] = "bù,fǒu"; /* 不 */
dict[0x4e0e] = "yǔ,yù,yú"; /* 与 */
dict[0x4e0f] = "miǎn"; /* 丏 */
dict[0x4e10] = "gài"; /* 丐 */
dict[0x4e11] = "chǒu"; /* 丑 */
dict[0x4e12] = "chǒu"; /* 丒 */
dict[0x4e13] = "zhuān"; /* 专 */
dict[0x4e14] = "qiě,jū"; /* 且 */
dict[0x4e15] = "pī"; /* 丕 */
dict[0x4e16] = "shì"; /* 世 */
dict[0x4e17] = "shì"; /* 丗 */
dict[0x4e18] = "qiū"; /* 丘 */
dict[0x4e19] = "bǐng"; /* 丙 */
dict[0x4e1a] = "yè"; /* 业 */
dict[0x4e1b] = "cóng"; /* 丛 */
dict[0x4e1c] = "dōng"; /* 东 */
dict[0x4e1d] = "sī"; /* 丝 */
dict[0x4e1e] = "chéng"; /* 丞 */
dict[0x4e1f] = "diū"; /* 丟 */
dict[0x4e20] = "qiū"; /* 丠 */
dict[0x4e21] = "liǎng"; /* 両 */
dict[0x4e22] = "diū"; /* 丢 */
dict[0x4e23] = "yǒu"; /* 丣 */
dict[0x4e24] = "liǎng"; /* 两 */
dict[0x4e25] = "yán"; /* 严 */
dict[0x4e26] = "bìng"; /* 並 */
dict[0x4e27] = "sāng,sàng"; /* 丧 */
dict[0x4e28] = "gǔn"; /* 丨 */
dict[0x4e29] = "jiū"; /* 丩 */
dict[0x4e2a] = "gè,gě"; /* 个 */
dict[0x4e2b] = "yā"; /* 丫 */
dict[0x4e2c] = "pán"; /* 丬 */
dict[0x4e2d] = "zhōng,zhòng"; /* 中 */
dict[0x4e2e] = "jǐ"; /* 丮 */
dict[0x4e2f] = "jiè"; /* 丯 */
dict[0x4e30] = "fēng"; /* 丰 */
dict[0x4e31] = "guàn,kuàng"; /* 丱 */
dict[0x4e32] = "chuàn"; /* 串 */
dict[0x4e33] = "chǎn"; /* 丳 */
dict[0x4e34] = "lín"; /* 临 */
dict[0x4e35] = "zhuó"; /* 丵 */
dict[0x4e36] = "zhǔ"; /* 丶 */
dict[0x4e37] = "bā"; /* 丷 */
dict[0x4e38] = "wán"; /* 丸 */
dict[0x4e39] = "dān"; /* 丹 */
dict[0x4e3a] = "wéi,wèi"; /* 为 */
dict[0x4e3b] = "zhǔ"; /* 主 */
dict[0x4e3c] = "jǐng"; /* 丼 */
dict[0x4e3d] = "lì,lí"; /* 丽 */
dict[0x4e3e] = "jǔ"; /* 举 */
dict[0x4e3f] = "piě"; /* 丿 */
dict[0x4e40] = "fú"; /* 乀 */
dict[0x4e41] = "yí,jí"; /* 乁 */
dict[0x4e42] = "yì"; /* 乂 */
dict[0x4e43] = "nǎi"; /* 乃 */
dict[0x4e44] = "wǔ"; /* 乄 */
dict[0x4e45] = "jiǔ"; /* 久 */
dict[0x4e46] = "jiǔ"; /* 乆 */
dict[0x4e47] = "tuō,zhé"; /* 乇 */
dict[0x4e48] = "mó,ma,me,yāo"; /* 么 */
dict[0x4e49] = "yì"; /* 义 */
dict[0x4e4a] = "yī"; /* 乊 */
dict[0x4e4b] = "zhī"; /* 之 */
dict[0x4e4c] = "wū"; /* 乌 */
dict[0x4e4d] = "zhà"; /* 乍 */
dict[0x4e4e] = "hū"; /* 乎 */
dict[0x4e4f] = "fá"; /* 乏 */
dict[0x4e50] = "lè,yuè,yào,lào"; /* 乐 */
dict[0x4e51] = "yín"; /* 乑 */
dict[0x4e52] = "pīng"; /* 乒 */
dict[0x4e53] = "pāng"; /* 乓 */
dict[0x4e54] = "qiáo"; /* 乔 */
dict[0x4e55] = "hǔ"; /* 乕 */
dict[0x4e56] = "guāi"; /* 乖 */
dict[0x4e57] = "chéng,shèng"; /* 乗 */
dict[0x4e58] = "chéng,shèng"; /* 乘 */
dict[0x4e59] = "yǐ"; /* 乙 */
dict[0x4e5a] = "háo,yǐ"; /* 乚 */
dict[0x4e5b] = "yǐ"; /* 乛 */
dict[0x4e5c] = "miē,niè"; /* 乜 */
dict[0x4e5d] = "jiǔ"; /* 九 */
dict[0x4e5e] = "qǐ"; /* 乞 */
dict[0x4e5f] = "yě"; /* 也 */
dict[0x4e60] = "xí"; /* 习 */
dict[0x4e61] = "xiāng"; /* 乡 */
dict[0x4e62] = "gài"; /* 乢 */
dict[0x4e63] = "jiǔ"; /* 乣 */
dict[0x4e64] = "xià"; /* 乤 */
dict[0x4e66] = "shū"; /* 书 */
dict[0x4e67] = "dǒu"; /* 乧 */
dict[0x4e68] = "shǐ"; /* 乨 */
dict[0x4e69] = "jī"; /* 乩 */
dict[0x4e6a] = "náng"; /* 乪 */
dict[0x4e6b] = "jiā"; /* 乫 */
dict[0x4e6c] = "jù"; /* 乬 */
dict[0x4e6d] = "shí"; /* 乭 */
dict[0x4e6e] = "mǎo"; /* 乮 */
dict[0x4e6f] = "hū"; /* 乯 */
dict[0x4e70] = "mǎi"; /* 买 */
dict[0x4e71] = "luàn"; /* 乱 */
dict[0x4e73] = "rǔ"; /* 乳 */
dict[0x4e74] = "xué"; /* 乴 */
dict[0x4e75] = "yǎn"; /* 乵 */
dict[0x4e76] = "fǔ"; /* 乶 */
dict[0x4e77] = "shā"; /* 乷 */
dict[0x4e78] = "nǎ"; /* 乸 */
dict[0x4e79] = "qián"; /* 乹 */
dict[0x4e7a] = "suǒ"; /* 乺 */
dict[0x4e7b] = "yú"; /* 乻 */
dict[0x4e7c] = "zhù"; /* 乼 */
dict[0x4e7d] = "zhě"; /* 乽 */
dict[0x4e7e] = "qián,gān"; /* 乾 */
dict[0x4e7f] = "zhì,luàn"; /* 乿 */
dict[0x4e80] = "guī"; /* 亀 */
dict[0x4e81] = "qián"; /* 亁 */
dict[0x4e82] = "luàn"; /* 亂 */
dict[0x4e83] = "lǐn,lìn"; /* 亃 */
dict[0x4e84] = "yì"; /* 亄 */
dict[0x4e85] = "jué"; /* 亅 */
dict[0x4e86] = "le,liǎo"; /* 了 */
dict[0x4e87] = "gè,mā"; /* 亇 */
dict[0x4e88] = "yú,yǔ"; /* 予 */
dict[0x4e89] = "zhēng"; /* 争 */
dict[0x4e8a] = "shì"; /* 亊 */
dict[0x4e8b] = "shì"; /* 事 */
dict[0x4e8c] = "èr"; /* 二 */
dict[0x4e8d] = "chù"; /* 亍 */
dict[0x4e8e] = "yú"; /* 于 */
dict[0x4e8f] = "kuī"; /* 亏 */
dict[0x4e90] = "yú"; /* 亐 */
dict[0x4e91] = "yún"; /* 云 */
dict[0x4e92] = "hù"; /* 互 */
dict[0x4e93] = "qí"; /* 亓 */
dict[0x4e94] = "wǔ"; /* 五 */
dict[0x4e95] = "jǐng"; /* 井 */
dict[0x4e96] = "sì"; /* 亖 */
dict[0x4e97] = "suì"; /* 亗 */
dict[0x4e98] = "gèn"; /* 亘 */
dict[0x4e99] = "gèn"; /* 亙 */
dict[0x4e9a] = "yà"; /* 亚 */
dict[0x4e9b] = "xiē,suò"; /* 些 */
dict[0x4e9c] = "yà"; /* 亜 */
dict[0x4e9d] = "qí,zhāi"; /* 亝 */
dict[0x4e9e] = "yā,yà"; /* 亞 */
dict[0x4e9f] = "jí,qì"; /* 亟 */
dict[0x4ea0] = "tóu"; /* 亠 */
dict[0x4ea1] = "wáng,wú"; /* 亡 */
dict[0x4ea2] = "kàng"; /* 亢 */
dict[0x4ea3] = "dà"; /* 亣 */
dict[0x4ea4] = "jiāo"; /* 交 */
dict[0x4ea5] = "hài"; /* 亥 */
dict[0x4ea6] = "yì"; /* 亦 */
dict[0x4ea7] = "chǎn"; /* 产 */
dict[0x4ea8] = "hēng,pēng"; /* 亨 */
dict[0x4ea9] = "mǔ"; /* 亩 */
dict[0x4eaa] = "ye"; /* 亪 */
dict[0x4eab] = "xiǎng"; /* 享 */
dict[0x4eac] = "jīng"; /* 京 */
dict[0x4ead] = "tíng"; /* 亭 */
dict[0x4eae] = "liàng"; /* 亮 */
dict[0x4eaf] = "xiǎng"; /* 亯 */
dict[0x4eb0] = "jīng"; /* 亰 */
dict[0x4eb1] = "yè"; /* 亱 */
dict[0x4eb2] = "qīn,qìng"; /* 亲 */
dict[0x4eb3] = "bó"; /* 亳 */
dict[0x4eb4] = "yòu"; /* 亴 */
dict[0x4eb5] = "xiè"; /* 亵 */
dict[0x4eb6] = "dǎn,dàn"; /* 亶 */
dict[0x4eb7] = "lián"; /* 亷 */
dict[0x4eb8] = "duǒ"; /* 亸 */
dict[0x4eb9] = "wěi,mén"; /* 亹 */
dict[0x4eba] = "rén"; /* 人 */
dict[0x4ebb] = "rén"; /* 亻 */
dict[0x4ebc] = "jí"; /* 亼 */
dict[0x4ebd] = "jí"; /* 亽 */
dict[0x4ebe] = "wáng"; /* 亾 */
dict[0x4ebf] = "yì"; /* 亿 */
dict[0x4ec0] = "shí,shén"; /* 什 */
dict[0x4ec1] = "rén"; /* 仁 */
dict[0x4ec2] = "lè"; /* 仂 */
dict[0x4ec3] = "dīng"; /* 仃 */
dict[0x4ec4] = "zè"; /* 仄 */
dict[0x4ec5] = "jǐn,jìn"; /* 仅 */
dict[0x4ec6] = "pū,pú"; /* 仆 */
dict[0x4ec7] = "chóu,qiú"; /* 仇 */
dict[0x4ec8] = "bā"; /* 仈 */
dict[0x4ec9] = "zhǎng"; /* 仉 */
dict[0x4eca] = "jīn"; /* 今 */
dict[0x4ecb] = "jiè"; /* 介 */
dict[0x4ecc] = "bīng"; /* 仌 */
dict[0x4ecd] = "réng"; /* 仍 */
dict[0x4ece] = "cóng,zòng"; /* 从 */
dict[0x4ecf] = "fó"; /* 仏 */
dict[0x4ed0] = "jīn,sǎn"; /* 仐 */
dict[0x4ed1] = "lún"; /* 仑 */
dict[0x4ed2] = "bīng"; /* 仒 */
dict[0x4ed3] = "cāng"; /* 仓 */
dict[0x4ed4] = "zī,zǐ,zǎi"; /* 仔 */
dict[0x4ed5] = "shì"; /* 仕 */
dict[0x4ed6] = "tā"; /* 他 */
dict[0x4ed7] = "zhàng"; /* 仗 */
dict[0x4ed8] = "fù"; /* 付 */
dict[0x4ed9] = "xiān"; /* 仙 */
dict[0x4eda] = "xiān"; /* 仚 */
dict[0x4edb] = "tuō,chà,duó"; /* 仛 */
dict[0x4edc] = "hóng"; /* 仜 */
dict[0x4edd] = "tóng"; /* 仝 */
dict[0x4ede] = "rèn"; /* 仞 */
dict[0x4edf] = "qiān"; /* 仟 */
dict[0x4ee0] = "gǎn,hàn"; /* 仠 */
dict[0x4ee1] = "yì,gē"; /* 仡 */
dict[0x4ee2] = "bó"; /* 仢 */
dict[0x4ee3] = "dài"; /* 代 */
dict[0x4ee4] = "líng,lǐng,lìng"; /* 令 */
dict[0x4ee5] = "yǐ"; /* 以 */
dict[0x4ee6] = "chào"; /* 仦 */
dict[0x4ee7] = "cháng,zhǎng"; /* 仧 */
dict[0x4ee8] = "sā"; /* 仨 */
dict[0x4ee9] = "cháng"; /* 仩 */
dict[0x4eea] = "yí"; /* 仪 */
dict[0x4eeb] = "mù"; /* 仫 */
dict[0x4eec] = "mén"; /* 们 */
dict[0x4eed] = "rèn"; /* 仭 */
dict[0x4eee] = "fǎn"; /* 仮 */
dict[0x4eef] = "chào,miǎo"; /* 仯 */
dict[0x4ef0] = "yǎng,áng"; /* 仰 */
dict[0x4ef1] = "qián"; /* 仱 */
dict[0x4ef2] = "zhòng"; /* 仲 */
dict[0x4ef3] = "pǐ,pí"; /* 仳 */
dict[0x4ef4] = "wò"; /* 仴 */
dict[0x4ef5] = "wǔ"; /* 仵 */
dict[0x4ef6] = "jiàn"; /* 件 */
dict[0x4ef7] = "jià,jiè,jie"; /* 价 */
dict[0x4ef8] = "yǎo,fó"; /* 仸 */
dict[0x4ef9] = "fēng"; /* 仹 */
dict[0x4efa] = "cāng"; /* 仺 */
dict[0x4efb] = "rèn,rén"; /* 任 */
dict[0x4efc] = "wáng"; /* 仼 */
dict[0x4efd] = "fèn,bīn"; /* 份 */
dict[0x4efe] = "dī"; /* 仾 */
dict[0x4eff] = "fǎng"; /* 仿 */
dict[0x4f00] = "zhōng"; /* 伀 */
dict[0x4f01] = "qǐ"; /* 企 */
dict[0x4f02] = "pèi"; /* 伂 */
dict[0x4f03] = "yú"; /* 伃 */
dict[0x4f04] = "diào"; /* 伄 */
dict[0x4f05] = "dùn"; /* 伅 */
dict[0x4f06] = "wěn"; /* 伆 */
dict[0x4f07] = "yì"; /* 伇 */
dict[0x4f08] = "xǐn"; /* 伈 */
dict[0x4f09] = "kàng"; /* 伉 */
dict[0x4f0a] = "yī"; /* 伊 */
dict[0x4f0b] = "jí"; /* 伋 */
dict[0x4f0c] = "ài"; /* 伌 */
dict[0x4f0d] = "wǔ"; /* 伍 */
dict[0x4f0e] = "jì,qí"; /* 伎 */
dict[0x4f0f] = "fú"; /* 伏 */
dict[0x4f10] = "fá"; /* 伐 */
dict[0x4f11] = "xiū,xǔ"; /* 休 */
dict[0x4f12] = "jìn,yín"; /* 伒 */
dict[0x4f13] = "pī"; /* 伓 */
dict[0x4f14] = "dǎn"; /* 伔 */
dict[0x4f15] = "fū"; /* 伕 */
dict[0x4f16] = "tǎng"; /* 伖 */
dict[0x4f17] = "zhòng"; /* 众 */
dict[0x4f18] = "yōu"; /* 优 */
dict[0x4f19] = "huǒ"; /* 伙 */
dict[0x4f1a] = "huì,kuài"; /* 会 */
dict[0x4f1b] = "yǔ"; /* 伛 */
dict[0x4f1c] = "cuì"; /* 伜 */
dict[0x4f1d] = "yún"; /* 伝 */
dict[0x4f1e] = "sǎn"; /* 伞 */
dict[0x4f1f] = "wěi"; /* 伟 */
dict[0x4f20] = "chuán,zhuàn"; /* 传 */
dict[0x4f21] = "chē,jū"; /* 伡 */
dict[0x4f22] = "yá"; /* 伢 */
dict[0x4f23] = "qiàn"; /* 伣 */
dict[0x4f24] = "shāng"; /* 伤 */
dict[0x4f25] = "chāng"; /* 伥 */
dict[0x4f26] = "lún"; /* 伦 */
dict[0x4f27] = "cāng,chen"; /* 伧 */
dict[0x4f28] = "xùn"; /* 伨 */
dict[0x4f29] = "xìn"; /* 伩 */
dict[0x4f2a] = "wěi"; /* 伪 */
dict[0x4f2b] = "zhù"; /* 伫 */
dict[0x4f2c] = "chǐ"; /* 伬 */
dict[0x4f2d] = "xián,xuán"; /* 伭 */
dict[0x4f2e] = "nú,nǔ"; /* 伮 */
dict[0x4f2f] = "bó,bǎi,bà"; /* 伯 */
dict[0x4f30] = "gū,gù"; /* 估 */
dict[0x4f31] = "nǐ"; /* 伱 */
dict[0x4f32] = "nǐ,nì"; /* 伲 */
dict[0x4f33] = "xiè"; /* 伳 */
dict[0x4f34] = "bàn"; /* 伴 */
dict[0x4f35] = "xù"; /* 伵 */
dict[0x4f36] = "líng"; /* 伶 */
dict[0x4f37] = "zhòu"; /* 伷 */
dict[0x4f38] = "shēn"; /* 伸 */
dict[0x4f39] = "qū"; /* 伹 */
dict[0x4f3a] = "sì,cì"; /* 伺 */
dict[0x4f3b] = "bēng"; /* 伻 */
dict[0x4f3c] = "sì,shì"; /* 似 */
dict[0x4f3d] = "qié,jiā,gā"; /* 伽 */
dict[0x4f3e] = "pī"; /* 伾 */
dict[0x4f3f] = "yì"; /* 伿 */
dict[0x4f40] = "sì"; /* 佀 */
dict[0x4f41] = "yǐ,chì"; /* 佁 */
dict[0x4f42] = "zhēng"; /* 佂 */
dict[0x4f43] = "diàn,tián"; /* 佃 */
dict[0x4f44] = "hān,gàn"; /* 佄 */
dict[0x4f45] = "mài"; /* 佅 */
dict[0x4f46] = "dàn"; /* 但 */
dict[0x4f47] = "zhù"; /* 佇 */
dict[0x4f48] = "bù"; /* 佈 */
dict[0x4f49] = "qū"; /* 佉 */
dict[0x4f4a] = "bǐ"; /* 佊 */
dict[0x4f4b] = "zhāo,shào"; /* 佋 */
dict[0x4f4c] = "cǐ"; /* 佌 */
dict[0x4f4d] = "wèi"; /* 位 */
dict[0x4f4e] = "dī"; /* 低 */
dict[0x4f4f] = "zhù"; /* 住 */
dict[0x4f50] = "zuǒ"; /* 佐 */
dict[0x4f51] = "yòu"; /* 佑 */
dict[0x4f52] = "yǎng"; /* 佒 */
dict[0x4f53] = "tǐ,tī"; /* 体 */
dict[0x4f54] = "zhàn,diān"; /* 佔 */
dict[0x4f55] = "hé,hē,hè"; /* 何 */
dict[0x4f56] = "bì"; /* 佖 */
dict[0x4f57] = "tuó"; /* 佗 */
dict[0x4f58] = "shé"; /* 佘 */
dict[0x4f59] = "yú"; /* 余 */
dict[0x4f5a] = "yì,dié"; /* 佚 */
dict[0x4f5b] = "fó,fú,bì,bó"; /* 佛 */
dict[0x4f5c] = "zuò"; /* 作 */
dict[0x4f5d] = "gōu,kòu"; /* 佝 */
dict[0x4f5e] = "nìng"; /* 佞 */
dict[0x4f5f] = "tóng"; /* 佟 */
dict[0x4f60] = "nǐ"; /* 你 */
dict[0x4f61] = "xiān"; /* 佡 */
dict[0x4f62] = "qú"; /* 佢 */
dict[0x4f63] = "yōng,yòng"; /* 佣 */
dict[0x4f64] = "wǎ"; /* 佤 */
dict[0x4f65] = "qiān"; /* 佥 */
dict[0x4f66] = "yòu"; /* 佦 */
dict[0x4f67] = "kǎ"; /* 佧 */
dict[0x4f68] = "bāo"; /* 佨 */
dict[0x4f69] = "pèi"; /* 佩 */
dict[0x4f6a] = "huí,huái"; /* 佪 */
dict[0x4f6b] = "gé"; /* 佫 */
dict[0x4f6c] = "lǎo"; /* 佬 */
dict[0x4f6d] = "xiáng"; /* 佭 */
dict[0x4f6e] = "gé"; /* 佮 */
dict[0x4f6f] = "yáng"; /* 佯 */
dict[0x4f70] = "bǎi"; /* 佰 */
dict[0x4f71] = "fǎ"; /* 佱 */
dict[0x4f72] = "mǐng"; /* 佲 */
dict[0x4f73] = "jiā"; /* 佳 */
dict[0x4f74] = "èr,nài"; /* 佴 */
dict[0x4f75] = "bìng"; /* 併 */
dict[0x4f76] = "jí"; /* 佶 */
dict[0x4f77] = "hěn"; /* 佷 */
dict[0x4f78] = "huó"; /* 佸 */
dict[0x4f79] = "guǐ"; /* 佹 */
dict[0x4f7a] = "quán"; /* 佺 */
dict[0x4f7b] = "tiāo"; /* 佻 */
dict[0x4f7c] = "jiǎo"; /* 佼 */
dict[0x4f7d] = "cì"; /* 佽 */
dict[0x4f7e] = "yì"; /* 佾 */
dict[0x4f7f] = "shǐ"; /* 使 */
dict[0x4f80] = "xíng"; /* 侀 */
dict[0x4f81] = "shēn"; /* 侁 */
dict[0x4f82] = "tuō"; /* 侂 */
dict[0x4f83] = "kǎn"; /* 侃 */
dict[0x4f84] = "zhí"; /* 侄 */
dict[0x4f85] = "gāi"; /* 侅 */
dict[0x4f86] = "lái"; /* 來 */
dict[0x4f87] = "yí"; /* 侇 */
dict[0x4f88] = "chǐ"; /* 侈 */
dict[0x4f89] = "kuǎ"; /* 侉 */
dict[0x4f8a] = "gōng"; /* 侊 */
dict[0x4f8b] = "lì"; /* 例 */
dict[0x4f8c] = "yīn"; /* 侌 */
dict[0x4f8d] = "shì"; /* 侍 */
dict[0x4f8e] = "mǐ"; /* 侎 */
dict[0x4f8f] = "zhū"; /* 侏 */
dict[0x4f90] = "xù"; /* 侐 */
dict[0x4f91] = "yòu"; /* 侑 */
dict[0x4f92] = "ān"; /* 侒 */
dict[0x4f93] = "lù"; /* 侓 */
dict[0x4f94] = "móu"; /* 侔 */
dict[0x4f95] = "ér"; /* 侕 */
dict[0x4f96] = "lún"; /* 侖 */
dict[0x4f97] = "dòng,tóng,tǒng"; /* 侗 */
dict[0x4f98] = "chà"; /* 侘 */
dict[0x4f99] = "chì"; /* 侙 */
dict[0x4f9a] = "xùn"; /* 侚 */
dict[0x4f9b] = "gōng,gòng"; /* 供 */
dict[0x4f9c] = "zhōu"; /* 侜 */
dict[0x4f9d] = "yī"; /* 依 */
dict[0x4f9e] = "rú"; /* 侞 */
dict[0x4f9f] = "cún,jiàn"; /* 侟 */
dict[0x4fa0] = "xiá"; /* 侠 */
dict[0x4fa1] = "sì"; /* 価 */
dict[0x4fa2] = "dài"; /* 侢 */
dict[0x4fa3] = "lǚ"; /* 侣 */
dict[0x4fa4] = "ta"; /* 侤 */
dict[0x4fa5] = "jiǎo,yáo"; /* 侥 */
dict[0x4fa6] = "zhēn"; /* 侦 */
dict[0x4fa7] = "cè,zè,zhāi"; /* 侧 */
dict[0x4fa8] = "qiáo"; /* 侨 */
dict[0x4fa9] = "kuài"; /* 侩 */
dict[0x4faa] = "chái"; /* 侪 */
dict[0x4fab] = "nìng"; /* 侫 */
dict[0x4fac] = "nóng"; /* 侬 */
dict[0x4fad] = "jǐn"; /* 侭 */
dict[0x4fae] = "wǔ"; /* 侮 */
dict[0x4faf] = "hóu,hòu"; /* 侯 */
dict[0x4fb0] = "jiǒng"; /* 侰 */
dict[0x4fb1] = "chěng,tǐng"; /* 侱 */
dict[0x4fb2] = "zhèn,zhēn"; /* 侲 */
dict[0x4fb3] = "zuò"; /* 侳 */
dict[0x4fb4] = "hào"; /* 侴 */
dict[0x4fb5] = "qīn"; /* 侵 */
dict[0x4fb6] = "lǚ"; /* 侶 */
dict[0x4fb7] = "jú"; /* 侷 */
dict[0x4fb8] = "shù,dōu"; /* 侸 */
dict[0x4fb9] = "tǐng"; /* 侹 */
dict[0x4fba] = "shèn"; /* 侺 */
dict[0x4fbb] = "tuó,tuì"; /* 侻 */
dict[0x4fbc] = "bó"; /* 侼 */
dict[0x4fbd] = "nán"; /* 侽 */
dict[0x4fbe] = "xiāo"; /* 侾 */
dict[0x4fbf] = "biàn,pián"; /* 便 */
dict[0x4fc0] = "tuǐ"; /* 俀 */
dict[0x4fc1] = "yǔ"; /* 俁 */
dict[0x4fc2] = "xì"; /* 係 */
dict[0x4fc3] = "cù"; /* 促 */
dict[0x4fc4] = "é"; /* 俄 */
dict[0x4fc5] = "qiú"; /* 俅 */
dict[0x4fc6] = "xú"; /* 俆 */
dict[0x4fc7] = "guàng"; /* 俇 */
dict[0x4fc8] = "kù"; /* 俈 */
dict[0x4fc9] = "wù"; /* 俉 */
dict[0x4fca] = "jùn"; /* 俊 */
dict[0x4fcb] = "yì"; /* 俋 */
dict[0x4fcc] = "fǔ"; /* 俌 */
dict[0x4fcd] = "liáng"; /* 俍 */
dict[0x4fce] = "zǔ"; /* 俎 */
dict[0x4fcf] = "qiào,xiào"; /* 俏 */
dict[0x4fd0] = "lì"; /* 俐 */
dict[0x4fd1] = "yǒng"; /* 俑 */
dict[0x4fd2] = "hùn"; /* 俒 */
dict[0x4fd3] = "jìng"; /* 俓 */
dict[0x4fd4] = "qiàn"; /* 俔 */
dict[0x4fd5] = "sàn"; /* 俕 */
dict[0x4fd6] = "pěi"; /* 俖 */
dict[0x4fd7] = "sú"; /* 俗 */
dict[0x4fd8] = "fú"; /* 俘 */
dict[0x4fd9] = "xī"; /* 俙 */
dict[0x4fda] = "lǐ"; /* 俚 */
dict[0x4fdb] = "fǔ"; /* 俛 */
dict[0x4fdc] = "pīng"; /* 俜 */
dict[0x4fdd] = "bǎo"; /* 保 */
dict[0x4fde] = "yú,yù,shù"; /* 俞 */
dict[0x4fdf] = "sì,qí"; /* 俟 */
dict[0x4fe0] = "xiá"; /* 俠 */
dict[0x4fe1] = "xìn,shēn"; /* 信 */
dict[0x4fe2] = "xiū"; /* 俢 */
dict[0x4fe3] = "yǔ"; /* 俣 */
dict[0x4fe4] = "dì"; /* 俤 */
dict[0x4fe5] = "chē,jū"; /* 俥 */
dict[0x4fe6] = "chóu"; /* 俦 */
dict[0x4fe7] = "zhì"; /* 俧 */
dict[0x4fe8] = "yǎn"; /* 俨 */
dict[0x4fe9] = "liǎng,liǎ"; /* 俩 */
dict[0x4fea] = "lì"; /* 俪 */
dict[0x4feb] = "lái"; /* 俫 */
dict[0x4fec] = "sī"; /* 俬 */
dict[0x4fed] = "jiǎn"; /* 俭 */
dict[0x4fee] = "xiū"; /* 修 */
dict[0x4fef] = "fǔ"; /* 俯 */
dict[0x4ff0] = "huò"; /* 俰 */
dict[0x4ff1] = "jù"; /* 俱 */
dict[0x4ff2] = "xiào"; /* 俲 */
dict[0x4ff3] = "pái"; /* 俳 */
dict[0x4ff4] = "jiàn"; /* 俴 */
dict[0x4ff5] = "biào"; /* 俵 */
dict[0x4ff6] = "chù,tì"; /* 俶 */
dict[0x4ff7] = "fèi"; /* 俷 */
dict[0x4ff8] = "fèng"; /* 俸 */
dict[0x4ff9] = "yà"; /* 俹 */
dict[0x4ffa] = "ǎn"; /* 俺 */
dict[0x4ffb] = "bèi"; /* 俻 */
dict[0x4ffc] = "yù"; /* 俼 */
dict[0x4ffd] = "xīn"; /* 俽 */
dict[0x4ffe] = "bǐ"; /* 俾 */
dict[0x4fff] = "hǔ,chí"; /* 俿 */
dict[0x5000] = "chāng"; /* 倀 */
dict[0x5001] = "zhī"; /* 倁 */
dict[0x5002] = "bìng"; /* 倂 */
dict[0x5003] = "jiù"; /* 倃 */
dict[0x5004] = "yáo"; /* 倄 */
dict[0x5005] = "cuì,zú"; /* 倅 */
dict[0x5006] = "liǎng,liǎ"; /* 倆 */
dict[0x5007] = "wǎn"; /* 倇 */
dict[0x5008] = "lái"; /* 倈 */
dict[0x5009] = "cāng"; /* 倉 */
dict[0x500a] = "zǒng"; /* 倊 */
dict[0x500b] = "gè,gě"; /* 個 */
dict[0x500c] = "guān"; /* 倌 */
dict[0x500d] = "bèi"; /* 倍 */
dict[0x500e] = "tiǎn"; /* 倎 */
dict[0x500f] = "shū"; /* 倏 */
dict[0x5010] = "shū"; /* 倐 */
dict[0x5011] = "mén"; /* 們 */
dict[0x5012] = "dǎo,dào"; /* 倒 */
dict[0x5013] = "tán,tàn"; /* 倓 */
dict[0x5014] = "jué,juè"; /* 倔 */
dict[0x5015] = "chuí"; /* 倕 */
dict[0x5016] = "xìng"; /* 倖 */
dict[0x5017] = "péng"; /* 倗 */
dict[0x5018] = "tǎng,cháng"; /* 倘 */
dict[0x5019] = "hòu"; /* 候 */
dict[0x501a] = "yǐ"; /* 倚 */
dict[0x501b] = "qī"; /* 倛 */
dict[0x501c] = "tì"; /* 倜 */
dict[0x501d] = "gàn"; /* 倝 */
dict[0x501e] = "liàng,jìng"; /* 倞 */
dict[0x501f] = "jiè"; /* 借 */
dict[0x5020] = "suī"; /* 倠 */
dict[0x5021] = "chàng,chāng"; /* 倡 */
dict[0x5022] = "jié"; /* 倢 */
dict[0x5023] = "fǎng"; /* 倣 */
dict[0x5024] = "zhí"; /* 値 */
dict[0x5025] = "kōng,kǒng"; /* 倥 */
dict[0x5026] = "juàn"; /* 倦 */
dict[0x5027] = "zōng"; /* 倧 */
dict[0x5028] = "jù"; /* 倨 */
dict[0x5029] = "qiàn"; /* 倩 */
dict[0x502a] = "ní"; /* 倪 */
dict[0x502b] = "lún"; /* 倫 */
dict[0x502c] = "zhuō"; /* 倬 */
dict[0x502d] = "wō,wēi"; /* 倭 */
dict[0x502e] = "luǒ"; /* 倮 */
dict[0x502f] = "sōng"; /* 倯 */
dict[0x5030] = "lèng"; /* 倰 */
dict[0x5031] = "hùn"; /* 倱 */
dict[0x5032] = "dōng"; /* 倲 */
dict[0x5033] = "zì"; /* 倳 */
dict[0x5034] = "bèn"; /* 倴 */
dict[0x5035] = "wǔ"; /* 倵 */
dict[0x5036] = "jù"; /* 倶 */
dict[0x5037] = "nǎi"; /* 倷 */
dict[0x5038] = "cǎi"; /* 倸 */
dict[0x5039] = "jiǎn"; /* 倹 */
dict[0x503a] = "zhài"; /* 债 */
dict[0x503b] = "yē"; /* 倻 */
dict[0x503c] = "zhí"; /* 值 */
dict[0x503d] = "shà"; /* 倽 */
dict[0x503e] = "qīng"; /* 倾 */
dict[0x503f] = "nìng"; /* 倿 */
dict[0x5040] = "yīng"; /* 偀 */
dict[0x5041] = "chēng,chèn"; /* 偁 */
dict[0x5042] = "qián"; /* 偂 */
dict[0x5043] = "yǎn"; /* 偃 */
dict[0x5044] = "ruǎn"; /* 偄 */
dict[0x5045] = "zhòng,tóng"; /* 偅 */
dict[0x5046] = "chǔn"; /* 偆 */
dict[0x5047] = "jiǎ,jià"; /* 假 */
dict[0x5048] = "jì,jié"; /* 偈 */
dict[0x5049] = "wěi"; /* 偉 */
dict[0x504a] = "yǔ"; /* 偊 */
dict[0x504b] = "bǐng,bìng"; /* 偋 */
dict[0x504c] = "ruò"; /* 偌 */
dict[0x504d] = "tí"; /* 偍 */
dict[0x504e] = "wēi"; /* 偎 */
dict[0x504f] = "piān"; /* 偏 */
dict[0x5050] = "yàn"; /* 偐 */
dict[0x5051] = "fēng"; /* 偑 */
dict[0x5052] = "tǎng,dàng"; /* 偒 */
dict[0x5053] = "wò"; /* 偓 */
dict[0x5054] = "è"; /* 偔 */
dict[0x5055] = "xié"; /* 偕 */
dict[0x5056] = "chě"; /* 偖 */
dict[0x5057] = "shěng"; /* 偗 */
dict[0x5058] = "kǎn"; /* 偘 */
dict[0x5059] = "dì"; /* 偙 */
dict[0x505a] = "zuò"; /* 做 */
dict[0x505b] = "chā"; /* 偛 */
dict[0x505c] = "tíng"; /* 停 */
dict[0x505d] = "bèi"; /* 偝 */
dict[0x505e] = "xiè"; /* 偞 */
dict[0x505f] = "huáng"; /* 偟 */
dict[0x5060] = "yǎo"; /* 偠 */
dict[0x5061] = "zhàn"; /* 偡 */
dict[0x5062] = "chǒu,qiào"; /* 偢 */
dict[0x5063] = "ān"; /* 偣 */
dict[0x5064] = "yóu"; /* 偤 */
dict[0x5065] = "jiàn"; /* 健 */
dict[0x5066] = "xū"; /* 偦 */
dict[0x5067] = "zhā"; /* 偧 */
dict[0x5068] = "cī"; /* 偨 */
dict[0x5069] = "fù"; /* 偩 */
dict[0x506a] = "bī"; /* 偪 */
dict[0x506b] = "zhì"; /* 偫 */
dict[0x506c] = "zǒng"; /* 偬 */
dict[0x506d] = "miǎn"; /* 偭 */
dict[0x506e] = "jí"; /* 偮 */
dict[0x506f] = "yǐ"; /* 偯 */
dict[0x5070] = "xiè"; /* 偰 */
dict[0x5071] = "xún"; /* 偱 */
dict[0x5072] = "cāi,sī"; /* 偲 */
dict[0x5073] = "duān"; /* 偳 */
dict[0x5074] = "cè,zè,zhāi"; /* 側 */
dict[0x5075] = "zhēn"; /* 偵 */
dict[0x5076] = "ǒu"; /* 偶 */
dict[0x5077] = "tōu"; /* 偷 */
dict[0x5078] = "tōu"; /* 偸 */
dict[0x5079] = "bèi"; /* 偹 */
dict[0x507a] = "zán,zá,zǎ"; /* 偺 */
dict[0x507b] = "lǚ,lóu"; /* 偻 */
dict[0x507c] = "jié"; /* 偼 */
dict[0x507d] = "wěi"; /* 偽 */
dict[0x507e] = "fèn"; /* 偾 */
dict[0x507f] = "cháng"; /* 偿 */
dict[0x5080] = "kuǐ,guī"; /* 傀 */
dict[0x5081] = "sǒu"; /* 傁 */
dict[0x5082] = "zhì,sī"; /* 傂 */
dict[0x5083] = "sù"; /* 傃 */
dict[0x5084] = "xiā"; /* 傄 */
dict[0x5085] = "fù"; /* 傅 */
dict[0x5086] = "yuàn,yuán"; /* 傆 */
dict[0x5087] = "rǒng"; /* 傇 */
dict[0x5088] = "lì"; /* 傈 */
dict[0x5089] = "nù"; /* 傉 */
dict[0x508a] = "yùn"; /* 傊 */
dict[0x508b] = "jiǎng,gòu"; /* 傋 */
dict[0x508c] = "mà"; /* 傌 */
dict[0x508d] = "bàng"; /* 傍 */
dict[0x508e] = "diān"; /* 傎 */
dict[0x508f] = "táng"; /* 傏 */
dict[0x5090] = "hào"; /* 傐 */
dict[0x5091] = "jié"; /* 傑 */
dict[0x5092] = "xī,xì"; /* 傒 */
dict[0x5093] = "shān"; /* 傓 */
dict[0x5094] = "qiàn,jiān"; /* 傔 */
dict[0x5095] = "què,jué"; /* 傕 */
dict[0x5096] = "cāng,chen"; /* 傖 */
dict[0x5097] = "chù"; /* 傗 */
dict[0x5098] = "sǎn"; /* 傘 */
dict[0x5099] = "bèi"; /* 備 */
dict[0x509a] = "xiào"; /* 傚 */
dict[0x509b] = "róng"; /* 傛 */
dict[0x509c] = "yáo"; /* 傜 */
dict[0x509d] = "tà,tàn"; /* 傝 */
dict[0x509e] = "suō"; /* 傞 */
dict[0x509f] = "yǎng"; /* 傟 */
dict[0x50a0] = "fá"; /* 傠 */
dict[0x50a1] = "bìng"; /* 傡 */
dict[0x50a2] = "jiā"; /* 傢 */
dict[0x50a3] = "dǎi"; /* 傣 */
dict[0x50a4] = "zài"; /* 傤 */
dict[0x50a5] = "tǎng"; /* 傥 */
dict[0x50a6] = "gǔ"; /* 傦 */
dict[0x50a7] = "bīn"; /* 傧 */
dict[0x50a8] = "chǔ"; /* 储 */
dict[0x50a9] = "nuó"; /* 傩 */
dict[0x50aa] = "cān,càn"; /* 傪 */
dict[0x50ab] = "lěi"; /* 傫 */
dict[0x50ac] = "cuī"; /* 催 */
dict[0x50ad] = "yōng"; /* 傭 */
dict[0x50ae] = "zāo,cáo"; /* 傮 */
dict[0x50af] = "zǒng"; /* 傯 */
dict[0x50b0] = "péng"; /* 傰 */
dict[0x50b1] = "sǒng"; /* 傱 */
dict[0x50b2] = "ào"; /* 傲 */
dict[0x50b3] = "chuán,zhuàn"; /* 傳 */
dict[0x50b4] = "yǔ"; /* 傴 */
dict[0x50b5] = "zhài"; /* 債 */
dict[0x50b6] = "qī,còu"; /* 傶 */
dict[0x50b7] = "shāng"; /* 傷 */
dict[0x50b8] = "chuǎng"; /* 傸 */
dict[0x50b9] = "jìng"; /* 傹 */
dict[0x50ba] = "chì"; /* 傺 */
dict[0x50bb] = "shǎ"; /* 傻 */
dict[0x50bc] = "hàn"; /* 傼 */
dict[0x50bd] = "zhāng"; /* 傽 */
dict[0x50be] = "qīng"; /* 傾 */
dict[0x50bf] = "yān,yàn"; /* 傿 */
dict[0x50c0] = "dì"; /* 僀 */
dict[0x50c1] = "xiè"; /* 僁 */
dict[0x50c2] = "lǚ,lóu"; /* 僂 */
dict[0x50c3] = "bèi"; /* 僃 */
dict[0x50c4] = "piào,biāo"; /* 僄 */
dict[0x50c5] = "jǐn,jìn"; /* 僅 */
dict[0x50c6] = "liàn"; /* 僆 */
dict[0x50c7] = "lù"; /* 僇 */
dict[0x50c8] = "màn"; /* 僈 */
dict[0x50c9] = "qiān"; /* 僉 */
dict[0x50ca] = "xiān"; /* 僊 */
dict[0x50cb] = "tǎn,tàn"; /* 僋 */
dict[0x50cc] = "yíng"; /* 僌 */
dict[0x50cd] = "dòng"; /* 働 */
dict[0x50ce] = "zhuàn"; /* 僎 */
dict[0x50cf] = "xiàng"; /* 像 */
dict[0x50d0] = "shàn"; /* 僐 */
dict[0x50d1] = "qiáo"; /* 僑 */
dict[0x50d2] = "jiǒng"; /* 僒 */
dict[0x50d3] = "tuǐ,tuí"; /* 僓 */
dict[0x50d4] = "zǔn"; /* 僔 */
dict[0x50d5] = "pú"; /* 僕 */
dict[0x50d6] = "xī"; /* 僖 */
dict[0x50d7] = "láo"; /* 僗 */
dict[0x50d8] = "chǎng"; /* 僘 */
dict[0x50d9] = "guāng"; /* 僙 */
dict[0x50da] = "liáo"; /* 僚 */
dict[0x50db] = "qī"; /* 僛 */
dict[0x50dc] = "chēng,dēng"; /* 僜 */
dict[0x50dd] = "zhàn,zhuàn,chán"; /* 僝 */
dict[0x50de] = "wěi"; /* 僞 */
dict[0x50df] = "jī"; /* 僟 */
dict[0x50e0] = "bō"; /* 僠 */
dict[0x50e1] = "huì"; /* 僡 */
dict[0x50e2] = "chuǎn"; /* 僢 */
dict[0x50e3] = "tiě,jiàn"; /* 僣 */
dict[0x50e4] = "dàn"; /* 僤 */
dict[0x50e5] = "jiǎo,yáo"; /* 僥 */
dict[0x50e6] = "jiù"; /* 僦 */
dict[0x50e7] = "sēng"; /* 僧 */
dict[0x50e8] = "fèn"; /* 僨 */
dict[0x50e9] = "xiàn"; /* 僩 */
dict[0x50ea] = "yù,jú"; /* 僪 */
dict[0x50eb] = "è,wù,wū"; /* 僫 */
dict[0x50ec] = "jiāo"; /* 僬 */
dict[0x50ed] = "jiàn"; /* 僭 */
dict[0x50ee] = "tóng,zhuàng"; /* 僮 */
dict[0x50ef] = "lǐn"; /* 僯 */
dict[0x50f0] = "bó"; /* 僰 */
dict[0x50f1] = "gù"; /* 僱 */
dict[0x50f2] = "xiān"; /* 僲 */
dict[0x50f3] = "sù"; /* 僳 */
dict[0x50f4] = "xiàn"; /* 僴 */
dict[0x50f5] = "jiāng"; /* 僵 */
dict[0x50f6] = "mǐn"; /* 僶 */
dict[0x50f7] = "yè"; /* 僷 */
dict[0x50f8] = "jìn"; /* 僸 */
dict[0x50f9] = "jià,jie"; /* 價 */
dict[0x50fa] = "qiào"; /* 僺 */
dict[0x50fb] = "pì"; /* 僻 */
dict[0x50fc] = "fēng"; /* 僼 */
dict[0x50fd] = "zhòu"; /* 僽 */
dict[0x50fe] = "ài"; /* 僾 */
dict[0x50ff] = "sài"; /* 僿 */
dict[0x5100] = "yí"; /* 儀 */
dict[0x5101] = "jùn"; /* 儁 */
dict[0x5102] = "nóng"; /* 儂 */
dict[0x5103] = "chán,tǎn,shàn"; /* 儃 */
dict[0x5104] = "yì"; /* 億 */
dict[0x5105] = "dāng,dàng"; /* 儅 */
dict[0x5106] = "jǐng"; /* 儆 */
dict[0x5107] = "xuān"; /* 儇 */
dict[0x5108] = "kuài"; /* 儈 */
dict[0x5109] = "jiǎn"; /* 儉 */
dict[0x510a] = "chù"; /* 儊 */
dict[0x510b] = "dān,dàn"; /* 儋 */
dict[0x510c] = "jiǎo"; /* 儌 */
dict[0x510d] = "shǎ"; /* 儍 */
dict[0x510e] = "zài"; /* 儎 */
dict[0x510f] = "càn"; /* 儏 */
dict[0x5110] = "bīn,bìn"; /* 儐 */
dict[0x5111] = "án,àn"; /* 儑 */
dict[0x5112] = "rú"; /* 儒 */
dict[0x5113] = "tái"; /* 儓 */
dict[0x5114] = "chóu"; /* 儔 */
dict[0x5115] = "chái"; /* 儕 */
dict[0x5116] = "lán"; /* 儖 */
dict[0x5117] = "nǐ,yì"; /* 儗 */
dict[0x5118] = "jǐn"; /* 儘 */
dict[0x5119] = "qiàn"; /* 儙 */
dict[0x511a] = "méng"; /* 儚 */
dict[0x511b] = "wǔ"; /* 儛 */
dict[0x511c] = "níng"; /* 儜 */
dict[0x511d] = "qióng"; /* 儝 */
dict[0x511e] = "nǐ"; /* 儞 */
dict[0x511f] = "cháng"; /* 償 */
dict[0x5120] = "liè"; /* 儠 */
dict[0x5121] = "lěi"; /* 儡 */
dict[0x5122] = "lǚ"; /* 儢 */
dict[0x5123] = "kuǎng"; /* 儣 */
dict[0x5124] = "bào"; /* 儤 */
dict[0x5125] = "yù"; /* 儥 */
dict[0x5126] = "biāo"; /* 儦 */
dict[0x5127] = "zǎn"; /* 儧 */
dict[0x5128] = "zhì"; /* 儨 */
dict[0x5129] = "sì"; /* 儩 */
dict[0x512a] = "yōu"; /* 優 */
dict[0x512b] = "háo"; /* 儫 */
dict[0x512c] = "qìng"; /* 儬 */
dict[0x512d] = "chèn"; /* 儭 */
dict[0x512e] = "lì"; /* 儮 */
dict[0x512f] = "téng"; /* 儯 */
dict[0x5130] = "wěi"; /* 儰 */
dict[0x5131] = "lǒng,lóng,lòng"; /* 儱 */
dict[0x5132] = "chǔ"; /* 儲 */
dict[0x5133] = "chán,chàn"; /* 儳 */
dict[0x5134] = "ráng,xiāng"; /* 儴 */
dict[0x5135] = "shū"; /* 儵 */
dict[0x5136] = "huì,xié"; /* 儶 */
dict[0x5137] = "lì"; /* 儷 */
dict[0x5138] = "luó"; /* 儸 */
dict[0x5139] = "zǎn"; /* 儹 */
dict[0x513a] = "nuó"; /* 儺 */
dict[0x513b] = "tǎng"; /* 儻 */
dict[0x513c] = "yǎn"; /* 儼 */
dict[0x513d] = "léi"; /* 儽 */
dict[0x513e] = "nàng,nāng"; /* 儾 */
dict[0x513f] = "ér"; /* 儿 */
dict[0x5140] = "wù"; /* 兀 */
dict[0x5141] = "yǔn"; /* 允 */
dict[0x5142] = "zān"; /* 兂 */
dict[0x5143] = "yuán"; /* 元 */
dict[0x5144] = "xiōng"; /* 兄 */
dict[0x5145] = "chōng"; /* 充 */
dict[0x5146] = "zhào"; /* 兆 */
dict[0x5147] = "xiōng"; /* 兇 */
dict[0x5148] = "xiān"; /* 先 */
dict[0x5149] = "guāng"; /* 光 */
dict[0x514a] = "duì,ruì,yuè"; /* 兊 */
dict[0x514b] = "kè"; /* 克 */
dict[0x514c] = "duì,ruì,yuè"; /* 兌 */
dict[0x514d] = "miǎn"; /* 免 */
dict[0x514e] = "tù"; /* 兎 */
dict[0x514f] = "cháng,zhǎng"; /* 兏 */
dict[0x5150] = "ér"; /* 児 */
dict[0x5151] = "duì,ruì,yuè"; /* 兑 */
dict[0x5152] = "ér"; /* 兒 */
dict[0x5153] = "qīn"; /* 兓 */
dict[0x5154] = "tù"; /* 兔 */
dict[0x5155] = "sì"; /* 兕 */
dict[0x5156] = "yǎn"; /* 兖 */
dict[0x5157] = "yǎn"; /* 兗 */
dict[0x5158] = "shǐ"; /* 兘 */
dict[0x515a] = "dǎng"; /* 党 */
dict[0x515c] = "dōu"; /* 兜 */
dict[0x515f] = "shēn"; /* 兟 */
dict[0x5160] = "dōu"; /* 兠 */
dict[0x5162] = "jīng"; /* 兢 */
dict[0x5164] = "huǎng"; /* 兤 */
dict[0x5165] = "rù"; /* 入 */
dict[0x5166] = "wáng"; /* 兦 */
dict[0x5167] = "nèi"; /* 內 */
dict[0x5168] = "quán"; /* 全 */
dict[0x5169] = "liǎng"; /* 兩 */
dict[0x516a] = "yú,shù"; /* 兪 */
dict[0x516b] = "bā"; /* 八 */
dict[0x516c] = "gōng"; /* 公 */
dict[0x516d] = "liù,lù"; /* 六 */
dict[0x516e] = "xī"; /* 兮 */
dict[0x516f] = "han"; /* 兯 */
dict[0x5170] = "lán"; /* 兰 */
dict[0x5171] = "gòng,gōng"; /* 共 */
dict[0x5172] = "tiān"; /* 兲 */
dict[0x5173] = "guān"; /* 关 */
dict[0x5174] = "xīng,xìng"; /* 兴 */
dict[0x5175] = "bīng"; /* 兵 */
dict[0x5176] = "qí,jī"; /* 其 */
dict[0x5177] = "jù"; /* 具 */
dict[0x5178] = "diǎn"; /* 典 */
dict[0x5179] = "zī,cí"; /* 兹 */
dict[0x517b] = "yǎng"; /* 养 */
dict[0x517c] = "jiān"; /* 兼 */
dict[0x517d] = "shòu"; /* 兽 */
dict[0x517e] = "jì"; /* 兾 */
dict[0x517f] = "yì"; /* 兿 */
dict[0x5180] = "jì"; /* 冀 */
dict[0x5181] = "chǎn"; /* 冁 */
dict[0x5182] = "jiōng"; /* 冂 */
dict[0x5183] = "mào"; /* 冃 */
dict[0x5184] = "rǎn"; /* 冄 */
dict[0x5185] = "nèi,nà"; /* 内 */
dict[0x5186] = "yuán"; /* 円 */
dict[0x5187] = "mǎo"; /* 冇 */
dict[0x5188] = "gāng"; /* 冈 */
dict[0x5189] = "rǎn"; /* 冉 */
dict[0x518a] = "cè"; /* 冊 */
dict[0x518b] = "jiōng"; /* 冋 */
dict[0x518c] = "cè"; /* 册 */
dict[0x518d] = "zài"; /* 再 */
dict[0x518e] = "guǎ"; /* 冎 */
dict[0x518f] = "jiǒng"; /* 冏 */
dict[0x5190] = "mào"; /* 冐 */
dict[0x5191] = "zhòu"; /* 冑 */
dict[0x5192] = "mào,mò"; /* 冒 */
dict[0x5193] = "gòu"; /* 冓 */
dict[0x5194] = "xú"; /* 冔 */
dict[0x5195] = "miǎn"; /* 冕 */
dict[0x5196] = "mì"; /* 冖 */
dict[0x5197] = "rǒng"; /* 冗 */
dict[0x5198] = "yín,yóu"; /* 冘 */
dict[0x5199] = "xiě"; /* 写 */
dict[0x519a] = "kǎn"; /* 冚 */
dict[0x519b] = "jūn"; /* 军 */
dict[0x519c] = "nóng"; /* 农 */
dict[0x519d] = "yí"; /* 冝 */
dict[0x519e] = "mí"; /* 冞 */
dict[0x519f] = "shì"; /* 冟 */
dict[0x51a0] = "guān,guàn"; /* 冠 */
dict[0x51a1] = "měng"; /* 冡 */
dict[0x51a2] = "zhǒng"; /* 冢 */
dict[0x51a3] = "zuì"; /* 冣 */
dict[0x51a4] = "yuān"; /* 冤 */
dict[0x51a5] = "míng"; /* 冥 */
dict[0x51a6] = "kòu"; /* 冦 */
dict[0x51a7] = "lín"; /* 冧 */
dict[0x51a8] = "fù"; /* 冨 */
dict[0x51a9] = "xiě"; /* 冩 */
dict[0x51aa] = "mì"; /* 冪 */
dict[0x51ab] = "bīng"; /* 冫 */
dict[0x51ac] = "dōng"; /* 冬 */
dict[0x51ad] = "tài"; /* 冭 */
dict[0x51ae] = "gāng"; /* 冮 */
dict[0x51af] = "féng,píng"; /* 冯 */
dict[0x51b0] = "bīng"; /* 冰 */
dict[0x51b1] = "hù"; /* 冱 */
dict[0x51b2] = "chōng,chòng"; /* 冲 */
dict[0x51b3] = "jué"; /* 决 */
dict[0x51b4] = "yà"; /* 冴 */
dict[0x51b5] = "kuàng"; /* 况 */
dict[0x51b6] = "yě"; /* 冶 */
dict[0x51b7] = "lěng"; /* 冷 */
dict[0x51b8] = "pàn"; /* 冸 */
dict[0x51b9] = "fā"; /* 冹 */
dict[0x51ba] = "mǐn"; /* 冺 */
dict[0x51bb] = "dòng"; /* 冻 */
dict[0x51bc] = "xiǎn"; /* 冼 */
dict[0x51bd] = "liè"; /* 冽 */
dict[0x51be] = "qià"; /* 冾 */
dict[0x51bf] = "jiān"; /* 冿 */
dict[0x51c0] = "jìng,chēng"; /* 净 */
dict[0x51c1] = "sōu"; /* 凁 */
dict[0x51c2] = "měi"; /* 凂 */
dict[0x51c3] = "tú"; /* 凃 */
dict[0x51c4] = "qī"; /* 凄 */
dict[0x51c5] = "gù"; /* 凅 */
dict[0x51c6] = "zhǔn"; /* 准 */
dict[0x51c7] = "sōng"; /* 凇 */
dict[0x51c8] = "jìng,chēng"; /* 凈 */
dict[0x51c9] = "liáng,liàng"; /* 凉 */
dict[0x51ca] = "qìng"; /* 凊 */
dict[0x51cb] = "diāo"; /* 凋 */
dict[0x51cc] = "líng"; /* 凌 */
dict[0x51cd] = "dòng"; /* 凍 */
dict[0x51ce] = "gàn"; /* 凎 */
dict[0x51cf] = "jiǎn"; /* 减 */
dict[0x51d0] = "yīn"; /* 凐 */
dict[0x51d1] = "còu"; /* 凑 */
dict[0x51d2] = "ái"; /* 凒 */
dict[0x51d3] = "lì"; /* 凓 */
dict[0x51d4] = "cāng"; /* 凔 */
dict[0x51d5] = "mǐng"; /* 凕 */
dict[0x51d6] = "zhǔn"; /* 凖 */
dict[0x51d7] = "cuī"; /* 凗 */
dict[0x51d8] = "sī"; /* 凘 */
dict[0x51d9] = "duó"; /* 凙 */
dict[0x51da] = "jìn"; /* 凚 */
dict[0x51db] = "lǐn"; /* 凛 */
dict[0x51dc] = "lǐn"; /* 凜 */
dict[0x51dd] = "níng"; /* 凝 */
dict[0x51de] = "xī"; /* 凞 */
dict[0x51df] = "dú"; /* 凟 */
dict[0x51e0] = "jī,jǐ"; /* 几 */
dict[0x51e1] = "fán"; /* 凡 */
dict[0x51e2] = "fán"; /* 凢 */
dict[0x51e3] = "fán"; /* 凣 */
dict[0x51e4] = "fèng"; /* 凤 */
dict[0x51e5] = "jū"; /* 凥 */
dict[0x51e6] = "chù,chǔ"; /* 処 */
dict[0x51e7] = "zhēng"; /* 凧 */
dict[0x51e8] = "fēng"; /* 凨 */
dict[0x51e9] = "mù"; /* 凩 */
dict[0x51ea] = "zhǐ"; /* 凪 */
dict[0x51eb] = "fú"; /* 凫 */
dict[0x51ec] = "fēng"; /* 凬 */
dict[0x51ed] = "píng"; /* 凭 */
dict[0x51ee] = "fēng"; /* 凮 */
dict[0x51ef] = "kǎi"; /* 凯 */
dict[0x51f0] = "huáng"; /* 凰 */
dict[0x51f1] = "kǎi"; /* 凱 */
dict[0x51f2] = "gān"; /* 凲 */
dict[0x51f3] = "dèng"; /* 凳 */
dict[0x51f4] = "píng"; /* 凴 */
dict[0x51f5] = "kǎn,qiǎn"; /* 凵 */
dict[0x51f6] = "xiōng"; /* 凶 */
dict[0x51f7] = "kuài"; /* 凷 */
dict[0x51f8] = "tū"; /* 凸 */
dict[0x51f9] = "āo,wā"; /* 凹 */
dict[0x51fa] = "chū"; /* 出 */
dict[0x51fb] = "jī"; /* 击 */
dict[0x51fc] = "dàng"; /* 凼 */
dict[0x51fd] = "hán"; /* 函 */
dict[0x51fe] = "hán"; /* 凾 */
dict[0x51ff] = "záo"; /* 凿 */
dict[0x5200] = "dāo"; /* 刀 */
dict[0x5201] = "diāo"; /* 刁 */
dict[0x5202] = "dāo"; /* 刂 */
dict[0x5203] = "rèn"; /* 刃 */
dict[0x5204] = "rèn"; /* 刄 */
dict[0x5205] = "chuāng"; /* 刅 */
dict[0x5206] = "fēn,fèn"; /* 分 */
dict[0x5207] = "qiē,qiè"; /* 切 */
dict[0x5208] = "yì"; /* 刈 */
dict[0x5209] = "jī"; /* 刉 */
dict[0x520a] = "kān"; /* 刊 */
dict[0x520b] = "qiàn"; /* 刋 */
dict[0x520c] = "cǔn"; /* 刌 */
dict[0x520d] = "chú"; /* 刍 */
dict[0x520e] = "wěn"; /* 刎 */
dict[0x520f] = "jī"; /* 刏 */
dict[0x5210] = "dǎn"; /* 刐 */
dict[0x5211] = "xíng"; /* 刑 */
dict[0x5212] = "huá,huà"; /* 划 */
dict[0x5213] = "wán"; /* 刓 */
dict[0x5214] = "jué"; /* 刔 */
dict[0x5215] = "lí"; /* 刕 */
dict[0x5216] = "yuè"; /* 刖 */
dict[0x5217] = "liè"; /* 列 */
dict[0x5218] = "liú"; /* 刘 */
dict[0x5219] = "zé"; /* 则 */
dict[0x521a] = "gāng"; /* 刚 */
dict[0x521b] = "chuàng,chuāng"; /* 创 */
dict[0x521c] = "fú"; /* 刜 */
dict[0x521d] = "chū"; /* 初 */
dict[0x521e] = "qù"; /* 刞 */
dict[0x521f] = "diāo"; /* 刟 */
dict[0x5220] = "shān"; /* 删 */
dict[0x5221] = "mǐn"; /* 刡 */
dict[0x5222] = "líng"; /* 刢 */
dict[0x5223] = "zhōng"; /* 刣 */
dict[0x5224] = "pàn"; /* 判 */
dict[0x5225] = "bié,biè"; /* 別 */
dict[0x5226] = "jié"; /* 刦 */
dict[0x5227] = "jié"; /* 刧 */
dict[0x5228] = "páo,bào"; /* 刨 */
dict[0x5229] = "lì"; /* 利 */
dict[0x522a] = "shān"; /* 刪 */
dict[0x522b] = "bié,biè"; /* 别 */
dict[0x522c] = "chǎn,chàn"; /* 刬 */
dict[0x522d] = "jǐng"; /* 刭 */
dict[0x522e] = "guā"; /* 刮 */
dict[0x522f] = "gēng"; /* 刯 */
dict[0x5230] = "dào"; /* 到 */
dict[0x5231] = "chuàng"; /* 刱 */
dict[0x5232] = "kuī"; /* 刲 */
dict[0x5233] = "kū"; /* 刳 */
dict[0x5234] = "duò"; /* 刴 */
dict[0x5235] = "èr"; /* 刵 */
dict[0x5236] = "zhì"; /* 制 */
dict[0x5237] = "shuā,shuà"; /* 刷 */
dict[0x5238] = "quàn,xuàn"; /* 券 */
dict[0x5239] = "chà,shā"; /* 刹 */
dict[0x523a] = "cì,cī"; /* 刺 */
dict[0x523b] = "kè"; /* 刻 */
dict[0x523c] = "jié"; /* 刼 */
dict[0x523d] = "guì"; /* 刽 */
dict[0x523e] = "cì"; /* 刾 */
dict[0x523f] = "guì"; /* 刿 */
dict[0x5240] = "kǎi"; /* 剀 */
dict[0x5241] = "duò"; /* 剁 */
dict[0x5242] = "jì"; /* 剂 */
dict[0x5243] = "tì"; /* 剃 */
dict[0x5244] = "jǐng"; /* 剄 */
dict[0x5245] = "lóu"; /* 剅 */
dict[0x5246] = "luǒ"; /* 剆 */
dict[0x5247] = "zé"; /* 則 */
dict[0x5248] = "yuān"; /* 剈 */
dict[0x5249] = "cuò"; /* 剉 */
dict[0x524a] = "xiāo,xuē"; /* 削 */
dict[0x524b] = "kēi,kè"; /* 剋 */
dict[0x524c] = "là,lá"; /* 剌 */
dict[0x524d] = "qián"; /* 前 */
dict[0x524e] = "chà,shā"; /* 剎 */
dict[0x524f] = "chuàng"; /* 剏 */
dict[0x5250] = "guǎ"; /* 剐 */
dict[0x5251] = "jiàn"; /* 剑 */
dict[0x5252] = "cuò"; /* 剒 */
dict[0x5253] = "lí"; /* 剓 */
dict[0x5254] = "tī"; /* 剔 */
dict[0x5255] = "fèi"; /* 剕 */
dict[0x5256] = "pōu"; /* 剖 */
dict[0x5257] = "chǎn,chàn"; /* 剗 */
dict[0x5258] = "qí"; /* 剘 */
dict[0x5259] = "chuàng"; /* 剙 */
dict[0x525a] = "zì"; /* 剚 */
dict[0x525b] = "gāng"; /* 剛 */
dict[0x525c] = "wān"; /* 剜 */
dict[0x525d] = "bāo,bō"; /* 剝 */
dict[0x525e] = "jī"; /* 剞 */
dict[0x525f] = "duō"; /* 剟 */
dict[0x5260] = "qíng"; /* 剠 */
dict[0x5261] = "yǎn,shàn"; /* 剡 */
dict[0x5262] = "dū,zhuó"; /* 剢 */
dict[0x5263] = "jiàn"; /* 剣 */
dict[0x5264] = "jì"; /* 剤 */
dict[0x5265] = "bāo,bō"; /* 剥 */
dict[0x5266] = "yān"; /* 剦 */
dict[0x5267] = "jù"; /* 剧 */
dict[0x5268] = "huò"; /* 剨 */
dict[0x5269] = "shèng"; /* 剩 */
dict[0x526a] = "jiǎn"; /* 剪 */
dict[0x526b] = "duó"; /* 剫 */
dict[0x526c] = "zhì,duān"; /* 剬 */
dict[0x526d] = "wū"; /* 剭 */
dict[0x526e] = "guǎ"; /* 剮 */
dict[0x526f] = "fù,pì"; /* 副 */
dict[0x5270] = "shèng"; /* 剰 */
dict[0x5271] = "jiàn"; /* 剱 */
dict[0x5272] = "gē"; /* 割 */
dict[0x5273] = "dá,zhá"; /* 剳 */
dict[0x5274] = "kǎi"; /* 剴 */
dict[0x5275] = "chuàng,chuāng"; /* 創 */
dict[0x5276] = "chuán"; /* 剶 */
dict[0x5277] = "chǎn"; /* 剷 */
dict[0x5278] = "tuán,zhuān"; /* 剸 */
dict[0x5279] = "lù,jiū"; /* 剹 */
dict[0x527a] = "lí"; /* 剺 */
dict[0x527b] = "pēng"; /* 剻 */
dict[0x527c] = "shān"; /* 剼 */
dict[0x527d] = "piāo"; /* 剽 */
dict[0x527e] = "kōu"; /* 剾 */
dict[0x527f] = "jiǎo,chāo"; /* 剿 */
dict[0x5280] = "guā"; /* 劀 */
dict[0x5281] = "qiāo"; /* 劁 */
dict[0x5282] = "jué"; /* 劂 */
dict[0x5283] = "huá,huà"; /* 劃 */
dict[0x5284] = "zhā,zhá"; /* 劄 */
dict[0x5285] = "zhuó"; /* 劅 */
dict[0x5286] = "lián"; /* 劆 */
dict[0x5287] = "jù"; /* 劇 */
dict[0x5288] = "pī,pǐ"; /* 劈 */
dict[0x5289] = "liú"; /* 劉 */
dict[0x528a] = "guì"; /* 劊 */
dict[0x528b] = "jiǎo,chāo"; /* 劋 */
dict[0x528c] = "guì"; /* 劌 */
dict[0x528d] = "jiàn"; /* 劍 */
dict[0x528e] = "jiàn"; /* 劎 */
dict[0x528f] = "tāng"; /* 劏 */
dict[0x5290] = "huō"; /* 劐 */
dict[0x5291] = "jì"; /* 劑 */
dict[0x5292] = "jiàn"; /* 劒 */
dict[0x5293] = "yì"; /* 劓 */
dict[0x5294] = "jiàn"; /* 劔 */
dict[0x5295] = "zhì"; /* 劕 */
dict[0x5296] = "chán"; /* 劖 */
dict[0x5297] = "zuān"; /* 劗 */
dict[0x5298] = "mó"; /* 劘 */
dict[0x5299] = "lí"; /* 劙 */
dict[0x529a] = "zhú"; /* 劚 */
dict[0x529b] = "lì"; /* 力 */
dict[0x529c] = "yà"; /* 劜 */
dict[0x529d] = "quàn"; /* 劝 */
dict[0x529e] = "bàn"; /* 办 */
dict[0x529f] = "gōng"; /* 功 */
dict[0x52a0] = "jiā"; /* 加 */
dict[0x52a1] = "wù"; /* 务 */
dict[0x52a2] = "mài"; /* 劢 */
dict[0x52a3] = "liè"; /* 劣 */
dict[0x52a4] = "jìn,jìng"; /* 劤 */
dict[0x52a5] = "kēng"; /* 劥 */
dict[0x52a6] = "xié,liè"; /* 劦 */
dict[0x52a7] = "zhǐ"; /* 劧 */
dict[0x52a8] = "dòng"; /* 动 */
dict[0x52a9] = "zhù,chú"; /* 助 */
dict[0x52aa] = "nǔ"; /* 努 */
dict[0x52ab] = "jié"; /* 劫 */
dict[0x52ac] = "qú"; /* 劬 */
dict[0x52ad] = "shào"; /* 劭 */
dict[0x52ae] = "yì"; /* 劮 */
dict[0x52af] = "zhǔ"; /* 劯 */
dict[0x52b0] = "miǎo"; /* 劰 */
dict[0x52b1] = "lì"; /* 励 */
dict[0x52b2] = "jìn,jìng"; /* 劲 */
dict[0x52b3] = "láo"; /* 劳 */
dict[0x52b4] = "láo"; /* 労 */
dict[0x52b5] = "juàn"; /* 劵 */
dict[0x52b6] = "kǒu"; /* 劶 */
dict[0x52b7] = "yáng"; /* 劷 */
dict[0x52b8] = "wā"; /* 劸 */
dict[0x52b9] = "xiào"; /* 効 */
dict[0x52ba] = "móu"; /* 劺 */
dict[0x52bb] = "kuāng"; /* 劻 */
dict[0x52bc] = "jié"; /* 劼 */
dict[0x52bd] = "liè"; /* 劽 */
dict[0x52be] = "hé"; /* 劾 */
dict[0x52bf] = "shì"; /* 势 */
dict[0x52c0] = "kè"; /* 勀 */
dict[0x52c1] = "jìn,jìng"; /* 勁 */
dict[0x52c2] = "gào"; /* 勂 */
dict[0x52c3] = "bó,bèi"; /* 勃 */
dict[0x52c4] = "mǐn"; /* 勄 */
dict[0x52c5] = "chì"; /* 勅 */
dict[0x52c6] = "láng"; /* 勆 */
dict[0x52c7] = "yǒng"; /* 勇 */
dict[0x52c8] = "yǒng"; /* 勈 */
dict[0x52c9] = "miǎn"; /* 勉 */
dict[0x52ca] = "kè"; /* 勊 */
dict[0x52cb] = "xūn"; /* 勋 */
dict[0x52cc] = "juàn,juān"; /* 勌 */
dict[0x52cd] = "qíng"; /* 勍 */
dict[0x52ce] = "lù"; /* 勎 */
dict[0x52cf] = "bù"; /* 勏 */
dict[0x52d0] = "měng"; /* 勐 */
dict[0x52d1] = "chì"; /* 勑 */
dict[0x52d2] = "lè,lēi"; /* 勒 */
dict[0x52d3] = "kài"; /* 勓 */
dict[0x52d4] = "miǎn"; /* 勔 */
dict[0x52d5] = "dòng"; /* 動 */
dict[0x52d6] = "xù"; /* 勖 */
dict[0x52d7] = "xù"; /* 勗 */
dict[0x52d8] = "kān"; /* 勘 */
dict[0x52d9] = "wù"; /* 務 */
dict[0x52da] = "yì"; /* 勚 */
dict[0x52db] = "xūn"; /* 勛 */
dict[0x52dc] = "wěng,yǎng"; /* 勜 */
dict[0x52dd] = "shèng"; /* 勝 */
dict[0x52de] = "láo"; /* 勞 */
dict[0x52df] = "mù"; /* 募 */
dict[0x52e0] = "lù"; /* 勠 */
dict[0x52e1] = "piāo"; /* 勡 */
dict[0x52e2] = "shì"; /* 勢 */
dict[0x52e3] = "jì"; /* 勣 */
dict[0x52e4] = "qín"; /* 勤 */
dict[0x52e5] = "jiàng"; /* 勥 */
dict[0x52e6] = "jiǎo,chāo"; /* 勦 */
dict[0x52e7] = "quàn"; /* 勧 */
dict[0x52e8] = "xiàng"; /* 勨 */
dict[0x52e9] = "yì"; /* 勩 */
dict[0x52ea] = "qiāo"; /* 勪 */
dict[0x52eb] = "fān"; /* 勫 */
dict[0x52ec] = "juān"; /* 勬 */
dict[0x52ed] = "tóng,dòng"; /* 勭 */
dict[0x52ee] = "jù"; /* 勮 */
dict[0x52ef] = "dān"; /* 勯 */
dict[0x52f0] = "xié"; /* 勰 */
dict[0x52f1] = "mài"; /* 勱 */
dict[0x52f2] = "xūn"; /* 勲 */
dict[0x52f3] = "xūn"; /* 勳 */
dict[0x52f4] = "lǜ"; /* 勴 */
dict[0x52f5] = "lì"; /* 勵 */
dict[0x52f6] = "chè"; /* 勶 */
dict[0x52f7] = "ráng,xiāng"; /* 勷 */
dict[0x52f8] = "quàn"; /* 勸 */
dict[0x52f9] = "bāo"; /* 勹 */
dict[0x52fa] = "sháo"; /* 勺 */
dict[0x52fb] = "yún"; /* 勻 */
dict[0x52fc] = "jiū"; /* 勼 */
dict[0x52fd] = "bào"; /* 勽 */
dict[0x52fe] = "gōu,gòu"; /* 勾 */
dict[0x52ff] = "wù"; /* 勿 */
dict[0x5300] = "yún"; /* 匀 */
dict[0x5302] = "xiōng"; /* 匂 */
dict[0x5303] = "gài"; /* 匃 */
dict[0x5304] = "gài"; /* 匄 */
dict[0x5305] = "bāo"; /* 包 */
dict[0x5306] = "cōng"; /* 匆 */
dict[0x5307] = "yì"; /* 匇 */
dict[0x5308] = "xiōng"; /* 匈 */
dict[0x5309] = "pēng"; /* 匉 */
dict[0x530a] = "jū"; /* 匊 */
dict[0x530b] = "táo,yáo"; /* 匋 */
dict[0x530c] = "gé"; /* 匌 */
dict[0x530d] = "pú"; /* 匍 */
dict[0x530e] = "è"; /* 匎 */
dict[0x530f] = "páo"; /* 匏 */
dict[0x5310] = "fú"; /* 匐 */
dict[0x5311] = "gōng"; /* 匑 */
dict[0x5312] = "dá"; /* 匒 */
dict[0x5313] = "jiù"; /* 匓 */
dict[0x5314] = "gōng"; /* 匔 */
dict[0x5315] = "bǐ"; /* 匕 */
dict[0x5316] = "huà,huā"; /* 化 */
dict[0x5317] = "běi,bèi"; /* 北 */
dict[0x5318] = "nǎo"; /* 匘 */
dict[0x5319] = "chí,shi"; /* 匙 */
dict[0x531a] = "fāng"; /* 匚 */
dict[0x531b] = "jiù"; /* 匛 */
dict[0x531c] = "yí"; /* 匜 */
dict[0x531d] = "zā"; /* 匝 */
dict[0x531e] = "jiàng"; /* 匞 */
dict[0x531f] = "kàng"; /* 匟 */
dict[0x5320] = "jiàng"; /* 匠 */
dict[0x5321] = "kuāng"; /* 匡 */
dict[0x5322] = "hū"; /* 匢 */
dict[0x5323] = "xiá"; /* 匣 */
dict[0x5324] = "qū"; /* 匤 */
dict[0x5325] = "fán"; /* 匥 */
dict[0x5326] = "guǐ"; /* 匦 */
dict[0x5327] = "qiè"; /* 匧 */
dict[0x5328] = "zāng,cáng"; /* 匨 */
dict[0x5329] = "kuāng"; /* 匩 */
dict[0x532a] = "fěi"; /* 匪 */
dict[0x532b] = "hū"; /* 匫 */
dict[0x532c] = "yǔ"; /* 匬 */
dict[0x532d] = "guǐ"; /* 匭 */
dict[0x532e] = "kuì,guì"; /* 匮 */
dict[0x532f] = "huì"; /* 匯 */
dict[0x5330] = "dān"; /* 匰 */
dict[0x5331] = "kuì,guì"; /* 匱 */
dict[0x5332] = "lián"; /* 匲 */
dict[0x5333] = "lián"; /* 匳 */
dict[0x5334] = "suǎn"; /* 匴 */
dict[0x5335] = "dú"; /* 匵 */
dict[0x5336] = "jiù"; /* 匶 */
dict[0x5337] = "jué"; /* 匷 */
dict[0x5338] = "xì"; /* 匸 */
dict[0x5339] = "pǐ"; /* 匹 */
dict[0x533a] = "qū,ōu"; /* 区 */
dict[0x533b] = "yī"; /* 医 */
dict[0x533c] = "kē,qià"; /* 匼 */
dict[0x533d] = "yǎn,yàn"; /* 匽 */
dict[0x533e] = "biǎn"; /* 匾 */
dict[0x533f] = "nì"; /* 匿 */
dict[0x5340] = "qū,ōu"; /* 區 */
dict[0x5341] = "shí"; /* 十 */
dict[0x5342] = "xùn"; /* 卂 */
dict[0x5343] = "qiān"; /* 千 */
dict[0x5344] = "niàn"; /* 卄 */
dict[0x5345] = "sà"; /* 卅 */
dict[0x5346] = "zú"; /* 卆 */
dict[0x5347] = "shēng"; /* 升 */
dict[0x5348] = "wǔ"; /* 午 */
dict[0x5349] = "huì"; /* 卉 */
dict[0x534a] = "bàn"; /* 半 */
dict[0x534b] = "shì"; /* 卋 */
dict[0x534c] = "xì"; /* 卌 */
dict[0x534d] = "wàn"; /* 卍 */
dict[0x534e] = "huá,huà,huā"; /* 华 */
dict[0x534f] = "xié"; /* 协 */
dict[0x5350] = "wàn"; /* 卐 */
dict[0x5351] = "bēi"; /* 卑 */
dict[0x5352] = "zú,cù"; /* 卒 */
dict[0x5353] = "zhuó"; /* 卓 */
dict[0x5354] = "xié"; /* 協 */
dict[0x5355] = "dān,shàn,chán"; /* 单 */
dict[0x5356] = "mài"; /* 卖 */
dict[0x5357] = "nán,nā"; /* 南 */
dict[0x5358] = "dān"; /* 単 */
dict[0x5359] = "jí"; /* 卙 */
dict[0x535a] = "bó"; /* 博 */
dict[0x535b] = "shuài,lǜ"; /* 卛 */
dict[0x535c] = "bǔ,bo"; /* 卜 */
dict[0x535d] = "guàn,kuàng"; /* 卝 */
dict[0x535e] = "biàn"; /* 卞 */
dict[0x535f] = "bǔ"; /* 卟 */
dict[0x5360] = "zhān,zhàn"; /* 占 */
dict[0x5361] = "kǎ,qiǎ"; /* 卡 */
dict[0x5362] = "lú"; /* 卢 */
dict[0x5363] = "yǒu"; /* 卣 */
dict[0x5364] = "lǔ"; /* 卤 */
dict[0x5365] = "xī"; /* 卥 */
dict[0x5366] = "guà"; /* 卦 */
dict[0x5367] = "wò"; /* 卧 */
dict[0x5368] = "xiè"; /* 卨 */
dict[0x5369] = "jié"; /* 卩 */
dict[0x536a] = "jié"; /* 卪 */
dict[0x536b] = "wèi"; /* 卫 */
dict[0x536c] = "yǎng,áng"; /* 卬 */
dict[0x536d] = "qióng"; /* 卭 */
dict[0x536e] = "zhī"; /* 卮 */
dict[0x536f] = "mǎo"; /* 卯 */
dict[0x5370] = "yìn"; /* 印 */
dict[0x5371] = "wēi"; /* 危 */
dict[0x5372] = "shào"; /* 卲 */
dict[0x5373] = "jí"; /* 即 */
dict[0x5374] = "què"; /* 却 */
dict[0x5375] = "luǎn"; /* 卵 */
dict[0x5376] = "chǐ"; /* 卶 */
dict[0x5377] = "juàn,juǎn"; /* 卷 */
dict[0x5378] = "xiè"; /* 卸 */
dict[0x5379] = "xù"; /* 卹 */
dict[0x537a] = "jǐn"; /* 卺 */
dict[0x537b] = "què"; /* 卻 */
dict[0x537c] = "wù"; /* 卼 */
dict[0x537d] = "jí"; /* 卽 */
dict[0x537e] = "è"; /* 卾 */
dict[0x537f] = "qīng"; /* 卿 */
dict[0x5380] = "xī"; /* 厀 */
dict[0x5381] = "sān"; /* 厁 */
dict[0x5382] = "chǎng,ān,hàn"; /* 厂 */
dict[0x5383] = "wēi,yán"; /* 厃 */
dict[0x5384] = "è"; /* 厄 */
dict[0x5385] = "tīng"; /* 厅 */
dict[0x5386] = "lì"; /* 历 */
dict[0x5387] = "zhé,zhái"; /* 厇 */
dict[0x5388] = "hàn,àn"; /* 厈 */
dict[0x5389] = "lì"; /* 厉 */
dict[0x538a] = "yǎ"; /* 厊 */
dict[0x538b] = "yā,yà"; /* 压 */
dict[0x538c] = "yàn"; /* 厌 */
dict[0x538d] = "shè"; /* 厍 */
dict[0x538e] = "dǐ"; /* 厎 */
dict[0x538f] = "zhǎ,zhǎi"; /* 厏 */
dict[0x5390] = "páng"; /* 厐 */
dict[0x5391] = "yá"; /* 厑 */
dict[0x5392] = "qiè"; /* 厒 */
dict[0x5393] = "yá"; /* 厓 */
dict[0x5394] = "zhì,shī"; /* 厔 */
dict[0x5395] = "cè"; /* 厕 */
dict[0x5396] = "máng"; /* 厖 */
dict[0x5397] = "tí"; /* 厗 */
dict[0x5398] = "lí"; /* 厘 */
dict[0x5399] = "shè"; /* 厙 */
dict[0x539a] = "hòu"; /* 厚 */
dict[0x539b] = "tīng"; /* 厛 */
dict[0x539c] = "zuī"; /* 厜 */
dict[0x539d] = "cuò"; /* 厝 */
dict[0x539e] = "fèi"; /* 厞 */
dict[0x539f] = "yuán"; /* 原 */
dict[0x53a0] = "cè"; /* 厠 */
dict[0x53a1] = "yuán"; /* 厡 */
dict[0x53a2] = "xiāng"; /* 厢 */
dict[0x53a3] = "yǎn"; /* 厣 */
dict[0x53a4] = "lì"; /* 厤 */
dict[0x53a5] = "jué"; /* 厥 */
dict[0x53a6] = "shà,xià"; /* 厦 */
dict[0x53a7] = "diān"; /* 厧 */
dict[0x53a8] = "chú"; /* 厨 */
dict[0x53a9] = "jiù"; /* 厩 */
dict[0x53aa] = "jǐn"; /* 厪 */
dict[0x53ab] = "áo"; /* 厫 */
dict[0x53ac] = "guǐ"; /* 厬 */
dict[0x53ad] = "yàn"; /* 厭 */
dict[0x53ae] = "sī"; /* 厮 */
dict[0x53af] = "lì"; /* 厯 */
dict[0x53b0] = "chǎng"; /* 厰 */
dict[0x53b1] = "qiān,lán"; /* 厱 */
dict[0x53b2] = "lì"; /* 厲 */
dict[0x53b3] = "yán"; /* 厳 */
dict[0x53b4] = "yǎn"; /* 厴 */
dict[0x53b5] = "yuán"; /* 厵 */
dict[0x53b6] = "sī,mǒu"; /* 厶 */
dict[0x53b7] = "gōng,hóng"; /* 厷 */
dict[0x53b8] = "lín,miǎo"; /* 厸 */
dict[0x53b9] = "róu,qiú"; /* 厹 */
dict[0x53ba] = "qù"; /* 厺 */
dict[0x53bb] = "qù"; /* 去 */
dict[0x53bd] = "lěi"; /* 厽 */
dict[0x53be] = "dū"; /* 厾 */
dict[0x53bf] = "xiàn,xuán"; /* 县 */
dict[0x53c0] = "zhuān"; /* 叀 */
dict[0x53c1] = "sān"; /* 叁 */
dict[0x53c2] = "cān,shēn,cēn,sān"; /* 参 */
dict[0x53c3] = "cān,shēn,cēn,sān"; /* 參 */
dict[0x53c4] = "cān,shēn,cēn,sān"; /* 叄 */
dict[0x53c5] = "cān,shēn,cēn,sān"; /* 叅 */
dict[0x53c6] = "ài"; /* 叆 */
dict[0x53c7] = "dài"; /* 叇 */
dict[0x53c8] = "yòu"; /* 又 */
dict[0x53c9] = "chā,chá,chǎ"; /* 叉 */
dict[0x53ca] = "jí"; /* 及 */
dict[0x53cb] = "yǒu"; /* 友 */
dict[0x53cc] = "shuāng"; /* 双 */
dict[0x53cd] = "fǎn"; /* 反 */
dict[0x53ce] = "shōu"; /* 収 */
dict[0x53cf] = "guái"; /* 叏 */
dict[0x53d0] = "bá"; /* 叐 */
dict[0x53d1] = "fā,fà"; /* 发 */
dict[0x53d2] = "ruò"; /* 叒 */
dict[0x53d3] = "lì"; /* 叓 */
dict[0x53d4] = "shū"; /* 叔 */
dict[0x53d5] = "zhuó,yǐ,lì,jué"; /* 叕 */
dict[0x53d6] = "qǔ"; /* 取 */
dict[0x53d7] = "shòu"; /* 受 */
dict[0x53d8] = "biàn"; /* 变 */
dict[0x53d9] = "xù"; /* 叙 */
dict[0x53da] = "jiǎ"; /* 叚 */
dict[0x53db] = "pàn"; /* 叛 */
dict[0x53dc] = "sǒu"; /* 叜 */
dict[0x53dd] = "jí"; /* 叝 */
dict[0x53de] = "wèi,yù"; /* 叞 */
dict[0x53df] = "sǒu"; /* 叟 */
dict[0x53e0] = "dié"; /* 叠 */
dict[0x53e1] = "ruì"; /* 叡 */
dict[0x53e2] = "cóng"; /* 叢 */
dict[0x53e3] = "kǒu"; /* 口 */
dict[0x53e4] = "gǔ"; /* 古 */
dict[0x53e5] = "jù,gōu"; /* 句 */
dict[0x53e6] = "lìng"; /* 另 */
dict[0x53e7] = "guǎ"; /* 叧 */
dict[0x53e8] = "tāo,dāo"; /* 叨 */
dict[0x53e9] = "kòu"; /* 叩 */
dict[0x53ea] = "zhī,zhǐ"; /* 只 */
dict[0x53eb] = "jiào"; /* 叫 */
dict[0x53ec] = "zhào,shào"; /* 召 */
dict[0x53ed] = "bā"; /* 叭 */
dict[0x53ee] = "dīng"; /* 叮 */
dict[0x53ef] = "kě,kè"; /* 可 */
dict[0x53f0] = "tái,tāi"; /* 台 */
dict[0x53f1] = "chì"; /* 叱 */
dict[0x53f2] = "shǐ"; /* 史 */
dict[0x53f3] = "yòu"; /* 右 */
dict[0x53f4] = "qiú"; /* 叴 */
dict[0x53f5] = "pǒ"; /* 叵 */
dict[0x53f6] = "yè,xié"; /* 叶 */
dict[0x53f7] = "hào,háo"; /* 号 */
dict[0x53f8] = "sī"; /* 司 */
dict[0x53f9] = "tàn"; /* 叹 */
dict[0x53fa] = "chǐ"; /* 叺 */
dict[0x53fb] = "lè"; /* 叻 */
dict[0x53fc] = "diāo"; /* 叼 */
dict[0x53fd] = "jī"; /* 叽 */
dict[0x53ff] = "hōng,hóng"; /* 叿 */
dict[0x5400] = "miē"; /* 吀 */
dict[0x5401] = "xū,yù"; /* 吁 */
dict[0x5402] = "máng"; /* 吂 */
dict[0x5403] = "chī"; /* 吃 */
dict[0x5404] = "gè,gě"; /* 各 */
dict[0x5405] = "xuān,sòng"; /* 吅 */
dict[0x5406] = "yāo"; /* 吆 */
dict[0x5407] = "zǐ"; /* 吇 */
dict[0x5408] = "hé,gě"; /* 合 */
dict[0x5409] = "jí"; /* 吉 */
dict[0x540a] = "diào"; /* 吊 */
dict[0x540b] = "dòu,cùn"; /* 吋 */
dict[0x540c] = "tóng,tòng"; /* 同 */
dict[0x540d] = "míng"; /* 名 */
dict[0x540e] = "hòu"; /* 后 */
dict[0x540f] = "lì"; /* 吏 */
dict[0x5410] = "tǔ,tù"; /* 吐 */
dict[0x5411] = "xiàng"; /* 向 */
dict[0x5412] = "zhà,zhā"; /* 吒 */
dict[0x5413] = "xià,hè"; /* 吓 */
dict[0x5414] = "yē"; /* 吔 */
dict[0x5415] = "lǚ"; /* 吕 */
dict[0x5416] = "yā,ā"; /* 吖 */
dict[0x5417] = "ma,má,mǎ"; /* 吗 */
dict[0x5418] = "ǒu"; /* 吘 */
dict[0x5419] = "huō"; /* 吙 */
dict[0x541a] = "yī"; /* 吚 */
dict[0x541b] = "jūn"; /* 君 */
dict[0x541c] = "chǒu"; /* 吜 */
dict[0x541d] = "lìn"; /* 吝 */
dict[0x541e] = "tūn"; /* 吞 */
dict[0x541f] = "yín"; /* 吟 */
dict[0x5420] = "fèi"; /* 吠 */
dict[0x5421] = "pǐ,bǐ"; /* 吡 */
dict[0x5422] = "qìn"; /* 吢 */
dict[0x5423] = "qìn"; /* 吣 */
dict[0x5424] = "jiè,gè"; /* 吤 */
dict[0x5425] = "bù"; /* 吥 */
dict[0x5426] = "fǒu,pǐ"; /* 否 */
dict[0x5427] = "bā,ba"; /* 吧 */
dict[0x5428] = "dūn"; /* 吨 */
dict[0x5429] = "fēn"; /* 吩 */
dict[0x542a] = "é,huā"; /* 吪 */
dict[0x542b] = "hán"; /* 含 */
dict[0x542c] = "tīng"; /* 听 */
dict[0x542d] = "háng,kēng"; /* 吭 */
dict[0x542e] = "shǔn"; /* 吮 */
dict[0x542f] = "qǐ"; /* 启 */
dict[0x5430] = "hóng"; /* 吰 */
dict[0x5431] = "zhī,zī"; /* 吱 */
dict[0x5432] = "yǐn,shěn"; /* 吲 */
dict[0x5433] = "wú"; /* 吳 */
dict[0x5434] = "wú"; /* 吴 */
dict[0x5435] = "chǎo,chāo"; /* 吵 */
dict[0x5436] = "nà,nè"; /* 吶 */
dict[0x5437] = "xuè,chuò,jué"; /* 吷 */
dict[0x5438] = "xī"; /* 吸 */
dict[0x5439] = "chuī"; /* 吹 */
dict[0x543a] = "dōu,rú"; /* 吺 */
dict[0x543b] = "wěn"; /* 吻 */
dict[0x543c] = "hǒu"; /* 吼 */
dict[0x543d] = "hǒu,hōng,ōu"; /* 吽 */
dict[0x543e] = "wú,yù"; /* 吾 */
dict[0x543f] = "gào"; /* 吿 */
dict[0x5440] = "yā,ya"; /* 呀 */
dict[0x5441] = "jùn"; /* 呁 */
dict[0x5442] = "lǚ"; /* 呂 */
dict[0x5443] = "è"; /* 呃 */
dict[0x5444] = "gé"; /* 呄 */
dict[0x5445] = "wěn"; /* 呅 */
dict[0x5446] = "dāi"; /* 呆 */
dict[0x5447] = "qǐ"; /* 呇 */
dict[0x5448] = "chéng"; /* 呈 */
dict[0x5449] = "wú"; /* 呉 */
dict[0x544a] = "gào"; /* 告 */
dict[0x544b] = "fū"; /* 呋 */
dict[0x544c] = "jiào"; /* 呌 */
dict[0x544d] = "hōng"; /* 呍 */
dict[0x544e] = "chǐ"; /* 呎 */
dict[0x544f] = "shēng"; /* 呏 */
dict[0x5450] = "nà,nè"; /* 呐 */
dict[0x5451] = "tūn,tiān"; /* 呑 */
dict[0x5452] = "fǔ"; /* 呒 */
dict[0x5453] = "yì"; /* 呓 */
dict[0x5454] = "dāi"; /* 呔 */
dict[0x5455] = "ǒu,ōu,òu"; /* 呕 */
dict[0x5456] = "lì"; /* 呖 */
dict[0x5457] = "bei,bài"; /* 呗 */
dict[0x5458] = "yuán,yún,yùn"; /* 员 */
dict[0x5459] = "wāi,hé,wǒ,wā,guǎ,guō"; /* 呙 */
dict[0x545a] = "huá,qì"; /* 呚 */
dict[0x545b] = "qiāng,qiàng"; /* 呛 */
dict[0x545c] = "wū"; /* 呜 */
dict[0x545d] = "è"; /* 呝 */
dict[0x545e] = "shī"; /* 呞 */
dict[0x545f] = "juǎn"; /* 呟 */
dict[0x5460] = "pěn"; /* 呠 */
dict[0x5461] = "wěn,mǐn"; /* 呡 */
dict[0x5462] = "ne,ní"; /* 呢 */
dict[0x5463] = "móu"; /* 呣 */
dict[0x5464] = "líng"; /* 呤 */
dict[0x5465] = "rán"; /* 呥 */
dict[0x5466] = "yōu"; /* 呦 */
dict[0x5467] = "dǐ"; /* 呧 */
dict[0x5468] = "zhōu"; /* 周 */
dict[0x5469] = "shì"; /* 呩 */
dict[0x546a] = "zhòu"; /* 呪 */
dict[0x546b] = "tiè,chè"; /* 呫 */
dict[0x546c] = "xì"; /* 呬 */
dict[0x546d] = "yì"; /* 呭 */
dict[0x546e] = "qì,zhī"; /* 呮 */
dict[0x546f] = "píng"; /* 呯 */
dict[0x5470] = "zǐ,cī"; /* 呰 */
dict[0x5471] = "guā,gū,guǎ"; /* 呱 */
dict[0x5472] = "zī,cī"; /* 呲 */
dict[0x5473] = "wèi"; /* 味 */
dict[0x5474] = "xǔ,hǒu,gòu"; /* 呴 */
dict[0x5475] = "hē,a,kē"; /* 呵 */
dict[0x5476] = "náo"; /* 呶 */
dict[0x5477] = "xiā"; /* 呷 */
dict[0x5478] = "pēi"; /* 呸 */
dict[0x5479] = "yì"; /* 呹 */
dict[0x547a] = "xiāo,háo"; /* 呺 */
dict[0x547b] = "shēn"; /* 呻 */
dict[0x547c] = "hū"; /* 呼 */
dict[0x547d] = "mìng"; /* 命 */
dict[0x547e] = "dá,dàn"; /* 呾 */
dict[0x547f] = "qū"; /* 呿 */
dict[0x5480] = "jǔ,zuǐ"; /* 咀 */
dict[0x5481] = "xián,gān"; /* 咁 */
dict[0x5482] = "zā"; /* 咂 */
dict[0x5483] = "tuō"; /* 咃 */
dict[0x5484] = "duō"; /* 咄 */
dict[0x5485] = "pǒu"; /* 咅 */
dict[0x5486] = "páo"; /* 咆 */
dict[0x5487] = "bì"; /* 咇 */
dict[0x5488] = "fú"; /* 咈 */
dict[0x5489] = "yǎng"; /* 咉 */
dict[0x548a] = "hé,hè"; /* 咊 */
dict[0x548b] = "zǎ,zé,zhā"; /* 咋 */
dict[0x548c] = "hé,hè,huó,huò,hú"; /* 和 */
dict[0x548d] = "hāi"; /* 咍 */
dict[0x548e] = "jiù"; /* 咎 */
dict[0x548f] = "yǒng"; /* 咏 */
dict[0x5490] = "fù"; /* 咐 */
dict[0x5491] = "dā"; /* 咑 */
dict[0x5492] = "zhòu"; /* 咒 */
dict[0x5493] = "wǎ"; /* 咓 */
dict[0x5494] = "kǎ"; /* 咔 */
dict[0x5495] = "gū"; /* 咕 */
dict[0x5496] = "kā,gā"; /* 咖 */
dict[0x5497] = "zuo"; /* 咗 */
dict[0x5498] = "bù"; /* 咘 */
dict[0x5499] = "lóng"; /* 咙 */
dict[0x549a] = "dōng"; /* 咚 */
dict[0x549b] = "níng"; /* 咛 */
dict[0x549c] = "tuō"; /* 咜 */
dict[0x549d] = "sī"; /* 咝 */
dict[0x549e] = "xiàn,xián"; /* 咞 */
dict[0x549f] = "huò"; /* 咟 */
dict[0x54a0] = "qì"; /* 咠 */
dict[0x54a1] = "èr"; /* 咡 */
dict[0x54a2] = "è"; /* 咢 */
dict[0x54a3] = "guāng"; /* 咣 */
dict[0x54a4] = "zhà"; /* 咤 */
dict[0x54a5] = "dié,xī"; /* 咥 */
dict[0x54a6] = "yí"; /* 咦 */
dict[0x54a7] = "liě,liē,lié,lie"; /* 咧 */
dict[0x54a8] = "zī"; /* 咨 */
dict[0x54a9] = "miē"; /* 咩 */
dict[0x54aa] = "mī"; /* 咪 */
dict[0x54ab] = "zhǐ"; /* 咫 */
dict[0x54ac] = "yǎo"; /* 咬 */
dict[0x54ad] = "jī,xī,qià"; /* 咭 */
dict[0x54ae] = "zhòu"; /* 咮 */
dict[0x54af] = "kǎ,luò,lo,gē"; /* 咯 */
dict[0x54b0] = "shù,xún"; /* 咰 */
dict[0x54b1] = "zán,zá,zǎ"; /* 咱 */
dict[0x54b2] = "xiào"; /* 咲 */
dict[0x54b3] = "ké,hāi"; /* 咳 */
dict[0x54b4] = "huī"; /* 咴 */
dict[0x54b5] = "kuā"; /* 咵 */
dict[0x54b6] = "huài,shì"; /* 咶 */
dict[0x54b7] = "táo"; /* 咷 */
dict[0x54b8] = "xián"; /* 咸 */
dict[0x54b9] = "è,àn"; /* 咹 */
dict[0x54ba] = "xuǎn,xuān"; /* 咺 */
dict[0x54bb] = "xiū"; /* 咻 */
dict[0x54bc] = "wāi,hé,wǒ,wā,guǎ,guō"; /* 咼 */
dict[0x54bd] = "yān,yàn,yè"; /* 咽 */
dict[0x54be] = "lǎo"; /* 咾 */
dict[0x54bf] = "yī"; /* 咿 */
dict[0x54c0] = "āi"; /* 哀 */
dict[0x54c1] = "pǐn"; /* 品 */
dict[0x54c2] = "shěn"; /* 哂 */
dict[0x54c3] = "tóng"; /* 哃 */
dict[0x54c4] = "hōng,hǒng,hòng"; /* 哄 */
dict[0x54c5] = "xiōng"; /* 哅 */
dict[0x54c6] = "duō"; /* 哆 */
dict[0x54c7] = "wā,wa"; /* 哇 */
dict[0x54c8] = "hā,hǎ,hà"; /* 哈 */
dict[0x54c9] = "zāi"; /* 哉 */
dict[0x54ca] = "yòu"; /* 哊 */
dict[0x54cb] = "diè,dì"; /* 哋 */
dict[0x54cc] = "pài"; /* 哌 */
dict[0x54cd] = "xiǎng"; /* 响 */
dict[0x54ce] = "āi"; /* 哎 */
dict[0x54cf] = "gén,hěn"; /* 哏 */
dict[0x54d0] = "kuāng"; /* 哐 */
dict[0x54d1] = "yǎ,yā"; /* 哑 */
dict[0x54d2] = "dā"; /* 哒 */
dict[0x54d3] = "xiāo"; /* 哓 */
dict[0x54d4] = "bì"; /* 哔 */
dict[0x54d5] = "yuě,huì"; /* 哕 */
dict[0x54d6] = "nián"; /* 哖 */
dict[0x54d7] = "huá,huā"; /* 哗 */
dict[0x54d8] = "xíng"; /* 哘 */
dict[0x54d9] = "kuài"; /* 哙 */
dict[0x54da] = "duǒ"; /* 哚 */
dict[0x54dc] = "jì,jiē,zhāi"; /* 哜 */
dict[0x54dd] = "nóng"; /* 哝 */
dict[0x54de] = "mōu"; /* 哞 */
dict[0x54df] = "yō,yo"; /* 哟 */
dict[0x54e0] = "hào"; /* 哠 */
dict[0x54e1] = "yuán,yún,yùn"; /* 員 */
dict[0x54e2] = "lòng"; /* 哢 */
dict[0x54e3] = "pǒu"; /* 哣 */
dict[0x54e4] = "máng"; /* 哤 */
dict[0x54e5] = "gē"; /* 哥 */
dict[0x54e6] = "ó,ò,é"; /* 哦 */
dict[0x54e7] = "chī"; /* 哧 */
dict[0x54e8] = "shào"; /* 哨 */
dict[0x54e9] = "li,lǐ,lī"; /* 哩 */
dict[0x54ea] = "nǎ,něi,na,né"; /* 哪 */
dict[0x54eb] = "zú"; /* 哫 */
dict[0x54ec] = "hè"; /* 哬 */
dict[0x54ed] = "kū"; /* 哭 */
dict[0x54ee] = "xiào"; /* 哮 */
dict[0x54ef] = "xiàn"; /* 哯 */
dict[0x54f0] = "láo"; /* 哰 */
dict[0x54f1] = "pò,bā,bō"; /* 哱 */
dict[0x54f2] = "zhé"; /* 哲 */
dict[0x54f3] = "zhā"; /* 哳 */
dict[0x54f4] = "liàng,láng"; /* 哴 */
dict[0x54f5] = "bā"; /* 哵 */
dict[0x54f6] = "miē"; /* 哶 */
dict[0x54f7] = "liè,lǜ"; /* 哷 */
dict[0x54f8] = "suī"; /* 哸 */
dict[0x54f9] = "fú"; /* 哹 */
dict[0x54fa] = "bǔ"; /* 哺 */
dict[0x54fb] = "hān"; /* 哻 */
dict[0x54fc] = "hēng,hng"; /* 哼 */
dict[0x54fd] = "gěng"; /* 哽 */
dict[0x54fe] = "chuò,yuè"; /* 哾 */
dict[0x54ff] = "gě,jiā"; /* 哿 */
dict[0x5500] = "yòu"; /* 唀 */
dict[0x5501] = "yàn"; /* 唁 */
dict[0x5502] = "gū"; /* 唂 */
dict[0x5503] = "gū"; /* 唃 */
dict[0x5504] = "bei,bài"; /* 唄 */
dict[0x5505] = "hán,hàn"; /* 唅 */
dict[0x5506] = "suō"; /* 唆 */
dict[0x5507] = "chún"; /* 唇 */
dict[0x5508] = "yì"; /* 唈 */
dict[0x5509] = "āi,ài"; /* 唉 */
dict[0x550a] = "jiá,qiǎn"; /* 唊 */
dict[0x550b] = "tǔ,tù"; /* 唋 */
dict[0x550c] = "dàn,xián,yán"; /* 唌 */
dict[0x550d] = "wǎn"; /* 唍 */
dict[0x550e] = "lì"; /* 唎 */
dict[0x550f] = "xī"; /* 唏 */
dict[0x5510] = "táng"; /* 唐 */
dict[0x5511] = "zuò"; /* 唑 */
dict[0x5512] = "qiú"; /* 唒 */
dict[0x5513] = "chē"; /* 唓 */
dict[0x5514] = "wù,wú,ń"; /* 唔 */
dict[0x5515] = "zào"; /* 唕 */
dict[0x5516] = "yǎ"; /* 唖 */
dict[0x5517] = "dōu"; /* 唗 */
dict[0x5518] = "qǐ"; /* 唘 */
dict[0x5519] = "dí"; /* 唙 */
dict[0x551a] = "qìn"; /* 唚 */
dict[0x551b] = "mài"; /* 唛 */
dict[0x551d] = "gòng,hǒng,gǒng"; /* 唝 */
dict[0x551e] = "dóu"; /* 唞 */
dict[0x5520] = "lào,láo"; /* 唠 */
dict[0x5521] = "liǎng"; /* 唡 */
dict[0x5522] = "suǒ"; /* 唢 */
dict[0x5523] = "zào"; /* 唣 */
dict[0x5524] = "huàn"; /* 唤 */
dict[0x5525] = "léng"; /* 唥 */
dict[0x5526] = "shā"; /* 唦 */
dict[0x5527] = "jī"; /* 唧 */
dict[0x5528] = "zǔ"; /* 唨 */
dict[0x5529] = "wō,wěi"; /* 唩 */
dict[0x552a] = "fěng"; /* 唪 */
dict[0x552b] = "jìn,yín"; /* 唫 */
dict[0x552c] = "hǔ,xià"; /* 唬 */
dict[0x552d] = "qì"; /* 唭 */
dict[0x552e] = "shòu"; /* 售 */
dict[0x552f] = "wéi"; /* 唯 */
dict[0x5530] = "shuā"; /* 唰 */
dict[0x5531] = "chàng"; /* 唱 */
dict[0x5532] = "ér,wā"; /* 唲 */
dict[0x5533] = "lì"; /* 唳 */
dict[0x5534] = "qiàng"; /* 唴 */
dict[0x5535] = "ǎn"; /* 唵 */
dict[0x5536] = "jiè,zé,jí"; /* 唶 */
dict[0x5537] = "yō"; /* 唷 */
dict[0x5538] = "niàn"; /* 唸 */
dict[0x5539] = "yū"; /* 唹 */
dict[0x553a] = "tiǎn"; /* 唺 */
dict[0x553b] = "lài"; /* 唻 */
dict[0x553c] = "shà"; /* 唼 */
dict[0x553d] = "xī"; /* 唽 */
dict[0x553e] = "tuò"; /* 唾 */
dict[0x553f] = "hū"; /* 唿 */
dict[0x5540] = "ái"; /* 啀 */
dict[0x5541] = "zhōu,zhāo,tiào"; /* 啁 */
dict[0x5542] = "gòu"; /* 啂 */
dict[0x5543] = "kěn"; /* 啃 */
dict[0x5544] = "zhuó"; /* 啄 */
dict[0x5545] = "zhuó,zhào"; /* 啅 */
dict[0x5546] = "shāng"; /* 商 */
dict[0x5547] = "dí"; /* 啇 */
dict[0x5548] = "hèng"; /* 啈 */
dict[0x5549] = "lán,lín"; /* 啉 */
dict[0x554a] = "ā,á,ǎ,à,a"; /* 啊 */
dict[0x554b] = "cǎi"; /* 啋 */
dict[0x554c] = "qiāng"; /* 啌 */
dict[0x554d] = "zhūn,tūn,xiāng,duǐ"; /* 啍 */
dict[0x554e] = "wǔ"; /* 啎 */
dict[0x554f] = "wèn"; /* 問 */
dict[0x5550] = "cuì,qi"; /* 啐 */
dict[0x5551] = "shà,jié,dié,tì"; /* 啑 */
dict[0x5552] = "gǔ"; /* 啒 */
dict[0x5553] = "qǐ"; /* 啓 */
dict[0x5554] = "qǐ"; /* 啔 */
dict[0x5555] = "táo"; /* 啕 */
dict[0x5556] = "dàn"; /* 啖 */
dict[0x5557] = "dàn"; /* 啗 */
dict[0x5558] = "yuē,wā"; /* 啘 */
dict[0x5559] = "zǐ,cǐ"; /* 啙 */
dict[0x555a] = "bǐ,tú"; /* 啚 */
dict[0x555b] = "cuì"; /* 啛 */
dict[0x555c] = "chuò,chuài"; /* 啜 */
dict[0x555d] = "hé"; /* 啝 */
dict[0x555e] = "yǎ,yā"; /* 啞 */
dict[0x555f] = "qǐ"; /* 啟 */
dict[0x5560] = "zhé"; /* 啠 */
dict[0x5561] = "fēi"; /* 啡 */
dict[0x5562] = "liǎng"; /* 啢 */
dict[0x5563] = "xián"; /* 啣 */
dict[0x5564] = "pí"; /* 啤 */
dict[0x5565] = "shá"; /* 啥 */
dict[0x5566] = "lā,la"; /* 啦 */
dict[0x5567] = "zé"; /* 啧 */
dict[0x5568] = "qíng,yīng"; /* 啨 */
dict[0x5569] = "guà"; /* 啩 */
dict[0x556a] = "pā"; /* 啪 */
dict[0x556b] = "zhě,shì"; /* 啫 */
dict[0x556c] = "sè"; /* 啬 */
dict[0x556d] = "zhuàn"; /* 啭 */
dict[0x556e] = "niè"; /* 啮 */
dict[0x556f] = "guō"; /* 啯 */
dict[0x5570] = "luō,luó,luo"; /* 啰 */
dict[0x5571] = "yán"; /* 啱 */
dict[0x5572] = "dī"; /* 啲 */
dict[0x5573] = "quán"; /* 啳 */
dict[0x5574] = "tān,chǎn,tuō"; /* 啴 */
dict[0x5575] = "bo"; /* 啵 */
dict[0x5576] = "dìng"; /* 啶 */
dict[0x5577] = "lāng"; /* 啷 */
dict[0x5578] = "xiào"; /* 啸 */
dict[0x5579] = "jú"; /* 啹 */
dict[0x557a] = "táng"; /* 啺 */
dict[0x557b] = "chì"; /* 啻 */
dict[0x557c] = "tí"; /* 啼 */
dict[0x557d] = "ān,án"; /* 啽 */
dict[0x557e] = "jiū"; /* 啾 */
dict[0x557f] = "dàn"; /* 啿 */
dict[0x5580] = "kā"; /* 喀 */
dict[0x5581] = "yóng"; /* 喁 */
dict[0x5582] = "wèi"; /* 喂 */
dict[0x5583] = "nán"; /* 喃 */
dict[0x5584] = "shàn"; /* 善 */
dict[0x5585] = "yù"; /* 喅 */
dict[0x5586] = "zhé"; /* 喆 */
dict[0x5587] = "lǎ"; /* 喇 */
dict[0x5588] = "jiē"; /* 喈 */
dict[0x5589] = "hóu"; /* 喉 */
dict[0x558a] = "hǎn"; /* 喊 */
dict[0x558b] = "dié,zhá"; /* 喋 */
dict[0x558c] = "zhōu"; /* 喌 */
dict[0x558d] = "chái"; /* 喍 */
dict[0x558e] = "wāi"; /* 喎 */
dict[0x558f] = "nuò,rě"; /* 喏 */
dict[0x5590] = "huò,guó,xù"; /* 喐 */
dict[0x5591] = "yīn"; /* 喑 */
dict[0x5592] = "zán,zá,zǎ"; /* 喒 */
dict[0x5593] = "yāo"; /* 喓 */
dict[0x5594] = "ō,wō"; /* 喔 */
dict[0x5595] = "miǎn"; /* 喕 */
dict[0x5596] = "hú"; /* 喖 */
dict[0x5597] = "yǔn"; /* 喗 */
dict[0x5598] = "chuǎn"; /* 喘 */
dict[0x5599] = "huì"; /* 喙 */
dict[0x559a] = "huàn"; /* 喚 */
dict[0x559b] = "huàn,yuán,xuǎn,hé"; /* 喛 */
dict[0x559c] = "xǐ"; /* 喜 */
dict[0x559d] = "hē,hè,yè"; /* 喝 */
dict[0x559e] = "jī"; /* 喞 */
dict[0x559f] = "kuì"; /* 喟 */
dict[0x55a0] = "zhǒng,chuáng"; /* 喠 */
dict[0x55a1] = "wéi,wèi"; /* 喡 */
dict[0x55a2] = "shà"; /* 喢 */
dict[0x55a3] = "xǔ"; /* 喣 */
dict[0x55a4] = "huáng"; /* 喤 */
dict[0x55a5] = "duó,zhà"; /* 喥 */
dict[0x55a6] = "yán"; /* 喦 */
dict[0x55a7] = "xuān"; /* 喧 */
dict[0x55a8] = "liàng"; /* 喨 */
dict[0x55a9] = "yù"; /* 喩 */
dict[0x55aa] = "sāng,sàng"; /* 喪 */
dict[0x55ab] = "chī"; /* 喫 */
dict[0x55ac] = "qiáo,jiāo"; /* 喬 */
dict[0x55ad] = "yàn"; /* 喭 */
dict[0x55ae] = "dān,shàn,chán"; /* 單 */
dict[0x55af] = "pèn,bēn"; /* 喯 */
dict[0x55b0] = "cān,sūn,qī"; /* 喰 */
dict[0x55b1] = "lí"; /* 喱 */
dict[0x55b2] = "yō,yo"; /* 喲 */
dict[0x55b3] = "zhā,chā"; /* 喳 */
dict[0x55b4] = "wēi"; /* 喴 */
dict[0x55b5] = "miāo"; /* 喵 */
dict[0x55b6] = "yíng"; /* 営 */
dict[0x55b7] = "pēn,pèn"; /* 喷 */
dict[0x55b9] = "kuí"; /* 喹 */
dict[0x55ba] = "xí"; /* 喺 */
dict[0x55bb] = "yù"; /* 喻 */
dict[0x55bc] = "jiē"; /* 喼 */
dict[0x55bd] = "lóu,lou"; /* 喽 */
dict[0x55be] = "kù"; /* 喾 */
dict[0x55bf] = "zào,qiāo"; /* 喿 */
dict[0x55c0] = "hù"; /* 嗀 */
dict[0x55c1] = "tí"; /* 嗁 */
dict[0x55c2] = "yáo"; /* 嗂 */
dict[0x55c3] = "hè,xiāo,xiào,hù"; /* 嗃 */
dict[0x55c4] = "shà,á"; /* 嗄 */
dict[0x55c5] = "xiù"; /* 嗅 */
dict[0x55c6] = "qiāng,qiàng"; /* 嗆 */
dict[0x55c7] = "sè"; /* 嗇 */
dict[0x55c8] = "yōng"; /* 嗈 */
dict[0x55c9] = "sù"; /* 嗉 */
dict[0x55ca] = "gòng,hǒng,gǒng"; /* 嗊 */
dict[0x55cb] = "xié"; /* 嗋 */
dict[0x55cc] = "yì,ài"; /* 嗌 */
dict[0x55cd] = "suō"; /* 嗍 */
dict[0x55ce] = "má,mǎ,ma"; /* 嗎 */
dict[0x55cf] = "chā"; /* 嗏 */
dict[0x55d0] = "hài"; /* 嗐 */
dict[0x55d1] = "kē,kè"; /* 嗑 */
dict[0x55d2] = "tà,dā"; /* 嗒 */
dict[0x55d3] = "sǎng"; /* 嗓 */
dict[0x55d4] = "chēn"; /* 嗔 */
dict[0x55d5] = "rù"; /* 嗕 */
dict[0x55d6] = "sōu"; /* 嗖 */
dict[0x55d7] = "wā,gǔ"; /* 嗗 */
dict[0x55d8] = "jī"; /* 嗘 */
dict[0x55d9] = "bēng,pǎng"; /* 嗙 */
dict[0x55da] = "wū"; /* 嗚 */
dict[0x55db] = "xián,qiàn,qiè"; /* 嗛 */
dict[0x55dc] = "shì"; /* 嗜 */
dict[0x55dd] = "gé"; /* 嗝 */
dict[0x55de] = "zī"; /* 嗞 */
dict[0x55df] = "jiē"; /* 嗟 */
dict[0x55e0] = "lào"; /* 嗠 */
dict[0x55e1] = "wēng"; /* 嗡 */
dict[0x55e2] = "wà"; /* 嗢 */
dict[0x55e3] = "sì"; /* 嗣 */
dict[0x55e4] = "chī"; /* 嗤 */
dict[0x55e5] = "háo"; /* 嗥 */
dict[0x55e6] = "suō"; /* 嗦 */
dict[0x55e8] = "hāi,hēi"; /* 嗨 */
dict[0x55e9] = "suǒ"; /* 嗩 */
dict[0x55ea] = "qín"; /* 嗪 */
dict[0x55eb] = "niè"; /* 嗫 */
dict[0x55ec] = "hē"; /* 嗬 */
dict[0x55ed] = "zi"; /* 嗭 */
dict[0x55ee] = "sǎi"; /* 嗮 */
dict[0x55ef] = "ňg,ń,ň"; /* 嗯 */
dict[0x55f0] = "gě"; /* 嗰 */
dict[0x55f1] = "ná"; /* 嗱 */
dict[0x55f2] = "diǎ"; /* 嗲 */
dict[0x55f3] = "ǎi,ài,āi"; /* 嗳 */
dict[0x55f4] = "qiāng"; /* 嗴 */
dict[0x55f5] = "tōng"; /* 嗵 */
dict[0x55f6] = "bì"; /* 嗶 */
dict[0x55f7] = "áo"; /* 嗷 */
dict[0x55f8] = "áo"; /* 嗸 */
dict[0x55f9] = "lián"; /* 嗹 */
dict[0x55fa] = "zuī,suī"; /* 嗺 */
dict[0x55fb] = "zhē,zhè,zhù,zhe"; /* 嗻 */
dict[0x55fc] = "mò"; /* 嗼 */
dict[0x55fd] = "sòu"; /* 嗽 */
dict[0x55fe] = "sǒu"; /* 嗾 */
dict[0x55ff] = "tǎn"; /* 嗿 */
dict[0x5600] = "dí"; /* 嘀 */
dict[0x5601] = "qī"; /* 嘁 */
dict[0x5602] = "jiào"; /* 嘂 */
dict[0x5603] = "chōng"; /* 嘃 */
dict[0x5604] = "jiào,dǎo"; /* 嘄 */
dict[0x5605] = "kǎi,gě"; /* 嘅 */
dict[0x5606] = "tàn"; /* 嘆 */
dict[0x5607] = "shān,càn"; /* 嘇 */
dict[0x5608] = "cáo"; /* 嘈 */
dict[0x5609] = "jiā"; /* 嘉 */
dict[0x560a] = "ái"; /* 嘊 */
dict[0x560b] = "xiào"; /* 嘋 */
dict[0x560c] = "piāo"; /* 嘌 */
dict[0x560d] = "lóu,lou"; /* 嘍 */
dict[0x560e] = "gā,gá,gǎ"; /* 嘎 */
dict[0x560f] = "gǔ"; /* 嘏 */
dict[0x5610] = "xiāo,jiāo"; /* 嘐 */
dict[0x5611] = "hū"; /* 嘑 */
dict[0x5612] = "huì"; /* 嘒 */
dict[0x5613] = "guō"; /* 嘓 */
dict[0x5614] = "ǒu,ōu,òu"; /* 嘔 */
dict[0x5615] = "xiān"; /* 嘕 */
dict[0x5616] = "zé"; /* 嘖 */
dict[0x5617] = "cháng"; /* 嘗 */
dict[0x5618] = "xū,shī"; /* 嘘 */
dict[0x5619] = "pó"; /* 嘙 */
dict[0x561a] = "dē,dēi"; /* 嘚 */
dict[0x561b] = "má,ma"; /* 嘛 */
dict[0x561c] = "mà"; /* 嘜 */
dict[0x561d] = "hú"; /* 嘝 */
dict[0x561e] = "lei,lē"; /* 嘞 */
dict[0x561f] = "dū"; /* 嘟 */
dict[0x5620] = "gā,gá,gǎ"; /* 嘠 */
dict[0x5621] = "tāng"; /* 嘡 */
dict[0x5622] = "yě"; /* 嘢 */
dict[0x5623] = "bēng"; /* 嘣 */
dict[0x5624] = "yīng"; /* 嘤 */
dict[0x5625] = "sāi"; /* 嘥 */
dict[0x5626] = "jiào"; /* 嘦 */
dict[0x5627] = "mì"; /* 嘧 */
dict[0x5628] = "xiào"; /* 嘨 */
dict[0x5629] = "huá,huā"; /* 嘩 */
dict[0x562a] = "mǎi"; /* 嘪 */
dict[0x562b] = "rán"; /* 嘫 */
dict[0x562c] = "zuō"; /* 嘬 */
dict[0x562d] = "pēng"; /* 嘭 */
dict[0x562e] = "lào,láo"; /* 嘮 */
dict[0x562f] = "xiào"; /* 嘯 */
dict[0x5630] = "jī"; /* 嘰 */
dict[0x5631] = "zhǔ"; /* 嘱 */
dict[0x5632] = "cháo,zhāo"; /* 嘲 */
dict[0x5633] = "kuì"; /* 嘳 */
dict[0x5634] = "zuǐ"; /* 嘴 */
dict[0x5635] = "xiāo"; /* 嘵 */
dict[0x5636] = "sī"; /* 嘶 */
dict[0x5637] = "háo"; /* 嘷 */
dict[0x5638] = "fǔ"; /* 嘸 */
dict[0x5639] = "liáo"; /* 嘹 */
dict[0x563a] = "qiáo,qiào"; /* 嘺 */
dict[0x563b] = "xī"; /* 嘻 */
dict[0x563c] = "chù,xù,shòu"; /* 嘼 */
dict[0x563d] = "tān,chǎn"; /* 嘽 */
dict[0x563e] = "dàn,tán"; /* 嘾 */
dict[0x563f] = "hēi,mò"; /* 嘿 */
dict[0x5640] = "xùn"; /* 噀 */
dict[0x5641] = "ě"; /* 噁 */
dict[0x5642] = "zūn"; /* 噂 */
dict[0x5643] = "fān,bo"; /* 噃 */
dict[0x5644] = "chī"; /* 噄 */
dict[0x5645] = "huī"; /* 噅 */
dict[0x5646] = "zǎn"; /* 噆 */
dict[0x5647] = "chuáng"; /* 噇 */
dict[0x5648] = "cù,zā,hé"; /* 噈 */
dict[0x5649] = "dàn"; /* 噉 */
dict[0x564a] = "jué"; /* 噊 */
dict[0x564b] = "tūn,kuò"; /* 噋 */
dict[0x564c] = "cēng"; /* 噌 */
dict[0x564d] = "jiào"; /* 噍 */
dict[0x564e] = "yē"; /* 噎 */
dict[0x564f] = "xī"; /* 噏 */
dict[0x5650] = "qì"; /* 噐 */
dict[0x5651] = "háo"; /* 噑 */
dict[0x5652] = "lián"; /* 噒 */
dict[0x5653] = "xū,shī"; /* 噓 */
dict[0x5654] = "dēng"; /* 噔 */
dict[0x5655] = "huī"; /* 噕 */
dict[0x5656] = "yín"; /* 噖 */
dict[0x5657] = "pū"; /* 噗 */
dict[0x5658] = "juē"; /* 噘 */
dict[0x5659] = "qín"; /* 噙 */
dict[0x565a] = "xún"; /* 噚 */
dict[0x565b] = "niè"; /* 噛 */
dict[0x565c] = "lū"; /* 噜 */
dict[0x565d] = "sī"; /* 噝 */
dict[0x565e] = "yǎn"; /* 噞 */
dict[0x565f] = "yīng"; /* 噟 */
dict[0x5660] = "dā"; /* 噠 */
dict[0x5661] = "zhān"; /* 噡 */
dict[0x5662] = "ō"; /* 噢 */
dict[0x5663] = "zhòu,zhuó"; /* 噣 */
dict[0x5664] = "jìn"; /* 噤 */
dict[0x5665] = "nóng"; /* 噥 */
dict[0x5666] = "yuě,huì"; /* 噦 */
dict[0x5667] = "xiè"; /* 噧 */
dict[0x5668] = "qì"; /* 器 */
dict[0x5669] = "è"; /* 噩 */
dict[0x566a] = "zào"; /* 噪 */
dict[0x566b] = "yī"; /* 噫 */
dict[0x566c] = "shì"; /* 噬 */
dict[0x566d] = "jiào,qiào,chī"; /* 噭 */
dict[0x566e] = "yuàn"; /* 噮 */
dict[0x566f] = "ǎi,ài,āi"; /* 噯 */
dict[0x5670] = "yōng,yǒng"; /* 噰 */
dict[0x5671] = "jué,xué"; /* 噱 */
dict[0x5672] = "kuài"; /* 噲 */
dict[0x5673] = "yǔ"; /* 噳 */
dict[0x5674] = "pēn,pèn"; /* 噴 */
dict[0x5675] = "dào"; /* 噵 */
dict[0x5676] = "gá"; /* 噶 */
dict[0x5677] = "xīn,hěn,hèn"; /* 噷 */
dict[0x5678] = "dūn"; /* 噸 */
dict[0x5679] = "dāng"; /* 噹 */
dict[0x567a] = "xīn"; /* 噺 */
dict[0x567b] = "sāi"; /* 噻 */
dict[0x567c] = "pī"; /* 噼 */
dict[0x567d] = "pǐ"; /* 噽 */
dict[0x567e] = "yīn"; /* 噾 */
dict[0x567f] = "zuǐ"; /* 噿 */
dict[0x5680] = "níng"; /* 嚀 */
dict[0x5681] = "dí"; /* 嚁 */
dict[0x5682] = "làn"; /* 嚂 */
dict[0x5683] = "tà"; /* 嚃 */
dict[0x5684] = "huò,ǒ"; /* 嚄 */
dict[0x5685] = "rú"; /* 嚅 */
dict[0x5686] = "hāo"; /* 嚆 */
dict[0x5687] = "hè,xià"; /* 嚇 */
dict[0x5688] = "yàn"; /* 嚈 */
dict[0x5689] = "duō"; /* 嚉 */
dict[0x568a] = "xiù,pì"; /* 嚊 */
dict[0x568b] = "zhōu,chóu"; /* 嚋 */
dict[0x568c] = "jì,jiē,zhāi"; /* 嚌 */
dict[0x568d] = "jìn"; /* 嚍 */
dict[0x568e] = "háo"; /* 嚎 */
dict[0x568f] = "tì"; /* 嚏 */
dict[0x5690] = "cháng"; /* 嚐 */
dict[0x5691] = "xūn"; /* 嚑 */
dict[0x5692] = "mē"; /* 嚒 */
dict[0x5693] = "cā,chā"; /* 嚓 */
dict[0x5694] = "tì"; /* 嚔 */
dict[0x5695] = "lū"; /* 嚕 */
dict[0x5696] = "huì"; /* 嚖 */
dict[0x5697] = "bó,pào,bào"; /* 嚗 */
dict[0x5698] = "yōu"; /* 嚘 */
dict[0x5699] = "niè"; /* 嚙 */
dict[0x569a] = "yín"; /* 嚚 */
dict[0x569b] = "hù"; /* 嚛 */
dict[0x569c] = "mèi,me,mò"; /* 嚜 */
dict[0x569d] = "hōng"; /* 嚝 */
dict[0x569e] = "zhé"; /* 嚞 */
dict[0x569f] = "lí"; /* 嚟 */
dict[0x56a0] = "liú"; /* 嚠 */
dict[0x56a1] = "xié,hái"; /* 嚡 */
dict[0x56a2] = "náng"; /* 嚢 */
dict[0x56a3] = "xiāo"; /* 嚣 */
dict[0x56a4] = "mō"; /* 嚤 */
dict[0x56a5] = "yàn"; /* 嚥 */
dict[0x56a6] = "lì"; /* 嚦 */
dict[0x56a7] = "lú"; /* 嚧 */
dict[0x56a8] = "lóng"; /* 嚨 */
dict[0x56a9] = "pó"; /* 嚩 */
dict[0x56aa] = "dàn"; /* 嚪 */
dict[0x56ab] = "chèn"; /* 嚫 */
dict[0x56ac] = "pín"; /* 嚬 */
dict[0x56ad] = "pǐ"; /* 嚭 */
dict[0x56ae] = "xiàng"; /* 嚮 */
dict[0x56af] = "huò"; /* 嚯 */
dict[0x56b0] = "mè"; /* 嚰 */
dict[0x56b1] = "xī"; /* 嚱 */
dict[0x56b2] = "duǒ"; /* 嚲 */
dict[0x56b3] = "kù"; /* 嚳 */
dict[0x56b4] = "yán"; /* 嚴 */
dict[0x56b5] = "chán"; /* 嚵 */
dict[0x56b6] = "yīng"; /* 嚶 */
dict[0x56b7] = "rǎng,rāng"; /* 嚷 */
dict[0x56b8] = "diǎn"; /* 嚸 */
dict[0x56b9] = "lá"; /* 嚹 */
dict[0x56ba] = "tà"; /* 嚺 */
dict[0x56bb] = "xiāo"; /* 嚻 */
dict[0x56bc] = "jiáo,jué,jiào"; /* 嚼 */
dict[0x56bd] = "chuò"; /* 嚽 */
dict[0x56be] = "huàn,huān"; /* 嚾 */
dict[0x56bf] = "huò"; /* 嚿 */
dict[0x56c0] = "zhuàn"; /* 囀 */
dict[0x56c1] = "niè"; /* 囁 */
dict[0x56c2] = "xiāo"; /* 囂 */
dict[0x56c3] = "zá,cà"; /* 囃 */
dict[0x56c4] = "lí"; /* 囄 */
dict[0x56c5] = "chǎn"; /* 囅 */
dict[0x56c6] = "chài"; /* 囆 */
dict[0x56c7] = "lì"; /* 囇 */
dict[0x56c8] = "yì"; /* 囈 */
dict[0x56c9] = "luō,luó,luo"; /* 囉 */
dict[0x56ca] = "náng,nāng"; /* 囊 */
dict[0x56cb] = "zá,zàn,cān"; /* 囋 */
dict[0x56cc] = "sū"; /* 囌 */
dict[0x56cd] = "xǐ"; /* 囍 */
dict[0x56ce] = "zèng"; /* 囎 */
dict[0x56cf] = "jiān"; /* 囏 */
dict[0x56d0] = "yàn,zá,niè"; /* 囐 */
dict[0x56d1] = "zhǔ"; /* 囑 */
dict[0x56d2] = "lán"; /* 囒 */
dict[0x56d3] = "niè"; /* 囓 */
dict[0x56d4] = "nāng"; /* 囔 */
dict[0x56d6] = "luó,luō,luo"; /* 囖 */
dict[0x56d7] = "wéi,guó"; /* 囗 */
dict[0x56d8] = "huí"; /* 囘 */
dict[0x56d9] = "yīn"; /* 囙 */
dict[0x56da] = "qiú"; /* 囚 */
dict[0x56db] = "sì"; /* 四 */
dict[0x56dc] = "nín"; /* 囜 */
dict[0x56dd] = "jiǎn,nān"; /* 囝 */
dict[0x56de] = "huí"; /* 回 */
dict[0x56df] = "xìn"; /* 囟 */
dict[0x56e0] = "yīn"; /* 因 */
dict[0x56e1] = "nān"; /* 囡 */
dict[0x56e2] = "tuán"; /* 团 */
dict[0x56e3] = "tuán"; /* 団 */
dict[0x56e4] = "dùn,tún"; /* 囤 */
dict[0x56e5] = "kàng"; /* 囥 */
dict[0x56e6] = "yuān"; /* 囦 */
dict[0x56e7] = "jiǒng"; /* 囧 */
dict[0x56e8] = "piān"; /* 囨 */
dict[0x56e9] = "yún"; /* 囩 */
dict[0x56ea] = "cōng"; /* 囪 */
dict[0x56eb] = "hú"; /* 囫 */
dict[0x56ec] = "huí"; /* 囬 */
dict[0x56ed] = "yuán"; /* 园 */
dict[0x56ee] = "é"; /* 囮 */
dict[0x56ef] = "guó"; /* 囯 */
dict[0x56f0] = "kùn"; /* 困 */
dict[0x56f1] = "cōng"; /* 囱 */
dict[0x56f2] = "wéi,tōng"; /* 囲 */
dict[0x56f3] = "tú"; /* 図 */
dict[0x56f4] = "wéi"; /* 围 */
dict[0x56f5] = "lún"; /* 囵 */
dict[0x56f6] = "guó"; /* 囶 */
dict[0x56f7] = "qūn"; /* 囷 */
dict[0x56f8] = "rì"; /* 囸 */
dict[0x56f9] = "líng"; /* 囹 */
dict[0x56fa] = "gù"; /* 固 */
dict[0x56fb] = "guó"; /* 囻 */
dict[0x56fc] = "tāi"; /* 囼 */
dict[0x56fd] = "guó"; /* 国 */
dict[0x56fe] = "tú"; /* 图 */
dict[0x56ff] = "yòu"; /* 囿 */
dict[0x5700] = "guó"; /* 圀 */
dict[0x5701] = "yín"; /* 圁 */
dict[0x5702] = "hùn"; /* 圂 */
dict[0x5703] = "pǔ"; /* 圃 */
dict[0x5704] = "yǔ"; /* 圄 */
dict[0x5705] = "hán"; /* 圅 */
dict[0x5706] = "yuán"; /* 圆 */
dict[0x5707] = "lún"; /* 圇 */
dict[0x5708] = "quān,juàn,juān"; /* 圈 */
dict[0x5709] = "yǔ"; /* 圉 */
dict[0x570a] = "qīng"; /* 圊 */
dict[0x570b] = "guó"; /* 國 */
dict[0x570c] = "chuán,chuí"; /* 圌 */
dict[0x570d] = "wéi"; /* 圍 */
dict[0x570e] = "yuán"; /* 圎 */
dict[0x570f] = "quān,juàn,juān"; /* 圏 */
dict[0x5710] = "kū"; /* 圐 */
dict[0x5711] = "pǔ"; /* 圑 */
dict[0x5712] = "yuán"; /* 園 */
dict[0x5713] = "yuán"; /* 圓 */
dict[0x5714] = "yà"; /* 圔 */
dict[0x5715] = "tuān"; /* 圕 */
dict[0x5716] = "tú"; /* 圖 */
dict[0x5717] = "tú"; /* 圗 */
dict[0x5718] = "tuán"; /* 團 */
dict[0x5719] = "lüè"; /* 圙 */
dict[0x571a] = "huì"; /* 圚 */
dict[0x571b] = "yì"; /* 圛 */
dict[0x571c] = "huán,yuán"; /* 圜 */
dict[0x571d] = "luán"; /* 圝 */
dict[0x571e] = "luán"; /* 圞 */
dict[0x571f] = "tǔ"; /* 土 */
dict[0x5720] = "yà"; /* 圠 */
dict[0x5721] = "tǔ"; /* 圡 */
dict[0x5722] = "tǐng"; /* 圢 */
dict[0x5723] = "shèng"; /* 圣 */
dict[0x5724] = "pú"; /* 圤 */
dict[0x5725] = "lù"; /* 圥 */
dict[0x5726] = "kuài"; /* 圦 */
dict[0x5727] = "yā"; /* 圧 */
dict[0x5728] = "zài"; /* 在 */
dict[0x5729] = "wéi,xū"; /* 圩 */
dict[0x572a] = "gē"; /* 圪 */
dict[0x572b] = "yù,zhūn"; /* 圫 */
dict[0x572c] = "wū"; /* 圬 */
dict[0x572d] = "guī"; /* 圭 */
dict[0x572e] = "pǐ"; /* 圮 */
dict[0x572f] = "yí"; /* 圯 */
dict[0x5730] = "dì,de"; /* 地 */
dict[0x5731] = "qiān,sú"; /* 圱 */
dict[0x5732] = "qiān"; /* 圲 */
dict[0x5733] = "zhèn"; /* 圳 */
dict[0x5734] = "zhuó"; /* 圴 */
dict[0x5735] = "dàng"; /* 圵 */
dict[0x5736] = "qià"; /* 圶 */
dict[0x5737] = "xià"; /* 圷 */
dict[0x5738] = "shān"; /* 圸 */
dict[0x5739] = "kuàng"; /* 圹 */
dict[0x573a] = "cháng,chǎng"; /* 场 */
dict[0x573b] = "qí,yín"; /* 圻 */
dict[0x573c] = "niè"; /* 圼 */
dict[0x573d] = "mò"; /* 圽 */
dict[0x573e] = "jī"; /* 圾 */
dict[0x573f] = "jiá"; /* 圿 */
dict[0x5740] = "zhǐ"; /* 址 */
dict[0x5741] = "zhǐ,zhì"; /* 坁 */
dict[0x5742] = "bǎn"; /* 坂 */
dict[0x5743] = "xūn"; /* 坃 */
dict[0x5744] = "yì"; /* 坄 */
dict[0x5745] = "qǐn"; /* 坅 */
dict[0x5746] = "méi,fén"; /* 坆 */
dict[0x5747] = "jūn"; /* 均 */
dict[0x5748] = "rǒng,kēng"; /* 坈 */
dict[0x5749] = "tún,dùn"; /* 坉 */
dict[0x574a] = "fāng,fáng"; /* 坊 */
dict[0x574b] = "bèn,fèn"; /* 坋 */
dict[0x574c] = "bèn"; /* 坌 */
dict[0x574d] = "tān"; /* 坍 */
dict[0x574e] = "kǎn"; /* 坎 */
dict[0x574f] = "huài"; /* 坏 */
dict[0x5750] = "zuò"; /* 坐 */
dict[0x5751] = "kēng"; /* 坑 */
dict[0x5752] = "bì"; /* 坒 */
dict[0x5753] = "jǐng"; /* 坓 */
dict[0x5754] = "dì,làn"; /* 坔 */
dict[0x5755] = "jīng"; /* 坕 */
dict[0x5756] = "jì"; /* 坖 */
dict[0x5757] = "kuài"; /* 块 */
dict[0x5758] = "dǐ"; /* 坘 */
dict[0x5759] = "jīng"; /* 坙 */
dict[0x575a] = "jiān"; /* 坚 */
dict[0x575b] = "tán"; /* 坛 */
dict[0x575c] = "lì"; /* 坜 */
dict[0x575d] = "bà"; /* 坝 */
dict[0x575e] = "wù"; /* 坞 */
dict[0x575f] = "fén"; /* 坟 */
dict[0x5760] = "zhuì"; /* 坠 */
dict[0x5761] = "pō"; /* 坡 */
dict[0x5762] = "pǎn,bàn"; /* 坢 */
dict[0x5763] = "táng"; /* 坣 */
dict[0x5764] = "kūn"; /* 坤 */
dict[0x5765] = "qū"; /* 坥 */
dict[0x5766] = "tǎn"; /* 坦 */
dict[0x5767] = "zhǐ"; /* 坧 */
dict[0x5768] = "tuó"; /* 坨 */
dict[0x5769] = "gān"; /* 坩 */
dict[0x576a] = "píng"; /* 坪 */
dict[0x576b] = "diàn"; /* 坫 */
dict[0x576c] = "guà"; /* 坬 */
dict[0x576d] = "ní"; /* 坭 */
dict[0x576e] = "tái"; /* 坮 */
dict[0x576f] = "pī"; /* 坯 */
dict[0x5770] = "jiōng"; /* 坰 */
dict[0x5771] = "yǎng"; /* 坱 */
dict[0x5772] = "fó"; /* 坲 */
dict[0x5773] = "ào"; /* 坳 */
dict[0x5774] = "lù"; /* 坴 */
dict[0x5775] = "qiū"; /* 坵 */
dict[0x5776] = "mù,mǔ"; /* 坶 */
dict[0x5777] = "kē,kě"; /* 坷 */
dict[0x5778] = "gòu"; /* 坸 */
dict[0x5779] = "xuè"; /* 坹 */
dict[0x577a] = "fá"; /* 坺 */
dict[0x577b] = "dǐ,chí"; /* 坻 */
dict[0x577c] = "chè"; /* 坼 */
dict[0x577d] = "líng"; /* 坽 */
dict[0x577e] = "zhù"; /* 坾 */
dict[0x577f] = "fù"; /* 坿 */
dict[0x5780] = "hū"; /* 垀 */
dict[0x5781] = "zhì"; /* 垁 */
dict[0x5782] = "chuí"; /* 垂 */
dict[0x5783] = "lā"; /* 垃 */
dict[0x5784] = "lǒng"; /* 垄 */
dict[0x5785] = "lǒng"; /* 垅 */
dict[0x5786] = "lú"; /* 垆 */
dict[0x5787] = "ào"; /* 垇 */
dict[0x5788] = "dài"; /* 垈 */
dict[0x5789] = "páo"; /* 垉 */
dict[0x578a] = "mín"; /* 垊 */
dict[0x578b] = "xíng"; /* 型 */
dict[0x578c] = "dòng,tóng"; /* 垌 */
dict[0x578d] = "jì"; /* 垍 */
dict[0x578e] = "hè"; /* 垎 */
dict[0x578f] = "lǜ"; /* 垏 */
dict[0x5790] = "cí"; /* 垐 */
dict[0x5791] = "chǐ"; /* 垑 */
dict[0x5792] = "lěi"; /* 垒 */
dict[0x5793] = "gāi"; /* 垓 */
dict[0x5794] = "yīn"; /* 垔 */
dict[0x5795] = "hòu"; /* 垕 */
dict[0x5796] = "duī"; /* 垖 */
dict[0x5797] = "zhào"; /* 垗 */
dict[0x5798] = "fú"; /* 垘 */
dict[0x5799] = "guāng"; /* 垙 */
dict[0x579a] = "yáo"; /* 垚 */
dict[0x579b] = "duǒ,duò"; /* 垛 */
dict[0x579c] = "duǒ,duò"; /* 垜 */
dict[0x579d] = "guǐ"; /* 垝 */
dict[0x579e] = "chá"; /* 垞 */
dict[0x579f] = "yáng"; /* 垟 */
dict[0x57a0] = "yín"; /* 垠 */
dict[0x57a1] = "fá"; /* 垡 */
dict[0x57a2] = "gòu"; /* 垢 */
dict[0x57a3] = "yuán"; /* 垣 */
dict[0x57a4] = "dié"; /* 垤 */
dict[0x57a5] = "xié"; /* 垥 */
dict[0x57a6] = "kěn"; /* 垦 */
dict[0x57a7] = "shǎng"; /* 垧 */
dict[0x57a8] = "shǒu"; /* 垨 */
dict[0x57a9] = "è"; /* 垩 */
dict[0x57aa] = "bìng"; /* 垪 */
dict[0x57ab] = "diàn"; /* 垫 */
dict[0x57ac] = "hóng"; /* 垬 */
dict[0x57ad] = "yā"; /* 垭 */
dict[0x57ae] = "kuǎ"; /* 垮 */
dict[0x57af] = "dá"; /* 垯 */
dict[0x57b0] = "kǎ"; /* 垰 */
dict[0x57b1] = "dàng"; /* 垱 */
dict[0x57b2] = "kǎi"; /* 垲 */
dict[0x57b3] = "háng"; /* 垳 */
dict[0x57b4] = "nǎo"; /* 垴 */
dict[0x57b5] = "ǎn"; /* 垵 */
dict[0x57b6] = "xīng"; /* 垶 */
dict[0x57b7] = "xiàn"; /* 垷 */
dict[0x57b8] = "yuàn,huán"; /* 垸 */
dict[0x57b9] = "bāng"; /* 垹 */
dict[0x57ba] = "póu,fú"; /* 垺 */
dict[0x57bb] = "bà"; /* 垻 */
dict[0x57bc] = "yì"; /* 垼 */
dict[0x57bd] = "yìn"; /* 垽 */
dict[0x57be] = "hàn"; /* 垾 */
dict[0x57bf] = "xù"; /* 垿 */
dict[0x57c0] = "chuí"; /* 埀 */
dict[0x57c1] = "cén"; /* 埁 */
dict[0x57c2] = "gěng"; /* 埂 */
dict[0x57c3] = "āi"; /* 埃 */
dict[0x57c4] = "běng,fēng"; /* 埄 */
dict[0x57c5] = "dì,fáng"; /* 埅 */
dict[0x57c6] = "què,jué"; /* 埆 */
dict[0x57c7] = "yǒng"; /* 埇 */
dict[0x57c8] = "jùn"; /* 埈 */
dict[0x57c9] = "xiá,jiā"; /* 埉 */
dict[0x57ca] = "dì"; /* 埊 */
dict[0x57cb] = "mái,mán"; /* 埋 */
dict[0x57cc] = "làng"; /* 埌 */
dict[0x57cd] = "juǎn"; /* 埍 */
dict[0x57ce] = "chéng"; /* 城 */
dict[0x57cf] = "yán,shān"; /* 埏 */
dict[0x57d0] = "qín,jīn"; /* 埐 */
dict[0x57d1] = "zhé"; /* 埑 */
dict[0x57d2] = "liè"; /* 埒 */
dict[0x57d3] = "liè"; /* 埓 */
dict[0x57d4] = "pǔ,bù"; /* 埔 */
dict[0x57d5] = "chéng"; /* 埕 */
dict[0x57d6] = "huā"; /* 埖 */
dict[0x57d7] = "bù"; /* 埗 */
dict[0x57d8] = "shí"; /* 埘 */
dict[0x57d9] = "xūn"; /* 埙 */
dict[0x57da] = "guō"; /* 埚 */
dict[0x57db] = "jiōng"; /* 埛 */
dict[0x57dc] = "yě"; /* 埜 */
dict[0x57dd] = "niàn"; /* 埝 */
dict[0x57de] = "dī"; /* 埞 */
dict[0x57df] = "yù"; /* 域 */
dict[0x57e0] = "bù"; /* 埠 */
dict[0x57e1] = "yà"; /* 埡 */
dict[0x57e2] = "quán"; /* 埢 */
dict[0x57e3] = "suì,sù"; /* 埣 */
dict[0x57e4] = "pí,pì"; /* 埤 */
dict[0x57e5] = "qīng,zhēng"; /* 埥 */
dict[0x57e6] = "wǎn,wān"; /* 埦 */
dict[0x57e7] = "jù"; /* 埧 */
dict[0x57e8] = "lǔn"; /* 埨 */
dict[0x57e9] = "zhēng,chéng"; /* 埩 */
dict[0x57ea] = "kōng"; /* 埪 */
dict[0x57eb] = "chǒng,shǎng"; /* 埫 */
dict[0x57ec] = "dōng"; /* 埬 */
dict[0x57ed] = "dài"; /* 埭 */
dict[0x57ee] = "tán,tàn"; /* 埮 */
dict[0x57ef] = "ǎn"; /* 埯 */
dict[0x57f0] = "cǎi,cài"; /* 埰 */
dict[0x57f1] = "chù,tòu"; /* 埱 */
dict[0x57f2] = "běng"; /* 埲 */
dict[0x57f3] = "xiàn,kǎn"; /* 埳 */
dict[0x57f4] = "zhí"; /* 埴 */
dict[0x57f5] = "duǒ"; /* 埵 */
dict[0x57f6] = "yì,shì"; /* 埶 */
dict[0x57f7] = "zhí"; /* 執 */
dict[0x57f8] = "yì"; /* 埸 */
dict[0x57f9] = "péi"; /* 培 */
dict[0x57fa] = "jī"; /* 基 */
dict[0x57fb] = "zhǔn"; /* 埻 */
dict[0x57fc] = "qí"; /* 埼 */
dict[0x57fd] = "sào,sǎo"; /* 埽 */
dict[0x57fe] = "jù"; /* 埾 */
dict[0x57ff] = "ní"; /* 埿 */
dict[0x5800] = "kū"; /* 堀 */
dict[0x5801] = "kè"; /* 堁 */
dict[0x5802] = "táng"; /* 堂 */
dict[0x5803] = "kūn"; /* 堃 */
dict[0x5804] = "nì"; /* 堄 */
dict[0x5805] = "jiān"; /* 堅 */
dict[0x5806] = "duī"; /* 堆 */
dict[0x5807] = "jīn"; /* 堇 */
dict[0x5808] = "gāng"; /* 堈 */
dict[0x5809] = "yù"; /* 堉 */
dict[0x580a] = "è"; /* 堊 */
dict[0x580b] = "péng,bèng"; /* 堋 */
dict[0x580c] = "gù"; /* 堌 */
dict[0x580d] = "tù"; /* 堍 */
dict[0x580e] = "lèng"; /* 堎 */
dict[0x580f] = "fāng"; /* 堏 */
dict[0x5810] = "yá"; /* 堐 */
dict[0x5811] = "qiàn"; /* 堑 */
dict[0x5812] = "kūn"; /* 堒 */
dict[0x5813] = "àn"; /* 堓 */
dict[0x5814] = "shēn"; /* 堔 */
dict[0x5815] = "duò,huī"; /* 堕 */
dict[0x5816] = "nǎo"; /* 堖 */
dict[0x5817] = "tū"; /* 堗 */
dict[0x5818] = "chéng"; /* 堘 */
dict[0x5819] = "yīn"; /* 堙 */
dict[0x581a] = "huán"; /* 堚 */
dict[0x581b] = "bì"; /* 堛 */
dict[0x581c] = "liàn"; /* 堜 */
dict[0x581d] = "guō"; /* 堝 */
dict[0x581e] = "dié"; /* 堞 */
dict[0x581f] = "zhuàn"; /* 堟 */
dict[0x5820] = "hòu"; /* 堠 */
dict[0x5821] = "bǎo,bǔ,pù"; /* 堡 */
dict[0x5822] = "bǎo"; /* 堢 */
dict[0x5823] = "yú"; /* 堣 */
dict[0x5824] = "dī"; /* 堤 */
dict[0x5825] = "máo,móu,wǔ"; /* 堥 */
dict[0x5826] = "jiē"; /* 堦 */
dict[0x5827] = "ruán"; /* 堧 */
dict[0x5828] = "è,ài,yè"; /* 堨 */
dict[0x5829] = "gèng"; /* 堩 */
dict[0x582a] = "kān"; /* 堪 */
dict[0x582b] = "zōng"; /* 堫 */
dict[0x582c] = "yú"; /* 堬 */
dict[0x582d] = "huáng"; /* 堭 */
dict[0x582e] = "è"; /* 堮 */
dict[0x582f] = "yáo"; /* 堯 */
dict[0x5830] = "yàn"; /* 堰 */
dict[0x5831] = "bào"; /* 報 */
dict[0x5832] = "jí"; /* 堲 */
dict[0x5833] = "méi"; /* 堳 */
dict[0x5834] = "cháng,chǎng"; /* 場 */
dict[0x5835] = "dǔ"; /* 堵 */
dict[0x5836] = "tuó"; /* 堶 */
dict[0x5837] = "yìn"; /* 堷 */
dict[0x5838] = "féng"; /* 堸 */
dict[0x5839] = "zhòng"; /* 堹 */
dict[0x583a] = "jiè"; /* 堺 */
dict[0x583b] = "jīn"; /* 堻 */
dict[0x583c] = "fēng"; /* 堼 */
dict[0x583d] = "gāng"; /* 堽 */
dict[0x583e] = "chuǎn"; /* 堾 */
dict[0x583f] = "jiǎn"; /* 堿 */
dict[0x5840] = "píng"; /* 塀 */
dict[0x5841] = "lěi"; /* 塁 */
dict[0x5842] = "jiǎng"; /* 塂 */
dict[0x5843] = "huāng"; /* 塃 */
dict[0x5844] = "léng"; /* 塄 */
dict[0x5845] = "duàn"; /* 塅 */
dict[0x5846] = "wān"; /* 塆 */
dict[0x5847] = "xuān"; /* 塇 */
dict[0x5848] = "jì"; /* 塈 */
dict[0x5849] = "jí"; /* 塉 */
dict[0x584a] = "kuài"; /* 塊 */
dict[0x584b] = "yíng"; /* 塋 */
dict[0x584c] = "tā"; /* 塌 */
dict[0x584d] = "chéng"; /* 塍 */
dict[0x584e] = "yǒng"; /* 塎 */
dict[0x584f] = "kǎi"; /* 塏 */
dict[0x5850] = "sù"; /* 塐 */
dict[0x5851] = "sù"; /* 塑 */
dict[0x5852] = "shí"; /* 塒 */
dict[0x5853] = "mì"; /* 塓 */
dict[0x5854] = "tǎ"; /* 塔 */
dict[0x5855] = "wěng"; /* 塕 */
dict[0x5856] = "chéng"; /* 塖 */
dict[0x5857] = "tú"; /* 塗 */
dict[0x5858] = "táng"; /* 塘 */
dict[0x5859] = "què"; /* 塙 */
dict[0x585a] = "zhǒng"; /* 塚 */
dict[0x585b] = "lì"; /* 塛 */
dict[0x585c] = "péng"; /* 塜 */
dict[0x585d] = "bàng"; /* 塝 */
dict[0x585e] = "sāi,sài,sè"; /* 塞 */
dict[0x585f] = "zàng"; /* 塟 */
dict[0x5860] = "duī"; /* 塠 */
dict[0x5861] = "tián"; /* 塡 */
dict[0x5862] = "wù"; /* 塢 */
dict[0x5863] = "zhèng"; /* 塣 */
dict[0x5864] = "xūn"; /* 塤 */
dict[0x5865] = "gé"; /* 塥 */
dict[0x5866] = "zhèn"; /* 塦 */
dict[0x5867] = "ài"; /* 塧 */
dict[0x5868] = "gōng"; /* 塨 */
dict[0x5869] = "yán"; /* 塩 */
dict[0x586a] = "xiàn"; /* 塪 */
dict[0x586b] = "tián,zhèn"; /* 填 */
dict[0x586c] = "yuán"; /* 塬 */
dict[0x586d] = "wēn"; /* 塭 */
dict[0x586e] = "xiè"; /* 塮 */
dict[0x586f] = "liù"; /* 塯 */
dict[0x5870] = "hǎi"; /* 塰 */
dict[0x5871] = "lǎng"; /* 塱 */
dict[0x5872] = "cháng,chǎng"; /* 塲 */
dict[0x5873] = "péng"; /* 塳 */
dict[0x5874] = "bèng"; /* 塴 */
dict[0x5875] = "chén"; /* 塵 */
dict[0x5876] = "lù"; /* 塶 */
dict[0x5877] = "lǔ"; /* 塷 */
dict[0x5878] = "ōu,qiū"; /* 塸 */
dict[0x5879] = "qiàn"; /* 塹 */
dict[0x587a] = "méi"; /* 塺 */
dict[0x587b] = "mò"; /* 塻 */
dict[0x587c] = "zhuān,tuán"; /* 塼 */
dict[0x587d] = "shuǎng"; /* 塽 */
dict[0x587e] = "shú"; /* 塾 */
dict[0x587f] = "lǒu"; /* 塿 */
dict[0x5880] = "chí"; /* 墀 */
dict[0x5881] = "màn"; /* 墁 */
dict[0x5882] = "biāo"; /* 墂 */
dict[0x5883] = "jìng"; /* 境 */
dict[0x5884] = "qī"; /* 墄 */
dict[0x5885] = "shù"; /* 墅 */
dict[0x5886] = "zhì,dì"; /* 墆 */
dict[0x5887] = "zhàng"; /* 墇 */
dict[0x5888] = "kàn"; /* 墈 */
dict[0x5889] = "yōng"; /* 墉 */
dict[0x588a] = "diàn"; /* 墊 */
dict[0x588b] = "chěn"; /* 墋 */
dict[0x588c] = "zhǐ,zhuó"; /* 墌 */
dict[0x588d] = "xì"; /* 墍 */
dict[0x588e] = "guō"; /* 墎 */
dict[0x588f] = "qiǎng"; /* 墏 */
dict[0x5890] = "jìn"; /* 墐 */
dict[0x5891] = "dì"; /* 墑 */
dict[0x5892] = "shāng"; /* 墒 */
dict[0x5893] = "mù"; /* 墓 */
dict[0x5894] = "cuī"; /* 墔 */
dict[0x5895] = "yàn"; /* 墕 */
dict[0x5896] = "tǎ"; /* 墖 */
dict[0x5897] = "zēng"; /* 増 */
dict[0x5898] = "qián"; /* 墘 */
dict[0x5899] = "qiáng"; /* 墙 */
dict[0x589a] = "liáng"; /* 墚 */
dict[0x589b] = "wèi"; /* 墛 */
dict[0x589c] = "zhuì"; /* 墜 */
dict[0x589d] = "qiāo"; /* 墝 */
dict[0x589e] = "zēng"; /* 增 */
dict[0x589f] = "xū"; /* 墟 */
dict[0x58a0] = "shàn"; /* 墠 */
dict[0x58a1] = "shàn"; /* 墡 */
dict[0x58a2] = "fá"; /* 墢 */
dict[0x58a3] = "pú"; /* 墣 */
dict[0x58a4] = "kuài,tuí"; /* 墤 */
dict[0x58a5] = "tuǎn,dǒng"; /* 墥 */
dict[0x58a6] = "fán"; /* 墦 */
dict[0x58a7] = "qiáo,què"; /* 墧 */
dict[0x58a8] = "mò"; /* 墨 */
dict[0x58a9] = "dūn"; /* 墩 */
dict[0x58aa] = "dūn"; /* 墪 */
dict[0x58ab] = "zūn,dūn"; /* 墫 */
dict[0x58ac] = "dì"; /* 墬 */
dict[0x58ad] = "shèng"; /* 墭 */
dict[0x58ae] = "duò,huī"; /* 墮 */
dict[0x58af] = "duò"; /* 墯 */
dict[0x58b0] = "tán"; /* 墰 */
dict[0x58b1] = "dèng"; /* 墱 */
dict[0x58b2] = "wú"; /* 墲 */
dict[0x58b3] = "fén"; /* 墳 */
dict[0x58b4] = "huáng"; /* 墴 */
dict[0x58b5] = "tán"; /* 墵 */
dict[0x58b6] = "dā"; /* 墶 */
dict[0x58b7] = "yè"; /* 墷 */
dict[0x58b8] = "zhù"; /* 墸 */
dict[0x58b9] = "jiàn"; /* 墹 */
dict[0x58ba] = "ào"; /* 墺 */
dict[0x58bb] = "qiáng"; /* 墻 */
dict[0x58bc] = "jī"; /* 墼 */
dict[0x58bd] = "qiāo,áo"; /* 墽 */
dict[0x58be] = "kěn"; /* 墾 */
dict[0x58bf] = "yì,tú"; /* 墿 */
dict[0x58c0] = "pí"; /* 壀 */
dict[0x58c1] = "bì"; /* 壁 */
dict[0x58c2] = "diàn"; /* 壂 */
dict[0x58c3] = "jiāng"; /* 壃 */
dict[0x58c4] = "yě"; /* 壄 */
dict[0x58c5] = "yōng"; /* 壅 */
dict[0x58c6] = "xué,bó,jué"; /* 壆 */
dict[0x58c7] = "tán"; /* 壇 */
dict[0x58c8] = "lǎn"; /* 壈 */
dict[0x58c9] = "jù"; /* 壉 */
dict[0x58ca] = "huài"; /* 壊 */
dict[0x58cb] = "dàng"; /* 壋 */
dict[0x58cc] = "rǎng"; /* 壌 */
dict[0x58cd] = "qiàn"; /* 壍 */
dict[0x58ce] = "xūn"; /* 壎 */
dict[0x58cf] = "xiàn,làn"; /* 壏 */
dict[0x58d0] = "xǐ"; /* 壐 */
dict[0x58d1] = "hè"; /* 壑 */
dict[0x58d2] = "ài"; /* 壒 */
dict[0x58d3] = "yā,yà"; /* 壓 */
dict[0x58d4] = "dǎo"; /* 壔 */
dict[0x58d5] = "háo"; /* 壕 */
dict[0x58d6] = "ruán"; /* 壖 */
dict[0x58d7] = "jìn"; /* 壗 */
dict[0x58d8] = "lěi"; /* 壘 */
dict[0x58d9] = "kuàng"; /* 壙 */
dict[0x58da] = "lú"; /* 壚 */
dict[0x58db] = "yán"; /* 壛 */
dict[0x58dc] = "tán"; /* 壜 */
dict[0x58dd] = "wéi"; /* 壝 */
dict[0x58de] = "huài"; /* 壞 */
dict[0x58df] = "lǒng"; /* 壟 */
dict[0x58e0] = "lǒng"; /* 壠 */
dict[0x58e1] = "ruǐ"; /* 壡 */
dict[0x58e2] = "lì"; /* 壢 */
dict[0x58e3] = "lín"; /* 壣 */
dict[0x58e4] = "rǎng"; /* 壤 */
dict[0x58e5] = "chán"; /* 壥 */
dict[0x58e6] = "xūn"; /* 壦 */
dict[0x58e7] = "yán"; /* 壧 */
dict[0x58e8] = "lěi"; /* 壨 */
dict[0x58e9] = "bà"; /* 壩 */
dict[0x58ea] = "wān"; /* 壪 */
dict[0x58eb] = "shì"; /* 士 */
dict[0x58ec] = "rén"; /* 壬 */
dict[0x58ed] = "san"; /* 壭 */
dict[0x58ee] = "zhuàng"; /* 壮 */
dict[0x58ef] = "zhuàng"; /* 壯 */
dict[0x58f0] = "shēng"; /* 声 */
dict[0x58f1] = "yī"; /* 壱 */
dict[0x58f2] = "mài"; /* 売 */
dict[0x58f3] = "ké,qiào"; /* 壳 */
dict[0x58f4] = "zhù"; /* 壴 */
dict[0x58f5] = "zhuàng"; /* 壵 */
dict[0x58f6] = "hú"; /* 壶 */
dict[0x58f7] = "hú"; /* 壷 */
dict[0x58f8] = "kǔn"; /* 壸 */
dict[0x58f9] = "yī"; /* 壹 */
dict[0x58fa] = "hú"; /* 壺 */
dict[0x58fb] = "xù"; /* 壻 */
dict[0x58fc] = "kǔn"; /* 壼 */
dict[0x58fd] = "shòu"; /* 壽 */
dict[0x58fe] = "mǎng"; /* 壾 */
dict[0x58ff] = "cún"; /* 壿 */
dict[0x5900] = "shòu"; /* 夀 */
dict[0x5901] = "yī"; /* 夁 */
dict[0x5902] = "zhǐ,zhōng"; /* 夂 */
dict[0x5903] = "gǔ,yíng"; /* 夃 */
dict[0x5904] = "chǔ,chù"; /* 处 */
dict[0x5905] = "jiàng,xiáng"; /* 夅 */
dict[0x5906] = "féng,fēng,páng"; /* 夆 */
dict[0x5907] = "bèi"; /* 备 */
dict[0x5908] = "zhāi"; /* 夈 */
dict[0x5909] = "biàn"; /* 変 */
dict[0x590a] = "suī"; /* 夊 */
dict[0x590b] = "qūn"; /* 夋 */
dict[0x590c] = "líng"; /* 夌 */
dict[0x590d] = "fù"; /* 复 */
dict[0x590e] = "cuò"; /* 夎 */
dict[0x590f] = "xià"; /* 夏 */
dict[0x5910] = "xiòng,xuàn"; /* 夐 */
dict[0x5911] = "xiè"; /* 夑 */
dict[0x5912] = "náo"; /* 夒 */
dict[0x5913] = "xià"; /* 夓 */
dict[0x5914] = "kuí"; /* 夔 */
dict[0x5915] = "xī"; /* 夕 */
dict[0x5916] = "wài"; /* 外 */
dict[0x5917] = "yuàn,wǎn,wān,yuān"; /* 夗 */
dict[0x5918] = "mǎo,wǎn"; /* 夘 */
dict[0x5919] = "sù"; /* 夙 */
dict[0x591a] = "duō"; /* 多 */
dict[0x591b] = "duō"; /* 夛 */
dict[0x591c] = "yè"; /* 夜 */
dict[0x591d] = "qíng"; /* 夝 */
dict[0x591f] = "gòu"; /* 够 */
dict[0x5920] = "gòu"; /* 夠 */
dict[0x5921] = "qì"; /* 夡 */
dict[0x5922] = "mèng"; /* 夢 */
dict[0x5923] = "mèng"; /* 夣 */
dict[0x5924] = "yín"; /* 夤 */
dict[0x5925] = "huǒ"; /* 夥 */
dict[0x5926] = "chěn"; /* 夦 */
dict[0x5927] = "dà,dài,tài"; /* 大 */
dict[0x5928] = "cè"; /* 夨 */
dict[0x5929] = "tiān"; /* 天 */
dict[0x592a] = "tài"; /* 太 */
dict[0x592b] = "fū,fú"; /* 夫 */
dict[0x592c] = "guài"; /* 夬 */
dict[0x592d] = "yāo"; /* 夭 */
dict[0x592e] = "yāng"; /* 央 */
dict[0x592f] = "hāng,bèn"; /* 夯 */
dict[0x5930] = "gǎo"; /* 夰 */
dict[0x5931] = "shī"; /* 失 */
dict[0x5932] = "tāo,běn"; /* 夲 */
dict[0x5933] = "tài"; /* 夳 */
dict[0x5934] = "tóu,tou"; /* 头 */
dict[0x5935] = "yǎn,tāo"; /* 夵 */
dict[0x5936] = "bǐ"; /* 夶 */
dict[0x5937] = "yí"; /* 夷 */
dict[0x5938] = "kuā,kuà"; /* 夸 */
dict[0x5939] = "jiā,jiá,gā"; /* 夹 */
dict[0x593a] = "duó"; /* 夺 */
dict[0x593b] = "huà"; /* 夻 */
dict[0x593c] = "kuǎng"; /* 夼 */
dict[0x593d] = "yǔn"; /* 夽 */
dict[0x593e] = "jiā,jiá,gā"; /* 夾 */
dict[0x593f] = "bā"; /* 夿 */
dict[0x5940] = "ēn"; /* 奀 */
dict[0x5941] = "lián"; /* 奁 */
dict[0x5942] = "huàn"; /* 奂 */
dict[0x5943] = "dī,tì"; /* 奃 */
dict[0x5944] = "yǎn,yān"; /* 奄 */
dict[0x5945] = "pào"; /* 奅 */
dict[0x5946] = "juàn"; /* 奆 */
dict[0x5947] = "qí,jī"; /* 奇 */
dict[0x5948] = "nài"; /* 奈 */
dict[0x5949] = "fèng"; /* 奉 */
dict[0x594a] = "xié"; /* 奊 */
dict[0x594b] = "fèn"; /* 奋 */
dict[0x594c] = "diǎn"; /* 奌 */
dict[0x594d] = "quān,juàn"; /* 奍 */
dict[0x594e] = "kuí"; /* 奎 */
dict[0x594f] = "zòu"; /* 奏 */
dict[0x5950] = "huàn"; /* 奐 */
dict[0x5951] = "qì,qiè,xiè"; /* 契 */
dict[0x5952] = "kāi"; /* 奒 */
dict[0x5953] = "shē,chǐ,zhà"; /* 奓 */
dict[0x5954] = "bēn,bèn"; /* 奔 */
dict[0x5955] = "yì"; /* 奕 */
dict[0x5956] = "jiǎng"; /* 奖 */
dict[0x5957] = "tào"; /* 套 */
dict[0x5958] = "zàng,zhuǎng"; /* 奘 */
dict[0x5959] = "běn"; /* 奙 */
dict[0x595a] = "xī"; /* 奚 */
dict[0x595b] = "huǎng"; /* 奛 */
dict[0x595c] = "fěi"; /* 奜 */
dict[0x595d] = "diāo"; /* 奝 */
dict[0x595e] = "xùn,zhuì"; /* 奞 */
dict[0x595f] = "bēng"; /* 奟 */
dict[0x5960] = "diàn"; /* 奠 */
dict[0x5961] = "ào"; /* 奡 */
dict[0x5962] = "shē"; /* 奢 */
dict[0x5963] = "wěng"; /* 奣 */
dict[0x5964] = "pò,hǎ,tǎi"; /* 奤 */
dict[0x5965] = "ào,yù"; /* 奥 */
dict[0x5966] = "wù"; /* 奦 */
dict[0x5967] = "ào,yù"; /* 奧 */
dict[0x5968] = "jiǎng"; /* 奨 */
dict[0x5969] = "lián"; /* 奩 */
dict[0x596a] = "duó"; /* 奪 */
dict[0x596b] = "yūn"; /* 奫 */
dict[0x596c] = "jiǎng"; /* 奬 */
dict[0x596d] = "shì"; /* 奭 */
dict[0x596e] = "fèn"; /* 奮 */
dict[0x596f] = "huò"; /* 奯 */
dict[0x5970] = "bì"; /* 奰 */
dict[0x5971] = "luán"; /* 奱 */
dict[0x5972] = "duǒ,chě"; /* 奲 */
dict[0x5973] = "nǚ,rǔ"; /* 女 */
dict[0x5974] = "nú"; /* 奴 */
dict[0x5975] = "dǐng,dīng,tiǎn"; /* 奵 */
dict[0x5976] = "nǎi"; /* 奶 */
dict[0x5977] = "qiān"; /* 奷 */
dict[0x5978] = "jiān"; /* 奸 */
dict[0x5979] = "tā,jiě"; /* 她 */
dict[0x597a] = "jiǔ"; /* 奺 */
dict[0x597b] = "nuán"; /* 奻 */
dict[0x597c] = "chà"; /* 奼 */
dict[0x597d] = "hǎo,hào"; /* 好 */
dict[0x597e] = "xiān"; /* 奾 */
dict[0x597f] = "fàn"; /* 奿 */
dict[0x5980] = "jǐ"; /* 妀 */
dict[0x5981] = "shuò"; /* 妁 */
dict[0x5982] = "rú"; /* 如 */
dict[0x5983] = "fēi,pèi"; /* 妃 */
dict[0x5984] = "wàng"; /* 妄 */
dict[0x5985] = "hóng"; /* 妅 */
dict[0x5986] = "zhuāng"; /* 妆 */
dict[0x5987] = "fù"; /* 妇 */
dict[0x5988] = "mā"; /* 妈 */
dict[0x5989] = "dān"; /* 妉 */
dict[0x598a] = "rèn"; /* 妊 */
dict[0x598b] = "fū,yōu"; /* 妋 */
dict[0x598c] = "jìng"; /* 妌 */
dict[0x598d] = "yán"; /* 妍 */
dict[0x598e] = "hài,jiè"; /* 妎 */
dict[0x598f] = "wèn"; /* 妏 */
dict[0x5990] = "zhōng"; /* 妐 */
dict[0x5991] = "pā"; /* 妑 */
dict[0x5992] = "dù"; /* 妒 */
dict[0x5993] = "jì"; /* 妓 */
dict[0x5994] = "kēng,háng"; /* 妔 */
dict[0x5995] = "zhòng"; /* 妕 */
dict[0x5996] = "yāo"; /* 妖 */
dict[0x5997] = "jìn"; /* 妗 */
dict[0x5998] = "yún"; /* 妘 */
dict[0x5999] = "miào"; /* 妙 */
dict[0x599a] = "fǒu,pēi,pī"; /* 妚 */
dict[0x599b] = "chī"; /* 妛 */
dict[0x599c] = "yuè,jué"; /* 妜 */
dict[0x599d] = "zhuāng"; /* 妝 */
dict[0x599e] = "niū"; /* 妞 */
dict[0x599f] = "yàn"; /* 妟 */
dict[0x59a0] = "nà,nàn"; /* 妠 */
dict[0x59a1] = "xīn"; /* 妡 */
dict[0x59a2] = "fén"; /* 妢 */
dict[0x59a3] = "bǐ"; /* 妣 */
dict[0x59a4] = "yú"; /* 妤 */
dict[0x59a5] = "tuǒ"; /* 妥 */
dict[0x59a6] = "fēng"; /* 妦 */
dict[0x59a7] = "wàn,yuán"; /* 妧 */
dict[0x59a8] = "fáng"; /* 妨 */
dict[0x59a9] = "wǔ"; /* 妩 */
dict[0x59aa] = "yù"; /* 妪 */
dict[0x59ab] = "guī"; /* 妫 */
dict[0x59ac] = "dù"; /* 妬 */
dict[0x59ad] = "bá"; /* 妭 */
dict[0x59ae] = "nī"; /* 妮 */
dict[0x59af] = "zhóu"; /* 妯 */
dict[0x59b0] = "zhuó"; /* 妰 */
dict[0x59b1] = "zhāo"; /* 妱 */
dict[0x59b2] = "dá"; /* 妲 */
dict[0x59b3] = "nǐ,nǎi"; /* 妳 */
dict[0x59b4] = "yuàn"; /* 妴 */
dict[0x59b5] = "tǒu"; /* 妵 */
dict[0x59b6] = "xián,xuán,xù"; /* 妶 */
dict[0x59b7] = "zhí,yì"; /* 妷 */
dict[0x59b8] = "ē"; /* 妸 */
dict[0x59b9] = "mèi"; /* 妹 */
dict[0x59ba] = "mò"; /* 妺 */
dict[0x59bb] = "qī,qì"; /* 妻 */
dict[0x59bc] = "bì"; /* 妼 */
dict[0x59bd] = "shēn"; /* 妽 */
dict[0x59be] = "qiè"; /* 妾 */
dict[0x59bf] = "ē"; /* 妿 */
dict[0x59c0] = "hé"; /* 姀 */
dict[0x59c1] = "xǔ,xū"; /* 姁 */
dict[0x59c2] = "fá"; /* 姂 */
dict[0x59c3] = "zhēng"; /* 姃 */
dict[0x59c4] = "mín"; /* 姄 */
dict[0x59c5] = "bàn"; /* 姅 */
dict[0x59c6] = "mǔ"; /* 姆 */
dict[0x59c7] = "fū,fú"; /* 姇 */
dict[0x59c8] = "líng"; /* 姈 */
dict[0x59c9] = "zǐ"; /* 姉 */
dict[0x59ca] = "zǐ"; /* 姊 */
dict[0x59cb] = "shǐ"; /* 始 */
dict[0x59cc] = "rǎn"; /* 姌 */
dict[0x59cd] = "shān,shàn"; /* 姍 */
dict[0x59ce] = "yāng"; /* 姎 */
dict[0x59cf] = "mán"; /* 姏 */
dict[0x59d0] = "jiě"; /* 姐 */
dict[0x59d1] = "gū"; /* 姑 */
dict[0x59d2] = "sì"; /* 姒 */
dict[0x59d3] = "xìng"; /* 姓 */
dict[0x59d4] = "wěi,wēi"; /* 委 */
dict[0x59d5] = "zī"; /* 姕 */
dict[0x59d6] = "jù"; /* 姖 */
dict[0x59d7] = "shān,shàn"; /* 姗 */
dict[0x59d8] = "pīn"; /* 姘 */
dict[0x59d9] = "rèn"; /* 姙 */
dict[0x59da] = "yáo"; /* 姚 */
dict[0x59db] = "dòng"; /* 姛 */
dict[0x59dc] = "jiāng"; /* 姜 */
dict[0x59dd] = "shū"; /* 姝 */
dict[0x59de] = "jí"; /* 姞 */
dict[0x59df] = "gāi"; /* 姟 */
dict[0x59e0] = "xiàng"; /* 姠 */
dict[0x59e1] = "huá,huó"; /* 姡 */
dict[0x59e2] = "juān"; /* 姢 */
dict[0x59e3] = "jiāo,xiáo"; /* 姣 */
dict[0x59e4] = "gòu,dù"; /* 姤 */
dict[0x59e5] = "mǔ,lǎo"; /* 姥 */
dict[0x59e6] = "jiān"; /* 姦 */
dict[0x59e7] = "jiān"; /* 姧 */
dict[0x59e8] = "yí"; /* 姨 */
dict[0x59e9] = "nián,niàn"; /* 姩 */
dict[0x59ea] = "zhí"; /* 姪 */
dict[0x59eb] = "zhěn"; /* 姫 */
dict[0x59ec] = "jī"; /* 姬 */
dict[0x59ed] = "xiàn"; /* 姭 */
dict[0x59ee] = "héng"; /* 姮 */
dict[0x59ef] = "guāng"; /* 姯 */
dict[0x59f0] = "jūn,xún"; /* 姰 */
dict[0x59f1] = "kuā,hù"; /* 姱 */
dict[0x59f2] = "yàn"; /* 姲 */
dict[0x59f3] = "mǐng"; /* 姳 */
dict[0x59f4] = "liè"; /* 姴 */
dict[0x59f5] = "pèi"; /* 姵 */
dict[0x59f6] = "è,yà"; /* 姶 */
dict[0x59f7] = "yòu"; /* 姷 */
dict[0x59f8] = "yán"; /* 姸 */
dict[0x59f9] = "chà"; /* 姹 */
dict[0x59fa] = "shēn,xiān"; /* 姺 */
dict[0x59fb] = "yīn"; /* 姻 */
dict[0x59fc] = "shí"; /* 姼 */
dict[0x59fd] = "guǐ"; /* 姽 */
dict[0x59fe] = "quán"; /* 姾 */
dict[0x59ff] = "zī"; /* 姿 */
dict[0x5a00] = "sōng"; /* 娀 */
dict[0x5a01] = "wēi"; /* 威 */
dict[0x5a02] = "hóng"; /* 娂 */
dict[0x5a03] = "wá"; /* 娃 */
dict[0x5a04] = "lóu"; /* 娄 */
dict[0x5a05] = "yà"; /* 娅 */
dict[0x5a06] = "ráo,rǎo"; /* 娆 */
dict[0x5a07] = "jiāo"; /* 娇 */
dict[0x5a08] = "luán"; /* 娈 */
dict[0x5a09] = "pīng"; /* 娉 */
dict[0x5a0a] = "xiàn"; /* 娊 */
dict[0x5a0b] = "shào,shāo"; /* 娋 */
dict[0x5a0c] = "lǐ"; /* 娌 */
dict[0x5a0d] = "chéng,shèng"; /* 娍 */
dict[0x5a0e] = "xiē"; /* 娎 */
dict[0x5a0f] = "máng"; /* 娏 */
dict[0x5a10] = "fū"; /* 娐 */
dict[0x5a11] = "suō"; /* 娑 */
dict[0x5a12] = "wǔ,mǔ"; /* 娒 */
dict[0x5a13] = "wěi"; /* 娓 */
dict[0x5a14] = "kè"; /* 娔 */
dict[0x5a15] = "chuò,lài"; /* 娕 */
dict[0x5a16] = "chuò"; /* 娖 */
dict[0x5a17] = "tǐng"; /* 娗 */
dict[0x5a18] = "niáng"; /* 娘 */
dict[0x5a19] = "xíng"; /* 娙 */
dict[0x5a1a] = "nán"; /* 娚 */
dict[0x5a1b] = "yú"; /* 娛 */
dict[0x5a1c] = "nà,nuó"; /* 娜 */
dict[0x5a1d] = "pōu,bǐ"; /* 娝 */
dict[0x5a1e] = "něi,suī"; /* 娞 */
dict[0x5a1f] = "juān"; /* 娟 */
dict[0x5a20] = "shēn"; /* 娠 */
dict[0x5a21] = "zhì"; /* 娡 */
dict[0x5a22] = "hán"; /* 娢 */
dict[0x5a23] = "dì"; /* 娣 */
dict[0x5a24] = "zhuāng"; /* 娤 */
dict[0x5a25] = "é"; /* 娥 */
dict[0x5a26] = "pín"; /* 娦 */
dict[0x5a27] = "tuì"; /* 娧 */
dict[0x5a28] = "mǎn"; /* 娨 */
dict[0x5a29] = "miǎn"; /* 娩 */
dict[0x5a2a] = "wú,wù,yú"; /* 娪 */
dict[0x5a2b] = "yán"; /* 娫 */
dict[0x5a2c] = "wǔ"; /* 娬 */
dict[0x5a2d] = "xī,āi"; /* 娭 */
dict[0x5a2e] = "yán"; /* 娮 */
dict[0x5a2f] = "yú"; /* 娯 */
dict[0x5a30] = "sì"; /* 娰 */
dict[0x5a31] = "yú"; /* 娱 */
dict[0x5a32] = "wā"; /* 娲 */
dict[0x5a33] = "lì"; /* 娳 */
dict[0x5a34] = "xián"; /* 娴 */
dict[0x5a35] = "jū"; /* 娵 */
dict[0x5a36] = "qǔ"; /* 娶 */
dict[0x5a37] = "zhuì,shuì"; /* 娷 */
dict[0x5a38] = "qī"; /* 娸 */
dict[0x5a39] = "xián"; /* 娹 */
dict[0x5a3a] = "zhuó"; /* 娺 */
dict[0x5a3b] = "dōng,dòng"; /* 娻 */
dict[0x5a3c] = "chāng"; /* 娼 */
dict[0x5a3d] = "lù"; /* 娽 */
dict[0x5a3e] = "ǎi,ái,è"; /* 娾 */
dict[0x5a3f] = "ē,ě"; /* 娿 */
dict[0x5a40] = "ē"; /* 婀 */
dict[0x5a41] = "lóu"; /* 婁 */
dict[0x5a42] = "mián"; /* 婂 */
dict[0x5a43] = "cóng"; /* 婃 */
dict[0x5a44] = "pǒu,péi,bù"; /* 婄 */
dict[0x5a45] = "jú"; /* 婅 */
dict[0x5a46] = "pó"; /* 婆 */
dict[0x5a47] = "cǎi"; /* 婇 */
dict[0x5a48] = "líng"; /* 婈 */
dict[0x5a49] = "wǎn"; /* 婉 */
dict[0x5a4a] = "biǎo"; /* 婊 */
dict[0x5a4b] = "xiāo"; /* 婋 */
dict[0x5a4c] = "shū"; /* 婌 */
dict[0x5a4d] = "qǐ"; /* 婍 */
dict[0x5a4e] = "huī"; /* 婎 */
dict[0x5a4f] = "fù,fàn"; /* 婏 */
dict[0x5a50] = "wǒ"; /* 婐 */
dict[0x5a51] = "wǒ"; /* 婑 */
dict[0x5a52] = "tán"; /* 婒 */
dict[0x5a53] = "fēi"; /* 婓 */
dict[0x5a54] = "fēi"; /* 婔 */
dict[0x5a55] = "jié"; /* 婕 */
dict[0x5a56] = "tiān"; /* 婖 */
dict[0x5a57] = "ní,nǐ"; /* 婗 */
dict[0x5a58] = "quán,juàn"; /* 婘 */
dict[0x5a59] = "jìng"; /* 婙 */
dict[0x5a5a] = "hūn"; /* 婚 */
dict[0x5a5b] = "jīng"; /* 婛 */
dict[0x5a5c] = "qiān,jǐn"; /* 婜 */
dict[0x5a5d] = "diàn"; /* 婝 */
dict[0x5a5e] = "xìng"; /* 婞 */
dict[0x5a5f] = "hù"; /* 婟 */
dict[0x5a60] = "wān,wà"; /* 婠 */
dict[0x5a61] = "lái,lài"; /* 婡 */
dict[0x5a62] = "bì"; /* 婢 */
dict[0x5a63] = "yīn"; /* 婣 */
dict[0x5a64] = "zhōu,chōu"; /* 婤 */
dict[0x5a65] = "chuò,nào"; /* 婥 */
dict[0x5a66] = "fù"; /* 婦 */
dict[0x5a67] = "jìng"; /* 婧 */
dict[0x5a68] = "lún"; /* 婨 */
dict[0x5a69] = "nüè"; /* 婩 */
dict[0x5a6a] = "lán"; /* 婪 */
dict[0x5a6b] = "hùn,kūn"; /* 婫 */
dict[0x5a6c] = "yín"; /* 婬 */
dict[0x5a6d] = "yà"; /* 婭 */
dict[0x5a6e] = "jū"; /* 婮 */
dict[0x5a6f] = "lì"; /* 婯 */
dict[0x5a70] = "diǎn"; /* 婰 */
dict[0x5a71] = "xián"; /* 婱 */
dict[0x5a72] = "huā"; /* 婲 */
dict[0x5a73] = "huà"; /* 婳 */
dict[0x5a74] = "yīng"; /* 婴 */
dict[0x5a75] = "chán"; /* 婵 */
dict[0x5a76] = "shěn"; /* 婶 */
dict[0x5a77] = "tíng"; /* 婷 */
dict[0x5a78] = "dàng,yáng"; /* 婸 */
dict[0x5a79] = "yǎo"; /* 婹 */
dict[0x5a7a] = "wù"; /* 婺 */
dict[0x5a7b] = "nàn"; /* 婻 */
dict[0x5a7c] = "ruò,chuò"; /* 婼 */
dict[0x5a7d] = "jiǎ"; /* 婽 */
dict[0x5a7e] = "tōu,yú"; /* 婾 */
dict[0x5a7f] = "xù"; /* 婿 */
dict[0x5a80] = "yù,yú"; /* 媀 */
dict[0x5a81] = "wéi,wěi"; /* 媁 */
dict[0x5a82] = "dì,tí"; /* 媂 */
dict[0x5a83] = "róu"; /* 媃 */
dict[0x5a84] = "měi"; /* 媄 */
dict[0x5a85] = "dān"; /* 媅 */
dict[0x5a86] = "ruǎn,nèn"; /* 媆 */
dict[0x5a87] = "qīn"; /* 媇 */
dict[0x5a88] = "huī"; /* 媈 */
dict[0x5a89] = "wò"; /* 媉 */
dict[0x5a8a] = "qián"; /* 媊 */
dict[0x5a8b] = "chūn"; /* 媋 */
dict[0x5a8c] = "miáo"; /* 媌 */
dict[0x5a8d] = "fù"; /* 媍 */
dict[0x5a8e] = "jiě"; /* 媎 */
dict[0x5a8f] = "duān"; /* 媏 */
dict[0x5a90] = "yí,pèi"; /* 媐 */
dict[0x5a91] = "zhòng"; /* 媑 */
dict[0x5a92] = "méi"; /* 媒 */
dict[0x5a93] = "huáng"; /* 媓 */
dict[0x5a94] = "mián,miǎn"; /* 媔 */
dict[0x5a95] = "ān"; /* 媕 */
dict[0x5a96] = "yīng"; /* 媖 */
dict[0x5a97] = "xuān"; /* 媗 */
dict[0x5a98] = "jiē"; /* 媘 */
dict[0x5a99] = "wēi"; /* 媙 */
dict[0x5a9a] = "mèi"; /* 媚 */
dict[0x5a9b] = "yuàn,yuán"; /* 媛 */
dict[0x5a9c] = "zhēng"; /* 媜 */
dict[0x5a9d] = "qiū"; /* 媝 */
dict[0x5a9e] = "tí"; /* 媞 */
dict[0x5a9f] = "xiè"; /* 媟 */
dict[0x5aa0] = "tuó,duò"; /* 媠 */
dict[0x5aa1] = "liàn"; /* 媡 */
dict[0x5aa2] = "mào"; /* 媢 */
dict[0x5aa3] = "rǎn"; /* 媣 */
dict[0x5aa4] = "sī"; /* 媤 */
dict[0x5aa5] = "piān"; /* 媥 */
dict[0x5aa6] = "wèi"; /* 媦 */
dict[0x5aa7] = "wā"; /* 媧 */
dict[0x5aa8] = "cù"; /* 媨 */
dict[0x5aa9] = "hú"; /* 媩 */
dict[0x5aaa] = "ǎo"; /* 媪 */
dict[0x5aab] = "jié"; /* 媫 */
dict[0x5aac] = "bǎo"; /* 媬 */
dict[0x5aad] = "xū"; /* 媭 */
dict[0x5aae] = "tōu,yú"; /* 媮 */
dict[0x5aaf] = "guī"; /* 媯 */
dict[0x5ab0] = "chú,zòu"; /* 媰 */
dict[0x5ab1] = "yáo"; /* 媱 */
dict[0x5ab2] = "pì"; /* 媲 */
dict[0x5ab3] = "xí"; /* 媳 */
dict[0x5ab4] = "yuán"; /* 媴 */
dict[0x5ab5] = "yìng"; /* 媵 */
dict[0x5ab6] = "róng"; /* 媶 */
dict[0x5ab7] = "rù"; /* 媷 */
dict[0x5ab8] = "chī"; /* 媸 */
dict[0x5ab9] = "liú"; /* 媹 */
dict[0x5aba] = "měi"; /* 媺 */
dict[0x5abb] = "pán"; /* 媻 */
dict[0x5abc] = "ǎo"; /* 媼 */
dict[0x5abd] = "mā"; /* 媽 */
dict[0x5abe] = "gòu"; /* 媾 */
dict[0x5abf] = "kuì"; /* 媿 */
dict[0x5ac0] = "qín,shēn"; /* 嫀 */
dict[0x5ac1] = "jià"; /* 嫁 */
dict[0x5ac2] = "sǎo"; /* 嫂 */
dict[0x5ac3] = "zhēn,zhěn"; /* 嫃 */
dict[0x5ac4] = "yuán"; /* 嫄 */
dict[0x5ac5] = "jiē,suǒ"; /* 嫅 */
dict[0x5ac6] = "róng"; /* 嫆 */
dict[0x5ac7] = "míng,mǐng"; /* 嫇 */
dict[0x5ac8] = "yīng"; /* 嫈 */
dict[0x5ac9] = "jí"; /* 嫉 */
dict[0x5aca] = "sù"; /* 嫊 */
dict[0x5acb] = "niǎo"; /* 嫋 */
dict[0x5acc] = "xián"; /* 嫌 */
dict[0x5acd] = "tāo"; /* 嫍 */
dict[0x5ace] = "páng"; /* 嫎 */
dict[0x5acf] = "láng"; /* 嫏 */
dict[0x5ad0] = "nǎo"; /* 嫐 */
dict[0x5ad1] = "biáo"; /* 嫑 */
dict[0x5ad2] = "ài"; /* 嫒 */
dict[0x5ad3] = "pì"; /* 嫓 */
dict[0x5ad4] = "pín"; /* 嫔 */
dict[0x5ad5] = "yì"; /* 嫕 */
dict[0x5ad6] = "piáo,piāo"; /* 嫖 */
dict[0x5ad7] = "yù"; /* 嫗 */
dict[0x5ad8] = "léi"; /* 嫘 */
dict[0x5ad9] = "xuán"; /* 嫙 */
dict[0x5ada] = "màn"; /* 嫚 */
dict[0x5adb] = "yī"; /* 嫛 */
dict[0x5adc] = "zhāng"; /* 嫜 */
dict[0x5add] = "kāng"; /* 嫝 */
dict[0x5ade] = "yōng"; /* 嫞 */
dict[0x5adf] = "nì"; /* 嫟 */
dict[0x5ae0] = "lí"; /* 嫠 */
dict[0x5ae1] = "dí"; /* 嫡 */
dict[0x5ae2] = "guī"; /* 嫢 */
dict[0x5ae3] = "yān"; /* 嫣 */
dict[0x5ae4] = "jǐn,jìn"; /* 嫤 */
dict[0x5ae5] = "zhuān"; /* 嫥 */
dict[0x5ae6] = "cháng"; /* 嫦 */
dict[0x5ae7] = "zé"; /* 嫧 */
dict[0x5ae8] = "hān,nǎn"; /* 嫨 */
dict[0x5ae9] = "nèn"; /* 嫩 */
dict[0x5aea] = "lào"; /* 嫪 */
dict[0x5aeb] = "mó"; /* 嫫 */
dict[0x5aec] = "zhē"; /* 嫬 */
dict[0x5aed] = "hù"; /* 嫭 */
dict[0x5aee] = "hù"; /* 嫮 */
dict[0x5aef] = "ào"; /* 嫯 */
dict[0x5af0] = "nèn"; /* 嫰 */
dict[0x5af1] = "qiáng"; /* 嫱 */
dict[0x5af2] = "mā,má"; /* 嫲 */
dict[0x5af3] = "piè"; /* 嫳 */
dict[0x5af4] = "gū"; /* 嫴 */
dict[0x5af5] = "wǔ"; /* 嫵 */
dict[0x5af6] = "qiáo"; /* 嫶 */
dict[0x5af7] = "tuǒ"; /* 嫷 */
dict[0x5af8] = "zhǎn"; /* 嫸 */
dict[0x5af9] = "miáo"; /* 嫹 */
dict[0x5afa] = "xián"; /* 嫺 */
dict[0x5afb] = "xián"; /* 嫻 */
dict[0x5afc] = "mò"; /* 嫼 */
dict[0x5afd] = "liáo"; /* 嫽 */
dict[0x5afe] = "lián"; /* 嫾 */
dict[0x5aff] = "huà"; /* 嫿 */
dict[0x5b00] = "guī"; /* 嬀 */
dict[0x5b01] = "dēng"; /* 嬁 */
dict[0x5b02] = "zhí"; /* 嬂 */
dict[0x5b03] = "xū"; /* 嬃 */
dict[0x5b04] = "yī"; /* 嬄 */
dict[0x5b05] = "huà"; /* 嬅 */
dict[0x5b06] = "xī"; /* 嬆 */
dict[0x5b07] = "kuì"; /* 嬇 */
dict[0x5b08] = "ráo,rǎo"; /* 嬈 */
dict[0x5b09] = "xī"; /* 嬉 */
dict[0x5b0a] = "yàn"; /* 嬊 */
dict[0x5b0b] = "chán"; /* 嬋 */
dict[0x5b0c] = "jiāo"; /* 嬌 */
dict[0x5b0d] = "měi"; /* 嬍 */
dict[0x5b0e] = "fàn"; /* 嬎 */
dict[0x5b0f] = "fān"; /* 嬏 */
dict[0x5b10] = "xiān,yǎn,jìn"; /* 嬐 */
dict[0x5b11] = "yì"; /* 嬑 */
dict[0x5b12] = "huì"; /* 嬒 */
dict[0x5b13] = "jiào"; /* 嬓 */
dict[0x5b14] = "fù"; /* 嬔 */
dict[0x5b15] = "shì"; /* 嬕 */
dict[0x5b16] = "bì"; /* 嬖 */
dict[0x5b17] = "shàn"; /* 嬗 */
dict[0x5b18] = "suì"; /* 嬘 */
dict[0x5b19] = "qiáng"; /* 嬙 */
dict[0x5b1a] = "liǎn"; /* 嬚 */
dict[0x5b1b] = "huán,xuān,qióng"; /* 嬛 */
dict[0x5b1c] = "xīn"; /* 嬜 */
dict[0x5b1d] = "niǎo"; /* 嬝 */
dict[0x5b1e] = "dǒng"; /* 嬞 */
dict[0x5b1f] = "yǐ"; /* 嬟 */
dict[0x5b20] = "cān"; /* 嬠 */
dict[0x5b21] = "ài"; /* 嬡 */
dict[0x5b22] = "niáng"; /* 嬢 */
dict[0x5b23] = "níng"; /* 嬣 */
dict[0x5b24] = "mó"; /* 嬤 */
dict[0x5b25] = "tiǎo"; /* 嬥 */
dict[0x5b26] = "chóu"; /* 嬦 */
dict[0x5b27] = "jìn"; /* 嬧 */
dict[0x5b28] = "cí"; /* 嬨 */
dict[0x5b29] = "yú"; /* 嬩 */
dict[0x5b2a] = "pín"; /* 嬪 */
dict[0x5b2b] = "róng"; /* 嬫 */
dict[0x5b2c] = "rú"; /* 嬬 */
dict[0x5b2d] = "nǎi"; /* 嬭 */
dict[0x5b2e] = "yān,yàn"; /* 嬮 */
dict[0x5b2f] = "tái"; /* 嬯 */
dict[0x5b30] = "yīng"; /* 嬰 */
dict[0x5b31] = "qiàn"; /* 嬱 */
dict[0x5b32] = "niǎo"; /* 嬲 */
dict[0x5b33] = "yuè"; /* 嬳 */
dict[0x5b34] = "yíng"; /* 嬴 */
dict[0x5b35] = "mián"; /* 嬵 */
dict[0x5b36] = "bí"; /* 嬶 */
dict[0x5b37] = "mó"; /* 嬷 */
dict[0x5b38] = "shěn"; /* 嬸 */
dict[0x5b39] = "xìng"; /* 嬹 */
dict[0x5b3a] = "nì"; /* 嬺 */
dict[0x5b3b] = "dú"; /* 嬻 */
dict[0x5b3c] = "liǔ"; /* 嬼 */
dict[0x5b3d] = "yuān"; /* 嬽 */
dict[0x5b3e] = "lǎn"; /* 嬾 */
dict[0x5b3f] = "yàn"; /* 嬿 */
dict[0x5b40] = "shuāng"; /* 孀 */
dict[0x5b41] = "líng"; /* 孁 */
dict[0x5b42] = "jiǎo"; /* 孂 */
dict[0x5b43] = "niáng"; /* 孃 */
dict[0x5b44] = "lǎn"; /* 孄 */
dict[0x5b45] = "xiān,qiān"; /* 孅 */
dict[0x5b46] = "yīng"; /* 孆 */
dict[0x5b47] = "shuāng"; /* 孇 */
dict[0x5b48] = "xié,huī"; /* 孈 */
dict[0x5b49] = "huān,quán"; /* 孉 */
dict[0x5b4a] = "mǐ"; /* 孊 */
dict[0x5b4b] = "lí,lì"; /* 孋 */
dict[0x5b4c] = "luán"; /* 孌 */
dict[0x5b4d] = "yǎn"; /* 孍 */
dict[0x5b4e] = "zhú,chuò"; /* 孎 */
dict[0x5b4f] = "lǎn"; /* 孏 */
dict[0x5b50] = "zǐ"; /* 子 */
dict[0x5b51] = "jié"; /* 孑 */
dict[0x5b52] = "jué"; /* 孒 */
dict[0x5b53] = "jué"; /* 孓 */
dict[0x5b54] = "kǒng"; /* 孔 */
dict[0x5b55] = "yùn"; /* 孕 */
dict[0x5b56] = "zī,mā"; /* 孖 */
dict[0x5b57] = "zì"; /* 字 */
dict[0x5b58] = "cún"; /* 存 */
dict[0x5b59] = "sūn,xùn"; /* 孙 */
dict[0x5b5a] = "fú"; /* 孚 */
dict[0x5b5b] = "bèi"; /* 孛 */
dict[0x5b5c] = "zī"; /* 孜 */
dict[0x5b5d] = "xiào"; /* 孝 */
dict[0x5b5e] = "xìn"; /* 孞 */
dict[0x5b5f] = "mèng"; /* 孟 */
dict[0x5b60] = "sì"; /* 孠 */
dict[0x5b61] = "tāi"; /* 孡 */
dict[0x5b62] = "bāo"; /* 孢 */
dict[0x5b63] = "jì"; /* 季 */
dict[0x5b64] = "gū"; /* 孤 */
dict[0x5b65] = "nú"; /* 孥 */
dict[0x5b66] = "xué"; /* 学 */
dict[0x5b67] = "yòu,niū"; /* 孧 */
dict[0x5b68] = "zhuǎn"; /* 孨 */
dict[0x5b69] = "hái"; /* 孩 */
dict[0x5b6a] = "luán"; /* 孪 */
dict[0x5b6b] = "sūn,xùn"; /* 孫 */
dict[0x5b6c] = "nāo"; /* 孬 */
dict[0x5b6d] = "miē"; /* 孭 */
dict[0x5b6e] = "cóng"; /* 孮 */
dict[0x5b6f] = "qiān"; /* 孯 */
dict[0x5b70] = "shú"; /* 孰 */
dict[0x5b71] = "chán,càn"; /* 孱 */
dict[0x5b72] = "yā"; /* 孲 */
dict[0x5b73] = "zī"; /* 孳 */
dict[0x5b74] = "nǐ"; /* 孴 */
dict[0x5b75] = "fū"; /* 孵 */
dict[0x5b76] = "zī"; /* 孶 */
dict[0x5b77] = "lí"; /* 孷 */
dict[0x5b78] = "xué"; /* 學 */
dict[0x5b79] = "bò"; /* 孹 */
dict[0x5b7a] = "rú"; /* 孺 */
dict[0x5b7b] = "nái"; /* 孻 */
dict[0x5b7c] = "niè"; /* 孼 */
dict[0x5b7d] = "niè"; /* 孽 */
dict[0x5b7e] = "yīng"; /* 孾 */
dict[0x5b7f] = "luán"; /* 孿 */
dict[0x5b80] = "mián"; /* 宀 */
dict[0x5b81] = "níng,nìng,zhù"; /* 宁 */
dict[0x5b82] = "rǒng"; /* 宂 */
dict[0x5b83] = "tā"; /* 它 */
dict[0x5b84] = "guǐ"; /* 宄 */
dict[0x5b85] = "zhái"; /* 宅 */
dict[0x5b86] = "qióng"; /* 宆 */
dict[0x5b87] = "yǔ"; /* 宇 */
dict[0x5b88] = "shǒu"; /* 守 */
dict[0x5b89] = "ān"; /* 安 */
dict[0x5b8a] = "tū,jiā"; /* 宊 */
dict[0x5b8b] = "sòng"; /* 宋 */
dict[0x5b8c] = "wán"; /* 完 */
dict[0x5b8d] = "ròu"; /* 宍 */
dict[0x5b8e] = "yǎo"; /* 宎 */
dict[0x5b8f] = "hóng"; /* 宏 */
dict[0x5b90] = "yí"; /* 宐 */
dict[0x5b91] = "jǐng"; /* 宑 */
dict[0x5b92] = "zhūn"; /* 宒 */
dict[0x5b93] = "mì,fú"; /* 宓 */
dict[0x5b94] = "zhǔ"; /* 宔 */
dict[0x5b95] = "dàng"; /* 宕 */
dict[0x5b96] = "hóng"; /* 宖 */
dict[0x5b97] = "zōng"; /* 宗 */
dict[0x5b98] = "guān"; /* 官 */
dict[0x5b99] = "zhòu"; /* 宙 */
dict[0x5b9a] = "dìng"; /* 定 */
dict[0x5b9b] = "wǎn,yuān"; /* 宛 */
dict[0x5b9c] = "yí"; /* 宜 */
dict[0x5b9d] = "bǎo"; /* 宝 */
dict[0x5b9e] = "shí"; /* 实 */
dict[0x5b9f] = "shí"; /* 実 */
dict[0x5ba0] = "chǒng"; /* 宠 */
dict[0x5ba1] = "shěn"; /* 审 */
dict[0x5ba2] = "kè"; /* 客 */
dict[0x5ba3] = "xuān"; /* 宣 */
dict[0x5ba4] = "shì"; /* 室 */
dict[0x5ba5] = "yòu"; /* 宥 */
dict[0x5ba6] = "huàn"; /* 宦 */
dict[0x5ba7] = "yí"; /* 宧 */
dict[0x5ba8] = "tiǎo"; /* 宨 */
dict[0x5ba9] = "shǐ"; /* 宩 */
dict[0x5baa] = "xiàn"; /* 宪 */
dict[0x5bab] = "gōng"; /* 宫 */
dict[0x5bac] = "chéng"; /* 宬 */
dict[0x5bad] = "qún"; /* 宭 */
dict[0x5bae] = "gōng"; /* 宮 */
dict[0x5baf] = "xiāo"; /* 宯 */
dict[0x5bb0] = "zǎi"; /* 宰 */
dict[0x5bb1] = "zhà"; /* 宱 */
dict[0x5bb2] = "bǎo,shí"; /* 宲 */
dict[0x5bb3] = "hài"; /* 害 */
dict[0x5bb4] = "yàn"; /* 宴 */
dict[0x5bb5] = "xiāo"; /* 宵 */
dict[0x5bb6] = "jiā,jia,jie"; /* 家 */
dict[0x5bb7] = "shěn"; /* 宷 */
dict[0x5bb8] = "chén"; /* 宸 */
dict[0x5bb9] = "róng"; /* 容 */
dict[0x5bba] = "huāng,huǎng"; /* 宺 */
dict[0x5bbb] = "mì"; /* 宻 */
dict[0x5bbc] = "kòu"; /* 宼 */
dict[0x5bbd] = "kuān"; /* 宽 */
dict[0x5bbe] = "bīn"; /* 宾 */
dict[0x5bbf] = "sù,xiǔ,xiù"; /* 宿 */
dict[0x5bc0] = "cǎi,cài"; /* 寀 */
dict[0x5bc1] = "zǎn"; /* 寁 */
dict[0x5bc2] = "jì"; /* 寂 */
dict[0x5bc3] = "yuān"; /* 寃 */
dict[0x5bc4] = "jì"; /* 寄 */
dict[0x5bc5] = "yín"; /* 寅 */
dict[0x5bc6] = "mì"; /* 密 */
dict[0x5bc7] = "kòu"; /* 寇 */
dict[0x5bc8] = "qīng"; /* 寈 */
dict[0x5bc9] = "hè"; /* 寉 */
dict[0x5bca] = "zhēn"; /* 寊 */
dict[0x5bcb] = "jiàn"; /* 寋 */
dict[0x5bcc] = "fù"; /* 富 */
dict[0x5bcd] = "níng,nìng"; /* 寍 */
dict[0x5bce] = "bǐng,bìng"; /* 寎 */
dict[0x5bcf] = "huán"; /* 寏 */
dict[0x5bd0] = "mèi"; /* 寐 */
dict[0x5bd1] = "qǐn"; /* 寑 */
dict[0x5bd2] = "hán"; /* 寒 */
dict[0x5bd3] = "yù"; /* 寓 */
dict[0x5bd4] = "shí"; /* 寔 */
dict[0x5bd5] = "níng,nìng"; /* 寕 */
dict[0x5bd6] = "jìn,qǐn"; /* 寖 */
dict[0x5bd7] = "níng,nìng"; /* 寗 */
dict[0x5bd8] = "zhì"; /* 寘 */
dict[0x5bd9] = "yǔ"; /* 寙 */
dict[0x5bda] = "bǎo"; /* 寚 */
dict[0x5bdb] = "kuān"; /* 寛 */
dict[0x5bdc] = "níng,nìng"; /* 寜 */
dict[0x5bdd] = "qǐn"; /* 寝 */
dict[0x5bde] = "mò"; /* 寞 */
dict[0x5bdf] = "chá"; /* 察 */
dict[0x5be0] = "jù,lóu"; /* 寠 */
dict[0x5be1] = "guǎ"; /* 寡 */
dict[0x5be2] = "qǐn"; /* 寢 */
dict[0x5be3] = "hū"; /* 寣 */
dict[0x5be4] = "wù"; /* 寤 */
dict[0x5be5] = "liáo"; /* 寥 */
dict[0x5be6] = "shí"; /* 實 */
dict[0x5be7] = "níng,nìng"; /* 寧 */
dict[0x5be8] = "zhài"; /* 寨 */
dict[0x5be9] = "shěn"; /* 審 */
dict[0x5bea] = "wěi"; /* 寪 */
dict[0x5beb] = "xiě,xiè"; /* 寫 */
dict[0x5bec] = "kuān"; /* 寬 */
dict[0x5bed] = "huì"; /* 寭 */
dict[0x5bee] = "liáo"; /* 寮 */
dict[0x5bef] = "jùn"; /* 寯 */
dict[0x5bf0] = "huán"; /* 寰 */
dict[0x5bf1] = "yì"; /* 寱 */
dict[0x5bf2] = "yí"; /* 寲 */
dict[0x5bf3] = "bǎo"; /* 寳 */
dict[0x5bf4] = "qīn,qìn"; /* 寴 */
dict[0x5bf5] = "chǒng"; /* 寵 */
dict[0x5bf6] = "bǎo"; /* 寶 */
dict[0x5bf7] = "fēng"; /* 寷 */
dict[0x5bf8] = "cùn"; /* 寸 */
dict[0x5bf9] = "duì"; /* 对 */
dict[0x5bfa] = "sì"; /* 寺 */
dict[0x5bfb] = "xún"; /* 寻 */
dict[0x5bfc] = "dǎo"; /* 导 */
dict[0x5bfd] = "lüè,luó"; /* 寽 */
dict[0x5bfe] = "duì"; /* 対 */
dict[0x5bff] = "shòu"; /* 寿 */
dict[0x5c00] = "pǒ"; /* 尀 */
dict[0x5c01] = "fēng"; /* 封 */
dict[0x5c02] = "zhuān"; /* 専 */
dict[0x5c03] = "fū"; /* 尃 */
dict[0x5c04] = "shè,yè,yì"; /* 射 */
dict[0x5c05] = "kēi,kè"; /* 尅 */
dict[0x5c06] = "jiāng,jiàng"; /* 将 */
dict[0x5c07] = "jiāng,jiàng"; /* 將 */
dict[0x5c08] = "zhuān"; /* 專 */
dict[0x5c09] = "wèi,yù"; /* 尉 */
dict[0x5c0a] = "zūn"; /* 尊 */
dict[0x5c0b] = "xún"; /* 尋 */
dict[0x5c0c] = "shù,zhù"; /* 尌 */
dict[0x5c0d] = "duì"; /* 對 */
dict[0x5c0e] = "dǎo"; /* 導 */
dict[0x5c0f] = "xiǎo"; /* 小 */
dict[0x5c10] = "jié,jí"; /* 尐 */
dict[0x5c11] = "shǎo,shào"; /* 少 */
dict[0x5c12] = "ěr"; /* 尒 */
dict[0x5c13] = "ěr"; /* 尓 */
dict[0x5c14] = "ěr"; /* 尔 */
dict[0x5c15] = "gǎ"; /* 尕 */
dict[0x5c16] = "jiān"; /* 尖 */
dict[0x5c17] = "shú"; /* 尗 */
dict[0x5c18] = "chén"; /* 尘 */
dict[0x5c19] = "shàng"; /* 尙 */
dict[0x5c1a] = "shàng"; /* 尚 */
dict[0x5c1b] = "mó"; /* 尛 */
dict[0x5c1c] = "gá"; /* 尜 */
dict[0x5c1d] = "cháng"; /* 尝 */
dict[0x5c1e] = "liáo"; /* 尞 */
dict[0x5c1f] = "xiǎn"; /* 尟 */
dict[0x5c20] = "xiǎn"; /* 尠 */
dict[0x5c21] = "hùn"; /* 尡 */
dict[0x5c22] = "yóu"; /* 尢 */
dict[0x5c23] = "wāng"; /* 尣 */
dict[0x5c24] = "yóu"; /* 尤 */
dict[0x5c25] = "liào"; /* 尥 */
dict[0x5c26] = "liào"; /* 尦 */
dict[0x5c27] = "yáo"; /* 尧 */
dict[0x5c28] = "lóng,máng,méng,páng"; /* 尨 */
dict[0x5c29] = "wāng"; /* 尩 */
dict[0x5c2a] = "wāng"; /* 尪 */
dict[0x5c2b] = "wāng"; /* 尫 */
dict[0x5c2c] = "gà"; /* 尬 */
dict[0x5c2d] = "yáo"; /* 尭 */
dict[0x5c2e] = "duò"; /* 尮 */
dict[0x5c2f] = "kuì,kuǐ"; /* 尯 */
dict[0x5c30] = "zhǒng"; /* 尰 */
dict[0x5c31] = "jiù"; /* 就 */
dict[0x5c32] = "gān"; /* 尲 */
dict[0x5c33] = "gǔ"; /* 尳 */
dict[0x5c34] = "gān"; /* 尴 */
dict[0x5c35] = "tuí"; /* 尵 */
dict[0x5c36] = "gān"; /* 尶 */
dict[0x5c37] = "gān"; /* 尷 */
dict[0x5c38] = "shī"; /* 尸 */
dict[0x5c39] = "yǐn"; /* 尹 */
dict[0x5c3a] = "chǐ,chě"; /* 尺 */
dict[0x5c3b] = "kāo"; /* 尻 */
dict[0x5c3c] = "ní"; /* 尼 */
dict[0x5c3d] = "jìn,jǐn"; /* 尽 */
dict[0x5c3e] = "wěi,yǐ"; /* 尾 */
dict[0x5c3f] = "niào,suī"; /* 尿 */
dict[0x5c40] = "jú"; /* 局 */
dict[0x5c41] = "pì"; /* 屁 */
dict[0x5c42] = "céng"; /* 层 */
dict[0x5c43] = "xì"; /* 屃 */
dict[0x5c44] = "bī"; /* 屄 */
dict[0x5c45] = "jū"; /* 居 */
dict[0x5c46] = "jiè"; /* 屆 */
dict[0x5c47] = "tián"; /* 屇 */
dict[0x5c48] = "qū"; /* 屈 */
dict[0x5c49] = "tì"; /* 屉 */
dict[0x5c4a] = "jiè"; /* 届 */
dict[0x5c4b] = "wū"; /* 屋 */
dict[0x5c4c] = "diǎo"; /* 屌 */
dict[0x5c4d] = "shī"; /* 屍 */
dict[0x5c4e] = "shǐ"; /* 屎 */
dict[0x5c4f] = "píng,bǐng"; /* 屏 */
dict[0x5c50] = "jī"; /* 屐 */
dict[0x5c51] = "xiè"; /* 屑 */
dict[0x5c52] = "zhěn"; /* 屒 */
dict[0x5c53] = "xì"; /* 屓 */
dict[0x5c54] = "ní"; /* 屔 */
dict[0x5c55] = "zhǎn"; /* 展 */
dict[0x5c56] = "xī"; /* 屖 */
dict[0x5c57] = "wěi"; /* 屗 */
dict[0x5c58] = "mǎn"; /* 屘 */
dict[0x5c59] = "ē"; /* 屙 */
dict[0x5c5a] = "lòu"; /* 屚 */
dict[0x5c5b] = "pǐng,bǐng"; /* 屛 */
dict[0x5c5c] = "tì"; /* 屜 */
dict[0x5c5d] = "fèi"; /* 屝 */
dict[0x5c5e] = "shǔ,zhǔ"; /* 属 */
dict[0x5c5f] = "xiè,tì"; /* 屟 */
dict[0x5c60] = "tú"; /* 屠 */
dict[0x5c61] = "lǚ"; /* 屡 */
dict[0x5c62] = "lǚ"; /* 屢 */
dict[0x5c63] = "xǐ"; /* 屣 */
dict[0x5c64] = "céng"; /* 層 */
dict[0x5c65] = "lǚ"; /* 履 */
dict[0x5c66] = "jù"; /* 屦 */
dict[0x5c67] = "xiè"; /* 屧 */
dict[0x5c68] = "jù"; /* 屨 */
dict[0x5c69] = "juē"; /* 屩 */
dict[0x5c6a] = "liáo"; /* 屪 */
dict[0x5c6b] = "juē"; /* 屫 */
dict[0x5c6c] = "shǔ,zhǔ"; /* 屬 */
dict[0x5c6d] = "xì"; /* 屭 */
dict[0x5c6e] = "chè,cǎo"; /* 屮 */
dict[0x5c6f] = "tún,zhūn"; /* 屯 */
dict[0x5c70] = "nì,jǐ"; /* 屰 */
dict[0x5c71] = "shān"; /* 山 */
dict[0x5c72] = "wā"; /* 屲 */
dict[0x5c73] = "xiān"; /* 屳 */
dict[0x5c74] = "lì"; /* 屴 */
dict[0x5c75] = "àn"; /* 屵 */
dict[0x5c76] = "huì"; /* 屶 */
dict[0x5c77] = "huì"; /* 屷 */
dict[0x5c78] = "hóng,lóng"; /* 屸 */
dict[0x5c79] = "yì"; /* 屹 */
dict[0x5c7a] = "qǐ"; /* 屺 */
dict[0x5c7b] = "rèn"; /* 屻 */
dict[0x5c7c] = "wù"; /* 屼 */
dict[0x5c7d] = "hàn,àn"; /* 屽 */
dict[0x5c7e] = "shēn"; /* 屾 */
dict[0x5c7f] = "yǔ"; /* 屿 */
dict[0x5c80] = "chū"; /* 岀 */
dict[0x5c81] = "suì"; /* 岁 */
dict[0x5c82] = "qǐ,kǎi"; /* 岂 */
dict[0x5c83] = "rèn"; /* 岃 */
dict[0x5c84] = "yuè"; /* 岄 */
dict[0x5c85] = "bǎn"; /* 岅 */
dict[0x5c86] = "yǎo"; /* 岆 */
dict[0x5c87] = "áng"; /* 岇 */
dict[0x5c88] = "yá"; /* 岈 */
dict[0x5c89] = "wù"; /* 岉 */
dict[0x5c8a] = "jié"; /* 岊 */
dict[0x5c8b] = "è"; /* 岋 */
dict[0x5c8c] = "jí"; /* 岌 */
dict[0x5c8d] = "qiān"; /* 岍 */
dict[0x5c8e] = "fén"; /* 岎 */
dict[0x5c8f] = "wán"; /* 岏 */
dict[0x5c90] = "qí"; /* 岐 */
dict[0x5c91] = "cén"; /* 岑 */
dict[0x5c92] = "qián"; /* 岒 */
dict[0x5c93] = "qí"; /* 岓 */
dict[0x5c94] = "chà"; /* 岔 */
dict[0x5c95] = "jiè"; /* 岕 */
dict[0x5c96] = "qū"; /* 岖 */
dict[0x5c97] = "gǎng"; /* 岗 */
dict[0x5c98] = "xiàn"; /* 岘 */
dict[0x5c99] = "ào"; /* 岙 */
dict[0x5c9a] = "lán"; /* 岚 */
dict[0x5c9b] = "dǎo"; /* 岛 */
dict[0x5c9c] = "bā"; /* 岜 */
dict[0x5c9d] = "zuò"; /* 岝 */
dict[0x5c9e] = "zuò"; /* 岞 */
dict[0x5c9f] = "yǎng"; /* 岟 */
dict[0x5ca0] = "jù"; /* 岠 */
dict[0x5ca1] = "gāng"; /* 岡 */
dict[0x5ca2] = "kě"; /* 岢 */
dict[0x5ca3] = "gǒu"; /* 岣 */
dict[0x5ca4] = "xuè"; /* 岤 */
dict[0x5ca5] = "pō"; /* 岥 */
dict[0x5ca6] = "lì"; /* 岦 */
dict[0x5ca7] = "tiáo"; /* 岧 */
dict[0x5ca8] = "jū,jǔ"; /* 岨 */
dict[0x5ca9] = "yán"; /* 岩 */
dict[0x5caa] = "fú"; /* 岪 */
dict[0x5cab] = "xiù"; /* 岫 */
dict[0x5cac] = "jiǎ"; /* 岬 */
dict[0x5cad] = "lǐng,líng"; /* 岭 */
dict[0x5cae] = "tuó"; /* 岮 */
dict[0x5caf] = "pī"; /* 岯 */
dict[0x5cb0] = "ào"; /* 岰 */
dict[0x5cb1] = "dài"; /* 岱 */
dict[0x5cb2] = "kuàng"; /* 岲 */
dict[0x5cb3] = "yuè"; /* 岳 */
dict[0x5cb4] = "qū"; /* 岴 */
dict[0x5cb5] = "hù"; /* 岵 */
dict[0x5cb6] = "pò"; /* 岶 */
dict[0x5cb7] = "mín"; /* 岷 */
dict[0x5cb8] = "àn"; /* 岸 */
dict[0x5cb9] = "tiáo"; /* 岹 */
dict[0x5cba] = "lǐng,líng"; /* 岺 */
dict[0x5cbb] = "dī"; /* 岻 */
dict[0x5cbc] = "píng"; /* 岼 */
dict[0x5cbd] = "dōng"; /* 岽 */
dict[0x5cbe] = "zhān"; /* 岾 */
dict[0x5cbf] = "kuī"; /* 岿 */
dict[0x5cc0] = "xiù"; /* 峀 */
dict[0x5cc1] = "mǎo"; /* 峁 */
dict[0x5cc2] = "tóng"; /* 峂 */
dict[0x5cc3] = "xué"; /* 峃 */
dict[0x5cc4] = "yì"; /* 峄 */
dict[0x5cc5] = "biàn"; /* 峅 */
dict[0x5cc6] = "hé"; /* 峆 */
dict[0x5cc7] = "kè,bā"; /* 峇 */
dict[0x5cc8] = "luò"; /* 峈 */
dict[0x5cc9] = "é"; /* 峉 */
dict[0x5cca] = "fù,niè"; /* 峊 */
dict[0x5ccb] = "xún"; /* 峋 */
dict[0x5ccc] = "dié"; /* 峌 */
dict[0x5ccd] = "lù"; /* 峍 */
dict[0x5cce] = "ěn"; /* 峎 */
dict[0x5ccf] = "ér"; /* 峏 */
dict[0x5cd0] = "gāi"; /* 峐 */
dict[0x5cd1] = "quán"; /* 峑 */
dict[0x5cd2] = "tóng,dòng"; /* 峒 */
dict[0x5cd3] = "yí"; /* 峓 */
dict[0x5cd4] = "mǔ"; /* 峔 */
dict[0x5cd5] = "shí"; /* 峕 */
dict[0x5cd6] = "ān"; /* 峖 */
dict[0x5cd7] = "wéi"; /* 峗 */
dict[0x5cd8] = "huán"; /* 峘 */
dict[0x5cd9] = "zhì,shì"; /* 峙 */
dict[0x5cda] = "mì"; /* 峚 */
dict[0x5cdb] = "lǐ"; /* 峛 */
dict[0x5cdc] = "fǎ"; /* 峜 */
dict[0x5cdd] = "tóng"; /* 峝 */
dict[0x5cde] = "wéi"; /* 峞 */
dict[0x5cdf] = "yòu"; /* 峟 */
dict[0x5ce0] = "qiǎ"; /* 峠 */
dict[0x5ce1] = "xiá"; /* 峡 */
dict[0x5ce2] = "lǐ"; /* 峢 */
dict[0x5ce3] = "yáo"; /* 峣 */
dict[0x5ce4] = "jiào,qiáo"; /* 峤 */
dict[0x5ce5] = "zhēng"; /* 峥 */
dict[0x5ce6] = "luán"; /* 峦 */
dict[0x5ce7] = "jiāo"; /* 峧 */
dict[0x5ce8] = "é"; /* 峨 */
dict[0x5ce9] = "é"; /* 峩 */
dict[0x5cea] = "yù"; /* 峪 */
dict[0x5ceb] = "xié,yé"; /* 峫 */
dict[0x5cec] = "bū"; /* 峬 */
dict[0x5ced] = "qiào"; /* 峭 */
dict[0x5cee] = "qún"; /* 峮 */
dict[0x5cef] = "fēng"; /* 峯 */
dict[0x5cf0] = "fēng"; /* 峰 */
dict[0x5cf1] = "náo"; /* 峱 */
dict[0x5cf2] = "lǐ"; /* 峲 */
dict[0x5cf3] = "yōu"; /* 峳 */
dict[0x5cf4] = "xiàn"; /* 峴 */
dict[0x5cf5] = "róng"; /* 峵 */
dict[0x5cf6] = "dǎo"; /* 島 */
dict[0x5cf7] = "shēn"; /* 峷 */
dict[0x5cf8] = "chéng"; /* 峸 */
dict[0x5cf9] = "tú"; /* 峹 */
dict[0x5cfa] = "gěng"; /* 峺 */
dict[0x5cfb] = "jùn"; /* 峻 */
dict[0x5cfc] = "gào"; /* 峼 */
dict[0x5cfd] = "xiá"; /* 峽 */
dict[0x5cfe] = "yín"; /* 峾 */
dict[0x5cff] = "wú"; /* 峿 */
dict[0x5d00] = "lǎng"; /* 崀 */
dict[0x5d01] = "kàn"; /* 崁 */
dict[0x5d02] = "láo"; /* 崂 */
dict[0x5d03] = "lái"; /* 崃 */
dict[0x5d04] = "xiǎn"; /* 崄 */
dict[0x5d05] = "què"; /* 崅 */
dict[0x5d06] = "kōng"; /* 崆 */
dict[0x5d07] = "chóng"; /* 崇 */
dict[0x5d08] = "chóng"; /* 崈 */
dict[0x5d09] = "tà"; /* 崉 */
dict[0x5d0a] = "lín"; /* 崊 */
dict[0x5d0b] = "huà"; /* 崋 */
dict[0x5d0c] = "jū"; /* 崌 */
dict[0x5d0d] = "lái"; /* 崍 */
dict[0x5d0e] = "qí"; /* 崎 */
dict[0x5d0f] = "mín"; /* 崏 */
dict[0x5d10] = "kūn"; /* 崐 */
dict[0x5d11] = "kūn"; /* 崑 */
dict[0x5d12] = "zú,cuì"; /* 崒 */
dict[0x5d13] = "gù"; /* 崓 */
dict[0x5d14] = "cuī"; /* 崔 */
dict[0x5d15] = "yá"; /* 崕 */
dict[0x5d16] = "yá"; /* 崖 */
dict[0x5d17] = "gǎng,gāng"; /* 崗 */
dict[0x5d18] = "lún"; /* 崘 */
dict[0x5d19] = "lún"; /* 崙 */
dict[0x5d1a] = "líng,léng"; /* 崚 */
dict[0x5d1b] = "jué"; /* 崛 */
dict[0x5d1c] = "duǒ"; /* 崜 */
dict[0x5d1d] = "zhēng"; /* 崝 */
dict[0x5d1e] = "guō"; /* 崞 */
dict[0x5d1f] = "yín"; /* 崟 */
dict[0x5d20] = "dōng,dòng"; /* 崠 */
dict[0x5d21] = "hán"; /* 崡 */
dict[0x5d22] = "zhēng"; /* 崢 */
dict[0x5d23] = "wěi"; /* 崣 */
dict[0x5d24] = "xiáo"; /* 崤 */
dict[0x5d25] = "pí,bǐ"; /* 崥 */
dict[0x5d26] = "yān"; /* 崦 */
dict[0x5d27] = "sōng"; /* 崧 */
dict[0x5d28] = "jié"; /* 崨 */
dict[0x5d29] = "bēng"; /* 崩 */
dict[0x5d2a] = "zú"; /* 崪 */
dict[0x5d2b] = "jué"; /* 崫 */
dict[0x5d2c] = "dōng"; /* 崬 */
dict[0x5d2d] = "zhǎn,chán"; /* 崭 */
dict[0x5d2e] = "gù"; /* 崮 */
dict[0x5d2f] = "yín"; /* 崯 */
dict[0x5d30] = "zī"; /* 崰 */
dict[0x5d31] = "zè"; /* 崱 */
dict[0x5d32] = "huáng"; /* 崲 */
dict[0x5d33] = "yú"; /* 崳 */
dict[0x5d34] = "wǎi,wēi"; /* 崴 */
dict[0x5d35] = "yáng,dàng"; /* 崵 */
dict[0x5d36] = "fēng"; /* 崶 */
dict[0x5d37] = "qiú"; /* 崷 */
dict[0x5d38] = "yáng"; /* 崸 */
dict[0x5d39] = "tí"; /* 崹 */
dict[0x5d3a] = "yǐ"; /* 崺 */
dict[0x5d3b] = "zhì,shì"; /* 崻 */
dict[0x5d3c] = "shì,dié"; /* 崼 */
dict[0x5d3d] = "zǎi"; /* 崽 */
dict[0x5d3e] = "yǎo"; /* 崾 */
dict[0x5d3f] = "è"; /* 崿 */
dict[0x5d40] = "zhù"; /* 嵀 */
dict[0x5d41] = "kān,zhàn"; /* 嵁 */
dict[0x5d42] = "lǜ"; /* 嵂 */
dict[0x5d43] = "yǎn"; /* 嵃 */
dict[0x5d44] = "měi"; /* 嵄 */
dict[0x5d45] = "hán"; /* 嵅 */
dict[0x5d46] = "jī"; /* 嵆 */
dict[0x5d47] = "jī"; /* 嵇 */
dict[0x5d48] = "huàn"; /* 嵈 */
dict[0x5d49] = "tíng"; /* 嵉 */
dict[0x5d4a] = "shèng"; /* 嵊 */
dict[0x5d4b] = "méi"; /* 嵋 */
dict[0x5d4c] = "qiàn,kàn"; /* 嵌 */
dict[0x5d4d] = "wù,máo"; /* 嵍 */
dict[0x5d4e] = "yú"; /* 嵎 */
dict[0x5d4f] = "zōng"; /* 嵏 */
dict[0x5d50] = "lán"; /* 嵐 */
dict[0x5d51] = "kě,jié"; /* 嵑 */
dict[0x5d52] = "yán"; /* 嵒 */
dict[0x5d53] = "yán"; /* 嵓 */
dict[0x5d54] = "wēi,wěi"; /* 嵔 */
dict[0x5d55] = "zōng"; /* 嵕 */
dict[0x5d56] = "chá"; /* 嵖 */
dict[0x5d57] = "suì"; /* 嵗 */
dict[0x5d58] = "róng"; /* 嵘 */
dict[0x5d59] = "kē"; /* 嵙 */
dict[0x5d5a] = "qīn"; /* 嵚 */
dict[0x5d5b] = "yú"; /* 嵛 */
dict[0x5d5c] = "qí"; /* 嵜 */
dict[0x5d5d] = "lǒu"; /* 嵝 */
dict[0x5d5e] = "tú"; /* 嵞 */
dict[0x5d5f] = "cuī"; /* 嵟 */
dict[0x5d60] = "xī"; /* 嵠 */
dict[0x5d61] = "wěng"; /* 嵡 */
dict[0x5d62] = "cāng"; /* 嵢 */
dict[0x5d63] = "dàng,táng"; /* 嵣 */
dict[0x5d64] = "róng,yíng"; /* 嵤 */
dict[0x5d65] = "jié"; /* 嵥 */
dict[0x5d66] = "kǎi,ái"; /* 嵦 */
dict[0x5d67] = "liú"; /* 嵧 */
dict[0x5d68] = "wù"; /* 嵨 */
dict[0x5d69] = "sōng"; /* 嵩 */
dict[0x5d6a] = "kāo,qiāo"; /* 嵪 */
dict[0x5d6b] = "zī"; /* 嵫 */
dict[0x5d6c] = "wéi"; /* 嵬 */
dict[0x5d6d] = "bēng"; /* 嵭 */
dict[0x5d6e] = "diān"; /* 嵮 */
dict[0x5d6f] = "cuó"; /* 嵯 */
dict[0x5d70] = "qīn,qiǎn"; /* 嵰 */
dict[0x5d71] = "yǒng"; /* 嵱 */
dict[0x5d72] = "niè"; /* 嵲 */
dict[0x5d73] = "cuó"; /* 嵳 */
dict[0x5d74] = "jǐ"; /* 嵴 */
dict[0x5d75] = "shí"; /* 嵵 */
dict[0x5d76] = "ruò"; /* 嵶 */
dict[0x5d77] = "sǒng"; /* 嵷 */
dict[0x5d78] = "zǒng"; /* 嵸 */
dict[0x5d79] = "jiàng"; /* 嵹 */
dict[0x5d7a] = "liáo"; /* 嵺 */
dict[0x5d7b] = "kāng"; /* 嵻 */
dict[0x5d7c] = "chǎn"; /* 嵼 */
dict[0x5d7d] = "dié,dì"; /* 嵽 */
dict[0x5d7e] = "cēn"; /* 嵾 */
dict[0x5d7f] = "dǐng"; /* 嵿 */
dict[0x5d80] = "tū"; /* 嶀 */
dict[0x5d81] = "lǒu"; /* 嶁 */
dict[0x5d82] = "zhàng"; /* 嶂 */
dict[0x5d83] = "zhǎn,chán"; /* 嶃 */
dict[0x5d84] = "zhǎn,chán"; /* 嶄 */
dict[0x5d85] = "áo,ào"; /* 嶅 */
dict[0x5d86] = "cáo"; /* 嶆 */
dict[0x5d87] = "qū"; /* 嶇 */
dict[0x5d88] = "qiāng"; /* 嶈 */
dict[0x5d89] = "wěi"; /* 嶉 */
dict[0x5d8a] = "zuǐ"; /* 嶊 */
dict[0x5d8b] = "dǎo"; /* 嶋 */
dict[0x5d8c] = "dǎo"; /* 嶌 */
dict[0x5d8d] = "xí"; /* 嶍 */
dict[0x5d8e] = "yù"; /* 嶎 */
dict[0x5d8f] = "pǐ,pèi"; /* 嶏 */
dict[0x5d90] = "lóng"; /* 嶐 */
dict[0x5d91] = "xiàng"; /* 嶑 */
dict[0x5d92] = "céng"; /* 嶒 */
dict[0x5d93] = "bō"; /* 嶓 */
dict[0x5d94] = "qīn"; /* 嶔 */
dict[0x5d95] = "jiāo"; /* 嶕 */
dict[0x5d96] = "yān"; /* 嶖 */
dict[0x5d97] = "láo"; /* 嶗 */
dict[0x5d98] = "zhàn"; /* 嶘 */
dict[0x5d99] = "lín"; /* 嶙 */
dict[0x5d9a] = "liáo"; /* 嶚 */
dict[0x5d9b] = "liáo"; /* 嶛 */
dict[0x5d9c] = "qín"; /* 嶜 */
dict[0x5d9d] = "dèng"; /* 嶝 */
dict[0x5d9e] = "tuò"; /* 嶞 */
dict[0x5d9f] = "zūn"; /* 嶟 */
dict[0x5da0] = "jiào,qiáo"; /* 嶠 */
dict[0x5da1] = "jué,guì"; /* 嶡 */
dict[0x5da2] = "yáo"; /* 嶢 */
dict[0x5da3] = "jiāo"; /* 嶣 */
dict[0x5da4] = "yáo"; /* 嶤 */
dict[0x5da5] = "jué"; /* 嶥 */
dict[0x5da6] = "zhān,shàn"; /* 嶦 */
dict[0x5da7] = "yì"; /* 嶧 */
dict[0x5da8] = "xué"; /* 嶨 */
dict[0x5da9] = "náo"; /* 嶩 */
dict[0x5daa] = "yè"; /* 嶪 */
dict[0x5dab] = "yè"; /* 嶫 */
dict[0x5dac] = "yí"; /* 嶬 */
dict[0x5dad] = "niè"; /* 嶭 */
dict[0x5dae] = "xiǎn"; /* 嶮 */
dict[0x5daf] = "jí"; /* 嶯 */
dict[0x5db0] = "xiè,jiè"; /* 嶰 */
dict[0x5db1] = "kě,jié"; /* 嶱 */
dict[0x5db2] = "guī,xī,juàn"; /* 嶲 */
dict[0x5db3] = "dì"; /* 嶳 */
dict[0x5db4] = "ào"; /* 嶴 */
dict[0x5db5] = "zuì"; /* 嶵 */
dict[0x5db6] = "wēi"; /* 嶶 */
dict[0x5db7] = "yí"; /* 嶷 */
dict[0x5db8] = "róng"; /* 嶸 */
dict[0x5db9] = "dǎo"; /* 嶹 */
dict[0x5dba] = "lǐng"; /* 嶺 */
dict[0x5dbb] = "jié"; /* 嶻 */
dict[0x5dbc] = "yǔ"; /* 嶼 */
dict[0x5dbd] = "yuè"; /* 嶽 */
dict[0x5dbe] = "yǐn"; /* 嶾 */
dict[0x5dbf] = "rū"; /* 嶿 */
dict[0x5dc0] = "jié"; /* 巀 */
dict[0x5dc1] = "lì,liè"; /* 巁 */
dict[0x5dc2] = "guī,xī,juàn"; /* 巂 */
dict[0x5dc3] = "lóng"; /* 巃 */
dict[0x5dc4] = "lóng"; /* 巄 */
dict[0x5dc5] = "diān"; /* 巅 */
dict[0x5dc6] = "yíng,hōng"; /* 巆 */
dict[0x5dc7] = "xī"; /* 巇 */
dict[0x5dc8] = "jú"; /* 巈 */
dict[0x5dc9] = "chán"; /* 巉 */
dict[0x5dca] = "yǐng"; /* 巊 */
dict[0x5dcb] = "kuī"; /* 巋 */
dict[0x5dcc] = "yán"; /* 巌 */
dict[0x5dcd] = "wēi"; /* 巍 */
dict[0x5dce] = "náo"; /* 巎 */
dict[0x5dcf] = "quán"; /* 巏 */
dict[0x5dd0] = "chǎo"; /* 巐 */
dict[0x5dd1] = "cuán"; /* 巑 */
dict[0x5dd2] = "luán"; /* 巒 */
dict[0x5dd3] = "diān"; /* 巓 */
dict[0x5dd4] = "diān"; /* 巔 */
dict[0x5dd5] = "niè"; /* 巕 */
dict[0x5dd6] = "yán"; /* 巖 */
dict[0x5dd7] = "yán"; /* 巗 */
dict[0x5dd8] = "yǎn"; /* 巘 */
dict[0x5dd9] = "kuí"; /* 巙 */
dict[0x5dda] = "yǎn"; /* 巚 */
dict[0x5ddb] = "chuān"; /* 巛 */
dict[0x5ddc] = "kuài"; /* 巜 */
dict[0x5ddd] = "chuān"; /* 川 */
dict[0x5dde] = "zhōu"; /* 州 */
dict[0x5ddf] = "huāng"; /* 巟 */
dict[0x5de0] = "jīng,xíng"; /* 巠 */
dict[0x5de1] = "xún"; /* 巡 */
dict[0x5de2] = "cháo"; /* 巢 */
dict[0x5de3] = "cháo"; /* 巣 */
dict[0x5de4] = "liè"; /* 巤 */
dict[0x5de5] = "gōng"; /* 工 */
dict[0x5de6] = "zuǒ"; /* 左 */
dict[0x5de7] = "qiǎo"; /* 巧 */
dict[0x5de8] = "jù"; /* 巨 */
dict[0x5de9] = "gǒng"; /* 巩 */
dict[0x5dea] = "jù"; /* 巪 */
dict[0x5deb] = "wū"; /* 巫 */
dict[0x5dec] = "gū"; /* 巬 */
dict[0x5ded] = "gū"; /* 巭 */
dict[0x5dee] = "chà,chā,chāi,cī"; /* 差 */
dict[0x5def] = "qiú"; /* 巯 */
dict[0x5df0] = "qiú"; /* 巰 */
dict[0x5df1] = "jǐ"; /* 己 */
dict[0x5df2] = "yǐ"; /* 已 */
dict[0x5df3] = "sì"; /* 巳 */
dict[0x5df4] = "bā"; /* 巴 */
dict[0x5df5] = "zhī"; /* 巵 */
dict[0x5df6] = "zhāo"; /* 巶 */
dict[0x5df7] = "xiàng,hàng"; /* 巷 */
dict[0x5df8] = "yí"; /* 巸 */
dict[0x5df9] = "jǐn"; /* 巹 */
dict[0x5dfa] = "xùn"; /* 巺 */
dict[0x5dfb] = "juàn,juǎn"; /* 巻 */
dict[0x5dfd] = "xùn"; /* 巽 */
dict[0x5dfe] = "jīn"; /* 巾 */
dict[0x5dff] = "fú"; /* 巿 */
dict[0x5e00] = "zā"; /* 帀 */
dict[0x5e01] = "bì"; /* 币 */
dict[0x5e02] = "shì"; /* 市 */
dict[0x5e03] = "bù"; /* 布 */
dict[0x5e04] = "dīng"; /* 帄 */
dict[0x5e05] = "shuài"; /* 帅 */
dict[0x5e06] = "fān"; /* 帆 */
dict[0x5e07] = "niè"; /* 帇 */
dict[0x5e08] = "shī"; /* 师 */
dict[0x5e09] = "fēn"; /* 帉 */
dict[0x5e0a] = "pà"; /* 帊 */
dict[0x5e0b] = "zhǐ"; /* 帋 */
dict[0x5e0c] = "xī"; /* 希 */
dict[0x5e0d] = "hù"; /* 帍 */
dict[0x5e0e] = "dàn"; /* 帎 */
dict[0x5e0f] = "wéi"; /* 帏 */
dict[0x5e10] = "zhàng"; /* 帐 */
dict[0x5e11] = "tǎng,nú"; /* 帑 */
dict[0x5e12] = "dài"; /* 帒 */
dict[0x5e13] = "mò,wà"; /* 帓 */
dict[0x5e14] = "pèi"; /* 帔 */
dict[0x5e15] = "pà"; /* 帕 */
dict[0x5e16] = "tiè,tiě,tiē"; /* 帖 */
dict[0x5e17] = "fú"; /* 帗 */
dict[0x5e18] = "lián"; /* 帘 */
dict[0x5e19] = "zhì"; /* 帙 */
dict[0x5e1a] = "zhǒu"; /* 帚 */
dict[0x5e1b] = "bó"; /* 帛 */
dict[0x5e1c] = "zhì"; /* 帜 */
dict[0x5e1d] = "dì"; /* 帝 */
dict[0x5e1e] = "mò"; /* 帞 */
dict[0x5e1f] = "yì"; /* 帟 */
dict[0x5e20] = "yì"; /* 帠 */
dict[0x5e21] = "píng"; /* 帡 */
dict[0x5e22] = "qià"; /* 帢 */
dict[0x5e23] = "juàn,juǎn"; /* 帣 */
dict[0x5e24] = "rú"; /* 帤 */
dict[0x5e25] = "shuài"; /* 帥 */
dict[0x5e26] = "dài"; /* 带 */
dict[0x5e27] = "zhēn"; /* 帧 */
dict[0x5e28] = "shuì"; /* 帨 */
dict[0x5e29] = "qiāo"; /* 帩 */
dict[0x5e2a] = "zhēn"; /* 帪 */
dict[0x5e2b] = "shī"; /* 師 */
dict[0x5e2c] = "qún"; /* 帬 */
dict[0x5e2d] = "xí"; /* 席 */
dict[0x5e2e] = "bāng"; /* 帮 */
dict[0x5e2f] = "dài"; /* 帯 */
dict[0x5e30] = "guī"; /* 帰 */
dict[0x5e31] = "chóu,dào"; /* 帱 */
dict[0x5e32] = "píng"; /* 帲 */
dict[0x5e33] = "zhàng"; /* 帳 */
dict[0x5e34] = "jiǎn,jiān,sàn"; /* 帴 */
dict[0x5e35] = "wān"; /* 帵 */
dict[0x5e36] = "dài"; /* 帶 */
dict[0x5e37] = "wéi"; /* 帷 */
dict[0x5e38] = "cháng"; /* 常 */
dict[0x5e39] = "shà,qiè"; /* 帹 */
dict[0x5e3a] = "qí,jì"; /* 帺 */
dict[0x5e3b] = "zé"; /* 帻 */
dict[0x5e3c] = "guó"; /* 帼 */
dict[0x5e3d] = "mào"; /* 帽 */
dict[0x5e3e] = "zhǔ"; /* 帾 */
dict[0x5e3f] = "hóu"; /* 帿 */
dict[0x5e40] = "zhēn"; /* 幀 */
dict[0x5e41] = "zhèng"; /* 幁 */
dict[0x5e42] = "mì"; /* 幂 */
dict[0x5e43] = "wéi"; /* 幃 */
dict[0x5e44] = "wò"; /* 幄 */
dict[0x5e45] = "fú"; /* 幅 */
dict[0x5e46] = "yì"; /* 幆 */
dict[0x5e47] = "bāng"; /* 幇 */
dict[0x5e48] = "píng"; /* 幈 */
dict[0x5e49] = "dié"; /* 幉 */
dict[0x5e4a] = "gōng"; /* 幊 */
dict[0x5e4b] = "pán"; /* 幋 */
dict[0x5e4c] = "huǎng"; /* 幌 */
dict[0x5e4d] = "tāo"; /* 幍 */
dict[0x5e4e] = "mì"; /* 幎 */
dict[0x5e4f] = "jià"; /* 幏 */
dict[0x5e50] = "téng"; /* 幐 */
dict[0x5e51] = "huī"; /* 幑 */
dict[0x5e52] = "zhōng"; /* 幒 */
dict[0x5e53] = "shān,qiāo,shēn"; /* 幓 */
dict[0x5e54] = "màn"; /* 幔 */
dict[0x5e55] = "mù"; /* 幕 */
dict[0x5e56] = "biāo"; /* 幖 */
dict[0x5e57] = "guó"; /* 幗 */
dict[0x5e58] = "zé"; /* 幘 */
dict[0x5e59] = "mù"; /* 幙 */
dict[0x5e5a] = "bāng"; /* 幚 */
dict[0x5e5b] = "zhàng"; /* 幛 */
dict[0x5e5c] = "jǐng"; /* 幜 */
dict[0x5e5d] = "chǎn,chàn"; /* 幝 */
dict[0x5e5e] = "fú"; /* 幞 */
dict[0x5e5f] = "zhì"; /* 幟 */
dict[0x5e60] = "hū"; /* 幠 */
dict[0x5e61] = "fān"; /* 幡 */
dict[0x5e62] = "chuáng,zhuàng"; /* 幢 */
dict[0x5e63] = "bì"; /* 幣 */
dict[0x5e64] = "bì"; /* 幤 */
dict[0x5e65] = "zhǎng"; /* 幥 */
dict[0x5e66] = "mì"; /* 幦 */
dict[0x5e67] = "qiāo"; /* 幧 */
dict[0x5e68] = "chān,chàn"; /* 幨 */
dict[0x5e69] = "fén"; /* 幩 */
dict[0x5e6a] = "méng"; /* 幪 */
dict[0x5e6b] = "bāng"; /* 幫 */
dict[0x5e6c] = "chóu,dào"; /* 幬 */
dict[0x5e6d] = "miè"; /* 幭 */
dict[0x5e6e] = "chú"; /* 幮 */
dict[0x5e6f] = "jié"; /* 幯 */
dict[0x5e70] = "xiǎn"; /* 幰 */
dict[0x5e71] = "lán"; /* 幱 */
dict[0x5e72] = "gān,gàn"; /* 干 */
dict[0x5e73] = "píng"; /* 平 */
dict[0x5e74] = "nián"; /* 年 */
dict[0x5e75] = "jiān"; /* 幵 */
dict[0x5e76] = "bìng,bīng"; /* 并 */
dict[0x5e77] = "bìng,bīng"; /* 幷 */
dict[0x5e78] = "xìng"; /* 幸 */
dict[0x5e79] = "gàn"; /* 幹 */
dict[0x5e7a] = "yāo"; /* 幺 */
dict[0x5e7b] = "huàn"; /* 幻 */
dict[0x5e7c] = "yòu"; /* 幼 */
dict[0x5e7d] = "yōu"; /* 幽 */
dict[0x5e7e] = "jī,jǐ"; /* 幾 */
dict[0x5e7f] = "guǎng,ān"; /* 广 */
dict[0x5e80] = "pǐ"; /* 庀 */
dict[0x5e81] = "tīng"; /* 庁 */
dict[0x5e82] = "zè"; /* 庂 */
dict[0x5e83] = "guǎng"; /* 広 */
dict[0x5e84] = "zhuāng"; /* 庄 */
dict[0x5e85] = "mó,mā,me"; /* 庅 */
dict[0x5e86] = "qìng"; /* 庆 */
dict[0x5e87] = "bì"; /* 庇 */
dict[0x5e88] = "qín"; /* 庈 */
dict[0x5e89] = "dùn,tún"; /* 庉 */
dict[0x5e8a] = "chuáng"; /* 床 */
dict[0x5e8b] = "guǐ"; /* 庋 */
dict[0x5e8c] = "yǎ"; /* 庌 */
dict[0x5e8d] = "bài,tīng"; /* 庍 */
dict[0x5e8e] = "jiè"; /* 庎 */
dict[0x5e8f] = "xù"; /* 序 */
dict[0x5e90] = "lú"; /* 庐 */
dict[0x5e91] = "wǔ"; /* 庑 */
dict[0x5e92] = "zhuāng"; /* 庒 */
dict[0x5e93] = "kù"; /* 库 */
dict[0x5e94] = "yīng,yìng"; /* 应 */
dict[0x5e95] = "dǐ,de"; /* 底 */
dict[0x5e96] = "páo"; /* 庖 */
dict[0x5e97] = "diàn"; /* 店 */
dict[0x5e98] = "yā"; /* 庘 */
dict[0x5e99] = "miào"; /* 庙 */
dict[0x5e9a] = "gēng"; /* 庚 */
dict[0x5e9b] = "cì"; /* 庛 */
dict[0x5e9c] = "fǔ"; /* 府 */
dict[0x5e9d] = "tóng"; /* 庝 */
dict[0x5e9e] = "páng"; /* 庞 */
dict[0x5e9f] = "fèi"; /* 废 */
dict[0x5ea0] = "xiáng"; /* 庠 */
dict[0x5ea1] = "yǐ"; /* 庡 */
dict[0x5ea2] = "zhì"; /* 庢 */
dict[0x5ea3] = "tiāo"; /* 庣 */
dict[0x5ea4] = "zhì"; /* 庤 */
dict[0x5ea5] = "xiū"; /* 庥 */
dict[0x5ea6] = "dù,duó"; /* 度 */
dict[0x5ea7] = "zuò"; /* 座 */
dict[0x5ea8] = "xiāo"; /* 庨 */
dict[0x5ea9] = "tú"; /* 庩 */
dict[0x5eaa] = "guǐ"; /* 庪 */
dict[0x5eab] = "kù"; /* 庫 */
dict[0x5eac] = "máng,méng,páng"; /* 庬 */
dict[0x5ead] = "tíng"; /* 庭 */
dict[0x5eae] = "yóu"; /* 庮 */
dict[0x5eaf] = "bū"; /* 庯 */
dict[0x5eb0] = "bìng,píng"; /* 庰 */
dict[0x5eb1] = "chěng"; /* 庱 */
dict[0x5eb2] = "lái"; /* 庲 */
dict[0x5eb3] = "bēi"; /* 庳 */
dict[0x5eb4] = "jī,cuò"; /* 庴 */
dict[0x5eb5] = "ān"; /* 庵 */
dict[0x5eb6] = "shù"; /* 庶 */
dict[0x5eb7] = "kāng"; /* 康 */
dict[0x5eb8] = "yōng"; /* 庸 */
dict[0x5eb9] = "tuǒ"; /* 庹 */
dict[0x5eba] = "sōng"; /* 庺 */
dict[0x5ebb] = "shù"; /* 庻 */
dict[0x5ebc] = "qǐng"; /* 庼 */
dict[0x5ebd] = "yù"; /* 庽 */
dict[0x5ebe] = "yǔ"; /* 庾 */
dict[0x5ebf] = "miào"; /* 庿 */
dict[0x5ec0] = "sōu"; /* 廀 */
dict[0x5ec1] = "cè"; /* 廁 */
dict[0x5ec2] = "xiāng"; /* 廂 */
dict[0x5ec3] = "fèi"; /* 廃 */
dict[0x5ec4] = "jiù"; /* 廄 */
dict[0x5ec5] = "è"; /* 廅 */
dict[0x5ec6] = "guī,wěi,huì"; /* 廆 */
dict[0x5ec7] = "liù"; /* 廇 */
dict[0x5ec8] = "shà,xià"; /* 廈 */
dict[0x5ec9] = "lián"; /* 廉 */
dict[0x5eca] = "láng"; /* 廊 */
dict[0x5ecb] = "sōu"; /* 廋 */
dict[0x5ecc] = "zhì"; /* 廌 */
dict[0x5ecd] = "bù"; /* 廍 */
dict[0x5ece] = "qǐng"; /* 廎 */
dict[0x5ecf] = "jiù"; /* 廏 */
dict[0x5ed0] = "jiù"; /* 廐 */
dict[0x5ed1] = "jǐn,qín"; /* 廑 */
dict[0x5ed2] = "áo"; /* 廒 */
dict[0x5ed3] = "kuò"; /* 廓 */
dict[0x5ed4] = "lóu"; /* 廔 */
dict[0x5ed5] = "yìn"; /* 廕 */
dict[0x5ed6] = "liào"; /* 廖 */
dict[0x5ed7] = "dài"; /* 廗 */
dict[0x5ed8] = "lù"; /* 廘 */
dict[0x5ed9] = "yì"; /* 廙 */
dict[0x5eda] = "chú"; /* 廚 */
dict[0x5edb] = "chán"; /* 廛 */
dict[0x5edc] = "tú"; /* 廜 */
dict[0x5edd] = "sī"; /* 廝 */
dict[0x5ede] = "xīn"; /* 廞 */
dict[0x5edf] = "miào"; /* 廟 */
dict[0x5ee0] = "chǎng"; /* 廠 */
dict[0x5ee1] = "wǔ"; /* 廡 */
dict[0x5ee2] = "fèi"; /* 廢 */
dict[0x5ee3] = "guǎng"; /* 廣 */
dict[0x5ee4] = "kù"; /* 廤 */
dict[0x5ee5] = "kuài"; /* 廥 */
dict[0x5ee6] = "bì"; /* 廦 */
dict[0x5ee7] = "qiáng,sè"; /* 廧 */
dict[0x5ee8] = "xiè"; /* 廨 */
dict[0x5ee9] = "lǐn"; /* 廩 */
dict[0x5eea] = "lǐn"; /* 廪 */
dict[0x5eeb] = "liáo"; /* 廫 */
dict[0x5eec] = "lú"; /* 廬 */
dict[0x5eed] = "jì"; /* 廭 */
dict[0x5eee] = "yǐng"; /* 廮 */
dict[0x5eef] = "xiān"; /* 廯 */
dict[0x5ef0] = "tīng"; /* 廰 */
dict[0x5ef1] = "yōng"; /* 廱 */
dict[0x5ef2] = "lí"; /* 廲 */
dict[0x5ef3] = "tīng"; /* 廳 */
dict[0x5ef4] = "yǐn,yìn"; /* 廴 */
dict[0x5ef5] = "xún"; /* 廵 */
dict[0x5ef6] = "yán"; /* 延 */
dict[0x5ef7] = "tíng"; /* 廷 */
dict[0x5ef8] = "dí"; /* 廸 */
dict[0x5ef9] = "pò,pǎi"; /* 廹 */
dict[0x5efa] = "jiàn"; /* 建 */
dict[0x5efb] = "huí"; /* 廻 */
dict[0x5efc] = "nǎi"; /* 廼 */
dict[0x5efd] = "huí"; /* 廽 */
dict[0x5efe] = "gǒng"; /* 廾 */
dict[0x5eff] = "niàn"; /* 廿 */
dict[0x5f00] = "kāi"; /* 开 */
dict[0x5f01] = "biàn"; /* 弁 */
dict[0x5f02] = "yì"; /* 异 */
dict[0x5f03] = "qì"; /* 弃 */
dict[0x5f04] = "nòng,lòng"; /* 弄 */
dict[0x5f05] = "fèn"; /* 弅 */
dict[0x5f06] = "jǔ"; /* 弆 */
dict[0x5f07] = "yǎn"; /* 弇 */
dict[0x5f08] = "yì"; /* 弈 */
dict[0x5f09] = "zàng"; /* 弉 */
dict[0x5f0a] = "bì"; /* 弊 */
dict[0x5f0b] = "yì"; /* 弋 */
dict[0x5f0c] = "yī"; /* 弌 */
dict[0x5f0d] = "èr"; /* 弍 */
dict[0x5f0e] = "sān"; /* 弎 */
dict[0x5f0f] = "shì"; /* 式 */
dict[0x5f10] = "èr"; /* 弐 */
dict[0x5f11] = "shì"; /* 弑 */
dict[0x5f12] = "shì"; /* 弒 */
dict[0x5f13] = "gōng"; /* 弓 */
dict[0x5f14] = "diào"; /* 弔 */
dict[0x5f15] = "yǐn"; /* 引 */
dict[0x5f16] = "hù"; /* 弖 */
dict[0x5f17] = "fú"; /* 弗 */
dict[0x5f18] = "hóng"; /* 弘 */
dict[0x5f19] = "wū"; /* 弙 */
dict[0x5f1a] = "tuí"; /* 弚 */
dict[0x5f1b] = "chí"; /* 弛 */
dict[0x5f1c] = "jiàng"; /* 弜 */
dict[0x5f1d] = "bà"; /* 弝 */
dict[0x5f1e] = "shěn"; /* 弞 */
dict[0x5f1f] = "dì,tì,tuí"; /* 弟 */
dict[0x5f20] = "zhāng"; /* 张 */
dict[0x5f21] = "jué,zhāng"; /* 弡 */
dict[0x5f22] = "tāo"; /* 弢 */
dict[0x5f23] = "fǔ"; /* 弣 */
dict[0x5f24] = "dǐ"; /* 弤 */
dict[0x5f25] = "mí,mǐ"; /* 弥 */
dict[0x5f26] = "xián"; /* 弦 */
dict[0x5f27] = "hú"; /* 弧 */
dict[0x5f28] = "chāo"; /* 弨 */
dict[0x5f29] = "nǔ"; /* 弩 */
dict[0x5f2a] = "jìng"; /* 弪 */
dict[0x5f2b] = "zhěn"; /* 弫 */
dict[0x5f2c] = "yi"; /* 弬 */
dict[0x5f2d] = "mǐ"; /* 弭 */
dict[0x5f2e] = "juàn,quān"; /* 弮 */
dict[0x5f2f] = "wān"; /* 弯 */
dict[0x5f30] = "shāo"; /* 弰 */
dict[0x5f31] = "ruò"; /* 弱 */
dict[0x5f32] = "xuān,yuān"; /* 弲 */
dict[0x5f33] = "jìng"; /* 弳 */
dict[0x5f34] = "diāo"; /* 弴 */
dict[0x5f35] = "zhāng"; /* 張 */
dict[0x5f36] = "jiàng"; /* 弶 */
dict[0x5f37] = "qiáng,qiǎng,jiàng"; /* 強 */
dict[0x5f38] = "péng"; /* 弸 */
dict[0x5f39] = "dàn,tán"; /* 弹 */
dict[0x5f3a] = "qiáng,qiǎng,jiàng"; /* 强 */
dict[0x5f3b] = "bì"; /* 弻 */
dict[0x5f3c] = "bì"; /* 弼 */
dict[0x5f3d] = "shè"; /* 弽 */
dict[0x5f3e] = "dàn,tán"; /* 弾 */
dict[0x5f3f] = "jiǎn"; /* 弿 */
dict[0x5f40] = "gòu"; /* 彀 */
dict[0x5f41] = "gē"; /* 彁 */
dict[0x5f42] = "fā"; /* 彂 */
dict[0x5f43] = "bì"; /* 彃 */
dict[0x5f44] = "kōu"; /* 彄 */
dict[0x5f45] = "jiǎn"; /* 彅 */
dict[0x5f46] = "biè"; /* 彆 */
dict[0x5f47] = "xiāo"; /* 彇 */
dict[0x5f48] = "dàn,tán"; /* 彈 */
dict[0x5f49] = "guō"; /* 彉 */
dict[0x5f4a] = "qiáng,qiǎng,jiàng"; /* 彊 */
dict[0x5f4b] = "hóng"; /* 彋 */
dict[0x5f4c] = "mí,mǐ"; /* 彌 */
dict[0x5f4d] = "guō"; /* 彍 */
dict[0x5f4e] = "wān"; /* 彎 */
dict[0x5f4f] = "jué"; /* 彏 */
dict[0x5f50] = "jì,xuě"; /* 彐 */
dict[0x5f51] = "jì"; /* 彑 */
dict[0x5f52] = "guī"; /* 归 */
dict[0x5f53] = "dāng,dàng"; /* 当 */
dict[0x5f54] = "lù"; /* 彔 */
dict[0x5f55] = "lù"; /* 录 */
dict[0x5f56] = "tuàn"; /* 彖 */
dict[0x5f57] = "huì"; /* 彗 */
dict[0x5f58] = "zhì"; /* 彘 */
dict[0x5f59] = "huì"; /* 彙 */
dict[0x5f5a] = "huì"; /* 彚 */
dict[0x5f5b] = "yí"; /* 彛 */
dict[0x5f5c] = "yí"; /* 彜 */
dict[0x5f5d] = "yí"; /* 彝 */
dict[0x5f5e] = "yí"; /* 彞 */
dict[0x5f5f] = "huò"; /* 彟 */
dict[0x5f60] = "huò"; /* 彠 */
dict[0x5f61] = "shān,xiǎn"; /* 彡 */
dict[0x5f62] = "xíng"; /* 形 */
dict[0x5f63] = "wén"; /* 彣 */
dict[0x5f64] = "tóng"; /* 彤 */
dict[0x5f65] = "yàn"; /* 彥 */
dict[0x5f66] = "yàn"; /* 彦 */
dict[0x5f67] = "yù"; /* 彧 */
dict[0x5f68] = "chī"; /* 彨 */
dict[0x5f69] = "cǎi"; /* 彩 */
dict[0x5f6a] = "biāo"; /* 彪 */
dict[0x5f6b] = "diāo"; /* 彫 */
dict[0x5f6c] = "bīn"; /* 彬 */
dict[0x5f6d] = "péng,bāng"; /* 彭 */
dict[0x5f6e] = "yǒng"; /* 彮 */
dict[0x5f6f] = "piāo,piào"; /* 彯 */
dict[0x5f70] = "zhāng"; /* 彰 */
dict[0x5f71] = "yǐng"; /* 影 */
dict[0x5f72] = "chī"; /* 彲 */
dict[0x5f73] = "chì"; /* 彳 */
dict[0x5f74] = "zhuó,bó"; /* 彴 */
dict[0x5f75] = "tuǒ,yí"; /* 彵 */
dict[0x5f76] = "jí"; /* 彶 */
dict[0x5f77] = "páng,fǎng"; /* 彷 */
dict[0x5f78] = "zhōng"; /* 彸 */
dict[0x5f79] = "yì"; /* 役 */
dict[0x5f7a] = "wǎng"; /* 彺 */
dict[0x5f7b] = "chè"; /* 彻 */
dict[0x5f7c] = "bǐ"; /* 彼 */
dict[0x5f7d] = "dī"; /* 彽 */
dict[0x5f7e] = "líng"; /* 彾 */
dict[0x5f7f] = "fù"; /* 彿 */
dict[0x5f80] = "wǎng"; /* 往 */
dict[0x5f81] = "zhēng"; /* 征 */
dict[0x5f82] = "cú"; /* 徂 */
dict[0x5f83] = "wǎng"; /* 徃 */
dict[0x5f84] = "jìng"; /* 径 */
dict[0x5f85] = "dài,dāi"; /* 待 */
dict[0x5f86] = "xī"; /* 徆 */
dict[0x5f87] = "xùn"; /* 徇 */
dict[0x5f88] = "hěn"; /* 很 */
dict[0x5f89] = "yáng"; /* 徉 */
dict[0x5f8a] = "huái"; /* 徊 */
dict[0x5f8b] = "lǜ"; /* 律 */
dict[0x5f8c] = "hòu"; /* 後 */
dict[0x5f8d] = "wàng,jiā,wā"; /* 徍 */
dict[0x5f8e] = "chěng,zhèng"; /* 徎 */
dict[0x5f8f] = "zhì"; /* 徏 */
dict[0x5f90] = "xú"; /* 徐 */
dict[0x5f91] = "jìng"; /* 徑 */
dict[0x5f92] = "tú"; /* 徒 */
dict[0x5f93] = "cóng"; /* 従 */
dict[0x5f94] = "cóng"; /* 徔 */
dict[0x5f95] = "lài,lái"; /* 徕 */
dict[0x5f96] = "cóng"; /* 徖 */
dict[0x5f97] = "dé,děi,de"; /* 得 */
dict[0x5f98] = "pái"; /* 徘 */
dict[0x5f99] = "xǐ"; /* 徙 */
dict[0x5f9a] = "dōng"; /* 徚 */
dict[0x5f9b] = "jì"; /* 徛 */
dict[0x5f9c] = "cháng"; /* 徜 */
dict[0x5f9d] = "zhì"; /* 徝 */
dict[0x5f9e] = "cóng,zòng"; /* 從 */
dict[0x5f9f] = "zhōu"; /* 徟 */
dict[0x5fa0] = "lái,lài"; /* 徠 */
dict[0x5fa1] = "yù"; /* 御 */
dict[0x5fa2] = "xiè"; /* 徢 */
dict[0x5fa3] = "jiè"; /* 徣 */
dict[0x5fa4] = "jiàn"; /* 徤 */
dict[0x5fa5] = "shì,tǐ"; /* 徥 */
dict[0x5fa6] = "jiǎ,xiá"; /* 徦 */
dict[0x5fa7] = "biàn"; /* 徧 */
dict[0x5fa8] = "huáng"; /* 徨 */
dict[0x5fa9] = "fù"; /* 復 */
dict[0x5faa] = "xún"; /* 循 */
dict[0x5fab] = "wěi"; /* 徫 */
dict[0x5fac] = "páng"; /* 徬 */
dict[0x5fad] = "yáo"; /* 徭 */
dict[0x5fae] = "wēi"; /* 微 */
dict[0x5faf] = "xī"; /* 徯 */
dict[0x5fb0] = "zhēng"; /* 徰 */
dict[0x5fb1] = "piào"; /* 徱 */
dict[0x5fb2] = "tí,chí"; /* 徲 */
dict[0x5fb3] = "dé"; /* 徳 */
dict[0x5fb4] = "zhǐ,zhēng"; /* 徴 */
dict[0x5fb5] = "zhǐ,zhēng"; /* 徵 */
dict[0x5fb6] = "bié"; /* 徶 */
dict[0x5fb7] = "dé"; /* 德 */
dict[0x5fb8] = "zhǒng,chōng"; /* 徸 */
dict[0x5fb9] = "chè"; /* 徹 */
dict[0x5fba] = "jiǎo,yáo"; /* 徺 */
dict[0x5fbb] = "huì"; /* 徻 */
dict[0x5fbc] = "jiǎo,jiào"; /* 徼 */
dict[0x5fbd] = "huī"; /* 徽 */
dict[0x5fbe] = "méi"; /* 徾 */
dict[0x5fbf] = "lòng,lǒng"; /* 徿 */
dict[0x5fc0] = "xiāng"; /* 忀 */
dict[0x5fc1] = "bào"; /* 忁 */
dict[0x5fc2] = "qú,jù"; /* 忂 */
dict[0x5fc3] = "xīn"; /* 心 */
dict[0x5fc4] = "xīn"; /* 忄 */
dict[0x5fc5] = "bì"; /* 必 */
dict[0x5fc6] = "yì"; /* 忆 */
dict[0x5fc7] = "lè"; /* 忇 */
dict[0x5fc8] = "rén"; /* 忈 */
dict[0x5fc9] = "dāo"; /* 忉 */
dict[0x5fca] = "dìng,tìng"; /* 忊 */
dict[0x5fcb] = "gǎi"; /* 忋 */
dict[0x5fcc] = "jì"; /* 忌 */
dict[0x5fcd] = "rěn"; /* 忍 */
dict[0x5fce] = "rén"; /* 忎 */
dict[0x5fcf] = "chàn"; /* 忏 */
dict[0x5fd0] = "tǎn"; /* 忐 */
dict[0x5fd1] = "tè"; /* 忑 */
dict[0x5fd2] = "tè,tuī"; /* 忒 */
dict[0x5fd3] = "gān,hàn"; /* 忓 */
dict[0x5fd4] = "yì,qì"; /* 忔 */
dict[0x5fd5] = "shì,tài"; /* 忕 */
dict[0x5fd6] = "cǔn"; /* 忖 */
dict[0x5fd7] = "zhì"; /* 志 */
dict[0x5fd8] = "wàng"; /* 忘 */
dict[0x5fd9] = "máng"; /* 忙 */
dict[0x5fda] = "xī,liě"; /* 忚 */
dict[0x5fdb] = "fān"; /* 忛 */
dict[0x5fdc] = "yīng,yìng"; /* 応 */
dict[0x5fdd] = "tiǎn"; /* 忝 */
dict[0x5fde] = "mǐn,wěn,mín"; /* 忞 */
dict[0x5fdf] = "mǐn,wěn,mín"; /* 忟 */
dict[0x5fe0] = "zhōng"; /* 忠 */
dict[0x5fe1] = "chōng"; /* 忡 */
dict[0x5fe2] = "wù"; /* 忢 */
dict[0x5fe3] = "jí"; /* 忣 */
dict[0x5fe4] = "wǔ"; /* 忤 */
dict[0x5fe5] = "xì"; /* 忥 */
dict[0x5fe6] = "jiá"; /* 忦 */
dict[0x5fe7] = "yōu"; /* 忧 */
dict[0x5fe8] = "wán"; /* 忨 */
dict[0x5fe9] = "cōng"; /* 忩 */
dict[0x5fea] = "sōng,zhōng"; /* 忪 */
dict[0x5feb] = "kuài"; /* 快 */
dict[0x5fec] = "yù,shū"; /* 忬 */
dict[0x5fed] = "biàn"; /* 忭 */
dict[0x5fee] = "zhì"; /* 忮 */
dict[0x5fef] = "qí,shì"; /* 忯 */
dict[0x5ff0] = "cuì"; /* 忰 */
dict[0x5ff1] = "chén"; /* 忱 */
dict[0x5ff2] = "tài"; /* 忲 */
dict[0x5ff3] = "tún,zhūn,dùn"; /* 忳 */
dict[0x5ff4] = "qián,qín"; /* 忴 */
dict[0x5ff5] = "niàn"; /* 念 */
dict[0x5ff6] = "hún"; /* 忶 */
dict[0x5ff7] = "xiōng"; /* 忷 */
dict[0x5ff8] = "niǔ"; /* 忸 */
dict[0x5ff9] = "kuáng,wǎng"; /* 忹 */
dict[0x5ffa] = "xiān"; /* 忺 */
dict[0x5ffb] = "xīn"; /* 忻 */
dict[0x5ffc] = "kāng,hàng"; /* 忼 */
dict[0x5ffd] = "hū"; /* 忽 */
dict[0x5ffe] = "kài,xì"; /* 忾 */
dict[0x5fff] = "fèn"; /* 忿 */
dict[0x6000] = "huái"; /* 怀 */
dict[0x6001] = "tài"; /* 态 */
dict[0x6002] = "sǒng"; /* 怂 */
dict[0x6003] = "wǔ"; /* 怃 */
dict[0x6004] = "òu"; /* 怄 */
dict[0x6005] = "chàng"; /* 怅 */
dict[0x6006] = "chuàng"; /* 怆 */
dict[0x6007] = "jù"; /* 怇 */
dict[0x6008] = "yì"; /* 怈 */
dict[0x6009] = "bǎo,bào"; /* 怉 */
dict[0x600a] = "chāo"; /* 怊 */
dict[0x600b] = "mín,mén"; /* 怋 */
dict[0x600c] = "pēi"; /* 怌 */
dict[0x600d] = "zuò,zhà"; /* 怍 */
dict[0x600e] = "zěn"; /* 怎 */
dict[0x600f] = "yàng"; /* 怏 */
dict[0x6010] = "kòu,jù"; /* 怐 */
dict[0x6011] = "bàn"; /* 怑 */
dict[0x6012] = "nù"; /* 怒 */
dict[0x6013] = "náo,niú"; /* 怓 */
dict[0x6014] = "zhēng"; /* 怔 */
dict[0x6015] = "pà"; /* 怕 */
dict[0x6016] = "bù"; /* 怖 */
dict[0x6017] = "tiē,zhān"; /* 怗 */
dict[0x6018] = "hù,gù"; /* 怘 */
dict[0x6019] = "hù"; /* 怙 */
dict[0x601a] = "cū,jù,zū"; /* 怚 */
dict[0x601b] = "dá"; /* 怛 */
dict[0x601c] = "lián"; /* 怜 */
dict[0x601d] = "sī,sāi"; /* 思 */
dict[0x601e] = "yóu,chóu"; /* 怞 */
dict[0x601f] = "dì"; /* 怟 */
dict[0x6020] = "dài"; /* 怠 */
dict[0x6021] = "yí"; /* 怡 */
dict[0x6022] = "tū,dié"; /* 怢 */
dict[0x6023] = "yóu"; /* 怣 */
dict[0x6024] = "fū"; /* 怤 */
dict[0x6025] = "jí"; /* 急 */
dict[0x6026] = "pēng"; /* 怦 */
dict[0x6027] = "xìng"; /* 性 */
dict[0x6028] = "yuàn"; /* 怨 */
dict[0x6029] = "ní"; /* 怩 */
dict[0x602a] = "guài"; /* 怪 */
dict[0x602b] = "fú"; /* 怫 */
dict[0x602c] = "xì"; /* 怬 */
dict[0x602d] = "bì"; /* 怭 */
dict[0x602e] = "yōu,yào"; /* 怮 */
dict[0x602f] = "qiè"; /* 怯 */
dict[0x6030] = "xuàn"; /* 怰 */
dict[0x6031] = "cōng"; /* 怱 */
dict[0x6032] = "bǐng"; /* 怲 */
dict[0x6033] = "huǎng"; /* 怳 */
dict[0x6034] = "xù,xuè"; /* 怴 */
dict[0x6035] = "chù"; /* 怵 */
dict[0x6036] = "bì,pī"; /* 怶 */
dict[0x6037] = "shù"; /* 怷 */
dict[0x6038] = "xī,shù"; /* 怸 */
dict[0x6039] = "tān"; /* 怹 */
dict[0x603a] = "yǒng"; /* 怺 */
dict[0x603b] = "zǒng"; /* 总 */
dict[0x603c] = "duì"; /* 怼 */
dict[0x603d] = "mì"; /* 怽 */
dict[0x603f] = "yì"; /* 怿 */
dict[0x6040] = "shì"; /* 恀 */
dict[0x6041] = "nèn,nín"; /* 恁 */
dict[0x6042] = "xún"; /* 恂 */
dict[0x6043] = "shì"; /* 恃 */
dict[0x6044] = "xì"; /* 恄 */
dict[0x6045] = "lǎo"; /* 恅 */
dict[0x6046] = "héng"; /* 恆 */
dict[0x6047] = "kuāng"; /* 恇 */
dict[0x6048] = "móu"; /* 恈 */
dict[0x6049] = "zhǐ"; /* 恉 */
dict[0x604a] = "xié"; /* 恊 */
dict[0x604b] = "liàn"; /* 恋 */
dict[0x604c] = "tiāo,yáo"; /* 恌 */
dict[0x604d] = "huǎng"; /* 恍 */
dict[0x604e] = "dié"; /* 恎 */
dict[0x604f] = "hào"; /* 恏 */
dict[0x6050] = "kǒng"; /* 恐 */
dict[0x6051] = "guǐ"; /* 恑 */
dict[0x6052] = "héng"; /* 恒 */
dict[0x6053] = "xī,qī,xù"; /* 恓 */
dict[0x6054] = "xiào,jiǎo"; /* 恔 */
dict[0x6055] = "shù"; /* 恕 */
dict[0x6056] = "sī"; /* 恖 */
dict[0x6057] = "hū,kuā"; /* 恗 */
dict[0x6058] = "qiū"; /* 恘 */
dict[0x6059] = "yàng"; /* 恙 */
dict[0x605a] = "huì"; /* 恚 */
dict[0x605b] = "huí"; /* 恛 */
dict[0x605c] = "chì"; /* 恜 */
dict[0x605d] = "jiá"; /* 恝 */
dict[0x605e] = "yí"; /* 恞 */
dict[0x605f] = "xiōng"; /* 恟 */
dict[0x6060] = "guài"; /* 恠 */
dict[0x6061] = "lìn"; /* 恡 */
dict[0x6062] = "huī"; /* 恢 */
dict[0x6063] = "zì"; /* 恣 */
dict[0x6064] = "xù"; /* 恤 */
dict[0x6065] = "chǐ"; /* 恥 */
dict[0x6066] = "shàng"; /* 恦 */
dict[0x6067] = "nǜ"; /* 恧 */
dict[0x6068] = "hèn"; /* 恨 */
dict[0x6069] = "ēn"; /* 恩 */
dict[0x606a] = "kè"; /* 恪 */
dict[0x606b] = "dòng"; /* 恫 */
dict[0x606c] = "tián"; /* 恬 */
dict[0x606d] = "gōng"; /* 恭 */
dict[0x606e] = "quán,zhuān"; /* 恮 */
dict[0x606f] = "xī"; /* 息 */
dict[0x6070] = "qià"; /* 恰 */
dict[0x6071] = "yuè"; /* 恱 */
dict[0x6072] = "pēng"; /* 恲 */
dict[0x6073] = "kěn"; /* 恳 */
dict[0x6074] = "dé"; /* 恴 */
dict[0x6075] = "huì"; /* 恵 */
dict[0x6076] = "è,wù,ě,wū"; /* 恶 */
dict[0x6077] = "qiū"; /* 恷 */
dict[0x6078] = "tòng"; /* 恸 */
dict[0x6079] = "yān"; /* 恹 */
dict[0x607a] = "kǎi"; /* 恺 */
dict[0x607b] = "cè"; /* 恻 */
dict[0x607c] = "nǎo"; /* 恼 */
dict[0x607d] = "yùn"; /* 恽 */
dict[0x607e] = "máng"; /* 恾 */
dict[0x607f] = "yǒng"; /* 恿 */
dict[0x6080] = "yǒng"; /* 悀 */
dict[0x6081] = "yuān,juàn"; /* 悁 */
dict[0x6082] = "pī,pǐ"; /* 悂 */
dict[0x6083] = "kǔn"; /* 悃 */
dict[0x6084] = "qiǎo,qiāo"; /* 悄 */
dict[0x6085] = "yuè"; /* 悅 */
dict[0x6086] = "yù,shū"; /* 悆 */
dict[0x6087] = "tú"; /* 悇 */
dict[0x6088] = "jiè,kè"; /* 悈 */
dict[0x6089] = "xī"; /* 悉 */
dict[0x608a] = "zhé"; /* 悊 */
dict[0x608b] = "lìn"; /* 悋 */
dict[0x608c] = "tì"; /* 悌 */
dict[0x608d] = "hàn"; /* 悍 */
dict[0x608e] = "hào,jiào"; /* 悎 */
dict[0x608f] = "qiè"; /* 悏 */
dict[0x6090] = "tì"; /* 悐 */
dict[0x6091] = "bù"; /* 悑 */
dict[0x6092] = "yì"; /* 悒 */
dict[0x6093] = "qiàn"; /* 悓 */
dict[0x6094] = "huǐ"; /* 悔 */
dict[0x6095] = "xī"; /* 悕 */
dict[0x6096] = "bèi"; /* 悖 */
dict[0x6097] = "mán,mèn"; /* 悗 */
dict[0x6098] = "yī,yì"; /* 悘 */
dict[0x6099] = "hēng,hèng"; /* 悙 */
dict[0x609a] = "sǒng"; /* 悚 */
dict[0x609b] = "quān"; /* 悛 */
dict[0x609c] = "chěng"; /* 悜 */
dict[0x609d] = "kuī,lǐ"; /* 悝 */
dict[0x609e] = "wù"; /* 悞 */
dict[0x609f] = "wù"; /* 悟 */
dict[0x60a0] = "yōu"; /* 悠 */
dict[0x60a1] = "lí"; /* 悡 */
dict[0x60a2] = "liàng"; /* 悢 */
dict[0x60a3] = "huàn"; /* 患 */
dict[0x60a4] = "cōng"; /* 悤 */
dict[0x60a5] = "yì,niàn"; /* 悥 */
dict[0x60a6] = "yuè"; /* 悦 */
dict[0x60a7] = "lì"; /* 悧 */
dict[0x60a8] = "nín"; /* 您 */
dict[0x60a9] = "nǎo"; /* 悩 */
dict[0x60aa] = "è"; /* 悪 */
dict[0x60ab] = "què"; /* 悫 */
dict[0x60ac] = "xuán"; /* 悬 */
dict[0x60ad] = "qiān"; /* 悭 */
dict[0x60ae] = "wù"; /* 悮 */
dict[0x60af] = "mǐn"; /* 悯 */
dict[0x60b0] = "cóng"; /* 悰 */
dict[0x60b1] = "fěi"; /* 悱 */
dict[0x60b2] = "bēi"; /* 悲 */
dict[0x60b3] = "dé"; /* 悳 */
dict[0x60b4] = "cuì"; /* 悴 */
dict[0x60b5] = "chàng"; /* 悵 */
dict[0x60b6] = "mèn,mēn"; /* 悶 */
dict[0x60b7] = "lì"; /* 悷 */
dict[0x60b8] = "jì"; /* 悸 */
dict[0x60b9] = "guàn"; /* 悹 */
dict[0x60ba] = "guàn"; /* 悺 */
dict[0x60bb] = "xìng"; /* 悻 */
dict[0x60bc] = "dào"; /* 悼 */
dict[0x60bd] = "qī"; /* 悽 */
dict[0x60be] = "kōng,kǒng"; /* 悾 */
dict[0x60bf] = "tiǎn"; /* 悿 */
dict[0x60c0] = "lǔn,lùn"; /* 惀 */
dict[0x60c1] = "xī"; /* 惁 */
dict[0x60c2] = "kǎn"; /* 惂 */
dict[0x60c3] = "gǔn"; /* 惃 */
dict[0x60c4] = "nì"; /* 惄 */
dict[0x60c5] = "qíng"; /* 情 */
dict[0x60c6] = "chóu"; /* 惆 */
dict[0x60c7] = "dūn"; /* 惇 */
dict[0x60c8] = "guǒ"; /* 惈 */
dict[0x60c9] = "zhān"; /* 惉 */
dict[0x60ca] = "jīng"; /* 惊 */
dict[0x60cb] = "wǎn"; /* 惋 */
dict[0x60cc] = "yuān,wǎn"; /* 惌 */
dict[0x60cd] = "jīn"; /* 惍 */
dict[0x60ce] = "jì"; /* 惎 */
dict[0x60cf] = "lán,lín"; /* 惏 */
dict[0x60d0] = "yù,xù"; /* 惐 */
dict[0x60d1] = "huò"; /* 惑 */
dict[0x60d2] = "hé,hè"; /* 惒 */
dict[0x60d3] = "juàn,quán"; /* 惓 */
dict[0x60d4] = "tán,dàn"; /* 惔 */
dict[0x60d5] = "tì"; /* 惕 */
dict[0x60d6] = "tì"; /* 惖 */
dict[0x60d7] = "niàn"; /* 惗 */
dict[0x60d8] = "wǎng"; /* 惘 */
dict[0x60d9] = "chuò,chuì"; /* 惙 */
dict[0x60da] = "hū"; /* 惚 */
dict[0x60db] = "hūn,mèn"; /* 惛 */
dict[0x60dc] = "xī"; /* 惜 */
dict[0x60dd] = "chǎng"; /* 惝 */
dict[0x60de] = "xīn"; /* 惞 */
dict[0x60df] = "wéi"; /* 惟 */
dict[0x60e0] = "huì"; /* 惠 */
dict[0x60e1] = "è,wù,ě,wū"; /* 惡 */
dict[0x60e2] = "suǒ,ruǐ"; /* 惢 */
dict[0x60e3] = "zǒng"; /* 惣 */
dict[0x60e4] = "jiān"; /* 惤 */
dict[0x60e5] = "yǒng"; /* 惥 */
dict[0x60e6] = "diàn"; /* 惦 */
dict[0x60e7] = "jù"; /* 惧 */
dict[0x60e8] = "cǎn"; /* 惨 */
dict[0x60e9] = "chéng"; /* 惩 */
dict[0x60ea] = "dé"; /* 惪 */
dict[0x60eb] = "bèi"; /* 惫 */
dict[0x60ec] = "qiè"; /* 惬 */
dict[0x60ed] = "cán"; /* 惭 */
dict[0x60ee] = "dàn,dá"; /* 惮 */
dict[0x60ef] = "guàn"; /* 惯 */
dict[0x60f0] = "duò"; /* 惰 */
dict[0x60f1] = "nǎo"; /* 惱 */
dict[0x60f2] = "yùn"; /* 惲 */
dict[0x60f3] = "xiǎng"; /* 想 */
dict[0x60f4] = "zhuì"; /* 惴 */
dict[0x60f5] = "dié"; /* 惵 */
dict[0x60f6] = "huáng"; /* 惶 */
dict[0x60f7] = "chǔn"; /* 惷 */
dict[0x60f8] = "qióng"; /* 惸 */
dict[0x60f9] = "rě"; /* 惹 */
dict[0x60fa] = "xīng"; /* 惺 */
dict[0x60fb] = "cè"; /* 惻 */
dict[0x60fc] = "biǎn"; /* 惼 */
dict[0x60fd] = "mǐn"; /* 惽 */
dict[0x60fe] = "zōng"; /* 惾 */
dict[0x60ff] = "tí,shì"; /* 惿 */
dict[0x6100] = "qiǎo"; /* 愀 */
dict[0x6101] = "chóu"; /* 愁 */
dict[0x6102] = "bèi"; /* 愂 */
dict[0x6103] = "xuān"; /* 愃 */
dict[0x6104] = "wēi"; /* 愄 */
dict[0x6105] = "gé"; /* 愅 */
dict[0x6106] = "qiān"; /* 愆 */
dict[0x6107] = "wěi"; /* 愇 */
dict[0x6108] = "yù"; /* 愈 */
dict[0x6109] = "yú,tōu"; /* 愉 */
dict[0x610a] = "bì"; /* 愊 */
dict[0x610b] = "xuān"; /* 愋 */
dict[0x610c] = "huàn"; /* 愌 */
dict[0x610d] = "mǐn"; /* 愍 */
dict[0x610e] = "bì"; /* 愎 */
dict[0x610f] = "yì"; /* 意 */
dict[0x6110] = "miǎn"; /* 愐 */
dict[0x6111] = "yǒng"; /* 愑 */
dict[0x6112] = "qì,kài"; /* 愒 */
dict[0x6113] = "dàng,shāng,táng,yáng"; /* 愓 */
dict[0x6114] = "yīn"; /* 愔 */
dict[0x6115] = "è"; /* 愕 */
dict[0x6116] = "chén,xìn,dān"; /* 愖 */
dict[0x6117] = "mào"; /* 愗 */
dict[0x6118] = "kè,qià"; /* 愘 */
dict[0x6119] = "kè"; /* 愙 */
dict[0x611a] = "yú"; /* 愚 */
dict[0x611b] = "ài"; /* 愛 */
dict[0x611c] = "qiè"; /* 愜 */
dict[0x611d] = "yǎn"; /* 愝 */
dict[0x611e] = "nuò"; /* 愞 */
dict[0x611f] = "gǎn"; /* 感 */
dict[0x6120] = "yùn"; /* 愠 */
dict[0x6121] = "còng,sōng"; /* 愡 */
dict[0x6122] = "sāi,sī,sǐ"; /* 愢 */
dict[0x6123] = "lèng"; /* 愣 */
dict[0x6124] = "fèn"; /* 愤 */
dict[0x6125] = "yīng"; /* 愥 */
dict[0x6126] = "kuì"; /* 愦 */
dict[0x6127] = "kuì"; /* 愧 */
dict[0x6128] = "què"; /* 愨 */
dict[0x6129] = "gōng,gòng,hǒng"; /* 愩 */
dict[0x612a] = "yún"; /* 愪 */
dict[0x612b] = "sù"; /* 愫 */
dict[0x612c] = "sù,shuò"; /* 愬 */
dict[0x612d] = "qí"; /* 愭 */
dict[0x612e] = "yáo,yào"; /* 愮 */
dict[0x612f] = "sǒng"; /* 愯 */
dict[0x6130] = "huàng"; /* 愰 */
dict[0x6131] = "jí"; /* 愱 */
dict[0x6132] = "gǔ"; /* 愲 */
dict[0x6133] = "jù"; /* 愳 */
dict[0x6134] = "chuàng"; /* 愴 */
dict[0x6135] = "nì"; /* 愵 */
dict[0x6136] = "xié"; /* 愶 */
dict[0x6137] = "kǎi"; /* 愷 */
dict[0x6138] = "zhěng"; /* 愸 */
dict[0x6139] = "yǒng"; /* 愹 */
dict[0x613a] = "cǎo"; /* 愺 */
dict[0x613b] = "xùn"; /* 愻 */
dict[0x613c] = "shèn"; /* 愼 */
dict[0x613d] = "bó"; /* 愽 */
dict[0x613e] = "kài,xì"; /* 愾 */
dict[0x613f] = "yuàn"; /* 愿 */
dict[0x6140] = "xì,xié"; /* 慀 */
dict[0x6141] = "hùn"; /* 慁 */
dict[0x6142] = "yǒng"; /* 慂 */
dict[0x6143] = "yǎng"; /* 慃 */
dict[0x6144] = "lì"; /* 慄 */
dict[0x6145] = "cǎo,sāo"; /* 慅 */
dict[0x6146] = "tāo"; /* 慆 */
dict[0x6147] = "yīn"; /* 慇 */
dict[0x6148] = "cí"; /* 慈 */
dict[0x6149] = "xù,chù"; /* 慉 */
dict[0x614a] = "qiàn,qiè"; /* 慊 */
dict[0x614b] = "tài"; /* 態 */
dict[0x614c] = "huāng"; /* 慌 */
dict[0x614d] = "yùn"; /* 慍 */
dict[0x614e] = "shèn"; /* 慎 */
dict[0x614f] = "mǐng"; /* 慏 */
dict[0x6150] = "gōng,gòng,hǒng"; /* 慐 */
dict[0x6151] = "shè"; /* 慑 */
dict[0x6152] = "cáo,cóng"; /* 慒 */
dict[0x6153] = "piāo"; /* 慓 */
dict[0x6154] = "mù"; /* 慔 */
dict[0x6155] = "mù"; /* 慕 */
dict[0x6156] = "guó"; /* 慖 */
dict[0x6157] = "chì"; /* 慗 */
dict[0x6158] = "cǎn"; /* 慘 */
dict[0x6159] = "cán"; /* 慙 */
dict[0x615a] = "cán"; /* 慚 */
dict[0x615b] = "cuī"; /* 慛 */
dict[0x615c] = "mín"; /* 慜 */
dict[0x615d] = "tè"; /* 慝 */
dict[0x615e] = "zhāng"; /* 慞 */
dict[0x615f] = "tòng"; /* 慟 */
dict[0x6160] = "ào,áo"; /* 慠 */
dict[0x6161] = "shuǎng"; /* 慡 */
dict[0x6162] = "màn"; /* 慢 */
dict[0x6163] = "guàn"; /* 慣 */
dict[0x6164] = "què"; /* 慤 */
dict[0x6165] = "zào"; /* 慥 */
dict[0x6166] = "jiù"; /* 慦 */
dict[0x6167] = "huì"; /* 慧 */
dict[0x6168] = "kǎi"; /* 慨 */
dict[0x6169] = "lián,liǎn"; /* 慩 */
dict[0x616a] = "òu"; /* 慪 */
dict[0x616b] = "sǒng"; /* 慫 */
dict[0x616c] = "qín,jìn,jǐn"; /* 慬 */
dict[0x616d] = "yìn"; /* 慭 */
dict[0x616e] = "lǜ"; /* 慮 */
dict[0x616f] = "shāng"; /* 慯 */
dict[0x6170] = "wèi"; /* 慰 */
dict[0x6171] = "tuán"; /* 慱 */
dict[0x6172] = "mán"; /* 慲 */
dict[0x6173] = "qiān"; /* 慳 */
dict[0x6174] = "shè"; /* 慴 */
dict[0x6175] = "yōng"; /* 慵 */
dict[0x6176] = "qìng"; /* 慶 */
dict[0x6177] = "kāng"; /* 慷 */
dict[0x6178] = "dì,chì"; /* 慸 */
dict[0x6179] = "zhí,zhé"; /* 慹 */
dict[0x617a] = "lóu,lǚ"; /* 慺 */
dict[0x617b] = "juàn"; /* 慻 */
dict[0x617c] = "qī"; /* 慼 */
dict[0x617d] = "qī"; /* 慽 */
dict[0x617e] = "yù"; /* 慾 */
dict[0x617f] = "píng"; /* 慿 */
dict[0x6180] = "liáo"; /* 憀 */
dict[0x6181] = "còng"; /* 憁 */
dict[0x6182] = "yōu"; /* 憂 */
dict[0x6183] = "chōng"; /* 憃 */
dict[0x6184] = "zhī,zhì"; /* 憄 */
dict[0x6185] = "tòng"; /* 憅 */
dict[0x6186] = "chēng"; /* 憆 */
dict[0x6187] = "qì"; /* 憇 */
dict[0x6188] = "qū"; /* 憈 */
dict[0x6189] = "péng"; /* 憉 */
dict[0x618a] = "bèi"; /* 憊 */
dict[0x618b] = "biē"; /* 憋 */
dict[0x618c] = "qióng"; /* 憌 */
dict[0x618d] = "jiāo"; /* 憍 */
dict[0x618e] = "zēng"; /* 憎 */
dict[0x618f] = "chì"; /* 憏 */
dict[0x6190] = "lián"; /* 憐 */
dict[0x6191] = "píng"; /* 憑 */
dict[0x6192] = "kuì"; /* 憒 */
dict[0x6193] = "huì"; /* 憓 */
dict[0x6194] = "qiáo"; /* 憔 */
dict[0x6195] = "chéng,dèng,zhèng"; /* 憕 */
dict[0x6196] = "yìn"; /* 憖 */
dict[0x6197] = "yìn"; /* 憗 */
dict[0x6198] = "xǐ,xī"; /* 憘 */
dict[0x6199] = "xǐ"; /* 憙 */
dict[0x619a] = "dàn,dá"; /* 憚 */
dict[0x619b] = "tán"; /* 憛 */
dict[0x619c] = "duò"; /* 憜 */
dict[0x619d] = "duì"; /* 憝 */
dict[0x619e] = "duì,dùn,tūn"; /* 憞 */
dict[0x619f] = "sù"; /* 憟 */
dict[0x61a0] = "jué"; /* 憠 */
dict[0x61a1] = "cè"; /* 憡 */
dict[0x61a2] = "xiāo,jiāo"; /* 憢 */
dict[0x61a3] = "fān"; /* 憣 */
dict[0x61a4] = "fèn"; /* 憤 */
dict[0x61a5] = "láo"; /* 憥 */
dict[0x61a6] = "lào,láo"; /* 憦 */
dict[0x61a7] = "chōng"; /* 憧 */
dict[0x61a8] = "hān"; /* 憨 */
dict[0x61a9] = "qì"; /* 憩 */
dict[0x61aa] = "xián,xiàn"; /* 憪 */
dict[0x61ab] = "mǐn"; /* 憫 */
dict[0x61ac] = "jǐng"; /* 憬 */
dict[0x61ad] = "liǎo,liáo"; /* 憭 */
dict[0x61ae] = "wǔ"; /* 憮 */
dict[0x61af] = "cǎn"; /* 憯 */
dict[0x61b0] = "jué"; /* 憰 */
dict[0x61b1] = "cù"; /* 憱 */
dict[0x61b2] = "xiàn"; /* 憲 */
dict[0x61b3] = "tǎn"; /* 憳 */
dict[0x61b4] = "shéng"; /* 憴 */
dict[0x61b5] = "pī"; /* 憵 */
dict[0x61b6] = "yì"; /* 憶 */
dict[0x61b7] = "chù"; /* 憷 */
dict[0x61b8] = "xiān"; /* 憸 */
dict[0x61b9] = "náo,nǎo,náng"; /* 憹 */
dict[0x61ba] = "dàn"; /* 憺 */
dict[0x61bb] = "tǎn"; /* 憻 */
dict[0x61bc] = "jǐng,jìng"; /* 憼 */
dict[0x61bd] = "sōng"; /* 憽 */
dict[0x61be] = "hàn"; /* 憾 */
dict[0x61bf] = "jiǎo,jǐ"; /* 憿 */
dict[0x61c0] = "wèi"; /* 懀 */
dict[0x61c1] = "xuān,huān"; /* 懁 */
dict[0x61c2] = "dǒng"; /* 懂 */
dict[0x61c3] = "qín"; /* 懃 */
dict[0x61c4] = "qín"; /* 懄 */
dict[0x61c5] = "jù"; /* 懅 */
dict[0x61c6] = "cǎo,sāo,sào"; /* 懆 */
dict[0x61c7] = "kěn"; /* 懇 */
dict[0x61c8] = "xiè"; /* 懈 */
dict[0x61c9] = "yīng,yìng"; /* 應 */
dict[0x61ca] = "ào"; /* 懊 */
dict[0x61cb] = "mào"; /* 懋 */
dict[0x61cc] = "yì"; /* 懌 */
dict[0x61cd] = "lǐn"; /* 懍 */
dict[0x61ce] = "sè"; /* 懎 */
dict[0x61cf] = "jùn"; /* 懏 */
dict[0x61d0] = "huái"; /* 懐 */
dict[0x61d1] = "mèn"; /* 懑 */
dict[0x61d2] = "lǎn"; /* 懒 */
dict[0x61d3] = "ài"; /* 懓 */
dict[0x61d4] = "lǐn"; /* 懔 */
dict[0x61d5] = "yān"; /* 懕 */
dict[0x61d6] = "guō"; /* 懖 */
dict[0x61d7] = "xià"; /* 懗 */
dict[0x61d8] = "chì"; /* 懘 */
dict[0x61d9] = "yǔ,yú"; /* 懙 */
dict[0x61da] = "yìn"; /* 懚 */
dict[0x61db] = "dāi"; /* 懛 */
dict[0x61dc] = "mèng,méng,měng"; /* 懜 */
dict[0x61dd] = "ài,yì,nǐ"; /* 懝 */
dict[0x61de] = "méng,měng"; /* 懞 */
dict[0x61df] = "duì"; /* 懟 */
dict[0x61e0] = "qí,jī,jì"; /* 懠 */
dict[0x61e1] = "mǒ"; /* 懡 */
dict[0x61e2] = "lán,xiàn"; /* 懢 */
dict[0x61e3] = "mèn"; /* 懣 */
dict[0x61e4] = "chóu"; /* 懤 */
dict[0x61e5] = "zhì"; /* 懥 */
dict[0x61e6] = "nuò"; /* 懦 */
dict[0x61e7] = "nuò"; /* 懧 */
dict[0x61e8] = "yān"; /* 懨 */
dict[0x61e9] = "yǎng"; /* 懩 */
dict[0x61ea] = "bó"; /* 懪 */
dict[0x61eb] = "zhì"; /* 懫 */
dict[0x61ec] = "kuàng"; /* 懬 */
dict[0x61ed] = "kuǎng"; /* 懭 */
dict[0x61ee] = "yōu,yǒu"; /* 懮 */
dict[0x61ef] = "fū"; /* 懯 */
dict[0x61f0] = "liú,liǔ"; /* 懰 */
dict[0x61f1] = "miè"; /* 懱 */
dict[0x61f2] = "chéng"; /* 懲 */
dict[0x61f3] = "huì"; /* 懳 */
dict[0x61f4] = "chàn"; /* 懴 */
dict[0x61f5] = "měng"; /* 懵 */
dict[0x61f6] = "lǎn"; /* 懶 */
dict[0x61f7] = "huái"; /* 懷 */
dict[0x61f8] = "xuán"; /* 懸 */
dict[0x61f9] = "ràng"; /* 懹 */
dict[0x61fa] = "chàn"; /* 懺 */
dict[0x61fb] = "jì"; /* 懻 */
dict[0x61fc] = "jù"; /* 懼 */
dict[0x61fd] = "huān"; /* 懽 */
dict[0x61fe] = "shè"; /* 懾 */
dict[0x61ff] = "yì"; /* 懿 */
dict[0x6200] = "liàn"; /* 戀 */
dict[0x6201] = "nǎn"; /* 戁 */
dict[0x6202] = "mí,mó"; /* 戂 */
dict[0x6203] = "tǎng"; /* 戃 */
dict[0x6204] = "jué"; /* 戄 */
dict[0x6205] = "gàng,zhuàng"; /* 戅 */
dict[0x6206] = "gàng,zhuàng"; /* 戆 */
dict[0x6207] = "gàng,zhuàng"; /* 戇 */
dict[0x6208] = "gē"; /* 戈 */
dict[0x6209] = "yuè"; /* 戉 */
dict[0x620a] = "wù"; /* 戊 */
dict[0x620b] = "jiān"; /* 戋 */
dict[0x620c] = "xū"; /* 戌 */
dict[0x620d] = "shù"; /* 戍 */
dict[0x620e] = "róng"; /* 戎 */
dict[0x620f] = "xì,hū"; /* 戏 */
dict[0x6210] = "chéng"; /* 成 */
dict[0x6211] = "wǒ"; /* 我 */
dict[0x6212] = "jiè"; /* 戒 */
dict[0x6213] = "gē"; /* 戓 */
dict[0x6214] = "jiān"; /* 戔 */
dict[0x6215] = "qiāng"; /* 戕 */
dict[0x6216] = "huò"; /* 或 */
dict[0x6217] = "qiāng,qiàng"; /* 戗 */
dict[0x6218] = "zhàn"; /* 战 */
dict[0x6219] = "dòng"; /* 戙 */
dict[0x621a] = "qī"; /* 戚 */
dict[0x621b] = "jiá"; /* 戛 */
dict[0x621c] = "dié"; /* 戜 */
dict[0x621d] = "zéi"; /* 戝 */
dict[0x621e] = "jiá"; /* 戞 */
dict[0x621f] = "jǐ"; /* 戟 */
dict[0x6220] = "zhí"; /* 戠 */
dict[0x6221] = "kān"; /* 戡 */
dict[0x6222] = "jí"; /* 戢 */
dict[0x6223] = "kuí"; /* 戣 */
dict[0x6224] = "gài"; /* 戤 */
dict[0x6225] = "děng"; /* 戥 */
dict[0x6226] = "zhàn"; /* 戦 */
dict[0x6227] = "qiāng,qiàng"; /* 戧 */
dict[0x6228] = "gē"; /* 戨 */
dict[0x6229] = "jiǎn"; /* 戩 */
dict[0x622a] = "jié"; /* 截 */
dict[0x622b] = "yù"; /* 戫 */
dict[0x622c] = "jiǎn"; /* 戬 */
dict[0x622d] = "yǎn"; /* 戭 */
dict[0x622e] = "lù"; /* 戮 */
dict[0x622f] = "xì,hū"; /* 戯 */
dict[0x6230] = "zhàn"; /* 戰 */
dict[0x6231] = "xì,hū"; /* 戱 */
dict[0x6232] = "xì,hū"; /* 戲 */
dict[0x6233] = "chuō"; /* 戳 */
dict[0x6234] = "dài"; /* 戴 */
dict[0x6235] = "qú"; /* 戵 */
dict[0x6236] = "hù"; /* 戶 */
dict[0x6237] = "hù"; /* 户 */
dict[0x6238] = "hù"; /* 戸 */
dict[0x6239] = "è"; /* 戹 */
dict[0x623a] = "shì"; /* 戺 */
dict[0x623b] = "tì"; /* 戻 */
dict[0x623c] = "mǎo"; /* 戼 */
dict[0x623d] = "hù"; /* 戽 */
dict[0x623e] = "lì"; /* 戾 */
dict[0x623f] = "fáng"; /* 房 */
dict[0x6240] = "suǒ"; /* 所 */
dict[0x6241] = "biǎn,piān"; /* 扁 */
dict[0x6242] = "diàn"; /* 扂 */
dict[0x6243] = "jiōng"; /* 扃 */
dict[0x6244] = "shǎng,jiōng"; /* 扄 */
dict[0x6245] = "yí"; /* 扅 */
dict[0x6246] = "yǐ"; /* 扆 */
dict[0x6247] = "shàn,shān"; /* 扇 */
dict[0x6248] = "hù"; /* 扈 */
dict[0x6249] = "fēi"; /* 扉 */
dict[0x624a] = "yǎn"; /* 扊 */
dict[0x624b] = "shǒu"; /* 手 */
dict[0x624c] = "shǒu"; /* 扌 */
dict[0x624d] = "cái"; /* 才 */
dict[0x624e] = "zā,zhā,zhá"; /* 扎 */
dict[0x624f] = "qiú"; /* 扏 */
dict[0x6250] = "lè,lì,cái"; /* 扐 */
dict[0x6251] = "pū"; /* 扑 */
dict[0x6252] = "bā,pá"; /* 扒 */
dict[0x6253] = "dǎ,dá"; /* 打 */
dict[0x6254] = "rēng"; /* 扔 */
dict[0x6255] = "fǎn,fú"; /* 払 */
dict[0x6256] = "rù"; /* 扖 */
dict[0x6257] = "zài"; /* 扗 */
dict[0x6258] = "tuō"; /* 托 */
dict[0x6259] = "zhàng"; /* 扙 */
dict[0x625a] = "diǎo,dí,yuē,lì"; /* 扚 */
dict[0x625b] = "káng,gāng"; /* 扛 */
dict[0x625c] = "yū,wū"; /* 扜 */
dict[0x625d] = "yū,wū,kū"; /* 扝 */
dict[0x625e] = "hàn"; /* 扞 */
dict[0x625f] = "shēn"; /* 扟 */
dict[0x6260] = "chā"; /* 扠 */
dict[0x6261] = "tuō,chǐ,yǐ"; /* 扡 */
dict[0x6262] = "gǔ,xì,gē,jié"; /* 扢 */
dict[0x6263] = "kòu"; /* 扣 */
dict[0x6264] = "wù"; /* 扤 */
dict[0x6265] = "dèn"; /* 扥 */
dict[0x6266] = "qiān"; /* 扦 */
dict[0x6267] = "zhí"; /* 执 */
dict[0x6268] = "rèn"; /* 扨 */
dict[0x6269] = "kuò"; /* 扩 */
dict[0x626a] = "mén"; /* 扪 */
dict[0x626b] = "sǎo,sào"; /* 扫 */
dict[0x626c] = "yáng"; /* 扬 */
dict[0x626d] = "niǔ"; /* 扭 */
dict[0x626e] = "bàn"; /* 扮 */
dict[0x626f] = "chě"; /* 扯 */
dict[0x6270] = "rǎo"; /* 扰 */
dict[0x6271] = "xī,chā,qì"; /* 扱 */
dict[0x6272] = "qián,qín"; /* 扲 */
dict[0x6273] = "bān"; /* 扳 */
dict[0x6274] = "jiá"; /* 扴 */
dict[0x6275] = "yú"; /* 扵 */
dict[0x6276] = "fú"; /* 扶 */
dict[0x6277] = "bā,ào"; /* 扷 */
dict[0x6278] = "xī,zhé"; /* 扸 */
dict[0x6279] = "pī"; /* 批 */
dict[0x627a] = "zhǐ"; /* 扺 */
dict[0x627b] = "zhì,sǔn,kǎn"; /* 扻 */
dict[0x627c] = "è"; /* 扼 */
dict[0x627d] = "dèn"; /* 扽 */
dict[0x627e] = "zhǎo"; /* 找 */
dict[0x627f] = "chéng"; /* 承 */
dict[0x6280] = "jì"; /* 技 */
dict[0x6281] = "yǎn"; /* 抁 */
dict[0x6282] = "kuáng,wǎng,zài"; /* 抂 */
dict[0x6283] = "biàn"; /* 抃 */
dict[0x6284] = "chāo"; /* 抄 */
dict[0x6285] = "jū"; /* 抅 */
dict[0x6286] = "wěn"; /* 抆 */
dict[0x6287] = "hú,gǔ"; /* 抇 */
dict[0x6288] = "yuè"; /* 抈 */
dict[0x6289] = "jué"; /* 抉 */
dict[0x628a] = "bǎ,bà"; /* 把 */
dict[0x628b] = "qìn"; /* 抋 */
dict[0x628c] = "dǎn,shěn"; /* 抌 */
dict[0x628d] = "zhěng"; /* 抍 */
dict[0x628e] = "yǔn"; /* 抎 */
dict[0x628f] = "wán"; /* 抏 */
dict[0x6290] = "nè,nì,ruì,nà"; /* 抐 */
dict[0x6291] = "yì"; /* 抑 */
dict[0x6292] = "shū"; /* 抒 */
dict[0x6293] = "zhuā"; /* 抓 */
dict[0x6294] = "póu"; /* 抔 */
dict[0x6295] = "tóu"; /* 投 */
dict[0x6296] = "dǒu"; /* 抖 */
dict[0x6297] = "kàng"; /* 抗 */
dict[0x6298] = "zhē,zhé,shé"; /* 折 */
dict[0x6299] = "póu,pōu,fū"; /* 抙 */
dict[0x629a] = "fǔ"; /* 抚 */
dict[0x629b] = "pāo"; /* 抛 */
dict[0x629c] = "bá"; /* 抜 */
dict[0x629d] = "ǎo,ào,niù"; /* 抝 */
dict[0x629e] = "zé"; /* 択 */
dict[0x629f] = "tuán"; /* 抟 */
dict[0x62a0] = "kōu"; /* 抠 */
dict[0x62a1] = "lūn,lún"; /* 抡 */
dict[0x62a2] = "qiāng,qiǎng,chēng"; /* 抢 */
dict[0x62a3] = "yún"; /* 抣 */
dict[0x62a4] = "hù"; /* 护 */
dict[0x62a5] = "bào"; /* 报 */
dict[0x62a6] = "bǐng"; /* 抦 */
dict[0x62a7] = "zhǐ,zhǎi"; /* 抧 */
dict[0x62a8] = "pēng"; /* 抨 */
dict[0x62a9] = "nán"; /* 抩 */
dict[0x62aa] = "bù,pū"; /* 抪 */
dict[0x62ab] = "pī"; /* 披 */
dict[0x62ac] = "tái"; /* 抬 */
dict[0x62ad] = "yǎo,tāo"; /* 抭 */
dict[0x62ae] = "zhěn"; /* 抮 */
dict[0x62af] = "zhā"; /* 抯 */
dict[0x62b0] = "yāng"; /* 抰 */
dict[0x62b1] = "bào"; /* 抱 */
dict[0x62b2] = "hē,hè,qiā"; /* 抲 */
dict[0x62b3] = "nǐ,ní"; /* 抳 */
dict[0x62b4] = "yè"; /* 抴 */
dict[0x62b5] = "dǐ"; /* 抵 */
dict[0x62b6] = "chì"; /* 抶 */
dict[0x62b7] = "pī,pēi"; /* 抷 */
dict[0x62b8] = "jiā"; /* 抸 */
dict[0x62b9] = "mǒ,mò,mā"; /* 抹 */
dict[0x62ba] = "mèi"; /* 抺 */
dict[0x62bb] = "chēn"; /* 抻 */
dict[0x62bc] = "yā"; /* 押 */
dict[0x62bd] = "chōu"; /* 抽 */
dict[0x62be] = "qū"; /* 抾 */
dict[0x62bf] = "mǐn"; /* 抿 */
dict[0x62c0] = "zhù"; /* 拀 */
dict[0x62c1] = "jiā,yá"; /* 拁 */
dict[0x62c2] = "fú,bì"; /* 拂 */
dict[0x62c3] = "zhǎ"; /* 拃 */
dict[0x62c4] = "zhǔ"; /* 拄 */
dict[0x62c5] = "dān,dàn,dǎn"; /* 担 */
dict[0x62c6] = "chāi,cā"; /* 拆 */
dict[0x62c7] = "mǔ"; /* 拇 */
dict[0x62c8] = "niān"; /* 拈 */
dict[0x62c9] = "lā,lá"; /* 拉 */
dict[0x62ca] = "fǔ"; /* 拊 */
dict[0x62cb] = "pāo"; /* 拋 */
dict[0x62cc] = "bàn,pàn"; /* 拌 */
dict[0x62cd] = "pāi"; /* 拍 */
dict[0x62ce] = "līn"; /* 拎 */
dict[0x62cf] = "ná"; /* 拏 */
dict[0x62d0] = "guǎi"; /* 拐 */
dict[0x62d1] = "qián"; /* 拑 */
dict[0x62d2] = "jù"; /* 拒 */
dict[0x62d3] = "tuò,tà,zhí"; /* 拓 */
dict[0x62d4] = "bá"; /* 拔 */
dict[0x62d5] = "tuō"; /* 拕 */
dict[0x62d6] = "tuō"; /* 拖 */
dict[0x62d7] = "ǎo,ào,niù"; /* 拗 */
dict[0x62d8] = "jū,gōu"; /* 拘 */
dict[0x62d9] = "zhuō"; /* 拙 */
dict[0x62da] = "pàn,pīn,fān"; /* 拚 */
dict[0x62db] = "zhāo"; /* 招 */
dict[0x62dc] = "bài"; /* 拜 */
dict[0x62dd] = "bài"; /* 拝 */
dict[0x62de] = "dǐ"; /* 拞 */
dict[0x62df] = "nǐ"; /* 拟 */
dict[0x62e0] = "jù"; /* 拠 */
dict[0x62e1] = "kuò"; /* 拡 */
dict[0x62e2] = "lǒng"; /* 拢 */
dict[0x62e3] = "jiǎn"; /* 拣 */
dict[0x62e4] = "qiǎ"; /* 拤 */
dict[0x62e5] = "yōng"; /* 拥 */
dict[0x62e6] = "lán"; /* 拦 */
dict[0x62e7] = "níng,nǐng,nìng"; /* 拧 */
dict[0x62e8] = "bō"; /* 拨 */
dict[0x62e9] = "zé,zhái"; /* 择 */
dict[0x62ea] = "qiān"; /* 拪 */
dict[0x62eb] = "hén"; /* 拫 */
dict[0x62ec] = "kuò,guā"; /* 括 */
dict[0x62ed] = "shì"; /* 拭 */
dict[0x62ee] = "jié,jiá"; /* 拮 */
dict[0x62ef] = "zhěng"; /* 拯 */
dict[0x62f0] = "nǐn"; /* 拰 */
dict[0x62f1] = "gǒng"; /* 拱 */
dict[0x62f2] = "gǒng"; /* 拲 */
dict[0x62f3] = "quán"; /* 拳 */
dict[0x62f4] = "shuān"; /* 拴 */
dict[0x62f5] = "cún,zùn"; /* 拵 */
dict[0x62f6] = "zā,zǎn"; /* 拶 */
dict[0x62f7] = "kǎo"; /* 拷 */
dict[0x62f8] = "yí,chǐ,hài"; /* 拸 */
dict[0x62f9] = "xié"; /* 拹 */
dict[0x62fa] = "cè,sè,chuò"; /* 拺 */
dict[0x62fb] = "huī"; /* 拻 */
dict[0x62fc] = "pīn"; /* 拼 */
dict[0x62fd] = "zhuài,zhuāi,yè"; /* 拽 */
dict[0x62fe] = "shí,shè"; /* 拾 */
dict[0x62ff] = "ná"; /* 拿 */
dict[0x6300] = "bāi"; /* 挀 */
dict[0x6301] = "chí"; /* 持 */
dict[0x6302] = "guà"; /* 挂 */
dict[0x6303] = "zhì"; /* 挃 */
dict[0x6304] = "kuò,guāng"; /* 挄 */
dict[0x6305] = "duò"; /* 挅 */
dict[0x6306] = "duǒ,duò"; /* 挆 */
dict[0x6307] = "zhǐ"; /* 指 */
dict[0x6308] = "qiè"; /* 挈 */
dict[0x6309] = "àn"; /* 按 */
dict[0x630a] = "nòng"; /* 挊 */
dict[0x630b] = "zhèn"; /* 挋 */
dict[0x630c] = "gé"; /* 挌 */
dict[0x630d] = "jiào"; /* 挍 */
dict[0x630e] = "kuà,kū"; /* 挎 */
dict[0x630f] = "dòng"; /* 挏 */
dict[0x6310] = "rú,ná"; /* 挐 */
dict[0x6311] = "tiāo,tiǎo"; /* 挑 */
dict[0x6312] = "liè"; /* 挒 */
dict[0x6313] = "zhā"; /* 挓 */
dict[0x6314] = "lǚ"; /* 挔 */
dict[0x6315] = "dié,shè"; /* 挕 */
dict[0x6316] = "wā"; /* 挖 */
dict[0x6317] = "jué"; /* 挗 */
dict[0x6318] = "liě"; /* 挘 */
dict[0x6319] = "jǔ"; /* 挙 */
dict[0x631a] = "zhì"; /* 挚 */
dict[0x631b] = "luán"; /* 挛 */
dict[0x631c] = "yà,yǎ"; /* 挜 */
dict[0x631d] = "zhuā,wō"; /* 挝 */
dict[0x631e] = "tà"; /* 挞 */
dict[0x631f] = "xié,jiā"; /* 挟 */
dict[0x6320] = "náo"; /* 挠 */
dict[0x6321] = "dǎng,dàng"; /* 挡 */
dict[0x6322] = "jiǎo"; /* 挢 */
dict[0x6323] = "zhèng,zhēng"; /* 挣 */
dict[0x6324] = "jǐ"; /* 挤 */
dict[0x6325] = "huī"; /* 挥 */
dict[0x6326] = "xián"; /* 挦 */
dict[0x6327] = "yǔ"; /* 挧 */
dict[0x6328] = "āi,ái"; /* 挨 */
dict[0x6329] = "tuō,shuì"; /* 挩 */
dict[0x632a] = "nuó"; /* 挪 */
dict[0x632b] = "cuò"; /* 挫 */
dict[0x632c] = "bó"; /* 挬 */
dict[0x632d] = "gěng"; /* 挭 */
dict[0x632e] = "tǐ,tì"; /* 挮 */
dict[0x632f] = "zhèn"; /* 振 */
dict[0x6330] = "chéng"; /* 挰 */
dict[0x6331] = "suō,shā"; /* 挱 */
dict[0x6332] = "suō,shā"; /* 挲 */
dict[0x6333] = "kēng,qiān"; /* 挳 */
dict[0x6334] = "měi"; /* 挴 */
dict[0x6335] = "nòng"; /* 挵 */
dict[0x6336] = "jú"; /* 挶 */
dict[0x6337] = "bàng,péng"; /* 挷 */
dict[0x6338] = "jiǎn"; /* 挸 */
dict[0x6339] = "yì"; /* 挹 */
dict[0x633a] = "tǐng"; /* 挺 */
dict[0x633b] = "shān"; /* 挻 */
dict[0x633c] = "ruó"; /* 挼 */
dict[0x633d] = "wǎn"; /* 挽 */
dict[0x633e] = "xié,jiā"; /* 挾 */
dict[0x633f] = "chā"; /* 挿 */
dict[0x6340] = "péng"; /* 捀 */
dict[0x6341] = "jiǎo,kù"; /* 捁 */
dict[0x6342] = "wǔ"; /* 捂 */
dict[0x6343] = "jùn"; /* 捃 */
dict[0x6344] = "jiù"; /* 捄 */
dict[0x6345] = "tǒng"; /* 捅 */
dict[0x6346] = "kǔn"; /* 捆 */
dict[0x6347] = "huò,chì"; /* 捇 */
dict[0x6348] = "tú,shū,chá"; /* 捈 */
dict[0x6349] = "zhuō"; /* 捉 */
dict[0x634a] = "póu,pōu,fū"; /* 捊 */
dict[0x634b] = "luō,lǚ"; /* 捋 */
dict[0x634c] = "bā"; /* 捌 */
dict[0x634d] = "hàn"; /* 捍 */
dict[0x634e] = "shāo,shào"; /* 捎 */
dict[0x634f] = "niē"; /* 捏 */
dict[0x6350] = "juān"; /* 捐 */
dict[0x6351] = "zè"; /* 捑 */
dict[0x6352] = "shù,sǒng,sōu"; /* 捒 */
dict[0x6353] = "yé,yú"; /* 捓 */
dict[0x6354] = "jué,zhuó"; /* 捔 */
dict[0x6355] = "bǔ"; /* 捕 */
dict[0x6356] = "wán"; /* 捖 */
dict[0x6357] = "bù,pú,zhì"; /* 捗 */
dict[0x6358] = "zùn"; /* 捘 */
dict[0x6359] = "yè"; /* 捙 */
dict[0x635a] = "zhāi"; /* 捚 */
dict[0x635b] = "lǚ"; /* 捛 */
dict[0x635c] = "sōu"; /* 捜 */
dict[0x635d] = "tuō,shuì"; /* 捝 */
dict[0x635e] = "lāo"; /* 捞 */
dict[0x635f] = "sǔn"; /* 损 */
dict[0x6360] = "bāng"; /* 捠 */
dict[0x6361] = "jiǎn"; /* 捡 */
dict[0x6362] = "huàn"; /* 换 */
dict[0x6363] = "dǎo"; /* 捣 */
dict[0x6364] = "wěi"; /* 捤 */
dict[0x6365] = "wàn,wǎn,wān,yù"; /* 捥 */
dict[0x6366] = "qín"; /* 捦 */
dict[0x6367] = "pěng"; /* 捧 */
dict[0x6368] = "shě"; /* 捨 */
dict[0x6369] = "liè"; /* 捩 */
dict[0x636a] = "mín"; /* 捪 */
dict[0x636b] = "mén"; /* 捫 */
dict[0x636c] = "fǔ,fù,bǔ"; /* 捬 */
dict[0x636d] = "bǎi"; /* 捭 */
dict[0x636e] = "jù,jū"; /* 据 */
dict[0x636f] = "dáo"; /* 捯 */
dict[0x6370] = "wǒ,luò,luǒ"; /* 捰 */
dict[0x6371] = "ái"; /* 捱 */
dict[0x6372] = "juǎn,quán"; /* 捲 */
dict[0x6373] = "yuè"; /* 捳 */
dict[0x6374] = "zǒng"; /* 捴 */
dict[0x6375] = "chēn"; /* 捵 */
dict[0x6376] = "chuí"; /* 捶 */
dict[0x6377] = "jié"; /* 捷 */
dict[0x6378] = "tū"; /* 捸 */
dict[0x6379] = "bèn"; /* 捹 */
dict[0x637a] = "nà"; /* 捺 */
dict[0x637b] = "niǎn,niē"; /* 捻 */
dict[0x637c] = "ruó,wěi,ré"; /* 捼 */
dict[0x637d] = "zuó"; /* 捽 */
dict[0x637e] = "wò,xiá"; /* 捾 */
dict[0x637f] = "qī"; /* 捿 */
dict[0x6380] = "xiān"; /* 掀 */
dict[0x6381] = "chéng"; /* 掁 */
dict[0x6382] = "diān"; /* 掂 */
dict[0x6383] = "sǎo,sào"; /* 掃 */
dict[0x6384] = "lūn,lún"; /* 掄 */
dict[0x6385] = "qìng,qiàn"; /* 掅 */
dict[0x6386] = "gāng"; /* 掆 */
dict[0x6387] = "duō"; /* 掇 */
dict[0x6388] = "shòu"; /* 授 */
dict[0x6389] = "diào"; /* 掉 */
dict[0x638a] = "pǒu,póu"; /* 掊 */
dict[0x638b] = "dǐ"; /* 掋 */
dict[0x638c] = "zhǎng"; /* 掌 */
dict[0x638d] = "hùn"; /* 掍 */
dict[0x638e] = "jǐ"; /* 掎 */
dict[0x638f] = "tāo"; /* 掏 */
dict[0x6390] = "qiā"; /* 掐 */
dict[0x6391] = "qí"; /* 掑 */
dict[0x6392] = "pái,pǎi"; /* 排 */
dict[0x6393] = "shū"; /* 掓 */
dict[0x6394] = "qiān,wàn"; /* 掔 */
dict[0x6395] = "líng"; /* 掕 */
dict[0x6396] = "yè,yē"; /* 掖 */
dict[0x6397] = "yà,yǎ"; /* 掗 */
dict[0x6398] = "jué"; /* 掘 */
dict[0x6399] = "zhēng,zhèng"; /* 掙 */
dict[0x639a] = "liǎng"; /* 掚 */
dict[0x639b] = "guà"; /* 掛 */
dict[0x639c] = "nǐ,niè,yì"; /* 掜 */
dict[0x639d] = "huò,xù"; /* 掝 */
dict[0x639e] = "shàn,yàn,yǎn"; /* 掞 */
dict[0x639f] = "zhěng,dìng"; /* 掟 */
dict[0x63a0] = "lüè"; /* 掠 */
dict[0x63a1] = "cǎi"; /* 採 */
dict[0x63a2] = "tàn"; /* 探 */
dict[0x63a3] = "chè"; /* 掣 */
dict[0x63a4] = "bīng"; /* 掤 */
dict[0x63a5] = "jiē"; /* 接 */
dict[0x63a6] = "tì"; /* 掦 */
dict[0x63a7] = "kòng"; /* 控 */
dict[0x63a8] = "tuī"; /* 推 */
dict[0x63a9] = "yǎn"; /* 掩 */
dict[0x63aa] = "cuò"; /* 措 */
dict[0x63ab] = "zōu,zhōu,chōu"; /* 掫 */
dict[0x63ac] = "jū"; /* 掬 */
dict[0x63ad] = "tiàn"; /* 掭 */
dict[0x63ae] = "qián"; /* 掮 */
dict[0x63af] = "kèn"; /* 掯 */
dict[0x63b0] = "bāi"; /* 掰 */
dict[0x63b1] = "pá"; /* 掱 */
dict[0x63b2] = "jiē"; /* 掲 */
dict[0x63b3] = "lǔ"; /* 掳 */
dict[0x63b4] = "guó"; /* 掴 */
dict[0x63b5] = "mìng"; /* 掵 */
dict[0x63b6] = "jié"; /* 掶 */
dict[0x63b7] = "zhì"; /* 掷 */
dict[0x63b8] = "dǎn,shàn"; /* 掸 */
dict[0x63b9] = "mēng"; /* 掹 */
dict[0x63ba] = "chān,xiān,càn,shǎn"; /* 掺 */
dict[0x63bb] = "sāo"; /* 掻 */
dict[0x63bc] = "guàn"; /* 掼 */
dict[0x63bd] = "pèng"; /* 掽 */
dict[0x63be] = "yuàn"; /* 掾 */
dict[0x63bf] = "nuò"; /* 掿 */
dict[0x63c0] = "jiǎn"; /* 揀 */
dict[0x63c1] = "zhēng,kēng"; /* 揁 */
dict[0x63c2] = "jiū,yóu"; /* 揂 */
dict[0x63c3] = "jiǎn,jiān"; /* 揃 */
dict[0x63c4] = "yú"; /* 揄 */
dict[0x63c5] = "yán"; /* 揅 */
dict[0x63c6] = "kuí"; /* 揆 */
dict[0x63c7] = "nǎn"; /* 揇 */
dict[0x63c8] = "hōng"; /* 揈 */
dict[0x63c9] = "róu"; /* 揉 */
dict[0x63ca] = "pì,chè"; /* 揊 */
dict[0x63cb] = "wēi"; /* 揋 */
dict[0x63cc] = "sāi"; /* 揌 */
dict[0x63cd] = "zòu"; /* 揍 */
dict[0x63ce] = "xuān"; /* 揎 */
dict[0x63cf] = "miáo"; /* 描 */
dict[0x63d0] = "tí,dī,dǐ"; /* 提 */
dict[0x63d1] = "niē"; /* 揑 */
dict[0x63d2] = "chā"; /* 插 */
dict[0x63d3] = "shì"; /* 揓 */
dict[0x63d4] = "zǒng,sōng"; /* 揔 */
dict[0x63d5] = "zhèn,zhēn"; /* 揕 */
dict[0x63d6] = "yī"; /* 揖 */
dict[0x63d7] = "xún"; /* 揗 */
dict[0x63d8] = "huáng,yóng"; /* 揘 */
dict[0x63d9] = "biǎn"; /* 揙 */
dict[0x63da] = "yáng"; /* 揚 */
dict[0x63db] = "huàn"; /* 換 */
dict[0x63dc] = "yǎn"; /* 揜 */
dict[0x63dd] = "zǎn,zuàn"; /* 揝 */
dict[0x63de] = "ǎn"; /* 揞 */
dict[0x63df] = "xū,jū"; /* 揟 */
dict[0x63e0] = "yà"; /* 揠 */
dict[0x63e1] = "wò"; /* 握 */
dict[0x63e2] = "ké,qiā"; /* 揢 */
dict[0x63e3] = "chuǎi,chuài,chuāi,tuán,zhuī"; /* 揣 */
dict[0x63e4] = "jí"; /* 揤 */
dict[0x63e5] = "tì,dì"; /* 揥 */
dict[0x63e6] = "là,lá"; /* 揦 */
dict[0x63e7] = "là"; /* 揧 */
dict[0x63e8] = "chéng"; /* 揨 */
dict[0x63e9] = "kāi"; /* 揩 */
dict[0x63ea] = "jiū"; /* 揪 */
dict[0x63eb] = "jiū"; /* 揫 */
dict[0x63ec] = "tú"; /* 揬 */
dict[0x63ed] = "jiē,qì"; /* 揭 */
dict[0x63ee] = "huī"; /* 揮 */
dict[0x63ef] = "gèn"; /* 揯 */
dict[0x63f0] = "chòng,dǒng"; /* 揰 */
dict[0x63f1] = "xiāo"; /* 揱 */
dict[0x63f2] = "shé,dié,yè"; /* 揲 */
dict[0x63f3] = "xiē"; /* 揳 */
dict[0x63f4] = "yuán"; /* 援 */
dict[0x63f5] = "qián,jiàn,jiǎn"; /* 揵 */
dict[0x63f6] = "yé"; /* 揶 */
dict[0x63f7] = "chā"; /* 揷 */
dict[0x63f8] = "zhā"; /* 揸 */
dict[0x63f9] = "bēi"; /* 揹 */
dict[0x63fa] = "yáo"; /* 揺 */
dict[0x63fb] = "wēi"; /* 揻 */
dict[0x63fc] = "bèng"; /* 揼 */
dict[0x63fd] = "lǎn"; /* 揽 */
dict[0x63fe] = "wèn"; /* 揾 */
dict[0x63ff] = "qìn"; /* 揿 */
dict[0x6400] = "chān"; /* 搀 */
dict[0x6401] = "gē,gé"; /* 搁 */
dict[0x6402] = "lǒu,lōu"; /* 搂 */
dict[0x6403] = "zǒng"; /* 搃 */
dict[0x6404] = "gèn"; /* 搄 */
dict[0x6405] = "jiǎo"; /* 搅 */
dict[0x6406] = "gòu"; /* 搆 */
dict[0x6407] = "qìn"; /* 搇 */
dict[0x6408] = "róng"; /* 搈 */
dict[0x6409] = "què"; /* 搉 */
dict[0x640a] = "chōu,zǒu"; /* 搊 */
dict[0x640b] = "chuāi"; /* 搋 */
dict[0x640c] = "zhǎn"; /* 搌 */
dict[0x640d] = "sǔn"; /* 損 */
dict[0x640e] = "sūn"; /* 搎 */
dict[0x640f] = "bó"; /* 搏 */
dict[0x6410] = "chù"; /* 搐 */
dict[0x6411] = "róng,náng,nǎng"; /* 搑 */
dict[0x6412] = "bàng,péng"; /* 搒 */
dict[0x6413] = "cuō"; /* 搓 */
dict[0x6414] = "sāo"; /* 搔 */
dict[0x6415] = "kē,è"; /* 搕 */
dict[0x6416] = "yáo"; /* 搖 */
dict[0x6417] = "dǎo"; /* 搗 */
dict[0x6418] = "zhī"; /* 搘 */
dict[0x6419] = "nù,nuò,nòu"; /* 搙 */
dict[0x641a] = "lā,xié,xiàn"; /* 搚 */
dict[0x641b] = "jiān"; /* 搛 */
dict[0x641c] = "sōu"; /* 搜 */
dict[0x641d] = "qiǔ"; /* 搝 */
dict[0x641e] = "gǎo"; /* 搞 */
dict[0x641f] = "xiǎn,xiān"; /* 搟 */
dict[0x6420] = "shuò"; /* 搠 */
dict[0x6421] = "sǎng"; /* 搡 */
dict[0x6422] = "jìn"; /* 搢 */
dict[0x6423] = "miè"; /* 搣 */
dict[0x6424] = "è"; /* 搤 */
dict[0x6425] = "chuí"; /* 搥 */
dict[0x6426] = "nuò"; /* 搦 */
dict[0x6427] = "shān"; /* 搧 */
dict[0x6428] = "tà"; /* 搨 */
dict[0x6429] = "jié,zhé"; /* 搩 */
dict[0x642a] = "táng"; /* 搪 */
dict[0x642b] = "pán,bān,pó"; /* 搫 */
dict[0x642c] = "bān"; /* 搬 */
dict[0x642d] = "dā"; /* 搭 */
dict[0x642e] = "lì"; /* 搮 */
dict[0x642f] = "tāo"; /* 搯 */
dict[0x6430] = "hú"; /* 搰 */
dict[0x6431] = "zhì,nái"; /* 搱 */
dict[0x6432] = "wā,wǎ,wà"; /* 搲 */
dict[0x6433] = "huá"; /* 搳 */
dict[0x6434] = "qiān"; /* 搴 */
dict[0x6435] = "wèn"; /* 搵 */
dict[0x6436] = "qiāng,qiǎng,chēng"; /* 搶 */
dict[0x6437] = "tián,shēn"; /* 搷 */
dict[0x6438] = "zhēn"; /* 搸 */
dict[0x6439] = "è"; /* 搹 */
dict[0x643a] = "xié"; /* 携 */
dict[0x643b] = "ná,nuò"; /* 搻 */
dict[0x643c] = "quán"; /* 搼 */
dict[0x643d] = "chá"; /* 搽 */
dict[0x643e] = "zhà"; /* 搾 */
dict[0x643f] = "gé"; /* 搿 */
dict[0x6440] = "wǔ"; /* 摀 */
dict[0x6441] = "èn"; /* 摁 */
dict[0x6442] = "shè"; /* 摂 */
dict[0x6443] = "gāng"; /* 摃 */
dict[0x6444] = "shè,niè"; /* 摄 */
dict[0x6445] = "shū"; /* 摅 */
dict[0x6446] = "bǎi"; /* 摆 */
dict[0x6447] = "yáo"; /* 摇 */
dict[0x6448] = "bìn"; /* 摈 */
dict[0x6449] = "sōu"; /* 摉 */
dict[0x644a] = "tān"; /* 摊 */
dict[0x644b] = "sà,shā,shǎi"; /* 摋 */
dict[0x644c] = "chǎn,sùn"; /* 摌 */
dict[0x644d] = "suō"; /* 摍 */
dict[0x644e] = "jiū,liú,liáo,jiǎo,náo"; /* 摎 */
dict[0x644f] = "chōng"; /* 摏 */
dict[0x6450] = "chuāng"; /* 摐 */
dict[0x6451] = "guó"; /* 摑 */
dict[0x6452] = "bìng"; /* 摒 */
dict[0x6453] = "féng,pěng"; /* 摓 */
dict[0x6454] = "shuāi"; /* 摔 */
dict[0x6455] = "dì,tú,zhí"; /* 摕 */
dict[0x6456] = "qì,jì,chá"; /* 摖 */
dict[0x6457] = "sōu,sǒng"; /* 摗 */
dict[0x6458] = "zhāi"; /* 摘 */
dict[0x6459] = "liǎn,liàn"; /* 摙 */
dict[0x645a] = "chēng"; /* 摚 */
dict[0x645b] = "chī"; /* 摛 */
dict[0x645c] = "guàn"; /* 摜 */
dict[0x645d] = "lù"; /* 摝 */
dict[0x645e] = "luò"; /* 摞 */
dict[0x645f] = "lǒu,lōu"; /* 摟 */
dict[0x6460] = "zǒng"; /* 摠 */
dict[0x6461] = "gài,xì"; /* 摡 */
dict[0x6462] = "hù,chū"; /* 摢 */
dict[0x6463] = "zhā"; /* 摣 */
dict[0x6464] = "qiāng"; /* 摤 */
dict[0x6465] = "tàng"; /* 摥 */
dict[0x6466] = "huà"; /* 摦 */
dict[0x6467] = "cuī"; /* 摧 */
dict[0x6468] = "zhì,nái"; /* 摨 */
dict[0x6469] = "mó,mā"; /* 摩 */
dict[0x646a] = "jiāng,qiàng"; /* 摪 */
dict[0x646b] = "guī"; /* 摫 */
dict[0x646c] = "yǐng"; /* 摬 */
dict[0x646d] = "zhí"; /* 摭 */
dict[0x646e] = "áo,qiáo"; /* 摮 */
dict[0x646f] = "zhì"; /* 摯 */
dict[0x6470] = "niè,chè"; /* 摰 */
dict[0x6471] = "mán,màn"; /* 摱 */
dict[0x6472] = "chàn,cán"; /* 摲 */
dict[0x6473] = "kōu"; /* 摳 */
dict[0x6474] = "chū"; /* 摴 */
dict[0x6475] = "sè,mí,sù"; /* 摵 */
dict[0x6476] = "tuán"; /* 摶 */
dict[0x6477] = "jiǎo,chāo"; /* 摷 */
dict[0x6478] = "mō"; /* 摸 */
dict[0x6479] = "mó"; /* 摹 */
dict[0x647a] = "zhé"; /* 摺 */
dict[0x647b] = "chān,xiān,càn,shǎn"; /* 摻 */
dict[0x647c] = "kēng,qiān"; /* 摼 */
dict[0x647d] = "biào,biāo"; /* 摽 */
dict[0x647e] = "jiàng"; /* 摾 */
dict[0x647f] = "yáo"; /* 摿 */
dict[0x6480] = "gòu"; /* 撀 */
dict[0x6481] = "qiān"; /* 撁 */
dict[0x6482] = "liào"; /* 撂 */
dict[0x6483] = "jī"; /* 撃 */
dict[0x6484] = "yīng"; /* 撄 */
dict[0x6485] = "juē,jué"; /* 撅 */
dict[0x6486] = "piē"; /* 撆 */
dict[0x6487] = "piē,piě"; /* 撇 */
dict[0x6488] = "lāo"; /* 撈 */
dict[0x6489] = "dūn"; /* 撉 */
dict[0x648a] = "xiàn"; /* 撊 */
dict[0x648b] = "ruán"; /* 撋 */
dict[0x648c] = "guì"; /* 撌 */
dict[0x648d] = "zǎn,zān,zēn,qián"; /* 撍 */
dict[0x648e] = "yī"; /* 撎 */
dict[0x648f] = "xián"; /* 撏 */
dict[0x6490] = "chēng"; /* 撐 */
dict[0x6491] = "chēng"; /* 撑 */
dict[0x6492] = "sā,sǎ"; /* 撒 */
dict[0x6493] = "náo"; /* 撓 */
dict[0x6494] = "hòng"; /* 撔 */
dict[0x6495] = "sī"; /* 撕 */
dict[0x6496] = "hàn"; /* 撖 */
dict[0x6497] = "héng,guàng"; /* 撗 */
dict[0x6498] = "dā"; /* 撘 */
dict[0x6499] = "zǔn"; /* 撙 */
dict[0x649a] = "niǎn"; /* 撚 */
dict[0x649b] = "lǐn"; /* 撛 */
dict[0x649c] = "zhěng,chéng"; /* 撜 */
dict[0x649d] = "huī,wéi"; /* 撝 */
dict[0x649e] = "zhuàng"; /* 撞 */
dict[0x649f] = "jiǎo"; /* 撟 */
dict[0x64a0] = "jǐ"; /* 撠 */
dict[0x64a1] = "cāo"; /* 撡 */
dict[0x64a2] = "dǎn"; /* 撢 */
dict[0x64a3] = "dǎn,shàn"; /* 撣 */
dict[0x64a4] = "chè"; /* 撤 */
dict[0x64a5] = "bō"; /* 撥 */
dict[0x64a6] = "chě"; /* 撦 */
dict[0x64a7] = "juē"; /* 撧 */
dict[0x64a8] = "xiāo,sōu"; /* 撨 */
dict[0x64a9] = "liāo,liáo"; /* 撩 */
dict[0x64aa] = "bèn"; /* 撪 */
dict[0x64ab] = "fǔ"; /* 撫 */
dict[0x64ac] = "qiào"; /* 撬 */
dict[0x64ad] = "bō"; /* 播 */
dict[0x64ae] = "cuō,zuǒ"; /* 撮 */
dict[0x64af] = "zhuó"; /* 撯 */
dict[0x64b0] = "zhuàn"; /* 撰 */
dict[0x64b1] = "wěi,tuǒ"; /* 撱 */
dict[0x64b2] = "pū"; /* 撲 */
dict[0x64b3] = "qìn"; /* 撳 */
dict[0x64b4] = "dūn"; /* 撴 */
dict[0x64b5] = "niǎn"; /* 撵 */
dict[0x64b6] = "huá"; /* 撶 */
dict[0x64b7] = "xié"; /* 撷 */
dict[0x64b8] = "lū"; /* 撸 */
dict[0x64b9] = "jiǎo"; /* 撹 */
dict[0x64ba] = "cuān"; /* 撺 */
dict[0x64bb] = "tà"; /* 撻 */
dict[0x64bc] = "hàn"; /* 撼 */
dict[0x64bd] = "qiào,yāo,jī"; /* 撽 */
dict[0x64be] = "zhuā,wō"; /* 撾 */
dict[0x64bf] = "jiǎn"; /* 撿 */
dict[0x64c0] = "gǎn"; /* 擀 */
dict[0x64c1] = "yōng"; /* 擁 */
dict[0x64c2] = "léi,lèi"; /* 擂 */
dict[0x64c3] = "nǎng"; /* 擃 */
dict[0x64c4] = "lǔ"; /* 擄 */
dict[0x64c5] = "shàn"; /* 擅 */
dict[0x64c6] = "zhuó"; /* 擆 */
dict[0x64c7] = "zé,zhái"; /* 擇 */
dict[0x64c8] = "pǔ"; /* 擈 */
dict[0x64c9] = "chuò"; /* 擉 */
dict[0x64ca] = "jī"; /* 擊 */
dict[0x64cb] = "dǎng,dàng"; /* 擋 */
dict[0x64cc] = "sè"; /* 擌 */
dict[0x64cd] = "cāo"; /* 操 */
dict[0x64ce] = "qíng"; /* 擎 */
dict[0x64cf] = "qíng,jǐng"; /* 擏 */
dict[0x64d0] = "huàn"; /* 擐 */
dict[0x64d1] = "jiē"; /* 擑 */
dict[0x64d2] = "qín"; /* 擒 */
dict[0x64d3] = "kuǎi"; /* 擓 */
dict[0x64d4] = "dān,dàn"; /* 擔 */
dict[0x64d5] = "xié"; /* 擕 */
dict[0x64d6] = "qiā,jiā,yè"; /* 擖 */
dict[0x64d7] = "pǐ,bò"; /* 擗 */
dict[0x64d8] = "bò,bāi"; /* 擘 */
dict[0x64d9] = "ào"; /* 擙 */
dict[0x64da] = "jù,jū"; /* 據 */
dict[0x64db] = "yè"; /* 擛 */
dict[0x64dc] = "è"; /* 擜 */
dict[0x64dd] = "mēng"; /* 擝 */
dict[0x64de] = "sòu,sǒu"; /* 擞 */
dict[0x64df] = "mí"; /* 擟 */
dict[0x64e0] = "jǐ"; /* 擠 */
dict[0x64e1] = "tái"; /* 擡 */
dict[0x64e2] = "zhuó"; /* 擢 */
dict[0x64e3] = "dǎo"; /* 擣 */
dict[0x64e4] = "xǐng"; /* 擤 */
dict[0x64e5] = "lǎn"; /* 擥 */
dict[0x64e6] = "cā"; /* 擦 */
dict[0x64e7] = "jǔ"; /* 擧 */
dict[0x64e8] = "yē"; /* 擨 */
dict[0x64e9] = "rǔ"; /* 擩 */
dict[0x64ea] = "yè"; /* 擪 */
dict[0x64eb] = "yè"; /* 擫 */
dict[0x64ec] = "nǐ"; /* 擬 */
dict[0x64ed] = "huò"; /* 擭 */
dict[0x64ee] = "jié"; /* 擮 */
dict[0x64ef] = "bìn"; /* 擯 */
dict[0x64f0] = "níng,nǐng,nìng"; /* 擰 */
dict[0x64f1] = "gē,gé"; /* 擱 */
dict[0x64f2] = "zhì"; /* 擲 */
dict[0x64f3] = "zhì,jié"; /* 擳 */
dict[0x64f4] = "kuò"; /* 擴 */
dict[0x64f5] = "mó"; /* 擵 */
dict[0x64f6] = "jiàn"; /* 擶 */
dict[0x64f7] = "xié"; /* 擷 */
dict[0x64f8] = "liè,là"; /* 擸 */
dict[0x64f9] = "tān"; /* 擹 */
dict[0x64fa] = "bǎi"; /* 擺 */
dict[0x64fb] = "sòu,sǒu"; /* 擻 */
dict[0x64fc] = "lū"; /* 擼 */
dict[0x64fd] = "lì,luò,yuè"; /* 擽 */
dict[0x64fe] = "rǎo"; /* 擾 */
dict[0x64ff] = "tī,zhì,zhāi"; /* 擿 */
dict[0x6500] = "pān"; /* 攀 */
dict[0x6501] = "yǎng"; /* 攁 */
dict[0x6502] = "léi,lèi"; /* 攂 */
dict[0x6503] = "cā,sǎ"; /* 攃 */
dict[0x6504] = "shū"; /* 攄 */
dict[0x6505] = "zǎn"; /* 攅 */
dict[0x6506] = "niǎn"; /* 攆 */
dict[0x6507] = "xiǎn"; /* 攇 */
dict[0x6508] = "jùn,pèi"; /* 攈 */
dict[0x6509] = "huō"; /* 攉 */
dict[0x650a] = "lì,luò"; /* 攊 */
dict[0x650b] = "là,lài"; /* 攋 */
dict[0x650c] = "huàn"; /* 攌 */
dict[0x650d] = "yíng"; /* 攍 */
dict[0x650e] = "lú,luó"; /* 攎 */
dict[0x650f] = "lǒng"; /* 攏 */
dict[0x6510] = "qiān"; /* 攐 */
dict[0x6511] = "qiān"; /* 攑 */
dict[0x6512] = "zǎn,cuán"; /* 攒 */
dict[0x6513] = "qiān"; /* 攓 */
dict[0x6514] = "lán"; /* 攔 */
dict[0x6515] = "xiān,jiān"; /* 攕 */
dict[0x6516] = "yīng"; /* 攖 */
dict[0x6517] = "méi"; /* 攗 */
dict[0x6518] = "rǎng"; /* 攘 */
dict[0x6519] = "chān"; /* 攙 */
dict[0x651a] = "wěng"; /* 攚 */
dict[0x651b] = "cuān"; /* 攛 */
dict[0x651c] = "xié"; /* 攜 */
dict[0x651d] = "shè,niè"; /* 攝 */
dict[0x651e] = "luó"; /* 攞 */
dict[0x651f] = "jùn"; /* 攟 */
dict[0x6520] = "mí,mǐ,mó"; /* 攠 */
dict[0x6521] = "chī"; /* 攡 */
dict[0x6522] = "zǎn,cuán"; /* 攢 */
dict[0x6523] = "luán"; /* 攣 */
dict[0x6524] = "tān"; /* 攤 */
dict[0x6525] = "zuàn"; /* 攥 */
dict[0x6526] = "lì,shài"; /* 攦 */
dict[0x6527] = "diān"; /* 攧 */
dict[0x6528] = "wā"; /* 攨 */
dict[0x6529] = "dǎng"; /* 攩 */
dict[0x652a] = "jiǎo"; /* 攪 */
dict[0x652b] = "jué"; /* 攫 */
dict[0x652c] = "lǎn"; /* 攬 */
dict[0x652d] = "lì,luǒ"; /* 攭 */
dict[0x652e] = "nǎng"; /* 攮 */
dict[0x652f] = "zhī"; /* 支 */
dict[0x6530] = "guì"; /* 攰 */
dict[0x6531] = "guǐ,guì"; /* 攱 */
dict[0x6532] = "qī,yǐ,jī"; /* 攲 */
dict[0x6533] = "xún"; /* 攳 */
dict[0x6534] = "pū"; /* 攴 */
dict[0x6535] = "pū"; /* 攵 */
dict[0x6536] = "shōu"; /* 收 */
dict[0x6537] = "kǎo"; /* 攷 */
dict[0x6538] = "yōu"; /* 攸 */
dict[0x6539] = "gǎi"; /* 改 */
dict[0x653a] = "yǐ"; /* 攺 */
dict[0x653b] = "gōng"; /* 攻 */
dict[0x653c] = "gān,hàn"; /* 攼 */
dict[0x653d] = "bān"; /* 攽 */
dict[0x653e] = "fàng"; /* 放 */
dict[0x653f] = "zhèng"; /* 政 */
dict[0x6540] = "pò"; /* 敀 */
dict[0x6541] = "diān"; /* 敁 */
dict[0x6542] = "kòu"; /* 敂 */
dict[0x6543] = "mǐn"; /* 敃 */
dict[0x6544] = "wù,móu"; /* 敄 */
dict[0x6545] = "gù"; /* 故 */
dict[0x6546] = "hé"; /* 敆 */
dict[0x6547] = "cè"; /* 敇 */
dict[0x6548] = "xiào"; /* 效 */
dict[0x6549] = "mǐ"; /* 敉 */
dict[0x654a] = "chù,shōu"; /* 敊 */
dict[0x654b] = "gé,guó,è"; /* 敋 */
dict[0x654c] = "dí"; /* 敌 */
dict[0x654d] = "xù"; /* 敍 */
dict[0x654e] = "jiào,jiāo"; /* 敎 */
dict[0x654f] = "mǐn"; /* 敏 */
dict[0x6550] = "chén"; /* 敐 */
dict[0x6551] = "jiù"; /* 救 */
dict[0x6552] = "shēn"; /* 敒 */
dict[0x6553] = "duó,duì"; /* 敓 */
dict[0x6554] = "yǔ"; /* 敔 */
dict[0x6555] = "chì"; /* 敕 */
dict[0x6556] = "áo"; /* 敖 */
dict[0x6557] = "bài"; /* 敗 */
dict[0x6558] = "xù"; /* 敘 */
dict[0x6559] = "jiào,jiāo"; /* 教 */
dict[0x655a] = "duó,duì"; /* 敚 */
dict[0x655b] = "liǎn"; /* 敛 */
dict[0x655c] = "niè"; /* 敜 */
dict[0x655d] = "bì"; /* 敝 */
dict[0x655e] = "chǎng"; /* 敞 */
dict[0x655f] = "diǎn"; /* 敟 */
dict[0x6560] = "duō,què"; /* 敠 */
dict[0x6561] = "yì"; /* 敡 */
dict[0x6562] = "gǎn"; /* 敢 */
dict[0x6563] = "sàn,sǎn"; /* 散 */
dict[0x6564] = "kě"; /* 敤 */
dict[0x6565] = "yàn"; /* 敥 */
dict[0x6566] = "dūn,duì"; /* 敦 */
dict[0x6567] = "qī,yǐ,jī"; /* 敧 */
dict[0x6568] = "tǒu"; /* 敨 */
dict[0x6569] = "xiào,xué"; /* 敩 */
dict[0x656a] = "duō,què"; /* 敪 */
dict[0x656b] = "jiǎo"; /* 敫 */
dict[0x656c] = "jìng"; /* 敬 */
dict[0x656d] = "yáng"; /* 敭 */
dict[0x656e] = "xiá"; /* 敮 */
dict[0x656f] = "mǐn"; /* 敯 */
dict[0x6570] = "shù,shǔ,shuò"; /* 数 */
dict[0x6571] = "ái,zhú"; /* 敱 */
dict[0x6572] = "qiāo"; /* 敲 */
dict[0x6573] = "ái"; /* 敳 */
dict[0x6574] = "zhěng"; /* 整 */
dict[0x6575] = "dí"; /* 敵 */
dict[0x6576] = "chén"; /* 敶 */
dict[0x6577] = "fū"; /* 敷 */
dict[0x6578] = "shù,shǔ,shuò"; /* 數 */
dict[0x6579] = "liáo"; /* 敹 */
dict[0x657a] = "qū"; /* 敺 */
dict[0x657b] = "xiòng,xuàn"; /* 敻 */
dict[0x657c] = "yǐ"; /* 敼 */
dict[0x657d] = "jiǎo"; /* 敽 */
dict[0x657e] = "shàn"; /* 敾 */
dict[0x657f] = "jiǎo"; /* 敿 */
dict[0x6580] = "zhuó,zhú"; /* 斀 */
dict[0x6581] = "yì,dù"; /* 斁 */
dict[0x6582] = "liǎn"; /* 斂 */
dict[0x6583] = "bì"; /* 斃 */
dict[0x6584] = "lí,tái"; /* 斄 */
dict[0x6585] = "xiào"; /* 斅 */
dict[0x6586] = "xiào"; /* 斆 */
dict[0x6587] = "wén"; /* 文 */
dict[0x6588] = "xué"; /* 斈 */
dict[0x6589] = "qí"; /* 斉 */
dict[0x658a] = "qí"; /* 斊 */
dict[0x658b] = "zhāi"; /* 斋 */
dict[0x658c] = "bīn"; /* 斌 */
dict[0x658d] = "jué,jiào"; /* 斍 */
dict[0x658e] = "zhāi"; /* 斎 */
dict[0x658f] = "láng"; /* 斏 */
dict[0x6590] = "fěi,fēi"; /* 斐 */
dict[0x6591] = "bān"; /* 斑 */
dict[0x6592] = "bān"; /* 斒 */
dict[0x6593] = "lán"; /* 斓 */
dict[0x6594] = "yǔ,zhōng"; /* 斔 */
dict[0x6595] = "lán"; /* 斕 */
dict[0x6596] = "wěi,mén"; /* 斖 */
dict[0x6597] = "dǒu,dòu"; /* 斗 */
dict[0x6598] = "shēng"; /* 斘 */
dict[0x6599] = "liào"; /* 料 */
dict[0x659a] = "jiǎ"; /* 斚 */
dict[0x659b] = "hú"; /* 斛 */
dict[0x659c] = "xié"; /* 斜 */
dict[0x659d] = "jiǎ"; /* 斝 */
dict[0x659e] = "yǔ"; /* 斞 */
dict[0x659f] = "zhēn"; /* 斟 */
dict[0x65a0] = "jiào"; /* 斠 */
dict[0x65a1] = "wò,guǎn"; /* 斡 */
dict[0x65a2] = "tǒu,tiǎo"; /* 斢 */
dict[0x65a3] = "dòu"; /* 斣 */
dict[0x65a4] = "jīn"; /* 斤 */
dict[0x65a5] = "chì"; /* 斥 */
dict[0x65a6] = "yín,zhì"; /* 斦 */
dict[0x65a7] = "fǔ"; /* 斧 */
dict[0x65a8] = "qiāng"; /* 斨 */
dict[0x65a9] = "zhǎn"; /* 斩 */
dict[0x65aa] = "qú"; /* 斪 */
dict[0x65ab] = "zhuó"; /* 斫 */
dict[0x65ac] = "zhǎn"; /* 斬 */
dict[0x65ad] = "duàn"; /* 断 */
dict[0x65ae] = "zhuó"; /* 斮 */
dict[0x65af] = "sī"; /* 斯 */
dict[0x65b0] = "xīn"; /* 新 */
dict[0x65b1] = "zhuó"; /* 斱 */
dict[0x65b2] = "zhuó"; /* 斲 */
dict[0x65b3] = "qín"; /* 斳 */
dict[0x65b4] = "lín"; /* 斴 */
dict[0x65b5] = "zhuó"; /* 斵 */
dict[0x65b6] = "chù"; /* 斶 */
dict[0x65b7] = "duàn"; /* 斷 */
dict[0x65b8] = "zhú"; /* 斸 */
dict[0x65b9] = "fāng"; /* 方 */
dict[0x65ba] = "chǎn,jiè"; /* 斺 */
dict[0x65bb] = "háng"; /* 斻 */
dict[0x65bc] = "yú,wū"; /* 於 */
dict[0x65bd] = "shī"; /* 施 */
dict[0x65be] = "pèi"; /* 斾 */
dict[0x65bf] = "liú,yóu"; /* 斿 */
dict[0x65c0] = "mèi"; /* 旀 */
dict[0x65c1] = "páng,bàng"; /* 旁 */
dict[0x65c2] = "qí"; /* 旂 */
dict[0x65c3] = "zhān"; /* 旃 */
dict[0x65c4] = "máo,mào"; /* 旄 */
dict[0x65c5] = "lǚ"; /* 旅 */
dict[0x65c6] = "pèi"; /* 旆 */
dict[0x65c7] = "pī,bì"; /* 旇 */
dict[0x65c8] = "liú"; /* 旈 */
dict[0x65c9] = "fū"; /* 旉 */
dict[0x65ca] = "fǎng"; /* 旊 */
dict[0x65cb] = "xuán,xuàn"; /* 旋 */
dict[0x65cc] = "jīng"; /* 旌 */
dict[0x65cd] = "jīng"; /* 旍 */
dict[0x65ce] = "nǐ"; /* 旎 */
dict[0x65cf] = "zú"; /* 族 */
dict[0x65d0] = "zhào"; /* 旐 */
dict[0x65d1] = "yǐ"; /* 旑 */
dict[0x65d2] = "liú"; /* 旒 */
dict[0x65d3] = "shāo"; /* 旓 */
dict[0x65d4] = "jiàn"; /* 旔 */
dict[0x65d6] = "yǐ"; /* 旖 */
dict[0x65d7] = "qí"; /* 旗 */
dict[0x65d8] = "zhì"; /* 旘 */
dict[0x65d9] = "fān"; /* 旙 */
dict[0x65da] = "piāo"; /* 旚 */
dict[0x65db] = "fān"; /* 旛 */
dict[0x65dc] = "zhān"; /* 旜 */
dict[0x65dd] = "kuài"; /* 旝 */
dict[0x65de] = "suì"; /* 旞 */
dict[0x65df] = "yú"; /* 旟 */
dict[0x65e0] = "wú"; /* 无 */
dict[0x65e1] = "jì"; /* 旡 */
dict[0x65e2] = "jì"; /* 既 */
dict[0x65e3] = "jì"; /* 旣 */
dict[0x65e4] = "huò"; /* 旤 */
dict[0x65e5] = "rì"; /* 日 */
dict[0x65e6] = "dàn"; /* 旦 */
dict[0x65e7] = "jiù"; /* 旧 */
dict[0x65e8] = "zhǐ"; /* 旨 */
dict[0x65e9] = "zǎo"; /* 早 */
dict[0x65ea] = "xié"; /* 旪 */
dict[0x65eb] = "tiāo"; /* 旫 */
dict[0x65ec] = "xún"; /* 旬 */
dict[0x65ed] = "xù"; /* 旭 */
dict[0x65ee] = "gā"; /* 旮 */
dict[0x65ef] = "lá"; /* 旯 */
dict[0x65f0] = "gàn,hàn"; /* 旰 */
dict[0x65f1] = "hàn"; /* 旱 */
dict[0x65f2] = "tái,yīng"; /* 旲 */
dict[0x65f3] = "dì,dí,de"; /* 旳 */
dict[0x65f4] = "xù,xū"; /* 旴 */
dict[0x65f5] = "chǎn"; /* 旵 */
dict[0x65f6] = "shí"; /* 时 */
dict[0x65f7] = "kuàng"; /* 旷 */
dict[0x65f8] = "yáng"; /* 旸 */
dict[0x65f9] = "shí"; /* 旹 */
dict[0x65fa] = "wàng"; /* 旺 */
dict[0x65fb] = "mín"; /* 旻 */
dict[0x65fc] = "mín"; /* 旼 */
dict[0x65fd] = "tūn,zhùn"; /* 旽 */
dict[0x65fe] = "chūn"; /* 旾 */
dict[0x65ff] = "wù,wǔ"; /* 旿 */
dict[0x6600] = "yún"; /* 昀 */
dict[0x6601] = "bèi"; /* 昁 */
dict[0x6602] = "áng"; /* 昂 */
dict[0x6603] = "zè"; /* 昃 */
dict[0x6604] = "bǎn"; /* 昄 */
dict[0x6605] = "jié"; /* 昅 */
dict[0x6606] = "kūn"; /* 昆 */
dict[0x6607] = "shēng"; /* 昇 */
dict[0x6608] = "hù"; /* 昈 */
dict[0x6609] = "fǎng"; /* 昉 */
dict[0x660a] = "hào"; /* 昊 */
dict[0x660b] = "guì"; /* 昋 */
dict[0x660c] = "chāng"; /* 昌 */
dict[0x660d] = "xuān"; /* 昍 */
dict[0x660e] = "míng"; /* 明 */
dict[0x660f] = "hūn"; /* 昏 */
dict[0x6610] = "fēn"; /* 昐 */
dict[0x6611] = "qǐn"; /* 昑 */
dict[0x6612] = "hū"; /* 昒 */
dict[0x6613] = "yì"; /* 易 */
dict[0x6614] = "xī"; /* 昔 */
dict[0x6615] = "xīn"; /* 昕 */
dict[0x6616] = "yán"; /* 昖 */
dict[0x6617] = "zè"; /* 昗 */
dict[0x6618] = "fǎng"; /* 昘 */
dict[0x6619] = "tán"; /* 昙 */
dict[0x661a] = "shèn"; /* 昚 */
dict[0x661b] = "jù"; /* 昛 */
dict[0x661c] = "yáng"; /* 昜 */
dict[0x661d] = "zǎn"; /* 昝 */
dict[0x661e] = "bǐng"; /* 昞 */
dict[0x661f] = "xīng"; /* 星 */
dict[0x6620] = "yìng"; /* 映 */
dict[0x6621] = "xuàn"; /* 昡 */
dict[0x6622] = "pò"; /* 昢 */
dict[0x6623] = "zhěn"; /* 昣 */
dict[0x6624] = "líng"; /* 昤 */
dict[0x6625] = "chūn"; /* 春 */
dict[0x6626] = "hào"; /* 昦 */
dict[0x6627] = "mèi"; /* 昧 */
dict[0x6628] = "zuó"; /* 昨 */
dict[0x6629] = "mò"; /* 昩 */
dict[0x662a] = "biàn"; /* 昪 */
dict[0x662b] = "xù"; /* 昫 */
dict[0x662c] = "hūn"; /* 昬 */
dict[0x662d] = "zhāo"; /* 昭 */
dict[0x662e] = "zòng"; /* 昮 */
dict[0x662f] = "shì"; /* 是 */
dict[0x6630] = "shì"; /* 昰 */
dict[0x6631] = "yù"; /* 昱 */
dict[0x6632] = "fèi"; /* 昲 */
dict[0x6633] = "dié,yì"; /* 昳 */
dict[0x6634] = "mǎo"; /* 昴 */
dict[0x6635] = "nì"; /* 昵 */
dict[0x6636] = "chǎng"; /* 昶 */
dict[0x6637] = "wēn"; /* 昷 */
dict[0x6638] = "dōng"; /* 昸 */
dict[0x6639] = "ǎi"; /* 昹 */
dict[0x663a] = "bǐng"; /* 昺 */
dict[0x663b] = "áng"; /* 昻 */
dict[0x663c] = "zhòu"; /* 昼 */
dict[0x663d] = "lóng"; /* 昽 */
dict[0x663e] = "xiǎn"; /* 显 */
dict[0x663f] = "kuàng"; /* 昿 */
dict[0x6640] = "tiǎo"; /* 晀 */
dict[0x6641] = "cháo"; /* 晁 */
dict[0x6642] = "shí"; /* 時 */
dict[0x6643] = "huǎng,huàng"; /* 晃 */
dict[0x6644] = "huǎng"; /* 晄 */
dict[0x6645] = "xuān"; /* 晅 */
dict[0x6646] = "kuí"; /* 晆 */
dict[0x6647] = "xù,kuā"; /* 晇 */
dict[0x6648] = "jiǎo"; /* 晈 */
dict[0x6649] = "jìn"; /* 晉 */
dict[0x664a] = "zhì"; /* 晊 */
dict[0x664b] = "jìn"; /* 晋 */
dict[0x664c] = "shǎng"; /* 晌 */
dict[0x664d] = "tóng"; /* 晍 */
dict[0x664e] = "hǒng"; /* 晎 */
dict[0x664f] = "yàn"; /* 晏 */
dict[0x6650] = "gāi"; /* 晐 */
dict[0x6651] = "xiǎng"; /* 晑 */
dict[0x6652] = "shài"; /* 晒 */
dict[0x6653] = "xiǎo"; /* 晓 */
dict[0x6654] = "yè"; /* 晔 */
dict[0x6655] = "yùn,yūn"; /* 晕 */
dict[0x6656] = "huī"; /* 晖 */
dict[0x6657] = "hán"; /* 晗 */
dict[0x6658] = "hàn"; /* 晘 */
dict[0x6659] = "jùn"; /* 晙 */
dict[0x665a] = "wǎn"; /* 晚 */
dict[0x665b] = "xiàn"; /* 晛 */
dict[0x665c] = "kūn"; /* 晜 */
dict[0x665d] = "zhòu"; /* 晝 */
dict[0x665e] = "xī"; /* 晞 */
dict[0x665f] = "shèng,chéng"; /* 晟 */
dict[0x6660] = "shèng"; /* 晠 */
dict[0x6661] = "bū"; /* 晡 */
dict[0x6662] = "zhé"; /* 晢 */
dict[0x6663] = "zhé"; /* 晣 */
dict[0x6664] = "wù"; /* 晤 */
dict[0x6665] = "wǎn"; /* 晥 */
dict[0x6666] = "huì"; /* 晦 */
dict[0x6667] = "hào"; /* 晧 */
dict[0x6668] = "chén"; /* 晨 */
dict[0x6669] = "wǎn"; /* 晩 */
dict[0x666a] = "tiǎn"; /* 晪 */
dict[0x666b] = "zhuó"; /* 晫 */
dict[0x666c] = "zuì"; /* 晬 */
dict[0x666d] = "zhǒu"; /* 晭 */
dict[0x666e] = "pǔ"; /* 普 */
dict[0x666f] = "jǐng,yǐng"; /* 景 */
dict[0x6670] = "xī"; /* 晰 */
dict[0x6671] = "shǎn"; /* 晱 */
dict[0x6672] = "nǐ"; /* 晲 */
dict[0x6673] = "xī"; /* 晳 */
dict[0x6674] = "qíng"; /* 晴 */
dict[0x6675] = "qǐ,dù"; /* 晵 */
dict[0x6676] = "jīng"; /* 晶 */
dict[0x6677] = "guǐ"; /* 晷 */
dict[0x6678] = "zhěng"; /* 晸 */
dict[0x6679] = "yì"; /* 晹 */
dict[0x667a] = "zhì"; /* 智 */
dict[0x667b] = "àn,ǎn,yǎn"; /* 晻 */
dict[0x667c] = "wǎn"; /* 晼 */
dict[0x667d] = "lín"; /* 晽 */
dict[0x667e] = "liàng"; /* 晾 */
dict[0x667f] = "chēng"; /* 晿 */
dict[0x6680] = "wǎng,wàng"; /* 暀 */
dict[0x6681] = "xiǎo"; /* 暁 */
dict[0x6682] = "zàn"; /* 暂 */
dict[0x6683] = "fēi"; /* 暃 */
dict[0x6684] = "xuān"; /* 暄 */
dict[0x6685] = "xuǎn"; /* 暅 */
dict[0x6686] = "yí"; /* 暆 */
dict[0x6687] = "xiá"; /* 暇 */
dict[0x6688] = "yùn,yūn"; /* 暈 */
dict[0x6689] = "huī"; /* 暉 */
dict[0x668a] = "xǔ"; /* 暊 */
dict[0x668b] = "mǐn,mín"; /* 暋 */
dict[0x668c] = "kuí"; /* 暌 */
dict[0x668d] = "yē"; /* 暍 */
dict[0x668e] = "yìng"; /* 暎 */
dict[0x668f] = "shǔ,dǔ"; /* 暏 */
dict[0x6690] = "wěi"; /* 暐 */
dict[0x6691] = "shǔ"; /* 暑 */
dict[0x6692] = "qíng"; /* 暒 */
dict[0x6693] = "mào"; /* 暓 */
dict[0x6694] = "nán"; /* 暔 */
dict[0x6695] = "jiǎn,lán"; /* 暕 */
dict[0x6696] = "nuǎn"; /* 暖 */
dict[0x6697] = "àn"; /* 暗 */
dict[0x6698] = "yáng"; /* 暘 */
dict[0x6699] = "chūn"; /* 暙 */
dict[0x669a] = "yáo"; /* 暚 */
dict[0x669b] = "suǒ"; /* 暛 */
dict[0x669c] = "pǔ"; /* 暜 */
dict[0x669d] = "míng"; /* 暝 */
dict[0x669e] = "jiǎo"; /* 暞 */
dict[0x669f] = "kǎi"; /* 暟 */
dict[0x66a0] = "hào"; /* 暠 */
dict[0x66a1] = "wěng"; /* 暡 */
dict[0x66a2] = "chàng"; /* 暢 */
dict[0x66a3] = "qì"; /* 暣 */
dict[0x66a4] = "hào"; /* 暤 */
dict[0x66a5] = "yàn"; /* 暥 */
dict[0x66a6] = "lì"; /* 暦 */
dict[0x66a7] = "ài"; /* 暧 */
dict[0x66a8] = "jì"; /* 暨 */
dict[0x66a9] = "jì"; /* 暩 */
dict[0x66aa] = "mèn"; /* 暪 */
dict[0x66ab] = "zàn"; /* 暫 */
dict[0x66ac] = "xiè"; /* 暬 */
dict[0x66ad] = "hào"; /* 暭 */
dict[0x66ae] = "mù"; /* 暮 */
dict[0x66af] = "mù"; /* 暯 */
dict[0x66b0] = "cōng"; /* 暰 */
dict[0x66b1] = "nì"; /* 暱 */
dict[0x66b2] = "zhāng"; /* 暲 */
dict[0x66b3] = "huì"; /* 暳 */
dict[0x66b4] = "bào,pù"; /* 暴 */
dict[0x66b5] = "hàn"; /* 暵 */
dict[0x66b6] = "xuán"; /* 暶 */
dict[0x66b7] = "chuán"; /* 暷 */
dict[0x66b8] = "liáo"; /* 暸 */
dict[0x66b9] = "xiān"; /* 暹 */
dict[0x66ba] = "tǎn"; /* 暺 */
dict[0x66bb] = "jǐng"; /* 暻 */
dict[0x66bc] = "piē"; /* 暼 */
dict[0x66bd] = "lín"; /* 暽 */
dict[0x66be] = "tūn"; /* 暾 */
dict[0x66bf] = "xī,xǐ"; /* 暿 */
dict[0x66c0] = "yì"; /* 曀 */
dict[0x66c1] = "jì"; /* 曁 */
dict[0x66c2] = "huàng"; /* 曂 */
dict[0x66c3] = "dài"; /* 曃 */
dict[0x66c4] = "yè"; /* 曄 */
dict[0x66c5] = "yè"; /* 曅 */
dict[0x66c6] = "lì"; /* 曆 */
dict[0x66c7] = "tán"; /* 曇 */
dict[0x66c8] = "tóng"; /* 曈 */
dict[0x66c9] = "xiǎo"; /* 曉 */
dict[0x66ca] = "fèi"; /* 曊 */
dict[0x66cb] = "shěn"; /* 曋 */
dict[0x66cc] = "zhào"; /* 曌 */
dict[0x66cd] = "hào"; /* 曍 */
dict[0x66ce] = "yì"; /* 曎 */
dict[0x66cf] = "xiàng"; /* 曏 */
dict[0x66d0] = "xīng"; /* 曐 */
dict[0x66d1] = "shēn"; /* 曑 */
dict[0x66d2] = "jiǎo"; /* 曒 */
dict[0x66d3] = "bào"; /* 曓 */
dict[0x66d4] = "jìng"; /* 曔 */
dict[0x66d5] = "yàn"; /* 曕 */
dict[0x66d6] = "ài"; /* 曖 */
dict[0x66d7] = "yè"; /* 曗 */
dict[0x66d8] = "rú"; /* 曘 */
dict[0x66d9] = "shǔ"; /* 曙 */
dict[0x66da] = "méng"; /* 曚 */
dict[0x66db] = "xūn"; /* 曛 */
dict[0x66dc] = "yào"; /* 曜 */
dict[0x66dd] = "pù,bào"; /* 曝 */
dict[0x66de] = "lì"; /* 曞 */
dict[0x66df] = "chén"; /* 曟 */
dict[0x66e0] = "kuàng"; /* 曠 */
dict[0x66e1] = "dié"; /* 曡 */
dict[0x66e2] = "liǎo"; /* 曢 */
dict[0x66e3] = "yàn"; /* 曣 */
dict[0x66e4] = "huò"; /* 曤 */
dict[0x66e5] = "lú"; /* 曥 */
dict[0x66e6] = "xī"; /* 曦 */
dict[0x66e7] = "róng"; /* 曧 */
dict[0x66e8] = "lóng"; /* 曨 */
dict[0x66e9] = "nǎng"; /* 曩 */
dict[0x66ea] = "luǒ"; /* 曪 */
dict[0x66eb] = "luán"; /* 曫 */
dict[0x66ec] = "shài"; /* 曬 */
dict[0x66ed] = "tǎng"; /* 曭 */
dict[0x66ee] = "yǎn"; /* 曮 */
dict[0x66ef] = "zhú"; /* 曯 */
dict[0x66f0] = "yuē"; /* 曰 */
dict[0x66f1] = "yuē"; /* 曱 */
dict[0x66f2] = "qū,qǔ"; /* 曲 */
dict[0x66f3] = "yè"; /* 曳 */
dict[0x66f4] = "gēng,gèng"; /* 更 */
dict[0x66f5] = "yè"; /* 曵 */
dict[0x66f6] = "hū,hù"; /* 曶 */
dict[0x66f7] = "hé"; /* 曷 */
dict[0x66f8] = "shū"; /* 書 */
dict[0x66f9] = "cáo"; /* 曹 */
dict[0x66fa] = "cáo"; /* 曺 */
dict[0x66fb] = "shēng"; /* 曻 */
dict[0x66fc] = "màn"; /* 曼 */
dict[0x66fd] = "zēng,céng"; /* 曽 */
dict[0x66fe] = "zēng,céng"; /* 曾 */
dict[0x66ff] = "tì"; /* 替 */
dict[0x6700] = "zuì"; /* 最 */
dict[0x6701] = "cǎn,qián,jiàn"; /* 朁 */
dict[0x6702] = "xù"; /* 朂 */
dict[0x6703] = "huì,kuài"; /* 會 */
dict[0x6704] = "yǐn"; /* 朄 */
dict[0x6705] = "qiè,hé"; /* 朅 */
dict[0x6706] = "fēn"; /* 朆 */
dict[0x6707] = "bì,pí"; /* 朇 */
dict[0x6708] = "yuè"; /* 月 */
dict[0x6709] = "yǒu,yòu"; /* 有 */
dict[0x670a] = "ruǎn"; /* 朊 */
dict[0x670b] = "péng"; /* 朋 */
dict[0x670c] = "fén,bān"; /* 朌 */
dict[0x670d] = "fú,fù"; /* 服 */
dict[0x670e] = "líng"; /* 朎 */
dict[0x670f] = "fěi,kū"; /* 朏 */
dict[0x6710] = "qú,xù,chǔn"; /* 朐 */
dict[0x6711] = "tì"; /* 朑 */
dict[0x6712] = "nǜ,gǎ"; /* 朒 */
dict[0x6713] = "tiǎo"; /* 朓 */
dict[0x6714] = "shuò"; /* 朔 */
dict[0x6715] = "zhèn"; /* 朕 */
dict[0x6716] = "lǎng"; /* 朖 */
dict[0x6717] = "lǎng"; /* 朗 */
dict[0x6718] = "juān,zuī"; /* 朘 */
dict[0x6719] = "míng"; /* 朙 */
dict[0x671a] = "huāng,máng,wáng"; /* 朚 */
dict[0x671b] = "wàng"; /* 望 */
dict[0x671c] = "tūn"; /* 朜 */
dict[0x671d] = "zhāo,cháo"; /* 朝 */
dict[0x671e] = "jī"; /* 朞 */
dict[0x671f] = "qī,jī"; /* 期 */
dict[0x6720] = "yīng"; /* 朠 */
dict[0x6721] = "zōng"; /* 朡 */
dict[0x6722] = "wàng"; /* 朢 */
dict[0x6723] = "tóng,chuáng"; /* 朣 */
dict[0x6724] = "lǎng"; /* 朤 */
dict[0x6725] = "láo"; /* 朥 */
dict[0x6726] = "méng"; /* 朦 */
dict[0x6727] = "lóng"; /* 朧 */
dict[0x6728] = "mù"; /* 木 */
dict[0x672a] = "wèi"; /* 未 */
dict[0x672b] = "mò"; /* 末 */
dict[0x672c] = "běn"; /* 本 */
dict[0x672d] = "zhá"; /* 札 */
dict[0x672e] = "shù,shú,zhú"; /* 朮 */
dict[0x672f] = "shù,shú,zhú"; /* 术 */
dict[0x6731] = "zhū,shú"; /* 朱 */
dict[0x6732] = "rén"; /* 朲 */
dict[0x6733] = "bā"; /* 朳 */
dict[0x6734] = "pǔ,pò,pō,piáo"; /* 朴 */
dict[0x6735] = "duǒ"; /* 朵 */
dict[0x6736] = "duǒ"; /* 朶 */
dict[0x6737] = "dāo,tiáo,mù"; /* 朷 */
dict[0x6738] = "lì"; /* 朸 */
dict[0x6739] = "qiú,guǐ"; /* 朹 */
dict[0x673a] = "jī"; /* 机 */
dict[0x673b] = "jiū"; /* 朻 */
dict[0x673c] = "bǐ"; /* 朼 */
dict[0x673d] = "xiǔ"; /* 朽 */
dict[0x673e] = "chéng,chēng"; /* 朾 */
dict[0x673f] = "cì"; /* 朿 */
dict[0x6740] = "shā"; /* 杀 */
dict[0x6741] = "rù"; /* 杁 */
dict[0x6742] = "zá"; /* 杂 */
dict[0x6743] = "quán"; /* 权 */
dict[0x6744] = "qiān"; /* 杄 */
dict[0x6745] = "yú,wū"; /* 杅 */
dict[0x6746] = "gān,gǎn"; /* 杆 */
dict[0x6747] = "wū"; /* 杇 */
dict[0x6748] = "chā,chà"; /* 杈 */
dict[0x6749] = "shān,shā"; /* 杉 */
dict[0x674a] = "xún"; /* 杊 */
dict[0x674b] = "fán"; /* 杋 */
dict[0x674c] = "wù"; /* 杌 */
dict[0x674d] = "zǐ"; /* 杍 */
dict[0x674e] = "lǐ"; /* 李 */
dict[0x674f] = "xìng"; /* 杏 */
dict[0x6750] = "cái"; /* 材 */
dict[0x6751] = "cūn"; /* 村 */
dict[0x6752] = "rèn,ér"; /* 杒 */
dict[0x6753] = "sháo,biāo"; /* 杓 */
dict[0x6754] = "tuō,zhé"; /* 杔 */
dict[0x6755] = "dì,duò"; /* 杕 */
dict[0x6756] = "zhàng"; /* 杖 */
dict[0x6757] = "máng"; /* 杗 */
dict[0x6758] = "chì"; /* 杘 */
dict[0x6759] = "yì"; /* 杙 */
dict[0x675a] = "gū,gài"; /* 杚 */
dict[0x675b] = "gōng"; /* 杛 */
dict[0x675c] = "dù"; /* 杜 */
dict[0x675d] = "yí,lì,lí,duò,tuò"; /* 杝 */
dict[0x675e] = "qǐ"; /* 杞 */
dict[0x675f] = "shù"; /* 束 */
dict[0x6760] = "gàng,gāng"; /* 杠 */
dict[0x6761] = "tiáo,tiāo"; /* 条 */
dict[0x6762] = "jié"; /* 杢 */
dict[0x6763] = "mián"; /* 杣 */
dict[0x6764] = "wàn"; /* 杤 */
dict[0x6765] = "lái"; /* 来 */
dict[0x6766] = "jiǔ"; /* 杦 */
dict[0x6767] = "máng"; /* 杧 */
dict[0x6768] = "yáng"; /* 杨 */
dict[0x6769] = "mà,mǎ"; /* 杩 */
dict[0x676a] = "miǎo"; /* 杪 */
dict[0x676b] = "sì,zhǐ,xǐ"; /* 杫 */
dict[0x676c] = "yuán,wán"; /* 杬 */
dict[0x676d] = "háng"; /* 杭 */
dict[0x676e] = "fèi,bèi"; /* 杮 */
dict[0x676f] = "bēi"; /* 杯 */
dict[0x6770] = "jié"; /* 杰 */
dict[0x6771] = "dōng"; /* 東 */
dict[0x6772] = "gǎo"; /* 杲 */
dict[0x6773] = "yǎo"; /* 杳 */
dict[0x6774] = "xiān"; /* 杴 */
dict[0x6775] = "chǔ"; /* 杵 */
dict[0x6776] = "chūn"; /* 杶 */
dict[0x6777] = "pá"; /* 杷 */
dict[0x6778] = "shū,duì"; /* 杸 */
dict[0x6779] = "huà"; /* 杹 */
dict[0x677a] = "xīn"; /* 杺 */
dict[0x677b] = "niǔ,chǒu"; /* 杻 */
dict[0x677c] = "zhù"; /* 杼 */
dict[0x677d] = "chǒu"; /* 杽 */
dict[0x677e] = "sōng"; /* 松 */
dict[0x677f] = "bǎn"; /* 板 */
dict[0x6780] = "sōng"; /* 枀 */
dict[0x6781] = "jí"; /* 极 */
dict[0x6782] = "wò,yuè"; /* 枂 */
dict[0x6783] = "jìn"; /* 枃 */
dict[0x6784] = "gòu"; /* 构 */
dict[0x6785] = "jī"; /* 枅 */
dict[0x6786] = "máo"; /* 枆 */
dict[0x6787] = "pí"; /* 枇 */
dict[0x6788] = "pī,mì"; /* 枈 */
dict[0x6789] = "wǎng"; /* 枉 */
dict[0x678a] = "àng"; /* 枊 */
dict[0x678b] = "fāng,bìng"; /* 枋 */
dict[0x678c] = "fén"; /* 枌 */
dict[0x678d] = "yì"; /* 枍 */
dict[0x678e] = "fú,fū"; /* 枎 */
dict[0x678f] = "nán"; /* 枏 */
dict[0x6790] = "xī"; /* 析 */
dict[0x6791] = "hù,dǐ"; /* 枑 */
dict[0x6792] = "yā"; /* 枒 */
dict[0x6793] = "dōu"; /* 枓 */
dict[0x6794] = "xín"; /* 枔 */
dict[0x6795] = "zhěn"; /* 枕 */
dict[0x6796] = "yǎo,yāo"; /* 枖 */
dict[0x6797] = "lín"; /* 林 */
dict[0x6798] = "ruì"; /* 枘 */
dict[0x6799] = "ě,è"; /* 枙 */
dict[0x679a] = "méi"; /* 枚 */
dict[0x679b] = "zhào"; /* 枛 */
dict[0x679c] = "guǒ"; /* 果 */
dict[0x679d] = "zhī,qí"; /* 枝 */
dict[0x679e] = "cōng,zōng"; /* 枞 */
dict[0x679f] = "yùn"; /* 枟 */
dict[0x67a0] = "huà"; /* 枠 */
dict[0x67a1] = "shēng"; /* 枡 */
dict[0x67a2] = "shū"; /* 枢 */
dict[0x67a3] = "zǎo"; /* 枣 */
dict[0x67a4] = "dì,duò"; /* 枤 */
dict[0x67a5] = "lì"; /* 枥 */
dict[0x67a6] = "lú"; /* 枦 */
dict[0x67a7] = "jiǎn"; /* 枧 */
dict[0x67a8] = "chéng"; /* 枨 */
dict[0x67a9] = "sōng"; /* 枩 */
dict[0x67aa] = "qiāng"; /* 枪 */
dict[0x67ab] = "fēng"; /* 枫 */
dict[0x67ac] = "zhān"; /* 枬 */
dict[0x67ad] = "xiāo"; /* 枭 */
dict[0x67ae] = "xiān,zhēn"; /* 枮 */
dict[0x67af] = "kū"; /* 枯 */
dict[0x67b0] = "píng"; /* 枰 */
dict[0x67b1] = "sì,tái"; /* 枱 */
dict[0x67b2] = "xǐ"; /* 枲 */
dict[0x67b3] = "zhǐ"; /* 枳 */
dict[0x67b4] = "guǎi"; /* 枴 */
dict[0x67b5] = "xiāo"; /* 枵 */
dict[0x67b6] = "jià"; /* 架 */
dict[0x67b7] = "jiā"; /* 枷 */
dict[0x67b8] = "jǔ,gǒu"; /* 枸 */
dict[0x67b9] = "bāo,fú"; /* 枹 */
dict[0x67ba] = "mò"; /* 枺 */
dict[0x67bb] = "yì,xiè"; /* 枻 */
dict[0x67bc] = "yè"; /* 枼 */
dict[0x67bd] = "yè"; /* 枽 */
dict[0x67be] = "shì"; /* 枾 */
dict[0x67bf] = "niè"; /* 枿 */
dict[0x67c0] = "bǐ"; /* 柀 */
dict[0x67c1] = "tuó,duò"; /* 柁 */
dict[0x67c2] = "yí,duò,lí"; /* 柂 */
dict[0x67c3] = "líng"; /* 柃 */
dict[0x67c4] = "bǐng"; /* 柄 */
dict[0x67c5] = "nǐ,chì"; /* 柅 */
dict[0x67c6] = "lā"; /* 柆 */
dict[0x67c7] = "hé"; /* 柇 */
dict[0x67c8] = "pán,bàn"; /* 柈 */
dict[0x67c9] = "fán"; /* 柉 */
dict[0x67ca] = "zhōng"; /* 柊 */
dict[0x67cb] = "dài"; /* 柋 */
dict[0x67cc] = "cí"; /* 柌 */
dict[0x67cd] = "yǎng,yàng,yāng,yīng"; /* 柍 */
dict[0x67ce] = "fū,fǔ,fù"; /* 柎 */
dict[0x67cf] = "bǎi,bó,bò"; /* 柏 */
dict[0x67d0] = "mǒu"; /* 某 */
dict[0x67d1] = "gān"; /* 柑 */
dict[0x67d2] = "qī"; /* 柒 */
dict[0x67d3] = "rǎn"; /* 染 */
dict[0x67d4] = "róu"; /* 柔 */
dict[0x67d5] = "mào"; /* 柕 */
dict[0x67d6] = "sháo,shào"; /* 柖 */
dict[0x67d7] = "sōng"; /* 柗 */
dict[0x67d8] = "zhè"; /* 柘 */
dict[0x67d9] = "xiá"; /* 柙 */
dict[0x67da] = "yòu,yóu"; /* 柚 */
dict[0x67db] = "shēn"; /* 柛 */
dict[0x67dc] = "guì,jǔ"; /* 柜 */
dict[0x67dd] = "tuò"; /* 柝 */
dict[0x67de] = "zuò,zhà"; /* 柞 */
dict[0x67df] = "nán"; /* 柟 */
dict[0x67e0] = "níng"; /* 柠 */
dict[0x67e1] = "yǒng"; /* 柡 */
dict[0x67e2] = "dǐ,chí"; /* 柢 */
dict[0x67e3] = "zhì,dié"; /* 柣 */
dict[0x67e4] = "zhā,zǔ,zū"; /* 柤 */
dict[0x67e5] = "chá,zhā"; /* 查 */
dict[0x67e6] = "dàn"; /* 柦 */
dict[0x67e7] = "gū"; /* 柧 */
dict[0x67e8] = "bù,pū"; /* 柨 */
dict[0x67e9] = "jiù"; /* 柩 */
dict[0x67ea] = "āo,ào"; /* 柪 */
dict[0x67eb] = "fú"; /* 柫 */
dict[0x67ec] = "jiǎn"; /* 柬 */
dict[0x67ed] = "bā,fú,pèi,bó,biē"; /* 柭 */
dict[0x67ee] = "duò,zuó,wù"; /* 柮 */
dict[0x67ef] = "kē"; /* 柯 */
dict[0x67f0] = "nài"; /* 柰 */
dict[0x67f1] = "zhù"; /* 柱 */
dict[0x67f2] = "bì,bié"; /* 柲 */
dict[0x67f3] = "liǔ"; /* 柳 */
dict[0x67f4] = "chái"; /* 柴 */
dict[0x67f5] = "shān"; /* 柵 */
dict[0x67f6] = "sì"; /* 柶 */
dict[0x67f7] = "zhù"; /* 柷 */
dict[0x67f8] = "bēi,pēi"; /* 柸 */
dict[0x67f9] = "shì,fèi"; /* 柹 */
dict[0x67fa] = "guǎi"; /* 柺 */
dict[0x67fb] = "chá,zhā"; /* 査 */
dict[0x67fc] = "yǎo"; /* 柼 */
dict[0x67fd] = "chēng"; /* 柽 */
dict[0x67fe] = "jiù"; /* 柾 */
dict[0x67ff] = "shì"; /* 柿 */
dict[0x6800] = "zhī"; /* 栀 */
dict[0x6801] = "liǔ"; /* 栁 */
dict[0x6802] = "méi"; /* 栂 */
dict[0x6803] = "lì"; /* 栃 */
dict[0x6804] = "róng"; /* 栄 */
dict[0x6805] = "zhà,shān,shi,cè"; /* 栅 */
dict[0x6806] = "zǎo"; /* 栆 */
dict[0x6807] = "biāo"; /* 标 */
dict[0x6808] = "zhàn"; /* 栈 */
dict[0x6809] = "zhì"; /* 栉 */
dict[0x680a] = "lóng"; /* 栊 */
dict[0x680b] = "dòng"; /* 栋 */
dict[0x680c] = "lú"; /* 栌 */
dict[0x680e] = "lì,yuè"; /* 栎 */
dict[0x680f] = "lán"; /* 栏 */
dict[0x6810] = "yǒng"; /* 栐 */
dict[0x6811] = "shù"; /* 树 */
dict[0x6812] = "xún"; /* 栒 */
dict[0x6813] = "shuān"; /* 栓 */
dict[0x6814] = "qì,qiè"; /* 栔 */
dict[0x6815] = "chén"; /* 栕 */
dict[0x6816] = "qī,xī"; /* 栖 */
dict[0x6817] = "lì"; /* 栗 */
dict[0x6818] = "yí"; /* 栘 */
dict[0x6819] = "xiáng"; /* 栙 */
dict[0x681a] = "zhèn"; /* 栚 */
dict[0x681b] = "lì"; /* 栛 */
dict[0x681c] = "sè"; /* 栜 */
dict[0x681d] = "guā,tiǎn"; /* 栝 */
dict[0x681e] = "kān"; /* 栞 */
dict[0x681f] = "bēn,bīng"; /* 栟 */
dict[0x6820] = "rěn"; /* 栠 */
dict[0x6821] = "xiào,jiào"; /* 校 */
dict[0x6822] = "bǎi"; /* 栢 */
dict[0x6823] = "rěn"; /* 栣 */
dict[0x6824] = "bìng"; /* 栤 */
dict[0x6825] = "zī"; /* 栥 */
dict[0x6826] = "chóu"; /* 栦 */
dict[0x6827] = "yì,xiè"; /* 栧 */
dict[0x6828] = "cì"; /* 栨 */
dict[0x6829] = "xǔ"; /* 栩 */
dict[0x682a] = "zhū"; /* 株 */
dict[0x682b] = "jiàn,zùn"; /* 栫 */
dict[0x682c] = "zuì"; /* 栬 */
dict[0x682d] = "ér"; /* 栭 */
dict[0x682e] = "ěr"; /* 栮 */
dict[0x682f] = "yǒu,yù"; /* 栯 */
dict[0x6830] = "fá"; /* 栰 */
dict[0x6831] = "gǒng"; /* 栱 */
dict[0x6832] = "kǎo"; /* 栲 */
dict[0x6833] = "lǎo"; /* 栳 */
dict[0x6834] = "zhān"; /* 栴 */
dict[0x6835] = "liè"; /* 栵 */
dict[0x6836] = "yīn"; /* 栶 */
dict[0x6837] = "yàng"; /* 样 */
dict[0x6838] = "hé,hú"; /* 核 */
dict[0x6839] = "gēn"; /* 根 */
dict[0x683a] = "zhī,yì"; /* 栺 */
dict[0x683b] = "shì"; /* 栻 */
dict[0x683c] = "gé"; /* 格 */
dict[0x683d] = "zāi"; /* 栽 */
dict[0x683e] = "luán"; /* 栾 */
dict[0x683f] = "fú"; /* 栿 */
dict[0x6840] = "jié"; /* 桀 */
dict[0x6841] = "héng,háng"; /* 桁 */
dict[0x6842] = "guì"; /* 桂 */
dict[0x6843] = "táo"; /* 桃 */
dict[0x6844] = "guāng,guàng"; /* 桄 */
dict[0x6845] = "wéi"; /* 桅 */
dict[0x6846] = "kuàng"; /* 框 */
dict[0x6847] = "rú"; /* 桇 */
dict[0x6848] = "àn"; /* 案 */
dict[0x6849] = "ān"; /* 桉 */
dict[0x684a] = "juàn"; /* 桊 */
dict[0x684b] = "yí,tí"; /* 桋 */
dict[0x684c] = "zhuō"; /* 桌 */
dict[0x684d] = "kū"; /* 桍 */
dict[0x684e] = "zhì"; /* 桎 */
dict[0x684f] = "qióng"; /* 桏 */
dict[0x6850] = "tóng"; /* 桐 */
dict[0x6851] = "sāng"; /* 桑 */
dict[0x6852] = "sāng"; /* 桒 */
dict[0x6853] = "huán"; /* 桓 */
dict[0x6854] = "jú,jié"; /* 桔 */
dict[0x6855] = "jiù"; /* 桕 */
dict[0x6856] = "xuè"; /* 桖 */
dict[0x6857] = "duò"; /* 桗 */
dict[0x6858] = "chuí"; /* 桘 */
dict[0x6859] = "yú,móu"; /* 桙 */
dict[0x685a] = "zā,zǎn"; /* 桚 */
dict[0x685c] = "yīng"; /* 桜 */
dict[0x685d] = "jié"; /* 桝 */
dict[0x685e] = "liǔ"; /* 桞 */
dict[0x685f] = "zhàn"; /* 桟 */
dict[0x6860] = "yā"; /* 桠 */
dict[0x6861] = "ráo,náo"; /* 桡 */
dict[0x6862] = "zhēn"; /* 桢 */
dict[0x6863] = "dàng"; /* 档 */
dict[0x6864] = "qī"; /* 桤 */
dict[0x6865] = "qiáo"; /* 桥 */
dict[0x6866] = "huà"; /* 桦 */
dict[0x6867] = "guì,huì"; /* 桧 */
dict[0x6868] = "jiǎng"; /* 桨 */
dict[0x6869] = "zhuāng"; /* 桩 */
dict[0x686a] = "xún"; /* 桪 */
dict[0x686b] = "suō"; /* 桫 */
dict[0x686c] = "shā"; /* 桬 */
dict[0x686d] = "chén,zhèn"; /* 桭 */
dict[0x686e] = "bēi"; /* 桮 */
dict[0x686f] = "tīng,yíng"; /* 桯 */
dict[0x6870] = "guā"; /* 桰 */
dict[0x6871] = "jìng"; /* 桱 */
dict[0x6872] = "bó"; /* 桲 */
dict[0x6873] = "bèn,fàn"; /* 桳 */
dict[0x6874] = "fú"; /* 桴 */
dict[0x6875] = "ruí"; /* 桵 */
dict[0x6876] = "tǒng"; /* 桶 */
dict[0x6877] = "jué"; /* 桷 */
dict[0x6878] = "xī"; /* 桸 */
dict[0x6879] = "láng"; /* 桹 */
dict[0x687a] = "liǔ"; /* 桺 */
dict[0x687b] = "fēng,fèng"; /* 桻 */
dict[0x687c] = "qī"; /* 桼 */
dict[0x687d] = "wěn"; /* 桽 */
dict[0x687e] = "jūn"; /* 桾 */
dict[0x687f] = "gǎn"; /* 桿 */
dict[0x6880] = "sù,yìn"; /* 梀 */
dict[0x6881] = "liáng"; /* 梁 */
dict[0x6882] = "qiú"; /* 梂 */
dict[0x6883] = "tǐng,tìng"; /* 梃 */
dict[0x6884] = "yǒu"; /* 梄 */
dict[0x6885] = "méi"; /* 梅 */
dict[0x6886] = "bāng"; /* 梆 */
dict[0x6887] = "lòng"; /* 梇 */
dict[0x6888] = "pēng"; /* 梈 */
dict[0x6889] = "zhuāng"; /* 梉 */
dict[0x688a] = "dì"; /* 梊 */
dict[0x688b] = "xuān,juān,xié"; /* 梋 */
dict[0x688c] = "tú,chá"; /* 梌 */
dict[0x688d] = "zào"; /* 梍 */
dict[0x688e] = "āo,yòu"; /* 梎 */
dict[0x688f] = "gù"; /* 梏 */
dict[0x6890] = "bì"; /* 梐 */
dict[0x6891] = "dí"; /* 梑 */
dict[0x6892] = "hán"; /* 梒 */
dict[0x6893] = "zǐ"; /* 梓 */
dict[0x6894] = "zhī"; /* 梔 */
dict[0x6895] = "rèn,ér"; /* 梕 */
dict[0x6896] = "bèi"; /* 梖 */
dict[0x6897] = "gěng"; /* 梗 */
dict[0x6898] = "jiǎn"; /* 梘 */
dict[0x6899] = "huàn"; /* 梙 */
dict[0x689a] = "wǎn"; /* 梚 */
dict[0x689b] = "nuó"; /* 梛 */
dict[0x689c] = "jiā"; /* 梜 */
dict[0x689d] = "tiáo,tiāo"; /* 條 */
dict[0x689e] = "jì"; /* 梞 */
dict[0x689f] = "xiāo"; /* 梟 */
dict[0x68a0] = "lǚ"; /* 梠 */
dict[0x68a1] = "kuǎn"; /* 梡 */
dict[0x68a2] = "shāo,sào"; /* 梢 */
dict[0x68a3] = "chén"; /* 梣 */
dict[0x68a4] = "fēn"; /* 梤 */
dict[0x68a5] = "sōng"; /* 梥 */
dict[0x68a6] = "mèng"; /* 梦 */
dict[0x68a7] = "wú"; /* 梧 */
dict[0x68a8] = "lí"; /* 梨 */
dict[0x68a9] = "sì,qǐ"; /* 梩 */
dict[0x68aa] = "dòu"; /* 梪 */
dict[0x68ab] = "qǐn"; /* 梫 */
dict[0x68ac] = "yǐng"; /* 梬 */
dict[0x68ad] = "suō"; /* 梭 */
dict[0x68ae] = "jū"; /* 梮 */
dict[0x68af] = "tī"; /* 梯 */
dict[0x68b0] = "xiè"; /* 械 */
dict[0x68b1] = "kǔn"; /* 梱 */
dict[0x68b2] = "zhuō"; /* 梲 */
dict[0x68b3] = "shū"; /* 梳 */
dict[0x68b4] = "chān,yán"; /* 梴 */
dict[0x68b5] = "fàn"; /* 梵 */
dict[0x68b6] = "wěi"; /* 梶 */
dict[0x68b7] = "jìng"; /* 梷 */
dict[0x68b8] = "lí"; /* 梸 */
dict[0x68b9] = "bīn,bīng"; /* 梹 */
dict[0x68ba] = "xià"; /* 梺 */
dict[0x68bb] = "fó"; /* 梻 */
dict[0x68bc] = "chóu,táo,dào"; /* 梼 */
dict[0x68bd] = "zhì"; /* 梽 */
dict[0x68be] = "lái"; /* 梾 */
dict[0x68bf] = "lián,liǎn"; /* 梿 */
dict[0x68c0] = "jiǎn"; /* 检 */
dict[0x68c1] = "zhuō"; /* 棁 */
dict[0x68c2] = "líng"; /* 棂 */
dict[0x68c3] = "lí"; /* 棃 */
dict[0x68c4] = "qì"; /* 棄 */
dict[0x68c5] = "bǐng"; /* 棅 */
dict[0x68c6] = "lún"; /* 棆 */
dict[0x68c7] = "cōng,sōng"; /* 棇 */
dict[0x68c8] = "qiàn"; /* 棈 */
dict[0x68c9] = "mián"; /* 棉 */
dict[0x68ca] = "qí"; /* 棊 */
dict[0x68cb] = "qí"; /* 棋 */
dict[0x68cc] = "cǎi"; /* 棌 */
dict[0x68cd] = "gùn,hùn"; /* 棍 */
dict[0x68ce] = "chán"; /* 棎 */
dict[0x68cf] = "dé,zhé"; /* 棏 */
dict[0x68d0] = "fěi"; /* 棐 */
dict[0x68d1] = "pái,bèi,pèi"; /* 棑 */
dict[0x68d2] = "bàng"; /* 棒 */
dict[0x68d3] = "bàng,pǒu,bèi,bēi"; /* 棓 */
dict[0x68d4] = "hūn"; /* 棔 */
dict[0x68d5] = "zōng"; /* 棕 */
dict[0x68d6] = "chéng"; /* 棖 */
dict[0x68d7] = "zǎo"; /* 棗 */
dict[0x68d8] = "jí"; /* 棘 */
dict[0x68d9] = "lì,liè"; /* 棙 */
dict[0x68da] = "péng"; /* 棚 */
dict[0x68db] = "yù"; /* 棛 */
dict[0x68dc] = "yù"; /* 棜 */
dict[0x68dd] = "gù"; /* 棝 */
dict[0x68de] = "jùn"; /* 棞 */
dict[0x68df] = "dòng"; /* 棟 */
dict[0x68e0] = "táng"; /* 棠 */
dict[0x68e1] = "gāng"; /* 棡 */
dict[0x68e2] = "wǎng"; /* 棢 */
dict[0x68e3] = "dì,dài,tì"; /* 棣 */
dict[0x68e4] = "què"; /* 棤 */
dict[0x68e5] = "fán"; /* 棥 */
dict[0x68e6] = "chēng"; /* 棦 */
dict[0x68e7] = "zhàn"; /* 棧 */
dict[0x68e8] = "qǐ"; /* 棨 */
dict[0x68e9] = "yuān"; /* 棩 */
dict[0x68ea] = "yǎn,yàn"; /* 棪 */
dict[0x68eb] = "yù"; /* 棫 */
dict[0x68ec] = "quān,juàn"; /* 棬 */
dict[0x68ed] = "yì"; /* 棭 */
dict[0x68ee] = "sēn"; /* 森 */
dict[0x68ef] = "rěn,shěn"; /* 棯 */
dict[0x68f0] = "chuí"; /* 棰 */
dict[0x68f1] = "léng,lēng,líng"; /* 棱 */
dict[0x68f2] = "qī"; /* 棲 */
dict[0x68f3] = "zhuō"; /* 棳 */
dict[0x68f4] = "fú,sù"; /* 棴 */
dict[0x68f5] = "kē"; /* 棵 */
dict[0x68f6] = "lái"; /* 棶 */
dict[0x68f7] = "zōu,sǒu"; /* 棷 */
dict[0x68f8] = "zōu"; /* 棸 */
dict[0x68f9] = "zhào,zhuō"; /* 棹 */
dict[0x68fa] = "guān"; /* 棺 */
dict[0x68fb] = "fēn"; /* 棻 */
dict[0x68fc] = "fén"; /* 棼 */
dict[0x68fd] = "chēn,shēn"; /* 棽 */
dict[0x68fe] = "qíng"; /* 棾 */
dict[0x68ff] = "ní,nǐ"; /* 棿 */
dict[0x6900] = "wǎn"; /* 椀 */
dict[0x6901] = "guǒ"; /* 椁 */
dict[0x6902] = "lù"; /* 椂 */
dict[0x6903] = "háo"; /* 椃 */
dict[0x6904] = "jiē,qiè"; /* 椄 */
dict[0x6905] = "yǐ,yī"; /* 椅 */
dict[0x6906] = "chóu,zhòu,diāo"; /* 椆 */
dict[0x6907] = "jǔ"; /* 椇 */
dict[0x6908] = "jú"; /* 椈 */
dict[0x6909] = "chéng,shèng"; /* 椉 */
dict[0x690a] = "zú,cuì"; /* 椊 */
dict[0x690b] = "liáng"; /* 椋 */
dict[0x690c] = "qiāng,kōng"; /* 椌 */
dict[0x690d] = "zhí"; /* 植 */
dict[0x690e] = "zhuī,chuí"; /* 椎 */
dict[0x690f] = "yā"; /* 椏 */
dict[0x6910] = "jū"; /* 椐 */
dict[0x6911] = "bēi"; /* 椑 */
dict[0x6912] = "jiāo"; /* 椒 */
dict[0x6913] = "zhuó"; /* 椓 */
dict[0x6914] = "zī"; /* 椔 */
dict[0x6915] = "bīn"; /* 椕 */
dict[0x6916] = "péng"; /* 椖 */
dict[0x6917] = "dìng"; /* 椗 */
dict[0x6918] = "chǔ"; /* 椘 */
dict[0x6919] = "chāng"; /* 椙 */
dict[0x691a] = "mēn"; /* 椚 */
dict[0x691b] = "huā"; /* 椛 */
dict[0x691c] = "jiǎn"; /* 検 */
dict[0x691d] = "guī"; /* 椝 */
dict[0x691e] = "xì"; /* 椞 */
dict[0x691f] = "dú"; /* 椟 */
dict[0x6920] = "qiàn"; /* 椠 */
dict[0x6921] = "dào"; /* 椡 */
dict[0x6922] = "guì"; /* 椢 */
dict[0x6923] = "diǎn"; /* 椣 */
dict[0x6924] = "luó"; /* 椤 */
dict[0x6925] = "zhī"; /* 椥 */
dict[0x6926] = "quān,juàn,quán"; /* 椦 */
dict[0x6928] = "fǔ"; /* 椨 */
dict[0x6929] = "gēng"; /* 椩 */
dict[0x692a] = "pèng"; /* 椪 */
dict[0x692b] = "shàn"; /* 椫 */
dict[0x692c] = "yí"; /* 椬 */
dict[0x692d] = "tuǒ"; /* 椭 */
dict[0x692e] = "sēn"; /* 椮 */
dict[0x692f] = "duǒ,chuán"; /* 椯 */
dict[0x6930] = "yē"; /* 椰 */
dict[0x6931] = "fù"; /* 椱 */
dict[0x6932] = "wěi,huī"; /* 椲 */
dict[0x6933] = "wēi"; /* 椳 */
dict[0x6934] = "duàn"; /* 椴 */
dict[0x6935] = "jiǎ,jiā"; /* 椵 */
dict[0x6936] = "zōng"; /* 椶 */
dict[0x6937] = "jiān,hán"; /* 椷 */
dict[0x6938] = "yí"; /* 椸 */
dict[0x6939] = "zhēn,shèn"; /* 椹 */
dict[0x693a] = "xí"; /* 椺 */
dict[0x693b] = "yàn,yà"; /* 椻 */
dict[0x693c] = "yǎn"; /* 椼 */
dict[0x693d] = "chuán"; /* 椽 */
dict[0x693e] = "jiān"; /* 椾 */
dict[0x693f] = "chūn"; /* 椿 */
dict[0x6940] = "yǔ"; /* 楀 */
dict[0x6941] = "hé"; /* 楁 */
dict[0x6942] = "zhā,chá"; /* 楂 */
dict[0x6943] = "wò"; /* 楃 */
dict[0x6944] = "piān"; /* 楄 */
dict[0x6945] = "bī"; /* 楅 */
dict[0x6946] = "yāo"; /* 楆 */
dict[0x6947] = "guō,kuǎ"; /* 楇 */
dict[0x6948] = "xū"; /* 楈 */
dict[0x6949] = "ruò"; /* 楉 */
dict[0x694a] = "yáng"; /* 楊 */
dict[0x694b] = "là"; /* 楋 */
dict[0x694c] = "yán"; /* 楌 */
dict[0x694d] = "běn"; /* 楍 */
dict[0x694e] = "huī"; /* 楎 */
dict[0x694f] = "kuí"; /* 楏 */
dict[0x6950] = "jiè"; /* 楐 */
dict[0x6951] = "kuí"; /* 楑 */
dict[0x6952] = "sī"; /* 楒 */
dict[0x6953] = "fēng"; /* 楓 */
dict[0x6954] = "xiē"; /* 楔 */
dict[0x6955] = "tuǒ"; /* 楕 */
dict[0x6956] = "jí,zhì"; /* 楖 */
dict[0x6957] = "jiàn"; /* 楗 */
dict[0x6958] = "mù"; /* 楘 */
dict[0x6959] = "máo"; /* 楙 */
dict[0x695a] = "chǔ"; /* 楚 */
dict[0x695b] = "kǔ,hù"; /* 楛 */
dict[0x695c] = "hú"; /* 楜 */
dict[0x695d] = "liàn"; /* 楝 */
dict[0x695e] = "léng"; /* 楞 */
dict[0x695f] = "tíng"; /* 楟 */
dict[0x6960] = "nán"; /* 楠 */
dict[0x6961] = "yú"; /* 楡 */
dict[0x6962] = "yóu,yǒu"; /* 楢 */
dict[0x6963] = "méi"; /* 楣 */
dict[0x6964] = "sǒng,cōng"; /* 楤 */
dict[0x6965] = "xuàn,yuán"; /* 楥 */
dict[0x6966] = "xuàn"; /* 楦 */
dict[0x6967] = "yǎng,yàng,yīng"; /* 楧 */
dict[0x6968] = "zhēn"; /* 楨 */
dict[0x6969] = "pián"; /* 楩 */
dict[0x696a] = "dié,yè"; /* 楪 */
dict[0x696b] = "jí"; /* 楫 */
dict[0x696c] = "jiē"; /* 楬 */
dict[0x696d] = "yè"; /* 業 */
dict[0x696e] = "chǔ"; /* 楮 */
dict[0x696f] = "shǔn,dùn"; /* 楯 */
dict[0x6970] = "yú"; /* 楰 */
dict[0x6971] = "còu,zòu"; /* 楱 */
dict[0x6972] = "wēi"; /* 楲 */
dict[0x6973] = "méi"; /* 楳 */
dict[0x6974] = "dì,dǐ,shì"; /* 楴 */
dict[0x6975] = "jí"; /* 極 */
dict[0x6976] = "jié"; /* 楶 */
dict[0x6977] = "kǎi,jiē"; /* 楷 */
dict[0x6978] = "qiū"; /* 楸 */
dict[0x6979] = "yíng"; /* 楹 */
dict[0x697a] = "róu,ròu"; /* 楺 */
dict[0x697b] = "huáng"; /* 楻 */
dict[0x697c] = "lóu"; /* 楼 */
dict[0x697d] = "lè,yuè"; /* 楽 */
dict[0x697e] = "quán"; /* 楾 */
dict[0x697f] = "xiāng"; /* 楿 */
dict[0x6980] = "pǐn"; /* 榀 */
dict[0x6981] = "shǐ"; /* 榁 */
dict[0x6982] = "gài"; /* 概 */
dict[0x6983] = "tán"; /* 榃 */
dict[0x6984] = "lǎn"; /* 榄 */
dict[0x6985] = "wēn,yùn"; /* 榅 */
dict[0x6986] = "yú"; /* 榆 */
dict[0x6987] = "chèn"; /* 榇 */
dict[0x6988] = "lǘ"; /* 榈 */
dict[0x6989] = "jǔ"; /* 榉 */
dict[0x698a] = "shén"; /* 榊 */
dict[0x698b] = "chū"; /* 榋 */
dict[0x698c] = "bī,pi"; /* 榌 */
dict[0x698d] = "xiè"; /* 榍 */
dict[0x698e] = "jiǎ"; /* 榎 */
dict[0x698f] = "yì"; /* 榏 */
dict[0x6990] = "zhǎn,niǎn,zhèn"; /* 榐 */
dict[0x6991] = "fú,fù,bó"; /* 榑 */
dict[0x6992] = "nuò"; /* 榒 */
dict[0x6993] = "mì"; /* 榓 */
dict[0x6994] = "láng"; /* 榔 */
dict[0x6995] = "róng"; /* 榕 */
dict[0x6996] = "gǔ"; /* 榖 */
dict[0x6997] = "jiàn,jìn"; /* 榗 */
dict[0x6998] = "jǔ"; /* 榘 */
dict[0x6999] = "tā"; /* 榙 */
dict[0x699a] = "yǎo"; /* 榚 */
dict[0x699b] = "zhēn"; /* 榛 */
dict[0x699c] = "bǎng,bàng"; /* 榜 */
dict[0x699d] = "shā,xiè"; /* 榝 */
dict[0x699e] = "yuán"; /* 榞 */
dict[0x699f] = "zǐ"; /* 榟 */
dict[0x69a0] = "míng"; /* 榠 */
dict[0x69a1] = "sù"; /* 榡 */
dict[0x69a2] = "jià"; /* 榢 */
dict[0x69a3] = "yáo"; /* 榣 */
dict[0x69a4] = "jié"; /* 榤 */
dict[0x69a5] = "huàng"; /* 榥 */
dict[0x69a6] = "gàn"; /* 榦 */
dict[0x69a7] = "fěi"; /* 榧 */
dict[0x69a8] = "zhà"; /* 榨 */
dict[0x69a9] = "qián"; /* 榩 */
dict[0x69aa] = "mà,mā"; /* 榪 */
dict[0x69ab] = "sǔn"; /* 榫 */
dict[0x69ac] = "yuán"; /* 榬 */
dict[0x69ad] = "xiè"; /* 榭 */
dict[0x69ae] = "róng"; /* 榮 */
dict[0x69af] = "shí"; /* 榯 */
dict[0x69b0] = "zhī"; /* 榰 */
dict[0x69b1] = "cuī"; /* 榱 */
dict[0x69b2] = "wēn"; /* 榲 */
dict[0x69b3] = "tíng"; /* 榳 */
dict[0x69b4] = "liú"; /* 榴 */
dict[0x69b5] = "róng"; /* 榵 */
dict[0x69b6] = "táng"; /* 榶 */
dict[0x69b7] = "què"; /* 榷 */
dict[0x69b8] = "zhāi"; /* 榸 */
dict[0x69b9] = "sì"; /* 榹 */
dict[0x69ba] = "shèng"; /* 榺 */
dict[0x69bb] = "tà"; /* 榻 */
dict[0x69bc] = "kē"; /* 榼 */
dict[0x69bd] = "xī"; /* 榽 */
dict[0x69be] = "gù"; /* 榾 */
dict[0x69bf] = "qī"; /* 榿 */
dict[0x69c0] = "gǎo"; /* 槀 */
dict[0x69c1] = "gǎo"; /* 槁 */
dict[0x69c2] = "sūn"; /* 槂 */
dict[0x69c3] = "pán"; /* 槃 */
dict[0x69c4] = "tāo"; /* 槄 */
dict[0x69c5] = "gé"; /* 槅 */
dict[0x69c6] = "chūn"; /* 槆 */
dict[0x69c7] = "diān"; /* 槇 */
dict[0x69c8] = "nòu"; /* 槈 */
dict[0x69c9] = "jí"; /* 槉 */
dict[0x69ca] = "shuò"; /* 槊 */
dict[0x69cb] = "gòu"; /* 構 */
dict[0x69cc] = "chuí"; /* 槌 */
dict[0x69cd] = "qiāng"; /* 槍 */
dict[0x69ce] = "chá"; /* 槎 */
dict[0x69cf] = "qiǎn,lián,xiàn"; /* 槏 */
dict[0x69d0] = "huái"; /* 槐 */
dict[0x69d1] = "méi"; /* 槑 */
dict[0x69d2] = "xù"; /* 槒 */
dict[0x69d3] = "gàng"; /* 槓 */
dict[0x69d4] = "gāo"; /* 槔 */
dict[0x69d5] = "zhuō"; /* 槕 */
dict[0x69d6] = "tuó"; /* 槖 */
dict[0x69d7] = "qiáo"; /* 槗 */
dict[0x69d8] = "yàng"; /* 様 */
dict[0x69d9] = "diān,zhěn,zhēn"; /* 槙 */
dict[0x69da] = "jiǎ"; /* 槚 */
dict[0x69db] = "jiàn,kǎn"; /* 槛 */
dict[0x69dc] = "zuì"; /* 槜 */
dict[0x69dd] = "dǎo"; /* 槝 */
dict[0x69de] = "lóng"; /* 槞 */
dict[0x69df] = "bīn,bīng"; /* 槟 */
dict[0x69e0] = "zhū"; /* 槠 */
dict[0x69e1] = "sāng"; /* 槡 */
dict[0x69e2] = "xí,dié"; /* 槢 */
dict[0x69e3] = "jī,guī"; /* 槣 */
dict[0x69e4] = "lián,liǎn"; /* 槤 */
dict[0x69e5] = "huì"; /* 槥 */
dict[0x69e6] = "róng,yōng"; /* 槦 */
dict[0x69e7] = "qiàn"; /* 槧 */
dict[0x69e8] = "guǒ"; /* 槨 */
dict[0x69e9] = "gài"; /* 槩 */
dict[0x69ea] = "gài"; /* 槪 */
dict[0x69eb] = "tuán,shuàn,quán"; /* 槫 */
dict[0x69ec] = "huà"; /* 槬 */
dict[0x69ed] = "qì,sè"; /* 槭 */
dict[0x69ee] = "sēn"; /* 槮 */
dict[0x69ef] = "cuī,zhǐ"; /* 槯 */
dict[0x69f0] = "pèng"; /* 槰 */
dict[0x69f1] = "yǒu,chǎo"; /* 槱 */
dict[0x69f2] = "hú"; /* 槲 */
dict[0x69f3] = "jiǎng"; /* 槳 */
dict[0x69f4] = "hù"; /* 槴 */
dict[0x69f5] = "huàn"; /* 槵 */
dict[0x69f6] = "guì"; /* 槶 */
dict[0x69f7] = "niè"; /* 槷 */
dict[0x69f8] = "yì"; /* 槸 */
dict[0x69f9] = "gāo"; /* 槹 */
dict[0x69fa] = "kāng"; /* 槺 */
dict[0x69fb] = "guī"; /* 槻 */
dict[0x69fc] = "guī"; /* 槼 */
dict[0x69fd] = "cáo"; /* 槽 */
dict[0x69fe] = "màn,wàn"; /* 槾 */
dict[0x69ff] = "jǐn"; /* 槿 */
dict[0x6a00] = "dī"; /* 樀 */
dict[0x6a01] = "zhuāng"; /* 樁 */
dict[0x6a02] = "lè,yuè,yào,lào"; /* 樂 */
dict[0x6a03] = "láng"; /* 樃 */
dict[0x6a04] = "chén"; /* 樄 */
dict[0x6a05] = "cōng,zōng"; /* 樅 */
dict[0x6a06] = "lí,chī"; /* 樆 */
dict[0x6a07] = "xiū"; /* 樇 */
dict[0x6a08] = "qíng"; /* 樈 */
dict[0x6a09] = "shǎng"; /* 樉 */
dict[0x6a0a] = "fán"; /* 樊 */
dict[0x6a0b] = "tōng"; /* 樋 */
dict[0x6a0c] = "guàn"; /* 樌 */
dict[0x6a0d] = "zé"; /* 樍 */
dict[0x6a0e] = "sù"; /* 樎 */
dict[0x6a0f] = "léi,lěi"; /* 樏 */
dict[0x6a10] = "lǔ"; /* 樐 */
dict[0x6a11] = "liáng"; /* 樑 */
dict[0x6a12] = "mì"; /* 樒 */
dict[0x6a13] = "lóu"; /* 樓 */
dict[0x6a14] = "cháo,jiǎo,chāo"; /* 樔 */
dict[0x6a15] = "sù"; /* 樕 */
dict[0x6a16] = "kē"; /* 樖 */
dict[0x6a17] = "chū"; /* 樗 */
dict[0x6a18] = "táng"; /* 樘 */
dict[0x6a19] = "biāo"; /* 標 */
dict[0x6a1a] = "lù"; /* 樚 */
dict[0x6a1b] = "jiū,liáo"; /* 樛 */
dict[0x6a1c] = "zhè"; /* 樜 */
dict[0x6a1d] = "zhā"; /* 樝 */
dict[0x6a1e] = "shū"; /* 樞 */
dict[0x6a1f] = "zhāng"; /* 樟 */
dict[0x6a20] = "mán"; /* 樠 */
dict[0x6a21] = "mó,mú"; /* 模 */
dict[0x6a22] = "niǎo,mù"; /* 樢 */
dict[0x6a23] = "yàng"; /* 樣 */
dict[0x6a24] = "tiáo"; /* 樤 */
dict[0x6a25] = "péng"; /* 樥 */
dict[0x6a26] = "zhù"; /* 樦 */
dict[0x6a27] = "shā,xiè"; /* 樧 */
dict[0x6a28] = "xī"; /* 樨 */
dict[0x6a29] = "quán"; /* 権 */
dict[0x6a2a] = "héng,hèng"; /* 横 */
dict[0x6a2b] = "jiān"; /* 樫 */
dict[0x6a2c] = "cōng"; /* 樬 */
dict[0x6a2d] = "jī"; /* 樭 */
dict[0x6a2e] = "yān"; /* 樮 */
dict[0x6a2f] = "qiáng"; /* 樯 */
dict[0x6a30] = "xuě"; /* 樰 */
dict[0x6a31] = "yīng"; /* 樱 */
dict[0x6a32] = "èr"; /* 樲 */
dict[0x6a33] = "xún"; /* 樳 */
dict[0x6a34] = "zhí"; /* 樴 */
dict[0x6a35] = "qiáo"; /* 樵 */
dict[0x6a36] = "zuī"; /* 樶 */
dict[0x6a37] = "cóng"; /* 樷 */
dict[0x6a38] = "pǔ"; /* 樸 */
dict[0x6a39] = "shù"; /* 樹 */
dict[0x6a3a] = "huà"; /* 樺 */
dict[0x6a3b] = "guì"; /* 樻 */
dict[0x6a3c] = "zhēn"; /* 樼 */
dict[0x6a3d] = "zūn"; /* 樽 */
dict[0x6a3e] = "yuè"; /* 樾 */
dict[0x6a3f] = "shàn"; /* 樿 */
dict[0x6a40] = "xī"; /* 橀 */
dict[0x6a41] = "chūn"; /* 橁 */
dict[0x6a42] = "diàn"; /* 橂 */
dict[0x6a43] = "fá,fèi"; /* 橃 */
dict[0x6a44] = "gǎn"; /* 橄 */
dict[0x6a45] = "mó"; /* 橅 */
dict[0x6a46] = "wú"; /* 橆 */
dict[0x6a47] = "qiāo"; /* 橇 */
dict[0x6a48] = "ráo,náo"; /* 橈 */
dict[0x6a49] = "lìn"; /* 橉 */
dict[0x6a4a] = "liú"; /* 橊 */
dict[0x6a4b] = "qiáo"; /* 橋 */
dict[0x6a4c] = "xiàn"; /* 橌 */
dict[0x6a4d] = "rùn"; /* 橍 */
dict[0x6a4e] = "fǎn"; /* 橎 */
dict[0x6a4f] = "zhǎn,jiǎn"; /* 橏 */
dict[0x6a50] = "tuó"; /* 橐 */
dict[0x6a51] = "liáo"; /* 橑 */
dict[0x6a52] = "yún"; /* 橒 */
dict[0x6a53] = "shùn"; /* 橓 */
dict[0x6a54] = "tuí,dūn"; /* 橔 */
dict[0x6a55] = "chēng"; /* 橕 */
dict[0x6a56] = "táng,chēng"; /* 橖 */
dict[0x6a57] = "méng"; /* 橗 */
dict[0x6a58] = "jú"; /* 橘 */
dict[0x6a59] = "chéng"; /* 橙 */
dict[0x6a5a] = "sù,qiū"; /* 橚 */
dict[0x6a5b] = "jué"; /* 橛 */
dict[0x6a5c] = "jué"; /* 橜 */
dict[0x6a5d] = "tán,diàn"; /* 橝 */
dict[0x6a5e] = "huì"; /* 橞 */
dict[0x6a5f] = "jī"; /* 機 */
dict[0x6a60] = "nuó"; /* 橠 */
dict[0x6a61] = "xiàng"; /* 橡 */
dict[0x6a62] = "tuǒ"; /* 橢 */
dict[0x6a63] = "níng"; /* 橣 */
dict[0x6a64] = "ruǐ"; /* 橤 */
dict[0x6a65] = "zhū"; /* 橥 */
dict[0x6a66] = "tóng,chuáng"; /* 橦 */
dict[0x6a67] = "zēng,céng"; /* 橧 */
dict[0x6a68] = "fén,fèn,fèi"; /* 橨 */
dict[0x6a69] = "qióng"; /* 橩 */
dict[0x6a6a] = "rǎn,yān"; /* 橪 */
dict[0x6a6b] = "héng,hèng"; /* 橫 */
dict[0x6a6c] = "qián"; /* 橬 */
dict[0x6a6d] = "gū"; /* 橭 */
dict[0x6a6e] = "liǔ"; /* 橮 */
dict[0x6a6f] = "lào"; /* 橯 */
dict[0x6a70] = "gāo"; /* 橰 */
dict[0x6a71] = "chú"; /* 橱 */
dict[0x6a72] = "xǐ"; /* 橲 */
dict[0x6a73] = "shèng"; /* 橳 */
dict[0x6a74] = "zǐ"; /* 橴 */
dict[0x6a75] = "zān"; /* 橵 */
dict[0x6a76] = "jǐ"; /* 橶 */
dict[0x6a77] = "dōu"; /* 橷 */
dict[0x6a78] = "jīng"; /* 橸 */
dict[0x6a79] = "lǔ"; /* 橹 */
dict[0x6a7a] = "xiàn"; /* 橺 */
dict[0x6a7b] = "cū,chu"; /* 橻 */
dict[0x6a7c] = "yuán"; /* 橼 */
dict[0x6a7d] = "tà"; /* 橽 */
dict[0x6a7e] = "shū,qiāo"; /* 橾 */
dict[0x6a7f] = "jiāng"; /* 橿 */
dict[0x6a80] = "tán"; /* 檀 */
dict[0x6a81] = "lǐn"; /* 檁 */
dict[0x6a82] = "nóng"; /* 檂 */
dict[0x6a83] = "yǐn"; /* 檃 */
dict[0x6a84] = "xí"; /* 檄 */
dict[0x6a85] = "huì"; /* 檅 */
dict[0x6a86] = "shān"; /* 檆 */
dict[0x6a87] = "zuì"; /* 檇 */
dict[0x6a88] = "xuán"; /* 檈 */
dict[0x6a89] = "chēng"; /* 檉 */
dict[0x6a8a] = "gàn"; /* 檊 */
dict[0x6a8b] = "jū"; /* 檋 */
dict[0x6a8c] = "zuì"; /* 檌 */
dict[0x6a8d] = "yì"; /* 檍 */
dict[0x6a8e] = "qín"; /* 檎 */
dict[0x6a8f] = "pǔ"; /* 檏 */
dict[0x6a90] = "yán"; /* 檐 */
dict[0x6a91] = "léi"; /* 檑 */
dict[0x6a92] = "fēng"; /* 檒 */
dict[0x6a93] = "huǐ"; /* 檓 */
dict[0x6a94] = "dàng"; /* 檔 */
dict[0x6a95] = "jì"; /* 檕 */
dict[0x6a96] = "suì"; /* 檖 */
dict[0x6a97] = "bò"; /* 檗 */
dict[0x6a98] = "píng,bò"; /* 檘 */
dict[0x6a99] = "chéng"; /* 檙 */
dict[0x6a9a] = "chǔ"; /* 檚 */
dict[0x6a9b] = "zhuā"; /* 檛 */
dict[0x6a9c] = "guì,huì"; /* 檜 */
dict[0x6a9d] = "jí"; /* 檝 */
dict[0x6a9e] = "jiě"; /* 檞 */
dict[0x6a9f] = "jiǎ"; /* 檟 */
dict[0x6aa0] = "qíng"; /* 檠 */
dict[0x6aa1] = "zhái,shì,tú"; /* 檡 */
dict[0x6aa2] = "jiǎn"; /* 檢 */
dict[0x6aa3] = "qiáng"; /* 檣 */
dict[0x6aa4] = "dào"; /* 檤 */
dict[0x6aa5] = "yǐ"; /* 檥 */
dict[0x6aa6] = "biāo,biǎo"; /* 檦 */
dict[0x6aa7] = "sōng"; /* 檧 */
dict[0x6aa8] = "shē"; /* 檨 */
dict[0x6aa9] = "lǐn"; /* 檩 */
dict[0x6aaa] = "lì"; /* 檪 */
dict[0x6aab] = "chá"; /* 檫 */
dict[0x6aac] = "méng"; /* 檬 */
dict[0x6aad] = "yín"; /* 檭 */
dict[0x6aae] = "chóu,táo,dǎo"; /* 檮 */
dict[0x6aaf] = "tái"; /* 檯 */
dict[0x6ab0] = "mián"; /* 檰 */
dict[0x6ab1] = "qí"; /* 檱 */
dict[0x6ab2] = "tuán"; /* 檲 */
dict[0x6ab3] = "bīn,bīng"; /* 檳 */
dict[0x6ab4] = "huò"; /* 檴 */
dict[0x6ab5] = "jì"; /* 檵 */
dict[0x6ab6] = "qiān,lián"; /* 檶 */
dict[0x6ab7] = "nǐ,mí"; /* 檷 */
dict[0x6ab8] = "níng"; /* 檸 */
dict[0x6ab9] = "yī"; /* 檹 */
dict[0x6aba] = "gǎo"; /* 檺 */
dict[0x6abb] = "jiàn,kǎn"; /* 檻 */
dict[0x6abc] = "yǐn"; /* 檼 */
dict[0x6abd] = "nòu,ruǎn,rú"; /* 檽 */
dict[0x6abe] = "qǐng"; /* 檾 */
dict[0x6abf] = "yǎn"; /* 檿 */
dict[0x6ac0] = "qí"; /* 櫀 */
dict[0x6ac1] = "mì"; /* 櫁 */
dict[0x6ac2] = "zhào"; /* 櫂 */
dict[0x6ac3] = "guì"; /* 櫃 */
dict[0x6ac4] = "chūn"; /* 櫄 */
dict[0x6ac5] = "jī,jì"; /* 櫅 */
dict[0x6ac6] = "kuí"; /* 櫆 */
dict[0x6ac7] = "pó"; /* 櫇 */
dict[0x6ac8] = "dèng"; /* 櫈 */
dict[0x6ac9] = "chú"; /* 櫉 */
dict[0x6aca] = "gé"; /* 櫊 */
dict[0x6acb] = "mián"; /* 櫋 */
dict[0x6acc] = "yōu"; /* 櫌 */
dict[0x6acd] = "zhì"; /* 櫍 */
dict[0x6ace] = "huǎng,guǒ,gǔ"; /* 櫎 */
dict[0x6acf] = "qiān"; /* 櫏 */
dict[0x6ad0] = "lěi"; /* 櫐 */
dict[0x6ad1] = "léi,lěi"; /* 櫑 */
dict[0x6ad2] = "sà"; /* 櫒 */
dict[0x6ad3] = "lǔ"; /* 櫓 */
dict[0x6ad4] = "lì"; /* 櫔 */
dict[0x6ad5] = "cuán"; /* 櫕 */
dict[0x6ad6] = "lǜ,chū"; /* 櫖 */
dict[0x6ad7] = "miè,mèi"; /* 櫗 */
dict[0x6ad8] = "huì"; /* 櫘 */
dict[0x6ad9] = "ōu"; /* 櫙 */
dict[0x6ada] = "lǘ"; /* 櫚 */
dict[0x6adb] = "zhì"; /* 櫛 */
dict[0x6adc] = "gāo"; /* 櫜 */
dict[0x6add] = "dú"; /* 櫝 */
dict[0x6ade] = "yuán"; /* 櫞 */
dict[0x6adf] = "lì,yuè"; /* 櫟 */
dict[0x6ae0] = "fèi"; /* 櫠 */
dict[0x6ae1] = "zhuó,zhù"; /* 櫡 */
dict[0x6ae2] = "sǒu"; /* 櫢 */
dict[0x6ae3] = "lián,liǎn"; /* 櫣 */
dict[0x6ae4] = "jiàng"; /* 櫤 */
dict[0x6ae5] = "chú"; /* 櫥 */
dict[0x6ae6] = "qìng"; /* 櫦 */
dict[0x6ae7] = "zhū"; /* 櫧 */
dict[0x6ae8] = "lú"; /* 櫨 */
dict[0x6ae9] = "yán"; /* 櫩 */
dict[0x6aea] = "lì"; /* 櫪 */
dict[0x6aeb] = "zhū"; /* 櫫 */
dict[0x6aec] = "chèn"; /* 櫬 */
dict[0x6aed] = "jué,jì"; /* 櫭 */
dict[0x6aee] = "è"; /* 櫮 */
dict[0x6aef] = "sū"; /* 櫯 */
dict[0x6af0] = "huái,guī"; /* 櫰 */
dict[0x6af1] = "niè"; /* 櫱 */
dict[0x6af2] = "yù"; /* 櫲 */
dict[0x6af3] = "lóng"; /* 櫳 */
dict[0x6af4] = "là,lài"; /* 櫴 */
dict[0x6af5] = "qiáo"; /* 櫵 */
dict[0x6af6] = "xiǎn"; /* 櫶 */
dict[0x6af7] = "guī"; /* 櫷 */
dict[0x6af8] = "jǔ"; /* 櫸 */
dict[0x6af9] = "xiāo"; /* 櫹 */
dict[0x6afa] = "líng"; /* 櫺 */
dict[0x6afb] = "yīng"; /* 櫻 */
dict[0x6afc] = "jiān"; /* 櫼 */
dict[0x6afd] = "yǐn"; /* 櫽 */
dict[0x6afe] = "yòu,yóu"; /* 櫾 */
dict[0x6aff] = "yíng"; /* 櫿 */
dict[0x6b00] = "xiāng"; /* 欀 */
dict[0x6b01] = "nóng"; /* 欁 */
dict[0x6b02] = "bó"; /* 欂 */
dict[0x6b03] = "chán,zhàn"; /* 欃 */
dict[0x6b04] = "lán"; /* 欄 */
dict[0x6b05] = "jǔ"; /* 欅 */
dict[0x6b06] = "shuāng"; /* 欆 */
dict[0x6b07] = "shè"; /* 欇 */
dict[0x6b08] = "wéi,zuì"; /* 欈 */
dict[0x6b09] = "cóng"; /* 欉 */
dict[0x6b0a] = "quán"; /* 權 */
dict[0x6b0b] = "qú"; /* 欋 */
dict[0x6b0c] = "cáng"; /* 欌 */
dict[0x6b0d] = "jiù"; /* 欍 */
dict[0x6b0e] = "yù"; /* 欎 */
dict[0x6b0f] = "luó"; /* 欏 */
dict[0x6b10] = "lì"; /* 欐 */
dict[0x6b11] = "cuán"; /* 欑 */
dict[0x6b12] = "luán"; /* 欒 */
dict[0x6b13] = "dǎng"; /* 欓 */
dict[0x6b14] = "qú"; /* 欔 */
dict[0x6b15] = "yán"; /* 欕 */
dict[0x6b16] = "lǎn"; /* 欖 */
dict[0x6b17] = "lán"; /* 欗 */
dict[0x6b18] = "zhú"; /* 欘 */
dict[0x6b19] = "léi"; /* 欙 */
dict[0x6b1a] = "lǐ"; /* 欚 */
dict[0x6b1b] = "bà"; /* 欛 */
dict[0x6b1c] = "náng"; /* 欜 */
dict[0x6b1d] = "yù"; /* 欝 */
dict[0x6b1e] = "líng"; /* 欞 */
dict[0x6b1f] = "guàn"; /* 欟 */
dict[0x6b20] = "qiàn"; /* 欠 */
dict[0x6b21] = "cì"; /* 次 */
dict[0x6b22] = "huān"; /* 欢 */
dict[0x6b23] = "xīn"; /* 欣 */
dict[0x6b24] = "yú"; /* 欤 */
dict[0x6b25] = "yù,yì"; /* 欥 */
dict[0x6b26] = "qiān,xiān"; /* 欦 */
dict[0x6b27] = "ōu"; /* 欧 */
dict[0x6b28] = "xū"; /* 欨 */
dict[0x6b29] = "chāo"; /* 欩 */
dict[0x6b2a] = "chù,qù,xì"; /* 欪 */
dict[0x6b2b] = "qì"; /* 欫 */
dict[0x6b2c] = "kài,ài"; /* 欬 */
dict[0x6b2d] = "yì,yīn"; /* 欭 */
dict[0x6b2e] = "jué"; /* 欮 */
dict[0x6b2f] = "xì,kài"; /* 欯 */
dict[0x6b30] = "xù"; /* 欰 */
dict[0x6b31] = "hē"; /* 欱 */
dict[0x6b32] = "yù"; /* 欲 */
dict[0x6b33] = "kuài"; /* 欳 */
dict[0x6b34] = "láng"; /* 欴 */
dict[0x6b35] = "kuǎn"; /* 欵 */
dict[0x6b36] = "shuò,sòu"; /* 欶 */
dict[0x6b37] = "xī"; /* 欷 */
dict[0x6b38] = "èi,èi,ěi,èi,ǎi"; /* 欸 */
dict[0x6b39] = "qī"; /* 欹 */
dict[0x6b3a] = "qī"; /* 欺 */
dict[0x6b3b] = "xū,chuā"; /* 欻 */
dict[0x6b3c] = "chǐ,chuài"; /* 欼 */
dict[0x6b3d] = "qīn"; /* 欽 */
dict[0x6b3e] = "kuǎn"; /* 款 */
dict[0x6b3f] = "kǎn,qiàn"; /* 欿 */
dict[0x6b40] = "kuǎn"; /* 歀 */
dict[0x6b41] = "kǎn,kè"; /* 歁 */
dict[0x6b42] = "chuǎn,chuán"; /* 歂 */
dict[0x6b43] = "shà"; /* 歃 */
dict[0x6b44] = "guā"; /* 歄 */
dict[0x6b45] = "yān,yīn"; /* 歅 */
dict[0x6b46] = "xīn"; /* 歆 */
dict[0x6b47] = "xiē"; /* 歇 */
dict[0x6b48] = "yú"; /* 歈 */
dict[0x6b49] = "qiàn"; /* 歉 */
dict[0x6b4a] = "xiāo"; /* 歊 */
dict[0x6b4b] = "yē"; /* 歋 */
dict[0x6b4c] = "gē"; /* 歌 */
dict[0x6b4d] = "wū"; /* 歍 */
dict[0x6b4e] = "tàn"; /* 歎 */
dict[0x6b4f] = "jìn,qūn"; /* 歏 */
dict[0x6b50] = "ōu"; /* 歐 */
dict[0x6b51] = "hū"; /* 歑 */
dict[0x6b52] = "tì"; /* 歒 */
dict[0x6b53] = "huān"; /* 歓 */
dict[0x6b54] = "xū"; /* 歔 */
dict[0x6b55] = "pēn"; /* 歕 */
dict[0x6b56] = "xǐ"; /* 歖 */
dict[0x6b57] = "xiào"; /* 歗 */
dict[0x6b58] = "xū"; /* 歘 */
dict[0x6b59] = "xī,shè"; /* 歙 */
dict[0x6b5a] = "shàn"; /* 歚 */
dict[0x6b5b] = "liǎn,hān"; /* 歛 */
dict[0x6b5c] = "chù"; /* 歜 */
dict[0x6b5d] = "yì"; /* 歝 */
dict[0x6b5e] = "è"; /* 歞 */
dict[0x6b5f] = "yú"; /* 歟 */
dict[0x6b60] = "chuò"; /* 歠 */
dict[0x6b61] = "huān"; /* 歡 */
dict[0x6b62] = "zhǐ"; /* 止 */
dict[0x6b63] = "zhèng,zhēng"; /* 正 */
dict[0x6b64] = "cǐ"; /* 此 */
dict[0x6b65] = "bù"; /* 步 */
dict[0x6b66] = "wǔ"; /* 武 */
dict[0x6b67] = "qí"; /* 歧 */
dict[0x6b68] = "bù"; /* 歨 */
dict[0x6b69] = "bù"; /* 歩 */
dict[0x6b6a] = "wāi"; /* 歪 */
dict[0x6b6b] = "jù"; /* 歫 */
dict[0x6b6c] = "qián"; /* 歬 */
dict[0x6b6d] = "zhì,chí"; /* 歭 */
dict[0x6b6e] = "sè"; /* 歮 */
dict[0x6b6f] = "chǐ"; /* 歯 */
dict[0x6b70] = "sè,shà"; /* 歰 */
dict[0x6b71] = "zhǒng"; /* 歱 */
dict[0x6b72] = "suì"; /* 歲 */
dict[0x6b73] = "suì"; /* 歳 */
dict[0x6b74] = "lì"; /* 歴 */
dict[0x6b75] = "zé"; /* 歵 */
dict[0x6b76] = "yú"; /* 歶 */
dict[0x6b77] = "lì"; /* 歷 */
dict[0x6b78] = "guī"; /* 歸 */
dict[0x6b79] = "dǎi"; /* 歹 */
dict[0x6b7a] = "è"; /* 歺 */
dict[0x6b7b] = "sǐ"; /* 死 */
dict[0x6b7c] = "jiān"; /* 歼 */
dict[0x6b7d] = "zhé"; /* 歽 */
dict[0x6b7e] = "mò,wěn"; /* 歾 */
dict[0x6b7f] = "mò"; /* 歿 */
dict[0x6b80] = "yāo"; /* 殀 */
dict[0x6b81] = "mò"; /* 殁 */
dict[0x6b82] = "cú"; /* 殂 */
dict[0x6b83] = "yāng"; /* 殃 */
dict[0x6b84] = "tiǎn"; /* 殄 */
dict[0x6b85] = "shēng"; /* 殅 */
dict[0x6b86] = "dài"; /* 殆 */
dict[0x6b87] = "shāng"; /* 殇 */
dict[0x6b88] = "xù"; /* 殈 */
dict[0x6b89] = "xùn"; /* 殉 */
dict[0x6b8a] = "shū"; /* 殊 */
dict[0x6b8b] = "cán"; /* 残 */
dict[0x6b8c] = "jǐng"; /* 殌 */
dict[0x6b8d] = "piǎo"; /* 殍 */
dict[0x6b8e] = "qià"; /* 殎 */
dict[0x6b8f] = "qiú"; /* 殏 */
dict[0x6b90] = "sù"; /* 殐 */
dict[0x6b91] = "qíng,jìng"; /* 殑 */
dict[0x6b92] = "yǔn"; /* 殒 */
dict[0x6b93] = "liàn"; /* 殓 */
dict[0x6b94] = "yì"; /* 殔 */
dict[0x6b95] = "fǒu,bó"; /* 殕 */
dict[0x6b96] = "zhí,shi"; /* 殖 */
dict[0x6b97] = "yè,yān,yàn"; /* 殗 */
dict[0x6b98] = "cán"; /* 殘 */
dict[0x6b99] = "hūn,mèi"; /* 殙 */
dict[0x6b9a] = "dān"; /* 殚 */
dict[0x6b9b] = "jí"; /* 殛 */
dict[0x6b9c] = "dié"; /* 殜 */
dict[0x6b9d] = "zhēn"; /* 殝 */
dict[0x6b9e] = "yǔn"; /* 殞 */
dict[0x6b9f] = "wēn"; /* 殟 */
dict[0x6ba0] = "chòu"; /* 殠 */
dict[0x6ba1] = "bìn"; /* 殡 */
dict[0x6ba2] = "tì"; /* 殢 */
dict[0x6ba3] = "jìn"; /* 殣 */
dict[0x6ba4] = "shāng"; /* 殤 */
dict[0x6ba5] = "yín"; /* 殥 */
dict[0x6ba6] = "chī"; /* 殦 */
dict[0x6ba7] = "jiù"; /* 殧 */
dict[0x6ba8] = "kuì,huì"; /* 殨 */
dict[0x6ba9] = "cuàn"; /* 殩 */
dict[0x6baa] = "yì"; /* 殪 */
dict[0x6bab] = "dān"; /* 殫 */
dict[0x6bac] = "dù"; /* 殬 */
dict[0x6bad] = "jiāng"; /* 殭 */
dict[0x6bae] = "liàn"; /* 殮 */
dict[0x6baf] = "bìn"; /* 殯 */
dict[0x6bb0] = "dú"; /* 殰 */
dict[0x6bb1] = "jiān"; /* 殱 */
dict[0x6bb2] = "jiān"; /* 殲 */
dict[0x6bb3] = "shū"; /* 殳 */
dict[0x6bb4] = "ōu"; /* 殴 */
dict[0x6bb5] = "duàn"; /* 段 */
dict[0x6bb6] = "zhù"; /* 殶 */
dict[0x6bb7] = "yīn,yān,yǐn"; /* 殷 */
dict[0x6bb8] = "qìng,kēng,shēng"; /* 殸 */
dict[0x6bb9] = "yì"; /* 殹 */
dict[0x6bba] = "shā"; /* 殺 */
dict[0x6bbb] = "ké,qiào"; /* 殻 */
dict[0x6bbc] = "ké,qiào"; /* 殼 */
dict[0x6bbd] = "xiáo,yáo,xiào"; /* 殽 */
dict[0x6bbe] = "xùn"; /* 殾 */
dict[0x6bbf] = "diàn"; /* 殿 */
dict[0x6bc0] = "huǐ"; /* 毀 */
dict[0x6bc1] = "huǐ"; /* 毁 */
dict[0x6bc2] = "gǔ"; /* 毂 */
dict[0x6bc3] = "qiāo"; /* 毃 */
dict[0x6bc4] = "jī"; /* 毄 */
dict[0x6bc5] = "yì"; /* 毅 */
dict[0x6bc6] = "ōu"; /* 毆 */
dict[0x6bc7] = "huǐ"; /* 毇 */
dict[0x6bc8] = "duàn"; /* 毈 */
dict[0x6bc9] = "yī"; /* 毉 */
dict[0x6bca] = "xiāo"; /* 毊 */
dict[0x6bcb] = "wú"; /* 毋 */
dict[0x6bcc] = "guàn,wān"; /* 毌 */
dict[0x6bcd] = "mǔ"; /* 母 */
dict[0x6bce] = "měi"; /* 毎 */
dict[0x6bcf] = "měi"; /* 每 */
dict[0x6bd0] = "ǎi"; /* 毐 */
dict[0x6bd1] = "jiě"; /* 毑 */
dict[0x6bd2] = "dú,dài"; /* 毒 */
dict[0x6bd3] = "yù"; /* 毓 */
dict[0x6bd4] = "bǐ"; /* 比 */
dict[0x6bd5] = "bì"; /* 毕 */
dict[0x6bd6] = "bì"; /* 毖 */
dict[0x6bd7] = "pí"; /* 毗 */
dict[0x6bd8] = "pí"; /* 毘 */
dict[0x6bd9] = "bì"; /* 毙 */
dict[0x6bda] = "chán"; /* 毚 */
dict[0x6bdb] = "máo"; /* 毛 */
dict[0x6bdc] = "háo"; /* 毜 */
dict[0x6bdd] = "cǎi"; /* 毝 */
dict[0x6bde] = "bǐ"; /* 毞 */
dict[0x6bdf] = "liě"; /* 毟 */
dict[0x6be0] = "jiā"; /* 毠 */
dict[0x6be1] = "zhān"; /* 毡 */
dict[0x6be2] = "sāi"; /* 毢 */
dict[0x6be3] = "mù"; /* 毣 */
dict[0x6be4] = "tuò"; /* 毤 */
dict[0x6be5] = "xún,xùn"; /* 毥 */
dict[0x6be6] = "ěr"; /* 毦 */
dict[0x6be7] = "róng"; /* 毧 */
dict[0x6be8] = "xiǎn"; /* 毨 */
dict[0x6be9] = "jū"; /* 毩 */
dict[0x6bea] = "mú"; /* 毪 */
dict[0x6beb] = "háo"; /* 毫 */
dict[0x6bec] = "qiú"; /* 毬 */
dict[0x6bed] = "dòu,nuò"; /* 毭 */
dict[0x6bee] = "shā"; /* 毮 */
dict[0x6bef] = "tǎn"; /* 毯 */
dict[0x6bf0] = "péi"; /* 毰 */
dict[0x6bf1] = "jū"; /* 毱 */
dict[0x6bf2] = "duō"; /* 毲 */
dict[0x6bf3] = "cuì"; /* 毳 */
dict[0x6bf4] = "bī"; /* 毴 */
dict[0x6bf5] = "sān"; /* 毵 */
dict[0x6bf6] = "sān"; /* 毶 */
dict[0x6bf7] = "mào"; /* 毷 */
dict[0x6bf8] = "sāi,suī"; /* 毸 */
dict[0x6bf9] = "shū"; /* 毹 */
dict[0x6bfa] = "shū"; /* 毺 */
dict[0x6bfb] = "tuò"; /* 毻 */
dict[0x6bfc] = "hé"; /* 毼 */
dict[0x6bfd] = "jiàn"; /* 毽 */
dict[0x6bfe] = "tà"; /* 毾 */
dict[0x6bff] = "sān"; /* 毿 */
dict[0x6c00] = "lǘ"; /* 氀 */
dict[0x6c01] = "mú"; /* 氁 */
dict[0x6c02] = "máo"; /* 氂 */
dict[0x6c03] = "tóng"; /* 氃 */
dict[0x6c04] = "rǒng"; /* 氄 */
dict[0x6c05] = "chǎng"; /* 氅 */
dict[0x6c06] = "pǔ"; /* 氆 */
dict[0x6c07] = "lǔ"; /* 氇 */
dict[0x6c08] = "zhān"; /* 氈 */
dict[0x6c09] = "sào"; /* 氉 */
dict[0x6c0a] = "zhān"; /* 氊 */
dict[0x6c0b] = "méng"; /* 氋 */
dict[0x6c0c] = "lǔ"; /* 氌 */
dict[0x6c0d] = "qú"; /* 氍 */
dict[0x6c0e] = "dié"; /* 氎 */
dict[0x6c0f] = "shì,zhī"; /* 氏 */
dict[0x6c10] = "dī,dǐ"; /* 氐 */
dict[0x6c11] = "mín"; /* 民 */
dict[0x6c12] = "jué"; /* 氒 */
dict[0x6c13] = "máng,méng"; /* 氓 */
dict[0x6c14] = "qì"; /* 气 */
dict[0x6c15] = "piē"; /* 氕 */
dict[0x6c16] = "nǎi"; /* 氖 */
dict[0x6c17] = "qì"; /* 気 */
dict[0x6c18] = "dāo"; /* 氘 */
dict[0x6c19] = "xiān"; /* 氙 */
dict[0x6c1a] = "chuān"; /* 氚 */
dict[0x6c1b] = "fēn"; /* 氛 */
dict[0x6c1c] = "yáng,rì"; /* 氜 */
dict[0x6c1d] = "nèi"; /* 氝 */
dict[0x6c1e] = "nèi"; /* 氞 */
dict[0x6c1f] = "fú"; /* 氟 */
dict[0x6c20] = "shēn"; /* 氠 */
dict[0x6c21] = "dōng"; /* 氡 */
dict[0x6c22] = "qīng"; /* 氢 */
dict[0x6c23] = "qì"; /* 氣 */
dict[0x6c24] = "yīn"; /* 氤 */
dict[0x6c25] = "xī"; /* 氥 */
dict[0x6c26] = "hài"; /* 氦 */
dict[0x6c27] = "yǎng"; /* 氧 */
dict[0x6c28] = "ān"; /* 氨 */
dict[0x6c29] = "yà"; /* 氩 */
dict[0x6c2a] = "kè"; /* 氪 */
dict[0x6c2b] = "qīng"; /* 氫 */
dict[0x6c2c] = "yà"; /* 氬 */
dict[0x6c2d] = "dōng"; /* 氭 */
dict[0x6c2e] = "dàn"; /* 氮 */
dict[0x6c2f] = "lǜ"; /* 氯 */
dict[0x6c30] = "qíng"; /* 氰 */
dict[0x6c31] = "yǎng"; /* 氱 */
dict[0x6c32] = "yūn"; /* 氲 */
dict[0x6c33] = "yūn"; /* 氳 */
dict[0x6c34] = "shuǐ"; /* 水 */
dict[0x6c35] = "shuǐ"; /* 氵 */
dict[0x6c36] = "zhěng,chéng,zhèng"; /* 氶 */
dict[0x6c37] = "bīng"; /* 氷 */
dict[0x6c38] = "yǒng"; /* 永 */
dict[0x6c39] = "dàng"; /* 氹 */
dict[0x6c3a] = "shuǐ"; /* 氺 */
dict[0x6c3b] = "lè"; /* 氻 */
dict[0x6c3c] = "nì"; /* 氼 */
dict[0x6c3d] = "tǔn"; /* 氽 */
dict[0x6c3e] = "fàn"; /* 氾 */
dict[0x6c3f] = "guǐ,jiǔ"; /* 氿 */
dict[0x6c40] = "tīng"; /* 汀 */
dict[0x6c41] = "zhī"; /* 汁 */
dict[0x6c42] = "qiú"; /* 求 */
dict[0x6c43] = "bīn,pà,pā"; /* 汃 */
dict[0x6c44] = "zè"; /* 汄 */
dict[0x6c45] = "miǎn"; /* 汅 */
dict[0x6c46] = "cuān"; /* 汆 */
dict[0x6c47] = "huì"; /* 汇 */
dict[0x6c48] = "diāo"; /* 汈 */
dict[0x6c49] = "hàn"; /* 汉 */
dict[0x6c4a] = "chà"; /* 汊 */
dict[0x6c4b] = "zhuó,què"; /* 汋 */
dict[0x6c4c] = "chuàn"; /* 汌 */
dict[0x6c4d] = "wán"; /* 汍 */
dict[0x6c4e] = "fàn"; /* 汎 */
dict[0x6c4f] = "tài,dà"; /* 汏 */
dict[0x6c50] = "xī"; /* 汐 */
dict[0x6c51] = "tuō"; /* 汑 */
dict[0x6c52] = "máng"; /* 汒 */
dict[0x6c53] = "qiú"; /* 汓 */
dict[0x6c54] = "qì"; /* 汔 */
dict[0x6c55] = "shàn"; /* 汕 */
dict[0x6c56] = "pìn"; /* 汖 */
dict[0x6c57] = "hàn,hán"; /* 汗 */
dict[0x6c58] = "qiān"; /* 汘 */
dict[0x6c59] = "wū"; /* 汙 */
dict[0x6c5a] = "wū"; /* 汚 */
dict[0x6c5b] = "xùn"; /* 汛 */
dict[0x6c5c] = "sì"; /* 汜 */
dict[0x6c5d] = "rǔ"; /* 汝 */
dict[0x6c5e] = "gǒng"; /* 汞 */
dict[0x6c5f] = "jiāng"; /* 江 */
dict[0x6c60] = "chí"; /* 池 */
dict[0x6c61] = "wū"; /* 污 */
dict[0x6c62] = "tu"; /* 汢 */
dict[0x6c63] = "jiǔ"; /* 汣 */
dict[0x6c64] = "tāng,shāng"; /* 汤 */
dict[0x6c65] = "zhī,jì"; /* 汥 */
dict[0x6c66] = "zhǐ"; /* 汦 */
dict[0x6c67] = "qiān"; /* 汧 */
dict[0x6c68] = "mì"; /* 汨 */
dict[0x6c69] = "gǔ,yù"; /* 汩 */
dict[0x6c6a] = "wāng"; /* 汪 */
dict[0x6c6b] = "jǐng"; /* 汫 */
dict[0x6c6c] = "jǐng"; /* 汬 */
dict[0x6c6d] = "ruì"; /* 汭 */
dict[0x6c6e] = "jūn"; /* 汮 */
dict[0x6c6f] = "hóng"; /* 汯 */
dict[0x6c70] = "tài"; /* 汰 */
dict[0x6c71] = "tài"; /* 汱 */
dict[0x6c72] = "jí"; /* 汲 */
dict[0x6c73] = "biàn"; /* 汳 */
dict[0x6c74] = "biàn"; /* 汴 */
dict[0x6c75] = "gàn,hán,cén"; /* 汵 */
dict[0x6c76] = "wèn,mén"; /* 汶 */
dict[0x6c77] = "zhōng"; /* 汷 */
dict[0x6c78] = "fāng,pāng"; /* 汸 */
dict[0x6c79] = "xiōng"; /* 汹 */
dict[0x6c7a] = "jué"; /* 決 */
dict[0x6c7b] = "hǔ,huǎng"; /* 汻 */
dict[0x6c7c] = "niú,yóu"; /* 汼 */
dict[0x6c7d] = "qì"; /* 汽 */
dict[0x6c7e] = "fén"; /* 汾 */
dict[0x6c7f] = "xù"; /* 汿 */
dict[0x6c80] = "xù"; /* 沀 */
dict[0x6c81] = "qìn"; /* 沁 */
dict[0x6c82] = "yí"; /* 沂 */
dict[0x6c83] = "wò"; /* 沃 */
dict[0x6c84] = "yún"; /* 沄 */
dict[0x6c85] = "yuán"; /* 沅 */
dict[0x6c86] = "hàng"; /* 沆 */
dict[0x6c87] = "yǎn"; /* 沇 */
dict[0x6c88] = "shěn,chén"; /* 沈 */
dict[0x6c89] = "chén"; /* 沉 */
dict[0x6c8a] = "dàn"; /* 沊 */
dict[0x6c8b] = "yóu"; /* 沋 */
dict[0x6c8c] = "dùn"; /* 沌 */
dict[0x6c8d] = "hù"; /* 沍 */
dict[0x6c8e] = "huò"; /* 沎 */
dict[0x6c8f] = "qī"; /* 沏 */
dict[0x6c90] = "mù"; /* 沐 */
dict[0x6c91] = "nǜ,niǔ"; /* 沑 */
dict[0x6c92] = "méi,mò"; /* 沒 */
dict[0x6c93] = "tà,dá"; /* 沓 */
dict[0x6c94] = "miǎn"; /* 沔 */
dict[0x6c95] = "mì,wù"; /* 沕 */
dict[0x6c96] = "chōng"; /* 沖 */
dict[0x6c97] = "hóng,pāng"; /* 沗 */
dict[0x6c98] = "bǐ"; /* 沘 */
dict[0x6c99] = "shā,shà"; /* 沙 */
dict[0x6c9a] = "zhǐ"; /* 沚 */
dict[0x6c9b] = "pèi"; /* 沛 */
dict[0x6c9c] = "pàn"; /* 沜 */
dict[0x6c9d] = "zhuǐ,zǐ"; /* 沝 */
dict[0x6c9e] = "zā"; /* 沞 */
dict[0x6c9f] = "gōu"; /* 沟 */
dict[0x6ca0] = "pài"; /* 沠 */
dict[0x6ca1] = "méi,mò"; /* 没 */
dict[0x6ca2] = "zé"; /* 沢 */
dict[0x6ca3] = "fēng"; /* 沣 */
dict[0x6ca4] = "òu,ōu"; /* 沤 */
dict[0x6ca5] = "lì"; /* 沥 */
dict[0x6ca6] = "lún"; /* 沦 */
dict[0x6ca7] = "cāng"; /* 沧 */
dict[0x6ca8] = "fēng"; /* 沨 */
dict[0x6ca9] = "wéi"; /* 沩 */
dict[0x6caa] = "hù"; /* 沪 */
dict[0x6cab] = "mò"; /* 沫 */
dict[0x6cac] = "mèi"; /* 沬 */
dict[0x6cad] = "shù"; /* 沭 */
dict[0x6cae] = "jǔ,jù"; /* 沮 */
dict[0x6caf] = "zá"; /* 沯 */
dict[0x6cb0] = "tuō,duó"; /* 沰 */
dict[0x6cb1] = "tuó"; /* 沱 */
dict[0x6cb2] = "tuó,duò"; /* 沲 */
dict[0x6cb3] = "hé"; /* 河 */
dict[0x6cb4] = "lì"; /* 沴 */
dict[0x6cb5] = "mǐ,lì"; /* 沵 */
dict[0x6cb6] = "yí,chí"; /* 沶 */
dict[0x6cb7] = "fā"; /* 沷 */
dict[0x6cb8] = "fèi"; /* 沸 */
dict[0x6cb9] = "yóu"; /* 油 */
dict[0x6cba] = "tián"; /* 沺 */
dict[0x6cbb] = "zhì"; /* 治 */
dict[0x6cbc] = "zhǎo"; /* 沼 */
dict[0x6cbd] = "gū"; /* 沽 */
dict[0x6cbe] = "zhān"; /* 沾 */
dict[0x6cbf] = "yán"; /* 沿 */
dict[0x6cc0] = "sī"; /* 泀 */
dict[0x6cc1] = "kuàng"; /* 況 */
dict[0x6cc2] = "jiǒng"; /* 泂 */
dict[0x6cc3] = "jū"; /* 泃 */
dict[0x6cc4] = "xiè,yì"; /* 泄 */
dict[0x6cc5] = "qiú"; /* 泅 */
dict[0x6cc6] = "yì,dié"; /* 泆 */
dict[0x6cc7] = "jiā"; /* 泇 */
dict[0x6cc8] = "zhōng"; /* 泈 */
dict[0x6cc9] = "quán"; /* 泉 */
dict[0x6cca] = "bó,pō"; /* 泊 */
dict[0x6ccb] = "huì"; /* 泋 */
dict[0x6ccc] = "mì,bì"; /* 泌 */
dict[0x6ccd] = "bēn,bèn"; /* 泍 */
dict[0x6cce] = "zé"; /* 泎 */
dict[0x6ccf] = "chù,shè"; /* 泏 */
dict[0x6cd0] = "lè"; /* 泐 */
dict[0x6cd1] = "yōu,yòu,āo"; /* 泑 */
dict[0x6cd2] = "gū"; /* 泒 */
dict[0x6cd3] = "hóng"; /* 泓 */
dict[0x6cd4] = "gān"; /* 泔 */
dict[0x6cd5] = "fǎ"; /* 法 */
dict[0x6cd6] = "mǎo"; /* 泖 */
dict[0x6cd7] = "sì"; /* 泗 */
dict[0x6cd8] = "hū"; /* 泘 */
dict[0x6cd9] = "pēng,píng"; /* 泙 */
dict[0x6cda] = "cǐ"; /* 泚 */
dict[0x6cdb] = "fàn"; /* 泛 */
dict[0x6cdc] = "zhī"; /* 泜 */
dict[0x6cdd] = "sù"; /* 泝 */
dict[0x6cde] = "nìng"; /* 泞 */
dict[0x6cdf] = "chēng"; /* 泟 */
dict[0x6ce0] = "líng"; /* 泠 */
dict[0x6ce1] = "pào,pāo"; /* 泡 */
dict[0x6ce2] = "bō"; /* 波 */
dict[0x6ce3] = "qì"; /* 泣 */
dict[0x6ce4] = "sì"; /* 泤 */
dict[0x6ce5] = "ní,nì"; /* 泥 */
dict[0x6ce6] = "jú"; /* 泦 */
dict[0x6ce7] = "yuè,sà"; /* 泧 */
dict[0x6ce8] = "zhù"; /* 注 */
dict[0x6ce9] = "shēng"; /* 泩 */
dict[0x6cea] = "lèi"; /* 泪 */
dict[0x6ceb] = "xuàn"; /* 泫 */
dict[0x6cec] = "jué,xuè"; /* 泬 */
dict[0x6ced] = "fú"; /* 泭 */
dict[0x6cee] = "pàn"; /* 泮 */
dict[0x6cef] = "mǐn"; /* 泯 */
dict[0x6cf0] = "tài"; /* 泰 */
dict[0x6cf1] = "yāng"; /* 泱 */
dict[0x6cf2] = "jǐ"; /* 泲 */
dict[0x6cf3] = "yǒng"; /* 泳 */
dict[0x6cf4] = "guàn"; /* 泴 */
dict[0x6cf5] = "bèng"; /* 泵 */
dict[0x6cf6] = "xué"; /* 泶 */
dict[0x6cf7] = "lóng,shuāng"; /* 泷 */
dict[0x6cf8] = "lú"; /* 泸 */
dict[0x6cf9] = "dàn"; /* 泹 */
dict[0x6cfa] = "luò,pō"; /* 泺 */
dict[0x6cfb] = "xiè"; /* 泻 */
dict[0x6cfc] = "pō"; /* 泼 */
dict[0x6cfd] = "zé,shì"; /* 泽 */
dict[0x6cfe] = "jīng"; /* 泾 */
dict[0x6cff] = "yín"; /* 泿 */
dict[0x6d00] = "pán"; /* 洀 */
dict[0x6d01] = "jié"; /* 洁 */
dict[0x6d02] = "yè"; /* 洂 */
dict[0x6d03] = "huī"; /* 洃 */
dict[0x6d04] = "huí"; /* 洄 */
dict[0x6d05] = "zài"; /* 洅 */
dict[0x6d06] = "chéng"; /* 洆 */
dict[0x6d07] = "yīn"; /* 洇 */
dict[0x6d08] = "wéi"; /* 洈 */
dict[0x6d09] = "hòu"; /* 洉 */
dict[0x6d0a] = "jiàn"; /* 洊 */
dict[0x6d0b] = "yáng"; /* 洋 */
dict[0x6d0c] = "liè"; /* 洌 */
dict[0x6d0d] = "sì"; /* 洍 */
dict[0x6d0e] = "jì"; /* 洎 */
dict[0x6d0f] = "ér"; /* 洏 */
dict[0x6d10] = "xíng"; /* 洐 */
dict[0x6d11] = "fú,fù"; /* 洑 */
dict[0x6d12] = "sǎ,xǐ"; /* 洒 */
dict[0x6d13] = "sè,qì,zì"; /* 洓 */
dict[0x6d14] = "zhǐ"; /* 洔 */
dict[0x6d15] = "yìn"; /* 洕 */
dict[0x6d16] = "wú"; /* 洖 */
dict[0x6d17] = "xǐ,xiǎn"; /* 洗 */
dict[0x6d18] = "kǎo,kào"; /* 洘 */
dict[0x6d19] = "zhū"; /* 洙 */
dict[0x6d1a] = "jiàng"; /* 洚 */
dict[0x6d1b] = "luò"; /* 洛 */
dict[0x6d1c] = "luò"; /* 洜 */
dict[0x6d1d] = "àn,yàn,è"; /* 洝 */
dict[0x6d1e] = "dòng"; /* 洞 */
dict[0x6d1f] = "yí"; /* 洟 */
dict[0x6d20] = "sì"; /* 洠 */
dict[0x6d21] = "lěi,lèi"; /* 洡 */
dict[0x6d22] = "yī"; /* 洢 */
dict[0x6d23] = "mǐ"; /* 洣 */
dict[0x6d24] = "quán"; /* 洤 */
dict[0x6d25] = "jīn"; /* 津 */
dict[0x6d26] = "pò"; /* 洦 */
dict[0x6d27] = "wěi"; /* 洧 */
dict[0x6d28] = "xiáo"; /* 洨 */
dict[0x6d29] = "xiè"; /* 洩 */
dict[0x6d2a] = "hóng"; /* 洪 */
dict[0x6d2b] = "xù"; /* 洫 */
dict[0x6d2c] = "sù,shuò"; /* 洬 */
dict[0x6d2d] = "kuāng"; /* 洭 */
dict[0x6d2e] = "táo"; /* 洮 */
dict[0x6d2f] = "qiè,jié"; /* 洯 */
dict[0x6d30] = "jù"; /* 洰 */
dict[0x6d31] = "ěr"; /* 洱 */
dict[0x6d32] = "zhōu"; /* 洲 */
dict[0x6d33] = "rù"; /* 洳 */
dict[0x6d34] = "píng"; /* 洴 */
dict[0x6d35] = "xún"; /* 洵 */
dict[0x6d36] = "xiōng"; /* 洶 */
dict[0x6d37] = "zhì"; /* 洷 */
dict[0x6d38] = "guāng"; /* 洸 */
dict[0x6d39] = "huán"; /* 洹 */
dict[0x6d3a] = "míng"; /* 洺 */
dict[0x6d3b] = "huó"; /* 活 */
dict[0x6d3c] = "wā"; /* 洼 */
dict[0x6d3d] = "qià"; /* 洽 */
dict[0x6d3e] = "pài"; /* 派 */
dict[0x6d3f] = "wū"; /* 洿 */
dict[0x6d40] = "qū"; /* 浀 */
dict[0x6d41] = "liú"; /* 流 */
dict[0x6d42] = "yì"; /* 浂 */
dict[0x6d43] = "jiā"; /* 浃 */
dict[0x6d44] = "jìng"; /* 浄 */
dict[0x6d45] = "qiǎn,jiān"; /* 浅 */
dict[0x6d46] = "jiāng,jiàng"; /* 浆 */
dict[0x6d47] = "jiāo"; /* 浇 */
dict[0x6d48] = "zhēn"; /* 浈 */
dict[0x6d49] = "shī"; /* 浉 */
dict[0x6d4a] = "zhuó"; /* 浊 */
dict[0x6d4b] = "cè"; /* 测 */
dict[0x6d4c] = "fá"; /* 浌 */
dict[0x6d4d] = "kuài,huì"; /* 浍 */
dict[0x6d4e] = "jì,jǐ"; /* 济 */
dict[0x6d4f] = "liú"; /* 浏 */
dict[0x6d50] = "chǎn"; /* 浐 */
dict[0x6d51] = "hún"; /* 浑 */
dict[0x6d52] = "hǔ,xǔ"; /* 浒 */
dict[0x6d53] = "nóng"; /* 浓 */
dict[0x6d54] = "xún"; /* 浔 */
dict[0x6d55] = "jìn"; /* 浕 */
dict[0x6d56] = "liè"; /* 浖 */
dict[0x6d57] = "qiú"; /* 浗 */
dict[0x6d58] = "wěi"; /* 浘 */
dict[0x6d59] = "zhè"; /* 浙 */
dict[0x6d5a] = "jùn,xùn"; /* 浚 */
dict[0x6d5b] = "hán"; /* 浛 */
dict[0x6d5c] = "bāng"; /* 浜 */
dict[0x6d5d] = "máng"; /* 浝 */
dict[0x6d5e] = "zhuó"; /* 浞 */
dict[0x6d5f] = "yōu,dí"; /* 浟 */
dict[0x6d60] = "xī"; /* 浠 */
dict[0x6d61] = "bó"; /* 浡 */
dict[0x6d62] = "dòu"; /* 浢 */
dict[0x6d63] = "huàn"; /* 浣 */
dict[0x6d64] = "hóng"; /* 浤 */
dict[0x6d65] = "yì"; /* 浥 */
dict[0x6d66] = "pǔ"; /* 浦 */
dict[0x6d67] = "yǐng,chéng,yíng"; /* 浧 */
dict[0x6d68] = "lǎn"; /* 浨 */
dict[0x6d69] = "hào"; /* 浩 */
dict[0x6d6a] = "làng"; /* 浪 */
dict[0x6d6b] = "hǎn"; /* 浫 */
dict[0x6d6c] = "lǐ"; /* 浬 */
dict[0x6d6d] = "gēng"; /* 浭 */
dict[0x6d6e] = "fú"; /* 浮 */
dict[0x6d6f] = "wú"; /* 浯 */
dict[0x6d70] = "lì"; /* 浰 */
dict[0x6d71] = "chún"; /* 浱 */
dict[0x6d72] = "féng,hóng"; /* 浲 */
dict[0x6d73] = "yì"; /* 浳 */
dict[0x6d74] = "yù"; /* 浴 */
dict[0x6d75] = "tóng"; /* 浵 */
dict[0x6d76] = "láo"; /* 浶 */
dict[0x6d77] = "hǎi"; /* 海 */
dict[0x6d78] = "jìn"; /* 浸 */
dict[0x6d79] = "jiā"; /* 浹 */
dict[0x6d7a] = "chōng"; /* 浺 */
dict[0x6d7b] = "jiǒng,jiōng"; /* 浻 */
dict[0x6d7c] = "měi"; /* 浼 */
dict[0x6d7d] = "suī,něi"; /* 浽 */
dict[0x6d7e] = "chēng"; /* 浾 */
dict[0x6d7f] = "pèi"; /* 浿 */
dict[0x6d80] = "xiàn"; /* 涀 */
dict[0x6d81] = "shèn"; /* 涁 */
dict[0x6d82] = "tú"; /* 涂 */
dict[0x6d83] = "kùn"; /* 涃 */
dict[0x6d84] = "pīng"; /* 涄 */
dict[0x6d85] = "niè"; /* 涅 */
dict[0x6d86] = "hàn"; /* 涆 */
dict[0x6d87] = "jīng"; /* 涇 */
dict[0x6d88] = "xiāo"; /* 消 */
dict[0x6d89] = "shè"; /* 涉 */
dict[0x6d8a] = "niǎn"; /* 涊 */
dict[0x6d8b] = "tū"; /* 涋 */
dict[0x6d8c] = "yǒng,chōng"; /* 涌 */
dict[0x6d8d] = "xiào"; /* 涍 */
dict[0x6d8e] = "xián"; /* 涎 */
dict[0x6d8f] = "tǐng"; /* 涏 */
dict[0x6d90] = "é"; /* 涐 */
dict[0x6d91] = "sù"; /* 涑 */
dict[0x6d92] = "tūn,yūn"; /* 涒 */
dict[0x6d93] = "juān"; /* 涓 */
dict[0x6d94] = "cén"; /* 涔 */
dict[0x6d95] = "tì"; /* 涕 */
dict[0x6d96] = "lì"; /* 涖 */
dict[0x6d97] = "shuì"; /* 涗 */
dict[0x6d98] = "sì"; /* 涘 */
dict[0x6d99] = "lèi"; /* 涙 */
dict[0x6d9a] = "shuì"; /* 涚 */
dict[0x6d9b] = "tāo"; /* 涛 */
dict[0x6d9c] = "dú"; /* 涜 */
dict[0x6d9d] = "lào"; /* 涝 */
dict[0x6d9e] = "lái"; /* 涞 */
dict[0x6d9f] = "lián"; /* 涟 */
dict[0x6da0] = "wéi"; /* 涠 */
dict[0x6da1] = "wō,guō"; /* 涡 */
dict[0x6da2] = "yún"; /* 涢 */
dict[0x6da3] = "huàn"; /* 涣 */
dict[0x6da4] = "dí"; /* 涤 */
dict[0x6da5] = "hēng"; /* 涥 */
dict[0x6da6] = "rùn"; /* 润 */
dict[0x6da7] = "jiàn"; /* 涧 */
dict[0x6da8] = "zhǎng,zhàng"; /* 涨 */
dict[0x6da9] = "sè"; /* 涩 */
dict[0x6daa] = "fú"; /* 涪 */
dict[0x6dab] = "guān"; /* 涫 */
dict[0x6dac] = "xìng"; /* 涬 */
dict[0x6dad] = "shòu,tāo"; /* 涭 */
dict[0x6dae] = "shuàn"; /* 涮 */
dict[0x6daf] = "yá"; /* 涯 */
dict[0x6db0] = "chuò"; /* 涰 */
dict[0x6db1] = "zhàng"; /* 涱 */
dict[0x6db2] = "yè"; /* 液 */
dict[0x6db3] = "kōng,náng"; /* 涳 */
dict[0x6db4] = "wǎn,wò,yuān"; /* 涴 */
dict[0x6db5] = "hán"; /* 涵 */
dict[0x6db6] = "tuō,tuò"; /* 涶 */
dict[0x6db7] = "dōng"; /* 涷 */
dict[0x6db8] = "hé"; /* 涸 */
dict[0x6db9] = "wō"; /* 涹 */
dict[0x6dba] = "jū"; /* 涺 */
dict[0x6dbb] = "shè"; /* 涻 */
dict[0x6dbc] = "liáng,liàng"; /* 涼 */
dict[0x6dbd] = "hūn"; /* 涽 */
dict[0x6dbe] = "tà"; /* 涾 */
dict[0x6dbf] = "zhuō"; /* 涿 */
dict[0x6dc0] = "diàn"; /* 淀 */
dict[0x6dc1] = "qiè,jí"; /* 淁 */
dict[0x6dc2] = "dé"; /* 淂 */
dict[0x6dc3] = "juàn"; /* 淃 */
dict[0x6dc4] = "zī"; /* 淄 */
dict[0x6dc5] = "xī"; /* 淅 */
dict[0x6dc6] = "xiáo"; /* 淆 */
dict[0x6dc7] = "qí"; /* 淇 */
dict[0x6dc8] = "gǔ"; /* 淈 */
dict[0x6dc9] = "guǒ,guàn"; /* 淉 */
dict[0x6dca] = "yān"; /* 淊 */
dict[0x6dcb] = "lín,lìn"; /* 淋 */
dict[0x6dcc] = "tǎng,chǎng"; /* 淌 */
dict[0x6dcd] = "zhōu"; /* 淍 */
dict[0x6dce] = "pěng"; /* 淎 */
dict[0x6dcf] = "hào"; /* 淏 */
dict[0x6dd0] = "chāng"; /* 淐 */
dict[0x6dd1] = "shū"; /* 淑 */
dict[0x6dd2] = "qī"; /* 淒 */
dict[0x6dd3] = "fāng"; /* 淓 */
dict[0x6dd4] = "zhí"; /* 淔 */
dict[0x6dd5] = "lù"; /* 淕 */
dict[0x6dd6] = "nào,chuò,zhuō"; /* 淖 */
dict[0x6dd7] = "jú"; /* 淗 */
dict[0x6dd8] = "táo"; /* 淘 */
dict[0x6dd9] = "cóng"; /* 淙 */
dict[0x6dda] = "lèi"; /* 淚 */
dict[0x6ddb] = "zhè"; /* 淛 */
dict[0x6ddc] = "píng,péng"; /* 淜 */
dict[0x6ddd] = "féi"; /* 淝 */
dict[0x6dde] = "sōng"; /* 淞 */
dict[0x6ddf] = "tiǎn"; /* 淟 */
dict[0x6de0] = "pì,pèi"; /* 淠 */
dict[0x6de1] = "dàn"; /* 淡 */
dict[0x6de2] = "yù,xù"; /* 淢 */
dict[0x6de3] = "ní"; /* 淣 */
dict[0x6de4] = "yū"; /* 淤 */
dict[0x6de5] = "lù"; /* 淥 */
dict[0x6de6] = "gàn"; /* 淦 */
dict[0x6de7] = "mì"; /* 淧 */
dict[0x6de8] = "jìng,chēng"; /* 淨 */
dict[0x6de9] = "líng"; /* 淩 */
dict[0x6dea] = "lún"; /* 淪 */
dict[0x6deb] = "yín"; /* 淫 */
dict[0x6dec] = "cuì"; /* 淬 */
dict[0x6ded] = "qú"; /* 淭 */
dict[0x6dee] = "huái"; /* 淮 */
dict[0x6def] = "yù"; /* 淯 */
dict[0x6df0] = "niǎn,shěn"; /* 淰 */
dict[0x6df1] = "shēn"; /* 深 */
dict[0x6df2] = "biāo,hǔ"; /* 淲 */
dict[0x6df3] = "chún,zhūn"; /* 淳 */
dict[0x6df4] = "hū"; /* 淴 */
dict[0x6df5] = "yuān"; /* 淵 */
dict[0x6df6] = "lái"; /* 淶 */
dict[0x6df7] = "hùn,hún"; /* 混 */
dict[0x6df8] = "qīng"; /* 淸 */
dict[0x6df9] = "yān"; /* 淹 */
dict[0x6dfa] = "qiǎn"; /* 淺 */
dict[0x6dfb] = "tiān"; /* 添 */
dict[0x6dfc] = "miǎo"; /* 淼 */
dict[0x6dfd] = "zhǐ"; /* 淽 */
dict[0x6dfe] = "yǐn"; /* 淾 */
dict[0x6dff] = "bó"; /* 淿 */
dict[0x6e00] = "bèn"; /* 渀 */
dict[0x6e01] = "yuān"; /* 渁 */
dict[0x6e02] = "wèn,mín"; /* 渂 */
dict[0x6e03] = "ruò,rè,luò"; /* 渃 */
dict[0x6e04] = "fēi"; /* 渄 */
dict[0x6e05] = "qīng"; /* 清 */
dict[0x6e06] = "yuān"; /* 渆 */
dict[0x6e07] = "kě"; /* 渇 */
dict[0x6e08] = "jì,jǐ"; /* 済 */
dict[0x6e09] = "shè"; /* 渉 */
dict[0x6e0a] = "yuān"; /* 渊 */
dict[0x6e0b] = "sè"; /* 渋 */
dict[0x6e0c] = "lù"; /* 渌 */
dict[0x6e0d] = "zì"; /* 渍 */
dict[0x6e0e] = "dú,dòu"; /* 渎 */
dict[0x6e0f] = "yī"; /* 渏 */
dict[0x6e10] = "jiàn,jiān"; /* 渐 */
dict[0x6e11] = "miǎn,shéng"; /* 渑 */
dict[0x6e12] = "pài"; /* 渒 */
dict[0x6e13] = "xī"; /* 渓 */
dict[0x6e14] = "yú"; /* 渔 */
dict[0x6e15] = "yuān"; /* 渕 */
dict[0x6e16] = "shěn"; /* 渖 */
dict[0x6e17] = "shèn"; /* 渗 */
dict[0x6e18] = "róu"; /* 渘 */
dict[0x6e19] = "huàn"; /* 渙 */
dict[0x6e1a] = "zhǔ"; /* 渚 */
dict[0x6e1b] = "jiǎn"; /* 減 */
dict[0x6e1c] = "nuǎn,nuán"; /* 渜 */
dict[0x6e1d] = "yú"; /* 渝 */
dict[0x6e1e] = "qiú,wù"; /* 渞 */
dict[0x6e1f] = "tíng,tīng"; /* 渟 */
dict[0x6e20] = "qú,jù"; /* 渠 */
dict[0x6e21] = "dù"; /* 渡 */
dict[0x6e22] = "fēng"; /* 渢 */
dict[0x6e23] = "zhā"; /* 渣 */
dict[0x6e24] = "bó"; /* 渤 */
dict[0x6e25] = "wò"; /* 渥 */
dict[0x6e26] = "wō,guō"; /* 渦 */
dict[0x6e27] = "tí,dī,dì"; /* 渧 */
dict[0x6e28] = "wěi"; /* 渨 */
dict[0x6e29] = "wēn"; /* 温 */
dict[0x6e2a] = "rú"; /* 渪 */
dict[0x6e2b] = "xiè"; /* 渫 */
dict[0x6e2c] = "cè"; /* 測 */
dict[0x6e2d] = "wèi"; /* 渭 */
dict[0x6e2e] = "hé"; /* 渮 */
dict[0x6e2f] = "gǎng,jiǎng"; /* 港 */
dict[0x6e30] = "yān,yǎn"; /* 渰 */
dict[0x6e31] = "hóng"; /* 渱 */
dict[0x6e32] = "xuàn"; /* 渲 */
dict[0x6e33] = "mǐ"; /* 渳 */
dict[0x6e34] = "kě"; /* 渴 */
dict[0x6e35] = "máo"; /* 渵 */
dict[0x6e36] = "yīng"; /* 渶 */
dict[0x6e37] = "yǎn"; /* 渷 */
dict[0x6e38] = "yóu"; /* 游 */
dict[0x6e39] = "hōng,qìng"; /* 渹 */
dict[0x6e3a] = "miǎo"; /* 渺 */
dict[0x6e3b] = "shěng"; /* 渻 */
dict[0x6e3c] = "měi"; /* 渼 */
dict[0x6e3d] = "zāi"; /* 渽 */
dict[0x6e3e] = "hún"; /* 渾 */
dict[0x6e3f] = "nài"; /* 渿 */
dict[0x6e40] = "guǐ"; /* 湀 */
dict[0x6e41] = "chì"; /* 湁 */
dict[0x6e42] = "è"; /* 湂 */
dict[0x6e43] = "pài"; /* 湃 */
dict[0x6e44] = "méi"; /* 湄 */
dict[0x6e45] = "liàn"; /* 湅 */
dict[0x6e46] = "qì"; /* 湆 */
dict[0x6e47] = "qì"; /* 湇 */
dict[0x6e48] = "méi"; /* 湈 */
dict[0x6e49] = "tián"; /* 湉 */
dict[0x6e4a] = "còu"; /* 湊 */
dict[0x6e4b] = "wéi"; /* 湋 */
dict[0x6e4c] = "cān"; /* 湌 */
dict[0x6e4d] = "tuān"; /* 湍 */
dict[0x6e4e] = "miǎn"; /* 湎 */
dict[0x6e4f] = "huì,mǐn,xū"; /* 湏 */
dict[0x6e50] = "pò"; /* 湐 */
dict[0x6e51] = "xǔ,xū"; /* 湑 */
dict[0x6e52] = "jí"; /* 湒 */
dict[0x6e53] = "pén"; /* 湓 */
dict[0x6e54] = "jiān"; /* 湔 */
dict[0x6e55] = "jiǎn"; /* 湕 */
dict[0x6e56] = "hú"; /* 湖 */
dict[0x6e57] = "fèng"; /* 湗 */
dict[0x6e58] = "xiāng"; /* 湘 */
dict[0x6e59] = "yì"; /* 湙 */
dict[0x6e5a] = "yìn"; /* 湚 */
dict[0x6e5b] = "zhàn"; /* 湛 */
dict[0x6e5c] = "shí"; /* 湜 */
dict[0x6e5d] = "jiē"; /* 湝 */
dict[0x6e5e] = "zhēn"; /* 湞 */
dict[0x6e5f] = "huáng"; /* 湟 */
dict[0x6e60] = "tàn"; /* 湠 */
dict[0x6e61] = "yú"; /* 湡 */
dict[0x6e62] = "bì"; /* 湢 */
dict[0x6e63] = "mǐn,hūn"; /* 湣 */
dict[0x6e64] = "shī"; /* 湤 */
dict[0x6e65] = "tū"; /* 湥 */
dict[0x6e66] = "shēng"; /* 湦 */
dict[0x6e67] = "yǒng"; /* 湧 */
dict[0x6e68] = "jú"; /* 湨 */
dict[0x6e69] = "dòng"; /* 湩 */
dict[0x6e6a] = "tuàn,nuǎn"; /* 湪 */
dict[0x6e6b] = "qiū,jiǎo"; /* 湫 */
dict[0x6e6c] = "qiū,jiǎo"; /* 湬 */
dict[0x6e6d] = "qiú"; /* 湭 */
dict[0x6e6e] = "yān,yīn"; /* 湮 */
dict[0x6e6f] = "tāng,shāng"; /* 湯 */
dict[0x6e70] = "lóng"; /* 湰 */
dict[0x6e71] = "huò"; /* 湱 */
dict[0x6e72] = "yuán"; /* 湲 */
dict[0x6e73] = "nǎn"; /* 湳 */
dict[0x6e74] = "bàn,pán"; /* 湴 */
dict[0x6e75] = "yǒu"; /* 湵 */
dict[0x6e76] = "quán"; /* 湶 */
dict[0x6e77] = "zhuāng,hún"; /* 湷 */
dict[0x6e78] = "liàng"; /* 湸 */
dict[0x6e79] = "chán"; /* 湹 */
dict[0x6e7a] = "xián"; /* 湺 */
dict[0x6e7b] = "chún"; /* 湻 */
dict[0x6e7c] = "niè"; /* 湼 */
dict[0x6e7d] = "zī"; /* 湽 */
dict[0x6e7e] = "wān"; /* 湾 */
dict[0x6e7f] = "shī"; /* 湿 */
dict[0x6e80] = "mǎn"; /* 満 */
dict[0x6e81] = "yíng"; /* 溁 */
dict[0x6e82] = "là"; /* 溂 */
dict[0x6e83] = "kuì,huì"; /* 溃 */
dict[0x6e84] = "féng,hóng"; /* 溄 */
dict[0x6e85] = "jiàn,jiān"; /* 溅 */
dict[0x6e86] = "xù"; /* 溆 */
dict[0x6e87] = "lóu"; /* 溇 */
dict[0x6e88] = "wéi"; /* 溈 */
dict[0x6e89] = "gài"; /* 溉 */
dict[0x6e8a] = "bō"; /* 溊 */
dict[0x6e8b] = "yíng"; /* 溋 */
dict[0x6e8c] = "pō"; /* 溌 */
dict[0x6e8d] = "jìn"; /* 溍 */
dict[0x6e8e] = "yàn,guì"; /* 溎 */
dict[0x6e8f] = "táng"; /* 溏 */
dict[0x6e90] = "yuán"; /* 源 */
dict[0x6e91] = "suǒ"; /* 溑 */
dict[0x6e92] = "yuán"; /* 溒 */
dict[0x6e93] = "lián,liǎn,nián,xián,xiàn"; /* 溓 */
dict[0x6e94] = "yǎo"; /* 溔 */
dict[0x6e95] = "méng"; /* 溕 */
dict[0x6e96] = "zhǔn"; /* 準 */
dict[0x6e97] = "chéng"; /* 溗 */
dict[0x6e98] = "kè"; /* 溘 */
dict[0x6e99] = "tài"; /* 溙 */
dict[0x6e9a] = "dá,tǎ"; /* 溚 */
dict[0x6e9b] = "wā"; /* 溛 */
dict[0x6e9c] = "liū,liù"; /* 溜 */
dict[0x6e9d] = "gōu"; /* 溝 */
dict[0x6e9e] = "sāo"; /* 溞 */
dict[0x6e9f] = "míng"; /* 溟 */
dict[0x6ea0] = "zhà"; /* 溠 */
dict[0x6ea1] = "shí"; /* 溡 */
dict[0x6ea2] = "yì"; /* 溢 */
dict[0x6ea3] = "lùn"; /* 溣 */
dict[0x6ea4] = "mǎ"; /* 溤 */
dict[0x6ea5] = "pǔ"; /* 溥 */
dict[0x6ea6] = "wēi"; /* 溦 */
dict[0x6ea7] = "lì"; /* 溧 */
dict[0x6ea8] = "zāi"; /* 溨 */
dict[0x6ea9] = "wù"; /* 溩 */
dict[0x6eaa] = "xī"; /* 溪 */
dict[0x6eab] = "wēn"; /* 溫 */
dict[0x6eac] = "qiāng"; /* 溬 */
dict[0x6ead] = "zé"; /* 溭 */
dict[0x6eae] = "shī"; /* 溮 */
dict[0x6eaf] = "sù"; /* 溯 */
dict[0x6eb0] = "ái"; /* 溰 */
dict[0x6eb1] = "zhēn,qín"; /* 溱 */
dict[0x6eb2] = "sōu"; /* 溲 */
dict[0x6eb3] = "yún"; /* 溳 */
dict[0x6eb4] = "xiù"; /* 溴 */
dict[0x6eb5] = "yīn"; /* 溵 */
dict[0x6eb6] = "róng"; /* 溶 */
dict[0x6eb7] = "hùn"; /* 溷 */
dict[0x6eb8] = "sù"; /* 溸 */
dict[0x6eb9] = "suò"; /* 溹 */
dict[0x6eba] = "nì,niào"; /* 溺 */
dict[0x6ebb] = "tā"; /* 溻 */
dict[0x6ebc] = "shī"; /* 溼 */
dict[0x6ebd] = "rù"; /* 溽 */
dict[0x6ebe] = "āi"; /* 溾 */
dict[0x6ebf] = "pàn"; /* 溿 */
dict[0x6ec0] = "chù,xù"; /* 滀 */
dict[0x6ec1] = "chú"; /* 滁 */
dict[0x6ec2] = "pāng"; /* 滂 */
dict[0x6ec3] = "wěng,wēng"; /* 滃 */
dict[0x6ec4] = "cāng"; /* 滄 */
dict[0x6ec5] = "miè"; /* 滅 */
dict[0x6ec6] = "gé"; /* 滆 */
dict[0x6ec7] = "diān"; /* 滇 */
dict[0x6ec8] = "hào,xuè"; /* 滈 */
dict[0x6ec9] = "huàng"; /* 滉 */
dict[0x6eca] = "qì,xì,xiē"; /* 滊 */
dict[0x6ecb] = "zī"; /* 滋 */
dict[0x6ecc] = "dí"; /* 滌 */
dict[0x6ecd] = "zhì"; /* 滍 */
dict[0x6ece] = "xíng,yíng"; /* 滎 */
dict[0x6ecf] = "fǔ"; /* 滏 */
dict[0x6ed0] = "jié"; /* 滐 */
dict[0x6ed1] = "huá"; /* 滑 */
dict[0x6ed2] = "gē"; /* 滒 */
dict[0x6ed3] = "zǐ"; /* 滓 */
dict[0x6ed4] = "tāo"; /* 滔 */
dict[0x6ed5] = "téng"; /* 滕 */
dict[0x6ed6] = "suī"; /* 滖 */
dict[0x6ed7] = "bì"; /* 滗 */
dict[0x6ed8] = "jiào"; /* 滘 */
dict[0x6ed9] = "huì"; /* 滙 */
dict[0x6eda] = "gǔn"; /* 滚 */
dict[0x6edb] = "yín"; /* 滛 */
dict[0x6edc] = "zé,hào"; /* 滜 */
dict[0x6edd] = "lóng"; /* 滝 */
dict[0x6ede] = "zhì"; /* 滞 */
dict[0x6edf] = "yàn"; /* 滟 */
dict[0x6ee0] = "shè"; /* 滠 */
dict[0x6ee1] = "mǎn"; /* 满 */
dict[0x6ee2] = "yíng"; /* 滢 */
dict[0x6ee3] = "chún"; /* 滣 */
dict[0x6ee4] = "lǜ"; /* 滤 */
dict[0x6ee5] = "làn"; /* 滥 */
dict[0x6ee6] = "luán"; /* 滦 */
dict[0x6ee7] = "yáo"; /* 滧 */
dict[0x6ee8] = "bīn"; /* 滨 */
dict[0x6ee9] = "tān"; /* 滩 */
dict[0x6eea] = "yù"; /* 滪 */
dict[0x6eeb] = "xiǔ"; /* 滫 */
dict[0x6eec] = "hù"; /* 滬 */
dict[0x6eed] = "bì"; /* 滭 */
dict[0x6eee] = "biāo"; /* 滮 */
dict[0x6eef] = "zhì"; /* 滯 */
dict[0x6ef0] = "jiàng"; /* 滰 */
dict[0x6ef1] = "kòu"; /* 滱 */
dict[0x6ef2] = "shèn"; /* 滲 */
dict[0x6ef3] = "shāng"; /* 滳 */
dict[0x6ef4] = "dī"; /* 滴 */
dict[0x6ef5] = "mì"; /* 滵 */
dict[0x6ef6] = "áo"; /* 滶 */
dict[0x6ef7] = "lǔ"; /* 滷 */
dict[0x6ef8] = "hǔ,xǔ"; /* 滸 */
dict[0x6ef9] = "hū"; /* 滹 */
dict[0x6efa] = "yōu"; /* 滺 */
dict[0x6efb] = "chǎn"; /* 滻 */
dict[0x6efc] = "fàn"; /* 滼 */
dict[0x6efd] = "yōng"; /* 滽 */
dict[0x6efe] = "gǔn"; /* 滾 */
dict[0x6eff] = "mǎn"; /* 滿 */
dict[0x6f00] = "qǐng"; /* 漀 */
dict[0x6f01] = "yú"; /* 漁 */
dict[0x6f02] = "piāo,piǎo,piào"; /* 漂 */
dict[0x6f03] = "jì"; /* 漃 */
dict[0x6f04] = "yá"; /* 漄 */
dict[0x6f05] = "cháo"; /* 漅 */
dict[0x6f06] = "qī"; /* 漆 */
dict[0x6f07] = "xǐ"; /* 漇 */
dict[0x6f08] = "jì"; /* 漈 */
dict[0x6f09] = "lù"; /* 漉 */
dict[0x6f0a] = "lóu"; /* 漊 */
dict[0x6f0b] = "lóng"; /* 漋 */
dict[0x6f0c] = "jǐn"; /* 漌 */
dict[0x6f0d] = "guó"; /* 漍 */
dict[0x6f0e] = "cóng,sǒng"; /* 漎 */
dict[0x6f0f] = "lòu"; /* 漏 */
dict[0x6f10] = "zhí"; /* 漐 */
dict[0x6f11] = "gài"; /* 漑 */
dict[0x6f12] = "qiáng"; /* 漒 */
dict[0x6f13] = "lí"; /* 漓 */
dict[0x6f14] = "yǎn"; /* 演 */
dict[0x6f15] = "cáo"; /* 漕 */
dict[0x6f16] = "jiào"; /* 漖 */
dict[0x6f17] = "cōng"; /* 漗 */
dict[0x6f18] = "chún"; /* 漘 */
dict[0x6f19] = "tuán,zhuān"; /* 漙 */
dict[0x6f1a] = "òu,ōu"; /* 漚 */
dict[0x6f1b] = "téng"; /* 漛 */
dict[0x6f1c] = "yě"; /* 漜 */
dict[0x6f1d] = "xí"; /* 漝 */
dict[0x6f1e] = "mì"; /* 漞 */
dict[0x6f1f] = "táng"; /* 漟 */
dict[0x6f20] = "mò"; /* 漠 */
dict[0x6f21] = "shāng"; /* 漡 */
dict[0x6f22] = "hàn"; /* 漢 */
dict[0x6f23] = "lián"; /* 漣 */
dict[0x6f24] = "lǎn"; /* 漤 */
dict[0x6f25] = "wā"; /* 漥 */
dict[0x6f26] = "chí"; /* 漦 */
dict[0x6f27] = "gān"; /* 漧 */
dict[0x6f28] = "féng,péng"; /* 漨 */
dict[0x6f29] = "xuán"; /* 漩 */
dict[0x6f2a] = "yī"; /* 漪 */
dict[0x6f2b] = "màn"; /* 漫 */
dict[0x6f2c] = "zì"; /* 漬 */
dict[0x6f2d] = "mǎng"; /* 漭 */
dict[0x6f2e] = "kāng"; /* 漮 */
dict[0x6f2f] = "luò,tà"; /* 漯 */
dict[0x6f30] = "bēn,pēng"; /* 漰 */
dict[0x6f31] = "shù"; /* 漱 */
dict[0x6f32] = "zhǎng,zhàng"; /* 漲 */
dict[0x6f33] = "zhāng"; /* 漳 */
dict[0x6f34] = "chóng,zhuàng"; /* 漴 */
dict[0x6f35] = "xù"; /* 漵 */
dict[0x6f36] = "huàn"; /* 漶 */
dict[0x6f37] = "huǒ,huò,kuò"; /* 漷 */
dict[0x6f38] = "jiàn,jiān"; /* 漸 */
dict[0x6f39] = "yān"; /* 漹 */
dict[0x6f3a] = "shuǎng"; /* 漺 */
dict[0x6f3b] = "liáo,liú"; /* 漻 */
dict[0x6f3c] = "cuǐ,cuī"; /* 漼 */
dict[0x6f3d] = "tí"; /* 漽 */
dict[0x6f3e] = "yàng"; /* 漾 */
dict[0x6f3f] = "jiāng,jiàng"; /* 漿 */
dict[0x6f40] = "cóng,zǒng"; /* 潀 */
dict[0x6f41] = "yǐng"; /* 潁 */
dict[0x6f42] = "hóng"; /* 潂 */
dict[0x6f43] = "xiǔ"; /* 潃 */
dict[0x6f44] = "shù"; /* 潄 */
dict[0x6f45] = "guàn"; /* 潅 */
dict[0x6f46] = "yíng"; /* 潆 */
dict[0x6f47] = "xiāo"; /* 潇 */
dict[0x6f48] = "cóng,zōng"; /* 潈 */
dict[0x6f49] = "kūn"; /* 潉 */
dict[0x6f4a] = "xù"; /* 潊 */
dict[0x6f4b] = "liàn"; /* 潋 */
dict[0x6f4c] = "zhì"; /* 潌 */
dict[0x6f4d] = "wéi"; /* 潍 */
dict[0x6f4e] = "pì,piē"; /* 潎 */
dict[0x6f4f] = "yù"; /* 潏 */
dict[0x6f50] = "jiào,qiáo"; /* 潐 */
dict[0x6f51] = "pō"; /* 潑 */
dict[0x6f52] = "dàng,xiàng"; /* 潒 */
dict[0x6f53] = "huì"; /* 潓 */
dict[0x6f54] = "jié"; /* 潔 */
dict[0x6f55] = "wǔ"; /* 潕 */
dict[0x6f56] = "pá"; /* 潖 */
dict[0x6f57] = "jí"; /* 潗 */
dict[0x6f58] = "pān"; /* 潘 */
dict[0x6f59] = "wéi"; /* 潙 */
dict[0x6f5a] = "sù"; /* 潚 */
dict[0x6f5b] = "qián"; /* 潛 */
dict[0x6f5c] = "qián"; /* 潜 */
dict[0x6f5d] = "xī,yà"; /* 潝 */
dict[0x6f5e] = "lù"; /* 潞 */
dict[0x6f5f] = "xì"; /* 潟 */
dict[0x6f60] = "xùn"; /* 潠 */
dict[0x6f61] = "dùn"; /* 潡 */
dict[0x6f62] = "huáng,guāng"; /* 潢 */
dict[0x6f63] = "mǐn"; /* 潣 */
dict[0x6f64] = "rùn"; /* 潤 */
dict[0x6f65] = "sù"; /* 潥 */
dict[0x6f66] = "lǎo,lào,liáo"; /* 潦 */
dict[0x6f67] = "zhēn"; /* 潧 */
dict[0x6f68] = "cōng,zòng"; /* 潨 */
dict[0x6f69] = "yì"; /* 潩 */
dict[0x6f6a] = "zhí,zhì"; /* 潪 */
dict[0x6f6b] = "wān"; /* 潫 */
dict[0x6f6c] = "tān,shàn"; /* 潬 */
dict[0x6f6d] = "tán"; /* 潭 */
dict[0x6f6e] = "cháo"; /* 潮 */
dict[0x6f6f] = "xún"; /* 潯 */
dict[0x6f70] = "kuì,huì"; /* 潰 */
dict[0x6f71] = "yē"; /* 潱 */
dict[0x6f72] = "shào"; /* 潲 */
dict[0x6f73] = "tú,zhā"; /* 潳 */
dict[0x6f74] = "zhū"; /* 潴 */
dict[0x6f75] = "sàn,sǎ"; /* 潵 */
dict[0x6f76] = "hēi"; /* 潶 */
dict[0x6f77] = "bì"; /* 潷 */
dict[0x6f78] = "shān"; /* 潸 */
dict[0x6f79] = "chán"; /* 潹 */
dict[0x6f7a] = "chán"; /* 潺 */
dict[0x6f7b] = "shǔ"; /* 潻 */
dict[0x6f7c] = "tóng"; /* 潼 */
dict[0x6f7d] = "pū"; /* 潽 */
dict[0x6f7e] = "lín"; /* 潾 */
dict[0x6f7f] = "wéi"; /* 潿 */
dict[0x6f80] = "sè"; /* 澀 */
dict[0x6f81] = "sè"; /* 澁 */
dict[0x6f82] = "chéng"; /* 澂 */
dict[0x6f83] = "jiǒng"; /* 澃 */
dict[0x6f84] = "chéng,dèng"; /* 澄 */
dict[0x6f85] = "huà"; /* 澅 */
dict[0x6f86] = "jiāo"; /* 澆 */
dict[0x6f87] = "lào"; /* 澇 */
dict[0x6f88] = "chè"; /* 澈 */
dict[0x6f89] = "gǎn"; /* 澉 */
dict[0x6f8a] = "cūn,cún"; /* 澊 */
dict[0x6f8b] = "jǐng"; /* 澋 */
dict[0x6f8c] = "sī"; /* 澌 */
dict[0x6f8d] = "shù,zhù"; /* 澍 */
dict[0x6f8e] = "péng"; /* 澎 */
dict[0x6f8f] = "hán"; /* 澏 */
dict[0x6f90] = "yún"; /* 澐 */
dict[0x6f91] = "liū,liù"; /* 澑 */
dict[0x6f92] = "hòng,gǒng"; /* 澒 */
dict[0x6f93] = "fú"; /* 澓 */
dict[0x6f94] = "hào"; /* 澔 */
dict[0x6f95] = "hé"; /* 澕 */
dict[0x6f96] = "xián"; /* 澖 */
dict[0x6f97] = "jiàn"; /* 澗 */
dict[0x6f98] = "shān"; /* 澘 */
dict[0x6f99] = "xì"; /* 澙 */
dict[0x6f9a] = "ào,yù"; /* 澚 */
dict[0x6f9b] = "lǔ"; /* 澛 */
dict[0x6f9c] = "lán"; /* 澜 */
dict[0x6f9d] = "nìng"; /* 澝 */
dict[0x6f9e] = "yú"; /* 澞 */
dict[0x6f9f] = "lǐn"; /* 澟 */
dict[0x6fa0] = "miǎn,shéng"; /* 澠 */
dict[0x6fa1] = "zǎo"; /* 澡 */
dict[0x6fa2] = "dāng"; /* 澢 */
dict[0x6fa3] = "huàn"; /* 澣 */
dict[0x6fa4] = "zé,shì"; /* 澤 */
dict[0x6fa5] = "xiè"; /* 澥 */
dict[0x6fa6] = "yù"; /* 澦 */
dict[0x6fa7] = "lǐ"; /* 澧 */
dict[0x6fa8] = "shì"; /* 澨 */
dict[0x6fa9] = "xué"; /* 澩 */
dict[0x6faa] = "líng"; /* 澪 */
dict[0x6fab] = "wàn,màn"; /* 澫 */
dict[0x6fac] = "zī"; /* 澬 */
dict[0x6fad] = "yōng,yǒng"; /* 澭 */
dict[0x6fae] = "kuài,huì"; /* 澮 */
dict[0x6faf] = "càn"; /* 澯 */
dict[0x6fb0] = "liàn"; /* 澰 */
dict[0x6fb1] = "diàn"; /* 澱 */
dict[0x6fb2] = "yè"; /* 澲 */
dict[0x6fb3] = "ào"; /* 澳 */
dict[0x6fb4] = "huán"; /* 澴 */
dict[0x6fb5] = "zhēn"; /* 澵 */
dict[0x6fb6] = "chán"; /* 澶 */
dict[0x6fb7] = "màn"; /* 澷 */
dict[0x6fb8] = "gǎn"; /* 澸 */
dict[0x6fb9] = "dàn,tán"; /* 澹 */
dict[0x6fba] = "yì"; /* 澺 */
dict[0x6fbb] = "suì"; /* 澻 */
dict[0x6fbc] = "pì"; /* 澼 */
dict[0x6fbd] = "jù"; /* 澽 */
dict[0x6fbe] = "tà"; /* 澾 */
dict[0x6fbf] = "qín"; /* 澿 */
dict[0x6fc0] = "jī"; /* 激 */
dict[0x6fc1] = "zhuó"; /* 濁 */
dict[0x6fc2] = "lián"; /* 濂 */
dict[0x6fc3] = "nóng"; /* 濃 */
dict[0x6fc4] = "guō,wō"; /* 濄 */
dict[0x6fc5] = "jìn"; /* 濅 */
dict[0x6fc6] = "fén,pēn"; /* 濆 */
dict[0x6fc7] = "sè"; /* 濇 */
dict[0x6fc8] = "jí,shà"; /* 濈 */
dict[0x6fc9] = "suī"; /* 濉 */
dict[0x6fca] = "huì,huò"; /* 濊 */
dict[0x6fcb] = "chǔ"; /* 濋 */
dict[0x6fcc] = "tà"; /* 濌 */
dict[0x6fcd] = "sōng"; /* 濍 */
dict[0x6fce] = "dǐng,tìng"; /* 濎 */
dict[0x6fcf] = "sè"; /* 濏 */
dict[0x6fd0] = "zhǔ"; /* 濐 */
dict[0x6fd1] = "lài"; /* 濑 */
dict[0x6fd2] = "bīn"; /* 濒 */
dict[0x6fd3] = "lián"; /* 濓 */
dict[0x6fd4] = "mǐ,nǐ"; /* 濔 */
dict[0x6fd5] = "shī"; /* 濕 */
dict[0x6fd6] = "shù"; /* 濖 */
dict[0x6fd7] = "mì"; /* 濗 */
dict[0x6fd8] = "nìng"; /* 濘 */
dict[0x6fd9] = "yíng"; /* 濙 */
dict[0x6fda] = "yíng"; /* 濚 */
dict[0x6fdb] = "méng"; /* 濛 */
dict[0x6fdc] = "jìn"; /* 濜 */
dict[0x6fdd] = "qí"; /* 濝 */
dict[0x6fde] = "bì,pì"; /* 濞 */
dict[0x6fdf] = "jì,jǐ"; /* 濟 */
dict[0x6fe0] = "háo"; /* 濠 */
dict[0x6fe1] = "rú"; /* 濡 */
dict[0x6fe2] = "cuì,zuǐ"; /* 濢 */
dict[0x6fe3] = "wò"; /* 濣 */
dict[0x6fe4] = "tāo"; /* 濤 */
dict[0x6fe5] = "yǐn"; /* 濥 */
dict[0x6fe6] = "yīn"; /* 濦 */
dict[0x6fe7] = "duì"; /* 濧 */
dict[0x6fe8] = "cí"; /* 濨 */
dict[0x6fe9] = "huò,hù"; /* 濩 */
dict[0x6fea] = "qìng"; /* 濪 */
dict[0x6feb] = "làn"; /* 濫 */
dict[0x6fec] = "jùn,xùn"; /* 濬 */
dict[0x6fed] = "ǎi,kài,kè"; /* 濭 */
dict[0x6fee] = "pú"; /* 濮 */
dict[0x6fef] = "zhuó,zhào"; /* 濯 */
dict[0x6ff0] = "wéi"; /* 濰 */
dict[0x6ff1] = "bīn"; /* 濱 */
dict[0x6ff2] = "gǔ"; /* 濲 */
dict[0x6ff3] = "qián"; /* 濳 */
dict[0x6ff4] = "yíng"; /* 濴 */
dict[0x6ff5] = "bīn"; /* 濵 */
dict[0x6ff6] = "kuò"; /* 濶 */
dict[0x6ff7] = "fèi"; /* 濷 */
dict[0x6ff8] = "cāng"; /* 濸 */
dict[0x6ff9] = "mè"; /* 濹 */
dict[0x6ffa] = "jiàn,jiān"; /* 濺 */
dict[0x6ffb] = "wěi,duì"; /* 濻 */
dict[0x6ffc] = "luò,pō"; /* 濼 */
dict[0x6ffd] = "zàn,cuán"; /* 濽 */
dict[0x6ffe] = "lǜ"; /* 濾 */
dict[0x6fff] = "lì"; /* 濿 */
dict[0x7000] = "yōu"; /* 瀀 */
dict[0x7001] = "yǎng,yàng"; /* 瀁 */
dict[0x7002] = "lǔ"; /* 瀂 */
dict[0x7003] = "sì"; /* 瀃 */
dict[0x7004] = "zhì"; /* 瀄 */
dict[0x7005] = "yíng"; /* 瀅 */
dict[0x7006] = "dú,dòu"; /* 瀆 */
dict[0x7007] = "wǎng,wāng"; /* 瀇 */
dict[0x7008] = "huī"; /* 瀈 */
dict[0x7009] = "xiè"; /* 瀉 */
dict[0x700a] = "pán"; /* 瀊 */
dict[0x700b] = "shěn"; /* 瀋 */
dict[0x700c] = "biāo"; /* 瀌 */
dict[0x700d] = "chán"; /* 瀍 */
dict[0x700e] = "miè,mò"; /* 瀎 */
dict[0x700f] = "liú"; /* 瀏 */
dict[0x7010] = "jiān"; /* 瀐 */
dict[0x7011] = "pù,bào"; /* 瀑 */
dict[0x7012] = "sè"; /* 瀒 */
dict[0x7013] = "chéng,dèng"; /* 瀓 */
dict[0x7014] = "gǔ"; /* 瀔 */
dict[0x7015] = "bīn"; /* 瀕 */
dict[0x7016] = "huò"; /* 瀖 */
dict[0x7017] = "xiàn"; /* 瀗 */
dict[0x7018] = "lú"; /* 瀘 */
dict[0x7019] = "qìn"; /* 瀙 */
dict[0x701a] = "hàn"; /* 瀚 */
dict[0x701b] = "yíng"; /* 瀛 */
dict[0x701c] = "róng"; /* 瀜 */
dict[0x701d] = "lì"; /* 瀝 */
dict[0x701e] = "jìng"; /* 瀞 */
dict[0x701f] = "xiāo"; /* 瀟 */
dict[0x7020] = "yíng"; /* 瀠 */
dict[0x7021] = "suǐ"; /* 瀡 */
dict[0x7022] = "wěi,duì"; /* 瀢 */
dict[0x7023] = "xiè"; /* 瀣 */
dict[0x7024] = "huái,wāi"; /* 瀤 */
dict[0x7025] = "xuè"; /* 瀥 */
dict[0x7026] = "zhū"; /* 瀦 */
dict[0x7027] = "lóng,shuāng"; /* 瀧 */
dict[0x7028] = "lài"; /* 瀨 */
dict[0x7029] = "duì"; /* 瀩 */
dict[0x702a] = "fàn"; /* 瀪 */
dict[0x702b] = "hú"; /* 瀫 */
dict[0x702c] = "lài"; /* 瀬 */
dict[0x702d] = "shū"; /* 瀭 */
dict[0x702e] = "lián"; /* 瀮 */
dict[0x702f] = "yíng"; /* 瀯 */
dict[0x7030] = "mí"; /* 瀰 */
dict[0x7031] = "jì"; /* 瀱 */
dict[0x7032] = "liàn"; /* 瀲 */
dict[0x7033] = "jiàn,zùn"; /* 瀳 */
dict[0x7034] = "yīng,yǐng,yìng"; /* 瀴 */
dict[0x7035] = "fèn"; /* 瀵 */
dict[0x7036] = "lín"; /* 瀶 */
dict[0x7037] = "yì"; /* 瀷 */
dict[0x7038] = "jiān"; /* 瀸 */
dict[0x7039] = "yuè"; /* 瀹 */
dict[0x703a] = "chán"; /* 瀺 */
dict[0x703b] = "dài"; /* 瀻 */
dict[0x703c] = "ráng,nǎng"; /* 瀼 */
dict[0x703d] = "jiǎn"; /* 瀽 */
dict[0x703e] = "lán"; /* 瀾 */
dict[0x703f] = "fán"; /* 瀿 */
dict[0x7040] = "shuàng"; /* 灀 */
dict[0x7041] = "yuān"; /* 灁 */
dict[0x7042] = "zhuó,jiào,zé"; /* 灂 */
dict[0x7043] = "fēng"; /* 灃 */
dict[0x7044] = "shè"; /* 灄 */
dict[0x7045] = "lěi"; /* 灅 */
dict[0x7046] = "lán"; /* 灆 */
dict[0x7047] = "cóng"; /* 灇 */
dict[0x7048] = "qú"; /* 灈 */
dict[0x7049] = "yōng"; /* 灉 */
dict[0x704a] = "qián"; /* 灊 */
dict[0x704b] = "fǎ"; /* 灋 */
dict[0x704c] = "guàn"; /* 灌 */
dict[0x704d] = "jué"; /* 灍 */
dict[0x704e] = "yàn"; /* 灎 */
dict[0x704f] = "hào"; /* 灏 */
dict[0x7050] = "yíng"; /* 灐 */
dict[0x7051] = "sǎ"; /* 灑 */
dict[0x7052] = "zàn,cuán"; /* 灒 */
dict[0x7053] = "luán,luàn"; /* 灓 */
dict[0x7054] = "yàn"; /* 灔 */
dict[0x7055] = "lí"; /* 灕 */
dict[0x7056] = "mǐ"; /* 灖 */
dict[0x7057] = "shàn"; /* 灗 */
dict[0x7058] = "tān"; /* 灘 */
dict[0x7059] = "dǎng,tǎng"; /* 灙 */
dict[0x705a] = "jiǎo"; /* 灚 */
dict[0x705b] = "chǎn"; /* 灛 */
dict[0x705c] = "yíng"; /* 灜 */
dict[0x705d] = "hào"; /* 灝 */
dict[0x705e] = "bà"; /* 灞 */
dict[0x705f] = "zhú"; /* 灟 */
dict[0x7060] = "lǎn"; /* 灠 */
dict[0x7061] = "lán"; /* 灡 */
dict[0x7062] = "nǎng"; /* 灢 */
dict[0x7063] = "wān"; /* 灣 */
dict[0x7064] = "luán"; /* 灤 */
dict[0x7065] = "xún,quán,quàn"; /* 灥 */
dict[0x7066] = "xiǎn"; /* 灦 */
dict[0x7067] = "yàn"; /* 灧 */
dict[0x7068] = "gàn"; /* 灨 */
dict[0x7069] = "yàn"; /* 灩 */
dict[0x706a] = "yù"; /* 灪 */
dict[0x706b] = "huǒ"; /* 火 */
dict[0x706c] = "huǒ,biāo"; /* 灬 */
dict[0x706d] = "miè"; /* 灭 */
dict[0x706e] = "guāng"; /* 灮 */
dict[0x706f] = "dēng"; /* 灯 */
dict[0x7070] = "huī"; /* 灰 */
dict[0x7071] = "xiāo"; /* 灱 */
dict[0x7072] = "xiāo"; /* 灲 */
dict[0x7073] = "huī"; /* 灳 */
dict[0x7074] = "hōng"; /* 灴 */
dict[0x7075] = "líng"; /* 灵 */
dict[0x7076] = "zào"; /* 灶 */
dict[0x7077] = "zhuàn"; /* 灷 */
dict[0x7078] = "jiǔ"; /* 灸 */
dict[0x7079] = "zhà,yù"; /* 灹 */
dict[0x707a] = "xiè"; /* 灺 */
dict[0x707b] = "chì"; /* 灻 */
dict[0x707c] = "zhuó"; /* 灼 */
dict[0x707d] = "zāi"; /* 災 */
dict[0x707e] = "zāi"; /* 灾 */
dict[0x707f] = "càn"; /* 灿 */
dict[0x7080] = "yáng"; /* 炀 */
dict[0x7081] = "qì"; /* 炁 */
dict[0x7082] = "zhōng"; /* 炂 */
dict[0x7083] = "fén,bèn"; /* 炃 */
dict[0x7084] = "niǔ"; /* 炄 */
dict[0x7085] = "jiǒng,guì"; /* 炅 */
dict[0x7086] = "wén"; /* 炆 */
dict[0x7087] = "pū"; /* 炇 */
dict[0x7088] = "yì"; /* 炈 */
dict[0x7089] = "lú"; /* 炉 */
dict[0x708a] = "chuī"; /* 炊 */
dict[0x708b] = "pī"; /* 炋 */
dict[0x708c] = "kài"; /* 炌 */
dict[0x708d] = "pàn"; /* 炍 */
dict[0x708e] = "yán"; /* 炎 */
dict[0x708f] = "yán"; /* 炏 */
dict[0x7090] = "pàng,fēng"; /* 炐 */
dict[0x7091] = "mù"; /* 炑 */
dict[0x7092] = "chǎo"; /* 炒 */
dict[0x7093] = "liào"; /* 炓 */
dict[0x7094] = "quē"; /* 炔 */
dict[0x7095] = "kàng"; /* 炕 */
dict[0x7096] = "dùn"; /* 炖 */
dict[0x7097] = "guāng"; /* 炗 */
dict[0x7098] = "xìn"; /* 炘 */
dict[0x7099] = "zhì"; /* 炙 */
dict[0x709a] = "guāng"; /* 炚 */
dict[0x709b] = "guāng"; /* 炛 */
dict[0x709c] = "wěi"; /* 炜 */
dict[0x709d] = "qiàng"; /* 炝 */
dict[0x709e] = "biān"; /* 炞 */
dict[0x709f] = "dá"; /* 炟 */
dict[0x70a0] = "xiá"; /* 炠 */
dict[0x70a1] = "zhēng"; /* 炡 */
dict[0x70a2] = "zhú"; /* 炢 */
dict[0x70a3] = "kě"; /* 炣 */
dict[0x70a4] = "zhào,zhāo"; /* 炤 */
dict[0x70a5] = "fú"; /* 炥 */
dict[0x70a6] = "bá"; /* 炦 */
dict[0x70a7] = "xiè"; /* 炧 */
dict[0x70a8] = "xiè"; /* 炨 */
dict[0x70a9] = "lìng"; /* 炩 */
dict[0x70aa] = "zhuō,chù"; /* 炪 */
dict[0x70ab] = "xuàn"; /* 炫 */
dict[0x70ac] = "jù"; /* 炬 */
dict[0x70ad] = "tàn"; /* 炭 */
dict[0x70ae] = "páo,bāo,pào"; /* 炮 */
dict[0x70af] = "jiǒng"; /* 炯 */
dict[0x70b0] = "páo,fǒu"; /* 炰 */
dict[0x70b1] = "tái"; /* 炱 */
dict[0x70b2] = "tái"; /* 炲 */
dict[0x70b3] = "bǐng"; /* 炳 */
dict[0x70b4] = "yǎng"; /* 炴 */
dict[0x70b5] = "tōng"; /* 炵 */
dict[0x70b6] = "shǎn,qián,shān"; /* 炶 */
dict[0x70b7] = "zhù"; /* 炷 */
dict[0x70b8] = "zhà,zhá"; /* 炸 */
dict[0x70b9] = "diǎn"; /* 点 */
dict[0x70ba] = "wéi,wèi"; /* 為 */
dict[0x70bb] = "shí"; /* 炻 */
dict[0x70bc] = "liàn"; /* 炼 */
dict[0x70bd] = "chì"; /* 炽 */
dict[0x70be] = "huǎng"; /* 炾 */
dict[0x70bf] = "zhōu"; /* 炿 */
dict[0x70c0] = "hū"; /* 烀 */
dict[0x70c1] = "shuò"; /* 烁 */
dict[0x70c2] = "làn"; /* 烂 */
dict[0x70c3] = "tīng"; /* 烃 */
dict[0x70c4] = "jiǎo,yào"; /* 烄 */
dict[0x70c5] = "xù"; /* 烅 */
dict[0x70c6] = "héng"; /* 烆 */
dict[0x70c7] = "quǎn"; /* 烇 */
dict[0x70c8] = "liè"; /* 烈 */
dict[0x70c9] = "huàn"; /* 烉 */
dict[0x70ca] = "yáng,yàng"; /* 烊 */
dict[0x70cb] = "xiāo"; /* 烋 */
dict[0x70cc] = "xiū"; /* 烌 */
dict[0x70cd] = "xiǎn"; /* 烍 */
dict[0x70ce] = "yín"; /* 烎 */
dict[0x70cf] = "wū"; /* 烏 */
dict[0x70d0] = "zhōu"; /* 烐 */
dict[0x70d1] = "yáo"; /* 烑 */
dict[0x70d2] = "shì"; /* 烒 */
dict[0x70d3] = "wēi"; /* 烓 */
dict[0x70d4] = "tóng,dòng"; /* 烔 */
dict[0x70d5] = "miè"; /* 烕 */
dict[0x70d6] = "zāi"; /* 烖 */
dict[0x70d7] = "kài"; /* 烗 */
dict[0x70d8] = "hōng"; /* 烘 */
dict[0x70d9] = "lào,luò"; /* 烙 */
dict[0x70da] = "xiá"; /* 烚 */
dict[0x70db] = "zhú"; /* 烛 */
dict[0x70dc] = "xuǎn"; /* 烜 */
dict[0x70dd] = "zhēng"; /* 烝 */
dict[0x70de] = "pò"; /* 烞 */
dict[0x70df] = "yān"; /* 烟 */
dict[0x70e0] = "huí,huǐ"; /* 烠 */
dict[0x70e1] = "guāng"; /* 烡 */
dict[0x70e2] = "chè"; /* 烢 */
dict[0x70e3] = "huī"; /* 烣 */
dict[0x70e4] = "kǎo"; /* 烤 */
dict[0x70e5] = "jù"; /* 烥 */
dict[0x70e6] = "fán"; /* 烦 */
dict[0x70e7] = "shāo"; /* 烧 */
dict[0x70e8] = "yè"; /* 烨 */
dict[0x70e9] = "huì"; /* 烩 */
dict[0x70eb] = "tàng"; /* 烫 */
dict[0x70ec] = "jìn"; /* 烬 */
dict[0x70ed] = "rè"; /* 热 */
dict[0x70ee] = "liè"; /* 烮 */
dict[0x70ef] = "xī"; /* 烯 */
dict[0x70f0] = "fú,páo"; /* 烰 */
dict[0x70f1] = "jiǒng"; /* 烱 */
dict[0x70f2] = "xiè,chè"; /* 烲 */
dict[0x70f3] = "pǔ"; /* 烳 */
dict[0x70f4] = "tīng"; /* 烴 */
dict[0x70f5] = "zhuó"; /* 烵 */
dict[0x70f6] = "tǐng"; /* 烶 */
dict[0x70f7] = "wán"; /* 烷 */
dict[0x70f8] = "hǎi"; /* 烸 */
dict[0x70f9] = "pēng"; /* 烹 */
dict[0x70fa] = "lǎng"; /* 烺 */
dict[0x70fb] = "yàn"; /* 烻 */
dict[0x70fc] = "xù"; /* 烼 */
dict[0x70fd] = "fēng"; /* 烽 */
dict[0x70fe] = "chì"; /* 烾 */
dict[0x70ff] = "róng"; /* 烿 */
dict[0x7100] = "hú"; /* 焀 */
dict[0x7101] = "xī"; /* 焁 */
dict[0x7102] = "shū"; /* 焂 */
dict[0x7103] = "hè"; /* 焃 */
dict[0x7104] = "xūn,hūn"; /* 焄 */
dict[0x7105] = "kù"; /* 焅 */
dict[0x7106] = "juān,yè"; /* 焆 */
dict[0x7107] = "xiāo"; /* 焇 */
dict[0x7108] = "xī"; /* 焈 */
dict[0x7109] = "yān"; /* 焉 */
dict[0x710a] = "hàn"; /* 焊 */
dict[0x710b] = "zhuàng"; /* 焋 */
dict[0x710c] = "qū,jùn"; /* 焌 */
dict[0x710d] = "dì"; /* 焍 */
dict[0x710e] = "xiè,chè"; /* 焎 */
dict[0x710f] = "jí,qì"; /* 焏 */
dict[0x7110] = "wù"; /* 焐 */
dict[0x7111] = "yān"; /* 焑 */
dict[0x7112] = "lǚ"; /* 焒 */
dict[0x7113] = "hán"; /* 焓 */
dict[0x7114] = "yàn"; /* 焔 */
dict[0x7115] = "huàn"; /* 焕 */
dict[0x7116] = "mèn"; /* 焖 */
dict[0x7117] = "jú"; /* 焗 */
dict[0x7118] = "dào"; /* 焘 */
dict[0x7119] = "bèi"; /* 焙 */
dict[0x711a] = "fén"; /* 焚 */
dict[0x711b] = "lìn"; /* 焛 */
dict[0x711c] = "kūn"; /* 焜 */
dict[0x711d] = "hùn"; /* 焝 */
dict[0x711e] = "tūn"; /* 焞 */
dict[0x711f] = "xī"; /* 焟 */
dict[0x7120] = "cuì"; /* 焠 */
dict[0x7121] = "wú"; /* 無 */
dict[0x7122] = "hōng"; /* 焢 */
dict[0x7123] = "chǎo,jù"; /* 焣 */
dict[0x7124] = "fǔ"; /* 焤 */
dict[0x7125] = "wò,ài"; /* 焥 */
dict[0x7126] = "jiāo"; /* 焦 */
dict[0x7127] = "zǒng,cōng"; /* 焧 */
dict[0x7128] = "fèng"; /* 焨 */
dict[0x7129] = "píng"; /* 焩 */
dict[0x712a] = "qióng"; /* 焪 */
dict[0x712b] = "ruò"; /* 焫 */
dict[0x712c] = "xī,yì"; /* 焬 */
dict[0x712d] = "qióng"; /* 焭 */
dict[0x712e] = "xìn"; /* 焮 */
dict[0x712f] = "zhuō,chāo"; /* 焯 */
dict[0x7130] = "yàn"; /* 焰 */
dict[0x7131] = "yàn"; /* 焱 */
dict[0x7132] = "yì"; /* 焲 */
dict[0x7133] = "jué"; /* 焳 */
dict[0x7134] = "yù"; /* 焴 */
dict[0x7135] = "gàng"; /* 焵 */
dict[0x7136] = "rán"; /* 然 */
dict[0x7137] = "pí"; /* 焷 */
dict[0x7138] = "xiǒng,yīng"; /* 焸 */
dict[0x7139] = "gàng"; /* 焹 */
dict[0x713a] = "shēng"; /* 焺 */
dict[0x713b] = "chàng"; /* 焻 */
dict[0x713c] = "shāo"; /* 焼 */
dict[0x713d] = "xiǒng,yīng"; /* 焽 */
dict[0x713e] = "niǎn"; /* 焾 */
dict[0x713f] = "gēng"; /* 焿 */
dict[0x7140] = "qū"; /* 煀 */
dict[0x7141] = "chén"; /* 煁 */
dict[0x7142] = "hè"; /* 煂 */
dict[0x7143] = "kuǐ"; /* 煃 */
dict[0x7144] = "zhǒng"; /* 煄 */
dict[0x7145] = "duàn"; /* 煅 */
dict[0x7146] = "xiā"; /* 煆 */
dict[0x7147] = "huī,yùn,xūn"; /* 煇 */
dict[0x7148] = "fèng"; /* 煈 */
dict[0x7149] = "liàn"; /* 煉 */
dict[0x714a] = "xuān"; /* 煊 */
dict[0x714b] = "xīng"; /* 煋 */
dict[0x714c] = "huáng"; /* 煌 */
dict[0x714d] = "jiǎo,qiāo"; /* 煍 */
dict[0x714e] = "jiān"; /* 煎 */
dict[0x714f] = "bì"; /* 煏 */
dict[0x7150] = "yīng"; /* 煐 */
dict[0x7151] = "zhǔ"; /* 煑 */
dict[0x7152] = "wěi"; /* 煒 */
dict[0x7153] = "tuān"; /* 煓 */
dict[0x7154] = "shǎn,qián,shān"; /* 煔 */
dict[0x7155] = "xī,yí"; /* 煕 */
dict[0x7156] = "nuǎn"; /* 煖 */
dict[0x7157] = "nuǎn"; /* 煗 */
dict[0x7158] = "chán"; /* 煘 */
dict[0x7159] = "yān"; /* 煙 */
dict[0x715a] = "jiǒng"; /* 煚 */
dict[0x715b] = "jiǒng"; /* 煛 */
dict[0x715c] = "yù"; /* 煜 */
dict[0x715d] = "mèi"; /* 煝 */
dict[0x715e] = "shā,shà"; /* 煞 */
dict[0x715f] = "wèi"; /* 煟 */
dict[0x7160] = "yè,zhá"; /* 煠 */
dict[0x7161] = "jìn"; /* 煡 */
dict[0x7162] = "qióng"; /* 煢 */
dict[0x7163] = "róu"; /* 煣 */
dict[0x7164] = "méi"; /* 煤 */
dict[0x7165] = "huàn"; /* 煥 */
dict[0x7166] = "xù"; /* 煦 */
dict[0x7167] = "zhào"; /* 照 */
dict[0x7168] = "wēi"; /* 煨 */
dict[0x7169] = "fán"; /* 煩 */
dict[0x716a] = "qiú"; /* 煪 */
dict[0x716b] = "suì"; /* 煫 */
dict[0x716c] = "yáng,yàng"; /* 煬 */
dict[0x716d] = "liè"; /* 煭 */
dict[0x716e] = "zhǔ"; /* 煮 */
dict[0x716f] = "jiē"; /* 煯 */
dict[0x7170] = "zào"; /* 煰 */
dict[0x7171] = "guā"; /* 煱 */
dict[0x7172] = "bāo"; /* 煲 */
dict[0x7173] = "hú"; /* 煳 */
dict[0x7174] = "yūn,yǔn"; /* 煴 */
dict[0x7175] = "nǎn"; /* 煵 */
dict[0x7176] = "shì"; /* 煶 */
dict[0x7177] = "huǒ"; /* 煷 */
dict[0x7178] = "biān"; /* 煸 */
dict[0x7179] = "gòu"; /* 煹 */
dict[0x717a] = "tuì"; /* 煺 */
dict[0x717b] = "táng"; /* 煻 */
dict[0x717c] = "chǎo"; /* 煼 */
dict[0x717d] = "shān"; /* 煽 */
dict[0x717e] = "ēn,yūn"; /* 煾 */
dict[0x717f] = "bó"; /* 煿 */
dict[0x7180] = "huǎng"; /* 熀 */
dict[0x7181] = "xié"; /* 熁 */
dict[0x7182] = "xì"; /* 熂 */
dict[0x7183] = "wù"; /* 熃 */
dict[0x7184] = "xī"; /* 熄 */
dict[0x7185] = "yūn,yǔn"; /* 熅 */
dict[0x7186] = "hé"; /* 熆 */
dict[0x7187] = "hè,xiāo"; /* 熇 */
dict[0x7188] = "xī"; /* 熈 */
dict[0x7189] = "yún"; /* 熉 */
dict[0x718a] = "xióng"; /* 熊 */
dict[0x718b] = "xióng"; /* 熋 */
dict[0x718c] = "shǎn"; /* 熌 */
dict[0x718d] = "qióng"; /* 熍 */
dict[0x718e] = "yào"; /* 熎 */
dict[0x718f] = "xūn,xùn"; /* 熏 */
dict[0x7190] = "mì"; /* 熐 */
dict[0x7191] = "lián"; /* 熑 */
dict[0x7192] = "yíng"; /* 熒 */
dict[0x7193] = "wǔ"; /* 熓 */
dict[0x7194] = "róng"; /* 熔 */
dict[0x7195] = "gòng"; /* 熕 */
dict[0x7196] = "yàn"; /* 熖 */
dict[0x7197] = "qiàng"; /* 熗 */
dict[0x7198] = "liū"; /* 熘 */
dict[0x7199] = "xī"; /* 熙 */
dict[0x719a] = "bì"; /* 熚 */
dict[0x719b] = "biāo"; /* 熛 */
dict[0x719c] = "cōng,zǒng"; /* 熜 */
dict[0x719d] = "lù,āo"; /* 熝 */
dict[0x719e] = "jiān"; /* 熞 */
dict[0x719f] = "shú"; /* 熟 */
dict[0x71a0] = "yì"; /* 熠 */
dict[0x71a1] = "lóu"; /* 熡 */
dict[0x71a2] = "péng,fēng"; /* 熢 */
dict[0x71a3] = "suī,cuǐ"; /* 熣 */
dict[0x71a4] = "yì"; /* 熤 */
dict[0x71a5] = "tēng"; /* 熥 */
dict[0x71a6] = "jué"; /* 熦 */
dict[0x71a7] = "zōng"; /* 熧 */
dict[0x71a8] = "yùn,yù"; /* 熨 */
dict[0x71a9] = "hù"; /* 熩 */
dict[0x71aa] = "yí"; /* 熪 */
dict[0x71ab] = "zhì"; /* 熫 */
dict[0x71ac] = "āo,áo"; /* 熬 */
dict[0x71ad] = "wèi"; /* 熭 */
dict[0x71ae] = "liǔ"; /* 熮 */
dict[0x71af] = "hàn,rǎn"; /* 熯 */
dict[0x71b0] = "ōu,ǒu"; /* 熰 */
dict[0x71b1] = "rè"; /* 熱 */
dict[0x71b2] = "jiǒng"; /* 熲 */
dict[0x71b3] = "màn"; /* 熳 */
dict[0x71b4] = "kūn"; /* 熴 */
dict[0x71b5] = "shāng"; /* 熵 */
dict[0x71b6] = "cuàn"; /* 熶 */
dict[0x71b7] = "zèng"; /* 熷 */
dict[0x71b8] = "jiān"; /* 熸 */
dict[0x71b9] = "xī"; /* 熹 */
dict[0x71ba] = "xī"; /* 熺 */
dict[0x71bb] = "xī"; /* 熻 */
dict[0x71bc] = "yì"; /* 熼 */
dict[0x71bd] = "xiào"; /* 熽 */
dict[0x71be] = "chì"; /* 熾 */
dict[0x71bf] = "huáng,huǎng"; /* 熿 */
dict[0x71c0] = "chǎn,dǎn,chàn"; /* 燀 */
dict[0x71c1] = "yè"; /* 燁 */
dict[0x71c2] = "tán"; /* 燂 */
dict[0x71c3] = "rán"; /* 燃 */
dict[0x71c4] = "yàn"; /* 燄 */
dict[0x71c5] = "xún"; /* 燅 */
dict[0x71c6] = "qiāo"; /* 燆 */
dict[0x71c7] = "jùn"; /* 燇 */
dict[0x71c8] = "dēng"; /* 燈 */
dict[0x71c9] = "dùn"; /* 燉 */
dict[0x71ca] = "shēn"; /* 燊 */
dict[0x71cb] = "jiāo,qiáo,jué,zhuó"; /* 燋 */
dict[0x71cc] = "fén"; /* 燌 */
dict[0x71cd] = "sī"; /* 燍 */
dict[0x71ce] = "liáo,liǎo"; /* 燎 */
dict[0x71cf] = "yù"; /* 燏 */
dict[0x71d0] = "lín"; /* 燐 */
dict[0x71d1] = "tóng,dòng"; /* 燑 */
dict[0x71d2] = "shāo"; /* 燒 */
dict[0x71d3] = "fén"; /* 燓 */
dict[0x71d4] = "fán"; /* 燔 */
dict[0x71d5] = "yàn,yān"; /* 燕 */
dict[0x71d6] = "xún"; /* 燖 */
dict[0x71d7] = "làn"; /* 燗 */
dict[0x71d8] = "měi"; /* 燘 */
dict[0x71d9] = "tàng"; /* 燙 */
dict[0x71da] = "yì"; /* 燚 */
dict[0x71db] = "jiǒng"; /* 燛 */
dict[0x71dc] = "mèn"; /* 燜 */
dict[0x71dd] = "zhǔ"; /* 燝 */
dict[0x71de] = "jiǎo"; /* 燞 */
dict[0x71df] = "yíng"; /* 營 */
dict[0x71e0] = "yù"; /* 燠 */
dict[0x71e1] = "yì"; /* 燡 */
dict[0x71e2] = "xué"; /* 燢 */
dict[0x71e3] = "lán"; /* 燣 */
dict[0x71e4] = "tài,liè"; /* 燤 */
dict[0x71e5] = "zào"; /* 燥 */
dict[0x71e6] = "càn"; /* 燦 */
dict[0x71e7] = "suì"; /* 燧 */
dict[0x71e8] = "xī"; /* 燨 */
dict[0x71e9] = "què"; /* 燩 */
dict[0x71ea] = "zǒng"; /* 燪 */
dict[0x71eb] = "lián"; /* 燫 */
dict[0x71ec] = "huǐ"; /* 燬 */
dict[0x71ed] = "zhú"; /* 燭 */
dict[0x71ee] = "xiè"; /* 燮 */
dict[0x71ef] = "líng"; /* 燯 */
dict[0x71f0] = "wēi"; /* 燰 */
dict[0x71f1] = "yì"; /* 燱 */
dict[0x71f2] = "xié"; /* 燲 */
dict[0x71f3] = "zhào"; /* 燳 */
dict[0x71f4] = "huì"; /* 燴 */
dict[0x71f5] = "dá"; /* 燵 */
dict[0x71f6] = "nóng"; /* 燶 */
dict[0x71f7] = "lán"; /* 燷 */
dict[0x71f8] = "xū"; /* 燸 */
dict[0x71f9] = "xiǎn"; /* 燹 */
dict[0x71fa] = "hè"; /* 燺 */
dict[0x71fb] = "xūn"; /* 燻 */
dict[0x71fc] = "jìn"; /* 燼 */
dict[0x71fd] = "chóu"; /* 燽 */
dict[0x71fe] = "dào"; /* 燾 */
dict[0x71ff] = "yào"; /* 燿 */
dict[0x7200] = "hè"; /* 爀 */
dict[0x7201] = "làn"; /* 爁 */
dict[0x7202] = "biāo"; /* 爂 */
dict[0x7203] = "róng,yíng"; /* 爃 */
dict[0x7204] = "lì,liè"; /* 爄 */
dict[0x7205] = "mò"; /* 爅 */
dict[0x7206] = "bào"; /* 爆 */
dict[0x7207] = "ruò"; /* 爇 */
dict[0x7208] = "lǜ"; /* 爈 */
dict[0x7209] = "là,liè"; /* 爉 */
dict[0x720a] = "āo"; /* 爊 */
dict[0x720b] = "xūn,xùn"; /* 爋 */
dict[0x720c] = "kuàng,huǎng"; /* 爌 */
dict[0x720d] = "shuò"; /* 爍 */
dict[0x720e] = "liáo,liǎo"; /* 爎 */
dict[0x720f] = "lì"; /* 爏 */
dict[0x7210] = "lú"; /* 爐 */
dict[0x7211] = "jué"; /* 爑 */
dict[0x7212] = "liáo,liǎo"; /* 爒 */
dict[0x7213] = "yàn,xún"; /* 爓 */
dict[0x7214] = "xī"; /* 爔 */
dict[0x7215] = "xiè"; /* 爕 */
dict[0x7216] = "lóng"; /* 爖 */
dict[0x7217] = "yè"; /* 爗 */
dict[0x7218] = "cān"; /* 爘 */
dict[0x7219] = "rǎng"; /* 爙 */
dict[0x721a] = "yuè"; /* 爚 */
dict[0x721b] = "làn"; /* 爛 */
dict[0x721c] = "cóng"; /* 爜 */
dict[0x721d] = "jué"; /* 爝 */
dict[0x721e] = "chóng"; /* 爞 */
dict[0x721f] = "guàn"; /* 爟 */
dict[0x7220] = "qú"; /* 爠 */
dict[0x7221] = "chè"; /* 爡 */
dict[0x7222] = "mí"; /* 爢 */
dict[0x7223] = "tǎng"; /* 爣 */
dict[0x7224] = "làn"; /* 爤 */
dict[0x7225] = "zhú"; /* 爥 */
dict[0x7226] = "lǎn,làn"; /* 爦 */
dict[0x7227] = "líng"; /* 爧 */
dict[0x7228] = "cuàn"; /* 爨 */
dict[0x7229] = "yù"; /* 爩 */
dict[0x722a] = "zhǎo,zhuǎ"; /* 爪 */
dict[0x722b] = "zhǎo,zhuǎ"; /* 爫 */
dict[0x722c] = "pá"; /* 爬 */
dict[0x722d] = "zhēng"; /* 爭 */
dict[0x722e] = "páo"; /* 爮 */
dict[0x722f] = "chēng,chèn"; /* 爯 */
dict[0x7230] = "yuán"; /* 爰 */
dict[0x7231] = "ài"; /* 爱 */
dict[0x7232] = "wéi,wèi"; /* 爲 */
dict[0x7233] = "han"; /* 爳 */
dict[0x7234] = "jué"; /* 爴 */
dict[0x7235] = "jué"; /* 爵 */
dict[0x7236] = "fù,fǔ"; /* 父 */
dict[0x7237] = "yé"; /* 爷 */
dict[0x7238] = "bà"; /* 爸 */
dict[0x7239] = "diē"; /* 爹 */
dict[0x723a] = "yé"; /* 爺 */
dict[0x723b] = "yáo"; /* 爻 */
dict[0x723c] = "zǔ"; /* 爼 */
dict[0x723d] = "shuǎng"; /* 爽 */
dict[0x723e] = "ěr"; /* 爾 */
dict[0x723f] = "pán"; /* 爿 */
dict[0x7240] = "chuáng"; /* 牀 */
dict[0x7241] = "kē"; /* 牁 */
dict[0x7242] = "zāng"; /* 牂 */
dict[0x7243] = "dié"; /* 牃 */
dict[0x7244] = "qiāng"; /* 牄 */
dict[0x7245] = "yōng"; /* 牅 */
dict[0x7246] = "qiáng"; /* 牆 */
dict[0x7247] = "piàn,piān"; /* 片 */
dict[0x7248] = "bǎn"; /* 版 */
dict[0x7249] = "pàn"; /* 牉 */
dict[0x724a] = "cháo"; /* 牊 */
dict[0x724b] = "jiān"; /* 牋 */
dict[0x724c] = "pái"; /* 牌 */
dict[0x724d] = "dú"; /* 牍 */
dict[0x724e] = "chuāng"; /* 牎 */
dict[0x724f] = "yú"; /* 牏 */
dict[0x7250] = "zhá"; /* 牐 */
dict[0x7251] = "biān,miàn"; /* 牑 */
dict[0x7252] = "dié"; /* 牒 */
dict[0x7253] = "bǎng"; /* 牓 */
dict[0x7254] = "bó"; /* 牔 */
dict[0x7255] = "chuāng"; /* 牕 */
dict[0x7256] = "yǒu"; /* 牖 */
dict[0x7257] = "yǒu,yōng"; /* 牗 */
dict[0x7258] = "dú"; /* 牘 */
dict[0x7259] = "yá"; /* 牙 */
dict[0x725a] = "chēng,chèng"; /* 牚 */
dict[0x725b] = "niú"; /* 牛 */
dict[0x725c] = "niú"; /* 牜 */
dict[0x725d] = "pìn"; /* 牝 */
dict[0x725e] = "jiū,lè"; /* 牞 */
dict[0x725f] = "móu,mù"; /* 牟 */
dict[0x7260] = "tā"; /* 牠 */
dict[0x7261] = "mǔ"; /* 牡 */
dict[0x7262] = "láo"; /* 牢 */
dict[0x7263] = "rèn"; /* 牣 */
dict[0x7264] = "māng"; /* 牤 */
dict[0x7265] = "fāng"; /* 牥 */
dict[0x7266] = "máo"; /* 牦 */
dict[0x7267] = "mù"; /* 牧 */
dict[0x7268] = "gāng"; /* 牨 */
dict[0x7269] = "wù"; /* 物 */
dict[0x726a] = "yàn"; /* 牪 */
dict[0x726b] = "gē,qiú"; /* 牫 */
dict[0x726c] = "bèi"; /* 牬 */
dict[0x726d] = "sì"; /* 牭 */
dict[0x726e] = "jiàn"; /* 牮 */
dict[0x726f] = "gǔ"; /* 牯 */
dict[0x7270] = "yòu,chōu"; /* 牰 */
dict[0x7271] = "kē"; /* 牱 */
dict[0x7272] = "shēng"; /* 牲 */
dict[0x7273] = "mǔ"; /* 牳 */
dict[0x7274] = "dǐ"; /* 牴 */
dict[0x7275] = "qiān"; /* 牵 */
dict[0x7276] = "quàn"; /* 牶 */
dict[0x7277] = "quán"; /* 牷 */
dict[0x7278] = "zì"; /* 牸 */
dict[0x7279] = "tè"; /* 特 */
dict[0x727a] = "xī"; /* 牺 */
dict[0x727b] = "máng"; /* 牻 */
dict[0x727c] = "kēng"; /* 牼 */
dict[0x727d] = "qiān"; /* 牽 */
dict[0x727e] = "wǔ"; /* 牾 */
dict[0x727f] = "gù"; /* 牿 */
dict[0x7280] = "xī"; /* 犀 */
dict[0x7281] = "lí"; /* 犁 */
dict[0x7282] = "lí"; /* 犂 */
dict[0x7283] = "pǒu"; /* 犃 */
dict[0x7284] = "jī"; /* 犄 */
dict[0x7285] = "gāng"; /* 犅 */
dict[0x7286] = "zhí,tè"; /* 犆 */
dict[0x7287] = "bēn"; /* 犇 */
dict[0x7288] = "quán"; /* 犈 */
dict[0x7289] = "chún"; /* 犉 */
dict[0x728a] = "dú"; /* 犊 */
dict[0x728b] = "jù"; /* 犋 */
dict[0x728c] = "jiā"; /* 犌 */
dict[0x728d] = "jiān,qián"; /* 犍 */
dict[0x728e] = "fēng"; /* 犎 */
dict[0x728f] = "piān"; /* 犏 */
dict[0x7290] = "kē"; /* 犐 */
dict[0x7291] = "jú"; /* 犑 */
dict[0x7292] = "kào"; /* 犒 */
dict[0x7293] = "chú"; /* 犓 */
dict[0x7294] = "xì"; /* 犔 */
dict[0x7295] = "bèi"; /* 犕 */
dict[0x7296] = "luò"; /* 犖 */
dict[0x7297] = "jiè"; /* 犗 */
dict[0x7298] = "má"; /* 犘 */
dict[0x7299] = "sān"; /* 犙 */
dict[0x729a] = "wèi"; /* 犚 */
dict[0x729b] = "máo,lí"; /* 犛 */
dict[0x729c] = "dūn"; /* 犜 */
dict[0x729d] = "tóng"; /* 犝 */
dict[0x729e] = "qiáo"; /* 犞 */
dict[0x729f] = "jiàng"; /* 犟 */
dict[0x72a0] = "xī"; /* 犠 */
dict[0x72a1] = "lì"; /* 犡 */
dict[0x72a2] = "dú"; /* 犢 */
dict[0x72a3] = "liè"; /* 犣 */
dict[0x72a4] = "pái"; /* 犤 */
dict[0x72a5] = "piāo"; /* 犥 */
dict[0x72a6] = "bào"; /* 犦 */
dict[0x72a7] = "xī"; /* 犧 */
dict[0x72a8] = "chōu"; /* 犨 */
dict[0x72a9] = "wéi"; /* 犩 */
dict[0x72aa] = "kuí"; /* 犪 */
dict[0x72ab] = "chōu"; /* 犫 */
dict[0x72ac] = "quǎn"; /* 犬 */
dict[0x72ad] = "quǎn"; /* 犭 */
dict[0x72ae] = "quǎn,bá"; /* 犮 */
dict[0x72af] = "fàn"; /* 犯 */
dict[0x72b0] = "qiú"; /* 犰 */
dict[0x72b1] = "jǐ"; /* 犱 */
dict[0x72b2] = "chái"; /* 犲 */
dict[0x72b3] = "zhuó,bào"; /* 犳 */
dict[0x72b4] = "hān,àn"; /* 犴 */
dict[0x72b5] = "gē"; /* 犵 */
dict[0x72b6] = "zhuàng"; /* 状 */
dict[0x72b7] = "guǎng"; /* 犷 */
dict[0x72b8] = "mǎ"; /* 犸 */
dict[0x72b9] = "yóu"; /* 犹 */
dict[0x72ba] = "kàng,gǎng"; /* 犺 */
dict[0x72bb] = "pèi,fèi"; /* 犻 */
dict[0x72bc] = "hǒu"; /* 犼 */
dict[0x72bd] = "yà"; /* 犽 */
dict[0x72be] = "yín"; /* 犾 */
dict[0x72bf] = "huān,fān"; /* 犿 */
dict[0x72c0] = "zhuàng"; /* 狀 */
dict[0x72c1] = "yǔn"; /* 狁 */
dict[0x72c2] = "kuáng"; /* 狂 */
dict[0x72c3] = "niǔ"; /* 狃 */
dict[0x72c4] = "dí"; /* 狄 */
dict[0x72c5] = "kuáng"; /* 狅 */
dict[0x72c6] = "zhòng"; /* 狆 */
dict[0x72c7] = "mù"; /* 狇 */
dict[0x72c8] = "bèi"; /* 狈 */
dict[0x72c9] = "pī"; /* 狉 */
dict[0x72ca] = "jú"; /* 狊 */
dict[0x72cb] = "yí,quán,chí"; /* 狋 */
dict[0x72cc] = "shēng,xīng"; /* 狌 */
dict[0x72cd] = "páo"; /* 狍 */
dict[0x72ce] = "xiá"; /* 狎 */
dict[0x72cf] = "tuó,yí"; /* 狏 */
dict[0x72d0] = "hú"; /* 狐 */
dict[0x72d1] = "líng"; /* 狑 */
dict[0x72d2] = "fèi"; /* 狒 */
dict[0x72d3] = "pī"; /* 狓 */
dict[0x72d4] = "nǐ"; /* 狔 */
dict[0x72d5] = "yǎo"; /* 狕 */
dict[0x72d6] = "yòu"; /* 狖 */
dict[0x72d7] = "gǒu"; /* 狗 */
dict[0x72d8] = "xuè"; /* 狘 */
dict[0x72d9] = "jū"; /* 狙 */
dict[0x72da] = "dàn"; /* 狚 */
dict[0x72db] = "bó"; /* 狛 */
dict[0x72dc] = "kǔ"; /* 狜 */
dict[0x72dd] = "xiǎn"; /* 狝 */
dict[0x72de] = "níng"; /* 狞 */
dict[0x72df] = "huán,huān"; /* 狟 */
dict[0x72e0] = "hěn"; /* 狠 */
dict[0x72e1] = "jiǎo"; /* 狡 */
dict[0x72e2] = "hé,mò"; /* 狢 */
dict[0x72e3] = "zhào"; /* 狣 */
dict[0x72e4] = "jié"; /* 狤 */
dict[0x72e5] = "xùn"; /* 狥 */
dict[0x72e6] = "shān"; /* 狦 */
dict[0x72e7] = "tà,shì"; /* 狧 */
dict[0x72e8] = "róng"; /* 狨 */
dict[0x72e9] = "shòu"; /* 狩 */
dict[0x72ea] = "tóng,dòng"; /* 狪 */
dict[0x72eb] = "lǎo"; /* 狫 */
dict[0x72ec] = "dú"; /* 独 */
dict[0x72ed] = "xiá"; /* 狭 */
dict[0x72ee] = "shī"; /* 狮 */
dict[0x72ef] = "kuài"; /* 狯 */
dict[0x72f0] = "zhēng"; /* 狰 */
dict[0x72f1] = "yù"; /* 狱 */
dict[0x72f2] = "sūn"; /* 狲 */
dict[0x72f3] = "yú"; /* 狳 */
dict[0x72f4] = "bì"; /* 狴 */
dict[0x72f5] = "máng,dòu"; /* 狵 */
dict[0x72f6] = "xī,shǐ"; /* 狶 */
dict[0x72f7] = "juàn"; /* 狷 */
dict[0x72f8] = "lí"; /* 狸 */
dict[0x72f9] = "xiá"; /* 狹 */
dict[0x72fa] = "yín"; /* 狺 */
dict[0x72fb] = "suān"; /* 狻 */
dict[0x72fc] = "láng"; /* 狼 */
dict[0x72fd] = "bèi"; /* 狽 */
dict[0x72fe] = "zhì"; /* 狾 */
dict[0x72ff] = "yán"; /* 狿 */
dict[0x7300] = "shā"; /* 猀 */
dict[0x7301] = "lì"; /* 猁 */
dict[0x7302] = "hàn"; /* 猂 */
dict[0x7303] = "xiǎn"; /* 猃 */
dict[0x7304] = "jīng"; /* 猄 */
dict[0x7305] = "pái"; /* 猅 */
dict[0x7306] = "fēi"; /* 猆 */
dict[0x7307] = "xiāo"; /* 猇 */
dict[0x7308] = "bài,pí"; /* 猈 */
dict[0x7309] = "qí"; /* 猉 */
dict[0x730a] = "ní"; /* 猊 */
dict[0x730b] = "biāo"; /* 猋 */
dict[0x730c] = "yìn"; /* 猌 */
dict[0x730d] = "lái"; /* 猍 */
dict[0x730e] = "liè"; /* 猎 */
dict[0x730f] = "jiān,yàn"; /* 猏 */
dict[0x7310] = "qiāng"; /* 猐 */
dict[0x7311] = "kūn"; /* 猑 */
dict[0x7312] = "yàn"; /* 猒 */
dict[0x7313] = "guō"; /* 猓 */
dict[0x7314] = "zòng"; /* 猔 */
dict[0x7315] = "mí"; /* 猕 */
dict[0x7316] = "chāng"; /* 猖 */
dict[0x7317] = "yī,yǐ"; /* 猗 */
dict[0x7318] = "zhì"; /* 猘 */
dict[0x7319] = "zhēng"; /* 猙 */
dict[0x731a] = "yá,wèi"; /* 猚 */
dict[0x731b] = "měng"; /* 猛 */
dict[0x731c] = "cāi"; /* 猜 */
dict[0x731d] = "cù"; /* 猝 */
dict[0x731e] = "shē"; /* 猞 */
dict[0x731f] = "liè"; /* 猟 */
dict[0x7321] = "luó"; /* 猡 */
dict[0x7322] = "hú"; /* 猢 */
dict[0x7323] = "zōng"; /* 猣 */
dict[0x7324] = "guì"; /* 猤 */
dict[0x7325] = "wěi"; /* 猥 */
dict[0x7326] = "fēng"; /* 猦 */
dict[0x7327] = "wō"; /* 猧 */
dict[0x7328] = "yuán"; /* 猨 */
dict[0x7329] = "xīng"; /* 猩 */
dict[0x732a] = "zhū"; /* 猪 */
dict[0x732b] = "māo,máo"; /* 猫 */
dict[0x732c] = "wèi"; /* 猬 */
dict[0x732d] = "chuàn,chuān"; /* 猭 */
dict[0x732e] = "xiàn"; /* 献 */
dict[0x732f] = "tuān,tuàn"; /* 猯 */
dict[0x7330] = "yà,jiá,qiè"; /* 猰 */
dict[0x7331] = "náo"; /* 猱 */
dict[0x7332] = "xiē,hè,gé,hài"; /* 猲 */
dict[0x7333] = "jiā"; /* 猳 */
dict[0x7334] = "hóu"; /* 猴 */
dict[0x7335] = "biān,piàn"; /* 猵 */
dict[0x7336] = "yóu"; /* 猶 */
dict[0x7337] = "yóu"; /* 猷 */
dict[0x7338] = "méi"; /* 猸 */
dict[0x7339] = "chá"; /* 猹 */
dict[0x733a] = "yáo"; /* 猺 */
dict[0x733b] = "sūn"; /* 猻 */
dict[0x733c] = "bó,pò"; /* 猼 */
dict[0x733d] = "míng"; /* 猽 */
dict[0x733e] = "huá"; /* 猾 */
dict[0x733f] = "yuán"; /* 猿 */
dict[0x7340] = "sōu"; /* 獀 */
dict[0x7341] = "mǎ"; /* 獁 */
dict[0x7342] = "huán"; /* 獂 */
dict[0x7343] = "dāi"; /* 獃 */
dict[0x7344] = "yù"; /* 獄 */
dict[0x7345] = "shī"; /* 獅 */
dict[0x7346] = "háo"; /* 獆 */
dict[0x7347] = "qiāng"; /* 獇 */
dict[0x7348] = "yì"; /* 獈 */
dict[0x7349] = "zhēn"; /* 獉 */
dict[0x734a] = "cāng"; /* 獊 */
dict[0x734b] = "háo,gāo"; /* 獋 */
dict[0x734c] = "màn"; /* 獌 */
dict[0x734d] = "jìng"; /* 獍 */
dict[0x734e] = "jiǎng"; /* 獎 */
dict[0x734f] = "mò"; /* 獏 */
dict[0x7350] = "zhāng"; /* 獐 */
dict[0x7351] = "chán"; /* 獑 */
dict[0x7352] = "áo"; /* 獒 */
dict[0x7353] = "áo"; /* 獓 */
dict[0x7354] = "háo"; /* 獔 */
dict[0x7355] = "suǒ"; /* 獕 */
dict[0x7356] = "fén,fèn"; /* 獖 */
dict[0x7357] = "jué"; /* 獗 */
dict[0x7358] = "bì"; /* 獘 */
dict[0x7359] = "bì"; /* 獙 */
dict[0x735a] = "huáng"; /* 獚 */
dict[0x735b] = "pú"; /* 獛 */
dict[0x735c] = "lín,lìn"; /* 獜 */
dict[0x735d] = "xù"; /* 獝 */
dict[0x735e] = "tóng"; /* 獞 */
dict[0x735f] = "yào,xiāo"; /* 獟 */
dict[0x7360] = "liáo"; /* 獠 */
dict[0x7361] = "shuò,xī"; /* 獡 */
dict[0x7362] = "xiāo"; /* 獢 */
dict[0x7363] = "shòu"; /* 獣 */
dict[0x7364] = "dūn"; /* 獤 */
dict[0x7365] = "jiào"; /* 獥 */
dict[0x7366] = "gé,liè,xiē"; /* 獦 */
dict[0x7367] = "juàn"; /* 獧 */
dict[0x7368] = "dú"; /* 獨 */
dict[0x7369] = "huì"; /* 獩 */
dict[0x736a] = "kuài"; /* 獪 */
dict[0x736b] = "xiǎn"; /* 獫 */
dict[0x736c] = "xiè"; /* 獬 */
dict[0x736d] = "tǎ"; /* 獭 */
dict[0x736e] = "xiǎn"; /* 獮 */
dict[0x736f] = "xūn"; /* 獯 */
dict[0x7370] = "níng"; /* 獰 */
dict[0x7371] = "biān,piàn"; /* 獱 */
dict[0x7372] = "huò"; /* 獲 */
dict[0x7373] = "nòu,rú"; /* 獳 */
dict[0x7374] = "méng"; /* 獴 */
dict[0x7375] = "liè"; /* 獵 */
dict[0x7376] = "náo,nǎo,yōu"; /* 獶 */
dict[0x7377] = "guǎng"; /* 獷 */
dict[0x7378] = "shòu"; /* 獸 */
dict[0x7379] = "lú"; /* 獹 */
dict[0x737a] = "tǎ"; /* 獺 */
dict[0x737b] = "xiàn"; /* 獻 */
dict[0x737c] = "mí"; /* 獼 */
dict[0x737d] = "ráng"; /* 獽 */
dict[0x737e] = "huān"; /* 獾 */
dict[0x737f] = "náo,yōu"; /* 獿 */
dict[0x7380] = "luó"; /* 玀 */
dict[0x7381] = "xiǎn"; /* 玁 */
dict[0x7382] = "qí"; /* 玂 */
dict[0x7383] = "jué"; /* 玃 */
dict[0x7384] = "xuán"; /* 玄 */
dict[0x7385] = "miào"; /* 玅 */
dict[0x7386] = "zī"; /* 玆 */
dict[0x7387] = "shuài,lǜ"; /* 率 */
dict[0x7388] = "lú"; /* 玈 */
dict[0x7389] = "yù"; /* 玉 */
dict[0x738a] = "sù"; /* 玊 */
dict[0x738b] = "wáng,wàng"; /* 王 */
dict[0x738c] = "qiú"; /* 玌 */
dict[0x738d] = "gǎ"; /* 玍 */
dict[0x738e] = "dīng"; /* 玎 */
dict[0x738f] = "lè"; /* 玏 */
dict[0x7390] = "bā"; /* 玐 */
dict[0x7391] = "jī"; /* 玑 */
dict[0x7392] = "hóng"; /* 玒 */
dict[0x7393] = "dì"; /* 玓 */
dict[0x7394] = "chuàn"; /* 玔 */
dict[0x7395] = "gān"; /* 玕 */
dict[0x7396] = "jiǔ"; /* 玖 */
dict[0x7397] = "yú"; /* 玗 */
dict[0x7398] = "qǐ"; /* 玘 */
dict[0x7399] = "yú"; /* 玙 */
dict[0x739a] = "chàng,yáng"; /* 玚 */
dict[0x739b] = "mǎ"; /* 玛 */
dict[0x739c] = "hóng"; /* 玜 */
dict[0x739d] = "wǔ"; /* 玝 */
dict[0x739e] = "fū"; /* 玞 */
dict[0x739f] = "mín,wén"; /* 玟 */
dict[0x73a0] = "jiè"; /* 玠 */
dict[0x73a1] = "yà"; /* 玡 */
dict[0x73a2] = "bīn,fēn"; /* 玢 */
dict[0x73a3] = "biàn"; /* 玣 */
dict[0x73a4] = "bàng"; /* 玤 */
dict[0x73a5] = "yuè"; /* 玥 */
dict[0x73a6] = "jué"; /* 玦 */
dict[0x73a7] = "mén,yǔn"; /* 玧 */
dict[0x73a8] = "jué"; /* 玨 */
dict[0x73a9] = "wán"; /* 玩 */
dict[0x73aa] = "jiān,qián"; /* 玪 */
dict[0x73ab] = "méi"; /* 玫 */
dict[0x73ac] = "dǎn"; /* 玬 */
dict[0x73ad] = "pín"; /* 玭 */
dict[0x73ae] = "wěi"; /* 玮 */
dict[0x73af] = "huán"; /* 环 */
dict[0x73b0] = "xiàn"; /* 现 */
dict[0x73b1] = "qiāng,cāng"; /* 玱 */
dict[0x73b2] = "líng"; /* 玲 */
dict[0x73b3] = "dài"; /* 玳 */
dict[0x73b4] = "yì"; /* 玴 */
dict[0x73b5] = "án,gān"; /* 玵 */
dict[0x73b6] = "píng"; /* 玶 */
dict[0x73b7] = "diàn"; /* 玷 */
dict[0x73b8] = "fú"; /* 玸 */
dict[0x73b9] = "xuán,xián"; /* 玹 */
dict[0x73ba] = "xǐ"; /* 玺 */
dict[0x73bb] = "bō"; /* 玻 */
dict[0x73bc] = "cī,cǐ"; /* 玼 */
dict[0x73bd] = "gǒu"; /* 玽 */
dict[0x73be] = "jiǎ"; /* 玾 */
dict[0x73bf] = "sháo"; /* 玿 */
dict[0x73c0] = "pò"; /* 珀 */
dict[0x73c1] = "cí"; /* 珁 */
dict[0x73c2] = "kē"; /* 珂 */
dict[0x73c3] = "rǎn"; /* 珃 */
dict[0x73c4] = "shēng"; /* 珄 */
dict[0x73c5] = "shēn"; /* 珅 */
dict[0x73c6] = "yí,tāi"; /* 珆 */
dict[0x73c7] = "zǔ,jù"; /* 珇 */
dict[0x73c8] = "jiā"; /* 珈 */
dict[0x73c9] = "mín"; /* 珉 */
dict[0x73ca] = "shān"; /* 珊 */
dict[0x73cb] = "liǔ"; /* 珋 */
dict[0x73cc] = "bì"; /* 珌 */
dict[0x73cd] = "zhēn"; /* 珍 */
dict[0x73ce] = "zhēn"; /* 珎 */
dict[0x73cf] = "jué"; /* 珏 */
dict[0x73d0] = "fà"; /* 珐 */
dict[0x73d1] = "lóng"; /* 珑 */
dict[0x73d2] = "jīn"; /* 珒 */
dict[0x73d3] = "jiào"; /* 珓 */
dict[0x73d4] = "jiàn"; /* 珔 */
dict[0x73d5] = "lì"; /* 珕 */
dict[0x73d6] = "guāng"; /* 珖 */
dict[0x73d7] = "xiān"; /* 珗 */
dict[0x73d8] = "zhōu"; /* 珘 */
dict[0x73d9] = "gǒng"; /* 珙 */
dict[0x73da] = "yān"; /* 珚 */
dict[0x73db] = "xiù"; /* 珛 */
dict[0x73dc] = "yáng"; /* 珜 */
dict[0x73dd] = "xǔ"; /* 珝 */
dict[0x73de] = "luò"; /* 珞 */
dict[0x73df] = "sù"; /* 珟 */
dict[0x73e0] = "zhū"; /* 珠 */
dict[0x73e1] = "qín"; /* 珡 */
dict[0x73e2] = "yín,kèn"; /* 珢 */
dict[0x73e3] = "xún"; /* 珣 */
dict[0x73e4] = "bǎo"; /* 珤 */
dict[0x73e5] = "ěr"; /* 珥 */
dict[0x73e6] = "xiàng"; /* 珦 */
dict[0x73e7] = "yáo"; /* 珧 */
dict[0x73e8] = "xiá"; /* 珨 */
dict[0x73e9] = "héng"; /* 珩 */
dict[0x73ea] = "guī"; /* 珪 */
dict[0x73eb] = "chōng"; /* 珫 */
dict[0x73ec] = "xù"; /* 珬 */
dict[0x73ed] = "bān"; /* 班 */
dict[0x73ee] = "pèi"; /* 珮 */
dict[0x73ef] = "lǎo"; /* 珯 */
dict[0x73f0] = "dāng"; /* 珰 */
dict[0x73f1] = "yīng"; /* 珱 */
dict[0x73f2] = "hún,huī"; /* 珲 */
dict[0x73f3] = "wén"; /* 珳 */
dict[0x73f4] = "é"; /* 珴 */
dict[0x73f5] = "chéng"; /* 珵 */
dict[0x73f6] = "dì,tí"; /* 珶 */
dict[0x73f7] = "wǔ"; /* 珷 */
dict[0x73f8] = "wú"; /* 珸 */
dict[0x73f9] = "chéng"; /* 珹 */
dict[0x73fa] = "jùn"; /* 珺 */
dict[0x73fb] = "méi"; /* 珻 */
dict[0x73fc] = "bèi"; /* 珼 */
dict[0x73fd] = "tǐng"; /* 珽 */
dict[0x73fe] = "xiàn"; /* 現 */
dict[0x73ff] = "chù"; /* 珿 */
dict[0x7400] = "hán"; /* 琀 */
dict[0x7401] = "xuán,qióng"; /* 琁 */
dict[0x7402] = "yán"; /* 琂 */
dict[0x7403] = "qiú"; /* 球 */
dict[0x7404] = "xuàn"; /* 琄 */
dict[0x7405] = "láng"; /* 琅 */
dict[0x7406] = "lǐ"; /* 理 */
dict[0x7407] = "xiù"; /* 琇 */
dict[0x7408] = "fú,fū"; /* 琈 */
dict[0x7409] = "liú"; /* 琉 */
dict[0x740a] = "yá"; /* 琊 */
dict[0x740b] = "xī"; /* 琋 */
dict[0x740c] = "líng"; /* 琌 */
dict[0x740d] = "lí"; /* 琍 */
dict[0x740e] = "jīn"; /* 琎 */
dict[0x740f] = "liǎn"; /* 琏 */
dict[0x7410] = "suǒ"; /* 琐 */
dict[0x7411] = "suǒ"; /* 琑 */
dict[0x7412] = "fēng"; /* 琒 */
dict[0x7413] = "wán"; /* 琓 */
dict[0x7414] = "diàn"; /* 琔 */
dict[0x7415] = "pín,bǐng"; /* 琕 */
dict[0x7416] = "zhǎn"; /* 琖 */
dict[0x7417] = "cuì,sè"; /* 琗 */
dict[0x7418] = "mín"; /* 琘 */
dict[0x7419] = "yù"; /* 琙 */
dict[0x741a] = "jū"; /* 琚 */
dict[0x741b] = "chēn"; /* 琛 */
dict[0x741c] = "lái"; /* 琜 */
dict[0x741d] = "mín"; /* 琝 */
dict[0x741e] = "shèng"; /* 琞 */
dict[0x741f] = "wéi,yù"; /* 琟 */
dict[0x7420] = "tiǎn,tiàn"; /* 琠 */
dict[0x7421] = "shū"; /* 琡 */
dict[0x7422] = "zhuó,zuó"; /* 琢 */
dict[0x7423] = "běng,pěi"; /* 琣 */
dict[0x7424] = "chēng"; /* 琤 */
dict[0x7425] = "hǔ"; /* 琥 */
dict[0x7426] = "qí"; /* 琦 */
dict[0x7427] = "è"; /* 琧 */
dict[0x7428] = "kūn"; /* 琨 */
dict[0x7429] = "chāng"; /* 琩 */
dict[0x742a] = "qí"; /* 琪 */
dict[0x742b] = "běng"; /* 琫 */
dict[0x742c] = "wǎn"; /* 琬 */
dict[0x742d] = "lù"; /* 琭 */
dict[0x742e] = "cóng"; /* 琮 */
dict[0x742f] = "guǎn"; /* 琯 */
dict[0x7430] = "yǎn"; /* 琰 */
dict[0x7431] = "diāo"; /* 琱 */
dict[0x7432] = "bèi"; /* 琲 */
dict[0x7433] = "lín"; /* 琳 */
dict[0x7434] = "qín"; /* 琴 */
dict[0x7435] = "pí"; /* 琵 */
dict[0x7436] = "pá"; /* 琶 */
dict[0x7437] = "què"; /* 琷 */
dict[0x7438] = "zhuó"; /* 琸 */
dict[0x7439] = "qín"; /* 琹 */
dict[0x743a] = "fà"; /* 琺 */
dict[0x743b] = "jīn"; /* 琻 */
dict[0x743c] = "qióng"; /* 琼 */
dict[0x743d] = "dǔ"; /* 琽 */
dict[0x743e] = "jiè"; /* 琾 */
dict[0x743f] = "hún,huī"; /* 琿 */
dict[0x7440] = "yǔ"; /* 瑀 */
dict[0x7441] = "mào"; /* 瑁 */
dict[0x7442] = "méi"; /* 瑂 */
dict[0x7443] = "chūn"; /* 瑃 */
dict[0x7444] = "xuān"; /* 瑄 */
dict[0x7445] = "tí"; /* 瑅 */
dict[0x7446] = "xīng"; /* 瑆 */
dict[0x7447] = "dài"; /* 瑇 */
dict[0x7448] = "róu"; /* 瑈 */
dict[0x7449] = "mín"; /* 瑉 */
dict[0x744a] = "jiān"; /* 瑊 */
dict[0x744b] = "wěi"; /* 瑋 */
dict[0x744c] = "ruǎn"; /* 瑌 */
dict[0x744d] = "huàn"; /* 瑍 */
dict[0x744e] = "xié,jiē"; /* 瑎 */
dict[0x744f] = "chuān"; /* 瑏 */
dict[0x7450] = "jiǎn"; /* 瑐 */
dict[0x7451] = "zhuàn"; /* 瑑 */
dict[0x7452] = "chàng,yáng"; /* 瑒 */
dict[0x7453] = "liàn"; /* 瑓 */
dict[0x7454] = "quán"; /* 瑔 */
dict[0x7455] = "xiá"; /* 瑕 */
dict[0x7456] = "duàn"; /* 瑖 */
dict[0x7457] = "yuàn"; /* 瑗 */
dict[0x7458] = "yé"; /* 瑘 */
dict[0x7459] = "nǎo"; /* 瑙 */
dict[0x745a] = "hú"; /* 瑚 */
dict[0x745b] = "yīng"; /* 瑛 */
dict[0x745c] = "yú"; /* 瑜 */
dict[0x745d] = "huáng"; /* 瑝 */
dict[0x745e] = "ruì"; /* 瑞 */
dict[0x745f] = "sè"; /* 瑟 */
dict[0x7460] = "liú"; /* 瑠 */
dict[0x7461] = "shī"; /* 瑡 */
dict[0x7462] = "róng"; /* 瑢 */
dict[0x7463] = "suǒ"; /* 瑣 */
dict[0x7464] = "yáo"; /* 瑤 */
dict[0x7465] = "wēn"; /* 瑥 */
dict[0x7466] = "wǔ"; /* 瑦 */
dict[0x7467] = "zhēn"; /* 瑧 */
dict[0x7468] = "jìn"; /* 瑨 */
dict[0x7469] = "yíng"; /* 瑩 */
dict[0x746a] = "mǎ"; /* 瑪 */
dict[0x746b] = "tāo"; /* 瑫 */
dict[0x746c] = "liú"; /* 瑬 */
dict[0x746d] = "táng"; /* 瑭 */
dict[0x746e] = "lì"; /* 瑮 */
dict[0x746f] = "láng"; /* 瑯 */
dict[0x7470] = "guī"; /* 瑰 */
dict[0x7471] = "tiàn,tián,zhèn"; /* 瑱 */
dict[0x7472] = "qiāng,cāng"; /* 瑲 */
dict[0x7473] = "cuō"; /* 瑳 */
dict[0x7474] = "jué"; /* 瑴 */
dict[0x7475] = "zhǎo"; /* 瑵 */
dict[0x7476] = "yáo"; /* 瑶 */
dict[0x7477] = "ài"; /* 瑷 */
dict[0x7478] = "bīn,pián"; /* 瑸 */
dict[0x7479] = "tú,shū"; /* 瑹 */
dict[0x747a] = "cháng"; /* 瑺 */
dict[0x747b] = "kūn"; /* 瑻 */
dict[0x747c] = "zhuān"; /* 瑼 */
dict[0x747d] = "cōng"; /* 瑽 */
dict[0x747e] = "jǐn"; /* 瑾 */
dict[0x747f] = "yī"; /* 瑿 */
dict[0x7480] = "cuǐ"; /* 璀 */
dict[0x7481] = "cōng"; /* 璁 */
dict[0x7482] = "qí"; /* 璂 */
dict[0x7483] = "lí"; /* 璃 */
dict[0x7484] = "jǐng"; /* 璄 */
dict[0x7485] = "zǎo,suǒ"; /* 璅 */
dict[0x7486] = "qiú"; /* 璆 */
dict[0x7487] = "xuán"; /* 璇 */
dict[0x7488] = "áo"; /* 璈 */
dict[0x7489] = "liǎn"; /* 璉 */
dict[0x748a] = "mén"; /* 璊 */
dict[0x748b] = "zhāng"; /* 璋 */
dict[0x748c] = "yín"; /* 璌 */
dict[0x748d] = "yè"; /* 璍 */
dict[0x748e] = "yīng"; /* 璎 */
dict[0x748f] = "zhì"; /* 璏 */
dict[0x7490] = "lù"; /* 璐 */
dict[0x7491] = "wú"; /* 璑 */
dict[0x7492] = "dēng"; /* 璒 */
dict[0x7493] = "xiù"; /* 璓 */
dict[0x7494] = "zēng"; /* 璔 */
dict[0x7495] = "xún"; /* 璕 */
dict[0x7496] = "qú"; /* 璖 */
dict[0x7497] = "dàng"; /* 璗 */
dict[0x7498] = "lín"; /* 璘 */
dict[0x7499] = "liáo"; /* 璙 */
dict[0x749a] = "qióng,jué"; /* 璚 */
dict[0x749b] = "sù"; /* 璛 */
dict[0x749c] = "huáng"; /* 璜 */
dict[0x749d] = "guī"; /* 璝 */
dict[0x749e] = "pú"; /* 璞 */
dict[0x749f] = "jǐng"; /* 璟 */
dict[0x74a0] = "fán"; /* 璠 */
dict[0x74a1] = "jīn"; /* 璡 */
dict[0x74a2] = "liú"; /* 璢 */
dict[0x74a3] = "jī"; /* 璣 */
dict[0x74a4] = "huì"; /* 璤 */
dict[0x74a5] = "jǐng"; /* 璥 */
dict[0x74a6] = "ài"; /* 璦 */
dict[0x74a7] = "bì"; /* 璧 */
dict[0x74a8] = "càn"; /* 璨 */
dict[0x74a9] = "qú"; /* 璩 */
dict[0x74aa] = "zǎo"; /* 璪 */
dict[0x74ab] = "dāng"; /* 璫 */
dict[0x74ac] = "jiǎo"; /* 璬 */
dict[0x74ad] = "guǎn"; /* 璭 */
dict[0x74ae] = "tǎn"; /* 璮 */
dict[0x74af] = "huì,kuài"; /* 璯 */
dict[0x74b0] = "huán"; /* 環 */
dict[0x74b1] = "sè"; /* 璱 */
dict[0x74b2] = "suì"; /* 璲 */
dict[0x74b3] = "tián"; /* 璳 */
dict[0x74b4] = "chǔ"; /* 璴 */
dict[0x74b5] = "yú"; /* 璵 */
dict[0x74b6] = "jìn"; /* 璶 */
dict[0x74b7] = "lú,fū"; /* 璷 */
dict[0x74b8] = "bīn,pián"; /* 璸 */
dict[0x74b9] = "shú"; /* 璹 */
dict[0x74ba] = "wèn"; /* 璺 */
dict[0x74bb] = "zuǐ"; /* 璻 */
dict[0x74bc] = "lán"; /* 璼 */
dict[0x74bd] = "xǐ"; /* 璽 */
dict[0x74be] = "jì,zī"; /* 璾 */
dict[0x74bf] = "xuán"; /* 璿 */
dict[0x74c0] = "ruǎn"; /* 瓀 */
dict[0x74c1] = "wò"; /* 瓁 */
dict[0x74c2] = "gài"; /* 瓂 */
dict[0x74c3] = "léi"; /* 瓃 */
dict[0x74c4] = "dú"; /* 瓄 */
dict[0x74c5] = "lì"; /* 瓅 */
dict[0x74c6] = "zhì"; /* 瓆 */
dict[0x74c7] = "róu"; /* 瓇 */
dict[0x74c8] = "lí"; /* 瓈 */
dict[0x74c9] = "zàn"; /* 瓉 */
dict[0x74ca] = "qióng"; /* 瓊 */
dict[0x74cb] = "tì"; /* 瓋 */
dict[0x74cc] = "guī"; /* 瓌 */
dict[0x74cd] = "suí"; /* 瓍 */
dict[0x74ce] = "là"; /* 瓎 */
dict[0x74cf] = "lóng"; /* 瓏 */
dict[0x74d0] = "lú"; /* 瓐 */
dict[0x74d1] = "lì"; /* 瓑 */
dict[0x74d2] = "zàn"; /* 瓒 */
dict[0x74d3] = "làn"; /* 瓓 */
dict[0x74d4] = "yīng"; /* 瓔 */
dict[0x74d5] = "mí,xǐ"; /* 瓕 */
dict[0x74d6] = "xiāng"; /* 瓖 */
dict[0x74d7] = "qióng,wěi,wèi"; /* 瓗 */
dict[0x74d8] = "guàn"; /* 瓘 */
dict[0x74d9] = "dào"; /* 瓙 */
dict[0x74da] = "zàn"; /* 瓚 */
dict[0x74db] = "huán,yè,yà"; /* 瓛 */
dict[0x74dc] = "guā"; /* 瓜 */
dict[0x74dd] = "bó"; /* 瓝 */
dict[0x74de] = "dié"; /* 瓞 */
dict[0x74df] = "bó,páo"; /* 瓟 */
dict[0x74e0] = "hù"; /* 瓠 */
dict[0x74e1] = "zhí,hú"; /* 瓡 */
dict[0x74e2] = "piáo"; /* 瓢 */
dict[0x74e3] = "bàn"; /* 瓣 */
dict[0x74e4] = "ráng"; /* 瓤 */
dict[0x74e5] = "lì"; /* 瓥 */
dict[0x74e6] = "wǎ,wà"; /* 瓦 */
dict[0x74e8] = "xiáng,hóng"; /* 瓨 */
dict[0x74ea] = "bǎn"; /* 瓪 */
dict[0x74eb] = "pén"; /* 瓫 */
dict[0x74ec] = "fǎng"; /* 瓬 */
dict[0x74ed] = "dǎn"; /* 瓭 */
dict[0x74ee] = "wèng"; /* 瓮 */
dict[0x74ef] = "ōu"; /* 瓯 */
dict[0x74f3] = "hú"; /* 瓳 */
dict[0x74f4] = "líng"; /* 瓴 */
dict[0x74f5] = "yí"; /* 瓵 */
dict[0x74f6] = "píng"; /* 瓶 */
dict[0x74f7] = "cí"; /* 瓷 */
dict[0x74f8] = "bǎi,wǎ"; /* 瓸 */
dict[0x74f9] = "juàn,juān"; /* 瓹 */
dict[0x74fa] = "cháng"; /* 瓺 */
dict[0x74fb] = "chī"; /* 瓻 */
dict[0x74fd] = "dàng"; /* 瓽 */
dict[0x74fe] = "wā"; /* 瓾 */
dict[0x74ff] = "bù"; /* 瓿 */
dict[0x7500] = "zhuì"; /* 甀 */
dict[0x7501] = "píng"; /* 甁 */
dict[0x7502] = "biān"; /* 甂 */
dict[0x7503] = "zhòu"; /* 甃 */
dict[0x7504] = "zhēn"; /* 甄 */
dict[0x7506] = "cí"; /* 甆 */
dict[0x7507] = "yīng"; /* 甇 */
dict[0x7508] = "qì"; /* 甈 */
dict[0x7509] = "xián"; /* 甉 */
dict[0x750a] = "lǒu"; /* 甊 */
dict[0x750b] = "dì"; /* 甋 */
dict[0x750c] = "ōu"; /* 甌 */
dict[0x750d] = "méng"; /* 甍 */
dict[0x750e] = "zhuān"; /* 甎 */
dict[0x750f] = "bèng"; /* 甏 */
dict[0x7510] = "lìn"; /* 甐 */
dict[0x7511] = "zèng"; /* 甑 */
dict[0x7512] = "wǔ"; /* 甒 */
dict[0x7513] = "pì"; /* 甓 */
dict[0x7514] = "dān"; /* 甔 */
dict[0x7515] = "wèng"; /* 甕 */
dict[0x7516] = "yīng"; /* 甖 */
dict[0x7517] = "yǎn"; /* 甗 */
dict[0x7518] = "gān"; /* 甘 */
dict[0x7519] = "dài"; /* 甙 */
dict[0x751a] = "shèn,shén"; /* 甚 */
dict[0x751b] = "tián"; /* 甛 */
dict[0x751c] = "tián"; /* 甜 */
dict[0x751d] = "hán"; /* 甝 */
dict[0x751e] = "cháng"; /* 甞 */
dict[0x751f] = "shēng"; /* 生 */
dict[0x7520] = "qíng"; /* 甠 */
dict[0x7521] = "shēn"; /* 甡 */
dict[0x7522] = "chǎn"; /* 產 */
dict[0x7523] = "chǎn"; /* 産 */
dict[0x7524] = "ruí"; /* 甤 */
dict[0x7525] = "shēng"; /* 甥 */
dict[0x7526] = "sū"; /* 甦 */
dict[0x7527] = "shēn"; /* 甧 */
dict[0x7528] = "yòng"; /* 用 */
dict[0x7529] = "shuǎi"; /* 甩 */
dict[0x752a] = "lù"; /* 甪 */
dict[0x752b] = "fǔ"; /* 甫 */
dict[0x752c] = "yǒng"; /* 甬 */
dict[0x752d] = "béng"; /* 甭 */
dict[0x752e] = "béng"; /* 甮 */
dict[0x752f] = "níng,nìng"; /* 甯 */
dict[0x7530] = "tián"; /* 田 */
dict[0x7531] = "yóu"; /* 由 */
dict[0x7532] = "jiǎ"; /* 甲 */
dict[0x7533] = "shēn"; /* 申 */
dict[0x7534] = "yóu,zhá"; /* 甴 */
dict[0x7535] = "diàn"; /* 电 */
dict[0x7536] = "fú"; /* 甶 */
dict[0x7537] = "nán"; /* 男 */
dict[0x7538] = "diàn,tián,shèng"; /* 甸 */
dict[0x7539] = "pīng"; /* 甹 */
dict[0x753a] = "tǐng,dīng"; /* 町 */
dict[0x753b] = "huà"; /* 画 */
dict[0x753c] = "tǐng,dīng"; /* 甼 */
dict[0x753d] = "zhèn"; /* 甽 */
dict[0x753e] = "zāi,zī"; /* 甾 */
dict[0x753f] = "méng"; /* 甿 */
dict[0x7540] = "bì"; /* 畀 */
dict[0x7541] = "bì,qí"; /* 畁 */
dict[0x7542] = "mǔ"; /* 畂 */
dict[0x7543] = "xún"; /* 畃 */
dict[0x7544] = "liú"; /* 畄 */
dict[0x7545] = "chàng"; /* 畅 */
dict[0x7546] = "mǔ"; /* 畆 */
dict[0x7547] = "yún"; /* 畇 */
dict[0x7548] = "fàn"; /* 畈 */
dict[0x7549] = "fú"; /* 畉 */
dict[0x754a] = "gēng"; /* 畊 */
dict[0x754b] = "tián"; /* 畋 */
dict[0x754c] = "jiè"; /* 界 */
dict[0x754d] = "jiè"; /* 畍 */
dict[0x754e] = "quǎn"; /* 畎 */
dict[0x754f] = "wèi"; /* 畏 */
dict[0x7550] = "fú,bì"; /* 畐 */
dict[0x7551] = "tián"; /* 畑 */
dict[0x7552] = "mǔ"; /* 畒 */
dict[0x7553] = "duō"; /* 畓 */
dict[0x7554] = "pàn"; /* 畔 */
dict[0x7555] = "jiāng"; /* 畕 */
dict[0x7556] = "wā"; /* 畖 */
dict[0x7557] = "dá,fú"; /* 畗 */
dict[0x7558] = "nán"; /* 畘 */
dict[0x7559] = "liú"; /* 留 */
dict[0x755a] = "běn"; /* 畚 */
dict[0x755b] = "zhěn"; /* 畛 */
dict[0x755c] = "xù,chù"; /* 畜 */
dict[0x755d] = "mǔ"; /* 畝 */
dict[0x755e] = "mǔ"; /* 畞 */
dict[0x755f] = "cè,jì"; /* 畟 */
dict[0x7560] = "zāi,zī"; /* 畠 */
dict[0x7561] = "gāi"; /* 畡 */
dict[0x7562] = "bì"; /* 畢 */
dict[0x7563] = "dá"; /* 畣 */
dict[0x7564] = "zhì,chóu,shì"; /* 畤 */
dict[0x7565] = "lüè"; /* 略 */
dict[0x7566] = "qí"; /* 畦 */
dict[0x7567] = "lüè"; /* 畧 */
dict[0x7568] = "fān,pān"; /* 畨 */
dict[0x7569] = "yī"; /* 畩 */
dict[0x756a] = "fān,pān"; /* 番 */
dict[0x756b] = "huà"; /* 畫 */
dict[0x756c] = "shē,yú"; /* 畬 */
dict[0x756d] = "shē"; /* 畭 */
dict[0x756e] = "mǔ"; /* 畮 */
dict[0x756f] = "jùn"; /* 畯 */
dict[0x7570] = "yì"; /* 異 */
dict[0x7571] = "liú"; /* 畱 */
dict[0x7572] = "shē"; /* 畲 */
dict[0x7573] = "dié"; /* 畳 */
dict[0x7574] = "chóu"; /* 畴 */
dict[0x7575] = "huà"; /* 畵 */
dict[0x7576] = "dāng,dàng,dǎng"; /* 當 */
dict[0x7577] = "zhuì"; /* 畷 */
dict[0x7578] = "jī"; /* 畸 */
dict[0x7579] = "wǎn"; /* 畹 */
dict[0x757a] = "jiāng,jiàng"; /* 畺 */
dict[0x757b] = "chéng"; /* 畻 */
dict[0x757c] = "chàng"; /* 畼 */
dict[0x757d] = "tuǎn"; /* 畽 */
dict[0x757e] = "léi"; /* 畾 */
dict[0x757f] = "jī"; /* 畿 */
dict[0x7580] = "chā"; /* 疀 */
dict[0x7581] = "liú"; /* 疁 */
dict[0x7582] = "dié"; /* 疂 */
dict[0x7583] = "tuǎn"; /* 疃 */
dict[0x7584] = "lín,lìn"; /* 疄 */
dict[0x7585] = "jiāng"; /* 疅 */
dict[0x7586] = "jiāng,qiáng"; /* 疆 */
dict[0x7587] = "chóu"; /* 疇 */
dict[0x7588] = "pì"; /* 疈 */
dict[0x7589] = "dié"; /* 疉 */
dict[0x758a] = "dié"; /* 疊 */
dict[0x758b] = "pǐ,yǎ,shū"; /* 疋 */
dict[0x758c] = "jié,qiè"; /* 疌 */
dict[0x758d] = "dàn"; /* 疍 */
dict[0x758e] = "shū"; /* 疎 */
dict[0x758f] = "shū"; /* 疏 */
dict[0x7590] = "zhì,dì"; /* 疐 */
dict[0x7591] = "yí,nǐ"; /* 疑 */
dict[0x7592] = "nè"; /* 疒 */
dict[0x7593] = "nǎi"; /* 疓 */
dict[0x7594] = "dīng"; /* 疔 */
dict[0x7595] = "bǐ"; /* 疕 */
dict[0x7596] = "jiē"; /* 疖 */
dict[0x7597] = "liáo"; /* 疗 */
dict[0x7598] = "gāng"; /* 疘 */
dict[0x7599] = "gē,yì"; /* 疙 */
dict[0x759a] = "jiù"; /* 疚 */
dict[0x759b] = "zhǒu"; /* 疛 */
dict[0x759c] = "xià"; /* 疜 */
dict[0x759d] = "shàn"; /* 疝 */
dict[0x759e] = "xū"; /* 疞 */
dict[0x759f] = "nüè,yào"; /* 疟 */
dict[0x75a0] = "lì,lài"; /* 疠 */
dict[0x75a1] = "yáng"; /* 疡 */
dict[0x75a2] = "chèn"; /* 疢 */
dict[0x75a3] = "yóu"; /* 疣 */
dict[0x75a4] = "bā"; /* 疤 */
dict[0x75a5] = "jiè"; /* 疥 */
dict[0x75a6] = "jué,xuè"; /* 疦 */
dict[0x75a7] = "qí"; /* 疧 */
dict[0x75a8] = "yǎ,xiā"; /* 疨 */
dict[0x75a9] = "cuì"; /* 疩 */
dict[0x75aa] = "bì"; /* 疪 */
dict[0x75ab] = "yì"; /* 疫 */
dict[0x75ac] = "lì"; /* 疬 */
dict[0x75ad] = "zòng"; /* 疭 */
dict[0x75ae] = "chuāng"; /* 疮 */
dict[0x75af] = "fēng"; /* 疯 */
dict[0x75b0] = "zhù"; /* 疰 */
dict[0x75b1] = "pào"; /* 疱 */
dict[0x75b2] = "pí"; /* 疲 */
dict[0x75b3] = "gān"; /* 疳 */
dict[0x75b4] = "kē"; /* 疴 */
dict[0x75b5] = "cī"; /* 疵 */
dict[0x75b6] = "xuē"; /* 疶 */
dict[0x75b7] = "zhī"; /* 疷 */
dict[0x75b8] = "dǎn"; /* 疸 */
dict[0x75b9] = "zhěn"; /* 疹 */
dict[0x75ba] = "fá,biǎn"; /* 疺 */
dict[0x75bb] = "zhǐ"; /* 疻 */
dict[0x75bc] = "téng"; /* 疼 */
dict[0x75bd] = "jū"; /* 疽 */
dict[0x75be] = "jí"; /* 疾 */
dict[0x75bf] = "fèi,féi"; /* 疿 */
dict[0x75c0] = "gōu"; /* 痀 */
dict[0x75c1] = "shān,diàn"; /* 痁 */
dict[0x75c2] = "jiā"; /* 痂 */
dict[0x75c3] = "xuán"; /* 痃 */
dict[0x75c4] = "zhà"; /* 痄 */
dict[0x75c5] = "bìng"; /* 病 */
dict[0x75c6] = "niè"; /* 痆 */
dict[0x75c7] = "zhèng,zhēng"; /* 症 */
dict[0x75c8] = "yōng"; /* 痈 */
dict[0x75c9] = "jìng"; /* 痉 */
dict[0x75ca] = "quán"; /* 痊 */
dict[0x75cb] = "téng,chóng"; /* 痋 */
dict[0x75cc] = "tōng,tóng"; /* 痌 */
dict[0x75cd] = "yí"; /* 痍 */
dict[0x75ce] = "jiē"; /* 痎 */
dict[0x75cf] = "wěi,yòu,yù"; /* 痏 */
dict[0x75d0] = "huí"; /* 痐 */
dict[0x75d1] = "tān,shǐ"; /* 痑 */
dict[0x75d2] = "yǎng"; /* 痒 */
dict[0x75d3] = "zhì"; /* 痓 */
dict[0x75d4] = "zhì"; /* 痔 */
dict[0x75d5] = "hén"; /* 痕 */
dict[0x75d6] = "yǎ"; /* 痖 */
dict[0x75d7] = "mèi"; /* 痗 */
dict[0x75d8] = "dòu"; /* 痘 */
dict[0x75d9] = "jìng"; /* 痙 */
dict[0x75da] = "xiāo"; /* 痚 */
dict[0x75db] = "tòng"; /* 痛 */
dict[0x75dc] = "tū"; /* 痜 */
dict[0x75dd] = "máng"; /* 痝 */
dict[0x75de] = "pǐ"; /* 痞 */
dict[0x75df] = "xiāo"; /* 痟 */
dict[0x75e0] = "suān"; /* 痠 */
dict[0x75e1] = "pū,pù"; /* 痡 */
dict[0x75e2] = "lì"; /* 痢 */
dict[0x75e3] = "zhì"; /* 痣 */
dict[0x75e4] = "cuó"; /* 痤 */
dict[0x75e5] = "duó"; /* 痥 */
dict[0x75e6] = "wù"; /* 痦 */
dict[0x75e7] = "shā"; /* 痧 */
dict[0x75e8] = "láo"; /* 痨 */
dict[0x75e9] = "shòu"; /* 痩 */
dict[0x75ea] = "huàn"; /* 痪 */
dict[0x75eb] = "xián"; /* 痫 */
dict[0x75ec] = "yì"; /* 痬 */
dict[0x75ed] = "bēng,péng"; /* 痭 */
dict[0x75ee] = "zhàng"; /* 痮 */
dict[0x75ef] = "guǎn"; /* 痯 */
dict[0x75f0] = "tán"; /* 痰 */
dict[0x75f1] = "fèi,féi"; /* 痱 */
dict[0x75f2] = "má"; /* 痲 */
dict[0x75f3] = "má,lìn"; /* 痳 */
dict[0x75f4] = "chī"; /* 痴 */
dict[0x75f5] = "jì"; /* 痵 */
dict[0x75f6] = "tiǎn,diàn"; /* 痶 */
dict[0x75f7] = "ān,yè,è"; /* 痷 */
dict[0x75f8] = "chì"; /* 痸 */
dict[0x75f9] = "bì"; /* 痹 */
dict[0x75fa] = "bì"; /* 痺 */
dict[0x75fb] = "mín"; /* 痻 */
dict[0x75fc] = "gù"; /* 痼 */
dict[0x75fd] = "duī"; /* 痽 */
dict[0x75fe] = "kē,ē"; /* 痾 */
dict[0x75ff] = "wěi"; /* 痿 */
dict[0x7600] = "yū"; /* 瘀 */
dict[0x7601] = "cuì"; /* 瘁 */
dict[0x7602] = "yǎ"; /* 瘂 */
dict[0x7603] = "zhú"; /* 瘃 */
dict[0x7604] = "cù"; /* 瘄 */
dict[0x7605] = "dàn,dān"; /* 瘅 */
dict[0x7606] = "shèn"; /* 瘆 */
dict[0x7607] = "zhǒng"; /* 瘇 */
dict[0x7608] = "zhì,chì"; /* 瘈 */
dict[0x7609] = "yù"; /* 瘉 */
dict[0x760a] = "hóu"; /* 瘊 */
dict[0x760b] = "fēng"; /* 瘋 */
dict[0x760c] = "là"; /* 瘌 */
dict[0x760d] = "yáng"; /* 瘍 */
dict[0x760e] = "chén"; /* 瘎 */
dict[0x760f] = "tú"; /* 瘏 */
dict[0x7610] = "yǔ"; /* 瘐 */
dict[0x7611] = "guō"; /* 瘑 */
dict[0x7612] = "wén"; /* 瘒 */
dict[0x7613] = "huàn"; /* 瘓 */
dict[0x7614] = "kù"; /* 瘔 */
dict[0x7615] = "jiǎ,xiá,xiā"; /* 瘕 */
dict[0x7616] = "yīn"; /* 瘖 */
dict[0x7617] = "yì"; /* 瘗 */
dict[0x7618] = "lòu"; /* 瘘 */
dict[0x7619] = "sào"; /* 瘙 */
dict[0x761a] = "jué"; /* 瘚 */
dict[0x761b] = "chì"; /* 瘛 */
dict[0x761c] = "xī"; /* 瘜 */
dict[0x761d] = "guān"; /* 瘝 */
dict[0x761e] = "yì"; /* 瘞 */
dict[0x761f] = "wēn"; /* 瘟 */
dict[0x7620] = "jí"; /* 瘠 */
dict[0x7621] = "chuāng"; /* 瘡 */
dict[0x7622] = "bān"; /* 瘢 */
dict[0x7623] = "huì,lěi"; /* 瘣 */
dict[0x7624] = "liú"; /* 瘤 */
dict[0x7625] = "chài,cuó"; /* 瘥 */
dict[0x7626] = "shòu"; /* 瘦 */
dict[0x7627] = "nüè,yào"; /* 瘧 */
dict[0x7628] = "diān,chēn"; /* 瘨 */
dict[0x7629] = "dá,da"; /* 瘩 */
dict[0x762a] = "biē,biě"; /* 瘪 */
dict[0x762b] = "tān"; /* 瘫 */
dict[0x762c] = "zhàng"; /* 瘬 */
dict[0x762d] = "biāo"; /* 瘭 */
dict[0x762e] = "shèn"; /* 瘮 */
dict[0x762f] = "cù"; /* 瘯 */
dict[0x7630] = "luǒ"; /* 瘰 */
dict[0x7631] = "yì"; /* 瘱 */
dict[0x7632] = "zòng"; /* 瘲 */
dict[0x7633] = "chōu"; /* 瘳 */
dict[0x7634] = "zhàng"; /* 瘴 */
dict[0x7635] = "zhài"; /* 瘵 */
dict[0x7636] = "sòu"; /* 瘶 */
dict[0x7637] = "sè"; /* 瘷 */
dict[0x7638] = "qué"; /* 瘸 */
dict[0x7639] = "diào"; /* 瘹 */
dict[0x763a] = "lòu"; /* 瘺 */
dict[0x763b] = "lòu"; /* 瘻 */
dict[0x763c] = "mò"; /* 瘼 */
dict[0x763d] = "qín"; /* 瘽 */
dict[0x763e] = "yǐn"; /* 瘾 */
dict[0x763f] = "yǐng"; /* 瘿 */
dict[0x7640] = "huáng"; /* 癀 */
dict[0x7641] = "fú"; /* 癁 */
dict[0x7642] = "liáo"; /* 療 */
dict[0x7643] = "lóng"; /* 癃 */
dict[0x7644] = "qiáo,jiào"; /* 癄 */
dict[0x7645] = "liú"; /* 癅 */
dict[0x7646] = "láo"; /* 癆 */
dict[0x7647] = "xián"; /* 癇 */
dict[0x7648] = "fèi"; /* 癈 */
dict[0x7649] = "dàn,dān"; /* 癉 */
dict[0x764a] = "yìn"; /* 癊 */
dict[0x764b] = "hè"; /* 癋 */
dict[0x764c] = "ái"; /* 癌 */
dict[0x764d] = "bān"; /* 癍 */
dict[0x764e] = "xián"; /* 癎 */
dict[0x764f] = "guān"; /* 癏 */
dict[0x7650] = "guì,wēi"; /* 癐 */
dict[0x7651] = "nòng,nóng"; /* 癑 */
dict[0x7652] = "yù"; /* 癒 */
dict[0x7653] = "wēi"; /* 癓 */
dict[0x7654] = "yì"; /* 癔 */
dict[0x7655] = "yōng"; /* 癕 */
dict[0x7656] = "pǐ"; /* 癖 */
dict[0x7657] = "lěi"; /* 癗 */
dict[0x7658] = "lì,lài"; /* 癘 */
dict[0x7659] = "shǔ"; /* 癙 */
dict[0x765a] = "dàn"; /* 癚 */
dict[0x765b] = "lǐn"; /* 癛 */
dict[0x765c] = "diàn"; /* 癜 */
dict[0x765d] = "lǐn"; /* 癝 */
dict[0x765e] = "lài"; /* 癞 */
dict[0x765f] = "biē,biě"; /* 癟 */
dict[0x7660] = "jì"; /* 癠 */
dict[0x7661] = "chī"; /* 癡 */
dict[0x7662] = "yǎng"; /* 癢 */
dict[0x7663] = "xuǎn"; /* 癣 */
dict[0x7664] = "jiē"; /* 癤 */
dict[0x7665] = "zhēng"; /* 癥 */
dict[0x7666] = "mèng"; /* 癦 */
dict[0x7667] = "lì"; /* 癧 */
dict[0x7668] = "huò"; /* 癨 */
dict[0x7669] = "lài"; /* 癩 */
dict[0x766a] = "jī"; /* 癪 */
dict[0x766b] = "diān"; /* 癫 */
dict[0x766c] = "xuǎn"; /* 癬 */
dict[0x766d] = "yǐng"; /* 癭 */
dict[0x766e] = "yǐn"; /* 癮 */
dict[0x766f] = "qú"; /* 癯 */
dict[0x7670] = "yōng"; /* 癰 */
dict[0x7671] = "tān"; /* 癱 */
dict[0x7672] = "diān"; /* 癲 */
dict[0x7673] = "luǒ"; /* 癳 */
dict[0x7674] = "luán"; /* 癴 */
dict[0x7675] = "luán"; /* 癵 */
dict[0x7676] = "bō"; /* 癶 */
dict[0x7677] = "bō,bǒ"; /* 癷 */
dict[0x7678] = "guǐ"; /* 癸 */
dict[0x7679] = "bá"; /* 癹 */
dict[0x767a] = "fā"; /* 発 */
dict[0x767b] = "dēng"; /* 登 */
dict[0x767c] = "fā"; /* 發 */
dict[0x767d] = "bái"; /* 白 */
dict[0x767e] = "bǎi"; /* 百 */
dict[0x767f] = "qié"; /* 癿 */
dict[0x7680] = "jí,bī"; /* 皀 */
dict[0x7681] = "zào"; /* 皁 */
dict[0x7682] = "zào"; /* 皂 */
dict[0x7683] = "mào"; /* 皃 */
dict[0x7684] = "de,dì,dí"; /* 的 */
dict[0x7685] = "pā,bà"; /* 皅 */
dict[0x7686] = "jiē"; /* 皆 */
dict[0x7687] = "huáng"; /* 皇 */
dict[0x7688] = "guī"; /* 皈 */
dict[0x7689] = "cǐ"; /* 皉 */
dict[0x768a] = "líng"; /* 皊 */
dict[0x768b] = "gāo,háo"; /* 皋 */
dict[0x768c] = "mò"; /* 皌 */
dict[0x768d] = "jí"; /* 皍 */
dict[0x768e] = "jiǎo"; /* 皎 */
dict[0x768f] = "pěng"; /* 皏 */
dict[0x7690] = "gāo,yáo"; /* 皐 */
dict[0x7691] = "ái"; /* 皑 */
dict[0x7692] = "é"; /* 皒 */
dict[0x7693] = "hào"; /* 皓 */
dict[0x7694] = "hàn"; /* 皔 */
dict[0x7695] = "bì"; /* 皕 */
dict[0x7696] = "wǎn"; /* 皖 */
dict[0x7697] = "chóu"; /* 皗 */
dict[0x7698] = "qiàn"; /* 皘 */
dict[0x7699] = "xī"; /* 皙 */
dict[0x769a] = "ái"; /* 皚 */
dict[0x769b] = "xiǎo"; /* 皛 */
dict[0x769c] = "hào"; /* 皜 */
dict[0x769d] = "huàng"; /* 皝 */
dict[0x769e] = "hào"; /* 皞 */
dict[0x769f] = "zé"; /* 皟 */
dict[0x76a0] = "cuǐ"; /* 皠 */
dict[0x76a1] = "hào"; /* 皡 */
dict[0x76a2] = "xiǎo"; /* 皢 */
dict[0x76a3] = "yè"; /* 皣 */
dict[0x76a4] = "pó"; /* 皤 */
dict[0x76a5] = "hào"; /* 皥 */
dict[0x76a6] = "jiǎo"; /* 皦 */
dict[0x76a7] = "ài"; /* 皧 */
dict[0x76a8] = "xīng"; /* 皨 */
dict[0x76a9] = "huàng"; /* 皩 */
dict[0x76aa] = "lì,luò,bō"; /* 皪 */
dict[0x76ab] = "piǎo"; /* 皫 */
dict[0x76ac] = "hé"; /* 皬 */
dict[0x76ad] = "jiào"; /* 皭 */
dict[0x76ae] = "pí"; /* 皮 */
dict[0x76af] = "gǎn"; /* 皯 */
dict[0x76b0] = "pào"; /* 皰 */
dict[0x76b1] = "zhòu"; /* 皱 */
dict[0x76b2] = "jūn"; /* 皲 */
dict[0x76b3] = "qiú"; /* 皳 */
dict[0x76b4] = "cūn"; /* 皴 */
dict[0x76b5] = "què"; /* 皵 */
dict[0x76b6] = "zhā"; /* 皶 */
dict[0x76b7] = "gǔ"; /* 皷 */
dict[0x76b8] = "jūn"; /* 皸 */
dict[0x76b9] = "jūn"; /* 皹 */
dict[0x76ba] = "zhòu"; /* 皺 */
dict[0x76bb] = "zhā,cǔ"; /* 皻 */
dict[0x76bc] = "gǔ"; /* 皼 */
dict[0x76bd] = "zhāo,zhǎn,dǎn"; /* 皽 */
dict[0x76be] = "dú"; /* 皾 */
dict[0x76bf] = "mǐn"; /* 皿 */
dict[0x76c0] = "qǐ"; /* 盀 */
dict[0x76c1] = "yíng"; /* 盁 */
dict[0x76c2] = "yú"; /* 盂 */
dict[0x76c3] = "bēi"; /* 盃 */
dict[0x76c4] = "diào"; /* 盄 */
dict[0x76c5] = "zhōng"; /* 盅 */
dict[0x76c6] = "pén"; /* 盆 */
dict[0x76c7] = "hé"; /* 盇 */
dict[0x76c8] = "yíng"; /* 盈 */
dict[0x76c9] = "hé"; /* 盉 */
dict[0x76ca] = "yì"; /* 益 */
dict[0x76cb] = "bō"; /* 盋 */
dict[0x76cc] = "wǎn"; /* 盌 */
dict[0x76cd] = "hé"; /* 盍 */
dict[0x76ce] = "àng"; /* 盎 */
dict[0x76cf] = "zhǎn"; /* 盏 */
dict[0x76d0] = "yán"; /* 盐 */
dict[0x76d1] = "jiān,jiàn"; /* 监 */
dict[0x76d2] = "hé"; /* 盒 */
dict[0x76d3] = "yū"; /* 盓 */
dict[0x76d4] = "kuī"; /* 盔 */
dict[0x76d5] = "fàn"; /* 盕 */
dict[0x76d6] = "gài,gě,hé"; /* 盖 */
dict[0x76d7] = "dào"; /* 盗 */
dict[0x76d8] = "pán"; /* 盘 */
dict[0x76d9] = "fǔ"; /* 盙 */
dict[0x76da] = "qiú"; /* 盚 */
dict[0x76db] = "shèng,chéng"; /* 盛 */
dict[0x76dc] = "dào"; /* 盜 */
dict[0x76dd] = "lù"; /* 盝 */
dict[0x76de] = "zhǎn"; /* 盞 */
dict[0x76df] = "méng"; /* 盟 */
dict[0x76e0] = "lí"; /* 盠 */
dict[0x76e1] = "jìn"; /* 盡 */
dict[0x76e2] = "xù"; /* 盢 */
dict[0x76e3] = "jiān,jiàn"; /* 監 */
dict[0x76e4] = "pán"; /* 盤 */
dict[0x76e5] = "guàn"; /* 盥 */
dict[0x76e6] = "ān"; /* 盦 */
dict[0x76e7] = "lú"; /* 盧 */
dict[0x76e8] = "xǔ"; /* 盨 */
dict[0x76e9] = "zhōu,chóu"; /* 盩 */
dict[0x76ea] = "dàng"; /* 盪 */
dict[0x76eb] = "ān"; /* 盫 */
dict[0x76ec] = "gǔ"; /* 盬 */
dict[0x76ed] = "lì"; /* 盭 */
dict[0x76ee] = "mù"; /* 目 */
dict[0x76ef] = "dīng"; /* 盯 */
dict[0x76f0] = "gàn"; /* 盰 */
dict[0x76f1] = "xū"; /* 盱 */
dict[0x76f2] = "máng"; /* 盲 */
dict[0x76f3] = "máng,wàng"; /* 盳 */
dict[0x76f4] = "zhí"; /* 直 */
dict[0x76f5] = "qì"; /* 盵 */
dict[0x76f6] = "yuǎn"; /* 盶 */
dict[0x76f7] = "xián,tián"; /* 盷 */
dict[0x76f8] = "xiāng,xiàng"; /* 相 */
dict[0x76f9] = "dǔn"; /* 盹 */
dict[0x76fa] = "xīn"; /* 盺 */
dict[0x76fb] = "xì,pǎn"; /* 盻 */
dict[0x76fc] = "pàn"; /* 盼 */
dict[0x76fd] = "fēng"; /* 盽 */
dict[0x76fe] = "dùn"; /* 盾 */
dict[0x76ff] = "mín"; /* 盿 */
dict[0x7700] = "míng"; /* 眀 */
dict[0x7701] = "shěng,xǐng"; /* 省 */
dict[0x7702] = "shì"; /* 眂 */
dict[0x7703] = "yún,hùn"; /* 眃 */
dict[0x7704] = "miǎn"; /* 眄 */
dict[0x7705] = "pān"; /* 眅 */
dict[0x7706] = "fǎng"; /* 眆 */
dict[0x7707] = "miǎo"; /* 眇 */
dict[0x7708] = "dān"; /* 眈 */
dict[0x7709] = "méi"; /* 眉 */
dict[0x770a] = "mào"; /* 眊 */
dict[0x770b] = "kàn,kān"; /* 看 */
dict[0x770c] = "xiàn"; /* 県 */
dict[0x770d] = "kōu"; /* 眍 */
dict[0x770e] = "shì"; /* 眎 */
dict[0x770f] = "yāng,yǎng,yìng"; /* 眏 */
dict[0x7710] = "zhēng"; /* 眐 */
dict[0x7711] = "yǎo,āo,ǎo"; /* 眑 */
dict[0x7712] = "shēn"; /* 眒 */
dict[0x7713] = "huò"; /* 眓 */
dict[0x7714] = "dà"; /* 眔 */
dict[0x7715] = "zhěn"; /* 眕 */
dict[0x7716] = "kuàng"; /* 眖 */
dict[0x7717] = "jū,xū,kōu"; /* 眗 */
dict[0x7718] = "shèn"; /* 眘 */
dict[0x7719] = "yí,chì"; /* 眙 */
dict[0x771a] = "shěng"; /* 眚 */
dict[0x771b] = "mèi"; /* 眛 */
dict[0x771c] = "mò,miè"; /* 眜 */
dict[0x771d] = "zhù"; /* 眝 */
dict[0x771e] = "zhēn"; /* 眞 */
dict[0x771f] = "zhēn"; /* 真 */
dict[0x7720] = "mián"; /* 眠 */
dict[0x7721] = "shì"; /* 眡 */
dict[0x7722] = "yuān"; /* 眢 */
dict[0x7723] = "dié,tì"; /* 眣 */
dict[0x7724] = "nì"; /* 眤 */
dict[0x7725] = "zì"; /* 眥 */
dict[0x7726] = "zì"; /* 眦 */
dict[0x7727] = "chǎo"; /* 眧 */
dict[0x7728] = "zhǎ"; /* 眨 */
dict[0x7729] = "xuàn"; /* 眩 */
dict[0x772a] = "bǐng,fǎng"; /* 眪 */
dict[0x772b] = "pàng,pán"; /* 眫 */
dict[0x772c] = "lóng"; /* 眬 */
dict[0x772d] = "guì,suī"; /* 眭 */
dict[0x772e] = "tóng"; /* 眮 */
dict[0x772f] = "mī,mí"; /* 眯 */
dict[0x7730] = "dié,zhì"; /* 眰 */
dict[0x7731] = "dì"; /* 眱 */
dict[0x7732] = "nè"; /* 眲 */
dict[0x7733] = "míng"; /* 眳 */
dict[0x7734] = "xuàn,shùn,xún"; /* 眴 */
dict[0x7735] = "chī"; /* 眵 */
dict[0x7736] = "kuàng"; /* 眶 */
dict[0x7737] = "juàn"; /* 眷 */
dict[0x7738] = "móu"; /* 眸 */
dict[0x7739] = "zhèn"; /* 眹 */
dict[0x773a] = "tiào"; /* 眺 */
dict[0x773b] = "yáng"; /* 眻 */
dict[0x773c] = "yǎn"; /* 眼 */
dict[0x773d] = "mò"; /* 眽 */
dict[0x773e] = "zhòng"; /* 眾 */
dict[0x773f] = "mò"; /* 眿 */
dict[0x7740] = "zháo,zhuó,zhāo,zhe"; /* 着 */
dict[0x7741] = "zhēng"; /* 睁 */
dict[0x7742] = "méi"; /* 睂 */
dict[0x7743] = "suō"; /* 睃 */
dict[0x7744] = "qiáo,shào,xiāo"; /* 睄 */
dict[0x7745] = "hàn"; /* 睅 */
dict[0x7746] = "huǎn"; /* 睆 */
dict[0x7747] = "dì"; /* 睇 */
dict[0x7748] = "chěng"; /* 睈 */
dict[0x7749] = "cuó,zhuài"; /* 睉 */
dict[0x774a] = "juàn"; /* 睊 */
dict[0x774b] = "é"; /* 睋 */
dict[0x774c] = "miǎn"; /* 睌 */
dict[0x774d] = "xiàn"; /* 睍 */
dict[0x774e] = "xī"; /* 睎 */
dict[0x774f] = "kùn"; /* 睏 */
dict[0x7750] = "lài"; /* 睐 */
dict[0x7751] = "jiǎn"; /* 睑 */
dict[0x7752] = "shǎn"; /* 睒 */
dict[0x7753] = "tiǎn"; /* 睓 */
dict[0x7754] = "gùn"; /* 睔 */
dict[0x7755] = "wān"; /* 睕 */
dict[0x7756] = "lèng"; /* 睖 */
dict[0x7757] = "shì"; /* 睗 */
dict[0x7758] = "qióng"; /* 睘 */
dict[0x7759] = "lì"; /* 睙 */
dict[0x775a] = "yá"; /* 睚 */
dict[0x775b] = "jīng"; /* 睛 */
dict[0x775c] = "zhēng"; /* 睜 */
dict[0x775d] = "lí"; /* 睝 */
dict[0x775e] = "lài"; /* 睞 */
dict[0x775f] = "suì,zuì"; /* 睟 */
dict[0x7760] = "juàn"; /* 睠 */
dict[0x7761] = "shuì"; /* 睡 */
dict[0x7762] = "huī,suī"; /* 睢 */
dict[0x7763] = "dū"; /* 督 */
dict[0x7764] = "bì"; /* 睤 */
dict[0x7765] = "bì,pì"; /* 睥 */
dict[0x7766] = "mù"; /* 睦 */
dict[0x7767] = "hūn"; /* 睧 */
dict[0x7768] = "nì"; /* 睨 */
dict[0x7769] = "lù"; /* 睩 */
dict[0x776a] = "yì,zé,gāo"; /* 睪 */
dict[0x776b] = "jié"; /* 睫 */
dict[0x776c] = "cǎi"; /* 睬 */
dict[0x776d] = "zhǒu"; /* 睭 */
dict[0x776e] = "yú"; /* 睮 */
dict[0x776f] = "hūn"; /* 睯 */
dict[0x7770] = "mà"; /* 睰 */
dict[0x7771] = "xià"; /* 睱 */
dict[0x7772] = "xǐng,xìng"; /* 睲 */
dict[0x7773] = "huī"; /* 睳 */
dict[0x7774] = "hùn"; /* 睴 */
dict[0x7775] = "zāi"; /* 睵 */
dict[0x7776] = "chǔn"; /* 睶 */
dict[0x7777] = "jiān"; /* 睷 */
dict[0x7778] = "mèi"; /* 睸 */
dict[0x7779] = "dǔ"; /* 睹 */
dict[0x777a] = "hóu"; /* 睺 */
dict[0x777b] = "xuān"; /* 睻 */
dict[0x777c] = "tí"; /* 睼 */
dict[0x777d] = "kuí"; /* 睽 */
dict[0x777e] = "gāo"; /* 睾 */
dict[0x777f] = "ruì"; /* 睿 */
dict[0x7780] = "mào"; /* 瞀 */
dict[0x7781] = "xù"; /* 瞁 */
dict[0x7782] = "fá"; /* 瞂 */
dict[0x7783] = "wò"; /* 瞃 */
dict[0x7784] = "miáo"; /* 瞄 */
dict[0x7785] = "chǒu"; /* 瞅 */
dict[0x7786] = "guì,wèi,kuì"; /* 瞆 */
dict[0x7787] = "mī,mí"; /* 瞇 */
dict[0x7788] = "wěng"; /* 瞈 */
dict[0x7789] = "kòu,jì"; /* 瞉 */
dict[0x778a] = "dàng"; /* 瞊 */
dict[0x778b] = "chēn"; /* 瞋 */
dict[0x778c] = "kē"; /* 瞌 */
dict[0x778d] = "sǒu"; /* 瞍 */
dict[0x778e] = "xiā"; /* 瞎 */
dict[0x778f] = "qióng,huán"; /* 瞏 */
dict[0x7790] = "mò"; /* 瞐 */
dict[0x7791] = "míng"; /* 瞑 */
dict[0x7792] = "mán,mén"; /* 瞒 */
dict[0x7793] = "fèn"; /* 瞓 */
dict[0x7794] = "zé"; /* 瞔 */
dict[0x7795] = "zhàng"; /* 瞕 */
dict[0x7796] = "yì"; /* 瞖 */
dict[0x7797] = "diāo,dōu"; /* 瞗 */
dict[0x7798] = "kōu"; /* 瞘 */
dict[0x7799] = "mò"; /* 瞙 */
dict[0x779a] = "shùn"; /* 瞚 */
dict[0x779b] = "cōng"; /* 瞛 */
dict[0x779c] = "lóu,lǘ,lou"; /* 瞜 */
dict[0x779d] = "chī"; /* 瞝 */
dict[0x779e] = "mán,mén"; /* 瞞 */
dict[0x779f] = "piǎo"; /* 瞟 */
dict[0x77a0] = "chēng"; /* 瞠 */
dict[0x77a1] = "guī"; /* 瞡 */
dict[0x77a2] = "méng,měng"; /* 瞢 */
dict[0x77a3] = "wàn"; /* 瞣 */
dict[0x77a4] = "rún,shùn"; /* 瞤 */
dict[0x77a5] = "piē"; /* 瞥 */
dict[0x77a6] = "xī"; /* 瞦 */
dict[0x77a7] = "qiáo"; /* 瞧 */
dict[0x77a8] = "pú"; /* 瞨 */
dict[0x77a9] = "zhǔ"; /* 瞩 */
dict[0x77aa] = "dèng"; /* 瞪 */
dict[0x77ab] = "shěn"; /* 瞫 */
dict[0x77ac] = "shùn"; /* 瞬 */
dict[0x77ad] = "liǎo,liào"; /* 瞭 */
dict[0x77ae] = "chè"; /* 瞮 */
dict[0x77af] = "xián,jiàn"; /* 瞯 */
dict[0x77b0] = "kàn"; /* 瞰 */
dict[0x77b1] = "yè"; /* 瞱 */
dict[0x77b2] = "xuè"; /* 瞲 */
dict[0x77b3] = "tóng"; /* 瞳 */
dict[0x77b4] = "wǔ,mí"; /* 瞴 */
dict[0x77b5] = "lín"; /* 瞵 */
dict[0x77b6] = "guì,kuì"; /* 瞶 */
dict[0x77b7] = "jiàn"; /* 瞷 */
dict[0x77b8] = "yè"; /* 瞸 */
dict[0x77b9] = "ài"; /* 瞹 */
dict[0x77ba] = "huì"; /* 瞺 */
dict[0x77bb] = "zhān"; /* 瞻 */
dict[0x77bc] = "jiǎn"; /* 瞼 */
dict[0x77bd] = "gǔ"; /* 瞽 */
dict[0x77be] = "zhào"; /* 瞾 */
dict[0x77bf] = "qú,jù"; /* 瞿 */
dict[0x77c0] = "wéi"; /* 矀 */
dict[0x77c1] = "chǒu"; /* 矁 */
dict[0x77c2] = "sào"; /* 矂 */
dict[0x77c3] = "nǐng,chēng"; /* 矃 */
dict[0x77c4] = "xūn"; /* 矄 */
dict[0x77c5] = "yào"; /* 矅 */
dict[0x77c6] = "huò,yuè"; /* 矆 */
dict[0x77c7] = "mēng"; /* 矇 */
dict[0x77c8] = "mián"; /* 矈 */
dict[0x77c9] = "pín"; /* 矉 */
dict[0x77ca] = "mián"; /* 矊 */
dict[0x77cb] = "lěi"; /* 矋 */
dict[0x77cc] = "kuàng,guō"; /* 矌 */
dict[0x77cd] = "jué"; /* 矍 */
dict[0x77ce] = "xuān"; /* 矎 */
dict[0x77cf] = "mián"; /* 矏 */
dict[0x77d0] = "huò"; /* 矐 */
dict[0x77d1] = "lú"; /* 矑 */
dict[0x77d2] = "méng,měng"; /* 矒 */
dict[0x77d3] = "lóng"; /* 矓 */
dict[0x77d4] = "guàn,quán"; /* 矔 */
dict[0x77d5] = "mǎn,mán"; /* 矕 */
dict[0x77d6] = "xǐ"; /* 矖 */
dict[0x77d7] = "chù"; /* 矗 */
dict[0x77d8] = "tǎng"; /* 矘 */
dict[0x77d9] = "kàn"; /* 矙 */
dict[0x77da] = "zhǔ"; /* 矚 */
dict[0x77db] = "máo"; /* 矛 */
dict[0x77dc] = "jīn,qín,guān"; /* 矜 */
dict[0x77dd] = "jīn,qín,guān"; /* 矝 */
dict[0x77de] = "yù,xù,jué"; /* 矞 */
dict[0x77df] = "shuò"; /* 矟 */
dict[0x77e0] = "zé"; /* 矠 */
dict[0x77e1] = "jué"; /* 矡 */
dict[0x77e2] = "shǐ"; /* 矢 */
dict[0x77e3] = "yǐ"; /* 矣 */
dict[0x77e4] = "shěn"; /* 矤 */
dict[0x77e5] = "zhī,zhì"; /* 知 */
dict[0x77e6] = "hóu,hòu"; /* 矦 */
dict[0x77e7] = "shěn"; /* 矧 */
dict[0x77e8] = "yǐng"; /* 矨 */
dict[0x77e9] = "jǔ"; /* 矩 */
dict[0x77ea] = "zhōu"; /* 矪 */
dict[0x77eb] = "jiǎo,jiáo"; /* 矫 */
dict[0x77ec] = "cuó"; /* 矬 */
dict[0x77ed] = "duǎn"; /* 短 */
dict[0x77ee] = "ǎi"; /* 矮 */
dict[0x77ef] = "jiǎo,jiáo"; /* 矯 */
dict[0x77f0] = "zēng"; /* 矰 */
dict[0x77f1] = "yuē"; /* 矱 */
dict[0x77f2] = "bà"; /* 矲 */
dict[0x77f3] = "shí,dàn"; /* 石 */
dict[0x77f4] = "dìng"; /* 矴 */
dict[0x77f5] = "qì"; /* 矵 */
dict[0x77f6] = "jī"; /* 矶 */
dict[0x77f7] = "zǐ"; /* 矷 */
dict[0x77f8] = "gān"; /* 矸 */
dict[0x77f9] = "wù"; /* 矹 */
dict[0x77fa] = "zhé"; /* 矺 */
dict[0x77fb] = "kū"; /* 矻 */
dict[0x77fc] = "gāng,qiāng,kòng"; /* 矼 */
dict[0x77fd] = "xī"; /* 矽 */
dict[0x77fe] = "fán"; /* 矾 */
dict[0x77ff] = "kuàng"; /* 矿 */
dict[0x7800] = "dàng"; /* 砀 */
dict[0x7801] = "mǎ"; /* 码 */
dict[0x7802] = "shā"; /* 砂 */
dict[0x7803] = "dān"; /* 砃 */
dict[0x7804] = "jué"; /* 砄 */
dict[0x7805] = "lì"; /* 砅 */
dict[0x7806] = "fū"; /* 砆 */
dict[0x7807] = "mín"; /* 砇 */
dict[0x7808] = "è"; /* 砈 */
dict[0x7809] = "xū,huā"; /* 砉 */
dict[0x780a] = "kāng"; /* 砊 */
dict[0x780b] = "zhǐ"; /* 砋 */
dict[0x780c] = "qì,qiè"; /* 砌 */
dict[0x780d] = "kǎn"; /* 砍 */
dict[0x780e] = "jiè"; /* 砎 */
dict[0x780f] = "pīn,bīn,fēn"; /* 砏 */
dict[0x7810] = "è"; /* 砐 */
dict[0x7811] = "yà"; /* 砑 */
dict[0x7812] = "pī"; /* 砒 */
dict[0x7813] = "zhé"; /* 砓 */
dict[0x7814] = "yán,yàn"; /* 研 */
dict[0x7815] = "suì"; /* 砕 */
dict[0x7816] = "zhuān"; /* 砖 */
dict[0x7817] = "chē"; /* 砗 */
dict[0x7818] = "dùn"; /* 砘 */
dict[0x7819] = "wǎ"; /* 砙 */
dict[0x781a] = "yàn"; /* 砚 */
dict[0x781b] = "jīn"; /* 砛 */
dict[0x781c] = "fēng"; /* 砜 */
dict[0x781d] = "fǎ"; /* 砝 */
dict[0x781e] = "mò"; /* 砞 */
dict[0x781f] = "zhǎ"; /* 砟 */
dict[0x7820] = "jū"; /* 砠 */
dict[0x7821] = "yù"; /* 砡 */
dict[0x7822] = "kē,luǒ"; /* 砢 */
dict[0x7823] = "tuó"; /* 砣 */
dict[0x7824] = "tuó"; /* 砤 */
dict[0x7825] = "dǐ"; /* 砥 */
dict[0x7826] = "zhài"; /* 砦 */
dict[0x7827] = "zhēn"; /* 砧 */
dict[0x7828] = "ě"; /* 砨 */
dict[0x7829] = "fú,fèi"; /* 砩 */
dict[0x782a] = "mǔ"; /* 砪 */
dict[0x782b] = "zhù,zhǔ"; /* 砫 */
dict[0x782c] = "lì,lā,lá"; /* 砬 */
dict[0x782d] = "biān"; /* 砭 */
dict[0x782e] = "nǔ"; /* 砮 */
dict[0x782f] = "pīng"; /* 砯 */
dict[0x7830] = "pēng"; /* 砰 */
dict[0x7831] = "líng"; /* 砱 */
dict[0x7832] = "pào"; /* 砲 */
dict[0x7833] = "lè"; /* 砳 */
dict[0x7834] = "pò"; /* 破 */
dict[0x7835] = "bō"; /* 砵 */
dict[0x7836] = "pò"; /* 砶 */
dict[0x7837] = "shēn"; /* 砷 */
dict[0x7838] = "zá"; /* 砸 */
dict[0x7839] = "ài"; /* 砹 */
dict[0x783a] = "lì"; /* 砺 */
dict[0x783b] = "lóng"; /* 砻 */
dict[0x783c] = "tóng"; /* 砼 */
dict[0x783d] = "yòng"; /* 砽 */
dict[0x783e] = "lì"; /* 砾 */
dict[0x783f] = "kuàng"; /* 砿 */
dict[0x7840] = "chǔ"; /* 础 */
dict[0x7841] = "kēng"; /* 硁 */
dict[0x7842] = "quán"; /* 硂 */
dict[0x7843] = "zhū"; /* 硃 */
dict[0x7844] = "kuāng,guāng"; /* 硄 */
dict[0x7845] = "guī"; /* 硅 */
dict[0x7846] = "è"; /* 硆 */
dict[0x7847] = "náo"; /* 硇 */
dict[0x7848] = "qià"; /* 硈 */
dict[0x7849] = "lù"; /* 硉 */
dict[0x784a] = "wěi,guì"; /* 硊 */
dict[0x784b] = "ài"; /* 硋 */
dict[0x784c] = "luò,gè"; /* 硌 */
dict[0x784d] = "kèn,xiàn,gǔn,yǐn"; /* 硍 */
dict[0x784e] = "xíng"; /* 硎 */
dict[0x784f] = "yán,yàn"; /* 硏 */
dict[0x7850] = "dòng"; /* 硐 */
dict[0x7851] = "pēng,píng"; /* 硑 */
dict[0x7852] = "xī"; /* 硒 */
dict[0x7853] = "lǎo"; /* 硓 */
dict[0x7854] = "hóng"; /* 硔 */
dict[0x7855] = "shuò,shí"; /* 硕 */
dict[0x7856] = "xiá"; /* 硖 */
dict[0x7857] = "qiāo"; /* 硗 */
dict[0x7858] = "qíng"; /* 硘 */
dict[0x7859] = "wéi,wèi"; /* 硙 */
dict[0x785a] = "qiáo"; /* 硚 */
dict[0x785c] = "kēng"; /* 硜 */
dict[0x785d] = "xiāo"; /* 硝 */
dict[0x785e] = "què,kè,kù"; /* 硞 */
dict[0x785f] = "chàn"; /* 硟 */
dict[0x7860] = "láng"; /* 硠 */
dict[0x7861] = "hōng"; /* 硡 */
dict[0x7862] = "yù"; /* 硢 */
dict[0x7863] = "xiāo"; /* 硣 */
dict[0x7864] = "xiá"; /* 硤 */
dict[0x7865] = "mǎng,bàng"; /* 硥 */
dict[0x7866] = "luò,lòng"; /* 硦 */
dict[0x7867] = "yǒng,tóng"; /* 硧 */
dict[0x7868] = "chē"; /* 硨 */
dict[0x7869] = "chè"; /* 硩 */
dict[0x786a] = "wò"; /* 硪 */
dict[0x786b] = "liú"; /* 硫 */
dict[0x786c] = "yìng"; /* 硬 */
dict[0x786d] = "máng"; /* 硭 */
dict[0x786e] = "què"; /* 确 */
dict[0x786f] = "yàn"; /* 硯 */
dict[0x7870] = "shā"; /* 硰 */
dict[0x7871] = "kǔn"; /* 硱 */
dict[0x7872] = "yù"; /* 硲 */
dict[0x7874] = "huā"; /* 硴 */
dict[0x7875] = "lǔ"; /* 硵 */
dict[0x7876] = "chěn"; /* 硶 */
dict[0x7877] = "jiǎn"; /* 硷 */
dict[0x7878] = "nüè"; /* 硸 */
dict[0x7879] = "sōng"; /* 硹 */
dict[0x787a] = "zhuó"; /* 硺 */
dict[0x787b] = "kēng,kěng"; /* 硻 */
dict[0x787c] = "péng"; /* 硼 */
dict[0x787d] = "yān,yǎn"; /* 硽 */
dict[0x787e] = "zhuì,chuí,duǒ"; /* 硾 */
dict[0x787f] = "kōng"; /* 硿 */
dict[0x7880] = "chēng"; /* 碀 */
dict[0x7881] = "qí"; /* 碁 */
dict[0x7882] = "zòng,cóng"; /* 碂 */
dict[0x7883] = "qìng"; /* 碃 */
dict[0x7884] = "lín"; /* 碄 */
dict[0x7885] = "jūn"; /* 碅 */
dict[0x7886] = "bō"; /* 碆 */
dict[0x7887] = "dìng"; /* 碇 */
dict[0x7888] = "mín"; /* 碈 */
dict[0x7889] = "diāo"; /* 碉 */
dict[0x788a] = "jiān,zhàn"; /* 碊 */
dict[0x788b] = "hè"; /* 碋 */
dict[0x788c] = "lù,liù"; /* 碌 */
dict[0x788d] = "ài"; /* 碍 */
dict[0x788e] = "suì"; /* 碎 */
dict[0x788f] = "què,xī"; /* 碏 */
dict[0x7890] = "léng"; /* 碐 */
dict[0x7891] = "bēi"; /* 碑 */
dict[0x7892] = "yín"; /* 碒 */
dict[0x7893] = "duì"; /* 碓 */
dict[0x7894] = "wǔ"; /* 碔 */
dict[0x7895] = "qí"; /* 碕 */
dict[0x7896] = "lún,lǔn,lùn"; /* 碖 */
dict[0x7897] = "wǎn"; /* 碗 */
dict[0x7898] = "diǎn"; /* 碘 */
dict[0x7899] = "náo,gāng"; /* 碙 */
dict[0x789a] = "bèi"; /* 碚 */
dict[0x789b] = "qì"; /* 碛 */
dict[0x789c] = "chěn"; /* 碜 */
dict[0x789d] = "ruǎn"; /* 碝 */
dict[0x789e] = "yán"; /* 碞 */
dict[0x789f] = "dié"; /* 碟 */
dict[0x78a0] = "dìng"; /* 碠 */
dict[0x78a1] = "zhóu"; /* 碡 */
dict[0x78a2] = "tuó"; /* 碢 */
dict[0x78a3] = "jié,yà"; /* 碣 */
dict[0x78a4] = "yīng"; /* 碤 */
dict[0x78a5] = "biǎn"; /* 碥 */
dict[0x78a6] = "kè"; /* 碦 */
dict[0x78a7] = "bì"; /* 碧 */
dict[0x78a8] = "wěi,wèi"; /* 碨 */
dict[0x78a9] = "shuò,shí"; /* 碩 */
dict[0x78aa] = "zhēn"; /* 碪 */
dict[0x78ab] = "duàn"; /* 碫 */
dict[0x78ac] = "xiá"; /* 碬 */
dict[0x78ad] = "dàng"; /* 碭 */
dict[0x78ae] = "tí,dī"; /* 碮 */
dict[0x78af] = "nǎo"; /* 碯 */
dict[0x78b0] = "pèng"; /* 碰 */
dict[0x78b1] = "jiǎn"; /* 碱 */
dict[0x78b2] = "dì"; /* 碲 */
dict[0x78b3] = "tàn"; /* 碳 */
dict[0x78b4] = "chá,chā"; /* 碴 */
dict[0x78b5] = "tián"; /* 碵 */
dict[0x78b6] = "qì"; /* 碶 */
dict[0x78b7] = "dùn"; /* 碷 */
dict[0x78b8] = "fēng"; /* 碸 */
dict[0x78b9] = "xuàn"; /* 碹 */
dict[0x78ba] = "què"; /* 確 */
dict[0x78bb] = "què,qiāo"; /* 碻 */
dict[0x78bc] = "mǎ"; /* 碼 */
dict[0x78bd] = "gōng"; /* 碽 */
dict[0x78be] = "niǎn"; /* 碾 */
dict[0x78bf] = "sù,xiè"; /* 碿 */
dict[0x78c0] = "é"; /* 磀 */
dict[0x78c1] = "cí"; /* 磁 */
dict[0x78c2] = "liú,liù"; /* 磂 */
dict[0x78c3] = "sī,tí"; /* 磃 */
dict[0x78c4] = "táng"; /* 磄 */
dict[0x78c5] = "bàng,páng"; /* 磅 */
dict[0x78c6] = "huá,kě,gū"; /* 磆 */
dict[0x78c7] = "pī"; /* 磇 */
dict[0x78c8] = "kuǐ,wěi"; /* 磈 */
dict[0x78c9] = "sǎng"; /* 磉 */
dict[0x78ca] = "lěi"; /* 磊 */
dict[0x78cb] = "cuō"; /* 磋 */
dict[0x78cc] = "tián"; /* 磌 */
dict[0x78cd] = "xiá,qià,yà"; /* 磍 */
dict[0x78ce] = "xī"; /* 磎 */
dict[0x78cf] = "lián,qiān"; /* 磏 */
dict[0x78d0] = "pán"; /* 磐 */
dict[0x78d1] = "ái,wèi"; /* 磑 */
dict[0x78d2] = "yǔn"; /* 磒 */
dict[0x78d3] = "duī"; /* 磓 */
dict[0x78d4] = "zhé"; /* 磔 */
dict[0x78d5] = "kē"; /* 磕 */
dict[0x78d6] = "lá,lā"; /* 磖 */
dict[0x78d7] = "zhuān"; /* 磗 */
dict[0x78d8] = "yáo"; /* 磘 */
dict[0x78d9] = "gǔn"; /* 磙 */
dict[0x78da] = "zhuān"; /* 磚 */
dict[0x78db] = "chán"; /* 磛 */
dict[0x78dc] = "qì"; /* 磜 */
dict[0x78dd] = "áo,qiāo"; /* 磝 */
dict[0x78de] = "pēng,pèng"; /* 磞 */
dict[0x78df] = "liù"; /* 磟 */
dict[0x78e0] = "lǔ"; /* 磠 */
dict[0x78e1] = "kàn"; /* 磡 */
dict[0x78e2] = "chuǎng"; /* 磢 */
dict[0x78e3] = "chěn"; /* 磣 */
dict[0x78e4] = "yīn,yǐn"; /* 磤 */
dict[0x78e5] = "lěi,léi"; /* 磥 */
dict[0x78e6] = "biāo"; /* 磦 */
dict[0x78e7] = "qì"; /* 磧 */
dict[0x78e8] = "mó,mò"; /* 磨 */
dict[0x78e9] = "qì,zhú"; /* 磩 */
dict[0x78ea] = "cuī"; /* 磪 */
dict[0x78eb] = "zōng"; /* 磫 */
dict[0x78ec] = "qìng"; /* 磬 */
dict[0x78ed] = "chuò"; /* 磭 */
dict[0x78ee] = "lún"; /* 磮 */
dict[0x78ef] = "jī"; /* 磯 */
dict[0x78f0] = "shàn"; /* 磰 */
dict[0x78f1] = "láo,luò"; /* 磱 */
dict[0x78f2] = "qú"; /* 磲 */
dict[0x78f3] = "zēng"; /* 磳 */
dict[0x78f4] = "dèng"; /* 磴 */
dict[0x78f5] = "jiàn"; /* 磵 */
dict[0x78f6] = "xì"; /* 磶 */
dict[0x78f7] = "lín"; /* 磷 */
dict[0x78f8] = "dìng"; /* 磸 */
dict[0x78f9] = "diàn"; /* 磹 */
dict[0x78fa] = "huáng"; /* 磺 */
dict[0x78fb] = "pán,bō"; /* 磻 */
dict[0x78fc] = "jí,shé"; /* 磼 */
dict[0x78fd] = "qiāo"; /* 磽 */
dict[0x78fe] = "dī"; /* 磾 */
dict[0x78ff] = "lì"; /* 磿 */
dict[0x7900] = "jiàn"; /* 礀 */
dict[0x7901] = "jiāo"; /* 礁 */
dict[0x7902] = "xī"; /* 礂 */
dict[0x7903] = "zhǎng"; /* 礃 */
dict[0x7904] = "qiáo"; /* 礄 */
dict[0x7905] = "dūn"; /* 礅 */
dict[0x7906] = "jiǎn"; /* 礆 */
dict[0x7907] = "yù"; /* 礇 */
dict[0x7908] = "zhuì"; /* 礈 */
dict[0x7909] = "hé,qiāo,qiào"; /* 礉 */
dict[0x790a] = "kè,huò"; /* 礊 */
dict[0x790b] = "zé"; /* 礋 */
dict[0x790c] = "léi,lěi"; /* 礌 */
dict[0x790d] = "jié"; /* 礍 */
dict[0x790e] = "chǔ"; /* 礎 */
dict[0x790f] = "yè"; /* 礏 */
dict[0x7910] = "què,hú"; /* 礐 */
dict[0x7911] = "dàng"; /* 礑 */
dict[0x7912] = "yǐ"; /* 礒 */
dict[0x7913] = "jiāng"; /* 礓 */
dict[0x7914] = "pī"; /* 礔 */
dict[0x7915] = "pī"; /* 礕 */
dict[0x7916] = "yù"; /* 礖 */
dict[0x7917] = "pīn"; /* 礗 */
dict[0x7918] = "è,qì"; /* 礘 */
dict[0x7919] = "ài"; /* 礙 */
dict[0x791a] = "kē"; /* 礚 */
dict[0x791b] = "jiān"; /* 礛 */
dict[0x791c] = "yù"; /* 礜 */
dict[0x791d] = "ruǎn"; /* 礝 */
dict[0x791e] = "méng"; /* 礞 */
dict[0x791f] = "pào"; /* 礟 */
dict[0x7920] = "cí"; /* 礠 */
dict[0x7921] = "bō"; /* 礡 */
dict[0x7922] = "yǎng"; /* 礢 */
dict[0x7923] = "miè"; /* 礣 */
dict[0x7924] = "cǎ"; /* 礤 */
dict[0x7925] = "xián,xín"; /* 礥 */
dict[0x7926] = "kuàng"; /* 礦 */
dict[0x7927] = "léi,lěi,lèi"; /* 礧 */
dict[0x7928] = "lěi"; /* 礨 */
dict[0x7929] = "zhì"; /* 礩 */
dict[0x792a] = "lì"; /* 礪 */
dict[0x792b] = "lì"; /* 礫 */
dict[0x792c] = "fán"; /* 礬 */
dict[0x792d] = "què"; /* 礭 */
dict[0x792e] = "pào"; /* 礮 */
dict[0x792f] = "yīng"; /* 礯 */
dict[0x7930] = "lì"; /* 礰 */
dict[0x7931] = "lóng"; /* 礱 */
dict[0x7932] = "lóng"; /* 礲 */
dict[0x7933] = "mò"; /* 礳 */
dict[0x7934] = "bó"; /* 礴 */
dict[0x7935] = "shuāng"; /* 礵 */
dict[0x7936] = "guàn"; /* 礶 */
dict[0x7937] = "jiān"; /* 礷 */
dict[0x7938] = "cǎ"; /* 礸 */
dict[0x7939] = "yán,yǎn"; /* 礹 */
dict[0x793a] = "shì"; /* 示 */
dict[0x793b] = "shì"; /* 礻 */
dict[0x793c] = "lǐ"; /* 礼 */
dict[0x793d] = "réng"; /* 礽 */
dict[0x793e] = "shè"; /* 社 */
dict[0x793f] = "yuè"; /* 礿 */
dict[0x7940] = "sì"; /* 祀 */
dict[0x7941] = "qí"; /* 祁 */
dict[0x7942] = "tā"; /* 祂 */
dict[0x7943] = "mà"; /* 祃 */
dict[0x7944] = "xiè"; /* 祄 */
dict[0x7945] = "yāo"; /* 祅 */
dict[0x7946] = "xiān"; /* 祆 */
dict[0x7947] = "zhǐ,qí"; /* 祇 */
dict[0x7948] = "qí"; /* 祈 */
dict[0x7949] = "zhǐ"; /* 祉 */
dict[0x794a] = "bēng,fāng"; /* 祊 */
dict[0x794b] = "duì"; /* 祋 */
dict[0x794c] = "zhòng"; /* 祌 */
dict[0x794d] = "rèn"; /* 祍 */
dict[0x794e] = "yī"; /* 祎 */
dict[0x794f] = "shí"; /* 祏 */
dict[0x7950] = "yòu"; /* 祐 */
dict[0x7951] = "zhì"; /* 祑 */
dict[0x7952] = "tiáo"; /* 祒 */
dict[0x7953] = "fú"; /* 祓 */
dict[0x7954] = "fù"; /* 祔 */
dict[0x7955] = "mì,bì"; /* 祕 */
dict[0x7956] = "zǔ"; /* 祖 */
dict[0x7957] = "zhī"; /* 祗 */
dict[0x7958] = "suàn"; /* 祘 */
dict[0x7959] = "mèi"; /* 祙 */
dict[0x795a] = "zuò"; /* 祚 */
dict[0x795b] = "qū"; /* 祛 */
dict[0x795c] = "hù"; /* 祜 */
dict[0x795d] = "zhù"; /* 祝 */
dict[0x795e] = "shén"; /* 神 */
dict[0x795f] = "suì"; /* 祟 */
dict[0x7960] = "cí"; /* 祠 */
dict[0x7961] = "chái"; /* 祡 */
dict[0x7962] = "mí"; /* 祢 */
dict[0x7963] = "lǚ"; /* 祣 */
dict[0x7964] = "yǔ"; /* 祤 */
dict[0x7965] = "xiáng"; /* 祥 */
dict[0x7966] = "wú"; /* 祦 */
dict[0x7967] = "tiāo"; /* 祧 */
dict[0x7968] = "piào,piāo"; /* 票 */
dict[0x7969] = "zhù"; /* 祩 */
dict[0x796a] = "guǐ"; /* 祪 */
dict[0x796b] = "xiá"; /* 祫 */
dict[0x796c] = "zhī"; /* 祬 */
dict[0x796d] = "jì,zhài"; /* 祭 */
dict[0x796e] = "gào"; /* 祮 */
dict[0x796f] = "zhēn"; /* 祯 */
dict[0x7970] = "gào"; /* 祰 */
dict[0x7971] = "shuì,lèi"; /* 祱 */
dict[0x7972] = "jìn"; /* 祲 */
dict[0x7973] = "shèn"; /* 祳 */
dict[0x7974] = "gāi"; /* 祴 */
dict[0x7975] = "kǔn"; /* 祵 */
dict[0x7976] = "dì"; /* 祶 */
dict[0x7977] = "dǎo"; /* 祷 */
dict[0x7978] = "huò"; /* 祸 */
dict[0x7979] = "táo"; /* 祹 */
dict[0x797a] = "qí"; /* 祺 */
dict[0x797b] = "gù"; /* 祻 */
dict[0x797c] = "guàn"; /* 祼 */
dict[0x797d] = "zuì"; /* 祽 */
dict[0x797e] = "líng"; /* 祾 */
dict[0x797f] = "lù"; /* 祿 */
dict[0x7980] = "bǐng"; /* 禀 */
dict[0x7981] = "jīn,jìn"; /* 禁 */
dict[0x7982] = "dǎo"; /* 禂 */
dict[0x7983] = "zhí"; /* 禃 */
dict[0x7984] = "lù"; /* 禄 */
dict[0x7985] = "chán,shàn"; /* 禅 */
dict[0x7986] = "bì,pí"; /* 禆 */
dict[0x7987] = "chǔ"; /* 禇 */
dict[0x7988] = "huī"; /* 禈 */
dict[0x7989] = "yǒu"; /* 禉 */
dict[0x798a] = "xì"; /* 禊 */
dict[0x798b] = "yīn"; /* 禋 */
dict[0x798c] = "zī"; /* 禌 */
dict[0x798d] = "huò"; /* 禍 */
dict[0x798e] = "zhēn"; /* 禎 */
dict[0x798f] = "fú"; /* 福 */
dict[0x7990] = "yuàn"; /* 禐 */
dict[0x7991] = "xú"; /* 禑 */
dict[0x7992] = "xiǎn"; /* 禒 */
dict[0x7993] = "shāng,yáng"; /* 禓 */
dict[0x7994] = "tí,zhǐ"; /* 禔 */
dict[0x7995] = "yī"; /* 禕 */
dict[0x7996] = "méi"; /* 禖 */
dict[0x7997] = "sī"; /* 禗 */
dict[0x7998] = "dì"; /* 禘 */
dict[0x7999] = "bèi"; /* 禙 */
dict[0x799a] = "zhuó"; /* 禚 */
dict[0x799b] = "zhēn"; /* 禛 */
dict[0x799c] = "yíng"; /* 禜 */
dict[0x799d] = "jì"; /* 禝 */
dict[0x799e] = "gào"; /* 禞 */
dict[0x799f] = "táng"; /* 禟 */
dict[0x79a0] = "sī"; /* 禠 */
dict[0x79a1] = "mà"; /* 禡 */
dict[0x79a2] = "tà"; /* 禢 */
dict[0x79a3] = "fù"; /* 禣 */
dict[0x79a4] = "xuān"; /* 禤 */
dict[0x79a5] = "qí"; /* 禥 */
dict[0x79a6] = "yù"; /* 禦 */
dict[0x79a7] = "xǐ"; /* 禧 */
dict[0x79a8] = "jī,jì"; /* 禨 */
dict[0x79a9] = "sì"; /* 禩 */
dict[0x79aa] = "shàn,chán"; /* 禪 */
dict[0x79ab] = "dàn"; /* 禫 */
dict[0x79ac] = "guì"; /* 禬 */
dict[0x79ad] = "suì"; /* 禭 */
dict[0x79ae] = "lǐ"; /* 禮 */
dict[0x79af] = "nóng"; /* 禯 */
dict[0x79b0] = "mí"; /* 禰 */
dict[0x79b1] = "dǎo"; /* 禱 */
dict[0x79b2] = "lì"; /* 禲 */
dict[0x79b3] = "ráng"; /* 禳 */
dict[0x79b4] = "yuè"; /* 禴 */
dict[0x79b5] = "tí"; /* 禵 */
dict[0x79b6] = "zàn"; /* 禶 */
dict[0x79b7] = "lèi"; /* 禷 */
dict[0x79b8] = "róu"; /* 禸 */
dict[0x79b9] = "yǔ"; /* 禹 */
dict[0x79ba] = "yú,yù,ǒu"; /* 禺 */
dict[0x79bb] = "lí"; /* 离 */
dict[0x79bc] = "xiè"; /* 禼 */
dict[0x79bd] = "qín"; /* 禽 */
dict[0x79be] = "hé"; /* 禾 */
dict[0x79bf] = "tū"; /* 禿 */
dict[0x79c0] = "xiù"; /* 秀 */
dict[0x79c1] = "sī"; /* 私 */
dict[0x79c2] = "rén"; /* 秂 */
dict[0x79c3] = "tū"; /* 秃 */
dict[0x79c4] = "zǐ,zì"; /* 秄 */
dict[0x79c5] = "chá,ná"; /* 秅 */
dict[0x79c6] = "gǎn"; /* 秆 */
dict[0x79c7] = "yì,zhí"; /* 秇 */
dict[0x79c8] = "xiān"; /* 秈 */
dict[0x79c9] = "bǐng"; /* 秉 */
dict[0x79ca] = "nián"; /* 秊 */
dict[0x79cb] = "qiū"; /* 秋 */
dict[0x79cc] = "qiū"; /* 秌 */
dict[0x79cd] = "zhǒng,zhòng,chóng"; /* 种 */
dict[0x79ce] = "fèn"; /* 秎 */
dict[0x79cf] = "hào,mào"; /* 秏 */
dict[0x79d0] = "yún"; /* 秐 */
dict[0x79d1] = "kē"; /* 科 */
dict[0x79d2] = "miǎo"; /* 秒 */
dict[0x79d3] = "zhī"; /* 秓 */
dict[0x79d4] = "jīng"; /* 秔 */
dict[0x79d5] = "bǐ"; /* 秕 */
dict[0x79d6] = "zhǐ"; /* 秖 */
dict[0x79d7] = "yù"; /* 秗 */
dict[0x79d8] = "mì,bì"; /* 秘 */
dict[0x79d9] = "kù,kū"; /* 秙 */
dict[0x79da] = "bàn"; /* 秚 */
dict[0x79db] = "pī"; /* 秛 */
dict[0x79dc] = "ní,nì"; /* 秜 */
dict[0x79dd] = "lì"; /* 秝 */
dict[0x79de] = "yóu"; /* 秞 */
dict[0x79df] = "zū"; /* 租 */
dict[0x79e0] = "pī"; /* 秠 */
dict[0x79e1] = "bó"; /* 秡 */
dict[0x79e2] = "líng"; /* 秢 */
dict[0x79e3] = "mò"; /* 秣 */
dict[0x79e4] = "chèng"; /* 秤 */
dict[0x79e5] = "nián"; /* 秥 */
dict[0x79e6] = "qín"; /* 秦 */
dict[0x79e7] = "yāng"; /* 秧 */
dict[0x79e8] = "zuó"; /* 秨 */
dict[0x79e9] = "zhì"; /* 秩 */
dict[0x79ea] = "dī"; /* 秪 */
dict[0x79eb] = "shú"; /* 秫 */
dict[0x79ec] = "jù"; /* 秬 */
dict[0x79ed] = "zǐ"; /* 秭 */
dict[0x79ee] = "huó,kuò"; /* 秮 */
dict[0x79ef] = "jī"; /* 积 */
dict[0x79f0] = "chēng,chèn,chèng"; /* 称 */
dict[0x79f1] = "tóng"; /* 秱 */
dict[0x79f2] = "shì,zhì"; /* 秲 */
dict[0x79f3] = "huó,kuò"; /* 秳 */
dict[0x79f4] = "huō"; /* 秴 */
dict[0x79f5] = "yīn"; /* 秵 */
dict[0x79f6] = "zī"; /* 秶 */
dict[0x79f7] = "zhì"; /* 秷 */
dict[0x79f8] = "jiē"; /* 秸 */
dict[0x79f9] = "rěn"; /* 秹 */
dict[0x79fa] = "dù"; /* 秺 */
dict[0x79fb] = "yí"; /* 移 */
dict[0x79fc] = "zhū"; /* 秼 */
dict[0x79fd] = "huì"; /* 秽 */
dict[0x79fe] = "nóng"; /* 秾 */
dict[0x79ff] = "fù,pū"; /* 秿 */
dict[0x7a00] = "xī"; /* 稀 */
dict[0x7a01] = "gǎo"; /* 稁 */
dict[0x7a02] = "láng"; /* 稂 */
dict[0x7a03] = "fū"; /* 稃 */
dict[0x7a04] = "xùn,zè"; /* 稄 */
dict[0x7a05] = "shuì"; /* 稅 */
dict[0x7a06] = "lǚ"; /* 稆 */
dict[0x7a07] = "kǔn"; /* 稇 */
dict[0x7a08] = "gǎn"; /* 稈 */
dict[0x7a09] = "jīng"; /* 稉 */
dict[0x7a0a] = "tí"; /* 稊 */
dict[0x7a0b] = "chéng"; /* 程 */
dict[0x7a0c] = "tú,shǔ"; /* 稌 */
dict[0x7a0d] = "shāo,shào"; /* 稍 */
dict[0x7a0e] = "shuì"; /* 税 */
dict[0x7a0f] = "yà"; /* 稏 */
dict[0x7a10] = "lǔn"; /* 稐 */
dict[0x7a11] = "lù"; /* 稑 */
dict[0x7a12] = "gū"; /* 稒 */
dict[0x7a13] = "zuó"; /* 稓 */
dict[0x7a14] = "rěn"; /* 稔 */
dict[0x7a15] = "zhùn,zhǔn"; /* 稕 */
dict[0x7a16] = "bàng"; /* 稖 */
dict[0x7a17] = "bài"; /* 稗 */
dict[0x7a18] = "jī,qí"; /* 稘 */
dict[0x7a19] = "zhī"; /* 稙 */
dict[0x7a1a] = "zhì"; /* 稚 */
dict[0x7a1b] = "kǔn"; /* 稛 */
dict[0x7a1c] = "léng,lēng,líng"; /* 稜 */
dict[0x7a1d] = "péng"; /* 稝 */
dict[0x7a1e] = "kē"; /* 稞 */
dict[0x7a1f] = "bǐng"; /* 稟 */
dict[0x7a20] = "chóu"; /* 稠 */
dict[0x7a21] = "zuì,zú,sū"; /* 稡 */
dict[0x7a22] = "yù"; /* 稢 */
dict[0x7a23] = "sū"; /* 稣 */
dict[0x7a24] = "lüè"; /* 稤 */
dict[0x7a25] = "xiāng"; /* 稥 */
dict[0x7a26] = "yī"; /* 稦 */
dict[0x7a27] = "xì,qiè"; /* 稧 */
dict[0x7a28] = "biǎn"; /* 稨 */
dict[0x7a29] = "jì"; /* 稩 */
dict[0x7a2a] = "fú"; /* 稪 */
dict[0x7a2b] = "pì,bì"; /* 稫 */
dict[0x7a2c] = "nuò"; /* 稬 */
dict[0x7a2d] = "jiē"; /* 稭 */
dict[0x7a2e] = "zhǒng,zhòng"; /* 種 */
dict[0x7a2f] = "zōng,zǒng"; /* 稯 */
dict[0x7a30] = "xǔ,xū"; /* 稰 */
dict[0x7a31] = "chēng,chèn,chèng"; /* 稱 */
dict[0x7a32] = "dào"; /* 稲 */
dict[0x7a33] = "wěn"; /* 稳 */
dict[0x7a34] = "xián,jiān,liàn"; /* 稴 */
dict[0x7a35] = "zī,jiū"; /* 稵 */
dict[0x7a36] = "yù"; /* 稶 */
dict[0x7a37] = "jì"; /* 稷 */
dict[0x7a38] = "xù"; /* 稸 */
dict[0x7a39] = "zhěn"; /* 稹 */
dict[0x7a3a] = "zhì"; /* 稺 */
dict[0x7a3b] = "dào"; /* 稻 */
dict[0x7a3c] = "jià"; /* 稼 */
dict[0x7a3d] = "jī,qǐ"; /* 稽 */
dict[0x7a3e] = "gǎo"; /* 稾 */
dict[0x7a3f] = "gǎo"; /* 稿 */
dict[0x7a40] = "gǔ"; /* 穀 */
dict[0x7a41] = "róng"; /* 穁 */
dict[0x7a42] = "suì"; /* 穂 */
dict[0x7a43] = "ròng"; /* 穃 */
dict[0x7a44] = "jì"; /* 穄 */
dict[0x7a45] = "kāng"; /* 穅 */
dict[0x7a46] = "mù"; /* 穆 */
dict[0x7a47] = "cǎn,shān,cēn"; /* 穇 */
dict[0x7a48] = "mén,méi"; /* 穈 */
dict[0x7a49] = "zhì"; /* 穉 */
dict[0x7a4a] = "jì"; /* 穊 */
dict[0x7a4b] = "lù"; /* 穋 */
dict[0x7a4c] = "sū"; /* 穌 */
dict[0x7a4d] = "jī"; /* 積 */
dict[0x7a4e] = "yǐng"; /* 穎 */
dict[0x7a4f] = "wěn"; /* 穏 */
dict[0x7a50] = "qiū"; /* 穐 */
dict[0x7a51] = "sè"; /* 穑 */
dict[0x7a53] = "yì"; /* 穓 */
dict[0x7a54] = "huáng"; /* 穔 */
dict[0x7a55] = "qiè"; /* 穕 */
dict[0x7a56] = "jǐ,jì"; /* 穖 */
dict[0x7a57] = "suì"; /* 穗 */
dict[0x7a58] = "xiāo,rào"; /* 穘 */
dict[0x7a59] = "pú"; /* 穙 */
dict[0x7a5a] = "jiāo"; /* 穚 */
dict[0x7a5b] = "zhuō,bó"; /* 穛 */
dict[0x7a5c] = "tóng,zhǒng"; /* 穜 */
dict[0x7a5d] = "zuō"; /* 穝 */
dict[0x7a5e] = "lǔ"; /* 穞 */
dict[0x7a5f] = "suì"; /* 穟 */
dict[0x7a60] = "nóng"; /* 穠 */
dict[0x7a61] = "sè"; /* 穡 */
dict[0x7a62] = "huì"; /* 穢 */
dict[0x7a63] = "ráng"; /* 穣 */
dict[0x7a64] = "nuò"; /* 穤 */
dict[0x7a65] = "yǔ"; /* 穥 */
dict[0x7a66] = "pīn"; /* 穦 */
dict[0x7a67] = "jì"; /* 穧 */
dict[0x7a68] = "tuí"; /* 穨 */
dict[0x7a69] = "wěn"; /* 穩 */
dict[0x7a6a] = "chēng,chèn,chèng"; /* 穪 */
dict[0x7a6b] = "huò"; /* 穫 */
dict[0x7a6c] = "kuàng"; /* 穬 */
dict[0x7a6d] = "lǚ"; /* 穭 */
dict[0x7a6e] = "biāo,pāo"; /* 穮 */
dict[0x7a6f] = "sè"; /* 穯 */
dict[0x7a70] = "ráng"; /* 穰 */
dict[0x7a71] = "zhuō,jué"; /* 穱 */
dict[0x7a72] = "lí"; /* 穲 */
dict[0x7a73] = "cuán,zàn"; /* 穳 */
dict[0x7a74] = "xué"; /* 穴 */
dict[0x7a75] = "wā"; /* 穵 */
dict[0x7a76] = "jiū"; /* 究 */
dict[0x7a77] = "qióng"; /* 穷 */
dict[0x7a78] = "xī"; /* 穸 */
dict[0x7a79] = "qióng"; /* 穹 */
dict[0x7a7a] = "kōng,kòng,kǒng"; /* 空 */
dict[0x7a7b] = "yū,yǔ"; /* 穻 */
dict[0x7a7c] = "shēn"; /* 穼 */
dict[0x7a7d] = "jǐng"; /* 穽 */
dict[0x7a7e] = "yào"; /* 穾 */
dict[0x7a7f] = "chuān"; /* 穿 */
dict[0x7a80] = "zhūn"; /* 窀 */
dict[0x7a81] = "tū"; /* 突 */
dict[0x7a82] = "láo"; /* 窂 */
dict[0x7a83] = "qiè"; /* 窃 */
dict[0x7a84] = "zhǎi"; /* 窄 */
dict[0x7a85] = "yǎo"; /* 窅 */
dict[0x7a86] = "biǎn"; /* 窆 */
dict[0x7a87] = "báo"; /* 窇 */
dict[0x7a88] = "yǎo"; /* 窈 */
dict[0x7a89] = "bìng"; /* 窉 */
dict[0x7a8a] = "wā"; /* 窊 */
dict[0x7a8b] = "zhú,kū"; /* 窋 */
dict[0x7a8c] = "jiào,liáo,liù"; /* 窌 */
dict[0x7a8d] = "qiào"; /* 窍 */
dict[0x7a8e] = "diào"; /* 窎 */
dict[0x7a8f] = "wū"; /* 窏 */
dict[0x7a90] = "wā,guī"; /* 窐 */
dict[0x7a91] = "yáo"; /* 窑 */
dict[0x7a92] = "zhì"; /* 窒 */
dict[0x7a93] = "chuāng"; /* 窓 */
dict[0x7a94] = "yào"; /* 窔 */
dict[0x7a95] = "tiǎo,yáo"; /* 窕 */
dict[0x7a96] = "jiào"; /* 窖 */
dict[0x7a97] = "chuāng"; /* 窗 */
dict[0x7a98] = "jiǒng"; /* 窘 */
dict[0x7a99] = "xiāo"; /* 窙 */
dict[0x7a9a] = "chéng"; /* 窚 */
dict[0x7a9b] = "kòu"; /* 窛 */
dict[0x7a9c] = "cuàn"; /* 窜 */
dict[0x7a9d] = "wō"; /* 窝 */
dict[0x7a9e] = "dàn"; /* 窞 */
dict[0x7a9f] = "kū"; /* 窟 */
dict[0x7aa0] = "kē"; /* 窠 */
dict[0x7aa1] = "zhuó"; /* 窡 */
dict[0x7aa2] = "huò"; /* 窢 */
dict[0x7aa3] = "sū"; /* 窣 */
dict[0x7aa4] = "guān"; /* 窤 */
dict[0x7aa5] = "kuī"; /* 窥 */
dict[0x7aa6] = "dòu"; /* 窦 */
dict[0x7aa7] = "zhuō"; /* 窧 */
dict[0x7aa8] = "yìn,xūn"; /* 窨 */
dict[0x7aa9] = "wō"; /* 窩 */
dict[0x7aaa] = "wā"; /* 窪 */
dict[0x7aab] = "yà,yē"; /* 窫 */
dict[0x7aac] = "yú"; /* 窬 */
dict[0x7aad] = "jù"; /* 窭 */
dict[0x7aae] = "qióng"; /* 窮 */
dict[0x7aaf] = "yáo"; /* 窯 */
dict[0x7ab0] = "yáo"; /* 窰 */
dict[0x7ab1] = "tiǎo"; /* 窱 */
dict[0x7ab2] = "cháo"; /* 窲 */
dict[0x7ab3] = "yǔ"; /* 窳 */
dict[0x7ab4] = "tián,diān,yǎn"; /* 窴 */
dict[0x7ab5] = "diào"; /* 窵 */
dict[0x7ab6] = "jù"; /* 窶 */
dict[0x7ab7] = "liào"; /* 窷 */
dict[0x7ab8] = "xī"; /* 窸 */
dict[0x7ab9] = "wù"; /* 窹 */
dict[0x7aba] = "kuī"; /* 窺 */
dict[0x7abb] = "chuāng"; /* 窻 */
dict[0x7abc] = "chāo,kē"; /* 窼 */
dict[0x7abd] = "kuǎn,cuàn"; /* 窽 */
dict[0x7abe] = "kuǎn,cuàn"; /* 窾 */
dict[0x7abf] = "lóng"; /* 窿 */
dict[0x7ac0] = "chēng,chèng"; /* 竀 */
dict[0x7ac1] = "cuì"; /* 竁 */
dict[0x7ac2] = "liáo"; /* 竂 */
dict[0x7ac3] = "zào"; /* 竃 */
dict[0x7ac4] = "cuàn"; /* 竄 */
dict[0x7ac5] = "qiào"; /* 竅 */
dict[0x7ac6] = "qióng"; /* 竆 */
dict[0x7ac7] = "dòu"; /* 竇 */
dict[0x7ac8] = "zào"; /* 竈 */
dict[0x7ac9] = "lǒng"; /* 竉 */
dict[0x7aca] = "qiè"; /* 竊 */
dict[0x7acb] = "lì"; /* 立 */
dict[0x7acc] = "chù"; /* 竌 */
dict[0x7acd] = "shí"; /* 竍 */
dict[0x7ace] = "fù"; /* 竎 */
dict[0x7acf] = "qiān"; /* 竏 */
dict[0x7ad0] = "chù,qì"; /* 竐 */
dict[0x7ad1] = "hóng"; /* 竑 */
dict[0x7ad2] = "qí"; /* 竒 */
dict[0x7ad3] = "háo"; /* 竓 */
dict[0x7ad4] = "shēng"; /* 竔 */
dict[0x7ad5] = "fēn"; /* 竕 */
dict[0x7ad6] = "shù"; /* 竖 */
dict[0x7ad7] = "miào"; /* 竗 */
dict[0x7ad8] = "qǔ,kǒu"; /* 竘 */
dict[0x7ad9] = "zhàn"; /* 站 */
dict[0x7ada] = "zhù"; /* 竚 */
dict[0x7adb] = "líng"; /* 竛 */
dict[0x7adc] = "lóng"; /* 竜 */
dict[0x7add] = "bìng"; /* 竝 */
dict[0x7ade] = "jìng"; /* 竞 */
dict[0x7adf] = "jìng"; /* 竟 */
dict[0x7ae0] = "zhāng"; /* 章 */
dict[0x7ae1] = "bǎi"; /* 竡 */
dict[0x7ae2] = "sì"; /* 竢 */
dict[0x7ae3] = "jùn"; /* 竣 */
dict[0x7ae4] = "hóng"; /* 竤 */
dict[0x7ae5] = "tóng"; /* 童 */
dict[0x7ae6] = "sǒng"; /* 竦 */
dict[0x7ae7] = "jìng,zhěn"; /* 竧 */
dict[0x7ae8] = "diào"; /* 竨 */
dict[0x7ae9] = "yì"; /* 竩 */
dict[0x7aea] = "shù"; /* 竪 */
dict[0x7aeb] = "jìng"; /* 竫 */
dict[0x7aec] = "qǔ"; /* 竬 */
dict[0x7aed] = "jié"; /* 竭 */
dict[0x7aee] = "píng"; /* 竮 */
dict[0x7aef] = "duān"; /* 端 */
dict[0x7af0] = "lí"; /* 竰 */
dict[0x7af1] = "zhuǎn"; /* 竱 */
dict[0x7af2] = "céng,zēng"; /* 竲 */
dict[0x7af3] = "dēng"; /* 竳 */
dict[0x7af4] = "cūn"; /* 竴 */
dict[0x7af5] = "wāi"; /* 竵 */
dict[0x7af6] = "jìng"; /* 競 */
dict[0x7af7] = "kǎn,kàn"; /* 竷 */
dict[0x7af8] = "jìng"; /* 竸 */
dict[0x7af9] = "zhú"; /* 竹 */
dict[0x7afa] = "zhú,dǔ"; /* 竺 */
dict[0x7afb] = "lè,jīn"; /* 竻 */
dict[0x7afc] = "péng"; /* 竼 */
dict[0x7afd] = "yú"; /* 竽 */
dict[0x7afe] = "chí"; /* 竾 */
dict[0x7aff] = "gān"; /* 竿 */
dict[0x7b00] = "máng"; /* 笀 */
dict[0x7b01] = "zhú"; /* 笁 */
dict[0x7b02] = "wán"; /* 笂 */
dict[0x7b03] = "dǔ"; /* 笃 */
dict[0x7b04] = "jī"; /* 笄 */
dict[0x7b05] = "jiǎo,jiào"; /* 笅 */
dict[0x7b06] = "bā"; /* 笆 */
dict[0x7b07] = "suàn"; /* 笇 */
dict[0x7b08] = "jí"; /* 笈 */
dict[0x7b09] = "qǐn"; /* 笉 */
dict[0x7b0a] = "zhào"; /* 笊 */
dict[0x7b0b] = "sǔn"; /* 笋 */
dict[0x7b0c] = "yá"; /* 笌 */
dict[0x7b0d] = "zhuì,ruì"; /* 笍 */
dict[0x7b0e] = "yuán"; /* 笎 */
dict[0x7b0f] = "hù"; /* 笏 */
dict[0x7b10] = "háng,hàng"; /* 笐 */
dict[0x7b11] = "xiào"; /* 笑 */
dict[0x7b12] = "cén,jìn,hán"; /* 笒 */
dict[0x7b13] = "pí,bì"; /* 笓 */
dict[0x7b14] = "bǐ"; /* 笔 */
dict[0x7b15] = "jiǎn"; /* 笕 */
dict[0x7b16] = "yǐ"; /* 笖 */
dict[0x7b17] = "dōng"; /* 笗 */
dict[0x7b18] = "shān"; /* 笘 */
dict[0x7b19] = "shēng"; /* 笙 */
dict[0x7b1a] = "dā,xiá,nà"; /* 笚 */
dict[0x7b1b] = "dí"; /* 笛 */
dict[0x7b1c] = "zhú"; /* 笜 */
dict[0x7b1d] = "nà"; /* 笝 */
dict[0x7b1e] = "chī"; /* 笞 */
dict[0x7b1f] = "gū"; /* 笟 */
dict[0x7b20] = "lì"; /* 笠 */
dict[0x7b21] = "qiè"; /* 笡 */
dict[0x7b22] = "mǐn"; /* 笢 */
dict[0x7b23] = "bāo"; /* 笣 */
dict[0x7b24] = "tiáo"; /* 笤 */
dict[0x7b25] = "sì"; /* 笥 */
dict[0x7b26] = "fú"; /* 符 */
dict[0x7b27] = "cè"; /* 笧 */
dict[0x7b28] = "bèn"; /* 笨 */
dict[0x7b29] = "fá"; /* 笩 */
dict[0x7b2a] = "dá"; /* 笪 */
dict[0x7b2b] = "zǐ"; /* 笫 */
dict[0x7b2c] = "dì"; /* 第 */
dict[0x7b2d] = "líng"; /* 笭 */
dict[0x7b2e] = "zuó,zé"; /* 笮 */
dict[0x7b2f] = "nú"; /* 笯 */
dict[0x7b30] = "fú,fèi"; /* 笰 */
dict[0x7b31] = "gǒu"; /* 笱 */
dict[0x7b32] = "fán"; /* 笲 */
dict[0x7b33] = "jiā"; /* 笳 */
dict[0x7b34] = "gě"; /* 笴 */
dict[0x7b35] = "fàn"; /* 笵 */
dict[0x7b36] = "shǐ"; /* 笶 */
dict[0x7b37] = "mǎo"; /* 笷 */
dict[0x7b38] = "pǒ"; /* 笸 */
dict[0x7b39] = "tì"; /* 笹 */
dict[0x7b3a] = "jiān"; /* 笺 */
dict[0x7b3b] = "qióng"; /* 笻 */
dict[0x7b3c] = "lóng,lǒng"; /* 笼 */
dict[0x7b3d] = "mǐn"; /* 笽 */
dict[0x7b3e] = "biān"; /* 笾 */
dict[0x7b3f] = "luò"; /* 笿 */
dict[0x7b40] = "guì"; /* 筀 */
dict[0x7b41] = "qū"; /* 筁 */
dict[0x7b42] = "chí"; /* 筂 */
dict[0x7b43] = "yīn"; /* 筃 */
dict[0x7b44] = "yào"; /* 筄 */
dict[0x7b45] = "xiǎn"; /* 筅 */
dict[0x7b46] = "bǐ"; /* 筆 */
dict[0x7b47] = "qióng"; /* 筇 */
dict[0x7b48] = "kuò"; /* 筈 */
dict[0x7b49] = "děng"; /* 等 */
dict[0x7b4a] = "jiǎo,jiào"; /* 筊 */
dict[0x7b4b] = "jīn"; /* 筋 */
dict[0x7b4c] = "quán"; /* 筌 */
dict[0x7b4d] = "sǔn"; /* 筍 */
dict[0x7b4e] = "rú"; /* 筎 */
dict[0x7b4f] = "fá"; /* 筏 */
dict[0x7b50] = "kuāng"; /* 筐 */
dict[0x7b51] = "zhù,zhú"; /* 筑 */
dict[0x7b52] = "tǒng"; /* 筒 */
dict[0x7b53] = "jī"; /* 筓 */
dict[0x7b54] = "dá,dā"; /* 答 */
dict[0x7b55] = "háng"; /* 筕 */
dict[0x7b56] = "cè"; /* 策 */
dict[0x7b57] = "zhòng"; /* 筗 */
dict[0x7b58] = "kòu"; /* 筘 */
dict[0x7b59] = "lái"; /* 筙 */
dict[0x7b5a] = "bì"; /* 筚 */
dict[0x7b5b] = "shāi"; /* 筛 */
dict[0x7b5c] = "dāng"; /* 筜 */
dict[0x7b5d] = "zhēng"; /* 筝 */
dict[0x7b5e] = "cè"; /* 筞 */
dict[0x7b5f] = "fū"; /* 筟 */
dict[0x7b60] = "yún,jūn"; /* 筠 */
dict[0x7b61] = "tú"; /* 筡 */
dict[0x7b62] = "pá"; /* 筢 */
dict[0x7b63] = "lí"; /* 筣 */
dict[0x7b64] = "láng,làng"; /* 筤 */
dict[0x7b65] = "jǔ"; /* 筥 */
dict[0x7b66] = "guǎn"; /* 筦 */
dict[0x7b67] = "jiǎn"; /* 筧 */
dict[0x7b68] = "hán"; /* 筨 */
dict[0x7b69] = "tǒng"; /* 筩 */
dict[0x7b6a] = "xiá"; /* 筪 */
dict[0x7b6b] = "zhì,zhǐ"; /* 筫 */
dict[0x7b6c] = "chéng"; /* 筬 */
dict[0x7b6d] = "suàn"; /* 筭 */
dict[0x7b6e] = "shì"; /* 筮 */
dict[0x7b6f] = "zhù"; /* 筯 */
dict[0x7b70] = "zuó"; /* 筰 */
dict[0x7b71] = "xiǎo"; /* 筱 */
dict[0x7b72] = "shāo"; /* 筲 */
dict[0x7b73] = "tíng"; /* 筳 */
dict[0x7b74] = "cè"; /* 筴 */
dict[0x7b75] = "yán"; /* 筵 */
dict[0x7b76] = "gào"; /* 筶 */
dict[0x7b77] = "kuài"; /* 筷 */
dict[0x7b78] = "gān"; /* 筸 */
dict[0x7b79] = "chóu"; /* 筹 */
dict[0x7b7a] = "kuāng"; /* 筺 */
dict[0x7b7b] = "gàng"; /* 筻 */
dict[0x7b7c] = "yún"; /* 筼 */
dict[0x7b7d] = "o"; /* 筽 */
dict[0x7b7e] = "qiān"; /* 签 */
dict[0x7b7f] = "xiǎo"; /* 筿 */
dict[0x7b80] = "jiǎn"; /* 简 */
dict[0x7b81] = "póu,bù,fú,pú"; /* 箁 */
dict[0x7b82] = "lái"; /* 箂 */
dict[0x7b83] = "zōu"; /* 箃 */
dict[0x7b84] = "pái,bēi"; /* 箄 */
dict[0x7b85] = "bì"; /* 箅 */
dict[0x7b86] = "bì"; /* 箆 */
dict[0x7b87] = "gè"; /* 箇 */
dict[0x7b88] = "tái,chí"; /* 箈 */
dict[0x7b89] = "guǎi,dài"; /* 箉 */
dict[0x7b8a] = "yū"; /* 箊 */
dict[0x7b8b] = "jiān"; /* 箋 */
dict[0x7b8c] = "zhào,dào"; /* 箌 */
dict[0x7b8d] = "gū"; /* 箍 */
dict[0x7b8e] = "chí"; /* 箎 */
dict[0x7b8f] = "zhēng"; /* 箏 */
dict[0x7b90] = "qìng,jīng"; /* 箐 */
dict[0x7b91] = "shà"; /* 箑 */
dict[0x7b92] = "zhǒu"; /* 箒 */
dict[0x7b93] = "lù"; /* 箓 */
dict[0x7b94] = "bó"; /* 箔 */
dict[0x7b95] = "jī"; /* 箕 */
dict[0x7b96] = "lín,lǐn"; /* 箖 */
dict[0x7b97] = "suàn"; /* 算 */
dict[0x7b98] = "jùn,qūn"; /* 箘 */
dict[0x7b99] = "fú"; /* 箙 */
dict[0x7b9a] = "zhá"; /* 箚 */
dict[0x7b9b] = "gū"; /* 箛 */
dict[0x7b9c] = "kōng"; /* 箜 */
dict[0x7b9d] = "qián"; /* 箝 */
dict[0x7b9e] = "quān"; /* 箞 */
dict[0x7b9f] = "jùn"; /* 箟 */
dict[0x7ba0] = "chuí"; /* 箠 */
dict[0x7ba1] = "guǎn"; /* 管 */
dict[0x7ba2] = "wǎn,yuān"; /* 箢 */
dict[0x7ba3] = "cè"; /* 箣 */
dict[0x7ba4] = "zú"; /* 箤 */
dict[0x7ba5] = "pǒ"; /* 箥 */
dict[0x7ba6] = "zé"; /* 箦 */
dict[0x7ba7] = "qiè"; /* 箧 */
dict[0x7ba8] = "tuò"; /* 箨 */
dict[0x7ba9] = "luó"; /* 箩 */
dict[0x7baa] = "dān"; /* 箪 */
dict[0x7bab] = "xiāo"; /* 箫 */
dict[0x7bac] = "ruò"; /* 箬 */
dict[0x7bad] = "jiàn"; /* 箭 */
dict[0x7bae] = "xuān"; /* 箮 */
dict[0x7baf] = "biān"; /* 箯 */
dict[0x7bb0] = "sǔn"; /* 箰 */
dict[0x7bb1] = "xiāng"; /* 箱 */
dict[0x7bb2] = "xiǎn"; /* 箲 */
dict[0x7bb3] = "píng"; /* 箳 */
dict[0x7bb4] = "zhēn"; /* 箴 */
dict[0x7bb5] = "xīng"; /* 箵 */
dict[0x7bb6] = "hú"; /* 箶 */
dict[0x7bb7] = "shī,yí"; /* 箷 */
dict[0x7bb8] = "zhù"; /* 箸 */
dict[0x7bb9] = "yuē,yào,chuò"; /* 箹 */
dict[0x7bba] = "chūn"; /* 箺 */
dict[0x7bbb] = "lǜ"; /* 箻 */
dict[0x7bbc] = "wū"; /* 箼 */
dict[0x7bbd] = "dǒng"; /* 箽 */
dict[0x7bbe] = "shuò,xiāo,qiào"; /* 箾 */
dict[0x7bbf] = "jí"; /* 箿 */
dict[0x7bc0] = "jié"; /* 節 */
dict[0x7bc1] = "huáng"; /* 篁 */
dict[0x7bc2] = "xīng"; /* 篂 */
dict[0x7bc3] = "mèi"; /* 篃 */
dict[0x7bc4] = "fàn"; /* 範 */
dict[0x7bc5] = "chuán"; /* 篅 */
dict[0x7bc6] = "zhuàn"; /* 篆 */
dict[0x7bc7] = "piān"; /* 篇 */
dict[0x7bc8] = "fēng"; /* 篈 */
dict[0x7bc9] = "zhù,zhú"; /* 築 */
dict[0x7bca] = "hóng"; /* 篊 */
dict[0x7bcb] = "qiè"; /* 篋 */
dict[0x7bcc] = "hóu"; /* 篌 */
dict[0x7bcd] = "qiū"; /* 篍 */
dict[0x7bce] = "miǎo"; /* 篎 */
dict[0x7bcf] = "qiàn"; /* 篏 */
dict[0x7bd0] = "gū"; /* 篐 */
dict[0x7bd1] = "kuì"; /* 篑 */
dict[0x7bd2] = "yì"; /* 篒 */
dict[0x7bd3] = "lǒu"; /* 篓 */
dict[0x7bd4] = "yún"; /* 篔 */
dict[0x7bd5] = "hé"; /* 篕 */
dict[0x7bd6] = "táng"; /* 篖 */
dict[0x7bd7] = "yuè"; /* 篗 */
dict[0x7bd8] = "chōu"; /* 篘 */
dict[0x7bd9] = "gāo"; /* 篙 */
dict[0x7bda] = "fěi"; /* 篚 */
dict[0x7bdb] = "ruò"; /* 篛 */
dict[0x7bdc] = "zhēng"; /* 篜 */
dict[0x7bdd] = "gōu"; /* 篝 */
dict[0x7bde] = "niè"; /* 篞 */
dict[0x7bdf] = "qiàn"; /* 篟 */
dict[0x7be0] = "xiǎo"; /* 篠 */
dict[0x7be1] = "cuàn"; /* 篡 */
dict[0x7be2] = "gōng,gǎn,lǒng"; /* 篢 */
dict[0x7be3] = "péng,páng"; /* 篣 */
dict[0x7be4] = "dǔ"; /* 篤 */
dict[0x7be5] = "lì"; /* 篥 */
dict[0x7be6] = "bì"; /* 篦 */
dict[0x7be7] = "zhuó,huò"; /* 篧 */
dict[0x7be8] = "chú"; /* 篨 */
dict[0x7be9] = "shāi"; /* 篩 */
dict[0x7bea] = "chí"; /* 篪 */
dict[0x7beb] = "zhù"; /* 篫 */
dict[0x7bec] = "qiāng,cāng"; /* 篬 */
dict[0x7bed] = "lóng,lǒng"; /* 篭 */
dict[0x7bee] = "lán"; /* 篮 */
dict[0x7bef] = "jiǎn,jiān"; /* 篯 */
dict[0x7bf0] = "bù"; /* 篰 */
dict[0x7bf1] = "lí"; /* 篱 */
dict[0x7bf2] = "huì"; /* 篲 */
dict[0x7bf3] = "bì"; /* 篳 */
dict[0x7bf4] = "zhú,dí"; /* 篴 */
dict[0x7bf5] = "cōng"; /* 篵 */
dict[0x7bf6] = "yān"; /* 篶 */
dict[0x7bf7] = "péng"; /* 篷 */
dict[0x7bf8] = "cēn,zān,cǎn"; /* 篸 */
dict[0x7bf9] = "zhuàn,zuàn,suǎn"; /* 篹 */
dict[0x7bfa] = "pí"; /* 篺 */
dict[0x7bfb] = "piǎo,biāo"; /* 篻 */
dict[0x7bfc] = "dōu"; /* 篼 */
dict[0x7bfd] = "yù"; /* 篽 */
dict[0x7bfe] = "miè"; /* 篾 */
dict[0x7bff] = "tuán,zhuān"; /* 篿 */
dict[0x7c00] = "zé"; /* 簀 */
dict[0x7c01] = "shāi"; /* 簁 */
dict[0x7c02] = "guó,guì"; /* 簂 */
dict[0x7c03] = "yí"; /* 簃 */
dict[0x7c04] = "hù"; /* 簄 */
dict[0x7c05] = "chǎn"; /* 簅 */
dict[0x7c06] = "kòu"; /* 簆 */
dict[0x7c07] = "cù"; /* 簇 */
dict[0x7c08] = "píng"; /* 簈 */
dict[0x7c09] = "zào"; /* 簉 */
dict[0x7c0a] = "jī"; /* 簊 */
dict[0x7c0b] = "guǐ"; /* 簋 */
dict[0x7c0c] = "sù"; /* 簌 */
dict[0x7c0d] = "lǒu"; /* 簍 */
dict[0x7c0e] = "cè,jí"; /* 簎 */
dict[0x7c0f] = "lù"; /* 簏 */
dict[0x7c10] = "niǎn"; /* 簐 */
dict[0x7c11] = "suō"; /* 簑 */
dict[0x7c12] = "cuàn"; /* 簒 */
dict[0x7c13] = "diāo"; /* 簓 */
dict[0x7c14] = "suō"; /* 簔 */
dict[0x7c15] = "lè"; /* 簕 */
dict[0x7c16] = "duàn"; /* 簖 */
dict[0x7c17] = "zhù"; /* 簗 */
dict[0x7c18] = "xiāo"; /* 簘 */
dict[0x7c19] = "bó"; /* 簙 */
dict[0x7c1a] = "mì,miè"; /* 簚 */
dict[0x7c1b] = "shāi"; /* 簛 */
dict[0x7c1c] = "dàng"; /* 簜 */
dict[0x7c1d] = "liáo"; /* 簝 */
dict[0x7c1e] = "dān"; /* 簞 */
dict[0x7c1f] = "diàn"; /* 簟 */
dict[0x7c20] = "fǔ"; /* 簠 */
dict[0x7c21] = "jiǎn"; /* 簡 */
dict[0x7c22] = "mǐn"; /* 簢 */
dict[0x7c23] = "kuì"; /* 簣 */
dict[0x7c24] = "dài"; /* 簤 */
dict[0x7c25] = "jiāo"; /* 簥 */
dict[0x7c26] = "dēng"; /* 簦 */
dict[0x7c27] = "huáng"; /* 簧 */
dict[0x7c28] = "sǔn,zhuàn"; /* 簨 */
dict[0x7c29] = "láo"; /* 簩 */
dict[0x7c2a] = "zān"; /* 簪 */
dict[0x7c2b] = "xiāo"; /* 簫 */
dict[0x7c2c] = "lù"; /* 簬 */
dict[0x7c2d] = "shì"; /* 簭 */
dict[0x7c2e] = "zān"; /* 簮 */
dict[0x7c2f] = "qí"; /* 簯 */
dict[0x7c30] = "pái"; /* 簰 */
dict[0x7c31] = "qí"; /* 簱 */
dict[0x7c32] = "pái"; /* 簲 */
dict[0x7c33] = "gǎn,gàn"; /* 簳 */
dict[0x7c34] = "jù"; /* 簴 */
dict[0x7c35] = "lù"; /* 簵 */
dict[0x7c36] = "lù"; /* 簶 */
dict[0x7c37] = "yán"; /* 簷 */
dict[0x7c38] = "bò,bǒ"; /* 簸 */
dict[0x7c39] = "dāng"; /* 簹 */
dict[0x7c3a] = "sài"; /* 簺 */
dict[0x7c3b] = "zhuā"; /* 簻 */
dict[0x7c3c] = "gōu"; /* 簼 */
dict[0x7c3d] = "qiān"; /* 簽 */
dict[0x7c3e] = "lián"; /* 簾 */
dict[0x7c3f] = "bù,bó"; /* 簿 */
dict[0x7c40] = "zhòu"; /* 籀 */
dict[0x7c41] = "lài"; /* 籁 */
dict[0x7c42] = "shi"; /* 籂 */
dict[0x7c43] = "lán"; /* 籃 */
dict[0x7c44] = "kuì"; /* 籄 */
dict[0x7c45] = "yú"; /* 籅 */
dict[0x7c46] = "yuè"; /* 籆 */
dict[0x7c47] = "háo"; /* 籇 */
dict[0x7c48] = "zhēn,jiān"; /* 籈 */
dict[0x7c49] = "tái"; /* 籉 */
dict[0x7c4a] = "tì"; /* 籊 */
dict[0x7c4b] = "niè"; /* 籋 */
dict[0x7c4c] = "chóu"; /* 籌 */
dict[0x7c4d] = "jí"; /* 籍 */
dict[0x7c4e] = "yí"; /* 籎 */
dict[0x7c4f] = "qí"; /* 籏 */
dict[0x7c50] = "téng"; /* 籐 */
dict[0x7c51] = "zhuàn"; /* 籑 */
dict[0x7c52] = "zhòu"; /* 籒 */
dict[0x7c53] = "fān,pān,biān"; /* 籓 */
dict[0x7c54] = "sǒu,shǔ"; /* 籔 */
dict[0x7c55] = "zhòu"; /* 籕 */
dict[0x7c56] = "qiān"; /* 籖 */
dict[0x7c57] = "zhuó"; /* 籗 */
dict[0x7c58] = "téng"; /* 籘 */
dict[0x7c59] = "lù"; /* 籙 */
dict[0x7c5a] = "lú"; /* 籚 */
dict[0x7c5b] = "jiǎn,jiān"; /* 籛 */
dict[0x7c5c] = "tuò"; /* 籜 */
dict[0x7c5d] = "yíng"; /* 籝 */
dict[0x7c5e] = "yù"; /* 籞 */
dict[0x7c5f] = "lài"; /* 籟 */
dict[0x7c60] = "lóng,lǒng"; /* 籠 */
dict[0x7c61] = "qiè"; /* 籡 */
dict[0x7c62] = "lián"; /* 籢 */
dict[0x7c63] = "lán"; /* 籣 */
dict[0x7c64] = "qiān"; /* 籤 */
dict[0x7c65] = "yuè"; /* 籥 */
dict[0x7c66] = "zhōng"; /* 籦 */
dict[0x7c67] = "qú"; /* 籧 */
dict[0x7c68] = "lián"; /* 籨 */
dict[0x7c69] = "biān"; /* 籩 */
dict[0x7c6a] = "duàn"; /* 籪 */
dict[0x7c6b] = "zuǎn"; /* 籫 */
dict[0x7c6c] = "lí"; /* 籬 */
dict[0x7c6d] = "shāi"; /* 籭 */
dict[0x7c6e] = "luó"; /* 籮 */
dict[0x7c6f] = "yíng"; /* 籯 */
dict[0x7c70] = "yuè"; /* 籰 */
dict[0x7c71] = "zhuó"; /* 籱 */
dict[0x7c72] = "yù"; /* 籲 */
dict[0x7c73] = "mǐ"; /* 米 */
dict[0x7c74] = "dí"; /* 籴 */
dict[0x7c75] = "fán"; /* 籵 */
dict[0x7c76] = "shēn"; /* 籶 */
dict[0x7c77] = "zhé"; /* 籷 */
dict[0x7c78] = "shēn"; /* 籸 */
dict[0x7c79] = "nǚ"; /* 籹 */
dict[0x7c7a] = "hé"; /* 籺 */
dict[0x7c7b] = "lèi"; /* 类 */
dict[0x7c7c] = "xiān"; /* 籼 */
dict[0x7c7d] = "zǐ"; /* 籽 */
dict[0x7c7e] = "ní"; /* 籾 */
dict[0x7c7f] = "cùn"; /* 籿 */
dict[0x7c80] = "zhàng"; /* 粀 */
dict[0x7c81] = "qiān"; /* 粁 */
dict[0x7c82] = "zhāi"; /* 粂 */
dict[0x7c83] = "bǐ"; /* 粃 */
dict[0x7c84] = "bǎn"; /* 粄 */
dict[0x7c85] = "wù"; /* 粅 */
dict[0x7c86] = "shā,chǎo"; /* 粆 */
dict[0x7c87] = "kāng,jīng"; /* 粇 */
dict[0x7c88] = "róu"; /* 粈 */
dict[0x7c89] = "fěn"; /* 粉 */
dict[0x7c8a] = "bì"; /* 粊 */
dict[0x7c8b] = "cuì"; /* 粋 */
dict[0x7c8c] = "yǐn"; /* 粌 */
dict[0x7c8d] = "zhé"; /* 粍 */
dict[0x7c8e] = "mǐ"; /* 粎 */
dict[0x7c8f] = "tà"; /* 粏 */
dict[0x7c90] = "hù"; /* 粐 */
dict[0x7c91] = "bā"; /* 粑 */
dict[0x7c92] = "lì"; /* 粒 */
dict[0x7c93] = "gān"; /* 粓 */
dict[0x7c94] = "jù"; /* 粔 */
dict[0x7c95] = "pò"; /* 粕 */
dict[0x7c96] = "yù"; /* 粖 */
dict[0x7c97] = "cū"; /* 粗 */
dict[0x7c98] = "nián,zhān"; /* 粘 */
dict[0x7c99] = "zhòu"; /* 粙 */
dict[0x7c9a] = "chī"; /* 粚 */
dict[0x7c9b] = "sù"; /* 粛 */
dict[0x7c9c] = "tiào"; /* 粜 */
dict[0x7c9d] = "lì"; /* 粝 */
dict[0x7c9e] = "xī"; /* 粞 */
dict[0x7c9f] = "sù"; /* 粟 */
dict[0x7ca0] = "hóng"; /* 粠 */
dict[0x7ca1] = "tóng"; /* 粡 */
dict[0x7ca2] = "zī,cí"; /* 粢 */
dict[0x7ca3] = "cè,sè"; /* 粣 */
dict[0x7ca4] = "yuè"; /* 粤 */
dict[0x7ca5] = "zhōu,yù"; /* 粥 */
dict[0x7ca6] = "lín"; /* 粦 */
dict[0x7ca7] = "zhuāng"; /* 粧 */
dict[0x7ca8] = "bǎi"; /* 粨 */
dict[0x7ca9] = "lāo"; /* 粩 */
dict[0x7caa] = "fèn"; /* 粪 */
dict[0x7cab] = "ér"; /* 粫 */
dict[0x7cac] = "qū"; /* 粬 */
dict[0x7cad] = "hé"; /* 粭 */
dict[0x7cae] = "liáng"; /* 粮 */
dict[0x7caf] = "xiàn"; /* 粯 */
dict[0x7cb0] = "fū,fú"; /* 粰 */
dict[0x7cb1] = "liáng"; /* 粱 */
dict[0x7cb2] = "càn"; /* 粲 */
dict[0x7cb3] = "jīng"; /* 粳 */
dict[0x7cb4] = "lǐ"; /* 粴 */
dict[0x7cb5] = "yuè"; /* 粵 */
dict[0x7cb6] = "lù"; /* 粶 */
dict[0x7cb7] = "jú"; /* 粷 */
dict[0x7cb8] = "qí"; /* 粸 */
dict[0x7cb9] = "cuì"; /* 粹 */
dict[0x7cba] = "bài"; /* 粺 */
dict[0x7cbb] = "zhāng"; /* 粻 */
dict[0x7cbc] = "lín"; /* 粼 */
dict[0x7cbd] = "zòng"; /* 粽 */
dict[0x7cbe] = "jīng"; /* 精 */
dict[0x7cbf] = "guǒ"; /* 粿 */
dict[0x7cc0] = "huā"; /* 糀 */
dict[0x7cc1] = "sǎn,shēn"; /* 糁 */
dict[0x7cc2] = "shēn"; /* 糂 */
dict[0x7cc3] = "táng"; /* 糃 */
dict[0x7cc4] = "biān,biǎn"; /* 糄 */
dict[0x7cc5] = "róu"; /* 糅 */
dict[0x7cc6] = "miàn"; /* 糆 */
dict[0x7cc7] = "hóu"; /* 糇 */
dict[0x7cc8] = "xǔ"; /* 糈 */
dict[0x7cc9] = "zòng"; /* 糉 */
dict[0x7cca] = "hū,hú,hù"; /* 糊 */
dict[0x7ccb] = "jiàn"; /* 糋 */
dict[0x7ccc] = "zān"; /* 糌 */
dict[0x7ccd] = "cí"; /* 糍 */
dict[0x7cce] = "lí"; /* 糎 */
dict[0x7ccf] = "xiè"; /* 糏 */
dict[0x7cd0] = "fū"; /* 糐 */
dict[0x7cd1] = "nuò"; /* 糑 */
dict[0x7cd2] = "bèi"; /* 糒 */
dict[0x7cd3] = "gǔ,gòu"; /* 糓 */
dict[0x7cd4] = "xiǔ"; /* 糔 */
dict[0x7cd5] = "gāo"; /* 糕 */
dict[0x7cd6] = "táng"; /* 糖 */
dict[0x7cd7] = "qiǔ"; /* 糗 */
dict[0x7cd8] = "jiā"; /* 糘 */
dict[0x7cd9] = "cāo"; /* 糙 */
dict[0x7cda] = "zhuāng"; /* 糚 */
dict[0x7cdb] = "táng"; /* 糛 */
dict[0x7cdc] = "mí,méi"; /* 糜 */
dict[0x7cdd] = "sǎn,shēn"; /* 糝 */
dict[0x7cde] = "fèn"; /* 糞 */
dict[0x7cdf] = "zāo"; /* 糟 */
dict[0x7ce0] = "kāng"; /* 糠 */
dict[0x7ce1] = "jiàng"; /* 糡 */
dict[0x7ce2] = "mó"; /* 糢 */
dict[0x7ce3] = "sǎn,shēn"; /* 糣 */
dict[0x7ce4] = "sǎn"; /* 糤 */
dict[0x7ce5] = "nuò"; /* 糥 */
dict[0x7ce6] = "xī"; /* 糦 */
dict[0x7ce7] = "liáng"; /* 糧 */
dict[0x7ce8] = "jiàng"; /* 糨 */
dict[0x7ce9] = "kuài"; /* 糩 */
dict[0x7cea] = "bó"; /* 糪 */
dict[0x7ceb] = "huán"; /* 糫 */
dict[0x7cec] = "shǔ"; /* 糬 */
dict[0x7ced] = "zòng"; /* 糭 */
dict[0x7cee] = "xiàn"; /* 糮 */
dict[0x7cef] = "nuò"; /* 糯 */
dict[0x7cf0] = "tuán"; /* 糰 */
dict[0x7cf1] = "niè"; /* 糱 */
dict[0x7cf2] = "lì"; /* 糲 */
dict[0x7cf3] = "zuò"; /* 糳 */
dict[0x7cf4] = "dí"; /* 糴 */
dict[0x7cf5] = "niè"; /* 糵 */
dict[0x7cf6] = "tiào"; /* 糶 */
dict[0x7cf7] = "làn"; /* 糷 */
dict[0x7cf8] = "mì,sī"; /* 糸 */
dict[0x7cf9] = "sī"; /* 糹 */
dict[0x7cfa] = "jiū,jiǔ"; /* 糺 */
dict[0x7cfb] = "xì,jì"; /* 系 */
dict[0x7cfc] = "gōng"; /* 糼 */
dict[0x7cfd] = "zhēng,zhěng"; /* 糽 */
dict[0x7cfe] = "jiū"; /* 糾 */
dict[0x7cff] = "gōng"; /* 糿 */
dict[0x7d00] = "jì"; /* 紀 */
dict[0x7d01] = "chà,chǎ"; /* 紁 */
dict[0x7d02] = "zhòu"; /* 紂 */
dict[0x7d03] = "xún"; /* 紃 */
dict[0x7d04] = "yuē,yāo"; /* 約 */
dict[0x7d05] = "hóng,gōng"; /* 紅 */
dict[0x7d06] = "yū"; /* 紆 */
dict[0x7d07] = "hé,gē"; /* 紇 */
dict[0x7d08] = "wán"; /* 紈 */
dict[0x7d09] = "rèn"; /* 紉 */
dict[0x7d0a] = "wěn"; /* 紊 */
dict[0x7d0b] = "wén,wèn"; /* 紋 */
dict[0x7d0c] = "qiú"; /* 紌 */
dict[0x7d0d] = "nà"; /* 納 */
dict[0x7d0e] = "zī"; /* 紎 */
dict[0x7d0f] = "tǒu"; /* 紏 */
dict[0x7d10] = "niǔ"; /* 紐 */
dict[0x7d11] = "fóu"; /* 紑 */
dict[0x7d12] = "jì,jié,jiè"; /* 紒 */
dict[0x7d13] = "shū"; /* 紓 */
dict[0x7d14] = "chún"; /* 純 */
dict[0x7d15] = "pī,pí,bǐ"; /* 紕 */
dict[0x7d16] = "zhèn"; /* 紖 */
dict[0x7d17] = "shā"; /* 紗 */
dict[0x7d18] = "hóng"; /* 紘 */
dict[0x7d19] = "zhǐ"; /* 紙 */
dict[0x7d1a] = "jí"; /* 級 */
dict[0x7d1b] = "fēn"; /* 紛 */
dict[0x7d1c] = "yún"; /* 紜 */
dict[0x7d1d] = "rèn"; /* 紝 */
dict[0x7d1e] = "dǎn"; /* 紞 */
dict[0x7d1f] = "jīn,jìn"; /* 紟 */
dict[0x7d20] = "sù"; /* 素 */
dict[0x7d21] = "fǎng"; /* 紡 */
dict[0x7d22] = "suǒ"; /* 索 */
dict[0x7d23] = "cuì"; /* 紣 */
dict[0x7d24] = "jiǔ"; /* 紤 */
dict[0x7d25] = "zhā,zā"; /* 紥 */
dict[0x7d26] = "hā"; /* 紦 */
dict[0x7d27] = "jǐn"; /* 紧 */
dict[0x7d28] = "fū,fù"; /* 紨 */
dict[0x7d29] = "zhì"; /* 紩 */
dict[0x7d2a] = "qī"; /* 紪 */
dict[0x7d2b] = "zǐ"; /* 紫 */
dict[0x7d2c] = "chōu,chóu"; /* 紬 */
dict[0x7d2d] = "hóng"; /* 紭 */
dict[0x7d2e] = "zhā,zā"; /* 紮 */
dict[0x7d2f] = "léi,lěi,lèi"; /* 累 */
dict[0x7d30] = "xì"; /* 細 */
dict[0x7d31] = "fú"; /* 紱 */
dict[0x7d32] = "xiè"; /* 紲 */
dict[0x7d33] = "shēn"; /* 紳 */
dict[0x7d34] = "bō,bì"; /* 紴 */
dict[0x7d35] = "zhù"; /* 紵 */
dict[0x7d36] = "qū,qǔ"; /* 紶 */
dict[0x7d37] = "líng"; /* 紷 */
dict[0x7d38] = "zhù"; /* 紸 */
dict[0x7d39] = "shào"; /* 紹 */
dict[0x7d3a] = "gàn"; /* 紺 */
dict[0x7d3b] = "yǎng"; /* 紻 */
dict[0x7d3c] = "fú"; /* 紼 */
dict[0x7d3d] = "tuó"; /* 紽 */
dict[0x7d3e] = "zhěn,tiǎn"; /* 紾 */
dict[0x7d3f] = "dài"; /* 紿 */
dict[0x7d40] = "chù"; /* 絀 */
dict[0x7d41] = "shī"; /* 絁 */
dict[0x7d42] = "zhōng"; /* 終 */
dict[0x7d43] = "xián"; /* 絃 */
dict[0x7d44] = "zǔ"; /* 組 */
dict[0x7d45] = "jiōng,jiǒng"; /* 絅 */
dict[0x7d46] = "bàn"; /* 絆 */
dict[0x7d47] = "qú"; /* 絇 */
dict[0x7d48] = "mò"; /* 絈 */
dict[0x7d49] = "shù"; /* 絉 */
dict[0x7d4a] = "zuì"; /* 絊 */
dict[0x7d4b] = "kuàng"; /* 絋 */
dict[0x7d4c] = "jīng"; /* 経 */
dict[0x7d4d] = "rèn"; /* 絍 */
dict[0x7d4e] = "háng"; /* 絎 */
dict[0x7d4f] = "xiè"; /* 絏 */
dict[0x7d50] = "jié,jiē"; /* 結 */
dict[0x7d51] = "zhū"; /* 絑 */
dict[0x7d52] = "chóu"; /* 絒 */
dict[0x7d53] = "guà,kuā"; /* 絓 */
dict[0x7d54] = "bǎi,mò"; /* 絔 */
dict[0x7d55] = "jué"; /* 絕 */
dict[0x7d56] = "kuàng"; /* 絖 */
dict[0x7d57] = "hú"; /* 絗 */
dict[0x7d58] = "cì"; /* 絘 */
dict[0x7d59] = "huán,gēng"; /* 絙 */
dict[0x7d5a] = "gēng"; /* 絚 */
dict[0x7d5b] = "tāo"; /* 絛 */
dict[0x7d5c] = "xié,jié"; /* 絜 */
dict[0x7d5d] = "kù"; /* 絝 */
dict[0x7d5e] = "jiǎo"; /* 絞 */
dict[0x7d5f] = "quán,shuān"; /* 絟 */
dict[0x7d60] = "gǎi,ǎi"; /* 絠 */
dict[0x7d61] = "luò,lào"; /* 絡 */
dict[0x7d62] = "xuàn"; /* 絢 */
dict[0x7d63] = "bēng,bīng,pēng"; /* 絣 */
dict[0x7d64] = "xiàn"; /* 絤 */
dict[0x7d65] = "fú"; /* 絥 */
dict[0x7d66] = "gěi,jǐ"; /* 給 */
dict[0x7d67] = "tōng,tóng,dòng"; /* 絧 */
dict[0x7d68] = "róng"; /* 絨 */
dict[0x7d69] = "tiào,diào,dào"; /* 絩 */
dict[0x7d6a] = "yīn"; /* 絪 */
dict[0x7d6b] = "lěi,lèi,léi"; /* 絫 */
dict[0x7d6c] = "xiè"; /* 絬 */
dict[0x7d6d] = "juàn"; /* 絭 */
dict[0x7d6e] = "xù"; /* 絮 */
dict[0x7d6f] = "gāi,hài"; /* 絯 */
dict[0x7d70] = "dié"; /* 絰 */
dict[0x7d71] = "tǒng"; /* 統 */
dict[0x7d72] = "sī"; /* 絲 */
dict[0x7d73] = "jiàng"; /* 絳 */
dict[0x7d74] = "xiáng"; /* 絴 */
dict[0x7d75] = "huì"; /* 絵 */
dict[0x7d76] = "jué"; /* 絶 */
dict[0x7d77] = "zhí"; /* 絷 */
dict[0x7d78] = "jiǎn"; /* 絸 */
dict[0x7d79] = "juàn"; /* 絹 */
dict[0x7d7a] = "chī,zhǐ"; /* 絺 */
dict[0x7d7b] = "miǎn,wèn,mán,wàn"; /* 絻 */
dict[0x7d7c] = "zhèn"; /* 絼 */
dict[0x7d7d] = "lǚ"; /* 絽 */
dict[0x7d7e] = "chéng"; /* 絾 */
dict[0x7d7f] = "qiú"; /* 絿 */
dict[0x7d80] = "shū"; /* 綀 */
dict[0x7d81] = "bǎng"; /* 綁 */
dict[0x7d82] = "tǒng"; /* 綂 */
dict[0x7d83] = "xiāo"; /* 綃 */
dict[0x7d84] = "huán,huàn,wàn"; /* 綄 */
dict[0x7d85] = "qīn,xiān"; /* 綅 */
dict[0x7d86] = "gěng"; /* 綆 */
dict[0x7d87] = "xū"; /* 綇 */
dict[0x7d88] = "tí,tì"; /* 綈 */
dict[0x7d89] = "xiù"; /* 綉 */
dict[0x7d8a] = "xié"; /* 綊 */
dict[0x7d8b] = "hóng"; /* 綋 */
dict[0x7d8c] = "xì"; /* 綌 */
dict[0x7d8d] = "fú"; /* 綍 */
dict[0x7d8e] = "tīng"; /* 綎 */
dict[0x7d8f] = "suí"; /* 綏 */
dict[0x7d90] = "duì"; /* 綐 */
dict[0x7d91] = "kǔn"; /* 綑 */
dict[0x7d92] = "fū"; /* 綒 */
dict[0x7d93] = "jīng"; /* 經 */
dict[0x7d94] = "hù"; /* 綔 */
dict[0x7d95] = "zhī"; /* 綕 */
dict[0x7d96] = "yán,xiàn"; /* 綖 */
dict[0x7d97] = "jiǒng"; /* 綗 */
dict[0x7d98] = "féng"; /* 綘 */
dict[0x7d99] = "jì"; /* 継 */
dict[0x7d9a] = "xù"; /* 続 */
dict[0x7d9b] = "rěn"; /* 綛 */
dict[0x7d9c] = "zōng,zèng"; /* 綜 */
dict[0x7d9d] = "lín,chēn"; /* 綝 */
dict[0x7d9e] = "duǒ"; /* 綞 */
dict[0x7d9f] = "lì,liè"; /* 綟 */
dict[0x7da0] = "lǜ"; /* 綠 */
dict[0x7da1] = "jīng"; /* 綡 */
dict[0x7da2] = "chóu"; /* 綢 */
dict[0x7da3] = "quǎn"; /* 綣 */
dict[0x7da4] = "shào"; /* 綤 */
dict[0x7da5] = "qí"; /* 綥 */
dict[0x7da6] = "qí"; /* 綦 */
dict[0x7da7] = "zhǔn,zhùn"; /* 綧 */
dict[0x7da8] = "jī,qí"; /* 綨 */
dict[0x7da9] = "wǎn"; /* 綩 */
dict[0x7daa] = "qiàn,qīng,zhēng"; /* 綪 */
dict[0x7dab] = "xiàn"; /* 綫 */
dict[0x7dac] = "shòu"; /* 綬 */
dict[0x7dad] = "wéi"; /* 維 */
dict[0x7dae] = "qìng,qǐ"; /* 綮 */
dict[0x7daf] = "táo"; /* 綯 */
dict[0x7db0] = "wǎn"; /* 綰 */
dict[0x7db1] = "gāng"; /* 綱 */
dict[0x7db2] = "wǎng"; /* 網 */
dict[0x7db3] = "bēng,běng,bèng"; /* 綳 */
dict[0x7db4] = "zhuì"; /* 綴 */
dict[0x7db5] = "cǎi"; /* 綵 */
dict[0x7db6] = "guǒ"; /* 綶 */
dict[0x7db7] = "cuì"; /* 綷 */
dict[0x7db8] = "lún,guān"; /* 綸 */
dict[0x7db9] = "liǔ"; /* 綹 */
dict[0x7dba] = "qǐ"; /* 綺 */
dict[0x7dbb] = "zhàn"; /* 綻 */
dict[0x7dbc] = "bì"; /* 綼 */
dict[0x7dbd] = "chuò,chāo"; /* 綽 */
dict[0x7dbe] = "líng"; /* 綾 */
dict[0x7dbf] = "mián"; /* 綿 */
dict[0x7dc0] = "qī"; /* 緀 */
dict[0x7dc1] = "jī"; /* 緁 */
dict[0x7dc2] = "tián,tǎn,chān"; /* 緂 */
dict[0x7dc3] = "zōng"; /* 緃 */
dict[0x7dc4] = "gǔn"; /* 緄 */
dict[0x7dc5] = "zōu"; /* 緅 */
dict[0x7dc6] = "xī"; /* 緆 */
dict[0x7dc7] = "zī"; /* 緇 */
dict[0x7dc8] = "xìng"; /* 緈 */
dict[0x7dc9] = "liǎng"; /* 緉 */
dict[0x7dca] = "jǐn"; /* 緊 */
dict[0x7dcb] = "fēi"; /* 緋 */
dict[0x7dcc] = "ruí"; /* 緌 */
dict[0x7dcd] = "mín"; /* 緍 */
dict[0x7dce] = "yù"; /* 緎 */
dict[0x7dcf] = "zǒng"; /* 総 */
dict[0x7dd0] = "fán"; /* 緐 */
dict[0x7dd1] = "lǜ,lù"; /* 緑 */
dict[0x7dd2] = "xù"; /* 緒 */
dict[0x7dd3] = "yīng"; /* 緓 */
dict[0x7dd4] = "shàng"; /* 緔 */
dict[0x7dd5] = "zī"; /* 緕 */
dict[0x7dd6] = "xù"; /* 緖 */
dict[0x7dd7] = "xiāng"; /* 緗 */
dict[0x7dd8] = "jiān"; /* 緘 */
dict[0x7dd9] = "kè"; /* 緙 */
dict[0x7dda] = "xiàn"; /* 線 */
dict[0x7ddb] = "ruǎn,ruàn"; /* 緛 */
dict[0x7ddc] = "mián"; /* 緜 */
dict[0x7ddd] = "jī,qī"; /* 緝 */
dict[0x7dde] = "duàn"; /* 緞 */
dict[0x7ddf] = "chóng,zhòng"; /* 緟 */
dict[0x7de0] = "dì"; /* 締 */
dict[0x7de1] = "mín"; /* 緡 */
dict[0x7de2] = "miáo,máo"; /* 緢 */
dict[0x7de3] = "yuán"; /* 緣 */
dict[0x7de4] = "xiè,yè"; /* 緤 */
dict[0x7de5] = "bǎo"; /* 緥 */
dict[0x7de6] = "sī"; /* 緦 */
dict[0x7de7] = "qiū"; /* 緧 */
dict[0x7de8] = "biān"; /* 編 */
dict[0x7de9] = "huǎn"; /* 緩 */
dict[0x7dea] = "gēng,gèng"; /* 緪 */
dict[0x7deb] = "zǒng"; /* 緫 */
dict[0x7dec] = "miǎn"; /* 緬 */
dict[0x7ded] = "wèi"; /* 緭 */
dict[0x7dee] = "fù"; /* 緮 */
dict[0x7def] = "wěi"; /* 緯 */
dict[0x7df0] = "tōu,xū,shū"; /* 緰 */
dict[0x7df1] = "gōu"; /* 緱 */
dict[0x7df2] = "miǎo"; /* 緲 */
dict[0x7df3] = "xié"; /* 緳 */
dict[0x7df4] = "liàn"; /* 練 */
dict[0x7df5] = "zōng,zòng"; /* 緵 */
dict[0x7df6] = "biàn,pián"; /* 緶 */
dict[0x7df7] = "gǔn,yùn"; /* 緷 */
dict[0x7df8] = "yīn"; /* 緸 */
dict[0x7df9] = "tí"; /* 緹 */
dict[0x7dfa] = "guā,wō"; /* 緺 */
dict[0x7dfb] = "zhì"; /* 緻 */
dict[0x7dfc] = "yùn,yūn,wēn"; /* 緼 */
dict[0x7dfd] = "chēng"; /* 緽 */
dict[0x7dfe] = "chán"; /* 緾 */
dict[0x7dff] = "dài"; /* 緿 */
dict[0x7e00] = "xié"; /* 縀 */
dict[0x7e01] = "yuán"; /* 縁 */
dict[0x7e02] = "zǒng"; /* 縂 */
dict[0x7e03] = "xū"; /* 縃 */
dict[0x7e04] = "shéng"; /* 縄 */
dict[0x7e05] = "wēi"; /* 縅 */
dict[0x7e06] = "gēng,gèng"; /* 縆 */
dict[0x7e08] = "yíng"; /* 縈 */
dict[0x7e09] = "jìn"; /* 縉 */
dict[0x7e0a] = "yì"; /* 縊 */
dict[0x7e0b] = "zhuì"; /* 縋 */
dict[0x7e0c] = "nì"; /* 縌 */
dict[0x7e0d] = "bāng,bàng"; /* 縍 */
dict[0x7e0e] = "gǔ,hú"; /* 縎 */
dict[0x7e0f] = "pán"; /* 縏 */
dict[0x7e10] = "zhòu"; /* 縐 */
dict[0x7e11] = "jiān"; /* 縑 */
dict[0x7e12] = "cī,cuò,suǒ"; /* 縒 */
dict[0x7e13] = "quán"; /* 縓 */
dict[0x7e14] = "shuǎng"; /* 縔 */
dict[0x7e15] = "yùn,yūn,wēn"; /* 縕 */
dict[0x7e16] = "xiá"; /* 縖 */
dict[0x7e17] = "cuī,suī,shuāi"; /* 縗 */
dict[0x7e18] = "xì"; /* 縘 */
dict[0x7e19] = "róng,rǒng,ròng"; /* 縙 */
dict[0x7e1a] = "tāo"; /* 縚 */
dict[0x7e1b] = "fù"; /* 縛 */
dict[0x7e1c] = "yún"; /* 縜 */
dict[0x7e1d] = "zhěn"; /* 縝 */
dict[0x7e1e] = "gǎo"; /* 縞 */
dict[0x7e1f] = "rù"; /* 縟 */
dict[0x7e20] = "hú"; /* 縠 */
dict[0x7e21] = "zài,zēng"; /* 縡 */
dict[0x7e22] = "téng"; /* 縢 */
dict[0x7e23] = "xiàn,xuán"; /* 縣 */
dict[0x7e24] = "sù"; /* 縤 */
dict[0x7e25] = "zhěn"; /* 縥 */
dict[0x7e26] = "zòng"; /* 縦 */
dict[0x7e27] = "tāo"; /* 縧 */
dict[0x7e28] = "huǎng"; /* 縨 */
dict[0x7e29] = "cài"; /* 縩 */
dict[0x7e2a] = "bì"; /* 縪 */
dict[0x7e2b] = "féng,fèng"; /* 縫 */
dict[0x7e2c] = "cù"; /* 縬 */
dict[0x7e2d] = "lí"; /* 縭 */
dict[0x7e2e] = "suō,sù"; /* 縮 */
dict[0x7e2f] = "yǎn,yǐn"; /* 縯 */
dict[0x7e30] = "xǐ"; /* 縰 */
dict[0x7e31] = "zòng,zǒng"; /* 縱 */
dict[0x7e32] = "léi"; /* 縲 */
dict[0x7e33] = "zhuàn,juàn"; /* 縳 */
dict[0x7e34] = "qiàn"; /* 縴 */
dict[0x7e35] = "màn"; /* 縵 */
dict[0x7e36] = "zhí"; /* 縶 */
dict[0x7e37] = "lǚ"; /* 縷 */
dict[0x7e38] = "mù,mò"; /* 縸 */
dict[0x7e39] = "piǎo,piāo"; /* 縹 */
dict[0x7e3a] = "lián"; /* 縺 */
dict[0x7e3b] = "mí"; /* 縻 */
dict[0x7e3c] = "xuàn"; /* 縼 */
dict[0x7e3d] = "zǒng"; /* 總 */
dict[0x7e3e] = "jì"; /* 績 */
dict[0x7e3f] = "shān"; /* 縿 */
dict[0x7e40] = "suì"; /* 繀 */
dict[0x7e41] = "fán,pó"; /* 繁 */
dict[0x7e42] = "lǜ"; /* 繂 */
dict[0x7e43] = "bēng,běng,bèng"; /* 繃 */
dict[0x7e44] = "yī"; /* 繄 */
dict[0x7e45] = "sāo"; /* 繅 */
dict[0x7e46] = "móu,miù,miào,mù,liǎo"; /* 繆 */
dict[0x7e47] = "yáo,yóu,zhòu"; /* 繇 */
dict[0x7e48] = "qiǎng"; /* 繈 */
dict[0x7e49] = "shéng"; /* 繉 */
dict[0x7e4a] = "xiān"; /* 繊 */
dict[0x7e4b] = "jì"; /* 繋 */
dict[0x7e4c] = "zōng,zòng"; /* 繌 */
dict[0x7e4d] = "xiù"; /* 繍 */
dict[0x7e4e] = "rán"; /* 繎 */
dict[0x7e4f] = "xuàn"; /* 繏 */
dict[0x7e50] = "suì"; /* 繐 */
dict[0x7e51] = "qiāo"; /* 繑 */
dict[0x7e52] = "zēng,zèng"; /* 繒 */
dict[0x7e53] = "zuǒ"; /* 繓 */
dict[0x7e54] = "zhī,zhì"; /* 織 */
dict[0x7e55] = "shàn"; /* 繕 */
dict[0x7e56] = "sǎn"; /* 繖 */
dict[0x7e57] = "lín"; /* 繗 */
dict[0x7e58] = "jú,jué"; /* 繘 */
dict[0x7e59] = "fān"; /* 繙 */
dict[0x7e5a] = "liáo"; /* 繚 */
dict[0x7e5b] = "chuō,chuò"; /* 繛 */
dict[0x7e5c] = "zūn,zǔn"; /* 繜 */
dict[0x7e5d] = "jiàn"; /* 繝 */
dict[0x7e5e] = "rào"; /* 繞 */
dict[0x7e5f] = "chǎn,chán"; /* 繟 */
dict[0x7e60] = "ruǐ"; /* 繠 */
dict[0x7e61] = "xiù"; /* 繡 */
dict[0x7e62] = "huì,huí"; /* 繢 */
dict[0x7e63] = "huà"; /* 繣 */
dict[0x7e64] = "zuǎn"; /* 繤 */
dict[0x7e65] = "xī"; /* 繥 */
dict[0x7e66] = "qiǎng"; /* 繦 */
dict[0x7e67] = "wén"; /* 繧 */
dict[0x7e68] = "da"; /* 繨 */
dict[0x7e69] = "shéng"; /* 繩 */
dict[0x7e6a] = "huì"; /* 繪 */
dict[0x7e6b] = "xì,jì"; /* 繫 */
dict[0x7e6c] = "sè"; /* 繬 */
dict[0x7e6d] = "jiǎn"; /* 繭 */
dict[0x7e6e] = "jiāng"; /* 繮 */
dict[0x7e6f] = "huán"; /* 繯 */
dict[0x7e70] = "qiāo,sāo"; /* 繰 */
dict[0x7e71] = "cōng"; /* 繱 */
dict[0x7e72] = "xiè"; /* 繲 */
dict[0x7e73] = "jiǎo,zhuó"; /* 繳 */
dict[0x7e74] = "bì"; /* 繴 */
dict[0x7e75] = "dàn,tán,chán"; /* 繵 */
dict[0x7e76] = "yì"; /* 繶 */
dict[0x7e77] = "nǒng"; /* 繷 */
dict[0x7e78] = "suì"; /* 繸 */
dict[0x7e79] = "yì"; /* 繹 */
dict[0x7e7a] = "shā"; /* 繺 */
dict[0x7e7b] = "rú"; /* 繻 */
dict[0x7e7c] = "jì"; /* 繼 */
dict[0x7e7d] = "bīn"; /* 繽 */
dict[0x7e7e] = "qiǎn"; /* 繾 */
dict[0x7e7f] = "lán"; /* 繿 */
dict[0x7e80] = "pú,fú"; /* 纀 */
dict[0x7e81] = "xūn"; /* 纁 */
dict[0x7e82] = "zuǎn"; /* 纂 */
dict[0x7e83] = "zī"; /* 纃 */
dict[0x7e84] = "péng"; /* 纄 */
dict[0x7e85] = "yào,lì"; /* 纅 */
dict[0x7e86] = "mò"; /* 纆 */
dict[0x7e87] = "lèi"; /* 纇 */
dict[0x7e88] = "xiè"; /* 纈 */
dict[0x7e89] = "zuǎn"; /* 纉 */
dict[0x7e8a] = "kuàng"; /* 纊 */
dict[0x7e8b] = "yōu"; /* 纋 */
dict[0x7e8c] = "xù"; /* 續 */
dict[0x7e8d] = "léi"; /* 纍 */
dict[0x7e8e] = "xiān"; /* 纎 */
dict[0x7e8f] = "chán"; /* 纏 */
dict[0x7e90] = "jiǎo"; /* 纐 */
dict[0x7e91] = "lú"; /* 纑 */
dict[0x7e92] = "chán"; /* 纒 */
dict[0x7e93] = "yīng"; /* 纓 */
dict[0x7e94] = "cái"; /* 纔 */
dict[0x7e95] = "xiāng,rǎng"; /* 纕 */
dict[0x7e96] = "xiān"; /* 纖 */
dict[0x7e97] = "zuī"; /* 纗 */
dict[0x7e98] = "zuǎn"; /* 纘 */
dict[0x7e99] = "luò"; /* 纙 */
dict[0x7e9a] = "lí,xǐ,lǐ,sǎ"; /* 纚 */
dict[0x7e9b] = "dào"; /* 纛 */
dict[0x7e9c] = "lǎn"; /* 纜 */
dict[0x7e9d] = "léi"; /* 纝 */
dict[0x7e9e] = "liàn"; /* 纞 */
dict[0x7e9f] = "sī"; /* 纟 */
dict[0x7ea0] = "jiū"; /* 纠 */
dict[0x7ea1] = "yū"; /* 纡 */
dict[0x7ea2] = "hóng,gōng"; /* 红 */
dict[0x7ea3] = "zhòu"; /* 纣 */
dict[0x7ea4] = "xiān,qiàn"; /* 纤 */
dict[0x7ea5] = "hé,gē"; /* 纥 */
dict[0x7ea6] = "yuē,yāo"; /* 约 */
dict[0x7ea7] = "jí"; /* 级 */
dict[0x7ea8] = "wán"; /* 纨 */
dict[0x7ea9] = "kuàng"; /* 纩 */
dict[0x7eaa] = "jì,jǐ"; /* 纪 */
dict[0x7eab] = "rèn"; /* 纫 */
dict[0x7eac] = "wěi"; /* 纬 */
dict[0x7ead] = "yún"; /* 纭 */
dict[0x7eae] = "hóng"; /* 纮 */
dict[0x7eaf] = "chún"; /* 纯 */
dict[0x7eb0] = "pī,pí,bǐ"; /* 纰 */
dict[0x7eb1] = "shā"; /* 纱 */
dict[0x7eb2] = "gāng"; /* 纲 */
dict[0x7eb3] = "nà"; /* 纳 */
dict[0x7eb4] = "rèn"; /* 纴 */
dict[0x7eb5] = "zòng,zǒng"; /* 纵 */
dict[0x7eb6] = "lún,guān"; /* 纶 */
dict[0x7eb7] = "fēn"; /* 纷 */
dict[0x7eb8] = "zhǐ"; /* 纸 */
dict[0x7eb9] = "wén,wèn"; /* 纹 */
dict[0x7eba] = "fǎng"; /* 纺 */
dict[0x7ebb] = "zhù"; /* 纻 */
dict[0x7ebc] = "zhèn"; /* 纼 */
dict[0x7ebd] = "niǔ"; /* 纽 */
dict[0x7ebe] = "shū"; /* 纾 */
dict[0x7ebf] = "xiàn"; /* 线 */
dict[0x7ec0] = "gàn"; /* 绀 */
dict[0x7ec1] = "xiè"; /* 绁 */
dict[0x7ec2] = "fú"; /* 绂 */
dict[0x7ec3] = "liàn"; /* 练 */
dict[0x7ec4] = "zǔ"; /* 组 */
dict[0x7ec5] = "shēn"; /* 绅 */
dict[0x7ec6] = "xì"; /* 细 */
dict[0x7ec7] = "zhī,zhì"; /* 织 */
dict[0x7ec8] = "zhōng"; /* 终 */
dict[0x7ec9] = "zhòu"; /* 绉 */
dict[0x7eca] = "bàn"; /* 绊 */
dict[0x7ecb] = "fú"; /* 绋 */
dict[0x7ecc] = "chù"; /* 绌 */
dict[0x7ecd] = "shào"; /* 绍 */
dict[0x7ece] = "yì"; /* 绎 */
dict[0x7ecf] = "jīng"; /* 经 */
dict[0x7ed0] = "dài"; /* 绐 */
dict[0x7ed1] = "bǎng"; /* 绑 */
dict[0x7ed2] = "róng"; /* 绒 */
dict[0x7ed3] = "jié,jiē"; /* 结 */
dict[0x7ed4] = "kù"; /* 绔 */
dict[0x7ed5] = "rào"; /* 绕 */
dict[0x7ed6] = "dié"; /* 绖 */
dict[0x7ed7] = "háng"; /* 绗 */
dict[0x7ed8] = "huì"; /* 绘 */
dict[0x7ed9] = "gěi,jǐ"; /* 给 */
dict[0x7eda] = "xuàn"; /* 绚 */
dict[0x7edb] = "jiàng"; /* 绛 */
dict[0x7edc] = "luò,lào"; /* 络 */
dict[0x7edd] = "jué"; /* 绝 */
dict[0x7ede] = "jiǎo"; /* 绞 */
dict[0x7edf] = "tǒng"; /* 统 */
dict[0x7ee0] = "gěng"; /* 绠 */
dict[0x7ee1] = "xiāo"; /* 绡 */
dict[0x7ee2] = "juàn"; /* 绢 */
dict[0x7ee3] = "xiù"; /* 绣 */
dict[0x7ee4] = "xì"; /* 绤 */
dict[0x7ee5] = "suí"; /* 绥 */
dict[0x7ee6] = "tāo"; /* 绦 */
dict[0x7ee7] = "jì"; /* 继 */
dict[0x7ee8] = "tí,tì"; /* 绨 */
dict[0x7ee9] = "jì"; /* 绩 */
dict[0x7eea] = "xù"; /* 绪 */
dict[0x7eeb] = "líng"; /* 绫 */
dict[0x7eec] = "yīng"; /* 绬 */
dict[0x7eed] = "xù"; /* 续 */
dict[0x7eee] = "qǐ"; /* 绮 */
dict[0x7eef] = "fēi"; /* 绯 */
dict[0x7ef0] = "chuò,chāo"; /* 绰 */
dict[0x7ef1] = "shàng"; /* 绱 */
dict[0x7ef2] = "gǔn"; /* 绲 */
dict[0x7ef3] = "shéng"; /* 绳 */
dict[0x7ef4] = "wéi"; /* 维 */
dict[0x7ef5] = "mián"; /* 绵 */
dict[0x7ef6] = "shòu"; /* 绶 */
dict[0x7ef7] = "bēng,běng,bèng"; /* 绷 */
dict[0x7ef8] = "chóu"; /* 绸 */
dict[0x7ef9] = "táo"; /* 绹 */
dict[0x7efa] = "liǔ"; /* 绺 */
dict[0x7efb] = "quǎn"; /* 绻 */
dict[0x7efc] = "zōng,zèng"; /* 综 */
dict[0x7efd] = "zhàn"; /* 绽 */
dict[0x7efe] = "wǎn"; /* 绾 */
dict[0x7eff] = "lǜ,lù"; /* 绿 */
dict[0x7f00] = "zhuì"; /* 缀 */
dict[0x7f01] = "zī"; /* 缁 */
dict[0x7f02] = "kè"; /* 缂 */
dict[0x7f03] = "xiāng"; /* 缃 */
dict[0x7f04] = "jiān"; /* 缄 */
dict[0x7f05] = "miǎn"; /* 缅 */
dict[0x7f06] = "lǎn"; /* 缆 */
dict[0x7f07] = "tí"; /* 缇 */
dict[0x7f08] = "miǎo"; /* 缈 */
dict[0x7f09] = "jī,qī"; /* 缉 */
dict[0x7f0a] = "yùn,yūn,wēn"; /* 缊 */
dict[0x7f0b] = "huì,huí"; /* 缋 */
dict[0x7f0c] = "sī"; /* 缌 */
dict[0x7f0d] = "duǒ"; /* 缍 */
dict[0x7f0e] = "duàn"; /* 缎 */
dict[0x7f0f] = "biàn,pián"; /* 缏 */
dict[0x7f10] = "xiàn"; /* 缐 */
dict[0x7f11] = "gōu"; /* 缑 */
dict[0x7f12] = "zhuì"; /* 缒 */
dict[0x7f13] = "huǎn"; /* 缓 */
dict[0x7f14] = "dì"; /* 缔 */
dict[0x7f15] = "lǚ"; /* 缕 */
dict[0x7f16] = "biān"; /* 编 */
dict[0x7f17] = "mín"; /* 缗 */
dict[0x7f18] = "yuán"; /* 缘 */
dict[0x7f19] = "jìn"; /* 缙 */
dict[0x7f1a] = "fù"; /* 缚 */
dict[0x7f1b] = "rù"; /* 缛 */
dict[0x7f1c] = "zhěn"; /* 缜 */
dict[0x7f1d] = "féng,fèng"; /* 缝 */
dict[0x7f1e] = "cuī,suī,shuāi"; /* 缞 */
dict[0x7f1f] = "gǎo"; /* 缟 */
dict[0x7f20] = "chán"; /* 缠 */
dict[0x7f21] = "lí"; /* 缡 */
dict[0x7f22] = "yì"; /* 缢 */
dict[0x7f23] = "jiān"; /* 缣 */
dict[0x7f24] = "bīn"; /* 缤 */
dict[0x7f25] = "piǎo,piāo"; /* 缥 */
dict[0x7f26] = "màn"; /* 缦 */
dict[0x7f27] = "léi"; /* 缧 */
dict[0x7f28] = "yīng"; /* 缨 */
dict[0x7f29] = "suō,sù"; /* 缩 */
dict[0x7f2a] = "móu,miù,miào,mù,liǎo"; /* 缪 */
dict[0x7f2b] = "sāo"; /* 缫 */
dict[0x7f2c] = "xié"; /* 缬 */
dict[0x7f2d] = "liáo"; /* 缭 */
dict[0x7f2e] = "shàn"; /* 缮 */
dict[0x7f2f] = "zēng,zèng"; /* 缯 */
dict[0x7f30] = "jiāng"; /* 缰 */
dict[0x7f31] = "qiǎn"; /* 缱 */
dict[0x7f32] = "qiāo,sāo"; /* 缲 */
dict[0x7f33] = "huán"; /* 缳 */
dict[0x7f34] = "jiǎo,zhuó"; /* 缴 */
dict[0x7f35] = "zuǎn"; /* 缵 */
dict[0x7f36] = "fǒu"; /* 缶 */
dict[0x7f37] = "xiè"; /* 缷 */
dict[0x7f38] = "gāng"; /* 缸 */
dict[0x7f39] = "fǒu"; /* 缹 */
dict[0x7f3a] = "quē"; /* 缺 */
dict[0x7f3b] = "fǒu"; /* 缻 */
dict[0x7f3c] = "quē"; /* 缼 */
dict[0x7f3d] = "bō"; /* 缽 */
dict[0x7f3e] = "píng"; /* 缾 */
dict[0x7f3f] = "xiàng"; /* 缿 */
dict[0x7f40] = "zhào"; /* 罀 */
dict[0x7f41] = "gāng"; /* 罁 */
dict[0x7f42] = "yīng"; /* 罂 */
dict[0x7f43] = "yīng"; /* 罃 */
dict[0x7f44] = "qìng"; /* 罄 */
dict[0x7f45] = "xià"; /* 罅 */
dict[0x7f46] = "guàn"; /* 罆 */
dict[0x7f47] = "zūn"; /* 罇 */
dict[0x7f48] = "tán"; /* 罈 */
dict[0x7f49] = "chēng"; /* 罉 */
dict[0x7f4a] = "qì"; /* 罊 */
dict[0x7f4b] = "wèng"; /* 罋 */
dict[0x7f4c] = "yīng"; /* 罌 */
dict[0x7f4d] = "léi"; /* 罍 */
dict[0x7f4e] = "tán"; /* 罎 */
dict[0x7f4f] = "lú"; /* 罏 */
dict[0x7f50] = "guàn"; /* 罐 */
dict[0x7f51] = "wǎng"; /* 网 */
dict[0x7f52] = "wǎng"; /* 罒 */
dict[0x7f53] = "wǎng"; /* 罓 */
dict[0x7f54] = "wǎng"; /* 罔 */
dict[0x7f55] = "hǎn"; /* 罕 */
dict[0x7f56] = "wǎng"; /* 罖 */
dict[0x7f57] = "luó"; /* 罗 */
dict[0x7f58] = "fú"; /* 罘 */
dict[0x7f59] = "shēn"; /* 罙 */
dict[0x7f5a] = "fá"; /* 罚 */
dict[0x7f5b] = "gū"; /* 罛 */
dict[0x7f5c] = "zhǔ"; /* 罜 */
dict[0x7f5d] = "jū"; /* 罝 */
dict[0x7f5e] = "máo"; /* 罞 */
dict[0x7f5f] = "gǔ"; /* 罟 */
dict[0x7f60] = "mín"; /* 罠 */
dict[0x7f61] = "gāng"; /* 罡 */
dict[0x7f62] = "bà,ba,pí"; /* 罢 */
dict[0x7f63] = "guà"; /* 罣 */
dict[0x7f64] = "tí"; /* 罤 */
dict[0x7f65] = "juàn"; /* 罥 */
dict[0x7f66] = "fú"; /* 罦 */
dict[0x7f67] = "shēn"; /* 罧 */
dict[0x7f68] = "yǎn"; /* 罨 */
dict[0x7f69] = "zhào"; /* 罩 */
dict[0x7f6a] = "zuì"; /* 罪 */
dict[0x7f6b] = "guǎi,guà"; /* 罫 */
dict[0x7f6c] = "zhuó"; /* 罬 */
dict[0x7f6d] = "yù"; /* 罭 */
dict[0x7f6e] = "zhì"; /* 置 */
dict[0x7f6f] = "ǎn"; /* 罯 */
dict[0x7f70] = "fá"; /* 罰 */
dict[0x7f71] = "lǎn"; /* 罱 */
dict[0x7f72] = "shǔ"; /* 署 */
dict[0x7f73] = "sī"; /* 罳 */
dict[0x7f74] = "pí"; /* 罴 */
dict[0x7f75] = "mà"; /* 罵 */
dict[0x7f76] = "liǔ"; /* 罶 */
dict[0x7f77] = "bà,ba,pí"; /* 罷 */
dict[0x7f78] = "fá"; /* 罸 */
dict[0x7f79] = "lí"; /* 罹 */
dict[0x7f7a] = "cháo"; /* 罺 */
dict[0x7f7b] = "wèi"; /* 罻 */
dict[0x7f7c] = "bì"; /* 罼 */
dict[0x7f7d] = "jì"; /* 罽 */
dict[0x7f7e] = "zēng"; /* 罾 */
dict[0x7f7f] = "chōng"; /* 罿 */
dict[0x7f80] = "liǔ"; /* 羀 */
dict[0x7f81] = "jī"; /* 羁 */
dict[0x7f82] = "juàn"; /* 羂 */
dict[0x7f83] = "mì"; /* 羃 */
dict[0x7f84] = "zhào"; /* 羄 */
dict[0x7f85] = "luó"; /* 羅 */
dict[0x7f86] = "pí"; /* 羆 */
dict[0x7f87] = "jī"; /* 羇 */
dict[0x7f88] = "jī"; /* 羈 */
dict[0x7f89] = "luán"; /* 羉 */
dict[0x7f8a] = "yáng,xiáng"; /* 羊 */
dict[0x7f8b] = "mǐ"; /* 羋 */
dict[0x7f8c] = "qiāng"; /* 羌 */
dict[0x7f8d] = "dá"; /* 羍 */
dict[0x7f8e] = "měi"; /* 美 */
dict[0x7f8f] = "yáng,xiáng"; /* 羏 */
dict[0x7f90] = "líng"; /* 羐 */
dict[0x7f91] = "yǒu"; /* 羑 */
dict[0x7f92] = "fén"; /* 羒 */
dict[0x7f93] = "bā"; /* 羓 */
dict[0x7f94] = "gāo"; /* 羔 */
dict[0x7f95] = "yàng"; /* 羕 */
dict[0x7f96] = "gǔ"; /* 羖 */
dict[0x7f97] = "qiāng"; /* 羗 */
dict[0x7f98] = "zāng"; /* 羘 */
dict[0x7f99] = "měi,gāo"; /* 羙 */
dict[0x7f9a] = "líng"; /* 羚 */
dict[0x7f9b] = "yì,xī"; /* 羛 */
dict[0x7f9c] = "zhù"; /* 羜 */
dict[0x7f9d] = "dī"; /* 羝 */
dict[0x7f9e] = "xiū"; /* 羞 */
dict[0x7f9f] = "qiǎng"; /* 羟 */
dict[0x7fa0] = "yí"; /* 羠 */
dict[0x7fa1] = "xiàn"; /* 羡 */
dict[0x7fa2] = "róng"; /* 羢 */
dict[0x7fa3] = "qún"; /* 羣 */
dict[0x7fa4] = "qún"; /* 群 */
dict[0x7fa5] = "qiǎng"; /* 羥 */
dict[0x7fa6] = "huán"; /* 羦 */
dict[0x7fa7] = "suō"; /* 羧 */
dict[0x7fa8] = "xiàn"; /* 羨 */
dict[0x7fa9] = "yì"; /* 義 */
dict[0x7faa] = "yōu"; /* 羪 */
dict[0x7fab] = "qiāng,kòng"; /* 羫 */
dict[0x7fac] = "qián,xián,yán"; /* 羬 */
dict[0x7fad] = "yú"; /* 羭 */
dict[0x7fae] = "gēng"; /* 羮 */
dict[0x7faf] = "jié"; /* 羯 */
dict[0x7fb0] = "tāng"; /* 羰 */
dict[0x7fb1] = "yuán"; /* 羱 */
dict[0x7fb2] = "xī"; /* 羲 */
dict[0x7fb3] = "fán"; /* 羳 */
dict[0x7fb4] = "shān"; /* 羴 */
dict[0x7fb5] = "fén"; /* 羵 */
dict[0x7fb6] = "shān"; /* 羶 */
dict[0x7fb7] = "liǎn"; /* 羷 */
dict[0x7fb8] = "léi"; /* 羸 */
dict[0x7fb9] = "gēng"; /* 羹 */
dict[0x7fba] = "nóu"; /* 羺 */
dict[0x7fbb] = "qiàng"; /* 羻 */
dict[0x7fbc] = "chàn"; /* 羼 */
dict[0x7fbd] = "yǔ"; /* 羽 */
dict[0x7fbe] = "hóng,gòng"; /* 羾 */
dict[0x7fbf] = "yì"; /* 羿 */
dict[0x7fc0] = "chōng"; /* 翀 */
dict[0x7fc1] = "wēng"; /* 翁 */
dict[0x7fc2] = "fēn"; /* 翂 */
dict[0x7fc3] = "hóng"; /* 翃 */
dict[0x7fc4] = "chì"; /* 翄 */
dict[0x7fc5] = "chì"; /* 翅 */
dict[0x7fc6] = "cuì"; /* 翆 */
dict[0x7fc7] = "fú"; /* 翇 */
dict[0x7fc8] = "xiá"; /* 翈 */
dict[0x7fc9] = "běn"; /* 翉 */
dict[0x7fca] = "yì"; /* 翊 */
dict[0x7fcb] = "là"; /* 翋 */
dict[0x7fcc] = "yì"; /* 翌 */
dict[0x7fcd] = "pī,bì,pō"; /* 翍 */
dict[0x7fce] = "líng"; /* 翎 */
dict[0x7fcf] = "liù"; /* 翏 */
dict[0x7fd0] = "zhì"; /* 翐 */
dict[0x7fd1] = "qú,yù"; /* 翑 */
dict[0x7fd2] = "xí"; /* 習 */
dict[0x7fd3] = "xié"; /* 翓 */
dict[0x7fd4] = "xiáng"; /* 翔 */
dict[0x7fd5] = "xī"; /* 翕 */
dict[0x7fd6] = "xī"; /* 翖 */
dict[0x7fd7] = "ké"; /* 翗 */
dict[0x7fd8] = "qiáo,qiào"; /* 翘 */
dict[0x7fd9] = "huì"; /* 翙 */
dict[0x7fda] = "huī"; /* 翚 */
dict[0x7fdb] = "xiāo"; /* 翛 */
dict[0x7fdc] = "shà"; /* 翜 */
dict[0x7fdd] = "hóng"; /* 翝 */
dict[0x7fde] = "jiāng"; /* 翞 */
dict[0x7fdf] = "dí,zhái"; /* 翟 */
dict[0x7fe0] = "cuì"; /* 翠 */
dict[0x7fe1] = "fěi"; /* 翡 */
dict[0x7fe2] = "dào,zhōu"; /* 翢 */
dict[0x7fe3] = "shà"; /* 翣 */
dict[0x7fe4] = "chì"; /* 翤 */
dict[0x7fe5] = "zhù"; /* 翥 */
dict[0x7fe6] = "jiǎn"; /* 翦 */
dict[0x7fe7] = "xuān"; /* 翧 */
dict[0x7fe8] = "chì"; /* 翨 */
dict[0x7fe9] = "piān"; /* 翩 */
dict[0x7fea] = "zōng"; /* 翪 */
dict[0x7feb] = "wán"; /* 翫 */
dict[0x7fec] = "huī"; /* 翬 */
dict[0x7fed] = "hóu"; /* 翭 */
dict[0x7fee] = "hé"; /* 翮 */
dict[0x7fef] = "hè"; /* 翯 */
dict[0x7ff0] = "hàn"; /* 翰 */
dict[0x7ff1] = "áo"; /* 翱 */
dict[0x7ff2] = "piāo"; /* 翲 */
dict[0x7ff3] = "yì"; /* 翳 */
dict[0x7ff4] = "lián"; /* 翴 */
dict[0x7ff5] = "hóu,qú"; /* 翵 */
dict[0x7ff6] = "áo"; /* 翶 */
dict[0x7ff7] = "lín"; /* 翷 */
dict[0x7ff8] = "pěn"; /* 翸 */
dict[0x7ff9] = "qiáo,qiào"; /* 翹 */
dict[0x7ffa] = "áo"; /* 翺 */
dict[0x7ffb] = "fān"; /* 翻 */
dict[0x7ffc] = "yì"; /* 翼 */
dict[0x7ffd] = "huì"; /* 翽 */
dict[0x7ffe] = "xuān"; /* 翾 */
dict[0x7fff] = "dào"; /* 翿 */
dict[0x8000] = "yào"; /* 耀 */
dict[0x8001] = "lǎo"; /* 老 */
dict[0x8002] = "lǎo"; /* 耂 */
dict[0x8003] = "kǎo"; /* 考 */
dict[0x8004] = "mào"; /* 耄 */
dict[0x8005] = "zhě"; /* 者 */
dict[0x8006] = "qí,shì"; /* 耆 */
dict[0x8007] = "gǒu"; /* 耇 */
dict[0x8008] = "gǒu"; /* 耈 */
dict[0x8009] = "gǒu"; /* 耉 */
dict[0x800a] = "dié"; /* 耊 */
dict[0x800b] = "dié"; /* 耋 */
dict[0x800c] = "ér"; /* 而 */
dict[0x800d] = "shuǎ"; /* 耍 */
dict[0x800e] = "ruǎn,nuò"; /* 耎 */
dict[0x800f] = "ér,nài"; /* 耏 */
dict[0x8010] = "nài"; /* 耐 */
dict[0x8011] = "duān,zhuān"; /* 耑 */
dict[0x8012] = "lěi"; /* 耒 */
dict[0x8013] = "tīng"; /* 耓 */
dict[0x8014] = "zǐ"; /* 耔 */
dict[0x8015] = "gēng"; /* 耕 */
dict[0x8016] = "chào"; /* 耖 */
dict[0x8017] = "hào"; /* 耗 */
dict[0x8018] = "yún"; /* 耘 */
dict[0x8019] = "bà,pá"; /* 耙 */
dict[0x801a] = "pī"; /* 耚 */
dict[0x801b] = "sì,chí"; /* 耛 */
dict[0x801c] = "sì"; /* 耜 */
dict[0x801d] = "qù,chú"; /* 耝 */
dict[0x801e] = "jiā"; /* 耞 */
dict[0x801f] = "jù"; /* 耟 */
dict[0x8020] = "huō"; /* 耠 */
dict[0x8021] = "chú"; /* 耡 */
dict[0x8022] = "lào"; /* 耢 */
dict[0x8023] = "lún,lǔn"; /* 耣 */
dict[0x8024] = "jí,jiè"; /* 耤 */
dict[0x8025] = "tǎng"; /* 耥 */
dict[0x8026] = "ǒu"; /* 耦 */
dict[0x8027] = "lóu"; /* 耧 */
dict[0x8028] = "nòu"; /* 耨 */
dict[0x8029] = "jiǎng"; /* 耩 */
dict[0x802a] = "pǎng"; /* 耪 */
dict[0x802b] = "zhá,zé"; /* 耫 */
dict[0x802c] = "lóu"; /* 耬 */
dict[0x802d] = "jī"; /* 耭 */
dict[0x802e] = "lào"; /* 耮 */
dict[0x802f] = "huò"; /* 耯 */
dict[0x8030] = "yōu"; /* 耰 */
dict[0x8031] = "mò"; /* 耱 */
dict[0x8032] = "huái"; /* 耲 */
dict[0x8033] = "ěr"; /* 耳 */
dict[0x8034] = "yì"; /* 耴 */
dict[0x8035] = "dīng"; /* 耵 */
dict[0x8036] = "yé,yē"; /* 耶 */
dict[0x8037] = "dā"; /* 耷 */
dict[0x8038] = "sǒng"; /* 耸 */
dict[0x8039] = "qín"; /* 耹 */
dict[0x803a] = "yún,yíng"; /* 耺 */
dict[0x803b] = "chǐ"; /* 耻 */
dict[0x803c] = "dān"; /* 耼 */
dict[0x803d] = "dān"; /* 耽 */
dict[0x803e] = "hóng"; /* 耾 */
dict[0x803f] = "gěng"; /* 耿 */
dict[0x8040] = "zhí"; /* 聀 */
dict[0x8041] = "pàn"; /* 聁 */
dict[0x8042] = "niè"; /* 聂 */
dict[0x8043] = "dān"; /* 聃 */
dict[0x8044] = "zhěn"; /* 聄 */
dict[0x8045] = "chè"; /* 聅 */
dict[0x8046] = "líng"; /* 聆 */
dict[0x8047] = "zhēng"; /* 聇 */
dict[0x8048] = "yǒu"; /* 聈 */
dict[0x8049] = "wà,tuǐ,zhuó"; /* 聉 */
dict[0x804a] = "liáo"; /* 聊 */
dict[0x804b] = "lóng"; /* 聋 */
dict[0x804c] = "zhí"; /* 职 */
dict[0x804d] = "níng"; /* 聍 */
dict[0x804e] = "tiāo"; /* 聎 */
dict[0x804f] = "ér,nǜ"; /* 聏 */
dict[0x8050] = "yà"; /* 聐 */
dict[0x8051] = "tiē,zhé"; /* 聑 */
dict[0x8052] = "guō"; /* 聒 */
dict[0x8053] = "xù"; /* 聓 */
dict[0x8054] = "lián"; /* 联 */
dict[0x8055] = "hào"; /* 聕 */
dict[0x8056] = "shèng"; /* 聖 */
dict[0x8057] = "liè"; /* 聗 */
dict[0x8058] = "pìn"; /* 聘 */
dict[0x8059] = "jīng"; /* 聙 */
dict[0x805a] = "jù"; /* 聚 */
dict[0x805b] = "bǐ"; /* 聛 */
dict[0x805c] = "dǐ,zhì"; /* 聜 */
dict[0x805d] = "guó"; /* 聝 */
dict[0x805e] = "wén"; /* 聞 */
dict[0x805f] = "xù"; /* 聟 */
dict[0x8060] = "pīng"; /* 聠 */
dict[0x8061] = "cōng"; /* 聡 */
dict[0x8062] = "dìng"; /* 聢 */
dict[0x8063] = "ní"; /* 聣 */
dict[0x8064] = "tíng"; /* 聤 */
dict[0x8065] = "jǔ"; /* 聥 */
dict[0x8066] = "cōng"; /* 聦 */
dict[0x8067] = "kuī"; /* 聧 */
dict[0x8068] = "lián"; /* 聨 */
dict[0x8069] = "kuì"; /* 聩 */
dict[0x806a] = "cōng"; /* 聪 */
dict[0x806b] = "lián"; /* 聫 */
dict[0x806c] = "wēng"; /* 聬 */
dict[0x806d] = "kuì"; /* 聭 */
dict[0x806e] = "lián"; /* 聮 */
dict[0x806f] = "lián"; /* 聯 */
dict[0x8070] = "cōng"; /* 聰 */
dict[0x8071] = "áo"; /* 聱 */
dict[0x8072] = "shēng"; /* 聲 */
dict[0x8073] = "sǒng"; /* 聳 */
dict[0x8074] = "tīng"; /* 聴 */
dict[0x8075] = "kuì"; /* 聵 */
dict[0x8076] = "niè"; /* 聶 */
dict[0x8077] = "zhí"; /* 職 */
dict[0x8078] = "dān"; /* 聸 */
dict[0x8079] = "níng"; /* 聹 */
dict[0x807a] = "qié"; /* 聺 */
dict[0x807b] = "nǐ,jiàn"; /* 聻 */
dict[0x807c] = "tīng"; /* 聼 */
dict[0x807d] = "tīng"; /* 聽 */
dict[0x807e] = "lóng"; /* 聾 */
dict[0x807f] = "yù"; /* 聿 */
dict[0x8080] = "yù"; /* 肀 */
dict[0x8081] = "zhào"; /* 肁 */
dict[0x8082] = "sì"; /* 肂 */
dict[0x8083] = "sù"; /* 肃 */
dict[0x8084] = "yì"; /* 肄 */
dict[0x8085] = "sù"; /* 肅 */
dict[0x8086] = "sì"; /* 肆 */
dict[0x8087] = "zhào"; /* 肇 */
dict[0x8088] = "zhào"; /* 肈 */
dict[0x8089] = "ròu"; /* 肉 */
dict[0x808a] = "yì"; /* 肊 */
dict[0x808b] = "lèi,lē"; /* 肋 */
dict[0x808c] = "jī"; /* 肌 */
dict[0x808d] = "qiú"; /* 肍 */
dict[0x808e] = "kěn"; /* 肎 */
dict[0x808f] = "cào"; /* 肏 */
dict[0x8090] = "gē"; /* 肐 */
dict[0x8091] = "bó,dí"; /* 肑 */
dict[0x8092] = "huàn"; /* 肒 */
dict[0x8093] = "huāng"; /* 肓 */
dict[0x8094] = "chǐ"; /* 肔 */
dict[0x8095] = "rèn"; /* 肕 */
dict[0x8096] = "xiāo,xiào"; /* 肖 */
dict[0x8097] = "rǔ"; /* 肗 */
dict[0x8098] = "zhǒu"; /* 肘 */
dict[0x8099] = "yuān"; /* 肙 */
dict[0x809a] = "dù,dǔ"; /* 肚 */
dict[0x809b] = "gāng"; /* 肛 */
dict[0x809c] = "róng,chēn"; /* 肜 */
dict[0x809d] = "gān"; /* 肝 */
dict[0x809e] = "chāi"; /* 肞 */
dict[0x809f] = "wò"; /* 肟 */
dict[0x80a0] = "cháng"; /* 肠 */
dict[0x80a1] = "gǔ"; /* 股 */
dict[0x80a2] = "zhī"; /* 肢 */
dict[0x80a3] = "qín,hán,hàn"; /* 肣 */
dict[0x80a4] = "fū"; /* 肤 */
dict[0x80a5] = "féi"; /* 肥 */
dict[0x80a6] = "bān"; /* 肦 */
dict[0x80a7] = "pēi"; /* 肧 */
dict[0x80a8] = "pàng,pán,pàn"; /* 肨 */
dict[0x80a9] = "jiān"; /* 肩 */
dict[0x80aa] = "fáng"; /* 肪 */
dict[0x80ab] = "zhūn,chún"; /* 肫 */
dict[0x80ac] = "yóu"; /* 肬 */
dict[0x80ad] = "nà"; /* 肭 */
dict[0x80ae] = "āng"; /* 肮 */
dict[0x80af] = "kěn"; /* 肯 */
dict[0x80b0] = "rán"; /* 肰 */
dict[0x80b1] = "gōng"; /* 肱 */
dict[0x80b2] = "yù"; /* 育 */
dict[0x80b3] = "wěn"; /* 肳 */
dict[0x80b4] = "yáo"; /* 肴 */
dict[0x80b5] = "qí"; /* 肵 */
dict[0x80b6] = "pí,bǐ,bì"; /* 肶 */
dict[0x80b7] = "qiǎn"; /* 肷 */
dict[0x80b8] = "xī"; /* 肸 */
dict[0x80b9] = "xī"; /* 肹 */
dict[0x80ba] = "fèi"; /* 肺 */
dict[0x80bb] = "kěn"; /* 肻 */
dict[0x80bc] = "jǐng"; /* 肼 */
dict[0x80bd] = "tài"; /* 肽 */
dict[0x80be] = "shèn"; /* 肾 */
dict[0x80bf] = "zhǒng"; /* 肿 */
dict[0x80c0] = "zhàng"; /* 胀 */
dict[0x80c1] = "xié"; /* 胁 */
dict[0x80c2] = "shèn"; /* 胂 */
dict[0x80c3] = "wèi"; /* 胃 */
dict[0x80c4] = "zhòu"; /* 胄 */
dict[0x80c5] = "dié"; /* 胅 */
dict[0x80c6] = "dǎn"; /* 胆 */
dict[0x80c7] = "fèi,bì"; /* 胇 */
dict[0x80c8] = "bá"; /* 胈 */
dict[0x80c9] = "bó"; /* 胉 */
dict[0x80ca] = "qú"; /* 胊 */
dict[0x80cb] = "tián"; /* 胋 */
dict[0x80cc] = "bèi,bēi"; /* 背 */
dict[0x80cd] = "guā"; /* 胍 */
dict[0x80ce] = "tāi"; /* 胎 */
dict[0x80cf] = "zǐ,fèi"; /* 胏 */
dict[0x80d0] = "fěi,kū"; /* 胐 */
dict[0x80d1] = "zhī"; /* 胑 */
dict[0x80d2] = "nì"; /* 胒 */
dict[0x80d3] = "píng,pēng"; /* 胓 */
dict[0x80d4] = "zì"; /* 胔 */
dict[0x80d5] = "fū,fú,zhǒu"; /* 胕 */
dict[0x80d6] = "pàng,pán,pàn"; /* 胖 */
dict[0x80d7] = "zhēn"; /* 胗 */
dict[0x80d8] = "xián"; /* 胘 */
dict[0x80d9] = "zuò"; /* 胙 */
dict[0x80da] = "pēi"; /* 胚 */
dict[0x80db] = "jiǎ"; /* 胛 */
dict[0x80dc] = "shèng"; /* 胜 */
dict[0x80dd] = "zhī"; /* 胝 */
dict[0x80de] = "bāo"; /* 胞 */
dict[0x80df] = "mǔ"; /* 胟 */
dict[0x80e0] = "qū"; /* 胠 */
dict[0x80e1] = "hú"; /* 胡 */
dict[0x80e2] = "qià"; /* 胢 */
dict[0x80e3] = "chǐ"; /* 胣 */
dict[0x80e4] = "yìn"; /* 胤 */
dict[0x80e5] = "xū"; /* 胥 */
dict[0x80e6] = "yāng"; /* 胦 */
dict[0x80e7] = "lóng"; /* 胧 */
dict[0x80e8] = "dòng"; /* 胨 */
dict[0x80e9] = "kǎ"; /* 胩 */
dict[0x80ea] = "lú"; /* 胪 */
dict[0x80eb] = "jìng"; /* 胫 */
dict[0x80ec] = "nǔ"; /* 胬 */
dict[0x80ed] = "yān"; /* 胭 */
dict[0x80ee] = "pāng"; /* 胮 */
dict[0x80ef] = "kuà"; /* 胯 */
dict[0x80f0] = "yí"; /* 胰 */
dict[0x80f1] = "guāng"; /* 胱 */
dict[0x80f2] = "hǎi"; /* 胲 */
dict[0x80f3] = "gē,gé"; /* 胳 */
dict[0x80f4] = "dòng"; /* 胴 */
dict[0x80f5] = "chī"; /* 胵 */
dict[0x80f6] = "jiāo"; /* 胶 */
dict[0x80f7] = "xiōng"; /* 胷 */
dict[0x80f8] = "xiōng"; /* 胸 */
dict[0x80f9] = "ér"; /* 胹 */
dict[0x80fa] = "àn"; /* 胺 */
dict[0x80fb] = "héng"; /* 胻 */
dict[0x80fc] = "pián"; /* 胼 */
dict[0x80fd] = "néng,nài"; /* 能 */
dict[0x80fe] = "zì"; /* 胾 */
dict[0x80ff] = "guī,kuì"; /* 胿 */
dict[0x8100] = "zhēng"; /* 脀 */
dict[0x8101] = "tiǎo"; /* 脁 */
dict[0x8102] = "zhī"; /* 脂 */
dict[0x8103] = "cuì"; /* 脃 */
dict[0x8104] = "méi"; /* 脄 */
dict[0x8105] = "xié"; /* 脅 */
dict[0x8106] = "cuì"; /* 脆 */
dict[0x8107] = "xié"; /* 脇 */
dict[0x8108] = "mài"; /* 脈 */
dict[0x8109] = "mài,mò"; /* 脉 */
dict[0x810a] = "jǐ"; /* 脊 */
dict[0x810b] = "xié"; /* 脋 */
dict[0x810c] = "nín"; /* 脌 */
dict[0x810d] = "kuài"; /* 脍 */
dict[0x810e] = "sà"; /* 脎 */
dict[0x810f] = "zāng,zàng"; /* 脏 */
dict[0x8110] = "qí"; /* 脐 */
dict[0x8111] = "nǎo"; /* 脑 */
dict[0x8112] = "mǐ"; /* 脒 */
dict[0x8113] = "nóng"; /* 脓 */
dict[0x8114] = "luán"; /* 脔 */
dict[0x8115] = "wàn"; /* 脕 */
dict[0x8116] = "bó"; /* 脖 */
dict[0x8117] = "wěn"; /* 脗 */
dict[0x8118] = "wǎn"; /* 脘 */
dict[0x8119] = "xiū"; /* 脙 */
dict[0x811a] = "jiǎo"; /* 脚 */
dict[0x811b] = "jìng"; /* 脛 */
dict[0x811c] = "róu"; /* 脜 */
dict[0x811d] = "hēng"; /* 脝 */
dict[0x811e] = "cuǒ"; /* 脞 */
dict[0x811f] = "liè"; /* 脟 */
dict[0x8120] = "shān"; /* 脠 */
dict[0x8121] = "tǐng"; /* 脡 */
dict[0x8122] = "méi"; /* 脢 */
dict[0x8123] = "chún"; /* 脣 */
dict[0x8124] = "shèn"; /* 脤 */
dict[0x8125] = "jiá"; /* 脥 */
dict[0x8126] = "tè"; /* 脦 */
dict[0x8127] = "juān"; /* 脧 */
dict[0x8128] = "cù"; /* 脨 */
dict[0x8129] = "xiū"; /* 脩 */
dict[0x812a] = "xìn"; /* 脪 */
dict[0x812b] = "tuō"; /* 脫 */
dict[0x812c] = "pāo"; /* 脬 */
dict[0x812d] = "chéng"; /* 脭 */
dict[0x812e] = "něi"; /* 脮 */
dict[0x812f] = "fǔ"; /* 脯 */
dict[0x8130] = "dòu"; /* 脰 */
dict[0x8131] = "tuō"; /* 脱 */
dict[0x8132] = "niào"; /* 脲 */
dict[0x8133] = "nǎo"; /* 脳 */
dict[0x8134] = "pǐ"; /* 脴 */
dict[0x8135] = "gǔ"; /* 脵 */
dict[0x8136] = "luó"; /* 脶 */
dict[0x8137] = "lì"; /* 脷 */
dict[0x8138] = "liǎn"; /* 脸 */
dict[0x8139] = "zhàng"; /* 脹 */
dict[0x813a] = "cuī"; /* 脺 */
dict[0x813b] = "jiē"; /* 脻 */
dict[0x813c] = "liǎng"; /* 脼 */
dict[0x813d] = "shuí"; /* 脽 */
dict[0x813e] = "pí"; /* 脾 */
dict[0x813f] = "biāo"; /* 脿 */
dict[0x8140] = "lún"; /* 腀 */
dict[0x8141] = "pián"; /* 腁 */
dict[0x8142] = "guò"; /* 腂 */
dict[0x8143] = "juàn"; /* 腃 */
dict[0x8144] = "chuí"; /* 腄 */
dict[0x8145] = "dàn"; /* 腅 */
dict[0x8146] = "tiǎn"; /* 腆 */
dict[0x8147] = "něi"; /* 腇 */
dict[0x8148] = "jīng"; /* 腈 */
dict[0x8149] = "nái"; /* 腉 */
dict[0x814a] = "là,xī"; /* 腊 */
dict[0x814b] = "yè"; /* 腋 */
dict[0x814c] = "ā,yān"; /* 腌 */
dict[0x814d] = "rèn"; /* 腍 */
dict[0x814e] = "shèn"; /* 腎 */
dict[0x814f] = "zhuì"; /* 腏 */
dict[0x8150] = "fǔ"; /* 腐 */
dict[0x8151] = "fǔ"; /* 腑 */
dict[0x8152] = "jū"; /* 腒 */
dict[0x8153] = "féi"; /* 腓 */
dict[0x8154] = "qiāng"; /* 腔 */
dict[0x8155] = "wàn"; /* 腕 */
dict[0x8156] = "dòng"; /* 腖 */
dict[0x8157] = "pí"; /* 腗 */
dict[0x8158] = "guó"; /* 腘 */
dict[0x8159] = "zōng"; /* 腙 */
dict[0x815a] = "dìng"; /* 腚 */
dict[0x815b] = "wò"; /* 腛 */
dict[0x815c] = "méi"; /* 腜 */
dict[0x815d] = "ruǎn"; /* 腝 */
dict[0x815e] = "zhuàn"; /* 腞 */
dict[0x815f] = "chì"; /* 腟 */
dict[0x8160] = "còu"; /* 腠 */
dict[0x8161] = "luó"; /* 腡 */
dict[0x8162] = "ǒu"; /* 腢 */
dict[0x8163] = "dì"; /* 腣 */
dict[0x8164] = "ān"; /* 腤 */
dict[0x8165] = "xīng"; /* 腥 */
dict[0x8166] = "nǎo"; /* 腦 */
dict[0x8167] = "shù"; /* 腧 */
dict[0x8168] = "shuàn"; /* 腨 */
dict[0x8169] = "nǎn"; /* 腩 */
dict[0x816a] = "yùn"; /* 腪 */
dict[0x816b] = "zhǒng"; /* 腫 */
dict[0x816c] = "róu"; /* 腬 */
dict[0x816d] = "è"; /* 腭 */
dict[0x816e] = "sāi"; /* 腮 */
dict[0x816f] = "tú"; /* 腯 */
dict[0x8170] = "yāo"; /* 腰 */
dict[0x8171] = "jiàn"; /* 腱 */
dict[0x8172] = "wěi"; /* 腲 */
dict[0x8173] = "jiǎo"; /* 腳 */
dict[0x8174] = "yú"; /* 腴 */
dict[0x8175] = "jiā"; /* 腵 */
dict[0x8176] = "duàn"; /* 腶 */
dict[0x8177] = "bì"; /* 腷 */
dict[0x8178] = "cháng"; /* 腸 */
dict[0x8179] = "fù"; /* 腹 */
dict[0x817a] = "xiàn"; /* 腺 */
dict[0x817b] = "nì"; /* 腻 */
dict[0x817c] = "miǎn"; /* 腼 */
dict[0x817d] = "wà"; /* 腽 */
dict[0x817e] = "téng"; /* 腾 */
dict[0x817f] = "tuǐ"; /* 腿 */
dict[0x8180] = "bǎng,páng"; /* 膀 */
dict[0x8181] = "qiǎn"; /* 膁 */
dict[0x8182] = "lǚ"; /* 膂 */
dict[0x8183] = "wà"; /* 膃 */
dict[0x8184] = "shòu"; /* 膄 */
dict[0x8185] = "táng"; /* 膅 */
dict[0x8186] = "sù"; /* 膆 */
dict[0x8187] = "zhuì"; /* 膇 */
dict[0x8188] = "gé"; /* 膈 */
dict[0x8189] = "yì"; /* 膉 */
dict[0x818a] = "bó"; /* 膊 */
dict[0x818b] = "liáo"; /* 膋 */
dict[0x818c] = "jí"; /* 膌 */
dict[0x818d] = "pí"; /* 膍 */
dict[0x818e] = "xié"; /* 膎 */
dict[0x818f] = "gāo,gào"; /* 膏 */
dict[0x8190] = "lǚ"; /* 膐 */
dict[0x8191] = "bìn"; /* 膑 */
dict[0x8192] = "ōu"; /* 膒 */
dict[0x8193] = "cháng"; /* 膓 */
dict[0x8194] = "lù,biāo"; /* 膔 */
dict[0x8195] = "guó"; /* 膕 */
dict[0x8196] = "pāng"; /* 膖 */
dict[0x8197] = "chuái"; /* 膗 */
dict[0x8198] = "biāo"; /* 膘 */
dict[0x8199] = "jiǎng"; /* 膙 */
dict[0x819a] = "fū"; /* 膚 */
dict[0x819b] = "táng"; /* 膛 */
dict[0x819c] = "mó"; /* 膜 */
dict[0x819d] = "xī"; /* 膝 */
dict[0x819e] = "zhuān,chuán,chún,zhuǎn"; /* 膞 */
dict[0x819f] = "lǜ"; /* 膟 */
dict[0x81a0] = "jiāo"; /* 膠 */
dict[0x81a1] = "yìng"; /* 膡 */
dict[0x81a2] = "lǘ"; /* 膢 */
dict[0x81a3] = "zhì"; /* 膣 */
dict[0x81a4] = "xuě"; /* 膤 */
dict[0x81a5] = "cūn"; /* 膥 */
dict[0x81a6] = "lìn"; /* 膦 */
dict[0x81a7] = "tóng"; /* 膧 */
dict[0x81a8] = "péng"; /* 膨 */
dict[0x81a9] = "nì"; /* 膩 */
dict[0x81aa] = "chuài"; /* 膪 */
dict[0x81ab] = "liáo"; /* 膫 */
dict[0x81ac] = "cuì"; /* 膬 */
dict[0x81ad] = "kuì"; /* 膭 */
dict[0x81ae] = "xiāo"; /* 膮 */
dict[0x81af] = "tēng"; /* 膯 */
dict[0x81b0] = "fán,pán"; /* 膰 */
dict[0x81b1] = "zhí"; /* 膱 */
dict[0x81b2] = "jiāo"; /* 膲 */
dict[0x81b3] = "shàn"; /* 膳 */
dict[0x81b4] = "hū,wǔ"; /* 膴 */
dict[0x81b5] = "cuì"; /* 膵 */
dict[0x81b6] = "rùn"; /* 膶 */
dict[0x81b7] = "xiāng"; /* 膷 */
dict[0x81b8] = "suǐ"; /* 膸 */
dict[0x81b9] = "fèn"; /* 膹 */
dict[0x81ba] = "yīng"; /* 膺 */
dict[0x81bb] = "shān,dàn"; /* 膻 */
dict[0x81bc] = "zhuā"; /* 膼 */
dict[0x81bd] = "dǎn"; /* 膽 */
dict[0x81be] = "kuài"; /* 膾 */
dict[0x81bf] = "nóng"; /* 膿 */
dict[0x81c0] = "tún"; /* 臀 */
dict[0x81c1] = "lián"; /* 臁 */
dict[0x81c2] = "bì,bei"; /* 臂 */
dict[0x81c3] = "yōng"; /* 臃 */
dict[0x81c4] = "jué"; /* 臄 */
dict[0x81c5] = "chù"; /* 臅 */
dict[0x81c6] = "yì"; /* 臆 */
dict[0x81c7] = "juǎn"; /* 臇 */
dict[0x81c8] = "là,gé"; /* 臈 */
dict[0x81c9] = "liǎn"; /* 臉 */
dict[0x81ca] = "sāo,sào"; /* 臊 */
dict[0x81cb] = "tún"; /* 臋 */
dict[0x81cc] = "gǔ"; /* 臌 */
dict[0x81cd] = "qí"; /* 臍 */
dict[0x81ce] = "cuì"; /* 臎 */
dict[0x81cf] = "bìn"; /* 臏 */
dict[0x81d0] = "xūn"; /* 臐 */
dict[0x81d1] = "nào"; /* 臑 */
dict[0x81d2] = "wò,yuè"; /* 臒 */
dict[0x81d3] = "zàng"; /* 臓 */
dict[0x81d4] = "xiàn"; /* 臔 */
dict[0x81d5] = "biāo"; /* 臕 */
dict[0x81d6] = "xìng"; /* 臖 */
dict[0x81d7] = "kuān"; /* 臗 */
dict[0x81d8] = "là"; /* 臘 */
dict[0x81d9] = "yān"; /* 臙 */
dict[0x81da] = "lú"; /* 臚 */
dict[0x81db] = "huò"; /* 臛 */
dict[0x81dc] = "zā"; /* 臜 */
dict[0x81dd] = "luǒ"; /* 臝 */
dict[0x81de] = "qú"; /* 臞 */
dict[0x81df] = "zàng"; /* 臟 */
dict[0x81e0] = "luán"; /* 臠 */
dict[0x81e1] = "ní,luán"; /* 臡 */
dict[0x81e2] = "zā"; /* 臢 */
dict[0x81e3] = "chén"; /* 臣 */
dict[0x81e4] = "qiān,xián"; /* 臤 */
dict[0x81e5] = "wò"; /* 臥 */
dict[0x81e6] = "guàng,jiǒng"; /* 臦 */
dict[0x81e7] = "zāng,zàng,cáng"; /* 臧 */
dict[0x81e8] = "lín"; /* 臨 */
dict[0x81e9] = "guǎng,jiǒng"; /* 臩 */
dict[0x81ea] = "zì"; /* 自 */
dict[0x81eb] = "jiǎo"; /* 臫 */
dict[0x81ec] = "niè"; /* 臬 */
dict[0x81ed] = "chòu,xiù"; /* 臭 */
dict[0x81ee] = "jì"; /* 臮 */
dict[0x81ef] = "gāo"; /* 臯 */
dict[0x81f0] = "chòu"; /* 臰 */
dict[0x81f1] = "mián,biān"; /* 臱 */
dict[0x81f2] = "niè"; /* 臲 */
dict[0x81f3] = "zhì"; /* 至 */
dict[0x81f4] = "zhì"; /* 致 */
dict[0x81f5] = "gé"; /* 臵 */
dict[0x81f6] = "jiàn"; /* 臶 */
dict[0x81f7] = "dié,zhí"; /* 臷 */
dict[0x81f8] = "zhī,jìn"; /* 臸 */
dict[0x81f9] = "xiū"; /* 臹 */
dict[0x81fa] = "tái"; /* 臺 */
dict[0x81fb] = "zhēn"; /* 臻 */
dict[0x81fc] = "jiù"; /* 臼 */
dict[0x81fd] = "xiàn"; /* 臽 */
dict[0x81fe] = "yú"; /* 臾 */
dict[0x81ff] = "chā"; /* 臿 */
dict[0x8200] = "yǎo"; /* 舀 */
dict[0x8201] = "yú"; /* 舁 */
dict[0x8202] = "chōng"; /* 舂 */
dict[0x8203] = "xì"; /* 舃 */
dict[0x8204] = "xì"; /* 舄 */
dict[0x8205] = "jiù"; /* 舅 */
dict[0x8206] = "yú"; /* 舆 */
dict[0x8207] = "yǔ"; /* 與 */
dict[0x8208] = "xīng"; /* 興 */
dict[0x8209] = "jǔ"; /* 舉 */
dict[0x820a] = "jiù"; /* 舊 */
dict[0x820b] = "xìn"; /* 舋 */
dict[0x820c] = "shé"; /* 舌 */
dict[0x820d] = "shě,shè"; /* 舍 */
dict[0x820e] = "shè"; /* 舎 */
dict[0x820f] = "jiǔ"; /* 舏 */
dict[0x8210] = "shì"; /* 舐 */
dict[0x8211] = "tān"; /* 舑 */
dict[0x8212] = "shū"; /* 舒 */
dict[0x8213] = "shì"; /* 舓 */
dict[0x8214] = "tiǎn"; /* 舔 */
dict[0x8215] = "tàn"; /* 舕 */
dict[0x8216] = "pù"; /* 舖 */
dict[0x8217] = "pù"; /* 舗 */
dict[0x8218] = "guǎn"; /* 舘 */
dict[0x8219] = "huà"; /* 舙 */
dict[0x821a] = "tiàn"; /* 舚 */
dict[0x821b] = "chuǎn"; /* 舛 */
dict[0x821c] = "shùn"; /* 舜 */
dict[0x821d] = "xiá"; /* 舝 */
dict[0x821e] = "wǔ"; /* 舞 */
dict[0x821f] = "zhōu"; /* 舟 */
dict[0x8220] = "dāo"; /* 舠 */
dict[0x8221] = "chuán"; /* 舡 */
dict[0x8222] = "shān"; /* 舢 */
dict[0x8223] = "yǐ"; /* 舣 */
dict[0x8224] = "fán"; /* 舤 */
dict[0x8225] = "pā"; /* 舥 */
dict[0x8226] = "tài"; /* 舦 */
dict[0x8227] = "fán"; /* 舧 */
dict[0x8228] = "bǎn"; /* 舨 */
dict[0x8229] = "chuán"; /* 舩 */
dict[0x822a] = "háng"; /* 航 */
dict[0x822b] = "fǎng"; /* 舫 */
dict[0x822c] = "bān"; /* 般 */
dict[0x822d] = "bǐ"; /* 舭 */
dict[0x822e] = "lú"; /* 舮 */
dict[0x822f] = "zhōng"; /* 舯 */
dict[0x8230] = "jiàn"; /* 舰 */
dict[0x8231] = "cāng"; /* 舱 */
dict[0x8232] = "líng"; /* 舲 */
dict[0x8233] = "zhú"; /* 舳 */
dict[0x8234] = "zé"; /* 舴 */
dict[0x8235] = "duò"; /* 舵 */
dict[0x8236] = "bó"; /* 舶 */
dict[0x8237] = "xián"; /* 舷 */
dict[0x8238] = "gě"; /* 舸 */
dict[0x8239] = "chuán"; /* 船 */
dict[0x823a] = "xiá"; /* 舺 */
dict[0x823b] = "lú"; /* 舻 */
dict[0x823c] = "qióng"; /* 舼 */
dict[0x823d] = "páng"; /* 舽 */
dict[0x823e] = "xī"; /* 舾 */
dict[0x823f] = "kuā"; /* 舿 */
dict[0x8240] = "fú"; /* 艀 */
dict[0x8241] = "zào"; /* 艁 */
dict[0x8242] = "féng"; /* 艂 */
dict[0x8243] = "lí"; /* 艃 */
dict[0x8244] = "shāo"; /* 艄 */
dict[0x8245] = "yú"; /* 艅 */
dict[0x8246] = "láng"; /* 艆 */
dict[0x8247] = "tǐng"; /* 艇 */
dict[0x8248] = "yù"; /* 艈 */
dict[0x8249] = "wěi"; /* 艉 */
dict[0x824a] = "bó"; /* 艊 */
dict[0x824b] = "měng"; /* 艋 */
dict[0x824c] = "niàn"; /* 艌 */
dict[0x824d] = "jū"; /* 艍 */
dict[0x824e] = "huáng"; /* 艎 */
dict[0x824f] = "shǒu"; /* 艏 */
dict[0x8250] = "kè"; /* 艐 */
dict[0x8251] = "biàn"; /* 艑 */
dict[0x8252] = "mù"; /* 艒 */
dict[0x8253] = "dié"; /* 艓 */
dict[0x8254] = "dào"; /* 艔 */
dict[0x8255] = "bàng"; /* 艕 */
dict[0x8256] = "chā"; /* 艖 */
dict[0x8257] = "yì"; /* 艗 */
dict[0x8258] = "sōu"; /* 艘 */
dict[0x8259] = "cāng"; /* 艙 */
dict[0x825a] = "cáo"; /* 艚 */
dict[0x825b] = "lóu"; /* 艛 */
dict[0x825c] = "dài"; /* 艜 */
dict[0x825d] = "xuě"; /* 艝 */
dict[0x825e] = "yào"; /* 艞 */
dict[0x825f] = "chōng"; /* 艟 */
dict[0x8260] = "dēng"; /* 艠 */
dict[0x8261] = "dāng"; /* 艡 */
dict[0x8262] = "qiáng"; /* 艢 */
dict[0x8263] = "lǔ"; /* 艣 */
dict[0x8264] = "yǐ"; /* 艤 */
dict[0x8265] = "jí"; /* 艥 */
dict[0x8266] = "jiàn"; /* 艦 */
dict[0x8267] = "huò"; /* 艧 */
dict[0x8268] = "méng"; /* 艨 */
dict[0x8269] = "qí"; /* 艩 */
dict[0x826a] = "lǔ"; /* 艪 */
dict[0x826b] = "lú"; /* 艫 */
dict[0x826c] = "chán"; /* 艬 */
dict[0x826d] = "shuāng"; /* 艭 */
dict[0x826e] = "gèn"; /* 艮 */
dict[0x826f] = "liáng"; /* 良 */
dict[0x8270] = "jiān"; /* 艰 */
dict[0x8271] = "jiān"; /* 艱 */
dict[0x8272] = "sè"; /* 色 */
dict[0x8273] = "yàn"; /* 艳 */
dict[0x8274] = "fú"; /* 艴 */
dict[0x8275] = "pīng"; /* 艵 */
dict[0x8276] = "yàn"; /* 艶 */
dict[0x8277] = "yàn"; /* 艷 */
dict[0x8278] = "cǎo"; /* 艸 */
dict[0x8279] = "ǎo"; /* 艹 */
dict[0x827a] = "yì"; /* 艺 */
dict[0x827b] = "lè"; /* 艻 */
dict[0x827c] = "dǐng"; /* 艼 */
dict[0x827d] = "jiāo,qiú"; /* 艽 */
dict[0x827e] = "ài,yì"; /* 艾 */
dict[0x827f] = "nǎi"; /* 艿 */
dict[0x8280] = "tiáo"; /* 芀 */
dict[0x8281] = "qiú"; /* 芁 */
dict[0x8282] = "jié,jiē"; /* 节 */
dict[0x8283] = "péng"; /* 芃 */
dict[0x8284] = "wán"; /* 芄 */
dict[0x8285] = "yì"; /* 芅 */
dict[0x8286] = "chāi,chā"; /* 芆 */
dict[0x8287] = "mián"; /* 芇 */
dict[0x8288] = "mǐ"; /* 芈 */
dict[0x8289] = "gǎn"; /* 芉 */
dict[0x828a] = "qiān"; /* 芊 */
dict[0x828b] = "yù"; /* 芋 */
dict[0x828c] = "yù"; /* 芌 */
dict[0x828d] = "sháo"; /* 芍 */
dict[0x828e] = "xiōng"; /* 芎 */
dict[0x828f] = "dù"; /* 芏 */
dict[0x8290] = "hù,xià"; /* 芐 */
dict[0x8291] = "qǐ"; /* 芑 */
dict[0x8292] = "máng"; /* 芒 */
dict[0x8293] = "zì,zǐ"; /* 芓 */
dict[0x8294] = "huì,hū"; /* 芔 */
dict[0x8295] = "suī"; /* 芕 */
dict[0x8296] = "zhì"; /* 芖 */
dict[0x8297] = "xiāng"; /* 芗 */
dict[0x8298] = "bì,pí"; /* 芘 */
dict[0x8299] = "fú"; /* 芙 */
dict[0x829a] = "tún,chūn"; /* 芚 */
dict[0x829b] = "wěi"; /* 芛 */
dict[0x829c] = "wú"; /* 芜 */
dict[0x829d] = "zhī"; /* 芝 */
dict[0x829e] = "qì"; /* 芞 */
dict[0x829f] = "shān"; /* 芟 */
dict[0x82a0] = "wén"; /* 芠 */
dict[0x82a1] = "qiàn"; /* 芡 */
dict[0x82a2] = "rén"; /* 芢 */
dict[0x82a3] = "fú"; /* 芣 */
dict[0x82a4] = "kōu"; /* 芤 */
dict[0x82a5] = "jiè,gài"; /* 芥 */
dict[0x82a6] = "lú"; /* 芦 */
dict[0x82a7] = "xù,zhù"; /* 芧 */
dict[0x82a8] = "jī"; /* 芨 */
dict[0x82a9] = "qín"; /* 芩 */
dict[0x82aa] = "qí"; /* 芪 */
dict[0x82ab] = "yuán,yán"; /* 芫 */
dict[0x82ac] = "fēn"; /* 芬 */
dict[0x82ad] = "bā"; /* 芭 */
dict[0x82ae] = "ruì"; /* 芮 */
dict[0x82af] = "xīn,xìn"; /* 芯 */
dict[0x82b0] = "jì"; /* 芰 */
dict[0x82b1] = "huā"; /* 花 */
dict[0x82b2] = "lún,huā"; /* 芲 */
dict[0x82b3] = "fāng"; /* 芳 */
dict[0x82b4] = "wù,hū"; /* 芴 */
dict[0x82b5] = "jué"; /* 芵 */
dict[0x82b6] = "gōu,gǒu"; /* 芶 */
dict[0x82b7] = "zhǐ"; /* 芷 */
dict[0x82b8] = "yún"; /* 芸 */
dict[0x82b9] = "qín"; /* 芹 */
dict[0x82ba] = "ǎo"; /* 芺 */
dict[0x82bb] = "chú"; /* 芻 */
dict[0x82bc] = "máo,mào"; /* 芼 */
dict[0x82bd] = "yá"; /* 芽 */
dict[0x82be] = "fèi,fú"; /* 芾 */
dict[0x82bf] = "réng"; /* 芿 */
dict[0x82c0] = "háng"; /* 苀 */
dict[0x82c1] = "cōng"; /* 苁 */
dict[0x82c2] = "chán,yín"; /* 苂 */
dict[0x82c3] = "yǒu"; /* 苃 */
dict[0x82c4] = "biàn"; /* 苄 */
dict[0x82c5] = "yì"; /* 苅 */
dict[0x82c6] = "qiē"; /* 苆 */
dict[0x82c7] = "wěi"; /* 苇 */
dict[0x82c8] = "lì"; /* 苈 */
dict[0x82c9] = "pǐ"; /* 苉 */
dict[0x82ca] = "è"; /* 苊 */
dict[0x82cb] = "xiàn"; /* 苋 */
dict[0x82cc] = "cháng"; /* 苌 */
dict[0x82cd] = "cāng"; /* 苍 */
dict[0x82ce] = "zhù"; /* 苎 */
dict[0x82cf] = "sū,sù"; /* 苏 */
dict[0x82d0] = "dì,tí"; /* 苐 */
dict[0x82d1] = "yuàn"; /* 苑 */
dict[0x82d2] = "rǎn"; /* 苒 */
dict[0x82d3] = "líng"; /* 苓 */
dict[0x82d4] = "tái,tāi"; /* 苔 */
dict[0x82d5] = "tiáo,sháo"; /* 苕 */
dict[0x82d6] = "dí"; /* 苖 */
dict[0x82d7] = "miáo"; /* 苗 */
dict[0x82d8] = "qǐng"; /* 苘 */
dict[0x82d9] = "lì,jī"; /* 苙 */
dict[0x82da] = "yòng"; /* 苚 */
dict[0x82db] = "kē,hē"; /* 苛 */
dict[0x82dc] = "mù"; /* 苜 */
dict[0x82dd] = "bèi"; /* 苝 */
dict[0x82de] = "bāo"; /* 苞 */
dict[0x82df] = "gǒu"; /* 苟 */
dict[0x82e0] = "mín"; /* 苠 */
dict[0x82e1] = "yǐ"; /* 苡 */
dict[0x82e2] = "yǐ"; /* 苢 */
dict[0x82e3] = "jù,qǔ"; /* 苣 */
dict[0x82e4] = "piě"; /* 苤 */
dict[0x82e5] = "ruò,rě"; /* 若 */
dict[0x82e6] = "kǔ"; /* 苦 */
dict[0x82e7] = "zhù,níng"; /* 苧 */
dict[0x82e8] = "nǐ"; /* 苨 */
dict[0x82e9] = "pā,bó"; /* 苩 */
dict[0x82ea] = "bǐng"; /* 苪 */
dict[0x82eb] = "shān,shàn"; /* 苫 */
dict[0x82ec] = "xiú"; /* 苬 */
dict[0x82ed] = "yǎo"; /* 苭 */
dict[0x82ee] = "xiān"; /* 苮 */
dict[0x82ef] = "běn"; /* 苯 */
dict[0x82f0] = "hóng"; /* 苰 */
dict[0x82f1] = "yīng"; /* 英 */
dict[0x82f2] = "zuó,zhǎ"; /* 苲 */
dict[0x82f3] = "dōng"; /* 苳 */
dict[0x82f4] = "jū,chá"; /* 苴 */
dict[0x82f5] = "dié"; /* 苵 */
dict[0x82f6] = "nié"; /* 苶 */
dict[0x82f7] = "gān"; /* 苷 */
dict[0x82f8] = "hū"; /* 苸 */
dict[0x82f9] = "píng,pēng"; /* 苹 */
dict[0x82fa] = "méi"; /* 苺 */
dict[0x82fb] = "fú"; /* 苻 */
dict[0x82fc] = "shēng,ruí"; /* 苼 */
dict[0x82fd] = "gū"; /* 苽 */
dict[0x82fe] = "bì"; /* 苾 */
dict[0x82ff] = "wèi"; /* 苿 */
dict[0x8300] = "fú"; /* 茀 */
dict[0x8301] = "zhuó"; /* 茁 */
dict[0x8302] = "mào"; /* 茂 */
dict[0x8303] = "fàn"; /* 范 */
dict[0x8304] = "qié"; /* 茄 */
dict[0x8305] = "máo"; /* 茅 */
dict[0x8306] = "máo"; /* 茆 */
dict[0x8307] = "bá"; /* 茇 */
dict[0x8308] = "zǐ"; /* 茈 */
dict[0x8309] = "mò"; /* 茉 */
dict[0x830a] = "zī"; /* 茊 */
dict[0x830b] = "zhǐ"; /* 茋 */
dict[0x830c] = "chí"; /* 茌 */
dict[0x830d] = "jì"; /* 茍 */
dict[0x830e] = "jīng"; /* 茎 */
dict[0x830f] = "lóng"; /* 茏 */
dict[0x8310] = "cōng"; /* 茐 */
dict[0x8311] = "niǎo"; /* 茑 */
dict[0x8312] = "yuán"; /* 茒 */
dict[0x8313] = "xué"; /* 茓 */
dict[0x8314] = "yíng"; /* 茔 */
dict[0x8315] = "qióng"; /* 茕 */
dict[0x8316] = "gè"; /* 茖 */
dict[0x8317] = "míng"; /* 茗 */
dict[0x8318] = "lì"; /* 茘 */
dict[0x8319] = "róng"; /* 茙 */
dict[0x831a] = "yìn"; /* 茚 */
dict[0x831b] = "gèn"; /* 茛 */
dict[0x831c] = "qiàn"; /* 茜 */
dict[0x831d] = "chǎi"; /* 茝 */
dict[0x831e] = "chén"; /* 茞 */
dict[0x831f] = "yù"; /* 茟 */
dict[0x8320] = "hāo"; /* 茠 */
dict[0x8321] = "zì"; /* 茡 */
dict[0x8322] = "liè"; /* 茢 */
dict[0x8323] = "wú"; /* 茣 */
dict[0x8324] = "jì"; /* 茤 */
dict[0x8325] = "guī"; /* 茥 */
dict[0x8326] = "cì"; /* 茦 */
dict[0x8327] = "jiǎn"; /* 茧 */
dict[0x8328] = "cí"; /* 茨 */
dict[0x8329] = "hòu"; /* 茩 */
dict[0x832a] = "guāng"; /* 茪 */
dict[0x832b] = "máng"; /* 茫 */
dict[0x832c] = "chá"; /* 茬 */
dict[0x832d] = "jiāo"; /* 茭 */
dict[0x832e] = "jiāo"; /* 茮 */
dict[0x832f] = "fú"; /* 茯 */
dict[0x8330] = "yú"; /* 茰 */
dict[0x8331] = "zhū"; /* 茱 */
dict[0x8332] = "zī"; /* 茲 */
dict[0x8333] = "jiāng"; /* 茳 */
dict[0x8334] = "huí"; /* 茴 */
dict[0x8335] = "yīn"; /* 茵 */
dict[0x8336] = "chá"; /* 茶 */
dict[0x8337] = "fá"; /* 茷 */
dict[0x8338] = "róng"; /* 茸 */
dict[0x8339] = "rú"; /* 茹 */
dict[0x833a] = "chōng"; /* 茺 */
dict[0x833b] = "mǎng"; /* 茻 */
dict[0x833c] = "tóng"; /* 茼 */
dict[0x833d] = "zhòng"; /* 茽 */
dict[0x833e] = "qiān"; /* 茾 */
dict[0x833f] = "zhú"; /* 茿 */
dict[0x8340] = "xún"; /* 荀 */
dict[0x8341] = "huán"; /* 荁 */
dict[0x8342] = "fū"; /* 荂 */
dict[0x8343] = "quán"; /* 荃 */
dict[0x8344] = "gāi"; /* 荄 */
dict[0x8345] = "dá"; /* 荅 */
dict[0x8346] = "jīng"; /* 荆 */
dict[0x8347] = "xìng"; /* 荇 */
dict[0x8348] = "chuǎn"; /* 荈 */
dict[0x8349] = "cǎo"; /* 草 */
dict[0x834a] = "jīng"; /* 荊 */
dict[0x834b] = "ér"; /* 荋 */
dict[0x834c] = "àn"; /* 荌 */
dict[0x834d] = "qiáo"; /* 荍 */
dict[0x834e] = "chí"; /* 荎 */
dict[0x834f] = "rěn"; /* 荏 */
dict[0x8350] = "jiàn"; /* 荐 */
dict[0x8351] = "yí,tí"; /* 荑 */
dict[0x8352] = "huāng"; /* 荒 */
dict[0x8353] = "píng"; /* 荓 */
dict[0x8354] = "lì"; /* 荔 */
dict[0x8355] = "jīn"; /* 荕 */
dict[0x8356] = "lǎo"; /* 荖 */
dict[0x8357] = "shù"; /* 荗 */
dict[0x8358] = "zhuāng"; /* 荘 */
dict[0x8359] = "dá"; /* 荙 */
dict[0x835a] = "jiá"; /* 荚 */
dict[0x835b] = "ráo"; /* 荛 */
dict[0x835c] = "bì"; /* 荜 */
dict[0x835d] = "cè"; /* 荝 */
dict[0x835e] = "qiáo"; /* 荞 */
dict[0x835f] = "huì"; /* 荟 */
dict[0x8360] = "jì,qí"; /* 荠 */
dict[0x8361] = "dàng"; /* 荡 */
dict[0x8362] = "zì"; /* 荢 */
dict[0x8363] = "róng"; /* 荣 */
dict[0x8364] = "hūn"; /* 荤 */
dict[0x8365] = "xíng,yīng"; /* 荥 */
dict[0x8366] = "luò"; /* 荦 */
dict[0x8367] = "yíng"; /* 荧 */
dict[0x8368] = "qián,xún"; /* 荨 */
dict[0x8369] = "jìn"; /* 荩 */
dict[0x836a] = "sūn"; /* 荪 */
dict[0x836b] = "yīn,yìn"; /* 荫 */
dict[0x836c] = "mǎi"; /* 荬 */
dict[0x836d] = "hóng"; /* 荭 */
dict[0x836e] = "zhòu"; /* 荮 */
dict[0x836f] = "yào"; /* 药 */
dict[0x8370] = "dù"; /* 荰 */
dict[0x8371] = "wěi"; /* 荱 */
dict[0x8372] = "lí"; /* 荲 */
dict[0x8373] = "dòu"; /* 荳 */
dict[0x8374] = "fū"; /* 荴 */
dict[0x8375] = "rěn"; /* 荵 */
dict[0x8376] = "yín"; /* 荶 */
dict[0x8377] = "hé"; /* 荷 */
dict[0x8378] = "bí"; /* 荸 */
dict[0x8379] = "bù"; /* 荹 */
dict[0x837a] = "yǔn"; /* 荺 */
dict[0x837b] = "dí"; /* 荻 */
dict[0x837c] = "tú"; /* 荼 */
dict[0x837d] = "suī"; /* 荽 */
dict[0x837e] = "suī"; /* 荾 */
dict[0x837f] = "chéng"; /* 荿 */
dict[0x8380] = "chén"; /* 莀 */
dict[0x8381] = "wú"; /* 莁 */
dict[0x8382] = "bié"; /* 莂 */
dict[0x8383] = "xī"; /* 莃 */
dict[0x8384] = "gěng"; /* 莄 */
dict[0x8385] = "lì"; /* 莅 */
dict[0x8386] = "pú"; /* 莆 */
dict[0x8387] = "zhù"; /* 莇 */
dict[0x8388] = "mò"; /* 莈 */
dict[0x8389] = "lì"; /* 莉 */
dict[0x838a] = "zhuāng"; /* 莊 */
dict[0x838b] = "zuó"; /* 莋 */
dict[0x838c] = "tuō"; /* 莌 */
dict[0x838d] = "qiú"; /* 莍 */
dict[0x838e] = "suō,shā"; /* 莎 */
dict[0x838f] = "suō"; /* 莏 */
dict[0x8390] = "chén"; /* 莐 */
dict[0x8391] = "péng,fēng"; /* 莑 */
dict[0x8392] = "jǔ"; /* 莒 */
dict[0x8393] = "méi"; /* 莓 */
dict[0x8394] = "méng"; /* 莔 */
dict[0x8395] = "xìng"; /* 莕 */
dict[0x8396] = "jìng"; /* 莖 */
dict[0x8397] = "chē"; /* 莗 */
dict[0x8398] = "shēn,xīn"; /* 莘 */
dict[0x8399] = "jūn"; /* 莙 */
dict[0x839a] = "yán"; /* 莚 */
dict[0x839b] = "tíng"; /* 莛 */
dict[0x839c] = "yóu"; /* 莜 */
dict[0x839d] = "cuò"; /* 莝 */
dict[0x839e] = "guān,guǎn,wǎn"; /* 莞 */
dict[0x839f] = "hàn"; /* 莟 */
dict[0x83a0] = "yǒu"; /* 莠 */
dict[0x83a1] = "cuò"; /* 莡 */
dict[0x83a2] = "jiá"; /* 莢 */
dict[0x83a3] = "wáng"; /* 莣 */
dict[0x83a4] = "sù,yóu"; /* 莤 */
dict[0x83a5] = "niǔ"; /* 莥 */
dict[0x83a6] = "shāo,xiāo"; /* 莦 */
dict[0x83a7] = "xiàn"; /* 莧 */
dict[0x83a8] = "làng,liáng"; /* 莨 */
dict[0x83a9] = "fú,piǎo"; /* 莩 */
dict[0x83aa] = "é"; /* 莪 */
dict[0x83ab] = "mò,mù"; /* 莫 */
dict[0x83ac] = "wèn,wǎn,miǎn"; /* 莬 */
dict[0x83ad] = "jié"; /* 莭 */
dict[0x83ae] = "nán"; /* 莮 */
dict[0x83af] = "mù"; /* 莯 */
dict[0x83b0] = "kǎn"; /* 莰 */
dict[0x83b1] = "lái"; /* 莱 */
dict[0x83b2] = "lián"; /* 莲 */
dict[0x83b3] = "shì,shí"; /* 莳 */
dict[0x83b4] = "wō"; /* 莴 */
dict[0x83b5] = "tù,tú"; /* 莵 */
dict[0x83b6] = "xiān,liǎn"; /* 莶 */
dict[0x83b7] = "huò"; /* 获 */
dict[0x83b8] = "yóu"; /* 莸 */
dict[0x83b9] = "yíng"; /* 莹 */
dict[0x83ba] = "yīng"; /* 莺 */
dict[0x83bc] = "chún"; /* 莼 */
dict[0x83bd] = "mǎng"; /* 莽 */
dict[0x83be] = "mǎng"; /* 莾 */
dict[0x83bf] = "cì"; /* 莿 */
dict[0x83c0] = "wǎn,yùn"; /* 菀 */
dict[0x83c1] = "jīng"; /* 菁 */
dict[0x83c2] = "dì"; /* 菂 */
dict[0x83c3] = "qú"; /* 菃 */
dict[0x83c4] = "dōng"; /* 菄 */
dict[0x83c5] = "jiān"; /* 菅 */
dict[0x83c6] = "zōu,chù"; /* 菆 */
dict[0x83c7] = "gū"; /* 菇 */
dict[0x83c8] = "lā"; /* 菈 */
dict[0x83c9] = "lù"; /* 菉 */
dict[0x83ca] = "jú"; /* 菊 */
dict[0x83cb] = "wèi"; /* 菋 */
dict[0x83cc] = "jūn,jùn"; /* 菌 */
dict[0x83cd] = "niè,rěn"; /* 菍 */
dict[0x83ce] = "kūn"; /* 菎 */
dict[0x83cf] = "hé"; /* 菏 */
dict[0x83d0] = "pú"; /* 菐 */
dict[0x83d1] = "zī,zì,zāi"; /* 菑 */
dict[0x83d2] = "gǎo"; /* 菒 */
dict[0x83d3] = "guǒ"; /* 菓 */
dict[0x83d4] = "fú"; /* 菔 */
dict[0x83d5] = "lún"; /* 菕 */
dict[0x83d6] = "chāng"; /* 菖 */
dict[0x83d7] = "chóu"; /* 菗 */
dict[0x83d8] = "sōng"; /* 菘 */
dict[0x83d9] = "chuí"; /* 菙 */
dict[0x83da] = "zhàn"; /* 菚 */
dict[0x83db] = "mén"; /* 菛 */
dict[0x83dc] = "cài"; /* 菜 */
dict[0x83dd] = "bá"; /* 菝 */
dict[0x83de] = "lí"; /* 菞 */
dict[0x83df] = "tù,tú"; /* 菟 */
dict[0x83e0] = "bō"; /* 菠 */
dict[0x83e1] = "hàn"; /* 菡 */
dict[0x83e2] = "bào"; /* 菢 */
dict[0x83e3] = "qìn"; /* 菣 */
dict[0x83e4] = "juǎn"; /* 菤 */
dict[0x83e5] = "xī"; /* 菥 */
dict[0x83e6] = "qín"; /* 菦 */
dict[0x83e7] = "dǐ"; /* 菧 */
dict[0x83e8] = "jiē,shà"; /* 菨 */
dict[0x83e9] = "pú"; /* 菩 */
dict[0x83ea] = "dàng"; /* 菪 */
dict[0x83eb] = "jǐn"; /* 菫 */
dict[0x83ec] = "qiáo,zhǎo"; /* 菬 */
dict[0x83ed] = "tái,zhī,chí"; /* 菭 */
dict[0x83ee] = "gēng"; /* 菮 */
dict[0x83ef] = "huá,huà,huā"; /* 華 */
dict[0x83f0] = "gū"; /* 菰 */
dict[0x83f1] = "líng"; /* 菱 */
dict[0x83f2] = "fēi,fěi"; /* 菲 */
dict[0x83f3] = "qín,qīn,jīn"; /* 菳 */
dict[0x83f4] = "ān"; /* 菴 */
dict[0x83f5] = "wǎng"; /* 菵 */
dict[0x83f6] = "běng"; /* 菶 */
dict[0x83f7] = "zhǒu"; /* 菷 */
dict[0x83f8] = "yān"; /* 菸 */
dict[0x83f9] = "zū"; /* 菹 */
dict[0x83fa] = "jiān"; /* 菺 */
dict[0x83fb] = "lǐn,má"; /* 菻 */
dict[0x83fc] = "tǎn"; /* 菼 */
dict[0x83fd] = "shū"; /* 菽 */
dict[0x83fe] = "tián,tiàn"; /* 菾 */
dict[0x83ff] = "dào"; /* 菿 */
dict[0x8400] = "hǔ"; /* 萀 */
dict[0x8401] = "qí"; /* 萁 */
dict[0x8402] = "hé"; /* 萂 */
dict[0x8403] = "cuì"; /* 萃 */
dict[0x8404] = "táo"; /* 萄 */
dict[0x8405] = "chūn"; /* 萅 */
dict[0x8406] = "bì"; /* 萆 */
dict[0x8407] = "cháng"; /* 萇 */
dict[0x8408] = "huán"; /* 萈 */
dict[0x8409] = "fèi"; /* 萉 */
dict[0x840a] = "lái"; /* 萊 */
dict[0x840b] = "qī"; /* 萋 */
dict[0x840c] = "méng"; /* 萌 */
dict[0x840d] = "píng"; /* 萍 */
dict[0x840e] = "wěi"; /* 萎 */
dict[0x840f] = "dàn"; /* 萏 */
dict[0x8410] = "shà"; /* 萐 */
dict[0x8411] = "huán"; /* 萑 */
dict[0x8412] = "yǎn"; /* 萒 */
dict[0x8413] = "yí"; /* 萓 */
dict[0x8414] = "tiáo"; /* 萔 */
dict[0x8415] = "qí"; /* 萕 */
dict[0x8416] = "wǎn"; /* 萖 */
dict[0x8417] = "cè"; /* 萗 */
dict[0x8418] = "nài"; /* 萘 */
dict[0x8419] = "zhěn"; /* 萙 */
dict[0x841a] = "tuò"; /* 萚 */
dict[0x841b] = "jiū"; /* 萛 */
dict[0x841c] = "tiē"; /* 萜 */
dict[0x841d] = "luó"; /* 萝 */
dict[0x841e] = "bì"; /* 萞 */
dict[0x841f] = "yì"; /* 萟 */
dict[0x8420] = "pān"; /* 萠 */
dict[0x8421] = "bó"; /* 萡 */
dict[0x8422] = "pāo"; /* 萢 */
dict[0x8423] = "dìng"; /* 萣 */
dict[0x8424] = "yíng"; /* 萤 */
dict[0x8425] = "yíng"; /* 营 */
dict[0x8426] = "yíng"; /* 萦 */
dict[0x8427] = "xiāo"; /* 萧 */
dict[0x8428] = "sà"; /* 萨 */
dict[0x8429] = "qiū"; /* 萩 */
dict[0x842a] = "kē"; /* 萪 */
dict[0x842b] = "xiāng"; /* 萫 */
dict[0x842c] = "wàn"; /* 萬 */
dict[0x842d] = "yǔ"; /* 萭 */
dict[0x842e] = "yú"; /* 萮 */
dict[0x842f] = "fù"; /* 萯 */
dict[0x8430] = "liàn"; /* 萰 */
dict[0x8431] = "xuān"; /* 萱 */
dict[0x8432] = "xuān"; /* 萲 */
dict[0x8433] = "nǎn"; /* 萳 */
dict[0x8434] = "cè"; /* 萴 */
dict[0x8435] = "wō"; /* 萵 */
dict[0x8436] = "chǔn"; /* 萶 */
dict[0x8437] = "shāo"; /* 萷 */
dict[0x8438] = "yú"; /* 萸 */
dict[0x8439] = "biān"; /* 萹 */
dict[0x843a] = "mào"; /* 萺 */
dict[0x843b] = "ān"; /* 萻 */
dict[0x843c] = "è"; /* 萼 */
dict[0x843d] = "luò,là,lào"; /* 落 */
dict[0x843e] = "yíng"; /* 萾 */
dict[0x843f] = "kuò"; /* 萿 */
dict[0x8440] = "kuò"; /* 葀 */
dict[0x8441] = "jiāng"; /* 葁 */
dict[0x8442] = "miǎn"; /* 葂 */
dict[0x8443] = "zuò"; /* 葃 */
dict[0x8444] = "zuò"; /* 葄 */
dict[0x8445] = "zū"; /* 葅 */
dict[0x8446] = "bǎo"; /* 葆 */
dict[0x8447] = "róu"; /* 葇 */
dict[0x8448] = "xǐ"; /* 葈 */
dict[0x8449] = "yè"; /* 葉 */
dict[0x844a] = "ān"; /* 葊 */
dict[0x844b] = "qú"; /* 葋 */
dict[0x844c] = "jiān"; /* 葌 */
dict[0x844d] = "fú"; /* 葍 */
dict[0x844e] = "lǜ"; /* 葎 */
dict[0x844f] = "jīng"; /* 葏 */
dict[0x8450] = "pén"; /* 葐 */
dict[0x8451] = "fēng"; /* 葑 */
dict[0x8452] = "hóng"; /* 葒 */
dict[0x8453] = "hóng"; /* 葓 */
dict[0x8454] = "hóu"; /* 葔 */
dict[0x8455] = "xìng"; /* 葕 */
dict[0x8456] = "tū"; /* 葖 */
dict[0x8457] = "zhù,zhuó,zhe"; /* 著 */
dict[0x8458] = "zī"; /* 葘 */
dict[0x8459] = "xiāng"; /* 葙 */
dict[0x845a] = "shèn"; /* 葚 */
dict[0x845b] = "gé,gě"; /* 葛 */
dict[0x845c] = "qiā"; /* 葜 */
dict[0x845d] = "qíng"; /* 葝 */
dict[0x845e] = "mǐ"; /* 葞 */
dict[0x845f] = "huáng"; /* 葟 */
dict[0x8460] = "shēn"; /* 葠 */
dict[0x8461] = "pú"; /* 葡 */
dict[0x8462] = "gài"; /* 葢 */
dict[0x8463] = "dǒng"; /* 董 */
dict[0x8464] = "zhòu"; /* 葤 */
dict[0x8465] = "qián"; /* 葥 */
dict[0x8466] = "wěi"; /* 葦 */
dict[0x8467] = "bó"; /* 葧 */
dict[0x8468] = "wēi"; /* 葨 */
dict[0x8469] = "pā"; /* 葩 */
dict[0x846a] = "jì"; /* 葪 */
dict[0x846b] = "hú"; /* 葫 */
dict[0x846c] = "zàng"; /* 葬 */
dict[0x846d] = "jiā"; /* 葭 */
dict[0x846e] = "duàn"; /* 葮 */
dict[0x846f] = "yào"; /* 葯 */
dict[0x8470] = "jùn"; /* 葰 */
dict[0x8471] = "cōng"; /* 葱 */
dict[0x8472] = "quán"; /* 葲 */
dict[0x8473] = "wēi"; /* 葳 */
dict[0x8474] = "zhēn"; /* 葴 */
dict[0x8475] = "kuí"; /* 葵 */
dict[0x8476] = "tíng"; /* 葶 */
dict[0x8477] = "hūn"; /* 葷 */
dict[0x8478] = "xǐ"; /* 葸 */
dict[0x8479] = "shī"; /* 葹 */
dict[0x847a] = "qì"; /* 葺 */
dict[0x847b] = "lán"; /* 葻 */
dict[0x847c] = "zōng"; /* 葼 */
dict[0x847d] = "yāo"; /* 葽 */
dict[0x847e] = "yuān"; /* 葾 */
dict[0x847f] = "méi"; /* 葿 */
dict[0x8480] = "yūn"; /* 蒀 */
dict[0x8481] = "shù"; /* 蒁 */
dict[0x8482] = "dì"; /* 蒂 */
dict[0x8483] = "zhuàn"; /* 蒃 */
dict[0x8484] = "guān"; /* 蒄 */
dict[0x8485] = "rǎn"; /* 蒅 */
dict[0x8486] = "xuē"; /* 蒆 */
dict[0x8487] = "chǎn"; /* 蒇 */
dict[0x8488] = "kǎi"; /* 蒈 */
dict[0x8489] = "kuì,kuài"; /* 蒉 */
dict[0x848a] = "huā"; /* 蒊 */
dict[0x848b] = "jiǎng"; /* 蒋 */
dict[0x848c] = "lóu"; /* 蒌 */
dict[0x848d] = "wěi"; /* 蒍 */
dict[0x848e] = "pài"; /* 蒎 */
dict[0x848f] = "yòng"; /* 蒏 */
dict[0x8490] = "sōu"; /* 蒐 */
dict[0x8491] = "yīn"; /* 蒑 */
dict[0x8492] = "shī"; /* 蒒 */
dict[0x8493] = "chún"; /* 蒓 */
dict[0x8494] = "shì,shí"; /* 蒔 */
dict[0x8495] = "yūn"; /* 蒕 */
dict[0x8496] = "zhēn"; /* 蒖 */
dict[0x8497] = "làng"; /* 蒗 */
dict[0x8498] = "rú,ná"; /* 蒘 */
dict[0x8499] = "mēng,méng,měng"; /* 蒙 */
dict[0x849a] = "lì"; /* 蒚 */
dict[0x849b] = "quē"; /* 蒛 */
dict[0x849c] = "suàn"; /* 蒜 */
dict[0x849d] = "yuán,huán"; /* 蒝 */
dict[0x849e] = "lì"; /* 蒞 */
dict[0x849f] = "jǔ"; /* 蒟 */
dict[0x84a0] = "xī"; /* 蒠 */
dict[0x84a1] = "bàng"; /* 蒡 */
dict[0x84a2] = "chú"; /* 蒢 */
dict[0x84a3] = "xú,shú"; /* 蒣 */
dict[0x84a4] = "tú"; /* 蒤 */
dict[0x84a5] = "liú"; /* 蒥 */
dict[0x84a6] = "huò"; /* 蒦 */
dict[0x84a7] = "diǎn"; /* 蒧 */
dict[0x84a8] = "qiàn"; /* 蒨 */
dict[0x84a9] = "zū,jù"; /* 蒩 */
dict[0x84aa] = "pò"; /* 蒪 */
dict[0x84ab] = "cuó"; /* 蒫 */
dict[0x84ac] = "yuān"; /* 蒬 */
dict[0x84ad] = "chú"; /* 蒭 */
dict[0x84ae] = "yù"; /* 蒮 */
dict[0x84af] = "kuǎi"; /* 蒯 */
dict[0x84b0] = "pán"; /* 蒰 */
dict[0x84b1] = "pú"; /* 蒱 */
dict[0x84b2] = "pú"; /* 蒲 */
dict[0x84b3] = "nà"; /* 蒳 */
dict[0x84b4] = "shuò"; /* 蒴 */
dict[0x84b5] = "xí,xì"; /* 蒵 */
dict[0x84b6] = "fén"; /* 蒶 */
dict[0x84b7] = "yún"; /* 蒷 */
dict[0x84b8] = "zhēng"; /* 蒸 */
dict[0x84b9] = "jiān"; /* 蒹 */
dict[0x84ba] = "jí"; /* 蒺 */
dict[0x84bb] = "ruò"; /* 蒻 */
dict[0x84bc] = "cāng"; /* 蒼 */
dict[0x84bd] = "ēn"; /* 蒽 */
dict[0x84be] = "mí"; /* 蒾 */
dict[0x84bf] = "hāo"; /* 蒿 */
dict[0x84c0] = "sūn"; /* 蓀 */
dict[0x84c1] = "zhēn"; /* 蓁 */
dict[0x84c2] = "míng"; /* 蓂 */
dict[0x84c3] = "sōu,sǒu"; /* 蓃 */
dict[0x84c4] = "xù"; /* 蓄 */
dict[0x84c5] = "liú"; /* 蓅 */
dict[0x84c6] = "xí"; /* 蓆 */
dict[0x84c7] = "gū"; /* 蓇 */
dict[0x84c8] = "láng"; /* 蓈 */
dict[0x84c9] = "róng"; /* 蓉 */
dict[0x84ca] = "wěng"; /* 蓊 */
dict[0x84cb] = "gài,gě,hé"; /* 蓋 */
dict[0x84cc] = "cuò"; /* 蓌 */
dict[0x84cd] = "shī"; /* 蓍 */
dict[0x84ce] = "táng"; /* 蓎 */
dict[0x84cf] = "luǒ"; /* 蓏 */
dict[0x84d0] = "rù"; /* 蓐 */
dict[0x84d1] = "suō"; /* 蓑 */
dict[0x84d2] = "xuān"; /* 蓒 */
dict[0x84d3] = "bèi"; /* 蓓 */
dict[0x84d4] = "yǎo,zhuó"; /* 蓔 */
dict[0x84d5] = "guì"; /* 蓕 */
dict[0x84d6] = "bì"; /* 蓖 */
dict[0x84d7] = "zǒng"; /* 蓗 */
dict[0x84d8] = "gǔn"; /* 蓘 */
dict[0x84d9] = "zuò"; /* 蓙 */
dict[0x84da] = "tiáo"; /* 蓚 */
dict[0x84db] = "cè"; /* 蓛 */
dict[0x84dc] = "pèi"; /* 蓜 */
dict[0x84dd] = "lán"; /* 蓝 */
dict[0x84de] = "dàn"; /* 蓞 */
dict[0x84df] = "jì"; /* 蓟 */
dict[0x84e0] = "lí"; /* 蓠 */
dict[0x84e1] = "shēn"; /* 蓡 */
dict[0x84e2] = "lǎng"; /* 蓢 */
dict[0x84e3] = "yù"; /* 蓣 */
dict[0x84e4] = "líng"; /* 蓤 */
dict[0x84e5] = "yíng"; /* 蓥 */
dict[0x84e6] = "mò"; /* 蓦 */
dict[0x84e7] = "diào,tiáo,dí"; /* 蓧 */
dict[0x84e8] = "tiáo"; /* 蓨 */
dict[0x84e9] = "mǎo"; /* 蓩 */
dict[0x84ea] = "tōng"; /* 蓪 */
dict[0x84eb] = "zhú"; /* 蓫 */
dict[0x84ec] = "péng"; /* 蓬 */
dict[0x84ed] = "ān"; /* 蓭 */
dict[0x84ee] = "lián"; /* 蓮 */
dict[0x84ef] = "cōng"; /* 蓯 */
dict[0x84f0] = "xǐ"; /* 蓰 */
dict[0x84f1] = "píng"; /* 蓱 */
dict[0x84f2] = "qiū,xū,fū"; /* 蓲 */
dict[0x84f3] = "jǐn"; /* 蓳 */
dict[0x84f4] = "chún"; /* 蓴 */
dict[0x84f5] = "jié"; /* 蓵 */
dict[0x84f6] = "wéi"; /* 蓶 */
dict[0x84f7] = "tuī"; /* 蓷 */
dict[0x84f8] = "cáo"; /* 蓸 */
dict[0x84f9] = "yù"; /* 蓹 */
dict[0x84fa] = "yì"; /* 蓺 */
dict[0x84fb] = "zí,jú"; /* 蓻 */
dict[0x84fc] = "liǎo,lù"; /* 蓼 */
dict[0x84fd] = "bì"; /* 蓽 */
dict[0x84fe] = "lǔ"; /* 蓾 */
dict[0x84ff] = "xù"; /* 蓿 */
dict[0x8500] = "bù"; /* 蔀 */
dict[0x8501] = "zhāng"; /* 蔁 */
dict[0x8502] = "léi"; /* 蔂 */
dict[0x8503] = "qiáng"; /* 蔃 */
dict[0x8504] = "màn"; /* 蔄 */
dict[0x8505] = "yán"; /* 蔅 */
dict[0x8506] = "líng"; /* 蔆 */
dict[0x8507] = "jì"; /* 蔇 */
dict[0x8508] = "biāo"; /* 蔈 */
dict[0x8509] = "gǔn"; /* 蔉 */
dict[0x850a] = "hàn"; /* 蔊 */
dict[0x850b] = "dí"; /* 蔋 */
dict[0x850c] = "sù"; /* 蔌 */
dict[0x850d] = "lù"; /* 蔍 */
dict[0x850e] = "shè"; /* 蔎 */
dict[0x850f] = "shāng"; /* 蔏 */
dict[0x8510] = "dí"; /* 蔐 */
dict[0x8511] = "miè"; /* 蔑 */
dict[0x8512] = "hūn"; /* 蔒 */
dict[0x8513] = "màn,wàn"; /* 蔓 */
dict[0x8514] = "bo"; /* 蔔 */
dict[0x8515] = "dì"; /* 蔕 */
dict[0x8516] = "cuó"; /* 蔖 */
dict[0x8517] = "zhè"; /* 蔗 */
dict[0x8518] = "shēn"; /* 蔘 */
dict[0x8519] = "xuàn"; /* 蔙 */
dict[0x851a] = "wèi"; /* 蔚 */
dict[0x851b] = "hú"; /* 蔛 */
dict[0x851c] = "áo"; /* 蔜 */
dict[0x851d] = "mǐ"; /* 蔝 */
dict[0x851e] = "lóu"; /* 蔞 */
dict[0x851f] = "cù"; /* 蔟 */
dict[0x8520] = "zhōng"; /* 蔠 */
dict[0x8521] = "cài"; /* 蔡 */
dict[0x8522] = "pó"; /* 蔢 */
dict[0x8523] = "jiǎng"; /* 蔣 */
dict[0x8524] = "mì"; /* 蔤 */
dict[0x8525] = "cōng"; /* 蔥 */
dict[0x8526] = "niǎo"; /* 蔦 */
dict[0x8527] = "huì"; /* 蔧 */
dict[0x8528] = "juàn"; /* 蔨 */
dict[0x8529] = "yín"; /* 蔩 */
dict[0x852a] = "jiān"; /* 蔪 */
dict[0x852b] = "niān"; /* 蔫 */
dict[0x852c] = "shū"; /* 蔬 */
dict[0x852d] = "yīn"; /* 蔭 */
dict[0x852e] = "guó"; /* 蔮 */
dict[0x852f] = "chén"; /* 蔯 */
dict[0x8530] = "hù"; /* 蔰 */
dict[0x8531] = "shā"; /* 蔱 */
dict[0x8532] = "kòu"; /* 蔲 */
dict[0x8533] = "qiàn"; /* 蔳 */
dict[0x8534] = "má"; /* 蔴 */
dict[0x8535] = "zàng"; /* 蔵 */
dict[0x8536] = "zé"; /* 蔶 */
dict[0x8537] = "qiáng"; /* 蔷 */
dict[0x8538] = "dōu"; /* 蔸 */
dict[0x8539] = "liǎn"; /* 蔹 */
dict[0x853a] = "lìn"; /* 蔺 */
dict[0x853b] = "kòu"; /* 蔻 */
dict[0x853c] = "ǎi"; /* 蔼 */
dict[0x853d] = "bì"; /* 蔽 */
dict[0x853e] = "lí"; /* 蔾 */
dict[0x853f] = "wěi"; /* 蔿 */
dict[0x8540] = "jí"; /* 蕀 */
dict[0x8541] = "qián,xún"; /* 蕁 */
dict[0x8542] = "shèng"; /* 蕂 */
dict[0x8543] = "fán"; /* 蕃 */
dict[0x8544] = "méng"; /* 蕄 */
dict[0x8545] = "ǒu"; /* 蕅 */
dict[0x8546] = "chǎn"; /* 蕆 */
dict[0x8547] = "diǎn"; /* 蕇 */
dict[0x8548] = "xùn"; /* 蕈 */
dict[0x8549] = "jiāo"; /* 蕉 */
dict[0x854a] = "ruǐ"; /* 蕊 */
dict[0x854b] = "ruǐ"; /* 蕋 */
dict[0x854c] = "lěi"; /* 蕌 */
dict[0x854d] = "yú"; /* 蕍 */
dict[0x854e] = "qiáo"; /* 蕎 */
dict[0x854f] = "zhū"; /* 蕏 */
dict[0x8550] = "huá"; /* 蕐 */
dict[0x8551] = "jiān"; /* 蕑 */
dict[0x8552] = "mǎi"; /* 蕒 */
dict[0x8553] = "yún"; /* 蕓 */
dict[0x8554] = "bāo"; /* 蕔 */
dict[0x8555] = "yóu"; /* 蕕 */
dict[0x8556] = "qú"; /* 蕖 */
dict[0x8557] = "lù"; /* 蕗 */
dict[0x8558] = "ráo"; /* 蕘 */
dict[0x8559] = "huì"; /* 蕙 */
dict[0x855a] = "è"; /* 蕚 */
dict[0x855b] = "tí"; /* 蕛 */
dict[0x855c] = "fěi"; /* 蕜 */
dict[0x855d] = "jué"; /* 蕝 */
dict[0x855e] = "zuì"; /* 蕞 */
dict[0x855f] = "fà"; /* 蕟 */
dict[0x8560] = "rú"; /* 蕠 */
dict[0x8561] = "fén"; /* 蕡 */
dict[0x8562] = "kuì"; /* 蕢 */
dict[0x8563] = "shùn"; /* 蕣 */
dict[0x8564] = "ruí"; /* 蕤 */
dict[0x8565] = "yǎ"; /* 蕥 */
dict[0x8566] = "xū"; /* 蕦 */
dict[0x8567] = "fù"; /* 蕧 */
dict[0x8568] = "jué"; /* 蕨 */
dict[0x8569] = "dàng"; /* 蕩 */
dict[0x856a] = "wú"; /* 蕪 */
dict[0x856b] = "dǒng"; /* 蕫 */
dict[0x856c] = "sī"; /* 蕬 */
dict[0x856d] = "xiāo"; /* 蕭 */
dict[0x856e] = "xì"; /* 蕮 */
dict[0x856f] = "sà"; /* 蕯 */
dict[0x8570] = "yùn"; /* 蕰 */
dict[0x8571] = "shāo"; /* 蕱 */
dict[0x8572] = "qí"; /* 蕲 */
dict[0x8573] = "jiān"; /* 蕳 */
dict[0x8574] = "yùn"; /* 蕴 */
dict[0x8575] = "sūn"; /* 蕵 */
dict[0x8576] = "líng"; /* 蕶 */
dict[0x8577] = "yù"; /* 蕷 */
dict[0x8578] = "xiá"; /* 蕸 */
dict[0x8579] = "wèng"; /* 蕹 */
dict[0x857a] = "jí"; /* 蕺 */
dict[0x857b] = "hòng"; /* 蕻 */
dict[0x857c] = "sì"; /* 蕼 */
dict[0x857d] = "nóng"; /* 蕽 */
dict[0x857e] = "lěi"; /* 蕾 */
dict[0x857f] = "xuān"; /* 蕿 */
dict[0x8580] = "yùn"; /* 薀 */
dict[0x8581] = "yù"; /* 薁 */
dict[0x8582] = "xí,xiào"; /* 薂 */
dict[0x8583] = "hào"; /* 薃 */
dict[0x8584] = "báo,bó,bò"; /* 薄 */
dict[0x8585] = "hāo"; /* 薅 */
dict[0x8586] = "ài"; /* 薆 */
dict[0x8587] = "wēi"; /* 薇 */
dict[0x8588] = "huì"; /* 薈 */
dict[0x8589] = "huì"; /* 薉 */
dict[0x858a] = "jì"; /* 薊 */
dict[0x858b] = "cí,zī"; /* 薋 */
dict[0x858c] = "xiāng"; /* 薌 */
dict[0x858d] = "wàn,luàn"; /* 薍 */
dict[0x858e] = "miè"; /* 薎 */
dict[0x858f] = "yì"; /* 薏 */
dict[0x8590] = "léng"; /* 薐 */
dict[0x8591] = "jiāng"; /* 薑 */
dict[0x8592] = "càn"; /* 薒 */
dict[0x8593] = "shēn"; /* 薓 */
dict[0x8594] = "qiáng,sè"; /* 薔 */
dict[0x8595] = "lián"; /* 薕 */
dict[0x8596] = "kē"; /* 薖 */
dict[0x8597] = "yuán"; /* 薗 */
dict[0x8598] = "dá"; /* 薘 */
dict[0x8599] = "tì"; /* 薙 */
dict[0x859a] = "tāng"; /* 薚 */
dict[0x859b] = "xuē"; /* 薛 */
dict[0x859c] = "bì"; /* 薜 */
dict[0x859d] = "zhān"; /* 薝 */
dict[0x859e] = "sūn"; /* 薞 */
dict[0x859f] = "xiān,liǎn"; /* 薟 */
dict[0x85a0] = "fán"; /* 薠 */
dict[0x85a1] = "dǐng"; /* 薡 */
dict[0x85a2] = "xiè"; /* 薢 */
dict[0x85a3] = "gǔ"; /* 薣 */
dict[0x85a4] = "xiè"; /* 薤 */
dict[0x85a5] = "shǔ"; /* 薥 */
dict[0x85a6] = "jiàn"; /* 薦 */
dict[0x85a7] = "hāo,kǎo"; /* 薧 */
dict[0x85a8] = "hōng"; /* 薨 */
dict[0x85a9] = "sà"; /* 薩 */
dict[0x85aa] = "xīn"; /* 薪 */
dict[0x85ab] = "xūn"; /* 薫 */
dict[0x85ac] = "yào"; /* 薬 */
dict[0x85ad] = "bài"; /* 薭 */
dict[0x85ae] = "sǒu"; /* 薮 */
dict[0x85af] = "shǔ"; /* 薯 */
dict[0x85b0] = "xūn"; /* 薰 */
dict[0x85b1] = "duì"; /* 薱 */
dict[0x85b2] = "pín"; /* 薲 */
dict[0x85b3] = "yuǎn,wěi"; /* 薳 */
dict[0x85b4] = "níng"; /* 薴 */
dict[0x85b5] = "chóu,zhòu"; /* 薵 */
dict[0x85b6] = "mái,wō"; /* 薶 */
dict[0x85b7] = "rú"; /* 薷 */
dict[0x85b8] = "piáo"; /* 薸 */
dict[0x85b9] = "tái"; /* 薹 */
dict[0x85ba] = "jì,qí"; /* 薺 */
dict[0x85bb] = "zǎo"; /* 薻 */
dict[0x85bc] = "chén"; /* 薼 */
dict[0x85bd] = "zhēn"; /* 薽 */
dict[0x85be] = "ěr"; /* 薾 */
dict[0x85bf] = "nǐ"; /* 薿 */
dict[0x85c0] = "yíng"; /* 藀 */
dict[0x85c1] = "gǎo"; /* 藁 */
dict[0x85c2] = "cóng"; /* 藂 */
dict[0x85c3] = "xiāo,hào"; /* 藃 */
dict[0x85c4] = "qí"; /* 藄 */
dict[0x85c5] = "fá"; /* 藅 */
dict[0x85c6] = "jiǎn"; /* 藆 */
dict[0x85c7] = "xù,yù,xū"; /* 藇 */
dict[0x85c8] = "kuí"; /* 藈 */
dict[0x85c9] = "jiè,jí"; /* 藉 */
dict[0x85ca] = "biǎn"; /* 藊 */
dict[0x85cb] = "diào,zhuó"; /* 藋 */
dict[0x85cc] = "mí"; /* 藌 */
dict[0x85cd] = "lán"; /* 藍 */
dict[0x85ce] = "jìn"; /* 藎 */
dict[0x85cf] = "cáng,zàng"; /* 藏 */
dict[0x85d0] = "miǎo"; /* 藐 */
dict[0x85d1] = "qióng"; /* 藑 */
dict[0x85d2] = "qì"; /* 藒 */
dict[0x85d3] = "xiǎn"; /* 藓 */
dict[0x85d4] = "liáo"; /* 藔 */
dict[0x85d5] = "ǒu"; /* 藕 */
dict[0x85d6] = "xián"; /* 藖 */
dict[0x85d7] = "sù"; /* 藗 */
dict[0x85d8] = "lǘ"; /* 藘 */
dict[0x85d9] = "yì"; /* 藙 */
dict[0x85da] = "xù"; /* 藚 */
dict[0x85db] = "xiě"; /* 藛 */
dict[0x85dc] = "lí"; /* 藜 */
dict[0x85dd] = "yì"; /* 藝 */
dict[0x85de] = "lǎ"; /* 藞 */
dict[0x85df] = "lěi"; /* 藟 */
dict[0x85e0] = "jiào"; /* 藠 */
dict[0x85e1] = "dí"; /* 藡 */
dict[0x85e2] = "zhǐ"; /* 藢 */
dict[0x85e3] = "bēi"; /* 藣 */
dict[0x85e4] = "téng"; /* 藤 */
dict[0x85e5] = "yào"; /* 藥 */
dict[0x85e6] = "mò"; /* 藦 */
dict[0x85e7] = "huàn"; /* 藧 */
dict[0x85e8] = "biāo,pāo"; /* 藨 */
dict[0x85e9] = "fān"; /* 藩 */
dict[0x85ea] = "sǒu"; /* 藪 */
dict[0x85eb] = "tán"; /* 藫 */
dict[0x85ec] = "tuī"; /* 藬 */
dict[0x85ed] = "qióng"; /* 藭 */
dict[0x85ee] = "qiáo"; /* 藮 */
dict[0x85ef] = "wèi"; /* 藯 */
dict[0x85f0] = "liú,liǔ"; /* 藰 */
dict[0x85f1] = "huì,huí"; /* 藱 */
dict[0x85f2] = "ōu"; /* 藲 */
dict[0x85f3] = "gǎo"; /* 藳 */
dict[0x85f4] = "yùn"; /* 藴 */
dict[0x85f5] = "bǎo"; /* 藵 */
dict[0x85f6] = "lì"; /* 藶 */
dict[0x85f7] = "shǔ"; /* 藷 */
dict[0x85f8] = "zhū,chú"; /* 藸 */
dict[0x85f9] = "ǎi"; /* 藹 */
dict[0x85fa] = "lìn"; /* 藺 */
dict[0x85fb] = "zǎo"; /* 藻 */
dict[0x85fc] = "xuān"; /* 藼 */
dict[0x85fd] = "qìn"; /* 藽 */
dict[0x85fe] = "lài"; /* 藾 */
dict[0x85ff] = "huò"; /* 藿 */
dict[0x8600] = "tuò"; /* 蘀 */
dict[0x8601] = "wù"; /* 蘁 */
dict[0x8602] = "ruǐ"; /* 蘂 */
dict[0x8603] = "ruǐ"; /* 蘃 */
dict[0x8604] = "qí"; /* 蘄 */
dict[0x8605] = "héng"; /* 蘅 */
dict[0x8606] = "lú"; /* 蘆 */
dict[0x8607] = "sū"; /* 蘇 */
dict[0x8608] = "tuí"; /* 蘈 */
dict[0x8609] = "máng"; /* 蘉 */
dict[0x860a] = "yùn"; /* 蘊 */
dict[0x860b] = "pín,píng"; /* 蘋 */
dict[0x860c] = "yù"; /* 蘌 */
dict[0x860d] = "xūn"; /* 蘍 */
dict[0x860e] = "jì"; /* 蘎 */
dict[0x860f] = "jiōng"; /* 蘏 */
dict[0x8610] = "xuān"; /* 蘐 */
dict[0x8611] = "mó"; /* 蘑 */
dict[0x8612] = "qiū"; /* 蘒 */
dict[0x8613] = "sū"; /* 蘓 */
dict[0x8614] = "jiōng"; /* 蘔 */
dict[0x8615] = "péng"; /* 蘕 */
dict[0x8616] = "niè"; /* 蘖 */
dict[0x8617] = "bò"; /* 蘗 */
dict[0x8618] = "ráng"; /* 蘘 */
dict[0x8619] = "yì"; /* 蘙 */
dict[0x861a] = "xiǎn"; /* 蘚 */
dict[0x861b] = "yú"; /* 蘛 */
dict[0x861c] = "jú"; /* 蘜 */
dict[0x861d] = "liǎn"; /* 蘝 */
dict[0x861e] = "liǎn"; /* 蘞 */
dict[0x861f] = "yǐn"; /* 蘟 */
dict[0x8620] = "qiáng"; /* 蘠 */
dict[0x8621] = "yīng"; /* 蘡 */
dict[0x8622] = "lóng"; /* 蘢 */
dict[0x8623] = "tǒu"; /* 蘣 */
dict[0x8624] = "huā"; /* 蘤 */
dict[0x8625] = "yuè"; /* 蘥 */
dict[0x8626] = "lìng"; /* 蘦 */
dict[0x8627] = "qú"; /* 蘧 */
dict[0x8628] = "yáo"; /* 蘨 */
dict[0x8629] = "fán"; /* 蘩 */
dict[0x862a] = "mí"; /* 蘪 */
dict[0x862b] = "lán"; /* 蘫 */
dict[0x862c] = "guī"; /* 蘬 */
dict[0x862d] = "lán"; /* 蘭 */
dict[0x862e] = "jì"; /* 蘮 */
dict[0x862f] = "dàng"; /* 蘯 */
dict[0x8630] = "màn"; /* 蘰 */
dict[0x8631] = "lèi"; /* 蘱 */
dict[0x8632] = "léi"; /* 蘲 */
dict[0x8633] = "huī"; /* 蘳 */
dict[0x8634] = "fēng"; /* 蘴 */
dict[0x8635] = "zhī"; /* 蘵 */
dict[0x8636] = "wèi"; /* 蘶 */
dict[0x8637] = "kuí"; /* 蘷 */
dict[0x8638] = "zhàn"; /* 蘸 */
dict[0x8639] = "huái"; /* 蘹 */
dict[0x863a] = "lí"; /* 蘺 */
dict[0x863b] = "jì"; /* 蘻 */
dict[0x863c] = "mí"; /* 蘼 */
dict[0x863d] = "lěi"; /* 蘽 */
dict[0x863e] = "huài"; /* 蘾 */
dict[0x863f] = "luó"; /* 蘿 */
dict[0x8640] = "jī"; /* 虀 */
dict[0x8641] = "kuí"; /* 虁 */
dict[0x8642] = "lù"; /* 虂 */
dict[0x8643] = "jiān"; /* 虃 */
dict[0x8645] = "téng"; /* 虅 */
dict[0x8646] = "léi"; /* 虆 */
dict[0x8647] = "quǎn"; /* 虇 */
dict[0x8648] = "xiāo"; /* 虈 */
dict[0x8649] = "yì"; /* 虉 */
dict[0x864a] = "luán"; /* 虊 */
dict[0x864b] = "mén"; /* 虋 */
dict[0x864c] = "biē"; /* 虌 */
dict[0x864d] = "hū"; /* 虍 */
dict[0x864e] = "hǔ"; /* 虎 */
dict[0x864f] = "lǔ"; /* 虏 */
dict[0x8650] = "nüè"; /* 虐 */
dict[0x8651] = "lǜ"; /* 虑 */
dict[0x8652] = "sī"; /* 虒 */
dict[0x8653] = "xiāo"; /* 虓 */
dict[0x8654] = "qián"; /* 虔 */
dict[0x8655] = "chǔ"; /* 處 */
dict[0x8656] = "hū"; /* 虖 */
dict[0x8657] = "xū"; /* 虗 */
dict[0x8658] = "cuó"; /* 虘 */
dict[0x8659] = "fú"; /* 虙 */
dict[0x865a] = "xū"; /* 虚 */
dict[0x865b] = "xū"; /* 虛 */
dict[0x865c] = "lǔ"; /* 虜 */
dict[0x865d] = "hǔ"; /* 虝 */
dict[0x865e] = "yú"; /* 虞 */
dict[0x865f] = "hào,háo"; /* 號 */
dict[0x8660] = "jiāo"; /* 虠 */
dict[0x8661] = "jù"; /* 虡 */
dict[0x8662] = "guó"; /* 虢 */
dict[0x8663] = "bào"; /* 虣 */
dict[0x8664] = "yán"; /* 虤 */
dict[0x8665] = "zhàn"; /* 虥 */
dict[0x8666] = "zhàn"; /* 虦 */
dict[0x8667] = "kuī"; /* 虧 */
dict[0x8668] = "bīn"; /* 虨 */
dict[0x8669] = "xì"; /* 虩 */
dict[0x866a] = "shù"; /* 虪 */
dict[0x866b] = "chóng"; /* 虫 */
dict[0x866c] = "qiú"; /* 虬 */
dict[0x866d] = "diāo"; /* 虭 */
dict[0x866e] = "jǐ"; /* 虮 */
dict[0x866f] = "qiú"; /* 虯 */
dict[0x8670] = "dīng"; /* 虰 */
dict[0x8671] = "shī"; /* 虱 */
dict[0x8672] = "xiā"; /* 虲 */
dict[0x8673] = "jué"; /* 虳 */
dict[0x8674] = "zhé"; /* 虴 */
dict[0x8675] = "shé"; /* 虵 */
dict[0x8676] = "yú"; /* 虶 */
dict[0x8677] = "hán"; /* 虷 */
dict[0x8678] = "zǐ"; /* 虸 */
dict[0x8679] = "hóng"; /* 虹 */
dict[0x867a] = "huǐ,huī"; /* 虺 */
dict[0x867b] = "méng"; /* 虻 */
dict[0x867c] = "gè"; /* 虼 */
dict[0x867d] = "suī"; /* 虽 */
dict[0x867e] = "xiā,hā"; /* 虾 */
dict[0x867f] = "chài"; /* 虿 */
dict[0x8680] = "shí"; /* 蚀 */
dict[0x8681] = "yǐ"; /* 蚁 */
dict[0x8682] = "mǎ,mā,mà"; /* 蚂 */
dict[0x8683] = "xiǎng"; /* 蚃 */
dict[0x8684] = "fāng,bàng"; /* 蚄 */
dict[0x8685] = "è"; /* 蚅 */
dict[0x8686] = "bā"; /* 蚆 */
dict[0x8687] = "chǐ"; /* 蚇 */
dict[0x8688] = "qiān"; /* 蚈 */
dict[0x8689] = "wén"; /* 蚉 */
dict[0x868a] = "wén"; /* 蚊 */
dict[0x868b] = "ruì"; /* 蚋 */
dict[0x868c] = "bàng,bèng"; /* 蚌 */
dict[0x868d] = "pí"; /* 蚍 */
dict[0x868e] = "yuè"; /* 蚎 */
dict[0x868f] = "yuè"; /* 蚏 */
dict[0x8690] = "jūn"; /* 蚐 */
dict[0x8691] = "qí"; /* 蚑 */
dict[0x8692] = "tóng"; /* 蚒 */
dict[0x8693] = "yǐn"; /* 蚓 */
dict[0x8694] = "qí,zhǐ"; /* 蚔 */
dict[0x8695] = "cán"; /* 蚕 */
dict[0x8696] = "yuán,wán"; /* 蚖 */
dict[0x8697] = "jué,quē"; /* 蚗 */
dict[0x8698] = "huí"; /* 蚘 */
dict[0x8699] = "qín,qián"; /* 蚙 */
dict[0x869a] = "qí"; /* 蚚 */
dict[0x869b] = "zhòng"; /* 蚛 */
dict[0x869c] = "yá"; /* 蚜 */
dict[0x869d] = "háo"; /* 蚝 */
dict[0x869e] = "mù"; /* 蚞 */
dict[0x869f] = "wáng"; /* 蚟 */
dict[0x86a0] = "fén"; /* 蚠 */
dict[0x86a1] = "fén"; /* 蚡 */
dict[0x86a2] = "háng"; /* 蚢 */
dict[0x86a3] = "gōng,zhōng"; /* 蚣 */
dict[0x86a4] = "zǎo"; /* 蚤 */
dict[0x86a5] = "fù,fǔ"; /* 蚥 */
dict[0x86a6] = "rán"; /* 蚦 */
dict[0x86a7] = "jiè"; /* 蚧 */
dict[0x86a8] = "fú"; /* 蚨 */
dict[0x86a9] = "chī"; /* 蚩 */
dict[0x86aa] = "dǒu"; /* 蚪 */
dict[0x86ab] = "bào"; /* 蚫 */
dict[0x86ac] = "xiǎn"; /* 蚬 */
dict[0x86ad] = "ní"; /* 蚭 */
dict[0x86ae] = "dài,dé"; /* 蚮 */
dict[0x86af] = "qiū"; /* 蚯 */
dict[0x86b0] = "yóu"; /* 蚰 */
dict[0x86b1] = "zhà"; /* 蚱 */
dict[0x86b2] = "píng"; /* 蚲 */
dict[0x86b3] = "chí"; /* 蚳 */
dict[0x86b4] = "yòu"; /* 蚴 */
dict[0x86b5] = "kē"; /* 蚵 */
dict[0x86b6] = "hān"; /* 蚶 */
dict[0x86b7] = "jù"; /* 蚷 */
dict[0x86b8] = "lì"; /* 蚸 */
dict[0x86b9] = "fù"; /* 蚹 */
dict[0x86ba] = "rán"; /* 蚺 */
dict[0x86bb] = "zhá"; /* 蚻 */
dict[0x86bc] = "gǒu,qú,xù"; /* 蚼 */
dict[0x86bd] = "pí"; /* 蚽 */
dict[0x86be] = "pí,bǒ"; /* 蚾 */
dict[0x86bf] = "xián"; /* 蚿 */
dict[0x86c0] = "zhù"; /* 蛀 */
dict[0x86c1] = "diāo"; /* 蛁 */
dict[0x86c2] = "bié"; /* 蛂 */
dict[0x86c3] = "bīng"; /* 蛃 */
dict[0x86c4] = "gū"; /* 蛄 */
dict[0x86c5] = "zhān"; /* 蛅 */
dict[0x86c6] = "qū"; /* 蛆 */
dict[0x86c7] = "shé,yí"; /* 蛇 */
dict[0x86c8] = "tiě"; /* 蛈 */
dict[0x86c9] = "líng"; /* 蛉 */
dict[0x86ca] = "gǔ"; /* 蛊 */
dict[0x86cb] = "dàn"; /* 蛋 */
dict[0x86cc] = "tún"; /* 蛌 */
dict[0x86cd] = "yíng"; /* 蛍 */
dict[0x86ce] = "lì"; /* 蛎 */
dict[0x86cf] = "chēng"; /* 蛏 */
dict[0x86d0] = "qū"; /* 蛐 */
dict[0x86d1] = "móu"; /* 蛑 */
dict[0x86d2] = "gé,luò"; /* 蛒 */
dict[0x86d3] = "cì"; /* 蛓 */
dict[0x86d4] = "huí"; /* 蛔 */
dict[0x86d5] = "huí"; /* 蛕 */
dict[0x86d6] = "máng,bàng"; /* 蛖 */
dict[0x86d7] = "fù"; /* 蛗 */
dict[0x86d8] = "yáng"; /* 蛘 */
dict[0x86d9] = "wā"; /* 蛙 */
dict[0x86da] = "liè"; /* 蛚 */
dict[0x86db] = "zhū"; /* 蛛 */
dict[0x86dc] = "yī"; /* 蛜 */
dict[0x86dd] = "xián"; /* 蛝 */
dict[0x86de] = "kuò"; /* 蛞 */
dict[0x86df] = "jiāo"; /* 蛟 */
dict[0x86e0] = "lì"; /* 蛠 */
dict[0x86e1] = "yì,xǔ"; /* 蛡 */
dict[0x86e2] = "píng"; /* 蛢 */
dict[0x86e3] = "jié"; /* 蛣 */
dict[0x86e4] = "gé,há"; /* 蛤 */
dict[0x86e5] = "shé"; /* 蛥 */
dict[0x86e6] = "yí"; /* 蛦 */
dict[0x86e7] = "wǎng"; /* 蛧 */
dict[0x86e8] = "mò"; /* 蛨 */
dict[0x86e9] = "qióng"; /* 蛩 */
dict[0x86ea] = "qiè,ní"; /* 蛪 */
dict[0x86eb] = "guǐ"; /* 蛫 */
dict[0x86ec] = "qióng"; /* 蛬 */
dict[0x86ed] = "zhì"; /* 蛭 */
dict[0x86ee] = "mán"; /* 蛮 */
dict[0x86ef] = "lǎo"; /* 蛯 */
dict[0x86f0] = "zhé"; /* 蛰 */
dict[0x86f1] = "jiá"; /* 蛱 */
dict[0x86f2] = "náo"; /* 蛲 */
dict[0x86f3] = "sī"; /* 蛳 */
dict[0x86f4] = "qí"; /* 蛴 */
dict[0x86f5] = "xíng"; /* 蛵 */
dict[0x86f6] = "jiè"; /* 蛶 */
dict[0x86f7] = "qiú"; /* 蛷 */
dict[0x86f8] = "xiāo"; /* 蛸 */
dict[0x86f9] = "yǒng"; /* 蛹 */
dict[0x86fa] = "jiá"; /* 蛺 */
dict[0x86fb] = "tuì"; /* 蛻 */
dict[0x86fc] = "chē"; /* 蛼 */
dict[0x86fd] = "bèi"; /* 蛽 */
dict[0x86fe] = "é,yǐ"; /* 蛾 */
dict[0x86ff] = "hàn"; /* 蛿 */
dict[0x8700] = "shǔ"; /* 蜀 */
dict[0x8701] = "xuán"; /* 蜁 */
dict[0x8702] = "fēng"; /* 蜂 */
dict[0x8703] = "shèn"; /* 蜃 */
dict[0x8704] = "shèn"; /* 蜄 */
dict[0x8705] = "fǔ"; /* 蜅 */
dict[0x8706] = "xiǎn"; /* 蜆 */
dict[0x8707] = "zhé"; /* 蜇 */
dict[0x8708] = "wú"; /* 蜈 */
dict[0x8709] = "fú"; /* 蜉 */
dict[0x870a] = "lì"; /* 蜊 */
dict[0x870b] = "láng"; /* 蜋 */
dict[0x870c] = "bì"; /* 蜌 */
dict[0x870d] = "chú"; /* 蜍 */
dict[0x870e] = "yuān"; /* 蜎 */
dict[0x870f] = "yǒu"; /* 蜏 */
dict[0x8710] = "jié"; /* 蜐 */
dict[0x8711] = "dàn"; /* 蜑 */
dict[0x8712] = "yán"; /* 蜒 */
dict[0x8713] = "tíng"; /* 蜓 */
dict[0x8714] = "diàn"; /* 蜔 */
dict[0x8715] = "tuì"; /* 蜕 */
dict[0x8716] = "huí"; /* 蜖 */
dict[0x8717] = "wō"; /* 蜗 */
dict[0x8718] = "zhī"; /* 蜘 */
dict[0x8719] = "zhōng"; /* 蜙 */
dict[0x871a] = "fēi"; /* 蜚 */
dict[0x871b] = "jū"; /* 蜛 */
dict[0x871c] = "mì"; /* 蜜 */
dict[0x871d] = "qí"; /* 蜝 */
dict[0x871e] = "qí"; /* 蜞 */
dict[0x871f] = "yù"; /* 蜟 */
dict[0x8720] = "jùn"; /* 蜠 */
dict[0x8721] = "là"; /* 蜡 */
dict[0x8722] = "měng"; /* 蜢 */
dict[0x8723] = "qiāng"; /* 蜣 */
dict[0x8724] = "sī"; /* 蜤 */
dict[0x8725] = "xī"; /* 蜥 */
dict[0x8726] = "lún"; /* 蜦 */
dict[0x8727] = "lì"; /* 蜧 */
dict[0x8728] = "dié"; /* 蜨 */
dict[0x8729] = "tiáo"; /* 蜩 */
dict[0x872a] = "táo"; /* 蜪 */
dict[0x872b] = "kūn"; /* 蜫 */
dict[0x872c] = "hán"; /* 蜬 */
dict[0x872d] = "hàn"; /* 蜭 */
dict[0x872e] = "yù"; /* 蜮 */
dict[0x872f] = "bàng"; /* 蜯 */
dict[0x8730] = "féi"; /* 蜰 */
dict[0x8731] = "pí"; /* 蜱 */
dict[0x8732] = "wēi"; /* 蜲 */
dict[0x8733] = "dūn"; /* 蜳 */
dict[0x8734] = "yì"; /* 蜴 */
dict[0x8735] = "yuān"; /* 蜵 */
dict[0x8736] = "suò"; /* 蜶 */
dict[0x8737] = "quán"; /* 蜷 */
dict[0x8738] = "qiǎn"; /* 蜸 */
dict[0x8739] = "ruì"; /* 蜹 */
dict[0x873a] = "ní"; /* 蜺 */
dict[0x873b] = "qīng"; /* 蜻 */
dict[0x873c] = "wèi"; /* 蜼 */
dict[0x873d] = "liǎng"; /* 蜽 */
dict[0x873e] = "guǒ"; /* 蜾 */
dict[0x873f] = "wān"; /* 蜿 */
dict[0x8740] = "dōng"; /* 蝀 */
dict[0x8741] = "è"; /* 蝁 */
dict[0x8742] = "bǎn"; /* 蝂 */
dict[0x8743] = "dì"; /* 蝃 */
dict[0x8744] = "wǎng"; /* 蝄 */
dict[0x8745] = "cán"; /* 蝅 */
dict[0x8746] = "yǎng"; /* 蝆 */
dict[0x8747] = "yíng"; /* 蝇 */
dict[0x8748] = "guō"; /* 蝈 */
dict[0x8749] = "chán"; /* 蝉 */
dict[0x874a] = "dìng"; /* 蝊 */
dict[0x874b] = "là"; /* 蝋 */
dict[0x874c] = "kē"; /* 蝌 */
dict[0x874d] = "jí"; /* 蝍 */
dict[0x874e] = "xiē"; /* 蝎 */
dict[0x874f] = "tíng"; /* 蝏 */
dict[0x8750] = "mào"; /* 蝐 */
dict[0x8751] = "xū"; /* 蝑 */
dict[0x8752] = "mián"; /* 蝒 */
dict[0x8753] = "yú"; /* 蝓 */
dict[0x8754] = "jiē"; /* 蝔 */
dict[0x8755] = "shí"; /* 蝕 */
dict[0x8756] = "xuān"; /* 蝖 */
dict[0x8757] = "huáng"; /* 蝗 */
dict[0x8758] = "yǎn"; /* 蝘 */
dict[0x8759] = "biān"; /* 蝙 */
dict[0x875a] = "róu"; /* 蝚 */
dict[0x875b] = "wēi"; /* 蝛 */
dict[0x875c] = "fù"; /* 蝜 */
dict[0x875d] = "yuán"; /* 蝝 */
dict[0x875e] = "mèi"; /* 蝞 */
dict[0x875f] = "wèi"; /* 蝟 */
dict[0x8760] = "fú"; /* 蝠 */
dict[0x8761] = "rú"; /* 蝡 */
dict[0x8762] = "xié"; /* 蝢 */
dict[0x8763] = "yóu"; /* 蝣 */
dict[0x8764] = "qiú"; /* 蝤 */
dict[0x8765] = "máo"; /* 蝥 */
dict[0x8766] = "xiā,hā"; /* 蝦 */
dict[0x8767] = "yīng"; /* 蝧 */
dict[0x8768] = "shī"; /* 蝨 */
dict[0x8769] = "chóng"; /* 蝩 */
dict[0x876a] = "tāng"; /* 蝪 */
dict[0x876b] = "zhū"; /* 蝫 */
dict[0x876c] = "zōng"; /* 蝬 */
dict[0x876d] = "dì"; /* 蝭 */
dict[0x876e] = "fù"; /* 蝮 */
dict[0x876f] = "yuán"; /* 蝯 */
dict[0x8770] = "kuí"; /* 蝰 */
dict[0x8771] = "méng"; /* 蝱 */
dict[0x8772] = "là"; /* 蝲 */
dict[0x8773] = "dài"; /* 蝳 */
dict[0x8774] = "hú"; /* 蝴 */
dict[0x8775] = "qiū"; /* 蝵 */
dict[0x8776] = "dié"; /* 蝶 */
dict[0x8777] = "lì"; /* 蝷 */
dict[0x8778] = "wō"; /* 蝸 */
dict[0x8779] = "yūn"; /* 蝹 */
dict[0x877a] = "qǔ"; /* 蝺 */
dict[0x877b] = "nǎn"; /* 蝻 */
dict[0x877c] = "lóu"; /* 蝼 */
dict[0x877d] = "chūn"; /* 蝽 */
dict[0x877e] = "róng"; /* 蝾 */
dict[0x877f] = "yíng"; /* 蝿 */
dict[0x8780] = "jiāng"; /* 螀 */
dict[0x8781] = "tuì"; /* 螁 */
dict[0x8782] = "láng"; /* 螂 */
dict[0x8783] = "páng"; /* 螃 */
dict[0x8784] = "sī"; /* 螄 */
dict[0x8785] = "xī"; /* 螅 */
dict[0x8786] = "cì"; /* 螆 */
dict[0x8787] = "xī,qī"; /* 螇 */
dict[0x8788] = "yuán"; /* 螈 */
dict[0x8789] = "wēng"; /* 螉 */
dict[0x878a] = "lián"; /* 螊 */
dict[0x878b] = "sōu"; /* 螋 */
dict[0x878c] = "bān"; /* 螌 */
dict[0x878d] = "róng"; /* 融 */
dict[0x878e] = "róng"; /* 螎 */
dict[0x878f] = "jí"; /* 螏 */
dict[0x8790] = "wū"; /* 螐 */
dict[0x8791] = "xiù"; /* 螑 */
dict[0x8792] = "hàn"; /* 螒 */
dict[0x8793] = "qín"; /* 螓 */
dict[0x8794] = "yí"; /* 螔 */
dict[0x8795] = "bī,pí"; /* 螕 */
dict[0x8796] = "huá"; /* 螖 */
dict[0x8797] = "táng"; /* 螗 */
dict[0x8798] = "yǐ"; /* 螘 */
dict[0x8799] = "dù"; /* 螙 */
dict[0x879a] = "nài,něng"; /* 螚 */
dict[0x879b] = "hé,xiá"; /* 螛 */
dict[0x879c] = "hú"; /* 螜 */
dict[0x879d] = "guì,huǐ"; /* 螝 */
dict[0x879e] = "mǎ,mā,mà"; /* 螞 */
dict[0x879f] = "míng"; /* 螟 */
dict[0x87a0] = "yì"; /* 螠 */
dict[0x87a1] = "wén"; /* 螡 */
dict[0x87a2] = "yíng"; /* 螢 */
dict[0x87a3] = "téng"; /* 螣 */
dict[0x87a4] = "zhōng"; /* 螤 */
dict[0x87a5] = "cāng"; /* 螥 */
dict[0x87a6] = "sāo"; /* 螦 */
dict[0x87a7] = "qí"; /* 螧 */
dict[0x87a8] = "mǎn"; /* 螨 */
dict[0x87a9] = "dāo"; /* 螩 */
dict[0x87aa] = "shāng"; /* 螪 */
dict[0x87ab] = "shì,zhē"; /* 螫 */
dict[0x87ac] = "cáo"; /* 螬 */
dict[0x87ad] = "chī"; /* 螭 */
dict[0x87ae] = "dì"; /* 螮 */
dict[0x87af] = "áo"; /* 螯 */
dict[0x87b0] = "lù"; /* 螰 */
dict[0x87b1] = "wèi"; /* 螱 */
dict[0x87b2] = "dié,zhì"; /* 螲 */
dict[0x87b3] = "táng"; /* 螳 */
dict[0x87b4] = "chén"; /* 螴 */
dict[0x87b5] = "piāo"; /* 螵 */
dict[0x87b6] = "qú,jù"; /* 螶 */
dict[0x87b7] = "pí"; /* 螷 */
dict[0x87b8] = "yú"; /* 螸 */
dict[0x87b9] = "chán,jiàn"; /* 螹 */
dict[0x87ba] = "luó"; /* 螺 */
dict[0x87bb] = "lóu"; /* 螻 */
dict[0x87bc] = "qǐn"; /* 螼 */
dict[0x87bd] = "zhōng"; /* 螽 */
dict[0x87be] = "yǐn"; /* 螾 */
dict[0x87bf] = "jiāng"; /* 螿 */
dict[0x87c0] = "shuài"; /* 蟀 */
dict[0x87c1] = "wén"; /* 蟁 */
dict[0x87c2] = "xiāo"; /* 蟂 */
dict[0x87c3] = "wàn"; /* 蟃 */
dict[0x87c4] = "zhé"; /* 蟄 */
dict[0x87c5] = "zhè"; /* 蟅 */
dict[0x87c6] = "má,mò"; /* 蟆 */
dict[0x87c7] = "má"; /* 蟇 */
dict[0x87c8] = "guō"; /* 蟈 */
dict[0x87c9] = "liú"; /* 蟉 */
dict[0x87ca] = "máo"; /* 蟊 */
dict[0x87cb] = "xī"; /* 蟋 */
dict[0x87cc] = "cōng"; /* 蟌 */
dict[0x87cd] = "lí"; /* 蟍 */
dict[0x87ce] = "mǎn"; /* 蟎 */
dict[0x87cf] = "xiāo"; /* 蟏 */
dict[0x87d0] = "chán"; /* 蟐 */
dict[0x87d1] = "zhāng"; /* 蟑 */
dict[0x87d2] = "mǎng,měng"; /* 蟒 */
dict[0x87d3] = "xiàng"; /* 蟓 */
dict[0x87d4] = "mò"; /* 蟔 */
dict[0x87d5] = "zuī"; /* 蟕 */
dict[0x87d6] = "sī"; /* 蟖 */
dict[0x87d7] = "qiū"; /* 蟗 */
dict[0x87d8] = "tè"; /* 蟘 */
dict[0x87d9] = "zhí"; /* 蟙 */
dict[0x87da] = "péng"; /* 蟚 */
dict[0x87db] = "péng"; /* 蟛 */
dict[0x87dc] = "jiǎo"; /* 蟜 */
dict[0x87dd] = "qú"; /* 蟝 */
dict[0x87de] = "biē,bié"; /* 蟞 */
dict[0x87df] = "liáo"; /* 蟟 */
dict[0x87e0] = "pán"; /* 蟠 */
dict[0x87e1] = "guǐ"; /* 蟡 */
dict[0x87e2] = "xǐ"; /* 蟢 */
dict[0x87e3] = "jǐ"; /* 蟣 */
dict[0x87e4] = "zhuān"; /* 蟤 */
dict[0x87e5] = "huáng"; /* 蟥 */
dict[0x87e6] = "fèi,bēn"; /* 蟦 */
dict[0x87e7] = "láo,liáo"; /* 蟧 */
dict[0x87e8] = "jué"; /* 蟨 */
dict[0x87e9] = "jué"; /* 蟩 */
dict[0x87ea] = "huì"; /* 蟪 */
dict[0x87eb] = "yín,xún"; /* 蟫 */
dict[0x87ec] = "chán"; /* 蟬 */
dict[0x87ed] = "jiāo"; /* 蟭 */
dict[0x87ee] = "shàn"; /* 蟮 */
dict[0x87ef] = "náo"; /* 蟯 */
dict[0x87f0] = "xiāo"; /* 蟰 */
dict[0x87f1] = "wú"; /* 蟱 */
dict[0x87f2] = "chóng"; /* 蟲 */
dict[0x87f3] = "xún"; /* 蟳 */
dict[0x87f4] = "sī"; /* 蟴 */
dict[0x87f5] = "chú"; /* 蟵 */
dict[0x87f6] = "chēng"; /* 蟶 */
dict[0x87f7] = "dāng"; /* 蟷 */
dict[0x87f8] = "lí"; /* 蟸 */
dict[0x87f9] = "xiè"; /* 蟹 */
dict[0x87fa] = "shàn"; /* 蟺 */
dict[0x87fb] = "yǐ"; /* 蟻 */
dict[0x87fc] = "jǐng"; /* 蟼 */
dict[0x87fd] = "dá"; /* 蟽 */
dict[0x87fe] = "chán"; /* 蟾 */
dict[0x87ff] = "qì"; /* 蟿 */
dict[0x8800] = "cī"; /* 蠀 */
dict[0x8801] = "xiǎng"; /* 蠁 */
dict[0x8802] = "shè"; /* 蠂 */
dict[0x8803] = "luǒ"; /* 蠃 */
dict[0x8804] = "qín"; /* 蠄 */
dict[0x8805] = "yíng"; /* 蠅 */
dict[0x8806] = "chài"; /* 蠆 */
dict[0x8807] = "lì"; /* 蠇 */
dict[0x8808] = "zéi"; /* 蠈 */
dict[0x8809] = "xuān"; /* 蠉 */
dict[0x880a] = "lián"; /* 蠊 */
dict[0x880b] = "zhú"; /* 蠋 */
dict[0x880c] = "zé"; /* 蠌 */
dict[0x880d] = "xiē"; /* 蠍 */
dict[0x880e] = "mǎng"; /* 蠎 */
dict[0x880f] = "xiè"; /* 蠏 */
dict[0x8810] = "qí"; /* 蠐 */
dict[0x8811] = "róng"; /* 蠑 */
dict[0x8812] = "jiǎn"; /* 蠒 */
dict[0x8813] = "měng"; /* 蠓 */
dict[0x8814] = "háo"; /* 蠔 */
dict[0x8815] = "rú"; /* 蠕 */
dict[0x8816] = "huò"; /* 蠖 */
dict[0x8817] = "zhuó"; /* 蠗 */
dict[0x8818] = "jié"; /* 蠘 */
dict[0x8819] = "pín"; /* 蠙 */
dict[0x881a] = "hē"; /* 蠚 */
dict[0x881b] = "miè"; /* 蠛 */
dict[0x881c] = "fán"; /* 蠜 */
dict[0x881d] = "lěi"; /* 蠝 */
dict[0x881e] = "jié"; /* 蠞 */
dict[0x881f] = "là"; /* 蠟 */
dict[0x8820] = "mǐn"; /* 蠠 */
dict[0x8821] = "lǐ"; /* 蠡 */
dict[0x8822] = "chǔn"; /* 蠢 */
dict[0x8823] = "lì"; /* 蠣 */
dict[0x8824] = "qiū"; /* 蠤 */
dict[0x8825] = "niè"; /* 蠥 */
dict[0x8826] = "lú"; /* 蠦 */
dict[0x8827] = "dù"; /* 蠧 */
dict[0x8828] = "xiāo"; /* 蠨 */
dict[0x8829] = "zhū"; /* 蠩 */
dict[0x882a] = "lóng"; /* 蠪 */
dict[0x882b] = "lí"; /* 蠫 */
dict[0x882c] = "lóng"; /* 蠬 */
dict[0x882d] = "fēng"; /* 蠭 */
dict[0x882e] = "yē"; /* 蠮 */
dict[0x882f] = "pí"; /* 蠯 */
dict[0x8830] = "náng"; /* 蠰 */
dict[0x8831] = "gǔ"; /* 蠱 */
dict[0x8832] = "juān"; /* 蠲 */
dict[0x8833] = "yīng"; /* 蠳 */
dict[0x8834] = "shǔ"; /* 蠴 */
dict[0x8835] = "xī"; /* 蠵 */
dict[0x8836] = "cán"; /* 蠶 */
dict[0x8837] = "qú"; /* 蠷 */
dict[0x8838] = "quán"; /* 蠸 */
dict[0x8839] = "dù"; /* 蠹 */
dict[0x883a] = "cán"; /* 蠺 */
dict[0x883b] = "mán"; /* 蠻 */
dict[0x883c] = "qú"; /* 蠼 */
dict[0x883d] = "jié"; /* 蠽 */
dict[0x883e] = "zhú"; /* 蠾 */
dict[0x883f] = "zhuó"; /* 蠿 */
dict[0x8840] = "xiě,xuè"; /* 血 */
dict[0x8841] = "huāng"; /* 衁 */
dict[0x8842] = "nǜ"; /* 衂 */
dict[0x8843] = "pēi"; /* 衃 */
dict[0x8844] = "nǜ"; /* 衄 */
dict[0x8845] = "xìn"; /* 衅 */
dict[0x8846] = "zhòng"; /* 衆 */
dict[0x8847] = "mài"; /* 衇 */
dict[0x8848] = "ěr"; /* 衈 */
dict[0x8849] = "kè"; /* 衉 */
dict[0x884a] = "miè"; /* 衊 */
dict[0x884b] = "xì"; /* 衋 */
dict[0x884c] = "háng,xíng"; /* 行 */
dict[0x884d] = "yǎn"; /* 衍 */
dict[0x884e] = "kàn"; /* 衎 */
dict[0x884f] = "yuàn"; /* 衏 */
dict[0x8850] = "qú"; /* 衐 */
dict[0x8851] = "líng"; /* 衑 */
dict[0x8852] = "xuàn"; /* 衒 */
dict[0x8853] = "shù"; /* 術 */
dict[0x8854] = "xián"; /* 衔 */
dict[0x8855] = "tòng"; /* 衕 */
dict[0x8856] = "xiàng"; /* 衖 */
dict[0x8857] = "jiē"; /* 街 */
dict[0x8858] = "xián"; /* 衘 */
dict[0x8859] = "yá"; /* 衙 */
dict[0x885a] = "hú"; /* 衚 */
dict[0x885b] = "wèi"; /* 衛 */
dict[0x885c] = "dào"; /* 衜 */
dict[0x885d] = "chōng"; /* 衝 */
dict[0x885e] = "wèi"; /* 衞 */
dict[0x885f] = "dào"; /* 衟 */
dict[0x8860] = "zhūn"; /* 衠 */
dict[0x8861] = "héng"; /* 衡 */
dict[0x8862] = "qú"; /* 衢 */
dict[0x8863] = "yī"; /* 衣 */
dict[0x8864] = "yī"; /* 衤 */
dict[0x8865] = "bǔ"; /* 补 */
dict[0x8866] = "gǎn"; /* 衦 */
dict[0x8867] = "yú"; /* 衧 */
dict[0x8868] = "biǎo"; /* 表 */
dict[0x8869] = "chà"; /* 衩 */
dict[0x886a] = "yì"; /* 衪 */
dict[0x886b] = "shān"; /* 衫 */
dict[0x886c] = "chèn"; /* 衬 */
dict[0x886d] = "fū"; /* 衭 */
dict[0x886e] = "gǔn"; /* 衮 */
dict[0x886f] = "fēn"; /* 衯 */
dict[0x8870] = "shuāi,cuī"; /* 衰 */
dict[0x8871] = "jié"; /* 衱 */
dict[0x8872] = "nà"; /* 衲 */
dict[0x8873] = "zhōng"; /* 衳 */
dict[0x8874] = "dǎn"; /* 衴 */
dict[0x8875] = "rì"; /* 衵 */
dict[0x8876] = "zhòng"; /* 衶 */
dict[0x8877] = "zhōng"; /* 衷 */
dict[0x8878] = "jiè"; /* 衸 */
dict[0x8879] = "zhǐ"; /* 衹 */
dict[0x887a] = "xié"; /* 衺 */
dict[0x887b] = "rán"; /* 衻 */
dict[0x887c] = "zhī"; /* 衼 */
dict[0x887d] = "rèn"; /* 衽 */
dict[0x887e] = "qīn"; /* 衾 */
dict[0x887f] = "jīn"; /* 衿 */
dict[0x8880] = "jūn"; /* 袀 */
dict[0x8881] = "yuán"; /* 袁 */
dict[0x8882] = "mèi"; /* 袂 */
dict[0x8883] = "chài"; /* 袃 */
dict[0x8884] = "ǎo"; /* 袄 */
dict[0x8885] = "niǎo"; /* 袅 */
dict[0x8886] = "huī"; /* 袆 */
dict[0x8887] = "rán"; /* 袇 */
dict[0x8888] = "jiā"; /* 袈 */
dict[0x8889] = "tuó,tuō"; /* 袉 */
dict[0x888a] = "lǐng,líng"; /* 袊 */
dict[0x888b] = "dài"; /* 袋 */
dict[0x888c] = "bào,páo,pào"; /* 袌 */
dict[0x888d] = "páo"; /* 袍 */
dict[0x888e] = "yào"; /* 袎 */
dict[0x888f] = "zuò"; /* 袏 */
dict[0x8890] = "bì"; /* 袐 */
dict[0x8891] = "shào"; /* 袑 */
dict[0x8892] = "tǎn"; /* 袒 */
dict[0x8893] = "jù,jiē"; /* 袓 */
dict[0x8894] = "hè,kè"; /* 袔 */
dict[0x8895] = "xué"; /* 袕 */
dict[0x8896] = "xiù"; /* 袖 */
dict[0x8897] = "zhěn"; /* 袗 */
dict[0x8898] = "yí,yì"; /* 袘 */
dict[0x8899] = "pà"; /* 袙 */
dict[0x889a] = "fú"; /* 袚 */
dict[0x889b] = "dī"; /* 袛 */
dict[0x889c] = "wà"; /* 袜 */
dict[0x889d] = "fù"; /* 袝 */
dict[0x889e] = "gǔn"; /* 袞 */
dict[0x889f] = "zhì"; /* 袟 */
dict[0x88a0] = "zhì"; /* 袠 */
dict[0x88a1] = "rán"; /* 袡 */
dict[0x88a2] = "pàn"; /* 袢 */
dict[0x88a3] = "yì"; /* 袣 */
dict[0x88a4] = "mào"; /* 袤 */
dict[0x88a5] = "tuō"; /* 袥 */
dict[0x88a6] = "nà,jué"; /* 袦 */
dict[0x88a7] = "gōu"; /* 袧 */
dict[0x88a8] = "xuàn"; /* 袨 */
dict[0x88a9] = "zhé"; /* 袩 */
dict[0x88aa] = "qū"; /* 袪 */
dict[0x88ab] = "bèi,pī"; /* 被 */
dict[0x88ac] = "yù"; /* 袬 */
dict[0x88ad] = "xí"; /* 袭 */
dict[0x88ae] = "mí"; /* 袮 */
dict[0x88af] = "bó"; /* 袯 */
dict[0x88b0] = "bō"; /* 袰 */
dict[0x88b1] = "fú"; /* 袱 */
dict[0x88b2] = "chǐ,nuǒ"; /* 袲 */
dict[0x88b3] = "chǐ,qǐ,duǒ,nuǒ"; /* 袳 */
dict[0x88b4] = "kù"; /* 袴 */
dict[0x88b5] = "rèn"; /* 袵 */
dict[0x88b6] = "péng"; /* 袶 */
dict[0x88b7] = "jiá,jié,qiā"; /* 袷 */
dict[0x88b8] = "jiàn,zùn"; /* 袸 */
dict[0x88b9] = "bó,mò"; /* 袹 */
dict[0x88ba] = "jié"; /* 袺 */
dict[0x88bb] = "ér"; /* 袻 */
dict[0x88bc] = "gē"; /* 袼 */
dict[0x88bd] = "rú"; /* 袽 */
dict[0x88be] = "zhū"; /* 袾 */
dict[0x88bf] = "guī,guà"; /* 袿 */
dict[0x88c0] = "yīn"; /* 裀 */
dict[0x88c1] = "cái"; /* 裁 */
dict[0x88c2] = "liè,liě"; /* 裂 */
dict[0x88c3] = "kǎ"; /* 裃 */
dict[0x88c4] = "háng"; /* 裄 */
dict[0x88c5] = "zhuāng"; /* 装 */
dict[0x88c6] = "dāng"; /* 裆 */
dict[0x88c7] = "xū"; /* 裇 */
dict[0x88c8] = "kūn"; /* 裈 */
dict[0x88c9] = "kèn"; /* 裉 */
dict[0x88ca] = "niǎo"; /* 裊 */
dict[0x88cb] = "shù"; /* 裋 */
dict[0x88cc] = "jiá"; /* 裌 */
dict[0x88cd] = "kǔn"; /* 裍 */
dict[0x88ce] = "chéng,chěng"; /* 裎 */
dict[0x88cf] = "lǐ"; /* 裏 */
dict[0x88d0] = "juān"; /* 裐 */
dict[0x88d1] = "shēn"; /* 裑 */
dict[0x88d2] = "póu"; /* 裒 */
dict[0x88d3] = "gé,jiē"; /* 裓 */
dict[0x88d4] = "yì"; /* 裔 */
dict[0x88d5] = "yù"; /* 裕 */
dict[0x88d6] = "zhěn"; /* 裖 */
dict[0x88d7] = "liú"; /* 裗 */
dict[0x88d8] = "qiú"; /* 裘 */
dict[0x88d9] = "qún"; /* 裙 */
dict[0x88da] = "jì"; /* 裚 */
dict[0x88db] = "yì"; /* 裛 */
dict[0x88dc] = "bǔ"; /* 補 */
dict[0x88dd] = "zhuāng"; /* 裝 */
dict[0x88de] = "shuì"; /* 裞 */
dict[0x88df] = "shā"; /* 裟 */
dict[0x88e0] = "qún"; /* 裠 */
dict[0x88e1] = "lǐ"; /* 裡 */
dict[0x88e2] = "lián"; /* 裢 */
dict[0x88e3] = "liǎn"; /* 裣 */
dict[0x88e4] = "kù"; /* 裤 */
dict[0x88e5] = "jiǎn"; /* 裥 */
dict[0x88e6] = "bāo"; /* 裦 */
dict[0x88e7] = "chān"; /* 裧 */
dict[0x88e8] = "bì,pí"; /* 裨 */
dict[0x88e9] = "kūn"; /* 裩 */
dict[0x88ea] = "táo"; /* 裪 */
dict[0x88eb] = "yuàn"; /* 裫 */
dict[0x88ec] = "líng"; /* 裬 */
dict[0x88ed] = "chǐ"; /* 裭 */
dict[0x88ee] = "chāng"; /* 裮 */
dict[0x88ef] = "chóu,dāo"; /* 裯 */
dict[0x88f0] = "duō"; /* 裰 */
dict[0x88f1] = "biǎo"; /* 裱 */
dict[0x88f2] = "liǎng"; /* 裲 */
dict[0x88f3] = "cháng,shang"; /* 裳 */
dict[0x88f4] = "péi"; /* 裴 */
dict[0x88f5] = "péi"; /* 裵 */
dict[0x88f6] = "fēi"; /* 裶 */
dict[0x88f7] = "yuān,gǔn"; /* 裷 */
dict[0x88f8] = "luǒ"; /* 裸 */
dict[0x88f9] = "guǒ"; /* 裹 */
dict[0x88fa] = "yǎn,ān"; /* 裺 */
dict[0x88fb] = "dú"; /* 裻 */
dict[0x88fc] = "xī,tì"; /* 裼 */
dict[0x88fd] = "zhì"; /* 製 */
dict[0x88fe] = "jū"; /* 裾 */
dict[0x88ff] = "yǐ"; /* 裿 */
dict[0x8900] = "qí"; /* 褀 */
dict[0x8901] = "guǒ"; /* 褁 */
dict[0x8902] = "guà"; /* 褂 */
dict[0x8903] = "kèn"; /* 褃 */
dict[0x8904] = "qī"; /* 褄 */
dict[0x8905] = "tì"; /* 褅 */
dict[0x8906] = "tí"; /* 褆 */
dict[0x8907] = "fù"; /* 複 */
dict[0x8908] = "chóng"; /* 褈 */
dict[0x8909] = "xiè"; /* 褉 */
dict[0x890a] = "biǎn"; /* 褊 */
dict[0x890b] = "dié"; /* 褋 */
dict[0x890c] = "kūn"; /* 褌 */
dict[0x890d] = "duān"; /* 褍 */
dict[0x890e] = "xiù"; /* 褎 */
dict[0x890f] = "xiù"; /* 褏 */
dict[0x8910] = "hè"; /* 褐 */
dict[0x8911] = "yuàn"; /* 褑 */
dict[0x8912] = "bāo"; /* 褒 */
dict[0x8913] = "bǎo"; /* 褓 */
dict[0x8914] = "fù,fú"; /* 褔 */
dict[0x8915] = "yú"; /* 褕 */
dict[0x8916] = "tuàn"; /* 褖 */
dict[0x8917] = "yǎn"; /* 褗 */
dict[0x8918] = "huī"; /* 褘 */
dict[0x8919] = "bèi"; /* 褙 */
dict[0x891a] = "zhǔ,chǔ"; /* 褚 */
dict[0x891b] = "lǚ"; /* 褛 */
dict[0x891c] = "páo"; /* 褜 */
dict[0x891d] = "dān"; /* 褝 */
dict[0x891e] = "yùn"; /* 褞 */
dict[0x891f] = "tā"; /* 褟 */
dict[0x8920] = "gōu"; /* 褠 */
dict[0x8921] = "dā"; /* 褡 */
dict[0x8922] = "huái"; /* 褢 */
dict[0x8923] = "róng"; /* 褣 */
dict[0x8924] = "yuán"; /* 褤 */
dict[0x8925] = "rù"; /* 褥 */
dict[0x8926] = "nài"; /* 褦 */
dict[0x8927] = "jiǒng"; /* 褧 */
dict[0x8928] = "suǒ"; /* 褨 */
dict[0x8929] = "bān"; /* 褩 */
dict[0x892a] = "tuì,tùn"; /* 褪 */
dict[0x892b] = "chǐ"; /* 褫 */
dict[0x892c] = "sǎng"; /* 褬 */
dict[0x892d] = "niǎo"; /* 褭 */
dict[0x892e] = "yīng"; /* 褮 */
dict[0x892f] = "jiè"; /* 褯 */
dict[0x8930] = "qiān"; /* 褰 */
dict[0x8931] = "huái"; /* 褱 */
dict[0x8932] = "kù"; /* 褲 */
dict[0x8933] = "lián"; /* 褳 */
dict[0x8934] = "lán"; /* 褴 */
dict[0x8935] = "lí"; /* 褵 */
dict[0x8936] = "zhě"; /* 褶 */
dict[0x8937] = "shī"; /* 褷 */
dict[0x8938] = "lǚ"; /* 褸 */
dict[0x8939] = "yì"; /* 褹 */
dict[0x893a] = "diē"; /* 褺 */
dict[0x893b] = "xiè"; /* 褻 */
dict[0x893c] = "xiān"; /* 褼 */
dict[0x893d] = "wèi"; /* 褽 */
dict[0x893e] = "biǎo"; /* 褾 */
dict[0x893f] = "cáo"; /* 褿 */
dict[0x8940] = "jì"; /* 襀 */
dict[0x8941] = "qiǎng"; /* 襁 */
dict[0x8942] = "sēn"; /* 襂 */
dict[0x8943] = "bāo"; /* 襃 */
dict[0x8944] = "xiāng"; /* 襄 */
dict[0x8945] = "bì"; /* 襅 */
dict[0x8946] = "fú"; /* 襆 */
dict[0x8947] = "jiǎn"; /* 襇 */
dict[0x8948] = "zhuàn"; /* 襈 */
dict[0x8949] = "jiǎn"; /* 襉 */
dict[0x894a] = "cuì"; /* 襊 */
dict[0x894b] = "jí"; /* 襋 */
dict[0x894c] = "dān"; /* 襌 */
dict[0x894d] = "zá"; /* 襍 */
dict[0x894e] = "fán"; /* 襎 */
dict[0x894f] = "bó"; /* 襏 */
dict[0x8950] = "xiàng"; /* 襐 */
dict[0x8951] = "xín"; /* 襑 */
dict[0x8952] = "bié"; /* 襒 */
dict[0x8953] = "ráo"; /* 襓 */
dict[0x8954] = "mǎn"; /* 襔 */
dict[0x8955] = "lán"; /* 襕 */
dict[0x8956] = "ǎo"; /* 襖 */
dict[0x8957] = "zé"; /* 襗 */
dict[0x8958] = "guì"; /* 襘 */
dict[0x8959] = "cào"; /* 襙 */
dict[0x895a] = "suì"; /* 襚 */
dict[0x895b] = "nóng"; /* 襛 */
dict[0x895c] = "chān"; /* 襜 */
dict[0x895d] = "liǎn"; /* 襝 */
dict[0x895e] = "bì"; /* 襞 */
dict[0x895f] = "jīn"; /* 襟 */
dict[0x8960] = "dāng"; /* 襠 */
dict[0x8961] = "shǔ"; /* 襡 */
dict[0x8962] = "tǎn"; /* 襢 */
dict[0x8963] = "bì"; /* 襣 */
dict[0x8964] = "lán"; /* 襤 */
dict[0x8965] = "fú"; /* 襥 */
dict[0x8966] = "rú"; /* 襦 */
dict[0x8967] = "zhǐ"; /* 襧 */
dict[0x8969] = "shǔ"; /* 襩 */
dict[0x896a] = "wà"; /* 襪 */
dict[0x896b] = "shì"; /* 襫 */
dict[0x896c] = "bǎi"; /* 襬 */
dict[0x896d] = "xié"; /* 襭 */
dict[0x896e] = "bó"; /* 襮 */
dict[0x896f] = "chèn"; /* 襯 */
dict[0x8970] = "lǎi"; /* 襰 */
dict[0x8971] = "lóng"; /* 襱 */
dict[0x8972] = "xí"; /* 襲 */
dict[0x8973] = "xiān"; /* 襳 */
dict[0x8974] = "lán"; /* 襴 */
dict[0x8975] = "zhě"; /* 襵 */
dict[0x8976] = "dài"; /* 襶 */
dict[0x8977] = "jǔ"; /* 襷 */
dict[0x8978] = "zàn"; /* 襸 */
dict[0x8979] = "shī"; /* 襹 */
dict[0x897a] = "jiǎn"; /* 襺 */
dict[0x897b] = "pàn"; /* 襻 */
dict[0x897c] = "yì"; /* 襼 */
dict[0x897d] = "lán"; /* 襽 */
dict[0x897e] = "yà"; /* 襾 */
dict[0x897f] = "xī"; /* 西 */
dict[0x8980] = "yà"; /* 覀 */
dict[0x8981] = "yào,yāo"; /* 要 */
dict[0x8982] = "fěng"; /* 覂 */
dict[0x8983] = "tán,qín"; /* 覃 */
dict[0x8984] = "fù"; /* 覄 */
dict[0x8985] = "fiào"; /* 覅 */
dict[0x8986] = "fù"; /* 覆 */
dict[0x8987] = "bà"; /* 覇 */
dict[0x8988] = "hé"; /* 覈 */
dict[0x8989] = "jī"; /* 覉 */
dict[0x898a] = "jī"; /* 覊 */
dict[0x898b] = "jiàn,xiàn"; /* 見 */
dict[0x898c] = "guān,guàn"; /* 覌 */
dict[0x898d] = "biàn"; /* 覍 */
dict[0x898e] = "yàn"; /* 覎 */
dict[0x898f] = "guī"; /* 規 */
dict[0x8990] = "jué,jiào"; /* 覐 */
dict[0x8991] = "piǎn"; /* 覑 */
dict[0x8992] = "mào"; /* 覒 */
dict[0x8993] = "mì"; /* 覓 */
dict[0x8994] = "mì"; /* 覔 */
dict[0x8995] = "piē,miè"; /* 覕 */
dict[0x8996] = "shì"; /* 視 */
dict[0x8997] = "sì"; /* 覗 */
dict[0x8998] = "chān"; /* 覘 */
dict[0x8999] = "zhěn"; /* 覙 */
dict[0x899a] = "jué,jiào"; /* 覚 */
dict[0x899b] = "mì"; /* 覛 */
dict[0x899c] = "tiào"; /* 覜 */
dict[0x899d] = "lián"; /* 覝 */
dict[0x899e] = "yào"; /* 覞 */
dict[0x899f] = "zhì"; /* 覟 */
dict[0x89a0] = "jūn"; /* 覠 */
dict[0x89a1] = "xī"; /* 覡 */
dict[0x89a2] = "shǎn"; /* 覢 */
dict[0x89a3] = "wēi"; /* 覣 */
dict[0x89a4] = "xì"; /* 覤 */
dict[0x89a5] = "tiǎn"; /* 覥 */
dict[0x89a6] = "yú"; /* 覦 */
dict[0x89a7] = "lǎn"; /* 覧 */
dict[0x89a8] = "è"; /* 覨 */
dict[0x89a9] = "dǔ"; /* 覩 */
dict[0x89aa] = "qīn,qìng"; /* 親 */
dict[0x89ab] = "pǎng"; /* 覫 */
dict[0x89ac] = "jì"; /* 覬 */
dict[0x89ad] = "míng"; /* 覭 */
dict[0x89ae] = "yíng,yǐng"; /* 覮 */
dict[0x89af] = "gòu"; /* 覯 */
dict[0x89b0] = "qū,qù"; /* 覰 */
dict[0x89b1] = "zhàn,zhān"; /* 覱 */
dict[0x89b2] = "jìn"; /* 覲 */
dict[0x89b3] = "guān,guàn"; /* 観 */
dict[0x89b4] = "dèng"; /* 覴 */
dict[0x89b5] = "jiàn,biǎn"; /* 覵 */
dict[0x89b6] = "luó,luǎn"; /* 覶 */
dict[0x89b7] = "qù,qū"; /* 覷 */
dict[0x89b8] = "jiàn"; /* 覸 */
dict[0x89b9] = "wéi"; /* 覹 */
dict[0x89ba] = "jué,jiào"; /* 覺 */
dict[0x89bb] = "qù,qū"; /* 覻 */
dict[0x89bc] = "luó"; /* 覼 */
dict[0x89bd] = "lǎn"; /* 覽 */
dict[0x89be] = "shěn"; /* 覾 */
dict[0x89bf] = "dí"; /* 覿 */
dict[0x89c0] = "guān,guàn"; /* 觀 */
dict[0x89c1] = "jiàn,xiàn"; /* 见 */
dict[0x89c2] = "guān,guàn"; /* 观 */
dict[0x89c3] = "yàn"; /* 觃 */
dict[0x89c4] = "guī"; /* 规 */
dict[0x89c5] = "mì"; /* 觅 */
dict[0x89c6] = "shì"; /* 视 */
dict[0x89c7] = "chān"; /* 觇 */
dict[0x89c8] = "lǎn"; /* 览 */
dict[0x89c9] = "jué,jiào"; /* 觉 */
dict[0x89ca] = "jì"; /* 觊 */
dict[0x89cb] = "xí"; /* 觋 */
dict[0x89cc] = "dí"; /* 觌 */
dict[0x89cd] = "tiǎn"; /* 觍 */
dict[0x89ce] = "yú"; /* 觎 */
dict[0x89cf] = "gòu"; /* 觏 */
dict[0x89d0] = "jìn"; /* 觐 */
dict[0x89d1] = "qù,qū"; /* 觑 */
dict[0x89d2] = "jiǎo,jué"; /* 角 */
dict[0x89d3] = "qiú"; /* 觓 */
dict[0x89d4] = "jīn"; /* 觔 */
dict[0x89d5] = "cū"; /* 觕 */
dict[0x89d6] = "jué"; /* 觖 */
dict[0x89d7] = "zhì"; /* 觗 */
dict[0x89d8] = "chào"; /* 觘 */
dict[0x89d9] = "jí"; /* 觙 */
dict[0x89da] = "gū"; /* 觚 */
dict[0x89db] = "dàn"; /* 觛 */
dict[0x89dc] = "zī,zuǐ"; /* 觜 */
dict[0x89dd] = "dǐ"; /* 觝 */
dict[0x89de] = "shāng"; /* 觞 */
dict[0x89df] = "huà,xiè"; /* 觟 */
dict[0x89e0] = "quán"; /* 觠 */
dict[0x89e1] = "gé"; /* 觡 */
dict[0x89e2] = "shì"; /* 觢 */
dict[0x89e3] = "jiě,jiè,xiè"; /* 解 */
dict[0x89e4] = "guǐ"; /* 觤 */
dict[0x89e5] = "gōng"; /* 觥 */
dict[0x89e6] = "chù"; /* 触 */
dict[0x89e7] = "jiě,jiè,xiè"; /* 觧 */
dict[0x89e8] = "hùn"; /* 觨 */
dict[0x89e9] = "qiú"; /* 觩 */
dict[0x89ea] = "xīng"; /* 觪 */
dict[0x89eb] = "sù"; /* 觫 */
dict[0x89ec] = "ní"; /* 觬 */
dict[0x89ed] = "jī,qí"; /* 觭 */
dict[0x89ee] = "jué"; /* 觮 */
dict[0x89ef] = "zhì"; /* 觯 */
dict[0x89f0] = "zhā"; /* 觰 */
dict[0x89f1] = "bì"; /* 觱 */
dict[0x89f2] = "xīng"; /* 觲 */
dict[0x89f3] = "hú"; /* 觳 */
dict[0x89f4] = "shāng"; /* 觴 */
dict[0x89f5] = "gōng"; /* 觵 */
dict[0x89f6] = "zhì"; /* 觶 */
dict[0x89f7] = "xué,hù"; /* 觷 */
dict[0x89f8] = "chù"; /* 觸 */
dict[0x89f9] = "xī"; /* 觹 */
dict[0x89fa] = "yí"; /* 觺 */
dict[0x89fb] = "lì,lù"; /* 觻 */
dict[0x89fc] = "jué"; /* 觼 */
dict[0x89fd] = "xī"; /* 觽 */
dict[0x89fe] = "yàn"; /* 觾 */
dict[0x89ff] = "xī"; /* 觿 */
dict[0x8a00] = "yán"; /* 言 */
dict[0x8a01] = "yán"; /* 訁 */
dict[0x8a02] = "dìng"; /* 訂 */
dict[0x8a03] = "fù"; /* 訃 */
dict[0x8a04] = "qiú"; /* 訄 */
dict[0x8a05] = "qiú"; /* 訅 */
dict[0x8a06] = "jiào"; /* 訆 */
dict[0x8a07] = "hōng"; /* 訇 */
dict[0x8a08] = "jì"; /* 計 */
dict[0x8a09] = "fàn"; /* 訉 */
dict[0x8a0a] = "xùn"; /* 訊 */
dict[0x8a0b] = "diào"; /* 訋 */
dict[0x8a0c] = "hòng"; /* 訌 */
dict[0x8a0d] = "chài"; /* 訍 */
dict[0x8a0e] = "tǎo"; /* 討 */
dict[0x8a0f] = "xū"; /* 訏 */
dict[0x8a10] = "jié"; /* 訐 */
dict[0x8a11] = "dàn"; /* 訑 */
dict[0x8a12] = "rèn"; /* 訒 */
dict[0x8a13] = "xùn"; /* 訓 */
dict[0x8a14] = "yín"; /* 訔 */
dict[0x8a15] = "shàn"; /* 訕 */
dict[0x8a16] = "qì"; /* 訖 */
dict[0x8a17] = "tuō"; /* 託 */
dict[0x8a18] = "jì"; /* 記 */
dict[0x8a19] = "xùn"; /* 訙 */
dict[0x8a1a] = "yín"; /* 訚 */
dict[0x8a1b] = "é"; /* 訛 */
dict[0x8a1c] = "fēn"; /* 訜 */
dict[0x8a1d] = "yà"; /* 訝 */
dict[0x8a1e] = "yāo"; /* 訞 */
dict[0x8a1f] = "sòng"; /* 訟 */
dict[0x8a20] = "shěn"; /* 訠 */
dict[0x8a21] = "yín"; /* 訡 */
dict[0x8a22] = "xīn"; /* 訢 */
dict[0x8a23] = "jué"; /* 訣 */
dict[0x8a24] = "xiáo"; /* 訤 */
dict[0x8a25] = "nè"; /* 訥 */
dict[0x8a26] = "chén"; /* 訦 */
dict[0x8a27] = "yóu"; /* 訧 */
dict[0x8a28] = "zhǐ"; /* 訨 */
dict[0x8a29] = "xiōng"; /* 訩 */
dict[0x8a2a] = "fǎng"; /* 訪 */
dict[0x8a2b] = "xìn"; /* 訫 */
dict[0x8a2c] = "chāo"; /* 訬 */
dict[0x8a2d] = "shè"; /* 設 */
dict[0x8a2e] = "yán"; /* 訮 */
dict[0x8a2f] = "sǎ"; /* 訯 */
dict[0x8a30] = "zhùn"; /* 訰 */
dict[0x8a31] = "xū"; /* 許 */
dict[0x8a32] = "yì"; /* 訲 */
dict[0x8a33] = "yì"; /* 訳 */
dict[0x8a34] = "sù"; /* 訴 */
dict[0x8a35] = "chī"; /* 訵 */
dict[0x8a36] = "hē"; /* 訶 */
dict[0x8a37] = "shēn"; /* 訷 */
dict[0x8a38] = "hé"; /* 訸 */
dict[0x8a39] = "xù"; /* 訹 */
dict[0x8a3a] = "zhěn"; /* 診 */
dict[0x8a3b] = "zhù"; /* 註 */
dict[0x8a3c] = "zhèng"; /* 証 */
dict[0x8a3d] = "gòu"; /* 訽 */
dict[0x8a3e] = "zī"; /* 訾 */
dict[0x8a3f] = "zǐ"; /* 訿 */
dict[0x8a40] = "zhān"; /* 詀 */
dict[0x8a41] = "gǔ"; /* 詁 */
dict[0x8a42] = "fù"; /* 詂 */
dict[0x8a43] = "jiǎn"; /* 詃 */
dict[0x8a44] = "dié"; /* 詄 */
dict[0x8a45] = "líng"; /* 詅 */
dict[0x8a46] = "dǐ"; /* 詆 */
dict[0x8a47] = "yàng"; /* 詇 */
dict[0x8a48] = "lì"; /* 詈 */
dict[0x8a49] = "náo"; /* 詉 */
dict[0x8a4a] = "pàn"; /* 詊 */
dict[0x8a4b] = "zhòu"; /* 詋 */
dict[0x8a4c] = "gàn"; /* 詌 */
dict[0x8a4d] = "yì"; /* 詍 */
dict[0x8a4e] = "jù"; /* 詎 */
dict[0x8a4f] = "yào"; /* 詏 */
dict[0x8a50] = "zhà"; /* 詐 */
dict[0x8a51] = "tuó"; /* 詑 */
dict[0x8a52] = "yí,dài"; /* 詒 */
dict[0x8a53] = "qǔ"; /* 詓 */
dict[0x8a54] = "zhào"; /* 詔 */
dict[0x8a55] = "píng"; /* 評 */
dict[0x8a56] = "bì"; /* 詖 */
dict[0x8a57] = "xiòng"; /* 詗 */
dict[0x8a58] = "qū"; /* 詘 */
dict[0x8a59] = "bá"; /* 詙 */
dict[0x8a5a] = "dá"; /* 詚 */
dict[0x8a5b] = "zǔ"; /* 詛 */
dict[0x8a5c] = "tāo"; /* 詜 */
dict[0x8a5d] = "zhǔ"; /* 詝 */
dict[0x8a5e] = "cí"; /* 詞 */
dict[0x8a5f] = "zhé"; /* 詟 */
dict[0x8a60] = "yǒng"; /* 詠 */
dict[0x8a61] = "xǔ"; /* 詡 */
dict[0x8a62] = "xún"; /* 詢 */
dict[0x8a63] = "yì"; /* 詣 */
dict[0x8a64] = "huǎng"; /* 詤 */
dict[0x8a65] = "hé"; /* 詥 */
dict[0x8a66] = "shì"; /* 試 */
dict[0x8a67] = "chá"; /* 詧 */
dict[0x8a68] = "xiào"; /* 詨 */
dict[0x8a69] = "shī"; /* 詩 */
dict[0x8a6a] = "hěn"; /* 詪 */
dict[0x8a6b] = "chà"; /* 詫 */
dict[0x8a6c] = "gòu"; /* 詬 */
dict[0x8a6d] = "guǐ"; /* 詭 */
dict[0x8a6e] = "quán"; /* 詮 */
dict[0x8a6f] = "huì"; /* 詯 */
dict[0x8a70] = "jié"; /* 詰 */
dict[0x8a71] = "huà"; /* 話 */
dict[0x8a72] = "gāi"; /* 該 */
dict[0x8a73] = "xiáng"; /* 詳 */
dict[0x8a74] = "wēi"; /* 詴 */
dict[0x8a75] = "shēn"; /* 詵 */
dict[0x8a76] = "chóu"; /* 詶 */
dict[0x8a77] = "tóng"; /* 詷 */
dict[0x8a78] = "mí"; /* 詸 */
dict[0x8a79] = "zhān"; /* 詹 */
dict[0x8a7a] = "míng"; /* 詺 */
dict[0x8a7b] = "luò"; /* 詻 */
dict[0x8a7c] = "huī"; /* 詼 */
dict[0x8a7d] = "yán"; /* 詽 */
dict[0x8a7e] = "xiōng"; /* 詾 */
dict[0x8a7f] = "guà"; /* 詿 */
dict[0x8a80] = "èr"; /* 誀 */
dict[0x8a81] = "bìng"; /* 誁 */
dict[0x8a82] = "tiǎo,diào"; /* 誂 */
dict[0x8a83] = "yí,chǐ,chì"; /* 誃 */
dict[0x8a84] = "lěi"; /* 誄 */
dict[0x8a85] = "zhū"; /* 誅 */
dict[0x8a86] = "kuāng"; /* 誆 */
dict[0x8a87] = "kuā,kuà"; /* 誇 */
dict[0x8a88] = "wū"; /* 誈 */
dict[0x8a89] = "yù"; /* 誉 */
dict[0x8a8a] = "téng"; /* 誊 */
dict[0x8a8b] = "jì"; /* 誋 */
dict[0x8a8c] = "zhì"; /* 誌 */
dict[0x8a8d] = "rèn"; /* 認 */
dict[0x8a8e] = "cù"; /* 誎 */
dict[0x8a8f] = "lǎng,làng"; /* 誏 */
dict[0x8a90] = "é"; /* 誐 */
dict[0x8a91] = "kuáng"; /* 誑 */
dict[0x8a92] = "ēi,éi,ěi,èi,xī"; /* 誒 */
dict[0x8a93] = "shì"; /* 誓 */
dict[0x8a94] = "tǐng"; /* 誔 */
dict[0x8a95] = "dàn"; /* 誕 */
dict[0x8a96] = "bèi,bó"; /* 誖 */
dict[0x8a97] = "chán"; /* 誗 */
dict[0x8a98] = "yòu"; /* 誘 */
dict[0x8a99] = "kēng"; /* 誙 */
dict[0x8a9a] = "qiào"; /* 誚 */
dict[0x8a9b] = "qīn"; /* 誛 */
dict[0x8a9c] = "shuà"; /* 誜 */
dict[0x8a9d] = "ān"; /* 誝 */
dict[0x8a9e] = "yǔ,yù"; /* 語 */
dict[0x8a9f] = "xiào"; /* 誟 */
dict[0x8aa0] = "chéng"; /* 誠 */
dict[0x8aa1] = "jiè"; /* 誡 */
dict[0x8aa2] = "xiàn"; /* 誢 */
dict[0x8aa3] = "wū"; /* 誣 */
dict[0x8aa4] = "wù"; /* 誤 */
dict[0x8aa5] = "gào"; /* 誥 */
dict[0x8aa6] = "sòng"; /* 誦 */
dict[0x8aa7] = "bū"; /* 誧 */
dict[0x8aa8] = "huì"; /* 誨 */
dict[0x8aa9] = "jìng"; /* 誩 */
dict[0x8aaa] = "shuō,shuì,yuè"; /* 說 */
dict[0x8aab] = "zhèn"; /* 誫 */
dict[0x8aac] = "shuō,shuì,yuè"; /* 説 */
dict[0x8aad] = "dú"; /* 読 */
dict[0x8aae] = "huā"; /* 誮 */
dict[0x8aaf] = "chàng"; /* 誯 */
dict[0x8ab0] = "shuí,shéi"; /* 誰 */
dict[0x8ab1] = "jié"; /* 誱 */
dict[0x8ab2] = "kè"; /* 課 */
dict[0x8ab3] = "qū,juè"; /* 誳 */
dict[0x8ab4] = "cóng"; /* 誴 */
dict[0x8ab5] = "xiáo"; /* 誵 */
dict[0x8ab6] = "suì"; /* 誶 */
dict[0x8ab7] = "wǎng"; /* 誷 */
dict[0x8ab8] = "xián"; /* 誸 */
dict[0x8ab9] = "fěi"; /* 誹 */
dict[0x8aba] = "chī,lài"; /* 誺 */
dict[0x8abb] = "tà"; /* 誻 */
dict[0x8abc] = "yì"; /* 誼 */
dict[0x8abd] = "nì,ná"; /* 誽 */
dict[0x8abe] = "yín"; /* 誾 */
dict[0x8abf] = "diào,tiáo"; /* 調 */
dict[0x8ac0] = "pǐ,bēi"; /* 諀 */
dict[0x8ac1] = "zhuó"; /* 諁 */
dict[0x8ac2] = "chǎn"; /* 諂 */
dict[0x8ac3] = "chēn"; /* 諃 */
dict[0x8ac4] = "zhūn"; /* 諄 */
dict[0x8ac5] = "jì,jī"; /* 諅 */
dict[0x8ac6] = "qī"; /* 諆 */
dict[0x8ac7] = "tán"; /* 談 */
dict[0x8ac8] = "zhuì"; /* 諈 */
dict[0x8ac9] = "wěi"; /* 諉 */
dict[0x8aca] = "jū"; /* 諊 */
dict[0x8acb] = "qǐng"; /* 請 */
dict[0x8acc] = "dǒng"; /* 諌 */
dict[0x8acd] = "zhèng"; /* 諍 */
dict[0x8ace] = "zé,zuò,zhǎ,cuò"; /* 諎 */
dict[0x8acf] = "zōu"; /* 諏 */
dict[0x8ad0] = "qiān"; /* 諐 */
dict[0x8ad1] = "zhuó"; /* 諑 */
dict[0x8ad2] = "liàng"; /* 諒 */
dict[0x8ad3] = "jiàn"; /* 諓 */
dict[0x8ad4] = "chù,jí"; /* 諔 */
dict[0x8ad5] = "xià,háo"; /* 諕 */
dict[0x8ad6] = "lùn,lún"; /* 論 */
dict[0x8ad7] = "shěn"; /* 諗 */
dict[0x8ad8] = "biǎo"; /* 諘 */
dict[0x8ad9] = "huà"; /* 諙 */
dict[0x8ada] = "biàn"; /* 諚 */
dict[0x8adb] = "yú"; /* 諛 */
dict[0x8adc] = "dié"; /* 諜 */
dict[0x8add] = "xū"; /* 諝 */
dict[0x8ade] = "piǎn"; /* 諞 */
dict[0x8adf] = "shì,dì"; /* 諟 */
dict[0x8ae0] = "xuān"; /* 諠 */
dict[0x8ae1] = "shì"; /* 諡 */
dict[0x8ae2] = "hùn"; /* 諢 */
dict[0x8ae3] = "huà,guā"; /* 諣 */
dict[0x8ae4] = "è"; /* 諤 */
dict[0x8ae5] = "zhòng"; /* 諥 */
dict[0x8ae6] = "dì"; /* 諦 */
dict[0x8ae7] = "xié"; /* 諧 */
dict[0x8ae8] = "fú"; /* 諨 */
dict[0x8ae9] = "pǔ"; /* 諩 */
dict[0x8aea] = "tíng"; /* 諪 */
dict[0x8aeb] = "jiàn"; /* 諫 */
dict[0x8aec] = "qǐ"; /* 諬 */
dict[0x8aed] = "yù"; /* 諭 */
dict[0x8aee] = "zī"; /* 諮 */
dict[0x8aef] = "zhuān"; /* 諯 */
dict[0x8af0] = "xǐ,shāi,āi"; /* 諰 */
dict[0x8af1] = "huì"; /* 諱 */
dict[0x8af2] = "yīn"; /* 諲 */
dict[0x8af3] = "ān"; /* 諳 */
dict[0x8af4] = "xián"; /* 諴 */
dict[0x8af5] = "nán,nàn"; /* 諵 */
dict[0x8af6] = "chén"; /* 諶 */
dict[0x8af7] = "fěng"; /* 諷 */
dict[0x8af8] = "zhū"; /* 諸 */
dict[0x8af9] = "yáng"; /* 諹 */
dict[0x8afa] = "yàn"; /* 諺 */
dict[0x8afb] = "huáng"; /* 諻 */
dict[0x8afc] = "xuān"; /* 諼 */
dict[0x8afd] = "gé"; /* 諽 */
dict[0x8afe] = "nuò"; /* 諾 */
dict[0x8aff] = "xǔ"; /* 諿 */
dict[0x8b00] = "móu"; /* 謀 */
dict[0x8b01] = "yè"; /* 謁 */
dict[0x8b02] = "wèi"; /* 謂 */
dict[0x8b03] = "xīng"; /* 謃 */
dict[0x8b04] = "téng"; /* 謄 */
dict[0x8b05] = "zhōu"; /* 謅 */
dict[0x8b06] = "shàn"; /* 謆 */
dict[0x8b07] = "jiǎn"; /* 謇 */
dict[0x8b08] = "bó"; /* 謈 */
dict[0x8b09] = "kuì"; /* 謉 */
dict[0x8b0a] = "huǎng"; /* 謊 */
dict[0x8b0b] = "huò"; /* 謋 */
dict[0x8b0c] = "gē"; /* 謌 */
dict[0x8b0d] = "yíng"; /* 謍 */
dict[0x8b0e] = "mí"; /* 謎 */
dict[0x8b0f] = "xiǎo"; /* 謏 */
dict[0x8b10] = "mì"; /* 謐 */
dict[0x8b11] = "xǐ"; /* 謑 */
dict[0x8b12] = "qiāng"; /* 謒 */
dict[0x8b13] = "chēn"; /* 謓 */
dict[0x8b14] = "xuè"; /* 謔 */
dict[0x8b15] = "tí"; /* 謕 */
dict[0x8b16] = "sù"; /* 謖 */
dict[0x8b17] = "bàng"; /* 謗 */
dict[0x8b18] = "chí"; /* 謘 */
dict[0x8b19] = "qiān"; /* 謙 */
dict[0x8b1a] = "shì"; /* 謚 */
dict[0x8b1b] = "jiǎng"; /* 講 */
dict[0x8b1c] = "yuán"; /* 謜 */
dict[0x8b1d] = "xiè"; /* 謝 */
dict[0x8b1e] = "hè"; /* 謞 */
dict[0x8b1f] = "tāo"; /* 謟 */
dict[0x8b20] = "yáo"; /* 謠 */
dict[0x8b21] = "yáo"; /* 謡 */
dict[0x8b22] = "lū"; /* 謢 */
dict[0x8b23] = "yú"; /* 謣 */
dict[0x8b24] = "biāo"; /* 謤 */
dict[0x8b25] = "còng"; /* 謥 */
dict[0x8b26] = "qǐng"; /* 謦 */
dict[0x8b27] = "lí"; /* 謧 */
dict[0x8b28] = "mó"; /* 謨 */
dict[0x8b29] = "mó"; /* 謩 */
dict[0x8b2a] = "shāng"; /* 謪 */
dict[0x8b2b] = "zhé"; /* 謫 */
dict[0x8b2c] = "miù"; /* 謬 */
dict[0x8b2d] = "jiǎn"; /* 謭 */
dict[0x8b2e] = "zé"; /* 謮 */
dict[0x8b2f] = "jiē"; /* 謯 */
dict[0x8b30] = "lián"; /* 謰 */
dict[0x8b31] = "lóu"; /* 謱 */
dict[0x8b32] = "càn"; /* 謲 */
dict[0x8b33] = "ōu"; /* 謳 */
dict[0x8b34] = "gùn"; /* 謴 */
dict[0x8b35] = "xí"; /* 謵 */
dict[0x8b36] = "zhuó"; /* 謶 */
dict[0x8b37] = "áo"; /* 謷 */
dict[0x8b38] = "áo"; /* 謸 */
dict[0x8b39] = "jǐn"; /* 謹 */
dict[0x8b3a] = "zhé"; /* 謺 */
dict[0x8b3b] = "yí"; /* 謻 */
dict[0x8b3c] = "hū"; /* 謼 */
dict[0x8b3d] = "jiàng"; /* 謽 */
dict[0x8b3e] = "mán"; /* 謾 */
dict[0x8b3f] = "cháo"; /* 謿 */
dict[0x8b40] = "hàn"; /* 譀 */
dict[0x8b41] = "huá"; /* 譁 */
dict[0x8b42] = "chǎn"; /* 譂 */
dict[0x8b43] = "xū"; /* 譃 */
dict[0x8b44] = "zēng"; /* 譄 */
dict[0x8b45] = "sè"; /* 譅 */
dict[0x8b46] = "xī"; /* 譆 */
dict[0x8b47] = "zhā"; /* 譇 */
dict[0x8b48] = "duì"; /* 譈 */
dict[0x8b49] = "zhèng"; /* 證 */
dict[0x8b4a] = "náo"; /* 譊 */
dict[0x8b4b] = "lán"; /* 譋 */
dict[0x8b4c] = "é"; /* 譌 */
dict[0x8b4d] = "yīng"; /* 譍 */
dict[0x8b4e] = "jué"; /* 譎 */
dict[0x8b4f] = "jī"; /* 譏 */
dict[0x8b50] = "zǔn"; /* 譐 */
dict[0x8b51] = "jiǎo"; /* 譑 */
dict[0x8b52] = "bò"; /* 譒 */
dict[0x8b53] = "huì"; /* 譓 */
dict[0x8b54] = "zhuàn"; /* 譔 */
dict[0x8b55] = "wú"; /* 譕 */
dict[0x8b56] = "zèn"; /* 譖 */
dict[0x8b57] = "zhá"; /* 譗 */
dict[0x8b58] = "shí"; /* 識 */
dict[0x8b59] = "qiáo"; /* 譙 */
dict[0x8b5a] = "tán"; /* 譚 */
dict[0x8b5b] = "jiàn"; /* 譛 */
dict[0x8b5c] = "pǔ"; /* 譜 */
dict[0x8b5d] = "shéng"; /* 譝 */
dict[0x8b5e] = "xuān"; /* 譞 */
dict[0x8b5f] = "zào"; /* 譟 */
dict[0x8b60] = "tán"; /* 譠 */
dict[0x8b61] = "dǎng"; /* 譡 */
dict[0x8b62] = "suì"; /* 譢 */
dict[0x8b63] = "xiǎn"; /* 譣 */
dict[0x8b64] = "jī"; /* 譤 */
dict[0x8b65] = "jiào"; /* 譥 */
dict[0x8b66] = "jǐng"; /* 警 */
dict[0x8b67] = "zhàn"; /* 譧 */
dict[0x8b68] = "nóng"; /* 譨 */
dict[0x8b69] = "yī"; /* 譩 */
dict[0x8b6a] = "ǎi"; /* 譪 */
dict[0x8b6b] = "zhān"; /* 譫 */
dict[0x8b6c] = "pì"; /* 譬 */
dict[0x8b6d] = "huǐ"; /* 譭 */
dict[0x8b6e] = "huà"; /* 譮 */
dict[0x8b6f] = "yì"; /* 譯 */
dict[0x8b70] = "yì"; /* 議 */
dict[0x8b71] = "shàn"; /* 譱 */
dict[0x8b72] = "ràng"; /* 譲 */
dict[0x8b73] = "ròu"; /* 譳 */
dict[0x8b74] = "qiǎn"; /* 譴 */
dict[0x8b75] = "duì"; /* 譵 */
dict[0x8b76] = "tà"; /* 譶 */
dict[0x8b77] = "hù"; /* 護 */
dict[0x8b78] = "zhōu"; /* 譸 */
dict[0x8b79] = "háo"; /* 譹 */
dict[0x8b7a] = "ài"; /* 譺 */
dict[0x8b7b] = "yīng"; /* 譻 */
dict[0x8b7c] = "jiān"; /* 譼 */
dict[0x8b7d] = "yù"; /* 譽 */
dict[0x8b7e] = "jiǎn"; /* 譾 */
dict[0x8b7f] = "huì"; /* 譿 */
dict[0x8b80] = "dú"; /* 讀 */
dict[0x8b81] = "zhé"; /* 讁 */
dict[0x8b82] = "juàn,xuān"; /* 讂 */
dict[0x8b83] = "zàn"; /* 讃 */
dict[0x8b84] = "lěi"; /* 讄 */
dict[0x8b85] = "shěn"; /* 讅 */
dict[0x8b86] = "wèi"; /* 讆 */
dict[0x8b87] = "chǎn"; /* 讇 */
dict[0x8b88] = "lì"; /* 讈 */
dict[0x8b89] = "yí,tuī"; /* 讉 */
dict[0x8b8a] = "biàn"; /* 變 */
dict[0x8b8b] = "zhé"; /* 讋 */
dict[0x8b8c] = "yàn"; /* 讌 */
dict[0x8b8d] = "è"; /* 讍 */
dict[0x8b8e] = "chóu"; /* 讎 */
dict[0x8b8f] = "wèi"; /* 讏 */
dict[0x8b90] = "chóu"; /* 讐 */
dict[0x8b91] = "yào"; /* 讑 */
dict[0x8b92] = "chán"; /* 讒 */
dict[0x8b93] = "ràng"; /* 讓 */
dict[0x8b94] = "yǐn"; /* 讔 */
dict[0x8b95] = "lán"; /* 讕 */
dict[0x8b96] = "chèn"; /* 讖 */
dict[0x8b97] = "xié"; /* 讗 */
dict[0x8b98] = "niè"; /* 讘 */
dict[0x8b99] = "huān"; /* 讙 */
dict[0x8b9a] = "zàn"; /* 讚 */
dict[0x8b9b] = "yì"; /* 讛 */
dict[0x8b9c] = "dǎng"; /* 讜 */
dict[0x8b9d] = "zhán"; /* 讝 */
dict[0x8b9e] = "yàn"; /* 讞 */
dict[0x8b9f] = "dú"; /* 讟 */
dict[0x8ba0] = "yán"; /* 讠 */
dict[0x8ba1] = "jì"; /* 计 */
dict[0x8ba2] = "dìng"; /* 订 */
dict[0x8ba3] = "fù"; /* 讣 */
dict[0x8ba4] = "rèn"; /* 认 */
dict[0x8ba5] = "jī"; /* 讥 */
dict[0x8ba6] = "jié"; /* 讦 */
dict[0x8ba7] = "hòng"; /* 讧 */
dict[0x8ba8] = "tǎo"; /* 讨 */
dict[0x8ba9] = "ràng"; /* 让 */
dict[0x8baa] = "shàn"; /* 讪 */
dict[0x8bab] = "qì"; /* 讫 */
dict[0x8bac] = "tuō"; /* 讬 */
dict[0x8bad] = "xùn"; /* 训 */
dict[0x8bae] = "yì"; /* 议 */
dict[0x8baf] = "xùn"; /* 讯 */
dict[0x8bb0] = "jì"; /* 记 */
dict[0x8bb1] = "rèn"; /* 讱 */
dict[0x8bb2] = "jiǎng"; /* 讲 */
dict[0x8bb3] = "huì"; /* 讳 */
dict[0x8bb4] = "ōu"; /* 讴 */
dict[0x8bb5] = "jù"; /* 讵 */
dict[0x8bb6] = "yà"; /* 讶 */
dict[0x8bb7] = "nè"; /* 讷 */
dict[0x8bb8] = "xǔ,hǔ"; /* 许 */
dict[0x8bb9] = "é"; /* 讹 */
dict[0x8bba] = "lùn,lún"; /* 论 */
dict[0x8bbb] = "xiōng"; /* 讻 */
dict[0x8bbc] = "sòng"; /* 讼 */
dict[0x8bbd] = "fěng"; /* 讽 */
dict[0x8bbe] = "shè"; /* 设 */
dict[0x8bbf] = "fǎng"; /* 访 */
dict[0x8bc0] = "jué"; /* 诀 */
dict[0x8bc1] = "zhèng"; /* 证 */
dict[0x8bc2] = "gǔ"; /* 诂 */
dict[0x8bc3] = "hē"; /* 诃 */
dict[0x8bc4] = "píng"; /* 评 */
dict[0x8bc5] = "zǔ"; /* 诅 */
dict[0x8bc6] = "shí,zhì"; /* 识 */
dict[0x8bc7] = "xiòng"; /* 诇 */
dict[0x8bc8] = "zhà"; /* 诈 */
dict[0x8bc9] = "sù"; /* 诉 */
dict[0x8bca] = "zhěn"; /* 诊 */
dict[0x8bcb] = "dǐ"; /* 诋 */
dict[0x8bcc] = "zhōu"; /* 诌 */
dict[0x8bcd] = "cí"; /* 词 */
dict[0x8bce] = "qū"; /* 诎 */
dict[0x8bcf] = "zhào"; /* 诏 */
dict[0x8bd0] = "bì"; /* 诐 */
dict[0x8bd1] = "yì"; /* 译 */
dict[0x8bd2] = "yí,dài"; /* 诒 */
dict[0x8bd3] = "kuāng"; /* 诓 */
dict[0x8bd4] = "lěi"; /* 诔 */
dict[0x8bd5] = "shì"; /* 试 */
dict[0x8bd6] = "guà"; /* 诖 */
dict[0x8bd7] = "shī"; /* 诗 */
dict[0x8bd8] = "jié,jí"; /* 诘 */
dict[0x8bd9] = "huī"; /* 诙 */
dict[0x8bda] = "chéng"; /* 诚 */
dict[0x8bdb] = "zhū"; /* 诛 */
dict[0x8bdc] = "shēn"; /* 诜 */
dict[0x8bdd] = "huà"; /* 话 */
dict[0x8bde] = "dàn"; /* 诞 */
dict[0x8bdf] = "gòu"; /* 诟 */
dict[0x8be0] = "quán"; /* 诠 */
dict[0x8be1] = "guǐ"; /* 诡 */
dict[0x8be2] = "xún"; /* 询 */
dict[0x8be3] = "yì"; /* 诣 */
dict[0x8be4] = "zhèng"; /* 诤 */
dict[0x8be5] = "gāi"; /* 该 */
dict[0x8be6] = "xiáng,yáng"; /* 详 */
dict[0x8be7] = "chà"; /* 诧 */
dict[0x8be8] = "hùn"; /* 诨 */
dict[0x8be9] = "xǔ"; /* 诩 */
dict[0x8bea] = "zhōu,chóu"; /* 诪 */
dict[0x8beb] = "jiè"; /* 诫 */
dict[0x8bec] = "wū"; /* 诬 */
dict[0x8bed] = "yǔ,yù"; /* 语 */
dict[0x8bee] = "qiào"; /* 诮 */
dict[0x8bef] = "wù"; /* 误 */
dict[0x8bf0] = "gào"; /* 诰 */
dict[0x8bf1] = "yòu"; /* 诱 */
dict[0x8bf2] = "huì"; /* 诲 */
dict[0x8bf3] = "kuáng"; /* 诳 */
dict[0x8bf4] = "shuō,shuì,yuè"; /* 说 */
dict[0x8bf5] = "sòng"; /* 诵 */
dict[0x8bf6] = "ēi,éi,ěi,èi,xī"; /* 诶 */
dict[0x8bf7] = "qǐng"; /* 请 */
dict[0x8bf8] = "zhū"; /* 诸 */
dict[0x8bf9] = "zōu"; /* 诹 */
dict[0x8bfa] = "nuò"; /* 诺 */
dict[0x8bfb] = "dú,dòu"; /* 读 */
dict[0x8bfc] = "zhuó"; /* 诼 */
dict[0x8bfd] = "fěi"; /* 诽 */
dict[0x8bfe] = "kè"; /* 课 */
dict[0x8bff] = "wěi"; /* 诿 */
dict[0x8c00] = "yú"; /* 谀 */
dict[0x8c01] = "shuí"; /* 谁 */
dict[0x8c02] = "shěn"; /* 谂 */
dict[0x8c03] = "tiáo,diào,zhōu"; /* 调 */
dict[0x8c04] = "chǎn"; /* 谄 */
dict[0x8c05] = "liàng"; /* 谅 */
dict[0x8c06] = "zhūn"; /* 谆 */
dict[0x8c07] = "suì"; /* 谇 */
dict[0x8c08] = "tán"; /* 谈 */
dict[0x8c09] = "shěn"; /* 谉 */
dict[0x8c0a] = "yì"; /* 谊 */
dict[0x8c0b] = "móu"; /* 谋 */
dict[0x8c0c] = "chén,shèn"; /* 谌 */
dict[0x8c0d] = "dié"; /* 谍 */
dict[0x8c0e] = "huǎng"; /* 谎 */
dict[0x8c0f] = "jiàn"; /* 谏 */
dict[0x8c10] = "xié"; /* 谐 */
dict[0x8c11] = "xuè"; /* 谑 */
dict[0x8c12] = "yè"; /* 谒 */
dict[0x8c13] = "wèi"; /* 谓 */
dict[0x8c14] = "è"; /* 谔 */
dict[0x8c15] = "yù"; /* 谕 */
dict[0x8c16] = "xuān"; /* 谖 */
dict[0x8c17] = "chán"; /* 谗 */
dict[0x8c18] = "zī"; /* 谘 */
dict[0x8c19] = "ān"; /* 谙 */
dict[0x8c1a] = "yàn"; /* 谚 */
dict[0x8c1b] = "dì"; /* 谛 */
dict[0x8c1c] = "mí"; /* 谜 */
dict[0x8c1d] = "piǎn"; /* 谝 */
dict[0x8c1e] = "xū"; /* 谞 */
dict[0x8c1f] = "mó"; /* 谟 */
dict[0x8c20] = "dǎng"; /* 谠 */
dict[0x8c21] = "sù"; /* 谡 */
dict[0x8c22] = "xiè"; /* 谢 */
dict[0x8c23] = "yáo"; /* 谣 */
dict[0x8c24] = "bàng"; /* 谤 */
dict[0x8c25] = "shì"; /* 谥 */
dict[0x8c26] = "qiān"; /* 谦 */
dict[0x8c27] = "mì"; /* 谧 */
dict[0x8c28] = "jǐn"; /* 谨 */
dict[0x8c29] = "mán"; /* 谩 */
dict[0x8c2a] = "zhé"; /* 谪 */
dict[0x8c2b] = "jiǎn"; /* 谫 */
dict[0x8c2c] = "miù"; /* 谬 */
dict[0x8c2d] = "tán"; /* 谭 */
dict[0x8c2e] = "zèn"; /* 谮 */
dict[0x8c2f] = "qiáo"; /* 谯 */
dict[0x8c30] = "lán"; /* 谰 */
dict[0x8c31] = "pǔ"; /* 谱 */
dict[0x8c32] = "jué"; /* 谲 */
dict[0x8c33] = "yàn"; /* 谳 */
dict[0x8c34] = "qiǎn"; /* 谴 */
dict[0x8c35] = "zhān"; /* 谵 */
dict[0x8c36] = "chèn"; /* 谶 */
dict[0x8c37] = "gǔ"; /* 谷 */
dict[0x8c38] = "qiān"; /* 谸 */
dict[0x8c39] = "hóng"; /* 谹 */
dict[0x8c3a] = "xiā"; /* 谺 */
dict[0x8c3b] = "jí"; /* 谻 */
dict[0x8c3c] = "hóng"; /* 谼 */
dict[0x8c3d] = "hān"; /* 谽 */
dict[0x8c3e] = "hōng"; /* 谾 */
dict[0x8c3f] = "xī"; /* 谿 */
dict[0x8c40] = "xī"; /* 豀 */
dict[0x8c41] = "huō,huò,huá"; /* 豁 */
dict[0x8c42] = "liáo"; /* 豂 */
dict[0x8c43] = "hǎn"; /* 豃 */
dict[0x8c44] = "dú"; /* 豄 */
dict[0x8c45] = "lóng"; /* 豅 */
dict[0x8c46] = "dòu"; /* 豆 */
dict[0x8c47] = "jiāng"; /* 豇 */
dict[0x8c48] = "qǐ,kǎi"; /* 豈 */
dict[0x8c49] = "chǐ"; /* 豉 */
dict[0x8c4a] = "lǐ"; /* 豊 */
dict[0x8c4b] = "dēng"; /* 豋 */
dict[0x8c4c] = "wān"; /* 豌 */
dict[0x8c4d] = "bī"; /* 豍 */
dict[0x8c4e] = "shù"; /* 豎 */
dict[0x8c4f] = "xiàn"; /* 豏 */
dict[0x8c50] = "fēng"; /* 豐 */
dict[0x8c51] = "zhì"; /* 豑 */
dict[0x8c52] = "zhì"; /* 豒 */
dict[0x8c53] = "yàn"; /* 豓 */
dict[0x8c54] = "yàn"; /* 豔 */
dict[0x8c55] = "shǐ"; /* 豕 */
dict[0x8c56] = "chù"; /* 豖 */
dict[0x8c57] = "huī"; /* 豗 */
dict[0x8c58] = "tún"; /* 豘 */
dict[0x8c59] = "yì"; /* 豙 */
dict[0x8c5a] = "tún"; /* 豚 */
dict[0x8c5b] = "yì"; /* 豛 */
dict[0x8c5c] = "jiān"; /* 豜 */
dict[0x8c5d] = "bā"; /* 豝 */
dict[0x8c5e] = "hòu"; /* 豞 */
dict[0x8c5f] = "è"; /* 豟 */
dict[0x8c60] = "chú"; /* 豠 */
dict[0x8c61] = "xiàng"; /* 象 */
dict[0x8c62] = "huàn"; /* 豢 */
dict[0x8c63] = "jiān,yàn"; /* 豣 */
dict[0x8c64] = "kěn"; /* 豤 */
dict[0x8c65] = "gāi"; /* 豥 */
dict[0x8c66] = "jù"; /* 豦 */
dict[0x8c67] = "fú"; /* 豧 */
dict[0x8c68] = "xī"; /* 豨 */
dict[0x8c69] = "bīn"; /* 豩 */
dict[0x8c6a] = "háo"; /* 豪 */
dict[0x8c6b] = "yù"; /* 豫 */
dict[0x8c6c] = "zhū"; /* 豬 */
dict[0x8c6d] = "jiā"; /* 豭 */
dict[0x8c6e] = "fén"; /* 豮 */
dict[0x8c6f] = "xī"; /* 豯 */
dict[0x8c70] = "hù"; /* 豰 */
dict[0x8c71] = "wēn"; /* 豱 */
dict[0x8c72] = "huán"; /* 豲 */
dict[0x8c73] = "bīn"; /* 豳 */
dict[0x8c74] = "dí"; /* 豴 */
dict[0x8c75] = "zōng"; /* 豵 */
dict[0x8c76] = "fén"; /* 豶 */
dict[0x8c77] = "yì"; /* 豷 */
dict[0x8c78] = "zhì"; /* 豸 */
dict[0x8c79] = "bào"; /* 豹 */
dict[0x8c7a] = "chái"; /* 豺 */
dict[0x8c7b] = "àn"; /* 豻 */
dict[0x8c7c] = "pí"; /* 豼 */
dict[0x8c7d] = "nà"; /* 豽 */
dict[0x8c7e] = "pī"; /* 豾 */
dict[0x8c7f] = "gǒu"; /* 豿 */
dict[0x8c80] = "nà"; /* 貀 */
dict[0x8c81] = "yòu"; /* 貁 */
dict[0x8c82] = "diāo"; /* 貂 */
dict[0x8c83] = "mò"; /* 貃 */
dict[0x8c84] = "sì"; /* 貄 */
dict[0x8c85] = "xiū"; /* 貅 */
dict[0x8c86] = "huán,huān"; /* 貆 */
dict[0x8c87] = "kěn,kūn"; /* 貇 */
dict[0x8c88] = "hé,mò"; /* 貈 */
dict[0x8c89] = "hé,háo,mò"; /* 貉 */
dict[0x8c8a] = "mò"; /* 貊 */
dict[0x8c8b] = "àn"; /* 貋 */
dict[0x8c8c] = "mào"; /* 貌 */
dict[0x8c8d] = "lí"; /* 貍 */
dict[0x8c8e] = "ní"; /* 貎 */
dict[0x8c8f] = "bǐ"; /* 貏 */
dict[0x8c90] = "yǔ"; /* 貐 */
dict[0x8c91] = "jiā"; /* 貑 */
dict[0x8c92] = "tuān,tuàn"; /* 貒 */
dict[0x8c93] = "māo,máo"; /* 貓 */
dict[0x8c94] = "pí"; /* 貔 */
dict[0x8c95] = "xī"; /* 貕 */
dict[0x8c96] = "yì"; /* 貖 */
dict[0x8c97] = "jù,lóu"; /* 貗 */
dict[0x8c98] = "mò"; /* 貘 */
dict[0x8c99] = "chū"; /* 貙 */
dict[0x8c9a] = "tán"; /* 貚 */
dict[0x8c9b] = "huān"; /* 貛 */
dict[0x8c9c] = "jué"; /* 貜 */
dict[0x8c9d] = "bèi"; /* 貝 */
dict[0x8c9e] = "zhēn"; /* 貞 */
dict[0x8c9f] = "yuán,yún,yùn"; /* 貟 */
dict[0x8ca0] = "fù"; /* 負 */
dict[0x8ca1] = "cái"; /* 財 */
dict[0x8ca2] = "gòng"; /* 貢 */
dict[0x8ca3] = "dài"; /* 貣 */
dict[0x8ca4] = "yì,yí"; /* 貤 */
dict[0x8ca5] = "háng"; /* 貥 */
dict[0x8ca6] = "wán"; /* 貦 */
dict[0x8ca7] = "pín"; /* 貧 */
dict[0x8ca8] = "huò"; /* 貨 */
dict[0x8ca9] = "fàn"; /* 販 */
dict[0x8caa] = "tān"; /* 貪 */
dict[0x8cab] = "guàn"; /* 貫 */
dict[0x8cac] = "zé,zhài"; /* 責 */
dict[0x8cad] = "zhì"; /* 貭 */
dict[0x8cae] = "èr"; /* 貮 */
dict[0x8caf] = "zhù"; /* 貯 */
dict[0x8cb0] = "shì"; /* 貰 */
dict[0x8cb1] = "bì"; /* 貱 */
dict[0x8cb2] = "zī"; /* 貲 */
dict[0x8cb3] = "èr"; /* 貳 */
dict[0x8cb4] = "guì"; /* 貴 */
dict[0x8cb5] = "piǎn"; /* 貵 */
dict[0x8cb6] = "biǎn"; /* 貶 */
dict[0x8cb7] = "mǎi"; /* 買 */
dict[0x8cb8] = "dài"; /* 貸 */
dict[0x8cb9] = "shèng"; /* 貹 */
dict[0x8cba] = "kuàng"; /* 貺 */
dict[0x8cbb] = "fèi"; /* 費 */
dict[0x8cbc] = "tiē"; /* 貼 */
dict[0x8cbd] = "yí"; /* 貽 */
dict[0x8cbe] = "chí"; /* 貾 */
dict[0x8cbf] = "mào"; /* 貿 */
dict[0x8cc0] = "hè"; /* 賀 */
dict[0x8cc1] = "bì,bēn"; /* 賁 */
dict[0x8cc2] = "lù"; /* 賂 */
dict[0x8cc3] = "lìn"; /* 賃 */
dict[0x8cc4] = "huì"; /* 賄 */
dict[0x8cc5] = "gāi"; /* 賅 */
dict[0x8cc6] = "pián"; /* 賆 */
dict[0x8cc7] = "zī"; /* 資 */
dict[0x8cc8] = "jiǎ,gǔ,jià"; /* 賈 */
dict[0x8cc9] = "xù"; /* 賉 */
dict[0x8cca] = "zéi"; /* 賊 */
dict[0x8ccb] = "jiǎo"; /* 賋 */
dict[0x8ccc] = "gāi"; /* 賌 */
dict[0x8ccd] = "zāng"; /* 賍 */
dict[0x8cce] = "jiàn"; /* 賎 */
dict[0x8ccf] = "yīng"; /* 賏 */
dict[0x8cd0] = "jùn"; /* 賐 */
dict[0x8cd1] = "zhèn"; /* 賑 */
dict[0x8cd2] = "shē"; /* 賒 */
dict[0x8cd3] = "bīn"; /* 賓 */
dict[0x8cd4] = "bīn"; /* 賔 */
dict[0x8cd5] = "qiú"; /* 賕 */
dict[0x8cd6] = "shē"; /* 賖 */
dict[0x8cd7] = "chuàn"; /* 賗 */
dict[0x8cd8] = "zāng"; /* 賘 */
dict[0x8cd9] = "zhōu"; /* 賙 */
dict[0x8cda] = "lài"; /* 賚 */
dict[0x8cdb] = "zàn"; /* 賛 */
dict[0x8cdc] = "cì"; /* 賜 */
dict[0x8cdd] = "chēn"; /* 賝 */
dict[0x8cde] = "shǎng"; /* 賞 */
dict[0x8cdf] = "tiǎn"; /* 賟 */
dict[0x8ce0] = "péi"; /* 賠 */
dict[0x8ce1] = "gēng"; /* 賡 */
dict[0x8ce2] = "xián"; /* 賢 */
dict[0x8ce3] = "mài"; /* 賣 */
dict[0x8ce4] = "jiàn"; /* 賤 */
dict[0x8ce5] = "suì"; /* 賥 */
dict[0x8ce6] = "fù"; /* 賦 */
dict[0x8ce7] = "dǎn"; /* 賧 */
dict[0x8ce8] = "cóng"; /* 賨 */
dict[0x8ce9] = "cóng"; /* 賩 */
dict[0x8cea] = "zhì"; /* 質 */
dict[0x8ceb] = "jī"; /* 賫 */
dict[0x8cec] = "zhàng"; /* 賬 */
dict[0x8ced] = "dǔ"; /* 賭 */
dict[0x8cee] = "jìn"; /* 賮 */
dict[0x8cef] = "xiōng,mín"; /* 賯 */
dict[0x8cf0] = "chǔn"; /* 賰 */
dict[0x8cf1] = "yǔn"; /* 賱 */
dict[0x8cf2] = "bǎo"; /* 賲 */
dict[0x8cf3] = "zāi"; /* 賳 */
dict[0x8cf4] = "lài"; /* 賴 */
dict[0x8cf5] = "fèng"; /* 賵 */
dict[0x8cf6] = "càng"; /* 賶 */
dict[0x8cf7] = "jī"; /* 賷 */
dict[0x8cf8] = "shèng"; /* 賸 */
dict[0x8cf9] = "ài"; /* 賹 */
dict[0x8cfa] = "zhuàn,zuàn"; /* 賺 */
dict[0x8cfb] = "fù"; /* 賻 */
dict[0x8cfc] = "gòu"; /* 購 */
dict[0x8cfd] = "sài"; /* 賽 */
dict[0x8cfe] = "zé"; /* 賾 */
dict[0x8cff] = "liáo"; /* 賿 */
dict[0x8d00] = "yì"; /* 贀 */
dict[0x8d01] = "bài"; /* 贁 */
dict[0x8d02] = "chěn"; /* 贂 */
dict[0x8d03] = "wàn,zhuàn"; /* 贃 */
dict[0x8d04] = "zhì"; /* 贄 */
dict[0x8d05] = "zhuì"; /* 贅 */
dict[0x8d06] = "biāo"; /* 贆 */
dict[0x8d07] = "yūn"; /* 贇 */
dict[0x8d08] = "zèng"; /* 贈 */
dict[0x8d09] = "dàn"; /* 贉 */
dict[0x8d0a] = "zàn"; /* 贊 */
dict[0x8d0b] = "yàn"; /* 贋 */
dict[0x8d0c] = "pú"; /* 贌 */
dict[0x8d0d] = "shàn"; /* 贍 */
dict[0x8d0e] = "wàn"; /* 贎 */
dict[0x8d0f] = "yíng"; /* 贏 */
dict[0x8d10] = "jìn"; /* 贐 */
dict[0x8d11] = "gàn"; /* 贑 */
dict[0x8d12] = "xián"; /* 贒 */
dict[0x8d13] = "zāng"; /* 贓 */
dict[0x8d14] = "bì"; /* 贔 */
dict[0x8d15] = "dú"; /* 贕 */
dict[0x8d16] = "shú"; /* 贖 */
dict[0x8d17] = "yàn"; /* 贗 */
dict[0x8d18] = "shǎng"; /* 贘 */
dict[0x8d19] = "xuàn"; /* 贙 */
dict[0x8d1a] = "lòng"; /* 贚 */
dict[0x8d1b] = "gàn"; /* 贛 */
dict[0x8d1c] = "zāng"; /* 贜 */
dict[0x8d1d] = "bèi"; /* 贝 */
dict[0x8d1e] = "zhēn"; /* 贞 */
dict[0x8d1f] = "fù"; /* 负 */
dict[0x8d20] = "yuán,yùn"; /* 贠 */
dict[0x8d21] = "gòng"; /* 贡 */
dict[0x8d22] = "cái"; /* 财 */
dict[0x8d23] = "zé,zhài"; /* 责 */
dict[0x8d24] = "xián"; /* 贤 */
dict[0x8d25] = "bài"; /* 败 */
dict[0x8d26] = "zhàng"; /* 账 */
dict[0x8d27] = "huò"; /* 货 */
dict[0x8d28] = "zhì"; /* 质 */
dict[0x8d29] = "fàn"; /* 贩 */
dict[0x8d2a] = "tān"; /* 贪 */
dict[0x8d2b] = "pín"; /* 贫 */
dict[0x8d2c] = "biǎn"; /* 贬 */
dict[0x8d2d] = "gòu"; /* 购 */
dict[0x8d2e] = "zhù"; /* 贮 */
dict[0x8d2f] = "guàn"; /* 贯 */
dict[0x8d30] = "èr"; /* 贰 */
dict[0x8d31] = "jiàn"; /* 贱 */
dict[0x8d32] = "bì,bēn"; /* 贲 */
dict[0x8d33] = "shì"; /* 贳 */
dict[0x8d34] = "tiē"; /* 贴 */
dict[0x8d35] = "guì"; /* 贵 */
dict[0x8d36] = "kuàng"; /* 贶 */
dict[0x8d37] = "dài"; /* 贷 */
dict[0x8d38] = "mào"; /* 贸 */
dict[0x8d39] = "fèi"; /* 费 */
dict[0x8d3a] = "hè"; /* 贺 */
dict[0x8d3b] = "yí"; /* 贻 */
dict[0x8d3c] = "zéi"; /* 贼 */
dict[0x8d3d] = "zhì"; /* 贽 */
dict[0x8d3e] = "jiǎ,gǔ"; /* 贾 */
dict[0x8d3f] = "huì"; /* 贿 */
dict[0x8d40] = "zī"; /* 赀 */
dict[0x8d41] = "lìn"; /* 赁 */
dict[0x8d42] = "lù"; /* 赂 */
dict[0x8d43] = "zāng"; /* 赃 */
dict[0x8d44] = "zī"; /* 资 */
dict[0x8d45] = "gāi"; /* 赅 */
dict[0x8d46] = "jìn"; /* 赆 */
dict[0x8d47] = "qiú"; /* 赇 */
dict[0x8d48] = "zhèn"; /* 赈 */
dict[0x8d49] = "lài"; /* 赉 */
dict[0x8d4a] = "shē"; /* 赊 */
dict[0x8d4b] = "fù"; /* 赋 */
dict[0x8d4c] = "dǔ"; /* 赌 */
dict[0x8d4d] = "jī"; /* 赍 */
dict[0x8d4e] = "shú"; /* 赎 */
dict[0x8d4f] = "shǎng"; /* 赏 */
dict[0x8d50] = "cì"; /* 赐 */
dict[0x8d51] = "bì"; /* 赑 */
dict[0x8d52] = "zhōu"; /* 赒 */
dict[0x8d53] = "gēng"; /* 赓 */
dict[0x8d54] = "péi"; /* 赔 */
dict[0x8d55] = "dǎn"; /* 赕 */
dict[0x8d56] = "lài"; /* 赖 */
dict[0x8d57] = "fèng"; /* 赗 */
dict[0x8d58] = "zhuì"; /* 赘 */
dict[0x8d59] = "fù"; /* 赙 */
dict[0x8d5a] = "zhuàn"; /* 赚 */
dict[0x8d5b] = "sài"; /* 赛 */
dict[0x8d5c] = "zé"; /* 赜 */
dict[0x8d5d] = "yàn"; /* 赝 */
dict[0x8d5e] = "zàn"; /* 赞 */
dict[0x8d5f] = "yūn"; /* 赟 */
dict[0x8d60] = "zèng"; /* 赠 */
dict[0x8d61] = "shàn"; /* 赡 */
dict[0x8d62] = "yíng"; /* 赢 */
dict[0x8d63] = "gàn"; /* 赣 */
dict[0x8d64] = "chì"; /* 赤 */
dict[0x8d65] = "xī"; /* 赥 */
dict[0x8d66] = "shè"; /* 赦 */
dict[0x8d67] = "nǎn"; /* 赧 */
dict[0x8d68] = "tóng"; /* 赨 */
dict[0x8d69] = "xì"; /* 赩 */
dict[0x8d6a] = "chēng"; /* 赪 */
dict[0x8d6b] = "hè"; /* 赫 */
dict[0x8d6c] = "chēng"; /* 赬 */
dict[0x8d6d] = "zhě"; /* 赭 */
dict[0x8d6e] = "xiá"; /* 赮 */
dict[0x8d6f] = "táng"; /* 赯 */
dict[0x8d70] = "zǒu"; /* 走 */
dict[0x8d71] = "zǒu"; /* 赱 */
dict[0x8d72] = "lì"; /* 赲 */
dict[0x8d73] = "jiū"; /* 赳 */
dict[0x8d74] = "fù"; /* 赴 */
dict[0x8d75] = "zhào"; /* 赵 */
dict[0x8d76] = "gǎn"; /* 赶 */
dict[0x8d77] = "qǐ"; /* 起 */
dict[0x8d78] = "shàn"; /* 赸 */
dict[0x8d79] = "qióng"; /* 赹 */
dict[0x8d7a] = "yǐn"; /* 赺 */
dict[0x8d7b] = "xiǎn"; /* 赻 */
dict[0x8d7c] = "zī"; /* 赼 */
dict[0x8d7d] = "jué"; /* 赽 */
dict[0x8d7e] = "qǐn"; /* 赾 */
dict[0x8d7f] = "chí"; /* 赿 */
dict[0x8d80] = "cī"; /* 趀 */
dict[0x8d81] = "chèn"; /* 趁 */
dict[0x8d82] = "chèn"; /* 趂 */
dict[0x8d83] = "dié,tú"; /* 趃 */
dict[0x8d84] = "qiè,jū"; /* 趄 */
dict[0x8d85] = "chāo"; /* 超 */
dict[0x8d86] = "dī"; /* 趆 */
dict[0x8d87] = "xì"; /* 趇 */
dict[0x8d88] = "zhān"; /* 趈 */
dict[0x8d89] = "jué"; /* 趉 */
dict[0x8d8a] = "yuè"; /* 越 */
dict[0x8d8b] = "qū,cù"; /* 趋 */
dict[0x8d8c] = "jí,jié"; /* 趌 */
dict[0x8d8d] = "qū"; /* 趍 */
dict[0x8d8e] = "chú"; /* 趎 */
dict[0x8d8f] = "guā,huó"; /* 趏 */
dict[0x8d90] = "xuè"; /* 趐 */
dict[0x8d91] = "zī"; /* 趑 */
dict[0x8d92] = "tiào"; /* 趒 */
dict[0x8d93] = "duǒ"; /* 趓 */
dict[0x8d94] = "liè"; /* 趔 */
dict[0x8d95] = "gǎn"; /* 趕 */
dict[0x8d96] = "suō"; /* 趖 */
dict[0x8d97] = "cù"; /* 趗 */
dict[0x8d98] = "xí"; /* 趘 */
dict[0x8d99] = "zhào"; /* 趙 */
dict[0x8d9a] = "sù"; /* 趚 */
dict[0x8d9b] = "yǐn"; /* 趛 */
dict[0x8d9c] = "jú"; /* 趜 */
dict[0x8d9d] = "jiàn"; /* 趝 */
dict[0x8d9e] = "què,qì,jí"; /* 趞 */
dict[0x8d9f] = "tàng,tāng"; /* 趟 */
dict[0x8da0] = "chuō,zhuó"; /* 趠 */
dict[0x8da1] = "cuǐ"; /* 趡 */
dict[0x8da2] = "lù"; /* 趢 */
dict[0x8da3] = "qù,cù"; /* 趣 */
dict[0x8da4] = "dàng"; /* 趤 */
dict[0x8da5] = "qiū"; /* 趥 */
dict[0x8da6] = "zī"; /* 趦 */
dict[0x8da7] = "tí"; /* 趧 */
dict[0x8da8] = "qū,cù"; /* 趨 */
dict[0x8da9] = "chì"; /* 趩 */
dict[0x8daa] = "huáng"; /* 趪 */
dict[0x8dab] = "qiáo"; /* 趫 */
dict[0x8dac] = "qiāo"; /* 趬 */
dict[0x8dad] = "jiào"; /* 趭 */
dict[0x8dae] = "zào"; /* 趮 */
dict[0x8daf] = "tì,yuè"; /* 趯 */
dict[0x8db0] = "ěr"; /* 趰 */
dict[0x8db1] = "zǎn"; /* 趱 */
dict[0x8db2] = "zǎn"; /* 趲 */
dict[0x8db3] = "zú"; /* 足 */
dict[0x8db4] = "pā"; /* 趴 */
dict[0x8db5] = "bào,bō"; /* 趵 */
dict[0x8db6] = "kuà,wù"; /* 趶 */
dict[0x8db7] = "kē"; /* 趷 */
dict[0x8db8] = "dǔn"; /* 趸 */
dict[0x8db9] = "jué,guì"; /* 趹 */
dict[0x8dba] = "fū"; /* 趺 */
dict[0x8dbb] = "chěn"; /* 趻 */
dict[0x8dbc] = "jiǎn"; /* 趼 */
dict[0x8dbd] = "fāng,fàng,páng"; /* 趽 */
dict[0x8dbe] = "zhǐ"; /* 趾 */
dict[0x8dbf] = "tā"; /* 趿 */
dict[0x8dc0] = "yuè"; /* 跀 */
dict[0x8dc1] = "bà,páo"; /* 跁 */
dict[0x8dc2] = "qí,qǐ"; /* 跂 */
dict[0x8dc3] = "yuè"; /* 跃 */
dict[0x8dc4] = "qiāng,qiàng"; /* 跄 */
dict[0x8dc5] = "tuò"; /* 跅 */
dict[0x8dc6] = "tái"; /* 跆 */
dict[0x8dc7] = "yì"; /* 跇 */
dict[0x8dc8] = "jiàn,chén"; /* 跈 */
dict[0x8dc9] = "líng"; /* 跉 */
dict[0x8dca] = "mèi"; /* 跊 */
dict[0x8dcb] = "bá"; /* 跋 */
dict[0x8dcc] = "diē"; /* 跌 */
dict[0x8dcd] = "kū"; /* 跍 */
dict[0x8dce] = "tuó"; /* 跎 */
dict[0x8dcf] = "jiā"; /* 跏 */
dict[0x8dd0] = "cī,cǐ"; /* 跐 */
dict[0x8dd1] = "pǎo,páo"; /* 跑 */
dict[0x8dd2] = "qiǎ"; /* 跒 */
dict[0x8dd3] = "zhù"; /* 跓 */
dict[0x8dd4] = "jū"; /* 跔 */
dict[0x8dd5] = "diǎn,tiē,dié"; /* 跕 */
dict[0x8dd6] = "zhí"; /* 跖 */
dict[0x8dd7] = "fū"; /* 跗 */
dict[0x8dd8] = "pán,bàn"; /* 跘 */
dict[0x8dd9] = "jū,jù,qiè"; /* 跙 */
dict[0x8dda] = "shān"; /* 跚 */
dict[0x8ddb] = "bǒ"; /* 跛 */
dict[0x8ddc] = "ní"; /* 跜 */
dict[0x8ddd] = "jù"; /* 距 */
dict[0x8dde] = "lì,luò"; /* 跞 */
dict[0x8ddf] = "gēn"; /* 跟 */
dict[0x8de0] = "yí"; /* 跠 */
dict[0x8de1] = "jì"; /* 跡 */
dict[0x8de2] = "dài,duò,duō,chí"; /* 跢 */
dict[0x8de3] = "xiǎn"; /* 跣 */
dict[0x8de4] = "jiāo"; /* 跤 */
dict[0x8de5] = "duò"; /* 跥 */
dict[0x8de6] = "zhū"; /* 跦 */
dict[0x8de7] = "quán"; /* 跧 */
dict[0x8de8] = "kuà"; /* 跨 */
dict[0x8de9] = "zhuǎi"; /* 跩 */
dict[0x8dea] = "guì"; /* 跪 */
dict[0x8deb] = "qióng"; /* 跫 */
dict[0x8dec] = "kuǐ"; /* 跬 */
dict[0x8ded] = "xiáng"; /* 跭 */
dict[0x8dee] = "dié"; /* 跮 */
dict[0x8def] = "lù"; /* 路 */
dict[0x8df0] = "pián,bèng"; /* 跰 */
dict[0x8df1] = "zhì"; /* 跱 */
dict[0x8df2] = "jié"; /* 跲 */
dict[0x8df3] = "tiào,táo"; /* 跳 */
dict[0x8df4] = "cǎi"; /* 跴 */
dict[0x8df5] = "jiàn"; /* 践 */
dict[0x8df6] = "dá"; /* 跶 */
dict[0x8df7] = "qiāo"; /* 跷 */
dict[0x8df8] = "bì"; /* 跸 */
dict[0x8df9] = "xiān"; /* 跹 */
dict[0x8dfa] = "duò"; /* 跺 */
dict[0x8dfb] = "jī"; /* 跻 */
dict[0x8dfc] = "jú"; /* 跼 */
dict[0x8dfd] = "jì"; /* 跽 */
dict[0x8dfe] = "shū,chōu"; /* 跾 */
dict[0x8dff] = "tú"; /* 跿 */
dict[0x8e00] = "chuò"; /* 踀 */
dict[0x8e01] = "jìng"; /* 踁 */
dict[0x8e02] = "niè"; /* 踂 */
dict[0x8e03] = "xiāo"; /* 踃 */
dict[0x8e04] = "bù"; /* 踄 */
dict[0x8e05] = "xué"; /* 踅 */
dict[0x8e06] = "cūn"; /* 踆 */
dict[0x8e07] = "mǔ"; /* 踇 */
dict[0x8e08] = "shū"; /* 踈 */
dict[0x8e09] = "liáng,liàng"; /* 踉 */
dict[0x8e0a] = "yǒng"; /* 踊 */
dict[0x8e0b] = "jiǎo"; /* 踋 */
dict[0x8e0c] = "chóu"; /* 踌 */
dict[0x8e0d] = "qiāo"; /* 踍 */
dict[0x8e0e] = "móu"; /* 踎 */
dict[0x8e0f] = "tà"; /* 踏 */
dict[0x8e10] = "jiàn"; /* 踐 */
dict[0x8e11] = "jī"; /* 踑 */
dict[0x8e12] = "wō"; /* 踒 */
dict[0x8e13] = "wěi"; /* 踓 */
dict[0x8e14] = "chuō"; /* 踔 */
dict[0x8e15] = "jié"; /* 踕 */
dict[0x8e16] = "jí"; /* 踖 */
dict[0x8e17] = "niè"; /* 踗 */
dict[0x8e18] = "jū"; /* 踘 */
dict[0x8e19] = "niè"; /* 踙 */
dict[0x8e1a] = "lún"; /* 踚 */
dict[0x8e1b] = "lù"; /* 踛 */
dict[0x8e1c] = "lèng"; /* 踜 */
dict[0x8e1d] = "huái"; /* 踝 */
dict[0x8e1e] = "jù"; /* 踞 */
dict[0x8e1f] = "chí"; /* 踟 */
dict[0x8e20] = "wǎn"; /* 踠 */
dict[0x8e21] = "quán"; /* 踡 */
dict[0x8e22] = "tī"; /* 踢 */
dict[0x8e23] = "bó"; /* 踣 */
dict[0x8e24] = "zú"; /* 踤 */
dict[0x8e25] = "qiè"; /* 踥 */
dict[0x8e26] = "qī"; /* 踦 */
dict[0x8e27] = "cù"; /* 踧 */
dict[0x8e28] = "zōng"; /* 踨 */
dict[0x8e29] = "cǎi"; /* 踩 */
dict[0x8e2a] = "zōng"; /* 踪 */
dict[0x8e2b] = "pèng"; /* 踫 */
dict[0x8e2c] = "zhì"; /* 踬 */
dict[0x8e2d] = "zhēng"; /* 踭 */
dict[0x8e2e] = "diǎn"; /* 踮 */
dict[0x8e2f] = "zhí"; /* 踯 */
dict[0x8e30] = "yú"; /* 踰 */
dict[0x8e31] = "duó"; /* 踱 */
dict[0x8e32] = "dùn"; /* 踲 */
dict[0x8e33] = "chuǎn"; /* 踳 */
dict[0x8e34] = "yǒng"; /* 踴 */
dict[0x8e35] = "zhǒng"; /* 踵 */
dict[0x8e36] = "dì"; /* 踶 */
dict[0x8e37] = "zhě"; /* 踷 */
dict[0x8e38] = "chěn"; /* 踸 */
dict[0x8e39] = "chuài"; /* 踹 */
dict[0x8e3a] = "jiàn"; /* 踺 */
dict[0x8e3b] = "guā"; /* 踻 */
dict[0x8e3c] = "táng"; /* 踼 */
dict[0x8e3d] = "jǔ"; /* 踽 */
dict[0x8e3e] = "fú"; /* 踾 */
dict[0x8e3f] = "cù"; /* 踿 */
dict[0x8e40] = "dié"; /* 蹀 */
dict[0x8e41] = "pián"; /* 蹁 */
dict[0x8e42] = "róu"; /* 蹂 */
dict[0x8e43] = "nuò"; /* 蹃 */
dict[0x8e44] = "tí"; /* 蹄 */
dict[0x8e45] = "chǎ"; /* 蹅 */
dict[0x8e46] = "tuǐ"; /* 蹆 */
dict[0x8e47] = "jiǎn"; /* 蹇 */
dict[0x8e48] = "dǎo"; /* 蹈 */
dict[0x8e49] = "cuō"; /* 蹉 */
dict[0x8e4a] = "qī,xī"; /* 蹊 */
dict[0x8e4b] = "tà"; /* 蹋 */
dict[0x8e4c] = "qiāng"; /* 蹌 */
dict[0x8e4d] = "niǎn"; /* 蹍 */
dict[0x8e4e] = "diān"; /* 蹎 */
dict[0x8e4f] = "tí"; /* 蹏 */
dict[0x8e50] = "jí"; /* 蹐 */
dict[0x8e51] = "niè"; /* 蹑 */
dict[0x8e52] = "pán"; /* 蹒 */
dict[0x8e53] = "liū"; /* 蹓 */
dict[0x8e54] = "zàn"; /* 蹔 */
dict[0x8e55] = "bì"; /* 蹕 */
dict[0x8e56] = "chōng"; /* 蹖 */
dict[0x8e57] = "lù"; /* 蹗 */
dict[0x8e58] = "liáo"; /* 蹘 */
dict[0x8e59] = "cù"; /* 蹙 */
dict[0x8e5a] = "tāng"; /* 蹚 */
dict[0x8e5b] = "dài"; /* 蹛 */
dict[0x8e5c] = "sù"; /* 蹜 */
dict[0x8e5d] = "xǐ"; /* 蹝 */
dict[0x8e5e] = "kuǐ"; /* 蹞 */
dict[0x8e5f] = "jì"; /* 蹟 */
dict[0x8e60] = "zhí"; /* 蹠 */
dict[0x8e61] = "qiāng"; /* 蹡 */
dict[0x8e62] = "dí"; /* 蹢 */
dict[0x8e63] = "pán"; /* 蹣 */
dict[0x8e64] = "zōng"; /* 蹤 */
dict[0x8e65] = "lián"; /* 蹥 */
dict[0x8e66] = "bèng"; /* 蹦 */
dict[0x8e67] = "zāo"; /* 蹧 */
dict[0x8e68] = "niǎn"; /* 蹨 */
dict[0x8e69] = "bié"; /* 蹩 */
dict[0x8e6a] = "tuí"; /* 蹪 */
dict[0x8e6b] = "jú"; /* 蹫 */
dict[0x8e6c] = "dēng"; /* 蹬 */
dict[0x8e6d] = "cèng"; /* 蹭 */
dict[0x8e6e] = "xiān"; /* 蹮 */
dict[0x8e6f] = "fán"; /* 蹯 */
dict[0x8e70] = "chú"; /* 蹰 */
dict[0x8e71] = "zhōng"; /* 蹱 */
dict[0x8e72] = "dūn"; /* 蹲 */
dict[0x8e73] = "bō"; /* 蹳 */
dict[0x8e74] = "cù"; /* 蹴 */
dict[0x8e75] = "cù"; /* 蹵 */
dict[0x8e76] = "jué,juě"; /* 蹶 */
dict[0x8e77] = "jué"; /* 蹷 */
dict[0x8e78] = "lìn"; /* 蹸 */
dict[0x8e79] = "tà"; /* 蹹 */
dict[0x8e7a] = "qiāo"; /* 蹺 */
dict[0x8e7b] = "qiāo"; /* 蹻 */
dict[0x8e7c] = "pǔ"; /* 蹼 */
dict[0x8e7d] = "liāo"; /* 蹽 */
dict[0x8e7e] = "dūn"; /* 蹾 */
dict[0x8e7f] = "cuān"; /* 蹿 */
dict[0x8e80] = "guàn"; /* 躀 */
dict[0x8e81] = "zào"; /* 躁 */
dict[0x8e82] = "tà"; /* 躂 */
dict[0x8e83] = "bì"; /* 躃 */
dict[0x8e84] = "bì"; /* 躄 */
dict[0x8e85] = "zhú"; /* 躅 */
dict[0x8e86] = "jù"; /* 躆 */
dict[0x8e87] = "chú"; /* 躇 */
dict[0x8e88] = "qiào"; /* 躈 */
dict[0x8e89] = "dǔn"; /* 躉 */
dict[0x8e8a] = "chóu"; /* 躊 */
dict[0x8e8b] = "jī"; /* 躋 */
dict[0x8e8c] = "wǔ"; /* 躌 */
dict[0x8e8d] = "yuè"; /* 躍 */
dict[0x8e8e] = "niǎn"; /* 躎 */
dict[0x8e8f] = "lìn"; /* 躏 */
dict[0x8e90] = "liè"; /* 躐 */
dict[0x8e91] = "zhí"; /* 躑 */
dict[0x8e92] = "lì,luò"; /* 躒 */
dict[0x8e93] = "zhì"; /* 躓 */
dict[0x8e94] = "chán"; /* 躔 */
dict[0x8e95] = "chú"; /* 躕 */
dict[0x8e96] = "duàn"; /* 躖 */
dict[0x8e97] = "wèi"; /* 躗 */
dict[0x8e98] = "lóng,lǒng"; /* 躘 */
dict[0x8e99] = "lìn"; /* 躙 */
dict[0x8e9a] = "xiān"; /* 躚 */
dict[0x8e9b] = "wèi"; /* 躛 */
dict[0x8e9c] = "zuān"; /* 躜 */
dict[0x8e9d] = "lán"; /* 躝 */
dict[0x8e9e] = "xiè"; /* 躞 */
dict[0x8e9f] = "ráng"; /* 躟 */
dict[0x8ea0] = "sǎ,xiè"; /* 躠 */
dict[0x8ea1] = "niè"; /* 躡 */
dict[0x8ea2] = "tà"; /* 躢 */
dict[0x8ea3] = "qú"; /* 躣 */
dict[0x8ea4] = "jí"; /* 躤 */
dict[0x8ea5] = "cuān"; /* 躥 */
dict[0x8ea6] = "zuān"; /* 躦 */
dict[0x8ea7] = "xǐ"; /* 躧 */
dict[0x8ea8] = "kuí"; /* 躨 */
dict[0x8ea9] = "jué"; /* 躩 */
dict[0x8eaa] = "lìn"; /* 躪 */
dict[0x8eab] = "shēn"; /* 身 */
dict[0x8eac] = "gōng"; /* 躬 */
dict[0x8ead] = "dān"; /* 躭 */
dict[0x8eae] = "fēn"; /* 躮 */
dict[0x8eaf] = "qū"; /* 躯 */
dict[0x8eb0] = "tǐ"; /* 躰 */
dict[0x8eb1] = "duǒ"; /* 躱 */
dict[0x8eb2] = "duǒ"; /* 躲 */
dict[0x8eb3] = "gōng"; /* 躳 */
dict[0x8eb4] = "láng"; /* 躴 */
dict[0x8eb5] = "rěn"; /* 躵 */
dict[0x8eb6] = "luǒ"; /* 躶 */
dict[0x8eb7] = "ǎi"; /* 躷 */
dict[0x8eb8] = "jī"; /* 躸 */
dict[0x8eb9] = "jū"; /* 躹 */
dict[0x8eba] = "tǎng"; /* 躺 */
dict[0x8ebb] = "kōng"; /* 躻 */
dict[0x8ebc] = "lào"; /* 躼 */
dict[0x8ebd] = "yǎn"; /* 躽 */
dict[0x8ebe] = "měi"; /* 躾 */
dict[0x8ebf] = "kāng"; /* 躿 */
dict[0x8ec0] = "qū"; /* 軀 */
dict[0x8ec1] = "lóu"; /* 軁 */
dict[0x8ec2] = "lào"; /* 軂 */
dict[0x8ec3] = "duǒ"; /* 軃 */
dict[0x8ec4] = "zhí"; /* 軄 */
dict[0x8ec5] = "yàn"; /* 軅 */
dict[0x8ec6] = "tǐ"; /* 軆 */
dict[0x8ec7] = "dào"; /* 軇 */
dict[0x8ec8] = "yīng"; /* 軈 */
dict[0x8ec9] = "yù"; /* 軉 */
dict[0x8eca] = "chē,jū"; /* 車 */
dict[0x8ecb] = "yà,zhá,gá"; /* 軋 */
dict[0x8ecc] = "guǐ"; /* 軌 */
dict[0x8ecd] = "jūn"; /* 軍 */
dict[0x8ece] = "wèi"; /* 軎 */
dict[0x8ecf] = "yuè"; /* 軏 */
dict[0x8ed0] = "xìn,xiàn"; /* 軐 */
dict[0x8ed1] = "dài"; /* 軑 */
dict[0x8ed2] = "xuān"; /* 軒 */
dict[0x8ed3] = "fàn,guǐ"; /* 軓 */
dict[0x8ed4] = "rèn"; /* 軔 */
dict[0x8ed5] = "shān"; /* 軕 */
dict[0x8ed6] = "kuáng"; /* 軖 */
dict[0x8ed7] = "shū"; /* 軗 */
dict[0x8ed8] = "tún"; /* 軘 */
dict[0x8ed9] = "chén"; /* 軙 */
dict[0x8eda] = "dài"; /* 軚 */
dict[0x8edb] = "è"; /* 軛 */
dict[0x8edc] = "nà"; /* 軜 */
dict[0x8edd] = "qí"; /* 軝 */
dict[0x8ede] = "máo"; /* 軞 */
dict[0x8edf] = "ruǎn"; /* 軟 */
dict[0x8ee0] = "kuáng"; /* 軠 */
dict[0x8ee1] = "qián"; /* 軡 */
dict[0x8ee2] = "zhuàn,zhuǎn"; /* 転 */
dict[0x8ee3] = "hōng"; /* 軣 */
dict[0x8ee4] = "hū"; /* 軤 */
dict[0x8ee5] = "qú"; /* 軥 */
dict[0x8ee6] = "kuàng"; /* 軦 */
dict[0x8ee7] = "dǐ"; /* 軧 */
dict[0x8ee8] = "líng"; /* 軨 */
dict[0x8ee9] = "dài"; /* 軩 */
dict[0x8eea] = "āo,ào"; /* 軪 */
dict[0x8eeb] = "zhěn"; /* 軫 */
dict[0x8eec] = "fàn"; /* 軬 */
dict[0x8eed] = "kuāng"; /* 軭 */
dict[0x8eee] = "yǎng"; /* 軮 */
dict[0x8eef] = "pēng"; /* 軯 */
dict[0x8ef0] = "bèi"; /* 軰 */
dict[0x8ef1] = "gū"; /* 軱 */
dict[0x8ef2] = "gū"; /* 軲 */
dict[0x8ef3] = "páo"; /* 軳 */
dict[0x8ef4] = "zhù"; /* 軴 */
dict[0x8ef5] = "rǒng"; /* 軵 */
dict[0x8ef6] = "è"; /* 軶 */
dict[0x8ef7] = "bá"; /* 軷 */
dict[0x8ef8] = "zhóu,zhòu"; /* 軸 */
dict[0x8ef9] = "zhǐ"; /* 軹 */
dict[0x8efa] = "yáo"; /* 軺 */
dict[0x8efb] = "kē,kě"; /* 軻 */
dict[0x8efc] = "yì,dié"; /* 軼 */
dict[0x8efd] = "qīng"; /* 軽 */
dict[0x8efe] = "shì"; /* 軾 */
dict[0x8eff] = "píng"; /* 軿 */
dict[0x8f00] = "ér"; /* 輀 */
dict[0x8f01] = "gǒng"; /* 輁 */
dict[0x8f02] = "jú"; /* 輂 */
dict[0x8f03] = "jiào"; /* 較 */
dict[0x8f04] = "guāng"; /* 輄 */
dict[0x8f05] = "lù"; /* 輅 */
dict[0x8f06] = "kǎi"; /* 輆 */
dict[0x8f07] = "quán"; /* 輇 */
dict[0x8f08] = "zhōu"; /* 輈 */
dict[0x8f09] = "zài"; /* 載 */
dict[0x8f0a] = "zhì"; /* 輊 */
dict[0x8f0b] = "shē"; /* 輋 */
dict[0x8f0c] = "liàng"; /* 輌 */
dict[0x8f0d] = "yù"; /* 輍 */
dict[0x8f0e] = "shāo"; /* 輎 */
dict[0x8f0f] = "yóu"; /* 輏 */
dict[0x8f10] = "wàn"; /* 輐 */
dict[0x8f11] = "yǐn"; /* 輑 */
dict[0x8f12] = "zhé"; /* 輒 */
dict[0x8f13] = "wǎn"; /* 輓 */
dict[0x8f14] = "fǔ"; /* 輔 */
dict[0x8f15] = "qīng"; /* 輕 */
dict[0x8f16] = "zhōu"; /* 輖 */
dict[0x8f17] = "ní"; /* 輗 */
dict[0x8f18] = "líng"; /* 輘 */
dict[0x8f19] = "zhé"; /* 輙 */
dict[0x8f1a] = "hàn"; /* 輚 */
dict[0x8f1b] = "liàng"; /* 輛 */
dict[0x8f1c] = "zī"; /* 輜 */
dict[0x8f1d] = "huī"; /* 輝 */
dict[0x8f1e] = "wǎng"; /* 輞 */
dict[0x8f1f] = "chuò"; /* 輟 */
dict[0x8f20] = "guǒ"; /* 輠 */
dict[0x8f21] = "kǎn"; /* 輡 */
dict[0x8f22] = "yǐ"; /* 輢 */
dict[0x8f23] = "péng"; /* 輣 */
dict[0x8f24] = "qiàn"; /* 輤 */
dict[0x8f25] = "gǔn"; /* 輥 */
dict[0x8f26] = "niǎn"; /* 輦 */
dict[0x8f27] = "píng"; /* 輧 */
dict[0x8f28] = "guǎn"; /* 輨 */
dict[0x8f29] = "bèi"; /* 輩 */
dict[0x8f2a] = "lún"; /* 輪 */
dict[0x8f2b] = "pái"; /* 輫 */
dict[0x8f2c] = "liáng"; /* 輬 */
dict[0x8f2d] = "ruǎn"; /* 輭 */
dict[0x8f2e] = "róu"; /* 輮 */
dict[0x8f2f] = "jí"; /* 輯 */
dict[0x8f30] = "yáng"; /* 輰 */
dict[0x8f31] = "xián"; /* 輱 */
dict[0x8f32] = "chuán"; /* 輲 */
dict[0x8f33] = "còu"; /* 輳 */
dict[0x8f34] = "chūn"; /* 輴 */
dict[0x8f35] = "gé"; /* 輵 */
dict[0x8f36] = "yóu"; /* 輶 */
dict[0x8f37] = "hōng"; /* 輷 */
dict[0x8f38] = "shū"; /* 輸 */
dict[0x8f39] = "fù"; /* 輹 */
dict[0x8f3a] = "zī"; /* 輺 */
dict[0x8f3b] = "fú"; /* 輻 */
dict[0x8f3c] = "wēn"; /* 輼 */
dict[0x8f3d] = "fàn"; /* 輽 */
dict[0x8f3e] = "zhǎn"; /* 輾 */
dict[0x8f3f] = "yú"; /* 輿 */
dict[0x8f40] = "wēn"; /* 轀 */
dict[0x8f41] = "tāo"; /* 轁 */
dict[0x8f42] = "gǔ"; /* 轂 */
dict[0x8f43] = "zhēn"; /* 轃 */
dict[0x8f44] = "xiá"; /* 轄 */
dict[0x8f45] = "yuán"; /* 轅 */
dict[0x8f46] = "lù"; /* 轆 */
dict[0x8f47] = "jiāo"; /* 轇 */
dict[0x8f48] = "cháo"; /* 轈 */
dict[0x8f49] = "zhuǎn"; /* 轉 */
dict[0x8f4a] = "wèi"; /* 轊 */
dict[0x8f4b] = "hūn"; /* 轋 */
dict[0x8f4c] = "xuě"; /* 轌 */
dict[0x8f4d] = "zhé"; /* 轍 */
dict[0x8f4e] = "jiào"; /* 轎 */
dict[0x8f4f] = "zhàn"; /* 轏 */
dict[0x8f50] = "bú"; /* 轐 */
dict[0x8f51] = "lǎo"; /* 轑 */
dict[0x8f52] = "fén"; /* 轒 */
dict[0x8f53] = "fān"; /* 轓 */
dict[0x8f54] = "lín"; /* 轔 */
dict[0x8f55] = "gé"; /* 轕 */
dict[0x8f56] = "sè"; /* 轖 */
dict[0x8f57] = "kǎn"; /* 轗 */
dict[0x8f58] = "huàn"; /* 轘 */
dict[0x8f59] = "yǐ"; /* 轙 */
dict[0x8f5a] = "jí"; /* 轚 */
dict[0x8f5b] = "duì"; /* 轛 */
dict[0x8f5c] = "ér"; /* 轜 */
dict[0x8f5d] = "yú"; /* 轝 */
dict[0x8f5e] = "jiàn"; /* 轞 */
dict[0x8f5f] = "hōng"; /* 轟 */
dict[0x8f60] = "léi"; /* 轠 */
dict[0x8f61] = "pèi"; /* 轡 */
dict[0x8f62] = "lì"; /* 轢 */
dict[0x8f63] = "lì"; /* 轣 */
dict[0x8f64] = "lú"; /* 轤 */
dict[0x8f65] = "lìn"; /* 轥 */
dict[0x8f66] = "chē,jū"; /* 车 */
dict[0x8f67] = "yà"; /* 轧 */
dict[0x8f68] = "guǐ"; /* 轨 */
dict[0x8f69] = "xuān"; /* 轩 */
dict[0x8f6a] = "dài"; /* 轪 */
dict[0x8f6b] = "rèn"; /* 轫 */
dict[0x8f6c] = "zhuǎn,zhuàn,zhuǎi"; /* 转 */
dict[0x8f6d] = "è"; /* 轭 */
dict[0x8f6e] = "lún"; /* 轮 */
dict[0x8f6f] = "ruǎn"; /* 软 */
dict[0x8f70] = "hōng"; /* 轰 */
dict[0x8f71] = "gū"; /* 轱 */
dict[0x8f72] = "kē"; /* 轲 */
dict[0x8f73] = "lú"; /* 轳 */
dict[0x8f74] = "zhóu,zhòu"; /* 轴 */
dict[0x8f75] = "zhǐ"; /* 轵 */
dict[0x8f76] = "yì"; /* 轶 */
dict[0x8f77] = "hū"; /* 轷 */
dict[0x8f78] = "zhěn"; /* 轸 */
dict[0x8f79] = "lì"; /* 轹 */
dict[0x8f7a] = "yáo"; /* 轺 */
dict[0x8f7b] = "qīng"; /* 轻 */
dict[0x8f7c] = "shì"; /* 轼 */
dict[0x8f7d] = "zǎi,zài"; /* 载 */
dict[0x8f7e] = "zhì"; /* 轾 */
dict[0x8f7f] = "jiào"; /* 轿 */
dict[0x8f80] = "zhōu"; /* 辀 */
dict[0x8f81] = "quán"; /* 辁 */
dict[0x8f82] = "lù"; /* 辂 */
dict[0x8f83] = "jiào"; /* 较 */
dict[0x8f84] = "zhé"; /* 辄 */
dict[0x8f85] = "fǔ"; /* 辅 */
dict[0x8f86] = "liàng"; /* 辆 */
dict[0x8f87] = "niǎn"; /* 辇 */
dict[0x8f88] = "bèi"; /* 辈 */
dict[0x8f89] = "huī"; /* 辉 */
dict[0x8f8a] = "gǔn"; /* 辊 */
dict[0x8f8b] = "wǎng"; /* 辋 */
dict[0x8f8c] = "liáng"; /* 辌 */
dict[0x8f8d] = "chuò"; /* 辍 */
dict[0x8f8e] = "zī"; /* 辎 */
dict[0x8f8f] = "còu"; /* 辏 */
dict[0x8f90] = "fú"; /* 辐 */
dict[0x8f91] = "jí"; /* 辑 */
dict[0x8f92] = "wēn"; /* 辒 */
dict[0x8f93] = "shū"; /* 输 */
dict[0x8f94] = "pèi"; /* 辔 */
dict[0x8f95] = "yuán"; /* 辕 */
dict[0x8f96] = "xiá"; /* 辖 */
dict[0x8f97] = "zhǎn,niǎn"; /* 辗 */
dict[0x8f98] = "lù"; /* 辘 */
dict[0x8f99] = "zhé"; /* 辙 */
dict[0x8f9a] = "lín"; /* 辚 */
dict[0x8f9b] = "xīn"; /* 辛 */
dict[0x8f9c] = "gū"; /* 辜 */
dict[0x8f9d] = "cí"; /* 辝 */
dict[0x8f9e] = "cí"; /* 辞 */
dict[0x8f9f] = "bì,pì"; /* 辟 */
dict[0x8fa0] = "zuì"; /* 辠 */
dict[0x8fa1] = "biàn"; /* 辡 */
dict[0x8fa2] = "là"; /* 辢 */
dict[0x8fa3] = "là"; /* 辣 */
dict[0x8fa4] = "cí"; /* 辤 */
dict[0x8fa5] = "xuē"; /* 辥 */
dict[0x8fa6] = "bàn"; /* 辦 */
dict[0x8fa7] = "biàn"; /* 辧 */
dict[0x8fa8] = "biàn"; /* 辨 */
dict[0x8fa9] = "biàn"; /* 辩 */
dict[0x8faa] = "xuē"; /* 辪 */
dict[0x8fab] = "biàn"; /* 辫 */
dict[0x8fac] = "bān"; /* 辬 */
dict[0x8fad] = "cí"; /* 辭 */
dict[0x8fae] = "biàn"; /* 辮 */
dict[0x8faf] = "biàn"; /* 辯 */
dict[0x8fb0] = "chén"; /* 辰 */
dict[0x8fb1] = "rǔ"; /* 辱 */
dict[0x8fb2] = "nóng"; /* 農 */
dict[0x8fb3] = "nóng"; /* 辳 */
dict[0x8fb4] = "zhěn"; /* 辴 */
dict[0x8fb5] = "chuò"; /* 辵 */
dict[0x8fb6] = "chuò"; /* 辶 */
dict[0x8fb7] = "yī"; /* 辷 */
dict[0x8fb8] = "réng"; /* 辸 */
dict[0x8fb9] = "biān"; /* 边 */
dict[0x8fba] = "dào,biān"; /* 辺 */
dict[0x8fbb] = "shi"; /* 辻 */
dict[0x8fbc] = "yū"; /* 込 */
dict[0x8fbd] = "liáo"; /* 辽 */
dict[0x8fbe] = "dá"; /* 达 */
dict[0x8fbf] = "chān"; /* 辿 */
dict[0x8fc0] = "gān"; /* 迀 */
dict[0x8fc1] = "qiān"; /* 迁 */
dict[0x8fc2] = "yū"; /* 迂 */
dict[0x8fc3] = "yū"; /* 迃 */
dict[0x8fc4] = "qì"; /* 迄 */
dict[0x8fc5] = "xùn"; /* 迅 */
dict[0x8fc6] = "yǐ,yí"; /* 迆 */
dict[0x8fc7] = "guò,guo,guō"; /* 过 */
dict[0x8fc8] = "mài"; /* 迈 */
dict[0x8fc9] = "qī"; /* 迉 */
dict[0x8fca] = "zā"; /* 迊 */
dict[0x8fcb] = "wàng,kuāng"; /* 迋 */
dict[0x8fcc] = "tù"; /* 迌 */
dict[0x8fcd] = "zhūn"; /* 迍 */
dict[0x8fce] = "yíng"; /* 迎 */
dict[0x8fcf] = "dá"; /* 迏 */
dict[0x8fd0] = "yùn"; /* 运 */
dict[0x8fd1] = "jìn"; /* 近 */
dict[0x8fd2] = "háng"; /* 迒 */
dict[0x8fd3] = "yà"; /* 迓 */
dict[0x8fd4] = "fǎn"; /* 返 */
dict[0x8fd5] = "wǔ"; /* 迕 */
dict[0x8fd6] = "dá"; /* 迖 */
dict[0x8fd7] = "é"; /* 迗 */
dict[0x8fd8] = "huán,hái"; /* 还 */
dict[0x8fd9] = "zhè,zhèi"; /* 这 */
dict[0x8fda] = "dá"; /* 迚 */
dict[0x8fdb] = "jìn"; /* 进 */
dict[0x8fdc] = "yuǎn,yuàn"; /* 远 */
dict[0x8fdd] = "wéi"; /* 违 */
dict[0x8fde] = "lián"; /* 连 */
dict[0x8fdf] = "chí"; /* 迟 */
dict[0x8fe0] = "chè"; /* 迠 */
dict[0x8fe1] = "chí"; /* 迡 */
dict[0x8fe2] = "tiáo"; /* 迢 */
dict[0x8fe3] = "zhì,lì"; /* 迣 */
dict[0x8fe4] = "yǐ,yí"; /* 迤 */
dict[0x8fe5] = "jiǒng"; /* 迥 */
dict[0x8fe6] = "jiā"; /* 迦 */
dict[0x8fe7] = "chén"; /* 迧 */
dict[0x8fe8] = "dài"; /* 迨 */
dict[0x8fe9] = "ěr"; /* 迩 */
dict[0x8fea] = "dí"; /* 迪 */
dict[0x8feb] = "pò,pǎi"; /* 迫 */
dict[0x8fec] = "zhù,wǎng"; /* 迬 */
dict[0x8fed] = "dié"; /* 迭 */
dict[0x8fee] = "zé"; /* 迮 */
dict[0x8fef] = "táo"; /* 迯 */
dict[0x8ff0] = "shù"; /* 述 */
dict[0x8ff1] = "yǐ,yí"; /* 迱 */
dict[0x8ff3] = "jìng"; /* 迳 */
dict[0x8ff4] = "huí"; /* 迴 */
dict[0x8ff5] = "dòng"; /* 迵 */
dict[0x8ff6] = "yòu"; /* 迶 */
dict[0x8ff7] = "mí"; /* 迷 */
dict[0x8ff8] = "bèng"; /* 迸 */
dict[0x8ff9] = "jì"; /* 迹 */
dict[0x8ffa] = "nǎi"; /* 迺 */
dict[0x8ffb] = "yí"; /* 迻 */
dict[0x8ffc] = "jié"; /* 迼 */
dict[0x8ffd] = "zhuī,duī"; /* 追 */
dict[0x8ffe] = "liè"; /* 迾 */
dict[0x8fff] = "xùn"; /* 迿 */
dict[0x9000] = "tuì"; /* 退 */
dict[0x9001] = "sòng"; /* 送 */
dict[0x9002] = "shì"; /* 适 */
dict[0x9003] = "táo"; /* 逃 */
dict[0x9004] = "páng"; /* 逄 */
dict[0x9005] = "hòu"; /* 逅 */
dict[0x9006] = "nì"; /* 逆 */
dict[0x9007] = "dùn"; /* 逇 */
dict[0x9008] = "jiǒng"; /* 逈 */
dict[0x9009] = "xuǎn"; /* 选 */
dict[0x900a] = "xùn"; /* 逊 */
dict[0x900b] = "bū"; /* 逋 */
dict[0x900c] = "yōu"; /* 逌 */
dict[0x900d] = "xiāo"; /* 逍 */
dict[0x900e] = "qiú"; /* 逎 */
dict[0x900f] = "tòu"; /* 透 */
dict[0x9010] = "zhú"; /* 逐 */
dict[0x9011] = "qiú"; /* 逑 */
dict[0x9012] = "dì"; /* 递 */
dict[0x9013] = "dì"; /* 逓 */
dict[0x9014] = "tú"; /* 途 */
dict[0x9015] = "jìng"; /* 逕 */
dict[0x9016] = "tì"; /* 逖 */
dict[0x9017] = "dòu"; /* 逗 */
dict[0x9018] = "yǐ"; /* 逘 */
dict[0x9019] = "zhè"; /* 這 */
dict[0x901a] = "tōng"; /* 通 */
dict[0x901b] = "guàng"; /* 逛 */
dict[0x901c] = "wǔ"; /* 逜 */
dict[0x901d] = "shì"; /* 逝 */
dict[0x901e] = "chěng"; /* 逞 */
dict[0x901f] = "sù"; /* 速 */
dict[0x9020] = "zào"; /* 造 */
dict[0x9021] = "qūn"; /* 逡 */
dict[0x9022] = "féng"; /* 逢 */
dict[0x9023] = "lián"; /* 連 */
dict[0x9024] = "suò"; /* 逤 */
dict[0x9025] = "huí"; /* 逥 */
dict[0x9026] = "lǐ"; /* 逦 */
dict[0x9027] = "gǔ"; /* 逧 */
dict[0x9028] = "lái"; /* 逨 */
dict[0x9029] = "bèn"; /* 逩 */
dict[0x902a] = "cuò"; /* 逪 */
dict[0x902b] = "zhú"; /* 逫 */
dict[0x902c] = "bèng"; /* 逬 */
dict[0x902d] = "huàn"; /* 逭 */
dict[0x902e] = "dài"; /* 逮 */
dict[0x902f] = "lù"; /* 逯 */
dict[0x9030] = "yóu"; /* 逰 */
dict[0x9031] = "zhōu"; /* 週 */
dict[0x9032] = "jìn"; /* 進 */
dict[0x9033] = "yù"; /* 逳 */
dict[0x9034] = "chuō"; /* 逴 */
dict[0x9035] = "kuí"; /* 逵 */
dict[0x9036] = "wēi"; /* 逶 */
dict[0x9037] = "tì"; /* 逷 */
dict[0x9038] = "yì"; /* 逸 */
dict[0x9039] = "dá"; /* 逹 */
dict[0x903a] = "yuǎn"; /* 逺 */
dict[0x903b] = "luó"; /* 逻 */
dict[0x903c] = "bī"; /* 逼 */
dict[0x903d] = "nuò"; /* 逽 */
dict[0x903e] = "yú"; /* 逾 */
dict[0x903f] = "dàng"; /* 逿 */
dict[0x9040] = "suí"; /* 遀 */
dict[0x9041] = "dùn"; /* 遁 */
dict[0x9042] = "suì"; /* 遂 */
dict[0x9043] = "yǎn"; /* 遃 */
dict[0x9044] = "chuán"; /* 遄 */
dict[0x9045] = "chí"; /* 遅 */
dict[0x9046] = "dì,tí"; /* 遆 */
dict[0x9047] = "yù"; /* 遇 */
dict[0x9048] = "shí"; /* 遈 */
dict[0x9049] = "zhēn"; /* 遉 */
dict[0x904a] = "yóu"; /* 遊 */
dict[0x904b] = "yùn"; /* 運 */
dict[0x904c] = "è"; /* 遌 */
dict[0x904d] = "biàn"; /* 遍 */
dict[0x904e] = "guò"; /* 過 */
dict[0x904f] = "è"; /* 遏 */
dict[0x9050] = "xiá"; /* 遐 */
dict[0x9051] = "huáng"; /* 遑 */
dict[0x9052] = "qiú"; /* 遒 */
dict[0x9053] = "dào"; /* 道 */
dict[0x9054] = "dá"; /* 達 */
dict[0x9055] = "wéi"; /* 違 */
dict[0x9056] = "nán"; /* 遖 */
dict[0x9057] = "yí"; /* 遗 */
dict[0x9058] = "gòu"; /* 遘 */
dict[0x9059] = "yáo"; /* 遙 */
dict[0x905a] = "chòu"; /* 遚 */
dict[0x905b] = "liù"; /* 遛 */
dict[0x905c] = "xùn"; /* 遜 */
dict[0x905d] = "tà"; /* 遝 */
dict[0x905e] = "dì"; /* 遞 */
dict[0x905f] = "chí"; /* 遟 */
dict[0x9060] = "yuǎn"; /* 遠 */
dict[0x9061] = "sù"; /* 遡 */
dict[0x9062] = "tà"; /* 遢 */
dict[0x9063] = "qiǎn"; /* 遣 */
dict[0x9064] = "mǎ"; /* 遤 */
dict[0x9065] = "yáo"; /* 遥 */
dict[0x9066] = "guàn"; /* 遦 */
dict[0x9067] = "zhāng"; /* 遧 */
dict[0x9068] = "áo"; /* 遨 */
dict[0x9069] = "shì"; /* 適 */
dict[0x906a] = "cà"; /* 遪 */
dict[0x906b] = "chì"; /* 遫 */
dict[0x906c] = "sù"; /* 遬 */
dict[0x906d] = "zāo"; /* 遭 */
dict[0x906e] = "zhē"; /* 遮 */
dict[0x906f] = "dùn"; /* 遯 */
dict[0x9070] = "dì"; /* 遰 */
dict[0x9071] = "lóu"; /* 遱 */
dict[0x9072] = "chí"; /* 遲 */
dict[0x9073] = "cuō"; /* 遳 */
dict[0x9074] = "lín"; /* 遴 */
dict[0x9075] = "zūn"; /* 遵 */
dict[0x9076] = "rào"; /* 遶 */
dict[0x9077] = "qiān"; /* 遷 */
dict[0x9078] = "xuǎn"; /* 選 */
dict[0x9079] = "yù"; /* 遹 */
dict[0x907a] = "yí"; /* 遺 */
dict[0x907b] = "è"; /* 遻 */
dict[0x907c] = "liáo"; /* 遼 */
dict[0x907d] = "jù"; /* 遽 */
dict[0x907e] = "shì"; /* 遾 */
dict[0x907f] = "bì"; /* 避 */
dict[0x9080] = "yāo"; /* 邀 */
dict[0x9081] = "mài"; /* 邁 */
dict[0x9082] = "xiè"; /* 邂 */
dict[0x9083] = "suì"; /* 邃 */
dict[0x9084] = "huán,hái"; /* 還 */
dict[0x9085] = "zhān"; /* 邅 */
dict[0x9086] = "téng"; /* 邆 */
dict[0x9087] = "ěr"; /* 邇 */
dict[0x9088] = "miǎo"; /* 邈 */
dict[0x9089] = "biān"; /* 邉 */
dict[0x908a] = "biān"; /* 邊 */
dict[0x908b] = "lā"; /* 邋 */
dict[0x908c] = "lí,chí"; /* 邌 */
dict[0x908d] = "yuán"; /* 邍 */
dict[0x908e] = "yáo"; /* 邎 */
dict[0x908f] = "luó"; /* 邏 */
dict[0x9090] = "lǐ"; /* 邐 */
dict[0x9091] = "yì"; /* 邑 */
dict[0x9092] = "tíng"; /* 邒 */
dict[0x9093] = "dèng"; /* 邓 */
dict[0x9094] = "qǐ"; /* 邔 */
dict[0x9095] = "yōng"; /* 邕 */
dict[0x9096] = "shān"; /* 邖 */
dict[0x9097] = "hán"; /* 邗 */
dict[0x9098] = "yú"; /* 邘 */
dict[0x9099] = "máng"; /* 邙 */
dict[0x909a] = "rú"; /* 邚 */
dict[0x909b] = "qióng"; /* 邛 */
dict[0x909c] = "xī"; /* 邜 */
dict[0x909d] = "kuàng"; /* 邝 */
dict[0x909e] = "fū"; /* 邞 */
dict[0x909f] = "kàng,háng"; /* 邟 */
dict[0x90a0] = "bīn"; /* 邠 */
dict[0x90a1] = "fāng"; /* 邡 */
dict[0x90a2] = "xíng"; /* 邢 */
dict[0x90a3] = "nà,nǎ,nèi,nā"; /* 那 */
dict[0x90a4] = "xīn"; /* 邤 */
dict[0x90a5] = "shěn"; /* 邥 */
dict[0x90a6] = "bāng"; /* 邦 */
dict[0x90a7] = "yuán"; /* 邧 */
dict[0x90a8] = "cūn"; /* 邨 */
dict[0x90a9] = "huǒ"; /* 邩 */
dict[0x90aa] = "xié,yá,yé,yú,xú"; /* 邪 */
dict[0x90ab] = "bāng"; /* 邫 */
dict[0x90ac] = "wū"; /* 邬 */
dict[0x90ad] = "jù"; /* 邭 */
dict[0x90ae] = "yóu"; /* 邮 */
dict[0x90af] = "hán"; /* 邯 */
dict[0x90b0] = "tái"; /* 邰 */
dict[0x90b1] = "qiū"; /* 邱 */
dict[0x90b2] = "bì"; /* 邲 */
dict[0x90b3] = "pī"; /* 邳 */
dict[0x90b4] = "bǐng"; /* 邴 */
dict[0x90b5] = "shào"; /* 邵 */
dict[0x90b6] = "bèi"; /* 邶 */
dict[0x90b7] = "wǎ"; /* 邷 */
dict[0x90b8] = "dǐ"; /* 邸 */
dict[0x90b9] = "zōu"; /* 邹 */
dict[0x90ba] = "yè"; /* 邺 */
dict[0x90bb] = "lín"; /* 邻 */
dict[0x90bc] = "kuāng"; /* 邼 */
dict[0x90bd] = "guī"; /* 邽 */
dict[0x90be] = "zhū"; /* 邾 */
dict[0x90bf] = "shī"; /* 邿 */
dict[0x90c0] = "kū"; /* 郀 */
dict[0x90c1] = "yù"; /* 郁 */
dict[0x90c2] = "gāi,hái"; /* 郂 */
dict[0x90c3] = "hé"; /* 郃 */
dict[0x90c4] = "qiè,xì"; /* 郄 */
dict[0x90c5] = "zhì"; /* 郅 */
dict[0x90c6] = "jí"; /* 郆 */
dict[0x90c7] = "xún,huán"; /* 郇 */
dict[0x90c8] = "hòu"; /* 郈 */
dict[0x90c9] = "xíng"; /* 郉 */
dict[0x90ca] = "jiāo"; /* 郊 */
dict[0x90cb] = "xí"; /* 郋 */
dict[0x90cc] = "guī"; /* 郌 */
dict[0x90cd] = "nà"; /* 郍 */
dict[0x90ce] = "láng,làng"; /* 郎 */
dict[0x90cf] = "jiá"; /* 郏 */
dict[0x90d0] = "kuài"; /* 郐 */
dict[0x90d1] = "zhèng"; /* 郑 */
dict[0x90d2] = "láng"; /* 郒 */
dict[0x90d3] = "yùn"; /* 郓 */
dict[0x90d4] = "yán"; /* 郔 */
dict[0x90d5] = "chéng"; /* 郕 */
dict[0x90d6] = "dòu"; /* 郖 */
dict[0x90d7] = "xī"; /* 郗 */
dict[0x90d8] = "lǚ"; /* 郘 */
dict[0x90d9] = "fǔ"; /* 郙 */
dict[0x90da] = "wú"; /* 郚 */
dict[0x90db] = "fú"; /* 郛 */
dict[0x90dc] = "gào"; /* 郜 */
dict[0x90dd] = "hǎo"; /* 郝 */
dict[0x90de] = "láng"; /* 郞 */
dict[0x90df] = "jiá"; /* 郟 */
dict[0x90e0] = "gěng"; /* 郠 */
dict[0x90e1] = "jùn"; /* 郡 */
dict[0x90e2] = "yǐng"; /* 郢 */
dict[0x90e3] = "bó"; /* 郣 */
dict[0x90e4] = "xì"; /* 郤 */
dict[0x90e5] = "bèi"; /* 郥 */
dict[0x90e6] = "lì,zhí"; /* 郦 */
dict[0x90e7] = "yún"; /* 郧 */
dict[0x90e8] = "bù"; /* 部 */
dict[0x90e9] = "xiáo,ǎo"; /* 郩 */
dict[0x90ea] = "qī"; /* 郪 */
dict[0x90eb] = "pí"; /* 郫 */
dict[0x90ec] = "qīng"; /* 郬 */
dict[0x90ed] = "guō"; /* 郭 */
dict[0x90ee] = "zhōu"; /* 郮 */
dict[0x90ef] = "tán"; /* 郯 */
dict[0x90f0] = "zōu"; /* 郰 */
dict[0x90f1] = "píng"; /* 郱 */
dict[0x90f2] = "lái"; /* 郲 */
dict[0x90f3] = "ní"; /* 郳 */
dict[0x90f4] = "chēn"; /* 郴 */
dict[0x90f5] = "yóu"; /* 郵 */
dict[0x90f6] = "bù"; /* 郶 */
dict[0x90f7] = "xiāng"; /* 郷 */
dict[0x90f8] = "dān"; /* 郸 */
dict[0x90f9] = "jú"; /* 郹 */
dict[0x90fa] = "yōng"; /* 郺 */
dict[0x90fb] = "qiāo"; /* 郻 */
dict[0x90fc] = "yī"; /* 郼 */
dict[0x90fd] = "dū,dōu"; /* 都 */
dict[0x90fe] = "yǎn"; /* 郾 */
dict[0x90ff] = "méi"; /* 郿 */
dict[0x9100] = "ruò"; /* 鄀 */
dict[0x9101] = "bèi"; /* 鄁 */
dict[0x9102] = "è"; /* 鄂 */
dict[0x9103] = "shū"; /* 鄃 */
dict[0x9104] = "juàn"; /* 鄄 */
dict[0x9105] = "yǔ"; /* 鄅 */
dict[0x9106] = "yùn"; /* 鄆 */
dict[0x9107] = "hóu"; /* 鄇 */
dict[0x9108] = "kuí"; /* 鄈 */
dict[0x9109] = "xiāng"; /* 鄉 */
dict[0x910a] = "xiāng"; /* 鄊 */
dict[0x910b] = "sōu"; /* 鄋 */
dict[0x910c] = "táng"; /* 鄌 */
dict[0x910d] = "míng"; /* 鄍 */
dict[0x910e] = "xī"; /* 鄎 */
dict[0x910f] = "rǔ"; /* 鄏 */
dict[0x9110] = "chù"; /* 鄐 */
dict[0x9111] = "zī"; /* 鄑 */
dict[0x9112] = "zōu"; /* 鄒 */
dict[0x9113] = "yì"; /* 鄓 */
dict[0x9114] = "wū"; /* 鄔 */
dict[0x9115] = "xiāng"; /* 鄕 */
dict[0x9116] = "yún"; /* 鄖 */
dict[0x9117] = "hào"; /* 鄗 */
dict[0x9118] = "yōng"; /* 鄘 */
dict[0x9119] = "bǐ"; /* 鄙 */
dict[0x911a] = "mào"; /* 鄚 */
dict[0x911b] = "cháo"; /* 鄛 */
dict[0x911c] = "fū"; /* 鄜 */
dict[0x911d] = "liǎo"; /* 鄝 */
dict[0x911e] = "yín"; /* 鄞 */
dict[0x911f] = "zhuān"; /* 鄟 */
dict[0x9120] = "hù"; /* 鄠 */
dict[0x9121] = "qiāo"; /* 鄡 */
dict[0x9122] = "yān"; /* 鄢 */
dict[0x9123] = "zhāng"; /* 鄣 */
dict[0x9124] = "màn"; /* 鄤 */
dict[0x9125] = "qiāo"; /* 鄥 */
dict[0x9126] = "xǔ"; /* 鄦 */
dict[0x9127] = "dèng"; /* 鄧 */
dict[0x9128] = "bì"; /* 鄨 */
dict[0x9129] = "xún"; /* 鄩 */
dict[0x912a] = "bì"; /* 鄪 */
dict[0x912b] = "zēng"; /* 鄫 */
dict[0x912c] = "wéi"; /* 鄬 */
dict[0x912d] = "zhèng"; /* 鄭 */
dict[0x912e] = "mào"; /* 鄮 */
dict[0x912f] = "shàn"; /* 鄯 */
dict[0x9130] = "lín"; /* 鄰 */
dict[0x9131] = "pó"; /* 鄱 */
dict[0x9132] = "dān"; /* 鄲 */
dict[0x9133] = "méng"; /* 鄳 */
dict[0x9134] = "yè"; /* 鄴 */
dict[0x9135] = "cào"; /* 鄵 */
dict[0x9136] = "kuài"; /* 鄶 */
dict[0x9137] = "fēng"; /* 鄷 */
dict[0x9138] = "méng"; /* 鄸 */
dict[0x9139] = "zōu"; /* 鄹 */
dict[0x913a] = "kuàng"; /* 鄺 */
dict[0x913b] = "liǎn"; /* 鄻 */
dict[0x913c] = "zàn"; /* 鄼 */
dict[0x913d] = "chán"; /* 鄽 */
dict[0x913e] = "yōu"; /* 鄾 */
dict[0x913f] = "qí"; /* 鄿 */
dict[0x9140] = "yàn"; /* 酀 */
dict[0x9141] = "chán"; /* 酁 */
dict[0x9142] = "cuó,zàn"; /* 酂 */
dict[0x9143] = "líng"; /* 酃 */
dict[0x9144] = "huān"; /* 酄 */
dict[0x9145] = "xī"; /* 酅 */
dict[0x9146] = "fēng"; /* 酆 */
dict[0x9147] = "cuó,zàn"; /* 酇 */
dict[0x9148] = "lì"; /* 酈 */
dict[0x9149] = "yǒu"; /* 酉 */
dict[0x914a] = "dīng,dǐng"; /* 酊 */
dict[0x914b] = "qiú"; /* 酋 */
dict[0x914c] = "zhuó"; /* 酌 */
dict[0x914d] = "pèi"; /* 配 */
dict[0x914e] = "zhòu"; /* 酎 */
dict[0x914f] = "yǐ"; /* 酏 */
dict[0x9150] = "gān"; /* 酐 */
dict[0x9151] = "yú"; /* 酑 */
dict[0x9152] = "jiǔ"; /* 酒 */
dict[0x9153] = "yǎn"; /* 酓 */
dict[0x9154] = "zuì"; /* 酔 */
dict[0x9155] = "máo"; /* 酕 */
dict[0x9156] = "dān"; /* 酖 */
dict[0x9157] = "xù"; /* 酗 */
dict[0x9158] = "dòu"; /* 酘 */
dict[0x9159] = "zhēn"; /* 酙 */
dict[0x915a] = "fēn"; /* 酚 */
dict[0x915b] = "yuán"; /* 酛 */
dict[0x915c] = "fū"; /* 酜 */
dict[0x915d] = "yùn"; /* 酝 */
dict[0x915e] = "tài"; /* 酞 */
dict[0x915f] = "tiān"; /* 酟 */
dict[0x9160] = "qiǎ"; /* 酠 */
dict[0x9161] = "tuó"; /* 酡 */
dict[0x9162] = "zuò"; /* 酢 */
dict[0x9163] = "hān"; /* 酣 */
dict[0x9164] = "gū"; /* 酤 */
dict[0x9165] = "sū"; /* 酥 */
dict[0x9166] = "pō"; /* 酦 */
dict[0x9167] = "chóu"; /* 酧 */
dict[0x9168] = "zài"; /* 酨 */
dict[0x9169] = "mǐng"; /* 酩 */
dict[0x916a] = "lào"; /* 酪 */
dict[0x916b] = "chuò"; /* 酫 */
dict[0x916c] = "chóu"; /* 酬 */
dict[0x916d] = "yòu"; /* 酭 */
dict[0x916e] = "tóng"; /* 酮 */
dict[0x916f] = "zhǐ"; /* 酯 */
dict[0x9170] = "xiān"; /* 酰 */
dict[0x9171] = "jiàng"; /* 酱 */
dict[0x9172] = "chéng"; /* 酲 */
dict[0x9173] = "yìn"; /* 酳 */
dict[0x9174] = "tú"; /* 酴 */
dict[0x9175] = "jiào"; /* 酵 */
dict[0x9176] = "méi"; /* 酶 */
dict[0x9177] = "kù"; /* 酷 */
dict[0x9178] = "suān"; /* 酸 */
dict[0x9179] = "lèi"; /* 酹 */
dict[0x917a] = "pú"; /* 酺 */
dict[0x917b] = "zuì"; /* 酻 */
dict[0x917c] = "hǎi"; /* 酼 */
dict[0x917d] = "yàn"; /* 酽 */
dict[0x917e] = "shī"; /* 酾 */
dict[0x917f] = "niàng"; /* 酿 */
dict[0x9180] = "wéi"; /* 醀 */
dict[0x9181] = "lù"; /* 醁 */
dict[0x9182] = "lǎn"; /* 醂 */
dict[0x9183] = "yān"; /* 醃 */
dict[0x9184] = "táo"; /* 醄 */
dict[0x9185] = "pēi"; /* 醅 */
dict[0x9186] = "zhǎn"; /* 醆 */
dict[0x9187] = "chún"; /* 醇 */
dict[0x9188] = "tán,dàn"; /* 醈 */
dict[0x9189] = "zuì"; /* 醉 */
dict[0x918a] = "zhuì"; /* 醊 */
dict[0x918b] = "cù"; /* 醋 */
dict[0x918c] = "kūn"; /* 醌 */
dict[0x918d] = "tí,tǐ"; /* 醍 */
dict[0x918e] = "xián"; /* 醎 */
dict[0x918f] = "dū"; /* 醏 */
dict[0x9190] = "hú"; /* 醐 */
dict[0x9191] = "xǔ"; /* 醑 */
dict[0x9192] = "xǐng"; /* 醒 */
dict[0x9193] = "tǎn"; /* 醓 */
dict[0x9194] = "qiú,chōu"; /* 醔 */
dict[0x9195] = "chún"; /* 醕 */
dict[0x9196] = "yùn"; /* 醖 */
dict[0x9197] = "pō,fā"; /* 醗 */
dict[0x9198] = "kē"; /* 醘 */
dict[0x9199] = "sōu"; /* 醙 */
dict[0x919a] = "mí"; /* 醚 */
dict[0x919b] = "quán"; /* 醛 */
dict[0x919c] = "chǒu"; /* 醜 */
dict[0x919d] = "cuō"; /* 醝 */
dict[0x919e] = "yùn"; /* 醞 */
dict[0x919f] = "yòng"; /* 醟 */
dict[0x91a0] = "àng"; /* 醠 */
dict[0x91a1] = "zhà"; /* 醡 */
dict[0x91a2] = "hǎi"; /* 醢 */
dict[0x91a3] = "táng"; /* 醣 */
dict[0x91a4] = "jiàng"; /* 醤 */
dict[0x91a5] = "piǎo"; /* 醥 */
dict[0x91a6] = "chǎn,chěn"; /* 醦 */
dict[0x91a7] = "yù"; /* 醧 */
dict[0x91a8] = "lí"; /* 醨 */
dict[0x91a9] = "zāo"; /* 醩 */
dict[0x91aa] = "láo"; /* 醪 */
dict[0x91ab] = "yī"; /* 醫 */
dict[0x91ac] = "jiàng"; /* 醬 */
dict[0x91ad] = "bú"; /* 醭 */
dict[0x91ae] = "jiào"; /* 醮 */
dict[0x91af] = "xī"; /* 醯 */
dict[0x91b0] = "tán"; /* 醰 */
dict[0x91b1] = "pō,fā"; /* 醱 */
dict[0x91b2] = "nóng"; /* 醲 */
dict[0x91b3] = "yì,shì"; /* 醳 */
dict[0x91b4] = "lǐ"; /* 醴 */
dict[0x91b5] = "jù"; /* 醵 */
dict[0x91b6] = "yàn,liǎn,xiān"; /* 醶 */
dict[0x91b7] = "yì"; /* 醷 */
dict[0x91b8] = "niàng"; /* 醸 */
dict[0x91b9] = "rú"; /* 醹 */
dict[0x91ba] = "xūn"; /* 醺 */
dict[0x91bb] = "chóu"; /* 醻 */
dict[0x91bc] = "yàn"; /* 醼 */
dict[0x91bd] = "líng"; /* 醽 */
dict[0x91be] = "mí"; /* 醾 */
dict[0x91bf] = "mí"; /* 醿 */
dict[0x91c0] = "niàng,niáng"; /* 釀 */
dict[0x91c1] = "xìn"; /* 釁 */
dict[0x91c2] = "jiào"; /* 釂 */
dict[0x91c3] = "shī"; /* 釃 */
dict[0x91c4] = "mí"; /* 釄 */
dict[0x91c5] = "yàn"; /* 釅 */
dict[0x91c6] = "biàn"; /* 釆 */
dict[0x91c7] = "cǎi,cài"; /* 采 */
dict[0x91c8] = "shì"; /* 釈 */
dict[0x91c9] = "yòu"; /* 釉 */
dict[0x91ca] = "shì"; /* 释 */
dict[0x91cb] = "shì"; /* 釋 */
dict[0x91cc] = "lǐ"; /* 里 */
dict[0x91cd] = "zhòng,chóng"; /* 重 */
dict[0x91ce] = "yě"; /* 野 */
dict[0x91cf] = "liáng,liàng"; /* 量 */
dict[0x91d0] = "lí,xǐ,xī"; /* 釐 */
dict[0x91d1] = "jīn"; /* 金 */
dict[0x91d2] = "jīn"; /* 釒 */
dict[0x91d3] = "gá"; /* 釓 */
dict[0x91d4] = "yǐ"; /* 釔 */
dict[0x91d5] = "liǎo,liào"; /* 釕 */
dict[0x91d6] = "dāo"; /* 釖 */
dict[0x91d7] = "zhāo"; /* 釗 */
dict[0x91d8] = "dīng,dìng"; /* 釘 */
dict[0x91d9] = "pō"; /* 釙 */
dict[0x91da] = "qiú"; /* 釚 */
dict[0x91db] = "hé"; /* 釛 */
dict[0x91dc] = "fǔ"; /* 釜 */
dict[0x91dd] = "zhēn"; /* 針 */
dict[0x91de] = "zhí"; /* 釞 */
dict[0x91df] = "bā"; /* 釟 */
dict[0x91e0] = "luàn"; /* 釠 */
dict[0x91e1] = "fǔ"; /* 釡 */
dict[0x91e2] = "nǎi"; /* 釢 */
dict[0x91e3] = "diào"; /* 釣 */
dict[0x91e4] = "shān,shàn"; /* 釤 */
dict[0x91e5] = "qiǎo,jiǎo"; /* 釥 */
dict[0x91e6] = "kòu"; /* 釦 */
dict[0x91e7] = "chuàn"; /* 釧 */
dict[0x91e8] = "zǐ"; /* 釨 */
dict[0x91e9] = "fán"; /* 釩 */
dict[0x91ea] = "huá,yú"; /* 釪 */
dict[0x91eb] = "huá,wū"; /* 釫 */
dict[0x91ec] = "hàn"; /* 釬 */
dict[0x91ed] = "gāng"; /* 釭 */
dict[0x91ee] = "qí"; /* 釮 */
dict[0x91ef] = "máng"; /* 釯 */
dict[0x91f0] = "rì,rèn,jiàn"; /* 釰 */
dict[0x91f1] = "dì,dài"; /* 釱 */
dict[0x91f2] = "sì"; /* 釲 */
dict[0x91f3] = "xì"; /* 釳 */
dict[0x91f4] = "yì"; /* 釴 */
dict[0x91f5] = "chāi"; /* 釵 */
dict[0x91f6] = "shī,yí"; /* 釶 */
dict[0x91f7] = "tǔ"; /* 釷 */
dict[0x91f8] = "xī"; /* 釸 */
dict[0x91f9] = "nǚ"; /* 釹 */
dict[0x91fa] = "qiān"; /* 釺 */
dict[0x91fb] = "qiú"; /* 釻 */
dict[0x91fc] = "rì,rèn,jiàn"; /* 釼 */
dict[0x91fd] = "pī,zhāo"; /* 釽 */
dict[0x91fe] = "yé,yá"; /* 釾 */
dict[0x91ff] = "jīn"; /* 釿 */
dict[0x9200] = "bǎ"; /* 鈀 */
dict[0x9201] = "fāng"; /* 鈁 */
dict[0x9202] = "chén"; /* 鈂 */
dict[0x9203] = "xíng"; /* 鈃 */
dict[0x9204] = "dǒu"; /* 鈄 */
dict[0x9205] = "yuè"; /* 鈅 */
dict[0x9206] = "qiān"; /* 鈆 */
dict[0x9207] = "fū"; /* 鈇 */
dict[0x9208] = "bù"; /* 鈈 */
dict[0x9209] = "nà"; /* 鈉 */
dict[0x920a] = "xīn"; /* 鈊 */
dict[0x920b] = "é"; /* 鈋 */
dict[0x920c] = "jué"; /* 鈌 */
dict[0x920d] = "dùn"; /* 鈍 */
dict[0x920e] = "gōu"; /* 鈎 */
dict[0x920f] = "yǐn"; /* 鈏 */
dict[0x9210] = "qián"; /* 鈐 */
dict[0x9211] = "bǎn"; /* 鈑 */
dict[0x9212] = "sà"; /* 鈒 */
dict[0x9213] = "rèn"; /* 鈓 */
dict[0x9214] = "chāo"; /* 鈔 */
dict[0x9215] = "niǔ"; /* 鈕 */
dict[0x9216] = "fēn"; /* 鈖 */
dict[0x9217] = "yǔn"; /* 鈗 */
dict[0x9218] = "yǐ"; /* 鈘 */
dict[0x9219] = "qín"; /* 鈙 */
dict[0x921a] = "pī"; /* 鈚 */
dict[0x921b] = "guō"; /* 鈛 */
dict[0x921c] = "hóng"; /* 鈜 */
dict[0x921d] = "yín"; /* 鈝 */
dict[0x921e] = "jūn"; /* 鈞 */
dict[0x921f] = "diào"; /* 鈟 */
dict[0x9220] = "yì"; /* 鈠 */
dict[0x9221] = "zhōng"; /* 鈡 */
dict[0x9222] = "xǐ"; /* 鈢 */
dict[0x9223] = "gài"; /* 鈣 */
dict[0x9224] = "rì"; /* 鈤 */
dict[0x9225] = "huǒ"; /* 鈥 */
dict[0x9226] = "tài"; /* 鈦 */
dict[0x9227] = "kàng"; /* 鈧 */
dict[0x9228] = "yuán"; /* 鈨 */
dict[0x9229] = "lú"; /* 鈩 */
dict[0x922a] = "è"; /* 鈪 */
dict[0x922b] = "qín"; /* 鈫 */
dict[0x922c] = "duó"; /* 鈬 */
dict[0x922d] = "zī"; /* 鈭 */
dict[0x922e] = "ní"; /* 鈮 */
dict[0x922f] = "tú"; /* 鈯 */
dict[0x9230] = "shì"; /* 鈰 */
dict[0x9231] = "mín"; /* 鈱 */
dict[0x9232] = "gū"; /* 鈲 */
dict[0x9233] = "kē"; /* 鈳 */
dict[0x9234] = "líng"; /* 鈴 */
dict[0x9235] = "bǐng"; /* 鈵 */
dict[0x9236] = "sì"; /* 鈶 */
dict[0x9237] = "gǔ"; /* 鈷 */
dict[0x9238] = "bó"; /* 鈸 */
dict[0x9239] = "pí"; /* 鈹 */
dict[0x923a] = "yù"; /* 鈺 */
dict[0x923b] = "sì"; /* 鈻 */
dict[0x923c] = "zuó"; /* 鈼 */
dict[0x923d] = "bū"; /* 鈽 */
dict[0x923e] = "yóu"; /* 鈾 */
dict[0x923f] = "diàn"; /* 鈿 */
dict[0x9240] = "jiǎ"; /* 鉀 */
dict[0x9241] = "zhēn"; /* 鉁 */
dict[0x9242] = "shǐ"; /* 鉂 */
dict[0x9243] = "shì"; /* 鉃 */
dict[0x9244] = "tiě"; /* 鉄 */
dict[0x9245] = "jù"; /* 鉅 */
dict[0x9246] = "zuān"; /* 鉆 */
dict[0x9247] = "shī"; /* 鉇 */
dict[0x9248] = "tā,tuó"; /* 鉈 */
dict[0x9249] = "xuàn"; /* 鉉 */
dict[0x924a] = "zhāo"; /* 鉊 */
dict[0x924b] = "bào,páo"; /* 鉋 */
dict[0x924c] = "hé"; /* 鉌 */
dict[0x924d] = "bì"; /* 鉍 */
dict[0x924e] = "shēng"; /* 鉎 */
dict[0x924f] = "chú"; /* 鉏 */
dict[0x9250] = "shí"; /* 鉐 */
dict[0x9251] = "bó"; /* 鉑 */
dict[0x9252] = "zhù"; /* 鉒 */
dict[0x9253] = "chì"; /* 鉓 */
dict[0x9254] = "zā"; /* 鉔 */
dict[0x9255] = "pǒ"; /* 鉕 */
dict[0x9256] = "tóng"; /* 鉖 */
dict[0x9257] = "qián"; /* 鉗 */
dict[0x9258] = "fú"; /* 鉘 */
dict[0x9259] = "zhǎi"; /* 鉙 */
dict[0x925a] = "mǎo"; /* 鉚 */
dict[0x925b] = "qiān"; /* 鉛 */
dict[0x925c] = "fú"; /* 鉜 */
dict[0x925d] = "lì"; /* 鉝 */
dict[0x925e] = "yuè"; /* 鉞 */
dict[0x925f] = "pī"; /* 鉟 */
dict[0x9260] = "yāng"; /* 鉠 */
dict[0x9261] = "bàn"; /* 鉡 */
dict[0x9262] = "bō"; /* 鉢 */
dict[0x9263] = "jié"; /* 鉣 */
dict[0x9264] = "gōu"; /* 鉤 */
dict[0x9265] = "shù"; /* 鉥 */
dict[0x9266] = "zhēng"; /* 鉦 */
dict[0x9267] = "mǔ"; /* 鉧 */
dict[0x9268] = "xǐ"; /* 鉨 */
dict[0x9269] = "xǐ"; /* 鉩 */
dict[0x926a] = "dì"; /* 鉪 */
dict[0x926b] = "jiā"; /* 鉫 */
dict[0x926c] = "mù"; /* 鉬 */
dict[0x926d] = "tǎn"; /* 鉭 */
dict[0x926e] = "shén"; /* 鉮 */
dict[0x926f] = "yǐ"; /* 鉯 */
dict[0x9270] = "sī"; /* 鉰 */
dict[0x9271] = "kuàng"; /* 鉱 */
dict[0x9272] = "kǎ"; /* 鉲 */
dict[0x9273] = "běi"; /* 鉳 */
dict[0x9274] = "jiàn"; /* 鉴 */
dict[0x9275] = "tóng"; /* 鉵 */
dict[0x9276] = "xíng"; /* 鉶 */
dict[0x9277] = "hóng"; /* 鉷 */
dict[0x9278] = "jiǎo"; /* 鉸 */
dict[0x9279] = "chǐ"; /* 鉹 */
dict[0x927a] = "ěr"; /* 鉺 */
dict[0x927b] = "gè"; /* 鉻 */
dict[0x927c] = "bǐng,píng"; /* 鉼 */
dict[0x927d] = "shì"; /* 鉽 */
dict[0x927e] = "máo"; /* 鉾 */
dict[0x927f] = "hā,kē"; /* 鉿 */
dict[0x9280] = "yín"; /* 銀 */
dict[0x9281] = "jūn"; /* 銁 */
dict[0x9282] = "zhōu"; /* 銂 */
dict[0x9283] = "chòng"; /* 銃 */
dict[0x9284] = "xiǎng,jiōng"; /* 銄 */
dict[0x9285] = "tóng"; /* 銅 */
dict[0x9286] = "mò"; /* 銆 */
dict[0x9287] = "lèi"; /* 銇 */
dict[0x9288] = "jī"; /* 銈 */
dict[0x9289] = "yù,sì"; /* 銉 */
dict[0x928a] = "xù,huì"; /* 銊 */
dict[0x928b] = "rén,rěn"; /* 銋 */
dict[0x928c] = "zùn"; /* 銌 */
dict[0x928d] = "zhì"; /* 銍 */
dict[0x928e] = "qióng"; /* 銎 */
dict[0x928f] = "shàn,shuò"; /* 銏 */
dict[0x9290] = "chì,lì"; /* 銐 */
dict[0x9291] = "xiǎn,xǐ"; /* 銑 */
dict[0x9292] = "xíng"; /* 銒 */
dict[0x9293] = "quán"; /* 銓 */
dict[0x9294] = "pī"; /* 銔 */
dict[0x9295] = "tiě"; /* 銕 */
dict[0x9296] = "zhū"; /* 銖 */
dict[0x9297] = "hóu,xiàng"; /* 銗 */
dict[0x9298] = "míng"; /* 銘 */
dict[0x9299] = "kuǎ"; /* 銙 */
dict[0x929a] = "diào,tiáo,yáo"; /* 銚 */
dict[0x929b] = "xiān,kuò,tiǎn,guā"; /* 銛 */
dict[0x929c] = "xián"; /* 銜 */
dict[0x929d] = "xiū"; /* 銝 */
dict[0x929e] = "jūn"; /* 銞 */
dict[0x929f] = "chā"; /* 銟 */
dict[0x92a0] = "lǎo"; /* 銠 */
dict[0x92a1] = "jí"; /* 銡 */
dict[0x92a2] = "pǐ"; /* 銢 */
dict[0x92a3] = "rú"; /* 銣 */
dict[0x92a4] = "mǐ"; /* 銤 */
dict[0x92a5] = "yī"; /* 銥 */
dict[0x92a6] = "yīn"; /* 銦 */
dict[0x92a7] = "guāng"; /* 銧 */
dict[0x92a8] = "ǎn"; /* 銨 */
dict[0x92a9] = "diū"; /* 銩 */
dict[0x92aa] = "yǒu"; /* 銪 */
dict[0x92ab] = "sè"; /* 銫 */
dict[0x92ac] = "kào"; /* 銬 */
dict[0x92ad] = "qián"; /* 銭 */
dict[0x92ae] = "luán"; /* 銮 */
dict[0x92af] = "sī"; /* 銯 */
dict[0x92b0] = "āi"; /* 銰 */
dict[0x92b1] = "diào"; /* 銱 */
dict[0x92b2] = "hàn"; /* 銲 */
dict[0x92b3] = "ruì"; /* 銳 */
dict[0x92b4] = "shì,zhì"; /* 銴 */
dict[0x92b5] = "kēng"; /* 銵 */
dict[0x92b6] = "qiú"; /* 銶 */
dict[0x92b7] = "xiāo"; /* 銷 */
dict[0x92b8] = "zhé,niè"; /* 銸 */
dict[0x92b9] = "xiù"; /* 銹 */
dict[0x92ba] = "zàng"; /* 銺 */
dict[0x92bb] = "tī"; /* 銻 */
dict[0x92bc] = "cuò"; /* 銼 */
dict[0x92bd] = "xiān,kuò,tiǎn,guā"; /* 銽 */
dict[0x92be] = "hòng,gǒng"; /* 銾 */
dict[0x92bf] = "zhōng,yōng"; /* 銿 */
dict[0x92c0] = "tōu,tù,dòu"; /* 鋀 */
dict[0x92c1] = "lǚ"; /* 鋁 */
dict[0x92c2] = "méi,méng"; /* 鋂 */
dict[0x92c3] = "láng"; /* 鋃 */
dict[0x92c4] = "wàn,jiǎn"; /* 鋄 */
dict[0x92c5] = "xīn"; /* 鋅 */
dict[0x92c6] = "yún"; /* 鋆 */
dict[0x92c7] = "bèi"; /* 鋇 */
dict[0x92c8] = "wù"; /* 鋈 */
dict[0x92c9] = "sù"; /* 鋉 */
dict[0x92ca] = "yù"; /* 鋊 */
dict[0x92cb] = "chán"; /* 鋋 */
dict[0x92cc] = "tǐng,dìng"; /* 鋌 */
dict[0x92cd] = "bó"; /* 鋍 */
dict[0x92ce] = "hàn"; /* 鋎 */
dict[0x92cf] = "jiá"; /* 鋏 */
dict[0x92d0] = "hóng"; /* 鋐 */
dict[0x92d1] = "juān,jiān,cuān"; /* 鋑 */
dict[0x92d2] = "fēng"; /* 鋒 */
dict[0x92d3] = "chān"; /* 鋓 */
dict[0x92d4] = "wǎn"; /* 鋔 */
dict[0x92d5] = "zhì"; /* 鋕 */
dict[0x92d6] = "sī,tuó"; /* 鋖 */
dict[0x92d7] = "xuān,juān,juàn"; /* 鋗 */
dict[0x92d8] = "huá,wú,wū"; /* 鋘 */
dict[0x92d9] = "wú"; /* 鋙 */
dict[0x92da] = "tiáo"; /* 鋚 */
dict[0x92db] = "kuàng"; /* 鋛 */
dict[0x92dc] = "zhuó,chuò"; /* 鋜 */
dict[0x92dd] = "lüè"; /* 鋝 */
dict[0x92de] = "xíng,xìng,jīng"; /* 鋞 */
dict[0x92df] = "qǐn"; /* 鋟 */
dict[0x92e0] = "shèn"; /* 鋠 */
dict[0x92e1] = "hán"; /* 鋡 */
dict[0x92e2] = "lüè"; /* 鋢 */
dict[0x92e3] = "yé"; /* 鋣 */
dict[0x92e4] = "chú"; /* 鋤 */
dict[0x92e5] = "zèng"; /* 鋥 */
dict[0x92e6] = "jū,jú"; /* 鋦 */
dict[0x92e7] = "xiàn"; /* 鋧 */
dict[0x92e8] = "é"; /* 鋨 */
dict[0x92e9] = "máng"; /* 鋩 */
dict[0x92ea] = "pū,pù"; /* 鋪 */
dict[0x92eb] = "lí"; /* 鋫 */
dict[0x92ec] = "pàn"; /* 鋬 */
dict[0x92ed] = "ruì"; /* 鋭 */
dict[0x92ee] = "chéng"; /* 鋮 */
dict[0x92ef] = "gào"; /* 鋯 */
dict[0x92f0] = "lǐ"; /* 鋰 */
dict[0x92f1] = "tè"; /* 鋱 */
dict[0x92f2] = "bīng"; /* 鋲 */
dict[0x92f3] = "zhù"; /* 鋳 */
dict[0x92f4] = "zhèn"; /* 鋴 */
dict[0x92f5] = "tū"; /* 鋵 */
dict[0x92f6] = "liǔ"; /* 鋶 */
dict[0x92f7] = "zuì,niè"; /* 鋷 */
dict[0x92f8] = "jù,jū"; /* 鋸 */
dict[0x92f9] = "chǎng"; /* 鋹 */
dict[0x92fa] = "yuǎn,yuān,wǎn,wān"; /* 鋺 */
dict[0x92fb] = "jiān,jiàn"; /* 鋻 */
dict[0x92fc] = "gāng,gàng"; /* 鋼 */
dict[0x92fd] = "diào"; /* 鋽 */
dict[0x92fe] = "táo"; /* 鋾 */
dict[0x92ff] = "shǎng"; /* 鋿 */
dict[0x9300] = "lún"; /* 錀 */
dict[0x9301] = "kè"; /* 錁 */
dict[0x9302] = "líng"; /* 錂 */
dict[0x9303] = "pī"; /* 錃 */
dict[0x9304] = "lù"; /* 錄 */
dict[0x9305] = "lí"; /* 錅 */
dict[0x9306] = "qīng"; /* 錆 */
dict[0x9307] = "péi"; /* 錇 */
dict[0x9308] = "juǎn"; /* 錈 */
dict[0x9309] = "mín"; /* 錉 */
dict[0x930a] = "zuì"; /* 錊 */
dict[0x930b] = "péng"; /* 錋 */
dict[0x930c] = "àn"; /* 錌 */
dict[0x930d] = "pī"; /* 錍 */
dict[0x930e] = "xiàn"; /* 錎 */
dict[0x930f] = "yā"; /* 錏 */
dict[0x9310] = "zhuī"; /* 錐 */
dict[0x9311] = "lèi"; /* 錑 */
dict[0x9312] = "ā"; /* 錒 */
dict[0x9313] = "kōng"; /* 錓 */
dict[0x9314] = "tà"; /* 錔 */
dict[0x9315] = "kūn"; /* 錕 */
dict[0x9316] = "dú"; /* 錖 */
dict[0x9317] = "nèi"; /* 錗 */
dict[0x9318] = "chuí"; /* 錘 */
dict[0x9319] = "zī"; /* 錙 */
dict[0x931a] = "zhēng"; /* 錚 */
dict[0x931b] = "bēn"; /* 錛 */
dict[0x931c] = "niè"; /* 錜 */
dict[0x931d] = "cóng"; /* 錝 */
dict[0x931e] = "chún"; /* 錞 */
dict[0x931f] = "tán"; /* 錟 */
dict[0x9320] = "dìng"; /* 錠 */
dict[0x9321] = "qí"; /* 錡 */
dict[0x9322] = "qián"; /* 錢 */
dict[0x9323] = "zhuì"; /* 錣 */
dict[0x9324] = "jī"; /* 錤 */
dict[0x9325] = "yù"; /* 錥 */
dict[0x9326] = "jǐn"; /* 錦 */
dict[0x9327] = "guǎn"; /* 錧 */
dict[0x9328] = "máo"; /* 錨 */
dict[0x9329] = "chāng"; /* 錩 */
dict[0x932a] = "tiǎn"; /* 錪 */
dict[0x932b] = "xī"; /* 錫 */
dict[0x932c] = "liàn"; /* 錬 */
dict[0x932d] = "diāo"; /* 錭 */
dict[0x932e] = "gù"; /* 錮 */
dict[0x932f] = "cuò"; /* 錯 */
dict[0x9330] = "shù"; /* 錰 */
dict[0x9331] = "zhēn"; /* 錱 */
dict[0x9332] = "lù"; /* 録 */
dict[0x9333] = "měng"; /* 錳 */
dict[0x9334] = "lù"; /* 錴 */
dict[0x9335] = "huā"; /* 錵 */
dict[0x9336] = "biǎo"; /* 錶 */
dict[0x9337] = "gá"; /* 錷 */
dict[0x9338] = "lái"; /* 錸 */
dict[0x9339] = "kěn"; /* 錹 */
dict[0x933a] = "fāng"; /* 錺 */
dict[0x933b] = "bū"; /* 錻 */
dict[0x933c] = "nài"; /* 錼 */
dict[0x933d] = "wàn"; /* 錽 */
dict[0x933e] = "zàn"; /* 錾 */
dict[0x933f] = "hǔ"; /* 錿 */
dict[0x9340] = "dé"; /* 鍀 */
dict[0x9341] = "xiān"; /* 鍁 */
dict[0x9342] = "piān"; /* 鍂 */
dict[0x9343] = "huò"; /* 鍃 */
dict[0x9344] = "liàng"; /* 鍄 */
dict[0x9345] = "fǎ"; /* 鍅 */
dict[0x9346] = "mén"; /* 鍆 */
dict[0x9347] = "kǎi"; /* 鍇 */
dict[0x9348] = "yāng"; /* 鍈 */
dict[0x9349] = "chí"; /* 鍉 */
dict[0x934a] = "liàn"; /* 鍊 */
dict[0x934b] = "guō"; /* 鍋 */
dict[0x934c] = "xiǎn"; /* 鍌 */
dict[0x934d] = "dù"; /* 鍍 */
dict[0x934e] = "tú"; /* 鍎 */
dict[0x934f] = "wéi"; /* 鍏 */
dict[0x9350] = "zōng"; /* 鍐 */
dict[0x9351] = "fù"; /* 鍑 */
dict[0x9352] = "róu"; /* 鍒 */
dict[0x9353] = "jí"; /* 鍓 */
dict[0x9354] = "è"; /* 鍔 */
dict[0x9355] = "jūn"; /* 鍕 */
dict[0x9356] = "chěn"; /* 鍖 */
dict[0x9357] = "tí"; /* 鍗 */
dict[0x9358] = "zhá"; /* 鍘 */
dict[0x9359] = "hù"; /* 鍙 */
dict[0x935a] = "yáng"; /* 鍚 */
dict[0x935b] = "duàn"; /* 鍛 */
dict[0x935c] = "xiá"; /* 鍜 */
dict[0x935d] = "yú"; /* 鍝 */
dict[0x935e] = "kēng"; /* 鍞 */
dict[0x935f] = "shēng"; /* 鍟 */
dict[0x9360] = "huáng"; /* 鍠 */
dict[0x9361] = "wěi"; /* 鍡 */
dict[0x9362] = "fù"; /* 鍢 */
dict[0x9363] = "zhāo"; /* 鍣 */
dict[0x9364] = "chā"; /* 鍤 */
dict[0x9365] = "qiè"; /* 鍥 */
dict[0x9366] = "shī"; /* 鍦 */
dict[0x9367] = "hōng"; /* 鍧 */
dict[0x9368] = "kuí"; /* 鍨 */
dict[0x9369] = "nuò"; /* 鍩 */
dict[0x936a] = "móu"; /* 鍪 */
dict[0x936b] = "qiāo"; /* 鍫 */
dict[0x936c] = "qiāo"; /* 鍬 */
dict[0x936d] = "hóu"; /* 鍭 */
dict[0x936e] = "tōu"; /* 鍮 */
dict[0x936f] = "cōng"; /* 鍯 */
dict[0x9370] = "huán"; /* 鍰 */
dict[0x9371] = "yè"; /* 鍱 */
dict[0x9372] = "mín"; /* 鍲 */
dict[0x9373] = "jiàn"; /* 鍳 */
dict[0x9374] = "duān"; /* 鍴 */
dict[0x9375] = "jiàn"; /* 鍵 */
dict[0x9376] = "sī"; /* 鍶 */
dict[0x9377] = "kuí"; /* 鍷 */
dict[0x9378] = "hú"; /* 鍸 */
dict[0x9379] = "xuān"; /* 鍹 */
dict[0x937a] = "zhě"; /* 鍺 */
dict[0x937b] = "jié"; /* 鍻 */
dict[0x937c] = "zhēn"; /* 鍼 */
dict[0x937d] = "biān"; /* 鍽 */
dict[0x937e] = "zhōng"; /* 鍾 */
dict[0x937f] = "zī"; /* 鍿 */
dict[0x9380] = "xiū"; /* 鎀 */
dict[0x9381] = "yé"; /* 鎁 */
dict[0x9382] = "měi"; /* 鎂 */
dict[0x9383] = "pài"; /* 鎃 */
dict[0x9384] = "āi"; /* 鎄 */
dict[0x9385] = "jiè"; /* 鎅 */
dict[0x9386] = "qián"; /* 鎆 */
dict[0x9387] = "méi"; /* 鎇 */
dict[0x9388] = "cuō,chā"; /* 鎈 */
dict[0x9389] = "dā,tà"; /* 鎉 */
dict[0x938a] = "bàng"; /* 鎊 */
dict[0x938b] = "xiá"; /* 鎋 */
dict[0x938c] = "lián"; /* 鎌 */
dict[0x938d] = "suǒ,sè"; /* 鎍 */
dict[0x938e] = "kài"; /* 鎎 */
dict[0x938f] = "liú"; /* 鎏 */
dict[0x9390] = "yáo,zú"; /* 鎐 */
dict[0x9391] = "yè,tà,gé"; /* 鎑 */
dict[0x9392] = "nòu"; /* 鎒 */
dict[0x9393] = "wēng"; /* 鎓 */
dict[0x9394] = "róng"; /* 鎔 */
dict[0x9395] = "táng"; /* 鎕 */
dict[0x9396] = "suǒ"; /* 鎖 */
dict[0x9397] = "qiāng,chēng"; /* 鎗 */
dict[0x9398] = "gé,lì"; /* 鎘 */
dict[0x9399] = "shuò"; /* 鎙 */
dict[0x939a] = "chuí"; /* 鎚 */
dict[0x939b] = "bó"; /* 鎛 */
dict[0x939c] = "pán"; /* 鎜 */
dict[0x939d] = "dā"; /* 鎝 */
dict[0x939e] = "bī,bì,pī"; /* 鎞 */
dict[0x939f] = "sǎng"; /* 鎟 */
dict[0x93a0] = "gāng"; /* 鎠 */
dict[0x93a1] = "zī"; /* 鎡 */
dict[0x93a2] = "wū"; /* 鎢 */
dict[0x93a3] = "yíng"; /* 鎣 */
dict[0x93a4] = "huàng"; /* 鎤 */
dict[0x93a5] = "tiáo"; /* 鎥 */
dict[0x93a6] = "liú,liù"; /* 鎦 */
dict[0x93a7] = "kǎi"; /* 鎧 */
dict[0x93a8] = "sǔn"; /* 鎨 */
dict[0x93a9] = "shā"; /* 鎩 */
dict[0x93aa] = "sōu"; /* 鎪 */
dict[0x93ab] = "wàn,jiǎn"; /* 鎫 */
dict[0x93ac] = "gǎo,hào"; /* 鎬 */
dict[0x93ad] = "zhèn"; /* 鎭 */
dict[0x93ae] = "zhèn"; /* 鎮 */
dict[0x93af] = "láng"; /* 鎯 */
dict[0x93b0] = "yì"; /* 鎰 */
dict[0x93b1] = "yuán"; /* 鎱 */
dict[0x93b2] = "tǎng"; /* 鎲 */
dict[0x93b3] = "niè"; /* 鎳 */
dict[0x93b4] = "xí"; /* 鎴 */
dict[0x93b5] = "jiā"; /* 鎵 */
dict[0x93b6] = "gē"; /* 鎶 */
dict[0x93b7] = "mǎ"; /* 鎷 */
dict[0x93b8] = "juān"; /* 鎸 */
dict[0x93b9] = "sòng"; /* 鎹 */
dict[0x93ba] = "zǔ"; /* 鎺 */
dict[0x93bb] = "suǒ"; /* 鎻 */
dict[0x93bc] = "xià"; /* 鎼 */
dict[0x93bd] = "fēng"; /* 鎽 */
dict[0x93be] = "wēn"; /* 鎾 */
dict[0x93bf] = "ná"; /* 鎿 */
dict[0x93c0] = "lǔ"; /* 鏀 */
dict[0x93c1] = "suǒ"; /* 鏁 */
dict[0x93c2] = "ōu"; /* 鏂 */
dict[0x93c3] = "zú,chuò"; /* 鏃 */
dict[0x93c4] = "tuán"; /* 鏄 */
dict[0x93c5] = "xiū,xiù"; /* 鏅 */
dict[0x93c6] = "guàn"; /* 鏆 */
dict[0x93c7] = "xuàn"; /* 鏇 */
dict[0x93c8] = "liàn"; /* 鏈 */
dict[0x93c9] = "shòu,sōu"; /* 鏉 */
dict[0x93ca] = "ào"; /* 鏊 */
dict[0x93cb] = "mǎn"; /* 鏋 */
dict[0x93cc] = "mò"; /* 鏌 */
dict[0x93cd] = "luó"; /* 鏍 */
dict[0x93ce] = "bì"; /* 鏎 */
dict[0x93cf] = "wèi"; /* 鏏 */
dict[0x93d0] = "liú"; /* 鏐 */
dict[0x93d1] = "dí,dī"; /* 鏑 */
dict[0x93d2] = "sǎn,qiāo,càn"; /* 鏒 */
dict[0x93d3] = "cōng"; /* 鏓 */
dict[0x93d4] = "yí"; /* 鏔 */
dict[0x93d5] = "lù,áo"; /* 鏕 */
dict[0x93d6] = "áo"; /* 鏖 */
dict[0x93d7] = "kēng"; /* 鏗 */
dict[0x93d8] = "qiāng"; /* 鏘 */
dict[0x93d9] = "cuī"; /* 鏙 */
dict[0x93da] = "qī"; /* 鏚 */
dict[0x93db] = "shǎng"; /* 鏛 */
dict[0x93dc] = "tāng,táng"; /* 鏜 */
dict[0x93dd] = "màn"; /* 鏝 */
dict[0x93de] = "yōng"; /* 鏞 */
dict[0x93df] = "chǎn"; /* 鏟 */
dict[0x93e0] = "fēng"; /* 鏠 */
dict[0x93e1] = "jìng"; /* 鏡 */
dict[0x93e2] = "biāo"; /* 鏢 */
dict[0x93e3] = "shù"; /* 鏣 */
dict[0x93e4] = "lòu"; /* 鏤 */
dict[0x93e5] = "xiù"; /* 鏥 */
dict[0x93e6] = "cōng"; /* 鏦 */
dict[0x93e7] = "lóng"; /* 鏧 */
dict[0x93e8] = "zàn"; /* 鏨 */
dict[0x93e9] = "jiàn,zàn"; /* 鏩 */
dict[0x93ea] = "cáo"; /* 鏪 */
dict[0x93eb] = "lí"; /* 鏫 */
dict[0x93ec] = "xià"; /* 鏬 */
dict[0x93ed] = "xī"; /* 鏭 */
dict[0x93ee] = "kāng"; /* 鏮 */
dict[0x93ef] = "shuǎng"; /* 鏯 */
dict[0x93f0] = "bèng"; /* 鏰 */
dict[0x93f1] = "zhāng"; /* 鏱 */
dict[0x93f2] = "qiān"; /* 鏲 */
dict[0x93f3] = "zhēng"; /* 鏳 */
dict[0x93f4] = "lù"; /* 鏴 */
dict[0x93f5] = "huá"; /* 鏵 */
dict[0x93f6] = "jí"; /* 鏶 */
dict[0x93f7] = "pú"; /* 鏷 */
dict[0x93f8] = "huì,suì,ruì"; /* 鏸 */
dict[0x93f9] = "qiǎng,qiāng"; /* 鏹 */
dict[0x93fa] = "pō"; /* 鏺 */
dict[0x93fb] = "lín"; /* 鏻 */
dict[0x93fc] = "sè"; /* 鏼 */
dict[0x93fd] = "xiù"; /* 鏽 */
dict[0x93fe] = "sǎn,xiàn,sà"; /* 鏾 */
dict[0x93ff] = "chēng"; /* 鏿 */
dict[0x9400] = "guì"; /* 鐀 */
dict[0x9401] = "sī"; /* 鐁 */
dict[0x9402] = "liú"; /* 鐂 */
dict[0x9403] = "náo"; /* 鐃 */
dict[0x9404] = "huáng"; /* 鐄 */
dict[0x9405] = "piě"; /* 鐅 */
dict[0x9406] = "suì"; /* 鐆 */
dict[0x9407] = "fán"; /* 鐇 */
dict[0x9408] = "qiáo"; /* 鐈 */
dict[0x9409] = "quān"; /* 鐉 */
dict[0x940a] = "xī"; /* 鐊 */
dict[0x940b] = "tàng"; /* 鐋 */
dict[0x940c] = "xiàng"; /* 鐌 */
dict[0x940d] = "jué"; /* 鐍 */
dict[0x940e] = "jiāo"; /* 鐎 */
dict[0x940f] = "zūn"; /* 鐏 */
dict[0x9410] = "liào"; /* 鐐 */
dict[0x9411] = "qì"; /* 鐑 */
dict[0x9412] = "láo"; /* 鐒 */
dict[0x9413] = "duī"; /* 鐓 */
dict[0x9414] = "xín"; /* 鐔 */
dict[0x9415] = "zān"; /* 鐕 */
dict[0x9416] = "jī"; /* 鐖 */
dict[0x9417] = "jiǎn"; /* 鐗 */
dict[0x9418] = "zhōng"; /* 鐘 */
dict[0x9419] = "dèng"; /* 鐙 */
dict[0x941a] = "yā"; /* 鐚 */
dict[0x941b] = "yǐng"; /* 鐛 */
dict[0x941c] = "duī"; /* 鐜 */
dict[0x941d] = "jué"; /* 鐝 */
dict[0x941e] = "nòu"; /* 鐞 */
dict[0x941f] = "zān"; /* 鐟 */
dict[0x9420] = "pǔ"; /* 鐠 */
dict[0x9421] = "tiě"; /* 鐡 */
dict[0x9422] = "fán"; /* 鐢 */
dict[0x9423] = "chēng"; /* 鐣 */
dict[0x9424] = "dǐng"; /* 鐤 */
dict[0x9425] = "shàn"; /* 鐥 */
dict[0x9426] = "kāi"; /* 鐦 */
dict[0x9427] = "jiǎn"; /* 鐧 */
dict[0x9428] = "fèi"; /* 鐨 */
dict[0x9429] = "suì"; /* 鐩 */
dict[0x942a] = "lǔ"; /* 鐪 */
dict[0x942b] = "juān"; /* 鐫 */
dict[0x942c] = "huì"; /* 鐬 */
dict[0x942d] = "yù"; /* 鐭 */
dict[0x942e] = "lián"; /* 鐮 */
dict[0x942f] = "zhuō"; /* 鐯 */
dict[0x9430] = "qiāo"; /* 鐰 */
dict[0x9431] = "jiàn"; /* 鐱 */
dict[0x9432] = "zhuó"; /* 鐲 */
dict[0x9433] = "léi"; /* 鐳 */
dict[0x9434] = "bì"; /* 鐴 */
dict[0x9435] = "tiě"; /* 鐵 */
dict[0x9436] = "huán"; /* 鐶 */
dict[0x9437] = "yè"; /* 鐷 */
dict[0x9438] = "duó"; /* 鐸 */
dict[0x9439] = "guò"; /* 鐹 */
dict[0x943a] = "dāng,chēng"; /* 鐺 */
dict[0x943b] = "jù"; /* 鐻 */
dict[0x943c] = "fén"; /* 鐼 */
dict[0x943d] = "dá"; /* 鐽 */
dict[0x943e] = "bèi"; /* 鐾 */
dict[0x943f] = "yì"; /* 鐿 */
dict[0x9440] = "ài"; /* 鑀 */
dict[0x9441] = "zōng"; /* 鑁 */
dict[0x9442] = "xùn"; /* 鑂 */
dict[0x9443] = "diào"; /* 鑃 */
dict[0x9444] = "zhù"; /* 鑄 */
dict[0x9445] = "héng"; /* 鑅 */
dict[0x9446] = "zhuì"; /* 鑆 */
dict[0x9447] = "jī"; /* 鑇 */
dict[0x9448] = "niè"; /* 鑈 */
dict[0x9449] = "hé"; /* 鑉 */
dict[0x944a] = "huò"; /* 鑊 */
dict[0x944b] = "qīng"; /* 鑋 */
dict[0x944c] = "bīn"; /* 鑌 */
dict[0x944d] = "yīng"; /* 鑍 */
dict[0x944e] = "guì"; /* 鑎 */
dict[0x944f] = "níng"; /* 鑏 */
dict[0x9450] = "xū"; /* 鑐 */
dict[0x9451] = "jiàn"; /* 鑑 */
dict[0x9452] = "jiàn"; /* 鑒 */
dict[0x9453] = "qiǎn"; /* 鑓 */
dict[0x9454] = "chǎ"; /* 鑔 */
dict[0x9455] = "zhì"; /* 鑕 */
dict[0x9456] = "miè"; /* 鑖 */
dict[0x9457] = "lí"; /* 鑗 */
dict[0x9458] = "léi"; /* 鑘 */
dict[0x9459] = "jī"; /* 鑙 */
dict[0x945a] = "zuān"; /* 鑚 */
dict[0x945b] = "kuàng"; /* 鑛 */
dict[0x945c] = "shǎng"; /* 鑜 */
dict[0x945d] = "péng"; /* 鑝 */
dict[0x945e] = "là"; /* 鑞 */
dict[0x945f] = "dú"; /* 鑟 */
dict[0x9460] = "shuò"; /* 鑠 */
dict[0x9461] = "chuò"; /* 鑡 */
dict[0x9462] = "lǜ"; /* 鑢 */
dict[0x9463] = "biāo"; /* 鑣 */
dict[0x9464] = "bào"; /* 鑤 */
dict[0x9465] = "lǔ"; /* 鑥 */
dict[0x9466] = "xián"; /* 鑦 */
dict[0x9467] = "kuān"; /* 鑧 */
dict[0x9468] = "lóng"; /* 鑨 */
dict[0x9469] = "è"; /* 鑩 */
dict[0x946a] = "lú"; /* 鑪 */
dict[0x946b] = "xīn"; /* 鑫 */
dict[0x946c] = "jiàn"; /* 鑬 */
dict[0x946d] = "lán"; /* 鑭 */
dict[0x946e] = "bó"; /* 鑮 */
dict[0x946f] = "jiān"; /* 鑯 */
dict[0x9470] = "yuè"; /* 鑰 */
dict[0x9471] = "chán"; /* 鑱 */
dict[0x9472] = "xiāng"; /* 鑲 */
dict[0x9473] = "jiàn"; /* 鑳 */
dict[0x9474] = "xī"; /* 鑴 */
dict[0x9475] = "guàn"; /* 鑵 */
dict[0x9476] = "cáng"; /* 鑶 */
dict[0x9477] = "niè"; /* 鑷 */
dict[0x9478] = "lěi"; /* 鑸 */
dict[0x9479] = "cuān"; /* 鑹 */
dict[0x947a] = "qú"; /* 鑺 */
dict[0x947b] = "pàn"; /* 鑻 */
dict[0x947c] = "luó"; /* 鑼 */
dict[0x947d] = "zuān"; /* 鑽 */
dict[0x947e] = "luán"; /* 鑾 */
dict[0x947f] = "záo"; /* 鑿 */
dict[0x9480] = "niè"; /* 钀 */
dict[0x9481] = "jué"; /* 钁 */
dict[0x9482] = "tǎng"; /* 钂 */
dict[0x9483] = "zhú"; /* 钃 */
dict[0x9484] = "làn"; /* 钄 */
dict[0x9485] = "jīn"; /* 钅 */
dict[0x9486] = "gá"; /* 钆 */
dict[0x9487] = "yǐ"; /* 钇 */
dict[0x9488] = "zhēn"; /* 针 */
dict[0x9489] = "dīng,dìng"; /* 钉 */
dict[0x948a] = "zhāo"; /* 钊 */
dict[0x948b] = "pō"; /* 钋 */
dict[0x948c] = "liǎo,liào"; /* 钌 */
dict[0x948d] = "tǔ"; /* 钍 */
dict[0x948e] = "qiān"; /* 钎 */
dict[0x948f] = "chuàn"; /* 钏 */
dict[0x9490] = "shān,shàn"; /* 钐 */
dict[0x9491] = "sà,xì"; /* 钑 */
dict[0x9492] = "fán"; /* 钒 */
dict[0x9493] = "diào"; /* 钓 */
dict[0x9494] = "mén"; /* 钔 */
dict[0x9495] = "nǚ"; /* 钕 */
dict[0x9496] = "yáng"; /* 钖 */
dict[0x9497] = "chāi"; /* 钗 */
dict[0x9498] = "xíng"; /* 钘 */
dict[0x9499] = "gài"; /* 钙 */
dict[0x949a] = "bù"; /* 钚 */
dict[0x949b] = "tài"; /* 钛 */
dict[0x949c] = "jù"; /* 钜 */
dict[0x949d] = "dùn"; /* 钝 */
dict[0x949e] = "chāo"; /* 钞 */
dict[0x949f] = "zhōng"; /* 钟 */
dict[0x94a0] = "nà"; /* 钠 */
dict[0x94a1] = "bèi"; /* 钡 */
dict[0x94a2] = "gāng,gàng"; /* 钢 */
dict[0x94a3] = "bǎn"; /* 钣 */
dict[0x94a4] = "qián"; /* 钤 */
dict[0x94a5] = "yuè,yào"; /* 钥 */
dict[0x94a6] = "qīn"; /* 钦 */
dict[0x94a7] = "jūn"; /* 钧 */
dict[0x94a8] = "wū"; /* 钨 */
dict[0x94a9] = "gōu"; /* 钩 */
dict[0x94aa] = "kàng"; /* 钪 */
dict[0x94ab] = "fāng"; /* 钫 */
dict[0x94ac] = "huǒ"; /* 钬 */
dict[0x94ad] = "dǒu"; /* 钭 */
dict[0x94ae] = "niǔ"; /* 钮 */
dict[0x94af] = "bǎ,pá"; /* 钯 */
dict[0x94b0] = "yù"; /* 钰 */
dict[0x94b1] = "qián"; /* 钱 */
dict[0x94b2] = "zhēng,zhèng"; /* 钲 */
dict[0x94b3] = "qián"; /* 钳 */
dict[0x94b4] = "gǔ"; /* 钴 */
dict[0x94b5] = "bō"; /* 钵 */
dict[0x94b6] = "kē"; /* 钶 */
dict[0x94b7] = "pǒ"; /* 钷 */
dict[0x94b8] = "bū"; /* 钸 */
dict[0x94b9] = "bó"; /* 钹 */
dict[0x94ba] = "yuè"; /* 钺 */
dict[0x94bb] = "zuān,zuàn"; /* 钻 */
dict[0x94bc] = "mù"; /* 钼 */
dict[0x94bd] = "tǎn"; /* 钽 */
dict[0x94be] = "jiǎ"; /* 钾 */
dict[0x94bf] = "diàn,tián"; /* 钿 */
dict[0x94c0] = "yóu"; /* 铀 */
dict[0x94c1] = "tiě"; /* 铁 */
dict[0x94c2] = "bó"; /* 铂 */
dict[0x94c3] = "líng"; /* 铃 */
dict[0x94c4] = "shuò"; /* 铄 */
dict[0x94c5] = "qiān,yán"; /* 铅 */
dict[0x94c6] = "mǎo"; /* 铆 */
dict[0x94c7] = "bào,páo"; /* 铇 */
dict[0x94c8] = "shì"; /* 铈 */
dict[0x94c9] = "xuàn"; /* 铉 */
dict[0x94ca] = "tā,tuó"; /* 铊 */
dict[0x94cb] = "bì"; /* 铋 */
dict[0x94cc] = "ní"; /* 铌 */
dict[0x94cd] = "pí,pī"; /* 铍 */
dict[0x94ce] = "duó"; /* 铎 */
dict[0x94cf] = "xíng"; /* 铏 */
dict[0x94d0] = "kào"; /* 铐 */
dict[0x94d1] = "lǎo"; /* 铑 */
dict[0x94d2] = "ěr"; /* 铒 */
dict[0x94d3] = "máng"; /* 铓 */
dict[0x94d4] = "yā,yà"; /* 铔 */
dict[0x94d5] = "yǒu"; /* 铕 */
dict[0x94d6] = "chéng"; /* 铖 */
dict[0x94d7] = "jiá"; /* 铗 */
dict[0x94d8] = "yé"; /* 铘 */
dict[0x94d9] = "náo"; /* 铙 */
dict[0x94da] = "zhì"; /* 铚 */
dict[0x94db] = "dāng,chēng"; /* 铛 */
dict[0x94dc] = "tóng"; /* 铜 */
dict[0x94dd] = "lǚ"; /* 铝 */
dict[0x94de] = "diào"; /* 铞 */
dict[0x94df] = "yīn"; /* 铟 */
dict[0x94e0] = "kǎi"; /* 铠 */
dict[0x94e1] = "zhá"; /* 铡 */
dict[0x94e2] = "zhū"; /* 铢 */
dict[0x94e3] = "xiǎn,xǐ"; /* 铣 */
dict[0x94e4] = "tǐng,dìng"; /* 铤 */
dict[0x94e5] = "diū"; /* 铥 */
dict[0x94e6] = "xiān,kuò,tiǎn,guā"; /* 铦 */
dict[0x94e7] = "huá"; /* 铧 */
dict[0x94e8] = "quán"; /* 铨 */
dict[0x94e9] = "shā"; /* 铩 */
dict[0x94ea] = "hā,kē"; /* 铪 */
dict[0x94eb] = "diào,tiáo,yáo"; /* 铫 */
dict[0x94ec] = "gè"; /* 铬 */
dict[0x94ed] = "míng"; /* 铭 */
dict[0x94ee] = "zhēng"; /* 铮 */
dict[0x94ef] = "sè"; /* 铯 */
dict[0x94f0] = "jiǎo"; /* 铰 */
dict[0x94f1] = "yī"; /* 铱 */
dict[0x94f2] = "chǎn"; /* 铲 */
dict[0x94f3] = "chòng"; /* 铳 */
dict[0x94f4] = "tàng,tāng"; /* 铴 */
dict[0x94f5] = "ǎn"; /* 铵 */
dict[0x94f6] = "yín"; /* 银 */
dict[0x94f7] = "rú"; /* 铷 */
dict[0x94f8] = "zhù"; /* 铸 */
dict[0x94f9] = "láo"; /* 铹 */
dict[0x94fa] = "pū,pù"; /* 铺 */
dict[0x94fb] = "wú"; /* 铻 */
dict[0x94fc] = "lái"; /* 铼 */
dict[0x94fd] = "tè"; /* 铽 */
dict[0x94fe] = "liàn"; /* 链 */
dict[0x94ff] = "kēng"; /* 铿 */
dict[0x9500] = "xiāo"; /* 销 */
dict[0x9501] = "suǒ"; /* 锁 */
dict[0x9502] = "lǐ"; /* 锂 */
dict[0x9503] = "zèng"; /* 锃 */
dict[0x9504] = "chú"; /* 锄 */
dict[0x9505] = "guō"; /* 锅 */
dict[0x9506] = "gào"; /* 锆 */
dict[0x9507] = "é"; /* 锇 */
dict[0x9508] = "xiù"; /* 锈 */
dict[0x9509] = "cuò"; /* 锉 */
dict[0x950a] = "lüè"; /* 锊 */
dict[0x950b] = "fēng"; /* 锋 */
dict[0x950c] = "xīn"; /* 锌 */
dict[0x950d] = "liǔ"; /* 锍 */
dict[0x950e] = "kāi"; /* 锎 */
dict[0x950f] = "jiǎn"; /* 锏 */
dict[0x9510] = "ruì"; /* 锐 */
dict[0x9511] = "tī"; /* 锑 */
dict[0x9512] = "láng"; /* 锒 */
dict[0x9513] = "qǐn"; /* 锓 */
dict[0x9514] = "jū"; /* 锔 */
dict[0x9515] = "ā"; /* 锕 */
dict[0x9516] = "qiāng"; /* 锖 */
dict[0x9517] = "zhě"; /* 锗 */
dict[0x9518] = "nuò"; /* 锘 */
dict[0x9519] = "cuò"; /* 错 */
dict[0x951a] = "máo"; /* 锚 */
dict[0x951b] = "bēn"; /* 锛 */
dict[0x951c] = "qí"; /* 锜 */
dict[0x951d] = "dé"; /* 锝 */
dict[0x951e] = "kè"; /* 锞 */
dict[0x951f] = "kūn"; /* 锟 */
dict[0x9520] = "chāng"; /* 锠 */
dict[0x9521] = "xī"; /* 锡 */
dict[0x9522] = "gù"; /* 锢 */
dict[0x9523] = "luó"; /* 锣 */
dict[0x9524] = "chuí"; /* 锤 */
dict[0x9525] = "zhuī"; /* 锥 */
dict[0x9526] = "jǐn"; /* 锦 */
dict[0x9527] = "zhì"; /* 锧 */
dict[0x9528] = "xiān"; /* 锨 */
dict[0x9529] = "juǎn"; /* 锩 */
dict[0x952a] = "huò"; /* 锪 */
dict[0x952b] = "péi"; /* 锫 */
dict[0x952c] = "tán"; /* 锬 */
dict[0x952d] = "dìng"; /* 锭 */
dict[0x952e] = "jiàn"; /* 键 */
dict[0x952f] = "jù"; /* 锯 */
dict[0x9530] = "měng"; /* 锰 */
dict[0x9531] = "zī"; /* 锱 */
dict[0x9532] = "qiè"; /* 锲 */
dict[0x9533] = "yīng"; /* 锳 */
dict[0x9534] = "kǎi"; /* 锴 */
dict[0x9535] = "qiāng"; /* 锵 */
dict[0x9536] = "sī"; /* 锶 */
dict[0x9537] = "è"; /* 锷 */
dict[0x9538] = "chā"; /* 锸 */
dict[0x9539] = "qiāo"; /* 锹 */
dict[0x953a] = "zhōng"; /* 锺 */
dict[0x953b] = "duàn"; /* 锻 */
dict[0x953c] = "sōu"; /* 锼 */
dict[0x953d] = "huáng"; /* 锽 */
dict[0x953e] = "huán"; /* 锾 */
dict[0x953f] = "āi"; /* 锿 */
dict[0x9540] = "dù"; /* 镀 */
dict[0x9541] = "měi"; /* 镁 */
dict[0x9542] = "lòu"; /* 镂 */
dict[0x9543] = "zī"; /* 镃 */
dict[0x9544] = "fèi"; /* 镄 */
dict[0x9545] = "méi"; /* 镅 */
dict[0x9546] = "mò"; /* 镆 */
dict[0x9547] = "zhèn"; /* 镇 */
dict[0x9548] = "bó"; /* 镈 */
dict[0x9549] = "gé,lì"; /* 镉 */
dict[0x954a] = "niè"; /* 镊 */
dict[0x954b] = "tǎng"; /* 镋 */
dict[0x954c] = "juān"; /* 镌 */
dict[0x954d] = "niè"; /* 镍 */
dict[0x954e] = "ná"; /* 镎 */
dict[0x954f] = "liú"; /* 镏 */
dict[0x9550] = "gǎo,hào"; /* 镐 */
dict[0x9551] = "bàng"; /* 镑 */
dict[0x9552] = "yì"; /* 镒 */
dict[0x9553] = "jiā"; /* 镓 */
dict[0x9554] = "bīn"; /* 镔 */
dict[0x9555] = "róng"; /* 镕 */
dict[0x9556] = "biāo"; /* 镖 */
dict[0x9557] = "tāng"; /* 镗 */
dict[0x9558] = "màn"; /* 镘 */
dict[0x9559] = "luó"; /* 镙 */
dict[0x955a] = "bèng"; /* 镚 */
dict[0x955b] = "yōng"; /* 镛 */
dict[0x955c] = "jìng"; /* 镜 */
dict[0x955d] = "dí"; /* 镝 */
dict[0x955e] = "zú"; /* 镞 */
dict[0x955f] = "xuàn"; /* 镟 */
dict[0x9560] = "liú"; /* 镠 */
dict[0x9561] = "xín"; /* 镡 */
dict[0x9562] = "jué"; /* 镢 */
dict[0x9563] = "liào"; /* 镣 */
dict[0x9564] = "pú"; /* 镤 */
dict[0x9565] = "lǔ"; /* 镥 */
dict[0x9566] = "duī"; /* 镦 */
dict[0x9567] = "lán"; /* 镧 */
dict[0x9568] = "pǔ"; /* 镨 */
dict[0x9569] = "cuān"; /* 镩 */
dict[0x956a] = "qiǎng"; /* 镪 */
dict[0x956b] = "dèng"; /* 镫 */
dict[0x956c] = "huò"; /* 镬 */
dict[0x956d] = "léi"; /* 镭 */
dict[0x956e] = "huán"; /* 镮 */
dict[0x956f] = "zhuó"; /* 镯 */
dict[0x9570] = "lián"; /* 镰 */
dict[0x9571] = "yì"; /* 镱 */
dict[0x9572] = "chǎ"; /* 镲 */
dict[0x9573] = "biāo"; /* 镳 */
dict[0x9574] = "là"; /* 镴 */
dict[0x9575] = "chán"; /* 镵 */
dict[0x9576] = "xiāng"; /* 镶 */
dict[0x9577] = "cháng,zhǎng"; /* 長 */
dict[0x9578] = "cháng"; /* 镸 */
dict[0x9579] = "jiǔ"; /* 镹 */
dict[0x957a] = "ǎo"; /* 镺 */
dict[0x957b] = "dié"; /* 镻 */
dict[0x957c] = "jié"; /* 镼 */
dict[0x957d] = "liǎo"; /* 镽 */
dict[0x957e] = "mí"; /* 镾 */
dict[0x957f] = "cháng,zhǎng"; /* 长 */
dict[0x9580] = "mén"; /* 門 */
dict[0x9581] = "mà"; /* 閁 */
dict[0x9582] = "shuān"; /* 閂 */
dict[0x9583] = "shǎn"; /* 閃 */
dict[0x9584] = "huò,shǎn"; /* 閄 */
dict[0x9585] = "mén"; /* 閅 */
dict[0x9586] = "yán"; /* 閆 */
dict[0x9587] = "bì"; /* 閇 */
dict[0x9588] = "hàn,bì"; /* 閈 */
dict[0x9589] = "bì"; /* 閉 */
dict[0x958a] = "shān"; /* 閊 */
dict[0x958b] = "kāi"; /* 開 */
dict[0x958c] = "kāng,kàng"; /* 閌 */
dict[0x958d] = "bēng"; /* 閍 */
dict[0x958e] = "hóng"; /* 閎 */
dict[0x958f] = "rùn"; /* 閏 */
dict[0x9590] = "sàn"; /* 閐 */
dict[0x9591] = "xián"; /* 閑 */
dict[0x9592] = "xián,jiān,jiàn"; /* 閒 */
dict[0x9593] = "jiān,jiàn"; /* 間 */
dict[0x9594] = "mǐn"; /* 閔 */
dict[0x9595] = "xiā,xiǎ"; /* 閕 */
dict[0x9596] = "shuǐ"; /* 閖 */
dict[0x9597] = "dòu"; /* 閗 */
dict[0x9598] = "zhá"; /* 閘 */
dict[0x9599] = "nào"; /* 閙 */
dict[0x959a] = "zhān"; /* 閚 */
dict[0x959b] = "pēng,pèng"; /* 閛 */
dict[0x959c] = "xiǎ,kě"; /* 閜 */
dict[0x959d] = "líng"; /* 閝 */
dict[0x959e] = "biàn,guān"; /* 閞 */
dict[0x959f] = "bì"; /* 閟 */
dict[0x95a0] = "rùn"; /* 閠 */
dict[0x95a1] = "hé"; /* 閡 */
dict[0x95a2] = "guān"; /* 関 */
dict[0x95a3] = "gé"; /* 閣 */
dict[0x95a4] = "hé,gé"; /* 閤 */
dict[0x95a5] = "fá"; /* 閥 */
dict[0x95a6] = "chù"; /* 閦 */
dict[0x95a7] = "hòng,xiàng"; /* 閧 */
dict[0x95a8] = "guī"; /* 閨 */
dict[0x95a9] = "mǐn"; /* 閩 */
dict[0x95aa] = "sē,xī"; /* 閪 */
dict[0x95ab] = "kǔn"; /* 閫 */
dict[0x95ac] = "làng"; /* 閬 */
dict[0x95ad] = "lǘ"; /* 閭 */
dict[0x95ae] = "tíng,tǐng"; /* 閮 */
dict[0x95af] = "shà"; /* 閯 */
dict[0x95b0] = "jú"; /* 閰 */
dict[0x95b1] = "yuè"; /* 閱 */
dict[0x95b2] = "yuè"; /* 閲 */
dict[0x95b3] = "chǎn"; /* 閳 */
dict[0x95b4] = "qù"; /* 閴 */
dict[0x95b5] = "lìn"; /* 閵 */
dict[0x95b6] = "chāng"; /* 閶 */
dict[0x95b7] = "shā"; /* 閷 */
dict[0x95b8] = "kǔn"; /* 閸 */
dict[0x95b9] = "yān"; /* 閹 */
dict[0x95ba] = "wén"; /* 閺 */
dict[0x95bb] = "yán"; /* 閻 */
dict[0x95bc] = "è,yān"; /* 閼 */
dict[0x95bd] = "hūn"; /* 閽 */
dict[0x95be] = "yù"; /* 閾 */
dict[0x95bf] = "wén"; /* 閿 */
dict[0x95c0] = "hòng"; /* 闀 */
dict[0x95c1] = "bāo"; /* 闁 */
dict[0x95c2] = "hòng,juǎn,xiàng"; /* 闂 */
dict[0x95c3] = "qù"; /* 闃 */
dict[0x95c4] = "yǎo"; /* 闄 */
dict[0x95c5] = "wén"; /* 闅 */
dict[0x95c6] = "bǎn,pàn"; /* 闆 */
dict[0x95c7] = "àn"; /* 闇 */
dict[0x95c8] = "wéi"; /* 闈 */
dict[0x95c9] = "yīn"; /* 闉 */
dict[0x95ca] = "kuò"; /* 闊 */
dict[0x95cb] = "què"; /* 闋 */
dict[0x95cc] = "lán"; /* 闌 */
dict[0x95cd] = "dū,shé"; /* 闍 */
dict[0x95ce] = "quán"; /* 闎 */
dict[0x95d0] = "tián"; /* 闐 */
dict[0x95d1] = "niè"; /* 闑 */
dict[0x95d2] = "tà"; /* 闒 */
dict[0x95d3] = "kǎi"; /* 闓 */
dict[0x95d4] = "hé"; /* 闔 */
dict[0x95d5] = "què,quē"; /* 闕 */
dict[0x95d6] = "chuǎng"; /* 闖 */
dict[0x95d7] = "guān"; /* 闗 */
dict[0x95d8] = "dòu"; /* 闘 */
dict[0x95d9] = "qǐ"; /* 闙 */
dict[0x95da] = "kuī"; /* 闚 */
dict[0x95db] = "táng,tāng,chāng"; /* 闛 */
dict[0x95dc] = "guān"; /* 關 */
dict[0x95dd] = "piáo"; /* 闝 */
dict[0x95de] = "kàn,hǎn"; /* 闞 */
dict[0x95df] = "xì,sè,tà"; /* 闟 */
dict[0x95e0] = "huì"; /* 闠 */
dict[0x95e1] = "chǎn"; /* 闡 */
dict[0x95e2] = "pì"; /* 闢 */
dict[0x95e3] = "dāng,dàng"; /* 闣 */
dict[0x95e4] = "huán"; /* 闤 */
dict[0x95e5] = "tà"; /* 闥 */
dict[0x95e6] = "wén"; /* 闦 */
dict[0x95e7] = "tā"; /* 闧 */
dict[0x95e8] = "mén"; /* 门 */
dict[0x95e9] = "shuān"; /* 闩 */
dict[0x95ea] = "shǎn"; /* 闪 */
dict[0x95eb] = "yán"; /* 闫 */
dict[0x95ec] = "hàn,bì"; /* 闬 */
dict[0x95ed] = "bì"; /* 闭 */
dict[0x95ee] = "wèn"; /* 问 */
dict[0x95ef] = "chuǎng"; /* 闯 */
dict[0x95f0] = "rùn"; /* 闰 */
dict[0x95f1] = "wéi"; /* 闱 */
dict[0x95f2] = "xián"; /* 闲 */
dict[0x95f3] = "hóng"; /* 闳 */
dict[0x95f4] = "jiān,jiàn"; /* 间 */
dict[0x95f5] = "mǐn"; /* 闵 */
dict[0x95f6] = "kàng,kāng"; /* 闶 */
dict[0x95f7] = "mèn,mēn"; /* 闷 */
dict[0x95f8] = "zhá"; /* 闸 */
dict[0x95f9] = "nào"; /* 闹 */
dict[0x95fa] = "guī"; /* 闺 */
dict[0x95fb] = "wén"; /* 闻 */
dict[0x95fc] = "tà"; /* 闼 */
dict[0x95fd] = "mǐn"; /* 闽 */
dict[0x95fe] = "lǘ"; /* 闾 */
dict[0x95ff] = "kǎi"; /* 闿 */
dict[0x9600] = "fá"; /* 阀 */
dict[0x9601] = "gé"; /* 阁 */
dict[0x9602] = "hé"; /* 阂 */
dict[0x9603] = "kǔn"; /* 阃 */
dict[0x9604] = "jiū"; /* 阄 */
dict[0x9605] = "yuè"; /* 阅 */
dict[0x9606] = "làng"; /* 阆 */
dict[0x9607] = "dū,shé"; /* 阇 */
dict[0x9608] = "yù"; /* 阈 */
dict[0x9609] = "yān"; /* 阉 */
dict[0x960a] = "chāng"; /* 阊 */
dict[0x960b] = "xì"; /* 阋 */
dict[0x960c] = "wén"; /* 阌 */
dict[0x960d] = "hūn"; /* 阍 */
dict[0x960e] = "yán"; /* 阎 */
dict[0x960f] = "è"; /* 阏 */
dict[0x9610] = "chǎn"; /* 阐 */
dict[0x9611] = "lán"; /* 阑 */
dict[0x9612] = "qù"; /* 阒 */
dict[0x9613] = "huì"; /* 阓 */
dict[0x9614] = "kuò"; /* 阔 */
dict[0x9615] = "què"; /* 阕 */
dict[0x9616] = "hé"; /* 阖 */
dict[0x9617] = "tián"; /* 阗 */
dict[0x9618] = "tà"; /* 阘 */
dict[0x9619] = "quē,què"; /* 阙 */
dict[0x961a] = "kàn"; /* 阚 */
dict[0x961b] = "huán"; /* 阛 */
dict[0x961c] = "fù"; /* 阜 */
dict[0x961d] = "fǔ"; /* 阝 */
dict[0x961e] = "lè"; /* 阞 */
dict[0x961f] = "duì"; /* 队 */
dict[0x9620] = "xìn"; /* 阠 */
dict[0x9621] = "qiān"; /* 阡 */
dict[0x9622] = "wù"; /* 阢 */
dict[0x9623] = "yì"; /* 阣 */
dict[0x9624] = "tuó"; /* 阤 */
dict[0x9625] = "yīn"; /* 阥 */
dict[0x9626] = "yáng"; /* 阦 */
dict[0x9627] = "dǒu"; /* 阧 */
dict[0x9628] = "è"; /* 阨 */
dict[0x9629] = "shēng"; /* 阩 */
dict[0x962a] = "bǎn"; /* 阪 */
dict[0x962b] = "péi"; /* 阫 */
dict[0x962c] = "kēng"; /* 阬 */
dict[0x962d] = "yǔn"; /* 阭 */
dict[0x962e] = "ruǎn"; /* 阮 */
dict[0x962f] = "zhǐ"; /* 阯 */
dict[0x9630] = "pí"; /* 阰 */
dict[0x9631] = "jǐng"; /* 阱 */
dict[0x9632] = "fáng"; /* 防 */
dict[0x9633] = "yáng"; /* 阳 */
dict[0x9634] = "yīn"; /* 阴 */
dict[0x9635] = "zhèn"; /* 阵 */
dict[0x9636] = "jiē"; /* 阶 */
dict[0x9637] = "chēng"; /* 阷 */
dict[0x9638] = "è"; /* 阸 */
dict[0x9639] = "qū"; /* 阹 */
dict[0x963a] = "dǐ"; /* 阺 */
dict[0x963b] = "zǔ"; /* 阻 */
dict[0x963c] = "zuò"; /* 阼 */
dict[0x963d] = "diàn"; /* 阽 */
dict[0x963e] = "lín"; /* 阾 */
dict[0x963f] = "ā,ē"; /* 阿 */
dict[0x9640] = "tuó"; /* 陀 */
dict[0x9641] = "tuó"; /* 陁 */
dict[0x9642] = "bēi,pí,pō"; /* 陂 */
dict[0x9643] = "bǐng"; /* 陃 */
dict[0x9644] = "fù"; /* 附 */
dict[0x9645] = "jì"; /* 际 */
dict[0x9646] = "lù"; /* 陆 */
dict[0x9647] = "lǒng"; /* 陇 */
dict[0x9648] = "chén"; /* 陈 */
dict[0x9649] = "xíng"; /* 陉 */
dict[0x964a] = "duò"; /* 陊 */
dict[0x964b] = "lòu"; /* 陋 */
dict[0x964c] = "mò"; /* 陌 */
dict[0x964d] = "jiàng,xiáng"; /* 降 */
dict[0x964e] = "shū"; /* 陎 */
dict[0x964f] = "duò"; /* 陏 */
dict[0x9650] = "xiàn"; /* 限 */
dict[0x9651] = "ér"; /* 陑 */
dict[0x9652] = "guǐ"; /* 陒 */
dict[0x9653] = "yū"; /* 陓 */
dict[0x9654] = "gāi"; /* 陔 */
dict[0x9655] = "shǎn"; /* 陕 */
dict[0x9656] = "jùn"; /* 陖 */
dict[0x9657] = "qiào"; /* 陗 */
dict[0x9658] = "xíng"; /* 陘 */
dict[0x9659] = "chún"; /* 陙 */
dict[0x965a] = "wǔ"; /* 陚 */
dict[0x965b] = "bì"; /* 陛 */
dict[0x965c] = "xiá"; /* 陜 */
dict[0x965d] = "shǎn"; /* 陝 */
dict[0x965e] = "shēng"; /* 陞 */
dict[0x965f] = "zhì"; /* 陟 */
dict[0x9660] = "pū"; /* 陠 */
dict[0x9661] = "dǒu"; /* 陡 */
dict[0x9662] = "yuàn"; /* 院 */
dict[0x9663] = "zhèn"; /* 陣 */
dict[0x9664] = "chú"; /* 除 */
dict[0x9665] = "xiàn"; /* 陥 */
dict[0x9666] = "dǎo"; /* 陦 */
dict[0x9667] = "niè"; /* 陧 */
dict[0x9668] = "yǔn"; /* 陨 */
dict[0x9669] = "xiǎn"; /* 险 */
dict[0x966a] = "péi"; /* 陪 */
dict[0x966b] = "fèi"; /* 陫 */
dict[0x966c] = "zōu"; /* 陬 */
dict[0x966d] = "qí"; /* 陭 */
dict[0x966e] = "duì"; /* 陮 */
dict[0x966f] = "lún"; /* 陯 */
dict[0x9670] = "yīn"; /* 陰 */
dict[0x9671] = "jū"; /* 陱 */
dict[0x9672] = "chuí"; /* 陲 */
dict[0x9673] = "chén"; /* 陳 */
dict[0x9674] = "pī"; /* 陴 */
dict[0x9675] = "líng"; /* 陵 */
dict[0x9676] = "táo"; /* 陶 */
dict[0x9677] = "xiàn"; /* 陷 */
dict[0x9678] = "lù"; /* 陸 */
dict[0x9679] = "shēng"; /* 陹 */
dict[0x967a] = "xiǎn"; /* 険 */
dict[0x967b] = "yīn"; /* 陻 */
dict[0x967c] = "zhǔ"; /* 陼 */
dict[0x967d] = "yáng"; /* 陽 */
dict[0x967e] = "réng"; /* 陾 */
dict[0x967f] = "xiá"; /* 陿 */
dict[0x9680] = "chóng"; /* 隀 */
dict[0x9681] = "yàn,yǎn"; /* 隁 */
dict[0x9682] = "yīn"; /* 隂 */
dict[0x9683] = "yú,yáo,shù"; /* 隃 */
dict[0x9684] = "dī"; /* 隄 */
dict[0x9685] = "yú"; /* 隅 */
dict[0x9686] = "lóng"; /* 隆 */
dict[0x9687] = "wēi"; /* 隇 */
dict[0x9688] = "wēi"; /* 隈 */
dict[0x9689] = "niè"; /* 隉 */
dict[0x968a] = "duì,zhuì"; /* 隊 */
dict[0x968b] = "suí,duò"; /* 隋 */
dict[0x968c] = "àn"; /* 隌 */
dict[0x968d] = "huáng"; /* 隍 */
dict[0x968e] = "jiē"; /* 階 */
dict[0x968f] = "suí"; /* 随 */
dict[0x9690] = "yǐn,yìn"; /* 隐 */
dict[0x9691] = "qí,gāi,ái"; /* 隑 */
dict[0x9692] = "yǎn"; /* 隒 */
dict[0x9693] = "huī,duò"; /* 隓 */
dict[0x9694] = "gé"; /* 隔 */
dict[0x9695] = "yǔn"; /* 隕 */
dict[0x9696] = "wù"; /* 隖 */
dict[0x9697] = "wěi,kuí"; /* 隗 */
dict[0x9698] = "ài"; /* 隘 */
dict[0x9699] = "xì"; /* 隙 */
dict[0x969a] = "táng"; /* 隚 */
dict[0x969b] = "jì"; /* 際 */
dict[0x969c] = "zhàng"; /* 障 */
dict[0x969d] = "dǎo"; /* 隝 */
dict[0x969e] = "áo"; /* 隞 */
dict[0x969f] = "xì"; /* 隟 */
dict[0x96a0] = "yǐn,yìn"; /* 隠 */
dict[0x96a1] = "sà"; /* 隡 */
dict[0x96a2] = "rǎo"; /* 隢 */
dict[0x96a3] = "lín"; /* 隣 */
dict[0x96a4] = "tuí"; /* 隤 */
dict[0x96a5] = "dèng"; /* 隥 */
dict[0x96a6] = "pí"; /* 隦 */
dict[0x96a7] = "suì"; /* 隧 */
dict[0x96a8] = "suí"; /* 隨 */
dict[0x96a9] = "ào,yù"; /* 隩 */
dict[0x96aa] = "xiǎn"; /* 險 */
dict[0x96ab] = "fén"; /* 隫 */
dict[0x96ac] = "nǐ"; /* 隬 */
dict[0x96ad] = "ér"; /* 隭 */
dict[0x96ae] = "jī"; /* 隮 */
dict[0x96af] = "dǎo"; /* 隯 */
dict[0x96b0] = "xí"; /* 隰 */
dict[0x96b1] = "yǐn,yìn"; /* 隱 */
dict[0x96b2] = "zhì"; /* 隲 */
dict[0x96b3] = "huī,duò"; /* 隳 */
dict[0x96b4] = "lǒng"; /* 隴 */
dict[0x96b5] = "xī"; /* 隵 */
dict[0x96b6] = "lì"; /* 隶 */
dict[0x96b7] = "lì"; /* 隷 */
dict[0x96b8] = "lì"; /* 隸 */
dict[0x96b9] = "zhuī,cuī,wéi"; /* 隹 */
dict[0x96ba] = "hú,hè"; /* 隺 */
dict[0x96bb] = "zhī"; /* 隻 */
dict[0x96bc] = "sǔn"; /* 隼 */
dict[0x96bd] = "jùn,juàn"; /* 隽 */
dict[0x96be] = "nán,nàn,nuó"; /* 难 */
dict[0x96bf] = "yì"; /* 隿 */
dict[0x96c0] = "què,qiāo,qiǎo"; /* 雀 */
dict[0x96c1] = "yàn"; /* 雁 */
dict[0x96c2] = "qín"; /* 雂 */
dict[0x96c3] = "jiān"; /* 雃 */
dict[0x96c4] = "xióng"; /* 雄 */
dict[0x96c5] = "yǎ"; /* 雅 */
dict[0x96c6] = "jí"; /* 集 */
dict[0x96c7] = "gù"; /* 雇 */
dict[0x96c8] = "huán"; /* 雈 */
dict[0x96c9] = "zhì"; /* 雉 */
dict[0x96ca] = "gòu"; /* 雊 */
dict[0x96cb] = "jùn,juàn"; /* 雋 */
dict[0x96cc] = "cí"; /* 雌 */
dict[0x96cd] = "yōng"; /* 雍 */
dict[0x96ce] = "jū"; /* 雎 */
dict[0x96cf] = "chú"; /* 雏 */
dict[0x96d0] = "hū"; /* 雐 */
dict[0x96d1] = "zá"; /* 雑 */
dict[0x96d2] = "luò"; /* 雒 */
dict[0x96d3] = "yú"; /* 雓 */
dict[0x96d4] = "chóu"; /* 雔 */
dict[0x96d5] = "diāo"; /* 雕 */
dict[0x96d6] = "suī"; /* 雖 */
dict[0x96d7] = "hàn"; /* 雗 */
dict[0x96d8] = "huò"; /* 雘 */
dict[0x96d9] = "shuāng"; /* 雙 */
dict[0x96da] = "guàn,huán"; /* 雚 */
dict[0x96db] = "chú"; /* 雛 */
dict[0x96dc] = "zá"; /* 雜 */
dict[0x96dd] = "yōng"; /* 雝 */
dict[0x96de] = "jī"; /* 雞 */
dict[0x96df] = "guī,xī"; /* 雟 */
dict[0x96e0] = "chóu"; /* 雠 */
dict[0x96e1] = "liù"; /* 雡 */
dict[0x96e2] = "lí"; /* 離 */
dict[0x96e3] = "nán,nàn,nuó"; /* 難 */
dict[0x96e4] = "yù"; /* 雤 */
dict[0x96e5] = "zá"; /* 雥 */
dict[0x96e6] = "chóu"; /* 雦 */
dict[0x96e7] = "jí"; /* 雧 */
dict[0x96e8] = "yǔ,yù"; /* 雨 */
dict[0x96e9] = "yú"; /* 雩 */
dict[0x96ea] = "xuě"; /* 雪 */
dict[0x96eb] = "nǎ"; /* 雫 */
dict[0x96ec] = "fǒu"; /* 雬 */
dict[0x96ed] = "sè,xí"; /* 雭 */
dict[0x96ee] = "mù"; /* 雮 */
dict[0x96ef] = "wén"; /* 雯 */
dict[0x96f0] = "fēn"; /* 雰 */
dict[0x96f1] = "pāng"; /* 雱 */
dict[0x96f2] = "yún"; /* 雲 */
dict[0x96f3] = "lì"; /* 雳 */
dict[0x96f4] = "chì"; /* 雴 */
dict[0x96f5] = "yāng"; /* 雵 */
dict[0x96f6] = "líng"; /* 零 */
dict[0x96f7] = "léi"; /* 雷 */
dict[0x96f8] = "án"; /* 雸 */
dict[0x96f9] = "báo"; /* 雹 */
dict[0x96fa] = "wù,méng"; /* 雺 */
dict[0x96fb] = "diàn"; /* 電 */
dict[0x96fc] = "dàng"; /* 雼 */
dict[0x96fd] = "hū,hù"; /* 雽 */
dict[0x96fe] = "wù"; /* 雾 */
dict[0x96ff] = "diào"; /* 雿 */
dict[0x9700] = "xū"; /* 需 */
dict[0x9701] = "jì"; /* 霁 */
dict[0x9702] = "mù"; /* 霂 */
dict[0x9703] = "chén"; /* 霃 */
dict[0x9704] = "xiāo"; /* 霄 */
dict[0x9705] = "zhá"; /* 霅 */
dict[0x9706] = "tíng"; /* 霆 */
dict[0x9707] = "zhèn"; /* 震 */
dict[0x9708] = "pèi"; /* 霈 */
dict[0x9709] = "méi"; /* 霉 */
dict[0x970a] = "líng"; /* 霊 */
dict[0x970b] = "qī"; /* 霋 */
dict[0x970c] = "zhōu"; /* 霌 */
dict[0x970d] = "huò"; /* 霍 */
dict[0x970e] = "shà"; /* 霎 */
dict[0x970f] = "fēi"; /* 霏 */
dict[0x9710] = "hóng"; /* 霐 */
dict[0x9711] = "zhān"; /* 霑 */
dict[0x9712] = "yīn"; /* 霒 */
dict[0x9713] = "ní"; /* 霓 */
dict[0x9714] = "shù"; /* 霔 */
dict[0x9715] = "tún"; /* 霕 */
dict[0x9716] = "lín"; /* 霖 */
dict[0x9717] = "líng"; /* 霗 */
dict[0x9718] = "dòng"; /* 霘 */
dict[0x9719] = "yīng"; /* 霙 */
dict[0x971a] = "wù"; /* 霚 */
dict[0x971b] = "líng"; /* 霛 */
dict[0x971c] = "shuāng"; /* 霜 */
dict[0x971d] = "líng"; /* 霝 */
dict[0x971e] = "xiá"; /* 霞 */
dict[0x971f] = "hóng"; /* 霟 */
dict[0x9720] = "yīn"; /* 霠 */
dict[0x9721] = "mài"; /* 霡 */
dict[0x9722] = "mài"; /* 霢 */
dict[0x9723] = "yǔn"; /* 霣 */
dict[0x9724] = "liù"; /* 霤 */
dict[0x9725] = "mèng"; /* 霥 */
dict[0x9726] = "bīn"; /* 霦 */
dict[0x9727] = "wù"; /* 霧 */
dict[0x9728] = "wèi"; /* 霨 */
dict[0x9729] = "kuò"; /* 霩 */
dict[0x972a] = "yín"; /* 霪 */
dict[0x972b] = "xí"; /* 霫 */
dict[0x972c] = "yì"; /* 霬 */
dict[0x972d] = "ǎi"; /* 霭 */
dict[0x972e] = "dàn"; /* 霮 */
dict[0x972f] = "tèng"; /* 霯 */
dict[0x9730] = "xiàn"; /* 霰 */
dict[0x9731] = "yù"; /* 霱 */
dict[0x9732] = "lòu,lù"; /* 露 */
dict[0x9733] = "lóng"; /* 霳 */
dict[0x9734] = "dài"; /* 霴 */
dict[0x9735] = "jí"; /* 霵 */
dict[0x9736] = "pāng"; /* 霶 */
dict[0x9737] = "yáng"; /* 霷 */
dict[0x9738] = "bà"; /* 霸 */
dict[0x9739] = "pī"; /* 霹 */
dict[0x973a] = "wēi"; /* 霺 */
dict[0x973b] = "fēng"; /* 霻 */
dict[0x973c] = "xì"; /* 霼 */
dict[0x973d] = "jì"; /* 霽 */
dict[0x973e] = "mái"; /* 霾 */
dict[0x973f] = "méng"; /* 霿 */
dict[0x9740] = "méng"; /* 靀 */
dict[0x9741] = "léi"; /* 靁 */
dict[0x9742] = "lì"; /* 靂 */
dict[0x9743] = "huò"; /* 靃 */
dict[0x9744] = "ǎi"; /* 靄 */
dict[0x9745] = "fèi"; /* 靅 */
dict[0x9746] = "dài"; /* 靆 */
dict[0x9747] = "lóng"; /* 靇 */
dict[0x9748] = "lìng"; /* 靈 */
dict[0x9749] = "ài"; /* 靉 */
dict[0x974a] = "fēng"; /* 靊 */
dict[0x974b] = "lì"; /* 靋 */
dict[0x974c] = "bǎo"; /* 靌 */
dict[0x974d] = "hè"; /* 靍 */
dict[0x974e] = "hè"; /* 靎 */
dict[0x974f] = "hè"; /* 靏 */
dict[0x9750] = "bìng"; /* 靐 */
dict[0x9751] = "qīng"; /* 靑 */
dict[0x9752] = "qīng"; /* 青 */
dict[0x9753] = "jìng,liàng"; /* 靓 */
dict[0x9754] = "tiān"; /* 靔 */
dict[0x9755] = "zhèng"; /* 靕 */
dict[0x9756] = "jìng"; /* 靖 */
dict[0x9757] = "chēng"; /* 靗 */
dict[0x9758] = "qìng"; /* 靘 */
dict[0x9759] = "jìng"; /* 静 */
dict[0x975a] = "jìng"; /* 靚 */
dict[0x975b] = "diàn"; /* 靛 */
dict[0x975c] = "jìng"; /* 靜 */
dict[0x975d] = "tiān"; /* 靝 */
dict[0x975e] = "fēi"; /* 非 */
dict[0x975f] = "fēi"; /* 靟 */
dict[0x9760] = "kào"; /* 靠 */
dict[0x9761] = "mí"; /* 靡 */
dict[0x9762] = "miàn"; /* 面 */
dict[0x9763] = "miàn"; /* 靣 */
dict[0x9764] = "pào"; /* 靤 */
dict[0x9765] = "yè"; /* 靥 */
dict[0x9766] = "miǎn"; /* 靦 */
dict[0x9767] = "huì"; /* 靧 */
dict[0x9768] = "yè"; /* 靨 */
dict[0x9769] = "gé"; /* 革 */
dict[0x976a] = "dīng"; /* 靪 */
dict[0x976b] = "chá"; /* 靫 */
dict[0x976c] = "jiān"; /* 靬 */
dict[0x976d] = "rèn"; /* 靭 */
dict[0x976e] = "dí"; /* 靮 */
dict[0x976f] = "dù"; /* 靯 */
dict[0x9770] = "wù"; /* 靰 */
dict[0x9771] = "rèn"; /* 靱 */
dict[0x9772] = "qín"; /* 靲 */
dict[0x9773] = "jìn"; /* 靳 */
dict[0x9774] = "xuē"; /* 靴 */
dict[0x9775] = "niǔ"; /* 靵 */
dict[0x9776] = "bǎ"; /* 靶 */
dict[0x9777] = "yǐn"; /* 靷 */
dict[0x9778] = "sǎ"; /* 靸 */
dict[0x9779] = "nà"; /* 靹 */
dict[0x977a] = "mò"; /* 靺 */
dict[0x977b] = "zǔ"; /* 靻 */
dict[0x977c] = "dá"; /* 靼 */
dict[0x977d] = "bàn"; /* 靽 */
dict[0x977e] = "xiè"; /* 靾 */
dict[0x977f] = "yào"; /* 靿 */
dict[0x9780] = "táo"; /* 鞀 */
dict[0x9781] = "bèi"; /* 鞁 */
dict[0x9782] = "jiē"; /* 鞂 */
dict[0x9783] = "hóng"; /* 鞃 */
dict[0x9784] = "páo"; /* 鞄 */
dict[0x9785] = "yāng,yàng"; /* 鞅 */
dict[0x9786] = "bǐng"; /* 鞆 */
dict[0x9787] = "yīn"; /* 鞇 */
dict[0x9788] = "gé,tà,sǎ"; /* 鞈 */
dict[0x9789] = "táo"; /* 鞉 */
dict[0x978a] = "jié,jí"; /* 鞊 */
dict[0x978b] = "xié"; /* 鞋 */
dict[0x978c] = "ān"; /* 鞌 */
dict[0x978d] = "ān"; /* 鞍 */
dict[0x978e] = "hén"; /* 鞎 */
dict[0x978f] = "gǒng"; /* 鞏 */
dict[0x9790] = "qiǎ"; /* 鞐 */
dict[0x9791] = "dá"; /* 鞑 */
dict[0x9792] = "qiáo"; /* 鞒 */
dict[0x9793] = "tīng"; /* 鞓 */
dict[0x9794] = "mán,mèn"; /* 鞔 */
dict[0x9795] = "biān,yìng"; /* 鞕 */
dict[0x9796] = "suī"; /* 鞖 */
dict[0x9797] = "tiáo"; /* 鞗 */
dict[0x9798] = "qiào,shāo"; /* 鞘 */
dict[0x9799] = "xuān,juān"; /* 鞙 */
dict[0x979a] = "kòng"; /* 鞚 */
dict[0x979b] = "běng"; /* 鞛 */
dict[0x979c] = "tà"; /* 鞜 */
dict[0x979d] = "shàng,zhǎng"; /* 鞝 */
dict[0x979e] = "bǐng,pí,bì,bēi"; /* 鞞 */
dict[0x979f] = "kuò"; /* 鞟 */
dict[0x97a0] = "jū"; /* 鞠 */
dict[0x97a1] = "la"; /* 鞡 */
dict[0x97a2] = "xiè,dié"; /* 鞢 */
dict[0x97a3] = "róu"; /* 鞣 */
dict[0x97a4] = "bāng"; /* 鞤 */
dict[0x97a5] = "ēng"; /* 鞥 */
dict[0x97a6] = "qiū"; /* 鞦 */
dict[0x97a7] = "qiū"; /* 鞧 */
dict[0x97a8] = "hé"; /* 鞨 */
dict[0x97a9] = "qiào"; /* 鞩 */
dict[0x97aa] = "mù,móu"; /* 鞪 */
dict[0x97ab] = "jū"; /* 鞫 */
dict[0x97ac] = "jiàn,jiān"; /* 鞬 */
dict[0x97ad] = "biān"; /* 鞭 */
dict[0x97ae] = "dī"; /* 鞮 */
dict[0x97af] = "jiān"; /* 鞯 */
dict[0x97b0] = "wēn,yùn"; /* 鞰 */
dict[0x97b1] = "tāo"; /* 鞱 */
dict[0x97b2] = "gōu"; /* 鞲 */
dict[0x97b3] = "tà"; /* 鞳 */
dict[0x97b4] = "bèi"; /* 鞴 */
dict[0x97b5] = "xié"; /* 鞵 */
dict[0x97b6] = "pán"; /* 鞶 */
dict[0x97b7] = "gé"; /* 鞷 */
dict[0x97b8] = "bì,bǐng"; /* 鞸 */
dict[0x97b9] = "kuò"; /* 鞹 */
dict[0x97ba] = "tāng"; /* 鞺 */
dict[0x97bb] = "lóu"; /* 鞻 */
dict[0x97bc] = "guì"; /* 鞼 */
dict[0x97bd] = "qiáo"; /* 鞽 */
dict[0x97be] = "xuē"; /* 鞾 */
dict[0x97bf] = "jī"; /* 鞿 */
dict[0x97c0] = "jiān"; /* 韀 */
dict[0x97c1] = "jiāng"; /* 韁 */
dict[0x97c2] = "chàn"; /* 韂 */
dict[0x97c3] = "dá"; /* 韃 */
dict[0x97c4] = "huò"; /* 韄 */
dict[0x97c5] = "xiǎn"; /* 韅 */
dict[0x97c6] = "qiān"; /* 韆 */
dict[0x97c7] = "dú"; /* 韇 */
dict[0x97c8] = "wā"; /* 韈 */
dict[0x97c9] = "jiān"; /* 韉 */
dict[0x97ca] = "lán"; /* 韊 */
dict[0x97cb] = "wéi"; /* 韋 */
dict[0x97cc] = "rèn"; /* 韌 */
dict[0x97cd] = "fú"; /* 韍 */
dict[0x97ce] = "mèi,wà"; /* 韎 */
dict[0x97cf] = "quàn"; /* 韏 */
dict[0x97d0] = "gé"; /* 韐 */
dict[0x97d1] = "wěi"; /* 韑 */
dict[0x97d2] = "qiào"; /* 韒 */
dict[0x97d3] = "hán"; /* 韓 */
dict[0x97d4] = "chàng"; /* 韔 */
dict[0x97d5] = "kuò"; /* 韕 */
dict[0x97d6] = "rǒu"; /* 韖 */
dict[0x97d7] = "yùn"; /* 韗 */
dict[0x97d8] = "shè,xiè"; /* 韘 */
dict[0x97d9] = "wěi"; /* 韙 */
dict[0x97da] = "gé"; /* 韚 */
dict[0x97db] = "bài"; /* 韛 */
dict[0x97dc] = "tāo"; /* 韜 */
dict[0x97dd] = "gōu"; /* 韝 */
dict[0x97de] = "yùn"; /* 韞 */
dict[0x97df] = "gāo"; /* 韟 */
dict[0x97e0] = "bì"; /* 韠 */
dict[0x97e1] = "wěi"; /* 韡 */
dict[0x97e2] = "suì"; /* 韢 */
dict[0x97e3] = "dú"; /* 韣 */
dict[0x97e4] = "wà"; /* 韤 */
dict[0x97e5] = "dú"; /* 韥 */
dict[0x97e6] = "wéi"; /* 韦 */
dict[0x97e7] = "rèn"; /* 韧 */
dict[0x97e8] = "fú"; /* 韨 */
dict[0x97e9] = "hán"; /* 韩 */
dict[0x97ea] = "wěi"; /* 韪 */
dict[0x97eb] = "yùn,wēn"; /* 韫 */
dict[0x97ec] = "tāo"; /* 韬 */
dict[0x97ed] = "jiǔ"; /* 韭 */
dict[0x97ee] = "jiǔ"; /* 韮 */
dict[0x97ef] = "xiān"; /* 韯 */
dict[0x97f0] = "xiè"; /* 韰 */
dict[0x97f1] = "xiān"; /* 韱 */
dict[0x97f2] = "jī"; /* 韲 */
dict[0x97f3] = "yīn"; /* 音 */
dict[0x97f4] = "zá"; /* 韴 */
dict[0x97f5] = "yùn"; /* 韵 */
dict[0x97f6] = "sháo"; /* 韶 */
dict[0x97f7] = "lè"; /* 韷 */
dict[0x97f8] = "péng"; /* 韸 */
dict[0x97f9] = "huáng"; /* 韹 */
dict[0x97fa] = "yīng"; /* 韺 */
dict[0x97fb] = "yùn"; /* 韻 */
dict[0x97fc] = "péng"; /* 韼 */
dict[0x97fd] = "ān"; /* 韽 */
dict[0x97fe] = "yīn"; /* 韾 */
dict[0x97ff] = "xiǎng"; /* 響 */
dict[0x9800] = "hù"; /* 頀 */
dict[0x9801] = "yè"; /* 頁 */
dict[0x9802] = "dǐng"; /* 頂 */
dict[0x9803] = "qǐng"; /* 頃 */
dict[0x9804] = "qiú"; /* 頄 */
dict[0x9805] = "xiàng"; /* 項 */
dict[0x9806] = "shùn"; /* 順 */
dict[0x9807] = "hān"; /* 頇 */
dict[0x9808] = "xū"; /* 須 */
dict[0x9809] = "yí"; /* 頉 */
dict[0x980a] = "xù"; /* 頊 */
dict[0x980b] = "ě"; /* 頋 */
dict[0x980c] = "sòng"; /* 頌 */
dict[0x980d] = "kuǐ"; /* 頍 */
dict[0x980e] = "qí"; /* 頎 */
dict[0x980f] = "háng"; /* 頏 */
dict[0x9810] = "yù"; /* 預 */
dict[0x9811] = "wán"; /* 頑 */
dict[0x9812] = "bān"; /* 頒 */
dict[0x9813] = "dùn"; /* 頓 */
dict[0x9814] = "dí"; /* 頔 */
dict[0x9815] = "dān"; /* 頕 */
dict[0x9816] = "pàn"; /* 頖 */
dict[0x9817] = "pō"; /* 頗 */
dict[0x9818] = "lǐng"; /* 領 */
dict[0x9819] = "chè"; /* 頙 */
dict[0x981a] = "jǐng"; /* 頚 */
dict[0x981b] = "lèi"; /* 頛 */
dict[0x981c] = "hé"; /* 頜 */
dict[0x981d] = "qiāo"; /* 頝 */
dict[0x981e] = "è"; /* 頞 */
dict[0x981f] = "é"; /* 頟 */
dict[0x9820] = "wěi"; /* 頠 */
dict[0x9821] = "jié"; /* 頡 */
dict[0x9822] = "kuò"; /* 頢 */
dict[0x9823] = "shěn"; /* 頣 */
dict[0x9824] = "yí"; /* 頤 */
dict[0x9825] = "yí"; /* 頥 */
dict[0x9826] = "kē"; /* 頦 */
dict[0x9827] = "duǐ"; /* 頧 */
dict[0x9828] = "yǔ"; /* 頨 */
dict[0x9829] = "pīng"; /* 頩 */
dict[0x982a] = "lèi"; /* 頪 */
dict[0x982b] = "fǔ"; /* 頫 */
dict[0x982c] = "jiá"; /* 頬 */
dict[0x982d] = "tóu"; /* 頭 */
dict[0x982e] = "huì"; /* 頮 */
dict[0x982f] = "kuí"; /* 頯 */
dict[0x9830] = "jiá"; /* 頰 */
dict[0x9831] = "luō"; /* 頱 */
dict[0x9832] = "tǐng"; /* 頲 */
dict[0x9833] = "chēng"; /* 頳 */
dict[0x9834] = "yǐng"; /* 頴 */
dict[0x9835] = "jūn"; /* 頵 */
dict[0x9836] = "hú"; /* 頶 */
dict[0x9837] = "hàn"; /* 頷 */
dict[0x9838] = "jǐng"; /* 頸 */
dict[0x9839] = "tuí"; /* 頹 */
dict[0x983a] = "tuí"; /* 頺 */
dict[0x983b] = "bīn"; /* 頻 */
dict[0x983c] = "lài"; /* 頼 */
dict[0x983d] = "tuí"; /* 頽 */
dict[0x983e] = "zī"; /* 頾 */
dict[0x983f] = "zī"; /* 頿 */
dict[0x9840] = "chuí"; /* 顀 */
dict[0x9841] = "dìng"; /* 顁 */
dict[0x9842] = "lài"; /* 顂 */
dict[0x9843] = "tán"; /* 顃 */
dict[0x9844] = "hàn"; /* 顄 */
dict[0x9845] = "qiān"; /* 顅 */
dict[0x9846] = "kē"; /* 顆 */
dict[0x9847] = "cuì"; /* 顇 */
dict[0x9848] = "jiǒng"; /* 顈 */
dict[0x9849] = "qīn"; /* 顉 */
dict[0x984a] = "yí"; /* 顊 */
dict[0x984b] = "sāi"; /* 顋 */
dict[0x984c] = "tí"; /* 題 */
dict[0x984d] = "é"; /* 額 */
dict[0x984e] = "è"; /* 顎 */
dict[0x984f] = "yán"; /* 顏 */
dict[0x9850] = "wèn"; /* 顐 */
dict[0x9851] = "kǎn"; /* 顑 */
dict[0x9852] = "yóng"; /* 顒 */
dict[0x9853] = "zhuān"; /* 顓 */
dict[0x9854] = "yán"; /* 顔 */
dict[0x9855] = "xiǎn"; /* 顕 */
dict[0x9856] = "xìn"; /* 顖 */
dict[0x9857] = "yǐ"; /* 顗 */
dict[0x9858] = "yuàn"; /* 願 */
dict[0x9859] = "sǎng"; /* 顙 */
dict[0x985a] = "diān"; /* 顚 */
dict[0x985b] = "diān"; /* 顛 */
dict[0x985c] = "jiǎng"; /* 顜 */
dict[0x985d] = "kuī"; /* 顝 */
dict[0x985e] = "lèi"; /* 類 */
dict[0x985f] = "láo"; /* 顟 */
dict[0x9860] = "piǎo"; /* 顠 */
dict[0x9861] = "wài"; /* 顡 */
dict[0x9862] = "mān"; /* 顢 */
dict[0x9863] = "cù"; /* 顣 */
dict[0x9864] = "yáo"; /* 顤 */
dict[0x9865] = "hào"; /* 顥 */
dict[0x9866] = "qiáo"; /* 顦 */
dict[0x9867] = "gù"; /* 顧 */
dict[0x9868] = "xùn"; /* 顨 */
dict[0x9869] = "yǎn"; /* 顩 */
dict[0x986a] = "huì"; /* 顪 */
dict[0x986b] = "chàn"; /* 顫 */
dict[0x986c] = "rú"; /* 顬 */
dict[0x986d] = "méng"; /* 顭 */
dict[0x986e] = "bīn"; /* 顮 */
dict[0x986f] = "xiǎn"; /* 顯 */
dict[0x9870] = "pín"; /* 顰 */
dict[0x9871] = "lú"; /* 顱 */
dict[0x9872] = "lǎn"; /* 顲 */
dict[0x9873] = "niè"; /* 顳 */
dict[0x9874] = "quán"; /* 顴 */
dict[0x9875] = "yè"; /* 页 */
dict[0x9876] = "dǐng"; /* 顶 */
dict[0x9877] = "qǐng"; /* 顷 */
dict[0x9878] = "hān"; /* 顸 */
dict[0x9879] = "xiàng"; /* 项 */
dict[0x987a] = "shùn"; /* 顺 */
dict[0x987b] = "xū"; /* 须 */
dict[0x987c] = "xū"; /* 顼 */
dict[0x987d] = "wán"; /* 顽 */
dict[0x987e] = "gù"; /* 顾 */
dict[0x987f] = "dùn"; /* 顿 */
dict[0x9880] = "qí"; /* 颀 */
dict[0x9881] = "bān"; /* 颁 */
dict[0x9882] = "sòng"; /* 颂 */
dict[0x9883] = "háng"; /* 颃 */
dict[0x9884] = "yù"; /* 预 */
dict[0x9885] = "lú"; /* 颅 */
dict[0x9886] = "lǐng"; /* 领 */
dict[0x9887] = "pō"; /* 颇 */
dict[0x9888] = "jǐng,gěng"; /* 颈 */
dict[0x9889] = "jié,xié,jiá"; /* 颉 */
dict[0x988a] = "jiá"; /* 颊 */
dict[0x988b] = "tǐng"; /* 颋 */
dict[0x988c] = "hé,gé"; /* 颌 */
dict[0x988d] = "yǐng"; /* 颍 */
dict[0x988e] = "jiǒng"; /* 颎 */
dict[0x988f] = "kē"; /* 颏 */
dict[0x9890] = "yí"; /* 颐 */
dict[0x9891] = "pín,bīn"; /* 频 */
dict[0x9892] = "huì"; /* 颒 */
dict[0x9893] = "tuí"; /* 颓 */
dict[0x9894] = "hàn"; /* 颔 */
dict[0x9895] = "yǐng"; /* 颕 */
dict[0x9896] = "yǐng"; /* 颖 */
dict[0x9897] = "kē"; /* 颗 */
dict[0x9898] = "tí"; /* 题 */
dict[0x9899] = "yóng"; /* 颙 */
dict[0x989a] = "è"; /* 颚 */
dict[0x989b] = "zhuān"; /* 颛 */
dict[0x989c] = "yán"; /* 颜 */
dict[0x989d] = "é"; /* 额 */
dict[0x989e] = "niè"; /* 颞 */
dict[0x989f] = "mān"; /* 颟 */
dict[0x98a0] = "diān"; /* 颠 */
dict[0x98a1] = "sǎng"; /* 颡 */
dict[0x98a2] = "hào"; /* 颢 */
dict[0x98a3] = "lèi"; /* 颣 */
dict[0x98a4] = "chàn,zhàn"; /* 颤 */
dict[0x98a5] = "rú"; /* 颥 */
dict[0x98a6] = "pín"; /* 颦 */
dict[0x98a7] = "quán"; /* 颧 */
dict[0x98a8] = "fēng,fěng"; /* 風 */
dict[0x98a9] = "biāo,diū"; /* 颩 */
dict[0x98aa] = "guā"; /* 颪 */
dict[0x98ab] = "fú"; /* 颫 */
dict[0x98ac] = "xiā"; /* 颬 */
dict[0x98ad] = "zhǎn"; /* 颭 */
dict[0x98ae] = "biāo"; /* 颮 */
dict[0x98af] = "sà"; /* 颯 */
dict[0x98b0] = "bá,fú"; /* 颰 */
dict[0x98b1] = "tái"; /* 颱 */
dict[0x98b2] = "liè"; /* 颲 */
dict[0x98b3] = "guā"; /* 颳 */
dict[0x98b4] = "xuàn"; /* 颴 */
dict[0x98b5] = "xiāo"; /* 颵 */
dict[0x98b6] = "jù"; /* 颶 */
dict[0x98b7] = "biāo"; /* 颷 */
dict[0x98b8] = "sī"; /* 颸 */
dict[0x98b9] = "wěi"; /* 颹 */
dict[0x98ba] = "yáng"; /* 颺 */
dict[0x98bb] = "yáo"; /* 颻 */
dict[0x98bc] = "sōu"; /* 颼 */
dict[0x98bd] = "kǎi"; /* 颽 */
dict[0x98be] = "sāo,sōu"; /* 颾 */
dict[0x98bf] = "fān"; /* 颿 */
dict[0x98c0] = "liú"; /* 飀 */
dict[0x98c1] = "xí"; /* 飁 */
dict[0x98c2] = "liù,liáo"; /* 飂 */
dict[0x98c3] = "piāo"; /* 飃 */
dict[0x98c4] = "piāo"; /* 飄 */
dict[0x98c5] = "liú"; /* 飅 */
dict[0x98c6] = "biāo"; /* 飆 */
dict[0x98c7] = "biāo"; /* 飇 */
dict[0x98c8] = "biāo"; /* 飈 */
dict[0x98c9] = "liáo"; /* 飉 */
dict[0x98ca] = "biāo"; /* 飊 */
dict[0x98cb] = "sè"; /* 飋 */
dict[0x98cc] = "fēng"; /* 飌 */
dict[0x98cd] = "xiū"; /* 飍 */
dict[0x98ce] = "fēng,fěng"; /* 风 */
dict[0x98cf] = "yáng"; /* 飏 */
dict[0x98d0] = "zhǎn"; /* 飐 */
dict[0x98d1] = "biāo"; /* 飑 */
dict[0x98d2] = "sà"; /* 飒 */
dict[0x98d3] = "jù"; /* 飓 */
dict[0x98d4] = "sī"; /* 飔 */
dict[0x98d5] = "sōu"; /* 飕 */
dict[0x98d6] = "yáo"; /* 飖 */
dict[0x98d7] = "liú"; /* 飗 */
dict[0x98d8] = "piāo"; /* 飘 */
dict[0x98d9] = "biāo"; /* 飙 */
dict[0x98da] = "biāo"; /* 飚 */
dict[0x98db] = "fēi"; /* 飛 */
dict[0x98dc] = "fān"; /* 飜 */
dict[0x98dd] = "fēi"; /* 飝 */
dict[0x98de] = "fēi"; /* 飞 */
dict[0x98df] = "shí,sì,yì"; /* 食 */
dict[0x98e0] = "shí"; /* 飠 */
dict[0x98e1] = "cān"; /* 飡 */
dict[0x98e2] = "jī"; /* 飢 */
dict[0x98e3] = "dìng"; /* 飣 */
dict[0x98e4] = "sì"; /* 飤 */
dict[0x98e5] = "tuō"; /* 飥 */
dict[0x98e6] = "zhān"; /* 飦 */
dict[0x98e7] = "sūn"; /* 飧 */
dict[0x98e8] = "xiǎng"; /* 飨 */
dict[0x98e9] = "tún"; /* 飩 */
dict[0x98ea] = "rèn"; /* 飪 */
dict[0x98eb] = "yù"; /* 飫 */
dict[0x98ec] = "yǎng,juàn"; /* 飬 */
dict[0x98ed] = "chì"; /* 飭 */
dict[0x98ee] = "yǐn,yìn"; /* 飮 */
dict[0x98ef] = "fàn"; /* 飯 */
dict[0x98f0] = "fàn"; /* 飰 */
dict[0x98f1] = "sūn"; /* 飱 */
dict[0x98f2] = "yǐn,yìn"; /* 飲 */
dict[0x98f3] = "zhù,tǒu"; /* 飳 */
dict[0x98f4] = "yí,sì"; /* 飴 */
dict[0x98f5] = "zuò,zé,zhā"; /* 飵 */
dict[0x98f6] = "bì"; /* 飶 */
dict[0x98f7] = "jiě"; /* 飷 */
dict[0x98f8] = "tāo"; /* 飸 */
dict[0x98f9] = "bǎo"; /* 飹 */
dict[0x98fa] = "cí"; /* 飺 */
dict[0x98fb] = "tiè"; /* 飻 */
dict[0x98fc] = "sì"; /* 飼 */
dict[0x98fd] = "bǎo"; /* 飽 */
dict[0x98fe] = "shì"; /* 飾 */
dict[0x98ff] = "duò"; /* 飿 */
dict[0x9900] = "hài"; /* 餀 */
dict[0x9901] = "rèn"; /* 餁 */
dict[0x9902] = "tiǎn"; /* 餂 */
dict[0x9903] = "jiǎo"; /* 餃 */
dict[0x9904] = "hé"; /* 餄 */
dict[0x9905] = "bǐng"; /* 餅 */
dict[0x9906] = "yáo"; /* 餆 */
dict[0x9907] = "tóng"; /* 餇 */
dict[0x9908] = "cí"; /* 餈 */
dict[0x9909] = "xiǎng"; /* 餉 */
dict[0x990a] = "yǎng"; /* 養 */
dict[0x990b] = "juàn"; /* 餋 */
dict[0x990c] = "ěr"; /* 餌 */
dict[0x990d] = "yàn"; /* 餍 */
dict[0x990e] = "lè"; /* 餎 */
dict[0x990f] = "xī"; /* 餏 */
dict[0x9910] = "cān"; /* 餐 */
dict[0x9911] = "bō"; /* 餑 */
dict[0x9912] = "něi"; /* 餒 */
dict[0x9913] = "è"; /* 餓 */
dict[0x9914] = "bū"; /* 餔 */
dict[0x9915] = "jùn"; /* 餕 */
dict[0x9916] = "dòu"; /* 餖 */
dict[0x9917] = "sù"; /* 餗 */
dict[0x9918] = "yú"; /* 餘 */
dict[0x9919] = "shì"; /* 餙 */
dict[0x991a] = "yáo"; /* 餚 */
dict[0x991b] = "hún"; /* 餛 */
dict[0x991c] = "guǒ"; /* 餜 */
dict[0x991d] = "shì"; /* 餝 */
dict[0x991e] = "jiàn"; /* 餞 */
dict[0x991f] = "chuò"; /* 餟 */
dict[0x9920] = "bǐng"; /* 餠 */
dict[0x9921] = "xiàn"; /* 餡 */
dict[0x9922] = "bù"; /* 餢 */
dict[0x9923] = "yè"; /* 餣 */
dict[0x9924] = "dàn"; /* 餤 */
dict[0x9925] = "fēi"; /* 餥 */
dict[0x9926] = "zhāng"; /* 餦 */
dict[0x9927] = "wèi"; /* 餧 */
dict[0x9928] = "guǎn"; /* 館 */
dict[0x9929] = "è"; /* 餩 */
dict[0x992a] = "nuǎn"; /* 餪 */
dict[0x992b] = "yùn"; /* 餫 */
dict[0x992c] = "hú"; /* 餬 */
dict[0x992d] = "huáng"; /* 餭 */
dict[0x992e] = "tiè"; /* 餮 */
dict[0x992f] = "huì"; /* 餯 */
dict[0x9930] = "jiān"; /* 餰 */
dict[0x9931] = "hóu"; /* 餱 */
dict[0x9932] = "ài"; /* 餲 */
dict[0x9933] = "xíng"; /* 餳 */
dict[0x9934] = "fēn"; /* 餴 */
dict[0x9935] = "wèi"; /* 餵 */
dict[0x9936] = "gǔ"; /* 餶 */
dict[0x9937] = "chā"; /* 餷 */
dict[0x9938] = "sòng"; /* 餸 */
dict[0x9939] = "táng"; /* 餹 */
dict[0x993a] = "bó"; /* 餺 */
dict[0x993b] = "gāo"; /* 餻 */
dict[0x993c] = "xì"; /* 餼 */
dict[0x993d] = "kuì"; /* 餽 */
dict[0x993e] = "liù"; /* 餾 */
dict[0x993f] = "sōu"; /* 餿 */
dict[0x9940] = "táo"; /* 饀 */
dict[0x9941] = "yè"; /* 饁 */
dict[0x9942] = "wēn"; /* 饂 */
dict[0x9943] = "mó"; /* 饃 */
dict[0x9944] = "táng"; /* 饄 */
dict[0x9945] = "mán"; /* 饅 */
dict[0x9946] = "bì"; /* 饆 */
dict[0x9947] = "yù"; /* 饇 */
dict[0x9948] = "xiū"; /* 饈 */
dict[0x9949] = "jǐn"; /* 饉 */
dict[0x994a] = "sǎn"; /* 饊 */
dict[0x994b] = "kuì"; /* 饋 */
dict[0x994c] = "zhuàn"; /* 饌 */
dict[0x994d] = "shàn"; /* 饍 */
dict[0x994e] = "xī"; /* 饎 */
dict[0x994f] = "dàn"; /* 饏 */
dict[0x9950] = "yì"; /* 饐 */
dict[0x9951] = "jī"; /* 饑 */
dict[0x9952] = "ráo"; /* 饒 */
dict[0x9953] = "chēng"; /* 饓 */
dict[0x9954] = "yōng"; /* 饔 */
dict[0x9955] = "tāo"; /* 饕 */
dict[0x9956] = "wèi"; /* 饖 */
dict[0x9957] = "xiǎng"; /* 饗 */
dict[0x9958] = "zhān"; /* 饘 */
dict[0x9959] = "fēn"; /* 饙 */
dict[0x995a] = "hài"; /* 饚 */
dict[0x995b] = "méng"; /* 饛 */
dict[0x995c] = "yàn"; /* 饜 */
dict[0x995d] = "mó"; /* 饝 */
dict[0x995e] = "chán"; /* 饞 */
dict[0x995f] = "xiǎng,náng"; /* 饟 */
dict[0x9960] = "luó"; /* 饠 */
dict[0x9961] = "zàn"; /* 饡 */
dict[0x9962] = "náng"; /* 饢 */
dict[0x9963] = "shí"; /* 饣 */
dict[0x9964] = "dìng"; /* 饤 */
dict[0x9965] = "jī"; /* 饥 */
dict[0x9966] = "tuō"; /* 饦 */
dict[0x9967] = "xíng"; /* 饧 */
dict[0x9968] = "tún"; /* 饨 */
dict[0x9969] = "xì"; /* 饩 */
dict[0x996a] = "rèn"; /* 饪 */
dict[0x996b] = "yù"; /* 饫 */
dict[0x996c] = "chì"; /* 饬 */
dict[0x996d] = "fàn"; /* 饭 */
dict[0x996e] = "yǐn"; /* 饮 */
dict[0x996f] = "jiàn"; /* 饯 */
dict[0x9970] = "shì"; /* 饰 */
dict[0x9971] = "bǎo"; /* 饱 */
dict[0x9972] = "sì"; /* 饲 */
dict[0x9973] = "duò"; /* 饳 */
dict[0x9974] = "yí"; /* 饴 */
dict[0x9975] = "ěr"; /* 饵 */
dict[0x9976] = "ráo"; /* 饶 */
dict[0x9977] = "xiǎng"; /* 饷 */
dict[0x9978] = "hé"; /* 饸 */
dict[0x9979] = "gē,le"; /* 饹 */
dict[0x997a] = "jiǎo"; /* 饺 */
dict[0x997b] = "xī"; /* 饻 */
dict[0x997c] = "bǐng"; /* 饼 */
dict[0x997d] = "bō"; /* 饽 */
dict[0x997e] = "dòu"; /* 饾 */
dict[0x997f] = "è"; /* 饿 */
dict[0x9980] = "yú"; /* 馀 */
dict[0x9981] = "něi"; /* 馁 */
dict[0x9982] = "jùn"; /* 馂 */
dict[0x9983] = "guǒ"; /* 馃 */
dict[0x9984] = "hún"; /* 馄 */
dict[0x9985] = "xiàn"; /* 馅 */
dict[0x9986] = "guǎn"; /* 馆 */
dict[0x9987] = "chā"; /* 馇 */
dict[0x9988] = "kuì"; /* 馈 */
dict[0x9989] = "gǔ"; /* 馉 */
dict[0x998a] = "sōu"; /* 馊 */
dict[0x998b] = "chán"; /* 馋 */
dict[0x998c] = "yè"; /* 馌 */
dict[0x998d] = "mó"; /* 馍 */
dict[0x998e] = "bó"; /* 馎 */
dict[0x998f] = "liù,liú"; /* 馏 */
dict[0x9990] = "xiū"; /* 馐 */
dict[0x9991] = "jǐn"; /* 馑 */
dict[0x9992] = "mán"; /* 馒 */
dict[0x9993] = "sǎn"; /* 馓 */
dict[0x9994] = "zhuàn"; /* 馔 */
dict[0x9995] = "náng,nǎng"; /* 馕 */
dict[0x9996] = "shǒu"; /* 首 */
dict[0x9997] = "kuí"; /* 馗 */
dict[0x9998] = "guó"; /* 馘 */
dict[0x9999] = "xiāng"; /* 香 */
dict[0x999a] = "fēn"; /* 馚 */
dict[0x999b] = "bó"; /* 馛 */
dict[0x999c] = "ní"; /* 馜 */
dict[0x999d] = "bì"; /* 馝 */
dict[0x999e] = "bó"; /* 馞 */
dict[0x999f] = "tú"; /* 馟 */
dict[0x99a0] = "hān"; /* 馠 */
dict[0x99a1] = "fēi"; /* 馡 */
dict[0x99a2] = "jiān"; /* 馢 */
dict[0x99a3] = "ān"; /* 馣 */
dict[0x99a4] = "ài"; /* 馤 */
dict[0x99a5] = "fù"; /* 馥 */
dict[0x99a6] = "xiān"; /* 馦 */
dict[0x99a7] = "yūn,wò"; /* 馧 */
dict[0x99a8] = "xīn"; /* 馨 */
dict[0x99a9] = "fén"; /* 馩 */
dict[0x99aa] = "pīn"; /* 馪 */
dict[0x99ab] = "xīn"; /* 馫 */
dict[0x99ac] = "mǎ"; /* 馬 */
dict[0x99ad] = "yù"; /* 馭 */
dict[0x99ae] = "féng,píng"; /* 馮 */
dict[0x99af] = "hàn,hán"; /* 馯 */
dict[0x99b0] = "dí"; /* 馰 */
dict[0x99b1] = "tuó,duò"; /* 馱 */
dict[0x99b2] = "tuō,zhé"; /* 馲 */
dict[0x99b3] = "chí"; /* 馳 */
dict[0x99b4] = "xùn"; /* 馴 */
dict[0x99b5] = "zhù"; /* 馵 */
dict[0x99b6] = "zhī,shì"; /* 馶 */
dict[0x99b7] = "pèi"; /* 馷 */
dict[0x99b8] = "xìn,jìn"; /* 馸 */
dict[0x99b9] = "rì"; /* 馹 */
dict[0x99ba] = "sà"; /* 馺 */
dict[0x99bb] = "yǔn"; /* 馻 */
dict[0x99bc] = "wén"; /* 馼 */
dict[0x99bd] = "zhí"; /* 馽 */
dict[0x99be] = "dǎn,dàn"; /* 馾 */
dict[0x99bf] = "lú"; /* 馿 */
dict[0x99c0] = "yóu"; /* 駀 */
dict[0x99c1] = "bó"; /* 駁 */
dict[0x99c2] = "bǎo"; /* 駂 */
dict[0x99c3] = "jué,kuài"; /* 駃 */
dict[0x99c4] = "tuó,duò"; /* 駄 */
dict[0x99c5] = "yì"; /* 駅 */
dict[0x99c6] = "qū"; /* 駆 */
dict[0x99c7] = "wén"; /* 駇 */
dict[0x99c8] = "qū"; /* 駈 */
dict[0x99c9] = "jiōng"; /* 駉 */
dict[0x99ca] = "pǒ"; /* 駊 */
dict[0x99cb] = "zhāo"; /* 駋 */
dict[0x99cc] = "yuān"; /* 駌 */
dict[0x99cd] = "pēng"; /* 駍 */
dict[0x99ce] = "zhòu"; /* 駎 */
dict[0x99cf] = "jù"; /* 駏 */
dict[0x99d0] = "zhù"; /* 駐 */
dict[0x99d1] = "nú"; /* 駑 */
dict[0x99d2] = "jū"; /* 駒 */
dict[0x99d3] = "pī"; /* 駓 */
dict[0x99d4] = "zǎng"; /* 駔 */
dict[0x99d5] = "jià"; /* 駕 */
dict[0x99d6] = "líng"; /* 駖 */
dict[0x99d7] = "zhěn"; /* 駗 */
dict[0x99d8] = "tái,dài"; /* 駘 */
dict[0x99d9] = "fù"; /* 駙 */
dict[0x99da] = "yǎng"; /* 駚 */
dict[0x99db] = "shǐ"; /* 駛 */
dict[0x99dc] = "bì"; /* 駜 */
dict[0x99dd] = "tuó"; /* 駝 */
dict[0x99de] = "tuó"; /* 駞 */
dict[0x99df] = "sì"; /* 駟 */
dict[0x99e0] = "liú"; /* 駠 */
dict[0x99e1] = "mà"; /* 駡 */
dict[0x99e2] = "pián"; /* 駢 */
dict[0x99e3] = "táo"; /* 駣 */
dict[0x99e4] = "zhì"; /* 駤 */
dict[0x99e5] = "róng"; /* 駥 */
dict[0x99e6] = "téng"; /* 駦 */
dict[0x99e7] = "dòng"; /* 駧 */
dict[0x99e8] = "xún,xuān"; /* 駨 */
dict[0x99e9] = "quán"; /* 駩 */
dict[0x99ea] = "shēn"; /* 駪 */
dict[0x99eb] = "jiōng"; /* 駫 */
dict[0x99ec] = "ěr"; /* 駬 */
dict[0x99ed] = "hài"; /* 駭 */
dict[0x99ee] = "bó"; /* 駮 */
dict[0x99ef] = "zhū"; /* 駯 */
dict[0x99f0] = "yīn"; /* 駰 */
dict[0x99f1] = "luò"; /* 駱 */
dict[0x99f2] = "zhōu"; /* 駲 */
dict[0x99f3] = "dàn"; /* 駳 */
dict[0x99f4] = "hài"; /* 駴 */
dict[0x99f5] = "liú"; /* 駵 */
dict[0x99f6] = "jú"; /* 駶 */
dict[0x99f7] = "sǒng"; /* 駷 */
dict[0x99f8] = "qīn"; /* 駸 */
dict[0x99f9] = "máng"; /* 駹 */
dict[0x99fa] = "liáng,láng"; /* 駺 */
dict[0x99fb] = "hàn"; /* 駻 */
dict[0x99fc] = "tú"; /* 駼 */
dict[0x99fd] = "xuān"; /* 駽 */
dict[0x99fe] = "tuì"; /* 駾 */
dict[0x99ff] = "jùn"; /* 駿 */
dict[0x9a00] = "ě"; /* 騀 */
dict[0x9a01] = "chěng"; /* 騁 */
dict[0x9a02] = "xīng"; /* 騂 */
dict[0x9a03] = "sì"; /* 騃 */
dict[0x9a04] = "lù"; /* 騄 */
dict[0x9a05] = "zhuī"; /* 騅 */
dict[0x9a06] = "zhōu"; /* 騆 */
dict[0x9a07] = "shè"; /* 騇 */
dict[0x9a08] = "pián"; /* 騈 */
dict[0x9a09] = "kūn"; /* 騉 */
dict[0x9a0a] = "táo"; /* 騊 */
dict[0x9a0b] = "lái"; /* 騋 */
dict[0x9a0c] = "zōng"; /* 騌 */
dict[0x9a0d] = "kè"; /* 騍 */
dict[0x9a0e] = "qí"; /* 騎 */
dict[0x9a0f] = "qí"; /* 騏 */
dict[0x9a10] = "yàn"; /* 騐 */
dict[0x9a11] = "fēi"; /* 騑 */
dict[0x9a12] = "sāo"; /* 騒 */
dict[0x9a13] = "yàn"; /* 験 */
dict[0x9a14] = "gé"; /* 騔 */
dict[0x9a15] = "yǎo"; /* 騕 */
dict[0x9a16] = "wù"; /* 騖 */
dict[0x9a17] = "piàn"; /* 騗 */
dict[0x9a18] = "cōng"; /* 騘 */
dict[0x9a19] = "piàn"; /* 騙 */
dict[0x9a1a] = "qián"; /* 騚 */
dict[0x9a1b] = "fēi"; /* 騛 */
dict[0x9a1c] = "huáng"; /* 騜 */
dict[0x9a1d] = "qián"; /* 騝 */
dict[0x9a1e] = "huō"; /* 騞 */
dict[0x9a1f] = "yú"; /* 騟 */
dict[0x9a20] = "tí"; /* 騠 */
dict[0x9a21] = "quán"; /* 騡 */
dict[0x9a22] = "xiá"; /* 騢 */
dict[0x9a23] = "zōng"; /* 騣 */
dict[0x9a24] = "kuí"; /* 騤 */
dict[0x9a25] = "róu"; /* 騥 */
dict[0x9a26] = "sī"; /* 騦 */
dict[0x9a27] = "guā"; /* 騧 */
dict[0x9a28] = "tuó"; /* 騨 */
dict[0x9a29] = "guī"; /* 騩 */
dict[0x9a2a] = "sōu"; /* 騪 */
dict[0x9a2b] = "qiān"; /* 騫 */
dict[0x9a2c] = "chéng"; /* 騬 */
dict[0x9a2d] = "zhì"; /* 騭 */
dict[0x9a2e] = "liú"; /* 騮 */
dict[0x9a2f] = "péng"; /* 騯 */
dict[0x9a30] = "téng"; /* 騰 */
dict[0x9a31] = "xí"; /* 騱 */
dict[0x9a32] = "cǎo"; /* 騲 */
dict[0x9a33] = "dú"; /* 騳 */
dict[0x9a34] = "yàn"; /* 騴 */
dict[0x9a35] = "yuán"; /* 騵 */
dict[0x9a36] = "zōu"; /* 騶 */
dict[0x9a37] = "sāo"; /* 騷 */
dict[0x9a38] = "shàn"; /* 騸 */
dict[0x9a39] = "qí"; /* 騹 */
dict[0x9a3a] = "zhì"; /* 騺 */
dict[0x9a3b] = "shuāng"; /* 騻 */
dict[0x9a3c] = "lù"; /* 騼 */
dict[0x9a3d] = "xí"; /* 騽 */
dict[0x9a3e] = "luó"; /* 騾 */
dict[0x9a3f] = "zhāng"; /* 騿 */
dict[0x9a40] = "mò"; /* 驀 */
dict[0x9a41] = "ào"; /* 驁 */
dict[0x9a42] = "cān"; /* 驂 */
dict[0x9a43] = "piào"; /* 驃 */
dict[0x9a44] = "cōng"; /* 驄 */
dict[0x9a45] = "qū"; /* 驅 */
dict[0x9a46] = "bì"; /* 驆 */
dict[0x9a47] = "zhì"; /* 驇 */
dict[0x9a48] = "yù"; /* 驈 */
dict[0x9a49] = "xū"; /* 驉 */
dict[0x9a4a] = "huá"; /* 驊 */
dict[0x9a4b] = "bō"; /* 驋 */
dict[0x9a4c] = "sù"; /* 驌 */
dict[0x9a4d] = "xiāo"; /* 驍 */
dict[0x9a4e] = "lín"; /* 驎 */
dict[0x9a4f] = "zhàn"; /* 驏 */
dict[0x9a50] = "dūn"; /* 驐 */
dict[0x9a51] = "liú"; /* 驑 */
dict[0x9a52] = "tuó"; /* 驒 */
dict[0x9a53] = "céng"; /* 驓 */
dict[0x9a54] = "diàn"; /* 驔 */
dict[0x9a55] = "jiāo"; /* 驕 */
dict[0x9a56] = "tiě"; /* 驖 */
dict[0x9a57] = "yàn"; /* 驗 */
dict[0x9a58] = "luó"; /* 驘 */
dict[0x9a59] = "zhān"; /* 驙 */
dict[0x9a5a] = "jīng"; /* 驚 */
dict[0x9a5b] = "yì"; /* 驛 */
dict[0x9a5c] = "yè"; /* 驜 */
dict[0x9a5d] = "tuó"; /* 驝 */
dict[0x9a5e] = "pīn"; /* 驞 */
dict[0x9a5f] = "zhòu"; /* 驟 */
dict[0x9a60] = "yàn"; /* 驠 */
dict[0x9a61] = "lóng"; /* 驡 */
dict[0x9a62] = "lǘ"; /* 驢 */
dict[0x9a63] = "téng"; /* 驣 */
dict[0x9a64] = "xiāng"; /* 驤 */
dict[0x9a65] = "jì"; /* 驥 */
dict[0x9a66] = "shuāng"; /* 驦 */
dict[0x9a67] = "jú"; /* 驧 */
dict[0x9a68] = "xí"; /* 驨 */
dict[0x9a69] = "huān"; /* 驩 */
dict[0x9a6a] = "lí"; /* 驪 */
dict[0x9a6b] = "biāo"; /* 驫 */
dict[0x9a6c] = "mǎ"; /* 马 */
dict[0x9a6d] = "yù"; /* 驭 */
dict[0x9a6e] = "tuó"; /* 驮 */
dict[0x9a6f] = "xùn"; /* 驯 */
dict[0x9a70] = "chí"; /* 驰 */
dict[0x9a71] = "qū"; /* 驱 */
dict[0x9a72] = "rì"; /* 驲 */
dict[0x9a73] = "bó"; /* 驳 */
dict[0x9a74] = "lǘ"; /* 驴 */
dict[0x9a75] = "zǎng"; /* 驵 */
dict[0x9a76] = "shǐ"; /* 驶 */
dict[0x9a77] = "sì"; /* 驷 */
dict[0x9a78] = "fù"; /* 驸 */
dict[0x9a79] = "jū"; /* 驹 */
dict[0x9a7a] = "zōu"; /* 驺 */
dict[0x9a7b] = "zhù"; /* 驻 */
dict[0x9a7c] = "tuó"; /* 驼 */
dict[0x9a7d] = "nú"; /* 驽 */
dict[0x9a7e] = "jià"; /* 驾 */
dict[0x9a7f] = "yì"; /* 驿 */
dict[0x9a80] = "tái"; /* 骀 */
dict[0x9a81] = "xiāo"; /* 骁 */
dict[0x9a82] = "mà"; /* 骂 */
dict[0x9a83] = "yīn"; /* 骃 */
dict[0x9a84] = "jiāo"; /* 骄 */
dict[0x9a85] = "huá"; /* 骅 */
dict[0x9a86] = "luò"; /* 骆 */
dict[0x9a87] = "hài"; /* 骇 */
dict[0x9a88] = "pián"; /* 骈 */
dict[0x9a89] = "biāo"; /* 骉 */
dict[0x9a8a] = "lí"; /* 骊 */
dict[0x9a8b] = "chěng"; /* 骋 */
dict[0x9a8c] = "yàn"; /* 验 */
dict[0x9a8d] = "xīng"; /* 骍 */
dict[0x9a8e] = "qīn"; /* 骎 */
dict[0x9a8f] = "jùn"; /* 骏 */
dict[0x9a90] = "qí"; /* 骐 */
dict[0x9a91] = "qí"; /* 骑 */
dict[0x9a92] = "kè"; /* 骒 */
dict[0x9a93] = "zhuī"; /* 骓 */
dict[0x9a94] = "zōng"; /* 骔 */
dict[0x9a95] = "sù"; /* 骕 */
dict[0x9a96] = "cān"; /* 骖 */
dict[0x9a97] = "piàn"; /* 骗 */
dict[0x9a98] = "zhì"; /* 骘 */
dict[0x9a99] = "kuí"; /* 骙 */
dict[0x9a9a] = "sāo,sǎo"; /* 骚 */
dict[0x9a9b] = "wù"; /* 骛 */
dict[0x9a9c] = "áo"; /* 骜 */
dict[0x9a9d] = "liú"; /* 骝 */
dict[0x9a9e] = "qiān"; /* 骞 */
dict[0x9a9f] = "shàn"; /* 骟 */
dict[0x9aa0] = "piào,biāo"; /* 骠 */
dict[0x9aa1] = "luó"; /* 骡 */
dict[0x9aa2] = "cōng"; /* 骢 */
dict[0x9aa3] = "chǎn"; /* 骣 */
dict[0x9aa4] = "zhòu"; /* 骤 */
dict[0x9aa5] = "jì"; /* 骥 */
dict[0x9aa6] = "shuāng"; /* 骦 */
dict[0x9aa7] = "xiāng"; /* 骧 */
dict[0x9aa8] = "gǔ,gū"; /* 骨 */
dict[0x9aa9] = "wěi"; /* 骩 */
dict[0x9aaa] = "wěi"; /* 骪 */
dict[0x9aab] = "wěi"; /* 骫 */
dict[0x9aac] = "yú"; /* 骬 */
dict[0x9aad] = "gàn"; /* 骭 */
dict[0x9aae] = "yì"; /* 骮 */
dict[0x9aaf] = "āng"; /* 骯 */
dict[0x9ab0] = "tóu"; /* 骰 */
dict[0x9ab1] = "jiè"; /* 骱 */
dict[0x9ab2] = "bào"; /* 骲 */
dict[0x9ab3] = "bèi,mó"; /* 骳 */
dict[0x9ab4] = "cī"; /* 骴 */
dict[0x9ab5] = "tǐ"; /* 骵 */
dict[0x9ab6] = "dǐ"; /* 骶 */
dict[0x9ab7] = "kū"; /* 骷 */
dict[0x9ab8] = "hái"; /* 骸 */
dict[0x9ab9] = "qiāo,xiāo"; /* 骹 */
dict[0x9aba] = "hóu"; /* 骺 */
dict[0x9abb] = "kuà"; /* 骻 */
dict[0x9abc] = "gé"; /* 骼 */
dict[0x9abd] = "tuǐ"; /* 骽 */
dict[0x9abe] = "gěng"; /* 骾 */
dict[0x9abf] = "pián"; /* 骿 */
dict[0x9ac0] = "bì"; /* 髀 */
dict[0x9ac1] = "kē"; /* 髁 */
dict[0x9ac2] = "qià"; /* 髂 */
dict[0x9ac3] = "yú"; /* 髃 */
dict[0x9ac4] = "suí"; /* 髄 */
dict[0x9ac5] = "lóu"; /* 髅 */
dict[0x9ac6] = "bó"; /* 髆 */
dict[0x9ac7] = "xiāo"; /* 髇 */
dict[0x9ac8] = "bǎng"; /* 髈 */
dict[0x9ac9] = "bó,jué"; /* 髉 */
dict[0x9aca] = "cī"; /* 髊 */
dict[0x9acb] = "kuān"; /* 髋 */
dict[0x9acc] = "bìn"; /* 髌 */
dict[0x9acd] = "mó"; /* 髍 */
dict[0x9ace] = "liáo"; /* 髎 */
dict[0x9acf] = "lóu"; /* 髏 */
dict[0x9ad0] = "xiāo"; /* 髐 */
dict[0x9ad1] = "dú"; /* 髑 */
dict[0x9ad2] = "zāng"; /* 髒 */
dict[0x9ad3] = "suǐ"; /* 髓 */
dict[0x9ad4] = "tǐ,tī"; /* 體 */
dict[0x9ad5] = "bìn"; /* 髕 */
dict[0x9ad6] = "kuān"; /* 髖 */
dict[0x9ad7] = "lú"; /* 髗 */
dict[0x9ad8] = "gāo"; /* 高 */
dict[0x9ad9] = "gāo"; /* 髙 */
dict[0x9ada] = "qiào"; /* 髚 */
dict[0x9adb] = "kāo"; /* 髛 */
dict[0x9adc] = "qiǎo"; /* 髜 */
dict[0x9add] = "láo"; /* 髝 */
dict[0x9ade] = "sào"; /* 髞 */
dict[0x9adf] = "biāo"; /* 髟 */
dict[0x9ae0] = "kūn"; /* 髠 */
dict[0x9ae1] = "kūn"; /* 髡 */
dict[0x9ae2] = "dí"; /* 髢 */
dict[0x9ae3] = "fǎng"; /* 髣 */
dict[0x9ae4] = "xiū"; /* 髤 */
dict[0x9ae5] = "rán"; /* 髥 */
dict[0x9ae6] = "máo"; /* 髦 */
dict[0x9ae7] = "dàn"; /* 髧 */
dict[0x9ae8] = "kūn"; /* 髨 */
dict[0x9ae9] = "bìn"; /* 髩 */
dict[0x9aea] = "fà"; /* 髪 */
dict[0x9aeb] = "tiáo"; /* 髫 */
dict[0x9aec] = "pī"; /* 髬 */
dict[0x9aed] = "zī"; /* 髭 */
dict[0x9aee] = "fà"; /* 髮 */
dict[0x9aef] = "rán"; /* 髯 */
dict[0x9af0] = "tì"; /* 髰 */
dict[0x9af1] = "bào"; /* 髱 */
dict[0x9af2] = "bì,pǒ"; /* 髲 */
dict[0x9af3] = "máo,méng"; /* 髳 */
dict[0x9af4] = "fú"; /* 髴 */
dict[0x9af5] = "ér"; /* 髵 */
dict[0x9af6] = "èr"; /* 髶 */
dict[0x9af7] = "qū"; /* 髷 */
dict[0x9af8] = "gōng"; /* 髸 */
dict[0x9af9] = "xiū"; /* 髹 */
dict[0x9afa] = "kuò,yuè"; /* 髺 */
dict[0x9afb] = "jì"; /* 髻 */
dict[0x9afc] = "péng"; /* 髼 */
dict[0x9afd] = "zhuā"; /* 髽 */
dict[0x9afe] = "shāo"; /* 髾 */
dict[0x9aff] = "shā"; /* 髿 */
dict[0x9b00] = "tì"; /* 鬀 */
dict[0x9b01] = "lì"; /* 鬁 */
dict[0x9b02] = "bìn"; /* 鬂 */
dict[0x9b03] = "zōng"; /* 鬃 */
dict[0x9b04] = "tì"; /* 鬄 */
dict[0x9b05] = "péng"; /* 鬅 */
dict[0x9b06] = "sōng"; /* 鬆 */
dict[0x9b07] = "zhēng"; /* 鬇 */
dict[0x9b08] = "quán"; /* 鬈 */
dict[0x9b09] = "zōng"; /* 鬉 */
dict[0x9b0a] = "shùn"; /* 鬊 */
dict[0x9b0b] = "jiǎn"; /* 鬋 */
dict[0x9b0c] = "duǒ"; /* 鬌 */
dict[0x9b0d] = "hú"; /* 鬍 */
dict[0x9b0e] = "là"; /* 鬎 */
dict[0x9b0f] = "jiū"; /* 鬏 */
dict[0x9b10] = "qí"; /* 鬐 */
dict[0x9b11] = "lián"; /* 鬑 */
dict[0x9b12] = "zhěn"; /* 鬒 */
dict[0x9b13] = "bìn"; /* 鬓 */
dict[0x9b14] = "péng"; /* 鬔 */
dict[0x9b15] = "mà"; /* 鬕 */
dict[0x9b16] = "sān"; /* 鬖 */
dict[0x9b17] = "mán"; /* 鬗 */
dict[0x9b18] = "mán"; /* 鬘 */
dict[0x9b19] = "sēng"; /* 鬙 */
dict[0x9b1a] = "xū"; /* 鬚 */
dict[0x9b1b] = "liè"; /* 鬛 */
dict[0x9b1c] = "qiān"; /* 鬜 */
dict[0x9b1d] = "qiān"; /* 鬝 */
dict[0x9b1e] = "nóng"; /* 鬞 */
dict[0x9b1f] = "huán"; /* 鬟 */
dict[0x9b20] = "kuò"; /* 鬠 */
dict[0x9b21] = "níng"; /* 鬡 */
dict[0x9b22] = "bìn"; /* 鬢 */
dict[0x9b23] = "liè"; /* 鬣 */
dict[0x9b24] = "ráng"; /* 鬤 */
dict[0x9b25] = "dòu"; /* 鬥 */
dict[0x9b26] = "dòu"; /* 鬦 */
dict[0x9b27] = "nào"; /* 鬧 */
dict[0x9b28] = "hòng"; /* 鬨 */
dict[0x9b29] = "xì"; /* 鬩 */
dict[0x9b2a] = "dòu"; /* 鬪 */
dict[0x9b2b] = "kàn"; /* 鬫 */
dict[0x9b2c] = "dòu"; /* 鬬 */
dict[0x9b2d] = "dòu"; /* 鬭 */
dict[0x9b2e] = "jiū"; /* 鬮 */
dict[0x9b2f] = "chàng"; /* 鬯 */
dict[0x9b30] = "yù"; /* 鬰 */
dict[0x9b31] = "yù"; /* 鬱 */
dict[0x9b32] = "gé,lì"; /* 鬲 */
dict[0x9b33] = "yàn"; /* 鬳 */
dict[0x9b34] = "fǔ"; /* 鬴 */
dict[0x9b35] = "zèng"; /* 鬵 */
dict[0x9b36] = "guī"; /* 鬶 */
dict[0x9b37] = "zōng"; /* 鬷 */
dict[0x9b38] = "liù"; /* 鬸 */
dict[0x9b39] = "guī"; /* 鬹 */
dict[0x9b3a] = "shāng"; /* 鬺 */
dict[0x9b3b] = "yù"; /* 鬻 */
dict[0x9b3c] = "guǐ"; /* 鬼 */
dict[0x9b3d] = "mèi"; /* 鬽 */
dict[0x9b3e] = "jì"; /* 鬾 */
dict[0x9b3f] = "qí"; /* 鬿 */
dict[0x9b40] = "gà"; /* 魀 */
dict[0x9b41] = "kuí"; /* 魁 */
dict[0x9b42] = "hún"; /* 魂 */
dict[0x9b43] = "bá"; /* 魃 */
dict[0x9b44] = "pò"; /* 魄 */
dict[0x9b45] = "mèi"; /* 魅 */
dict[0x9b46] = "xū"; /* 魆 */
dict[0x9b47] = "yǎn"; /* 魇 */
dict[0x9b48] = "xiāo"; /* 魈 */
dict[0x9b49] = "liǎng"; /* 魉 */
dict[0x9b4a] = "yù"; /* 魊 */
dict[0x9b4b] = "tuí"; /* 魋 */
dict[0x9b4c] = "qī"; /* 魌 */
dict[0x9b4d] = "wǎng"; /* 魍 */
dict[0x9b4e] = "liǎng"; /* 魎 */
dict[0x9b4f] = "wèi"; /* 魏 */
dict[0x9b50] = "gān"; /* 魐 */
dict[0x9b51] = "chī"; /* 魑 */
dict[0x9b52] = "piāo"; /* 魒 */
dict[0x9b53] = "bì"; /* 魓 */
dict[0x9b54] = "mó"; /* 魔 */
dict[0x9b55] = "jī"; /* 魕 */
dict[0x9b56] = "xū"; /* 魖 */
dict[0x9b57] = "chǒu"; /* 魗 */
dict[0x9b58] = "yǎn"; /* 魘 */
dict[0x9b59] = "zhān"; /* 魙 */
dict[0x9b5a] = "yú"; /* 魚 */
dict[0x9b5b] = "dāo"; /* 魛 */
dict[0x9b5c] = "rén"; /* 魜 */
dict[0x9b5d] = "jì"; /* 魝 */
dict[0x9b5e] = "bā,bà"; /* 魞 */
dict[0x9b5f] = "hóng"; /* 魟 */
dict[0x9b60] = "tuō"; /* 魠 */
dict[0x9b61] = "diào"; /* 魡 */
dict[0x9b62] = "jǐ"; /* 魢 */
dict[0x9b63] = "yú"; /* 魣 */
dict[0x9b64] = "é"; /* 魤 */
dict[0x9b65] = "jì"; /* 魥 */
dict[0x9b66] = "shā"; /* 魦 */
dict[0x9b67] = "háng"; /* 魧 */
dict[0x9b68] = "tún"; /* 魨 */
dict[0x9b69] = "mò"; /* 魩 */
dict[0x9b6a] = "jiè"; /* 魪 */
dict[0x9b6b] = "shěn"; /* 魫 */
dict[0x9b6c] = "bǎn"; /* 魬 */
dict[0x9b6d] = "yuán"; /* 魭 */
dict[0x9b6e] = "pí"; /* 魮 */
dict[0x9b6f] = "lǔ"; /* 魯 */
dict[0x9b70] = "wén"; /* 魰 */
dict[0x9b71] = "hú"; /* 魱 */
dict[0x9b72] = "lú"; /* 魲 */
dict[0x9b73] = "zā"; /* 魳 */
dict[0x9b74] = "fáng"; /* 魴 */
dict[0x9b75] = "fén"; /* 魵 */
dict[0x9b76] = "nà"; /* 魶 */
dict[0x9b77] = "yóu"; /* 魷 */
dict[0x9b78] = "piàn"; /* 魸 */
dict[0x9b79] = "mó"; /* 魹 */
dict[0x9b7a] = "hé"; /* 魺 */
dict[0x9b7b] = "xiá"; /* 魻 */
dict[0x9b7c] = "qū"; /* 魼 */
dict[0x9b7d] = "hān"; /* 魽 */
dict[0x9b7e] = "pī"; /* 魾 */
dict[0x9b7f] = "líng"; /* 魿 */
dict[0x9b80] = "tuó"; /* 鮀 */
dict[0x9b81] = "bà"; /* 鮁 */
dict[0x9b82] = "qiú"; /* 鮂 */
dict[0x9b83] = "píng"; /* 鮃 */
dict[0x9b84] = "fú"; /* 鮄 */
dict[0x9b85] = "bì"; /* 鮅 */
dict[0x9b86] = "cǐ,jì"; /* 鮆 */
dict[0x9b87] = "wèi"; /* 鮇 */
dict[0x9b88] = "jū"; /* 鮈 */
dict[0x9b89] = "diāo"; /* 鮉 */
dict[0x9b8a] = "bó,bà"; /* 鮊 */
dict[0x9b8b] = "yóu"; /* 鮋 */
dict[0x9b8c] = "gǔn"; /* 鮌 */
dict[0x9b8d] = "pí"; /* 鮍 */
dict[0x9b8e] = "nián"; /* 鮎 */
dict[0x9b8f] = "xīng"; /* 鮏 */
dict[0x9b90] = "tái"; /* 鮐 */
dict[0x9b91] = "bào"; /* 鮑 */
dict[0x9b92] = "fù"; /* 鮒 */
dict[0x9b93] = "zhǎ,zhà"; /* 鮓 */
dict[0x9b94] = "jù"; /* 鮔 */
dict[0x9b95] = "gū"; /* 鮕 */
dict[0x9b96] = "shí"; /* 鮖 */
dict[0x9b97] = "dōng"; /* 鮗 */
dict[0x9b98] = "chou,dài"; /* 鮘 */
dict[0x9b99] = "tǎ"; /* 鮙 */
dict[0x9b9a] = "jié"; /* 鮚 */
dict[0x9b9b] = "shū"; /* 鮛 */
dict[0x9b9c] = "hòu"; /* 鮜 */
dict[0x9b9d] = "xiǎng"; /* 鮝 */
dict[0x9b9e] = "ér"; /* 鮞 */
dict[0x9b9f] = "ān"; /* 鮟 */
dict[0x9ba0] = "wéi"; /* 鮠 */
dict[0x9ba1] = "zhào"; /* 鮡 */
dict[0x9ba2] = "zhū"; /* 鮢 */
dict[0x9ba3] = "yìn"; /* 鮣 */
dict[0x9ba4] = "liè"; /* 鮤 */
dict[0x9ba5] = "luò,gé"; /* 鮥 */
dict[0x9ba6] = "tóng"; /* 鮦 */
dict[0x9ba7] = "yí"; /* 鮧 */
dict[0x9ba8] = "yì"; /* 鮨 */
dict[0x9ba9] = "bìng"; /* 鮩 */
dict[0x9baa] = "wěi"; /* 鮪 */
dict[0x9bab] = "jiāo"; /* 鮫 */
dict[0x9bac] = "kū"; /* 鮬 */
dict[0x9bad] = "guī,xié"; /* 鮭 */
dict[0x9bae] = "xiān,xiǎn"; /* 鮮 */
dict[0x9baf] = "gé"; /* 鮯 */
dict[0x9bb0] = "huí"; /* 鮰 */
dict[0x9bb1] = "lǎo"; /* 鮱 */
dict[0x9bb2] = "fú"; /* 鮲 */
dict[0x9bb3] = "kào"; /* 鮳 */
dict[0x9bb4] = "xiū"; /* 鮴 */
dict[0x9bb5] = "tuō"; /* 鮵 */
dict[0x9bb6] = "jūn"; /* 鮶 */
dict[0x9bb7] = "tí"; /* 鮷 */
dict[0x9bb8] = "miǎn"; /* 鮸 */
dict[0x9bb9] = "shāo"; /* 鮹 */
dict[0x9bba] = "zhǎ"; /* 鮺 */
dict[0x9bbb] = "suō"; /* 鮻 */
dict[0x9bbc] = "qīn"; /* 鮼 */
dict[0x9bbd] = "yú"; /* 鮽 */
dict[0x9bbe] = "něi"; /* 鮾 */
dict[0x9bbf] = "zhé"; /* 鮿 */
dict[0x9bc0] = "gǔn"; /* 鯀 */
dict[0x9bc1] = "gěng"; /* 鯁 */
dict[0x9bc2] = "sū"; /* 鯂 */
dict[0x9bc3] = "wú"; /* 鯃 */
dict[0x9bc4] = "qiú"; /* 鯄 */
dict[0x9bc5] = "shān"; /* 鯅 */
dict[0x9bc6] = "pū,bū"; /* 鯆 */
dict[0x9bc7] = "huàn"; /* 鯇 */
dict[0x9bc8] = "tiáo"; /* 鯈 */
dict[0x9bc9] = "lǐ"; /* 鯉 */
dict[0x9bca] = "shā"; /* 鯊 */
dict[0x9bcb] = "shā"; /* 鯋 */
dict[0x9bcc] = "kào"; /* 鯌 */
dict[0x9bcd] = "méng"; /* 鯍 */
dict[0x9bce] = "chéng"; /* 鯎 */
dict[0x9bcf] = "lí"; /* 鯏 */
dict[0x9bd0] = "zǒu"; /* 鯐 */
dict[0x9bd1] = "xī"; /* 鯑 */
dict[0x9bd2] = "yǒng"; /* 鯒 */
dict[0x9bd3] = "shēn"; /* 鯓 */
dict[0x9bd4] = "zī"; /* 鯔 */
dict[0x9bd5] = "qí"; /* 鯕 */
dict[0x9bd6] = "qīng"; /* 鯖 */
dict[0x9bd7] = "xiǎng"; /* 鯗 */
dict[0x9bd8] = "něi"; /* 鯘 */
dict[0x9bd9] = "chún"; /* 鯙 */
dict[0x9bda] = "jì"; /* 鯚 */
dict[0x9bdb] = "diāo"; /* 鯛 */
dict[0x9bdc] = "qiè"; /* 鯜 */
dict[0x9bdd] = "gù"; /* 鯝 */
dict[0x9bde] = "zhǒu"; /* 鯞 */
dict[0x9bdf] = "dōng"; /* 鯟 */
dict[0x9be0] = "lái"; /* 鯠 */
dict[0x9be1] = "fēi"; /* 鯡 */
dict[0x9be2] = "ní"; /* 鯢 */
dict[0x9be3] = "yì,sī"; /* 鯣 */
dict[0x9be4] = "kūn"; /* 鯤 */
dict[0x9be5] = "lù"; /* 鯥 */
dict[0x9be6] = "jiù"; /* 鯦 */
dict[0x9be7] = "chāng"; /* 鯧 */
dict[0x9be8] = "jīng"; /* 鯨 */
dict[0x9be9] = "lún"; /* 鯩 */
dict[0x9bea] = "líng"; /* 鯪 */
dict[0x9beb] = "zōu"; /* 鯫 */
dict[0x9bec] = "lí"; /* 鯬 */
dict[0x9bed] = "měng"; /* 鯭 */
dict[0x9bee] = "zōng"; /* 鯮 */
dict[0x9bef] = "zhì"; /* 鯯 */
dict[0x9bf0] = "nián"; /* 鯰 */
dict[0x9bf1] = "hǔ"; /* 鯱 */
dict[0x9bf2] = "yú"; /* 鯲 */
dict[0x9bf3] = "dǐ"; /* 鯳 */
dict[0x9bf4] = "shī"; /* 鯴 */
dict[0x9bf5] = "shēn"; /* 鯵 */
dict[0x9bf6] = "huàn"; /* 鯶 */
dict[0x9bf7] = "tí"; /* 鯷 */
dict[0x9bf8] = "hóu"; /* 鯸 */
dict[0x9bf9] = "xīng"; /* 鯹 */
dict[0x9bfa] = "zhū"; /* 鯺 */
dict[0x9bfb] = "là"; /* 鯻 */
dict[0x9bfc] = "zōng"; /* 鯼 */
dict[0x9bfd] = "jì"; /* 鯽 */
dict[0x9bfe] = "biān"; /* 鯾 */
dict[0x9bff] = "biān"; /* 鯿 */
dict[0x9c00] = "huàn"; /* 鰀 */
dict[0x9c01] = "quán"; /* 鰁 */
dict[0x9c02] = "zéi"; /* 鰂 */
dict[0x9c03] = "wēi"; /* 鰃 */
dict[0x9c04] = "wēi"; /* 鰄 */
dict[0x9c05] = "yú"; /* 鰅 */
dict[0x9c06] = "chūn"; /* 鰆 */
dict[0x9c07] = "róu"; /* 鰇 */
dict[0x9c08] = "dié"; /* 鰈 */
dict[0x9c09] = "huáng"; /* 鰉 */
dict[0x9c0a] = "liàn"; /* 鰊 */
dict[0x9c0b] = "yǎn"; /* 鰋 */
dict[0x9c0c] = "qiū"; /* 鰌 */
dict[0x9c0d] = "qiū"; /* 鰍 */
dict[0x9c0e] = "jiǎn"; /* 鰎 */
dict[0x9c0f] = "bī"; /* 鰏 */
dict[0x9c10] = "è"; /* 鰐 */
dict[0x9c11] = "yáng"; /* 鰑 */
dict[0x9c12] = "fù"; /* 鰒 */
dict[0x9c13] = "sāi,xǐ"; /* 鰓 */
dict[0x9c14] = "jiān"; /* 鰔 */
dict[0x9c15] = "xiā"; /* 鰕 */
dict[0x9c16] = "tuǒ"; /* 鰖 */
dict[0x9c17] = "hú"; /* 鰗 */
dict[0x9c18] = "shì"; /* 鰘 */
dict[0x9c19] = "ruò"; /* 鰙 */
dict[0x9c1a] = "xuān"; /* 鰚 */
dict[0x9c1b] = "wēn"; /* 鰛 */
dict[0x9c1c] = "jiān"; /* 鰜 */
dict[0x9c1d] = "hào"; /* 鰝 */
dict[0x9c1e] = "wū"; /* 鰞 */
dict[0x9c1f] = "páng"; /* 鰟 */
dict[0x9c20] = "sāo"; /* 鰠 */
dict[0x9c21] = "liú"; /* 鰡 */
dict[0x9c22] = "mǎ"; /* 鰢 */
dict[0x9c23] = "shí"; /* 鰣 */
dict[0x9c24] = "shī"; /* 鰤 */
dict[0x9c25] = "guān"; /* 鰥 */
dict[0x9c26] = "zī"; /* 鰦 */
dict[0x9c27] = "téng"; /* 鰧 */
dict[0x9c28] = "tǎ"; /* 鰨 */
dict[0x9c29] = "yáo"; /* 鰩 */
dict[0x9c2a] = "è"; /* 鰪 */
dict[0x9c2b] = "yóng"; /* 鰫 */
dict[0x9c2c] = "qián"; /* 鰬 */
dict[0x9c2d] = "qí"; /* 鰭 */
dict[0x9c2e] = "wēn"; /* 鰮 */
dict[0x9c2f] = "ruò"; /* 鰯 */
dict[0x9c30] = "shén"; /* 鰰 */
dict[0x9c31] = "lián"; /* 鰱 */
dict[0x9c32] = "áo"; /* 鰲 */
dict[0x9c33] = "lè"; /* 鰳 */
dict[0x9c34] = "huī"; /* 鰴 */
dict[0x9c35] = "mǐn"; /* 鰵 */
dict[0x9c36] = "jì"; /* 鰶 */
dict[0x9c37] = "tiáo"; /* 鰷 */
dict[0x9c38] = "qū"; /* 鰸 */
dict[0x9c39] = "jiān"; /* 鰹 */
dict[0x9c3a] = "shēn"; /* 鰺 */
dict[0x9c3b] = "mán"; /* 鰻 */
dict[0x9c3c] = "xí"; /* 鰼 */
dict[0x9c3d] = "qiú"; /* 鰽 */
dict[0x9c3e] = "piào"; /* 鰾 */
dict[0x9c3f] = "jì"; /* 鰿 */
dict[0x9c40] = "jì"; /* 鱀 */
dict[0x9c41] = "zhú"; /* 鱁 */
dict[0x9c42] = "jiāng"; /* 鱂 */
dict[0x9c43] = "xiū"; /* 鱃 */
dict[0x9c44] = "zhuān"; /* 鱄 */
dict[0x9c45] = "yōng"; /* 鱅 */
dict[0x9c46] = "zhāng"; /* 鱆 */
dict[0x9c47] = "kāng"; /* 鱇 */
dict[0x9c48] = "xuě"; /* 鱈 */
dict[0x9c49] = "biē"; /* 鱉 */
dict[0x9c4a] = "yù"; /* 鱊 */
dict[0x9c4b] = "qū"; /* 鱋 */
dict[0x9c4c] = "xiàng"; /* 鱌 */
dict[0x9c4d] = "bō"; /* 鱍 */
dict[0x9c4e] = "jiǎo"; /* 鱎 */
dict[0x9c4f] = "xún"; /* 鱏 */
dict[0x9c50] = "sù"; /* 鱐 */
dict[0x9c51] = "huáng"; /* 鱑 */
dict[0x9c52] = "zūn"; /* 鱒 */
dict[0x9c53] = "shàn"; /* 鱓 */
dict[0x9c54] = "shàn"; /* 鱔 */
dict[0x9c55] = "fān"; /* 鱕 */
dict[0x9c56] = "guì"; /* 鱖 */
dict[0x9c57] = "lín"; /* 鱗 */
dict[0x9c58] = "xún"; /* 鱘 */
dict[0x9c59] = "yáo"; /* 鱙 */
dict[0x9c5a] = "xǐ"; /* 鱚 */
dict[0x9c5b] = "zēng"; /* 鱛 */
dict[0x9c5c] = "xiāng"; /* 鱜 */
dict[0x9c5d] = "fèn"; /* 鱝 */
dict[0x9c5e] = "guān"; /* 鱞 */
dict[0x9c5f] = "hòu"; /* 鱟 */
dict[0x9c60] = "kuài"; /* 鱠 */
dict[0x9c61] = "zéi"; /* 鱡 */
dict[0x9c62] = "sāo"; /* 鱢 */
dict[0x9c63] = "zhān"; /* 鱣 */
dict[0x9c64] = "gǎn"; /* 鱤 */
dict[0x9c65] = "guì"; /* 鱥 */
dict[0x9c66] = "yìng"; /* 鱦 */
dict[0x9c67] = "lǐ"; /* 鱧 */
dict[0x9c68] = "cháng"; /* 鱨 */
dict[0x9c69] = "léi"; /* 鱩 */
dict[0x9c6a] = "shǔ"; /* 鱪 */
dict[0x9c6b] = "ài"; /* 鱫 */
dict[0x9c6c] = "rú"; /* 鱬 */
dict[0x9c6d] = "jì"; /* 鱭 */
dict[0x9c6e] = "xù"; /* 鱮 */
dict[0x9c6f] = "hù"; /* 鱯 */
dict[0x9c70] = "shǔ"; /* 鱰 */
dict[0x9c71] = "lǐ"; /* 鱱 */
dict[0x9c72] = "liè"; /* 鱲 */
dict[0x9c73] = "lè"; /* 鱳 */
dict[0x9c74] = "miè"; /* 鱴 */
dict[0x9c75] = "zhēn"; /* 鱵 */
dict[0x9c76] = "xiǎng"; /* 鱶 */
dict[0x9c77] = "è"; /* 鱷 */
dict[0x9c78] = "lú"; /* 鱸 */
dict[0x9c79] = "guàn"; /* 鱹 */
dict[0x9c7a] = "lí"; /* 鱺 */
dict[0x9c7b] = "xiān"; /* 鱻 */
dict[0x9c7c] = "yú"; /* 鱼 */
dict[0x9c7d] = "dāo"; /* 鱽 */
dict[0x9c7e] = "jǐ"; /* 鱾 */
dict[0x9c7f] = "yóu"; /* 鱿 */
dict[0x9c80] = "tún"; /* 鲀 */
dict[0x9c81] = "lǔ"; /* 鲁 */
dict[0x9c82] = "fáng"; /* 鲂 */
dict[0x9c83] = "bā,bà"; /* 鲃 */
dict[0x9c84] = "hé,gě"; /* 鲄 */
dict[0x9c85] = "bà"; /* 鲅 */
dict[0x9c86] = "píng"; /* 鲆 */
dict[0x9c87] = "nián"; /* 鲇 */
dict[0x9c88] = "lú"; /* 鲈 */
dict[0x9c89] = "yóu"; /* 鲉 */
dict[0x9c8a] = "zhǎ,zhà"; /* 鲊 */
dict[0x9c8b] = "fù"; /* 鲋 */
dict[0x9c8c] = "bó,bà"; /* 鲌 */
dict[0x9c8d] = "bào"; /* 鲍 */
dict[0x9c8e] = "hòu"; /* 鲎 */
dict[0x9c8f] = "pí"; /* 鲏 */
dict[0x9c90] = "tái"; /* 鲐 */
dict[0x9c91] = "guī,xié"; /* 鲑 */
dict[0x9c92] = "jié"; /* 鲒 */
dict[0x9c93] = "kào"; /* 鲓 */
dict[0x9c94] = "wěi"; /* 鲔 */
dict[0x9c95] = "ér"; /* 鲕 */
dict[0x9c96] = "tóng"; /* 鲖 */
dict[0x9c97] = "zéi"; /* 鲗 */
dict[0x9c98] = "hòu"; /* 鲘 */
dict[0x9c99] = "kuài"; /* 鲙 */
dict[0x9c9a] = "jì"; /* 鲚 */
dict[0x9c9b] = "jiāo"; /* 鲛 */
dict[0x9c9c] = "xiān,xiǎn"; /* 鲜 */
dict[0x9c9d] = "zhǎ"; /* 鲝 */
dict[0x9c9e] = "xiǎng"; /* 鲞 */
dict[0x9c9f] = "xún"; /* 鲟 */
dict[0x9ca0] = "gěng"; /* 鲠 */
dict[0x9ca1] = "lí"; /* 鲡 */
dict[0x9ca2] = "lián"; /* 鲢 */
dict[0x9ca3] = "jiān"; /* 鲣 */
dict[0x9ca4] = "lǐ"; /* 鲤 */
dict[0x9ca5] = "shí"; /* 鲥 */
dict[0x9ca6] = "tiáo"; /* 鲦 */
dict[0x9ca7] = "gǔn"; /* 鲧 */
dict[0x9ca8] = "shā"; /* 鲨 */
dict[0x9ca9] = "huàn"; /* 鲩 */
dict[0x9caa] = "jūn"; /* 鲪 */
dict[0x9cab] = "jì"; /* 鲫 */
dict[0x9cac] = "yǒng"; /* 鲬 */
dict[0x9cad] = "qīng"; /* 鲭 */
dict[0x9cae] = "líng"; /* 鲮 */
dict[0x9caf] = "qí"; /* 鲯 */
dict[0x9cb0] = "zōu"; /* 鲰 */
dict[0x9cb1] = "fēi"; /* 鲱 */
dict[0x9cb2] = "kūn"; /* 鲲 */
dict[0x9cb3] = "chāng"; /* 鲳 */
dict[0x9cb4] = "gù"; /* 鲴 */
dict[0x9cb5] = "ní"; /* 鲵 */
dict[0x9cb6] = "nián"; /* 鲶 */
dict[0x9cb7] = "diāo"; /* 鲷 */
dict[0x9cb8] = "jīng"; /* 鲸 */
dict[0x9cb9] = "shēn"; /* 鲹 */
dict[0x9cba] = "shī"; /* 鲺 */
dict[0x9cbb] = "zī"; /* 鲻 */
dict[0x9cbc] = "fèn"; /* 鲼 */
dict[0x9cbd] = "dié"; /* 鲽 */
dict[0x9cbe] = "bī"; /* 鲾 */
dict[0x9cbf] = "cháng"; /* 鲿 */
dict[0x9cc0] = "tí"; /* 鳀 */
dict[0x9cc1] = "wēn"; /* 鳁 */
dict[0x9cc2] = "wēi"; /* 鳂 */
dict[0x9cc3] = "sāi,xǐ"; /* 鳃 */
dict[0x9cc4] = "è"; /* 鳄 */
dict[0x9cc5] = "qiū"; /* 鳅 */
dict[0x9cc6] = "fù"; /* 鳆 */
dict[0x9cc7] = "huáng"; /* 鳇 */
dict[0x9cc8] = "quán"; /* 鳈 */
dict[0x9cc9] = "jiāng"; /* 鳉 */
dict[0x9cca] = "biān"; /* 鳊 */
dict[0x9ccb] = "sāo"; /* 鳋 */
dict[0x9ccc] = "áo"; /* 鳌 */
dict[0x9ccd] = "qí"; /* 鳍 */
dict[0x9cce] = "tǎ"; /* 鳎 */
dict[0x9ccf] = "guān"; /* 鳏 */
dict[0x9cd0] = "yáo"; /* 鳐 */
dict[0x9cd1] = "páng"; /* 鳑 */
dict[0x9cd2] = "jiān"; /* 鳒 */
dict[0x9cd3] = "lè"; /* 鳓 */
dict[0x9cd4] = "biào"; /* 鳔 */
dict[0x9cd5] = "xuě"; /* 鳕 */
dict[0x9cd6] = "biē"; /* 鳖 */
dict[0x9cd7] = "mán"; /* 鳗 */
dict[0x9cd8] = "mǐn"; /* 鳘 */
dict[0x9cd9] = "yōng"; /* 鳙 */
dict[0x9cda] = "wèi"; /* 鳚 */
dict[0x9cdb] = "xí"; /* 鳛 */
dict[0x9cdc] = "guì,jué"; /* 鳜 */
dict[0x9cdd] = "shàn"; /* 鳝 */
dict[0x9cde] = "lín"; /* 鳞 */
dict[0x9cdf] = "zūn"; /* 鳟 */
dict[0x9ce0] = "hù"; /* 鳠 */
dict[0x9ce1] = "gǎn"; /* 鳡 */
dict[0x9ce2] = "lǐ"; /* 鳢 */
dict[0x9ce3] = "zhān,shàn"; /* 鳣 */
dict[0x9ce4] = "guǎn"; /* 鳤 */
dict[0x9ce5] = "niǎo,diǎo"; /* 鳥 */
dict[0x9ce6] = "yǐ"; /* 鳦 */
dict[0x9ce7] = "fú"; /* 鳧 */
dict[0x9ce8] = "lì"; /* 鳨 */
dict[0x9ce9] = "jiū"; /* 鳩 */
dict[0x9cea] = "bú"; /* 鳪 */
dict[0x9ceb] = "yàn"; /* 鳫 */
dict[0x9cec] = "fú"; /* 鳬 */
dict[0x9ced] = "diāo,zhāo"; /* 鳭 */
dict[0x9cee] = "jī"; /* 鳮 */
dict[0x9cef] = "fèng"; /* 鳯 */
dict[0x9cf0] = "rù"; /* 鳰 */
dict[0x9cf1] = "gān,hàn,yàn"; /* 鳱 */
dict[0x9cf2] = "shī"; /* 鳲 */
dict[0x9cf3] = "fèng"; /* 鳳 */
dict[0x9cf4] = "míng"; /* 鳴 */
dict[0x9cf5] = "bǎo"; /* 鳵 */
dict[0x9cf6] = "yuān"; /* 鳶 */
dict[0x9cf7] = "zhī"; /* 鳷 */
dict[0x9cf8] = "hù"; /* 鳸 */
dict[0x9cf9] = "qín"; /* 鳹 */
dict[0x9cfa] = "fū,guī"; /* 鳺 */
dict[0x9cfb] = "bān,fén"; /* 鳻 */
dict[0x9cfc] = "wén"; /* 鳼 */
dict[0x9cfd] = "jiān,qiān,zhān"; /* 鳽 */
dict[0x9cfe] = "shī"; /* 鳾 */
dict[0x9cff] = "yù"; /* 鳿 */
dict[0x9d00] = "fǒu"; /* 鴀 */
dict[0x9d01] = "yāo"; /* 鴁 */
dict[0x9d02] = "jué"; /* 鴂 */
dict[0x9d03] = "jué"; /* 鴃 */
dict[0x9d04] = "pǐ"; /* 鴄 */
dict[0x9d05] = "huān"; /* 鴅 */
dict[0x9d06] = "zhèn"; /* 鴆 */
dict[0x9d07] = "bǎo"; /* 鴇 */
dict[0x9d08] = "yàn"; /* 鴈 */
dict[0x9d09] = "yā"; /* 鴉 */
dict[0x9d0a] = "zhèng"; /* 鴊 */
dict[0x9d0b] = "fāng"; /* 鴋 */
dict[0x9d0c] = "fèng"; /* 鴌 */
dict[0x9d0d] = "wén"; /* 鴍 */
dict[0x9d0e] = "ōu"; /* 鴎 */
dict[0x9d0f] = "dài"; /* 鴏 */
dict[0x9d10] = "jiā"; /* 鴐 */
dict[0x9d11] = "rú"; /* 鴑 */
dict[0x9d12] = "líng"; /* 鴒 */
dict[0x9d13] = "miè"; /* 鴓 */
dict[0x9d14] = "fú"; /* 鴔 */
dict[0x9d15] = "tuó"; /* 鴕 */
dict[0x9d16] = "mín"; /* 鴖 */
dict[0x9d17] = "lì"; /* 鴗 */
dict[0x9d18] = "biǎn"; /* 鴘 */
dict[0x9d19] = "zhì"; /* 鴙 */
dict[0x9d1a] = "gē"; /* 鴚 */
dict[0x9d1b] = "yuān"; /* 鴛 */
dict[0x9d1c] = "cí"; /* 鴜 */
dict[0x9d1d] = "qú"; /* 鴝 */
dict[0x9d1e] = "xiāo"; /* 鴞 */
dict[0x9d1f] = "chī"; /* 鴟 */
dict[0x9d20] = "dàn"; /* 鴠 */
dict[0x9d21] = "jū"; /* 鴡 */
dict[0x9d22] = "yāo"; /* 鴢 */
dict[0x9d23] = "gū"; /* 鴣 */
dict[0x9d24] = "zhōng"; /* 鴤 */
dict[0x9d25] = "yù"; /* 鴥 */
dict[0x9d26] = "yāng"; /* 鴦 */
dict[0x9d27] = "yù"; /* 鴧 */
dict[0x9d28] = "yā"; /* 鴨 */
dict[0x9d29] = "dié"; /* 鴩 */
dict[0x9d2a] = "yù"; /* 鴪 */
dict[0x9d2b] = "tián"; /* 鴫 */
dict[0x9d2c] = "yīng"; /* 鴬 */
dict[0x9d2d] = "duī"; /* 鴭 */
dict[0x9d2e] = "wū"; /* 鴮 */
dict[0x9d2f] = "ér"; /* 鴯 */
dict[0x9d30] = "guā"; /* 鴰 */
dict[0x9d31] = "ài"; /* 鴱 */
dict[0x9d32] = "zhī"; /* 鴲 */
dict[0x9d33] = "yàn"; /* 鴳 */
dict[0x9d34] = "héng"; /* 鴴 */
dict[0x9d35] = "xiāo"; /* 鴵 */
dict[0x9d36] = "jiá"; /* 鴶 */
dict[0x9d37] = "liè"; /* 鴷 */
dict[0x9d38] = "zhū"; /* 鴸 */
dict[0x9d39] = "yáng"; /* 鴹 */
dict[0x9d3a] = "yí"; /* 鴺 */
dict[0x9d3b] = "hóng"; /* 鴻 */
dict[0x9d3c] = "lù"; /* 鴼 */
dict[0x9d3d] = "rú"; /* 鴽 */
dict[0x9d3e] = "móu"; /* 鴾 */
dict[0x9d3f] = "gē"; /* 鴿 */
dict[0x9d40] = "rén"; /* 鵀 */
dict[0x9d41] = "jiāo"; /* 鵁 */
dict[0x9d42] = "xiū"; /* 鵂 */
dict[0x9d43] = "zhōu"; /* 鵃 */
dict[0x9d44] = "chī"; /* 鵄 */
dict[0x9d45] = "luò"; /* 鵅 */
dict[0x9d46] = "héng"; /* 鵆 */
dict[0x9d47] = "nián"; /* 鵇 */
dict[0x9d48] = "ě"; /* 鵈 */
dict[0x9d49] = "luán"; /* 鵉 */
dict[0x9d4a] = "jiá"; /* 鵊 */
dict[0x9d4b] = "jì"; /* 鵋 */
dict[0x9d4c] = "tú"; /* 鵌 */
dict[0x9d4d] = "huān"; /* 鵍 */
dict[0x9d4e] = "tuǒ"; /* 鵎 */
dict[0x9d4f] = "bū"; /* 鵏 */
dict[0x9d50] = "wú"; /* 鵐 */
dict[0x9d51] = "jiān"; /* 鵑 */
dict[0x9d52] = "yù"; /* 鵒 */
dict[0x9d53] = "bó"; /* 鵓 */
dict[0x9d54] = "jùn"; /* 鵔 */
dict[0x9d55] = "jùn"; /* 鵕 */
dict[0x9d56] = "bī"; /* 鵖 */
dict[0x9d57] = "xī"; /* 鵗 */
dict[0x9d58] = "jùn"; /* 鵘 */
dict[0x9d59] = "jú"; /* 鵙 */
dict[0x9d5a] = "tū"; /* 鵚 */
dict[0x9d5b] = "jìng"; /* 鵛 */
dict[0x9d5c] = "tí"; /* 鵜 */
dict[0x9d5d] = "é"; /* 鵝 */
dict[0x9d5e] = "é"; /* 鵞 */
dict[0x9d5f] = "kuáng"; /* 鵟 */
dict[0x9d60] = "hú"; /* 鵠 */
dict[0x9d61] = "wǔ"; /* 鵡 */
dict[0x9d62] = "shēn"; /* 鵢 */
dict[0x9d63] = "lài"; /* 鵣 */
dict[0x9d64] = "zān"; /* 鵤 */
dict[0x9d65] = "pàn"; /* 鵥 */
dict[0x9d66] = "lù"; /* 鵦 */
dict[0x9d67] = "pí"; /* 鵧 */
dict[0x9d68] = "shū"; /* 鵨 */
dict[0x9d69] = "fú"; /* 鵩 */
dict[0x9d6a] = "ān"; /* 鵪 */
dict[0x9d6b] = "zhuó"; /* 鵫 */
dict[0x9d6c] = "péng"; /* 鵬 */
dict[0x9d6d] = "qín"; /* 鵭 */
dict[0x9d6e] = "qiān"; /* 鵮 */
dict[0x9d6f] = "bēi"; /* 鵯 */
dict[0x9d70] = "diāo"; /* 鵰 */
dict[0x9d71] = "lù"; /* 鵱 */
dict[0x9d72] = "què"; /* 鵲 */
dict[0x9d73] = "jiān"; /* 鵳 */
dict[0x9d74] = "jú"; /* 鵴 */
dict[0x9d75] = "tù"; /* 鵵 */
dict[0x9d76] = "yā"; /* 鵶 */
dict[0x9d77] = "yuān"; /* 鵷 */
dict[0x9d78] = "qí"; /* 鵸 */
dict[0x9d79] = "lí"; /* 鵹 */
dict[0x9d7a] = "yè"; /* 鵺 */
dict[0x9d7b] = "zhuī"; /* 鵻 */
dict[0x9d7c] = "kōng"; /* 鵼 */
dict[0x9d7d] = "duò"; /* 鵽 */
dict[0x9d7e] = "kūn"; /* 鵾 */
dict[0x9d7f] = "shēng"; /* 鵿 */
dict[0x9d80] = "qí"; /* 鶀 */
dict[0x9d81] = "jīng"; /* 鶁 */
dict[0x9d82] = "yì"; /* 鶂 */
dict[0x9d83] = "yì"; /* 鶃 */
dict[0x9d84] = "jīng"; /* 鶄 */
dict[0x9d85] = "zī"; /* 鶅 */
dict[0x9d86] = "lái"; /* 鶆 */
dict[0x9d87] = "dōng"; /* 鶇 */
dict[0x9d88] = "qī"; /* 鶈 */
dict[0x9d89] = "chún"; /* 鶉 */
dict[0x9d8a] = "gēng"; /* 鶊 */
dict[0x9d8b] = "jū"; /* 鶋 */
dict[0x9d8c] = "qū"; /* 鶌 */
dict[0x9d8d] = "yì"; /* 鶍 */
dict[0x9d8e] = "zūn"; /* 鶎 */
dict[0x9d8f] = "jī"; /* 鶏 */
dict[0x9d90] = "shù"; /* 鶐 */
dict[0x9d91] = "yīng"; /* 鶑 */
dict[0x9d92] = "chì"; /* 鶒 */
dict[0x9d93] = "miáo"; /* 鶓 */
dict[0x9d94] = "róu"; /* 鶔 */
dict[0x9d95] = "ān"; /* 鶕 */
dict[0x9d96] = "qiū"; /* 鶖 */
dict[0x9d97] = "tí,chí"; /* 鶗 */
dict[0x9d98] = "hú"; /* 鶘 */
dict[0x9d99] = "tí,chí"; /* 鶙 */
dict[0x9d9a] = "è"; /* 鶚 */
dict[0x9d9b] = "jiē"; /* 鶛 */
dict[0x9d9c] = "máo"; /* 鶜 */
dict[0x9d9d] = "fú,bì"; /* 鶝 */
dict[0x9d9e] = "chūn"; /* 鶞 */
dict[0x9d9f] = "tú"; /* 鶟 */
dict[0x9da0] = "yǎn"; /* 鶠 */
dict[0x9da1] = "hé,jiè"; /* 鶡 */
dict[0x9da2] = "yuán"; /* 鶢 */
dict[0x9da3] = "piān,biǎn"; /* 鶣 */
dict[0x9da4] = "kūn"; /* 鶤 */
dict[0x9da5] = "méi"; /* 鶥 */
dict[0x9da6] = "hú"; /* 鶦 */
dict[0x9da7] = "yīng"; /* 鶧 */
dict[0x9da8] = "chuàn,zhì"; /* 鶨 */
dict[0x9da9] = "wù"; /* 鶩 */
dict[0x9daa] = "jú"; /* 鶪 */
dict[0x9dab] = "dōng"; /* 鶫 */
dict[0x9dac] = "cāng,qiāng"; /* 鶬 */
dict[0x9dad] = "fǎng"; /* 鶭 */
dict[0x9dae] = "hè,hú"; /* 鶮 */
dict[0x9daf] = "yīng"; /* 鶯 */
dict[0x9db0] = "yuán"; /* 鶰 */
dict[0x9db1] = "xiān"; /* 鶱 */
dict[0x9db2] = "wēng"; /* 鶲 */
dict[0x9db3] = "shī"; /* 鶳 */
dict[0x9db4] = "hè"; /* 鶴 */
dict[0x9db5] = "chú"; /* 鶵 */
dict[0x9db6] = "táng"; /* 鶶 */
dict[0x9db7] = "xiá"; /* 鶷 */
dict[0x9db8] = "ruò"; /* 鶸 */
dict[0x9db9] = "liú"; /* 鶹 */
dict[0x9dba] = "jī"; /* 鶺 */
dict[0x9dbb] = "gǔ,hú"; /* 鶻 */
dict[0x9dbc] = "jiān"; /* 鶼 */
dict[0x9dbd] = "sǔn,xùn"; /* 鶽 */
dict[0x9dbe] = "hàn"; /* 鶾 */
dict[0x9dbf] = "cí"; /* 鶿 */
dict[0x9dc0] = "cí"; /* 鷀 */
dict[0x9dc1] = "yì"; /* 鷁 */
dict[0x9dc2] = "yào"; /* 鷂 */
dict[0x9dc3] = "yàn"; /* 鷃 */
dict[0x9dc4] = "jī"; /* 鷄 */
dict[0x9dc5] = "lì"; /* 鷅 */
dict[0x9dc6] = "tián"; /* 鷆 */
dict[0x9dc7] = "kòu"; /* 鷇 */
dict[0x9dc8] = "tī"; /* 鷈 */
dict[0x9dc9] = "tī"; /* 鷉 */
dict[0x9dca] = "yì"; /* 鷊 */
dict[0x9dcb] = "tú"; /* 鷋 */
dict[0x9dcc] = "mǎ"; /* 鷌 */
dict[0x9dcd] = "xiāo"; /* 鷍 */
dict[0x9dce] = "gāo"; /* 鷎 */
dict[0x9dcf] = "tián"; /* 鷏 */
dict[0x9dd0] = "chén"; /* 鷐 */
dict[0x9dd1] = "jì"; /* 鷑 */
dict[0x9dd2] = "tuán"; /* 鷒 */
dict[0x9dd3] = "zhè"; /* 鷓 */
dict[0x9dd4] = "áo"; /* 鷔 */
dict[0x9dd5] = "yǎo"; /* 鷕 */
dict[0x9dd6] = "yī"; /* 鷖 */
dict[0x9dd7] = "ōu"; /* 鷗 */
dict[0x9dd8] = "chì"; /* 鷘 */
dict[0x9dd9] = "zhì"; /* 鷙 */
dict[0x9dda] = "liù"; /* 鷚 */
dict[0x9ddb] = "yōng"; /* 鷛 */
dict[0x9ddc] = "lóu,lǚ"; /* 鷜 */
dict[0x9ddd] = "bì"; /* 鷝 */
dict[0x9dde] = "shuāng"; /* 鷞 */
dict[0x9ddf] = "zhuó"; /* 鷟 */
dict[0x9de0] = "yú"; /* 鷠 */
dict[0x9de1] = "wú"; /* 鷡 */
dict[0x9de2] = "jué"; /* 鷢 */
dict[0x9de3] = "yín"; /* 鷣 */
dict[0x9de4] = "tí"; /* 鷤 */
dict[0x9de5] = "sī"; /* 鷥 */
dict[0x9de6] = "jiāo"; /* 鷦 */
dict[0x9de7] = "yì"; /* 鷧 */
dict[0x9de8] = "huá"; /* 鷨 */
dict[0x9de9] = "bì"; /* 鷩 */
dict[0x9dea] = "yīng"; /* 鷪 */
dict[0x9deb] = "sù"; /* 鷫 */
dict[0x9dec] = "huáng"; /* 鷬 */
dict[0x9ded] = "fán"; /* 鷭 */
dict[0x9dee] = "jiāo"; /* 鷮 */
dict[0x9def] = "liáo"; /* 鷯 */
dict[0x9df0] = "yàn"; /* 鷰 */
dict[0x9df1] = "gāo"; /* 鷱 */
dict[0x9df2] = "jiù"; /* 鷲 */
dict[0x9df3] = "xián"; /* 鷳 */
dict[0x9df4] = "xián"; /* 鷴 */
dict[0x9df5] = "tú"; /* 鷵 */
dict[0x9df6] = "mǎi"; /* 鷶 */
dict[0x9df7] = "zūn"; /* 鷷 */
dict[0x9df8] = "yù"; /* 鷸 */
dict[0x9df9] = "yīng"; /* 鷹 */
dict[0x9dfa] = "lù"; /* 鷺 */
dict[0x9dfb] = "tuán"; /* 鷻 */
dict[0x9dfc] = "xián"; /* 鷼 */
dict[0x9dfd] = "xué"; /* 鷽 */
dict[0x9dfe] = "yì"; /* 鷾 */
dict[0x9dff] = "pì"; /* 鷿 */
dict[0x9e00] = "zhǔ"; /* 鸀 */
dict[0x9e01] = "luó"; /* 鸁 */
dict[0x9e02] = "xī"; /* 鸂 */
dict[0x9e03] = "yì"; /* 鸃 */
dict[0x9e04] = "jī"; /* 鸄 */
dict[0x9e05] = "zé"; /* 鸅 */
dict[0x9e06] = "yú"; /* 鸆 */
dict[0x9e07] = "zhān"; /* 鸇 */
dict[0x9e08] = "yè"; /* 鸈 */
dict[0x9e09] = "yáng"; /* 鸉 */
dict[0x9e0a] = "pì"; /* 鸊 */
dict[0x9e0b] = "níng"; /* 鸋 */
dict[0x9e0c] = "hù"; /* 鸌 */
dict[0x9e0d] = "mí"; /* 鸍 */
dict[0x9e0e] = "yīng"; /* 鸎 */
dict[0x9e0f] = "méng"; /* 鸏 */
dict[0x9e10] = "dí"; /* 鸐 */
dict[0x9e11] = "yuè"; /* 鸑 */
dict[0x9e12] = "yù"; /* 鸒 */
dict[0x9e13] = "lěi"; /* 鸓 */
dict[0x9e14] = "bǔ"; /* 鸔 */
dict[0x9e15] = "lú"; /* 鸕 */
dict[0x9e16] = "hè"; /* 鸖 */
dict[0x9e17] = "lóng"; /* 鸗 */
dict[0x9e18] = "shuāng"; /* 鸘 */
dict[0x9e19] = "yuè"; /* 鸙 */
dict[0x9e1a] = "yīng"; /* 鸚 */
dict[0x9e1b] = "guàn"; /* 鸛 */
dict[0x9e1c] = "qú"; /* 鸜 */
dict[0x9e1d] = "lí"; /* 鸝 */
dict[0x9e1e] = "luán"; /* 鸞 */
dict[0x9e1f] = "niǎo"; /* 鸟 */
dict[0x9e20] = "jiū"; /* 鸠 */
dict[0x9e21] = "jī"; /* 鸡 */
dict[0x9e22] = "yuān"; /* 鸢 */
dict[0x9e23] = "míng"; /* 鸣 */
dict[0x9e24] = "shī"; /* 鸤 */
dict[0x9e25] = "ōu"; /* 鸥 */
dict[0x9e26] = "yā"; /* 鸦 */
dict[0x9e27] = "cāng"; /* 鸧 */
dict[0x9e28] = "bǎo"; /* 鸨 */
dict[0x9e29] = "zhèn"; /* 鸩 */
dict[0x9e2a] = "gū"; /* 鸪 */
dict[0x9e2b] = "dōng"; /* 鸫 */
dict[0x9e2c] = "lú"; /* 鸬 */
dict[0x9e2d] = "yā"; /* 鸭 */
dict[0x9e2e] = "xiāo"; /* 鸮 */
dict[0x9e2f] = "yāng"; /* 鸯 */
dict[0x9e30] = "líng"; /* 鸰 */
dict[0x9e31] = "chī"; /* 鸱 */
dict[0x9e32] = "qú"; /* 鸲 */
dict[0x9e33] = "yuān"; /* 鸳 */
dict[0x9e34] = "xué"; /* 鸴 */
dict[0x9e35] = "tuó"; /* 鸵 */
dict[0x9e36] = "sī"; /* 鸶 */
dict[0x9e37] = "zhì"; /* 鸷 */
dict[0x9e38] = "ér"; /* 鸸 */
dict[0x9e39] = "guā"; /* 鸹 */
dict[0x9e3a] = "xiū"; /* 鸺 */
dict[0x9e3b] = "héng"; /* 鸻 */
dict[0x9e3c] = "zhōu"; /* 鸼 */
dict[0x9e3d] = "gē"; /* 鸽 */
dict[0x9e3e] = "luán"; /* 鸾 */
dict[0x9e3f] = "hóng"; /* 鸿 */
dict[0x9e40] = "wú"; /* 鹀 */
dict[0x9e41] = "bó"; /* 鹁 */
dict[0x9e42] = "lí"; /* 鹂 */
dict[0x9e43] = "juān"; /* 鹃 */
dict[0x9e44] = "hú"; /* 鹄 */
dict[0x9e45] = "é"; /* 鹅 */
dict[0x9e46] = "yù"; /* 鹆 */
dict[0x9e47] = "xián"; /* 鹇 */
dict[0x9e48] = "tí"; /* 鹈 */
dict[0x9e49] = "wǔ"; /* 鹉 */
dict[0x9e4a] = "què"; /* 鹊 */
dict[0x9e4b] = "miáo"; /* 鹋 */
dict[0x9e4c] = "ān"; /* 鹌 */
dict[0x9e4d] = "kūn"; /* 鹍 */
dict[0x9e4e] = "bēi"; /* 鹎 */
dict[0x9e4f] = "péng"; /* 鹏 */
dict[0x9e50] = "qiān"; /* 鹐 */
dict[0x9e51] = "chún"; /* 鹑 */
dict[0x9e52] = "gēng"; /* 鹒 */
dict[0x9e53] = "yuān"; /* 鹓 */
dict[0x9e54] = "sù"; /* 鹔 */
dict[0x9e55] = "hú"; /* 鹕 */
dict[0x9e56] = "hé"; /* 鹖 */
dict[0x9e57] = "è"; /* 鹗 */
dict[0x9e58] = "gǔ"; /* 鹘 */
dict[0x9e59] = "qiū"; /* 鹙 */
dict[0x9e5a] = "cí"; /* 鹚 */
dict[0x9e5b] = "méi"; /* 鹛 */
dict[0x9e5c] = "wù"; /* 鹜 */
dict[0x9e5d] = "yì"; /* 鹝 */
dict[0x9e5e] = "yào"; /* 鹞 */
dict[0x9e5f] = "wēng"; /* 鹟 */
dict[0x9e60] = "liú"; /* 鹠 */
dict[0x9e61] = "jī"; /* 鹡 */
dict[0x9e62] = "yì"; /* 鹢 */
dict[0x9e63] = "jiān"; /* 鹣 */
dict[0x9e64] = "hè"; /* 鹤 */
dict[0x9e65] = "yī"; /* 鹥 */
dict[0x9e66] = "yīng"; /* 鹦 */
dict[0x9e67] = "zhè"; /* 鹧 */
dict[0x9e68] = "liù"; /* 鹨 */
dict[0x9e69] = "liáo"; /* 鹩 */
dict[0x9e6a] = "jiāo"; /* 鹪 */
dict[0x9e6b] = "jiù"; /* 鹫 */
dict[0x9e6c] = "yù"; /* 鹬 */
dict[0x9e6d] = "lù"; /* 鹭 */
dict[0x9e6e] = "huán"; /* 鹮 */
dict[0x9e6f] = "zhān"; /* 鹯 */
dict[0x9e70] = "yīng"; /* 鹰 */
dict[0x9e71] = "hù"; /* 鹱 */
dict[0x9e72] = "méng"; /* 鹲 */
dict[0x9e73] = "guàn"; /* 鹳 */
dict[0x9e74] = "shuāng"; /* 鹴 */
dict[0x9e75] = "lǔ"; /* 鹵 */
dict[0x9e76] = "jīn"; /* 鹶 */
dict[0x9e77] = "líng"; /* 鹷 */
dict[0x9e78] = "jiǎn"; /* 鹸 */
dict[0x9e79] = "xián"; /* 鹹 */
dict[0x9e7a] = "cuó"; /* 鹺 */
dict[0x9e7b] = "jiǎn"; /* 鹻 */
dict[0x9e7c] = "jiǎn"; /* 鹼 */
dict[0x9e7d] = "yán"; /* 鹽 */
dict[0x9e7e] = "cuó"; /* 鹾 */
dict[0x9e7f] = "lù"; /* 鹿 */
dict[0x9e80] = "yōu"; /* 麀 */
dict[0x9e81] = "cū"; /* 麁 */
dict[0x9e82] = "jǐ"; /* 麂 */
dict[0x9e83] = "páo,biāo"; /* 麃 */
dict[0x9e84] = "cū"; /* 麄 */
dict[0x9e85] = "páo"; /* 麅 */
dict[0x9e86] = "zhù,cū"; /* 麆 */
dict[0x9e87] = "jūn,qún"; /* 麇 */
dict[0x9e88] = "zhǔ"; /* 麈 */
dict[0x9e89] = "jiān"; /* 麉 */
dict[0x9e8a] = "mí"; /* 麊 */
dict[0x9e8b] = "mí"; /* 麋 */
dict[0x9e8c] = "yǔ"; /* 麌 */
dict[0x9e8d] = "liú"; /* 麍 */
dict[0x9e8e] = "chén"; /* 麎 */
dict[0x9e8f] = "jūn"; /* 麏 */
dict[0x9e90] = "lín"; /* 麐 */
dict[0x9e91] = "ní"; /* 麑 */
dict[0x9e92] = "qí"; /* 麒 */
dict[0x9e93] = "lù"; /* 麓 */
dict[0x9e94] = "jiù"; /* 麔 */
dict[0x9e95] = "jūn"; /* 麕 */
dict[0x9e96] = "jīng"; /* 麖 */
dict[0x9e97] = "lí,lì"; /* 麗 */
dict[0x9e98] = "xiāng"; /* 麘 */
dict[0x9e99] = "xián"; /* 麙 */
dict[0x9e9a] = "jiā"; /* 麚 */
dict[0x9e9b] = "mí"; /* 麛 */
dict[0x9e9c] = "lì"; /* 麜 */
dict[0x9e9d] = "shè"; /* 麝 */
dict[0x9e9e] = "zhāng"; /* 麞 */
dict[0x9e9f] = "lín"; /* 麟 */
dict[0x9ea0] = "jīng"; /* 麠 */
dict[0x9ea1] = "qí"; /* 麡 */
dict[0x9ea2] = "líng"; /* 麢 */
dict[0x9ea3] = "yán"; /* 麣 */
dict[0x9ea4] = "cū"; /* 麤 */
dict[0x9ea5] = "mài"; /* 麥 */
dict[0x9ea6] = "mài"; /* 麦 */
dict[0x9ea7] = "hé"; /* 麧 */
dict[0x9ea8] = "chǎo"; /* 麨 */
dict[0x9ea9] = "fū"; /* 麩 */
dict[0x9eaa] = "miàn"; /* 麪 */
dict[0x9eab] = "miàn"; /* 麫 */
dict[0x9eac] = "fū"; /* 麬 */
dict[0x9ead] = "pào"; /* 麭 */
dict[0x9eae] = "qù"; /* 麮 */
dict[0x9eaf] = "qū"; /* 麯 */
dict[0x9eb0] = "móu"; /* 麰 */
dict[0x9eb1] = "fū"; /* 麱 */
dict[0x9eb2] = "xiàn"; /* 麲 */
dict[0x9eb3] = "lái"; /* 麳 */
dict[0x9eb4] = "qū"; /* 麴 */
dict[0x9eb5] = "miàn"; /* 麵 */
dict[0x9eb6] = "chi"; /* 麶 */
dict[0x9eb7] = "fēng"; /* 麷 */
dict[0x9eb8] = "fū"; /* 麸 */
dict[0x9eb9] = "qū"; /* 麹 */
dict[0x9eba] = "miàn"; /* 麺 */
dict[0x9ebb] = "má"; /* 麻 */
dict[0x9ebc] = "mó,me"; /* 麼 */
dict[0x9ebd] = "mó,me,ma"; /* 麽 */
dict[0x9ebe] = "huī"; /* 麾 */
dict[0x9ebf] = "mí"; /* 麿 */
dict[0x9ec0] = "zōu"; /* 黀 */
dict[0x9ec1] = "nún"; /* 黁 */
dict[0x9ec2] = "fén"; /* 黂 */
dict[0x9ec3] = "huáng"; /* 黃 */
dict[0x9ec4] = "huáng"; /* 黄 */
dict[0x9ec5] = "jīn"; /* 黅 */
dict[0x9ec6] = "guāng"; /* 黆 */
dict[0x9ec7] = "tiān"; /* 黇 */
dict[0x9ec8] = "tǒu"; /* 黈 */
dict[0x9ec9] = "hóng"; /* 黉 */
dict[0x9eca] = "huà"; /* 黊 */
dict[0x9ecb] = "kuàng"; /* 黋 */
dict[0x9ecc] = "hóng"; /* 黌 */
dict[0x9ecd] = "shǔ"; /* 黍 */
dict[0x9ece] = "lí"; /* 黎 */
dict[0x9ecf] = "nián"; /* 黏 */
dict[0x9ed0] = "chī"; /* 黐 */
dict[0x9ed1] = "hēi"; /* 黑 */
dict[0x9ed2] = "hēi"; /* 黒 */
dict[0x9ed3] = "yì"; /* 黓 */
dict[0x9ed4] = "qián"; /* 黔 */
dict[0x9ed5] = "dǎn"; /* 黕 */
dict[0x9ed6] = "xì"; /* 黖 */
dict[0x9ed7] = "tún"; /* 黗 */
dict[0x9ed8] = "mò"; /* 默 */
dict[0x9ed9] = "mò"; /* 黙 */
dict[0x9eda] = "qián"; /* 黚 */
dict[0x9edb] = "dài"; /* 黛 */
dict[0x9edc] = "chù"; /* 黜 */
dict[0x9edd] = "yǒu"; /* 黝 */
dict[0x9ede] = "diǎn"; /* 點 */
dict[0x9edf] = "yī"; /* 黟 */
dict[0x9ee0] = "xiá"; /* 黠 */
dict[0x9ee1] = "yǎn"; /* 黡 */
dict[0x9ee2] = "qū"; /* 黢 */
dict[0x9ee3] = "měi"; /* 黣 */
dict[0x9ee4] = "yǎn"; /* 黤 */
dict[0x9ee5] = "qíng"; /* 黥 */
dict[0x9ee6] = "yuè"; /* 黦 */
dict[0x9ee7] = "lí"; /* 黧 */
dict[0x9ee8] = "dǎng"; /* 黨 */
dict[0x9ee9] = "dú"; /* 黩 */
dict[0x9eea] = "cǎn"; /* 黪 */
dict[0x9eeb] = "yān"; /* 黫 */
dict[0x9eec] = "yǎn"; /* 黬 */
dict[0x9eed] = "yǎn"; /* 黭 */
dict[0x9eee] = "dàn,shèn"; /* 黮 */
dict[0x9eef] = "àn"; /* 黯 */
dict[0x9ef0] = "zhěn,yān"; /* 黰 */
dict[0x9ef1] = "dài"; /* 黱 */
dict[0x9ef2] = "cǎn"; /* 黲 */
dict[0x9ef3] = "yī"; /* 黳 */
dict[0x9ef4] = "méi"; /* 黴 */
dict[0x9ef5] = "dǎn,zhǎn"; /* 黵 */
dict[0x9ef6] = "yǎn"; /* 黶 */
dict[0x9ef7] = "dú"; /* 黷 */
dict[0x9ef8] = "lú"; /* 黸 */
dict[0x9ef9] = "zhǐ"; /* 黹 */
dict[0x9efa] = "fěn"; /* 黺 */
dict[0x9efb] = "fú"; /* 黻 */
dict[0x9efc] = "fǔ"; /* 黼 */
dict[0x9efd] = "mǐn,miǎn,měng"; /* 黽 */
dict[0x9efe] = "mǐn,miǎn,měng"; /* 黾 */
dict[0x9eff] = "yuán"; /* 黿 */
dict[0x9f00] = "cù"; /* 鼀 */
dict[0x9f01] = "qù"; /* 鼁 */
dict[0x9f02] = "cháo"; /* 鼂 */
dict[0x9f03] = "wā"; /* 鼃 */
dict[0x9f04] = "zhū"; /* 鼄 */
dict[0x9f05] = "zhī"; /* 鼅 */
dict[0x9f06] = "měng"; /* 鼆 */
dict[0x9f07] = "áo"; /* 鼇 */
dict[0x9f08] = "biē"; /* 鼈 */
dict[0x9f09] = "tuó"; /* 鼉 */
dict[0x9f0a] = "bì"; /* 鼊 */
dict[0x9f0b] = "yuán"; /* 鼋 */
dict[0x9f0c] = "cháo"; /* 鼌 */
dict[0x9f0d] = "tuó"; /* 鼍 */
dict[0x9f0e] = "dǐng"; /* 鼎 */
dict[0x9f0f] = "mì"; /* 鼏 */
dict[0x9f10] = "nài"; /* 鼐 */
dict[0x9f11] = "dǐng"; /* 鼑 */
dict[0x9f12] = "zī"; /* 鼒 */
dict[0x9f13] = "gǔ"; /* 鼓 */
dict[0x9f14] = "gǔ"; /* 鼔 */
dict[0x9f15] = "dōng"; /* 鼕 */
dict[0x9f16] = "fén"; /* 鼖 */
dict[0x9f17] = "táo"; /* 鼗 */
dict[0x9f18] = "yuān"; /* 鼘 */
dict[0x9f19] = "pí"; /* 鼙 */
dict[0x9f1a] = "chāng"; /* 鼚 */
dict[0x9f1b] = "gāo"; /* 鼛 */
dict[0x9f1c] = "cào"; /* 鼜 */
dict[0x9f1d] = "yuān"; /* 鼝 */
dict[0x9f1e] = "tāng"; /* 鼞 */
dict[0x9f1f] = "tēng"; /* 鼟 */
dict[0x9f20] = "shǔ"; /* 鼠 */
dict[0x9f21] = "shǔ"; /* 鼡 */
dict[0x9f22] = "fén"; /* 鼢 */
dict[0x9f23] = "fèi"; /* 鼣 */
dict[0x9f24] = "wén"; /* 鼤 */
dict[0x9f25] = "bá"; /* 鼥 */
dict[0x9f26] = "diāo"; /* 鼦 */
dict[0x9f27] = "tuó"; /* 鼧 */
dict[0x9f28] = "zhōng"; /* 鼨 */
dict[0x9f29] = "qú"; /* 鼩 */
dict[0x9f2a] = "shēng"; /* 鼪 */
dict[0x9f2b] = "shí"; /* 鼫 */
dict[0x9f2c] = "yòu"; /* 鼬 */
dict[0x9f2d] = "shí"; /* 鼭 */
dict[0x9f2e] = "tíng"; /* 鼮 */
dict[0x9f2f] = "wú"; /* 鼯 */
dict[0x9f30] = "jú"; /* 鼰 */
dict[0x9f31] = "jīng"; /* 鼱 */
dict[0x9f32] = "hún"; /* 鼲 */
dict[0x9f33] = "jú"; /* 鼳 */
dict[0x9f34] = "yǎn"; /* 鼴 */
dict[0x9f35] = "tū"; /* 鼵 */
dict[0x9f36] = "sī"; /* 鼶 */
dict[0x9f37] = "xī"; /* 鼷 */
dict[0x9f38] = "xiàn"; /* 鼸 */
dict[0x9f39] = "yǎn"; /* 鼹 */
dict[0x9f3a] = "léi"; /* 鼺 */
dict[0x9f3b] = "bí"; /* 鼻 */
dict[0x9f3c] = "yào"; /* 鼼 */
dict[0x9f3d] = "qiú"; /* 鼽 */
dict[0x9f3e] = "hān"; /* 鼾 */
dict[0x9f3f] = "wù"; /* 鼿 */
dict[0x9f40] = "wù"; /* 齀 */
dict[0x9f41] = "hōu"; /* 齁 */
dict[0x9f42] = "xiè"; /* 齂 */
dict[0x9f43] = "è"; /* 齃 */
dict[0x9f44] = "zhā"; /* 齄 */
dict[0x9f45] = "xiù"; /* 齅 */
dict[0x9f46] = "wèng"; /* 齆 */
dict[0x9f47] = "zhā"; /* 齇 */
dict[0x9f48] = "nòng"; /* 齈 */
dict[0x9f49] = "nàng"; /* 齉 */
dict[0x9f4a] = "qí,zhāi"; /* 齊 */
dict[0x9f4b] = "zhāi"; /* 齋 */
dict[0x9f4c] = "jì"; /* 齌 */
dict[0x9f4d] = "zī"; /* 齍 */
dict[0x9f4e] = "jí"; /* 齎 */
dict[0x9f4f] = "jī"; /* 齏 */
dict[0x9f50] = "qí,jì,zī,zhāi"; /* 齐 */
dict[0x9f51] = "jī"; /* 齑 */
dict[0x9f52] = "chǐ"; /* 齒 */
dict[0x9f53] = "chèn"; /* 齓 */
dict[0x9f54] = "chèn"; /* 齔 */
dict[0x9f55] = "hé"; /* 齕 */
dict[0x9f56] = "yá"; /* 齖 */
dict[0x9f57] = "yīn"; /* 齗 */
dict[0x9f58] = "xiè"; /* 齘 */
dict[0x9f59] = "bāo"; /* 齙 */
dict[0x9f5a] = "zé"; /* 齚 */
dict[0x9f5b] = "xiè"; /* 齛 */
dict[0x9f5c] = "zī"; /* 齜 */
dict[0x9f5d] = "chī"; /* 齝 */
dict[0x9f5e] = "yàn"; /* 齞 */
dict[0x9f5f] = "jǔ"; /* 齟 */
dict[0x9f60] = "tiáo"; /* 齠 */
dict[0x9f61] = "líng"; /* 齡 */
dict[0x9f62] = "líng"; /* 齢 */
dict[0x9f63] = "chū"; /* 齣 */
dict[0x9f64] = "quán"; /* 齤 */
dict[0x9f65] = "xiè"; /* 齥 */
dict[0x9f66] = "yín"; /* 齦 */
dict[0x9f67] = "niè"; /* 齧 */
dict[0x9f68] = "jiù"; /* 齨 */
dict[0x9f69] = "yǎo"; /* 齩 */
dict[0x9f6a] = "chuò"; /* 齪 */
dict[0x9f6b] = "yǔn"; /* 齫 */
dict[0x9f6c] = "yǔ"; /* 齬 */
dict[0x9f6d] = "chǔ"; /* 齭 */
dict[0x9f6e] = "yǐ"; /* 齮 */
dict[0x9f6f] = "ní"; /* 齯 */
dict[0x9f70] = "zé"; /* 齰 */
dict[0x9f71] = "zōu"; /* 齱 */
dict[0x9f72] = "qǔ"; /* 齲 */
dict[0x9f73] = "yǔn"; /* 齳 */
dict[0x9f74] = "yǎn"; /* 齴 */
dict[0x9f75] = "yú"; /* 齵 */
dict[0x9f76] = "è"; /* 齶 */
dict[0x9f77] = "wò"; /* 齷 */
dict[0x9f78] = "yì"; /* 齸 */
dict[0x9f79] = "cī"; /* 齹 */
dict[0x9f7a] = "zōu"; /* 齺 */
dict[0x9f7b] = "diān"; /* 齻 */
dict[0x9f7c] = "chǔ"; /* 齼 */
dict[0x9f7d] = "jìn"; /* 齽 */
dict[0x9f7e] = "yà"; /* 齾 */
dict[0x9f7f] = "chǐ"; /* 齿 */
dict[0x9f80] = "chèn"; /* 龀 */
dict[0x9f81] = "hé"; /* 龁 */
dict[0x9f82] = "yín,kěn"; /* 龂 */
dict[0x9f83] = "jǔ"; /* 龃 */
dict[0x9f84] = "líng"; /* 龄 */
dict[0x9f85] = "bāo"; /* 龅 */
dict[0x9f86] = "tiáo"; /* 龆 */
dict[0x9f87] = "zī"; /* 龇 */
dict[0x9f88] = "yín,kěn"; /* 龈 */
dict[0x9f89] = "yǔ"; /* 龉 */
dict[0x9f8a] = "chuò"; /* 龊 */
dict[0x9f8b] = "qǔ"; /* 龋 */
dict[0x9f8c] = "wò"; /* 龌 */
dict[0x9f8d] = "lóng,lǒng"; /* 龍 */
dict[0x9f8e] = "páng"; /* 龎 */
dict[0x9f8f] = "gōng,wò"; /* 龏 */
dict[0x9f90] = "páng"; /* 龐 */
dict[0x9f91] = "yǎn"; /* 龑 */
dict[0x9f92] = "lóng"; /* 龒 */
dict[0x9f93] = "lóng,lǒng"; /* 龓 */
dict[0x9f94] = "gōng"; /* 龔 */
dict[0x9f95] = "kān"; /* 龕 */
dict[0x9f96] = "dá"; /* 龖 */
dict[0x9f97] = "líng"; /* 龗 */
dict[0x9f98] = "dá"; /* 龘 */
dict[0x9f99] = "lóng"; /* 龙 */
dict[0x9f9a] = "gōng"; /* 龚 */
dict[0x9f9b] = "kān"; /* 龛 */
dict[0x9f9c] = "guī,jūn,qiū"; /* 龜 */
dict[0x9f9d] = "qiū"; /* 龝 */
dict[0x9f9e] = "biē"; /* 龞 */
dict[0x9f9f] = "guī,jūn,qiū"; /* 龟 */
dict[0x9fa0] = "yuè"; /* 龠 */
dict[0x9fa1] = "chuī"; /* 龡 */
dict[0x9fa2] = "hé"; /* 龢 */
dict[0x9fa3] = "jiǎo"; /* 龣 */
dict[0x9fa4] = "xié"; /* 龤 */
dict[0x9fa6] = "cháng"; /* 龦 */
dict[0x9fa7] = "shǔ"; /* 龧 */
dict[0x9fa8] = "huái"; /* 龨 */
dict[0x9faa] = "zhān"; /* 龪 */
dict[0x9fab] = "gàn"; /* 龫 */
dict[0x9fae] = "jì"; /* 龮 */
dict[0x9faf] = "yuè"; /* 龯 */
dict[0x9fb0] = "zǒu"; /* 龰 */
dict[0x9fb1] = "sì"; /* 龱 */
dict[0x9fb2] = "kù"; /* 龲 */
dict[0x9fb5] = "shǒu"; /* 龵 */
dict[0x9fb7] = "gòng"; /* 龷 */
dict[0x9fb9] = "juǎn"; /* 龹 */
dict[0x9fba] = "zhuó"; /* 龺 */
dict[0x9fbb] = "luán"; /* 龻 */
dict[0x9fc3] = "shǎn"; /* 鿃 */
dict[0x9fc4] = "liáng"; /* 鿄 */
dict[0x9fcc] = "liáng,liàng"; /* 鿌 */
dict[0xfa1e] = "yǔ"; /* 羽 */
dict[0xfa24] = "jí"; /* 﨤 */
dict[0xfa29] = "dǎo"; /* 﨩 */

dict[0x20000] = "hē"; /*   */
dict[0x20001] = "qī"; /*  */
dict[0x20003] = "qiě,jī"; /*  */
dict[0x20005] = "hài"; /*  */
dict[0x20007] = "qiě"; /*  */
dict[0x20008] = "qiū"; /*  */
dict[0x20009] = "qiū"; /* 	 */
dict[0x2000a] = "cāo"; /* */
dict[0x2000c] = "qiū"; /* */
dict[0x2000d] = "shì"; /*  */
dict[0x20013] = "sī"; /*  */
dict[0x20014] = "jué"; /*  */
dict[0x20015] = "gèn"; /*  */
dict[0x2001a] = "bù"; /*  */
dict[0x2001b] = "yù"; /*  */
dict[0x2001d] = "kōng"; /*  */
dict[0x20022] = "zī"; /* " */
dict[0x20024] = "bìng"; /* $ */
dict[0x20026] = "xíng"; /* & */
dict[0x2002c] = "tiǎn"; /* , */
dict[0x2002e] = "jī"; /* . */
dict[0x20031] = "mǒu"; /* 1 */
dict[0x20037] = "jī"; /* 7 */
dict[0x20038] = "yè"; /* 8 */
dict[0x20039] = "jūn"; /* 9 */
dict[0x2003c] = "qián,xià"; /* < */
dict[0x2003d] = "lù"; /* = */
dict[0x2003e] = "pēi"; /* > */
dict[0x20049] = "chū"; /* I */
dict[0x20057] = "shì,hè"; /* W */
dict[0x2005e] = "pēi"; /* ^ */
dict[0x20060] = "qiè"; /* ` */
dict[0x20061] = "bǔ"; /* a */
dict[0x20065] = "guǎi"; /* e */
dict[0x20066] = "zhōng"; /* f */
dict[0x20067] = "zhōng"; /* g */
dict[0x20069] = "zhōng"; /* i */
dict[0x2006d] = "qí"; /* m */
dict[0x2006e] = "shū"; /* n */
dict[0x20070] = "guāi"; /* p */
dict[0x20071] = "shì"; /* q */
dict[0x20074] = "guī"; /* t */
dict[0x20077] = "chǎn"; /* w */
dict[0x2007c] = "yī"; /* | */
dict[0x2007d] = "wán"; /* } */
dict[0x2007f] = "dān"; /*  */
dict[0x20082] = "zhōng"; /*  */
dict[0x20084] = "huān"; /*  */
dict[0x20086] = "yì"; /*  */
dict[0x20087] = "zuǒ"; /*  */
dict[0x20088] = "jié"; /*  */
dict[0x20091] = "zōu"; /*  */
dict[0x20094] = "zǐ"; /*  */
dict[0x20095] = "shǐ"; /*  */
dict[0x20096] = "dì"; /*  */
dict[0x2009f] = "jīn"; /*  */
dict[0x200a2] = "pài"; /* ¢ */
dict[0x200a3] = "yī"; /* £ */
dict[0x200a4] = "duī"; /* ¤ */
dict[0x200a5] = "cóng"; /* ¥ */
dict[0x200a7] = "shèn"; /* § */
dict[0x200b3] = "zǒng"; /* ³ */
dict[0x200b7] = "xìng"; /* · */
dict[0x200b8] = "huáng"; /* ¸ */
dict[0x200b9] = "chuí"; /* ¹ */
dict[0x200ba] = "sī"; /* º */
dict[0x200bf] = "shǒu"; /* ¿ */
dict[0x200c9] = "yà"; /* É */
dict[0x200ca] = "yǐn"; /* Ê */
dict[0x200cb] = "gōng"; /* Ë */
dict[0x200cc] = "gǔn"; /* Ì */
dict[0x200cf] = "jiū"; /* Ï */
dict[0x200d0] = "huì"; /* Ð */
dict[0x200d2] = "yě"; /* Ò */
dict[0x200d4] = "jiǔ"; /* Ô */
dict[0x200d5] = "zhōu"; /* Õ */
dict[0x200d6] = "jiū"; /* Ö */
dict[0x200de] = "lǐ"; /* Þ */
dict[0x200df] = "yě"; /* ß */
dict[0x200e4] = "huāng"; /* ä */
dict[0x200e5] = "jǔ"; /* å */
dict[0x200e8] = "jǐ"; /* è */
dict[0x200eb] = "shēn"; /* ë */
dict[0x200ed] = "shǐ"; /* í */
dict[0x200f2] = "jié"; /* ò */
dict[0x200f3] = "kuí"; /* ó */
dict[0x200fa] = "jiù"; /* ú */
dict[0x200fc] = "sī"; /* ü */
dict[0x20103] = "gān,qián"; /* ă */
dict[0x20105] = "yè"; /* ą */
dict[0x20107] = "lào"; /* ć */
dict[0x20108] = "lín"; /* Ĉ */
dict[0x20109] = "dòng"; /* ĉ */
dict[0x2010b] = "gān,qián"; /* ċ */
dict[0x2010c] = "jué,zhuì"; /* Č */
dict[0x2010d] = "jié"; /* č */
dict[0x2010e] = "nǎi"; /* Ď */
dict[0x2010f] = "diǎo"; /* ď */
dict[0x20110] = "mā"; /* Đ */
dict[0x20111] = "jué"; /* đ */
dict[0x20112] = "chuí,shā"; /* Ē */
dict[0x20113] = "zhōu"; /* ē */
dict[0x20114] = "huàn"; /* Ĕ */
dict[0x20115] = "nǎi"; /* ĕ */
dict[0x20116] = "líng"; /* Ė */
dict[0x20117] = "zhōu"; /* ė */
dict[0x20119] = "zhēng"; /* ę */
dict[0x2011a] = "tīng"; /* Ě */
dict[0x2011b] = "yù"; /* ě */
dict[0x2011d] = "yù"; /* ĝ */
dict[0x2011e] = "shàng"; /* Ğ */
dict[0x2011f] = "xià"; /* ğ */
dict[0x20120] = "shàng"; /* Ġ */
dict[0x20121] = "wǔ"; /* ġ */
dict[0x20122] = "xuān"; /* Ģ */
dict[0x20123] = "gèn"; /* ģ */
dict[0x20124] = "chún"; /* Ĥ */
dict[0x20128] = "héng"; /* Ĩ */
dict[0x2012e] = "yà,mǒ"; /* Į */
dict[0x20130] = "lǎo"; /* İ */
dict[0x20131] = "yí"; /* ı */
dict[0x20135] = "shèng"; /* ĵ */
dict[0x20139] = "jí"; /* Ĺ */
dict[0x2013f] = "wéi"; /* Ŀ */
dict[0x20142] = "jié"; /* ł */
dict[0x20143] = "yì"; /* Ń */
dict[0x20145] = "sòng"; /* Ņ */
dict[0x20148] = "nào"; /* ň */
dict[0x2014c] = "yí"; /* Ō */
dict[0x20153] = "yóu"; /* œ */
dict[0x20154] = "kè"; /* Ŕ */
dict[0x20156] = "hēng"; /* Ŗ */
dict[0x20157] = "diè"; /* ŗ */
dict[0x2015a] = "qí"; /* Ś */
dict[0x2015e] = "chèng,shèng"; /* Ş */
dict[0x2015f] = "chèng,shèng"; /* ş */
dict[0x20160] = "xiǎng"; /* Š */
dict[0x20161] = "kè"; /* š */
dict[0x20163] = "gǎng"; /* ţ */
dict[0x20164] = "xí"; /* Ť */
dict[0x20169] = "shú"; /* ũ */
dict[0x2016a] = "guō"; /* Ū */
dict[0x2016b] = "shèng"; /* ū */
dict[0x2016c] = "bāo"; /* Ŭ */
dict[0x20171] = "xiè"; /* ű */
dict[0x20179] = "zhàng"; /* Ź */
dict[0x20181] = "luǒ"; /* Ɓ */
dict[0x20182] = "shuāi"; /* Ƃ */
dict[0x2018c] = "yōng"; /* ƌ */
dict[0x20190] = "xù"; /* Ɛ */
dict[0x20199] = "diè"; /* ƙ */
dict[0x2019b] = "dān"; /* ƛ */
dict[0x2019d] = "xiāng"; /* Ɲ */
dict[0x2019f] = "wěi"; /* Ɵ */
dict[0x201a3] = "guǎ,zhuǎ"; /* ƣ */
dict[0x201a4] = "dīng"; /* Ƥ */
dict[0x201a6] = "zhà"; /* Ʀ */
dict[0x201a7] = "rén"; /* Ƨ */
dict[0x201a9] = "fàn"; /* Ʃ */
dict[0x201ad] = "yīn"; /* ƭ */
dict[0x201ae] = "mò"; /* Ʈ */
dict[0x201b1] = "xī"; /* Ʊ */
dict[0x201b2] = "yǎn"; /* Ʋ */
dict[0x201b5] = "ní"; /* Ƶ */
dict[0x201b6] = "dàn"; /* ƶ */
dict[0x201c2] = "gè,gě"; /* ǂ */
dict[0x201cb] = "dǎn"; /* ǋ */
dict[0x201cc] = "hún"; /* ǌ */
dict[0x201cf] = "tāo"; /* Ǐ */
dict[0x201d2] = "gōng"; /* ǒ */
dict[0x201d4] = "tuō,chà"; /* ǔ */
dict[0x201d7] = "kuā"; /* Ǘ */
dict[0x201d8] = "chù"; /* ǘ */
dict[0x201ee] = "mìng"; /* Ǯ */
dict[0x201ef] = "qù"; /* ǯ */
dict[0x201f1] = "mò"; /* Ǳ */
dict[0x201f3] = "shī"; /* ǳ */
dict[0x201f5] = "gǎn"; /* ǵ */
dict[0x201f7] = "shēng"; /* Ƿ */
dict[0x201f8] = "zuǒ"; /* Ǹ */
dict[0x201fa] = "xiá"; /* Ǻ */
dict[0x201fc] = "hǔ"; /* Ǽ */
dict[0x20205] = "shōu"; /* ȅ */
dict[0x2020a] = "niě"; /* Ȋ */
dict[0x20218] = "kuí"; /* Ș */
dict[0x20224] = "yùn"; /* Ȥ */
dict[0x20225] = "guǎ"; /* ȥ */
dict[0x2022c] = "xiāo"; /* Ȭ */
dict[0x2022d] = "láo"; /* ȭ */
dict[0x20230] = "dàn"; /* Ȱ */
dict[0x20231] = "suō"; /* ȱ */
dict[0x20235] = "mǎng"; /* ȵ */
dict[0x20236] = "yí"; /* ȶ */
dict[0x20238] = "tè"; /* ȸ */
dict[0x2023a] = "bì"; /* Ⱥ */
dict[0x20262] = "xǐ"; /* ɢ */
dict[0x20263] = "hūn,hùn"; /* ɣ */
dict[0x20264] = "dá"; /* ɤ */
dict[0x20267] = "jù"; /* ɧ */
dict[0x20269] = "dú"; /* ɩ */
dict[0x2026c] = "ǎn,yǎn"; /* ɬ */
dict[0x20289] = "mèi"; /* ʉ */
dict[0x2028c] = "rán"; /* ʌ */
dict[0x2028e] = "ái"; /* ʎ */
dict[0x2028f] = "yù,xián"; /* ʏ */
dict[0x20292] = "jiàn"; /* ʒ */
dict[0x20294] = "qì"; /* ʔ */
dict[0x202a3] = "zhòu"; /* ʣ */
dict[0x202a4] = "zhì"; /* ʤ */
dict[0x202a5] = "zhǒng"; /* ʥ */
dict[0x202a6] = "nǎo"; /* ʦ */
dict[0x202a7] = "bìng"; /* ʧ */
dict[0x202a9] = "zhuàn"; /* ʩ */
dict[0x202aa] = "shù"; /* ʪ */
dict[0x202ab] = "xùn,qióng"; /* ʫ */
dict[0x202ac] = "jué"; /* ʬ */
dict[0x202ad] = "qiǎn"; /* ʭ */
dict[0x202b0] = "guǎ"; /* ʰ */
dict[0x202b1] = "hòu"; /* ʱ */
dict[0x202b2] = "tū"; /* ʲ */
dict[0x202b5] = "bēng"; /* ʵ */
dict[0x202b6] = "yìng"; /* ʶ */
dict[0x202b7] = "zhì"; /* ʷ */
dict[0x202be] = "kuí"; /* ʾ */
dict[0x202d6] = "liàn"; /* ˖ */
dict[0x202d7] = "yā"; /* ˗ */
dict[0x202dc] = "guò"; /* ˜ */
dict[0x202dd] = "miǎo"; /* ˝ */
dict[0x202de] = "shé"; /* ˞ */
dict[0x202df] = "yǔ"; /* ˟ */
dict[0x202e1] = "sì"; /* ˡ */
dict[0x202e2] = "sǒu,zhòu"; /* ˢ */
dict[0x202e3] = "yǐ"; /* ˣ */
dict[0x202e4] = "zhì"; /* ˤ */
dict[0x202e7] = "qiē"; /* ˧ */
dict[0x202e9] = "fù"; /* ˩ */
dict[0x202ec] = "jú"; /* ˬ */
dict[0x202ed] = "bèi"; /* ˭ */
dict[0x202ef] = "bì"; /* ˯ */
dict[0x202f2] = "suǒ"; /* ˲ */
dict[0x202f5] = "qiǎn"; /* ˵ */
dict[0x202f6] = "mǐng"; /* ˶ */
dict[0x202f7] = "chǎn"; /* ˷ */
dict[0x202fa] = "sāo"; /* ˺ */
dict[0x202fb] = "jī"; /* ˻ */
dict[0x20315] = "gòng"; /* ̕ */
dict[0x20316] = "qióng"; /* ̖ */
dict[0x2031a] = "ròng"; /* ̚ */
dict[0x2031e] = "sǒu"; /* ̞ */
dict[0x2031f] = "sǒu"; /* ̟ */
dict[0x20320] = "yáo"; /* ̠ */
dict[0x20325] = "wū"; /* ̥ */
dict[0x2032a] = "chōu,tāo"; /* ̪ */
dict[0x2032d] = "shuài"; /* ̭ */
dict[0x2032e] = "zhē"; /* ̮ */
dict[0x2032f] = "lì,lí"; /* ̯ */
dict[0x20330] = "gài"; /* ̰ */
dict[0x20331] = "suī"; /* ̱ */
dict[0x20332] = "zhān"; /* ̲ */
dict[0x20334] = "zhuàng"; /* ̴ */
dict[0x20336] = "huā"; /* ̶ */
dict[0x2033d] = "fù"; /* ̽ */
dict[0x20343] = "jī"; /* ̓ */
dict[0x20344] = "dōu"; /* ̈́ */
dict[0x20350] = "hú,lěng"; /* ͐ */
dict[0x20357] = "huì"; /* ͗ */
dict[0x20359] = "bǎo"; /* ͙ */
dict[0x2035a] = "jiǎn"; /* ͚ */
dict[0x2035b] = "yǎn"; /* ͛ */
dict[0x2035c] = "zhì"; /* ͜ */
dict[0x20366] = "xián"; /* ͦ */
dict[0x20368] = "měi"; /* ͨ */
dict[0x20369] = "yào"; /* ͩ */
dict[0x2036a] = "dī"; /* ͪ */
dict[0x2036b] = "yí"; /* ͫ */
dict[0x2036f] = "bié"; /* ͯ */
dict[0x20372] = "qú"; /* Ͳ */
dict[0x20373] = "yì"; /* ͳ */
dict[0x20375] = "yàng"; /* ͵ */
dict[0x20379] = "zhá"; /* ͹ */
dict[0x2037d] = "shà"; /* ͽ */
dict[0x20392] = "mèn"; /* Β */
dict[0x20399] = "lái"; /* Ι */
dict[0x2039d] = "qiān"; /* Ν */
dict[0x203ae] = "jué"; /* ή */
dict[0x203b0] = "qī"; /* ΰ */
dict[0x203b3] = "yú"; /* γ */
dict[0x203b6] = "zǎi"; /* ζ */
dict[0x203b7] = "sà"; /* η */
dict[0x203b8] = "sè"; /* θ */
dict[0x203bb] = "dùn"; /* λ */
dict[0x203bf] = "jiě"; /* ο */
dict[0x203c0] = "kē"; /* π */
dict[0x203c3] = "yuē"; /* σ */
dict[0x203c7] = "jiǎn"; /* χ */
dict[0x203c8] = "yáo"; /* ψ */
dict[0x203d3] = "xiān"; /* ϓ */
dict[0x203d5] = "xiào"; /* ϕ */
dict[0x203d6] = "qiāo"; /* ϖ */
dict[0x203da] = "yù"; /* Ϛ */
dict[0x203db] = "qú"; /* ϛ */
dict[0x203e1] = "xiān,líng"; /* ϡ */
dict[0x203e2] = "luò"; /* Ϣ */
dict[0x203e4] = "guǎng"; /* Ϥ */
dict[0x203e7] = "chēng"; /* ϧ */
dict[0x203e8] = "chuǎng"; /* Ϩ */
dict[0x203e9] = "yí"; /* ϩ */
dict[0x203eb] = "zhěng"; /* ϫ */
dict[0x203ed] = "zòng"; /* ϭ */
dict[0x203ee] = "duì"; /* Ϯ */
dict[0x203f0] = "zhǎi"; /* ϰ */
dict[0x203ff] = "fěi"; /* Ͽ */
dict[0x20400] = "yí"; /* Ѐ */
dict[0x20401] = "méng"; /* Ё */
dict[0x20408] = "biān,pián"; /* Ј */
dict[0x20409] = "jié"; /* Љ */
dict[0x2040a] = "shù"; /* Њ */
dict[0x2040b] = "liáo"; /* Ћ */
dict[0x2040c] = "bǐ,bà"; /* Ќ */
dict[0x2040d] = "sú"; /* Ѝ */
dict[0x20411] = "dì"; /* Б */
dict[0x20421] = "bèi"; /* С */
dict[0x20422] = "wèn"; /* Т */
dict[0x20427] = "méng"; /* Ч */
dict[0x20429] = "chǎn"; /* Щ */
dict[0x20431] = "gàn"; /* б */
dict[0x20432] = "bèi"; /* в */
dict[0x20435] = "dǎo"; /* е */
dict[0x2043a] = "pín"; /* к */
dict[0x2043b] = "jiǎn"; /* л */
dict[0x2043c] = "lìn"; /* м */
dict[0x2043d] = "guì,guī"; /* н */
dict[0x2043e] = "qī"; /* о */
dict[0x2043f] = "hōng"; /* п */
dict[0x20443] = "jí"; /* у */
dict[0x20444] = "xiè"; /* ф */
dict[0x20445] = "zhēng"; /* х */
dict[0x20446] = "chǎn"; /* ц */
dict[0x20450] = "yáo"; /* ѐ */
dict[0x20451] = "chǎn"; /* ё */
dict[0x20458] = "diān"; /* ј */
dict[0x20459] = "chòng"; /* љ */
dict[0x2045a] = "néi"; /* њ */
dict[0x2045b] = "néi"; /* ћ */
dict[0x2045e] = "zhài"; /* ў */
dict[0x2045f] = "biān,pián"; /* џ */
dict[0x20461] = "chǎn"; /* ѡ */
dict[0x2046a] = "xiāo"; /* Ѫ */
dict[0x2046f] = "cù"; /* ѯ */
dict[0x20470] = "xīn"; /* Ѱ */
dict[0x20471] = "jǐng"; /* ѱ */
dict[0x20472] = "qiān"; /* Ѳ */
dict[0x20474] = "qīng"; /* Ѵ */
dict[0x20476] = "wú"; /* Ѷ */
dict[0x20477] = "cháng,zhǎng"; /* ѷ */
dict[0x20479] = "gǔ"; /* ѹ */
dict[0x2047a] = "tiān"; /* Ѻ */
dict[0x2047b] = "cháng,zhǎng"; /* ѻ */
dict[0x2047d] = "chōng"; /* ѽ */
dict[0x2047e] = "sǐ"; /* Ѿ */
dict[0x20483] = "sì"; /* ҃ */
dict[0x20484] = "wù"; /* ҄ */
dict[0x20485] = "sì"; /* ҅ */
dict[0x20486] = "ér"; /* ҆ */
dict[0x2048c] = "qiāng"; /* Ҍ */
dict[0x2048d] = "yú"; /* ҍ */
dict[0x2049c] = "yuǎn"; /* Ҝ */
dict[0x2049d] = "bǐng"; /* ҝ */
dict[0x204a2] = "wán"; /* Ң */
dict[0x204a7] = "bó"; /* ҧ */
dict[0x204a8] = "liáng,liàng"; /* Ҩ */
dict[0x204b0] = "niǎo,ní"; /* Ұ */
dict[0x204b1] = "pì"; /* ұ */
dict[0x204b5] = "liàn"; /* ҵ */
dict[0x204b8] = "rǎo"; /* Ҹ */
dict[0x204be] = "fàn"; /* Ҿ */
dict[0x204bf] = "dí"; /* ҿ */
dict[0x204c6] = "jīng"; /* ӆ */
dict[0x204ca] = "huī,dān"; /* ӊ */
dict[0x204cb] = "yì"; /* Ӌ */
dict[0x204cc] = "xián"; /* ӌ */
dict[0x204d6] = "lán"; /* Ӗ */
dict[0x204d7] = "fù"; /* ӗ */
dict[0x204d9] = "xiòng"; /* ә */
dict[0x204db] = "jí"; /* ӛ */
dict[0x204dc] = "liǎng"; /* Ӝ */
dict[0x204dd] = "tāo"; /* ӝ */
dict[0x204de] = "jí"; /* Ӟ */
dict[0x204df] = "fá"; /* ӟ */
dict[0x204e1] = "shǐ"; /* ӡ */
dict[0x204e2] = "jiè"; /* Ӣ */
dict[0x204e3] = "zhá"; /* ӣ */
dict[0x204e4] = "shī"; /* Ӥ */
dict[0x204ea] = "qí"; /* Ӫ */
dict[0x204eb] = "biǎn"; /* ӫ */
dict[0x204ed] = "lǎn"; /* ӭ */
dict[0x204ee] = "lǐn"; /* Ӯ */
dict[0x204f1] = "yù"; /* ӱ */
dict[0x204f2] = "chéng"; /* Ӳ */
dict[0x204f4] = "quán"; /* Ӵ */
dict[0x204f5] = "bì"; /* ӵ */
dict[0x204f6] = "zhì"; /* Ӷ */
dict[0x204f7] = "bì,chéng"; /* ӷ */
dict[0x204f8] = "shèng"; /* Ӹ */
dict[0x204fd] = "shèng"; /* ӽ */
dict[0x204ff] = "qín"; /* ӿ */
dict[0x20500] = "bān"; /* Ԁ */
dict[0x20501] = "bié"; /* ԁ */
dict[0x20502] = "biāo"; /* Ԃ */
dict[0x20503] = "xī"; /* ԃ */
dict[0x20508] = "zhōng"; /* Ԉ */
dict[0x20509] = "juàn"; /* ԉ */
dict[0x2050a] = "cháng,zhǎng"; /* Ԋ */
dict[0x2050b] = "jī,xìn"; /* ԋ */
dict[0x2050c] = "jué"; /* Ԍ */
dict[0x2050d] = "xī"; /* ԍ */
dict[0x2050e] = "qǐn"; /* Ԏ */
dict[0x20510] = "jī"; /* Ԑ */
dict[0x20511] = "hài"; /* ԑ */
dict[0x20512] = "chǐ"; /* Ԓ */
dict[0x20513] = "diǎn"; /* ԓ */
dict[0x20514] = "yǔ"; /* Ԕ */
dict[0x20515] = "lún"; /* ԕ */
dict[0x20516] = "jǔ"; /* Ԗ */
dict[0x20519] = "zhōng"; /* ԙ */
dict[0x2051a] = "qì"; /* Ԛ */
dict[0x2051b] = "jī"; /* ԛ */
dict[0x2051f] = "duó"; /* ԟ */
dict[0x20520] = "yuè"; /* Ԡ */
dict[0x20528] = "lián"; /* Ԩ */
dict[0x2052f] = "bān"; /* ԯ */
dict[0x20530] = "diǎn"; /* ԰ */
dict[0x20532] = "héng"; /* Բ */
dict[0x20536] = "qī"; /* Զ */
dict[0x20538] = "jī,qī"; /* Ը */
dict[0x20539] = "chén"; /* Թ */
dict[0x2053a] = "qiān"; /* Ժ */
dict[0x2053b] = "zhèng"; /* Ի */
dict[0x2053c] = "mǎo"; /* Լ */
dict[0x2053d] = "rén"; /* Խ */
dict[0x2053e] = "zhōng"; /* Ծ */
dict[0x20541] = "cóng"; /* Ձ */
dict[0x20542] = "zài"; /* Ղ */
dict[0x20543] = "wǎng"; /* Ճ */
dict[0x20544] = "nà"; /* Մ */
dict[0x20545] = "zài"; /* Յ */
dict[0x20546] = "diàn"; /* Ն */
dict[0x20547] = "diàn"; /* Շ */
dict[0x2054a] = "tǐng"; /* Պ */
dict[0x2054b] = "cè"; /* Ջ */
dict[0x2054c] = "zōng"; /* Ռ */
dict[0x2054d] = "guān"; /* Ս */
dict[0x20550] = "cè"; /* Ր */
dict[0x20551] = "dān"; /* Ց */
dict[0x20552] = "yǔ"; /* Ւ */
dict[0x20555] = "jiōng"; /* Օ */
dict[0x20556] = "zhǎo"; /* Ֆ */
dict[0x20557] = "chuò"; /* ՗ */
dict[0x20558] = "yǔ"; /* ՘ */
dict[0x2055b] = "hé"; /* ՛ */
dict[0x2055d] = "nuó"; /* ՝ */
dict[0x2055e] = "cì"; /* ՞ */
dict[0x2055f] = "niǎn"; /* ՟ */
dict[0x20560] = "chéng"; /* ՠ */
dict[0x20563] = "qià"; /* գ */
dict[0x20564] = "yuān"; /* դ */
dict[0x20565] = "dào"; /* ե */
dict[0x20566] = "yù"; /* զ */
dict[0x20567] = "jiǎo"; /* է */
dict[0x20568] = "jì"; /* ը */
dict[0x20569] = "bēi"; /* թ */
dict[0x2056d] = "zhào"; /* խ */
dict[0x2056e] = "xū"; /* ծ */
dict[0x20570] = "nuó"; /* հ */
dict[0x20572] = "yǔ"; /* ղ */
dict[0x20573] = "dí"; /* ճ */
dict[0x20574] = "jiū"; /* մ */
dict[0x20578] = "suǐ"; /* ո */
dict[0x2057b] = "yāo"; /* ջ */
dict[0x2057f] = "wāng"; /* տ */
dict[0x20582] = "liáo"; /* ւ */
dict[0x20584] = "tóng"; /* ք */
dict[0x20586] = "mèng"; /* ֆ */
dict[0x2058b] = "yǒu"; /* ֋ */
dict[0x20593] = "sī"; /* ֓ */
dict[0x2059b] = "lòu"; /* ֛ */
dict[0x2059f] = "yīn"; /* ֟ */
dict[0x205a5] = "chǒng"; /* ֥ */
dict[0x205ab] = "gǎn"; /* ֫ */
dict[0x205ac] = "jiū"; /* ֬ */
dict[0x205b6] = "qìn"; /* ֶ */
dict[0x205b7] = "jiǒng"; /* ַ */
dict[0x205b9] = "xié,xiá"; /* ֹ */
dict[0x205c2] = "hè"; /* ׂ */
dict[0x205c6] = "tāo"; /* ׆ */
dict[0x205c8] = "qiú"; /* ׈ */
dict[0x205c9] = "xié"; /* ׉ */
dict[0x205ca] = "jìng"; /* ׊ */
dict[0x205cb] = "niǎn"; /* ׋ */
dict[0x205cc] = "jìng"; /* ׌ */
dict[0x205cf] = "jí"; /* ׏ */
dict[0x205d8] = "tiǎn"; /* ט */
dict[0x205d9] = "hán"; /* י */
dict[0x205da] = "cuì"; /* ך */
dict[0x205db] = "dié"; /* כ */
dict[0x205dd] = "qǐng"; /* ם */
dict[0x205e5] = "pìng"; /* ץ */
dict[0x205e6] = "píng"; /* צ */
dict[0x205e8] = "dié"; /* ר */
dict[0x205e9] = "lòu"; /* ש */
dict[0x205f3] = "liǎn"; /* ׳ */
dict[0x205f4] = "hán"; /* ״ */
dict[0x205f5] = "pāng"; /* ׵ */
dict[0x205f6] = "táng"; /* ׶ */
dict[0x205fa] = "yí"; /* ׺ */
dict[0x205fb] = "xuán"; /* ׻ */
dict[0x205fc] = "suò"; /* ׼ */
dict[0x205fd] = "liú"; /* ׽ */
dict[0x205fe] = "shuǎng"; /* ׾ */
dict[0x205ff] = "shèn"; /* ׿ */
dict[0x20601] = "bù"; /* ؁ */
dict[0x20602] = "sōu"; /* ؂ */
dict[0x20605] = "qín"; /* ؅ */
dict[0x20606] = "shěn"; /* ؆ */
dict[0x2060a] = "nòng"; /* ؊ */
dict[0x2060b] = "tǐng"; /* ؋ */
dict[0x2060c] = "jiāng"; /* ، */
dict[0x20615] = "xī"; /* ؕ */
dict[0x20616] = "zhì"; /* ؖ */
dict[0x2061d] = "lài"; /* ؝ */
dict[0x2061e] = "lì"; /* ؞ */
dict[0x2061f] = "lì"; /* ؟ */
dict[0x20622] = "hé"; /* آ */
dict[0x20623] = "jiào"; /* أ */
dict[0x20625] = "yán"; /* إ */
dict[0x20627] = "shū"; /* ا */
dict[0x2062a] = "shǐ"; /* ت */
dict[0x20631] = "zhěn"; /* ر */
dict[0x20633] = "yōu"; /* س */
dict[0x2063a] = "suò"; /* غ */
dict[0x2063b] = "wú"; /* ػ */
dict[0x20641] = "cháng"; /* ف */
dict[0x20642] = "cóng"; /* ق */
dict[0x20646] = "jù"; /* ن */
dict[0x2064e] = "shū"; /* َ */
dict[0x20654] = "jiù"; /* ٔ */
dict[0x20655] = "wéi"; /* ٕ */
dict[0x2065e] = "huò"; /* ٞ */
dict[0x20660] = "shuāng,shuǎng"; /* ٠ */
dict[0x20664] = "jiē"; /* ٤ */
dict[0x2066c] = "zǎo"; /* ٬ */
dict[0x20674] = "qū"; /* ٴ */
dict[0x20676] = "ǒu"; /* ٶ */
dict[0x2067c] = "guǎ"; /* ټ */
dict[0x20683] = "háo"; /* ڃ */
dict[0x20684] = "lǐ"; /* ڄ */
dict[0x20685] = "zhì"; /* څ */
dict[0x20686] = "xiàn"; /* چ */
dict[0x20689] = "bū"; /* ډ */
dict[0x2068a] = "chàng"; /* ڊ */
dict[0x20693] = "yūn"; /* ړ */
dict[0x20694] = "hé"; /* ڔ */
dict[0x2069c] = "tāo"; /* ڜ */
dict[0x206a0] = "biāo"; /* ڠ */
dict[0x206a1] = "tāo"; /* ڡ */
dict[0x206a3] = "dāo"; /* ڣ */
dict[0x206a5] = "diāo"; /* ڥ */
dict[0x206a7] = "èr"; /* ڧ */
dict[0x206a8] = "jiū"; /* ڨ */
dict[0x206ad] = "dì"; /* ڭ */
dict[0x206ae] = "yì"; /* ڮ */
dict[0x206af] = "kūn"; /* گ */
dict[0x206b1] = "zhé"; /* ڱ */
dict[0x206b4] = "zhōu"; /* ڴ */
dict[0x206b5] = "jù"; /* ڵ */
dict[0x206b9] = "shàn"; /* ڹ */
dict[0x206ba] = "shà"; /* ں */
dict[0x206bb] = "diāo"; /* ڻ */
dict[0x206bc] = "bān"; /* ڼ */
dict[0x206bd] = "jī"; /* ڽ */
dict[0x206c0] = "zhōng"; /* ۀ */
dict[0x206c3] = "yí"; /* ۃ */
dict[0x206c5] = "kōu"; /* ۅ */
dict[0x206ca] = "gē"; /* ۊ */
dict[0x206cb] = "bā"; /* ۋ */
dict[0x206ce] = "gōu"; /* ێ */
dict[0x206d1] = "xián"; /* ۑ */
dict[0x206d2] = "guā"; /* ے */
dict[0x206d3] = "liǔ"; /* ۓ */
dict[0x206d4] = "chǐ"; /* ۔ */
dict[0x206d5] = "guāi"; /* ە */
dict[0x206d6] = "chuān"; /* ۖ */
dict[0x206d8] = "lí"; /* ۘ */
dict[0x206d9] = "cù"; /* ۙ */
dict[0x206da] = "shuā"; /* ۚ */
dict[0x206e1] = "bǐ"; /* ۡ */
dict[0x206e2] = "gē"; /* ۢ */
dict[0x206e5] = "bǐng"; /* ۥ */
dict[0x206e6] = "lì"; /* ۦ */
dict[0x206e9] = "jiǔ"; /* ۩ */
dict[0x206ea] = "tiāo,diāo"; /* ۪ */
dict[0x206eb] = "duǒ"; /* ۫ */
dict[0x206ec] = "xíng"; /* ۬ */
dict[0x206ed] = "yān,yuān"; /* ۭ */
dict[0x206ee] = "quān"; /* ۮ */
dict[0x206f0] = "bié"; /* ۰ */
dict[0x206f1] = "liè,zā"; /* ۱ */
dict[0x206f3] = "kè,hé"; /* ۳ */
dict[0x206f5] = "gēn"; /* ۵ */
dict[0x206f6] = "zhēn"; /* ۶ */
dict[0x206f8] = "fén"; /* ۸ */
dict[0x20701] = "yí"; /* ܁ */
dict[0x20703] = "jiù"; /* ܃ */
dict[0x20704] = "xù"; /* ܄ */
dict[0x20705] = "jiǎo"; /* ܅ */
dict[0x20708] = "lǜ"; /* ܈ */
dict[0x20709] = "jiǔ"; /* ܉ */
dict[0x2070b] = "chǒu"; /* ܋ */
dict[0x2070e] = "xiàn"; /* ܎ */
dict[0x20710] = "kuài"; /* ܐ */
dict[0x20711] = "duì"; /* ܑ */
dict[0x20716] = "luō"; /* ܖ */
dict[0x20717] = "xī,xì"; /* ܗ */
dict[0x20718] = "qìn"; /* ܘ */
dict[0x20719] = "bù"; /* ܙ */
dict[0x20724] = "qià"; /* ܤ */
dict[0x20731] = "pī"; /* ܱ */
dict[0x20732] = "yā"; /* ܲ */
dict[0x20733] = "bēng"; /* ܳ */
dict[0x20734] = "guǒ"; /* ܴ */
dict[0x20735] = "guā"; /* ܵ */
dict[0x20736] = "nǎo"; /* ܶ */
dict[0x20739] = "jú"; /* ܹ */
dict[0x2073c] = "qiā"; /* ܼ */
dict[0x2073e] = "jué,guì"; /* ܾ */
dict[0x20744] = "lì"; /* ݄ */
dict[0x20750] = "huā"; /* ݐ */
dict[0x20751] = "jiāo"; /* ݑ */
dict[0x20758] = "qià"; /* ݘ */
dict[0x2075a] = "zhá,zhé"; /* ݚ */
dict[0x2075b] = "qiā"; /* ݛ */
dict[0x2075d] = "zhé,zhá"; /* ݝ */
dict[0x2075e] = "chā"; /* ݞ */
dict[0x2075f] = "yǐng"; /* ݟ */
dict[0x20762] = "yān"; /* ݢ */
dict[0x20764] = "chōng"; /* ݤ */
dict[0x20768] = "chǐ"; /* ݨ */
dict[0x2076a] = "wān"; /* ݪ */
dict[0x2076c] = "sōu"; /* ݬ */
dict[0x20772] = "kǎn"; /* ݲ */
dict[0x20773] = "yuán"; /* ݳ */
dict[0x20779] = "jiè"; /* ݹ */
dict[0x2077d] = "chóu"; /* ݽ */
dict[0x2077f] = "suǒ"; /* ݿ */
dict[0x20780] = "tū"; /* ހ */
dict[0x20783] = "zhé"; /* ރ */
dict[0x20784] = "tī,chǐ"; /* ބ */
dict[0x20786] = "wū"; /* ކ */
dict[0x20788] = "dā"; /* ވ */
dict[0x20789] = "lì"; /* މ */
dict[0x2078a] = "chā,chāi,chá"; /* ފ */
dict[0x20795] = "róng"; /* ޕ */
dict[0x20796] = "gòng"; /* ޖ */
dict[0x20797] = "què"; /* ޗ */
dict[0x20799] = "lí"; /* ޙ */
dict[0x2079e] = "tāo"; /* ޞ */
dict[0x207a4] = "lì"; /* ޤ */
dict[0x207a7] = "mí"; /* ާ */
dict[0x207a9] = "chì,shuài"; /* ީ */
dict[0x207ac] = "gùn"; /* ެ */
dict[0x207ad] = "lóu,lòu"; /* ޭ */
dict[0x207ae] = "chuǎng"; /* ޮ */
dict[0x207af] = "suǒ"; /* ޯ */
dict[0x207b0] = "jiǎo"; /* ް */
dict[0x207b1] = "jìn"; /* ޱ */
dict[0x207b5] = "fá"; /* ޵ */
dict[0x207b6] = "zhāi"; /* ޶ */
dict[0x207be] = "jìn"; /* ޾ */
dict[0x207bf] = "cuì"; /* ޿ */
dict[0x207c2] = "cèng"; /* ߂ */
dict[0x207c3] = "zǔn"; /* ߃ */
dict[0x207c4] = "lì"; /* ߄ */
dict[0x207c5] = "zhào,rì,zhì"; /* ߅ */
dict[0x207c8] = "piē"; /* ߈ */
dict[0x207c9] = "zhǎn,chàn"; /* ߉ */
dict[0x207ca] = "xī"; /* ߊ */
dict[0x207cb] = "yào"; /* ߋ */
dict[0x207cc] = "fǔ,pǒu"; /* ߌ */
dict[0x207cd] = "chōng"; /* ߍ */
dict[0x207d3] = "cuì"; /* ߓ */
dict[0x207d7] = "guā"; /* ߗ */
dict[0x207df] = "fá"; /* ߟ */
dict[0x207e3] = "jī"; /* ߣ */
dict[0x207e6] = "sè"; /* ߦ */
dict[0x207e7] = "zhān"; /* ߧ */
dict[0x207e8] = "lìng,líng"; /* ߨ */
dict[0x207e9] = "sè"; /* ߩ */
dict[0x207ea] = "yè"; /* ߪ */
dict[0x207f0] = "jū"; /* ߰ */
dict[0x207f6] = "tū"; /* ߶ */
dict[0x207fa] = "rú,ruǎn"; /* ߺ */
dict[0x207fb] = "zé,bài"; /* ߻ */
dict[0x207fc] = "huán"; /* ߼ */
dict[0x20801] = "xiǎn"; /* ࠁ */
dict[0x20803] = "qiān"; /* ࠃ */
dict[0x20804] = "zhào"; /* ࠄ */
dict[0x2080b] = "cán"; /* ࠋ */
dict[0x2080d] = "lí"; /* ࠍ */
dict[0x2080e] = "kuò"; /* ࠎ */
dict[0x2080f] = "lì"; /* ࠏ */
dict[0x20810] = "róu"; /* ࠐ */
dict[0x20814] = "dú"; /* ࠔ */
dict[0x20817] = "liè"; /* ࠗ */
dict[0x2081c] = "yīng"; /* ࠜ */
dict[0x2081d] = "lì"; /* ࠝ */
dict[0x20820] = "dú"; /* ࠠ */
dict[0x20822] = "líng"; /* ࠢ */
dict[0x2082a] = "wān"; /* ࠪ */
dict[0x2082f] = "dié"; /* ࠯ */
dict[0x20833] = "jiū"; /* ࠳ */
dict[0x20835] = "lì"; /* ࠵ */
dict[0x20836] = "kū"; /* ࠶ */
dict[0x20837] = "kēng"; /* ࠷ */
dict[0x20839] = "zhěn"; /* ࠹ */
dict[0x20840] = "hè"; /* ࡀ */
dict[0x20842] = "bì,fú"; /* ࡂ */
dict[0x20844] = "pī"; /* ࡄ */
dict[0x2084a] = "hāng"; /* ࡊ */
dict[0x20851] = "zhuó"; /* ࡑ */
dict[0x20852] = "duǐ"; /* ࡒ */
dict[0x20854] = "yì"; /* ࡔ */
dict[0x2085c] = "kè"; /* ࡜ */
dict[0x2085d] = "yì"; /* ࡝ */
dict[0x2085e] = "mò"; /* ࡞ */
dict[0x20860] = "chì"; /* ࡠ */
dict[0x20861] = "cán"; /* ࡡ */
dict[0x20863] = "gěng"; /* ࡣ */
dict[0x20864] = "kè"; /* ࡤ */
dict[0x20865] = "shì"; /* ࡥ */
dict[0x2086d] = "líng,lìng"; /* ࡭ */
dict[0x2086e] = "bēng,kēng"; /* ࡮ */
dict[0x20871] = "duàn"; /* ࡱ */
dict[0x20876] = "juān"; /* ࡶ */
dict[0x20877] = "nǎo"; /* ࡷ */
dict[0x20878] = "zǐ"; /* ࡸ */
dict[0x2087b] = "zòng"; /* ࡻ */
dict[0x20883] = "táng"; /* ࢃ */
dict[0x20886] = "xiá"; /* ࢆ */
dict[0x20887] = "hàn"; /* ࢇ */
dict[0x2088c] = "lüè"; /* ࢌ */
dict[0x2088d] = "qián"; /* ࢍ */
dict[0x20893] = "mò"; /* ࢓ */
dict[0x20894] = "ōu"; /* ࢔ */
dict[0x20895] = "háo"; /* ࢕ */
dict[0x20899] = "zhá"; /* ࢙ */
dict[0x2089a] = "juàn"; /* ࢚ */
dict[0x2089b] = "cóng"; /* ࢛ */
dict[0x208a0] = "lì,jí"; /* ࢠ */
dict[0x208a1] = "zhá"; /* ࢡ */
dict[0x208a2] = "yǒu"; /* ࢢ */
dict[0x208a3] = "diàn"; /* ࢣ */
dict[0x208a4] = "jué"; /* ࢤ */
dict[0x208a5] = "bèi"; /* ࢥ */
dict[0x208a9] = "yǎo"; /* ࢩ */
dict[0x208aa] = "piē"; /* ࢪ */
dict[0x208b1] = "jìn"; /* ࢱ */
dict[0x208b2] = "kǎi,xiè"; /* ࢲ */
dict[0x208b3] = "sè"; /* ࢳ */
dict[0x208b4] = "yǎng"; /* ࢴ */
dict[0x208b5] = "jìn"; /* ࢵ */
dict[0x208b9] = "kè"; /* ࢹ */
dict[0x208c4] = "chān"; /* ࣄ */
dict[0x208c7] = "niǎn"; /* ࣇ */
dict[0x208c9] = "wàn"; /* ࣉ */
dict[0x208ca] = "lǜ"; /* ࣊ */
dict[0x208d0] = "yún"; /* ࣐ */
dict[0x208d1] = "yāo"; /* ࣑ */
dict[0x208d2] = "bāo"; /* ࣒ */
dict[0x208d5] = "jūn"; /* ࣕ */
dict[0x208d6] = "xuán"; /* ࣖ */
dict[0x208d8] = "zhōu"; /* ࣘ */
dict[0x208e0] = "kuì"; /* ࣠ */
dict[0x208e1] = "fèng"; /* ࣡ */
dict[0x208ea] = "qú"; /* ࣪ */
dict[0x208eb] = "shào"; /* ࣫ */
dict[0x208ec] = "sǔn"; /* ࣬ */
dict[0x208f0] = "dū"; /* ࣰ */
dict[0x208f2] = "kuǎi"; /* ࣲ */
dict[0x208f3] = "pào"; /* ࣳ */
dict[0x208fa] = "bào"; /* ࣺ */
dict[0x208fe] = "fù"; /* ࣾ */
dict[0x208ff] = "jiù"; /* ࣿ */
dict[0x20900] = "rán"; /* ऀ */
dict[0x20904] = "jū"; /* ऄ */
dict[0x2090a] = "qióng"; /* ऊ */
dict[0x2090d] = "zhōu"; /* ऍ */
dict[0x2090e] = "huà"; /* ऎ */
dict[0x2090f] = "bǎo"; /* ए */
dict[0x20915] = "yí,xián"; /* क */
dict[0x20917] = "yí"; /* ग */
dict[0x20918] = "yí,yǐ"; /* घ */
dict[0x2091d] = "mào"; /* झ */
dict[0x20926] = "ruǎn,rú"; /* द */
dict[0x2092b] = "cí"; /* फ */
dict[0x2092e] = "hán"; /* म */
dict[0x20930] = "cóng,xuán"; /* र */
dict[0x20934] = "xì"; /* ऴ */
dict[0x20939] = "quán"; /* ह */
dict[0x2093a] = "tiáo"; /* ऺ */
dict[0x2093c] = "diào"; /* ़ */
dict[0x2093e] = "hán"; /* ा */
dict[0x20947] = "yě"; /* े */
dict[0x2094a] = "jī"; /* ॊ */
dict[0x2094d] = "ē"; /* ् */
dict[0x2094e] = "wéi"; /* ॎ */
dict[0x20950] = "cāng"; /* ॐ */
dict[0x20951] = "diào"; /* ॑ */
dict[0x20953] = "fāng"; /* ॓ */
dict[0x20955] = "è"; /* ॕ */
dict[0x20956] = "dì"; /* ॖ */
dict[0x20958] = "suǎn"; /* क़ */
dict[0x20959] = "quán"; /* ख़ */
dict[0x2095c] = "è"; /* ड़ */
dict[0x2095d] = "ōu,ǒu"; /* ढ़ */
dict[0x2095e] = "xuán"; /* फ़ */
dict[0x20962] = "wǔ"; /* ॢ */
dict[0x20966] = "yì"; /* ० */
dict[0x20967] = "bēi"; /* १ */
dict[0x20968] = "móu"; /* २ */
dict[0x20969] = "jī"; /* ३ */
dict[0x2096a] = "tāo"; /* ४ */
dict[0x2096b] = "biān"; /* ५ */
dict[0x2096c] = "jiù"; /* ६ */
dict[0x20970] = "hū"; /* ॰ */
dict[0x20974] = "hán,gān"; /* ॴ */
dict[0x2097f] = "shí"; /* ॿ */
dict[0x20983] = "sà"; /* ঃ */
dict[0x20988] = "bì"; /* ঈ */
dict[0x2098a] = "hán"; /* ঊ */
dict[0x2098b] = "jìng"; /* ঋ */
dict[0x2098e] = "qìn"; /* ঎ */
dict[0x2098f] = "cuó"; /* এ */
dict[0x20990] = "cì"; /* ঐ */
dict[0x20992] = "bān"; /* ঒ */
dict[0x20997] = "duī"; /* গ */
dict[0x2099c] = "xì,shù"; /* জ */
dict[0x209a1] = "xìng"; /* ড */
dict[0x209a7] = "zhī"; /* ধ */
dict[0x209a8] = "luàn"; /* ন */
dict[0x209aa] = "hū"; /* প */
dict[0x209ab] = "jí"; /* ফ */
dict[0x209ac] = "guāi"; /* ব */
dict[0x209b2] = "pāng"; /* ল */
dict[0x209c0] = "zhū"; /* ী */
dict[0x209c5] = "bǐ"; /* ৅ */
dict[0x209c7] = "yú"; /* ে */
dict[0x209d2] = "qǐ"; /* ৒ */
dict[0x209d5] = "hé"; /* ৕ */
dict[0x209d6] = "chǔ"; /* ৖ */
dict[0x209d9] = "shào"; /* ৙ */
dict[0x209da] = "chì"; /* ৚ */
dict[0x209db] = "bó"; /* ৛ */
dict[0x209de] = "zhào"; /* ৞ */
dict[0x209df] = "réng,nǎi"; /* য় */
dict[0x209e0] = "yóu"; /* ৠ */
dict[0x209e4] = "nǎi"; /* ৤ */
dict[0x209e9] = "huǐ,huì"; /* ৩ */
dict[0x209ea] = "tiáo,yǒu"; /* ৪ */
dict[0x209eb] = "bǎn"; /* ৫ */
dict[0x209f0] = "xū"; /* ৰ */
dict[0x209f4] = "yóu,yòu"; /* ৴ */
dict[0x209f5] = "chì"; /* ৵ */
dict[0x209ff] = "héng"; /* ৿ */
dict[0x20a03] = "wài"; /* ਃ */
dict[0x20a06] = "xiè"; /* ਆ */
dict[0x20a0a] = "jué"; /* ਊ */
dict[0x20a0c] = "suī"; /* ਌ */
dict[0x20a0d] = "qīng"; /* ਍ */
dict[0x20a0e] = "zhuàn"; /* ਎ */
dict[0x20a10] = "yǎng"; /* ਐ */
dict[0x20a12] = "bì"; /* ਒ */
dict[0x20a15] = "jì"; /* ਕ */
dict[0x20a18] = "bì"; /* ਘ */
dict[0x20a1a] = "xī"; /* ਚ */
dict[0x20a20] = "jí"; /* ਠ */
dict[0x20a22] = "jùn"; /* ਢ */
dict[0x20a25] = "liáo"; /* ਥ */
dict[0x20a26] = "yōu"; /* ਦ */
dict[0x20a2d] = "jú"; /* ਭ */
dict[0x20a32] = "yuè"; /* ਲ */
dict[0x20a35] = "bàng"; /* ਵ */
dict[0x20a38] = "pí"; /* ਸ */
dict[0x20a3b] = "zè"; /* ਻ */
dict[0x20a3e] = "yì"; /* ਾ */
dict[0x20a3f] = "dǐ"; /* ਿ */
dict[0x20a40] = "jú"; /* ੀ */
dict[0x20a42] = "qiè"; /* ੂ */
dict[0x20a44] = "suǒ"; /* ੄ */
dict[0x20a46] = "cì"; /* ੆ */
dict[0x20a48] = "zhù"; /* ੈ */
dict[0x20a49] = "yuè,jú"; /* ੉ */
dict[0x20a4f] = "jiāo"; /* ੏ */
dict[0x20a54] = "shí"; /* ੔ */
dict[0x20a55] = "sī"; /* ੕ */
dict[0x20a57] = "yí"; /* ੗ */
dict[0x20a58] = "xiá"; /* ੘ */
dict[0x20a60] = "yuán"; /* ੠ */
dict[0x20a65] = "guó"; /* ੥ */
dict[0x20a67] = "kè"; /* ੧ */
dict[0x20a6a] = "cuì"; /* ੪ */
dict[0x20a6b] = "yì"; /* ੫ */
dict[0x20a75] = "lì"; /* ੵ */
dict[0x20a77] = "diǎn"; /* ੷ */
dict[0x20a7a] = "xī,chí"; /* ੺ */
dict[0x20a7f] = "bì"; /* ੿ */
dict[0x20a82] = "biǎn"; /* ં */
dict[0x20a83] = "méi"; /* ઃ */
dict[0x20a84] = "lì"; /* ઄ */
dict[0x20a87] = "sǒu"; /* ઇ */
dict[0x20a90] = "liú"; /* ઐ */
dict[0x20a91] = "guì"; /* ઑ */
dict[0x20a92] = "kè"; /* ઒ */
dict[0x20a97] = "yí"; /* ગ */
dict[0x20a98] = "yín,ǎn,kǎn"; /* ઘ */
dict[0x20a99] = "xǐ"; /* ઙ */
dict[0x20a9a] = "yín,ǎn,kǎn"; /* ચ */
dict[0x20a9f] = "kè"; /* ટ */
dict[0x20aa2] = "qīn"; /* ઢ */
dict[0x20aa3] = "shè"; /* ણ */
dict[0x20aa7] = "wǒ"; /* ધ */
dict[0x20aae] = "pì"; /* મ */
dict[0x20ab1] = "lì"; /* ઱ */
dict[0x20ab2] = "jǐn"; /* લ */
dict[0x20ab3] = "hǔ"; /* ળ */
dict[0x20ab6] = "yuè"; /* શ */
dict[0x20ab7] = "hóng"; /* ષ */
dict[0x20aba] = "lì"; /* ઺ */
dict[0x20abb] = "fù"; /* ઻ */
dict[0x20ac3] = "jué"; /* ૃ */
dict[0x20ac4] = "xiān"; /* ૄ */
dict[0x20ac9] = "diān"; /* ૉ */
dict[0x20acc] = "lì"; /* ૌ */
dict[0x20ace] = "chū"; /* ૎ */
dict[0x20ad0] = "yuán"; /* ૐ */
dict[0x20ad2] = "yuán"; /* ૒ */
dict[0x20ad3] = "tū"; /* ૓ */
dict[0x20ad8] = "jiān"; /* ૘ */
dict[0x20adb] = "bǎi"; /* ૛ */
dict[0x20adc] = "dì"; /* ૜ */
dict[0x20add] = "zhǎng"; /* ૝ */
dict[0x20ae3] = "yù"; /* ૣ */
dict[0x20ae4] = "lìn"; /* ૤ */
dict[0x20ae8] = "duì"; /* ૨ */
dict[0x20aed] = "cān"; /* ૭ */
dict[0x20aee] = "tú"; /* ૮ */
dict[0x20af5] = "cān"; /* ૵ */
dict[0x20af6] = "tān"; /* ૶ */
dict[0x20af7] = "jí"; /* ૷ */
dict[0x20af8] = "qí,zhāi"; /* ૸ */
dict[0x20af9] = "shàn"; /* ૹ */
dict[0x20afa] = "nián,shì"; /* ૺ */
dict[0x20b06] = "guàn"; /* ଆ */
dict[0x20b08] = "bǐ"; /* ଈ */
dict[0x20b0b] = "xīng,nián"; /* ଋ */
dict[0x20b13] = "zhěn"; /* ଓ */
dict[0x20b19] = "sā"; /* ଙ */
dict[0x20b1b] = "mò"; /* ଛ */
dict[0x20b1c] = "pān"; /* ଜ */
dict[0x20b1d] = "fú"; /* ଝ */
dict[0x20b1e] = "gǒng"; /* ଞ */
dict[0x20b22] = "tāo"; /* ଢ */
dict[0x20b23] = "bàng"; /* ଣ */
dict[0x20b2a] = "biào"; /* ପ */
dict[0x20b2c] = "xī"; /* ବ */
dict[0x20b2e] = "jié"; /* ମ */
dict[0x20b36] = "jìn"; /* ଶ */
dict[0x20b38] = "mò"; /* ସ */
dict[0x20b3e] = "qiān"; /* ା */
dict[0x20b48] = "sì"; /* ୈ */
dict[0x20b49] = "jǐng"; /* ୉ */
dict[0x20b4b] = "chǐ"; /* ୋ */
dict[0x20b56] = "gǎn"; /* ୖ */
dict[0x20b57] = "jǐng"; /* ୗ */
dict[0x20b58] = "jǐng"; /* ୘ */
dict[0x20b59] = "shēn"; /* ୙ */
dict[0x20b65] = "suì"; /* ୥ */
dict[0x20b6f] = "zhā"; /* ୯ */
dict[0x20b70] = "lí"; /* ୰ */
dict[0x20b74] = "zhuō"; /* ୴ */
dict[0x20b79] = "biàn"; /* ୹ */
dict[0x20b7f] = "tún"; /* ୿ */
dict[0x20b83] = "bì"; /* ஃ */
dict[0x20b86] = "fèi"; /* ஆ */
dict[0x20b8a] = "dé"; /* ஊ */
dict[0x20b8c] = "zhú"; /* ஌ */
dict[0x20b91] = "jū"; /* ஑ */
dict[0x20b99] = "yǐ"; /* ங */
dict[0x20b9c] = "yà,yīn"; /* ஜ */
dict[0x20b9f] = "chì"; /* ட */
dict[0x20ba0] = "guǎ,bǎi"; /* ஠ */
dict[0x20ba1] = "zhǐ"; /* ஡ */
dict[0x20ba6] = "zhào"; /* ஦ */
dict[0x20ba8] = "réng"; /* ந */
dict[0x20bab] = "yōu"; /* ஫ */
dict[0x20bad] = "bó"; /* ஭ */
dict[0x20baf] = "jǐ"; /* ய */
dict[0x20bb0] = "pǐn"; /* ர */
dict[0x20bb1] = "xū"; /* ற */
dict[0x20bb3] = "yīng"; /* ள */
dict[0x20bb4] = "yāng"; /* ழ */
dict[0x20bb5] = "màng"; /* வ */
dict[0x20bb6] = "gǎ,gě"; /* ஶ */
dict[0x20bb7] = "jí"; /* ஷ */
dict[0x20bb9] = "cái"; /* ஹ */
dict[0x20bbd] = "lòng"; /* ஽ */
dict[0x20bbf] = "sa,san"; /* ி */
dict[0x20bc0] = "chuān"; /* ீ */
dict[0x20bc1] = "zú"; /* ு */
dict[0x20bc2] = "cí"; /* ூ */
dict[0x20bc3] = "wǔ"; /* ௃ */
dict[0x20bc4] = "rèn"; /* ௄ */
dict[0x20bc8] = "dài"; /* ை */
dict[0x20bc9] = "jí"; /* ௉ */
dict[0x20bcb] = "yǐ"; /* ோ */
dict[0x20bcd] = "rán"; /* ் */
dict[0x20bd0] = "huò"; /* ௐ */
dict[0x20bd1] = "guā"; /* ௑ */
dict[0x20bd3] = "zhé"; /* ௓ */
dict[0x20bd4] = "pì"; /* ௔ */
dict[0x20bd7] = "zā"; /* ௗ */
dict[0x20bd8] = "bàn"; /* ௘ */
dict[0x20bd9] = "jié"; /* ௙ */
dict[0x20bdc] = "hōu,xǔ"; /* ௜ */
dict[0x20bdf] = "xiàn"; /* ௟ */
dict[0x20be0] = "huī"; /* ௠ */
dict[0x20be3] = "zú"; /* ௣ */
dict[0x20be9] = "zhā"; /* ௩ */
dict[0x20bea] = "dāi,dǎi,è"; /* ௪ */
dict[0x20beb] = "gē"; /* ௫ */
dict[0x20bed] = "pì"; /* ௭ */
dict[0x20bef] = "piàn"; /* ௯ */
dict[0x20bf0] = "shí"; /* ௰ */
dict[0x20bf1] = "liǎng"; /* ௱ */
dict[0x20bf2] = "yuè"; /* ௲ */
dict[0x20bf3] = "hù,wěn"; /* ௳ */
dict[0x20bf4] = "biàn"; /* ௴ */
dict[0x20bf7] = "réng"; /* ௷ */
dict[0x20bf8] = "tīng"; /* ௸ */
dict[0x20bf9] = "réng"; /* ௹ */
dict[0x20bff] = "lù,liū"; /* ௿ */
dict[0x20c04] = "yī"; /* ఄ */
dict[0x20c05] = "zhī"; /* అ */
dict[0x20c07] = "jīn"; /* ఇ */
dict[0x20c08] = "wēng"; /* ఈ */
dict[0x20c09] = "chāo"; /* ఉ */
dict[0x20c0b] = "qiū"; /* ఋ */
dict[0x20c0d] = "zhǔ,zhù"; /* ఍ */
dict[0x20c0f] = "zhá"; /* ఏ */
dict[0x20c10] = "pǒ"; /* ఐ */
dict[0x20c11] = "àn"; /* ఑ */
dict[0x20c13] = "hé"; /* ఓ */
dict[0x20c15] = "chū"; /* క */
dict[0x20c16] = "yán"; /* ఖ */
dict[0x20c1a] = "shì"; /* చ */
dict[0x20c1b] = "hù,gào"; /* ఛ */
dict[0x20c1c] = "è"; /* జ */
dict[0x20c22] = "bā"; /* ఢ */
dict[0x20c33] = "bǐng"; /* ళ */
dict[0x20c34] = "shí"; /* ఴ */
dict[0x20c39] = "tuō"; /* హ */
dict[0x20c3a] = "dài"; /* ఺ */
dict[0x20c3b] = "wài,wai"; /* ఻ */
dict[0x20c3c] = "pō"; /* ఼ */
dict[0x20c3d] = "rǒng"; /* ఽ */
dict[0x20c3e] = "jū"; /* ా */
dict[0x20c40] = "bō"; /* ీ */
dict[0x20c43] = "āo"; /* ృ */
dict[0x20c50] = "yǔ"; /* ౐ */
dict[0x20c51] = "dōu"; /* ౑ */
dict[0x20c53] = "guǐ"; /* ౓ */
dict[0x20c54] = "shòu"; /* ౔ */
dict[0x20c57] = "suō"; /* ౗ */
dict[0x20c58] = "nì"; /* ౘ */
dict[0x20c59] = "zhōu,yù,jì,cù"; /* ౙ */
dict[0x20c5a] = "lòng"; /* ౚ */
dict[0x20c5b] = "bǐng"; /* ౛ */
dict[0x20c5c] = "zùn"; /* ౜ */
dict[0x20c5d] = "yè"; /* ౝ */
dict[0x20c5e] = "rǎn"; /* ౞ */
dict[0x20c60] = "líng"; /* ౠ */
dict[0x20c61] = "sà,shài"; /* ౡ */
dict[0x20c64] = "lěi"; /* ౤ */
dict[0x20c65] = "è,huì,zá"; /* ౥ */
dict[0x20c67] = "zhòng"; /* ౧ */
dict[0x20c68] = "jǐ"; /* ౨ */
dict[0x20c6b] = "è"; /* ౫ */
dict[0x20c6f] = "zuò"; /* ౯ */
dict[0x20c72] = "nà"; /* ౲ */
dict[0x20c73] = "yǔn"; /* ౳ */
dict[0x20c8a] = "xiè"; /* ಊ */
dict[0x20c8b] = "zuǐ"; /* ಋ */
dict[0x20c8c] = "shù"; /* ಌ */
dict[0x20c8d] = "diū"; /* ಍ */
dict[0x20c8e] = "fèi,fá,wa"; /* ಎ */
dict[0x20c8f] = "rěn"; /* ಏ */
dict[0x20c91] = "bāng"; /* ಑ */
dict[0x20c92] = "hán"; /* ಒ */
dict[0x20c93] = "hóng"; /* ಓ */
dict[0x20c94] = "yī"; /* ಔ */
dict[0x20c96] = "yī"; /* ಖ */
dict[0x20c99] = "kē"; /* ಙ */
dict[0x20c9a] = "yì"; /* ಚ */
dict[0x20c9b] = "huí"; /* ಛ */
dict[0x20c9c] = "zhēng"; /* ಜ */
dict[0x20ca5] = "lǐ"; /* ಥ */
dict[0x20cae] = "jìng"; /* ಮ */
dict[0x20cb1] = "gé"; /* ಱ */
dict[0x20cb4] = "nóu"; /* ಴ */
dict[0x20cb5] = "qiè,jié"; /* ವ */
dict[0x20cb7] = "dié"; /* ಷ */
dict[0x20cb9] = "jì"; /* ಹ */
dict[0x20cba] = "yì"; /* ಺ */
dict[0x20cbb] = "yí"; /* ಻ */
dict[0x20cbd] = "fú"; /* ಽ */
dict[0x20cbe] = "shuò"; /* ಾ */
dict[0x20cbf] = "shuò"; /* ಿ */
dict[0x20cc0] = "yǒng"; /* ೀ */
dict[0x20cc1] = "kěn"; /* ು */
dict[0x20cc2] = "huá"; /* ೂ */
dict[0x20cc3] = "hòng"; /* ೃ */
dict[0x20cc6] = "zāi"; /* ೆ */
dict[0x20cc7] = "hé"; /* ೇ */
dict[0x20cca] = "hē"; /* ೊ */
dict[0x20ccb] = "qiǎn"; /* ೋ */
dict[0x20ccc] = "qià"; /* ೌ */
dict[0x20cce] = "sì"; /* ೎ */
dict[0x20cd0] = "bāng"; /* ೐ */
dict[0x20cec] = "jīng"; /* ೬ */
dict[0x20ced] = "kè"; /* ೭ */
dict[0x20cf3] = "āi"; /* ೳ */
dict[0x20cf4] = "lóu"; /* ೴ */
dict[0x20cf6] = "tū"; /* ೶ */
dict[0x20cf9] = "chuáng"; /* ೹ */
dict[0x20cfc] = "sòng"; /* ೼ */
dict[0x20cfd] = "chéng"; /* ೽ */
dict[0x20cfe] = "hǎn"; /* ೾ */
dict[0x20cff] = "wēi"; /* ೿ */
dict[0x20d02] = "nǔ"; /* ം */
dict[0x20d04] = "jiǔ"; /* ഄ */
dict[0x20d07] = "bīn"; /* ഇ */
dict[0x20d21] = "xiào"; /* ഡ */
dict[0x20d22] = "shēng"; /* ഢ */
dict[0x20d23] = "hǒu"; /* ണ */
dict[0x20d26] = "zhù"; /* ദ */
dict[0x20d28] = "guān"; /* ന */
dict[0x20d29] = "jī,qǐ"; /* ഩ */
dict[0x20d2b] = "jì,cù,yù,zhù"; /* ഫ */
dict[0x20d2d] = "xī"; /* ഭ */
dict[0x20d2f] = "shè"; /* യ */
dict[0x20d30] = "ǒu"; /* ര */
dict[0x20d31] = "hú"; /* റ */
dict[0x20d32] = "tà"; /* ല */
dict[0x20d33] = "xiáo"; /* ള */
dict[0x20d35] = "zào"; /* വ */
dict[0x20d38] = "bò"; /* സ */
dict[0x20d39] = "qì"; /* ഹ */
dict[0x20d3a] = "wā"; /* ഺ */
dict[0x20d3b] = "tuō"; /* ഻ */
dict[0x20d3c] = "dào"; /* ഼ */
dict[0x20d3e] = "nà"; /* ാ */
dict[0x20d53] = "xuán"; /* ൓ */
dict[0x20d58] = "mèn"; /* ൘ */
dict[0x20d60] = "zhāi"; /* ൠ */
dict[0x20d63] = "yà"; /* ൣ */
dict[0x20d66] = "wǔ"; /* ൦ */
dict[0x20d67] = "zhén,chún"; /* ൧ */
dict[0x20d68] = "de"; /* ൨ */
dict[0x20d69] = "hē"; /* ൩ */
dict[0x20d6b] = "āng"; /* ൫ */
dict[0x20d6c] = "pí"; /* ൬ */
dict[0x20d6d] = "sè"; /* ൭ */
dict[0x20d6e] = "fěn"; /* ൮ */
dict[0x20d6f] = "guā"; /* ൯ */
dict[0x20d73] = "pǒ"; /* ൳ */
dict[0x20d77] = "xuàn"; /* ൷ */
dict[0x20d78] = "hān,mí"; /* ൸ */
dict[0x20d79] = "gāng"; /* ൹ */
dict[0x20d7a] = "bā"; /* ൺ */
dict[0x20d7b] = "zōng"; /* ൻ */
dict[0x20d7c] = "mèng"; /* ർ */
dict[0x20d9c] = "zhì"; /* ග */
dict[0x20da7] = "diān"; /* ට */
dict[0x20da8] = "xī"; /* ඨ */
dict[0x20dab] = "dà"; /* ණ */
dict[0x20dac] = "nàng"; /* ඬ */
dict[0x20db0] = "diāo"; /* ධ */
dict[0x20db1] = "luò"; /* න */
dict[0x20db2] = "kè"; /* ඲ */
dict[0x20db7] = "yì"; /* භ */
dict[0x20db8] = "jué"; /* ම */
dict[0x20db9] = "hé"; /* ඹ */
dict[0x20dbb] = "jí"; /* ර */
dict[0x20dbe] = "hè"; /* ඾ */
dict[0x20dbf] = "niè,zá"; /* ඿ */
dict[0x20dc0] = "rǔn"; /* ව */
dict[0x20dc1] = "qián,jiān"; /* ශ */
dict[0x20dc2] = "dài"; /* ෂ */
dict[0x20dc3] = "shāo,sù,shòu"; /* ස */
dict[0x20dc4] = "kè"; /* හ */
dict[0x20dc5] = "zhú"; /* ළ */
dict[0x20dc7] = "shī"; /* ෇ */
dict[0x20dc8] = "lǜ,liè"; /* ෈ */
dict[0x20dc9] = "jiā"; /* ෉ */
dict[0x20dca] = "pián"; /* ් */
dict[0x20dcb] = "hòu"; /* ෋ */
dict[0x20dcc] = "jī,zé"; /* ෌ */
dict[0x20dcd] = "tà"; /* ෍ */
dict[0x20dce] = "chóu,shòu"; /* ෎ */
dict[0x20dcf] = "wō"; /* ා */
dict[0x20dd0] = "jìng,jiàng"; /* ැ */
dict[0x20dd1] = "pō"; /* ෑ */
dict[0x20dd2] = "zhāi"; /* ි */
dict[0x20dd3] = "xīn"; /* ී */
dict[0x20dd6] = "biàn"; /* ූ */
dict[0x20dd9] = "xù"; /* ෙ */
dict[0x20dde] = "gū"; /* ෞ */
dict[0x20ddf] = "jiè"; /* ෟ */
dict[0x20de0] = "qǐ"; /* ෠ */
dict[0x20de2] = "xián"; /* ෢ */
dict[0x20de8] = "biǎn"; /* ෨ */
dict[0x20df8] = "é,yóng"; /* ෸ */
dict[0x20dfa] = "bó"; /* ෺ */
dict[0x20dfb] = "piāo"; /* ෻ */
dict[0x20dff] = "zǎ"; /* ෿ */
dict[0x20e01] = "pài"; /* ก */
dict[0x20e02] = "tū"; /* ข */
dict[0x20e04] = "yīng"; /* ค */
dict[0x20e0d] = "xiào"; /* ญ */
dict[0x20e2e] = "xiǎng"; /* ฮ */
dict[0x20e31] = "nuò"; /* ั */
dict[0x20e32] = "gē"; /* า */
dict[0x20e33] = "bó"; /* ำ */
dict[0x20e34] = "xiè"; /* ิ */
dict[0x20e38] = "zhēn,chún"; /* ุ */
dict[0x20e39] = "yú"; /* ู */
dict[0x20e3a] = "nì"; /* ฺ */
dict[0x20e40] = "xùn"; /* เ */
dict[0x20e41] = "wà"; /* แ */
dict[0x20e43] = "àng"; /* ใ */
dict[0x20e44] = "hàn"; /* ไ */
dict[0x20e45] = "hōng"; /* ๅ */
dict[0x20e46] = "dān"; /* ๆ */
dict[0x20e48] = "nuó"; /* ่ */
dict[0x20e4a] = "cǎo"; /* ๊ */
dict[0x20e4b] = "jí"; /* ๋ */
dict[0x20e4c] = "něng"; /* ์ */
dict[0x20e4d] = "yǒng,róng"; /* ํ */
dict[0x20e4e] = "xiāo"; /* ๎ */
dict[0x20e50] = "chuǎ"; /* ๐ */
dict[0x20e51] = "yào"; /* ๑ */
dict[0x20e53] = "gé"; /* ๓ */
dict[0x20e54] = "táng"; /* ๔ */
dict[0x20e55] = "bào"; /* ๕ */
dict[0x20e56] = "chǎn"; /* ๖ */
dict[0x20e58] = "xù"; /* ๘ */
dict[0x20e5b] = "hái"; /* ๛ */
dict[0x20e5d] = "chóu"; /* ๝ */
dict[0x20e5f] = "jiǎn"; /* ๟ */
dict[0x20e60] = "zuō"; /* ๠ */
dict[0x20e64] = "wèi"; /* ๤ */
dict[0x20e65] = "dā"; /* ๥ */
dict[0x20e66] = "pī"; /* ๦ */
dict[0x20e6d] = "gē"; /* ๭ */
dict[0x20e73] = "jié"; /* ๳ */
dict[0x20e90] = "huàn"; /* ຐ */
dict[0x20e92] = "xī"; /* ຒ */
dict[0x20e94] = "pèn"; /* ດ */
dict[0x20e95] = "liū,liáo"; /* ຕ */
dict[0x20e96] = "mǔ"; /* ຖ */
dict[0x20e97] = "miē"; /* ທ */
dict[0x20e98] = "làng"; /* ຘ */
dict[0x20e99] = "tuì"; /* ນ */
dict[0x20e9a] = "bān"; /* ບ */
dict[0x20e9d] = "gē"; /* ຝ */
dict[0x20e9f] = "kù"; /* ຟ */
dict[0x20ea2] = "jiā"; /* ຢ */
dict[0x20ea3] = "bō"; /* ຣ */
dict[0x20ecd] = "huàn"; /* ໍ */
dict[0x20ecf] = "zú"; /* ໏ */
dict[0x20ed0] = "luò"; /* ໐ */
dict[0x20ed7] = "lí"; /* ໗ */
dict[0x20ed9] = "hé"; /* ໙ */
dict[0x20eda] = "mó"; /* ໚ */
dict[0x20edc] = "shuì,lǜ,sū"; /* ໜ */
dict[0x20edd] = "shēn"; /* ໝ */
dict[0x20ede] = "kǎng"; /* ໞ */
dict[0x20edf] = "chì"; /* ໟ */
dict[0x20ee0] = "líng"; /* ໠ */
dict[0x20ee1] = "luǒ"; /* ໡ */
dict[0x20ee4] = "yǎn"; /* ໤ */
dict[0x20ee5] = "zhào"; /* ໥ */
dict[0x20ee6] = "chuǎ"; /* ໦ */
dict[0x20ee7] = "gǔ"; /* ໧ */
dict[0x20ee8] = "qǐn"; /* ໨ */
dict[0x20eea] = "tán"; /* ໪ */
dict[0x20eeb] = "fèn"; /* ໫ */
dict[0x20eec] = "tú"; /* ໬ */
dict[0x20ef1] = "líng"; /* ໱ */
dict[0x20ef3] = "zuò"; /* ໳ */
dict[0x20ef4] = "lǎng"; /* ໴ */
dict[0x20f16] = "lán"; /* ༖ */
dict[0x20f17] = "zàn"; /* ༗ */
dict[0x20f18] = "wù"; /* ༘ */
dict[0x20f1d] = "lí"; /* ༝ */
dict[0x20f1e] = "ā"; /* ༞ */
dict[0x20f1f] = "lüè"; /* ༟ */
dict[0x20f20] = "zhǐ"; /* ༠ */
dict[0x20f21] = "chóu"; /* ༡ */
dict[0x20f22] = "jiàng,qiàng"; /* ༢ */
dict[0x20f24] = "jiān"; /* ༤ */
dict[0x20f29] = "lún"; /* ༩ */
dict[0x20f2a] = "yí"; /* ༪ */
dict[0x20f2c] = "shāng"; /* ༬ */
dict[0x20f2e] = "ǎi"; /* ༮ */
dict[0x20f3b] = "jī"; /* ༻ */
dict[0x20f5c] = "yì"; /* ཛྷ */
dict[0x20f5d] = "nín"; /* ཝ */
dict[0x20f61] = "huì"; /* ཡ */
dict[0x20f63] = "zhā"; /* ལ */
dict[0x20f66] = "hǎn"; /* ས */
dict[0x20f68] = "yǐn"; /* ཨ */
dict[0x20f69] = "bì"; /* ཀྵ */
dict[0x20f6a] = "ān"; /* ཪ */
dict[0x20f6b] = "xiā,xiǎ"; /* ཫ */
dict[0x20f6c] = "ní"; /* ཬ */
dict[0x20f70] = "dī"; /* ཰ */
dict[0x20f71] = "jiǎn"; /* ཱ */
dict[0x20f72] = "pán"; /* ི */
dict[0x20f75] = "yù"; /* ཱུ */
dict[0x20f76] = "chuài,cuì,chuò"; /* ྲྀ */
dict[0x20f77] = "zā"; /* ཷ */
dict[0x20f79] = "chá"; /* ཹ */
dict[0x20f7b] = "zhé"; /* ཻ */
dict[0x20f7c] = "sè"; /* ོ */
dict[0x20f7e] = "pēn,pǔ"; /* ཾ */
dict[0x20f7f] = "gū"; /* ཿ */
dict[0x20f80] = "zhé"; /* ྀ */
dict[0x20f86] = "lí"; /* ྆ */
dict[0x20f87] = "dōu"; /* ྇ */
dict[0x20f89] = "chóu"; /* ྉ */
dict[0x20f8b] = "zuǐ"; /* ྋ */
dict[0x20f8c] = "pò"; /* ྌ */
dict[0x20f8f] = "shē"; /* ྏ */
dict[0x20f90] = "lóng"; /* ྐ */
dict[0x20fa2] = "shù"; /* ྡྷ */
dict[0x20fa4] = "jìn"; /* ྤ */
dict[0x20fa5] = "líng"; /* ྥ */
dict[0x20fa8] = "kāng"; /* ྨ */
dict[0x20fa9] = "là"; /* ྩ */
dict[0x20fab] = "xū"; /* ྫ */
dict[0x20fac] = "jìn"; /* ྫྷ */
dict[0x20fae] = "chuān"; /* ྮ */
dict[0x20fb2] = "yuè"; /* ྲ */
dict[0x20fc6] = "mǎi"; /* ࿆ */
dict[0x20fc7] = "xiè"; /* ࿇ */
dict[0x20fc8] = "jiū"; /* ࿈ */
dict[0x20fc9] = "jì"; /* ࿉ */
dict[0x20fcb] = "yuè"; /* ࿋ */
dict[0x20fcf] = "jiān"; /* ࿏ */
dict[0x20fd1] = "hán,gǎn,ǎn,hǎn"; /* ࿑ */
dict[0x20fd3] = "sà"; /* ࿓ */
dict[0x20fd4] = "huì"; /* ࿔ */
dict[0x20fd5] = "qiào"; /* ࿕ */
dict[0x20fd7] = "sè"; /* ࿗ */
dict[0x20fd8] = "zuǐ"; /* ࿘ */
dict[0x20fdb] = "lǔ"; /* ࿛ */
dict[0x20fdc] = "huà"; /* ࿜ */
dict[0x20fdd] = "chū"; /* ࿝ */
dict[0x20fde] = "shǎn"; /* ࿞ */
dict[0x20fdf] = "wò"; /* ࿟ */
dict[0x20fe0] = "jí"; /* ࿠ */
dict[0x20fe1] = "zhuó"; /* ࿡ */
dict[0x20fe2] = "xián,xiàn"; /* ࿢ */
dict[0x20fe3] = "yī"; /* ࿣ */
dict[0x20fe4] = "guó"; /* ࿤ */
dict[0x20fe5] = "kuì,guì"; /* ࿥ */
dict[0x21007] = "dǒng"; /* ဇ */
dict[0x21011] = "zhōu"; /* ထ */
dict[0x21014] = "lù,lou"; /* န */
dict[0x21016] = "bō"; /* ဖ */
dict[0x21017] = "shí"; /* ဗ */
dict[0x21018] = "yìng"; /* ဘ */
dict[0x21019] = "kū"; /* မ */
dict[0x21039] = "zhì"; /* ္ */
dict[0x2103a] = "xié"; /* ် */
dict[0x2103d] = "yè,hè"; /* ွ */
dict[0x2103e] = "è"; /* ှ */
dict[0x2103f] = "lǜ"; /* ဿ */
dict[0x21040] = "hàn"; /* ၀ */
dict[0x21041] = "yè,kài"; /* ၁ */
dict[0x21046] = "luò"; /* ၆ */
dict[0x21047] = "chuò"; /* ၇ */
dict[0x21048] = "fàn"; /* ၈ */
dict[0x21049] = "zhí"; /* ၉ */
dict[0x2104a] = "yìng"; /* ၊ */
dict[0x2104b] = "wěn"; /* ။ */
dict[0x2104c] = "wā"; /* ၌ */
dict[0x2104d] = "ài"; /* ၍ */
dict[0x2104e] = "yú"; /* ၎ */
dict[0x2104f] = "méng"; /* ၏ */
dict[0x21051] = "huā"; /* ၑ */
dict[0x21053] = "liè"; /* ၓ */
dict[0x21054] = "jīng"; /* ၔ */
dict[0x21055] = "zá"; /* ၕ */
dict[0x21067] = "zāng"; /* ၧ */
dict[0x21068] = "duì"; /* ၨ */
dict[0x2106a] = "jì"; /* ၪ */
dict[0x2106e] = "wō"; /* ၮ */
dict[0x21070] = "jí"; /* ၰ */
dict[0x21071] = "xī"; /* ၱ */
dict[0x21073] = "zhàn"; /* ၳ */
dict[0x21074] = "tuán"; /* ၴ */
dict[0x21076] = "jiē"; /* ၶ */
dict[0x2108a] = "yú"; /* ႊ */
dict[0x2108f] = "liè"; /* ႏ */
dict[0x21092] = "zhì"; /* ႒ */
dict[0x21093] = "shī"; /* ႓ */
dict[0x21095] = "lǎo"; /* ႕ */
dict[0x21096] = "lài,tà"; /* ႖ */
dict[0x21097] = "wěi"; /* ႗ */
dict[0x21098] = "páo"; /* ႘ */
dict[0x21099] = "chí"; /* ႙ */
dict[0x2109a] = "yǐng"; /* ႚ */
dict[0x2109b] = "dòu"; /* ႛ */
dict[0x2109d] = "dòu"; /* ႝ */
dict[0x2109f] = "bào"; /* ႟ */
dict[0x210a0] = "qiè"; /* Ⴀ */
dict[0x210a1] = "shù"; /* Ⴁ */
dict[0x210a2] = "jiāo"; /* Ⴂ */
dict[0x210a3] = "zhí"; /* Ⴃ */
dict[0x210a9] = "liè"; /* Ⴉ */
dict[0x210ab] = "péng"; /* Ⴋ */
dict[0x210ad] = "zhē"; /* Ⴍ */
dict[0x210bf] = "ōu,ou"; /* Ⴟ */
dict[0x210c2] = "xiè"; /* Ⴢ */
dict[0x210c3] = "jí"; /* Ⴣ */
dict[0x210c4] = "lài"; /* Ⴤ */
dict[0x210c5] = "yíng"; /* Ⴥ */
dict[0x210c6] = "cēng"; /* ჆ */
dict[0x210c7] = "bì"; /* Ⴧ */
dict[0x210c8] = "kè"; /* ჈ */
dict[0x210d3] = "bō"; /* დ */
dict[0x210d6] = "lē"; /* ზ */
dict[0x210dd] = "lùn"; /* ო */
dict[0x210e1] = "lóng"; /* ს */
dict[0x210e2] = "xì"; /* ტ */
dict[0x210e4] = "lài"; /* ფ */
dict[0x210e6] = "lìn"; /* ღ */
dict[0x210e9] = "guī"; /* ჩ */
dict[0x210f3] = "xīng"; /* ჳ */
dict[0x210f4] = "chú"; /* ჴ */
dict[0x210f5] = "yōng"; /* ჵ */
dict[0x210f7] = "lí"; /* ჷ */
dict[0x210f8] = "cī"; /* ჸ */
dict[0x21107] = "qǐng"; /* ᄇ */
dict[0x21111] = "jiān"; /* ᄑ */
dict[0x21112] = "dào"; /* ᄒ */
dict[0x21113] = "jiǎn"; /* ᄓ */
dict[0x21114] = "qìng"; /* ᄔ */
dict[0x21115] = "xiè"; /* ᄕ */
dict[0x21116] = "yìng"; /* ᄖ */
dict[0x2111f] = "há"; /* ᄟ */
dict[0x21121] = "zhe"; /* ᄡ */
dict[0x21122] = "shē"; /* ᄢ */
dict[0x21123] = "mí"; /* ᄣ */
dict[0x21124] = "huán"; /* ᄤ */
dict[0x21131] = "cù"; /* ᄱ */
dict[0x21132] = "rú"; /* ᄲ */
dict[0x21133] = "sǎ"; /* ᄳ */
dict[0x21134] = "huò"; /* ᄴ */
dict[0x21135] = "yī"; /* ᄵ */
dict[0x21137] = "dī"; /* ᄷ */
dict[0x21139] = "luàn"; /* ᄹ */
dict[0x2113b] = "yì"; /* ᄻ */
dict[0x21142] = "bò"; /* ᅂ */
dict[0x21143] = "páng"; /* ᅃ */
dict[0x21144] = "tán"; /* ᅄ */
dict[0x21145] = "é,éi"; /* ᅅ */
dict[0x21146] = "zāng"; /* ᅆ */
dict[0x21147] = "cóng"; /* ᅇ */
dict[0x21153] = "zhāi"; /* ᅓ */
dict[0x21155] = "xǐ"; /* ᅕ */
dict[0x21156] = "mǎng"; /* ᅖ */
dict[0x21158] = "là"; /* ᅘ */
dict[0x21159] = "yùn"; /* ᅙ */
dict[0x21161] = "è"; /* ᅡ */
dict[0x21165] = "dié"; /* ᅥ */
dict[0x2116d] = "guān"; /* ᅭ */
dict[0x21171] = "huàn"; /* ᅱ */
dict[0x21175] = "shì"; /* ᅵ */
dict[0x21176] = "jiǎn"; /* ᅶ */
dict[0x21179] = "zhān"; /* ᅹ */
dict[0x2117a] = "jí"; /* ᅺ */
dict[0x2117b] = "huàn"; /* ᅻ */
dict[0x21185] = "wàn"; /* ᆅ */
dict[0x21186] = "luǒ"; /* ᆆ */
dict[0x2118f] = "dòu"; /* ᆏ */
dict[0x21195] = "liàn"; /* ᆕ */
dict[0x211a2] = "qiú"; /* ᆢ */
dict[0x211a3] = "niè,dí"; /* ᆣ */
dict[0x211a4] = "nǎn"; /* ᆤ */
dict[0x211a5] = "jiù"; /* ᆥ */
dict[0x211a6] = "yuè"; /* ᆦ */
dict[0x211a9] = "yāo,jiǒng"; /* ᆩ */
dict[0x211aa] = "chuāng"; /* ᆪ */
dict[0x211ac] = "yīn"; /* ᆬ */
dict[0x211ae] = "cǎn"; /* ᆮ */
dict[0x211af] = "lǐ"; /* ᆯ */
dict[0x211b0] = "dùn"; /* ᆰ */
dict[0x211b1] = "nǎn"; /* ᆱ */
dict[0x211b2] = "nǎn"; /* ᆲ */
dict[0x211b8] = "rì,guó"; /* ᆸ */
dict[0x211bd] = "yuè"; /* ᆽ */
dict[0x211c0] = "yóu"; /* ᇀ */
dict[0x211c2] = "yīn"; /* ᇂ */
dict[0x211c4] = "guó,niè"; /* ᇄ */
dict[0x211c5] = "guó"; /* ᇅ */
dict[0x211c8] = "dàng,tuó"; /* ᇈ */
dict[0x211d1] = "zhēn"; /* ᇑ */
dict[0x211d2] = "mí"; /* ᇒ */
dict[0x211d3] = "dié"; /* ᇓ */
dict[0x211d6] = "zhēn"; /* ᇖ */
dict[0x211da] = "kuā"; /* ᇚ */
dict[0x211dc] = "hán"; /* ᇜ */
dict[0x211dd] = "sòng"; /* ᇝ */
dict[0x211de] = "hé"; /* ᇞ */
dict[0x211df] = "jī"; /* ᇟ */
dict[0x211e0] = "zhé"; /* ᇠ */
dict[0x211e4] = "bǐng"; /* ᇤ */
dict[0x211e6] = "wéi"; /* ᇦ */
dict[0x211e7] = "tōu"; /* ᇧ */
dict[0x211e9] = "tú"; /* ᇩ */
dict[0x211ec] = "gāng"; /* ᇬ */
dict[0x211ed] = "lóu"; /* ᇭ */
dict[0x211ee] = "quán"; /* ᇮ */
dict[0x211ef] = "hùn"; /* ᇯ */
dict[0x211f0] = "zhuǎn"; /* ᇰ */
dict[0x211f1] = "què"; /* ᇱ */
dict[0x211f3] = "hóng"; /* ᇳ */
dict[0x211f5] = "dàng"; /* ᇵ */
dict[0x211f6] = "hé"; /* ᇶ */
dict[0x211f7] = "tài"; /* ᇷ */
dict[0x211f8] = "guāi"; /* ᇸ */
dict[0x211fa] = "yù"; /* ᇺ */
dict[0x211fc] = "yà"; /* ᇼ */
dict[0x211ff] = "wān"; /* ᇿ */
dict[0x21200] = "qūn"; /* ሀ */
dict[0x21205] = "jué"; /* ህ */
dict[0x21206] = "ōu"; /* ሆ */
dict[0x21209] = "quān"; /* ሉ */
dict[0x2120a] = "zhí"; /* ሊ */
dict[0x2120b] = "kǔn"; /* ላ */
dict[0x2120d] = "líng"; /* ል */
dict[0x2120e] = "wū,rì"; /* ሎ */
dict[0x2120f] = "xìn"; /* ሏ */
dict[0x21210] = "dá"; /* ሐ */
dict[0x21212] = "yuān"; /* ሒ */
dict[0x21213] = "yuàn"; /* ሓ */
dict[0x21217] = "mò"; /* ሗ */
dict[0x21219] = "yóu"; /* ሙ */
dict[0x2121e] = "wǔ"; /* ሞ */
dict[0x21220] = "zhāng"; /* ሠ */
dict[0x21223] = "xuān"; /* ሣ */
dict[0x21226] = "rǎo"; /* ሦ */
dict[0x21227] = "gǔn"; /* ሧ */
dict[0x21228] = "yù"; /* ረ */
dict[0x2122e] = "xiá"; /* ሮ */
dict[0x2122f] = "biǎn"; /* ሯ */
dict[0x21230] = "yóu"; /* ሰ */
dict[0x21232] = "yīn"; /* ሲ */
dict[0x21234] = "xuán,rǔ"; /* ሴ */
dict[0x21235] = "yóu"; /* ስ */
dict[0x21236] = "léi"; /* ሶ */
dict[0x2123c] = "tǐng,tíng,zhēng,zhǐ"; /* ሼ */
dict[0x2123f] = "zhēn"; /* ሿ */
dict[0x21242] = "tǐng"; /* ቂ */
dict[0x21244] = "zài,kū"; /* ቄ */
dict[0x21245] = "gā"; /* ቅ */
dict[0x21246] = "lá"; /* ቆ */
dict[0x21247] = "kuài"; /* ቇ */
dict[0x21249] = "què"; /* ቉ */
dict[0x2124e] = "jú"; /* ቎ */
dict[0x21250] = "chūn"; /* ቐ */
dict[0x21251] = "dā"; /* ቑ */
dict[0x21252] = "tún"; /* ቒ */
dict[0x21253] = "āi"; /* ቓ */
dict[0x21257] = "zǐ"; /* ቗ */
dict[0x2125a] = "huáng,fēng"; /* ቚ */
dict[0x2125b] = "yì"; /* ቛ */
dict[0x21261] = "zuò"; /* ቡ */
dict[0x21266] = "wù"; /* ቦ */
dict[0x21269] = "bào"; /* ቩ */
dict[0x2126a] = "chí"; /* ቪ */
dict[0x2126b] = "tún"; /* ቫ */
dict[0x2126d] = "rì"; /* ቭ */
dict[0x21274] = "lú,hù"; /* ቴ */
dict[0x21277] = "jié"; /* ቷ */
dict[0x21278] = "shì"; /* ቸ */
dict[0x2127a] = "zuān"; /* ቺ */
dict[0x21281] = "yì"; /* ኁ */
dict[0x21284] = "fèn"; /* ኄ */
dict[0x21285] = "fèn,biàn"; /* ኅ */
dict[0x21289] = "mò"; /* ኉ */
dict[0x2128d] = "shù"; /* ኍ */
dict[0x2129b] = "áo"; /* ኛ */
dict[0x2129d] = "pǐ"; /* ኝ */
dict[0x2129e] = "píng,pìng"; /* ኞ */
dict[0x2129f] = "pō"; /* ኟ */
dict[0x212a0] = "jiá"; /* አ */
dict[0x212a1] = "zhóu"; /* ኡ */
dict[0x212a3] = "qiū"; /* ኣ */
dict[0x212a5] = "zhào"; /* እ */
dict[0x212a7] = "yǒu"; /* ኧ */
dict[0x212a8] = "tán"; /* ከ */
dict[0x212ab] = "rǒng"; /* ካ */
dict[0x212ad] = "mì"; /* ክ */
dict[0x212b6] = "yì"; /* ኶ */
dict[0x212b8] = "rǒng"; /* ኸ */
dict[0x212bb] = "liè"; /* ኻ */
dict[0x212bc] = "qióng"; /* ኼ */
dict[0x212d9] = "huí"; /* ዙ */
dict[0x212da] = "jì"; /* ዚ */
dict[0x212df] = "gào"; /* ዟ */
dict[0x212e7] = "yóu"; /* ዧ */
dict[0x212e8] = "chā"; /* የ */
dict[0x212e9] = "dé"; /* ዩ */
dict[0x212ea] = "yīn"; /* ዪ */
dict[0x212ec] = "yù"; /* ዬ */
dict[0x212ed] = "bèi"; /* ይ */
dict[0x212ef] = "bó"; /* ዯ */
dict[0x212f2] = "zuò"; /* ዲ */
dict[0x21314] = "qiāo"; /* ጔ */
dict[0x2131a] = "chǎ"; /* ጚ */
dict[0x2131c] = "xīn"; /* ጜ */
dict[0x2131e] = "chí"; /* ጞ */
dict[0x21324] = "kuí"; /* ጤ */
dict[0x21326] = "fèi"; /* ጦ */
dict[0x21329] = "tā,dá"; /* ጩ */
dict[0x2132a] = "guài"; /* ጪ */
dict[0x2132d] = "duō"; /* ጭ */
dict[0x21332] = "guī"; /* ጲ */
dict[0x2134c] = "chǎn"; /* ፌ */
dict[0x2134d] = "nǎo"; /* ፍ */
dict[0x21350] = "hú"; /* ፐ */
dict[0x21352] = "táo"; /* ፒ */
dict[0x21361] = "yì"; /* ፡ */
dict[0x21364] = "niè"; /* ፤ */
dict[0x21365] = "zhài"; /* ፥ */
dict[0x21366] = "huán"; /* ፦ */
dict[0x21368] = "dù"; /* ፨ */
dict[0x2136a] = "qì"; /* ፪ */
dict[0x2136b] = "cè"; /* ፫ */
dict[0x2136e] = "chuí"; /* ፮ */
dict[0x21372] = "dā"; /* ፲ */
dict[0x21376] = "zhì"; /* ፶ */
dict[0x21377] = "gèng"; /* ፷ */
dict[0x2137b] = "wèng"; /* ፻ */
dict[0x21381] = "hù"; /* ᎁ */
dict[0x21389] = "dù"; /* ᎉ */
dict[0x2138a] = "fàn"; /* ᎊ */
dict[0x2138d] = "chí"; /* ᎍ */
dict[0x21390] = "yì"; /* ᎐ */
dict[0x21391] = "àn"; /* ᎑ */
dict[0x21392] = "kuò"; /* ᎒ */
dict[0x21393] = "hè"; /* ᎓ */
dict[0x21394] = "wò"; /* ᎔ */
dict[0x21398] = "yīng"; /* ᎘ */
dict[0x2139a] = "piǎn"; /* ᎚ */
dict[0x213ab] = "zhá,qì"; /* Ꭻ */
dict[0x213ac] = "zhuǎ"; /* Ꭼ */
dict[0x213ae] = "sù"; /* Ꭾ */
dict[0x213b3] = "nì"; /* Ꮃ */
dict[0x213ba] = "zhú"; /* Ꮊ */
dict[0x213bb] = "chán"; /* Ꮋ */
dict[0x213be] = "bèng"; /* Ꮎ */
dict[0x213bf] = "ní"; /* Ꮏ */
dict[0x213c0] = "zhí"; /* Ꮐ */
dict[0x213c1] = "huì"; /* Ꮑ */
dict[0x213d6] = "ài"; /* Ꮦ */
dict[0x213d8] = "xià"; /* Ꮨ */
dict[0x213da] = "zhì"; /* Ꮪ */
dict[0x213db] = "xī"; /* Ꮫ */
dict[0x213de] = "jiǎng"; /* Ꮮ */
dict[0x213e9] = "duī"; /* Ꮹ */
dict[0x213ea] = "fū"; /* Ꮺ */
dict[0x213ed] = "jiāo"; /* Ꮽ */
dict[0x213ee] = "cháo"; /* Ꮾ */
dict[0x213ef] = "bài"; /* Ꮿ */
dict[0x213f2] = "xì"; /* Ᏺ */
dict[0x213f5] = "liè"; /* Ᏽ */
dict[0x213fc] = "áo"; /* ᏼ */
dict[0x2140b] = "zāo"; /* ᐋ */
dict[0x2140c] = "chù"; /* ᐌ */
dict[0x2140f] = "tuǒ"; /* ᐏ */
dict[0x21412] = "háo,hào"; /* ᐒ */
dict[0x21413] = "kāng"; /* ᐓ */
dict[0x21414] = "yín"; /* ᐔ */
dict[0x21416] = "xiàn"; /* ᐖ */
dict[0x2141d] = "fù"; /* ᐝ */
dict[0x2141e] = "biē"; /* ᐞ */
dict[0x21420] = "kuī"; /* ᐠ */
dict[0x21424] = "qiè"; /* ᐤ */
dict[0x21425] = "sà"; /* ᐥ */
dict[0x2143f] = "dā,da"; /* ᐿ */
dict[0x21440] = "yě,shù"; /* ᑀ */
dict[0x21444] = "zhǎng"; /* ᑄ */
dict[0x21446] = "liáng"; /* ᑆ */
dict[0x21448] = "duǐ"; /* ᑈ */
dict[0x2144d] = "láo"; /* ᑍ */
dict[0x2144e] = "xūn"; /* ᑎ */
dict[0x21458] = "zhì"; /* ᑘ */
dict[0x2145a] = "kū"; /* ᑚ */
dict[0x2145e] = "suì"; /* ᑞ */
dict[0x2145f] = "wō"; /* ᑟ */
dict[0x21462] = "dié"; /* ᑢ */
dict[0x21463] = "kū"; /* ᑣ */
dict[0x21464] = "luǒ,yíng"; /* ᑤ */
dict[0x2146f] = "jiǎn"; /* ᑯ */
dict[0x21476] = "jiǎng"; /* ᑶ */
dict[0x2147b] = "zhuì"; /* ᑻ */
dict[0x2147d] = "shuǎng"; /* ᑽ */
dict[0x2147e] = "yú"; /* ᑾ */
dict[0x21481] = "sà"; /* ᒁ */
dict[0x21483] = "yù,ào"; /* ᒃ */
dict[0x21484] = "lǎn"; /* ᒄ */
dict[0x2148a] = "yù"; /* ᒊ */
dict[0x2148c] = "qiǎn"; /* ᒌ */
dict[0x2148d] = "jù"; /* ᒍ */
dict[0x2148f] = "liè"; /* ᒏ */
dict[0x21492] = "shú"; /* ᒒ */
dict[0x21493] = "xiàn"; /* ᒓ */
dict[0x21496] = "gài"; /* ᒖ */
dict[0x214a2] = "tái"; /* ᒢ */
dict[0x214a7] = "tiǎn"; /* ᒧ */
dict[0x214a9] = "gāo"; /* ᒩ */
dict[0x214af] = "mèng"; /* ᒯ */
dict[0x214b1] = "dí"; /* ᒱ */
dict[0x214b3] = "mián"; /* ᒳ */
dict[0x214be] = "huī,kuì"; /* ᒾ */
dict[0x214c9] = "duò"; /* ᓉ */
dict[0x214cd] = "liè"; /* ᓍ */
dict[0x214d2] = "lài"; /* ᓒ */
dict[0x214d3] = "yín,yīn"; /* ᓓ */
dict[0x214d4] = "lǎn"; /* ᓔ */
dict[0x214d6] = "jiāo"; /* ᓖ */
dict[0x214d8] = "huò"; /* ᓘ */
dict[0x214dc] = "qiáng"; /* ᓜ */
dict[0x214e3] = "guō"; /* ᓣ */
dict[0x214e6] = "zhàn"; /* ᓦ */
dict[0x214ed] = "mǐ"; /* ᓭ */
dict[0x214f0] = "kuī"; /* ᓰ */
dict[0x214f7] = "duò"; /* ᓷ */
dict[0x214ff] = "yín"; /* ᓿ */
dict[0x21507] = "lèi"; /* ᔇ */
dict[0x21515] = "gòng"; /* ᔕ */
dict[0x2151b] = "tǐng"; /* ᔛ */
dict[0x2151c] = "yáo"; /* ᔜ */
dict[0x2151e] = "wǎng"; /* ᔞ */
dict[0x21522] = "jié"; /* ᔢ */
dict[0x21523] = "jié,qiè"; /* ᔣ */
dict[0x21528] = "xiū"; /* ᔨ */
dict[0x2152a] = "shù"; /* ᔪ */
dict[0x21531] = "wèi"; /* ᔱ */
dict[0x21534] = "yù"; /* ᔴ */
dict[0x21541] = "zhān"; /* ᕁ */
dict[0x21544] = "yī"; /* ᕄ */
dict[0x21549] = "āng"; /* ᕉ */
dict[0x2154f] = "sǎng"; /* ᕏ */
dict[0x21550] = "chóu"; /* ᕐ */
dict[0x21552] = "kuà"; /* ᕒ */
dict[0x21556] = "jǔ,féng"; /* ᕖ */
dict[0x21557] = "hài"; /* ᕗ */
dict[0x21562] = "miǎn,mǎn"; /* ᕢ */
dict[0x21565] = "xuè"; /* ᕥ */
dict[0x21567] = "hàng"; /* ᕧ */
dict[0x21568] = "fú"; /* ᕨ */
dict[0x2156a] = "chóu"; /* ᕪ */
dict[0x2156e] = "líng"; /* ᕮ */
dict[0x21570] = "zōng"; /* ᕰ */
dict[0x21589] = "kūn"; /* ᖉ */
dict[0x2158a] = "sù"; /* ᖊ */
dict[0x2158c] = "zhōng"; /* ᖌ */
dict[0x2158e] = "zhāo"; /* ᖎ */
dict[0x21590] = "diě"; /* ᖐ */
dict[0x21591] = "gǒu"; /* ᖑ */
dict[0x21592] = "yún"; /* ᖒ */
dict[0x21593] = "dān"; /* ᖓ */
dict[0x21594] = "nuǒ"; /* ᖔ */
dict[0x21597] = "niǎo"; /* ᖗ */
dict[0x2159b] = "bǐng"; /* ᖛ */
dict[0x2159d] = "rán"; /* ᖝ */
dict[0x2159e] = "chān"; /* ᖞ */
dict[0x215a2] = "rǒng"; /* ᖢ */
dict[0x215a3] = "yīn"; /* ᖣ */
dict[0x215a4] = "chān"; /* ᖤ */
dict[0x215a7] = "zhì"; /* ᖧ */
dict[0x215aa] = "guài"; /* ᖪ */
dict[0x215ab] = "nuó"; /* ᖫ */
dict[0x215ac] = "shēn"; /* ᖬ */
dict[0x215af] = "sù"; /* ᖯ */
dict[0x215b2] = "wǒ"; /* ᖲ */
dict[0x215b3] = "chǐ"; /* ᖳ */
dict[0x215b6] = "mò"; /* ᖶ */
dict[0x215ba] = "miè"; /* ᖺ */
dict[0x215bb] = "zhí"; /* ᖻ */
dict[0x215be] = "qī"; /* ᖾ */
dict[0x215c1] = "gōu"; /* ᗁ */
dict[0x215c6] = "lǒu"; /* ᗆ */
dict[0x215c8] = "zī"; /* ᗈ */
dict[0x215cd] = "dǎng"; /* ᗍ */
dict[0x215cf] = "xiǎn"; /* ᗏ */
dict[0x215d1] = "rǒu"; /* ᗑ */
dict[0x215d4] = "tài"; /* ᗔ */
dict[0x215d7] = "pěng"; /* ᗗ */
dict[0x215de] = "xī"; /* ᗞ */
dict[0x215e2] = "kuā,běn"; /* ᗢ */
dict[0x215e4] = "guì"; /* ᗤ */
dict[0x215e5] = "chún"; /* ᗥ */
dict[0x215e6] = "jiè"; /* ᗦ */
dict[0x215f2] = "jiè,bēn"; /* ᗲ */
dict[0x215f3] = "xī"; /* ᗳ */
dict[0x215f5] = "kū"; /* ᗵ */
dict[0x215f7] = "gū"; /* ᗷ */
dict[0x215f8] = "zhà,kuā"; /* ᗸ */
dict[0x215f9] = "fàn"; /* ᗹ */
dict[0x215fc] = "xiè"; /* ᗼ */
dict[0x2160d] = "huán,qié"; /* ᘍ */
dict[0x2160f] = "niǎo"; /* ᘏ */
dict[0x21610] = "xì"; /* ᘐ */
dict[0x2161b] = "cū"; /* ᘛ */
dict[0x2161d] = "gǔn"; /* ᘝ */
dict[0x21621] = "xī"; /* ᘡ */
dict[0x21627] = "qiá"; /* ᘧ */
dict[0x2162a] = "māng"; /* ᘪ */
dict[0x2162d] = "zhé"; /* ᘭ */
dict[0x21630] = "juàn"; /* ᘰ */
dict[0x21634] = "biē"; /* ᘴ */
dict[0x21640] = "biē"; /* ᙀ */
dict[0x21645] = "quán"; /* ᙅ */
dict[0x2164b] = "xì"; /* ᙋ */
dict[0x2164e] = "jiǎo,miǎo"; /* ᙎ */
dict[0x21650] = "quán"; /* ᙐ */
dict[0x21651] = "zhǐ"; /* ᙑ */
dict[0x21652] = "tiān"; /* ᙒ */
dict[0x21653] = "kāi"; /* ᙓ */
dict[0x21658] = "sǎn,yì"; /* ᙘ */
dict[0x2165b] = "zī"; /* ᙛ */
dict[0x21663] = "jié"; /* ᙣ */
dict[0x2166a] = "bié"; /* ᙪ */
dict[0x2166c] = "dòu"; /* ᙬ */
dict[0x2166d] = "zuī"; /* ᙭ */
dict[0x21673] = "jú"; /* ᙳ */
dict[0x21676] = "yǎn"; /* ᙶ */
dict[0x21681] = "bì"; /* ᚁ */
dict[0x21685] = "kuǎi"; /* ᚅ */
dict[0x21687] = "yàn"; /* ᚇ */
dict[0x21688] = "wéi"; /* ᚈ */
dict[0x2168a] = "huān"; /* ᚊ */
dict[0x2168c] = "hào"; /* ᚌ */
dict[0x2168d] = "lián"; /* ᚍ */
dict[0x21691] = "gōng"; /* ᚑ */
dict[0x21694] = "méng"; /* ᚔ */
dict[0x21697] = "lěi"; /* ᚗ */
dict[0x21699] = "dì"; /* ᚙ */
dict[0x2169b] = "bǐng"; /* ᚛ */
dict[0x2169c] = "huān,kàn"; /* ᚜ */
dict[0x2169f] = "wā"; /* ᚟ */
dict[0x216a0] = "jué"; /* ᚠ */
dict[0x216a4] = "bì"; /* ᚤ */
dict[0x216a6] = "jī"; /* ᚦ */
dict[0x216a8] = "chì"; /* ᚨ */
dict[0x216ad] = "bā"; /* ᚭ */
dict[0x216ae] = "jiǔ"; /* ᚮ */
dict[0x216b7] = "dì"; /* ᚷ */
dict[0x216b8] = "yāo"; /* ᚸ */
dict[0x216b9] = "zhàng"; /* ᚹ */
dict[0x216bb] = "dà"; /* ᚻ */
dict[0x216bc] = "shí"; /* ᚼ */
dict[0x216bd] = "hào"; /* ᚽ */
dict[0x216be] = "shū"; /* ᚾ */
dict[0x216cc] = "yè"; /* ᛌ */
dict[0x216d7] = "bì"; /* ᛗ */
dict[0x216d8] = "pǐ"; /* ᛘ */
dict[0x216d9] = "yǎo,yāo"; /* ᛙ */
dict[0x216dc] = "dī"; /* ᛜ */
dict[0x216dd] = "càn"; /* ᛝ */
dict[0x216de] = "pín"; /* ᛞ */
dict[0x216df] = "yuè"; /* ᛟ */
dict[0x216e0] = "qiē"; /* ᛠ */
dict[0x216e1] = "pī"; /* ᛡ */
dict[0x216f0] = "zhí"; /* ᛰ */
dict[0x216f5] = "tuǒ"; /* ᛵ */
dict[0x216f6] = "xiè"; /* ᛶ */
dict[0x216fd] = "yè"; /* ᛽ */
dict[0x21700] = "fàn"; /* ᜀ */
dict[0x21701] = "guā"; /* ᜁ */
dict[0x21702] = "hù"; /* ᜂ */
dict[0x21703] = "rǔ"; /* ᜃ */
dict[0x21709] = "rǎn,ràn"; /* ᜉ */
dict[0x2170a] = "fǒu"; /* ᜊ */
dict[0x2170b] = "huāng"; /* ᜋ */
dict[0x2171a] = "rú"; /* ᜚ */
dict[0x2171d] = "dòng"; /* ᜝ */
dict[0x21722] = "mǎo"; /* ᜢ */
dict[0x21725] = "duī"; /* ᜥ */
dict[0x21726] = "huì"; /* ᜦ */
dict[0x21727] = "xì"; /* ᜧ */
dict[0x21728] = "xiū"; /* ᜨ */
dict[0x2172a] = "nǎo"; /* ᜪ */
dict[0x2172b] = "rǎn"; /* ᜫ */
dict[0x2172c] = "yī"; /* ᜬ */
dict[0x2172f] = "zhé"; /* ᜯ */
dict[0x21731] = "jì"; /* ᜱ */
dict[0x21732] = "gào"; /* ᜲ */
dict[0x21733] = "yòu"; /* ᜳ */
dict[0x21735] = "pū"; /* ᜵ */
dict[0x2173f] = "mǔ"; /* ᜿ */
dict[0x21748] = "chù"; /* ᝈ */
dict[0x21749] = "cū"; /* ᝉ */
dict[0x2174a] = "zhé"; /* ᝊ */
dict[0x2174b] = "niǎo"; /* ᝋ */
dict[0x2174d] = "qiè"; /* ᝍ */
dict[0x2174f] = "pín"; /* ᝏ */
dict[0x21750] = "chá"; /* ᝐ */
dict[0x21752] = "niǎo"; /* ᝒ */
dict[0x21753] = "suī"; /* ᝓ */
dict[0x21757] = "qún"; /* ᝗ */
dict[0x21759] = "chá"; /* ᝙ */
dict[0x2175a] = "chéng"; /* ᝚ */
dict[0x2175b] = "yáo"; /* ᝛ */
dict[0x2175c] = "dù"; /* ᝜ */
dict[0x2175d] = "wāng"; /* ᝝ */
dict[0x2175f] = "niàn"; /* ᝟ */
dict[0x21766] = "nǒu"; /* ᝦ */
dict[0x21767] = "xì"; /* ᝧ */
dict[0x21769] = "yāo"; /* ᝩ */
dict[0x2176b] = "chān"; /* ᝫ */
dict[0x2178f] = "nài"; /* ត */
dict[0x21798] = "xiè"; /* ម */
dict[0x21799] = "miè"; /* យ */
dict[0x2179a] = "kěng"; /* រ */
dict[0x2179c] = "cù"; /* វ */
dict[0x2179e] = "shěng"; /* ឞ */
dict[0x2179f] = "pàn"; /* ស */
dict[0x217a0] = "hù"; /* ហ */
dict[0x217a2] = "kè"; /* អ */
dict[0x217a3] = "xiàn"; /* ឣ */
dict[0x217a5] = "hóu"; /* ឥ */
dict[0x217a6] = "qióng"; /* ឦ */
dict[0x217a7] = "zōng"; /* ឧ */
dict[0x217aa] = "fú"; /* ឪ */
dict[0x217ab] = "nài"; /* ឫ */
dict[0x217ad] = "nì"; /* ឭ */
dict[0x217af] = "kǔ"; /* ឯ */
dict[0x217be] = "nèn"; /* ើ */
dict[0x217cd] = "gē"; /* ៍ */
dict[0x217d1] = "hóu"; /* ៑ */
dict[0x217d3] = "āi"; /* ៓ */
dict[0x217d5] = "shī"; /* ៕ */
dict[0x217de] = "xiū"; /* ៞ */
dict[0x217df] = "cōng"; /* ៟ */
dict[0x217e0] = "jiāo"; /* ០ */
dict[0x217e2] = "zhá"; /* ២ */
dict[0x217e3] = "xiāo"; /* ៣ */
dict[0x217e4] = "liàn"; /* ៤ */
dict[0x217e5] = "qǔ"; /* ៥ */
dict[0x217e8] = "shǎn"; /* ៨ */
dict[0x217e9] = "xiè"; /* ៩ */
dict[0x217eb] = "gòng"; /* ៫ */
dict[0x217ec] = "miè"; /* ៬ */
dict[0x217ed] = "chái"; /* ៭ */
dict[0x217ef] = "ēn"; /* ៯ */
dict[0x217f0] = "wǎn"; /* ៰ */
dict[0x217f3] = "dòu"; /* ៳ */
dict[0x21806] = "kòu"; /* ᠆ */
dict[0x21809] = "lí"; /* ᠉ */
dict[0x2180a] = "tiáo"; /* ᠊ */
dict[0x2180b] = "shī"; /* ᠋ */
dict[0x2180f] = "sāng"; /* ᠏ */
dict[0x21812] = "guān"; /* ᠒ */
dict[0x21816] = "hào"; /* ᠖ */
dict[0x21817] = "zhì"; /* ᠗ */
dict[0x21818] = "yàng"; /* ᠘ */
dict[0x21819] = "tōng"; /* ᠙ */
dict[0x2181a] = "bì"; /* ᠚ */
dict[0x2181c] = "mó,mò"; /* ᠜ */
dict[0x2181e] = "fú"; /* ᠞ */
dict[0x21825] = "qiáng"; /* ᠥ */
dict[0x21839] = "zhì"; /* ᠹ */
dict[0x2183c] = "sōu"; /* ᠼ */
dict[0x2183f] = "niǎo"; /* ᠿ */
dict[0x21840] = "juàn"; /* ᡀ */
dict[0x21842] = "yàng"; /* ᡂ */
dict[0x21844] = "huāng"; /* ᡄ */
dict[0x21848] = "bēng"; /* ᡈ */
dict[0x21849] = "mó"; /* ᡉ */
dict[0x2184a] = "cháo"; /* ᡊ */
dict[0x2184e] = "lǚ,lóu"; /* ᡎ */
dict[0x2184f] = "shāo"; /* ᡏ */
dict[0x21850] = "bǔ"; /* ᡐ */
dict[0x21851] = "zēng"; /* ᡑ */
dict[0x21852] = "sī,xī"; /* ᡒ */
dict[0x21853] = "xū"; /* ᡓ */
dict[0x21854] = "zuì"; /* ᡔ */
dict[0x21855] = "yuē"; /* ᡕ */
dict[0x21856] = "zān,cān"; /* ᡖ */
dict[0x21857] = "luǎn,luàn"; /* ᡗ */
dict[0x21865] = "qú"; /* ᡥ */
dict[0x2187a] = "miǎo"; /* ᡺ */
dict[0x21880] = "zhuàn"; /* ᢀ */
dict[0x21888] = "dàng"; /* ᢈ */
dict[0x2188a] = "yuān"; /* ᢊ */
dict[0x2188e] = "fàn"; /* ᢎ */
dict[0x21892] = "jǔ"; /* ᢒ */
dict[0x21895] = "huǐ"; /* ᢕ */
dict[0x21896] = "qì"; /* ᢖ */
dict[0x21898] = "yùn,yíng"; /* ᢘ */
dict[0x2189a] = "màn"; /* ᢚ */
dict[0x2189c] = "mǒ"; /* ᢜ */
dict[0x218b1] = "piāo"; /* ᢱ */
dict[0x218b3] = "jìn"; /* ᢳ */
dict[0x218b9] = "yāo"; /* ᢹ */
dict[0x218c0] = "chì"; /* ᣀ */
dict[0x218c1] = "nì"; /* ᣁ */
dict[0x218c2] = "sōu"; /* ᣂ */
dict[0x218c8] = "shù"; /* ᣈ */
dict[0x218cb] = "piāo"; /* ᣋ */
dict[0x218d4] = "hàn"; /* ᣔ */
dict[0x218d5] = "pín"; /* ᣕ */
dict[0x218e0] = "yāo"; /* ᣠ */
dict[0x218e2] = "néi"; /* ᣢ */
dict[0x218ea] = "shì"; /* ᣪ */
dict[0x218ec] = "yuān"; /* ᣬ */
dict[0x218ee] = "cài"; /* ᣮ */
dict[0x218ef] = "jié"; /* ᣯ */
dict[0x218f9] = "xiè"; /* ᣹ */
dict[0x218fd] = "yán"; /* ᣽ */
dict[0x218fe] = "xiāo"; /* ᣾ */
dict[0x2190b] = "xiè"; /* ᤋ */
dict[0x2190c] = "lì"; /* ᤌ */
dict[0x2190e] = "fàn"; /* ᤎ */
dict[0x21917] = "zhù"; /* ᤗ */
dict[0x21919] = "nà"; /* ᤙ */
dict[0x2191b] = "zhuǎn"; /* ᤛ */
dict[0x2191e] = "kuī"; /* ᤞ */
dict[0x21922] = "luó"; /* ᤢ */
dict[0x2192b] = "qiā"; /* ᤫ */
dict[0x21936] = "wān"; /* ᤶ */
dict[0x2193d] = "shǔ"; /* ᤽ */
dict[0x2193f] = "chèng,kǒng"; /* ᤿ */
dict[0x21941] = "yì"; /* ᥁ */
dict[0x21946] = "hǎo,hào"; /* ᥆ */
dict[0x21948] = "jiào"; /* ᥈ */
dict[0x2194b] = "huì"; /* ᥋ */
dict[0x2194d] = "xiào"; /* ᥍ */
dict[0x2194e] = "cí,zǐ"; /* ᥎ */
dict[0x21958] = "chuā"; /* ᥘ */
dict[0x2195e] = "jì,bèi"; /* ᥞ */
dict[0x21966] = "nǐ,jìn"; /* ᥦ */
dict[0x21967] = "jìn"; /* ᥧ */
dict[0x21968] = "nǐ,jìn"; /* ᥨ */
dict[0x21969] = "tǐ"; /* ᥩ */
dict[0x21976] = "jù,rú"; /* ᥶ */
dict[0x21978] = "mìng"; /* ᥸ */
dict[0x2197d] = "lí"; /* ᥽ */
dict[0x2197f] = "zhòng"; /* ᥿ */
dict[0x21981] = "xù"; /* ᦁ */
dict[0x21983] = "qióng"; /* ᦃ */
dict[0x21984] = "fú"; /* ᦄ */
dict[0x21986] = "bìn"; /* ᦆ */
dict[0x2198a] = "jì"; /* ᦊ */
dict[0x2198d] = "qí"; /* ᦍ */
dict[0x2198e] = "xì"; /* ᦎ */
dict[0x21994] = "dèng"; /* ᦔ */
dict[0x21995] = "ér"; /* ᦕ */
dict[0x2199b] = "shú"; /* ᦛ */
dict[0x2199c] = "tóng"; /* ᦜ */
dict[0x2199d] = "xiáo"; /* ᦝ */
dict[0x2199f] = "pí"; /* ᦟ */
dict[0x219a8] = "dǎn"; /* ᦨ */
dict[0x219aa] = "jí"; /* ᦪ */
dict[0x219b3] = "xiào"; /* ᦳ */
dict[0x219b7] = "cóng"; /* ᦷ */
dict[0x219b9] = "guān"; /* ᦹ */
dict[0x219bb] = "bīn"; /* ᦻ */
dict[0x219bc] = "rǒng"; /* ᦼ */
dict[0x219cd] = "miàn,bīn"; /* ᧍ */
dict[0x219d2] = "miàn"; /* ᧒ */
dict[0x219d4] = "shū"; /* ᧔ */
dict[0x219d5] = "xiáo,shǒu"; /* ᧕ */
dict[0x219d6] = "bǎo"; /* ᧖ */
dict[0x219d7] = "wà"; /* ᧗ */
dict[0x219d9] = "pào"; /* ᧙ */
dict[0x219e3] = "gǎi"; /* ᧣ */
dict[0x219e5] = "hū"; /* ᧥ */
dict[0x219e6] = "héng"; /* ᧦ */
dict[0x219e8] = "zhú"; /* ᧨ */
dict[0x219e9] = "guāi"; /* ᧩ */
dict[0x219ed] = "guì,guǐ"; /* ᧭ */
dict[0x219ee] = "yǎo"; /* ᧮ */
dict[0x219ef] = "jì"; /* ᧯ */
dict[0x219f1] = "hài"; /* ᧱ */
dict[0x219f9] = "dài"; /* ᧹ */
dict[0x219fc] = "bīn"; /* ᧼ */
dict[0x219fd] = "huǎng,huāng"; /* ᧽ */
dict[0x21a00] = "chá"; /* ᨀ */
dict[0x21a02] = "wù"; /* ᨂ */
dict[0x21a04] = "xià,sāi"; /* ᨄ */
dict[0x21a05] = "jú"; /* ᨅ */
dict[0x21a07] = "yǎo,xiǎng"; /* ᨇ */
dict[0x21a16] = "fěn"; /* ᨖ */
dict[0x21a17] = "zào"; /* ᨗ */
dict[0x21a1b] = "fēng"; /* ᨛ */
dict[0x21a1c] = "jì"; /* ᨜ */
dict[0x21a22] = "jū"; /* ᨢ */
dict[0x21a23] = "yù"; /* ᨣ */
dict[0x21a27] = "zǎi"; /* ᨧ */
dict[0x21a29] = "hūn"; /* ᨩ */
dict[0x21a32] = "jié"; /* ᨲ */
dict[0x21a33] = "xiòng,hùn"; /* ᨳ */
dict[0x21a35] = "nài"; /* ᨵ */
dict[0x21a3b] = "nǒu"; /* ᨻ */
dict[0x21a3d] = "shěng"; /* ᨽ */
dict[0x21a3f] = "yù"; /* ᨿ */
dict[0x21a42] = "huán"; /* ᩂ */
dict[0x21a43] = "gěng"; /* ᩃ */
dict[0x21a44] = "wǎn"; /* ᩄ */
dict[0x21a46] = "tuó"; /* ᩆ */
dict[0x21a47] = "qiāo"; /* ᩇ */
dict[0x21a58] = "yìn"; /* ᩘ */
dict[0x21a5a] = "jiā,zhuàn"; /* ᩚ */
dict[0x21a61] = "suǒ"; /* ᩡ */
dict[0x21a63] = "jié"; /* ᩣ */
dict[0x21a64] = "xī"; /* ᩤ */
dict[0x21a65] = "wěng"; /* ᩥ */
dict[0x21a69] = "máng"; /* ᩩ */
dict[0x21a76] = "yáng"; /* ᩶ */
dict[0x21a78] = "yáo"; /* ᩸ */
dict[0x21a7d] = "máng"; /* ᩽ */
dict[0x21a7e] = "ōu"; /* ᩾ */
dict[0x21a81] = "án"; /* ᪁ */
dict[0x21a85] = "lòu"; /* ᪅ */
dict[0x21a90] = "diàn"; /* ᪐ */
dict[0x21a91] = "è"; /* ᪑ */
dict[0x21a92] = "zǐ"; /* ᪒ */
dict[0x21a97] = "è"; /* ᪗ */
dict[0x21a99] = "àn"; /* ᪙ */
dict[0x21a9e] = "huò"; /* ᪞ */
dict[0x21aa0] = "céng"; /* ᪠ */
dict[0x21ab0] = "xiòng"; /* ᪰ */
dict[0x21ab1] = "jì"; /* ᪱ */
dict[0x21ab3] = "zuó"; /* ᪳ */
dict[0x21ab5] = "qí"; /* ᪵ */
dict[0x21ab9] = "liáo"; /* ᪹ */
dict[0x21aba] = "zhēng"; /* ᪺ */
dict[0x21ac0] = "jī"; /* ᫀ */
dict[0x21ac1] = "qī,chèn"; /* ᫁ */
dict[0x21ac2] = "juǎn"; /* ᫂ */
dict[0x21ac3] = "níng"; /* ᫃ */
dict[0x21adb] = "mián"; /* ᫛ */
dict[0x21adf] = "sè"; /* ᫟ */
dict[0x21ae5] = "hè"; /* ᫥ */
dict[0x21ae6] = "rǒng"; /* ᫦ */
dict[0x21ae7] = "qǐn"; /* ᫧ */
dict[0x21aec] = "jū"; /* ᫬ */
dict[0x21aef] = "lì"; /* ᫯ */
dict[0x21af3] = "sè"; /* ᫳ */
dict[0x21af5] = "shí"; /* ᫵ */
dict[0x21af8] = "nì"; /* ᫸ */
dict[0x21af9] = "xián"; /* ᫹ */
dict[0x21afa] = "fū"; /* ᫺ */
dict[0x21afd] = "rǔ,yù"; /* ᫽ */
dict[0x21b01] = "xiòng"; /* ᬁ */
dict[0x21b02] = "guì"; /* ᬂ */
dict[0x21b04] = "jì"; /* ᬄ */
dict[0x21b06] = "měng,mèng"; /* ᬆ */
dict[0x21b07] = "fū"; /* ᬇ */
dict[0x21b09] = "sài"; /* ᬉ */
dict[0x21b0a] = "yù"; /* ᬊ */
dict[0x21b0b] = "jiào"; /* ᬋ */
dict[0x21b0c] = "mèng"; /* ᬌ */
dict[0x21b0d] = "lóng"; /* ᬍ */
dict[0x21b0e] = "qiāng"; /* ᬎ */
dict[0x21b10] = "mí,mǐ"; /* ᬐ */
dict[0x21b13] = "yí"; /* ᬓ */
dict[0x21b16] = "hān"; /* ᬖ */
dict[0x21b17] = "nì"; /* ᬗ */
dict[0x21b18] = "lào"; /* ᬘ */
dict[0x21b19] = "sèng"; /* ᬙ */
dict[0x21b1c] = "lǐn"; /* ᬜ */
dict[0x21b1e] = "yù"; /* ᬞ */
dict[0x21b25] = "nuó"; /* ᬥ */
dict[0x21b2b] = "wù"; /* ᬫ */
dict[0x21b2f] = "biǎn"; /* ᬯ */
dict[0x21b32] = "biǎn"; /* ᬲ */
dict[0x21b33] = "xuān,shòu"; /* ᬳ */
dict[0x21b35] = "jiān"; /* ᬵ */
dict[0x21b38] = "biǎn"; /* ᬸ */
dict[0x21b42] = "dé"; /* ᭂ */
dict[0x21b47] = "zhuān"; /* ᭇ */
dict[0x21b4b] = "rǒng"; /* ᭋ */
dict[0x21b50] = "shuàn"; /* ᭐ */
dict[0x21b58] = "jiā"; /* ᭘ */
dict[0x21b5a] = "mó"; /* ᭚ */
dict[0x21b5b] = "huǐ"; /* ᭛ */
dict[0x21b5e] = "zhān"; /* ᭞ */
dict[0x21b62] = "bài"; /* ᭢ */
dict[0x21b63] = "liè"; /* ᭣ */
dict[0x21b65] = "xiē"; /* ᭥ */
dict[0x21b6d] = "jiǎn"; /* ᭭ */
dict[0x21b6e] = "shǒu"; /* ᭮ */
dict[0x21b73] = "kào"; /* ᭳ */
dict[0x21b74] = "xì"; /* ᭴ */
dict[0x21b77] = "guān"; /* ᭷ */
dict[0x21b78] = "luàn"; /* ᭸ */
dict[0x21b7d] = "xì"; /* ᭽ */
dict[0x21b7e] = "nǒu"; /* ᭾ */
dict[0x21b7f] = "chǎng"; /* ᭿ */
dict[0x21b8e] = "liáng"; /* ᮎ */
dict[0x21b99] = "nài"; /* ᮙ */
dict[0x21b9a] = "rǔ"; /* ᮚ */
dict[0x21b9e] = "zhì"; /* ᮞ */
dict[0x21ba6] = "cáo"; /* ᮦ */
dict[0x21bb0] = "lì"; /* ᮰ */
dict[0x21bbb] = "lán"; /* ᮻ */
dict[0x21bbf] = "chān"; /* ᮿ */
dict[0x21bc1] = "wāng"; /* ᯁ */
dict[0x21bc4] = "lì"; /* ᯄ */
dict[0x21bc7] = "wù"; /* ᯇ */
dict[0x21bc8] = "páo"; /* ᯈ */
dict[0x21bc9] = "yòu"; /* ᯉ */
dict[0x21bcb] = "gān"; /* ᯋ */
dict[0x21bcf] = "ān"; /* ᯏ */
dict[0x21bd0] = "xiū"; /* ᯐ */
dict[0x21bd1] = "shuǐ,zhuǐ"; /* ᯑ */
dict[0x21bd2] = "ruǐ"; /* ᯒ */
dict[0x21bd8] = "bǎn"; /* ᯘ */
dict[0x21bd9] = "yóu"; /* ᯙ */
dict[0x21bdb] = "zuǒ"; /* ᯛ */
dict[0x21be2] = "huó"; /* ᯢ */
dict[0x21be3] = "yào"; /* ᯣ */
dict[0x21be5] = "huī"; /* ᯥ */
dict[0x21be8] = "zuò"; /* ᯨ */
dict[0x21be9] = "xiāo"; /* ᯩ */
dict[0x21beb] = "mián"; /* ᯫ */
dict[0x21bf0] = "gà"; /* ᯰ */
dict[0x21bf1] = "yuǎn"; /* ᯱ */
dict[0x21bf3] = "bò"; /* ᯳ */
dict[0x21bf4] = "chào"; /* ᯴ */
dict[0x21bf5] = "tuǐ,kuì"; /* ᯵ */
dict[0x21bf7] = "bò,kòu"; /* ᯷ */
dict[0x21bfd] = "gà"; /* ᯽ */
dict[0x21bff] = "tiāo"; /* ᯿ */
dict[0x21c00] = "ná"; /* ᰀ */
dict[0x21c02] = "kuī"; /* ᰂ */
dict[0x21c05] = "hú"; /* ᰅ */
dict[0x21c06] = "niè"; /* ᰆ */
dict[0x21c0b] = "huí"; /* ᰋ */
dict[0x21c0c] = "lǒu"; /* ᰌ */
dict[0x21c0e] = "tí"; /* ᰎ */
dict[0x21c10] = "qiào"; /* ᰐ */
dict[0x21c11] = "qiáo"; /* ᰑ */
dict[0x21c12] = "zhǒng"; /* ᰒ */
dict[0x21c16] = "dī"; /* ᰖ */
dict[0x21c1a] = "lín"; /* ᰚ */
dict[0x21c1d] = "quán"; /* ᰝ */
dict[0x21c1e] = "zhuān"; /* ᰞ */
dict[0x21c20] = "léi,luán"; /* ᰠ */
dict[0x21c22] = "xié"; /* ᰢ */
dict[0x21c23] = "shī"; /* ᰣ */
dict[0x21c25] = "rén,yí"; /* ᰥ */
dict[0x21c28] = "dāng"; /* ᰨ */
dict[0x21c2b] = "niǎn"; /* ᰫ */
dict[0x21c2f] = "shǐ,diǎo,běi"; /* ᰯ */
dict[0x21c32] = "xián"; /* ᰲ */
dict[0x21c35] = "jī"; /* ᰵ */
dict[0x21c38] = "jī"; /* ᰸ */
dict[0x21c39] = "zhí"; /* ᰹ */
dict[0x21c3d] = "ài"; /* ᰽ */
dict[0x21c3e] = "cī"; /* ᰾ */
dict[0x21c3f] = "pú"; /* ᰿ */
dict[0x21c41] = "shǐ"; /* ᱁ */
dict[0x21c42] = "tún"; /* ᱂ */
dict[0x21c45] = "qū"; /* ᱅ */
dict[0x21c46] = "shǔ"; /* ᱆ */
dict[0x21c47] = "diān"; /* ᱇ */
dict[0x21c49] = "xiǎo"; /* ᱉ */
dict[0x21c4a] = "shuǐ"; /* ᱊ */
dict[0x21c4c] = "huán"; /* ᱌ */
dict[0x21c50] = "yí"; /* ᱐ */
dict[0x21c51] = "juān"; /* ᱑ */
dict[0x21c54] = "zhǐ,qì"; /* ᱔ */
dict[0x21c5c] = "zhào"; /* ᱜ */
dict[0x21c63] = "xù"; /* ᱣ */
dict[0x21c6f] = "lòng"; /* ᱯ */
dict[0x21c71] = "zhù"; /* ᱱ */
dict[0x21c73] = "suǒ"; /* ᱳ */
dict[0x21c77] = "dié"; /* ᱷ */
dict[0x21c7a] = "qú"; /* ᱺ */
dict[0x21c7c] = "kè,kuà"; /* ᱼ */
dict[0x21c7d] = "hū"; /* ᱽ */
dict[0x21c7e] = "jū"; /* ᱾ */
dict[0x21c80] = "qǐng"; /* ᲀ */
dict[0x21c86] = "jī"; /* ᲆ */
dict[0x21c8d] = "bīng"; /* ᲍ */
dict[0x21c95] = "tì"; /* Ვ */
dict[0x21c97] = "jué"; /* Თ */
dict[0x21c9a] = "qiú"; /* Ლ */
dict[0x21ca3] = "jiàng"; /* Უ */
dict[0x21caa] = "yùn"; /* Ც */
dict[0x21cad] = "mèi"; /* Ჭ */
dict[0x21cae] = "pī"; /* Ხ */
dict[0x21cb0] = "qú"; /* Ჰ */
dict[0x21cbc] = "mì"; /* ᲼ */
dict[0x21cbe] = "tuī"; /* Ჾ */
dict[0x21cbf] = "tì"; /* Ჿ */
dict[0x21cc2] = "kài"; /* ᳂ */
dict[0x21cc4] = "bǐ"; /* ᳄ */
dict[0x21cc6] = "qū,qù"; /* ᳆ */
dict[0x21ccf] = "tiāo"; /* ᳏ */
dict[0x21cd1] = "chù"; /* ᳑ */
dict[0x21cd8] = "jú"; /* ᳘ */
dict[0x21cda] = "xī"; /* ᳚ */
dict[0x21cde] = "lìn"; /* ᳞ */
dict[0x21ced] = "chǐ"; /* ᳭ */
dict[0x21cee] = "jī"; /* ᳮ */
dict[0x21cf4] = "lú"; /* ᳴ */
dict[0x21cf8] = "lì"; /* ᳸ */
dict[0x21cfe] = "jué"; /* ᳾ */
dict[0x21d05] = "zhū"; /* ᴅ */
dict[0x21d06] = "lù"; /* ᴆ */
dict[0x21d0e] = "niè"; /* ᴎ */
dict[0x21d14] = "quán"; /* ᴔ */
dict[0x21d18] = "xìng"; /* ᴘ */
dict[0x21d1e] = "yǔn"; /* ᴞ */
dict[0x21d2d] = "yà"; /* ᴭ */
dict[0x21d2f] = "è"; /* ᴯ */
dict[0x21d31] = "hù,jié"; /* ᴱ */
dict[0x21d39] = "jié"; /* ᴹ */
dict[0x21d40] = "máng"; /* ᵀ */
dict[0x21d49] = "wù"; /* ᵉ */
dict[0x21d4c] = "chā"; /* ᵌ */
dict[0x21d51] = "qīn"; /* ᵑ */
dict[0x21d52] = "jié,qǐ"; /* ᵒ */
dict[0x21d53] = "hóng"; /* ᵓ */
dict[0x21d55] = "dān"; /* ᵕ */
dict[0x21d56] = "ěn"; /* ᵖ */
dict[0x21d57] = "zè"; /* ᵗ */
dict[0x21d58] = "hù"; /* ᵘ */
dict[0x21d59] = "àng"; /* ᵙ */
dict[0x21d5a] = "jiè"; /* ᵚ */
dict[0x21d5b] = "fù"; /* ᵛ */
dict[0x21d5c] = "yòng"; /* ᵜ */
dict[0x21d5e] = "fēng"; /* ᵞ */
dict[0x21d6c] = "mù"; /* ᵬ */
dict[0x21d6d] = "cūn"; /* ᵭ */
dict[0x21d76] = "sè"; /* ᵶ */
dict[0x21d77] = "cóng"; /* ᵷ */
dict[0x21d7b] = "kāng"; /* ᵻ */
dict[0x21d82] = "yào"; /* ᶂ */
dict[0x21d83] = "ài"; /* ᶃ */
dict[0x21d84] = "bāo"; /* ᶄ */
dict[0x21d86] = "pǒ"; /* ᶆ */
dict[0x21d88] = "shǐ"; /* ᶈ */
dict[0x21d89] = "fàn"; /* ᶉ */
dict[0x21d8b] = "jú"; /* ᶋ */
dict[0x21d8c] = "pí"; /* ᶌ */
dict[0x21d8e] = "wèi"; /* ᶎ */
dict[0x21d8f] = "kū"; /* ᶏ */
dict[0x21d90] = "qié"; /* ᶐ */
dict[0x21d91] = "gān"; /* ᶑ */
dict[0x21da2] = "kuàng"; /* ᶢ */
dict[0x21da3] = "suì"; /* ᶣ */
dict[0x21da4] = "bēng,yòng"; /* ᶤ */
dict[0x21da5] = "jiā"; /* ᶥ */
dict[0x21da6] = "yà"; /* ᶦ */
dict[0x21daa] = "kàn"; /* ᶪ */
dict[0x21dab] = "niè"; /* ᶫ */
dict[0x21dad] = "xíng"; /* ᶭ */
dict[0x21daf] = "xì"; /* ᶯ */
dict[0x21db1] = "lìn"; /* ᶱ */
dict[0x21db2] = "duǒ"; /* ᶲ */
dict[0x21dbe] = "shí"; /* ᶾ */
dict[0x21dc8] = "shì"; /* ᷈ */
dict[0x21dcb] = "duì"; /* ᷋ */
dict[0x21dcd] = "jiāng"; /* ᷍ */
dict[0x21dce] = "yǔ"; /* ᷎ */
dict[0x21dcf] = "lù"; /* ᷏ */
dict[0x21dd0] = "ěn"; /* ᷐ */
dict[0x21dd3] = "gǔ"; /* ᷓ */
dict[0x21dd5] = "wěi"; /* ᷕ */
dict[0x21dd6] = "chē"; /* ᷖ */
dict[0x21dd7] = "huàn,huán"; /* ᷗ */
dict[0x21dd8] = "bié"; /* ᷘ */
dict[0x21ddb] = "hàn"; /* ᷛ */
dict[0x21ddc] = "tuí"; /* ᷜ */
dict[0x21ddd] = "nà"; /* ᷝ */
dict[0x21dde] = "qǐ"; /* ᷞ */
dict[0x21de0] = "tóu"; /* ᷠ */
dict[0x21de1] = "yuān"; /* ᷡ */
dict[0x21de2] = "wáng"; /* ᷢ */
dict[0x21de4] = "wú"; /* ᷤ */
dict[0x21de5] = "gào"; /* ᷥ */
dict[0x21de8] = "kēng,xíng"; /* ᷨ */
dict[0x21dea] = "yí,níng"; /* ᷪ */
dict[0x21deb] = "chéng"; /* ᷫ */
dict[0x21df8] = "xiāo"; /* ᷸ */
dict[0x21dfa] = "guǐ"; /* ᷺ */
dict[0x21dfb] = "yà"; /* ᷻ */
dict[0x21dfc] = "suì"; /* ᷼ */
dict[0x21dfd] = "sǒng"; /* ᷽ */
dict[0x21dff] = "zhuó"; /* ᷿ */
dict[0x21e02] = "tū,tú"; /* Ḃ */
dict[0x21e03] = "jiǎn"; /* ḃ */
dict[0x21e05] = "tāo"; /* ḅ */
dict[0x21e08] = "zè"; /* Ḉ */
dict[0x21e09] = "lì"; /* ḉ */
dict[0x21e0c] = "zhù"; /* Ḍ */
dict[0x21e0e] = "jié"; /* Ḏ */
dict[0x21e11] = "tì"; /* ḑ */
dict[0x21e14] = "xié"; /* Ḕ */
dict[0x21e15] = "qióng"; /* ḕ */
dict[0x21e17] = "yà"; /* ḗ */
dict[0x21e18] = "jū"; /* Ḙ */
dict[0x21e1b] = "yín"; /* ḛ */
dict[0x21e1c] = "zhí"; /* Ḝ */
dict[0x21e1e] = "kǎn"; /* Ḟ */
dict[0x21e1f] = "zī"; /* ḟ */
dict[0x21e21] = "kē"; /* ḡ */
dict[0x21e23] = "niè"; /* ḣ */
dict[0x21e24] = "qiáng"; /* Ḥ */
dict[0x21e25] = "wǎn"; /* ḥ */
dict[0x21e26] = "zé"; /* Ḧ */
dict[0x21e28] = "jū"; /* Ḩ */
dict[0x21e2a] = "zì"; /* Ḫ */
dict[0x21e2b] = "pīn"; /* ḫ */
dict[0x21e44] = "yà"; /* Ṅ */
dict[0x21e47] = "lín"; /* ṇ */
dict[0x21e49] = "qí"; /* ṉ */
dict[0x21e4e] = "huí"; /* Ṏ */
dict[0x21e53] = "qì"; /* ṓ */
dict[0x21e54] = "bēng"; /* Ṕ */
dict[0x21e55] = "yáng"; /* ṕ */
dict[0x21e56] = "suì"; /* Ṗ */
dict[0x21e58] = "qǐ"; /* Ṙ */
dict[0x21e59] = "guī"; /* ṙ */
dict[0x21e62] = "qìn"; /* Ṣ */
dict[0x21e63] = "ē"; /* ṣ */
dict[0x21e65] = "zuò"; /* ṥ */
dict[0x21e68] = "zè"; /* Ṩ */
dict[0x21e69] = "qì"; /* ṩ */
dict[0x21e6a] = "jí"; /* Ṫ */
dict[0x21e6c] = "tuó"; /* Ṭ */
dict[0x21e6d] = "dié"; /* ṭ */
dict[0x21e6f] = "huì"; /* ṯ */
dict[0x21e70] = "máo"; /* Ṱ */
dict[0x21e72] = "xǔ"; /* Ṳ */
dict[0x21e75] = "hóu"; /* ṵ */
dict[0x21e76] = "yǎn"; /* Ṷ */
dict[0x21e77] = "xiáng"; /* ṷ */
dict[0x21e78] = "cōng"; /* Ṹ */
dict[0x21e79] = "hú"; /* ṹ */
dict[0x21e7c] = "àn,yǎn"; /* Ṽ */
dict[0x21e7e] = "bǐng"; /* Ṿ */
dict[0x21e87] = "duǒ"; /* ẇ */
dict[0x21e90] = "zhǔ"; /* Ẑ */
dict[0x21e91] = "dié"; /* ẑ */
dict[0x21e92] = "yōu"; /* Ẓ */
dict[0x21e93] = "qǐ"; /* ẓ */
dict[0x21e94] = "shí"; /* Ẕ */
dict[0x21e95] = "xūn"; /* ẕ */
dict[0x21e96] = "yōu"; /* ẖ */
dict[0x21e97] = "kān"; /* ẗ */
dict[0x21e98] = "qiǎo"; /* ẘ */
dict[0x21e9b] = "qiāng,huà"; /* ẛ */
dict[0x21e9c] = "pén"; /* ẜ */
dict[0x21e9e] = "shí"; /* ẞ */
dict[0x21e9f] = "quán"; /* ẟ */
dict[0x21ea1] = "yíng"; /* ạ */
dict[0x21ea7] = "shā"; /* ầ */
dict[0x21eab] = "tāo"; /* ẫ */
dict[0x21ead] = "hòng"; /* ậ */
dict[0x21eae] = "pǐ"; /* Ắ */
dict[0x21eaf] = "yáo"; /* ắ */
dict[0x21eb2] = "jùn"; /* Ẳ */
dict[0x21eb4] = "tú"; /* Ẵ */
dict[0x21eb5] = "chái"; /* ẵ */
dict[0x21eb7] = "xià"; /* ặ */
dict[0x21eb8] = "qí"; /* Ẹ */
dict[0x21eba] = "qióng"; /* Ẻ */
dict[0x21ebd] = "jìn"; /* ẽ */
dict[0x21ec8] = "zhēn"; /* Ỉ */
dict[0x21ecc] = "zhū"; /* Ọ */
dict[0x21ece] = "xī"; /* Ỏ */
dict[0x21ed0] = "wēng"; /* Ố */
dict[0x21ed1] = "zhǒng"; /* ố */
dict[0x21ed2] = "wù,máo"; /* Ồ */
dict[0x21ed8] = "kē"; /* Ộ */
dict[0x21ed9] = "kuò"; /* ộ */
dict[0x21eda] = "kǎng"; /* Ớ */
dict[0x21edd] = "cháo"; /* ờ */
dict[0x21ede] = "bì"; /* Ở */
dict[0x21edf] = "mò"; /* ở */
dict[0x21ee0] = "zhù"; /* Ỡ */
dict[0x21ee1] = "hàn,yán"; /* ỡ */
dict[0x21ee2] = "yǔ"; /* Ợ */
dict[0x21ee3] = "yí"; /* ợ */
dict[0x21ee4] = "má"; /* Ụ */
dict[0x21ee7] = "qì"; /* ủ */
dict[0x21ee8] = "gùn"; /* Ứ */
dict[0x21ee9] = "màn"; /* ứ */
dict[0x21eea] = "liáo,liù"; /* Ừ */
dict[0x21eeb] = "lín"; /* ừ */
dict[0x21eec] = "zú"; /* Ử */
dict[0x21eed] = "lěi"; /* ử */
dict[0x21eee] = "hù"; /* Ữ */
dict[0x21eef] = "chuǎng"; /* ữ */
dict[0x21ef0] = "qì"; /* Ự */
dict[0x21ef1] = "léi"; /* ự */
dict[0x21f00] = "huà"; /* ἀ */
dict[0x21f01] = "chī"; /* ἁ */
dict[0x21f03] = "pó"; /* ἃ */
dict[0x21f04] = "dié"; /* ἄ */
dict[0x21f0a] = "lěi"; /* Ἂ */
dict[0x21f0e] = "yǐ"; /* Ἆ */
dict[0x21f10] = "mín"; /* ἐ */
dict[0x21f13] = "diàn"; /* ἓ */
dict[0x21f16] = "dūn"; /* ἖ */
dict[0x21f17] = "gāo"; /* ἗ */
dict[0x21f18] = "hū"; /* Ἐ */
dict[0x21f1a] = "xiāo"; /* Ἒ */
dict[0x21f1b] = "gá"; /* Ἓ */
dict[0x21f1c] = "pēng"; /* Ἔ */
dict[0x21f2c] = "shěn"; /* Ἤ */
dict[0x21f31] = "wéi"; /* ἱ */
dict[0x21f3b] = "duì"; /* Ἳ */
dict[0x21f3c] = "cháo"; /* Ἴ */
dict[0x21f3d] = "yǐn"; /* Ἵ */
dict[0x21f3e] = "kuài"; /* Ἶ */
dict[0x21f3f] = "kū"; /* Ἷ */
dict[0x21f41] = "zuì"; /* ὁ */
dict[0x21f42] = "gǔ"; /* ὂ */
dict[0x21f43] = "duò"; /* ὃ */
dict[0x21f45] = "yùn"; /* ὅ */
dict[0x21f46] = "zhì"; /* ὆ */
dict[0x21f49] = "jì"; /* Ὁ */
dict[0x21f4a] = "chēng"; /* Ὂ */
dict[0x21f55] = "zuì"; /* ὕ */
dict[0x21f56] = "xiè"; /* ὖ */
dict[0x21f5b] = "zuǐ"; /* Ὓ */
dict[0x21f5c] = "án"; /* ὜ */
dict[0x21f5d] = "hāo"; /* Ὕ */
dict[0x21f60] = "pǒ"; /* ὠ */
dict[0x21f62] = "dí"; /* ὢ */
dict[0x21f63] = "yè"; /* ὣ */
dict[0x21f67] = "náo"; /* ὧ */
dict[0x21f71] = "jié"; /* ά */
dict[0x21f72] = "bàng"; /* ὲ */
dict[0x21f73] = "lǎn"; /* έ */
dict[0x21f74] = "cáng"; /* ὴ */
dict[0x21f76] = "bì"; /* ὶ */
dict[0x21f7b] = "zhǎn"; /* ύ */
dict[0x21f7c] = "qì"; /* ὼ */
dict[0x21f82] = "náo"; /* ᾂ */
dict[0x21f85] = "lǜ"; /* ᾅ */
dict[0x21f87] = "kuàng"; /* ᾇ */
dict[0x21f89] = "mó"; /* ᾉ */
dict[0x21f8b] = "lěi,léi"; /* ᾋ */
dict[0x21f8c] = "páo"; /* ᾌ */
dict[0x21f92] = "lì"; /* ᾒ */
dict[0x21f93] = "céng"; /* ᾓ */
dict[0x21f95] = "dàng"; /* ᾕ */
dict[0x21f96] = "lěi"; /* ᾖ */
dict[0x21f99] = "è"; /* ᾙ */
dict[0x21f9b] = "bèng"; /* ᾛ */
dict[0x21f9c] = "jué,huò"; /* ᾜ */
dict[0x21f9d] = "huái"; /* ᾝ */
dict[0x21fa5] = "xuán"; /* ᾥ */
dict[0x21fa6] = "niè"; /* ᾦ */
dict[0x21fa8] = "hài"; /* ᾨ */
dict[0x21fae] = "xiǎn"; /* ᾮ */
dict[0x21fb0] = "jiǎn"; /* ᾰ */
dict[0x21fb1] = "mí"; /* ᾱ */
dict[0x21fb2] = "niè"; /* ᾲ */
dict[0x21fbb] = "cáng"; /* Ά */
dict[0x21fbc] = "sǒng"; /* ᾼ */
dict[0x21fbd] = "zēng"; /* ᾽ */
dict[0x21fbe] = "yì"; /* ι */
dict[0x21fc2] = "chóng"; /* ῂ */
dict[0x21fc4] = "cáng"; /* ῄ */
dict[0x21fc9] = "lěi"; /* Έ */
dict[0x21fca] = "nuó"; /* Ὴ */
dict[0x21fcb] = "lì"; /* Ή */
dict[0x21fce] = "lí"; /* ῎ */
dict[0x21fcf] = "luó"; /* ῏ */
dict[0x21fd3] = "tǎng"; /* ΐ */
dict[0x21fd6] = "niè,yà"; /* ῖ */
dict[0x21fd7] = "niè"; /* ῗ */
dict[0x21fd9] = "jī"; /* Ῑ */
dict[0x21fdb] = "lěi"; /* Ί */
dict[0x21fdd] = "nàng"; /* ῝ */
dict[0x21fe0] = "lín"; /* ῠ */
dict[0x21fe1] = "líng"; /* ῡ */
dict[0x21fe4] = "xián"; /* ῤ */
dict[0x21fe5] = "yù"; /* ῥ */
dict[0x21fe7] = "zāi"; /* ῧ */
dict[0x21fe8] = "quǎn"; /* Ῠ */
dict[0x21fe9] = "liè"; /* Ῡ */
dict[0x21fea] = "liè"; /* Ὺ */
dict[0x21fef] = "yù"; /* ` */
dict[0x21ff0] = "huāng"; /* ῰ */
dict[0x21ffa] = "nǎo"; /* Ὼ */
dict[0x21ffc] = "xùn"; /* ῼ */
dict[0x21ffe] = "jú"; /* ῾ */
dict[0x21fff] = "huò"; /* ῿ */
dict[0x22001] = "yì"; /* */
dict[0x2200a] = "xī"; /* */
dict[0x2200b] = "sè"; /* */
dict[0x2200c] = "jiǎo"; /* */
dict[0x2200d] = "yōng"; /* ‍ */
dict[0x22013] = "jù"; /* – */
dict[0x22015] = "shī"; /* ― */
dict[0x22016] = "jīng"; /* ‖ */
dict[0x22017] = "wàn"; /* ‗ */
dict[0x22018] = "yě"; /* ‘ */
dict[0x22019] = "jiū"; /* ’ */
dict[0x2201c] = "gǒng"; /* “ */
dict[0x22021] = "huī,zuǒ"; /* ‡ */
dict[0x2202a] = "ěr"; /* ‪ */
dict[0x22035] = "hàn"; /* ‵ */
dict[0x2203c] = "fú"; /* ‼ */
dict[0x22040] = "fú"; /* ⁀ */
dict[0x22041] = "zhuó"; /* ⁁ */
dict[0x22042] = "jī,jì"; /* ⁂ */
dict[0x2204f] = "bāng"; /* ⁏ */
dict[0x22052] = "qí"; /* ⁒ */
dict[0x22053] = "shǐ,hài"; /* ⁓ */
dict[0x22055] = "diǎo"; /* ⁕ */
dict[0x22056] = "pèi"; /* ⁖ */
dict[0x22057] = "xiǎn,gàn"; /* ⁗ */
dict[0x22058] = "sān"; /* ⁘ */
dict[0x2205d] = "cháng"; /* ⁝ */
dict[0x2205e] = "yuē"; /* ⁞ */
dict[0x22060] = "gōng"; /* ⁠ */
dict[0x22062] = "wū"; /* ⁢ */
dict[0x22064] = "fēn"; /* ⁤ */
dict[0x22065] = "fēn"; /* ⁥ */
dict[0x22067] = "chǎn"; /* ⁧ */
dict[0x22069] = "nèi"; /* ⁩ */
dict[0x2206a] = "jué"; /* ⁪ */
dict[0x2206c] = "zhǎo"; /* ⁬ */
dict[0x2206e] = "qián"; /* ⁮ */
dict[0x22071] = "ǎo"; /* ⁱ */
dict[0x22076] = "wǎng"; /* ⁶ */
dict[0x22077] = "zhōng"; /* ⁷ */
dict[0x22079] = "huāng"; /* ⁹ */
dict[0x2207b] = "bù"; /* ⁻ */
dict[0x2207c] = "zhǔ"; /* ⁼ */
dict[0x2207d] = "bì"; /* ⁽ */
dict[0x2207e] = "chāo"; /* ⁾ */
dict[0x2207f] = "zhēng"; /* ⁿ */
dict[0x22080] = "fú"; /* ₀ */
dict[0x22081] = "kōu,qú"; /* ₁ */
dict[0x22083] = "zuó"; /* ₃ */
dict[0x22084] = "xuàn"; /* ₄ */
dict[0x22086] = "fù"; /* ₆ */
dict[0x2208a] = "yǎo"; /* ₊ */
dict[0x2208d] = "bō"; /* ₍ */
dict[0x2208f] = "bèi"; /* ₏ */
dict[0x22090] = "xié"; /* ₐ */
dict[0x22091] = "shì"; /* ₑ */
dict[0x22092] = "yí"; /* ₒ */
dict[0x22094] = "hóng"; /* ₔ */
dict[0x22095] = "cuì"; /* ₕ */
dict[0x22097] = "yì"; /* ₗ */
dict[0x22098] = "zhuān"; /* ₘ */
dict[0x2209d] = "chì"; /* ₝ */
dict[0x220a4] = "pō,lù"; /* ₤ */
dict[0x220a8] = "yín"; /* ₨ */
dict[0x220b1] = "yuàn"; /* ₱ */
dict[0x220b6] = "jiōng"; /* ₶ */
dict[0x220b7] = "jiá"; /* ₷ */
dict[0x220b9] = "mào"; /* ₹ */
dict[0x220ba] = "qiàn"; /* ₺ */
dict[0x220bc] = "yì"; /* ₼ */
dict[0x220c0] = "wú"; /* ⃀ */
dict[0x220cd] = "bēi"; /* ⃍ */
dict[0x220ce] = "huò"; /* ⃎ */
dict[0x220cf] = "cóng"; /* ⃏ */
dict[0x220d0] = "kōng"; /* ⃐ */
dict[0x220d5] = "tà"; /* ⃕ */
dict[0x220d7] = "hàn"; /* ⃗ */
dict[0x220d8] = "qiàn"; /* ⃘ */
dict[0x220db] = "qí"; /* ⃛ */
dict[0x220dc] = "zhí"; /* ⃜ */
dict[0x220e2] = "sè"; /* ⃢ */
dict[0x220e5] = "qiān"; /* ⃥ */
dict[0x220e6] = "guǒ"; /* ⃦ */
dict[0x220e9] = "gǔn,juǎn"; /* ⃩ */
dict[0x220ec] = "jiān"; /* ⃬ */
dict[0x220ed] = "zhōng"; /* ⃭ */
dict[0x220ee] = "miǎn"; /* ⃮ */
dict[0x220ef] = "guǐ"; /* ⃯ */
dict[0x220f0] = "shì"; /* ⃰ */
dict[0x220f1] = "móu"; /* ⃱ */
dict[0x220f2] = "è"; /* ⃲ */
dict[0x220f3] = "bǎ"; /* ⃳ */
dict[0x220f4] = "là"; /* ⃴ */
dict[0x220f8] = "zhòu"; /* ⃸ */
dict[0x220fa] = "jí"; /* ⃺ */
dict[0x22100] = "zǎo"; /* ℀ */
dict[0x22104] = "zhā"; /* ℄ */
dict[0x22105] = "yì"; /* ℅ */
dict[0x22107] = "gǒu"; /* ℇ */
dict[0x2210a] = "guī"; /* ℊ */
dict[0x2210b] = "yīng"; /* ℋ */
dict[0x2210c] = "shǎi"; /* ℌ */
dict[0x2210d] = "hé,gé"; /* ℍ */
dict[0x2210e] = "bàng"; /* ℎ */
dict[0x2210f] = "mò"; /* ℏ */
dict[0x22110] = "méng"; /* ℐ */
dict[0x22113] = "wù"; /* ℓ */
dict[0x22114] = "dài"; /* ℔ */
dict[0x22117] = "jiǒng"; /* ℗ */
dict[0x2211c] = "hàn"; /* ℜ */
dict[0x2211f] = "tōng"; /* ℟ */
dict[0x22120] = "kōu"; /* ℠ */
dict[0x22121] = "lí"; /* ℡ */
dict[0x22122] = "zhì"; /* ™ */
dict[0x22123] = "huì"; /* ℣ */
dict[0x22124] = "zǎn"; /* ℤ */
dict[0x22125] = "yì"; /* ℥ */
dict[0x22126] = "diǎo"; /* Ω */
dict[0x22127] = "cù"; /* ℧ */
dict[0x22131] = "zhì"; /* ℱ */
dict[0x22133] = "kuǎ"; /* ℳ */
dict[0x22135] = "xiàng"; /* ℵ */
dict[0x22136] = "huà"; /* ℶ */
dict[0x22137] = "liáo"; /* ℷ */
dict[0x22138] = "cuì"; /* ℸ */
dict[0x22139] = "qiāo"; /* ℹ */
dict[0x2213a] = "jiǎo"; /* ℺ */
dict[0x2213c] = "xū"; /* ℼ */
dict[0x2213d] = "èr"; /* ℽ */
dict[0x2213f] = "tuō"; /* ℿ */
dict[0x22140] = "tán"; /* ⅀ */
dict[0x22141] = "zhì"; /* ⅁ */
dict[0x22148] = "nǎo"; /* ⅈ */
dict[0x22149] = "mào"; /* ⅉ */
dict[0x2214a] = "dì"; /* ⅊ */
dict[0x2214b] = "céng"; /* ⅋ */
dict[0x2214e] = "jiǎo"; /* ⅎ */
dict[0x2214f] = "lián"; /* ⅏ */
dict[0x22151] = "shā"; /* ⅑ */
dict[0x22152] = "dàn"; /* ⅒ */
dict[0x22155] = "suì"; /* ⅕ */
dict[0x22157] = "guò"; /* ⅗ */
dict[0x2215a] = "biǎo,biāo"; /* ⅚ */
dict[0x2215c] = "cì"; /* ⅜ */
dict[0x2215d] = "diàn"; /* ⅝ */
dict[0x2215e] = "lǜ"; /* ⅞ */
dict[0x2215f] = "nǐ"; /* ⅟ */
dict[0x22160] = "yǎn"; /* Ⅰ */
dict[0x22161] = "lán"; /* Ⅱ */
dict[0x22164] = "gài"; /* Ⅴ */
dict[0x22165] = "chú"; /* Ⅵ */
dict[0x22169] = "bì"; /* Ⅹ */
dict[0x2216a] = "zú"; /* Ⅺ */
dict[0x2216b] = "huì"; /* Ⅻ */
dict[0x2216d] = "lǎi"; /* Ⅽ */
dict[0x2216e] = "xián"; /* Ⅾ */
dict[0x2216f] = "fèn"; /* Ⅿ */
dict[0x22170] = "hè"; /* ⅰ */
dict[0x22179] = "yào"; /* ⅹ */
dict[0x2217a] = "zhǎn"; /* ⅺ */
dict[0x2217c] = "néi"; /* ⅼ */
dict[0x2217e] = "luǒ"; /* ⅾ */
dict[0x22180] = "yuán"; /* ↀ */
dict[0x22182] = "néng"; /* ↂ */
dict[0x22189] = "rěn"; /* ↉ */
dict[0x2218d] = "chā"; /* ↍ */
dict[0x2219c] = "gé"; /* ↜ */
dict[0x2219e] = "jiǎn"; /* ↞ */
dict[0x2219f] = "píng"; /* ↟ */
dict[0x221a1] = "niān"; /* ↡ */
dict[0x221a3] = "biè"; /* ↣ */
dict[0x221a6] = "jiàn"; /* ↦ */
dict[0x221a9] = "bìng"; /* ↩ */
dict[0x221af] = "mì,xuán"; /* ↯ */
dict[0x221b0] = "hù"; /* ↰ */
dict[0x221b4] = "diǎo"; /* ↴ */
dict[0x221b6] = "yōu,zī"; /* ↶ */
dict[0x221b7] = "yāo,miào"; /* ↷ */
dict[0x221b8] = "bēng"; /* ↸ */
dict[0x221ba] = "chén"; /* ↺ */
dict[0x221bb] = "jī,duì"; /* ↻ */
dict[0x221bd] = "yāo"; /* ↽ */
dict[0x221c5] = "guān"; /* ⇅ */
dict[0x221c7] = "guān"; /* ⇇ */
dict[0x221c8] = "yàn"; /* ⇈ */
dict[0x221d5] = "chǐ"; /* ⇕ */
dict[0x221d7] = "shà"; /* ⇗ */
dict[0x221d8] = "yǎn"; /* ⇘ */
dict[0x221d9] = "yì"; /* ⇙ */
dict[0x221da] = "yì"; /* ⇚ */
dict[0x221db] = "chè,chǐ"; /* ⇛ */
dict[0x221de] = "hàn"; /* ⇞ */
dict[0x221df] = "huāng"; /* ⇟ */
dict[0x221e4] = "shuì"; /* ⇤ */
dict[0x221e5] = "suì"; /* ⇥ */
dict[0x221e6] = "rén"; /* ⇦ */
dict[0x221e7] = "tán"; /* ⇧ */
dict[0x221e8] = "zhǐ"; /* ⇨ */
dict[0x221ea] = "fàn"; /* ⇪ */
dict[0x221eb] = "fěng"; /* ⇫ */
dict[0x221f0] = "tán"; /* ⇰ */
dict[0x221f2] = "mí"; /* ⇲ */
dict[0x221f3] = "pí"; /* ⇳ */
dict[0x221f4] = "bù"; /* ⇴ */
dict[0x221f5] = "nà"; /* ⇵ */
dict[0x221f6] = "tián"; /* ⇶ */
dict[0x221f7] = "bá"; /* ⇷ */
dict[0x221f8] = "yì"; /* ⇸ */
dict[0x22202] = "yǎn"; /* ∂ */
dict[0x22204] = "tiāo"; /* ∄ */
dict[0x22206] = "yáo"; /* ∆ */
dict[0x22207] = "shěn"; /* ∇ */
dict[0x22208] = "kē,wā"; /* ∈ */
dict[0x22209] = "tóng"; /* ∉ */
dict[0x2220b] = "xuǎn"; /* ∋ */
dict[0x22213] = "yòu"; /* ∓ */
dict[0x22215] = "bài"; /* ∕ */
dict[0x22219] = "xiá"; /* ∙ */
dict[0x2221a] = "lǚ"; /* √ */
dict[0x2221b] = "kùn"; /* ∛ */
dict[0x2221c] = "zāng"; /* ∜ */
dict[0x2221d] = "qiú"; /* ∝ */
dict[0x22220] = "cù,là"; /* ∠ */
dict[0x22221] = "zuī"; /* ∡ */
dict[0x22222] = "lǒu"; /* ∢ */
dict[0x22224] = "xiá"; /* ∤ */
dict[0x2222f] = "shēn"; /* ∯ */
dict[0x22232] = "pú"; /* ∲ */
dict[0x22234] = "jīng"; /* ∴ */
dict[0x22235] = "qiāng"; /* ∵ */
dict[0x22236] = "yì,sī"; /* ∶ */
dict[0x22238] = "niè"; /* ∸ */
dict[0x22239] = "duī,tuí"; /* ∹ */
dict[0x2223b] = "jié"; /* ∻ */
dict[0x2223c] = "suì"; /* ∼ */
dict[0x2223d] = "zhàn"; /* ∽ */
dict[0x2223e] = "cōu"; /* ∾ */
dict[0x22241] = "bēng"; /* ≁ */
dict[0x22242] = "guān"; /* ≂ */
dict[0x22243] = "shě"; /* ≃ */
dict[0x22245] = "jìn"; /* ≅ */
dict[0x22246] = "dì"; /* ≆ */
dict[0x22251] = "dān"; /* ≑ */
dict[0x22253] = "nǎi"; /* ≓ */
dict[0x22255] = "nóu"; /* ≕ */
dict[0x22257] = "jí"; /* ≗ */
dict[0x22258] = "yán"; /* ≘ */
dict[0x2225a] = "nòu"; /* ≚ */
dict[0x2225c] = "dù,tú"; /* ≜ */
dict[0x2225d] = "wèi"; /* ≝ */
dict[0x2225e] = "piān"; /* ≞ */
dict[0x22262] = "hú"; /* ≢ */
dict[0x22264] = "jià"; /* ≤ */
dict[0x22265] = "yè"; /* ≥ */
dict[0x22266] = "jǔn"; /* ≦ */
dict[0x22267] = "lán,lián"; /* ≧ */
dict[0x22268] = "là"; /* ≨ */
dict[0x22269] = "yīn"; /* ≩ */
dict[0x2226d] = "tuí"; /* ≭ */
dict[0x22275] = "nǎo"; /* ≵ */
dict[0x2227a] = "zǔ"; /* ≺ */
dict[0x2227f] = "mà"; /* ≿ */
dict[0x22280] = "sī,mà"; /* ⊀ */
dict[0x22281] = "zhì"; /* ⊁ */
dict[0x22284] = "huī"; /* ⊄ */
dict[0x22285] = "zhuì"; /* ⊅ */
dict[0x22286] = "lì"; /* ⊆ */
dict[0x22287] = "huì"; /* ⊇ */
dict[0x2228d] = "chú"; /* ⊍ */
dict[0x2228f] = "chè"; /* ⊏ */
dict[0x22292] = "xiū"; /* ⊒ */
dict[0x22293] = "lán"; /* ⊓ */
dict[0x22295] = "cōng"; /* ⊕ */
dict[0x22296] = "shèn"; /* ⊖ */
dict[0x22297] = "mò"; /* ⊗ */
dict[0x22298] = "yī"; /* ⊘ */
dict[0x22299] = "yáo"; /* ⊙ */
dict[0x2229a] = "xǐ"; /* ⊚ */
dict[0x2229b] = "zuǐ"; /* ⊛ */
dict[0x2229c] = "bìng"; /* ⊜ */
dict[0x222a7] = "yú"; /* ⊧ */
dict[0x222a9] = "lù"; /* ⊩ */
dict[0x222ae] = "tuí"; /* ⊮ */
dict[0x222af] = "wěi"; /* ⊯ */
dict[0x222b1] = "fén"; /* ⊱ */
dict[0x222b2] = "shěn"; /* ⊲ */
dict[0x222ba] = "liù"; /* ⊺ */
dict[0x222bb] = "liáo"; /* ⊻ */
dict[0x222c2] = "shǔ"; /* ⋂ */
dict[0x222c3] = "dǎn"; /* ⋃ */
dict[0x222c4] = "juǎn"; /* ⋄ */
dict[0x222c5] = "yú"; /* ⋅ */
dict[0x222c6] = "xìn"; /* ⋆ */
dict[0x222c7] = "yáo"; /* ⋇ */
dict[0x222d2] = "huó"; /* ⋒ */
dict[0x222d4] = "qiān"; /* ⋔ */
dict[0x222da] = "má"; /* ⋚ */
dict[0x222dd] = "kǎi"; /* ⋝ */
dict[0x222e1] = "lǔ"; /* ⋡ */
dict[0x222e3] = "yōu"; /* ⋣ */
dict[0x222ee] = "xiàn"; /* ⋮ */
dict[0x222f9] = "wú"; /* ⋹ */
dict[0x222fb] = "yǐn"; /* ⋻ */
dict[0x222fc] = "xī"; /* ⋼ */
dict[0x222fe] = "qiáng"; /* ⋾ */
dict[0x222ff] = "zhāi"; /* ⋿ */
dict[0x22300] = "xiè"; /* ⌀ */
dict[0x22304] = "qú"; /* ⌄ */
dict[0x22308] = "lí"; /* ⌈ */
dict[0x2230d] = "qiān"; /* ⌍ */
dict[0x22314] = "líng"; /* ⌔ */
dict[0x22315] = "luán"; /* ⌕ */
dict[0x2231a] = "chān"; /* ⌚ */
dict[0x2231b] = "zhēng"; /* ⌛ */
dict[0x22326] = "zhèng"; /* ⌦ */
dict[0x22328] = "yán"; /* ⌨ */
dict[0x22332] = "yìn"; /* ⌲ */
dict[0x22333] = "kuí"; /* ⌳ */
dict[0x22337] = "qū"; /* ⌷ */
dict[0x22339] = "fú"; /* ⌹ */
dict[0x2233b] = "yù"; /* ⌻ */
dict[0x22341] = "qí,bì"; /* ⍁ */
dict[0x22346] = "qì,qiè"; /* ⍆ */
dict[0x22347] = "jì"; /* ⍇ */
dict[0x22348] = "yuān,zàng"; /* ⍈ */
dict[0x22349] = "qí"; /* ⍉ */
dict[0x2234e] = "gào"; /* ⍎ */
dict[0x2234f] = "juàn"; /* ⍏ */
dict[0x22351] = "qí"; /* ⍑ */
dict[0x22353] = "gǎi"; /* ⍓ */
dict[0x22355] = "quàn"; /* ⍕ */
dict[0x2235a] = "wèi"; /* ⍚ */
dict[0x2235c] = "zūn"; /* ⍜ */
dict[0x22367] = "zhì"; /* ⍧ */
dict[0x22369] = "shèn"; /* ⍩ */
dict[0x2236a] = "dēng"; /* ⍪ */
dict[0x2236b] = "jiǎn"; /* ⍫ */
dict[0x2236d] = "sì"; /* ⍭ */
dict[0x22370] = "yì,zé"; /* ⍰ */
dict[0x22371] = "qiān"; /* ⍱ */
dict[0x2237c] = "lì"; /* ⍼ */
dict[0x2237f] = "zāng"; /* ⍿ */
dict[0x22380] = "yì"; /* ⎀ */
dict[0x22382] = "cái"; /* ⎂ */
dict[0x22383] = "yì"; /* ⎃ */
dict[0x22384] = "gē"; /* ⎄ */
dict[0x22386] = "dié"; /* ⎆ */
dict[0x22388] = "zhī"; /* ⎈ */
dict[0x22389] = "yì"; /* ⎉ */
dict[0x2238b] = "zāi"; /* ⎋ */
dict[0x2238c] = "dài"; /* ⎌ */
dict[0x2238e] = "sù"; /* ⎎ */
dict[0x22394] = "jié"; /* ⎔ */
dict[0x22395] = "chèn"; /* ⎕ */
dict[0x22396] = "qú"; /* ⎖ */
dict[0x22398] = "hàn"; /* ⎘ */
dict[0x22399] = "xián"; /* ⎙ */
dict[0x2239b] = "jié"; /* ⎛ */
dict[0x2239f] = "dàn"; /* ⎟ */
dict[0x223a0] = "quán,juàn"; /* ⎠ */
dict[0x223a1] = "jié"; /* ⎡ */
dict[0x223a5] = "juàn"; /* ⎥ */
dict[0x223aa] = "dàn"; /* ⎪ */
dict[0x223ad] = "jīn"; /* ⎭ */
dict[0x223af] = "yí"; /* ⎯ */
dict[0x223b4] = "bīng"; /* ⎴ */
dict[0x223b5] = "hú"; /* ⎵ */
dict[0x223b9] = "jué"; /* ⎹ */
dict[0x223bb] = "yú"; /* ⎻ */
dict[0x223c3] = "lǐ"; /* ⏃ */
dict[0x223c4] = "qiáng"; /* ⏄ */
dict[0x223c5] = "shuǐ"; /* ⏅ */
dict[0x223c6] = "kū"; /* ⏆ */
dict[0x223c8] = "zhěn"; /* ⏈ */
dict[0x223cd] = "fú"; /* ⏍ */
dict[0x223ce] = "shēn"; /* ⏎ */
dict[0x223d2] = "chuí"; /* ⏒ */
dict[0x223d5] = "tóng"; /* ⏕ */
dict[0x223d7] = "yì"; /* ⏗ */
dict[0x223d9] = "yáng"; /* ⏙ */
dict[0x223dc] = "tuó"; /* ⏜ */
dict[0x223dd] = "zhōu"; /* ⏝ */
dict[0x223de] = "jí"; /* ⏞ */
dict[0x223e4] = "xùn"; /* ⏤ */
dict[0x223e6] = "shěn"; /* ⏦ */
dict[0x223e7] = "xuān"; /* ⏧ */
dict[0x223ed] = "liú"; /* ⏭ */
dict[0x223ee] = "yuān"; /* ⏮ */
dict[0x223ef] = "hú,shǐ"; /* ⏯ */
dict[0x223f0] = "zhèng"; /* ⏰ */
dict[0x223f3] = "pēng,bēng"; /* ⏳ */
dict[0x223f7] = "jué"; /* ⏷ */
dict[0x22402] = "zhì"; /* ␂ */
dict[0x22403] = "piān"; /* ␃ */
dict[0x22404] = "yuàn"; /* ␄ */
dict[0x22406] = "jiān"; /* ␆ */
dict[0x2240a] = "páng"; /* ␊ */
dict[0x2240e] = "zhuàn"; /* ␎ */
dict[0x22410] = "xián"; /* ␐ */
dict[0x22412] = "bēng"; /* ␒ */
dict[0x22414] = "cōng"; /* ␔ */
dict[0x22416] = "mò"; /* ␖ */
dict[0x2241a] = "guó"; /* ␚ */
dict[0x2241e] = "chéng"; /* ␞ */
dict[0x2241f] = "qiāo"; /* ␟ */
dict[0x22426] = "bì"; /* ␦ */
dict[0x22429] = "qiǎng"; /* ␩ */
dict[0x2242b] = "zhōu"; /* ␫ */
dict[0x22432] = "fán"; /* ␲ */
dict[0x22433] = "biē"; /* ␳ */
dict[0x22434] = "fèng"; /* ␴ */
dict[0x2243e] = "bó"; /* ␾ */
dict[0x2243f] = "rǒng"; /* ␿ */
dict[0x22445] = "dǐng"; /* ⑅ */
dict[0x22446] = "quán"; /* ⑆ */
dict[0x22447] = "jiù"; /* ⑇ */
dict[0x22448] = "yáo"; /* ⑈ */
dict[0x2244f] = "yì"; /* ⑏ */
dict[0x22453] = "xiá"; /* ⑓ */
dict[0x22456] = "zǎo"; /* ⑖ */
dict[0x2245a] = "shēn"; /* ⑚ */
dict[0x2245d] = "dān"; /* ⑝ */
dict[0x2245e] = "yì"; /* ⑞ */
dict[0x2245f] = "wǔ"; /* ⑟ */
dict[0x22460] = "tuó"; /* ① */
dict[0x22462] = "hū"; /* ③ */
dict[0x22467] = "xī"; /* ⑧ */
dict[0x2246c] = "lái"; /* ⑬ */
dict[0x2246d] = "wèi"; /* ⑭ */
dict[0x2246e] = "fēi"; /* ⑮ */
dict[0x22471] = "yí"; /* ⑱ */
dict[0x22479] = "hú"; /* ⑹ */
dict[0x22486] = "xiān"; /* ⒆ */
dict[0x22489] = "shǎn"; /* ⒉ */
dict[0x2248d] = "fèi"; /* ⒍ */
dict[0x22490] = "cuò"; /* ⒐ */
dict[0x22492] = "fú"; /* ⒒ */
dict[0x22494] = "chù"; /* ⒔ */
dict[0x2249d] = "diū"; /* ⒝ */
dict[0x2249e] = "làn"; /* ⒞ */
dict[0x224a9] = "xǐ"; /* ⒩ */
dict[0x224ab] = "xún"; /* ⒫ */
dict[0x224af] = "biāo"; /* ⒯ */
dict[0x224b0] = "yù"; /* ⒰ */
dict[0x224b1] = "suì"; /* ⒱ */
dict[0x224b2] = "xǐ"; /* ⒲ */
dict[0x224b7] = "póu"; /* Ⓑ */
dict[0x224be] = "jiào"; /* Ⓘ */
dict[0x224c0] = "yì"; /* Ⓚ */
dict[0x224c3] = "wán"; /* Ⓝ */
dict[0x224c4] = "jǐ"; /* Ⓞ */
dict[0x224c6] = "wán"; /* Ⓠ */
dict[0x224c7] = "tuì,nà"; /* Ⓡ */
dict[0x224c8] = "xùn"; /* Ⓢ */
dict[0x224cb] = "àng"; /* Ⓥ */
dict[0x224cd] = "tiān"; /* Ⓧ */
dict[0x224ce] = "chí"; /* Ⓨ */
dict[0x224d2] = "rán"; /* ⓒ */
dict[0x224d4] = "sà"; /* ⓔ */
dict[0x224d5] = "yín"; /* ⓕ */
dict[0x224d6] = "pī"; /* ⓖ */
dict[0x224d7] = "cǐ"; /* ⓗ */
dict[0x224d8] = "tóng,tāo"; /* ⓘ */
dict[0x224d9] = "yǐn"; /* ⓙ */
dict[0x224dc] = "gé"; /* ⓜ */
dict[0x224dd] = "tiāo"; /* ⓝ */
dict[0x224de] = "zhēng"; /* ⓞ */
dict[0x224df] = "zhòu"; /* ⓟ */
dict[0x224e1] = "yí,tí"; /* ⓡ */
dict[0x224e2] = "kuà"; /* ⓢ */
dict[0x224e3] = "sōng"; /* ⓣ */
dict[0x224e7] = "dì"; /* ⓧ */
dict[0x224ec] = "xié"; /* ⓬ */
dict[0x224ee] = "xiāo"; /* ⓮ */
dict[0x224ef] = "guàng,wǎng"; /* ⓯ */
dict[0x224f0] = "tuǒ"; /* ⓰ */
dict[0x224f1] = "fēng,fèng"; /* ⓱ */
dict[0x224f2] = "wú,hú"; /* ⓲ */
dict[0x224f4] = "tuì"; /* ⓴ */
dict[0x224f5] = "xiù"; /* ⓵ */
dict[0x224ff] = "yóu"; /* ⓿ */
dict[0x22501] = "líng"; /* ━ */
dict[0x22502] = "yàn"; /* │ */
dict[0x22505] = "dōng"; /* ┅ */
dict[0x22506] = "qì"; /* ┆ */
dict[0x22507] = "táo"; /* ┇ */
dict[0x22508] = "hán"; /* ┈ */
dict[0x2250a] = "chí"; /* ┊ */
dict[0x2250b] = "sōng"; /* ┋ */
dict[0x22511] = "quǎn"; /* ┑ */
dict[0x22514] = "hàn,jí"; /* └ */
dict[0x2251f] = "rǒu,niǔ"; /* ┟ */
dict[0x22520] = "qì"; /* ┠ */
dict[0x22521] = "kāi"; /* ┡ */
dict[0x22522] = "yú"; /* ┢ */
dict[0x22523] = "chā,shà"; /* ┣ */
dict[0x22524] = "chèng"; /* ┤ */
dict[0x22525] = "yù"; /* ┥ */
dict[0x22527] = "bìng"; /* ┧ */
dict[0x22529] = "cōng,sǒng"; /* ┩ */
dict[0x2252a] = "zhū"; /* ┪ */
dict[0x2252c] = "yù"; /* ┬ */
dict[0x2252f] = "là"; /* ┯ */
dict[0x22531] = "jué,què"; /* ┱ */
dict[0x22532] = "liù"; /* ┲ */
dict[0x22533] = "sāo"; /* ┳ */
dict[0x22534] = "yù"; /* ┴ */
dict[0x22545] = "shuài"; /* ╅ */
dict[0x22548] = "sǒng"; /* ╈ */
dict[0x2254b] = "yuàn"; /* ╋ */
dict[0x2254e] = "zhāng"; /* ╎ */
dict[0x22551] = "shuài"; /* ║ */
dict[0x22553] = "chǔ"; /* ╓ */
dict[0x22554] = "zhāng,zhàng"; /* ╔ */
dict[0x22555] = "sǎn,sàn"; /* ╕ */
dict[0x22556] = "xiān"; /* ╖ */
dict[0x22558] = "cuī"; /* ╘ */
dict[0x22559] = "měng"; /* ╙ */
dict[0x2255a] = "dí"; /* ╚ */
dict[0x2255e] = "zhì"; /* ╞ */
dict[0x2255f] = "ào"; /* ╟ */
dict[0x22566] = "xiū"; /* ╦ */
dict[0x22568] = "pián"; /* ╨ */
dict[0x2256a] = "jiào"; /* ╪ */
dict[0x2256b] = "kuǎn"; /* ╫ */
dict[0x2256c] = "sà"; /* ╬ */
dict[0x2256d] = "xiàn"; /* ╭ */
dict[0x2256e] = "zhà"; /* ╮ */
dict[0x2256f] = "diàn"; /* ╯ */
dict[0x22577] = "yí"; /* ╷ */
dict[0x2257a] = "huì"; /* ╺ */
dict[0x2257b] = "shàn"; /* ╻ */
dict[0x22584] = "chóng"; /* ▄ */
dict[0x22585] = "yí"; /* ▅ */
dict[0x22586] = "xiè"; /* ▆ */
dict[0x22587] = "zhì"; /* ▇ */
dict[0x22588] = "tiào"; /* █ */
dict[0x2258a] = "pīng"; /* ▊ */
dict[0x2258b] = "xián"; /* ▋ */
dict[0x2258e] = "xiān"; /* ▎ */
dict[0x2258f] = "sù"; /* ▏ */
dict[0x22591] = "cuán"; /* ░ */
dict[0x22597] = "sǒng"; /* ▗ */
dict[0x2259b] = "hēi"; /* ▛ */
dict[0x2259d] = "xiàn"; /* ▝ */
dict[0x2259f] = "yóu"; /* ▟ */
dict[0x225a1] = "yù"; /* □ */
dict[0x225a4] = "tái"; /* ▤ */
dict[0x225a6] = "jué"; /* ▦ */
dict[0x225a7] = "nàng"; /* ▧ */
dict[0x225a9] = "diān"; /* ▩ */
dict[0x225ab] = "yì"; /* ▫ */
dict[0x225ac] = "bì"; /* ▬ */
dict[0x225b2] = "chà"; /* ▲ */
dict[0x225b3] = "xū"; /* △ */
dict[0x225b4] = "yì"; /* ▴ */
dict[0x225b5] = "rù"; /* ▵ */
dict[0x225b7] = "gōng"; /* ▷ */
dict[0x225ba] = "yì"; /* ► */
dict[0x225bb] = "ài"; /* ▻ */
dict[0x225bc] = "tè"; /* ▼ */
dict[0x225bd] = "zhì"; /* ▽ */
dict[0x225bf] = "zhì"; /* ▿ */
dict[0x225c0] = "xīn"; /* ◀ */
dict[0x225c2] = "jì"; /* ◂ */
dict[0x225c4] = "xià"; /* ◄ */
dict[0x225c8] = "zhāo"; /* ◈ */
dict[0x225c9] = "nè"; /* ◉ */
dict[0x225ca] = "xiè,jiá"; /* ◊ */
dict[0x225ce] = "yì"; /* ◎ */
dict[0x225dd] = "dì"; /* ◝ */
dict[0x225eb] = "fǔ"; /* ◫ */
dict[0x225ed] = "shè"; /* ◭ */
dict[0x225ef] = "yuán"; /* ◯ */
dict[0x225f0] = "fǎn"; /* ◰ */
dict[0x225f2] = "fū"; /* ◲ */
dict[0x225f3] = "wù"; /* ◳ */
dict[0x225f4] = "xī"; /* ◴ */
dict[0x225f5] = "hǒng"; /* ◵ */
dict[0x225f9] = "jì"; /* ◹ */
dict[0x225fa] = "chàng"; /* ◺ */
dict[0x225ff] = "mò"; /* ◿ */
dict[0x22600] = "pèi"; /* ☀ */
dict[0x22601] = "xiān"; /* ☁ */
dict[0x22603] = "mú,wǔ"; /* ☃ */
dict[0x22604] = "qiú"; /* ☄ */
dict[0x22605] = "mào,róu"; /* ★ */
dict[0x22607] = "dá,dàn"; /* ☇ */
dict[0x22609] = "xiá"; /* ☉ */
dict[0x2260a] = "shēn"; /* ☊ */
dict[0x2260b] = "tè"; /* ☋ */
dict[0x2260c] = "hóng"; /* ☌ */
dict[0x2260d] = "bì,fú"; /* ☍ */
dict[0x2261f] = "qiáo"; /* ☟ */
dict[0x22625] = "shì"; /* ☥ */
dict[0x22627] = "ruǎn"; /* ☧ */
dict[0x2262b] = "zhèng"; /* ☫ */
dict[0x22638] = "jiàng"; /* ☸ */
dict[0x22639] = "chā"; /* ☹ */
dict[0x2263a] = "mǐ,mí"; /* ☺ */
dict[0x2263d] = "yì"; /* ☽ */
dict[0x2263f] = "suō"; /* ☿ */
dict[0x22641] = "wù"; /* ♁ */
dict[0x22642] = "xuān"; /* ♂ */
dict[0x22645] = "xí"; /* ♅ */
dict[0x22647] = "yǐ"; /* ♇ */
dict[0x22649] = "nǎo"; /* ♉ */
dict[0x22650] = "náo"; /* ♐ */
dict[0x22660] = "yín"; /* ♠ */
dict[0x22662] = "kǒng"; /* ♢ */
dict[0x22667] = "piàn"; /* ♧ */
dict[0x2266e] = "kàn"; /* ♮ */
dict[0x22671] = "lòng"; /* ♱ */
dict[0x22672] = "lǚ"; /* ♲ */
dict[0x22673] = "zhuǎng"; /* ♳ */
dict[0x22674] = "ài"; /* ♴ */
dict[0x2267a] = "zhì"; /* ♺ */
dict[0x2267c] = "xìng"; /* ♼ */
dict[0x2267e] = "gěng"; /* ♾ */
dict[0x2267f] = "jìn"; /* ♿ */
dict[0x22680] = "xiàn"; /* ⚀ */
dict[0x22681] = "jì"; /* ⚁ */
dict[0x22682] = "cuò"; /* ⚂ */
dict[0x22684] = "láo"; /* ⚄ */
dict[0x22685] = "fěn"; /* ⚅ */
dict[0x22686] = "jù"; /* ⚆ */
dict[0x2268b] = "miào"; /* ⚋ */
dict[0x2268c] = "xiá"; /* ⚌ */
dict[0x22691] = "sù"; /* ⚑ */
dict[0x22697] = "sàn"; /* ⚗ */
dict[0x226a8] = "zhì"; /* ⚨ */
dict[0x226aa] = "hù"; /* ⚪ */
dict[0x226ab] = "kòu"; /* ⚫ */
dict[0x226ad] = "suǒ"; /* ⚭ */
dict[0x226ae] = "nì"; /* ⚮ */
dict[0x226ba] = "tēng"; /* ⚺ */
dict[0x226bb] = "zhù"; /* ⚻ */
dict[0x226c1] = "dá,chè"; /* ⛁ */
dict[0x226c3] = "qiú"; /* ⛃ */
dict[0x226c4] = "yà"; /* ⛄ */
dict[0x226c6] = "xián"; /* ⛆ */
dict[0x226c9] = "nèi"; /* ⛉ */
dict[0x226cd] = "zhǐ"; /* ⛍ */
dict[0x226ce] = "bié"; /* ⛎ */
dict[0x226d2] = "chǒng"; /* ⛒ */
dict[0x226d3] = "lán"; /* ⛓ */
dict[0x226d4] = "dōng"; /* ⛔ */
dict[0x226d5] = "qūn"; /* ⛕ */
dict[0x226d6] = "xiàng"; /* ⛖ */
dict[0x226d8] = "xiáo"; /* ⛘ */
dict[0x226d9] = "wǎn"; /* ⛙ */
dict[0x226da] = "rù"; /* ⛚ */
dict[0x226db] = "wàng"; /* ⛛ */
dict[0x226dc] = "nì"; /* ⛜ */
dict[0x226de] = "bāi"; /* ⛞ */
dict[0x226df] = "yà"; /* ⛟ */
dict[0x226e5] = "sī"; /* ⛥ */
dict[0x226e6] = "yǐn"; /* ⛦ */
dict[0x226e8] = "yù"; /* ⛨ */
dict[0x226ee] = "lí"; /* ⛮ */
dict[0x22717] = "bàng"; /* ✗ */
dict[0x22718] = "bèn"; /* ✘ */
dict[0x22723] = "xī"; /* ✣ */
dict[0x22725] = "jiū"; /* ✥ */
dict[0x22728] = "xiè,dié"; /* ✨ */
dict[0x22729] = "qiān"; /* ✩ */
dict[0x2272a] = "nuò,ruò"; /* ✪ */
dict[0x2272b] = "xǐng"; /* ✫ */
dict[0x2272c] = "duó"; /* ✬ */
dict[0x2272d] = "jǐ"; /* ✭ */
dict[0x2272e] = "wǔ"; /* ✮ */
dict[0x2272f] = "mú,móu,mǔ"; /* ✯ */
dict[0x22730] = "yàn,yǎn"; /* ✰ */
dict[0x22731] = "qì"; /* ✱ */
dict[0x22732] = "ná"; /* ✲ */
dict[0x22733] = "chì"; /* ✳ */
dict[0x22734] = "hóu"; /* ✴ */
dict[0x22736] = "sào"; /* ✶ */
dict[0x22738] = "náo"; /* ✸ */
dict[0x2273b] = "chěng"; /* ✻ */
dict[0x2273c] = "chěng"; /* ✼ */
dict[0x2273d] = "kuǐ"; /* ✽ */
dict[0x2273f] = "jià"; /* ✿ */
dict[0x22740] = "tú"; /* ❀ */
dict[0x22742] = "dú"; /* ❂ */
dict[0x22745] = "xiá"; /* ❅ */
dict[0x22746] = "zhòng"; /* ❆ */
dict[0x22747] = "huò"; /* ❇ */
dict[0x22748] = "chóng"; /* ❈ */
dict[0x22749] = "dá"; /* ❉ */
dict[0x2274a] = "yōu"; /* ❊ */
dict[0x2274c] = "mào"; /* ❌ */
dict[0x2274d] = "yào"; /* ❍ */
dict[0x22753] = "juān"; /* ❓ */
dict[0x2276c] = "shì"; /* ❬ */
dict[0x2276f] = "yín"; /* ❯ */
dict[0x22772] = "chóu"; /* ❲ */
dict[0x22773] = "gǔ"; /* ❳ */
dict[0x22774] = "wù"; /* ❴ */
dict[0x22778] = "guò"; /* ❸ */
dict[0x22779] = "tì"; /* ❹ */
dict[0x2277b] = "hōng"; /* ❻ */
dict[0x22787] = "rě"; /* ➇ */
dict[0x22789] = "yí"; /* ➉ */
dict[0x2278b] = "tǔn"; /* ➋ */
dict[0x2278f] = "qióng"; /* ➏ */
dict[0x22790] = "hài"; /* ➐ */
dict[0x22792] = "qì"; /* ➒ */
dict[0x22795] = "huò"; /* ➕ */
dict[0x22796] = "tì"; /* ➖ */
dict[0x22797] = "pī,bī"; /* ➗ */
dict[0x2279a] = "gěng"; /* ➚ */
dict[0x2279c] = "xiè"; /* ➜ */
dict[0x2279e] = "mì,mí"; /* ➞ */
dict[0x2279f] = "gào"; /* ➟ */
dict[0x227a0] = "tā"; /* ➠ */
dict[0x227a1] = "xiǎng"; /* ➡ */
dict[0x227a3] = "shū"; /* ➣ */
dict[0x227a6] = "fú"; /* ➦ */
dict[0x227ac] = "zhuān"; /* ➬ */
dict[0x227ad] = "liù"; /* ➭ */
dict[0x227c5] = "yóu"; /* ⟅ */
dict[0x227ca] = "chěng"; /* ⟊ */
dict[0x227cb] = "duī"; /* ⟋ */
dict[0x227e1] = "bèi"; /* ⟡ */
dict[0x227e2] = "lí"; /* ⟢ */
dict[0x227e3] = "yàng"; /* ⟣ */
dict[0x227e4] = "lí"; /* ⟤ */
dict[0x227e7] = "lǔ"; /* ⟧ */
dict[0x227e8] = "mǔ"; /* ⟨ */
dict[0x227e9] = "suì"; /* ⟩ */
dict[0x227ea] = "ài,xì"; /* ⟪ */
dict[0x227ed] = "kòu"; /* ⟭ */
dict[0x227ef] = "zhé,shì"; /* ⟯ */
dict[0x227f0] = "ài"; /* ⟰ */
dict[0x227f1] = "téng"; /* ⟱ */
dict[0x227f3] = "lǜ"; /* ⟳ */
dict[0x227f4] = "tuí"; /* ⟴ */
dict[0x227f5] = "bī"; /* ⟵ */
dict[0x227fd] = "mù"; /* ⟽ */
dict[0x227fe] = "huì"; /* ⟾ */
dict[0x227ff] = "huán"; /* ⟿ */
dict[0x2281b] = "kuò"; /* ⠛ */
dict[0x2281d] = "xīn"; /* ⠝ */
dict[0x22821] = "sào"; /* ⠡ */
dict[0x2282b] = "shù"; /* ⠫ */
dict[0x2282c] = "què"; /* ⠬ */
dict[0x2282d] = "bā"; /* ⠭ */
dict[0x2282e] = "tuì"; /* ⠮ */
dict[0x22830] = "sǒng"; /* ⠰ */
dict[0x22832] = "fù"; /* ⠲ */
dict[0x22833] = "biē"; /* ⠳ */
dict[0x22835] = "chǎng,tǎng"; /* ⠵ */
dict[0x22837] = "xiàng"; /* ⠷ */
dict[0x22839] = "sī,xī"; /* ⠹ */
dict[0x2283a] = "bó"; /* ⠺ */
dict[0x2283c] = "mái"; /* ⠼ */
dict[0x2283d] = "dàng"; /* ⠽ */
dict[0x2283f] = "guì"; /* ⠿ */
dict[0x22840] = "hēi"; /* ⡀ */
dict[0x22841] = "xī"; /* ⡁ */
dict[0x22842] = "dàng"; /* ⡂ */
dict[0x22843] = "yì"; /* ⡃ */
dict[0x22845] = "bī"; /* ⡅ */
dict[0x22846] = "kěn"; /* ⡆ */
dict[0x22847] = "gū"; /* ⡇ */
dict[0x22848] = "cuì"; /* ⡈ */
dict[0x22849] = "sè"; /* ⡉ */
dict[0x2284d] = "gé"; /* ⡍ */
dict[0x2284e] = "yù"; /* ⡎ */
dict[0x2284f] = "nǎ"; /* ⡏ */
dict[0x22851] = "lì"; /* ⡑ */
dict[0x22852] = "zhì"; /* ⡒ */
dict[0x22870] = "zhào"; /* ⡰ */
dict[0x22874] = "jī"; /* ⡴ */
dict[0x22875] = "ruǎn"; /* ⡵ */
dict[0x22879] = "chòng"; /* ⡹ */
dict[0x22882] = "jié"; /* ⢂ */
dict[0x2288c] = "chàng"; /* ⢌ */
dict[0x2288d] = "zhé"; /* ⢍ */
dict[0x22892] = "sù"; /* ⢒ */
dict[0x22893] = "yōng"; /* ⢓ */
dict[0x22896] = "qì"; /* ⢖ */
dict[0x22897] = "zhuó"; /* ⢗ */
dict[0x2289a] = "kài"; /* ⢚ */
dict[0x2289c] = "yè"; /* ⢜ */
dict[0x2289e] = "qì,jì,kuài"; /* ⢞ */
dict[0x228b9] = "xiòng"; /* ⢹ */
dict[0x228bc] = "biāo"; /* ⢼ */
dict[0x228c9] = "yī"; /* ⣉ */
dict[0x228ca] = "chǒu"; /* ⣊ */
dict[0x228ce] = "tuǎn"; /* ⣎ */
dict[0x228cf] = "ài"; /* ⣏ */
dict[0x228d0] = "pīn"; /* ⣐ */
dict[0x228d3] = "liè"; /* ⣓ */
dict[0x228d4] = "mián"; /* ⣔ */
dict[0x228d5] = "ài,chī"; /* ⣕ */
dict[0x228d7] = "mǒ"; /* ⣗ */
dict[0x228d8] = "wèi"; /* ⣘ */
dict[0x228d9] = "yìng"; /* ⣙ */
dict[0x228da] = "nǐ"; /* ⣚ */
dict[0x228de] = "bó"; /* ⣞ */
dict[0x228e0] = "liù"; /* ⣠ */
dict[0x228e2] = "xié"; /* ⣢ */
dict[0x228f3] = "ruì"; /* ⣳ */
dict[0x228fb] = "lǘ"; /* ⣻ */
dict[0x228fc] = "chá"; /* ⣼ */
dict[0x228ff] = "chù"; /* ⣿ */
dict[0x22901] = "sào"; /* ⤁ */
dict[0x22902] = "lí"; /* ⤂ */
dict[0x22904] = "sōng"; /* ⤄ */
dict[0x22906] = "lì,là"; /* ⤆ */
dict[0x2290b] = "xì"; /* ⤋ */
dict[0x2290d] = "yān"; /* ⤍ */
dict[0x2290e] = "cuō,zuǒ"; /* ⤎ */
dict[0x22910] = "liú"; /* ⤐ */
dict[0x22918] = "méng"; /* ⤘ */
dict[0x2291a] = "zhàn"; /* ⤚ */
dict[0x22924] = "zhuàng"; /* ⤤ */
dict[0x22927] = "miǎo"; /* ⤧ */
dict[0x22929] = "lì"; /* ⤩ */
dict[0x2292b] = "jǔ"; /* ⤫ */
dict[0x2292f] = "xiè"; /* ⤯ */
dict[0x22930] = "xiè"; /* ⤰ */
dict[0x22931] = "lǒng"; /* ⤱ */
dict[0x22932] = "lóng"; /* ⤲ */
dict[0x22942] = "téng"; /* ⥂ */
dict[0x22943] = "zhù"; /* ⥃ */
dict[0x2294b] = "chán"; /* ⥋ */
dict[0x2294c] = "xiǎn"; /* ⥌ */
dict[0x2294f] = "yíng"; /* ⥏ */
dict[0x22950] = "pèi"; /* ⥐ */
dict[0x22958] = "xié"; /* ⥘ */
dict[0x2295a] = "jiào"; /* ⥚ */
dict[0x2295b] = "sè"; /* ⥛ */
dict[0x2295e] = "chōng"; /* ⥞ */
dict[0x22960] = "sǒng"; /* ⥠ */
dict[0x22973] = "hē"; /* ⥳ */
dict[0x2297d] = "tǔn"; /* ⥽ */
dict[0x22985] = "hǒng,zhuàng"; /* ⦅ */
dict[0x22988] = "mán"; /* ⦈ */
dict[0x2298a] = "jīn"; /* ⦊ */
dict[0x2298c] = "qú"; /* ⦌ */
dict[0x2298d] = "dǒu"; /* ⦍ */
dict[0x2298e] = "qiú"; /* ⦎ */
dict[0x2298f] = "zāi"; /* ⦏ */
dict[0x22991] = "shēng"; /* ⦑ */
dict[0x22992] = "zāi"; /* ⦒ */
dict[0x22994] = "zāi"; /* ⦔ */
dict[0x22995] = "yǐ,zhí"; /* ⦕ */
dict[0x2299a] = "huà"; /* ⦚ */
dict[0x2299f] = "kān"; /* ⦟ */
dict[0x229a3] = "yè"; /* ⦣ */
dict[0x229a6] = "róng"; /* ⦦ */
dict[0x229b0] = "yuè"; /* ⦰ */
dict[0x229b1] = "nì"; /* ⦱ */
dict[0x229b2] = "sī"; /* ⦲ */
dict[0x229b4] = "wǒ"; /* ⦴ */
dict[0x229b8] = "cán"; /* ⦸ */
dict[0x229ba] = "jiān"; /* ⦺ */
dict[0x229bc] = "miè"; /* ⦼ */
dict[0x229bd] = "sháo,qī"; /* ⦽ */
dict[0x229bf] = "rǒng"; /* ⦿ */
dict[0x229c0] = "gān"; /* ⧀ */
dict[0x229c4] = "dié"; /* ⧄ */
dict[0x229c5] = "qiáng"; /* ⧅ */
dict[0x229c7] = "shú"; /* ⧇ */
dict[0x229c8] = "zhuó"; /* ⧈ */
dict[0x229cf] = "shī"; /* ⧏ */
dict[0x229d1] = "tì"; /* ⧑ */
dict[0x229d6] = "zhá"; /* ⧖ */
dict[0x229d7] = "zhān"; /* ⧗ */
dict[0x229dc] = "zhì"; /* ⧜ */
dict[0x229dd] = "fèn"; /* ⧝ */
dict[0x229de] = "miè"; /* ⧞ */
dict[0x229e0] = "zè"; /* ⧠ */
dict[0x229e2] = "jǐ"; /* ⧢ */
dict[0x229e4] = "zhì"; /* ⧤ */
dict[0x229e5] = "qiān"; /* ⧥ */
dict[0x229e6] = "hàn"; /* ⧦ */
dict[0x229e7] = "gé"; /* ⧧ */
dict[0x229ee] = "cán"; /* ⧮ */
dict[0x229f0] = "guó"; /* ⧰ */
dict[0x229f1] = "jiāo"; /* ⧱ */
dict[0x229f3] = "yōng"; /* ⧳ */
dict[0x229f4] = "áo"; /* ⧴ */
dict[0x229f5] = "jié"; /* ⧵ */
dict[0x229fb] = "zhá"; /* ⧻ */
dict[0x229fd] = "xì"; /* ⧽ */
dict[0x22a01] = "xū"; /* ⨁ */
dict[0x22a02] = "wǔ"; /* ⨂ */
dict[0x22a0f] = "jué"; /* ⨏ */
dict[0x22a10] = "jī"; /* ⨐ */
dict[0x22a12] = "chì"; /* ⨒ */
dict[0x22a14] = "wǎn"; /* ⨔ */
dict[0x22a16] = "miè"; /* ⨖ */
dict[0x22a17] = "zéi"; /* ⨗ */
dict[0x22a1c] = "jié"; /* ⨜ */
dict[0x22a1d] = "shí"; /* ⨝ */
dict[0x22a1f] = "xī,xì"; /* ⨟ */
dict[0x22a21] = "è"; /* ⨡ */
dict[0x22a25] = "hù"; /* ⨥ */
dict[0x22a26] = "hù"; /* ⨦ */
dict[0x22a28] = "lì"; /* ⨨ */
dict[0x22a2b] = "chù"; /* ⨫ */
dict[0x22a2e] = "yī"; /* ⨮ */
dict[0x22a2f] = "mǎo"; /* ⨯ */
dict[0x22a30] = "xū"; /* ⨰ */
dict[0x22a31] = "zhōng"; /* ⨱ */
dict[0x22a32] = "fáng"; /* ⨲ */
dict[0x22a33] = "yì"; /* ⨳ */
dict[0x22a3a] = "liáo"; /* ⨺ */
dict[0x22a3f] = "jiān"; /* ⨿ */
dict[0x22a40] = "jiǎn"; /* ⩀ */
dict[0x22a41] = "jú"; /* ⩁ */
dict[0x22a44] = "zhù"; /* ⩄ */
dict[0x22a48] = "wǔ"; /* ⩈ */
dict[0x22a4f] = "kè"; /* ⩏ */
dict[0x22a50] = "kě"; /* ⩐ */
dict[0x22a51] = "lì"; /* ⩑ */
dict[0x22a52] = "bǐ"; /* ⩒ */
dict[0x22a53] = "gé"; /* ⩓ */
dict[0x22a55] = "xū"; /* ⩕ */
dict[0x22a56] = "shā"; /* ⩖ */
dict[0x22a57] = "líng"; /* ⩗ */
dict[0x22a58] = "kē"; /* ⩘ */
dict[0x22a5e] = "bó"; /* ⩞ */
dict[0x22a5f] = "biān"; /* ⩟ */
dict[0x22a60] = "shuān"; /* ⩠ */
dict[0x22a61] = "qí"; /* ⩡ */
dict[0x22a62] = "shàn"; /* ⩢ */
dict[0x22a66] = "jī"; /* ⩦ */
dict[0x22a68] = "qiǎo,xiǔ"; /* ⩨ */
dict[0x22a6a] = "liāo"; /* ⩪ */
dict[0x22a6e] = "yì"; /* ⩮ */
dict[0x22a6f] = "jué"; /* ⩯ */
dict[0x22a70] = "zhǎng"; /* ⩰ */
dict[0x22a72] = "xìn"; /* ⩲ */
dict[0x22a77] = "tuō"; /* ⩷ */
dict[0x22a78] = "hài"; /* ⩸ */
dict[0x22a79] = "xià"; /* ⩹ */
dict[0x22a7b] = "tuó"; /* ⩻ */
dict[0x22a7c] = "yí"; /* ⩼ */
dict[0x22a82] = "xuǎn"; /* ⪂ */
dict[0x22a83] = "cù"; /* ⪃ */
dict[0x22a87] = "jiāng"; /* ⪇ */
dict[0x22a88] = "nán"; /* ⪈ */
dict[0x22a8b] = "pěng,féng,bàng"; /* ⪋ */
dict[0x22a8d] = "jié,jiā"; /* ⪍ */
dict[0x22a8e] = "xuē"; /* ⪎ */
dict[0x22a8f] = "hú,gǔ"; /* ⪏ */
dict[0x22a91] = "gài"; /* ⪑ */
dict[0x22aa0] = "chōng"; /* ⪠ */
dict[0x22aa5] = "yǒu"; /* ⪥ */
dict[0x22aa6] = "nǔ"; /* ⪦ */
dict[0x22aa7] = "yè"; /* ⪧ */
dict[0x22aaa] = "yìn"; /* ⪪ */
dict[0x22aac] = "kǒng"; /* ⪬ */
dict[0x22ab1] = "wù"; /* ⪱ */
dict[0x22ab6] = "xiāo"; /* ⪶ */
dict[0x22ab7] = "xiāng"; /* ⪷ */
dict[0x22abc] = "náo"; /* ⪼ */
dict[0x22abe] = "zhàng"; /* ⪾ */
dict[0x22ac6] = "bō"; /* ⫆ */
dict[0x22ac8] = "gū,gǔ"; /* ⫈ */
dict[0x22ad0] = "jié"; /* ⫐ */
dict[0x22ad3] = "nǔ"; /* ⫓ */
dict[0x22ad4] = "shàn,quán"; /* ⫔ */
dict[0x22ad5] = "yǒng"; /* ⫕ */
dict[0x22ad8] = "lú"; /* ⫘ */
dict[0x22ae2] = "jiá"; /* ⫢ */
dict[0x22ae6] = "pāi"; /* ⫦ */
dict[0x22ae7] = "zhǒu"; /* ⫧ */
dict[0x22ae8] = "rǒng,rēng"; /* ⫨ */
dict[0x22ae9] = "hāo"; /* ⫩ */
dict[0x22aeb] = "lù"; /* ⫫ */
dict[0x22aec] = "cuō"; /* ⫬ */
dict[0x22aed] = "nù"; /* ⫭ */
dict[0x22aef] = "bó"; /* ⫯ */
dict[0x22af0] = "zhé"; /* ⫰ */
dict[0x22af2] = "qǐn"; /* ⫲ */
dict[0x22af4] = "cī"; /* ⫴ */
dict[0x22af5] = "zú"; /* ⫵ */
dict[0x22af7] = "wǒ"; /* ⫷ */
dict[0x22af8] = "wǔ,wū"; /* ⫸ */
dict[0x22afb] = "nié"; /* ⫻ */
dict[0x22aff] = "xiān"; /* ⫿ */
dict[0x22b00] = "hóng"; /* ⬀ */
dict[0x22b2b] = "tìng"; /* ⬫ */
dict[0x22b2c] = "jǐn"; /* ⬬ */
dict[0x22b31] = "jié"; /* ⬱ */
dict[0x22b32] = "hè"; /* ⬲ */
dict[0x22b33] = "tū"; /* ⬳ */
dict[0x22b34] = "zhé,niè,dié"; /* ⬴ */
dict[0x22b35] = "pīn,pān,biàn,fān"; /* ⬵ */
dict[0x22b36] = "jìn"; /* ⬶ */
dict[0x22b37] = "nàn"; /* ⬷ */
dict[0x22b3c] = "dùn"; /* ⬼ */
dict[0x22b3e] = "xī"; /* ⬾ */
dict[0x22b3f] = "xiè"; /* ⬿ */
dict[0x22b41] = "xì"; /* ⭁ */
dict[0x22b42] = "láo"; /* ⭂ */
dict[0x22b43] = "duǎn,dòu"; /* ⭃ */
dict[0x22b44] = "jì"; /* ⭄ */
dict[0x22b45] = "chā"; /* ⭅ */
dict[0x22b46] = "chōu"; /* ⭆ */
dict[0x22b48] = "gāng"; /* ⭈ */
dict[0x22b4e] = "xiáng"; /* ⭎ */
dict[0x22b4f] = "dǎo"; /* ⭏ */
dict[0x22b65] = "biàn"; /* ⭥ */
dict[0x22b66] = "xiāo"; /* ⭦ */
dict[0x22b67] = "xīn"; /* ⭧ */
dict[0x22b81] = "yǔ"; /* ⮁ */
dict[0x22b82] = "xián"; /* ⮂ */
dict[0x22b83] = "lí"; /* ⮃ */
dict[0x22b84] = "qiǎn"; /* ⮄ */
dict[0x22b87] = "měi"; /* ⮇ */
dict[0x22b89] = "qiāo"; /* ⮉ */
dict[0x22b8a] = "yà"; /* ⮊ */
dict[0x22b8c] = "qiā,jié"; /* ⮌ */
dict[0x22b8d] = "qiòng"; /* ⮍ */
dict[0x22b8f] = "bàng"; /* ⮏ */
dict[0x22b90] = "zhēng"; /* ⮐ */
dict[0x22b9a] = "zè"; /* ⮚ */
dict[0x22b9b] = "shuàn,tuán"; /* ⮛ */
dict[0x22b9e] = "sào"; /* ⮞ */
dict[0x22bc5] = "lù,jué"; /* ⯅ */
dict[0x22bc9] = "xié"; /* ⯉ */
dict[0x22bcb] = "fǔ"; /* ⯋ */
dict[0x22bcc] = "zhài"; /* ⯌ */
dict[0x22be6] = "lái"; /* ⯦ */
dict[0x22be9] = "zè"; /* ⯩ */
dict[0x22beb] = "duàn,wǎn"; /* ⯫ */
dict[0x22bed] = "dèng"; /* ⯭ */
dict[0x22bee] = "yù"; /* ⯮ */
dict[0x22bf0] = "lǜ"; /* ⯰ */
dict[0x22bf1] = "sōu"; /* ⯱ */
dict[0x22bf2] = "wàn"; /* ⯲ */
dict[0x22bf3] = "xué"; /* ⯳ */
dict[0x22bf4] = "jiǎo"; /* ⯴ */
dict[0x22bf5] = "yuě"; /* ⯵ */
dict[0x22bf6] = "zhì"; /* ⯶ */
dict[0x22bf7] = "wěi,huī"; /* ⯷ */
dict[0x22bf9] = "gé"; /* ⯹ */
dict[0x22bfa] = "jǔ"; /* ⯺ */
dict[0x22bfc] = "yǎn"; /* ⯼ */
dict[0x22bfd] = "cuò"; /* ⯽ */
dict[0x22bfe] = "mào"; /* ⯾ */
dict[0x22c06] = "fú"; /* Ⰶ */
dict[0x22c07] = "āi"; /* Ⰷ */
dict[0x22c0a] = "xuān"; /* Ⰺ */
dict[0x22c0c] = "gāng"; /* Ⰼ */
dict[0x22c0d] = "ān"; /* Ⰽ */
dict[0x22c12] = "jí"; /* Ⱂ */
dict[0x22c18] = "pí"; /* Ⱈ */
dict[0x22c19] = "zhǐ"; /* Ⱉ */
dict[0x22c1c] = "nuó"; /* Ⱌ */
dict[0x22c3f] = "pàn"; /* ⰿ */
dict[0x22c41] = "yí"; /* ⱁ */
dict[0x22c44] = "jié"; /* ⱄ */
dict[0x22c46] = "zī"; /* ⱆ */
dict[0x22c48] = "jià"; /* ⱈ */
dict[0x22c49] = "wǎi"; /* ⱉ */
dict[0x22c4a] = "lüè"; /* ⱊ */
dict[0x22c4c] = "jià"; /* ⱌ */
dict[0x22c5f] = "chǎn,chī"; /* ⱟ */
dict[0x22c61] = "suǒ"; /* ⱡ */
dict[0x22c62] = "suǒ,sè"; /* Ɫ */
dict[0x22c63] = "jí"; /* Ᵽ */
dict[0x22c64] = "sǒng"; /* Ɽ */
dict[0x22c66] = "tī"; /* ⱦ */
dict[0x22c67] = "pī"; /* Ⱨ */
dict[0x22c68] = "pó"; /* ⱨ */
dict[0x22c6e] = "mì"; /* Ɱ */
dict[0x22c74] = "yè"; /* ⱴ */
dict[0x22c76] = "qìn"; /* ⱶ */
dict[0x22c77] = "jìn"; /* ⱷ */
dict[0x22c7a] = "juē"; /* ⱺ */
dict[0x22c7d] = "yuān"; /* ⱽ */
dict[0x22c7e] = "ruán"; /* Ȿ */
dict[0x22c94] = "bàn,bān,pān"; /* Ⲕ */
dict[0x22cab] = "mā"; /* ⲫ */
dict[0x22cb0] = "bīn"; /* Ⲱ */
dict[0x22cb4] = "wèi"; /* Ⲵ */
dict[0x22cb5] = "zào"; /* ⲵ */
dict[0x22cb6] = "qiè"; /* Ⲷ */
dict[0x22cb7] = "ǎo"; /* ⲷ */
dict[0x22cb8] = "lǔ"; /* Ⲹ */
dict[0x22cbc] = "dié"; /* Ⲽ */
dict[0x22cbd] = "chuāi"; /* ⲽ */
dict[0x22cbe] = "bì"; /* Ⲿ */
dict[0x22cbf] = "zhú"; /* ⲿ */
dict[0x22cc0] = "mó,mā"; /* Ⳁ */
dict[0x22cc1] = "fèi"; /* ⳁ */
dict[0x22cc2] = "piē"; /* Ⳃ */
dict[0x22cc3] = "yìn"; /* ⳃ */
dict[0x22cc4] = "xuàn,xuán"; /* Ⳅ */
dict[0x22cc6] = "ào,áo"; /* Ⳇ */
dict[0x22cc7] = "zhuó,zú"; /* ⳇ */
dict[0x22cc8] = "zú"; /* Ⳉ */
dict[0x22ccb] = "bǐ"; /* ⳋ */
dict[0x22cce] = "bài"; /* Ⳏ */
dict[0x22cd1] = "làng"; /* ⳑ */
dict[0x22cd3] = "tì"; /* ⳓ */
dict[0x22cd9] = "tiǎo"; /* ⳙ */
dict[0x22cda] = "jiān"; /* Ⳛ */
dict[0x22cdb] = "zhā"; /* ⳛ */
dict[0x22cdf] = "tǒng"; /* ⳟ */
dict[0x22ce5] = "cāo"; /* ⳥ */
dict[0x22cfd] = "duō"; /* ⳽ */
dict[0x22cfe] = "dòng"; /* ⳾ */
dict[0x22d02] = "biǎn"; /* ⴂ */
dict[0x22d08] = "dá"; /* ⴈ */
dict[0x22d12] = "pēng"; /* ⴒ */
dict[0x22d1a] = "nì"; /* ⴚ */
dict[0x22d20] = "zhì"; /* ⴠ */
dict[0x22d22] = "fén"; /* ⴢ */
dict[0x22d26] = "káng"; /* ⴦ */
dict[0x22d27] = "zhì"; /* ⴧ */
dict[0x22d28] = "zhāi,zhì,chì"; /* ⴨ */
dict[0x22d29] = "bì"; /* ⴩ */
dict[0x22d2a] = "kuǎn"; /* ⴪ */
dict[0x22d2c] = "bàn"; /* ⴬ */
dict[0x22d2d] = "juē"; /* ⴭ */
dict[0x22d2e] = "qū"; /* ⴮ */
dict[0x22d30] = "qī"; /* ⴰ */
dict[0x22d31] = "léi"; /* ⴱ */
dict[0x22d32] = "xié,jié"; /* ⴲ */
dict[0x22d33] = "tāng"; /* ⴳ */
dict[0x22d3c] = "sōu"; /* ⴼ */
dict[0x22d3e] = "bèi"; /* ⴾ */
dict[0x22d47] = "yàng"; /* ⵇ */
dict[0x22d48] = "jiǎn,zhǎn"; /* ⵈ */
dict[0x22d63] = "yā"; /* ⵣ */
dict[0x22d65] = "zào"; /* ⵥ */
dict[0x22d6e] = "lū"; /* ⵮ */
dict[0x22d80] = "chuái,zhuài"; /* ⶀ */
dict[0x22d83] = "fán"; /* ⶃ */
dict[0x22d85] = "shé"; /* ⶅ */
dict[0x22d87] = "qióng"; /* ⶇ */
dict[0x22d89] = "pò"; /* ⶉ */
dict[0x22d8b] = "tiě"; /* ⶋ */
dict[0x22d8c] = "shā"; /* ⶌ */
dict[0x22d8d] = "zá,sà"; /* ⶍ */
dict[0x22d91] = "niǎo"; /* ⶑ */
dict[0x22d92] = "guài"; /* ⶒ */
dict[0x22d93] = "cuǐ"; /* ⶓ */
dict[0x22da1] = "qiào,jiǎo"; /* ⶡ */
dict[0x22da3] = "dié"; /* ⶣ */
dict[0x22db3] = "pīn"; /* ⶳ */
dict[0x22db4] = "cí"; /* ⶴ */
dict[0x22db6] = "bàng"; /* ⶶ */
dict[0x22dc3] = "nào"; /* ⷃ */
dict[0x22dc5] = "lù"; /* ⷅ */
dict[0x22dcd] = "yìn"; /* ⷍ */
dict[0x22dd1] = "xiǎn"; /* ⷑ */
dict[0x22dd4] = "yǐ"; /* ⷔ */
dict[0x22dd5] = "miǎo"; /* ⷕ */
dict[0x22dd6] = "duǎn"; /* ⷖ */
dict[0x22dd7] = "zhòu"; /* ⷗ */
dict[0x22dd9] = "kōng"; /* ⷙ */
dict[0x22de2] = "zhāng"; /* ⷢ */
dict[0x22df6] = "liú"; /* ⷶ */
dict[0x22df8] = "zhǐ"; /* ⷸ */
dict[0x22df9] = "chǎn"; /* ⷹ */
dict[0x22dfa] = "dú"; /* ⷺ */
dict[0x22dfb] = "yuán"; /* ⷻ */
dict[0x22dfe] = "suò,cè"; /* ⷾ */
dict[0x22dff] = "jié"; /* ⷿ */
dict[0x22e00] = "lì"; /* ⸀ */
dict[0x22e01] = "gǒng"; /* ⸁ */
dict[0x22e0c] = "bāng"; /* ⸌ */
dict[0x22e17] = "guó"; /* ⸗ */
dict[0x22e18] = "liáo"; /* ⸘ */
dict[0x22e19] = "shěn"; /* ⸙ */
dict[0x22e23] = "niǎo"; /* ⸣ */
dict[0x22e25] = "cuàn"; /* ⸥ */
dict[0x22e26] = "wěi"; /* ⸦ */
dict[0x22e28] = "tuō"; /* ⸨ */
dict[0x22e2b] = "sū"; /* ⸫ */
dict[0x22e2d] = "lóng"; /* ⸭ */
dict[0x22e34] = "yǎn,yán"; /* ⸴ */
dict[0x22e43] = "qǐng"; /* ⹃ */
dict[0x22e4d] = "xī"; /* ⹍ */
dict[0x22e4e] = "rǎo"; /* ⹎ */
dict[0x22e4f] = "yú"; /* ⹏ */
dict[0x22e51] = "zhèng,zhēng"; /* ⹑ */
dict[0x22e52] = "xiè"; /* ⹒ */
dict[0x22e53] = "chāi"; /* ⹓ */
dict[0x22e54] = "fèn"; /* ⹔ */
dict[0x22e56] = "guó"; /* ⹖ */
dict[0x22e58] = "jǐng"; /* ⹘ */
dict[0x22e59] = "làn"; /* ⹙ */
dict[0x22e5a] = "xiān"; /* ⹚ */
dict[0x22e5d] = "líng"; /* ⹝ */
dict[0x22e65] = "yā"; /* ⹥ */
dict[0x22e6c] = "yǒng"; /* ⹬ */
dict[0x22e6e] = "lěi"; /* ⹮ */
dict[0x22e73] = "xiào"; /* ⹳ */
dict[0x22e7c] = "zá"; /* ⹼ */
dict[0x22e84] = "guān"; /* ⺄ */
dict[0x22e85] = "qiè"; /* ⺅ */
dict[0x22e86] = "luò"; /* ⺆ */
dict[0x22e87] = "yào"; /* ⺇ */
dict[0x22e88] = "luán"; /* ⺈ */
dict[0x22e89] = "tà"; /* ⺉ */
dict[0x22e91] = "luò"; /* ⺑ */
dict[0x22e9e] = "bǎ"; /* ⺞ */
dict[0x22e9f] = "chàn"; /* ⺟ */
dict[0x22ea1] = "zhuó"; /* ⺡ */
dict[0x22eab] = "tiǎo"; /* ⺫ */
dict[0x22eaf] = "wān"; /* ⺯ */
dict[0x22eb0] = "líng,lìng"; /* ⺰ */
dict[0x22eb3] = "mán"; /* ⺳ */
dict[0x22eb4] = "yù"; /* ⺴ */
dict[0x22eb5] = "qì,qǐ"; /* ⺵ */
dict[0x22eb7] = "qí"; /* ⺷ */
dict[0x22ebc] = "jì"; /* ⺼ */
dict[0x22ebd] = "bó,jiào"; /* ⺽ */
dict[0x22ebf] = "shī"; /* ⺿ */
dict[0x22ec0] = "fǔ"; /* ⻀ */
dict[0x22ec2] = "guī"; /* ⻂ */
dict[0x22ec5] = "diǎn"; /* ⻅ */
dict[0x22ec7] = "hāo"; /* ⻇ */
dict[0x22ec9] = "gǎi"; /* ⻉ */
dict[0x22ecb] = "qí"; /* ⻋ */
dict[0x22ed3] = "chéng"; /* ⻓ */
dict[0x22ed4] = "huì"; /* ⻔ */
dict[0x22ed7] = "xiá,guī"; /* ⻗ */
dict[0x22ed8] = "shí"; /* ⻘ */
dict[0x22ed9] = "zhì"; /* ⻙ */
dict[0x22eda] = "qí"; /* ⻚ */
dict[0x22edc] = "hài"; /* ⻜ */
dict[0x22edf] = "jiǎo"; /* ⻟ */
dict[0x22ee0] = "lì"; /* ⻠ */
dict[0x22ee2] = "liǎo"; /* ⻢ */
dict[0x22ee4] = "qiāo,qiáo"; /* ⻤ */
dict[0x22ee8] = "sà"; /* ⻨ */
dict[0x22eea] = "qī"; /* ⻪ */
dict[0x22eeb] = "shī"; /* ⻫ */
dict[0x22eee] = "jié,fú"; /* ⻮ */
dict[0x22ef1] = "shī"; /* ⻱ */
dict[0x22ef2] = "fǔ"; /* ⻲ */
dict[0x22ef5] = "bèi,lù"; /* ⻵ */
dict[0x22ef6] = "biān"; /* ⻶ */
dict[0x22ef7] = "bā"; /* ⻷ */
dict[0x22ef8] = "jūn"; /* ⻸ */
dict[0x22ef9] = "pī"; /* ⻹ */
dict[0x22efc] = "dǎn"; /* ⻼ */
dict[0x22eff] = "táng"; /* ⻿ */
dict[0x22f00] = "kuǐ"; /* ⼀ */
dict[0x22f01] = "kū"; /* ⼁ */
dict[0x22f03] = "kǒu"; /* ⼃ */
dict[0x22f09] = "shī"; /* ⼉ */
dict[0x22f0a] = "shī,tuó"; /* ⼊ */
dict[0x22f0b] = "jī"; /* ⼋ */
dict[0x22f0c] = "bào"; /* ⼌ */
dict[0x22f10] = "kě"; /* ⼐ */
dict[0x22f11] = "kuāng"; /* ⼑ */
dict[0x22f16] = "mǐn"; /* ⼖ */
dict[0x22f19] = "liáo"; /* ⼙ */
dict[0x22f1a] = "è"; /* ⼚ */
dict[0x22f1b] = "gé,guó,è"; /* ⼛ */
dict[0x22f1f] = "wǎng"; /* ⼟ */
dict[0x22f20] = "duó"; /* ⼠ */
dict[0x22f23] = "qià"; /* ⼣ */
dict[0x22f24] = "huá"; /* ⼤ */
dict[0x22f26] = "hǒng"; /* ⼦ */
dict[0x22f29] = "pēng"; /* ⼩ */
dict[0x22f2b] = "jiào"; /* ⼫ */
dict[0x22f30] = "qū"; /* ⼰ */
dict[0x22f31] = "zì"; /* ⼱ */
dict[0x22f32] = "zhòu"; /* ⼲ */
dict[0x22f33] = "kuāng"; /* ⼳ */
dict[0x22f35] = "shā"; /* ⼵ */
dict[0x22f37] = "jì"; /* ⼷ */
dict[0x22f38] = "wēi,wéi"; /* ⼸ */
dict[0x22f39] = "pū,bǔ"; /* ⼹ */
dict[0x22f3a] = "xué"; /* ⼺ */
dict[0x22f3c] = "shāo"; /* ⼼ */
dict[0x22f42] = "láng"; /* ⽂ */
dict[0x22f43] = "zhǐ"; /* ⽃ */
dict[0x22f44] = "tǐng"; /* ⽄ */
dict[0x22f47] = "dà"; /* ⽇ */
dict[0x22f4e] = "hàn"; /* ⽎ */
dict[0x22f55] = "yáng"; /* ⽕ */
dict[0x22f56] = "jìn"; /* ⽖ */
dict[0x22f57] = "zhǐ"; /* ⽗ */
dict[0x22f5a] = "zhuó,dū"; /* ⽚ */
dict[0x22f5c] = "zá"; /* ⽜ */
dict[0x22f5d] = "chán"; /* ⽝ */
dict[0x22f62] = "mào"; /* ⽢ */
dict[0x22f66] = "kōng"; /* ⽦ */
dict[0x22f67] = "zhōu"; /* ⽧ */
dict[0x22f68] = "hū"; /* ⽨ */
dict[0x22f69] = "pēng"; /* ⽩ */
dict[0x22f6d] = "jiù"; /* ⽭ */
dict[0x22f74] = "zhuó"; /* ⽴ */
dict[0x22f78] = "chuò"; /* ⽸ */
dict[0x22f79] = "mǐn"; /* ⽹ */
dict[0x22f80] = "dǔ"; /* ⾀ */
dict[0x22f81] = "wéi"; /* ⾁ */
dict[0x22f83] = "cán"; /* ⾃ */
dict[0x22f84] = "yú"; /* ⾄ */
dict[0x22f85] = "dù"; /* ⾅ */
dict[0x22f86] = "kāi"; /* ⾆ */
dict[0x22f87] = "pì"; /* ⾇ */
dict[0x22f8a] = "chéng"; /* ⾊ */
dict[0x22f8e] = "chǔn"; /* ⾎ */
dict[0x22f90] = "shǎo"; /* ⾐ */
dict[0x22f91] = "yǎn"; /* ⾑ */
dict[0x22f92] = "kuài"; /* ⾒ */
dict[0x22f94] = "yuē"; /* ⾔ */
dict[0x22f9d] = "wéi"; /* ⾝ */
dict[0x22fa6] = "qí"; /* ⾦ */
dict[0x22fa7] = "zhēng"; /* ⾧ */
dict[0x22fa9] = "kè"; /* ⾩ */
dict[0x22faa] = "qí"; /* ⾪ */
dict[0x22fab] = "zhǐ"; /* ⾫ */
dict[0x22fac] = "lù"; /* ⾬ */
dict[0x22fad] = "fū"; /* ⾭ */
dict[0x22fb1] = "pī"; /* ⾱ */
dict[0x22fb2] = "nuò"; /* ⾲ */
dict[0x22fb3] = "pǎo"; /* ⾳ */
dict[0x22fba] = "fěi"; /* ⾺ */
dict[0x22fbf] = "wén"; /* ⾿ */
dict[0x22fc2] = "méng"; /* ⿂ */
dict[0x22fc8] = "shǎn"; /* ⿈ */
dict[0x22fcc] = "xiòng,xuàn"; /* ⿌ */
dict[0x22fce] = "duò"; /* ⿎ */
dict[0x22fcf] = "biào,pāo"; /* ⿏ */
dict[0x22fda] = "yōu"; /* ⿚ */
dict[0x22fdc] = "màn"; /* ⿜ */
dict[0x22fde] = "liǎo"; /* ⿞ */
dict[0x22fe1] = "xié"; /* ⿡ */
dict[0x22fe2] = "luàn"; /* ⿢ */
dict[0x22fe3] = "qiāo"; /* ⿣ */
dict[0x22fe4] = "dèng"; /* ⿤ */
dict[0x22fe6] = "chéng"; /* ⿦ */
dict[0x22fe7] = "chéng"; /* ⿧ */
dict[0x22fed] = "chuò"; /* ⿭ */
dict[0x22ff1] = "sàn"; /* ⿱ */
dict[0x22ff2] = "qiāo"; /* ⿲ */
dict[0x22ff3] = "luàn"; /* ⿳ */
dict[0x22ff8] = "cè"; /* ⿸ */
dict[0x23000] = "léi"; /* */
dict[0x23001] = "zhǎn"; /* 、 */
dict[0x23002] = "lǐ"; /* 。 */
dict[0x23003] = "lián"; /* 〃 */
dict[0x23004] = "qún"; /* 〄 */
dict[0x23006] = "qún"; /* 〆 */
dict[0x2300d] = "chén"; /* 」 */
dict[0x2300f] = "chéng"; /* 』 */
dict[0x23010] = "gū"; /* 【 */
dict[0x23012] = "zòng"; /* 〒 */
dict[0x23013] = "chóu,dǎo"; /* 〓 */
dict[0x23014] = "chuàn,chuò"; /* 〔 */
dict[0x23018] = "chóu"; /* 〘 */
dict[0x2301c] = "lèi"; /* 〜 */
dict[0x2301d] = "shuò"; /* 〝 */
dict[0x2301e] = "lǜ"; /* 〞 */
dict[0x23023] = "fú"; /* 〣 */
dict[0x23025] = "lì"; /* 〥 */
dict[0x23027] = "sàn"; /* 〧 */
dict[0x2302b] = "sān"; /* 〫 */
dict[0x2302f] = "sà"; /* 〯 */
dict[0x23033] = "niè"; /* 〳 */
dict[0x23036] = "zuān"; /* 〶 */
dict[0x23037] = "lǐ,lí"; /* 〷 */
dict[0x2303b] = "shǔ,zhǔ"; /* 〻 */
dict[0x2303e] = "fú"; /* 〾 */
dict[0x23049] = "bì"; /* ぉ */
dict[0x2304d] = "dào"; /* き */
dict[0x23052] = "shī"; /* げ */
dict[0x23056] = "gàn"; /* ざ */
dict[0x23057] = "tàn"; /* し */
dict[0x2305c] = "màn"; /* ぜ */
dict[0x2305f] = "lí"; /* た */
dict[0x23062] = "bì"; /* ぢ */
dict[0x23066] = "pán"; /* て */
dict[0x23068] = "yōu"; /* と */
dict[0x2306d] = "jiū"; /* ね */
dict[0x2306f] = "guō"; /* は */
dict[0x23070] = "liáo"; /* ば */
dict[0x23073] = "wò"; /* び */
dict[0x23074] = "qià"; /* ぴ */
dict[0x23075] = "dǒu"; /* ふ */
dict[0x23077] = "liè"; /* ぷ */
dict[0x23079] = "jiǎo"; /* べ */
dict[0x2307b] = "liè,luō"; /* ほ */
dict[0x23080] = "tiāo"; /* む */
dict[0x23081] = "tiāo,qiāo"; /* め */
dict[0x23084] = "guō"; /* や */
dict[0x23086] = "pāng"; /* ゆ */
dict[0x23087] = "qiāo"; /* ょ */
dict[0x23089] = "dí"; /* ら */
dict[0x2308a] = "yùn"; /* り */
dict[0x23092] = "lè"; /* を */
dict[0x23096] = "sī"; /* ゖ */
dict[0x23097] = "xīn"; /* ゗ */
dict[0x2309c] = "xīn"; /* ゜ */
dict[0x2309d] = "xiàng"; /* ゝ */
dict[0x2309e] = "luǒ"; /* ゞ */
dict[0x230a4] = "bēng"; /* イ */
dict[0x230a5] = "tiāo,qiāo"; /* ゥ */
dict[0x230ac] = "xiào"; /* ガ */
dict[0x230ae] = "dōu,tóu"; /* ギ */
dict[0x230b3] = "dàng"; /* コ */
dict[0x230b4] = "tíng"; /* ゴ */
dict[0x230b5] = "zhuàn"; /* サ */
dict[0x230bb] = "ōu,kōu"; /* セ */
dict[0x230bd] = "wò"; /* ソ */
dict[0x230c4] = "xīn"; /* ツ */
dict[0x230c5] = "ruǎn"; /* ヅ */
dict[0x230c8] = "zhuó"; /* ト */
dict[0x230c9] = "dàng"; /* ド */
dict[0x230cd] = "cuì,chà"; /* ネ */
dict[0x230d1] = "zhuó"; /* パ */
dict[0x230d4] = "duàn"; /* ピ */
dict[0x230d7] = "cóng"; /* プ */
dict[0x230d8] = "chǎn,chuáng"; /* ヘ */
dict[0x230da] = "háng"; /* ペ */
dict[0x230dd] = "yǎng"; /* ポ */
dict[0x230e7] = "yǎn"; /* ョ */
dict[0x230f3] = "yǎn,yè"; /* ン */
dict[0x230f5] = "zhèn,shēn"; /* ヵ */
dict[0x230fd] = "nuǒ"; /* ヽ */
dict[0x230fe] = "yàn"; /* ヾ */
dict[0x23105] = "fǎng"; /* ㄅ */
dict[0x23109] = "yǎn"; /* ㄉ */
dict[0x2310d] = "tí"; /* ㄍ */
dict[0x2310e] = "fù"; /* ㄎ */
dict[0x2310f] = "běn"; /* ㄏ */
dict[0x23111] = "yǎn"; /* ㄑ */
dict[0x23113] = "huī"; /* ㄓ */
dict[0x23119] = "huǎng"; /* ㄙ */
dict[0x2311c] = "guì"; /* ㄜ */
dict[0x2311d] = "yàn"; /* ㄝ */
dict[0x2311f] = "hú"; /* ㄟ */
dict[0x23120] = "biāo"; /* ㄠ */
dict[0x23127] = "suì,wéi"; /* ㄧ */
dict[0x2312e] = "zì"; /* ㄮ */
dict[0x2312f] = "jì"; /* ㄯ */
dict[0x23130] = "ě"; /* ㄰ */
dict[0x23131] = "jì"; /* ㄱ */
dict[0x23132] = "kuǐ"; /* ㄲ */
dict[0x23134] = "liàng"; /* ㄴ */
dict[0x23138] = "huò"; /* ㄸ */
dict[0x2313a] = "wéi"; /* ㄺ */
dict[0x2313b] = "zhuō"; /* ㄻ */
dict[0x2313f] = "tǐng"; /* ㄿ */
dict[0x23143] = "zǎi"; /* ㅃ */
dict[0x23144] = "yòu"; /* ㅄ */
dict[0x23149] = "rèn"; /* ㅉ */
dict[0x2314d] = "miàn,bīng"; /* ㅍ */
dict[0x2315a] = "nà,niǔ"; /* ㅚ */
dict[0x2315c] = "jiē"; /* ㅜ */
dict[0x2315d] = "tū"; /* ㅝ */
dict[0x2315e] = "jué"; /* ㅞ */
dict[0x2315f] = "dān"; /* ㅟ */
dict[0x23161] = "jué"; /* ㅡ */
dict[0x23164] = "xū"; /* ㅤ */
dict[0x23165] = "dī"; /* ㅥ */
dict[0x2316f] = "zhòu"; /* ㅯ */
dict[0x23170] = "xiàng"; /* ㅰ */
dict[0x23172] = "jué"; /* ㅲ */
dict[0x23177] = "xiòng"; /* ㅷ */
dict[0x2317a] = "yǒu"; /* ㅺ */
dict[0x2317b] = "guǎ,jiōng"; /* ㅻ */
dict[0x2317e] = "xī"; /* ㅾ */
dict[0x23188] = "hè"; /* ㆈ */
dict[0x2318d] = "dǐng"; /* ㆍ */
dict[0x23191] = "cè"; /* ㆑ */
dict[0x23192] = "xú"; /* ㆒ */
dict[0x23194] = "zhòu"; /* ㆔ */
dict[0x23195] = "xiàn"; /* ㆕ */
dict[0x23196] = "huāng"; /* ㆖ */
dict[0x23197] = "chā"; /* ㆗ */
dict[0x23198] = "shǐ"; /* ㆘ */
dict[0x23199] = "gàn"; /* ㆙ */
dict[0x2319a] = "nuǒ,chǐ"; /* ㆚ */
dict[0x2319b] = "àn,wǎn"; /* ㆛ */
dict[0x2319f] = "xiē,jiē"; /* ㆟ */
dict[0x231a7] = "hào"; /* ㆧ */
dict[0x231b2] = "qīn"; /* ㆲ */
dict[0x231b3] = "gěng"; /* ㆳ */
dict[0x231b4] = "shān"; /* ㆴ */
dict[0x231b5] = "fú"; /* ㆵ */
dict[0x231bd] = "zè"; /* ㆽ */
dict[0x231d6] = "diǎn"; /* ㇖ */
dict[0x231d7] = "shēn"; /* ㇗ */
dict[0x231d9] = "zǔ"; /* ㇙ */
dict[0x231e2] = "biē"; /* ㇢ */
dict[0x231e6] = "chuí"; /* ㇦ */
dict[0x231e7] = "zhè"; /* ㇧ */
dict[0x231e8] = "dài"; /* ㇨ */
dict[0x231eb] = "wǒ"; /* ㇫ */
dict[0x231ec] = "qióng"; /* ㇬ */
dict[0x231f0] = "lín"; /* ㇰ */
dict[0x231f2] = "hūn"; /* ㇲ */
dict[0x231f3] = "jī"; /* ㇳ */
dict[0x231f5] = "jīng"; /* ㇵ */
dict[0x231f6] = "mò"; /* ㇶ */
dict[0x23205] = "cáo"; /* ㈅ */
dict[0x2320a] = "mù"; /* ㈊ */
dict[0x2320c] = "dū"; /* ㈌ */
dict[0x2320d] = "dié"; /* ㈍ */
dict[0x2320e] = "wèi"; /* ㈎ */
dict[0x23220] = "biàn"; /* ㈠ */
dict[0x23221] = "tǐ"; /* ㈡ */
dict[0x23225] = "tú"; /* ㈥ */
dict[0x23244] = "chí"; /* ㉄ */
dict[0x23245] = "còu"; /* ㉅ */
dict[0x23246] = "tǐ"; /* ㉆ */
dict[0x23252] = "huò"; /* ㉒ */
dict[0x23253] = "qī"; /* ㉓ */
dict[0x23254] = "sāo"; /* ㉔ */
dict[0x23255] = "sàng"; /* ㉕ */
dict[0x23256] = "xuǎn"; /* ㉖ */
dict[0x23257] = "àng"; /* ㉗ */
dict[0x23258] = "nài"; /* ㉘ */
dict[0x2325a] = "yáng"; /* ㉚ */
dict[0x2325b] = "shū"; /* ㉛ */
dict[0x2325c] = "shā"; /* ㉜ */
dict[0x23261] = "tǐng"; /* ㉡ */
dict[0x23269] = "yà"; /* ㉩ */
dict[0x2326a] = "huǎng"; /* ㉪ */
dict[0x2326e] = "bīn"; /* ㉮ */
dict[0x2327e] = "òu"; /* ㉾ */
dict[0x2327f] = "cáo"; /* ㉿ */
dict[0x23281] = "áo"; /* ㊁ */
dict[0x23283] = "mào"; /* ㊃ */
dict[0x23293] = "xiè"; /* ㊓ */
dict[0x23294] = "méng"; /* ㊔ */
dict[0x23296] = "tiān"; /* ㊖ */
dict[0x2329d] = "sàng"; /* ㊝ */
dict[0x2329e] = "xù"; /* ㊞ */
dict[0x2329f] = "kàn"; /* ㊟ */
dict[0x232a7] = "lǎng,zhào"; /* ㊧ */
dict[0x232ab] = "liù"; /* ㊫ */
dict[0x232b6] = "biē"; /* ㊶ */
dict[0x232b7] = "cóng"; /* ㊷ */
dict[0x232ba] = "xián"; /* ㊺ */
dict[0x232c4] = "tūn"; /* ㋄ */
dict[0x232c9] = "yù"; /* ㋉ */
dict[0x232ca] = "dàn"; /* ㋊ */
dict[0x232cb] = "yìng"; /* ㋋ */
dict[0x232cc] = "yè"; /* ㋌ */
dict[0x232cd] = "zhāo"; /* ㋍ */
dict[0x232cf] = "pù"; /* ㋏ */
dict[0x232d8] = "huì"; /* ㋘ */
dict[0x232de] = "ài"; /* ㋞ */
dict[0x232df] = "mǒ"; /* ㋟ */
dict[0x232e2] = "jīng"; /* ㋢ */
dict[0x232e3] = "lán"; /* ㋣ */
dict[0x232f2] = "liè"; /* ㋲ */
dict[0x232f3] = "piǎo,bào"; /* ㋳ */
dict[0x232f5] = "bó"; /* ㋵ */
dict[0x232f6] = "qióng"; /* ㋶ */
dict[0x232f9] = "bì"; /* ㋹ */
dict[0x232ff] = "yōng"; /* ㋿ */
dict[0x23305] = "lì"; /* ㌅ */
dict[0x2330d] = "niè"; /* ㌍ */
dict[0x2330f] = "dé"; /* ㌏ */
dict[0x23313] = "huān"; /* ㌓ */
dict[0x23317] = "yuè"; /* ㌗ */
dict[0x2331a] = "chūn"; /* ㌚ */
dict[0x2331c] = "lì"; /* ㌜ */
dict[0x2331e] = "zhāng"; /* ㌞ */
dict[0x2331f] = "líng"; /* ㌟ */
dict[0x23320] = "chún"; /* ㌠ */
dict[0x23327] = "cè"; /* ㌧ */
dict[0x23328] = "xún"; /* ㌨ */
dict[0x2332c] = "jǔ"; /* ㌬ */
dict[0x2332d] = "hui,dá"; /* ㌭ */
dict[0x2333e] = "tōng"; /* ㌾ */
dict[0x23343] = "yìn"; /* ㍃ */
dict[0x23346] = "níng"; /* ㍆ */
dict[0x23347] = "jù"; /* ㍇ */
dict[0x2334f] = "chà"; /* ㍏ */
dict[0x23350] = "fèi"; /* ㍐ */
dict[0x23356] = "zāo"; /* ㍖ */
dict[0x2335b] = "yù"; /* ㍛ */
dict[0x2335f] = "kěn,wěi"; /* ㍟ */
dict[0x23366] = "kuàng"; /* ㍦ */
dict[0x23367] = "fěi"; /* ㍧ */
dict[0x23374] = "quán"; /* ㍴ */
dict[0x23378] = "pò"; /* ㍸ */
dict[0x2337a] = "pěi"; /* ㍺ */
dict[0x23384] = "gèng"; /* ㎄ */
dict[0x23385] = "yì,huān"; /* ㎅ */
dict[0x2338e] = "líng"; /* ㎎ */
dict[0x23393] = "xuǎn"; /* ㎓ */
dict[0x23394] = "niàn"; /* ㎔ */
dict[0x2339a] = "hú"; /* ㎚ */
dict[0x2339b] = "jú,xuè"; /* ㎛ */
dict[0x2339f] = "xún"; /* ㎟ */
dict[0x233a9] = "yè"; /* ㎩ */
dict[0x233ae] = "xī"; /* ㎮ */
dict[0x233b1] = "yuè"; /* ㎱ */
dict[0x233b2] = "tǎng"; /* ㎲ */
dict[0x233b3] = "pìn"; /* ㎳ */
dict[0x233b4] = "dǔn"; /* ㎴ */
dict[0x233b5] = "bèi,pō"; /* ㎵ */
dict[0x233b8] = "liǎo"; /* ㎸ */
dict[0x233c0] = "yǒng"; /* ㏀ */
dict[0x233c1] = "mǒu"; /* ㏁ */
dict[0x233cc] = "sì"; /* ㏌ */
dict[0x233ce] = "yā"; /* ㏎ */
dict[0x233d1] = "jiǎo"; /* ㏑ */
dict[0x233d4] = "kùn,kǔn"; /* ㏔ */
dict[0x233d6] = "zhèn"; /* ㏖ */
dict[0x233d7] = "shù"; /* ㏗ */
dict[0x233da] = "shí"; /* ㏚ */
dict[0x233de] = "yóu"; /* ㏞ */
dict[0x233df] = "pài"; /* ㏟ */
dict[0x233e0] = "xiáo"; /* ㏠ */
dict[0x233e1] = "jí"; /* ㏡ */
dict[0x233e5] = "lóu"; /* ㏥ */
dict[0x233ea] = "shuāng"; /* ㏪ */
dict[0x233eb] = "pāo"; /* ㏫ */
dict[0x233f6] = "qī"; /* ㏶ */
dict[0x233f7] = "hé"; /* ㏷ */
dict[0x233fa] = "kǒng"; /* ㏺ */
dict[0x23402] = "yè"; /* 㐂 */
dict[0x23403] = "chì"; /* 㐃 */
dict[0x2340a] = "kǎo,jú"; /* 㐊 */
dict[0x2340b] = "yuè"; /* 㐋 */
dict[0x2340e] = "wǎ"; /* 㐎 */
dict[0x2340f] = "niǎn"; /* 㐏 */
dict[0x23411] = "cí"; /* 㐑 */
dict[0x23413] = "yí"; /* 㐓 */
dict[0x23429] = "shēn"; /* 㐩 */
dict[0x2342b] = "yāng"; /* 㐫 */
dict[0x2342c] = "lí"; /* 㐬 */
dict[0x2342e] = "dāi"; /* 㐮 */
dict[0x2342f] = "chóng"; /* 㐯 */
dict[0x23435] = "yí"; /* 㐵 */
dict[0x2343a] = "hàn"; /* 㐺 */
dict[0x2343f] = "yī"; /* 㐿 */
dict[0x23441] = "chòng"; /* 㑁 */
dict[0x23442] = "hù"; /* 㑂 */
dict[0x23443] = "zhuǎ"; /* 㑃 */
dict[0x2344d] = "guǎi"; /* 㑍 */
dict[0x23466] = "qióng"; /* 㑦 */
dict[0x23467] = "duò"; /* 㑧 */
dict[0x2346e] = "nán"; /* 㑮 */
dict[0x2346f] = "táo"; /* 㑯 */
dict[0x23478] = "tóng"; /* 㑸 */
dict[0x23479] = "xiān"; /* 㑹 */
dict[0x2347f] = "fú"; /* 㑿 */
dict[0x23482] = "diàn"; /* 㒂 */
dict[0x23483] = "xí"; /* 㒃 */
dict[0x23484] = "xiē"; /* 㒄 */
dict[0x23485] = "zhèn"; /* 㒅 */
dict[0x23486] = "qiào"; /* 㒆 */
dict[0x23487] = "tū"; /* 㒇 */
dict[0x2348d] = "hé"; /* 㒍 */
dict[0x234b7] = "hàn"; /* 㒷 */
dict[0x234b8] = "kuàng"; /* 㒸 */
dict[0x234b9] = "suō"; /* 㒹 */
dict[0x234bb] = "shòu"; /* 㒻 */
dict[0x234bc] = "tiáo"; /* 㒼 */
dict[0x234c0] = "zhēn,zhěn"; /* 㓀 */
dict[0x234c1] = "kān"; /* 㓁 */
dict[0x234c3] = "nèi"; /* 㓃 */
dict[0x234c5] = "qiǎn"; /* 㓅 */
dict[0x234c6] = "yín"; /* 㓆 */
dict[0x234c8] = "liǎng"; /* 㓈 */
dict[0x234c9] = "shà,jié"; /* 㓉 */
dict[0x234ca] = "zì"; /* 㓊 */
dict[0x234cb] = "pí"; /* 㓋 */
dict[0x234cc] = "gāo,jú"; /* 㓌 */
dict[0x234cf] = "jìn"; /* 㓏 */
dict[0x234d0] = "yóu"; /* 㓐 */
dict[0x234d2] = "shàn"; /* 㓒 */
dict[0x234d4] = "mì"; /* 㓔 */
dict[0x234d5] = "òu"; /* 㓕 */
dict[0x234d7] = "hū"; /* 㓗 */
dict[0x234db] = "yòu"; /* 㓛 */
dict[0x234dd] = "měng"; /* 㓝 */
dict[0x23510] = "zhǐ"; /* 㔐 */
dict[0x23513] = "bǐ"; /* 㔓 */
dict[0x23517] = "shēn"; /* 㔗 */
dict[0x23518] = "qì"; /* 㔘 */
dict[0x23519] = "xiān"; /* 㔙 */
dict[0x2351a] = "pán"; /* 㔚 */
dict[0x2351b] = "kǎng"; /* 㔛 */
dict[0x2352b] = "shuān"; /* 㔫 */
dict[0x2352c] = "pí"; /* 㔬 */
dict[0x2352e] = "zāi"; /* 㔮 */
dict[0x2352f] = "zhǔ"; /* 㔯 */
dict[0x23531] = "sōu,sāo"; /* 㔱 */
dict[0x23532] = "jiǒng"; /* 㔲 */
dict[0x23535] = "chán"; /* 㔵 */
dict[0x23536] = "fán,fàn"; /* 㔶 */
dict[0x23537] = "xiáo"; /* 㔷 */
dict[0x23538] = "yǐn"; /* 㔸 */
dict[0x23539] = "hóu"; /* 㔹 */
dict[0x2353a] = "mào"; /* 㔺 */
dict[0x2353b] = "tú,chán"; /* 㔻 */
dict[0x2353d] = "jì"; /* 㔽 */
dict[0x2353e] = "suì"; /* 㔾 */
dict[0x23541] = "yí"; /* 㕁 */
dict[0x23543] = "yù"; /* 㕃 */
dict[0x23544] = "jiōng"; /* 㕄 */
dict[0x23545] = "pào"; /* 㕅 */
dict[0x23547] = "xiāo"; /* 㕇 */
dict[0x23549] = "gǒu"; /* 㕉 */
dict[0x2354b] = "xiè"; /* 㕋 */
dict[0x2354c] = "gōu"; /* 㕌 */
dict[0x2354d] = "sǔn"; /* 㕍 */
dict[0x2354e] = "xiǎn"; /* 㕎 */
dict[0x2354f] = "zhuǎn"; /* 㕏 */
dict[0x23564] = "zǎo"; /* 㕤 */
dict[0x2357e] = "chóu,bì"; /* 㕾 */
dict[0x23584] = "qiāo"; /* 㖄 */
dict[0x23585] = "tí"; /* 㖅 */
dict[0x23586] = "yún"; /* 㖆 */
dict[0x23589] = "shān"; /* 㖉 */
dict[0x2358a] = "liè,lì"; /* 㖊 */
dict[0x2358c] = "zhǐ"; /* 㖌 */
dict[0x23590] = "pāi"; /* 㖐 */
dict[0x235a3] = "jú"; /* 㖣 */
dict[0x235a4] = "lái"; /* 㖤 */
dict[0x235a8] = "zǐ"; /* 㖨 */
dict[0x235aa] = "qú"; /* 㖪 */
dict[0x235ab] = "gǔ,què"; /* 㖫 */
dict[0x235ac] = "jué"; /* 㖬 */
dict[0x235ad] = "zhí"; /* 㖭 */
dict[0x235ae] = "àng"; /* 㖮 */
dict[0x235af] = "qìn"; /* 㖯 */
dict[0x235b0] = "pí"; /* 㖰 */
dict[0x235b1] = "zuī"; /* 㖱 */
dict[0x235b3] = "qián"; /* 㖳 */
dict[0x235b5] = "cuó"; /* 㖵 */
dict[0x235b7] = "jí"; /* 㖷 */
dict[0x235b8] = "tí"; /* 㖸 */
dict[0x235b9] = "rú"; /* 㖹 */
dict[0x235bb] = "hǎi"; /* 㖻 */
dict[0x235bc] = "xún"; /* 㖼 */
dict[0x235be] = "bèi"; /* 㖾 */
dict[0x235bf] = "zhí"; /* 㖿 */
dict[0x235c1] = "dùn,zā"; /* 㗁 */
dict[0x235d0] = "réng"; /* 㗐 */
dict[0x235ec] = "chòu"; /* 㗬 */
dict[0x235f2] = "gān"; /* 㗲 */
dict[0x235f3] = "shù"; /* 㗳 */
dict[0x235f5] = "gàng,gāng"; /* 㗵 */
dict[0x235f6] = "tà"; /* 㗶 */
dict[0x235f8] = "tuò"; /* 㗸 */
dict[0x235f9] = "yàng"; /* 㗹 */
dict[0x235fa] = "kū"; /* 㗺 */
dict[0x235fb] = "zhì"; /* 㗻 */
dict[0x23616] = "jiān"; /* 㘖 */
dict[0x23617] = "nì"; /* 㘗 */
dict[0x23618] = "shēn,zhēn"; /* 㘘 */
dict[0x23619] = "bàng"; /* 㘙 */
dict[0x2361a] = "shuài"; /* 㘚 */
dict[0x2361b] = "dōu"; /* 㘛 */
dict[0x2361d] = "qiān"; /* 㘝 */
dict[0x2361e] = "hán"; /* 㘞 */
dict[0x2361f] = "qiā"; /* 㘟 */
dict[0x23620] = "gǎn"; /* 㘠 */
dict[0x23623] = "chún"; /* 㘣 */
dict[0x23624] = "chá,sà"; /* 㘤 */
dict[0x23625] = "bì"; /* 㘥 */
dict[0x23626] = "yī"; /* 㘦 */
dict[0x23627] = "fū"; /* 㘧 */
dict[0x23628] = "ě,ē"; /* 㘨 */
dict[0x2362a] = "láo"; /* 㘪 */
dict[0x2362b] = "háo"; /* 㘫 */
dict[0x2362c] = "lí"; /* 㘬 */
dict[0x23631] = "tè"; /* 㘱 */
dict[0x23632] = "shēn"; /* 㘲 */
dict[0x2363b] = "chá,tú"; /* 㘻 */
dict[0x23657] = "niè"; /* 㙗 */
dict[0x23658] = "còu"; /* 㙘 */
dict[0x2365b] = "yí"; /* 㙛 */
dict[0x2365f] = "táng"; /* 㙟 */
dict[0x23662] = "juàn"; /* 㙢 */
dict[0x23670] = "chì"; /* 㙰 */
dict[0x23671] = "gǒu"; /* 㙱 */
dict[0x23674] = "jié"; /* 㙴 */
dict[0x23675] = "zhé"; /* 㙵 */
dict[0x23676] = "hú"; /* 㙶 */
dict[0x23677] = "máng"; /* 㙷 */
dict[0x2367b] = "zōu"; /* 㙻 */
dict[0x2367c] = "sì,cí"; /* 㙼 */
dict[0x2367f] = "fèi"; /* 㙿 */
dict[0x23680] = "zī"; /* 㚀 */
dict[0x23681] = "zī"; /* 㚁 */
dict[0x23683] = "jié"; /* 㚃 */
dict[0x23684] = "sī"; /* 㚄 */
dict[0x23686] = "chūn"; /* 㚆 */
dict[0x23687] = "pào"; /* 㚇 */
dict[0x2368b] = "yé"; /* 㚋 */
dict[0x2368c] = "dī,shì"; /* 㚌 */
dict[0x2368d] = "yì"; /* 㚍 */
dict[0x2368e] = "léi"; /* 㚎 */
dict[0x2368f] = "xū"; /* 㚏 */
dict[0x23690] = "rú"; /* 㚐 */
dict[0x23692] = "pá"; /* 㚒 */
dict[0x23693] = "juàn"; /* 㚓 */
dict[0x23694] = "xì"; /* 㚔 */
dict[0x23695] = "yè,yǎn"; /* 㚕 */
dict[0x23696] = "ān"; /* 㚖 */
dict[0x23698] = "yì"; /* 㚘 */
dict[0x23699] = "jiān,jiàn"; /* 㚙 */
dict[0x2369c] = "sōng"; /* 㚜 */
dict[0x2369d] = "wǒ"; /* 㚝 */
dict[0x2369f] = "sè"; /* 㚟 */
dict[0x236a0] = "zhǐ"; /* 㚠 */
dict[0x236a1] = "bī"; /* 㚡 */
dict[0x236a2] = "zhuàn"; /* 㚢 */
dict[0x236a6] = "jiàng"; /* 㚦 */
dict[0x236a7] = "hào"; /* 㚧 */
dict[0x236a9] = "chì"; /* 㚩 */
dict[0x236aa] = "dùn"; /* 㚪 */
dict[0x236d3] = "bó"; /* 㛓 */
dict[0x236d4] = "jí"; /* 㛔 */
dict[0x236d5] = "chuǎ"; /* 㛕 */
dict[0x236d7] = "luò"; /* 㛗 */
dict[0x236da] = "ruǐ"; /* 㛚 */
dict[0x236eb] = "hú"; /* 㛫 */
dict[0x236ee] = "shēng"; /* 㛮 */
dict[0x236f1] = "dàn,lǎn"; /* 㛱 */
dict[0x236f4] = "hǎn"; /* 㛴 */
dict[0x236f5] = "què"; /* 㛵 */
dict[0x236f6] = "shā"; /* 㛶 */
dict[0x236f7] = "zhǎn"; /* 㛷 */
dict[0x236f8] = "zé"; /* 㛸 */
dict[0x236f9] = "chuán,chuǎi"; /* 㛹 */
dict[0x236fa] = "qī"; /* 㛺 */
dict[0x236fb] = "dié"; /* 㛻 */
dict[0x236fd] = "zhà"; /* 㛽 */
dict[0x236fe] = "tòu"; /* 㛾 */
dict[0x23701] = "cī"; /* 㜁 */
dict[0x23702] = "sà"; /* 㜂 */
dict[0x23704] = "luó"; /* 㜄 */
dict[0x23707] = "jí"; /* 㜇 */
dict[0x23722] = "luǒ"; /* 㜢 */
dict[0x23723] = "qín"; /* 㜣 */
dict[0x23726] = "dào"; /* 㜦 */
dict[0x23727] = "qióng"; /* 㜧 */
dict[0x23728] = "juàn"; /* 㜨 */
dict[0x2372c] = "ài"; /* 㜬 */
dict[0x2372d] = "jiǎn"; /* 㜭 */
dict[0x23739] = "tì"; /* 㜹 */
dict[0x2373a] = "wén"; /* 㜺 */
dict[0x2373d] = "qiāo"; /* 㜽 */
dict[0x23741] = "pái,bēi"; /* 㝁 */
dict[0x23742] = "hún"; /* 㝂 */
dict[0x23745] = "ài"; /* 㝅 */
dict[0x23747] = "shuò"; /* 㝇 */
dict[0x23748] = "lián"; /* 㝈 */
dict[0x23749] = "duì"; /* 㝉 */
dict[0x2374b] = "tà"; /* 㝋 */
dict[0x2374c] = "jǐn"; /* 㝌 */
dict[0x2374d] = "bì"; /* 㝍 */
dict[0x2374e] = "yǎn"; /* 㝎 */
dict[0x2374f] = "gào"; /* 㝏 */
dict[0x23750] = "piáo"; /* 㝐 */
dict[0x23751] = "yù,yú"; /* 㝑 */
dict[0x23752] = "shè"; /* 㝒 */
dict[0x23755] = "jiān"; /* 㝕 */
dict[0x23757] = "hú"; /* 㝗 */
dict[0x2375a] = "liè"; /* 㝚 */
dict[0x2375c] = "biàn"; /* 㝜 */
dict[0x2375d] = "sù"; /* 㝝 */
dict[0x2375e] = "jiāo"; /* 㝞 */
dict[0x23778] = "zhuì"; /* 㝸 */
dict[0x2377c] = "mián"; /* 㝼 */
dict[0x2377d] = "hān"; /* 㝽 */
dict[0x23787] = "dùn"; /* 㞇 */
dict[0x23790] = "xiě"; /* 㞐 */
dict[0x23791] = "méng"; /* 㞑 */
dict[0x23792] = "fū"; /* 㞒 */
dict[0x23793] = "lù"; /* 㞓 */
dict[0x23794] = "tàn"; /* 㞔 */
dict[0x23795] = "yì"; /* 㞕 */
dict[0x23797] = "liú"; /* 㞗 */
dict[0x23798] = "xiān"; /* 㞘 */
dict[0x23799] = "sǎng"; /* 㞙 */
dict[0x2379c] = "còu"; /* 㞜 */
dict[0x2379d] = "zhuāng"; /* 㞝 */
dict[0x2379f] = "chēn"; /* 㞟 */
dict[0x237a4] = "wú"; /* 㞤 */
dict[0x237b0] = "liàn"; /* 㞰 */
dict[0x237b4] = "lí"; /* 㞴 */
dict[0x237c0] = "pèng"; /* 㟀 */
dict[0x237c1] = "tuǒ"; /* 㟁 */
dict[0x237c4] = "tuò"; /* 㟄 */
dict[0x237c6] = "liáo"; /* 㟆 */
dict[0x237c7] = "xiào"; /* 㟇 */
dict[0x237c8] = "chuì"; /* 㟈 */
dict[0x237c9] = "huài"; /* 㟉 */
dict[0x237ca] = "niǎo"; /* 㟊 */
dict[0x237cb] = "qiān"; /* 㟋 */
dict[0x237cc] = "lì"; /* 㟌 */
dict[0x237cf] = "pāo"; /* 㟏 */
dict[0x237d0] = "tiáo"; /* 㟐 */
dict[0x237d1] = "liú"; /* 㟑 */
dict[0x237d2] = "wú"; /* 㟒 */
dict[0x237e4] = "yǐng"; /* 㟤 */
dict[0x237e6] = "zhá"; /* 㟦 */
dict[0x237f0] = "yú"; /* 㟰 */
dict[0x237f2] = "xiǎn"; /* 㟲 */
dict[0x237f3] = "xuán"; /* 㟳 */
dict[0x237f5] = "xī"; /* 㟵 */
dict[0x237f8] = "méi"; /* 㟸 */
dict[0x237f9] = "sēn"; /* 㟹 */
dict[0x237fa] = "liàn"; /* 㟺 */
dict[0x237fc] = "jiū,qiāo"; /* 㟼 */
dict[0x237fd] = "lào"; /* 㟽 */
dict[0x2380e] = "xiāo"; /* 㠎 */
dict[0x2380f] = "zōu"; /* 㠏 */
dict[0x2381a] = "liú"; /* 㠚 */
dict[0x2381c] = "zhào"; /* 㠜 */
dict[0x2381e] = "zhé,shè"; /* 㠞 */
dict[0x23820] = "lěi"; /* 㠠 */
dict[0x2382d] = "duǎn"; /* 㠭 */
dict[0x23837] = "jiǎn"; /* 㠷 */
dict[0x23838] = "shuān"; /* 㠸 */
dict[0x23839] = "zuó"; /* 㠹 */
dict[0x2383a] = "qiè"; /* 㠺 */
dict[0x2383c] = "lǎo"; /* 㠼 */
dict[0x23849] = "yù"; /* 㡉 */
dict[0x2384a] = "yì"; /* 㡊 */
dict[0x2384b] = "nǐ"; /* 㡋 */
dict[0x2384c] = "niè"; /* 㡌 */
dict[0x2384e] = "cén"; /* 㡎 */
dict[0x23855] = "yàn"; /* 㡕 */
dict[0x23857] = "ruǎn"; /* 㡗 */
dict[0x2385e] = "yán"; /* 㡞 */
dict[0x2385f] = "dié"; /* 㡟 */
dict[0x23860] = "mián"; /* 㡠 */
dict[0x23867] = "léi"; /* 㡧 */
dict[0x23869] = "wān"; /* 㡩 */
dict[0x23870] = "nǎ"; /* 㡰 */
dict[0x23876] = "yán"; /* 㡶 */
dict[0x2387a] = "lěi"; /* 㡺 */
dict[0x2387d] = "shā"; /* 㡽 */
dict[0x2387e] = "hū"; /* 㡾 */
dict[0x23881] = "xī"; /* 㢁 */
dict[0x23882] = "xī"; /* 㢂 */
dict[0x23884] = "yǒu,yōu"; /* 㢄 */
dict[0x23885] = "hān"; /* 㢅 */
dict[0x23886] = "jì"; /* 㢆 */
dict[0x23887] = "hāi,xī"; /* 㢇 */
dict[0x23889] = "wā"; /* 㢉 */
dict[0x2388a] = "xù"; /* 㢊 */
dict[0x2388b] = "pī"; /* 㢋 */
dict[0x2388c] = "tān"; /* 㢌 */
dict[0x2388d] = "xī"; /* 㢍 */
dict[0x2388e] = "xī"; /* 㢎 */
dict[0x2388f] = "bīn"; /* 㢏 */
dict[0x23890] = "qīn,kēng"; /* 㢐 */
dict[0x23891] = "xī"; /* 㢑 */
dict[0x23892] = "yú"; /* 㢒 */
dict[0x23893] = "xì"; /* 㢓 */
dict[0x23895] = "cì"; /* 㢕 */
dict[0x23896] = "qiàn"; /* 㢖 */
dict[0x23897] = "xiā"; /* 㢗 */
dict[0x2389a] = "wá"; /* 㢚 */
dict[0x2389b] = "è"; /* 㢛 */
dict[0x2389c] = "yǒu,yōu"; /* 㢜 */
dict[0x2389d] = "xìng"; /* 㢝 */
dict[0x2389e] = "ní"; /* 㢞 */
dict[0x2389f] = "hán,xián"; /* 㢟 */
dict[0x238a0] = "bì"; /* 㢠 */
dict[0x238a1] = "shēng"; /* 㢡 */
dict[0x238a4] = "zhān"; /* 㢤 */
dict[0x238a5] = "diàn"; /* 㢥 */
dict[0x238a6] = "yǔ"; /* 㢦 */
dict[0x238a8] = "ǒu"; /* 㢨 */
dict[0x238aa] = "guǐ"; /* 㢪 */
dict[0x238ab] = "wǎng,wāng"; /* 㢫 */
dict[0x238ac] = "qiān"; /* 㢬 */
dict[0x238ad] = "yí"; /* 㢭 */
dict[0x238b0] = "zú"; /* 㢰 */
dict[0x238b2] = "qiān"; /* 㢲 */
dict[0x238b3] = "dìng"; /* 㢳 */
dict[0x238b4] = "kēng"; /* 㢴 */
dict[0x238b6] = "chù"; /* 㢶 */
dict[0x238b7] = "yī"; /* 㢷 */
dict[0x238ba] = "hān"; /* 㢺 */
dict[0x238bb] = "kuǎn"; /* 㢻 */
dict[0x238c8] = "diàn"; /* 㣈 */
dict[0x238c9] = "xì"; /* 㣉 */
dict[0x238ca] = "zī"; /* 㣊 */
dict[0x238cb] = "líng"; /* 㣋 */
dict[0x238cc] = "zì,sì"; /* 㣌 */
dict[0x238ce] = "yù"; /* 㣎 */
dict[0x238cf] = "hūn"; /* 㣏 */
dict[0x238d1] = "sǐ"; /* 㣑 */
dict[0x238d2] = "kǎn"; /* 㣒 */
dict[0x238da] = "àn"; /* 㣚 */
dict[0x238dc] = "yǒu"; /* 㣜 */
dict[0x238dd] = "jí"; /* 㣝 */
dict[0x238de] = "hùn"; /* 㣞 */
dict[0x238df] = "qiā"; /* 㣟 */
dict[0x238e0] = "hóu"; /* 㣠 */
dict[0x238e1] = "hóu"; /* 㣡 */
dict[0x238e3] = "diàn"; /* 㣣 */
dict[0x238e9] = "xiē"; /* 㣩 */
dict[0x238ed] = "shè"; /* 㣭 */
dict[0x238ee] = "shà"; /* 㣮 */
dict[0x238f2] = "xié"; /* 㣲 */
dict[0x238f3] = "yáo,yǎo"; /* 㣳 */
dict[0x238f4] = "dà"; /* 㣴 */
dict[0x238f5] = "yáo"; /* 㣵 */
dict[0x238f6] = "xiè"; /* 㣶 */
dict[0x238f7] = "chī"; /* 㣷 */
dict[0x238f8] = "yǒu"; /* 㣸 */
dict[0x238f9] = "hē"; /* 㣹 */
dict[0x238fa] = "shà"; /* 㣺 */
dict[0x238ff] = "tái"; /* 㣿 */
dict[0x23901] = "zhú"; /* 㤁 */
dict[0x23903] = "ǎi"; /* 㤃 */
dict[0x23907] = "què"; /* 㤇 */
dict[0x23908] = "zé"; /* 㤈 */
dict[0x2390a] = "lā"; /* 㤊 */
dict[0x2390b] = "lòu"; /* 㤋 */
dict[0x2390c] = "chuài,chǐ,chuò"; /* 㤌 */
dict[0x2390e] = "yǒu"; /* 㤎 */
dict[0x23916] = "tì"; /* 㤖 */
dict[0x23918] = "shī"; /* 㤘 */
dict[0x23921] = "xiào,yǒu"; /* 㤡 */
dict[0x23922] = "xì"; /* 㤢 */
dict[0x23928] = "huò"; /* 㤨 */
dict[0x23929] = "chì"; /* 㤩 */
dict[0x2392a] = "yì"; /* 㤪 */
dict[0x2392d] = "jiān"; /* 㤭 */
dict[0x2392f] = "shú"; /* 㤯 */
dict[0x23930] = "yuè"; /* 㤰 */
dict[0x23931] = "chán"; /* 㤱 */
dict[0x23932] = "è"; /* 㤲 */
dict[0x23933] = "xī"; /* 㤳 */
dict[0x23934] = "xī"; /* 㤴 */
dict[0x23935] = "yǐng"; /* 㤵 */
dict[0x23936] = "zú,zā,zǎn"; /* 㤶 */
dict[0x23937] = "zā"; /* 㤷 */
dict[0x23939] = "jiào"; /* 㤹 */
dict[0x2393a] = "zā"; /* 㤺 */
dict[0x2393f] = "kūn"; /* 㤿 */
dict[0x23942] = "tà"; /* 㥂 */
dict[0x23943] = "wàn"; /* 㥃 */
dict[0x23947] = "xìn"; /* 㥇 */
dict[0x2394a] = "wàng"; /* 㥊 */
dict[0x2394b] = "fǔ"; /* 㥋 */
dict[0x23950] = "lǔ,lǚ"; /* 㥐 */
dict[0x2395e] = "jiǎn"; /* 㥞 */
dict[0x23960] = "tī"; /* 㥠 */
dict[0x23961] = "yán"; /* 㥡 */
dict[0x23963] = "bì"; /* 㥣 */
dict[0x23964] = "kěn"; /* 㥤 */
dict[0x23965] = "guàn"; /* 㥥 */
dict[0x23968] = "zī"; /* 㥨 */
dict[0x2396e] = "kuǐ"; /* 㥮 */
dict[0x2396f] = "zhǒu"; /* 㥯 */
dict[0x23970] = "zhì"; /* 㥰 */
dict[0x23973] = "tú"; /* 㥳 */
dict[0x23976] = "bù"; /* 㥶 */
dict[0x23977] = "tà"; /* 㥷 */
dict[0x23979] = "chù"; /* 㥹 */
dict[0x2397a] = "chēng"; /* 㥺 */
dict[0x2397b] = "chěng"; /* 㥻 */
dict[0x2397c] = "zhù"; /* 㥼 */
dict[0x2397e] = "dà"; /* 㥾 */
dict[0x23987] = "bì"; /* 㦇 */
dict[0x23989] = "jiǎ"; /* 㦉 */
dict[0x2398c] = "yì"; /* 㦌 */
dict[0x2398f] = "yuè"; /* 㦏 */
dict[0x23990] = "gāng"; /* 㦐 */
dict[0x23996] = "gān"; /* 㦖 */
dict[0x2399c] = "qiāo"; /* 㦜 */
dict[0x239a0] = "chú"; /* 㦠 */
dict[0x239a1] = "chú"; /* 㦡 */
dict[0x239a2] = "bì"; /* 㦢 */
dict[0x239a6] = "guì"; /* 㦦 */
dict[0x239a9] = "gǔ"; /* 㦩 */
dict[0x239aa] = "bǐng"; /* 㦪 */
dict[0x239ab] = "yìn"; /* 㦫 */
dict[0x239ac] = "zhuì"; /* 㦬 */
dict[0x239ad] = "gǔ"; /* 㦭 */
dict[0x239af] = "lì"; /* 㦯 */
dict[0x239b5] = "è,zhēn"; /* 㦵 */
dict[0x239b6] = "dǎi"; /* 㦶 */
dict[0x239bc] = "cán"; /* 㦼 */
dict[0x239c2] = "tì"; /* 㧂 */
dict[0x239c3] = "dù"; /* 㧃 */
dict[0x239c4] = "yì"; /* 㧄 */
dict[0x239c8] = "dié"; /* 㧈 */
dict[0x239ca] = "niǔ"; /* 㧊 */
dict[0x239cc] = "xuè"; /* 㧌 */
dict[0x239cd] = "nè"; /* 㧍 */
dict[0x239ce] = "guì"; /* 㧎 */
dict[0x239cf] = "kǎo"; /* 㧏 */
dict[0x239d2] = "chuǎn,mò"; /* 㧒 */
dict[0x239d6] = "zhá"; /* 㧖 */
dict[0x239d7] = "yóu"; /* 㧗 */
dict[0x239d8] = "chuǎn"; /* 㧘 */
dict[0x239d9] = "bài"; /* 㧙 */
dict[0x239da] = "shí"; /* 㧚 */
dict[0x239db] = "diàn"; /* 㧛 */
dict[0x239dc] = "pā"; /* 㧜 */
dict[0x239dd] = "qiú"; /* 㧝 */
dict[0x239e1] = "xuè"; /* 㧡 */
dict[0x239e3] = "mò"; /* 㧣 */
dict[0x239e4] = "kē"; /* 㧤 */
dict[0x239e5] = "yǒu"; /* 㧥 */
dict[0x239e6] = "jiǎo"; /* 㧦 */
dict[0x239e7] = "bó"; /* 㧧 */
dict[0x239ec] = "xiǔ"; /* 㧬 */
dict[0x239f2] = "mǐ"; /* 㧲 */
dict[0x239f3] = "luò"; /* 㧳 */
dict[0x239f5] = "xuè,xù"; /* 㧵 */
dict[0x239f7] = "duò"; /* 㧷 */
dict[0x239f9] = "èr"; /* 㧹 */
dict[0x239fa] = "shān"; /* 㧺 */
dict[0x239fb] = "cán"; /* 㧻 */
dict[0x239fc] = "kuì"; /* 㧼 */
dict[0x239fd] = "nào"; /* 㧽 */
dict[0x239fe] = "miǎn"; /* 㧾 */
dict[0x239ff] = "lì"; /* 㧿 */
dict[0x23a00] = "luàn"; /* 㨀 */
dict[0x23a02] = "dié"; /* 㨂 */
dict[0x23a04] = "qià"; /* 㨄 */
dict[0x23a05] = "lèi"; /* 㨅 */
dict[0x23a07] = "mào"; /* 㨇 */
dict[0x23a09] = "hēng"; /* 㨉 */
dict[0x23a0a] = "chè"; /* 㨊 */
dict[0x23a0b] = "zhì"; /* 㨋 */
dict[0x23a0d] = "gǔ"; /* 㨍 */
dict[0x23a0e] = "cuō"; /* 㨎 */
dict[0x23a13] = "wù"; /* 㨓 */
dict[0x23a14] = "tào"; /* 㨔 */
dict[0x23a17] = "xī"; /* 㨗 */
dict[0x23a18] = "yāo"; /* 㨘 */
dict[0x23a19] = "wěi,wèi"; /* 㨙 */
dict[0x23a1b] = "zú"; /* 㨛 */
dict[0x23a1c] = "mà"; /* 㨜 */
dict[0x23a1d] = "yǔ"; /* 㨝 */
dict[0x23a1e] = "pěng"; /* 㨞 */
dict[0x23a1f] = "yì"; /* 㨟 */
dict[0x23a20] = "qìn,qīn"; /* 㨠 */
dict[0x23a21] = "yuè"; /* 㨡 */
dict[0x23a22] = "juè"; /* 㨢 */
dict[0x23a23] = "jiàng"; /* 㨣 */
dict[0x23a24] = "xù"; /* 㨤 */
dict[0x23a25] = "bēng"; /* 㨥 */
dict[0x23a2a] = "luǒ"; /* 㨪 */
dict[0x23a2b] = "zhuī"; /* 㨫 */
dict[0x23a32] = "dù"; /* 㨲 */
dict[0x23a33] = "xiàng"; /* 㨳 */
dict[0x23a36] = "huì"; /* 㨶 */
dict[0x23a3a] = "gǔ"; /* 㨺 */
dict[0x23a3b] = "kǎo"; /* 㨻 */
dict[0x23a3e] = "xīng"; /* 㨾 */
dict[0x23a3f] = "hún"; /* 㨿 */
dict[0x23a40] = "biān"; /* 㩀 */
dict[0x23a44] = "kè,ài"; /* 㩄 */
dict[0x23a45] = "kǎo"; /* 㩅 */
dict[0x23a48] = "cuó,zuō"; /* 㩈 */
dict[0x23a4f] = "lù"; /* 㩏 */
dict[0x23a51] = "zuì"; /* 㩑 */
dict[0x23a52] = "zāo"; /* 㩒 */
dict[0x23a53] = "jiǎo"; /* 㩓 */
dict[0x23a54] = "guàn"; /* 㩔 */
dict[0x23a59] = "yān"; /* 㩙 */
dict[0x23a5a] = "ér"; /* 㩚 */
dict[0x23a5c] = "qíng"; /* 㩜 */
dict[0x23a5f] = "dèng"; /* 㩟 */
dict[0x23a60] = "sì"; /* 㩠 */
dict[0x23a61] = "suì"; /* 㩡 */
dict[0x23a62] = "liào"; /* 㩢 */
dict[0x23a67] = "shàn"; /* 㩧 */
dict[0x23a69] = "bì"; /* 㩩 */
dict[0x23a6a] = "wèi"; /* 㩪 */
dict[0x23a6b] = "yè"; /* 㩫 */
dict[0x23a6d] = "zhài"; /* 㩭 */
dict[0x23a6f] = "yé"; /* 㩯 */
dict[0x23a70] = "diào"; /* 㩰 */
dict[0x23a71] = "ài,kē"; /* 㩱 */
dict[0x23a74] = "jiàng"; /* 㩴 */
dict[0x23a77] = "sū"; /* 㩷 */
dict[0x23a79] = "huài"; /* 㩹 */
dict[0x23a7a] = "yù"; /* 㩺 */
dict[0x23a7d] = "rǎng"; /* 㩽 */
dict[0x23a80] = "diān"; /* 㪀 */
dict[0x23a81] = "zuān"; /* 㪁 */
dict[0x23a82] = "bān"; /* 㪂 */
dict[0x23a84] = "qín"; /* 㪄 */
dict[0x23a87] = "jiā"; /* 㪇 */
dict[0x23a89] = "pí"; /* 㪉 */
dict[0x23a8c] = "tóu,duì"; /* 㪌 */
dict[0x23a90] = "chóu"; /* 㪐 */
dict[0x23a95] = "guǐ"; /* 㪕 */
dict[0x23a98] = "guǐ"; /* 㪘 */
dict[0x23aa0] = "jī,jì,qì"; /* 㪠 */
dict[0x23aa8] = "xuè"; /* 㪨 */
dict[0x23aaa] = "diàn"; /* 㪪 */
dict[0x23aab] = "diàn"; /* 㪫 */
dict[0x23aad] = "biàn"; /* 㪭 */
dict[0x23aae] = "zǎi"; /* 㪮 */
dict[0x23aaf] = "tóng"; /* 㪯 */
dict[0x23ab6] = "shǎn"; /* 㪶 */
dict[0x23ab8] = "gù"; /* 㪸 */
dict[0x23ab9] = "què"; /* 㪹 */
dict[0x23aba] = "hú"; /* 㪺 */
dict[0x23ac0] = "gǔ"; /* 㫀 */
dict[0x23ac5] = "hú"; /* 㫅 */
dict[0x23ac6] = "shēng"; /* 㫆 */
dict[0x23ac8] = "hú"; /* 㫈 */
dict[0x23ac9] = "kuǎi"; /* 㫉 */
dict[0x23acc] = "gòu"; /* 㫌 */
dict[0x23ace] = "sù"; /* 㫎 */
dict[0x23ad0] = "chóu"; /* 㫐 */
dict[0x23ad2] = "kēng"; /* 㫒 */
dict[0x23ad4] = "dū"; /* 㫔 */
dict[0x23ad9] = "yì"; /* 㫙 */
dict[0x23adc] = "dào"; /* 㫜 */
dict[0x23add] = "qiāng"; /* 㫝 */
dict[0x23ae3] = "lóng"; /* 㫣 */
dict[0x23ae5] = "lí"; /* 㫥 */
dict[0x23ae7] = "lì"; /* 㫧 */
dict[0x23ae8] = "qīng"; /* 㫨 */
dict[0x23aea] = "wēi"; /* 㫪 */
dict[0x23aec] = "móu"; /* 㫬 */
dict[0x23af1] = "qì"; /* 㫱 */
dict[0x23af3] = "jiǎng"; /* 㫳 */
dict[0x23af4] = "xié"; /* 㫴 */
dict[0x23af9] = "dài"; /* 㫹 */
dict[0x23afb] = "lóu"; /* 㫻 */
dict[0x23b02] = "guàn"; /* 㬂 */
dict[0x23b06] = "péi"; /* 㬆 */
dict[0x23b08] = "pí"; /* 㬈 */
dict[0x23b09] = "pí"; /* 㬉 */
dict[0x23b0b] = "juàn,chuò"; /* 㬋 */
dict[0x23b0d] = "bēi"; /* 㬍 */
dict[0x23b0e] = "jué"; /* 㬎 */
dict[0x23b0f] = "juàn"; /* 㬏 */
dict[0x23b10] = "shì"; /* 㬐 */
dict[0x23b15] = "xiě"; /* 㬕 */
dict[0x23b18] = "ruí"; /* 㬘 */
dict[0x23b19] = "jìng"; /* 㬙 */
dict[0x23b1a] = "pò"; /* 㬚 */
dict[0x23b1b] = "sān,shān"; /* 㬛 */
dict[0x23b1d] = "liáo"; /* 㬝 */
dict[0x23b20] = "jī"; /* 㬠 */
dict[0x23b29] = "fēn"; /* 㬩 */
dict[0x23b2a] = "bèi"; /* 㬪 */
dict[0x23b2b] = "jiè,gà"; /* 㬫 */
dict[0x23b2c] = "sā"; /* 㬬 */
dict[0x23b2e] = "pī"; /* 㬮 */
dict[0x23b34] = "dì"; /* 㬴 */
dict[0x23b35] = "máo,mào"; /* 㬵 */
dict[0x23b36] = "ba"; /* 㬶 */
dict[0x23b37] = "ba"; /* 㬷 */
dict[0x23b38] = "tiáo"; /* 㬸 */
dict[0x23b39] = "líng"; /* 㬹 */
dict[0x23b3a] = "shēng"; /* 㬺 */
dict[0x23b3b] = "zhěn"; /* 㬻 */
dict[0x23b3c] = "pī"; /* 㬼 */
dict[0x23b3d] = "wù"; /* 㬽 */
dict[0x23b3f] = "zè"; /* 㬿 */
dict[0x23b40] = "bào"; /* 㭀 */
dict[0x23b47] = "lǚ"; /* 㭇 */
dict[0x23b56] = "hāo"; /* 㭖 */
dict[0x23b57] = "dǒu"; /* 㭗 */
dict[0x23b58] = "fú"; /* 㭘 */
dict[0x23b59] = "ní"; /* 㭙 */
dict[0x23b5d] = "gé"; /* 㭝 */
dict[0x23b60] = "rú"; /* 㭠 */
dict[0x23b6e] = "máo"; /* 㭮 */
dict[0x23b73] = "qiú,qú"; /* 㭳 */
dict[0x23b77] = "bó"; /* 㭷 */
dict[0x23b79] = "hāo"; /* 㭹 */
dict[0x23b7a] = "nǎo"; /* 㭺 */
dict[0x23b7b] = "yán"; /* 㭻 */
dict[0x23b83] = "páo"; /* 㮃 */
dict[0x23b84] = "suī"; /* 㮄 */
dict[0x23b86] = "tuò"; /* 㮆 */
dict[0x23b88] = "qū"; /* 㮈 */
dict[0x23b89] = "lí"; /* 㮉 */
dict[0x23b8a] = "dé"; /* 㮊 */
dict[0x23b8c] = "jié"; /* 㮌 */
dict[0x23b8d] = "jié"; /* 㮍 */
dict[0x23b8e] = "gǔn"; /* 㮎 */
dict[0x23b8f] = "jiān"; /* 㮏 */
dict[0x23b90] = "bì"; /* 㮐 */
dict[0x23ba0] = "sàn"; /* 㮠 */
dict[0x23ba1] = "bāng"; /* 㮡 */
dict[0x23ba2] = "chún"; /* 㮢 */
dict[0x23ba6] = "nài"; /* 㮦 */
dict[0x23ba7] = "bǎng"; /* 㮧 */
dict[0x23baa] = "róng"; /* 㮪 */
dict[0x23bab] = "jiā"; /* 㮫 */
dict[0x23bac] = "sōu"; /* 㮬 */
dict[0x23bb0] = "dé"; /* 㮰 */
dict[0x23bbe] = "xiān"; /* 㮾 */
dict[0x23bbf] = "zhān"; /* 㮿 */
dict[0x23bc0] = "mào"; /* 㯀 */
dict[0x23bc3] = "zī"; /* 㯃 */
dict[0x23bc5] = "jì"; /* 㯅 */
dict[0x23bc6] = "qí"; /* 㯆 */
dict[0x23bcb] = "rù"; /* 㯋 */
dict[0x23bcc] = "suō"; /* 㯌 */
dict[0x23bcd] = "rǒng"; /* 㯍 */
dict[0x23bce] = "wù"; /* 㯎 */
dict[0x23bcf] = "róng,rǒng"; /* 㯏 */
dict[0x23bd0] = "róng"; /* 㯐 */
dict[0x23bda] = "tà"; /* 㯚 */
dict[0x23bdc] = "sōu"; /* 㯜 */
dict[0x23be4] = "lí"; /* 㯤 */
dict[0x23be7] = "cuǐ,suī"; /* 㯧 */
dict[0x23be8] = "zōng"; /* 㯨 */
dict[0x23be9] = "mén"; /* 㯩 */
dict[0x23bea] = "xǐ"; /* 㯪 */
dict[0x23bec] = "mǎng"; /* 㯬 */
dict[0x23bed] = "niè"; /* 㯭 */
dict[0x23bef] = "suī"; /* 㯯 */
dict[0x23bf1] = "péi"; /* 㯱 */
dict[0x23bf4] = "bì"; /* 㯴 */
dict[0x23bf5] = "dì"; /* 㯵 */
dict[0x23bf8] = "qú"; /* 㯸 */
dict[0x23bf9] = "qiáo"; /* 㯹 */
dict[0x23bfb] = "fēn"; /* 㯻 */
dict[0x23bfc] = "sù"; /* 㯼 */
dict[0x23c03] = "xū"; /* 㰃 */
dict[0x23c08] = "jī"; /* 㰈 */
dict[0x23c0b] = "qú"; /* 㰋 */
dict[0x23c0c] = "liè,hé"; /* 㰌 */
dict[0x23c15] = "sào"; /* 㰕 */
dict[0x23c18] = "kùn"; /* 㰘 */
dict[0x23c1a] = "cuì"; /* 㰚 */
dict[0x23c1b] = "yè"; /* 㰛 */
dict[0x23c1c] = "bìng"; /* 㰜 */
dict[0x23c1e] = "jié"; /* 㰞 */
dict[0x23c20] = "qú"; /* 㰠 */
dict[0x23c21] = "qú"; /* 㰡 */
dict[0x23c25] = "méng"; /* 㰥 */
dict[0x23c26] = "rán,gān"; /* 㰦 */
dict[0x23c28] = "bīn"; /* 㰨 */
dict[0x23c29] = "cháo"; /* 㰩 */
dict[0x23c2c] = "dú"; /* 㰬 */
dict[0x23c36] = "ráng,nǎng"; /* 㰶 */
dict[0x23c37] = "xiān"; /* 㰷 */
dict[0x23c3a] = "táo"; /* 㰺 */
dict[0x23c3b] = "qú"; /* 㰻 */
dict[0x23c3c] = "niè"; /* 㰼 */
dict[0x23c3f] = "shū"; /* 㰿 */
dict[0x23c40] = "lǔ"; /* 㱀 */
dict[0x23c42] = "kùn"; /* 㱂 */
dict[0x23c48] = "mín"; /* 㱈 */
dict[0x23c49] = "mǐn"; /* 㱉 */
dict[0x23c4d] = "dàn"; /* 㱍 */
dict[0x23c50] = "yìn,zhì"; /* 㱐 */
dict[0x23c53] = "xiào,hào"; /* 㱓 */
dict[0x23c57] = "jì"; /* 㱗 */
dict[0x23c5c] = "yīn"; /* 㱜 */
dict[0x23c66] = "fēn"; /* 㱦 */
dict[0x23c67] = "zhòng"; /* 㱧 */
dict[0x23c6b] = "gǔ"; /* 㱫 */
dict[0x23c71] = "chá"; /* 㱱 */
dict[0x23c73] = "liú"; /* 㱳 */
dict[0x23c76] = "bǔ"; /* 㱶 */
dict[0x23c7a] = "pā"; /* 㱺 */
dict[0x23c7b] = "sì"; /* 㱻 */
dict[0x23c7c] = "dāo"; /* 㱼 */
dict[0x23c7d] = "zhěn"; /* 㱽 */
dict[0x23c80] = "shān"; /* 㲀 */
dict[0x23c82] = "chuǎi"; /* 㲂 */
dict[0x23c84] = "jiǔ"; /* 㲄 */
dict[0x23c8a] = "kè"; /* 㲊 */
dict[0x23c8b] = "chí"; /* 㲋 */
dict[0x23c91] = "hù,chí,hé,hú"; /* 㲑 */
dict[0x23c92] = "lì,lè"; /* 㲒 */
dict[0x23c93] = "shā"; /* 㲓 */
dict[0x23c96] = "pài,liú,gū"; /* 㲖 */
dict[0x23c97] = "wéi"; /* 㲗 */
dict[0x23c98] = "wǔ"; /* 㲘 */
dict[0x23c9c] = "yíng"; /* 㲜 */
dict[0x23c9d] = "bīng"; /* 㲝 */
dict[0x23ca1] = "shā,jí,jié"; /* 㲡 */
dict[0x23ca2] = "dī"; /* 㲢 */
dict[0x23ca5] = "dān"; /* 㲥 */
dict[0x23ca9] = "pá"; /* 㲩 */
dict[0x23cb1] = "tū"; /* 㲱 */
dict[0x23cb2] = "hé"; /* 㲲 */
dict[0x23cb3] = "pǒ"; /* 㲳 */
dict[0x23cb5] = "zhǐ"; /* 㲵 */
dict[0x23cb6] = "niǔ"; /* 㲶 */
dict[0x23cb7] = "nì"; /* 㲷 */
dict[0x23cbd] = "rǒng"; /* 㲽 */
dict[0x23cbe] = "guài"; /* 㲾 */
dict[0x23cc0] = "zhí"; /* 㳀 */
dict[0x23cc3] = "jí"; /* 㳃 */
dict[0x23cd7] = "hǎi"; /* 㳗 */
dict[0x23cdc] = "fàn"; /* 㳜 */
dict[0x23cdf] = "jié"; /* 㳟 */
dict[0x23ce0] = "hǎi,mǔ"; /* 㳠 */
dict[0x23ce4] = "zhàn"; /* 㳤 */
dict[0x23ce6] = "xì,náo"; /* 㳦 */
dict[0x23ce9] = "zī"; /* 㳩 */
dict[0x23cec] = "xí"; /* 㳬 */
dict[0x23ced] = "piào"; /* 㳭 */
dict[0x23cf0] = "bēn"; /* 㳰 */
dict[0x23cf2] = "jiǎn"; /* 㳲 */
dict[0x23d01] = "xī"; /* 㴁 */
dict[0x23d13] = "jiàn"; /* 㴓 */
dict[0x23d16] = "zá"; /* 㴖 */
dict[0x23d1e] = "bèn"; /* 㴞 */
dict[0x23d1f] = "mào,huǎn"; /* 㴟 */
dict[0x23d22] = "zào"; /* 㴢 */
dict[0x23d23] = "zhuàng"; /* 㴣 */
dict[0x23d25] = "kuáng"; /* 㴥 */
dict[0x23d28] = "bí"; /* 㴨 */
dict[0x23d2a] = "pài,pì"; /* 㴪 */
dict[0x23d37] = "shā"; /* 㴷 */
dict[0x23d3c] = "mào"; /* 㴼 */
dict[0x23d3d] = "tàn"; /* 㴽 */
dict[0x23d5e] = "tǔn"; /* 㵞 */
dict[0x23d5f] = "luǒ"; /* 㵟 */
dict[0x23d62] = "tān"; /* 㵢 */
dict[0x23d71] = "án"; /* 㵱 */
dict[0x23d77] = "hán,gàn"; /* 㵷 */
dict[0x23d78] = "zhú"; /* 㵸 */
dict[0x23d7a] = "duò,tuó"; /* 㵺 */
dict[0x23d7b] = "duò,tuó"; /* 㵻 */
dict[0x23d7c] = "gàn"; /* 㵼 */
dict[0x23d7d] = "wò"; /* 㵽 */
dict[0x23d83] = "cháo"; /* 㶃 */
dict[0x23d86] = "qiòng"; /* 㶆 */
dict[0x23d88] = "wǎng,mǎng"; /* 㶈 */
dict[0x23d8a] = "mò"; /* 㶊 */
dict[0x23d8b] = "zhè"; /* 㶋 */
dict[0x23d8c] = "wěn"; /* 㶌 */
dict[0x23d8d] = "zhuàng"; /* 㶍 */
dict[0x23d8f] = "jiē,diē"; /* 㶏 */
dict[0x23d90] = "pào"; /* 㶐 */
dict[0x23d92] = "yuān"; /* 㶒 */
dict[0x23d98] = "sù"; /* 㶘 */
dict[0x23d9d] = "jù"; /* 㶝 */
dict[0x23da0] = "qī"; /* 㶠 */
dict[0x23da1] = "càn"; /* 㶡 */
dict[0x23da3] = "tuán"; /* 㶣 */
dict[0x23da4] = "shā"; /* 㶤 */
dict[0x23da6] = "tuó"; /* 㶦 */
dict[0x23dde] = "xiè"; /* 㷞 */
dict[0x23de0] = "míng"; /* 㷠 */
dict[0x23de1] = "zhōng"; /* 㷡 */
dict[0x23de5] = "shuò"; /* 㷥 */
dict[0x23de9] = "yì"; /* 㷩 */
dict[0x23dea] = "wǎng"; /* 㷪 */
dict[0x23deb] = "áo"; /* 㷫 */
dict[0x23df6] = "sǔ"; /* 㷶 */
dict[0x23dfe] = "guǐ"; /* 㷾 */
dict[0x23dff] = "tuǒ"; /* 㷿 */
dict[0x23e00] = "huǐ"; /* 㸀 */
dict[0x23e03] = "xù"; /* 㸃 */
dict[0x23e04] = "zǎn"; /* 㸄 */
dict[0x23e06] = "zǐ"; /* 㸆 */
dict[0x23e07] = "biàn"; /* 㸇 */
dict[0x23e08] = "sǒu"; /* 㸈 */
dict[0x23e09] = "dá"; /* 㸉 */
dict[0x23e0a] = "yīn"; /* 㸊 */
dict[0x23e0b] = "quǎn"; /* 㸋 */
dict[0x23e0e] = "huài"; /* 㸎 */
dict[0x23e0f] = "ná"; /* 㸏 */
dict[0x23e10] = "zá"; /* 㸐 */
dict[0x23e12] = "tí"; /* 㸒 */
dict[0x23e18] = "yí"; /* 㸘 */
dict[0x23e19] = "tān"; /* 㸙 */
dict[0x23e1a] = "shé"; /* 㸚 */
dict[0x23e1b] = "shuò"; /* 㸛 */
dict[0x23e1d] = "xíng"; /* 㸝 */
dict[0x23e20] = "yǒu"; /* 㸠 */
dict[0x23e23] = "fén"; /* 㸣 */
dict[0x23e38] = "tiān"; /* 㸸 */
dict[0x23e3c] = "yuán"; /* 㸼 */
dict[0x23e47] = "kè"; /* 㹇 */
dict[0x23e4b] = "fú"; /* 㹋 */
dict[0x23e52] = "mǐn"; /* 㹒 */
dict[0x23e55] = "lǜ"; /* 㹕 */
dict[0x23e5a] = "pì"; /* 㹚 */
dict[0x23e5c] = "jí"; /* 㹜 */
dict[0x23e5d] = "qiào,xiào"; /* 㹝 */
dict[0x23e5e] = "zhǒng"; /* 㹞 */
dict[0x23e5f] = "gàn"; /* 㹟 */
dict[0x23e60] = "yuān"; /* 㹠 */
dict[0x23e61] = "chí"; /* 㹡 */
dict[0x23e62] = "hán"; /* 㹢 */
dict[0x23e64] = "rù"; /* 㹤 */
dict[0x23e65] = "qiàn"; /* 㹥 */
dict[0x23e67] = "zuó,zhà"; /* 㹧 */
dict[0x23e69] = "xié"; /* 㹩 */
dict[0x23e6a] = "máo"; /* 㹪 */
dict[0x23e6c] = "hú"; /* 㹬 */
dict[0x23e6d] = "liú"; /* 㹭 */
dict[0x23e6e] = "pì"; /* 㹮 */
dict[0x23e6f] = "xùn"; /* 㹯 */
dict[0x23e71] = "xiá"; /* 㹱 */
dict[0x23e72] = "tí"; /* 㹲 */
dict[0x23e75] = "nà"; /* 㹵 */
dict[0x23e76] = "chuǎ"; /* 㹶 */
dict[0x23e80] = "wǔ"; /* 㺀 */
dict[0x23e8c] = "miǎo"; /* 㺌 */
dict[0x23eac] = "huāng"; /* 㺬 */
dict[0x23ead] = "xuè"; /* 㺭 */
dict[0x23eae] = "tào"; /* 㺮 */
dict[0x23eb0] = "qiào"; /* 㺰 */
dict[0x23eb3] = "jiāo"; /* 㺳 */
dict[0x23eb9] = "zhān"; /* 㺹 */
dict[0x23ecd] = "dàng,xiàng"; /* 㻍 */
dict[0x23ece] = "kòu"; /* 㻎 */
dict[0x23ed0] = "jū"; /* 㻐 */
dict[0x23ed1] = "shā,shài"; /* 㻑 */
dict[0x23ed2] = "jīng"; /* 㻒 */
dict[0x23ed5] = "mó"; /* 㻕 */
dict[0x23ed6] = "nóu"; /* 㻖 */
dict[0x23ed8] = "shuò"; /* 㻘 */
dict[0x23eda] = "shù"; /* 㻚 */
dict[0x23edb] = "zhuāng"; /* 㻛 */
dict[0x23edc] = "fú"; /* 㻜 */
dict[0x23ede] = "zhǐ"; /* 㻞 */
dict[0x23edf] = "zāng"; /* 㻟 */
dict[0x23ee0] = "xié"; /* 㻠 */
dict[0x23ee1] = "làng"; /* 㻡 */
dict[0x23ee2] = "tōng"; /* 㻢 */
dict[0x23ee3] = "shè"; /* 㻣 */
dict[0x23ee9] = "zhé"; /* 㻩 */
dict[0x23eec] = "càn"; /* 㻬 */
dict[0x23eee] = "yuè"; /* 㻮 */
dict[0x23ef1] = "zhòu"; /* 㻱 */
dict[0x23f1a] = "tān"; /* 㼚 */
dict[0x23f1e] = "yán"; /* 㼞 */
dict[0x23f1f] = "lù"; /* 㼟 */
dict[0x23f20] = "yǎn"; /* 㼠 */
dict[0x23f26] = "zé"; /* 㼦 */
dict[0x23f27] = "shuài"; /* 㼧 */
dict[0x23f3d] = "lǎng"; /* 㼽 */
dict[0x23f45] = "guō"; /* 㽅 */
dict[0x23f46] = "zhú"; /* 㽆 */
dict[0x23f48] = "rú,ruán"; /* 㽈 */
dict[0x23f49] = "rú"; /* 㽉 */
dict[0x23f4c] = "kǎn"; /* 㽌 */
dict[0x23f4d] = "jì"; /* 㽍 */
dict[0x23f4e] = "gāo,zé,háo"; /* 㽎 */
dict[0x23f4f] = "wū"; /* 㽏 */
dict[0x23f52] = "xiè"; /* 㽒 */
dict[0x23f55] = "òu"; /* 㽕 */
dict[0x23f56] = "jiān"; /* 㽖 */
dict[0x23f5a] = "zhí"; /* 㽚 */
dict[0x23f5b] = "zhá"; /* 㽛 */
dict[0x23f5d] = "hǒng"; /* 㽝 */
dict[0x23f5f] = "kuǎn"; /* 㽟 */
dict[0x23f61] = "bó"; /* 㽡 */
dict[0x23f64] = "sè"; /* 㽤 */
dict[0x23f65] = "àn"; /* 㽥 */
dict[0x23f66] = "jiàn"; /* 㽦 */
dict[0x23f68] = "téng"; /* 㽨 */
dict[0x23f6b] = "sōng"; /* 㽫 */
dict[0x23f6d] = "mèng"; /* 㽭 */
dict[0x23f6e] = "yín"; /* 㽮 */
dict[0x23f6f] = "tān"; /* 㽯 */
dict[0x23f70] = "guō"; /* 㽰 */
dict[0x23f73] = "ruán"; /* 㽳 */
dict[0x23f74] = "wèi"; /* 㽴 */
dict[0x23fa4] = "qì"; /* 㾤 */
dict[0x23fa6] = "zhǎng"; /* 㾦 */
dict[0x23fc5] = "dǒng"; /* 㿅 */
dict[0x23fc6] = "fú"; /* 㿆 */
dict[0x23fc7] = "shěn"; /* 㿇 */
dict[0x23fc8] = "sù"; /* 㿈 */
dict[0x23fc9] = "yì"; /* 㿉 */
dict[0x23fca] = "liàn"; /* 㿊 */
dict[0x23fcc] = "hé"; /* 㿌 */
dict[0x23fce] = "zhēn"; /* 㿎 */
dict[0x23fd0] = "zé"; /* 㿐 */
dict[0x23fd2] = "cuǐ"; /* 㿒 */
dict[0x23fd3] = "cuǐ"; /* 㿓 */
dict[0x23fdd] = "fèng"; /* 㿝 */
dict[0x23fde] = "lǐ"; /* 㿞 */
dict[0x23fdf] = "kòu"; /* 㿟 */
dict[0x23fe3] = "xiào"; /* 㿣 */
dict[0x23fe4] = "yǒu"; /* 㿤 */
dict[0x23fe8] = "xiè"; /* 㿨 */
dict[0x23ff4] = "dàng"; /* 㿴 */
dict[0x24003] = "háo"; /* 䀃 */
dict[0x24009] = "hàn"; /* 䀉 */
dict[0x2400a] = "kěn"; /* 䀊 */
dict[0x2401d] = "yù"; /* 䀝 */
dict[0x24020] = "xī"; /* 䀠 */
dict[0x24023] = "huǎn"; /* 䀣 */
dict[0x24024] = "suō,shàn,shuài"; /* 䀤 */
dict[0x24026] = "là"; /* 䀦 */
dict[0x24028] = "dòu"; /* 䀨 */
dict[0x24029] = "jiàn"; /* 䀩 */
dict[0x2402a] = "pō"; /* 䀪 */
dict[0x2402b] = "biǎn"; /* 䀫 */
dict[0x24030] = "xuè"; /* 䀰 */
dict[0x24032] = "biàn"; /* 䀲 */
dict[0x24037] = "wèi"; /* 䀷 */
dict[0x24061] = "dàn"; /* 䁡 */
dict[0x24062] = "jié"; /* 䁢 */
dict[0x24063] = "bài"; /* 䁣 */
dict[0x24065] = "niǎn"; /* 䁥 */
dict[0x24066] = "xiàn"; /* 䁦 */
dict[0x24067] = "sè"; /* 䁧 */
dict[0x2406a] = "huá"; /* 䁪 */
dict[0x2406b] = "chuā"; /* 䁫 */
dict[0x2406e] = "òu"; /* 䁮 */
dict[0x2406f] = "liè"; /* 䁯 */
dict[0x24070] = "dí"; /* 䁰 */
dict[0x24071] = "cài"; /* 䁱 */
dict[0x24073] = "zhá"; /* 䁳 */
dict[0x24075] = "lǘ"; /* 䁵 */
dict[0x24079] = "huò"; /* 䁹 */
dict[0x2407c] = "lì"; /* 䁼 */
dict[0x2407d] = "yǐng"; /* 䁽 */
dict[0x2407f] = "wěi"; /* 䁿 */
dict[0x24080] = "bì"; /* 䂀 */
dict[0x24081] = "guó"; /* 䂁 */
dict[0x24083] = "pì"; /* 䂃 */
dict[0x24086] = "biāo"; /* 䂆 */
dict[0x24091] = "nóng"; /* 䂑 */
dict[0x240a0] = "yǎn"; /* 䂠 */
dict[0x240a4] = "zhuàn"; /* 䂤 */
dict[0x240b2] = "hóng"; /* 䂲 */
dict[0x240b6] = "lìn"; /* 䂶 */
dict[0x240b7] = "è"; /* 䂷 */
dict[0x240b9] = "yǐn"; /* 䂹 */
dict[0x240ba] = "làn"; /* 䂺 */
dict[0x240bc] = "yào"; /* 䂼 */
dict[0x240bf] = "xuàn"; /* 䂿 */
dict[0x240c0] = "lì"; /* 䃀 */
dict[0x240e8] = "làn"; /* 䃨 */
dict[0x240e9] = "líng"; /* 䃩 */
dict[0x240ea] = "xī"; /* 䃪 */
dict[0x240eb] = "hōng"; /* 䃫 */
dict[0x240ec] = "huàn"; /* 䃬 */
dict[0x240ed] = "jiǎo"; /* 䃭 */
dict[0x240ee] = "zhuó"; /* 䃮 */
dict[0x240f2] = "zhí"; /* 䃲 */
dict[0x240f4] = "huò"; /* 䃴 */
dict[0x240f5] = "bó"; /* 䃵 */
dict[0x240f6] = "tēng"; /* 䃶 */
dict[0x240f7] = "ǎn"; /* 䃷 */
dict[0x240fa] = "xún"; /* 䃺 */
dict[0x240fb] = "lěi"; /* 䃻 */
dict[0x240fc] = "zāng"; /* 䃼 */
dict[0x240fd] = "huǐ"; /* 䃽 */
dict[0x2410e] = "xì"; /* 䄎 */
dict[0x2410f] = "hóng"; /* 䄏 */
dict[0x24111] = "fàn"; /* 䄑 */
dict[0x24112] = "jiǎn"; /* 䄒 */
dict[0x24113] = "cóng"; /* 䄓 */
dict[0x24114] = "zá"; /* 䄔 */
dict[0x24116] = "cā,zá"; /* 䄖 */
dict[0x24118] = "yōu"; /* 䄘 */
dict[0x2411b] = "duì"; /* 䄛 */
dict[0x2411c] = "pān"; /* 䄜 */
dict[0x24125] = "tà"; /* 䄥 */
dict[0x24127] = "pàn"; /* 䄧 */
dict[0x2412b] = "fān"; /* 䄫 */
dict[0x2412c] = "xī"; /* 䄬 */
dict[0x24136] = "yào,shuò"; /* 䄶 */
dict[0x24137] = "luó"; /* 䄷 */
dict[0x2413a] = "biān"; /* 䄺 */
dict[0x2413c] = "jìn"; /* 䄼 */
dict[0x2413d] = "lì"; /* 䄽 */
dict[0x2414a] = "yàn"; /* 䅊 */
dict[0x2414b] = "dòu"; /* 䅋 */
dict[0x2414e] = "màn"; /* 䅎 */
dict[0x24150] = "gōng"; /* 䅐 */
dict[0x24151] = "rǎng"; /* 䅑 */
dict[0x24152] = "càn"; /* 䅒 */
dict[0x24163] = "mén"; /* 䅣 */
dict[0x24164] = "mí"; /* 䅤 */
dict[0x24166] = "tán"; /* 䅦 */
dict[0x24169] = "tān"; /* 䅩 */
dict[0x24171] = "gǔ"; /* 䅱 */
dict[0x24172] = "shuàn"; /* 䅲 */
dict[0x24178] = "yán,yàn"; /* 䅸 */
dict[0x24179] = "bì"; /* 䅹 */
dict[0x24180] = "biāo"; /* 䆀 */
dict[0x24181] = "chéng"; /* 䆁 */
dict[0x24182] = "kuì"; /* 䆂 */
dict[0x24184] = "huǒ,zāi"; /* 䆄 */
dict[0x2418c] = "yán"; /* 䆌 */
dict[0x2418d] = "chì"; /* 䆍 */
dict[0x2418f] = "wò"; /* 䆏 */
dict[0x24191] = "còu"; /* 䆑 */
dict[0x24192] = "zhì"; /* 䆒 */
dict[0x24195] = "rěn"; /* 䆕 */
dict[0x24199] = "shuǐ"; /* 䆙 */
dict[0x2419c] = "guà"; /* 䆜 */
dict[0x2419d] = "pū"; /* 䆝 */
dict[0x2419e] = "xù"; /* 䆞 */
dict[0x2419f] = "sī"; /* 䆟 */
dict[0x241a1] = "wǔ"; /* 䆡 */
dict[0x241a4] = "zhèn"; /* 䆤 */
dict[0x241ac] = "qǔ"; /* 䆬 */
dict[0x241ae] = "fū"; /* 䆮 */
dict[0x241b0] = "shì"; /* 䆰 */
dict[0x241b3] = "huì"; /* 䆳 */
dict[0x241b4] = "huāng"; /* 䆴 */
dict[0x241b5] = "pā"; /* 䆵 */
dict[0x241b6] = "fén"; /* 䆶 */
dict[0x241ba] = "kǒng"; /* 䆺 */
dict[0x241bc] = "zhǔ"; /* 䆼 */
dict[0x241be] = "yí"; /* 䆾 */
dict[0x241cf] = "zhēng"; /* 䇏 */
dict[0x241dc] = "mín"; /* 䇜 */
dict[0x241de] = "gē"; /* 䇞 */
dict[0x241e0] = "hū"; /* 䇠 */
dict[0x241ee] = "fá"; /* 䇮 */
dict[0x241ef] = "ēn,āo"; /* 䇯 */
dict[0x241f0] = "fá"; /* 䇰 */
dict[0x241f3] = "xù,xuè"; /* 䇳 */
dict[0x241f4] = "yí,xī"; /* 䇴 */
dict[0x241f6] = "zhēng"; /* 䇶 */
dict[0x241fe] = "yìng"; /* 䇾 */
dict[0x24204] = "jí"; /* 䈄 */
dict[0x24214] = "chí"; /* 䈔 */
dict[0x24219] = "yí"; /* 䈙 */
dict[0x24225] = "dí"; /* 䈥 */
dict[0x24226] = "huǐ,méi"; /* 䈦 */
dict[0x24227] = "hé"; /* 䈧 */
dict[0x24229] = "zhǎ"; /* 䈩 */
dict[0x2422b] = "wèi"; /* 䈫 */
dict[0x2424c] = "xián"; /* 䉌 */
dict[0x2424d] = "lào"; /* 䉍 */
dict[0x2424e] = "shào"; /* 䉎 */
dict[0x2424f] = "shì"; /* 䉏 */
dict[0x24250] = "zhuó"; /* 䉐 */
dict[0x24259] = "jūn"; /* 䉙 */
dict[0x24261] = "sì"; /* 䉡 */
dict[0x24264] = "biē"; /* 䉤 */
dict[0x24265] = "jiǔ"; /* 䉥 */
dict[0x24266] = "wō"; /* 䉦 */
dict[0x24267] = "jiǎo"; /* 䉧 */
dict[0x24268] = "fú"; /* 䉨 */
dict[0x2426a] = "xiāng"; /* 䉪 */
dict[0x2426b] = "kài"; /* 䉫 */
dict[0x242b2] = "nǎo"; /* 䊲 */
dict[0x242b4] = "huò"; /* 䊴 */
dict[0x242b5] = "jí"; /* 䊵 */
dict[0x242b6] = "là"; /* 䊶 */
dict[0x242bb] = "fōu"; /* 䊻 */
dict[0x242bc] = "shǎn"; /* 䊼 */
dict[0x242bd] = "liào,liǎo"; /* 䊽 */
dict[0x242be] = "miè"; /* 䊾 */
dict[0x242bf] = "chè"; /* 䊿 */
dict[0x242c2] = "mó"; /* 䋂 */
dict[0x242e0] = "yàn"; /* 䋠 */
dict[0x242e8] = "duò"; /* 䋨 */
dict[0x242eb] = "nǎo"; /* 䋫 */
dict[0x242ed] = "jī"; /* 䋭 */
dict[0x242ee] = "xī"; /* 䋮 */
dict[0x242f0] = "zhù"; /* 䋰 */
dict[0x24302] = "sù"; /* 䌂 */
dict[0x24303] = "duò"; /* 䌃 */
dict[0x24307] = "jiǒng"; /* 䌇 */
dict[0x2430a] = "zǎi"; /* 䌊 */
dict[0x2430b] = "huǐ"; /* 䌋 */
dict[0x2430c] = "yǐng"; /* 䌌 */
dict[0x2430d] = "hú"; /* 䌍 */
dict[0x2430e] = "lìn,lǐn"; /* 䌎 */
dict[0x2430f] = "wěng"; /* 䌏 */
dict[0x24310] = "hàn"; /* 䌐 */
dict[0x24314] = "nán"; /* 䌔 */
dict[0x24337] = "xì"; /* 䌷 */
dict[0x24339] = "gàn"; /* 䌹 */
dict[0x2433e] = "hè"; /* 䌾 */
dict[0x2433f] = "jī"; /* 䌿 */
dict[0x24340] = "xiǎng"; /* 䍀 */
dict[0x24341] = "shā"; /* 䍁 */
dict[0x24352] = "zhāo"; /* 䍒 */
dict[0x24353] = "shù"; /* 䍓 */
dict[0x24355] = "yǒu"; /* 䍕 */
dict[0x24356] = "jiān"; /* 䍖 */
dict[0x2435c] = "zào"; /* 䍜 */
dict[0x24364] = "zhāng"; /* 䍤 */
dict[0x2437d] = "ruò"; /* 䍽 */
dict[0x24384] = "yān"; /* 䎄 */
dict[0x24385] = "áo"; /* 䎅 */
dict[0x24389] = "lián"; /* 䎉 */
dict[0x2438b] = "cuì"; /* 䎋 */
dict[0x24397] = "jí"; /* 䎗 */
dict[0x24398] = "shāng"; /* 䎘 */
dict[0x243a3] = "è"; /* 䎣 */
dict[0x243a4] = "láo"; /* 䎤 */
dict[0x243a5] = "tǎn,chān"; /* 䎥 */
dict[0x243a7] = "zhù"; /* 䎧 */
dict[0x243ad] = "lǐn,yǐn"; /* 䎭 */
dict[0x243af] = "zēng"; /* 䎯 */
dict[0x243b1] = "juǎn"; /* 䎱 */
dict[0x243b2] = "hū"; /* 䎲 */
dict[0x243d7] = "shěn"; /* 䏗 */
dict[0x243d8] = "huò"; /* 䏘 */
dict[0x243dc] = "kuì"; /* 䏜 */
dict[0x243f0] = "piē"; /* 䏰 */
dict[0x243f1] = "chù"; /* 䏱 */
dict[0x243f2] = "zhòu"; /* 䏲 */
dict[0x243f6] = "āo"; /* 䏶 */
dict[0x243f8] = "zhuó"; /* 䏸 */
dict[0x243fb] = "xiè"; /* 䏻 */
dict[0x243fd] = "xīng"; /* 䏽 */
dict[0x243ff] = "miè"; /* 䏿 */
dict[0x24400] = "hū"; /* 䐀 */
dict[0x24414] = "tán"; /* 䐔 */
dict[0x24419] = "bì"; /* 䐙 */
dict[0x24423] = "dǐng"; /* 䐣 */
dict[0x24429] = "kài"; /* 䐩 */
dict[0x2442b] = "biāo"; /* 䐫 */
dict[0x24430] = "huò"; /* 䐰 */
dict[0x24431] = "liè"; /* 䐱 */
dict[0x24432] = "cuàn"; /* 䐲 */
dict[0x24438] = "bì"; /* 䐸 */
dict[0x24443] = "xiàn"; /* 䑃 */
dict[0x24444] = "rè"; /* 䑄 */
dict[0x24453] = "yuè"; /* 䑓 */
dict[0x24455] = "xūn,xùn"; /* 䑕 */
dict[0x24457] = "liǎo,zhāo"; /* 䑗 */
dict[0x24463] = "shā"; /* 䑣 */
dict[0x24466] = "shì"; /* 䑦 */
dict[0x2446a] = "xiè"; /* 䑪 */
dict[0x24473] = "xiāo"; /* 䑳 */
dict[0x24477] = "yé"; /* 䑷 */
dict[0x24478] = "lǎn"; /* 䑸 */
dict[0x24479] = "yì"; /* 䑹 */
dict[0x2447f] = "liǎn"; /* 䑿 */
dict[0x24485] = "jiāo"; /* 䒅 */
dict[0x24493] = "fú"; /* 䒓 */
dict[0x24494] = "bó"; /* 䒔 */
dict[0x24495] = "cāo"; /* 䒕 */
dict[0x24498] = "dǔ"; /* 䒘 */
dict[0x2449d] = "yào"; /* 䒝 */
dict[0x244a6] = "liàn,yàn"; /* 䒦 */
dict[0x244bb] = "tà"; /* 䒻 */
dict[0x244cc] = "rán"; /* 䓌 */
dict[0x244d1] = "jì"; /* 䓑 */
dict[0x244d2] = "mí"; /* 䓒 */
dict[0x244d3] = "luó"; /* 䓓 */
dict[0x244d4] = "xī"; /* 䓔 */
dict[0x244d5] = "zhì"; /* 䓕 */
dict[0x244da] = "xī"; /* 䓚 */
dict[0x244dd] = "yuè"; /* 䓝 */
dict[0x244e4] = "xiǎn"; /* 䓤 */
dict[0x244e6] = "zhuò"; /* 䓦 */
dict[0x244ea] = "jiāo"; /* 䓪 */
dict[0x244ef] = "zhǎng,jú"; /* 䓯 */
dict[0x244f5] = "zǔ"; /* 䓵 */
dict[0x244f7] = "ná"; /* 䓷 */
dict[0x244fe] = "dào"; /* 䓾 */
dict[0x244ff] = "liè"; /* 䓿 */
dict[0x24500] = "ná"; /* 䔀 */
dict[0x24509] = "páo"; /* 䔉 */
dict[0x2450b] = "jù"; /* 䔋 */
dict[0x2450c] = "yǐn"; /* 䔌 */
dict[0x24514] = "luàn"; /* 䔔 */
dict[0x24516] = "luǒ"; /* 䔖 */
dict[0x24519] = "shuǎ"; /* 䔙 */
dict[0x2451a] = "shàng"; /* 䔚 */
dict[0x2451d] = "luǒ"; /* 䔝 */
dict[0x2451f] = "fēn"; /* 䔟 */
dict[0x24523] = "bào"; /* 䔣 */
dict[0x24528] = "lì"; /* 䔨 */
dict[0x2452b] = "xiòng"; /* 䔫 */
dict[0x24531] = "tāo"; /* 䔱 */
dict[0x24536] = "dāng"; /* 䔶 */
dict[0x24540] = "chèng"; /* 䕀 */
dict[0x24544] = "zhǎng"; /* 䕄 */
dict[0x24547] = "sǒu"; /* 䕇 */
dict[0x24548] = "liàn"; /* 䕈 */
dict[0x2454a] = "shén"; /* 䕊 */
dict[0x24552] = "gě"; /* 䕒 */
dict[0x24553] = "yé"; /* 䕓 */
dict[0x24558] = "yū,wù"; /* 䕘 */
dict[0x2455a] = "huī"; /* 䕚 */
dict[0x2455b] = "chè"; /* 䕛 */
dict[0x2455d] = "jiào,bó"; /* 䕝 */
dict[0x2455e] = "zhù"; /* 䕞 */
dict[0x2455f] = "shū"; /* 䕟 */
dict[0x24562] = "xiáo"; /* 䕢 */
dict[0x24564] = "shuāng,shuǎng"; /* 䕤 */
dict[0x24566] = "níng"; /* 䕦 */
dict[0x2456c] = "jí"; /* 䕬 */
dict[0x2456d] = "jiāng,jiàng,qiāng"; /* 䕭 */
dict[0x2456f] = "jiāng,zhuàng"; /* 䕯 */
dict[0x24577] = "diào"; /* 䕷 */
dict[0x2457d] = "qiáng"; /* 䕽 */
dict[0x2457e] = "qiú,fǔ"; /* 䕾 */
dict[0x24580] = "fēng"; /* 䖀 */
dict[0x24585] = "jiāng"; /* 䖅 */
dict[0x24586] = "zhàn"; /* 䖆 */
dict[0x24587] = "kē"; /* 䖇 */
dict[0x24592] = "dié"; /* 䖒 */
dict[0x24593] = "zé"; /* 䖓 */
dict[0x24596] = "guāng"; /* 䖖 */
dict[0x24597] = "sè"; /* 䖗 */
dict[0x24598] = "fèn,fén"; /* 䖘 */
dict[0x2459b] = "jiǎng"; /* 䖛 */
dict[0x2459d] = "yán"; /* 䖝 */
dict[0x2459e] = "zhì"; /* 䖞 */
dict[0x2459f] = "bò"; /* 䖟 */
dict[0x245a2] = "lì"; /* 䖢 */
dict[0x245a6] = "líng"; /* 䖦 */
dict[0x245aa] = "yí"; /* 䖪 */
dict[0x245ac] = "qǔ"; /* 䖬 */
dict[0x245ad] = "pán"; /* 䖭 */
dict[0x245ae] = "gōu"; /* 䖮 */
dict[0x245b0] = "jiǎ"; /* 䖰 */
dict[0x245b1] = "hé"; /* 䖱 */
dict[0x245b3] = "pèng"; /* 䖳 */
dict[0x245b5] = "jù"; /* 䖵 */
dict[0x245b7] = "chè"; /* 䖷 */
dict[0x245ba] = "liè"; /* 䖺 */
dict[0x245bb] = "shì"; /* 䖻 */
dict[0x245bc] = "pò"; /* 䖼 */
dict[0x245bd] = "xiàng"; /* 䖽 */
dict[0x245bf] = "pì"; /* 䖿 */
dict[0x245c0] = "luǒ"; /* 䗀 */
dict[0x245c1] = "cù"; /* 䗁 */
dict[0x245c3] = "yǔ"; /* 䗃 */
dict[0x245c7] = "kòng"; /* 䗇 */
dict[0x245c8] = "xiè"; /* 䗈 */
dict[0x245cd] = "wǎn"; /* 䗍 */
dict[0x245ce] = "yǎn"; /* 䗎 */
dict[0x245cf] = "péi"; /* 䗏 */
dict[0x245d3] = "chéng"; /* 䗓 */
dict[0x245d8] = "tí"; /* 䗘 */
dict[0x245d9] = "chè,tuò"; /* 䗙 */
dict[0x245da] = "bì"; /* 䗚 */
dict[0x245db] = "liàn"; /* 䗛 */
dict[0x245dc] = "jiǎ"; /* 䗜 */
dict[0x245de] = "tíng"; /* 䗞 */
dict[0x245e2] = "tī"; /* 䗢 */
dict[0x245e8] = "dié"; /* 䗨 */
dict[0x245ea] = "shù"; /* 䗪 */
dict[0x245eb] = "lí"; /* 䗫 */
dict[0x245ec] = "lǘ"; /* 䗬 */
dict[0x245ed] = "xiā"; /* 䗭 */
dict[0x245ef] = "cuī"; /* 䗯 */
dict[0x245f3] = "bō"; /* 䗳 */
dict[0x245f4] = "tuí"; /* 䗴 */
dict[0x245f5] = "pú"; /* 䗵 */
dict[0x245f7] = "lìn"; /* 䗷 */
dict[0x245f8] = "fèn,fén"; /* 䗸 */
dict[0x245fa] = "bó"; /* 䗺 */
dict[0x245fb] = "chàn"; /* 䗻 */
dict[0x245fe] = "dāng"; /* 䗾 */
dict[0x245ff] = "tǎi"; /* 䗿 */
dict[0x24600] = "dào"; /* 䘀 */
dict[0x24603] = "lì"; /* 䘃 */
dict[0x24605] = "yá"; /* 䘅 */
dict[0x24606] = "yá"; /* 䘆 */
dict[0x24607] = "zhān"; /* 䘇 */
dict[0x2460a] = "yí"; /* 䘊 */
dict[0x2460c] = "qī"; /* 䘌 */
dict[0x24610] = "qǔ"; /* 䘐 */
dict[0x24614] = "hù"; /* 䘔 */
dict[0x24616] = "tīng"; /* 䘖 */
dict[0x24618] = "kǒu"; /* 䘘 */
dict[0x2461b] = "chún"; /* 䘛 */
dict[0x2461c] = "yóu"; /* 䘜 */
dict[0x2461d] = "fèn"; /* 䘝 */
dict[0x2461f] = "nuó"; /* 䘟 */
dict[0x24620] = "tiàn"; /* 䘠 */
dict[0x24621] = "jìn"; /* 䘡 */
dict[0x24622] = "pí"; /* 䘢 */
dict[0x24623] = "chén"; /* 䘣 */
dict[0x24624] = "pì"; /* 䘤 */
dict[0x24626] = "jiè"; /* 䘦 */
dict[0x24627] = "guǐ"; /* 䘧 */
dict[0x24632] = "zhuàng"; /* 䘲 */
dict[0x24635] = "hú"; /* 䘵 */
dict[0x24636] = "chǒu"; /* 䘶 */
dict[0x24637] = "shù"; /* 䘷 */
dict[0x24638] = "tāo"; /* 䘸 */
dict[0x24639] = "pí"; /* 䘹 */
dict[0x2463a] = "rǒng"; /* 䘺 */
dict[0x2463b] = "rǒng"; /* 䘻 */
dict[0x2463d] = "hǒu"; /* 䘽 */
dict[0x2463e] = "pēng"; /* 䘾 */
dict[0x24645] = "bài"; /* 䙅 */
dict[0x24647] = "xiá"; /* 䙇 */
dict[0x2464b] = "qǐn"; /* 䙋 */
dict[0x2464c] = "nǐ"; /* 䙌 */
dict[0x2464e] = "tāo"; /* 䙎 */
dict[0x2464f] = "qù"; /* 䙏 */
dict[0x24652] = "xié"; /* 䙒 */
dict[0x24654] = "zhào"; /* 䙔 */
dict[0x24655] = "huā"; /* 䙕 */
dict[0x24656] = "xīn"; /* 䙖 */
dict[0x24658] = "shōu"; /* 䙘 */
dict[0x2465b] = "tú"; /* 䙛 */
dict[0x2465d] = "liáng"; /* 䙝 */
dict[0x2465e] = "bì"; /* 䙞 */
dict[0x2465f] = "chū"; /* 䙟 */
dict[0x24661] = "xīng"; /* 䙡 */
dict[0x24663] = "xīn"; /* 䙣 */
dict[0x24664] = "fū"; /* 䙤 */
dict[0x24669] = "jiè"; /* 䙩 */
dict[0x2466d] = "fǔ"; /* 䙭 */
dict[0x2466f] = "láo"; /* 䙯 */
dict[0x24670] = "tè"; /* 䙰 */
dict[0x24671] = "shè"; /* 䙱 */
dict[0x24674] = "chāo"; /* 䙴 */
dict[0x24675] = "chuī"; /* 䙵 */
dict[0x2467c] = "rán"; /* 䙼 */
dict[0x2467d] = "hǒu"; /* 䙽 */
dict[0x2467e] = "bēng"; /* 䙾 */
dict[0x24680] = "cǎi"; /* 䚀 */
dict[0x24685] = "mú"; /* 䚅 */
dict[0x24689] = "xū"; /* 䚉 */
dict[0x2468a] = "dié"; /* 䚊 */
dict[0x2468d] = "chǎn"; /* 䚍 */
dict[0x2468e] = "yú"; /* 䚎 */
dict[0x2468f] = "zhòng"; /* 䚏 */
dict[0x24693] = "lí"; /* 䚓 */
dict[0x24694] = "shōu"; /* 䚔 */
dict[0x2469a] = "dú"; /* 䚚 */
dict[0x2469c] = "māo"; /* 䚜 */
dict[0x2469d] = "huáng"; /* 䚝 */
dict[0x2469f] = "táo"; /* 䚟 */
dict[0x246a1] = "dù"; /* 䚡 */
dict[0x246a2] = "tí"; /* 䚢 */
dict[0x246a3] = "shēng"; /* 䚣 */
dict[0x246a4] = "méi"; /* 䚤 */
dict[0x246a8] = "zhēn"; /* 䚨 */
dict[0x246a9] = "qín"; /* 䚩 */
dict[0x246aa] = "pì"; /* 䚪 */
dict[0x246ab] = "táng"; /* 䚫 */
dict[0x246ac] = "cāng"; /* 䚬 */
dict[0x246ad] = "yáo"; /* 䚭 */
dict[0x246af] = "xiù"; /* 䚯 */
dict[0x246b0] = "bāng"; /* 䚰 */
dict[0x246b1] = "gǔ"; /* 䚱 */
dict[0x246b5] = "bù"; /* 䚵 */
dict[0x246bc] = "gòu"; /* 䚼 */
dict[0x246bd] = "bó"; /* 䚽 */
dict[0x246c1] = "wèn"; /* 䛁 */
dict[0x246c4] = "jì"; /* 䛄 */
dict[0x246ca] = "lā"; /* 䛊 */
dict[0x246cd] = "cuī"; /* 䛍 */
dict[0x246ce] = "mǐn"; /* 䛎 */
dict[0x246cf] = "cǔ"; /* 䛏 */
dict[0x246d0] = "ōu"; /* 䛐 */
dict[0x246d1] = "yōng"; /* 䛑 */
dict[0x246d6] = "máo"; /* 䛖 */
dict[0x246d7] = "kè"; /* 䛗 */
dict[0x246d9] = "dǐng"; /* 䛙 */
dict[0x246da] = "huān"; /* 䛚 */
dict[0x246db] = "duǒ"; /* 䛛 */
dict[0x246dc] = "jiāng"; /* 䛜 */
dict[0x246dd] = "sù"; /* 䛝 */
dict[0x246df] = "bèi"; /* 䛟 */
dict[0x246e2] = "céng"; /* 䛢 */
dict[0x246e3] = "tà"; /* 䛣 */
dict[0x246e5] = "huáng"; /* 䛥 */
dict[0x246e6] = "jué"; /* 䛦 */
dict[0x246e7] = "xún"; /* 䛧 */
dict[0x246ea] = "xiòng"; /* 䛪 */
dict[0x246ec] = "mì"; /* 䛬 */
dict[0x246ed] = "qún"; /* 䛭 */
dict[0x246ee] = "láo"; /* 䛮 */
dict[0x246f1] = "zhì"; /* 䛱 */
dict[0x246f2] = "wěi,wéi"; /* 䛲 */
dict[0x246f7] = "sè"; /* 䛷 */
dict[0x246fb] = "zāng"; /* 䛻 */
dict[0x246ff] = "lí"; /* 䛿 */
dict[0x24701] = "ǎn"; /* 䜁 */
dict[0x24702] = "wèi,guì"; /* 䜂 */
dict[0x24704] = "huài"; /* 䜄 */
dict[0x24707] = "zhàn"; /* 䜇 */
dict[0x24709] = "yīng"; /* 䜉 */
dict[0x2470a] = "gē"; /* 䜊 */
dict[0x2470b] = "huì"; /* 䜋 */
dict[0x2470d] = "quán"; /* 䜍 */
dict[0x24713] = "liè"; /* 䜓 */
dict[0x24714] = "jú"; /* 䜔 */
dict[0x24715] = "bà"; /* 䜕 */
dict[0x24716] = "léi"; /* 䜖 */
dict[0x24718] = "mán"; /* 䜘 */
dict[0x24719] = "líng"; /* 䜙 */
dict[0x2471c] = "lì"; /* 䜜 */
dict[0x2471d] = "jǐ"; /* 䜝 */
dict[0x24721] = "huí"; /* 䜡 */
dict[0x24722] = "xìn"; /* 䜢 */
dict[0x24723] = "shì,shé"; /* 䜣 */
dict[0x24724] = "zhé"; /* 䜤 */
dict[0x24727] = "bō"; /* 䜧 */
dict[0x2472b] = "chā"; /* 䜫 */
dict[0x2472f] = "chā"; /* 䜯 */
dict[0x24730] = "jīng"; /* 䜰 */
dict[0x24731] = "bā"; /* 䜱 */
dict[0x24732] = "bèi,pèi"; /* 䜲 */
dict[0x24735] = "yàn"; /* 䜵 */
dict[0x24737] = "hù"; /* 䜷 */
dict[0x24739] = "yú"; /* 䜹 */
dict[0x2473b] = "bì,pí"; /* 䜻 */
dict[0x2473c] = "chuán"; /* 䜼 */
dict[0x2473e] = "jǐ"; /* 䜾 */
dict[0x24742] = "mù"; /* 䝂 */
dict[0x24744] = "máo"; /* 䝄 */
dict[0x24745] = "zhōng"; /* 䝅 */
dict[0x24747] = "yè"; /* 䝇 */
dict[0x24748] = "dōu"; /* 䝈 */
dict[0x24749] = "yě"; /* 䝉 */
dict[0x2474d] = "rì"; /* 䝍 */
dict[0x2474e] = "yīn"; /* 䝎 */
dict[0x24750] = "hào"; /* 䝐 */
dict[0x24752] = "nà"; /* 䝒 */
dict[0x24753] = "tiè"; /* 䝓 */
dict[0x24754] = "fù,chái"; /* 䝔 */
dict[0x24755] = "mǔ"; /* 䝕 */
dict[0x24756] = "zǎi"; /* 䝖 */
dict[0x24758] = "hú"; /* 䝘 */
dict[0x2475a] = "chēn"; /* 䝚 */
dict[0x2475b] = "tuó"; /* 䝛 */
dict[0x2475e] = "chù"; /* 䝞 */
dict[0x2475f] = "fú,fèi"; /* 䝟 */
dict[0x24767] = "bào"; /* 䝧 */
dict[0x2476c] = "dǐ"; /* 䝬 */
dict[0x2476d] = "cǎi"; /* 䝭 */
dict[0x2476e] = "lù"; /* 䝮 */
dict[0x2476f] = "pǒ"; /* 䝯 */
dict[0x24770] = "dá"; /* 䝰 */
dict[0x24771] = "yè"; /* 䝱 */
dict[0x24773] = "yǐ"; /* 䝳 */
dict[0x24777] = "xiáng"; /* 䝷 */
dict[0x24778] = "bī"; /* 䝸 */
dict[0x24779] = "zhū"; /* 䝹 */
dict[0x2477b] = "yí"; /* 䝻 */
dict[0x2477c] = "zhì"; /* 䝼 */
dict[0x2477f] = "kuāng"; /* 䝿 */
dict[0x24782] = "zhì"; /* 䞂 */
dict[0x24787] = "wá,kuáng"; /* 䞇 */
dict[0x24788] = "dī"; /* 䞈 */
dict[0x24789] = "shù"; /* 䞉 */
dict[0x2478a] = "liè"; /* 䞊 */
dict[0x2478b] = "zǎo"; /* 䞋 */
dict[0x2478c] = "zhì"; /* 䞌 */
dict[0x2478d] = "náo"; /* 䞍 */
dict[0x2478f] = "shī"; /* 䞏 */
dict[0x24797] = "chái"; /* 䞗 */
dict[0x2479a] = "xiāo"; /* 䞚 */
dict[0x2479b] = "zàng"; /* 䞛 */
dict[0x2479e] = "yù"; /* 䞞 */
dict[0x2479f] = "dòu"; /* 䞟 */
dict[0x247a0] = "chà"; /* 䞠 */
dict[0x247a1] = "xié"; /* 䞡 */
dict[0x247a2] = "yáng"; /* 䞢 */
dict[0x247a3] = "yàn"; /* 䞣 */
dict[0x247a5] = "bǎo"; /* 䞥 */
dict[0x247ae] = "zhāi"; /* 䞮 */
dict[0x247b0] = "qiú"; /* 䞰 */
dict[0x247b2] = "hú"; /* 䞲 */
dict[0x247b3] = "zài"; /* 䞳 */
dict[0x247b4] = "jué"; /* 䞴 */
dict[0x247b6] = "hàn"; /* 䞶 */
dict[0x247bf] = "àn"; /* 䞿 */
dict[0x247c0] = "zào"; /* 䟀 */
dict[0x247c3] = "shà"; /* 䟃 */
dict[0x247c5] = "xiàn"; /* 䟅 */
dict[0x247c6] = "chǐ"; /* 䟆 */
dict[0x247c7] = "yǎn"; /* 䟇 */
dict[0x247c9] = "àn"; /* 䟉 */
dict[0x247cc] = "jiǎng"; /* 䟌 */
dict[0x247cd] = "zhé"; /* 䟍 */
dict[0x247ce] = "jué"; /* 䟎 */
dict[0x247d1] = "lì"; /* 䟑 */
dict[0x247d3] = "lè"; /* 䟓 */
dict[0x247d6] = "cǎi"; /* 䟖 */
dict[0x247d8] = "lù"; /* 䟘 */
dict[0x247da] = "jiā"; /* 䟚 */
dict[0x247dd] = "xià"; /* 䟝 */
dict[0x247de] = "xiào"; /* 䟞 */
dict[0x247df] = "yān"; /* 䟟 */
dict[0x247e0] = "xū"; /* 䟠 */
dict[0x247e2] = "dùn"; /* 䟢 */
dict[0x247e3] = "yíng"; /* 䟣 */
dict[0x247e4] = "huī,xūn"; /* 䟤 */
dict[0x247e5] = "tí"; /* 䟥 */
dict[0x247e6] = "nóu"; /* 䟦 */
dict[0x247e7] = "xǐ"; /* 䟧 */
dict[0x247ea] = "tú"; /* 䟪 */
dict[0x247f7] = "wāi"; /* 䟷 */
dict[0x247f8] = "chēn"; /* 䟸 */
dict[0x247f9] = "yù"; /* 䟹 */
dict[0x247fc] = "hōng"; /* 䟼 */
dict[0x247fe] = "tí"; /* 䟾 */
dict[0x247ff] = "xuān"; /* 䟿 */
dict[0x24800] = "zá"; /* 䠀 */
dict[0x24807] = "gé"; /* 䠇 */
dict[0x2480c] = "chái"; /* 䠌 */
dict[0x2480d] = "pán"; /* 䠍 */
dict[0x2480e] = "jí"; /* 䠎 */
dict[0x2480f] = "nǎo"; /* 䠏 */
dict[0x24810] = "tà"; /* 䠐 */
dict[0x24813] = "xī"; /* 䠓 */
dict[0x24816] = "xiāo"; /* 䠖 */
dict[0x24818] = "sāo"; /* 䠘 */
dict[0x24819] = "jiā"; /* 䠙 */
dict[0x2481a] = "sù"; /* 䠚 */
dict[0x2481b] = "huāng"; /* 䠛 */
dict[0x2481d] = "cuō"; /* 䠝 */
dict[0x2481f] = "tà"; /* 䠟 */
dict[0x24820] = "shuāi"; /* 䠠 */
dict[0x2482a] = "fú"; /* 䠪 */
dict[0x2482b] = "lì"; /* 䠫 */
dict[0x2482d] = "shè"; /* 䠭 */
dict[0x2482f] = "táng"; /* 䠯 */
dict[0x24836] = "diān"; /* 䠶 */
dict[0x2483a] = "bì"; /* 䠺 */
dict[0x2483c] = "gòu"; /* 䠼 */
dict[0x2483d] = "cù"; /* 䠽 */
dict[0x2483f] = "qiān"; /* 䠿 */
dict[0x24842] = "léi,lěi"; /* 䡂 */
dict[0x24843] = "sù"; /* 䡃 */
dict[0x24846] = "zòng,zōng"; /* 䡆 */
dict[0x24847] = "hāo"; /* 䡇 */
dict[0x2484f] = "chì"; /* 䡏 */
dict[0x24850] = "cáo"; /* 䡐 */
dict[0x24853] = "wò"; /* 䡓 */
dict[0x24854] = "xiāo"; /* 䡔 */
dict[0x24855] = "liè,wěn"; /* 䡕 */
dict[0x24856] = "yān"; /* 䡖 */
dict[0x2485d] = "bì"; /* 䡝 */
dict[0x2485f] = "huàn"; /* 䡟 */
dict[0x24861] = "xī"; /* 䡡 */
dict[0x24862] = "chī"; /* 䡢 */
dict[0x24863] = "xū"; /* 䡣 */
dict[0x24864] = "náo,nà,rú"; /* 䡤 */
dict[0x24865] = "yán,xiàn"; /* 䡥 */
dict[0x24867] = "xiè"; /* 䡧 */
dict[0x24868] = "zhá"; /* 䡨 */
dict[0x2486a] = "suì,wěi"; /* 䡪 */
dict[0x2486c] = "xì"; /* 䡬 */
dict[0x2486d] = "bēng,péng"; /* 䡭 */
dict[0x2486e] = "rán"; /* 䡮 */
dict[0x2486f] = "shuò,xī,què"; /* 䡯 */
dict[0x24870] = "bān"; /* 䡰 */
dict[0x24871] = "guì"; /* 䡱 */
dict[0x24872] = "kāi"; /* 䡲 */
dict[0x24873] = "chēn"; /* 䡳 */
dict[0x24876] = "xù"; /* 䡶 */
dict[0x2487e] = "è"; /* 䡾 */
dict[0x2487f] = "lì"; /* 䡿 */
dict[0x24880] = "xī"; /* 䢀 */
dict[0x24881] = "huàn"; /* 䢁 */
dict[0x24882] = "sù"; /* 䢂 */
dict[0x24884] = "chǎng"; /* 䢄 */
dict[0x2488a] = "lù"; /* 䢊 */
dict[0x2488b] = "yán"; /* 䢋 */
dict[0x2488e] = "dāng"; /* 䢎 */
dict[0x2488f] = "dǎn"; /* 䢏 */
dict[0x24890] = "yāng"; /* 䢐 */
dict[0x24892] = "zhǎi"; /* 䢒 */
dict[0x24893] = "jù,qú"; /* 䢓 */
dict[0x24895] = "duó"; /* 䢕 */
dict[0x24896] = "sāo,shān"; /* 䢖 */
dict[0x24897] = "lái"; /* 䢗 */
dict[0x24898] = "sù"; /* 䢘 */
dict[0x2489f] = "zé"; /* 䢟 */
dict[0x248a3] = "bì"; /* 䢣 */
dict[0x248a6] = "yìn"; /* 䢦 */
dict[0x248a8] = "hāo"; /* 䢨 */
dict[0x248aa] = "liè"; /* 䢪 */
dict[0x248ad] = "háo"; /* 䢭 */
dict[0x248ae] = "yáng"; /* 䢮 */
dict[0x248b4] = "shuò,lì"; /* 䢴 */
dict[0x248b5] = "ài"; /* 䢵 */
dict[0x248b6] = "qióng"; /* 䢶 */
dict[0x248b9] = "lěi"; /* 䢹 */
dict[0x248ba] = "xié"; /* 䢺 */
dict[0x248bc] = "shì"; /* 䢼 */
dict[0x248c3] = "lǔ"; /* 䣃 */
dict[0x248c5] = "què"; /* 䣅 */
dict[0x248c6] = "lián"; /* 䣆 */
dict[0x248cc] = "xiào"; /* 䣌 */
dict[0x248ce] = "yīng"; /* 䣎 */
dict[0x248d1] = "xié"; /* 䣑 */
dict[0x248d4] = "xiǎn"; /* 䣔 */
dict[0x248d6] = "fēng"; /* 䣖 */
dict[0x248d8] = "líng"; /* 䣘 */
dict[0x248d9] = "yōu"; /* 䣙 */
dict[0x248de] = "dǎng"; /* 䣞 */
dict[0x248df] = "lǎn"; /* 䣟 */
dict[0x248e0] = "xiāo"; /* 䣠 */
dict[0x248e5] = "xuán"; /* 䣥 */
dict[0x248e8] = "yì"; /* 䣨 */
dict[0x248ec] = "wū"; /* 䣬 */
dict[0x248ee] = "yì"; /* 䣮 */
dict[0x248ef] = "tuō"; /* 䣯 */
dict[0x248f0] = "bǔ"; /* 䣰 */
dict[0x248f1] = "qǐ"; /* 䣱 */
dict[0x248f2] = "xìn"; /* 䣲 */
dict[0x248f5] = "sī"; /* 䣵 */
dict[0x248f6] = "jīn"; /* 䣶 */
dict[0x248f8] = "bā"; /* 䣸 */
dict[0x248f9] = "fǎ"; /* 䣹 */
dict[0x248fb] = "mò"; /* 䣻 */
dict[0x248fc] = "ruò"; /* 䣼 */
dict[0x2490a] = "dà"; /* 䤊 */
dict[0x2490b] = "jì"; /* 䤋 */
dict[0x24910] = "sù"; /* 䤐 */
dict[0x24911] = "qióng"; /* 䤑 */
dict[0x24912] = "bā"; /* 䤒 */
dict[0x24926] = "tián"; /* 䤦 */
dict[0x24927] = "yóu"; /* 䤧 */
dict[0x24929] = "tuó"; /* 䤩 */
dict[0x2492b] = "wài"; /* 䤫 */
dict[0x2492c] = "yòu"; /* 䤬 */
dict[0x2492e] = "dōng"; /* 䤮 */
dict[0x24931] = "xǐ"; /* 䤱 */
dict[0x24932] = "kǒng"; /* 䤲 */
dict[0x24936] = "qióng"; /* 䤶 */
dict[0x24937] = "duī"; /* 䤷 */
dict[0x24938] = "duò"; /* 䤸 */
dict[0x2493a] = "yì"; /* 䤺 */
dict[0x2494e] = "yǎn"; /* 䥎 */
dict[0x24952] = "xī"; /* 䥒 */
dict[0x24953] = "qīn"; /* 䥓 */
dict[0x24954] = "sù"; /* 䥔 */
dict[0x24957] = "liú"; /* 䥗 */
dict[0x24959] = "wán"; /* 䥙 */
dict[0x2496d] = "chē"; /* 䥭 */
dict[0x2496e] = "zhū"; /* 䥮 */
dict[0x24970] = "mào"; /* 䥰 */
dict[0x24977] = "quán"; /* 䥷 */
dict[0x2497b] = "yán"; /* 䥻 */
dict[0x2497d] = "yū"; /* 䥽 */
dict[0x2497f] = "yì"; /* 䥿 */
dict[0x24983] = "lái"; /* 䦃 */
dict[0x24984] = "zhì"; /* 䦄 */
dict[0x249a4] = "ní"; /* 䦤 */
dict[0x249a6] = "bān"; /* 䦦 */
dict[0x249aa] = "dōng"; /* 䦪 */
dict[0x249ae] = "zhì"; /* 䦮 */
dict[0x249ba] = "qí"; /* 䦺 */
dict[0x249d5] = "yì"; /* 䧕 */
dict[0x249d8] = "líng"; /* 䧘 */
dict[0x249d9] = "yú"; /* 䧙 */
dict[0x249db] = "dì"; /* 䧛 */
dict[0x249dc] = "zhì"; /* 䧜 */
dict[0x249e0] = "ruǎn"; /* 䧠 */
dict[0x249e3] = "jiàn"; /* 䧣 */
dict[0x249e9] = "wàn"; /* 䧩 */
dict[0x249eb] = "jìn,duī"; /* 䧫 */
dict[0x249ed] = "páng"; /* 䧭 */
dict[0x24a0d] = "lù"; /* 䨍 */
dict[0x24a0e] = "qú"; /* 䨎 */
dict[0x24a0f] = "suǒ"; /* 䨏 */
dict[0x24a10] = "xǐ,tāo"; /* 䨐 */
dict[0x24a11] = "dá"; /* 䨑 */
dict[0x24a16] = "hù"; /* 䨖 */
dict[0x24a17] = "luǒ"; /* 䨗 */
dict[0x24a19] = "lè"; /* 䨙 */
dict[0x24a36] = "gǒng"; /* 䨶 */
dict[0x24a3b] = "lìng"; /* 䨻 */
dict[0x24a42] = "láo"; /* 䩂 */
dict[0x24a44] = "zhuàn"; /* 䩄 */
dict[0x24a68] = "zǎo"; /* 䩨 */
dict[0x24a69] = "hào"; /* 䩩 */
dict[0x24a6a] = "xiàng"; /* 䩪 */
dict[0x24a6d] = "hào"; /* 䩭 */
dict[0x24a6e] = "lì"; /* 䩮 */
dict[0x24a6f] = "lì"; /* 䩯 */
dict[0x24a70] = "lì"; /* 䩰 */
dict[0x24a71] = "diàn,tiàn"; /* 䩱 */
dict[0x24a72] = "gé"; /* 䩲 */
dict[0x24a84] = "è"; /* 䪄 */
dict[0x24a86] = "xiá"; /* 䪆 */
dict[0x24a8b] = "jiān"; /* 䪋 */
dict[0x24a8c] = "qí"; /* 䪌 */
dict[0x24a8d] = "xiá"; /* 䪍 */
dict[0x24a8e] = "yǒu"; /* 䪎 */
dict[0x24a9e] = "qióng"; /* 䪞 */
dict[0x24aa1] = "zhēng"; /* 䪡 */
dict[0x24aaa] = "zhuàn,chūn"; /* 䪪 */
dict[0x24aae] = "chàn"; /* 䪮 */
dict[0x24ac9] = "xiè"; /* 䫉 */
dict[0x24aca] = "líng"; /* 䫊 */
dict[0x24ad5] = "náo"; /* 䫕 */
dict[0x24add] = "jì"; /* 䫝 */
dict[0x24ade] = "tián"; /* 䫞 */
dict[0x24ae3] = "yǎn"; /* 䫣 */
dict[0x24ae7] = "hǎo"; /* 䫧 */
dict[0x24ae8] = "xín"; /* 䫨 */
dict[0x24aeb] = "bān"; /* 䫫 */
dict[0x24aec] = "běng"; /* 䫬 */
dict[0x24af1] = "gōu"; /* 䫱 */
dict[0x24af2] = "líng"; /* 䫲 */
dict[0x24af5] = "kuò,guó"; /* 䫵 */
dict[0x24af6] = "qià"; /* 䫶 */
dict[0x24af7] = "jiào"; /* 䫷 */
dict[0x24af9] = "ēn"; /* 䫹 */
dict[0x24afa] = "yáo"; /* 䫺 */
dict[0x24afb] = "dū"; /* 䫻 */
dict[0x24b01] = "huǒ,guǒ,luǒ"; /* 䬁 */
dict[0x24b02] = "dǔ"; /* 䬂 */
dict[0x24b03] = "pēi"; /* 䬃 */
dict[0x24b0c] = "yuán"; /* 䬌 */
dict[0x24b0f] = "lóu"; /* 䬏 */
dict[0x24b10] = "xíng"; /* 䬐 */
dict[0x24b13] = "lián,liǎn"; /* 䬓 */
dict[0x24b14] = "yáo"; /* 䬔 */
dict[0x24b15] = "xī"; /* 䬕 */
dict[0x24b16] = "yáo"; /* 䬖 */
dict[0x24b18] = "xī"; /* 䬘 */
dict[0x24b1b] = "lú"; /* 䬛 */
dict[0x24b1d] = "yàn"; /* 䬝 */
dict[0x24b20] = "quán"; /* 䬠 */
dict[0x24b25] = "ráng"; /* 䬥 */
dict[0x24b26] = "wà"; /* 䬦 */
dict[0x24b27] = "zú"; /* 䬧 */
dict[0x24b28] = "fàn"; /* 䬨 */
dict[0x24b29] = "yì"; /* 䬩 */
dict[0x24b2a] = "dù,kān"; /* 䬪 */
dict[0x24b2b] = "suì"; /* 䬫 */
dict[0x24b2d] = "pī"; /* 䬭 */
dict[0x24b2f] = "hán,qiàn"; /* 䬯 */
dict[0x24b31] = "xù"; /* 䬱 */
dict[0x24b33] = "gǒng"; /* 䬳 */
dict[0x24b35] = "dì"; /* 䬵 */
dict[0x24b37] = "nà"; /* 䬷 */
dict[0x24b3e] = "duò,tuó"; /* 䬾 */
dict[0x24b3f] = "wā"; /* 䬿 */
dict[0x24b42] = "niè"; /* 䭂 */
dict[0x24b48] = "diào"; /* 䭈 */
dict[0x24b49] = "huāng"; /* 䭉 */
dict[0x24b4c] = "tí"; /* 䭌 */
dict[0x24b4d] = "fàn"; /* 䭍 */
dict[0x24b51] = "wú"; /* 䭑 */
dict[0x24b52] = "áng"; /* 䭒 */
dict[0x24b54] = "píng"; /* 䭔 */
dict[0x24b59] = "hán,gān"; /* 䭙 */
dict[0x24b5c] = "lí"; /* 䭜 */
dict[0x24b5e] = "dūn"; /* 䭞 */
dict[0x24b5f] = "fù"; /* 䭟 */
dict[0x24b60] = "nà"; /* 䭠 */
dict[0x24b62] = "suì"; /* 䭢 */
dict[0x24b67] = "jiē"; /* 䭧 */
dict[0x24b69] = "qìng"; /* 䭩 */
dict[0x24b6b] = "yīng"; /* 䭫 */
dict[0x24b6c] = "xiáng"; /* 䭬 */
dict[0x24b70] = "zhòu"; /* 䭰 */
dict[0x24b71] = "hú"; /* 䭱 */
dict[0x24b74] = "sù"; /* 䭴 */
dict[0x24b7b] = "gē"; /* 䭻 */
dict[0x24b7c] = "è"; /* 䭼 */
dict[0x24b7d] = "xù"; /* 䭽 */
dict[0x24b86] = "xī"; /* 䮆 */
dict[0x24b8a] = "kāng"; /* 䮊 */
dict[0x24b8b] = "guó"; /* 䮋 */
dict[0x24b8c] = "jiē"; /* 䮌 */
dict[0x24b8d] = "chuán"; /* 䮍 */
dict[0x24b8e] = "léi"; /* 䮎 */
dict[0x24b8f] = "héng"; /* 䮏 */
dict[0x24b90] = "zūn"; /* 䮐 */
dict[0x24b95] = "piè"; /* 䮕 */
dict[0x24b98] = "dēng"; /* 䮘 */
dict[0x24b99] = "xī"; /* 䮙 */
dict[0x24b9a] = "léi"; /* 䮚 */
dict[0x24b9c] = "shàn"; /* 䮜 */
dict[0x24ba7] = "lú"; /* 䮧 */
dict[0x24ba9] = "duì"; /* 䮩 */
dict[0x24baa] = "jùn"; /* 䮪 */
dict[0x24bad] = "chàn"; /* 䮭 */
dict[0x24baf] = "xié"; /* 䮯 */
dict[0x24bb0] = "wā"; /* 䮰 */
dict[0x24bb1] = "zhé"; /* 䮱 */
dict[0x24bb3] = "zhuān,guàn"; /* 䮳 */
dict[0x24bb7] = "liù"; /* 䮷 */
dict[0x24bb8] = "léi"; /* 䮸 */
dict[0x24bbc] = "dài"; /* 䮼 */
dict[0x24bbd] = "gān"; /* 䮽 */
dict[0x24bc4] = "shì"; /* 䯄 */
dict[0x24bc7] = "yǎn"; /* 䯇 */
dict[0x24bcc] = "gān"; /* 䯌 */
dict[0x24bd0] = "yán"; /* 䯐 */
dict[0x24bd6] = "suī"; /* 䯖 */
dict[0x24bda] = "zhōng"; /* 䯚 */
dict[0x24bdc] = "shì"; /* 䯜 */
dict[0x24be1] = "shèng"; /* 䯡 */
dict[0x24be5] = "chǎn"; /* 䯥 */
dict[0x24bf7] = "huáng"; /* 䯷 */
dict[0x24bf8] = "yìn"; /* 䯸 */
dict[0x24bfb] = "měng"; /* 䯻 */
dict[0x24c02] = "ráng"; /* 䰂 */
dict[0x24c05] = "xiáng"; /* 䰅 */
dict[0x24c08] = "bèi,fú"; /* 䰈 */
dict[0x24c0c] = "chuán"; /* 䰌 */
dict[0x24c11] = "pú"; /* 䰑 */
dict[0x24c19] = "gé,kē"; /* 䰙 */
dict[0x24c1a] = "lá"; /* 䰚 */
dict[0x24c1d] = "quǎn"; /* 䰝 */
dict[0x24c1f] = "hàng"; /* 䰟 */
dict[0x24c20] = "chì"; /* 䰠 */
dict[0x24c21] = "máng"; /* 䰡 */
dict[0x24c26] = "zhà"; /* 䰦 */
dict[0x24c2a] = "fèn"; /* 䰪 */
dict[0x24c2c] = "chào"; /* 䰬 */
dict[0x24c33] = "jǐng"; /* 䰳 */
dict[0x24c43] = "liè"; /* 䱃 */
dict[0x24c45] = "nà"; /* 䱅 */
dict[0x24c46] = "nà"; /* 䱆 */
dict[0x24c47] = "tóng"; /* 䱇 */
dict[0x24c4b] = "rán"; /* 䱋 */
dict[0x24c4c] = "zǔ"; /* 䱌 */
dict[0x24c4d] = "pī,pǒ"; /* 䱍 */
dict[0x24c4e] = "yǒu"; /* 䱎 */
dict[0x24c50] = "shū"; /* 䱐 */
dict[0x24c54] = "mǔ"; /* 䱔 */
dict[0x24c5b] = "liè"; /* 䱛 */
dict[0x24c5c] = "shōu"; /* 䱜 */
dict[0x24c5f] = "gǎo"; /* 䱟 */
dict[0x24c60] = "sháo"; /* 䱠 */
dict[0x24c61] = "tuó"; /* 䱡 */
dict[0x24c63] = "nán"; /* 䱣 */
dict[0x24c67] = "tuǒ"; /* 䱧 */
dict[0x24c68] = "gōng"; /* 䱨 */
dict[0x24c69] = "diào"; /* 䱩 */
dict[0x24c74] = "měng"; /* 䱴 */
dict[0x24c75] = "bāng"; /* 䱵 */
dict[0x24c77] = "xié"; /* 䱷 */
dict[0x24c78] = "sì"; /* 䱸 */
dict[0x24c79] = "tǐng"; /* 䱹 */
dict[0x24c7a] = "guì"; /* 䱺 */
dict[0x24c7d] = "fú"; /* 䱽 */
dict[0x24c7e] = "guì"; /* 䱾 */
dict[0x24c89] = "guì"; /* 䲉 */
dict[0x24c91] = "zhǔ"; /* 䲑 */
dict[0x24c93] = "lái"; /* 䲓 */
dict[0x24c95] = "lǔn"; /* 䲕 */
dict[0x24c96] = "tiǎn"; /* 䲖 */
dict[0x24c97] = "rǎn"; /* 䲗 */
dict[0x24c99] = "běn"; /* 䲙 */
dict[0x24c9a] = "dōng"; /* 䲚 */
dict[0x24ca8] = "juàn"; /* 䲨 */
dict[0x24ca9] = "yán"; /* 䲩 */
dict[0x24cac] = "ruán"; /* 䲬 */
dict[0x24cad] = "dǎn"; /* 䲭 */
dict[0x24cb0] = "mào"; /* 䲰 */
dict[0x24cb6] = "luán,niǎo"; /* 䲶 */
dict[0x24cb8] = "xù,zī"; /* 䲸 */
dict[0x24cba] = "xī"; /* 䲺 */
dict[0x24cc2] = "má"; /* 䳂 */
dict[0x24cc3] = "qī"; /* 䳃 */
dict[0x24cc5] = "chà"; /* 䳅 */
dict[0x24cc9] = "hàn"; /* 䳉 */
dict[0x24cca] = "píng"; /* 䳊 */
dict[0x24cce] = "jī"; /* 䳎 */
dict[0x24cd3] = "lì"; /* 䳓 */
dict[0x24cd5] = "yù"; /* 䳕 */
dict[0x24cd6] = "bān,fān"; /* 䳖 */
dict[0x24cd8] = "tēng"; /* 䳘 */
dict[0x24cdd] = "chóu"; /* 䳝 */
dict[0x24ce0] = "chóu"; /* 䳠 */
dict[0x24ce4] = "qī"; /* 䳤 */
dict[0x24ce5] = "xī"; /* 䳥 */
dict[0x24ce6] = "bèi"; /* 䳦 */
dict[0x24cea] = "yè"; /* 䳪 */
dict[0x24ced] = "guǎng"; /* 䳭 */
dict[0x24cef] = "zhù"; /* 䳯 */
dict[0x24cf3] = "huǐ"; /* 䳳 */
dict[0x24cf4] = "léi"; /* 䳴 */
dict[0x24cf5] = "chā"; /* 䳵 */
dict[0x24d00] = "guǎng,qiāo"; /* 䴀 */
dict[0x24d04] = "huǐ"; /* 䴄 */
dict[0x24d0d] = "dié"; /* 䴍 */
dict[0x24d12] = "léi"; /* 䴒 */
dict[0x24d13] = "yǎ"; /* 䴓 */
dict[0x24d18] = "niè"; /* 䴘 */
dict[0x24d19] = "shū,xū"; /* 䴙 */
dict[0x24d1f] = "zhì"; /* 䴟 */
dict[0x24d22] = "zhì"; /* 䴢 */
dict[0x24d23] = "pǐ"; /* 䴣 */
dict[0x24d25] = "jiū"; /* 䴥 */
dict[0x24d26] = "jiū"; /* 䴦 */
dict[0x24d27] = "yì"; /* 䴧 */
dict[0x24d28] = "yòu,yǒu"; /* 䴨 */
dict[0x24d2a] = "jiū"; /* 䴪 */
dict[0x24d2f] = "huàn"; /* 䴯 */
dict[0x24d31] = "dù"; /* 䴱 */
dict[0x24d3b] = "táo"; /* 䴻 */
dict[0x24d3c] = "qiè,cí"; /* 䴼 */
dict[0x24d3d] = "qín"; /* 䴽 */
dict[0x24d3e] = "xìn"; /* 䴾 */
dict[0x24d3f] = "chān"; /* 䴿 */
dict[0x24d40] = "jì"; /* 䵀 */
dict[0x24d42] = "qìn"; /* 䵂 */
dict[0x24d4a] = "dù"; /* 䵊 */
dict[0x24d4b] = "zhī"; /* 䵋 */
dict[0x24d4e] = "ǒu"; /* 䵎 */
dict[0x24d50] = "wù"; /* 䵐 */
dict[0x24d52] = "wén"; /* 䵒 */
dict[0x24d58] = "bì"; /* 䵘 */
dict[0x24d5a] = "tuó"; /* 䵚 */
dict[0x24d5b] = "bēi"; /* 䵛 */
dict[0x24d5d] = "mǔ"; /* 䵝 */
dict[0x24d5e] = "jìn"; /* 䵞 */
dict[0x24d5f] = "táo"; /* 䵟 */
dict[0x24d60] = "liáo"; /* 䵠 */
dict[0x24d61] = "hú"; /* 䵡 */
dict[0x24d65] = "cáo,zhǒu"; /* 䵥 */
dict[0x24d66] = "zhá"; /* 䵦 */
dict[0x24d6c] = "chǐ"; /* 䵬 */
dict[0x24d6d] = "yā"; /* 䵭 */
dict[0x24d6e] = "kuí"; /* 䵮 */
dict[0x24d6f] = "yìn"; /* 䵯 */
dict[0x24d78] = "lóng,pāng"; /* 䵸 */
dict[0x24d79] = "qià"; /* 䵹 */
dict[0x24d7b] = "hāng"; /* 䵻 */
dict[0x24d7c] = "shàng,shāng"; /* 䵼 */
dict[0x24d7d] = "hài"; /* 䵽 */
dict[0x24d7e] = "chā"; /* 䵾 */
dict[0x24d80] = "jiǎo"; /* 䶀 */
dict[0x24d81] = "lǎo"; /* 䶁 */
dict[0x24d88] = "xī"; /* 䶈 */
dict[0x24d8b] = "bó"; /* 䶋 */
dict[0x24d93] = "zhǐ"; /* 䶓 */
dict[0x24d95] = "tùn"; /* 䶕 */
dict[0x24d96] = "fú"; /* 䶖 */
dict[0x24d98] = "hū"; /* 䶘 */
dict[0x24d9a] = "niè"; /* 䶚 */
dict[0x24d9b] = "yì"; /* 䶛 */
dict[0x24d9c] = "zhuàng"; /* 䶜 */
dict[0x24da0] = "chá"; /* 䶠 */
dict[0x24da4] = "suān"; /* 䶤 */
dict[0x24dae] = "dù"; /* 䶮 */
dict[0x24db0] = "xī"; /* 䶰 */
dict[0x24db1] = "chuàn"; /* 䶱 */
dict[0x24db2] = "xíng"; /* 䶲 */
dict[0x24db3] = "jiǎo"; /* 䶳 */
dict[0x24db4] = "shēn"; /* 䶴 */
dict[0x24db8] = "nā"; /* 䶸 */
dict[0x24dc0] = "wāng"; /* ䷀ */
dict[0x24dc1] = "bēi"; /* ䷁ */
dict[0x24dc2] = "féi"; /* ䷂ */
dict[0x24dc3] = "jiàn"; /* ䷃ */
dict[0x24dc4] = "quán"; /* ䷄ */
dict[0x24dc5] = "yì,yá"; /* ䷅ */
dict[0x24dc6] = "dōng"; /* ䷆ */
dict[0x24dc7] = "xù"; /* ䷇ */
dict[0x24dc8] = "nà,niè"; /* ䷈ */
dict[0x24dc9] = "jí"; /* ䷉ */
dict[0x24dcc] = "zhěn"; /* ䷌ */
dict[0x24dcd] = "qí"; /* ䷍ */
dict[0x24dce] = "duī"; /* ䷎ */
dict[0x24dcf] = "yín"; /* ䷏ */
dict[0x24dd1] = "jiù"; /* ䷑ */
dict[0x24dd2] = "pí,bì,bēi"; /* ䷒ */
dict[0x24dd3] = "xìn"; /* ䷓ */
dict[0x24dd4] = "lún"; /* ䷔ */
dict[0x24dd5] = "cǎi"; /* ䷕ */
dict[0x24dd6] = "lìng"; /* ䷖ */
dict[0x24dd7] = "biē"; /* ䷗ */
dict[0x24dd8] = "dào"; /* ䷘ */
dict[0x24dd9] = "dé"; /* ䷙ */
dict[0x24ddf] = "la"; /* ䷟ */
dict[0x24de1] = "xī,nüè"; /* ䷡ */
dict[0x24de2] = "jù"; /* ䷢ */
dict[0x24de4] = "xiáo"; /* ䷤ */
dict[0x24de6] = "jīng"; /* ䷦ */
dict[0x24dea] = "měng"; /* ䷪ */
dict[0x24df9] = "wài"; /* ䷹ */
dict[0x24dfb] = "nǎo"; /* ䷻ */
dict[0x24dfc] = "xiāng"; /* ䷼ */
dict[0x24dfd] = "què"; /* ䷽ */
dict[0x24dfe] = "qiè"; /* ䷾ */
dict[0x24dff] = "tū"; /* ䷿ */
dict[0x24e00] = "xǔ"; /* 一 */
dict[0x24e01] = "huì"; /* 丁 */
dict[0x24e03] = "shòu"; /* 七 */
dict[0x24e05] = "mín"; /* 丅 */
dict[0x24e06] = "wěi"; /* 丆 */
dict[0x24e08] = "yóu"; /* 丈 */
dict[0x24e09] = "tuí"; /* 三 */
dict[0x24e0a] = "dài"; /* 上 */
dict[0x24e0b] = "jiè"; /* 下 */
dict[0x24e0e] = "kě,hài"; /* 与 */
dict[0x24e0f] = "nà,niè"; /* 丏 */
dict[0x24e11] = "fù"; /* 丑 */
dict[0x24e12] = "yù"; /* 丒 */
dict[0x24e13] = "zhǐ"; /* 专 */
dict[0x24e15] = "hān"; /* 丕 */
dict[0x24e16] = "āi"; /* 世 */
dict[0x24e17] = "fù"; /* 丗 */
dict[0x24e21] = "yāng"; /* 両 */
dict[0x24e24] = "shí"; /* 两 */
dict[0x24e26] = "chán"; /* 並 */
dict[0x24e2a] = "chì"; /* 个 */
dict[0x24e2b] = "yùn"; /* 丫 */
dict[0x24e2c] = "shuāi"; /* 丬 */
dict[0x24e2e] = "sù"; /* 丮 */
dict[0x24e2f] = "sǎng"; /* 丯 */
dict[0x24e31] = "è,kè,kài,yà"; /* 丱 */
dict[0x24e32] = "zhěng"; /* 串 */
dict[0x24e33] = "ái"; /* 丳 */
dict[0x24e34] = "suǒ"; /* 临 */
dict[0x24e35] = "bù"; /* 丵 */
dict[0x24e37] = "qún"; /* 丷 */
dict[0x24e38] = "yì"; /* 丸 */
dict[0x24e39] = "yǎn"; /* 丹 */
dict[0x24e3b] = "nà"; /* 主 */
dict[0x24e3c] = "wǔ"; /* 丼 */
dict[0x24e47] = "lì"; /* 乇 */
dict[0x24e48] = "lì"; /* 么 */
dict[0x24e4a] = "xī"; /* 乊 */
dict[0x24e4b] = "jué"; /* 之 */
dict[0x24e4c] = "shī"; /* 乌 */
dict[0x24e4e] = "yǎ"; /* 乎 */
dict[0x24e50] = "liè"; /* 𤹐 */
dict[0x24e5b] = "chén"; /* 乛 */
dict[0x24e5c] = "yíng"; /* 乜 */
dict[0x24e5d] = "bì"; /* 九 */
dict[0x24e5e] = "chè"; /* 乞 */
dict[0x24e61] = "zhā"; /* 乡 */
dict[0x24e62] = "tuǒ"; /* 乢 */
dict[0x24e63] = "hù"; /* 乣 */
dict[0x24e64] = "téng"; /* 乤 */
dict[0x24e65] = "yìng"; /* 乥 */
dict[0x24e66] = "bǐ"; /* 书 */
dict[0x24e67] = "níng"; /* 乧 */
dict[0x24e68] = "liàn"; /* 乨 */
dict[0x24e69] = "xìn"; /* 乩 */
dict[0x24e6a] = "yǔ"; /* 乪 */
dict[0x24e6f] = "tòng"; /* 乯 */
dict[0x24e72] = "bèi"; /* 乲 */
dict[0x24e74] = "mó"; /* 乴 */
dict[0x24e75] = "duī"; /* 乵 */
dict[0x24e77] = "dǎo"; /* 乷 */
dict[0x24e78] = "qí"; /* 乸 */
dict[0x24e80] = "shuāi"; /* 亀 */
dict[0x24e83] = "xiāo,jiāo,yāo"; /* 亃 */
dict[0x24e84] = "zhǒng,tóng"; /* 亄 */
dict[0x24e85] = "zhuì"; /* 亅 */
dict[0x24e87] = "biàn"; /* 亇 */
dict[0x24e89] = "wěi"; /* 争 */
dict[0x24e8a] = "xī,sī"; /* 亊 */
dict[0x24e8c] = "dēng"; /* 二 */
dict[0x24e8e] = "xiē"; /* 于 */
dict[0x24e8f] = "pān"; /* 亏 */
dict[0x24e90] = "niè"; /* 亐 */
dict[0x24e93] = "bié"; /* 亓 */
dict[0x24e94] = "shè"; /* 五 */
dict[0x24e95] = "fèi"; /* 井 */
dict[0x24e96] = "mǐn"; /* 亖 */
dict[0x24e97] = "qì,jì"; /* 亗 */
dict[0x24e98] = "yǎ"; /* 亘 */
dict[0x24eaa] = "shàn"; /* 亪 */
dict[0x24eab] = "suǒ"; /* 享 */
dict[0x24eb7] = "jí"; /* 亷 */
dict[0x24eba] = "dǎn,dàn,tán"; /* 人 */
dict[0x24ebb] = "juàn"; /* 亻 */
dict[0x24ebc] = "lù"; /* 亼 */
dict[0x24ebe] = "ào"; /* 亾 */
dict[0x24ec2] = "yì"; /* 仂 */
dict[0x24ec3] = "shǔ"; /* 仃 */
dict[0x24ec4] = "suì"; /* 仄 */
dict[0x24ec5] = "wèi"; /* 仅 */
dict[0x24ec6] = "wán"; /* 仆 */
dict[0x24ec7] = "chǔ"; /* 仇 */
dict[0x24ecc] = "wò"; /* 仌 */
dict[0x24ed6] = "bì"; /* 他 */
dict[0x24ed8] = "yǐn"; /* 付 */
dict[0x24ed9] = "huó"; /* 仙 */
dict[0x24edc] = "kài,è"; /* 仜 */
dict[0x24edd] = "níng"; /* 仝 */
dict[0x24ee2] = "ài"; /* 仢 */
dict[0x24ee4] = "lì"; /* 令 */
dict[0x24ee6] = "zhāi"; /* 仦 */
dict[0x24ef1] = "lù"; /* 仱 */
dict[0x24ef2] = "liáo"; /* 仲 */
dict[0x24ef6] = "biàn"; /* 件 */
dict[0x24ef7] = "pán"; /* 价 */
dict[0x24eff] = "guì"; /* 仿 */
dict[0x24f00] = "sū"; /* 伀 */
dict[0x24f01] = "méng"; /* 企 */
dict[0x24f02] = "xiǎn"; /* 伂 */
dict[0x24f03] = "lòng,lóng"; /* 伃 */
dict[0x24f05] = "qì"; /* 伅 */
dict[0x24f0b] = "chàn"; /* 伋 */
dict[0x24f0c] = "yì"; /* 伌 */
dict[0x24f0d] = "háng"; /* 伍 */
dict[0x24f0f] = "liǎn"; /* 伏 */
dict[0x24f10] = "guàn,huàn"; /* 伐 */
dict[0x24f12] = "wěi,huà"; /* 伒 */
dict[0x24f17] = "jué"; /* 众 */
dict[0x24f18] = "léi"; /* 优 */
dict[0x24f19] = "luán"; /* 伙 */
dict[0x24f1a] = "lì"; /* 会 */
dict[0x24f1c] = "pí"; /* 伜 */
dict[0x24f22] = "huǎn"; /* 伢 */
dict[0x24f24] = "pì"; /* 伤 */
dict[0x24f2e] = "guī"; /* 伮 */
dict[0x24f33] = "jú"; /* 伳 */
dict[0x24f35] = "fā"; /* 伵 */
dict[0x24f36] = "dēng"; /* 伶 */
dict[0x24f3a] = "fèi"; /* 伺 */
dict[0x24f41] = "zhī"; /* 佁 */
dict[0x24f43] = "mèi"; /* 佃 */
dict[0x24f45] = "huàn"; /* 佅 */
dict[0x24f49] = "pā"; /* 佉 */
dict[0x24f4a] = "bǐ"; /* 佊 */
dict[0x24f4c] = "pō"; /* 佌 */
dict[0x24f53] = "ér"; /* 体 */
dict[0x24f55] = "huàn"; /* 何 */
dict[0x24f63] = "chàng"; /* 佣 */
dict[0x24f65] = "luò"; /* 佥 */
dict[0x24f66] = "fǒu"; /* 佦 */
dict[0x24f71] = "zú"; /* 佱 */
dict[0x24f72] = "nán"; /* 佲 */
dict[0x24f73] = "xiǎo"; /* 佳 */
dict[0x24f79] = "bài"; /* 佹 */
dict[0x24f7a] = "lù"; /* 佺 */
dict[0x24f7c] = "luò"; /* 佼 */
dict[0x24f7f] = "niàn"; /* 使 */
dict[0x24f84] = "zhù"; /* 侄 */
dict[0x24f85] = "hú"; /* 侅 */
dict[0x24f88] = "huī"; /* 侈 */
dict[0x24f89] = "tǎng"; /* 侉 */
dict[0x24f8a] = "chóu"; /* 侊 */
dict[0x24f91] = "huáng"; /* 侑 */
dict[0x24f92] = "dōu"; /* 侒 */
dict[0x24f95] = "tì"; /* 侕 */
dict[0x24f9b] = "miào"; /* 供 */
dict[0x24f9d] = "bó"; /* 依 */
dict[0x24fa0] = "dì"; /* 侠 */
dict[0x24fa2] = "děng"; /* 侢 */
dict[0x24fa3] = "pū"; /* 侣 */
dict[0x24fa5] = "sōng"; /* 侥 */
dict[0x24fa6] = "chóu"; /* 侦 */
dict[0x24fab] = "yào"; /* 侫 */
dict[0x24fac] = "měng"; /* 侬 */
dict[0x24fad] = "lóng"; /* 侭 */
dict[0x24fb2] = "lián"; /* 侲 */
dict[0x24fb5] = "bié"; /* 侵 */
dict[0x24fba] = "lǚ"; /* 侺 */
dict[0x24fbf] = "sè"; /* 便 */
dict[0x24fc0] = "zuó"; /* 俀 */
dict[0x24fc4] = "cún"; /* 俄 */
dict[0x24fc5] = "líng"; /* 俅 */
dict[0x24fc6] = "zhěng"; /* 俆 */
dict[0x24fc7] = "pǐ"; /* 俇 */
dict[0x24fc8] = "báo"; /* 俈 */
dict[0x24fcb] = "què"; /* 俋 */
dict[0x24fce] = "pī"; /* 俎 */
dict[0x24fcf] = "nàn"; /* 俏 */
dict[0x24fd0] = "pī"; /* 俐 */
dict[0x24fd1] = "bǒ"; /* 俑 */
dict[0x24fd2] = "bèi"; /* 俒 */
dict[0x24fd3] = "fā"; /* 俓 */
dict[0x24fd5] = "mǐn"; /* 俕 */
dict[0x24fd6] = "mò"; /* 俖 */
dict[0x24fd7] = "wà"; /* 俗 */
dict[0x24fd8] = "zhāo"; /* 俘 */
dict[0x24fd9] = "zhì,pí"; /* 俙 */
dict[0x24fda] = "cū"; /* 俚 */
dict[0x24fdf] = "xún"; /* 俟 */
dict[0x24fe0] = "jí"; /* 俠 */
dict[0x24fe1] = "guì,qí"; /* 信 */
dict[0x24fe3] = "chéng"; /* 俣 */
dict[0x24fe7] = "hàn"; /* 俧 */
dict[0x24fe8] = "xiào"; /* 俨 */
dict[0x24fe9] = "què"; /* 俩 */
dict[0x24feb] = "chuò"; /* 俫 */
dict[0x24fed] = "fǔ"; /* 俭 */
dict[0x24ff3] = "qǐn"; /* 俳 */
dict[0x24ff4] = "lù"; /* 俴 */
dict[0x24ff5] = "què"; /* 俵 */
dict[0x24ff6] = "diǎn"; /* 俶 */
dict[0x24ff7] = "qiān"; /* 俷 */
dict[0x24ffc] = "chǎng"; /* 俼 */
dict[0x24ffd] = "tà"; /* 俽 */
dict[0x24ffe] = "bēi"; /* 俾 */
dict[0x25001] = "dù"; /* 倁 */
dict[0x25002] = "běng,bāng"; /* 倂 */
dict[0x25003] = "hòu"; /* 倃 */
dict[0x25008] = "zhǎ"; /* 倈 */
dict[0x25009] = "zhǎ"; /* 倉 */
dict[0x2500e] = "què"; /* 倎 */
dict[0x2500f] = "má"; /* 倏 */
dict[0x25010] = "hán"; /* 倐 */
dict[0x25013] = "liú"; /* 倓 */
dict[0x25014] = "lù"; /* 倔 */
dict[0x25016] = "zī"; /* 倖 */
dict[0x25018] = "pǐ"; /* 倘 */
dict[0x25019] = "zhòu"; /* 候 */
dict[0x2501b] = "zāo"; /* 倛 */
dict[0x2501d] = "niǔ"; /* 倝 */
dict[0x25020] = "huì"; /* 倠 */
dict[0x25023] = "xué,qiào"; /* 倣 */
dict[0x25025] = "là"; /* 倥 */
dict[0x2502b] = "nóu,rǎn"; /* 倫 */
dict[0x2502c] = "yǎn,yè"; /* 倬 */
dict[0x2502d] = "rǎn"; /* 倭 */
dict[0x2502e] = "nǎo"; /* 倮 */
dict[0x25030] = "là"; /* 倰 */
dict[0x25031] = "guǎng"; /* 倱 */
dict[0x25032] = "dú"; /* 倲 */
dict[0x25035] = "lú"; /* 倵 */
dict[0x25039] = "jiǎn"; /* 倹 */
dict[0x2503a] = "xiè"; /* 债 */
dict[0x2503b] = "qì"; /* 倻 */
dict[0x2503e] = "xiàng"; /* 倾 */
dict[0x25041] = "guǒ"; /* 偁 */
dict[0x25042] = "jié"; /* 偂 */
dict[0x25043] = "màng"; /* 偃 */
dict[0x25046] = "xiā"; /* 偆 */
dict[0x25047] = "kuī"; /* 假 */
dict[0x2504e] = "yòng"; /* 偎 */
dict[0x25050] = "hǎi"; /* 偐 */
dict[0x25051] = "mì"; /* 偑 */
dict[0x25052] = "yào"; /* 偒 */
dict[0x25055] = "wēn"; /* 偕 */
dict[0x2505f] = "lì"; /* 偟 */
dict[0x25060] = "juàn,quán,quān"; /* 偠 */
dict[0x25061] = "wū"; /* 偡 */
dict[0x2506e] = "diào"; /* 偮 */
dict[0x2506f] = "chù,chuò"; /* 偯 */
dict[0x25072] = "suō"; /* 偲 */
dict[0x25075] = "chōng"; /* 偵 */
dict[0x25078] = "quān"; /* 偸 */
dict[0x25079] = "shè"; /* 偹 */
dict[0x25081] = "yán"; /* 傁 */
dict[0x25082] = "měng"; /* 傂 */
dict[0x25083] = "jù"; /* 傃 */
dict[0x2508b] = "tú"; /* 傋 */
dict[0x25092] = "nóng"; /* 傒 */
dict[0x25093] = "mó"; /* 傓 */
dict[0x25099] = "fèn"; /* 備 */
dict[0x250a2] = "áo"; /* 傢 */
dict[0x250a3] = "guō"; /* 傣 */
dict[0x250a4] = "hú"; /* 傤 */
dict[0x250a5] = "cán"; /* 傥 */
dict[0x250a6] = "dūn"; /* 傦 */
dict[0x250a7] = "hǎi"; /* 傧 */
dict[0x250a8] = "jiǎo"; /* 储 */
dict[0x250b0] = "gū"; /* 傰 */
dict[0x250b5] = "jīn"; /* 債 */
dict[0x250b8] = "yáng"; /* 傸 */
dict[0x250c0] = "chà"; /* 僀 */
dict[0x250cc] = "huī"; /* 僌 */
dict[0x250d4] = "qú"; /* 僔 */
dict[0x250d5] = "kē"; /* 僕 */
dict[0x250dc] = "qú"; /* 僜 */
dict[0x250df] = "qīng"; /* 僟 */
dict[0x250e0] = "yì"; /* 僠 */
dict[0x250e3] = "kǎi"; /* 僣 */
dict[0x250e4] = "jiǎo"; /* 僤 */
dict[0x250e7] = "chōu,jiǎo,yǎo"; /* 僧 */
dict[0x250e8] = "bǔ"; /* 僨 */
dict[0x250e9] = "gèn,yǎn"; /* 僩 */
dict[0x250ea] = "jiāo"; /* 僪 */
dict[0x250eb] = "zhī"; /* 僫 */
dict[0x250ee] = "wèn"; /* 僮 */
dict[0x250ef] = "yào"; /* 僯 */
dict[0x250f0] = "bīn"; /* 僰 */
dict[0x250f4] = "xiòng"; /* 僴 */
dict[0x250f5] = "fàn"; /* 僵 */
dict[0x250f8] = "yí"; /* 僸 */
dict[0x250f9] = "chuàn"; /* 價 */
dict[0x250fa] = "yào"; /* 僺 */
dict[0x250fd] = "yāng"; /* 僽 */
dict[0x250fe] = "dù"; /* 僾 */
dict[0x250ff] = "yǎn"; /* 僿 */
dict[0x25101] = "méng"; /* 儁 */
dict[0x25107] = "chī,hūn"; /* 儇 */
dict[0x25108] = "mù"; /* 儈 */
dict[0x25109] = "jiāo"; /* 儉 */
dict[0x2510b] = "nǜ"; /* 儋 */
dict[0x2510d] = "guó"; /* 儍 */
dict[0x2510e] = "xuè"; /* 儎 */
dict[0x25111] = "fú"; /* 儑 */
dict[0x25112] = "xuē"; /* 儒 */
dict[0x25113] = "fū"; /* 儓 */
dict[0x25114] = "pèi,pò"; /* 儔 */
dict[0x25115] = "mò"; /* 儕 */
dict[0x25116] = "xī"; /* 儖 */
dict[0x25117] = "wò,nài"; /* 儗 */
dict[0x25118] = "shǎn"; /* 儘 */
dict[0x2511b] = "xī"; /* 儛 */
dict[0x2511c] = "qì"; /* 儜 */
dict[0x2511d] = "miàn"; /* 儝 */
dict[0x25122] = "xiāng"; /* 儢 */
dict[0x25126] = "dǎn"; /* 儦 */
dict[0x2512b] = "jí"; /* 儫 */
dict[0x25131] = "fèi"; /* 儱 */
dict[0x25132] = "mié"; /* 儲 */
dict[0x25134] = "xuè,jué"; /* 儴 */
dict[0x25135] = "xù,yù"; /* 儵 */
dict[0x25136] = "sī"; /* 儶 */
dict[0x25137] = "jǔ"; /* 儷 */
dict[0x25138] = "mǎo"; /* 儸 */
dict[0x25139] = "bào"; /* 儹 */
dict[0x2513b] = "yí"; /* 儻 */
dict[0x2513c] = "guā"; /* 儼 */
dict[0x2513d] = "nì"; /* 儽 */
dict[0x2513f] = "yí,dì"; /* 儿 */
dict[0x25141] = "zuò"; /* 允 */
dict[0x25144] = "nǔ"; /* 兄 */
dict[0x25151] = "diàn"; /* 兑 */
dict[0x25152] = "fàn"; /* 兒 */
dict[0x25153] = "yì"; /* 兓 */
dict[0x25154] = "shì"; /* 兔 */
dict[0x25157] = "cū"; /* 兗 */
dict[0x25158] = "zhěn,mí"; /* 兘 */
dict[0x2515e] = "shì"; /* 兞 */
dict[0x2515f] = "jiǎo"; /* 兟 */
dict[0x25160] = "hòu"; /* 兠 */
dict[0x25161] = "ér"; /* 兡 */
dict[0x25166] = "lèi"; /* 兦 */
dict[0x25167] = "xuè"; /* 內 */
dict[0x25168] = "gèng"; /* 全 */
dict[0x2516a] = "shōu"; /* 兪 */
dict[0x2516c] = "juān"; /* 公 */
dict[0x25175] = "wéi"; /* 兵 */
dict[0x25177] = "shǒu"; /* 具 */
dict[0x25178] = "jìng"; /* 典 */
dict[0x2517a] = "xú"; /* 兺 */
dict[0x2517b] = "chòng"; /* 养 */
dict[0x2517d] = "mì"; /* 兽 */
dict[0x25185] = "jiāng"; /* 内 */
dict[0x25186] = "mòu"; /* 円 */
dict[0x25189] = "yù"; /* 冉 */
dict[0x2518c] = "jué"; /* 册 */
dict[0x25191] = "tìng"; /* 冑 */
dict[0x25194] = "xiāo"; /* 冔 */
dict[0x25196] = "dōu"; /* 冖 */
dict[0x25198] = "guó"; /* 冘 */
dict[0x25199] = "máng"; /* 写 */
dict[0x2519a] = "wāng"; /* 冚 */
dict[0x2519b] = "xù"; /* 军 */
dict[0x2519c] = "wàng"; /* 农 */
dict[0x2519d] = "suō"; /* 冝 */
dict[0x2519e] = "juàn"; /* 冞 */
dict[0x2519f] = "yuè"; /* 冟 */
dict[0x251a1] = "hán"; /* 冡 */
dict[0x251a3] = "shēn"; /* 冣 */
dict[0x251a5] = "xié"; /* 冥 */
dict[0x251a6] = "liú"; /* 冦 */
dict[0x251af] = "bì"; /* 冯 */
dict[0x251b2] = "nào"; /* 冲 */
dict[0x251b3] = "dū"; /* 决 */
dict[0x251b6] = "wàn"; /* 冶 */
dict[0x251b7] = "jiù"; /* 冷 */
dict[0x251b8] = "quē"; /* 冸 */
dict[0x251c4] = "nì"; /* 凄 */
dict[0x251c6] = "mí"; /* 准 */
dict[0x251c7] = "suō"; /* 凇 */
dict[0x251c9] = "qiǎng"; /* 凉 */
dict[0x251cc] = "hàn,qià"; /* 凌 */
dict[0x251cd] = "zhuó"; /* 凍 */
dict[0x251ce] = "mí"; /* 凎 */
dict[0x251cf] = "xù"; /* 减 */
dict[0x251d1] = "lǎng"; /* 凑 */
dict[0x251d2] = "jié"; /* 凒 */
dict[0x251d3] = "dìng"; /* 凓 */
dict[0x251d4] = "chàng,zhāng"; /* 凔 */
dict[0x251d5] = "zhì"; /* 凕 */
dict[0x251d6] = "fēi"; /* 凖 */
dict[0x251d7] = "jiá"; /* 凗 */
dict[0x251d8] = "jùn"; /* 凘 */
dict[0x251d9] = "huò"; /* 凙 */
dict[0x251da] = "qī"; /* 凚 */
dict[0x251db] = "jū,jù,xì"; /* 凛 */
dict[0x251dc] = "zhūn,guō"; /* 凜 */
dict[0x251de] = "diàn"; /* 凞 */
dict[0x251df] = "jiǎo"; /* 凟 */
dict[0x251e0] = "yā"; /* 几 */
dict[0x251ed] = "zhī"; /* 凭 */
dict[0x251ef] = "mài"; /* 凯 */
dict[0x251f0] = "hū"; /* 凰 */
dict[0x251f1] = "xiè"; /* 凱 */
dict[0x251f2] = "shí"; /* 凲 */
dict[0x251f3] = "guī"; /* 凳 */
dict[0x251ff] = "xù"; /* 凿 */
dict[0x25202] = "jí"; /* 刂 */
dict[0x25204] = "chuàng"; /* 刄 */
dict[0x25206] = "mào"; /* 分 */
dict[0x25207] = "ruán"; /* 切 */
dict[0x25208] = "xū"; /* 刈 */
dict[0x25209] = "huàn"; /* 刉 */
dict[0x2520a] = "shà"; /* 刊 */
dict[0x2520b] = "jǔ"; /* 刋 */
dict[0x2520f] = "kuàng"; /* 刏 */
dict[0x25211] = "hóu"; /* 刑 */
dict[0x25212] = "guān"; /* 划 */
dict[0x25213] = "guā"; /* 刓 */
dict[0x25215] = "mí"; /* 刕 */
dict[0x25216] = "dié"; /* 刖 */
dict[0x25217] = "bì"; /* 列 */
dict[0x25218] = "liǎng"; /* 刘 */
dict[0x25219] = "là"; /* 则 */
dict[0x2521a] = "shǎn"; /* 刚 */
dict[0x2521b] = "lù"; /* 创 */
dict[0x2521c] = "xì"; /* 刜 */
dict[0x2521f] = "sǒu"; /* 刟 */
dict[0x2522c] = "ōu"; /* 刬 */
dict[0x2522e] = "léng"; /* 刮 */
dict[0x25237] = "kū"; /* 刷 */
dict[0x25238] = "guī"; /* 券 */
dict[0x2523b] = "xī"; /* 刻 */
dict[0x2523c] = "pán,pān"; /* 刼 */
dict[0x2523d] = "sè"; /* 刽 */
dict[0x2523e] = "juè"; /* 刾 */
dict[0x2523f] = "hòng"; /* 刿 */
dict[0x25240] = "guàn"; /* 剀 */
dict[0x25241] = "jù"; /* 剁 */
dict[0x25243] = "nài"; /* 剃 */
dict[0x25244] = "huá"; /* 剄 */
dict[0x25245] = "gé"; /* 剅 */
dict[0x25246] = "lì"; /* 剆 */
dict[0x25247] = "gòu"; /* 則 */
dict[0x25248] = "tì"; /* 剈 */
dict[0x2524a] = "mà"; /* 削 */
dict[0x2524b] = "téng"; /* 剋 */
dict[0x2524c] = "dá"; /* 剌 */
dict[0x25250] = "qī"; /* 剐 */
dict[0x25251] = "yù,hè"; /* 剑 */
dict[0x25252] = "jiǎo"; /* 剒 */
dict[0x25253] = "miè"; /* 剓 */
dict[0x25254] = "gěng"; /* 剔 */
dict[0x25255] = "mèng,méng"; /* 剕 */
dict[0x25256] = "wèi"; /* 剖 */
dict[0x25258] = "tí"; /* 剘 */
dict[0x25259] = "qí"; /* 剙 */
dict[0x2525c] = "chén"; /* 剜 */
dict[0x2525d] = "dōu"; /* 剝 */
dict[0x2525f] = "pán"; /* 剟 */
dict[0x25270] = "hàn,qià"; /* 剰 */
dict[0x25273] = "liū"; /* 剳 */
dict[0x25274] = "mì"; /* 剴 */
dict[0x25275] = "má"; /* 創 */
dict[0x25276] = "lù"; /* 剶 */
dict[0x25277] = "qī"; /* 剷 */
dict[0x25278] = "kēng"; /* 剸 */
dict[0x2527a] = "dié"; /* 剺 */
dict[0x2527b] = "qì"; /* 剻 */
dict[0x2527c] = "jiāo"; /* 剼 */
dict[0x2527d] = "kāng"; /* 剽 */
dict[0x2527e] = "qiāo"; /* 剾 */
dict[0x2527f] = "mì"; /* 剿 */
dict[0x25280] = "shān,sǎn"; /* 劀 */
dict[0x25287] = "jiān"; /* 劇 */
dict[0x25288] = "lí"; /* 劈 */
dict[0x25289] = "kè"; /* 劉 */
dict[0x2528a] = "xù"; /* 劊 */
dict[0x2528c] = "cháo"; /* 劌 */
dict[0x25291] = "mán,màn"; /* 劑 */
dict[0x25292] = "fèng"; /* 劒 */
dict[0x25293] = "chàn"; /* 劓 */
dict[0x25294] = "huǐ"; /* 劔 */
dict[0x252a7] = "kòu"; /* 劧 */
dict[0x252aa] = "wěi"; /* 努 */
dict[0x252ab] = "guàn"; /* 劫 */
dict[0x252ac] = "jí"; /* 劬 */
dict[0x252ad] = "zùn"; /* 劭 */
dict[0x252ae] = "huò"; /* 劮 */
dict[0x252af] = "xié"; /* 劯 */
dict[0x252b4] = "suì"; /* 労 */
dict[0x252b6] = "ruǎn"; /* 劶 */
dict[0x252b8] = "tè"; /* 劸 */
dict[0x252bc] = "zhèng"; /* 劼 */
dict[0x252bd] = "kūn"; /* 劽 */
dict[0x252be] = "xiǎng"; /* 劾 */
dict[0x252bf] = "mián"; /* 势 */
dict[0x252c1] = "xì"; /* 勁 */
dict[0x252c7] = "chèng"; /* 勇 */
dict[0x252cc] = "sā"; /* 勌 */
dict[0x252ce] = "mèi"; /* 勎 */
dict[0x252d9] = "è"; /* 務 */
dict[0x252da] = "miè"; /* 勚 */
dict[0x252db] = "zhǔ"; /* 勛 */
dict[0x252dc] = "zōu"; /* 勜 */
dict[0x252dd] = "měng"; /* 勝 */
dict[0x252df] = "xī"; /* 募 */
dict[0x252e1] = "táng"; /* 勡 */
dict[0x252e3] = "jià"; /* 勣 */
dict[0x252e4] = "cháng"; /* 勤 */
dict[0x252e5] = "jí"; /* 勥 */
dict[0x252ee] = "zhuó"; /* 勮 */
dict[0x252ff] = "hè"; /* 勿 */
dict[0x25300] = "chá"; /* 匀 */
dict[0x25301] = "qì"; /* 匁 */
dict[0x25302] = "mián"; /* 匂 */
dict[0x25304] = "kū"; /* 匄 */
dict[0x25305] = "yè"; /* 包 */
dict[0x25306] = "zhōu"; /* 匆 */
dict[0x25308] = "jiān"; /* 匈 */
dict[0x2530a] = "pàn"; /* 匊 */
dict[0x2530d] = "huī"; /* 匍 */
dict[0x2530f] = "míng"; /* 匏 */
dict[0x25310] = "liù"; /* 匐 */
dict[0x25318] = "shuì"; /* 匘 */
dict[0x2531a] = "mài,yá,shù"; /* 匚 */
dict[0x2531b] = "lí"; /* 匛 */
dict[0x2531e] = "shuò"; /* 匞 */
dict[0x2531f] = "yí"; /* 匟 */
dict[0x25324] = "lì"; /* 匤 */
dict[0x25328] = "xiē,miè"; /* 匨 */
dict[0x25329] = "tè"; /* 匩 */
dict[0x2532a] = "xiū"; /* 匪 */
dict[0x2532d] = "xuàn"; /* 匭 */
dict[0x2532e] = "lì"; /* 匮 */
dict[0x2532f] = "méng"; /* 匯 */
dict[0x25330] = "wéi"; /* 匰 */
dict[0x25331] = "méng"; /* 匱 */
dict[0x2533a] = "yào"; /* 区 */
dict[0x2533b] = "lán"; /* 医 */
dict[0x2533c] = "líng"; /* 匼 */
dict[0x2533d] = "yīng"; /* 匽 */
dict[0x2533e] = "yīng"; /* 匾 */
dict[0x2533f] = "lì"; /* 匿 */
dict[0x25340] = "jiǎn"; /* 區 */
dict[0x25341] = "guī,guì"; /* 十 */
dict[0x25345] = "guān"; /* 卅 */
dict[0x25346] = "xiè"; /* 卆 */
dict[0x25349] = "shè"; /* 卉 */
dict[0x2534b] = "zuī,xiē,huǐ"; /* 卋 */
dict[0x25353] = "kàn,yǎn"; /* 卓 */
dict[0x25354] = "léi"; /* 協 */
dict[0x2535a] = "biàn"; /* 博 */
dict[0x2535d] = "shǔ"; /* 卝 */
dict[0x2535e] = "nǜ"; /* 卞 */
dict[0x2535f] = "xù,yì"; /* 卟 */
dict[0x25363] = "hào"; /* 卣 */
dict[0x25368] = "guǐ"; /* 卨 */
dict[0x2536a] = "zhài"; /* 卪 */
dict[0x2536b] = "láng"; /* 卫 */
dict[0x2536c] = "cuān"; /* 卬 */
dict[0x2536d] = "zhì"; /* 卭 */
dict[0x2536e] = "féng,fēng"; /* 卮 */
dict[0x2536f] = "qīn"; /* 卯 */
dict[0x25371] = "zé"; /* 危 */
dict[0x25372] = "nà"; /* 卲 */
dict[0x25373] = "niǔ"; /* 即 */
dict[0x25374] = "yì"; /* 却 */
dict[0x25377] = "cōng"; /* 卷 */
dict[0x25378] = "shī"; /* 卸 */
dict[0x25379] = "jiǎn"; /* 卹 */
dict[0x2537a] = "zōng"; /* 卺 */
dict[0x2537b] = "yǎn"; /* 卻 */
dict[0x2537c] = "yīng"; /* 卼 */
dict[0x25380] = "ruǎn"; /* 厀 */
dict[0x25382] = "róng"; /* 厂 */
dict[0x25383] = "xì"; /* 厃 */
dict[0x25385] = "guān"; /* 厅 */
dict[0x25386] = "kài"; /* 历 */
dict[0x25388] = "wù"; /* 厈 */
dict[0x2538a] = "qín"; /* 厊 */
dict[0x2538b] = "cōng"; /* 压 */
dict[0x2538d] = "zé"; /* 厍 */
dict[0x2538e] = "xiè"; /* 厎 */
dict[0x25390] = "yù"; /* 厐 */
dict[0x25391] = "zàn"; /* 厑 */
dict[0x25392] = "chuāng"; /* 厒 */
dict[0x25393] = "lǐ"; /* 厓 */
dict[0x25394] = "lǐ"; /* 厔 */
dict[0x25395] = "xù"; /* 厕 */
dict[0x25396] = "mí"; /* 厖 */
dict[0x25397] = "xù"; /* 厗 */
dict[0x25398] = "ruǎn"; /* 厘 */
dict[0x2539b] = "guì"; /* 厛 */
dict[0x2539c] = "rǒng"; /* 厜 */
dict[0x2539f] = "máo"; /* 原 */
dict[0x253a1] = "qín"; /* 厡 */
dict[0x253a2] = "cuàn"; /* 厢 */
dict[0x253a3] = "cuàn"; /* 厣 */
dict[0x253a4] = "cuàn"; /* 厤 */
dict[0x253aa] = "shěn"; /* 厪 */
dict[0x253ae] = "wū"; /* 厮 */
dict[0x253b0] = "fǎ"; /* 厰 */
dict[0x253b1] = "bá"; /* 厱 */
dict[0x253b8] = "qià"; /* 厸 */
dict[0x253b9] = "zhì"; /* 厹 */
dict[0x253ba] = "tiào"; /* 厺 */
dict[0x253c4] = "zhì"; /* 叄 */
dict[0x253c5] = "zhí"; /* 叅 */
dict[0x253c7] = "huàn"; /* 叇 */
dict[0x253c8] = "chóu"; /* 又 */
dict[0x253ca] = "zhì"; /* 及 */
dict[0x253ce] = "yǐng"; /* 収 */
dict[0x253d2] = "wù"; /* 叒 */
dict[0x253d3] = "bēi"; /* 叓 */
dict[0x253d5] = "hóng"; /* 叕 */
dict[0x253d6] = "shěn"; /* 取 */
dict[0x253d8] = "jué"; /* 变 */
dict[0x253d9] = "kuì"; /* 叙 */
dict[0x253dc] = "yǐ"; /* 叜 */
dict[0x253dd] = "yà"; /* 叝 */
dict[0x253e0] = "bī"; /* 叠 */
dict[0x253e4] = "kuà"; /* 古 */
dict[0x253e5] = "qiān"; /* 句 */
dict[0x253e8] = "zhāo"; /* 叨 */
dict[0x253ea] = "kǎi"; /* 只 */
dict[0x253eb] = "shāng"; /* 叫 */
dict[0x253ee] = "àn"; /* 叮 */
dict[0x253ef] = "zhé"; /* 可 */
dict[0x253f0] = "zhì"; /* 台 */
dict[0x253f7] = "zhì"; /* 号 */
dict[0x253f9] = "jiǎo"; /* 叹 */
dict[0x25400] = "sī"; /* 吀 */
dict[0x25401] = "pú"; /* 吁 */
dict[0x25402] = "ǒu"; /* 吂 */
dict[0x2540a] = "zhuó"; /* 吊 */
dict[0x25411] = "yīng"; /* 向 */
dict[0x25413] = "huān"; /* 吓 */
dict[0x25415] = "yà"; /* 吕 */
dict[0x25418] = "shí"; /* 吘 */
dict[0x25419] = "pā,bā"; /* 吙 */
dict[0x2541a] = "pǔ"; /* 吚 */
dict[0x2541e] = "máng"; /* 吞 */
dict[0x2541f] = "chāi"; /* 吟 */
dict[0x25429] = "yún"; /* 吩 */
dict[0x2542c] = "gǔ"; /* 听 */
dict[0x25430] = "qū"; /* 吰 */
dict[0x25439] = "dǎn"; /* 吹 */
dict[0x2543d] = "zhé"; /* 吽 */
dict[0x2543f] = "hú"; /* 吿 */
dict[0x25445] = "kēng"; /* 呅 */
dict[0x25447] = "dié"; /* 呇 */
dict[0x25448] = "tīng"; /* 呈 */
dict[0x2544b] = "guài"; /* 呋 */
dict[0x2544e] = "qiōng"; /* 呎 */
dict[0x2544f] = "shǐ"; /* 呏 */
dict[0x25450] = "jiǎ"; /* 呐 */
dict[0x25451] = "ào"; /* 呑 */
dict[0x25452] = "nǎ,kēng"; /* 呒 */
dict[0x25453] = "pǐn"; /* 呓 */
dict[0x25454] = "jiá"; /* 呔 */
dict[0x25461] = "zhè"; /* 呡 */
dict[0x25462] = "bù"; /* 呢 */
dict[0x25463] = "wǒ"; /* 呣 */
dict[0x25465] = "chǎ"; /* 呥 */
dict[0x25468] = "náo"; /* 周 */
dict[0x25469] = "náo"; /* 呩 */
dict[0x2546a] = "náo"; /* 呪 */
dict[0x2546b] = "kǎn"; /* 呫 */
dict[0x2546f] = "dú"; /* 呯 */
dict[0x25470] = "guài"; /* 呰 */
dict[0x25471] = "qióng"; /* 呱 */
dict[0x25473] = "róng"; /* 味 */
dict[0x25474] = "yǐ"; /* 呴 */
dict[0x25475] = "duī"; /* 呵 */
dict[0x25476] = "lěi"; /* 呶 */
dict[0x25478] = "zhōu"; /* 呸 */
dict[0x25479] = "kuā"; /* 呹 */
dict[0x2547a] = "ē"; /* 呺 */
dict[0x2547b] = "xiān"; /* 呻 */
dict[0x2547c] = "diàn"; /* 呼 */
dict[0x2547d] = "nuò"; /* 命 */
dict[0x2547e] = "è"; /* 呾 */
dict[0x2547f] = "yōng"; /* 呿 */
dict[0x25480] = "wù"; /* 咀 */
dict[0x25481] = "kēng"; /* 咁 */
dict[0x25493] = "zhì"; /* 咓 */
dict[0x25497] = "zhǐ"; /* 咗 */
dict[0x25498] = "xún"; /* 咘 */
dict[0x2549b] = "zhèng"; /* 咛 */
dict[0x2549e] = "yáng"; /* 咞 */
dict[0x254a0] = "huò"; /* 咠 */
dict[0x254a1] = "jí"; /* 咡 */
dict[0x254a2] = "nǎo,lì"; /* 咢 */
dict[0x254a5] = "jiù"; /* 咥 */
dict[0x254a7] = "yà"; /* 咧 */
dict[0x254a8] = "lù"; /* 咨 */
dict[0x254ab] = "fū"; /* 咫 */
dict[0x254ac] = "sǎn"; /* 咬 */
dict[0x254ad] = "chù"; /* 咭 */
dict[0x254ae] = "wěi"; /* 咮 */
dict[0x254b0] = "fǔ"; /* 咰 */
dict[0x254b1] = "kēng"; /* 咱 */
dict[0x254b2] = "sì"; /* 咲 */
dict[0x254b3] = "kàng"; /* 咳 */
dict[0x254b5] = "yì"; /* 咵 */
dict[0x254b6] = "huà"; /* 咶 */
dict[0x254be] = "yǔ"; /* 咾 */
dict[0x254c3] = "lì"; /* 哃 */
dict[0x254c6] = "lǐn"; /* 哆 */
dict[0x254c7] = "dǔ"; /* 哇 */
dict[0x254c8] = "è"; /* 哈 */
dict[0x254cc] = "qiǎng"; /* 哌 */
dict[0x254cd] = "dú"; /* 响 */
dict[0x254d0] = "jié"; /* 哐 */
dict[0x254d1] = "chuò"; /* 哑 */
dict[0x254d2] = "xiàn,kàn"; /* 哒 */
dict[0x254d3] = "bēi"; /* 哓 */
dict[0x254d6] = "gǎo"; /* 哖 */
dict[0x254ec] = "dào"; /* 哬 */
dict[0x254ed] = "suǒ"; /* 哭 */
dict[0x254f0] = "hōng"; /* 哰 */
dict[0x254fb] = "zōng"; /* 哻 */
dict[0x254fe] = "qì"; /* 哾 */
dict[0x254ff] = "tuó"; /* 哿 */
dict[0x25500] = "hōng"; /* 唀 */
dict[0x25501] = "pǐ"; /* 唁 */
dict[0x25502] = "gèng"; /* 唂 */
dict[0x25504] = "niè"; /* 唄 */
dict[0x25507] = "kōng"; /* 唇 */
dict[0x2550a] = "zhǐ"; /* 唊 */
dict[0x25511] = "xiǎo"; /* 唑 */
dict[0x25521] = "shè"; /* 唡 */
dict[0x25522] = "yú"; /* 唢 */
dict[0x25523] = "jiāng"; /* 唣 */
dict[0x25529] = "qǐ"; /* 唩 */
dict[0x2552a] = "chěn"; /* 唪 */
dict[0x2552b] = "sǎng"; /* 唫 */
dict[0x2552d] = "suǒ"; /* 唭 */
dict[0x2552e] = "qián"; /* 售 */
dict[0x2552f] = "huì"; /* 唯 */
dict[0x25531] = "shàn"; /* 唱 */
dict[0x25532] = "è"; /* 唲 */
dict[0x2553b] = "qiū"; /* 唻 */
dict[0x2553d] = "kè"; /* 唽 */
dict[0x25540] = "wēng"; /* 啀 */
dict[0x25541] = "zī"; /* 啁 */
dict[0x25542] = "jí"; /* 啂 */
dict[0x25547] = "dǎ"; /* 啇 */
dict[0x25549] = "cuò"; /* 啉 */
dict[0x2554d] = "lǒu"; /* 啍 */
dict[0x2554e] = "kāng"; /* 啎 */
dict[0x2554f] = "kuò"; /* 問 */
dict[0x25550] = "dí"; /* 啐 */
dict[0x25551] = "qiē,jū"; /* 啑 */
dict[0x25553] = "mò"; /* 啓 */
dict[0x25555] = "xià"; /* 啕 */
dict[0x25556] = "guǒ"; /* 啖 */
dict[0x25557] = "hōng"; /* 啗 */
dict[0x25558] = "cháo,suǒ"; /* 啘 */
dict[0x25559] = "hēi"; /* 啙 */
dict[0x25562] = "cáo"; /* 啢 */
dict[0x25563] = "zhé"; /* 啣 */
dict[0x25565] = "qū"; /* 啥 */
dict[0x25570] = "xū"; /* 啰 */
dict[0x25571] = "péng,pēng"; /* 啱 */
dict[0x25572] = "jué"; /* 啲 */
dict[0x25575] = "gǎn"; /* 啵 */
dict[0x25576] = "sī"; /* 啶 */
dict[0x25578] = "suì"; /* 啸 */
dict[0x25579] = "què"; /* 啹 */
dict[0x2557b] = "wú,wǔ"; /* 啻 */
dict[0x2557c] = "yán"; /* 啼 */
dict[0x2557d] = "pèng"; /* 啽 */
dict[0x2557e] = "xiǎo"; /* 啾 */
dict[0x2557f] = "pān"; /* 啿 */
dict[0x25584] = "xiàn"; /* 善 */
dict[0x2558d] = "là"; /* 喍 */
dict[0x25597] = "bèng"; /* 喗 */
dict[0x25598] = "zhěn"; /* 喘 */
dict[0x25599] = "jí"; /* 喙 */
dict[0x2559c] = "jǐn"; /* 喜 */
dict[0x2559d] = "lián"; /* 喝 */
dict[0x2559e] = "kěn"; /* 喞 */
dict[0x255a0] = "zhóu,dú"; /* 喠 */
dict[0x255a8] = "zào"; /* 喨 */
dict[0x255aa] = "lè"; /* 喪 */
dict[0x255ab] = "qī"; /* 喫 */
dict[0x255ac] = "bìng"; /* 喬 */
dict[0x255b5] = "yǐn"; /* 喵 */
dict[0x255b6] = "pīn"; /* 営 */
dict[0x255bb] = "sǒu"; /* 喻 */
dict[0x255bc] = "lǜ"; /* 喼 */
dict[0x255be] = "dí"; /* 喾 */
dict[0x255bf] = "dú"; /* 喿 */
dict[0x255c0] = "liǎo"; /* 嗀 */
dict[0x255c1] = "zhuó"; /* 嗁 */
dict[0x255ca] = "chǎng"; /* 嗊 */
dict[0x255d2] = "chèn"; /* 嗒 */
dict[0x255d3] = "tà"; /* 嗓 */
dict[0x255d9] = "què"; /* 嗙 */
dict[0x255da] = "dào"; /* 嗚 */
dict[0x255dd] = "rǎng"; /* 嗝 */
dict[0x255df] = "pò"; /* 嗟 */
dict[0x255e6] = "zhōng"; /* 嗦 */
dict[0x255e7] = "xiē"; /* 嗧 */
dict[0x255ea] = "jiāng"; /* 嗪 */
dict[0x255eb] = "qú"; /* 嗫 */
dict[0x255ec] = "lěi"; /* 嗬 */
dict[0x255ed] = "cà"; /* 嗭 */
dict[0x255ee] = "quē"; /* 嗮 */
dict[0x255f5] = "xiàng"; /* 嗵 */
dict[0x255f6] = "lèi"; /* 嗶 */
dict[0x255fa] = "làn"; /* 嗺 */
dict[0x255ff] = "lǎ"; /* 嗿 */
dict[0x25601] = "lǎ"; /* 嘁 */
dict[0x25604] = "yù"; /* 嘄 */
dict[0x2560a] = "jiào"; /* 嘊 */
dict[0x2560b] = "qín"; /* 嘋 */
dict[0x2560c] = "jī"; /* 嘌 */
dict[0x2560f] = "gǎn"; /* 嘏 */
dict[0x25611] = "cùn"; /* 嘑 */
dict[0x25612] = "yì"; /* 嘒 */
dict[0x25620] = "yì"; /* 嘠 */
dict[0x25621] = "zhī"; /* 嘡 */
dict[0x25624] = "biǎo"; /* 嘤 */
dict[0x25625] = "shēng"; /* 嘥 */
dict[0x25626] = "jiù,shè"; /* 嘦 */
dict[0x2562b] = "hē"; /* 嘫 */
dict[0x2562c] = "fú"; /* 嘬 */
dict[0x2562e] = "jū"; /* 嘮 */
dict[0x25640] = "zuǒ"; /* 噀 */
dict[0x25641] = "yí"; /* 噁 */
dict[0x25646] = "xiàn,zhī"; /* 噆 */
dict[0x25647] = "yí"; /* 噇 */
dict[0x25649] = "sì,tái"; /* 噉 */
dict[0x2564b] = "chuì"; /* 噋 */
dict[0x2564e] = "mò"; /* 噎 */
dict[0x25661] = "zhān"; /* 噡 */
dict[0x25663] = "xún"; /* 噣 */
dict[0x25666] = "rú"; /* 噦 */
dict[0x25668] = "huò"; /* 器 */
dict[0x2566b] = "yǒu"; /* 噫 */
dict[0x2566c] = "shāo"; /* 噬 */
dict[0x25670] = "shòu"; /* 噰 */
dict[0x2567e] = "yòu"; /* 噾 */
dict[0x2567f] = "yù"; /* 噿 */
dict[0x25682] = "jùn"; /* 嚂 */
dict[0x25689] = "zī"; /* 嚉 */
dict[0x2568a] = "lù"; /* 嚊 */
dict[0x2569a] = "chǐ"; /* 嚚 */
dict[0x2569b] = "kūn"; /* 嚛 */
dict[0x2569f] = "huò"; /* 嚟 */
dict[0x256a0] = "zhùn"; /* 嚠 */
dict[0x256a6] = "hóu"; /* 嚦 */
dict[0x256a9] = "xǔ"; /* 嚩 */
dict[0x256be] = "zōng"; /* 嚾 */
dict[0x256bf] = "yìng"; /* 嚿 */
dict[0x256c2] = "zhū"; /* 囂 */
dict[0x256c5] = "liù"; /* 囅 */
dict[0x256d1] = "nù"; /* 囑 */
dict[0x256d8] = "bì"; /* 囘 */
dict[0x256da] = "chì"; /* 囚 */
dict[0x256dc] = "zǔ"; /* 囜 */
dict[0x256dd] = "féng"; /* 囝 */
dict[0x256de] = "lù"; /* 回 */
dict[0x256df] = "pǔ"; /* 囟 */
dict[0x256e5] = "zhuàn"; /* 囥 */
dict[0x256e7] = "zhé"; /* 囧 */
dict[0x256e8] = "shī"; /* 囨 */
dict[0x256e9] = "yǔ"; /* 囩 */
dict[0x256ea] = "lù"; /* 囪 */
dict[0x256eb] = "liáng"; /* 囫 */
dict[0x256ef] = "jué"; /* 囯 */
dict[0x256f0] = "liào"; /* 困 */
dict[0x256f1] = "bēng"; /* 囱 */
dict[0x256fd] = "liù"; /* 国 */
dict[0x25703] = "yì"; /* 圃 */
dict[0x25704] = "guān"; /* 圄 */
dict[0x2570c] = "ǎo"; /* 圌 */
dict[0x2570f] = "guì"; /* 圏 */
dict[0x25710] = "mǐn"; /* 圐 */
dict[0x25712] = "yǎn"; /* 園 */
dict[0x25713] = "lán"; /* 圓 */
dict[0x25716] = "bó"; /* 圖 */
dict[0x25719] = "zàn"; /* 圙 */
dict[0x2571a] = "yǒu"; /* 圚 */
dict[0x25725] = "yì"; /* 圥 */
dict[0x25726] = "nǐ,xiǎn"; /* 圦 */
dict[0x2572c] = "nǐ,xiǎn"; /* 圬 */
dict[0x2572d] = "guǒ"; /* 圭 */
dict[0x2572e] = "jùn"; /* 圮 */
dict[0x25730] = "shī"; /* 地 */
dict[0x25732] = "xiǎn,jiǎn"; /* 圲 */
dict[0x25734] = "qiān"; /* 圴 */
dict[0x25735] = "què"; /* 圵 */
dict[0x25736] = "kuí"; /* 圶 */
dict[0x25740] = "shé"; /* 址 */
dict[0x25742] = "huò"; /* 坂 */
dict[0x25744] = "wàn"; /* 坄 */
dict[0x2574a] = "fèi"; /* 坊 */
dict[0x2574b] = "fèi"; /* 坋 */
dict[0x2574c] = "jī"; /* 坌 */
dict[0x2574d] = "yù,wáng"; /* 坍 */
dict[0x25751] = "zhī"; /* 坑 */
dict[0x25752] = "guà"; /* 坒 */
dict[0x25754] = "jié"; /* 坔 */
dict[0x25755] = "máng"; /* 坕 */
dict[0x25756] = "hé,xié"; /* 坖 */
dict[0x25758] = "yǒu"; /* 坘 */
dict[0x2575f] = "dù"; /* 坟 */
dict[0x25760] = "sī,xiù"; /* 坠 */
dict[0x25762] = "lì"; /* 坢 */
dict[0x25765] = "jié"; /* 坥 */
dict[0x25766] = "niǔ"; /* 坦 */
dict[0x25767] = "bà"; /* 坧 */
dict[0x25768] = "yú"; /* 坨 */
dict[0x25769] = "suì"; /* 坩 */
dict[0x2576e] = "zhī"; /* 坮 */
dict[0x25778] = "hé"; /* 坸 */
dict[0x25779] = "kē"; /* 坹 */
dict[0x2577e] = "dù,zhà"; /* 坾 */
dict[0x2577f] = "jiā"; /* 坿 */
dict[0x25781] = "chēn"; /* 垁 */
dict[0x25783] = "chuì,shù"; /* 垃 */
dict[0x25784] = "hé"; /* 垄 */
dict[0x25785] = "zhǎi"; /* 垅 */
dict[0x2578a] = "mèi"; /* 垊 */
dict[0x2578d] = "hé"; /* 垍 */
dict[0x2578e] = "zǐ"; /* 垎 */
dict[0x2578f] = "zhú"; /* 垏 */
dict[0x25791] = "zǐ"; /* 垑 */
dict[0x25792] = "tuó"; /* 垒 */
dict[0x25798] = "zùn"; /* 垘 */
dict[0x2579a] = "rú"; /* 垚 */
dict[0x2579b] = "duò"; /* 垛 */
dict[0x2579c] = "jiàng"; /* 垜 */
dict[0x257a5] = "liè"; /* 垥 */
dict[0x257a7] = "héng"; /* 垧 */
dict[0x257a9] = "bēng"; /* 垩 */
dict[0x257aa] = "mò,mǐ"; /* 垪 */
dict[0x257af] = "zú"; /* 垯 */
dict[0x257b2] = "biē"; /* 垲 */
dict[0x257b4] = "kù"; /* 垴 */
dict[0x257b5] = "jiá"; /* 垵 */
dict[0x257ba] = "zhuō"; /* 垺 */
dict[0x257bc] = "xiū"; /* 垼 */
dict[0x257c3] = "hé"; /* 埃 */
dict[0x257c5] = "qiāo"; /* 埅 */
dict[0x257cd] = "fěi"; /* 埍 */
dict[0x257ce] = "shēng"; /* 城 */
dict[0x257d2] = "zhuì"; /* 埒 */
dict[0x257d3] = "kuǎn"; /* 埓 */
dict[0x257d4] = "zè"; /* 埔 */
dict[0x257d5] = "xiān"; /* 埕 */
dict[0x257d7] = "bì"; /* 埗 */
dict[0x257d8] = "yì"; /* 埘 */
dict[0x257da] = "chàng"; /* 埚 */
dict[0x257ea] = "mào"; /* 埪 */
dict[0x257f6] = "wǎn"; /* 埶 */
dict[0x257fd] = "wū"; /* 埽 */
dict[0x257fe] = "kū"; /* 埾 */
dict[0x257ff] = "wǒ"; /* 埿 */
dict[0x25800] = "xīng"; /* 堀 */
dict[0x25801] = "kē"; /* 堁 */
dict[0x25803] = "jiū"; /* 堃 */
dict[0x25804] = "duān"; /* 堄 */
dict[0x25805] = "huàn"; /* 堅 */
dict[0x25808] = "zhì,jì"; /* 堈 */
dict[0x25809] = "cè"; /* 堉 */
dict[0x2580a] = "róu"; /* 堊 */
dict[0x2580b] = "jí"; /* 堋 */
dict[0x2580d] = "yè"; /* 堍 */
dict[0x2581b] = "jīng"; /* 堛 */
dict[0x2581c] = "yàng"; /* 堜 */
dict[0x25821] = "zǒng"; /* 堡 */
dict[0x25829] = "cǎn"; /* 堩 */
dict[0x25831] = "sī"; /* 報 */
dict[0x25832] = "lì"; /* 堲 */
dict[0x25833] = "gǔ"; /* 堳 */
dict[0x25834] = "chàng"; /* 場 */
dict[0x25836] = "fěi"; /* 堶 */
dict[0x25837] = "liú"; /* 堷 */
dict[0x25839] = "jié"; /* 堹 */
dict[0x2583a] = "yūn"; /* 堺 */
dict[0x2583d] = "zhì"; /* 堽 */
dict[0x25840] = "chóu"; /* 塀 */
dict[0x25841] = "biē"; /* 塁 */
dict[0x25843] = "huāng"; /* 塃 */
dict[0x25845] = "gāo"; /* 塅 */
dict[0x25852] = "jī"; /* 塒 */
dict[0x2585c] = "luó,suì"; /* 塜 */
dict[0x2585d] = "jiān,qiān"; /* 塝 */
dict[0x2585f] = "chuāng"; /* 塟 */
dict[0x25860] = "shuǎng"; /* 塠 */
dict[0x25862] = "lǜ"; /* 塢 */
dict[0x25863] = "jùn"; /* 塣 */
dict[0x25864] = "jiào"; /* 塤 */
dict[0x25866] = "tì,dì"; /* 塦 */
dict[0x25867] = "zhā"; /* 塧 */
dict[0x2586a] = "yì"; /* 塪 */
dict[0x2586c] = "cōng"; /* 塬 */
dict[0x2586d] = "něi"; /* 塭 */
dict[0x2586e] = "jiā"; /* 塮 */
dict[0x25874] = "jì"; /* 塴 */
dict[0x2587d] = "ài"; /* 塽 */
dict[0x25887] = "jiǎn"; /* 墇 */
dict[0x2588a] = "bèn"; /* 墊 */
dict[0x2588c] = "fán"; /* 墌 */
dict[0x2588d] = "suì"; /* 墍 */
dict[0x2588e] = "zùn"; /* 墎 */
dict[0x25890] = "gāo"; /* 墐 */
dict[0x25891] = "gǎo,hào"; /* 墑 */
dict[0x25892] = "láo,lào"; /* 墒 */
dict[0x25894] = "zhuó,zhào"; /* 墔 */
dict[0x2589f] = "hù"; /* 墟 */
dict[0x258a6] = "bì"; /* 墦 */
dict[0x258a7] = "jú,yì"; /* 墧 */
dict[0x258ae] = "huá"; /* 墮 */
dict[0x258b2] = "chéng"; /* 墲 */
dict[0x258b6] = "kuài"; /* 墶 */
dict[0x258b7] = "dāng"; /* 墷 */
dict[0x258b8] = "gé"; /* 墸 */
dict[0x258b9] = "xié"; /* 墹 */
dict[0x258bb] = "jié"; /* 墻 */
dict[0x258bd] = "cān"; /* 墽 */
dict[0x258c6] = "zú"; /* 壆 */
dict[0x258c8] = "pú"; /* 壈 */
dict[0x258cb] = "shǔ"; /* 壋 */
dict[0x258cc] = "bǔ"; /* 壌 */
dict[0x258d7] = "níng"; /* 壗 */
dict[0x258d8] = "yǎn"; /* 壘 */
dict[0x258d9] = "zhòu,còng"; /* 壙 */
dict[0x258db] = "méng"; /* 壛 */
dict[0x258dd] = "biǎn"; /* 壝 */
dict[0x258df] = "xiàng"; /* 壟 */
dict[0x258e4] = "lù"; /* 壤 */
dict[0x258e5] = "lí"; /* 壥 */
dict[0x258e9] = "jì"; /* 壩 */
dict[0x258eb] = "miè"; /* 士 */
dict[0x258ec] = "lèi"; /* 壬 */
dict[0x258ee] = "zhì"; /* 壮 */
dict[0x258ef] = "yōu"; /* 壯 */
dict[0x258f0] = "biǎn"; /* 声 */
dict[0x258f1] = "sè"; /* 壱 */
dict[0x258f8] = "mù"; /* 壸 */
dict[0x258f9] = "ràn"; /* 壹 */
dict[0x25902] = "niǎo"; /* 夂 */
dict[0x2590a] = "quán"; /* 夊 */
dict[0x2590b] = "zhé"; /* 夋 */
dict[0x25910] = "lèi,léi"; /* 夐 */
dict[0x25917] = "dǎng"; /* 夗 */
dict[0x25918] = "jué"; /* 夘 */
dict[0x2591c] = "líng"; /* 夜 */
dict[0x2591e] = "líng"; /* 夞 */
dict[0x2591f] = "yán"; /* 够 */
dict[0x25921] = "shēn"; /* 夡 */
dict[0x25923] = "yǎo"; /* 夣 */
dict[0x25924] = "zhèn"; /* 夤 */
dict[0x25925] = "qī"; /* 夥 */
dict[0x25926] = "ài"; /* 夦 */
dict[0x25928] = "nú"; /* 夨 */
dict[0x25929] = "mǎng"; /* 天 */
dict[0x25931] = "kǎn,hān"; /* 失 */
dict[0x25933] = "jiū,cuàn"; /* 夳 */
dict[0x25934] = "yǎn"; /* 头 */
dict[0x25935] = "miàn"; /* 夵 */
dict[0x25937] = "yín"; /* 夷 */
dict[0x25938] = "wán"; /* 夸 */
dict[0x25939] = "yào,yǎo"; /* 夹 */
dict[0x2593a] = "wā"; /* 夺 */
dict[0x2593b] = "pí"; /* 夻 */
dict[0x2593c] = "suì"; /* 夼 */
dict[0x25945] = "kǒng"; /* 奅 */
dict[0x25948] = "hóng"; /* 奈 */
dict[0x2594a] = "mǐng"; /* 奊 */
dict[0x2594b] = "líng"; /* 奋 */
dict[0x2594c] = "yì,dié"; /* 奌 */
dict[0x2594d] = "shēn,shèn"; /* 奍 */
dict[0x2594f] = "zuò"; /* 奏 */
dict[0x2595b] = "tū,bá"; /* 奛 */
dict[0x2595d] = "yòng"; /* 奝 */
dict[0x2595f] = "wà"; /* 奟 */
dict[0x25960] = "guǐ"; /* 奠 */
dict[0x25961] = "hòng"; /* 奡 */
dict[0x25965] = "shì"; /* 奥 */
dict[0x25967] = "xiòng"; /* 奧 */
dict[0x25969] = "ā,xiàng"; /* 奩 */
dict[0x25971] = "chéng"; /* 奱 */
dict[0x25973] = "kēng"; /* 女 */
dict[0x25974] = "yì"; /* 奴 */
dict[0x25975] = "yàng"; /* 奵 */
dict[0x25976] = "tíng"; /* 奶 */
dict[0x25977] = "dòu"; /* 奷 */
dict[0x25978] = "chá"; /* 奸 */
dict[0x25979] = "liù"; /* 她 */
dict[0x2597b] = "qìng"; /* 奻 */
dict[0x2597d] = "qiú"; /* 好 */
dict[0x2597e] = "xuǎn"; /* 奾 */
dict[0x2597f] = "shēn"; /* 奿 */
dict[0x25980] = "kuān,mì"; /* 妀 */
dict[0x25981] = "tòng"; /* 妁 */
dict[0x25983] = "qiǎn"; /* 妃 */
dict[0x25985] = "chòu"; /* 妅 */
dict[0x2598a] = "wěn"; /* 妊 */
dict[0x2598c] = "lòng"; /* 妌 */
dict[0x2598d] = "ǎn,yǎn"; /* 妍 */
dict[0x25994] = "kǎn"; /* 妔 */
dict[0x25996] = "yǎo"; /* 妖 */
dict[0x25997] = "chuāng"; /* 妗 */
dict[0x25998] = "fú"; /* 妘 */
dict[0x2599c] = "bèng"; /* 妜 */
dict[0x2599d] = "lǎn"; /* 妝 */
dict[0x2599e] = "qià"; /* 妞 */
dict[0x2599f] = "diàn"; /* 妟 */
dict[0x259a2] = "jiào"; /* 妢 */
dict[0x259a3] = "guī"; /* 妣 */
dict[0x259a5] = "xiòng"; /* 妥 */
dict[0x259a8] = "kè"; /* 妨 */
dict[0x259b6] = "xiàn"; /* 妶 */
dict[0x259bf] = "jiào"; /* 妿 */
dict[0x259c2] = "gǒng"; /* 姂 */
dict[0x259c6] = "ǒu"; /* 姆 */
dict[0x259c7] = "kē,cháo"; /* 姇 */
dict[0x259cb] = "kū"; /* 始 */
dict[0x259d1] = "tián,diān,yǎn,chǎn"; /* 姑 */
dict[0x259d2] = "gòu"; /* 姒 */
dict[0x259d3] = "mǎ"; /* 姓 */
dict[0x259d4] = "pì"; /* 委 */
dict[0x259d5] = "liù"; /* 姕 */
dict[0x259d9] = "wèi"; /* 姙 */
dict[0x259da] = "wěn"; /* 姚 */
dict[0x259e1] = "gòng"; /* 姡 */
dict[0x259e3] = "tú"; /* 姣 */
dict[0x259e4] = "níng"; /* 姤 */
dict[0x259e6] = "jiào"; /* 姦 */
dict[0x259e7] = "mì"; /* 姧 */
dict[0x259eb] = "láng"; /* 姫 */
dict[0x259ec] = "qiǎn"; /* 姬 */
dict[0x259ed] = "mán"; /* 姭 */
dict[0x259ee] = "zhé"; /* 姮 */
dict[0x259f0] = "huà"; /* 姰 */
dict[0x259f1] = "yōng"; /* 姱 */
dict[0x259f2] = "jìn,jǐn"; /* 姲 */
dict[0x259f4] = "mèi"; /* 姴 */
dict[0x259f7] = "fú"; /* 姷 */
dict[0x259fb] = "qú"; /* 姻 */
dict[0x25a09] = "hū"; /* 娉 */
dict[0x25a0c] = "liù"; /* 娌 */
dict[0x25a0d] = "fù"; /* 娍 */
dict[0x25a0e] = "dàn"; /* 娎 */
dict[0x25a10] = "gǒng"; /* 娐 */
dict[0x25a12] = "cuì,cuàn"; /* 娒 */
dict[0x25a15] = "xǐng"; /* 娕 */
dict[0x25a1c] = "tū"; /* 娜 */
dict[0x25a1d] = "shòu"; /* 娝 */
dict[0x25a2a] = "qióng"; /* 娪 */
dict[0x25a33] = "róng"; /* 娳 */
dict[0x25a3b] = "lì"; /* 娻 */
dict[0x25a3f] = "jī"; /* 娿 */
dict[0x25a40] = "tuò"; /* 婀 */
dict[0x25a4c] = "tóng"; /* 婌 */
dict[0x25a52] = "tán"; /* 婒 */
dict[0x25a53] = "qiè"; /* 婓 */
dict[0x25a54] = "líng"; /* 婔 */
dict[0x25a56] = "yì"; /* 婖 */
dict[0x25a57] = "ruǎn"; /* 婗 */
dict[0x25a59] = "pǎ"; /* 婙 */
dict[0x25a5d] = "cà"; /* 婝 */
dict[0x25a61] = "yuè"; /* 婡 */
dict[0x25a62] = "què"; /* 婢 */
dict[0x25a63] = "zhù"; /* 婣 */
dict[0x25a64] = "hài"; /* 婤 */
dict[0x25a6e] = "è"; /* 婮 */
dict[0x25a71] = "fá"; /* 婱 */
dict[0x25a72] = "hài"; /* 婲 */
dict[0x25a80] = "bū"; /* 媀 */
dict[0x25a81] = "pīng"; /* 媁 */
dict[0x25a82] = "liè"; /* 媂 */
dict[0x25a8a] = "kuǐ,jué"; /* 媊 */
dict[0x25a8b] = "fú"; /* 媋 */
dict[0x25a8c] = "tiǎn"; /* 媌 */
dict[0x25a8d] = "wò"; /* 媍 */
dict[0x25a8f] = "jū"; /* 媏 */
dict[0x25a98] = "zhēn"; /* 媘 */
dict[0x25a9a] = "fú"; /* 媚 */
dict[0x25aa1] = "shù"; /* 媡 */
dict[0x25aa2] = "lóng"; /* 媢 */
dict[0x25aa6] = "xì"; /* 媦 */
dict[0x25aa7] = "tián"; /* 媧 */
dict[0x25aab] = "jì"; /* 媫 */
dict[0x25aaf] = "yào,qiáo"; /* 媯 */
dict[0x25ab1] = "cù"; /* 媱 */
dict[0x25ab4] = "pàng"; /* 媴 */
dict[0x25ab5] = "qiè"; /* 媵 */
dict[0x25abb] = "lóng"; /* 媻 */
dict[0x25abc] = "jǐ"; /* 媼 */
dict[0x25ac0] = "wāi"; /* 嫀 */
dict[0x25ac2] = "tóng"; /* 嫂 */
dict[0x25ac3] = "yí"; /* 嫃 */
dict[0x25ac5] = "chāng"; /* 嫅 */
dict[0x25acb] = "gōng"; /* 嫋 */
dict[0x25ace] = "dòng"; /* 嫎 */
dict[0x25ad4] = "gòng"; /* 嫔 */
dict[0x25ad6] = "xiāng"; /* 嫖 */
dict[0x25ad9] = "tǐng"; /* 嫙 */
dict[0x25adb] = "zhuān"; /* 嫛 */
dict[0x25adc] = "yǐ"; /* 嫜 */
dict[0x25add] = "yì"; /* 嫝 */
dict[0x25ade] = "zǐ"; /* 嫞 */
dict[0x25adf] = "qǐ"; /* 嫟 */
dict[0x25ae2] = "chǎ"; /* 嫢 */
dict[0x25aec] = "dùn"; /* 嫬 */
dict[0x25aef] = "chōng"; /* 嫯 */
dict[0x25af0] = "lù"; /* 嫰 */
dict[0x25af1] = "dùn"; /* 嫱 */
dict[0x25af3] = "fāng"; /* 嫳 */
dict[0x25af4] = "shì"; /* 嫴 */
dict[0x25af5] = "tì"; /* 嫵 */
dict[0x25af6] = "jī"; /* 嫶 */
dict[0x25af7] = "qiū"; /* 嫷 */
dict[0x25af8] = "shuǐ"; /* 嫸 */
dict[0x25af9] = "chén"; /* 嫹 */
dict[0x25afc] = "huàng"; /* 嫼 */
dict[0x25afd] = "shi"; /* 嫽 */
dict[0x25b06] = "lóng"; /* 嬆 */
dict[0x25b08] = "mǎn"; /* 嬈 */
dict[0x25b09] = "gōu"; /* 嬉 */
dict[0x25b0d] = "xiān"; /* 嬍 */
dict[0x25b0e] = "mò"; /* 嬎 */
dict[0x25b10] = "shěn"; /* 嬐 */
dict[0x25b12] = "pō"; /* 嬒 */
dict[0x25b13] = "yào"; /* 嬓 */
dict[0x25b14] = "qū"; /* 嬔 */
dict[0x25b15] = "rǎn"; /* 嬕 */
dict[0x25b19] = "jù"; /* 嬙 */
dict[0x25b1c] = "yǐn"; /* 嬜 */
dict[0x25b1d] = "bái"; /* 嬝 */
dict[0x25b2a] = "róng"; /* 嬪 */
dict[0x25b2b] = "chuǎn"; /* 嬫 */
dict[0x25b2c] = "niè"; /* 嬬 */
dict[0x25b2d] = "lì,liè"; /* 嬭 */
dict[0x25b2e] = "jiāng"; /* 嬮 */
dict[0x25b2f] = "kǎo"; /* 嬯 */
dict[0x25b30] = "cè,zhà"; /* 嬰 */
dict[0x25b31] = "chòng"; /* 嬱 */
dict[0x25b32] = "zhuā,duò"; /* 嬲 */
dict[0x25b33] = "zǐ"; /* 嬳 */
dict[0x25b34] = "yáng"; /* 嬴 */
dict[0x25b3c] = "wěn"; /* 嬼 */
dict[0x25b4b] = "jì"; /* 孋 */
dict[0x25b4c] = "jì"; /* 孌 */
dict[0x25b50] = "lǜ"; /* 子 */
dict[0x25b51] = "qiú"; /* 孑 */
dict[0x25b52] = "dùn"; /* 孒 */
dict[0x25b53] = "báo"; /* 孓 */
dict[0x25b54] = "chān"; /* 孔 */
dict[0x25b56] = "bó"; /* 孖 */
dict[0x25b58] = "chī"; /* 存 */
dict[0x25b59] = "zhè,niè"; /* 孙 */
dict[0x25b5a] = "màng"; /* 孚 */
dict[0x25b5c] = "jì"; /* 孜 */
dict[0x25b5d] = "miào"; /* 孝 */
dict[0x25b5e] = "yuàn"; /* 孞 */
dict[0x25b5f] = "suō"; /* 孟 */
dict[0x25b60] = "wú"; /* 孠 */
dict[0x25b61] = "zhì"; /* 孡 */
dict[0x25b62] = "pīng"; /* 孢 */
dict[0x25b65] = "chōng"; /* 孥 */
dict[0x25b6b] = "mí"; /* 孫 */
dict[0x25b6c] = "féi"; /* 孬 */
dict[0x25b6d] = "cuō"; /* 孭 */
dict[0x25b6e] = "méng"; /* 孮 */
dict[0x25b8d] = "yín"; /* 宍 */
dict[0x25b8e] = "mǎng"; /* 宎 */
dict[0x25b8f] = "diǎn"; /* 宏 */
dict[0x25b90] = "diāo"; /* 宐 */
dict[0x25b92] = "qián,zhān"; /* 宒 */
dict[0x25b95] = "hàng"; /* 宕 */
dict[0x25b96] = "zhí"; /* 宖 */
dict[0x25b97] = "jú"; /* 宗 */
dict[0x25b98] = "niàn"; /* 官 */
dict[0x25b9a] = "sān"; /* 定 */
dict[0x25b9d] = "gǔ"; /* 宝 */
dict[0x25ba3] = "zhuā"; /* 宣 */
dict[0x25ba4] = "niè"; /* 室 */
dict[0x25ba5] = "zhuó"; /* 宥 */
dict[0x25ba7] = "yè"; /* 宧 */
dict[0x25ba8] = "còng"; /* 宨 */
dict[0x25baa] = "xū,jí"; /* 宪 */
dict[0x25bac] = "xì"; /* 宬 */
dict[0x25baf] = "bō"; /* 宯 */
dict[0x25bc3] = "yǎn"; /* 寃 */
dict[0x25bd1] = "jǐn"; /* 寑 */
dict[0x25bd4] = "jǔ"; /* 寔 */
dict[0x25bd5] = "dàng"; /* 寕 */
dict[0x25bd6] = "dù"; /* 寖 */
dict[0x25bd8] = "yé"; /* 寘 */
dict[0x25bd9] = "jìng"; /* 寙 */
dict[0x25bda] = "kè"; /* 寚 */
dict[0x25bdb] = "luò"; /* 寛 */
dict[0x25bdc] = "wěi"; /* 寜 */
dict[0x25bdd] = "tū"; /* 寝 */
dict[0x25bde] = "yóu"; /* 寞 */
dict[0x25bdf] = "pài"; /* 察 */
dict[0x25be1] = "pí"; /* 寡 */
dict[0x25be2] = "dìng"; /* 寢 */
dict[0x25be3] = "miè"; /* 寣 */
dict[0x25be4] = "wěi"; /* 寤 */
dict[0x25be5] = "chè"; /* 寥 */
dict[0x25be6] = "jiàn,shà"; /* 實 */
dict[0x25be8] = "sī"; /* 寨 */
dict[0x25be9] = "zhuó"; /* 審 */
dict[0x25bea] = "sòu"; /* 寪 */
dict[0x25bec] = "ruǎn"; /* 寬 */
dict[0x25bee] = "yú"; /* 寮 */
dict[0x25bf3] = "è"; /* 寳 */
dict[0x25bf6] = "kǔ"; /* 寶 */
dict[0x25bf8] = "zhù"; /* 寸 */
dict[0x25bfe] = "xiá"; /* 対 */
dict[0x25c1b] = "fú"; /* 尛 */
dict[0x25c1c] = "táo"; /* 尜 */
dict[0x25c1d] = "xī"; /* 尝 */
dict[0x25c1e] = "chōu,sǒu"; /* 尞 */
dict[0x25c1f] = "gǎn,lǒng"; /* 尟 */
dict[0x25c20] = "lǘ"; /* 尠 */
dict[0x25c21] = "cè"; /* 尡 */
dict[0x25c22] = "shàn"; /* 尢 */
dict[0x25c23] = "liú"; /* 尣 */
dict[0x25c25] = "xì"; /* 尥 */
dict[0x25c26] = "jī"; /* 尦 */
dict[0x25c27] = "yǐ"; /* 尧 */
dict[0x25c28] = "tán"; /* 尨 */
dict[0x25c2a] = "hú"; /* 尪 */
dict[0x25c2b] = "shì"; /* 尫 */
dict[0x25c2d] = "cuō,zhǎ,cī"; /* 尭 */
dict[0x25c2e] = "gě"; /* 尮 */
dict[0x25c30] = "shì,shé"; /* 尰 */
dict[0x25c31] = "sāo"; /* 就 */
dict[0x25c32] = "hòng"; /* 尲 */
dict[0x25c33] = "xiàn"; /* 尳 */
dict[0x25c36] = "xiá"; /* 尶 */
dict[0x25c3b] = "mù"; /* 尻 */
dict[0x25c3c] = "suǒ"; /* 尼 */
dict[0x25c3e] = "zhài"; /* 尾 */
dict[0x25c40] = "fū"; /* 局 */
dict[0x25c41] = "sè"; /* 屁 */
dict[0x25c42] = "nú"; /* 层 */
dict[0x25c43] = "yì"; /* 屃 */
dict[0x25c52] = "shì"; /* 屒 */
dict[0x25c67] = "qín"; /* 屧 */
dict[0x25c68] = "qìng"; /* 屨 */
dict[0x25c75] = "huì,suì,xí"; /* 屵 */
dict[0x25c76] = "shuǎng"; /* 屶 */
dict[0x25c77] = "dǎn"; /* 屷 */
dict[0x25c78] = "ōu"; /* 屸 */
dict[0x25c79] = "mò"; /* 屹 */
dict[0x25c7a] = "qiān"; /* 屺 */
dict[0x25c7b] = "chì,tú"; /* 屻 */
dict[0x25c7c] = "pái,pì"; /* 屼 */
dict[0x25c7d] = "juàn"; /* 屽 */
dict[0x25c80] = "cháo"; /* 岀 */
dict[0x25c81] = "liè"; /* 岁 */
dict[0x25c82] = "bīng"; /* 岂 */
dict[0x25c83] = "kòu"; /* 岃 */
dict[0x25c84] = "dàn"; /* 岄 */
dict[0x25c85] = "chóu"; /* 岅 */
dict[0x25c86] = "tōng"; /* 岆 */
dict[0x25c87] = "dàn"; /* 岇 */
dict[0x25c88] = "mǎn"; /* 岈 */
dict[0x25c89] = "hù"; /* 岉 */
dict[0x25c8a] = "liáo"; /* 岊 */
dict[0x25c8b] = "xián"; /* 岋 */
dict[0x25c8d] = "cáo"; /* 岍 */
dict[0x25c8e] = "lù"; /* 岎 */
dict[0x25c8f] = "chuàn"; /* 岏 */
dict[0x25c90] = "wú"; /* 岐 */
dict[0x25c91] = "mán"; /* 岑 */
dict[0x25c95] = "zǐ"; /* 岕 */
dict[0x25c97] = "dù"; /* 岗 */
dict[0x25c9a] = "shuàng"; /* 岚 */
dict[0x25c9b] = "fù"; /* 岛 */
dict[0x25c9c] = "jù"; /* 岜 */
dict[0x25c9d] = "zhòu"; /* 岝 */
dict[0x25c9f] = "diào"; /* 岟 */
dict[0x25ca0] = "wàng"; /* 岠 */
dict[0x25ca1] = "chuāng"; /* 岡 */
dict[0x25ca2] = "qiān"; /* 岢 */
dict[0x25ca3] = "tuì"; /* 岣 */
dict[0x25ca5] = "lián"; /* 岥 */
dict[0x25ca6] = "biāo"; /* 岦 */
dict[0x25ca7] = "lí"; /* 岧 */
dict[0x25caa] = "lí"; /* 岪 */
dict[0x25cbd] = "cuó"; /* 岽 */
dict[0x25cc6] = "bì"; /* 峆 */
dict[0x25cc7] = "fù"; /* 峇 */
dict[0x25cc8] = "cuì"; /* 峈 */
dict[0x25cc9] = "dū"; /* 峉 */
dict[0x25ccb] = "zàn,zān"; /* 峋 */
dict[0x25ccc] = "lóng"; /* 峌 */
dict[0x25ccd] = "xún"; /* 峍 */
dict[0x25cce] = "qióng"; /* 峎 */
dict[0x25ccf] = "jī"; /* 峏 */
dict[0x25cd0] = "qiǎn"; /* 峐 */
dict[0x25cd2] = "jiǎn"; /* 峒 */
dict[0x25cd3] = "shāo"; /* 峓 */
dict[0x25cd4] = "duò"; /* 峔 */
dict[0x25cd5] = "shū"; /* 峕 */
dict[0x25cd6] = "bù"; /* 峖 */
dict[0x25cd7] = "xū"; /* 峗 */
dict[0x25cd8] = "dǒng"; /* 峘 */
dict[0x25cda] = "rán"; /* 峚 */
dict[0x25cdc] = "yáng"; /* 峜 */
dict[0x25cdd] = "ruǐ"; /* 峝 */
dict[0x25cde] = "lìn"; /* 峞 */
dict[0x25cdf] = "jiǎn"; /* 峟 */
dict[0x25ce0] = "dì"; /* 峠 */
dict[0x25ce1] = "fén"; /* 峡 */
dict[0x25ce2] = "diàn"; /* 峢 */
dict[0x25ce3] = "zuì"; /* 峣 */
dict[0x25ce5] = "nǐng"; /* 峥 */
dict[0x25cea] = "suàn"; /* 峪 */
dict[0x25ceb] = "tiǎn"; /* 峫 */
dict[0x25cec] = "àn"; /* 峬 */
dict[0x25cef] = "cè"; /* 峯 */
dict[0x25cf0] = "dìng"; /* 峰 */
dict[0x25cf1] = "shēn"; /* 峱 */
dict[0x25cf2] = "dù"; /* 峲 */
dict[0x25cf3] = "tí"; /* 峳 */
dict[0x25cf4] = "jiǎo"; /* 峴 */
dict[0x25cf5] = "zuì"; /* 峵 */
dict[0x25cf6] = "zhǎng"; /* 島 */
dict[0x25cf7] = "jiǎn"; /* 峷 */
dict[0x25cf8] = "dàn"; /* 峸 */
dict[0x25cf9] = "dǎn"; /* 峹 */
dict[0x25cfa] = "sǒng"; /* 峺 */
dict[0x25cfd] = "qī"; /* 峽 */
dict[0x25d10] = "zhǎn"; /* 崐 */
dict[0x25d11] = "tíng"; /* 崑 */
dict[0x25d12] = "zhì"; /* 崒 */
dict[0x25d15] = "yóu"; /* 崕 */
dict[0x25d16] = "pái"; /* 崖 */
dict[0x25d21] = "lǐ"; /* 崡 */
dict[0x25d24] = "qián"; /* 崤 */
dict[0x25d26] = "suì,dí"; /* 崦 */
dict[0x25d27] = "jǔ"; /* 崧 */
dict[0x25d28] = "ài"; /* 崨 */
dict[0x25d29] = "gé"; /* 崩 */
dict[0x25d2a] = "jù"; /* 崪 */
dict[0x25d2b] = "tún,diàn"; /* 崫 */
dict[0x25d2c] = "bì"; /* 崬 */
dict[0x25d2d] = "qià"; /* 崭 */
dict[0x25d2e] = "bó"; /* 崮 */
dict[0x25d2f] = "huì"; /* 崯 */
dict[0x25d31] = "jiàn"; /* 崱 */
dict[0x25d34] = "gōu"; /* 崴 */
dict[0x25d35] = "suàn"; /* 崵 */
dict[0x25d3a] = "cí"; /* 崺 */
dict[0x25d3b] = "qiàng"; /* 崻 */
dict[0x25d3f] = "yán"; /* 崿 */
dict[0x25d4f] = "diàn"; /* 嵏 */
dict[0x25d52] = "miè"; /* 嵒 */
dict[0x25d5c] = "pò"; /* 嵜 */
dict[0x25d5d] = "lǐng"; /* 嵝 */
dict[0x25d5e] = "jié"; /* 嵞 */
dict[0x25d5f] = "zhù"; /* 嵟 */
dict[0x25d60] = "gǔ"; /* 嵠 */
dict[0x25d63] = "duān"; /* 嵣 */
dict[0x25d64] = "zhào"; /* 嵤 */
dict[0x25d66] = "shǎo"; /* 嵦 */
dict[0x25d67] = "qǐn"; /* 嵧 */
dict[0x25d68] = "mí"; /* 嵨 */
dict[0x25d6a] = "píng"; /* 嵪 */
dict[0x25d6b] = "cóng"; /* 嵫 */
dict[0x25d6c] = "chōu"; /* 嵬 */
dict[0x25d6f] = "sà"; /* 嵯 */
dict[0x25d76] = "tiǎn"; /* 嵶 */
dict[0x25d78] = "mí"; /* 嵸 */
dict[0x25d85] = "liú"; /* 嶅 */
dict[0x25d86] = "lǘ"; /* 嶆 */
dict[0x25d87] = "lǔ"; /* 嶇 */
dict[0x25d88] = "zōu"; /* 嶈 */
dict[0x25d8c] = "lǜ"; /* 嶌 */
dict[0x25d8d] = "huǎn"; /* 嶍 */
dict[0x25d8f] = "tiáo"; /* 嶏 */
dict[0x25d90] = "tuí"; /* 嶐 */
dict[0x25d91] = "qiǎng"; /* 嶑 */
dict[0x25d92] = "lìn"; /* 嶒 */
dict[0x25d93] = "bēi"; /* 嶓 */
dict[0x25d94] = "páo"; /* 嶔 */
dict[0x25d95] = "zhān"; /* 嶕 */
dict[0x25d97] = "lì"; /* 嶗 */
dict[0x25d9b] = "tí"; /* 嶛 */
dict[0x25d9c] = "hú"; /* 嶜 */
dict[0x25da2] = "liè"; /* 嶢 */
dict[0x25db5] = "huǐ"; /* 嶵 */
dict[0x25db6] = "qū"; /* 嶶 */
dict[0x25db7] = "xuǎn"; /* 嶷 */
dict[0x25db9] = "jìng"; /* 嶹 */
dict[0x25dba] = "dié"; /* 嶺 */
dict[0x25dbb] = "suí"; /* 嶻 */
dict[0x25dbd] = "wèi"; /* 嶽 */
dict[0x25dbf] = "yán"; /* 嶿 */
dict[0x25dc0] = "yān"; /* 巀 */
dict[0x25dc1] = "bàn"; /* 巁 */
dict[0x25dc3] = "jiǎng"; /* 巃 */
dict[0x25dc4] = "nǐ"; /* 巄 */
dict[0x25dc5] = "lì"; /* 巅 */
dict[0x25dc6] = "hú"; /* 巆 */
dict[0x25dc7] = "qì"; /* 巇 */
dict[0x25dc8] = "zhōng"; /* 巈 */
dict[0x25dd4] = "yú"; /* 巔 */
dict[0x25dd5] = "dié"; /* 巕 */
dict[0x25dd6] = "lìn"; /* 巖 */
dict[0x25dd7] = "lì"; /* 巗 */
dict[0x25dd8] = "zhuó"; /* 巘 */
dict[0x25dd9] = "jì"; /* 巙 */
dict[0x25dda] = "jū"; /* 巚 */
dict[0x25ddc] = "fēng"; /* 巜 */
dict[0x25dde] = "yù"; /* 州 */
dict[0x25de8] = "liè"; /* 巨 */
dict[0x25de9] = "zá"; /* 巩 */
dict[0x25dea] = "qián"; /* 巪 */
dict[0x25deb] = "jiē"; /* 巫 */
dict[0x25dec] = "guān"; /* 巬 */
dict[0x25dee] = "zhuó,zhāo"; /* 差 */
dict[0x25df1] = "fù"; /* 己 */
dict[0x25df9] = "sè"; /* 巹 */
dict[0x25dfc] = "cù"; /* 巼 */
dict[0x25e03] = "huǐ"; /* 布 */
dict[0x25e05] = "biān"; /* 帅 */
dict[0x25e08] = "dàng"; /* 师 */
dict[0x25e09] = "lóng"; /* 帉 */
dict[0x25e0a] = "yì"; /* 帊 */
dict[0x25e17] = "sǎ"; /* 帗 */
dict[0x25e18] = "yuè"; /* 帘 */
dict[0x25e1a] = "dí"; /* 帚 */
dict[0x25e21] = "gǎn"; /* 帡 */
dict[0x25e22] = "zān"; /* 帢 */
dict[0x25e23] = "shàn"; /* 帣 */
dict[0x25e24] = "yù"; /* 帤 */
dict[0x25e25] = "bǒ"; /* 帥 */
dict[0x25e27] = "dìng"; /* 帧 */
dict[0x25e28] = "fán,bǒ,bǔ"; /* 帨 */
dict[0x25e2a] = "yù"; /* 帪 */
dict[0x25e2c] = "shēn"; /* 帬 */
dict[0x25e32] = "gōng"; /* 帲 */
dict[0x25e34] = "miè"; /* 帴 */
dict[0x25e35] = "tún"; /* 帵 */
dict[0x25e38] = "liè"; /* 常 */
dict[0x25e41] = "zhā,zuò"; /* 幁 */
dict[0x25e42] = "pēi"; /* 幂 */
dict[0x25e44] = "mí"; /* 幄 */
dict[0x25e46] = "míng"; /* 幆 */
dict[0x25e47] = "fàn"; /* 幇 */
dict[0x25e48] = "tuó"; /* 幈 */
dict[0x25e49] = "nà"; /* 幉 */
dict[0x25e4a] = "sì"; /* 幊 */
dict[0x25e4b] = "yí"; /* 幋 */
dict[0x25e4c] = "jiā"; /* 幌 */
dict[0x25e4d] = "zhù"; /* 幍 */
dict[0x25e53] = "bān"; /* 幓 */
dict[0x25e54] = "yù"; /* 幔 */
dict[0x25e56] = "pǒ"; /* 幖 */
dict[0x25e5a] = "huān"; /* 幚 */
dict[0x25e5b] = "càn"; /* 幛 */
dict[0x25e5c] = "jiāo"; /* 幜 */
dict[0x25e60] = "tán"; /* 幠 */
dict[0x25e69] = "zhì"; /* 幩 */
dict[0x25e6b] = "mǐ"; /* 幫 */
dict[0x25e6c] = "kǎo"; /* 幬 */
dict[0x25e71] = "yāo"; /* 幱 */
dict[0x25e72] = "duì"; /* 干 */
dict[0x25e73] = "quǎn,huán"; /* 平 */
dict[0x25e74] = "bù"; /* 年 */
dict[0x25e75] = "chù"; /* 幵 */
dict[0x25e76] = "qiǎo"; /* 并 */
dict[0x25e77] = "liú"; /* 幷 */
dict[0x25e78] = "bó"; /* 幸 */
dict[0x25e7a] = "kāng"; /* 幺 */
dict[0x25e7b] = "fèn"; /* 幻 */
dict[0x25e89] = "dòu"; /* 庉 */
dict[0x25e8a] = "gé"; /* 床 */
dict[0x25e99] = "líng"; /* 庙 */
dict[0x25e9a] = "xí"; /* 庚 */
dict[0x25e9c] = "nì"; /* 府 */
dict[0x25e9d] = "zhōu"; /* 庝 */
dict[0x25e9e] = "zhōu,yù"; /* 庞 */
dict[0x25ea1] = "chī"; /* 庡 */
dict[0x25ea3] = "chōu"; /* 庣 */
dict[0x25eb4] = "niān"; /* 庴 */
dict[0x25eb5] = "jī"; /* 庵 */
dict[0x25eb7] = "qū"; /* 康 */
dict[0x25ec4] = "kāi"; /* 廄 */
dict[0x25ec6] = "sù"; /* 廆 */
dict[0x25ec7] = "xiàn"; /* 廇 */
dict[0x25ec9] = "hé"; /* 廉 */
dict[0x25ecb] = "lín"; /* 廋 */
dict[0x25ecd] = "zī"; /* 廍 */
dict[0x25ed1] = "ǒu,lì"; /* 廑 */
dict[0x25ed2] = "cù,mì"; /* 廒 */
dict[0x25ed7] = "chá"; /* 廗 */
dict[0x25edd] = "zhòng"; /* 廝 */
dict[0x25ede] = "bú"; /* 廞 */
dict[0x25ee4] = "chōu"; /* 廤 */
dict[0x25ee5] = "xì"; /* 廥 */
dict[0x25ee6] = "sà"; /* 廦 */
dict[0x25ee7] = "xián,jiān"; /* 廧 */
dict[0x25ee8] = "sè"; /* 廨 */
dict[0x25ee9] = "miàn"; /* 廩 */
dict[0x25eeb] = "fán"; /* 廫 */
dict[0x25eec] = "zhī"; /* 廬 */
dict[0x25eee] = "cuì"; /* 廮 */
dict[0x25ef4] = "xià"; /* 廴 */
dict[0x25ef5] = "cí"; /* 廵 */
dict[0x25efe] = "nuò"; /* 廾 */
dict[0x25eff] = "lí"; /* 廿 */
dict[0x25f00] = "zú"; /* 开 */
dict[0x25f02] = "cuī"; /* 异 */
dict[0x25f03] = "zé"; /* 弃 */
dict[0x25f05] = "lí"; /* 弅 */
dict[0x25f0b] = "lí"; /* 弋 */
dict[0x25f13] = "bèi"; /* 弓 */
dict[0x25f18] = "qí"; /* 弘 */
dict[0x25f1a] = "zhuō"; /* 弚 */
dict[0x25f1b] = "cuì"; /* 弛 */
dict[0x25f1c] = "pū"; /* 弜 */
dict[0x25f1d] = "chī"; /* 弝 */
dict[0x25f1e] = "fán"; /* 弞 */
dict[0x25f1f] = "tán"; /* 弟 */
dict[0x25f29] = "zī"; /* 弩 */
dict[0x25f2a] = "zǔ"; /* 弪 */
dict[0x25f2b] = "zhōu"; /* 弫 */
dict[0x25f2c] = "róng"; /* 弬 */
dict[0x25f2d] = "lín"; /* 弭 */
dict[0x25f2e] = "tán"; /* 弮 */
dict[0x25f36] = "shì"; /* 弶 */
dict[0x25f38] = "líng"; /* 弸 */
dict[0x25f3a] = "cuǐ"; /* 强 */
dict[0x25f3b] = "zī"; /* 弻 */
dict[0x25f3c] = "fū"; /* 弼 */
dict[0x25f41] = "xiào"; /* 彁 */
dict[0x25f48] = "fēng,lǐ"; /* 彈 */
dict[0x25f4f] = "xiàn"; /* 彏 */
dict[0x25f50] = "jiàn"; /* 彐 */
dict[0x25f52] = "fèn"; /* 归 */
dict[0x25f57] = "lì"; /* 彗 */
dict[0x25f58] = "mò,miè"; /* 彘 */
dict[0x25f5f] = "yōu"; /* 彟 */
dict[0x25f63] = "líng"; /* 彣 */
dict[0x25f65] = "huò"; /* 彥 */
dict[0x25f67] = "qū"; /* 彧 */
dict[0x25f6c] = "niàng"; /* 彬 */
dict[0x25f70] = "mí"; /* 彰 */
dict[0x25f73] = "qì"; /* 彳 */
dict[0x25f76] = "hé"; /* 彶 */
dict[0x25f78] = "liàn"; /* 彸 */
dict[0x25f79] = "cào"; /* 役 */
dict[0x25f7f] = "zuò"; /* 彿 */
dict[0x25f82] = "líng"; /* 徂 */
dict[0x25f85] = "zhú"; /* 待 */
dict[0x25f87] = "niǎo"; /* 徇 */
dict[0x25f8a] = "jǐ"; /* 徊 */
dict[0x25f8b] = "réng"; /* 律 */
dict[0x25f8c] = "jié"; /* 後 */
dict[0x25f8d] = "gǎn"; /* 徍 */
dict[0x25f90] = "yì"; /* 徐 */
dict[0x25f93] = "zhóu"; /* 従 */
dict[0x25f95] = "wù"; /* 徕 */
dict[0x25f9a] = "gěng,dǎn"; /* 徚 */
dict[0x25f9b] = "cù"; /* 徛 */
dict[0x25f9d] = "miè,miǎn"; /* 徝 */
dict[0x25fa1] = "xún,jī"; /* 御 */
dict[0x25fa3] = "zhī"; /* 徣 */
dict[0x25fa4] = "xiáo"; /* 徤 */
dict[0x25fa7] = "fú"; /* 徧 */
dict[0x25fa8] = "hú"; /* 徨 */
dict[0x25fac] = "dī"; /* 徬 */
dict[0x25fae] = "jué"; /* 微 */
dict[0x25faf] = "diào"; /* 徯 */
dict[0x25fb9] = "shǒu"; /* 徹 */
dict[0x25fbc] = "wǎng"; /* 徼 */
dict[0x25fc3] = "nà"; /* 心 */
dict[0x25fc4] = "dī"; /* 忄 */
dict[0x25fc5] = "shì"; /* 必 */
dict[0x25fc6] = "cí"; /* 忆 */
dict[0x25fc7] = "shū"; /* 忇 */
dict[0x25fc9] = "wà,mò"; /* 忉 */
dict[0x25fca] = "chè"; /* 忊 */
dict[0x25fcb] = "fán,biàn"; /* 忋 */
dict[0x25fcd] = "gū"; /* 忍 */
dict[0x25fce] = "yuān,wǎn"; /* 忎 */
dict[0x25fd1] = "guān,lún"; /* 忑 */
dict[0x25fda] = "qiè"; /* 忚 */
dict[0x25fdc] = "zhǎn,zhěn"; /* 応 */
dict[0x25fdd] = "dài"; /* 忝 */
dict[0x25fde] = "shē"; /* 忞 */
dict[0x25fe6] = "zhōu"; /* 忦 */
dict[0x25fe7] = "xiǎng"; /* 忧 */
dict[0x25fe8] = "míng"; /* 忨 */
dict[0x25fe9] = "zì"; /* 忩 */
dict[0x25fea] = "huāng"; /* 忪 */
dict[0x25feb] = "mí,yì,wèi"; /* 快 */
dict[0x25fed] = "xì"; /* 忭 */
dict[0x25fee] = "zhì,shì"; /* 忮 */
dict[0x25fef] = "pài"; /* 忯 */
dict[0x25ff0] = "duǒ"; /* 忰 */
dict[0x25ff4] = "cì"; /* 忴 */
dict[0x25ff5] = "móu"; /* 念 */
dict[0x25ff7] = "chào"; /* 忷 */
dict[0x25ff9] = "yì"; /* 忹 */
dict[0x25ffa] = "gōu"; /* 忺 */
dict[0x26007] = "jīng"; /* 怇 */
dict[0x26013] = "zēng,jiē"; /* 怓 */
dict[0x26014] = "pīng"; /* 怔 */
dict[0x26015] = "yè"; /* 怕 */
dict[0x26016] = "jié"; /* 怖 */
dict[0x26018] = "pī,bī"; /* 怘 */
dict[0x2601b] = "shā"; /* 怛 */
dict[0x2601c] = "zhuàng"; /* 怜 */
dict[0x2601d] = "jiǒng"; /* 思 */
dict[0x26020] = "liú"; /* 怠 */
dict[0x26021] = "yǔ"; /* 怡 */
dict[0x26023] = "jū"; /* 怣 */
dict[0x26028] = "nuò"; /* 怨 */
dict[0x26038] = "mào"; /* 怸 */
dict[0x26044] = "chēn"; /* 恄 */
dict[0x26046] = "zhuàn,juàn,shuàn"; /* 恆 */
dict[0x26047] = "niàn"; /* 恇 */
dict[0x26048] = "kòng"; /* 恈 */
dict[0x26049] = "jiē"; /* 恉 */
dict[0x2604a] = "huà"; /* 恊 */
dict[0x2604d] = "xīn"; /* 恍 */
dict[0x2604e] = "zuó"; /* 恎 */
dict[0x2604f] = "yàn"; /* 恏 */
dict[0x26050] = "jué"; /* 恐 */
dict[0x26055] = "hū"; /* 恕 */
dict[0x26056] = "zhòu"; /* 恖 */
dict[0x26057] = "shè"; /* 恗 */
dict[0x26059] = "yǎn"; /* 恙 */
dict[0x2605b] = "xiè,dié"; /* 恛 */
dict[0x2605c] = "dié"; /* 恜 */
dict[0x2605f] = "chēn,chén,zhěn"; /* 恟 */
dict[0x26072] = "jiǎn"; /* 恲 */
dict[0x26073] = "jì"; /* 恳 */
dict[0x26076] = "chuò"; /* 恶 */
dict[0x26077] = "hóng"; /* 恷 */
dict[0x26080] = "dá"; /* 悀 */
dict[0x26084] = "kāi"; /* 悄 */
dict[0x26085] = "xīng,xǐ"; /* 悅 */
dict[0x26086] = "huì"; /* 悆 */
dict[0x26087] = "jiǎn"; /* 悇 */
dict[0x26088] = "zhòu"; /* 悈 */
dict[0x26089] = "zhǎ"; /* 悉 */
dict[0x2608a] = "fù"; /* 悊 */
dict[0x2608b] = "chì"; /* 悋 */
dict[0x2608c] = "běng"; /* 悌 */
dict[0x2608d] = "nuò"; /* 悍 */
dict[0x26090] = "gōu"; /* 悐 */
dict[0x26091] = "jì"; /* 悑 */
dict[0x26092] = "qián"; /* 悒 */
dict[0x26094] = "wàn"; /* 悔 */
dict[0x26095] = "óu"; /* 悕 */
dict[0x26096] = "bì"; /* 悖 */
dict[0x26097] = "shuò"; /* 悗 */
dict[0x260a0] = "jīng"; /* 悠 */
dict[0x260a1] = "yè"; /* 悡 */
dict[0x260b6] = "yǐ"; /* 悶 */
dict[0x260c4] = "fěi"; /* 惄 */
dict[0x260c7] = "lí"; /* 惇 */
dict[0x260ca] = "lì"; /* 惊 */
dict[0x260cb] = "pí"; /* 惋 */
dict[0x260d2] = "suì"; /* 惒 */
dict[0x260d3] = "liú"; /* 惓 */
dict[0x260d4] = "hé"; /* 惔 */
dict[0x260d5] = "hǔn"; /* 惕 */
dict[0x260d6] = "tǎn"; /* 惖 */
dict[0x260d7] = "shuò"; /* 惗 */
dict[0x260d8] = "zhì"; /* 惘 */
dict[0x260d9] = "bó"; /* 惙 */
dict[0x260dd] = "xì"; /* 惝 */
dict[0x260e1] = "pó,tāo"; /* 惡 */
dict[0x260e2] = "qǔn"; /* 惢 */
dict[0x260e4] = "mù"; /* 惤 */
dict[0x260fd] = "yōng"; /* 惽 */
dict[0x26102] = "dài"; /* 愂 */
dict[0x2610a] = "qǐ"; /* 愊 */
dict[0x2610b] = "diǎo"; /* 愋 */
dict[0x2610c] = "niè"; /* 愌 */
dict[0x2610d] = "shuǎng"; /* 愍 */
dict[0x2610f] = "shāo"; /* 意 */
dict[0x26110] = "kǔn,mí"; /* 愐 */
dict[0x26111] = "suì"; /* 愑 */
dict[0x26113] = "dōu"; /* 愓 */
dict[0x26114] = "dié"; /* 愔 */
dict[0x2611c] = "gōng"; /* 愜 */
dict[0x26127] = "sōu"; /* 愧 */
dict[0x2612f] = "zhuǎn"; /* 愯 */
dict[0x26130] = "guó"; /* 愰 */
dict[0x2613c] = "xū"; /* 愼 */
dict[0x2613d] = "qú"; /* 愽 */
dict[0x2613f] = "mò"; /* 愿 */
dict[0x26140] = "xún"; /* 慀 */
dict[0x26143] = "jiāo,qiāo"; /* 慃 */
dict[0x26144] = "zhé"; /* 慄 */
dict[0x26146] = "diàn"; /* 慆 */
dict[0x26147] = "sāng"; /* 慇 */
dict[0x26148] = "bēng"; /* 慈 */
dict[0x2614a] = "suǒ"; /* 慊 */
dict[0x2614b] = "qiǎn"; /* 態 */
dict[0x2614f] = "xū"; /* 慏 */
dict[0x26151] = "xún"; /* 慑 */
dict[0x26154] = "mò"; /* 慔 */
dict[0x26157] = "chǎn"; /* 慗 */
dict[0x26168] = "xǔ"; /* 慨 */
dict[0x26175] = "suì"; /* 慵 */
dict[0x26176] = "là,liè"; /* 慶 */
dict[0x26177] = "zhǔ,zhù"; /* 慷 */
dict[0x26178] = "zhòu"; /* 慸 */
dict[0x2617a] = "lì"; /* 慺 */
dict[0x2617b] = "huǎn"; /* 慻 */
dict[0x2617c] = "dān"; /* 慼 */
dict[0x2617d] = "jú"; /* 慽 */
dict[0x2617e] = "zhuó"; /* 慾 */
dict[0x2617f] = "yùn"; /* 慿 */
dict[0x26180] = "chǎn"; /* 憀 */
dict[0x26181] = "luó"; /* 憁 */
dict[0x26184] = "sè"; /* 憄 */
dict[0x26186] = "lián"; /* 憆 */
dict[0x26188] = "zuǎn,zuí"; /* 憈 */
dict[0x2618b] = "lài"; /* 憋 */
dict[0x2618c] = "shuǎng"; /* 憌 */
dict[0x2618d] = "qiè"; /* 憍 */
dict[0x26198] = "dōu"; /* 憘 */
dict[0x2619e] = "wù"; /* 憞 */
dict[0x2619f] = "méng"; /* 憟 */
dict[0x261a1] = "jì"; /* 憡 */
dict[0x261a4] = "chī"; /* 憤 */
dict[0x261a6] = "nǐ"; /* 憦 */
dict[0x261b2] = "liào"; /* 憲 */
dict[0x261b8] = "yáo"; /* 憸 */
dict[0x261bb] = "là"; /* 憻 */
dict[0x261be] = "lǜ"; /* 憾 */
dict[0x261c0] = "suì"; /* 懀 */
dict[0x261c1] = "fū"; /* 懁 */
dict[0x261c4] = "lěi"; /* 懄 */
dict[0x261c5] = "wěi"; /* 懅 */
dict[0x261ce] = "cōng"; /* 懎 */
dict[0x261d4] = "lì"; /* 懔 */
dict[0x261d6] = "pín"; /* 懖 */
dict[0x261d8] = "jūn"; /* 懘 */
dict[0x261d9] = "jǔ"; /* 懙 */
dict[0x261db] = "là"; /* 懛 */
dict[0x261e7] = "jì"; /* 懧 */
dict[0x261ea] = "miè"; /* 懪 */
dict[0x261ec] = "yào"; /* 懬 */
dict[0x261ed] = "biān"; /* 懭 */
dict[0x261f1] = "cóng"; /* 懱 */
dict[0x261f2] = "sī,chī"; /* 懲 */
dict[0x261f5] = "sī"; /* 懵 */
dict[0x261f8] = "hé"; /* 懸 */
dict[0x26203] = "nàng"; /* 戃 */
dict[0x26205] = "dié"; /* 戅 */
dict[0x26208] = "chè"; /* 戈 */
dict[0x26223] = "yú"; /* 戣 */
dict[0x26224] = "xiòng"; /* 戤 */
dict[0x26226] = "qì"; /* 戦 */
dict[0x26227] = "bēi"; /* 戧 */
dict[0x26228] = "xíng"; /* 戨 */
dict[0x26229] = "gǒng"; /* 戩 */
dict[0x2622c] = "zuǐ"; /* 戬 */
dict[0x26230] = "jiē"; /* 戰 */
dict[0x26232] = "kāi,gǔ"; /* 戲 */
dict[0x26235] = "xíng"; /* 戵 */
dict[0x26236] = "bēi"; /* 戶 */
dict[0x26237] = "shū"; /* 户 */
dict[0x26238] = "yù"; /* 戸 */
dict[0x2623a] = "zhǒu"; /* 戺 */
dict[0x2623b] = "zhǎn"; /* 戻 */
dict[0x26242] = "zhōng"; /* 扂 */
dict[0x26246] = "chá,chà"; /* 扆 */
dict[0x26248] = "chuí"; /* 扈 */
dict[0x26249] = "liù"; /* 扉 */
dict[0x2624e] = "suī"; /* 扎 */
dict[0x26250] = "zhǔ"; /* 扐 */
dict[0x26259] = "biàn"; /* 扙 */
dict[0x2625d] = "xìn"; /* 扝 */
dict[0x2625f] = "yà"; /* 扟 */
dict[0x26262] = "líng"; /* 扢 */
dict[0x26265] = "wèng"; /* 扥 */
dict[0x26267] = "yà"; /* 执 */
dict[0x2626a] = "wǎng"; /* 扪 */
dict[0x2626c] = "tīng"; /* 扬 */
dict[0x26279] = "dí"; /* 批 */
dict[0x26281] = "pí"; /* 抁 */
dict[0x26282] = "hù"; /* 抂 */
dict[0x26283] = "cén"; /* 抃 */
dict[0x2628a] = "tiān"; /* 把 */
dict[0x2628b] = "mǒu"; /* 抋 */
dict[0x2628c] = "juǎn"; /* 抌 */
dict[0x2628d] = "hù"; /* 抍 */
dict[0x2628e] = "mǒu"; /* 抎 */
dict[0x26290] = "jù"; /* 抐 */
dict[0x26293] = "lǐng"; /* 抓 */
dict[0x26297] = "liǔ"; /* 抗 */
dict[0x26298] = "hù"; /* 折 */
dict[0x262a6] = "fú"; /* 抦 */
dict[0x262a7] = "hú"; /* 抧 */
dict[0x262aa] = "è"; /* 抪 */
dict[0x262ab] = "gōng"; /* 披 */
dict[0x262ac] = "gū"; /* 抬 */
dict[0x262b9] = "lüè"; /* 抹 */
dict[0x262bb] = "fán"; /* 抻 */
dict[0x262bc] = "lǜ"; /* 押 */
dict[0x262bd] = "méng"; /* 抽 */
dict[0x262be] = "fú"; /* 抾 */
dict[0x262bf] = "liú"; /* 抿 */
dict[0x262c5] = "xié"; /* 担 */
dict[0x262c6] = "gū"; /* 拆 */
dict[0x262c8] = "xiàn"; /* 拈 */
dict[0x262c9] = "bó"; /* 拉 */
dict[0x262cb] = "jì"; /* 拋 */
dict[0x262d3] = "quān"; /* 拓 */
dict[0x262d4] = "lù"; /* 拔 */
dict[0x262de] = "shuò"; /* 拞 */
dict[0x262e1] = "mǒu"; /* 拡 */
dict[0x262e2] = "yù"; /* 拢 */
dict[0x262e3] = "hàn"; /* 拣 */
dict[0x262e9] = "yuè"; /* 择 */
dict[0x262ea] = "dàn"; /* 拪 */
dict[0x262ef] = "yú"; /* 拯 */
dict[0x262f0] = "jiān"; /* 拰 */
dict[0x262f3] = "gāng"; /* 拳 */
dict[0x262f9] = "mò"; /* 拹 */
dict[0x262ff] = "cáo"; /* 拿 */
dict[0x26300] = "shèn"; /* 挀 */
dict[0x26301] = "liǔ,lóu"; /* 持 */
dict[0x26306] = "jiāo"; /* 挆 */
dict[0x26309] = "sù"; /* 按 */
dict[0x2630a] = "sù"; /* 挊 */
dict[0x2630b] = "zhòng"; /* 挋 */
dict[0x26312] = "liào"; /* 挒 */
dict[0x26314] = "xuǎn"; /* 挔 */
dict[0x26315] = "lù"; /* 挕 */
dict[0x26317] = "jì"; /* 挗 */
dict[0x2631a] = "yán"; /* 挚 */
dict[0x2631f] = "lù"; /* 挟 */
dict[0x26321] = "mǐn"; /* 挡 */
dict[0x26322] = "tí"; /* 挢 */
dict[0x26326] = "huàn"; /* 挦 */
dict[0x26329] = "yì"; /* 挩 */
dict[0x2632a] = "tǎn"; /* 挪 */
dict[0x2632c] = "wǔ,wú"; /* 挬 */
dict[0x2632d] = "jī"; /* 挭 */
dict[0x26330] = "jī"; /* 挰 */
dict[0x26337] = "dú"; /* 挷 */
dict[0x26338] = "kūn"; /* 挸 */
dict[0x2633a] = "jūn"; /* 挺 */
dict[0x2633e] = "juàn"; /* 挾 */
dict[0x2633f] = "shī"; /* 挿 */
dict[0x26340] = "nàn"; /* 捀 */
dict[0x26341] = "pò"; /* 捁 */
dict[0x26344] = "shū"; /* 捄 */
dict[0x26345] = "quàn"; /* 捅 */
dict[0x2634c] = "rèn"; /* 捌 */
dict[0x2634f] = "fén"; /* 捏 */
dict[0x26352] = "tà"; /* 捒 */
dict[0x26353] = "tún"; /* 捓 */
dict[0x26355] = "yáng"; /* 捕 */
dict[0x2635a] = "gāo"; /* 捚 */
dict[0x26366] = "duō"; /* 捦 */
dict[0x26367] = "cī"; /* 捧 */
dict[0x2636a] = "fén"; /* 捪 */
dict[0x2636d] = "róu"; /* 捭 */
dict[0x26371] = "gāo"; /* 捱 */
dict[0x26372] = "xiáng,yàng"; /* 捲 */
dict[0x26374] = "xiáng"; /* 捴 */
dict[0x26375] = "hǒu"; /* 捵 */
dict[0x26377] = "tāo"; /* 捷 */
dict[0x26378] = "shàn"; /* 捸 */
dict[0x26379] = "yáng"; /* 捹 */
dict[0x2637a] = "zì"; /* 捺 */
dict[0x2637c] = "yuán"; /* 捼 */
dict[0x26384] = "sú"; /* 掄 */
dict[0x26387] = "chuàn"; /* 掇 */
dict[0x26388] = "xiáng,xiè"; /* 授 */
dict[0x2638a] = "bān"; /* 掊 */
dict[0x2638c] = "mǎn"; /* 掌 */
dict[0x2638e] = "fǔ"; /* 掎 */
dict[0x2638f] = "lǎ"; /* 掏 */
dict[0x26390] = "lǐ"; /* 掐 */
dict[0x26392] = "jié"; /* 排 */
dict[0x26393] = "yōu"; /* 掓 */
dict[0x26398] = "yù"; /* 掘 */
dict[0x2639a] = "chì"; /* 掚 */
dict[0x2639c] = "chuàn"; /* 掜 */
dict[0x2639d] = "yì"; /* 掝 */
dict[0x2639e] = "shān"; /* 掞 */
dict[0x263a2] = "jí"; /* 探 */
dict[0x263a3] = "yān"; /* 掣 */
dict[0x263a6] = "wù"; /* 掦 */
dict[0x263a7] = "chún,dūn,dùn"; /* 控 */
dict[0x263a8] = "máng"; /* 推 */
dict[0x263ab] = "chún"; /* 掫 */
dict[0x263ad] = "fú"; /* 掭 */
dict[0x263ae] = "jiā"; /* 掮 */
dict[0x263af] = "gòu"; /* 掯 */
dict[0x263b0] = "gú"; /* 掰 */
dict[0x263b1] = "jiá"; /* 掱 */
dict[0x263b5] = "xián"; /* 掵 */
dict[0x263b7] = "jìn"; /* 掷 */
dict[0x263b8] = "zì"; /* 掸 */
dict[0x263b9] = "lóu"; /* 掹 */
dict[0x263bc] = "gòu"; /* 掼 */
dict[0x263c0] = "rén"; /* 揀 */
dict[0x263c1] = "xī"; /* 揁 */
dict[0x263c2] = "shān"; /* 揂 */
dict[0x263c5] = "jué"; /* 揅 */
dict[0x263c6] = "tóng"; /* 揆 */
dict[0x263c7] = "yǒu"; /* 揇 */
dict[0x263d4] = "jiān"; /* 揔 */
dict[0x263d5] = "dú"; /* 揕 */
dict[0x263d7] = "hú"; /* 揗 */
dict[0x263db] = "sāo"; /* 換 */
dict[0x263dc] = "yù"; /* 揜 */
dict[0x263e2] = "mài"; /* 揢 */
dict[0x263e4] = "zhī"; /* 揤 */
dict[0x263e5] = "yān"; /* 揥 */
dict[0x263e6] = "gāo"; /* 揦 */
dict[0x263e7] = "shú"; /* 揧 */
dict[0x263e8] = "huài"; /* 揨 */
dict[0x263ee] = "quán"; /* 揮 */
dict[0x263f1] = "yǎng,chài"; /* 揱 */
dict[0x263f3] = "zuǐ"; /* 揳 */
dict[0x263f7] = "xiāo"; /* 揷 */
dict[0x263f8] = "yì,chí"; /* 揸 */
dict[0x263f9] = "yǎn"; /* 揹 */
dict[0x263fa] = "hóng,gòng"; /* 揺 */
dict[0x263fb] = "yú,yù"; /* 揻 */
dict[0x263ff] = "chì"; /* 揿 */
dict[0x26401] = "chí"; /* 搁 */
dict[0x26404] = "háng"; /* 搄 */
dict[0x26405] = "sè"; /* 搅 */
dict[0x26406] = "pā"; /* 搆 */
dict[0x26407] = "tà"; /* 搇 */
dict[0x26408] = "fēn"; /* 搈 */
dict[0x26409] = "chī"; /* 搉 */
dict[0x2640d] = "xuè"; /* 損 */
dict[0x26416] = "zhǐ"; /* 搖 */
dict[0x2641b] = "qú,yù"; /* 搛 */
dict[0x26420] = "xī"; /* 搠 */
dict[0x26421] = "fú"; /* 搡 */
dict[0x26423] = "shū"; /* 搣 */
dict[0x26424] = "hài"; /* 搤 */
dict[0x26426] = "pò"; /* 搦 */
dict[0x26427] = "yì"; /* 搧 */
dict[0x26428] = "cǐ"; /* 搨 */
dict[0x26430] = "chài"; /* 搰 */
dict[0x26433] = "hōng"; /* 搳 */
dict[0x26438] = "pǎo"; /* 搸 */
dict[0x26439] = "shēn"; /* 搹 */
dict[0x2643a] = "xiāo"; /* 携 */
dict[0x2643d] = "xuān,líng"; /* 搽 */
dict[0x2643e] = "cǐ"; /* 搾 */
dict[0x2643f] = "tíng"; /* 搿 */
dict[0x26440] = "pò"; /* 摀 */
dict[0x26447] = "tà"; /* 摇 */
dict[0x26448] = "chā"; /* 摈 */
dict[0x2644b] = "zú"; /* 摋 */
dict[0x2644c] = "huò"; /* 摌 */
dict[0x2644d] = "xù"; /* 摍 */
dict[0x2644e] = "yàn"; /* 摎 */
dict[0x2644f] = "chài"; /* 摏 */
dict[0x26451] = "tuó"; /* 摑 */
dict[0x26458] = "xián"; /* 摘 */
dict[0x26459] = "xuān"; /* 摙 */
dict[0x2645a] = "hóu"; /* 摚 */
dict[0x2645b] = "huǎn"; /* 摛 */
dict[0x2645c] = "gé"; /* 摜 */
dict[0x2645d] = "chǒng"; /* 摝 */
dict[0x2645e] = "bì"; /* 摞 */
dict[0x2645f] = "hōng"; /* 摟 */
dict[0x26460] = "hōng"; /* 摠 */
dict[0x26461] = "chí,chī"; /* 摡 */
dict[0x26463] = "chá"; /* 摣 */
dict[0x2646d] = "bì"; /* 摭 */
dict[0x2646f] = "zhǎ"; /* 摯 */
dict[0x26471] = "zhái,huò"; /* 摱 */
dict[0x26472] = "tà"; /* 摲 */
dict[0x26475] = "pò"; /* 摵 */
dict[0x26476] = "tà"; /* 摶 */
dict[0x26478] = "yóu"; /* 摸 */
dict[0x26479] = "fú"; /* 摹 */
dict[0x2647a] = "cī"; /* 摺 */
dict[0x2647b] = "dá"; /* 摻 */
dict[0x2647c] = "tǎ"; /* 摼 */
dict[0x2647e] = "liú"; /* 摾 */
dict[0x26481] = "cī"; /* 撁 */
dict[0x26483] = "hōng"; /* 撃 */
dict[0x26485] = "hàn"; /* 撅 */
dict[0x26486] = "lā"; /* 撆 */
dict[0x26488] = "shī"; /* 撈 */
dict[0x2648b] = "hàn"; /* 撋 */
dict[0x2648d] = "tóng"; /* 撍 */
dict[0x2648e] = "huì"; /* 撎 */
dict[0x2648f] = "hé"; /* 撏 */
dict[0x26490] = "piē"; /* 撐 */
dict[0x26491] = "yù"; /* 撑 */
dict[0x2649c] = "xiān"; /* 撜 */
dict[0x2649d] = "hǎn"; /* 撝 */
dict[0x2649f] = "pò"; /* 撟 */
dict[0x264a2] = "áo"; /* 撢 */
dict[0x264a6] = "là"; /* 撦 */
dict[0x264a7] = "huò"; /* 撧 */
dict[0x264b0] = "tài"; /* 撰 */
dict[0x264b4] = "lǎo"; /* 撴 */
dict[0x264b6] = "shù"; /* 撶 */
dict[0x264ba] = "dào"; /* 撺 */
dict[0x264bb] = "diǎn"; /* 撻 */
dict[0x264c8] = "xiòng"; /* 擈 */
dict[0x264cb] = "wàng"; /* 擋 */
dict[0x264cd] = "chě"; /* 操 */
dict[0x264ce] = "nài"; /* 擎 */
dict[0x264d0] = "jué"; /* 擐 */
dict[0x264d3] = "ér,liè"; /* 擓 */
dict[0x264d4] = "ér,xū"; /* 擔 */
dict[0x264d5] = "nǘ"; /* 擕 */
dict[0x264d6] = "nǜ"; /* 擖 */
dict[0x264da] = "zhuǎn"; /* 據 */
dict[0x264dd] = "zhuǎn"; /* 擝 */
dict[0x264e2] = "nuò"; /* 擢 */
dict[0x264e4] = "liè"; /* 擤 */
dict[0x264e5] = "lěi"; /* 擥 */
dict[0x264e7] = "bā"; /* 擧 */
dict[0x264ec] = "chēng"; /* 擬 */
dict[0x264ef] = "guī"; /* 擯 */
dict[0x264f0] = "quán"; /* 擰 */
dict[0x264f1] = "gè"; /* 擱 */
dict[0x264f3] = "gǒng"; /* 擳 */
dict[0x264f4] = "shào,shāo"; /* 擴 */
dict[0x264f9] = "lái"; /* 擹 */
dict[0x264fa] = "zhēng"; /* 擺 */
dict[0x264fb] = "yì"; /* 擻 */
dict[0x264fc] = "gǔn"; /* 擼 */
dict[0x264fd] = "wēi"; /* 擽 */
dict[0x264fe] = "lǔn,kǔn"; /* 擾 */
dict[0x26502] = "shí"; /* 攂 */
dict[0x26503] = "yīng"; /* 攃 */
dict[0x26504] = "shěng"; /* 攄 */
dict[0x26505] = "tú"; /* 攅 */
dict[0x26506] = "bì"; /* 攆 */
dict[0x26508] = "zé"; /* 攈 */
dict[0x26509] = "zhòng"; /* 攉 */
dict[0x2650b] = "rǒng"; /* 攋 */
dict[0x2650c] = "qí,sí"; /* 攌 */
dict[0x2650d] = "fù"; /* 攍 */
dict[0x2650e] = "cè"; /* 攎 */
dict[0x26510] = "yún"; /* 攐 */
dict[0x26513] = "lí"; /* 攓 */
dict[0x26514] = "mán,màn"; /* 攔 */
dict[0x26516] = "lián"; /* 攖 */
dict[0x26517] = "biāo"; /* 攗 */
dict[0x2651b] = "chuáng"; /* 攛 */
dict[0x2651c] = "yì"; /* 攜 */
dict[0x26520] = "pài"; /* 攠 */
dict[0x26525] = "yì,shì"; /* 攥 */
dict[0x26526] = "kuài"; /* 攦 */
dict[0x26529] = "biāo,pāo"; /* 攩 */
dict[0x2652b] = "chì,yì"; /* 攫 */
dict[0x2652c] = "qú"; /* 攬 */
dict[0x2652d] = "mò"; /* 攭 */
dict[0x2652e] = "zhé"; /* 攮 */
dict[0x2652f] = "shà"; /* 支 */
dict[0x26530] = "shà,xū"; /* 攰 */
dict[0x26535] = "wén"; /* 攵 */
dict[0x26537] = "yāo"; /* 攷 */
dict[0x26538] = "gōng"; /* 攸 */
dict[0x26539] = "nài"; /* 改 */
dict[0x2653b] = "shèng"; /* 攻 */
dict[0x2653c] = "xiè"; /* 攼 */
dict[0x2653f] = "tiàn"; /* 政 */
dict[0x26546] = "yé"; /* 敆 */
dict[0x26549] = "shā"; /* 敉 */
dict[0x2654f] = "sào"; /* 敏 */
dict[0x26552] = "diān"; /* 敒 */
dict[0x26553] = "xù"; /* 敓 */
dict[0x26559] = "qú"; /* 教 */
dict[0x26560] = "hōng"; /* 敠 */
dict[0x26561] = "shèng"; /* 敡 */
dict[0x26562] = "tìng"; /* 敢 */
dict[0x26570] = "duo"; /* 数 */
dict[0x26575] = "liáo"; /* 敵 */
dict[0x26577] = "hòng"; /* 敷 */
dict[0x26578] = "lǐ"; /* 數 */
dict[0x2657a] = "xiǎng,gāo"; /* 敺 */
dict[0x2657d] = "shèn"; /* 敽 */
dict[0x26580] = "fū"; /* 斀 */
dict[0x26588] = "yǎn"; /* 斈 */
dict[0x26589] = "wǎng"; /* 斉 */
dict[0x2658a] = "qī"; /* 斊 */
dict[0x2658b] = "duǒ"; /* 斋 */
dict[0x2658d] = "huà"; /* 斍 */
dict[0x2658e] = "qiān"; /* 斎 */
dict[0x26590] = "xiè"; /* 斐 */
dict[0x2659d] = "cì"; /* 斝 */
dict[0x2659e] = "shēng,wén"; /* 斞 */
dict[0x265a2] = "èr"; /* 斢 */
dict[0x265a4] = "xīng"; /* 斤 */
dict[0x265a6] = "tuì"; /* 斦 */
dict[0x265a7] = "yàn"; /* 斧 */
dict[0x265a9] = "liè"; /* 斩 */
dict[0x265ac] = "mí"; /* 斬 */
dict[0x265b8] = "zòng"; /* 斸 */
dict[0x265ba] = "zī"; /* 斺 */
dict[0x265bc] = "hú"; /* 於 */
dict[0x265bd] = "yíng"; /* 施 */
dict[0x265be] = "lián"; /* 斾 */
dict[0x265bf] = "dā"; /* 斿 */
dict[0x265c0] = "tián"; /* 旀 */
dict[0x265c1] = "tiàn"; /* 旁 */
dict[0x265cb] = "róng"; /* 旋 */
dict[0x265cd] = "ài"; /* 旍 */
dict[0x265d0] = "ài"; /* 旐 */
dict[0x265d1] = "zhé"; /* 旑 */
dict[0x265d2] = "guō"; /* 旒 */
dict[0x265d3] = "lù"; /* 旓 */
dict[0x265d4] = "zhāo"; /* 旔 */
dict[0x265d5] = "mí"; /* 旕 */
dict[0x265d6] = "liáo"; /* 旖 */
dict[0x265d7] = "zhé"; /* 旗 */
dict[0x265db] = "qǔ"; /* 旛 */
dict[0x265dc] = "cōng"; /* 旜 */
dict[0x265df] = "tīng,tè"; /* 旟 */
dict[0x265e1] = "tán"; /* 旡 */
dict[0x265e2] = "zhǎn"; /* 既 */
dict[0x265e3] = "hú"; /* 旣 */
dict[0x265e5] = "piē"; /* 日 */
dict[0x265e7] = "dā"; /* 旧 */
dict[0x265e8] = "róng"; /* 旨 */
dict[0x265ee] = "nǎo"; /* 旮 */
dict[0x265f3] = "náng"; /* 旳 */
dict[0x265f4] = "dāng"; /* 旴 */
dict[0x265f5] = "jiǎo"; /* 旵 */
dict[0x265fb] = "jù"; /* 旻 */
dict[0x265fc] = "ěr"; /* 旼 */
dict[0x2660a] = "lì"; /* 昊 */
dict[0x2660c] = "guō"; /* 昌 */
dict[0x2660d] = "wài,wà"; /* 昍 */
dict[0x26612] = "niè"; /* 昒 */
dict[0x26614] = "jīn"; /* 昔 */
dict[0x2661d] = "sù"; /* 昝 */
dict[0x26629] = "pǐ"; /* 昩 */
dict[0x2662a] = "chì"; /* 昪 */
dict[0x26632] = "pǐ"; /* 昲 */
dict[0x26633] = "yì"; /* 昳 */
dict[0x26634] = "dū"; /* 昴 */
dict[0x26635] = "wǎ"; /* 昵 */
dict[0x26636] = "xūn"; /* 昶 */
dict[0x26638] = "qì"; /* 昸 */
dict[0x26639] = "shàn,yuè"; /* 昹 */
dict[0x2663c] = "xū"; /* 昼 */
dict[0x2663f] = "hē"; /* 昿 */
dict[0x26640] = "pàn"; /* 晀 */
dict[0x26642] = "pēi"; /* 時 */
dict[0x26644] = "xiōng"; /* 晄 */
dict[0x26646] = "chǐ"; /* 晆 */
dict[0x26647] = "tān"; /* 晇 */
dict[0x26648] = "zuì,cuì"; /* 晈 */
dict[0x26649] = "zuǎn"; /* 晉 */
dict[0x2664a] = "qì"; /* 晊 */
dict[0x2664b] = "dū"; /* 晋 */
dict[0x2664d] = "yìn"; /* 晍 */
dict[0x26659] = "shuǐ"; /* 晙 */
dict[0x2665c] = "nǎ"; /* 晜 */
dict[0x2665d] = "xī"; /* 晝 */
dict[0x26667] = "chǎo"; /* 晧 */
dict[0x26668] = "yì"; /* 晨 */
dict[0x2666a] = "jiān"; /* 晪 */
dict[0x2666b] = "zhēng"; /* 晫 */
dict[0x2666e] = "jú"; /* 普 */
dict[0x2666f] = "dài"; /* 景 */
dict[0x26671] = "sān"; /* 晱 */
dict[0x26674] = "zhù"; /* 晴 */
dict[0x26675] = "wàn"; /* 晵 */
dict[0x26676] = "gǔ"; /* 晶 */
dict[0x26678] = "sān"; /* 晸 */
dict[0x26679] = "bàn"; /* 晹 */
dict[0x2667a] = "jià,jiā"; /* 智 */
dict[0x2667b] = "mài"; /* 晻 */
dict[0x2667f] = "kuàng"; /* 晿 */
dict[0x26688] = "tuò,dù"; /* 暈 */
dict[0x2668a] = "qì"; /* 暊 */
dict[0x2668f] = "zhuāng"; /* 暏 */
dict[0x26690] = "tuó"; /* 暐 */
dict[0x26693] = "píng"; /* 暓 */
dict[0x26699] = "zǐ"; /* 暙 */
dict[0x2669d] = "pēng"; /* 暝 */
dict[0x2669e] = "kuāng,kuàng"; /* 暞 */
dict[0x2669f] = "yí"; /* 暟 */
dict[0x266a1] = "xiè,mài"; /* 暡 */
dict[0x266a2] = "yuē"; /* 暢 */
dict[0x266a3] = "hén"; /* 暣 */
dict[0x266a5] = "hóu,yóu"; /* 暥 */
dict[0x266a6] = "zhēng"; /* 暦 */
dict[0x266a7] = "chǔn"; /* 暧 */
dict[0x266a8] = "shì"; /* 暨 */
dict[0x266a9] = "wǎ"; /* 暩 */
dict[0x266ab] = "xié"; /* 暫 */
dict[0x266b8] = "gèng"; /* 暸 */
dict[0x266c5] = "è"; /* 曅 */
dict[0x266c6] = "chéng"; /* 曆 */
dict[0x266ca] = "cún"; /* 曊 */
dict[0x266cf] = "kú"; /* 曏 */
dict[0x266d0] = "nà"; /* 曐 */
dict[0x266d3] = "jū"; /* 曓 */
dict[0x266d4] = "xuàn"; /* 曔 */
dict[0x266d5] = "qū"; /* 曕 */
dict[0x266d6] = "chè"; /* 曖 */
dict[0x266d7] = "lǚ"; /* 曗 */
dict[0x266d8] = "hé"; /* 曘 */
dict[0x266d9] = "shèng"; /* 曙 */
dict[0x266da] = "nàn"; /* 曚 */
dict[0x266dc] = "hé,hán"; /* 曜 */
dict[0x266dd] = "chá"; /* 曝 */
dict[0x266de] = "yān"; /* 曞 */
dict[0x266df] = "gěng"; /* 曟 */
dict[0x266e0] = "niè"; /* 曠 */
dict[0x266e2] = "guó"; /* 曢 */
dict[0x266e3] = "yán"; /* 曣 */
dict[0x266e4] = "guǎn"; /* 曤 */
dict[0x266e7] = "zhì"; /* 曧 */
dict[0x266ef] = "dǔ"; /* 曯 */
dict[0x266f0] = "qì"; /* 曰 */
dict[0x266f1] = "qū"; /* 曱 */
dict[0x266f2] = "jué"; /* 曲 */
dict[0x266f9] = "zì"; /* 曹 */
dict[0x26701] = "fēng"; /* 朁 */
dict[0x26703] = "xù"; /* 會 */
dict[0x26704] = "tuì"; /* 朄 */
dict[0x26706] = "hán"; /* 朆 */
dict[0x26707] = "kū"; /* 朇 */
dict[0x2670a] = "shēn"; /* 朊 */
dict[0x2670b] = "zhì"; /* 朋 */
dict[0x2670d] = "pàng"; /* 服 */
dict[0x2670e] = "zhēng"; /* 朎 */
dict[0x2670f] = "lì"; /* 朏 */
dict[0x26710] = "wǎn"; /* 朐 */
dict[0x26712] = "fǎn"; /* 朒 */
dict[0x26713] = "xìn"; /* 朓 */
dict[0x26716] = "yà"; /* 朖 */
dict[0x2671b] = "jū"; /* 望 */
dict[0x2671c] = "shèn"; /* 朜 */
dict[0x2671d] = "qí"; /* 朝 */
dict[0x2671f] = "bù"; /* 期 */
dict[0x2672d] = "mǎng"; /* 札 */
dict[0x2672f] = "tǔn"; /* 术 */
dict[0x26730] = "zhuó"; /* 朰 */
dict[0x26731] = "xī"; /* 朱 */
dict[0x26732] = "yìn"; /* 朲 */
dict[0x26733] = "jīng"; /* 朳 */
dict[0x26734] = "tún"; /* 朴 */
dict[0x26737] = "gèng"; /* 朷 */
dict[0x26738] = "jì"; /* 朸 */
dict[0x2674f] = "zhuǎn,shuàn"; /* 杏 */
dict[0x26752] = "tiē"; /* 杒 */
dict[0x26754] = "zhī"; /* 杔 */
dict[0x26756] = "jí"; /* 杖 */
dict[0x2675a] = "yíng"; /* 杚 */
dict[0x2675b] = "wèi"; /* 杛 */
dict[0x2675d] = "huàn"; /* 杝 */
dict[0x2675e] = "tíng"; /* 杞 */
dict[0x2675f] = "chán"; /* 束 */
dict[0x26762] = "kuí"; /* 杢 */
dict[0x26763] = "qià,kē"; /* 杣 */
dict[0x26764] = "bàn"; /* 杤 */
dict[0x26765] = "chā,zhá"; /* 来 */
dict[0x26766] = "tuǒ"; /* 杦 */
dict[0x26767] = "nǎn"; /* 杧 */
dict[0x26768] = "jiē"; /* 杨 */
dict[0x2676a] = "yān"; /* 杪 */
dict[0x2676c] = "tú"; /* 杬 */
dict[0x2676d] = "lǜ"; /* 杭 */
dict[0x2676e] = "wěn"; /* 杮 */
dict[0x26770] = "cōng"; /* 杰 */
dict[0x26773] = "xù"; /* 杳 */
dict[0x26774] = "yìn"; /* 杴 */
dict[0x26777] = "bèng"; /* 杷 */
dict[0x26781] = "zāi"; /* 极 */
dict[0x26782] = "dā,da"; /* 枂 */
dict[0x26786] = "niè"; /* 枆 */
dict[0x26787] = "jǔ"; /* 枇 */
dict[0x26788] = "hóu"; /* 枈 */
dict[0x2678c] = "gèng"; /* 枌 */
dict[0x26795] = "hóu"; /* 枕 */
dict[0x26796] = "kān"; /* 枖 */
dict[0x26797] = "gōng"; /* 林 */
dict[0x26799] = "huǐ"; /* 枙 */
dict[0x2679a] = "xiè"; /* 枚 */
dict[0x2679d] = "xì"; /* 枝 */
dict[0x2679e] = "hán"; /* 枞 */
dict[0x2679f] = "mí"; /* 枟 */
dict[0x267a1] = "wěng"; /* 枡 */
dict[0x267a2] = "hùn"; /* 枢 */
dict[0x267a3] = "sāo,sào"; /* 枣 */
dict[0x267a4] = "xìn,zǐ"; /* 枤 */
dict[0x267a5] = "zhé"; /* 枥 */
dict[0x267a6] = "hè"; /* 枦 */
dict[0x267a8] = "gōng"; /* 枨 */
dict[0x267ab] = "sài"; /* 枫 */
dict[0x267ac] = "jīn,jiàn"; /* 枬 */
dict[0x267ad] = "wā"; /* 枭 */
dict[0x267b1] = "duǐ"; /* 枱 */
dict[0x267b2] = "chī"; /* 枲 */
dict[0x267bd] = "xī,wèi,jí"; /* 枽 */
dict[0x267c0] = "luó"; /* 柀 */
dict[0x267c1] = "huāng"; /* 柁 */
dict[0x267c2] = "mí"; /* 柂 */
dict[0x267c3] = "zāng"; /* 柃 */
dict[0x267c4] = "sǎng,sào"; /* 柄 */
dict[0x267cc] = "jiǎn"; /* 柌 */
dict[0x267d0] = "mā"; /* 某 */
dict[0x267d3] = "tún"; /* 染 */
dict[0x267d4] = "zhì"; /* 柔 */
dict[0x267d5] = "wěn"; /* 柕 */
dict[0x267d8] = "yín"; /* 柘 */
dict[0x267d9] = "tǔn"; /* 柙 */
dict[0x267db] = "chōng"; /* 柛 */
dict[0x267dc] = "zé"; /* 柜 */
dict[0x267de] = "xiāo"; /* 柞 */
dict[0x267df] = "mó"; /* 柟 */
dict[0x267e0] = "cù"; /* 柠 */
dict[0x267e3] = "biǎn"; /* 柣 */
dict[0x267e4] = "xiū"; /* 柤 */
dict[0x267e7] = "yí"; /* 柧 */
dict[0x267ee] = "huǎng"; /* 柮 */
dict[0x267f0] = "zhā"; /* 柰 */
dict[0x267f1] = "suō"; /* 柱 */
dict[0x267f2] = "hún"; /* 柲 */
dict[0x267f3] = "jù"; /* 柳 */
dict[0x267fe] = "ōu"; /* 柾 */
dict[0x26801] = "cù"; /* 栁 */
dict[0x26804] = "jī"; /* 栄 */
dict[0x26805] = "xún"; /* 栅 */
dict[0x26806] = "sǔn,zhuàn"; /* 栆 */
dict[0x26807] = "céng"; /* 标 */
dict[0x26809] = "yì"; /* 栉 */
dict[0x2680e] = "biāo"; /* 栎 */
dict[0x26812] = "jué"; /* 栒 */
dict[0x26813] = "lì"; /* 栓 */
dict[0x26816] = "pào"; /* 栖 */
dict[0x2681b] = "zā"; /* 栛 */
dict[0x2681c] = "yè"; /* 栜 */
dict[0x2681e] = "bì"; /* 栞 */
dict[0x2681f] = "zhè"; /* 栟 */
dict[0x26820] = "zhè"; /* 栠 */
dict[0x26822] = "jiù"; /* 栢 */
dict[0x26823] = "zhé"; /* 栣 */
dict[0x26826] = "shù"; /* 栦 */
dict[0x2682a] = "xī"; /* 株 */
dict[0x26837] = "xǔ"; /* 样 */
dict[0x26838] = "nǎi"; /* 核 */
dict[0x26839] = "xián"; /* 根 */
dict[0x2683a] = "gǔn"; /* 栺 */
dict[0x2683b] = "wèi"; /* 栻 */
dict[0x2683e] = "jí"; /* 栾 */
dict[0x2683f] = "sà"; /* 栿 */
dict[0x26842] = "dǒng"; /* 桂 */
dict[0x26843] = "nuó,nié"; /* 桃 */
dict[0x26844] = "dù"; /* 桄 */
dict[0x26845] = "zhēng"; /* 桅 */
dict[0x26846] = "kū"; /* 框 */
dict[0x26849] = "míng"; /* 桉 */
dict[0x26855] = "báo"; /* 桕 */
dict[0x26856] = "huì"; /* 桖 */
dict[0x26859] = "zōng"; /* 桙 */
dict[0x26868] = "sàn"; /* 桨 */
dict[0x2686a] = "tēng"; /* 桪 */
dict[0x2686b] = "yí"; /* 桫 */
dict[0x2686d] = "yù"; /* 桭 */
dict[0x26871] = "yào,shào"; /* 桱 */
dict[0x26872] = "nǐng"; /* 桲 */
dict[0x26874] = "chóu,zhǒu"; /* 桴 */
dict[0x26875] = "hùn"; /* 桵 */
dict[0x26877] = "duì"; /* 桷 */
dict[0x26879] = "qì"; /* 桹 */
dict[0x2687a] = "yǐng"; /* 桺 */
dict[0x2687b] = "bìng"; /* 桻 */
dict[0x2687c] = "níng"; /* 桼 */
dict[0x2687d] = "huáng"; /* 桽 */
dict[0x26882] = "pú"; /* 梂 */
dict[0x26886] = "yǐng"; /* 梆 */
dict[0x2688a] = "báo,bó"; /* 梊 */
dict[0x2688e] = "guàng"; /* 梎 */
dict[0x2688f] = "lěi"; /* 梏 */
dict[0x26890] = "zǔn"; /* 梐 */
dict[0x26899] = "chǎn,qiān,xiān"; /* 梙 */
dict[0x268a3] = "jiǎn"; /* 梣 */
dict[0x268a7] = "méng"; /* 梧 */
dict[0x268a9] = "xiào,sōu"; /* 梩 */
dict[0x268af] = "xìn,xìng"; /* 梯 */
dict[0x268b1] = "lí"; /* 梱 */
dict[0x268ba] = "qiǎo"; /* 梺 */
dict[0x268bb] = "yīng"; /* 梻 */
dict[0x268bf] = "wěi,juǎn"; /* 梿 */
dict[0x268c0] = "nà,niè,zhé"; /* 检 */
dict[0x268c2] = "pāng"; /* 棂 */
dict[0x268c4] = "léi"; /* 棄 */
dict[0x268c7] = "luó"; /* 棇 */
dict[0x268cb] = "luán"; /* 棋 */
dict[0x268cd] = "gēng"; /* 棍 */
dict[0x268cf] = "luán"; /* 棏 */
dict[0x268d2] = "qú"; /* 棒 */
dict[0x268d6] = "luó"; /* 棖 */
dict[0x268d8] = "náng"; /* 棘 */
dict[0x268db] = "luó"; /* 棛 */
dict[0x268dc] = "yuè"; /* 棜 */
dict[0x268dd] = "yí"; /* 棝 */
dict[0x268de] = "yí"; /* 棞 */
dict[0x268e2] = "shuì"; /* 棢 */
dict[0x268e5] = "mì"; /* 棥 */
dict[0x268e6] = "wáng"; /* 棦 */
dict[0x268e7] = "cè"; /* 棧 */
dict[0x268e8] = "jiān"; /* 棨 */
dict[0x268e9] = "wǎng"; /* 棩 */
dict[0x268ef] = "jiā"; /* 棯 */
dict[0x268f1] = "zé"; /* 棱 */
dict[0x268f4] = "huán"; /* 棴 */
dict[0x268f8] = "liàn"; /* 棸 */
dict[0x268f9] = "zì"; /* 棹 */
dict[0x268fa] = "bái"; /* 棺 */
dict[0x268fb] = "shǒu,bǎi"; /* 棻 */
dict[0x268fe] = "wǎn"; /* 棾 */
dict[0x26902] = "shū"; /* 椂 */
dict[0x26907] = "guī"; /* 椇 */
dict[0x26908] = "xī"; /* 椈 */
dict[0x2690a] = "rú"; /* 椊 */
dict[0x2690b] = "yào"; /* 椋 */
dict[0x2690e] = "gāo"; /* 椎 */
dict[0x26915] = "yuè"; /* 椕 */
dict[0x26918] = "yōng"; /* 椘 */
dict[0x26919] = "wà"; /* 椙 */
dict[0x2691a] = "bó"; /* 椚 */
dict[0x2691d] = "mián"; /* 椝 */
dict[0x2691f] = "xìn"; /* 椟 */
dict[0x26922] = "pì"; /* 椢 */
dict[0x26923] = "bó"; /* 椣 */
dict[0x26926] = "hài,hè,ài"; /* 椦 */
dict[0x26927] = "zhài"; /* 椧 */
dict[0x26928] = "wò"; /* 椨 */
dict[0x2692a] = "yè"; /* 椪 */
dict[0x2692b] = "bì,bí"; /* 椫 */
dict[0x2692c] = "hài"; /* 椬 */
dict[0x26938] = "chì"; /* 椸 */
dict[0x2693b] = "zhì"; /* 椻 */
dict[0x2693d] = "ní"; /* 椽 */
dict[0x26941] = "wú"; /* 楁 */
dict[0x26942] = "ǎi"; /* 楂 */
dict[0x26948] = "ǎi"; /* 楈 */
dict[0x26949] = "yǔ"; /* 楉 */
dict[0x2694a] = "chì"; /* 楊 */
dict[0x2694d] = "jìng"; /* 楍 */
dict[0x2694e] = "zhì"; /* 楎 */
dict[0x2694f] = "zhì"; /* 楏 */
dict[0x26950] = "zhì"; /* 楐 */
dict[0x26951] = "jú,jǔ"; /* 楑 */
dict[0x26956] = "hán,xián"; /* 楖 */
dict[0x2695a] = "pīng"; /* 楚 */
dict[0x2695d] = "yǎo"; /* 楝 */
dict[0x26963] = "yóu"; /* 楣 */
dict[0x26964] = "pīng"; /* 楤 */
dict[0x26966] = "mò"; /* 楦 */
dict[0x2696c] = "zuò"; /* 楬 */
dict[0x2696d] = "pò"; /* 業 */
dict[0x2696f] = "xué"; /* 楯 */
dict[0x26970] = "kuáng"; /* 楰 */
dict[0x26971] = "yì"; /* 楱 */
dict[0x26972] = "pò"; /* 楲 */
dict[0x2697b] = "zhuì"; /* 楻 */
dict[0x26983] = "ní"; /* 榃 */
dict[0x26984] = "qiǔ"; /* 榄 */
dict[0x26985] = "còu"; /* 榅 */
dict[0x2698c] = "yǎo"; /* 榌 */
dict[0x26991] = "fén"; /* 榑 */
dict[0x26995] = "xiá"; /* 榕 */
dict[0x26997] = "jiāng"; /* 榗 */
dict[0x26998] = "chā"; /* 榘 */
dict[0x2699b] = "xiào"; /* 榛 */
dict[0x2699c] = "chā"; /* 榜 */
dict[0x269a2] = "chéng"; /* 榢 */
dict[0x269a3] = "cuì"; /* 榣 */
dict[0x269a7] = "qióng,gǒng"; /* 榧 */
dict[0x269a9] = "yù"; /* 榩 */
dict[0x269ab] = "yú"; /* 榫 */
dict[0x269af] = "wèn"; /* 榯 */
dict[0x269b1] = "chā"; /* 榱 */
dict[0x269b2] = "yǔ,yù"; /* 榲 */
dict[0x269b9] = "zuó"; /* 榹 */
dict[0x269ba] = "dǎo"; /* 榺 */
dict[0x269bd] = "juàn,fàn"; /* 榽 */
dict[0x269be] = "dǎo"; /* 榾 */
dict[0x269bf] = "yīng"; /* 榿 */
dict[0x269c1] = "fěng"; /* 槁 */
dict[0x269c5] = "wèng"; /* 槅 */
dict[0x269c8] = "jìn"; /* 槈 */
dict[0x269c9] = "qì"; /* 槉 */
dict[0x269cb] = "qìn"; /* 構 */
dict[0x269cd] = "kuò"; /* 槍 */
dict[0x269cf] = "tān"; /* 槏 */
dict[0x269d0] = "xiān"; /* 槐 */
dict[0x269d2] = "tiān"; /* 槒 */
dict[0x269d4] = "kuò"; /* 槔 */
dict[0x269d6] = "tiàn"; /* 槖 */
dict[0x269d8] = "hú"; /* 様 */
dict[0x269d9] = "zhū"; /* 槙 */
dict[0x269da] = "zhān"; /* 槚 */
dict[0x269db] = "tà"; /* 槛 */
dict[0x269dd] = "tiān"; /* 槝 */
dict[0x269de] = "tà"; /* 槞 */
dict[0x269df] = "tà"; /* 槟 */
dict[0x269e0] = "huá"; /* 槠 */
dict[0x269e1] = "yǎn,tiàn"; /* 槡 */
dict[0x269e2] = "tiè"; /* 槢 */
dict[0x269e4] = "tiè"; /* 槤 */
dict[0x269e5] = "tà"; /* 槥 */
dict[0x269ec] = "huài"; /* 槬 */
dict[0x269ee] = "jiá"; /* 槮 */
dict[0x269ef] = "qì"; /* 槯 */
dict[0x269f1] = "tà"; /* 槱 */
dict[0x269f2] = "luó"; /* 槲 */
dict[0x269f4] = "tān"; /* 槴 */
dict[0x269f5] = "huà"; /* 槵 */
dict[0x269f8] = "zhuàn"; /* 槸 */
dict[0x269f9] = "huā"; /* 槹 */
dict[0x269fa] = "lài"; /* 槺 */
dict[0x269fc] = "lán"; /* 槼 */
dict[0x26a06] = "zūn"; /* 樆 */
dict[0x26a07] = "yì"; /* 樇 */
dict[0x26a08] = "fú"; /* 樈 */
dict[0x26a09] = "wù"; /* 樉 */
dict[0x26a0b] = "fú"; /* 樋 */
dict[0x26a0d] = "dīng"; /* 樍 */
dict[0x26a0e] = "tà"; /* 樎 */
dict[0x26a16] = "chào"; /* 樖 */
dict[0x26a19] = "rì"; /* 標 */
dict[0x26a1a] = "quǎn"; /* 樚 */
dict[0x26a1c] = "gē"; /* 樜 */
dict[0x26a21] = "fú"; /* 模 */
dict[0x26a22] = "dì"; /* 樢 */
dict[0x26a23] = "diāo"; /* 樣 */
dict[0x26a24] = "yǒng"; /* 樤 */
dict[0x26a26] = "jià"; /* 樦 */
dict[0x26a2c] = "yǒng"; /* 樬 */
dict[0x26a2d] = "pí"; /* 樭 */
dict[0x26a2f] = "huó"; /* 樯 */
dict[0x26a30] = "qióng"; /* 樰 */
dict[0x26a32] = "fán"; /* 樲 */
dict[0x26a33] = "wú"; /* 樳 */
dict[0x26a34] = "tóng"; /* 樴 */
dict[0x26a35] = "háng"; /* 樵 */
dict[0x26a38] = "tān"; /* 樸 */
dict[0x26a3e] = "hēng"; /* 樾 */
dict[0x26a44] = "tiāo"; /* 橄 */
dict[0x26a48] = "zhōu"; /* 橈 */
dict[0x26a4b] = "bài"; /* 橋 */
dict[0x26a4c] = "xiè"; /* 橌 */
dict[0x26a4d] = "dāo,diāo"; /* 橍 */
dict[0x26a4f] = "jīn,wéi"; /* 橏 */
dict[0x26a55] = "hū"; /* 橕 */
dict[0x26a56] = "bēi"; /* 橖 */
dict[0x26a58] = "dìng"; /* 橘 */
dict[0x26a5c] = "nuó"; /* 橜 */
dict[0x26a5d] = "wèi"; /* 橝 */
dict[0x26a5e] = "yú"; /* 橞 */
dict[0x26a60] = "xīng"; /* 橠 */
dict[0x26a61] = "fú"; /* 橡 */
dict[0x26a62] = "xiàn"; /* 橢 */
dict[0x26a63] = "qì"; /* 橣 */
dict[0x26a64] = "tū"; /* 橤 */
dict[0x26a67] = "jí"; /* 橧 */
dict[0x26a69] = "yìng"; /* 橩 */
dict[0x26a6b] = "dèng,téng"; /* 橫 */
dict[0x26a6c] = "wēi"; /* 橬 */
dict[0x26a6d] = "xī"; /* 橭 */
dict[0x26a6f] = "pái"; /* 橯 */
dict[0x26a71] = "shéng"; /* 橱 */
dict[0x26a72] = "yǒu"; /* 橲 */
dict[0x26a74] = "ái"; /* 橴 */
dict[0x26a75] = "jiàn"; /* 橵 */
dict[0x26a77] = "gōu"; /* 橷 */
dict[0x26a78] = "ruò"; /* 橸 */
dict[0x26a7b] = "zhāo"; /* 橻 */
dict[0x26a7c] = "gòng"; /* 橼 */
dict[0x26a7f] = "shà"; /* 橿 */
dict[0x26a80] = "táng"; /* 檀 */
dict[0x26a87] = "lù"; /* 檇 */
dict[0x26a88] = "áo"; /* 檈 */
dict[0x26a8a] = "qì"; /* 檊 */
dict[0x26a8b] = "xiū"; /* 檋 */
dict[0x26a8d] = "dāi"; /* 檍 */
dict[0x26a91] = "fá"; /* 檑 */
dict[0x26a92] = "wèi"; /* 檒 */
dict[0x26a94] = "dùn"; /* 檔 */
dict[0x26a95] = "liáo"; /* 檕 */
dict[0x26a96] = "fān"; /* 檖 */
dict[0x26a97] = "huáng,héng"; /* 檗 */
dict[0x26a98] = "jué"; /* 檘 */
dict[0x26a99] = "tà"; /* 檙 */
dict[0x26a9a] = "zùn"; /* 檚 */
dict[0x26a9b] = "ráo"; /* 檛 */
dict[0x26a9c] = "cān"; /* 檜 */
dict[0x26a9d] = "téng"; /* 檝 */
dict[0x26aa0] = "huà"; /* 檠 */
dict[0x26aa1] = "xū"; /* 檡 */
dict[0x26aa3] = "zhān"; /* 檣 */
dict[0x26aa7] = "gǎn"; /* 檧 */
dict[0x26aaa] = "péng"; /* 檪 */
dict[0x26aab] = "cān"; /* 檫 */
dict[0x26aac] = "xiē"; /* 檬 */
dict[0x26aad] = "dá"; /* 檭 */
dict[0x26ab1] = "jì"; /* 檱 */
dict[0x26ab6] = "lǐ"; /* 檶 */
dict[0x26ab9] = "pán"; /* 檹 */
dict[0x26abd] = "lóng,lǒng"; /* 檽 */
dict[0x26abe] = "lì"; /* 檾 */
dict[0x26abf] = "xí"; /* 檿 */
dict[0x26ac0] = "téng"; /* 櫀 */
dict[0x26ac3] = "líng"; /* 櫃 */
dict[0x26ac8] = "lǐ"; /* 櫈 */
dict[0x26ac9] = "rán"; /* 櫉 */
dict[0x26aca] = "líng"; /* 櫊 */
dict[0x26ace] = "gǔn"; /* 櫎 */
dict[0x26ad4] = "pō"; /* 櫔 */
dict[0x26ad5] = "mò"; /* 櫕 */
dict[0x26ad6] = "pāi"; /* 櫖 */
dict[0x26ad9] = "bà"; /* 櫙 */
dict[0x26ae1] = "qí"; /* 櫡 */
dict[0x26ae4] = "yán"; /* 櫤 */
dict[0x26aea] = "wà"; /* 櫪 */
dict[0x26aeb] = "ǎng"; /* 櫫 */
dict[0x26aed] = "mìng"; /* 櫭 */
dict[0x26aee] = "mǐn"; /* 櫮 */
dict[0x26aef] = "xùn"; /* 櫯 */
dict[0x26af0] = "méng"; /* 櫰 */
dict[0x26af3] = "guǎi"; /* 櫳 */
dict[0x26af6] = "jiāo"; /* 櫶 */
dict[0x26afb] = "gǎi"; /* 櫻 */
dict[0x26afc] = "kǎi"; /* 櫼 */
dict[0x26b01] = "cái"; /* 欁 */
dict[0x26b02] = "wù"; /* 欂 */
dict[0x26b03] = "zhé"; /* 欃 */
dict[0x26b04] = "rěn"; /* 欄 */
dict[0x26b05] = "kōu"; /* 欅 */
dict[0x26b06] = "máng"; /* 欆 */
dict[0x26b14] = "zhǎo"; /* 欔 */
dict[0x26b15] = "zhōng"; /* 欕 */
dict[0x26b16] = "qiú"; /* 欖 */
dict[0x26b17] = "guō"; /* 欗 */
dict[0x26b18] = "gōng,sōng"; /* 欘 */
dict[0x26b19] = "pū"; /* 欙 */
dict[0x26b1a] = "hù"; /* 欚 */
dict[0x26b1b] = "miǎn"; /* 欛 */
dict[0x26b1e] = "tiān"; /* 欞 */
dict[0x26b23] = "wǎng"; /* 欣 */
dict[0x26b38] = "zhú"; /* 欸 */
dict[0x26b39] = "dá,dàn"; /* 欹 */
dict[0x26b3a] = "xiòng,huǎng"; /* 欺 */
dict[0x26b3b] = "ná"; /* 欻 */
dict[0x26b3e] = "juān"; /* 款 */
dict[0x26b41] = "niǎn"; /* 歁 */
dict[0x26b48] = "hù"; /* 歈 */
dict[0x26b49] = "shā"; /* 歉 */
dict[0x26b58] = "yuán"; /* 歘 */
dict[0x26b5c] = "zhī"; /* 歜 */
dict[0x26b5f] = "tā"; /* 歟 */
dict[0x26b61] = "sī"; /* 歡 */
dict[0x26b65] = "yì"; /* 步 */
dict[0x26b6d] = "qióng"; /* 歭 */
dict[0x26b6e] = "zhì"; /* 歮 */
dict[0x26b6f] = "lǚ,lóu"; /* 歯 */
dict[0x26b70] = "rú"; /* 歰 */
dict[0x26b72] = "qí"; /* 歲 */
dict[0x26b73] = "yǔ"; /* 歳 */
dict[0x26b74] = "zhōu"; /* 歴 */
dict[0x26b75] = "yáng"; /* 歵 */
dict[0x26b76] = "xiǎn"; /* 歶 */
dict[0x26b77] = "móu"; /* 歷 */
dict[0x26b78] = "chóu"; /* 歸 */
dict[0x26b79] = "huī"; /* 歹 */
dict[0x26b7a] = "jiū"; /* 歺 */
dict[0x26b7b] = "jiù"; /* 死 */
dict[0x26b7c] = "piǎo,bì"; /* 歼 */
dict[0x26b81] = "jiào"; /* 殁 */
dict[0x26b83] = "guāi,kuā"; /* 殃 */
dict[0x26b85] = "mò"; /* 殅 */
dict[0x26b90] = "xī"; /* 殐 */
dict[0x26b91] = "pú"; /* 殑 */
dict[0x26b99] = "kuí"; /* 殙 */
dict[0x26baf] = "jì"; /* 殯 */
dict[0x26bb6] = "wěn"; /* 殶 */
dict[0x26bb7] = "bèi"; /* 殷 */
dict[0x26bb8] = "yǐ"; /* 殸 */
dict[0x26bb9] = "fú"; /* 殹 */
dict[0x26bba] = "sī"; /* 殺 */
dict[0x26bbb] = "juān"; /* 殻 */
dict[0x26bbc] = "jì,qí"; /* 殼 */
dict[0x26bbe] = "nì"; /* 殾 */
dict[0x26bc0] = "bèn"; /* 毀 */
dict[0x26bc5] = "xù"; /* 毅 */
dict[0x26bc6] = "mǎo"; /* 毆 */
dict[0x26bc8] = "qǐn"; /* 毈 */
dict[0x26bc9] = "bó"; /* 毉 */
dict[0x26bcc] = "wáng"; /* 毌 */
dict[0x26bcd] = "zhè"; /* 母 */
dict[0x26bcf] = "wò"; /* 每 */
dict[0x26bd0] = "sháo"; /* 毐 */
dict[0x26bd1] = "zào"; /* 毑 */
dict[0x26bd2] = "yǎng"; /* 毒 */
dict[0x26bd5] = "sòng"; /* 毕 */
dict[0x26bd6] = "niè"; /* 毖 */
dict[0x26bdb] = "bì"; /* 毛 */
dict[0x26be3] = "cú"; /* 毣 */
dict[0x26be4] = "qiāng"; /* 毤 */
dict[0x26bea] = "xiào"; /* 毪 */
dict[0x26beb] = "zhī"; /* 毫 */
dict[0x26bec] = "shé"; /* 毬 */
dict[0x26bef] = "zhì"; /* 毯 */
dict[0x26bf0] = "pēng"; /* 毰 */
dict[0x26c16] = "wò"; /* 氖 */
dict[0x26c17] = "huá,huà,huā"; /* 気 */
dict[0x26c18] = "zhǐ"; /* 氘 */
dict[0x26c19] = "bì"; /* 氙 */
dict[0x26c1b] = "fén"; /* 氛 */
dict[0x26c21] = "nà,nuó"; /* 氡 */
dict[0x26c25] = "bāng"; /* 氥 */
dict[0x26c2a] = "qiú"; /* 氪 */
dict[0x26c2b] = "nǐ"; /* 氫 */
dict[0x26c2c] = "bó"; /* 氬 */
dict[0x26c2d] = "dùn"; /* 氭 */
dict[0x26c2f] = "shǐ"; /* 氯 */
dict[0x26c30] = "xū"; /* 氰 */
dict[0x26c31] = "cháng"; /* 氱 */
dict[0x26c32] = "xū"; /* 氲 */
dict[0x26c33] = "yé"; /* 氳 */
dict[0x26c38] = "xīn"; /* 永 */
dict[0x26c39] = "zhuó"; /* 氹 */
dict[0x26c3a] = "fù"; /* 氺 */
dict[0x26c3d] = "pǐ"; /* 氽 */
dict[0x26c3e] = "xuè"; /* 氾 */
dict[0x26c40] = "yù"; /* 汀 */
dict[0x26c41] = "xián"; /* 汁 */
dict[0x26c42] = "yù"; /* 求 */
dict[0x26c43] = "yú"; /* 汃 */
dict[0x26c44] = "gū"; /* 汄 */
dict[0x26c45] = "jū"; /* 汅 */
dict[0x26c46] = "tā"; /* 汆 */
dict[0x26c47] = "kōng"; /* 汇 */
dict[0x26c4a] = "zhēng"; /* 汊 */
dict[0x26c4b] = "méng"; /* 汋 */
dict[0x26c4c] = "gāng"; /* 汌 */
dict[0x26c52] = "mù"; /* 汒 */
dict[0x26c53] = "xǐ"; /* 汓 */
dict[0x26c54] = "bì"; /* 汔 */
dict[0x26c56] = "fù"; /* 汖 */
dict[0x26c5c] = "xiào"; /* 汜 */
dict[0x26c60] = "jiū"; /* 池 */
dict[0x26c63] = "gǒu"; /* 汣 */
dict[0x26c70] = "chí"; /* 汰 */
dict[0x26c71] = "jiū"; /* 汱 */
dict[0x26c72] = "jiū"; /* 汲 */
dict[0x26c75] = "shā"; /* 汵 */
dict[0x26c77] = "fēi"; /* 汷 */
dict[0x26cab] = "fú"; /* 沫 */
dict[0x26caf] = "wàn"; /* 沯 */
dict[0x26cb0] = "xū"; /* 沰 */
dict[0x26cb1] = "bō"; /* 沱 */
dict[0x26cb7] = "lì"; /* 沷 */
dict[0x26cc1] = "hào,mào"; /* 況 */
dict[0x26cc3] = "xié"; /* 泃 */
dict[0x26cc4] = "pián"; /* 泄 */
dict[0x26cc5] = "yǔ"; /* 泅 */
dict[0x26cc7] = "tián"; /* 泇 */
dict[0x26cc8] = "pí,bì"; /* 泈 */
dict[0x26cca] = "shǐ"; /* 泊 */
dict[0x26ccb] = "kuǎi"; /* 泋 */
dict[0x26ccc] = "jī"; /* 泌 */
dict[0x26ccf] = "zhā"; /* 泏 */
dict[0x26cd0] = "nài,nà"; /* 泐 */
dict[0x26cd1] = "mǒu"; /* 泑 */
dict[0x26cd3] = "fú"; /* 泓 */
dict[0x26cd4] = "dù"; /* 泔 */
dict[0x26cd7] = "shěng"; /* 泗 */
dict[0x26cd8] = "chá"; /* 泘 */
dict[0x26cd9] = "zhì"; /* 泙 */
dict[0x26cda] = "chí"; /* 泚 */
dict[0x26cdb] = "guǐ"; /* 泛 */
dict[0x26cdc] = "mín"; /* 泜 */
dict[0x26cdd] = "tāng,dàng"; /* 泝 */
dict[0x26cde] = "bài"; /* 泞 */
dict[0x26cdf] = "qiāng"; /* 泟 */
dict[0x26ce1] = "zhuó"; /* 泡 */
dict[0x26ce2] = "wèi"; /* 波 */
dict[0x26ce3] = "xún"; /* 泣 */
dict[0x26ce5] = "miǎo"; /* 泥 */
dict[0x26ce6] = "zāi"; /* 泦 */
dict[0x26ce7] = "yóu"; /* 泧 */
dict[0x26ce9] = "yòu"; /* 泩 */
dict[0x26ceb] = "shān"; /* 泫 */
dict[0x26cec] = "hé"; /* 泬 */
dict[0x26ced] = "lǚ"; /* 泭 */
dict[0x26cee] = "zhí"; /* 泮 */
dict[0x26cf2] = "jìng"; /* 泲 */
dict[0x26cf3] = "zhēn"; /* 泳 */
dict[0x26cf6] = "méng"; /* 泶 */
dict[0x26cf7] = "yóu"; /* 泷 */
dict[0x26cf9] = "wò"; /* 泹 */
dict[0x26cfa] = "bá"; /* 泺 */
dict[0x26cfd] = "juàn"; /* 泽 */
dict[0x26cfe] = "rú"; /* 泾 */
dict[0x26cff] = "còu"; /* 泿 */
dict[0x26d00] = "zhī"; /* 洀 */
dict[0x26d09] = "hú"; /* 洉 */
dict[0x26d0a] = "yāng"; /* 洊 */
dict[0x26d0c] = "jùn"; /* 洌 */
dict[0x26d0d] = "shé"; /* 洍 */
dict[0x26d0e] = "kòu"; /* 洎 */
dict[0x26d11] = "qián"; /* 洑 */
dict[0x26d14] = "méng"; /* 洔 */
dict[0x26d1a] = "tiáo"; /* 洚 */
dict[0x26d50] = "niè"; /* 浐 */
dict[0x26d5f] = "chí"; /* 浟 */
dict[0x26d61] = "xiōng,gōng"; /* 浡 */
dict[0x26d63] = "hùn"; /* 浣 */
dict[0x26d66] = "dí"; /* 浦 */
dict[0x26d67] = "láng"; /* 浧 */
dict[0x26d69] = "zāo,qiú"; /* 浩 */
dict[0x26d6a] = "cè"; /* 浪 */
dict[0x26d6b] = "suǒ"; /* 浫 */
dict[0x26d6c] = "zù"; /* 浬 */
dict[0x26d6d] = "suī"; /* 浭 */
dict[0x26d6f] = "xiá"; /* 浯 */
dict[0x26d71] = "xiè"; /* 浱 */
dict[0x26d74] = "jié"; /* 浴 */
dict[0x26d75] = "yóu"; /* 浵 */
dict[0x26d77] = "gòu"; /* 海 */
dict[0x26d78] = "gěng"; /* 浸 */
dict[0x26d79] = "tǎn"; /* 浹 */
dict[0x26d7c] = "jùn"; /* 浼 */
dict[0x26d7d] = "huǎng"; /* 浽 */
dict[0x26d7e] = "jí"; /* 浾 */
dict[0x26d7f] = "pōu"; /* 浿 */
dict[0x26d80] = "wū"; /* 涀 */
dict[0x26d82] = "yì"; /* 涂 */
dict[0x26d85] = "nǎi"; /* 涅 */
dict[0x26d87] = "rǒng,ruǎn"; /* 涇 */
dict[0x26d88] = "nán"; /* 消 */
dict[0x26d8a] = "píng"; /* 涊 */
dict[0x26d8b] = "shàn"; /* 涋 */
dict[0x26d8c] = "diāo"; /* 涌 */
dict[0x26d8d] = "jí"; /* 涍 */
dict[0x26d8e] = "huā"; /* 涎 */
dict[0x26d8f] = "duì"; /* 涏 */
dict[0x26d90] = "kǒng"; /* 涐 */
dict[0x26d91] = "tà"; /* 涑 */
dict[0x26d93] = "hòng"; /* 涓 */
dict[0x26d95] = "shū"; /* 涕 */
dict[0x26d99] = "héng"; /* 涙 */
dict[0x26d9a] = "fěn"; /* 涚 */
dict[0x26d9f] = "ruò"; /* 涟 */
dict[0x26db2] = "kòu"; /* 液 */
dict[0x26dd9] = "nián"; /* 淙 */
dict[0x26ddd] = "chú"; /* 淝 */
dict[0x26de6] = "qiàng"; /* 淦 */
dict[0x26df2] = "xì"; /* 淲 */
dict[0x26df3] = "hú"; /* 淳 */
dict[0x26df4] = "sòng"; /* 淴 */
dict[0x26df5] = "wò"; /* 淵 */
dict[0x26df7] = "hài"; /* 混 */
dict[0x26df8] = "rú"; /* 淸 */
dict[0x26df9] = "méng"; /* 淹 */
dict[0x26dfb] = "sǎn"; /* 添 */
dict[0x26dfd] = "wú"; /* 淽 */
dict[0x26dff] = "yóu"; /* 淿 */
dict[0x26e01] = "tān"; /* 渁 */
dict[0x26e02] = "shēn"; /* 渂 */
dict[0x26e06] = "qǐ"; /* 渆 */
dict[0x26e08] = "guó"; /* 済 */
dict[0x26e09] = "qià"; /* 渉 */
dict[0x26e0a] = "xiān"; /* 渊 */
dict[0x26e0f] = "suī"; /* 渏 */
dict[0x26e10] = "lù"; /* 渐 */
dict[0x26e13] = "qī"; /* 渓 */
dict[0x26e14] = "diāo"; /* 渔 */
dict[0x26e17] = "qí"; /* 渗 */
dict[0x26e18] = "jiá"; /* 渘 */
dict[0x26e19] = "yóu"; /* 渙 */
dict[0x26e1a] = "xí"; /* 渚 */
dict[0x26e1b] = "cháo"; /* 減 */
dict[0x26e21] = "mì"; /* 渡 */
dict[0x26e22] = "lòu"; /* 渢 */
dict[0x26e23] = "bǐ"; /* 渣 */
dict[0x26e2a] = "péi"; /* 渪 */
dict[0x26e2e] = "zhēn"; /* 渮 */
dict[0x26e2f] = "shēn"; /* 港 */
dict[0x26e30] = "chǎn"; /* 渰 */
dict[0x26e31] = "fù"; /* 渱 */
dict[0x26e36] = "qū"; /* 渶 */
dict[0x26e37] = "sī"; /* 渷 */
dict[0x26e3a] = "zuī"; /* 渺 */
dict[0x26e6b] = "zhào"; /* 湫 */
dict[0x26e7d] = "pí"; /* 湽 */
dict[0x26e80] = "còu"; /* 満 */
dict[0x26e86] = "gāo"; /* 溆 */
dict[0x26e87] = "dú"; /* 溇 */
dict[0x26e89] = "fū"; /* 溉 */
dict[0x26e8a] = "guān"; /* 溊 */
dict[0x26e8b] = "sǎo"; /* 溋 */
dict[0x26e8c] = "sǒu"; /* 溌 */
dict[0x26e8d] = "jiǎn"; /* 溍 */
dict[0x26e8e] = "póu"; /* 溎 */
dict[0x26e90] = "cán"; /* 源 */
dict[0x26e91] = "bèng"; /* 溑 */
dict[0x26e92] = "mòu"; /* 溒 */
dict[0x26e93] = "zhāo"; /* 溓 */
dict[0x26e94] = "xiáo"; /* 溔 */
dict[0x26e96] = "jú"; /* 準 */
dict[0x26e97] = "shū"; /* 溗 */
dict[0x26e98] = "jiǎn"; /* 溘 */
dict[0x26e99] = "lí"; /* 溙 */
dict[0x26e9b] = "chuàn"; /* 溛 */
dict[0x26e9c] = "lào,láo"; /* 溜 */
dict[0x26e9d] = "níng"; /* 溝 */
dict[0x26e9e] = "hè"; /* 溞 */
dict[0x26e9f] = "hú"; /* 溟 */
dict[0x26ea0] = "gū"; /* 溠 */
dict[0x26ea1] = "zhǎng"; /* 溡 */
dict[0x26ea2] = "jié"; /* 溢 */
dict[0x26ea3] = "xiàng"; /* 溣 */
dict[0x26ea5] = "dū"; /* 溥 */
dict[0x26ea6] = "hán"; /* 溦 */
dict[0x26ea7] = "jiá"; /* 溧 */
dict[0x26ea8] = "xiàng"; /* 溨 */
dict[0x26ea9] = "jí"; /* 溩 */
dict[0x26eaa] = "shǔ"; /* 溪 */
dict[0x26eab] = "làng"; /* 溫 */
dict[0x26eac] = "jī"; /* 溬 */
dict[0x26ead] = "shān"; /* 溭 */
dict[0x26eb0] = "tāo,tiáo"; /* 溰 */
dict[0x26eb1] = "zī"; /* 溱 */
dict[0x26eb2] = "shuàn"; /* 溲 */
dict[0x26eb3] = "yì"; /* 溳 */
dict[0x26eb4] = "jí"; /* 溴 */
dict[0x26eb5] = "chù"; /* 溵 */
dict[0x26eb6] = "jì"; /* 溶 */
dict[0x26eb7] = "shēn"; /* 溷 */
dict[0x26eb8] = "lìn,lín"; /* 溸 */
dict[0x26eb9] = "liáo"; /* 溹 */
dict[0x26ebb] = "sǎn"; /* 溻 */
dict[0x26ebd] = "ǎn"; /* 溽 */
dict[0x26ebe] = "ruǎn"; /* 溾 */
dict[0x26ec0] = "tí,tái"; /* 滀 */
dict[0x26ec1] = "dàn"; /* 滁 */
dict[0x26ec3] = "huán"; /* 滃 */
dict[0x26ec5] = "sà"; /* 滅 */
dict[0x26ed0] = "zhào"; /* 滐 */
dict[0x26f06] = "ruí"; /* 漆 */
dict[0x26f07] = "wū"; /* 漇 */
dict[0x26f08] = "jù"; /* 漈 */
dict[0x26f09] = "huán"; /* 漉 */
dict[0x26f0a] = "léng"; /* 漊 */
dict[0x26f0b] = "lù"; /* 漋 */
dict[0x26f0e] = "tān"; /* 漎 */
dict[0x26f0f] = "zēng"; /* 漏 */
dict[0x26f13] = "qián"; /* 漓 */
dict[0x26f17] = "xī"; /* 漗 */
dict[0x26f21] = "cǐ"; /* 漡 */
dict[0x26f22] = "shé"; /* 漢 */
dict[0x26f27] = "sà"; /* 漧 */
dict[0x26f2a] = "mào"; /* 漪 */
dict[0x26f2b] = "qú"; /* 漫 */
dict[0x26f2d] = "bó"; /* 漭 */
dict[0x26f2e] = "gǎn,gàn"; /* 漮 */
dict[0x26f30] = "qiè,hé"; /* 漰 */
dict[0x26f31] = "juàn"; /* 漱 */
dict[0x26f32] = "dāng"; /* 漲 */
dict[0x26f33] = "cháng"; /* 漳 */
dict[0x26f34] = "yáng"; /* 漴 */
dict[0x26f35] = "hé"; /* 漵 */
dict[0x26f37] = "jī"; /* 漷 */
dict[0x26f39] = "bǐng"; /* 漹 */
dict[0x26f3b] = "méi"; /* 漻 */
dict[0x26f3f] = "dūn"; /* 漿 */
dict[0x26f40] = "ǎo"; /* 潀 */
dict[0x26f41] = "jīng"; /* 潁 */
dict[0x26f42] = "lù"; /* 潂 */
dict[0x26f43] = "miàn"; /* 潃 */
dict[0x26f44] = "diàn"; /* 潄 */
dict[0x26f45] = "hè"; /* 潅 */
dict[0x26f47] = "jiān"; /* 潇 */
dict[0x26f4a] = "huá"; /* 潊 */
dict[0x26f4b] = "gōu"; /* 潋 */
dict[0x26f4e] = "lù"; /* 潎 */
dict[0x26f4f] = "fú"; /* 潏 */
dict[0x26f50] = "huǐ"; /* 潐 */
dict[0x26f52] = "zéi"; /* 潒 */
dict[0x26f54] = "jìn"; /* 潔 */
dict[0x26f55] = "sī"; /* 潕 */
dict[0x26f56] = "qūn"; /* 潖 */
dict[0x26f5c] = "dàn"; /* 潜 */
dict[0x26f5e] = "wàn"; /* 潞 */
dict[0x26f5f] = "biǎn"; /* 潟 */
dict[0x26f61] = "mào"; /* 潡 */
dict[0x26f64] = "jiá"; /* 潤 */
dict[0x26f6b] = "dǎn"; /* 潫 */
dict[0x26f6c] = "jiū"; /* 潬 */
dict[0x26f6d] = "xián"; /* 潭 */
dict[0x26f6e] = "bó"; /* 潮 */
dict[0x26f8f] = "xiá"; /* 澏 */
dict[0x26f91] = "biāo"; /* 澑 */
dict[0x26f95] = "pò"; /* 澕 */
dict[0x26f98] = "sǎo"; /* 澘 */
dict[0x26f99] = "bèi"; /* 澙 */
dict[0x26f9a] = "shà"; /* 澚 */
dict[0x26f9b] = "wěi"; /* 澛 */
dict[0x26f9d] = "cāng"; /* 澝 */
dict[0x26f9e] = "lù"; /* 澞 */
dict[0x26fa9] = "dàn"; /* 澩 */
dict[0x26fab] = "gǔ"; /* 澫 */
dict[0x26fac] = "zā"; /* 澬 */
dict[0x26fad] = "bǎng"; /* 澭 */
dict[0x26fae] = "gàn,gǎn"; /* 澮 */
dict[0x26fb1] = "chāo"; /* 澱 */
dict[0x26fb2] = "jì"; /* 澲 */
dict[0x26fb3] = "liē"; /* 澳 */
dict[0x26fb4] = "fán"; /* 澴 */
dict[0x26fb5] = "qióng"; /* 澵 */
dict[0x26fb6] = "jiàn"; /* 澶 */
dict[0x26fb7] = "lù"; /* 澷 */
dict[0x26fb8] = "duān"; /* 澸 */
dict[0x26fb9] = "suān"; /* 澹 */
dict[0x26fba] = "yáo"; /* 澺 */
dict[0x26fbb] = "yǐn"; /* 澻 */
dict[0x26fbd] = "tà"; /* 澽 */
dict[0x26fbe] = "yáo"; /* 澾 */
dict[0x26fbf] = "jīng"; /* 澿 */
dict[0x26fc0] = "chú"; /* 激 */
dict[0x26fc1] = "fú"; /* 濁 */
dict[0x26fc2] = "yuán"; /* 濂 */
dict[0x26fc3] = "shǎo"; /* 濃 */
dict[0x26fc5] = "bìng"; /* 濅 */
dict[0x26fc6] = "dàng"; /* 濆 */
dict[0x26fc7] = "shì"; /* 濇 */
dict[0x26fca] = "lú"; /* 濊 */
dict[0x26fcb] = "qiè"; /* 濋 */
dict[0x26fcc] = "luó"; /* 濌 */
dict[0x26fcd] = "pò"; /* 濍 */
dict[0x26fcf] = "méng,mèng"; /* 濏 */
dict[0x26fd0] = "jié"; /* 濐 */
dict[0x26fd3] = "jī"; /* 濓 */
dict[0x26fd6] = "lù"; /* 濖 */
dict[0x27004] = "chàng"; /* 瀄 */
dict[0x27005] = "miè,mò"; /* 瀅 */
dict[0x27006] = "méng"; /* 瀆 */
dict[0x27007] = "jiǎn"; /* 瀇 */
dict[0x2700a] = "cǎi"; /* 瀊 */
dict[0x2700c] = "sù"; /* 瀌 */
dict[0x2700d] = "qū"; /* 瀍 */
dict[0x27014] = "hè"; /* 瀔 */
dict[0x27015] = "sà"; /* 瀕 */
dict[0x27017] = "zī"; /* 瀗 */
dict[0x27018] = "kēng"; /* 瀘 */
dict[0x27019] = "gěng"; /* 瀙 */
dict[0x2701a] = "sī"; /* 瀚 */
dict[0x27020] = "tí"; /* 瀠 */
dict[0x27021] = "zhàn"; /* 瀡 */
dict[0x27022] = "xiè"; /* 瀢 */
dict[0x27023] = "shuí"; /* 瀣 */
dict[0x27024] = "chǐ"; /* 瀤 */
dict[0x27025] = "yōu"; /* 瀥 */
dict[0x27026] = "lǔ"; /* 瀦 */
dict[0x27027] = "mèng"; /* 瀧 */
dict[0x27028] = "liè"; /* 瀨 */
dict[0x27029] = "sì"; /* 瀩 */
dict[0x2702c] = "xī"; /* 瀬 */
dict[0x2702d] = "fán"; /* 瀭 */
dict[0x2702e] = "fū"; /* 瀮 */
dict[0x2702f] = "shěn"; /* 瀯 */
dict[0x27030] = "tí"; /* 瀰 */
dict[0x27031] = "chài"; /* 瀱 */
dict[0x27032] = "yuè"; /* 瀲 */
dict[0x27033] = "sì"; /* 瀳 */
dict[0x27034] = "fū"; /* 瀴 */
dict[0x27035] = "jiàn,shǎn"; /* 瀵 */
dict[0x27036] = "dì"; /* 瀶 */
dict[0x27039] = "zhè"; /* 瀹 */
dict[0x2703a] = "xié"; /* 瀺 */
dict[0x2703b] = "dān"; /* 瀻 */
dict[0x2703c] = "xuē"; /* 瀼 */
dict[0x2703f] = "zhí"; /* 瀿 */
dict[0x27043] = "xù"; /* 灃 */
dict[0x27048] = "niè"; /* 灈 */
dict[0x27049] = "fàn"; /* 灉 */
dict[0x2704a] = "méng"; /* 灊 */
dict[0x2704b] = "mǐn"; /* 灋 */
dict[0x2707e] = "lóu"; /* 灾 */
dict[0x2707f] = "dú,shǔ"; /* 灿 */
dict[0x27080] = "mò"; /* 炀 */
dict[0x27081] = "zhàn"; /* 炁 */
dict[0x27082] = "jiàn"; /* 炂 */
dict[0x27083] = "hàn"; /* 炃 */
dict[0x27084] = "dàn"; /* 炄 */
dict[0x27085] = "sēn"; /* 炅 */
dict[0x27086] = "jiàn"; /* 炆 */
dict[0x27087] = "tán,xún"; /* 炇 */
dict[0x27088] = "jiǎo"; /* 炈 */
dict[0x27089] = "pó"; /* 炉 */
dict[0x2708b] = "píng"; /* 炋 */
dict[0x2708d] = "zhuàn,sūn"; /* 炍 */
dict[0x2708f] = "liáo"; /* 炏 */
dict[0x27090] = "zì"; /* 炐 */
dict[0x27092] = "zhuó"; /* 炒 */
dict[0x27094] = "hù"; /* 炔 */
dict[0x27099] = "xì"; /* 炙 */
dict[0x2709b] = "méng"; /* 炛 */
dict[0x2709c] = "jù"; /* 炜 */
dict[0x2709d] = "miè"; /* 炝 */
dict[0x2709e] = "xián"; /* 炞 */
dict[0x270a0] = "kuì"; /* 炠 */
dict[0x270a1] = "méng"; /* 炡 */
dict[0x270a2] = "jiān"; /* 炢 */
dict[0x270a6] = "nóu"; /* 炦 */
dict[0x270a8] = "dì"; /* 炨 */
dict[0x270a9] = "sāo"; /* 炩 */
dict[0x270cf] = "chù"; /* 烏 */
dict[0x270d0] = "zhí"; /* 烐 */
dict[0x270d1] = "qián"; /* 烑 */
dict[0x270d2] = "lǚ"; /* 烒 */
dict[0x270d4] = "zhuó"; /* 烔 */
dict[0x270d8] = "zuò"; /* 烘 */
dict[0x270d9] = "hán"; /* 烙 */
dict[0x270da] = "suǐ"; /* 烚 */
dict[0x270db] = "gòu"; /* 烛 */
dict[0x270dd] = "chǒu"; /* 烝 */
dict[0x270de] = "jì"; /* 烞 */
dict[0x270df] = "yì"; /* 烟 */
dict[0x270e0] = "yú"; /* 烠 */
dict[0x270e3] = "kūn"; /* 烣 */
dict[0x270e8] = "nóu"; /* 烨 */
dict[0x270e9] = "nǐ"; /* 烩 */
dict[0x270ea] = "ruò"; /* 烪 */
dict[0x270ee] = "lín"; /* 烮 */
dict[0x270f1] = "níng"; /* 烱 */
dict[0x270f9] = "zhá"; /* 烹 */
dict[0x2710d] = "qiáo"; /* 焍 */
dict[0x2710e] = "yáo"; /* 焎 */
dict[0x2710f] = "fù"; /* 焏 */
dict[0x27110] = "shuāng"; /* 焐 */
dict[0x27111] = "kuì"; /* 焑 */
dict[0x27112] = "qú"; /* 焒 */
dict[0x27113] = "dǒng"; /* 焓 */
dict[0x27114] = "shǔ"; /* 焔 */
dict[0x2711a] = "lí"; /* 焚 */
dict[0x2711b] = "jú"; /* 焛 */
dict[0x2711c] = "ruǐ"; /* 焜 */
dict[0x27120] = "zhá"; /* 焠 */
dict[0x27124] = "xiāo"; /* 焤 */
dict[0x27138] = "mén,wěi"; /* 焸 */
dict[0x27139] = "shí"; /* 焹 */
dict[0x2713a] = "diān"; /* 焺 */
dict[0x2713b] = "lì"; /* 焻 */
dict[0x2713c] = "dèng,téng"; /* 焼 */
dict[0x2713d] = "zàn,zā"; /* 焽 */
dict[0x2713f] = "luó"; /* 焿 */
dict[0x27140] = "cán"; /* 煀 */
dict[0x27143] = "āo"; /* 煃 */
dict[0x27146] = "jiǎn"; /* 煆 */
dict[0x27148] = "diào"; /* 煈 */
dict[0x2714b] = "yíng"; /* 煋 */
dict[0x27156] = "yì"; /* 煖 */
dict[0x27157] = "dǎng"; /* 煗 */
dict[0x27158] = "nóu"; /* 煘 */
dict[0x2715a] = "yuè"; /* 煚 */
dict[0x2716e] = "lǐ"; /* 煮 */
dict[0x2716f] = "lí"; /* 煯 */
dict[0x27170] = "hù"; /* 煰 */
dict[0x27172] = "yòu"; /* 煲 */
dict[0x2717a] = "nàng"; /* 煺 */
dict[0x2717b] = "hàn"; /* 煻 */
dict[0x27182] = "chèn"; /* 熂 */
dict[0x27188] = "yì"; /* 熈 */
dict[0x27189] = "fēng"; /* 熉 */
dict[0x2718a] = "biē"; /* 熊 */
dict[0x2718f] = "mǎn"; /* 熏 */
dict[0x27190] = "gàn"; /* 熐 */
dict[0x27191] = "huò,suǐ"; /* 熑 */
dict[0x27193] = "cū"; /* 熓 */
dict[0x27195] = "yǒu"; /* 熕 */
dict[0x27198] = "yòu"; /* 熘 */
dict[0x2719c] = "xū"; /* 熜 */
dict[0x271a1] = "xù"; /* 熡 */
dict[0x271a2] = "hǔ"; /* 熢 */
dict[0x271a3] = "lú"; /* 熣 */
dict[0x271a5] = "xiá"; /* 熥 */
dict[0x271a6] = "yì"; /* 熦 */
dict[0x271ae] = "hǔ"; /* 熮 */
dict[0x271af] = "hù"; /* 熯 */
dict[0x271b0] = "zǐ"; /* 熰 */
dict[0x271b7] = "gōng"; /* 熷 */
dict[0x271b8] = "tuī"; /* 熸 */
dict[0x271b9] = "wū"; /* 熹 */
dict[0x271ba] = "líng"; /* 熺 */
dict[0x271bb] = "gū"; /* 熻 */
dict[0x271bc] = "zhōng,dōng"; /* 熼 */
dict[0x271c4] = "lú"; /* 燄 */
dict[0x271c8] = "zù"; /* 燈 */
dict[0x271cc] = "tóng"; /* 燌 */
dict[0x271cd] = "xiā"; /* 燍 */
dict[0x271ce] = "hé"; /* 燎 */
dict[0x271d2] = "bào"; /* 燒 */
dict[0x271d3] = "yuè"; /* 燓 */
dict[0x271d9] = "nán"; /* 燙 */
dict[0x271da] = "bó"; /* 燚 */
dict[0x271db] = "hū"; /* 燛 */
dict[0x271dc] = "qì"; /* 燜 */
dict[0x271dd] = "shú"; /* 燝 */
dict[0x271de] = "qiāng"; /* 燞 */
dict[0x271df] = "zhōu"; /* 營 */
dict[0x271e0] = "yào"; /* 燠 */
dict[0x271e1] = "gū"; /* 燡 */
dict[0x271e5] = "bān"; /* 燥 */
dict[0x271e6] = "kǎn"; /* 燦 */
dict[0x271ee] = "hé"; /* 燮 */
dict[0x271ef] = "jì"; /* 燯 */
dict[0x271f0] = "hú"; /* 燰 */
dict[0x271f1] = "yán"; /* 燱 */
dict[0x271f6] = "chūn"; /* 燶 */
dict[0x271f7] = "dǐng"; /* 燷 */
dict[0x271f8] = "qiū"; /* 燸 */
dict[0x271f9] = "hóu"; /* 燹 */
dict[0x271fc] = "hào"; /* 燼 */
dict[0x271fd] = "jù"; /* 燽 */
dict[0x271ff] = "zù"; /* 燿 */
dict[0x27201] = "xián"; /* 爁 */
dict[0x27204] = "xià"; /* 爄 */
dict[0x27205] = "xì"; /* 爅 */
dict[0x27208] = "sè,xì"; /* 爈 */
dict[0x2720c] = "gé"; /* 爌 */
dict[0x2720d] = "xì"; /* 爍 */
dict[0x27211] = "gé"; /* 爑 */
dict[0x27214] = "lǚ"; /* 爔 */
dict[0x27216] = "gé"; /* 爖 */
dict[0x27217] = "kè"; /* 爗 */
dict[0x27219] = "shòu"; /* 爙 */
dict[0x2721a] = "zhù"; /* 爚 */
dict[0x2721c] = "téng"; /* 爜 */
dict[0x2721d] = "yà"; /* 爝 */
dict[0x2721e] = "nì"; /* 爞 */
dict[0x27226] = "luò"; /* 爦 */
dict[0x27227] = "suī,méng"; /* 爧 */
dict[0x2722a] = "chǎn"; /* 爪 */
dict[0x2722d] = "wù"; /* 爭 */
dict[0x2722f] = "yū"; /* 爯 */
dict[0x27239] = "zǎo"; /* 爹 */
dict[0x2723b] = "yì"; /* 爻 */
dict[0x2723c] = "xī,jí"; /* 爼 */
dict[0x2723d] = "hóng"; /* 爽 */
dict[0x2723e] = "quán"; /* 爾 */
dict[0x2723f] = "wǎng"; /* 爿 */
dict[0x27240] = "chǐ"; /* 牀 */
dict[0x27241] = "xì"; /* 牁 */
dict[0x27242] = "tiǎn"; /* 牂 */
dict[0x27243] = "yǔn"; /* 牃 */
dict[0x27244] = "mián"; /* 牄 */
dict[0x27245] = "yī"; /* 牅 */
dict[0x27246] = "jí"; /* 牆 */
dict[0x27247] = "huī"; /* 片 */
dict[0x27248] = "fóu,fú"; /* 版 */
dict[0x2724a] = "fǔ"; /* 牊 */
dict[0x2724d] = "jí"; /* 牍 */
dict[0x2724e] = "xuán"; /* 牎 */
dict[0x27251] = "tài"; /* 牑 */
dict[0x27257] = "yuán"; /* 牗 */
dict[0x2725b] = "dì"; /* 牛 */
dict[0x2725e] = "zhǔ"; /* 牞 */
dict[0x2725f] = "tāi"; /* 牟 */
dict[0x27261] = "rǒng"; /* 牡 */
dict[0x27262] = "xué"; /* 牢 */
dict[0x27263] = "yù"; /* 牣 */
dict[0x27264] = "fàn"; /* 牤 */
dict[0x27265] = "běi"; /* 牥 */
dict[0x27267] = "qǔ,jié"; /* 牧 */
dict[0x27269] = "bù"; /* 物 */
dict[0x2726a] = "jiā"; /* 牪 */
dict[0x2726b] = "zhá"; /* 牫 */
dict[0x2726d] = "nǔ"; /* 牭 */
dict[0x2726e] = "shé,yán,yí"; /* 牮 */
dict[0x27272] = "lì"; /* 牲 */
dict[0x27279] = "zhā"; /* 特 */
dict[0x27284] = "guǐ"; /* 犄 */
dict[0x27285] = "guǎi"; /* 犅 */
dict[0x27287] = "dài,dé"; /* 犇 */
dict[0x2728f] = "gāi"; /* 犏 */
dict[0x27292] = "cì"; /* 犒 */
dict[0x27294] = "yǎn"; /* 犔 */
dict[0x27295] = "sōng"; /* 犕 */
dict[0x27296] = "shì"; /* 犖 */
dict[0x27298] = "kù"; /* 犘 */
dict[0x27299] = "zhǐ"; /* 犙 */
dict[0x2729a] = "tóng"; /* 犚 */
dict[0x2729b] = "qú"; /* 犛 */
dict[0x2729c] = "è"; /* 犜 */
dict[0x2729d] = "hē"; /* 犝 */
dict[0x2729e] = "xíng"; /* 犞 */
dict[0x2729f] = "rú"; /* 犟 */
dict[0x272a0] = "yú,shū"; /* 犠 */
dict[0x272a3] = "yì"; /* 犣 */
dict[0x272a4] = "yì"; /* 犤 */
dict[0x272a5] = "xù"; /* 犥 */
dict[0x272a6] = "fǒu"; /* 犦 */
dict[0x272a7] = "gé,è"; /* 犧 */
dict[0x272a8] = "rán"; /* 犨 */
dict[0x272ac] = "hé"; /* 犬 */
dict[0x272ad] = "yīn"; /* 犭 */
dict[0x272af] = "hòng"; /* 犯 */
dict[0x272b1] = "duǒ"; /* 犱 */
dict[0x272bd] = "xíng"; /* 犽 */
dict[0x272be] = "fán"; /* 犾 */
dict[0x272c9] = "qī"; /* 狉 */
dict[0x272ca] = "shā,shuō"; /* 狊 */
dict[0x272cc] = "dù"; /* 狌 */
dict[0x272cd] = "dì,xué"; /* 狍 */
dict[0x272ce] = "lí"; /* 狎 */
dict[0x272cf] = "yì"; /* 狏 */
dict[0x272d0] = "xí"; /* 狐 */
dict[0x272d1] = "gěng"; /* 狑 */
dict[0x272d2] = "tóng,shì"; /* 狒 */
dict[0x272d3] = "kào"; /* 狓 */
dict[0x272d4] = "hòng"; /* 狔 */
dict[0x272d5] = "kǔn"; /* 狕 */
dict[0x272d6] = "niè"; /* 狖 */
dict[0x272d7] = "chí"; /* 狗 */
dict[0x272d8] = "tí"; /* 狘 */
dict[0x272da] = "tóng"; /* 狚 */
dict[0x272e0] = "lí,lǐ"; /* 狠 */
dict[0x272e1] = "nà"; /* 狡 */
dict[0x272e2] = "bō"; /* 狢 */
dict[0x272e3] = "kuò"; /* 狣 */
dict[0x272f1] = "zhān"; /* 狱 */
dict[0x272f2] = "běi"; /* 狲 */
dict[0x27301] = "tiáo"; /* 猁 */
dict[0x27303] = "zā"; /* 猃 */
dict[0x27304] = "è,yè"; /* 猄 */
dict[0x27305] = "shòu"; /* 猅 */
dict[0x27306] = "kōng"; /* 猆 */
dict[0x27307] = "péng"; /* 猇 */
dict[0x27308] = "fù"; /* 猈 */
dict[0x27309] = "lù"; /* 猉 */
dict[0x2730a] = "xiè"; /* 猊 */
dict[0x2730b] = "xiè"; /* 猋 */
dict[0x2730c] = "xiū"; /* 猌 */
dict[0x2730d] = "lù"; /* 猍 */
dict[0x2730e] = "tiǎn"; /* 猎 */
dict[0x2730f] = "tà"; /* 猏 */
dict[0x27310] = "cì"; /* 猐 */
dict[0x27311] = "qū"; /* 猑 */
dict[0x27313] = "fù"; /* 猓 */
dict[0x27314] = "zhī"; /* 猔 */
dict[0x27316] = "xiè,shè"; /* 猖 */
dict[0x27317] = "zǒu"; /* 猗 */
dict[0x27318] = "fèi"; /* 猘 */
dict[0x27319] = "mín"; /* 猙 */
dict[0x2731a] = "xīng"; /* 猚 */
dict[0x2731d] = "tóng"; /* 猝 */
dict[0x2731e] = "qí"; /* 猞 */
dict[0x27320] = "piāo"; /* 猠 */
dict[0x27322] = "suì"; /* 猢 */
dict[0x27323] = "ěr"; /* 猣 */
dict[0x27327] = "hǔ"; /* 猧 */
dict[0x27334] = "qí"; /* 猴 */
dict[0x2733b] = "sōng"; /* 猻 */
dict[0x2733d] = "biē"; /* 猽 */
dict[0x2733e] = "dīng"; /* 猾 */
dict[0x2733f] = "bǎn"; /* 猿 */
dict[0x27340] = "shī,lǐ"; /* 獀 */
dict[0x27341] = "xiè"; /* 獁 */
dict[0x27342] = "xiáo"; /* 獂 */
dict[0x27343] = "fěi"; /* 獃 */
dict[0x27352] = "chuǎn,chuǎi"; /* 獒 */
dict[0x27353] = "shuài"; /* 獓 */
dict[0x27354] = "yāo"; /* 獔 */
dict[0x27355] = "jué"; /* 獕 */
dict[0x27356] = "shěng,nìng"; /* 獖 */
dict[0x27358] = "yōu"; /* 獘 */
dict[0x27359] = "fàn"; /* 獙 */
dict[0x2735c] = "kuí"; /* 獜 */
dict[0x2735d] = "dì"; /* 獝 */
dict[0x2735f] = "máo"; /* 獟 */
dict[0x27360] = "jié"; /* 獠 */
dict[0x27362] = "yán,yǐn"; /* 獢 */
dict[0x27363] = "chài"; /* 獣 */
dict[0x27365] = "wēi"; /* 獥 */
dict[0x27368] = "sāng"; /* 獨 */
dict[0x27369] = "jié"; /* 獩 */
dict[0x2736a] = "yú"; /* 獪 */
dict[0x2736b] = "wèi"; /* 獫 */
dict[0x2736c] = "è"; /* 獬 */
dict[0x2736d] = "quán"; /* 獭 */
dict[0x2736e] = "jiǒng"; /* 獮 */
dict[0x2736f] = "féng"; /* 獯 */
dict[0x27370] = "lóng"; /* 獰 */
dict[0x27371] = "dié"; /* 獱 */
dict[0x27372] = "pián"; /* 獲 */
dict[0x27374] = "liàn"; /* 獴 */
dict[0x27375] = "hú"; /* 獵 */
dict[0x27376] = "lǜ"; /* 獶 */
dict[0x27378] = "zhōng"; /* 獸 */
dict[0x2737f] = "diàn"; /* 獿 */
dict[0x27383] = "cuì"; /* 玃 */
dict[0x27384] = "móu,wù"; /* 玄 */
dict[0x27395] = "wáng"; /* 玕 */
dict[0x27396] = "juān"; /* 玖 */
dict[0x27397] = "kē"; /* 玗 */
dict[0x27398] = "yán"; /* 玘 */
dict[0x27399] = "jiǎo"; /* 玙 */
dict[0x273a1] = "gōng"; /* 玡 */
dict[0x273a2] = "tè"; /* 玢 */
dict[0x273a3] = "róng"; /* 玣 */
dict[0x273a4] = "sūn"; /* 玤 */
dict[0x273a5] = "shàn"; /* 玥 */
dict[0x273a8] = "chí"; /* 玨 */
dict[0x273aa] = "qí"; /* 玪 */
dict[0x273ab] = "suǒ"; /* 玫 */
dict[0x273ad] = "yè"; /* 玭 */
dict[0x273ae] = "zǎo"; /* 玮 */
dict[0x273af] = "quē"; /* 环 */
dict[0x273b0] = "zhǎn"; /* 现 */
dict[0x273b1] = "bā"; /* 玱 */
dict[0x273b2] = "zú"; /* 玲 */
dict[0x273b3] = "suǒ"; /* 玳 */
dict[0x273b4] = "zhé"; /* 玴 */
dict[0x273b5] = "xì"; /* 玵 */
dict[0x273b7] = "chǔ"; /* 玷 */
dict[0x273b8] = "jiǎo"; /* 玸 */
dict[0x273b9] = "zuì"; /* 玹 */
dict[0x273ba] = "gē"; /* 玺 */
dict[0x273bb] = "wù,móu"; /* 玻 */
dict[0x273be] = "lüè"; /* 玾 */
dict[0x273bf] = "jí"; /* 玿 */
dict[0x273c2] = "xié"; /* 珂 */
dict[0x273c3] = "xié"; /* 珃 */
dict[0x273c6] = "dǒu"; /* 珆 */
dict[0x273cb] = "qiū"; /* 珋 */
dict[0x273d1] = "píng"; /* 珑 */
dict[0x273d3] = "liú"; /* 珓 */
dict[0x273e5] = "jié"; /* 珥 */
dict[0x273e7] = "huì"; /* 珧 */
dict[0x273eb] = "shà"; /* 珫 */
dict[0x273f8] = "zhí"; /* 珸 */
dict[0x273f9] = "ài"; /* 珹 */
dict[0x273fa] = "xù,òu"; /* 珺 */
dict[0x273fb] = "bì"; /* 珻 */
dict[0x273fd] = "yē"; /* 珽 */
dict[0x273fe] = "nì"; /* 現 */
dict[0x273ff] = "zhú"; /* 珿 */
dict[0x27401] = "sù"; /* 琁 */
dict[0x27402] = "shí"; /* 琂 */
dict[0x27403] = "xié"; /* 球 */
dict[0x27404] = "yù,yú"; /* 琄 */
dict[0x27405] = "qū"; /* 琅 */
dict[0x27408] = "zú"; /* 琈 */
dict[0x27409] = "zhī"; /* 琉 */
dict[0x2740a] = "zhāng"; /* 琊 */
dict[0x2740b] = "lüè"; /* 琋 */
dict[0x2740c] = "wěi"; /* 琌 */
dict[0x2740d] = "chōng"; /* 琍 */
dict[0x2740e] = "mì"; /* 琎 */
dict[0x27410] = "jī"; /* 琐 */
dict[0x27412] = "sù"; /* 琒 */
dict[0x27413] = "yě"; /* 琓 */
dict[0x27414] = "xí,yì"; /* 琔 */
dict[0x27415] = "tuán"; /* 琕 */
dict[0x27416] = "lián,liàn"; /* 琖 */
dict[0x27417] = "xuán"; /* 琗 */
dict[0x27419] = "wù"; /* 琙 */
dict[0x2741f] = "máo"; /* 琟 */
dict[0x27422] = "háo"; /* 琢 */
dict[0x2742c] = "hóng"; /* 琬 */
dict[0x2742f] = "lüè"; /* 琯 */
dict[0x27430] = "dú"; /* 琰 */
dict[0x27431] = "cóng"; /* 琱 */
dict[0x27432] = "chán"; /* 琲 */
dict[0x27433] = "lù"; /* 琳 */
dict[0x27434] = "sù"; /* 琴 */
dict[0x27440] = "lüè"; /* 瑀 */
dict[0x27446] = "zhōng"; /* 瑆 */
dict[0x27447] = "lí"; /* 瑇 */
dict[0x27448] = "fèi"; /* 瑈 */
dict[0x2744a] = "jǐng"; /* 瑊 */
dict[0x2744b] = "kuì"; /* 瑋 */
dict[0x2744c] = "yì"; /* 瑌 */
dict[0x2744d] = "huá"; /* 瑍 */
dict[0x2744e] = "cuì"; /* 瑎 */
dict[0x27450] = "yù"; /* 瑐 */
dict[0x27451] = "běng"; /* 瑑 */
dict[0x27452] = "tūn"; /* 瑒 */
dict[0x27453] = "shǔ"; /* 瑓 */
dict[0x27454] = "dài"; /* 瑔 */
dict[0x27455] = "wū"; /* 瑕 */
dict[0x27456] = "cì"; /* 瑖 */
dict[0x27457] = "nìng"; /* 瑗 */
dict[0x27458] = "dàng"; /* 瑘 */
dict[0x27459] = "zú"; /* 瑙 */
dict[0x2745a] = "hán"; /* 瑚 */
dict[0x2745c] = "pí"; /* 瑜 */
dict[0x2745d] = "chuàn"; /* 瑝 */
dict[0x27460] = "dù"; /* 瑠 */
dict[0x27461] = "pá"; /* 瑡 */
dict[0x27464] = "zhū"; /* 瑤 */
dict[0x27466] = "xié"; /* 瑦 */
dict[0x27467] = "zhé"; /* 瑧 */
dict[0x27468] = "qiè"; /* 瑨 */
dict[0x27469] = "xuān"; /* 瑩 */
dict[0x2746b] = "sào"; /* 瑫 */
dict[0x27480] = "bì"; /* 璀 */
dict[0x27482] = "fù"; /* 璂 */
dict[0x27488] = "lì"; /* 璈 */
dict[0x2748e] = "é"; /* 璎 */
dict[0x27490] = "yē"; /* 璐 */
dict[0x27491] = "shǔ"; /* 璑 */
dict[0x27493] = "sè"; /* 璓 */
dict[0x27494] = "qiú"; /* 璔 */
dict[0x27495] = "qī"; /* 璕 */
dict[0x27496] = "guò"; /* 璖 */
dict[0x27497] = "sè"; /* 璗 */
dict[0x27498] = "guǒ"; /* 璘 */
dict[0x27499] = "fù"; /* 璙 */
dict[0x2749a] = "máo"; /* 璚 */
dict[0x2749c] = "léi"; /* 璜 */
dict[0x2749d] = "zhān"; /* 璝 */
dict[0x274a8] = "chài"; /* 璨 */
dict[0x274bb] = "xiè"; /* 璻 */
dict[0x274bd] = "léi"; /* 璽 */
dict[0x274be] = "dāng"; /* 璾 */
dict[0x274bf] = "zéi"; /* 璿 */
dict[0x274c0] = "yīng"; /* 瓀 */
dict[0x274c1] = "ài"; /* 瓁 */
dict[0x274c2] = "xiē"; /* 瓂 */
dict[0x274c4] = "bì"; /* 瓄 */
dict[0x274c9] = "qí"; /* 瓉 */
dict[0x274cb] = "chán"; /* 瓋 */
dict[0x274ce] = "pí,bī"; /* 瓎 */
dict[0x274cf] = "cóng"; /* 瓏 */
dict[0x274d0] = "liè"; /* 瓐 */
dict[0x274d1] = "qí"; /* 瓑 */
dict[0x274d3] = "jì"; /* 瓓 */
dict[0x274d4] = "jīng"; /* 瓔 */
dict[0x274d5] = "dōng"; /* 瓕 */
dict[0x274d6] = "féi"; /* 瓖 */
dict[0x274d7] = "yí"; /* 瓗 */
dict[0x274d8] = "tuán"; /* 瓘 */
dict[0x274e7] = "biān"; /* 瓧 */
dict[0x274e8] = "měng"; /* 瓨 */
dict[0x274e9] = "cán"; /* 瓩 */
dict[0x274ea] = "yá"; /* 瓪 */
dict[0x274f2] = "yǎng"; /* 瓲 */
dict[0x274f4] = "tíng"; /* 瓴 */
dict[0x274f8] = "zhí"; /* 瓸 */
dict[0x274fa] = "xiè"; /* 瓺 */
dict[0x274fb] = "lǜ"; /* 瓻 */
dict[0x274fd] = "lì,chài"; /* 瓽 */
dict[0x274ff] = "máo"; /* 瓿 */
dict[0x27502] = "xiá"; /* 甂 */
dict[0x27505] = "sòu"; /* 甅 */
dict[0x27516] = "sū"; /* 甖 */
dict[0x27517] = "xuè"; /* 甗 */
dict[0x2751d] = "lì"; /* 甝 */
dict[0x2751e] = "yuán"; /* 甞 */
dict[0x27521] = "zhǎn"; /* 甡 */
dict[0x27523] = "tà"; /* 産 */
dict[0x27524] = "xuán"; /* 甤 */
dict[0x27525] = "wèi"; /* 甥 */
dict[0x27526] = "yè"; /* 甦 */
dict[0x27527] = "páng"; /* 甧 */
dict[0x27528] = "máo"; /* 用 */
dict[0x27529] = "tí"; /* 甩 */
dict[0x2752a] = "pín"; /* 甪 */
dict[0x2752c] = "dù"; /* 甬 */
dict[0x2752d] = "qiú"; /* 甭 */
dict[0x2752e] = "yǐ"; /* 甮 */
dict[0x27533] = "tuó"; /* 申 */
dict[0x27534] = "chài"; /* 甴 */
dict[0x27537] = "jìn"; /* 男 */
dict[0x2753c] = "é"; /* 甼 */
dict[0x27543] = "chán"; /* 畃 */
dict[0x27544] = "yīng"; /* 畄 */
dict[0x27545] = "líng"; /* 畅 */
dict[0x27547] = "xiǎn"; /* 畇 */
dict[0x27549] = "qī"; /* 畉 */
dict[0x2754b] = "yuè"; /* 畋 */
dict[0x2754c] = "lüè"; /* 界 */
dict[0x2754d] = "yíng"; /* 畍 */
dict[0x2754e] = "qú"; /* 畎 */
dict[0x27550] = "cáo"; /* 畐 */
dict[0x27552] = "fěi"; /* 畒 */
dict[0x27553] = "zī"; /* 畓 */
dict[0x27559] = "qīng"; /* 留 */
dict[0x2755d] = "níng"; /* 畝 */
dict[0x2755e] = "wèi"; /* 畞 */
dict[0x2755f] = "shuāng"; /* 畟 */
dict[0x27561] = "fù"; /* 畡 */
dict[0x27564] = "mò"; /* 畤 */
dict[0x27565] = "mò"; /* 略 */
dict[0x27566] = "tuó"; /* 畦 */
dict[0x27567] = "chài"; /* 畧 */
dict[0x27568] = "zàng"; /* 畨 */
dict[0x2756e] = "lí"; /* 畮 */
dict[0x2756f] = "lí,shī"; /* 畯 */
dict[0x27571] = "xiá"; /* 畱 */
dict[0x27572] = "juǎn"; /* 畲 */
dict[0x27574] = "nán"; /* 畴 */
dict[0x27575] = "mì"; /* 畵 */
dict[0x27578] = "huáng"; /* 畸 */
dict[0x2757a] = "shuàng"; /* 畺 */
dict[0x2757c] = "xǔ"; /* 畼 */
dict[0x2757f] = "fěi"; /* 畿 */
dict[0x27581] = "xiè,wén"; /* 疁 */
dict[0x27585] = "mì"; /* 疅 */
dict[0x27586] = "tà"; /* 疆 */
dict[0x27587] = "yǒng"; /* 疇 */
dict[0x27589] = "zhǎn"; /* 疉 */
dict[0x27591] = "qiáng"; /* 疑 */
dict[0x27592] = "náng"; /* 疒 */
dict[0x27594] = "lìn"; /* 疔 */
dict[0x27595] = "pí"; /* 疕 */
dict[0x27598] = "luán"; /* 疘 */
dict[0x27599] = "xiǎn"; /* 疙 */
dict[0x2759a] = "fú"; /* 疚 */
dict[0x2759c] = "líng"; /* 疜 */
dict[0x275a0] = "sāo"; /* 疠 */
dict[0x275a2] = "huì"; /* 疢 */
dict[0x275a8] = "tíng"; /* 疨 */
dict[0x275aa] = "qíng"; /* 疪 */
dict[0x275ac] = "huāng"; /* 疬 */
dict[0x275ae] = "àn"; /* 疮 */
dict[0x275b4] = "mài"; /* 疴 */
dict[0x275b5] = "mǎn"; /* 疵 */
dict[0x275b7] = "nì,nǜ"; /* 疷 */
dict[0x275b8] = "méng"; /* 疸 */
dict[0x275ba] = "tǎn"; /* 疺 */
dict[0x275bb] = "guó"; /* 疻 */
dict[0x275bc] = "ǒu"; /* 疼 */
dict[0x275bf] = "xiàng"; /* 疿 */
dict[0x275c1] = "jīn"; /* 痁 */
dict[0x275c6] = "zhēng"; /* 痆 */
dict[0x275c8] = "n"; /* 痈 */
dict[0x275cb] = "sàn"; /* 痋 */
dict[0x275cc] = "hù"; /* 痌 */
dict[0x275ce] = "zú"; /* 痎 */
dict[0x275cf] = "huǐ"; /* 痏 */
dict[0x275d2] = "jī"; /* 痒 */
dict[0x275d3] = "jī"; /* 痓 */
dict[0x275d5] = "nóng"; /* 痕 */
dict[0x275d6] = "yè"; /* 痖 */
dict[0x275e6] = "xíng"; /* 痦 */
dict[0x275e9] = "là"; /* 痩 */
dict[0x275ea] = "yù,qú"; /* 痪 */
dict[0x275eb] = "jué"; /* 痫 */
dict[0x275f1] = "shù,yù"; /* 痱 */
dict[0x275f2] = "zhēng"; /* 痲 */
dict[0x275f3] = "xuàn"; /* 痳 */
dict[0x275f4] = "yǒng"; /* 痴 */
dict[0x275f6] = "gē"; /* 痶 */
dict[0x275f8] = "jiàn"; /* 痸 */
dict[0x275f9] = "xìn,xiān"; /* 痹 */
dict[0x275fc] = "huī"; /* 痼 */
dict[0x275ff] = "shuài"; /* 痿 */
dict[0x27602] = "chōng,chòng"; /* 瘂 */
dict[0x27603] = "háng"; /* 瘃 */
dict[0x27608] = "liǎo"; /* 瘈 */
dict[0x27609] = "yì"; /* 瘉 */
dict[0x2760d] = "jiāng"; /* 瘍 */
dict[0x2760f] = "gōng"; /* 瘏 */
dict[0x27610] = "tuō"; /* 瘐 */
dict[0x27611] = "zhuó,bào"; /* 瘑 */
dict[0x27613] = "tì"; /* 瘓 */
dict[0x27617] = "qǐ"; /* 瘗 */
dict[0x2761c] = "qiān"; /* 瘜 */
dict[0x2761d] = "biǎo"; /* 瘝 */
dict[0x2761e] = "dǒu"; /* 瘞 */
dict[0x2761f] = "pō,bō"; /* 瘟 */
dict[0x27622] = "hù"; /* 瘢 */
dict[0x27625] = "niǔ"; /* 瘥 */
dict[0x27627] = "qì"; /* 瘧 */
dict[0x27628] = "diāo"; /* 瘨 */
dict[0x27629] = "diāo"; /* 瘩 */
dict[0x2762b] = "lì"; /* 瘫 */
dict[0x2762e] = "xiōng"; /* 瘮 */
dict[0x2763d] = "ná"; /* 瘽 */
dict[0x2763f] = "zhēng"; /* 瘿 */
dict[0x27640] = "là"; /* 癀 */
dict[0x27641] = "zhì,zī,jì,pī"; /* 癁 */
dict[0x27643] = "ě"; /* 癃 */
dict[0x27644] = "bō"; /* 癄 */
dict[0x27645] = "pō"; /* 癅 */
dict[0x27646] = "xū"; /* 癆 */
dict[0x27647] = "yòng,dǎn"; /* 癇 */
dict[0x27648] = "cí"; /* 癈 */
dict[0x27649] = "lì"; /* 癉 */
dict[0x2764b] = "zhǐ"; /* 癋 */
dict[0x2764c] = "páo"; /* 癌 */
dict[0x2764f] = "xiù,yǒu"; /* 癏 */
dict[0x2765b] = "pù"; /* 癛 */
dict[0x2765d] = "ché"; /* 癝 */
dict[0x2765e] = "qì"; /* 癞 */
dict[0x2765f] = "yì"; /* 癟 */
dict[0x27661] = "yì"; /* 癡 */
dict[0x27663] = "tí"; /* 癣 */
dict[0x27664] = "duǒ"; /* 癤 */
dict[0x27665] = "lóng,tǒng"; /* 癥 */
dict[0x27667] = "jiàn"; /* 癧 */
dict[0x2766d] = "zhàn"; /* 癭 */
dict[0x2766e] = "yuàn"; /* 癮 */
dict[0x27676] = "yú"; /* 癶 */
dict[0x27678] = "gēng"; /* 癸 */
dict[0x2767a] = "hòu"; /* 発 */
dict[0x2767e] = "qǐ"; /* 百 */
dict[0x27680] = "mù"; /* 皀 */
dict[0x27681] = "huàn"; /* 皁 */
dict[0x27682] = "lòng"; /* 皂 */
dict[0x27683] = "xì"; /* 皃 */
dict[0x27684] = "é"; /* 的 */
dict[0x27685] = "lǎng"; /* 皅 */
dict[0x27686] = "fèi"; /* 皆 */
dict[0x27687] = "wǎn,wèn"; /* 皇 */
dict[0x27689] = "cūn"; /* 皉 */
dict[0x2768b] = "péng"; /* 皋 */
dict[0x2768f] = "cuò"; /* 皏 */
dict[0x27690] = "wēng"; /* 皐 */
dict[0x27694] = "tóng"; /* 皔 */
dict[0x276a1] = "gǎo"; /* 皡 */
dict[0x276a5] = "cuì"; /* 皥 */
dict[0x276a8] = "qì,shà,qiè"; /* 皨 */
dict[0x276a9] = "lí"; /* 皩 */
dict[0x276aa] = "qiè"; /* 皪 */
dict[0x276ab] = "qiàn,jīng"; /* 皫 */
dict[0x276ac] = "kōng"; /* 皬 */
dict[0x276ad] = "běng"; /* 皭 */
dict[0x276af] = "shòu"; /* 皯 */
dict[0x276b7] = "wēi"; /* 皷 */
dict[0x276c4] = "shān"; /* 盄 */
dict[0x276cf] = "zī"; /* 盏 */
dict[0x276d2] = "tì"; /* 盒 */
dict[0x276d3] = "qiān"; /* 盓 */
dict[0x276d4] = "dú"; /* 盔 */
dict[0x276d7] = "tú"; /* 盗 */
dict[0x276da] = "wēi"; /* 盚 */
dict[0x276de] = "hú"; /* 盞 */
dict[0x276df] = "xīng"; /* 盟 */
dict[0x276e1] = "shān"; /* 盡 */
dict[0x276e2] = "zhǐ"; /* 盢 */
dict[0x276e7] = "chǐ"; /* 盧 */
dict[0x276f8] = "zhòu"; /* 相 */
dict[0x276f9] = "wēng"; /* 盹 */
dict[0x276fa] = "chí"; /* 盺 */
dict[0x276fb] = "suǒ"; /* 盻 */
dict[0x276fc] = "xiè"; /* 盼 */
dict[0x276fd] = "wèi"; /* 盽 */
dict[0x276fe] = "kè"; /* 盾 */
dict[0x27701] = "shài,shā,shǎi"; /* 省 */
dict[0x27702] = "shī"; /* 眂 */
dict[0x27703] = "shòu"; /* 眃 */
dict[0x27705] = "jiè"; /* 眅 */
dict[0x27709] = "gǎo"; /* 眉 */
dict[0x2770a] = "lǚ"; /* 眊 */
dict[0x27714] = "xiè"; /* 眔 */
dict[0x27715] = "tì"; /* 眕 */
dict[0x2771a] = "zhǐ"; /* 眚 */
dict[0x2771e] = "mán,màn"; /* 眞 */
dict[0x27720] = "shuài"; /* 眠 */
dict[0x27721] = "kè"; /* 眡 */
dict[0x27723] = "diǎo"; /* 眣 */
dict[0x27724] = "yī"; /* 眤 */
dict[0x27726] = "sù"; /* 眦 */
dict[0x27727] = "chuāng"; /* 眧 */
dict[0x27731] = "cuì"; /* 眱 */
dict[0x27732] = "tuò"; /* 眲 */
dict[0x2773d] = "xuán"; /* 眽 */
dict[0x27742] = "hè"; /* 睂 */
dict[0x27743] = "jué"; /* 睃 */
dict[0x27746] = "tì"; /* 睆 */
dict[0x27747] = "fèi"; /* 睇 */
dict[0x27749] = "zhǐ"; /* 睉 */
dict[0x2774a] = "shì"; /* 睊 */
dict[0x2774b] = "tuí"; /* 睋 */
dict[0x2774e] = "chōng,chuáng,chóng"; /* 睎 */
dict[0x27750] = "tì"; /* 睐 */
dict[0x27751] = "zhàn"; /* 睑 */
dict[0x27752] = "héng"; /* 睒 */
dict[0x27754] = "qú"; /* 睔 */
dict[0x27755] = "wéi"; /* 睕 */
dict[0x27757] = "dūn"; /* 睗 */
dict[0x27758] = "bào"; /* 睘 */
dict[0x2775c] = "liáo"; /* 睜 */
dict[0x27764] = "sī"; /* 睤 */
dict[0x2776a] = "biǎo"; /* 睪 */
dict[0x2776b] = "xiè"; /* 睫 */
dict[0x2776c] = "bié,bì"; /* 睬 */
dict[0x2776e] = "cǒng"; /* 睮 */
dict[0x27772] = "jù"; /* 睲 */
dict[0x27773] = "hé"; /* 睳 */
dict[0x27775] = "dié"; /* 睵 */
dict[0x27777] = "kuì"; /* 睷 */
dict[0x27778] = "yōng"; /* 睸 */
dict[0x27779] = "luǒ"; /* 睹 */
dict[0x27780] = "shù"; /* 瞀 */
dict[0x2778d] = "niè"; /* 瞍 */
dict[0x2778f] = "yú"; /* 瞏 */
dict[0x27790] = "zhuó"; /* 瞐 */
dict[0x27791] = "méng"; /* 瞑 */
dict[0x27792] = "hú"; /* 瞒 */
dict[0x27793] = "zī"; /* 瞓 */
dict[0x27794] = "jiè"; /* 瞔 */
dict[0x27795] = "liè"; /* 瞕 */
dict[0x2779d] = "jiē"; /* 瞝 */
dict[0x2779e] = "xióng"; /* 瞞 */
dict[0x277a3] = "yǎn"; /* 瞣 */
dict[0x277a9] = "jié"; /* 瞩 */
dict[0x277aa] = "là"; /* 瞪 */
dict[0x277ab] = "shù"; /* 瞫 */
dict[0x277ac] = "jié"; /* 瞬 */
dict[0x277ad] = "léi"; /* 瞭 */
dict[0x277b0] = "zú"; /* 瞰 */
dict[0x277b2] = "shì"; /* 瞲 */
dict[0x277b8] = "wéi,suì"; /* 瞸 */
dict[0x277b9] = "dū"; /* 瞹 */
dict[0x277ba] = "sù"; /* 瞺 */
dict[0x277bb] = "xiāng"; /* 瞻 */
dict[0x277c3] = "xié"; /* 矃 */
dict[0x277c4] = "ráng"; /* 矄 */
dict[0x277cc] = "luò"; /* 矌 */
dict[0x277d1] = "qiān"; /* 矑 */
dict[0x277d8] = "nàng"; /* 矘 */
dict[0x277d9] = "líng"; /* 矙 */
dict[0x277dc] = "jì"; /* 矜 */
dict[0x277e0] = "mìng"; /* 矠 */
dict[0x277e3] = "gǔ"; /* 矣 */
dict[0x277e8] = "xuán"; /* 矨 */
dict[0x277ec] = "xū"; /* 矬 */
dict[0x277f0] = "fiào"; /* 矰 */
dict[0x277f1] = "bó"; /* 矱 */
dict[0x277f5] = "bó"; /* 矵 */
dict[0x277fc] = "wēi"; /* 矼 */
dict[0x27802] = "kū"; /* 砂 */
dict[0x27806] = "wǎn"; /* 砆 */
dict[0x27808] = "chà"; /* 砈 */
dict[0x2780a] = "mào"; /* 砊 */
dict[0x2780b] = "kè"; /* 砋 */
dict[0x2780e] = "cì"; /* 砎 */
dict[0x27812] = "xiàn"; /* 砒 */
dict[0x27813] = "mò"; /* 砓 */
dict[0x2781a] = "hūn"; /* 砚 */
dict[0x2781b] = "chàn"; /* 砛 */
dict[0x2781c] = "shī"; /* 砜 */
dict[0x2781d] = "zhěn"; /* 砝 */
dict[0x2781e] = "è"; /* 砞 */
dict[0x2781f] = "mí"; /* 砟 */
dict[0x27821] = "shī"; /* 砡 */
dict[0x27822] = "qū"; /* 砢 */
dict[0x27823] = "shū"; /* 砣 */
dict[0x27825] = "cī"; /* 砥 */
dict[0x27826] = "yǎn"; /* 砦 */
dict[0x27829] = "hū"; /* 砩 */
dict[0x2782a] = "qī"; /* 砪 */
dict[0x2782b] = "zhì,dí,chì"; /* 砫 */
dict[0x2782c] = "huāng"; /* 砬 */
dict[0x27834] = "zhǐ"; /* 破 */
dict[0x27836] = "yǒu"; /* 砶 */
dict[0x2783c] = "gào"; /* 砼 */
dict[0x2783d] = "yǎo"; /* 砽 */
dict[0x2783e] = "pōu"; /* 砾 */
dict[0x27847] = "yí"; /* 硇 */
dict[0x27848] = "chèng"; /* 硈 */
dict[0x27849] = "jì"; /* 硉 */
dict[0x2784b] = "ǎi,yá"; /* 硋 */
dict[0x2784d] = "dòng"; /* 硍 */
dict[0x2784e] = "nì"; /* 硎 */
dict[0x2784f] = "suì"; /* 硏 */
dict[0x27851] = "jiù"; /* 硑 */
dict[0x27858] = "qì,qīn"; /* 硘 */
dict[0x27859] = "lián"; /* 硙 */
dict[0x2785a] = "xuǎn"; /* 硚 */
dict[0x2785c] = "liǎo"; /* 硜 */
dict[0x27861] = "yùn"; /* 硡 */
dict[0x27862] = "xuǎn"; /* 硢 */
dict[0x27863] = "cóu"; /* 硣 */
dict[0x27864] = "piān"; /* 硤 */
dict[0x27866] = "kuí"; /* 硦 */
dict[0x27868] = "tí"; /* 硨 */
dict[0x27869] = "huǎn"; /* 硩 */
dict[0x2786a] = "dān,dàn"; /* 硪 */
dict[0x2786b] = "guì,kuì"; /* 硫 */
dict[0x2786c] = "chēn"; /* 硬 */
dict[0x2786e] = "shǎng"; /* 确 */
dict[0x2786f] = "jì"; /* 硯 */
dict[0x27874] = "liàn"; /* 硴 */
dict[0x27875] = "kān"; /* 硵 */
dict[0x27876] = "shèng"; /* 硶 */
dict[0x27878] = "dōu"; /* 硸 */
dict[0x27879] = "yóu"; /* 硹 */
dict[0x2787a] = "qí"; /* 硺 */
dict[0x2787c] = "xiǎo"; /* 硼 */
dict[0x27882] = "yì"; /* 碂 */
dict[0x27883] = "lóu"; /* 碃 */
dict[0x27884] = "piǎo"; /* 碄 */
dict[0x27886] = "chuāng"; /* 碆 */
dict[0x2788b] = "lào"; /* 碋 */
dict[0x2788c] = "gāo"; /* 碌 */
dict[0x27890] = "zēng"; /* 碐 */
dict[0x27892] = "wéi,wěi"; /* 碒 */
dict[0x27896] = "jiān"; /* 碖 */
dict[0x2789b] = "yīng"; /* 碛 */
dict[0x2789c] = "fán"; /* 碜 */
dict[0x2789d] = "lì"; /* 碝 */
dict[0x2789e] = "qiān"; /* 碞 */
dict[0x278a2] = "yào"; /* 碢 */
dict[0x278a6] = "kuī,kuí,guì"; /* 碦 */
dict[0x278a7] = "wéi"; /* 碧 */
dict[0x278a9] = "què"; /* 碩 */
dict[0x278ac] = "xiǎo"; /* 碬 */
dict[0x278ad] = "què"; /* 碭 */
dict[0x278b0] = "hū"; /* 碰 */
dict[0x278b5] = "duō"; /* 碵 */
dict[0x278b6] = "chù"; /* 碶 */
dict[0x278b9] = "shēn,jīn"; /* 碹 */
dict[0x278bb] = "chù"; /* 碻 */
dict[0x278bc] = "zhuó"; /* 碼 */
dict[0x278bd] = "é"; /* 碽 */
dict[0x278be] = "jì"; /* 碾 */
dict[0x278c1] = "tán"; /* 磁 */
dict[0x278c3] = "pā"; /* 磃 */
dict[0x278c8] = "chù"; /* 磈 */
dict[0x278cb] = "jiè"; /* 磋 */
dict[0x278cc] = "qiào"; /* 磌 */
dict[0x278d1] = "qián"; /* 磑 */
dict[0x278d2] = "jù"; /* 磒 */
dict[0x278d5] = "qiú"; /* 磕 */
dict[0x278d6] = "tuó"; /* 磖 */
dict[0x278da] = "nuò"; /* 磚 */
dict[0x278db] = "sì"; /* 磛 */
dict[0x278df] = "yí"; /* 磟 */
dict[0x278e1] = "gǔ"; /* 磡 */
dict[0x278e2] = "hùn"; /* 磢 */
dict[0x278e3] = "pá"; /* 磣 */
dict[0x278e4] = "zī"; /* 磤 */
dict[0x278e6] = "jiāo"; /* 磦 */
dict[0x278e9] = "xǐ"; /* 磩 */
dict[0x278ea] = "shǎo,shào"; /* 磪 */
dict[0x278ec] = "yí"; /* 磬 */
dict[0x278ed] = "zhì"; /* 磭 */
dict[0x278f5] = "lùn"; /* 磵 */
dict[0x278f7] = "zhōu"; /* 磷 */
dict[0x278f8] = "jué"; /* 磸 */
dict[0x278f9] = "tán"; /* 磹 */
dict[0x278fa] = "nuò,chuò"; /* 磺 */
dict[0x278fb] = "jù"; /* 磻 */
dict[0x278fc] = "hú"; /* 磼 */
dict[0x278fe] = "zhì"; /* 磾 */
dict[0x27903] = "bī"; /* 礃 */
dict[0x2790d] = "chì,tì"; /* 礍 */
dict[0x2790e] = "xuān"; /* 礎 */
dict[0x2790f] = "jí"; /* 礏 */
dict[0x27910] = "guǎ"; /* 礐 */
dict[0x27911] = "jú"; /* 礑 */
dict[0x27912] = "wò"; /* 礒 */
dict[0x27913] = "tuó"; /* 礓 */
dict[0x27915] = "qiú"; /* 礕 */
dict[0x27916] = "wēi"; /* 礖 */
dict[0x27917] = "duān"; /* 礗 */
dict[0x27919] = "shòu"; /* 礙 */
dict[0x2791b] = "zhěn"; /* 礛 */
dict[0x2791c] = "nè,lì"; /* 礜 */
dict[0x2791f] = "xì"; /* 礟 */
dict[0x27920] = "zhé"; /* 礠 */
dict[0x27921] = "zhì"; /* 礡 */
dict[0x27923] = "ná"; /* 礣 */
dict[0x27928] = "jiān"; /* 礨 */
dict[0x2792e] = "yáo"; /* 礮 */
dict[0x2792f] = "guó,yuè"; /* 礯 */
dict[0x27932] = "dǐ"; /* 礲 */
dict[0x27934] = "huò"; /* 礴 */
dict[0x27935] = "jīng"; /* 礵 */
dict[0x2793c] = "jué"; /* 礼 */
dict[0x2793d] = "yuè,jiàn"; /* 礽 */
dict[0x27944] = "jí"; /* 祄 */
dict[0x27946] = "sù"; /* 祆 */
dict[0x27948] = "jiān"; /* 祈 */
dict[0x2794a] = "kūn"; /* 祊 */
dict[0x2794b] = "wò"; /* 祋 */
dict[0x2794c] = "kuàng"; /* 祌 */
dict[0x2794d] = "biāo"; /* 祍 */
dict[0x2794e] = "jué"; /* 祎 */
dict[0x27951] = "bì"; /* 祑 */
dict[0x27953] = "chán"; /* 祓 */
dict[0x27955] = "zī"; /* 祕 */
dict[0x27956] = "lì,shǐ"; /* 祖 */
dict[0x2795a] = "fó"; /* 祚 */
dict[0x2795b] = "qiǎn"; /* 祛 */
dict[0x2795c] = "yǎn"; /* 祜 */
dict[0x2795e] = "tàn"; /* 神 */
dict[0x2795f] = "mò"; /* 祟 */
dict[0x27963] = "kòu"; /* 祣 */
dict[0x27964] = "xī,xiē"; /* 祤 */
dict[0x2796e] = "hù,dǐ"; /* 祮 */
dict[0x2796f] = "hù"; /* 祯 */
dict[0x27971] = "fú"; /* 祱 */
dict[0x27974] = "yàng"; /* 祴 */
dict[0x27975] = "guò"; /* 祵 */
dict[0x27977] = "rén"; /* 祷 */
dict[0x27978] = "yìn"; /* 祸 */
dict[0x27979] = "fēng"; /* 祹 */
dict[0x2797a] = "jùn,yùn"; /* 祺 */
dict[0x2797c] = "yún"; /* 祼 */
dict[0x2797f] = "xùn"; /* 祿 */
dict[0x27981] = "xì"; /* 禁 */
dict[0x2798e] = "xiā"; /* 禎 */
dict[0x27991] = "háng"; /* 禑 */
dict[0x2799a] = "hù,dǐ"; /* 禚 */
dict[0x2799d] = "hū,hào"; /* 禝 */
dict[0x2799e] = "pù"; /* 禞 */
dict[0x2799f] = "fān"; /* 禟 */
dict[0x279a4] = "jiā"; /* 禤 */
dict[0x279a7] = "yí,tuō"; /* 禧 */
dict[0x279ad] = "tuō,xī"; /* 禭 */
dict[0x279ae] = "ná"; /* 禮 */
dict[0x279b4] = "chá"; /* 禴 */
dict[0x279b8] = "yín"; /* 禸 */
dict[0x279b9] = "yìn"; /* 禹 */
dict[0x279c1] = "yuǎn"; /* 私 */
dict[0x279c3] = "jì"; /* 秃 */
dict[0x279c4] = "wàng"; /* 秄 */
dict[0x279c5] = "shì,jiàn"; /* 秅 */
dict[0x279c6] = "duī"; /* 秆 */
dict[0x279c7] = "duò"; /* 秇 */
dict[0x279c9] = "tuó"; /* 秉 */
dict[0x279ca] = "wā"; /* 秊 */
dict[0x279cb] = "lì"; /* 秋 */
dict[0x279cf] = "rè,rě"; /* 秏 */
dict[0x279d2] = "cì"; /* 秒 */
dict[0x279d3] = "xù"; /* 秓 */
dict[0x279d4] = "zhōu"; /* 秔 */
dict[0x279d5] = "zì"; /* 秕 */
dict[0x279db] = "nán"; /* 秛 */
dict[0x279dc] = "wǎng"; /* 秜 */
dict[0x279dd] = "yǎ"; /* 秝 */
dict[0x279df] = "jì"; /* 租 */
dict[0x279e0] = "chǎo"; /* 秠 */
dict[0x279e9] = "jí"; /* 秩 */
dict[0x279ec] = "zhí,xiè"; /* 秬 */
dict[0x279ed] = "gàng"; /* 秭 */
dict[0x279f0] = "zhǐ"; /* 称 */
dict[0x279f5] = "shǎn"; /* 秵 */
dict[0x279f6] = "tú"; /* 秶 */
dict[0x279f8] = "bié"; /* 秸 */
dict[0x279f9] = "xì"; /* 秹 */
dict[0x279fa] = "pī"; /* 秺 */
dict[0x279fb] = "zhà"; /* 移 */
dict[0x279fe] = "huì"; /* 秾 */
dict[0x27a00] = "suō,zuò"; /* 稀 */
dict[0x27a02] = "hè"; /* 稂 */
dict[0x27a04] = "yuē"; /* 稄 */
dict[0x27a06] = "wū,huǎng"; /* 稆 */
dict[0x27a08] = "líng,wū"; /* 稈 */
dict[0x27a0a] = "zhà"; /* 稊 */
dict[0x27a0b] = "huá"; /* 程 */
dict[0x27a17] = "chán"; /* 稗 */
dict[0x27a1f] = "è"; /* 稟 */
dict[0x27a21] = "chén"; /* 稡 */
dict[0x27a22] = "xiáng"; /* 稢 */
dict[0x27a27] = "suì"; /* 稧 */
dict[0x27a29] = "tiǎn"; /* 稩 */
dict[0x27a30] = "zhì"; /* 稰 */
dict[0x27a31] = "tì"; /* 稱 */
dict[0x27a32] = "āo"; /* 稲 */
dict[0x27a33] = "zhuó"; /* 稳 */
dict[0x27a34] = "zì"; /* 稴 */
dict[0x27a35] = "kē"; /* 稵 */
dict[0x27a37] = "sè"; /* 稷 */
dict[0x27a38] = "tián"; /* 稸 */
dict[0x27a39] = "lù"; /* 稹 */
dict[0x27a3e] = "shán"; /* 稾 */
dict[0x27a3f] = "zhǎ"; /* 稿 */
dict[0x27a43] = "chōng"; /* 穃 */
dict[0x27a45] = "yàn"; /* 穅 */
dict[0x27a52] = "mǔ"; /* 穒 */
dict[0x27a53] = "hū"; /* 穓 */
dict[0x27a5a] = "chī"; /* 穚 */
dict[0x27a5d] = "sù"; /* 穝 */
dict[0x27a63] = "nǎo"; /* 穣 */
dict[0x27a66] = "jí"; /* 穦 */
dict[0x27a67] = "duó"; /* 穧 */
dict[0x27a68] = "hòu"; /* 穨 */
dict[0x27a6a] = "còng"; /* 穪 */
dict[0x27a6b] = "zhā,chà"; /* 穫 */
dict[0x27a6c] = "yín"; /* 穬 */
dict[0x27a6e] = "xiǎo,sǒu,sòu"; /* 穮 */
dict[0x27a70] = "biàn"; /* 穰 */
dict[0x27a71] = "bèng"; /* 穱 */
dict[0x27a72] = "là"; /* 穲 */
dict[0x27a74] = "chī,chì"; /* 穴 */
dict[0x27a76] = "qià"; /* 究 */
dict[0x27a78] = "ān"; /* 穸 */
dict[0x27a79] = "shī,yǐ"; /* 穹 */
dict[0x27a7c] = "chì,zhǐ"; /* 穼 */
dict[0x27a85] = "nù"; /* 窅 */
dict[0x27a87] = "jì"; /* 窇 */
dict[0x27a93] = "ǒu"; /* 窓 */
dict[0x27a95] = "xiā"; /* 窕 */
dict[0x27a98] = "chài,cuǒ,jiē"; /* 窘 */
dict[0x27a9a] = "ái"; /* 窚 */
dict[0x27a9d] = "shèng"; /* 窝 */
dict[0x27a9e] = "hé,gé"; /* 窞 */
dict[0x27aa0] = "jí"; /* 窠 */
dict[0x27aa1] = "chī"; /* 窡 */
dict[0x27aa2] = "xì"; /* 窢 */
dict[0x27aa3] = "zhēng"; /* 窣 */
dict[0x27aa6] = "tā"; /* 窦 */
dict[0x27aa8] = "mà"; /* 窨 */
dict[0x27aab] = "pī"; /* 窫 */
dict[0x27aae] = "xū,huá"; /* 窮 */
dict[0x27aaf] = "qiǎn"; /* 窯 */
dict[0x27ab7] = "xī"; /* 窷 */
dict[0x27ab9] = "xià"; /* 窹 */
dict[0x27aca] = "yù"; /* 竊 */
dict[0x27ad1] = "jié"; /* 竑 */
dict[0x27ad2] = "xià"; /* 竒 */
dict[0x27ad3] = "lǔ"; /* 竓 */
dict[0x27ad5] = "qiè"; /* 竕 */
dict[0x27ad7] = "chà"; /* 竗 */
dict[0x27adb] = "yàng"; /* 竛 */
dict[0x27adc] = "jì"; /* 竜 */
dict[0x27add] = "shǎ"; /* 竝 */
dict[0x27ade] = "lòu"; /* 竞 */
dict[0x27ae0] = "jī"; /* 章 */
dict[0x27ae1] = "zhì"; /* 竡 */
dict[0x27ae2] = "wàng"; /* 竢 */
dict[0x27ae4] = "bì"; /* 竤 */
dict[0x27ae5] = "ān"; /* 童 */
dict[0x27ae6] = "yī"; /* 竦 */
dict[0x27ae7] = "ān,àn"; /* 竧 */
dict[0x27aec] = "lí"; /* 竬 */
dict[0x27af9] = "xiān"; /* 竹 */
dict[0x27afe] = "jiù"; /* 竾 */
dict[0x27aff] = "tǎn"; /* 竿 */
dict[0x27b01] = "hào"; /* 笁 */
dict[0x27b02] = "hè"; /* 笂 */
dict[0x27b05] = "zhā"; /* 笅 */
dict[0x27b06] = "zhǎn"; /* 笆 */
dict[0x27b07] = "yì"; /* 笇 */
dict[0x27b08] = "xì"; /* 笈 */
dict[0x27b0a] = "xì,sí"; /* 笊 */
dict[0x27b0b] = "fà"; /* 笋 */
dict[0x27b0c] = "yán"; /* 笌 */
dict[0x27b0f] = "mǔ"; /* 笏 */
dict[0x27b15] = "gū"; /* 笕 */
dict[0x27b1e] = "yún"; /* 笞 */
dict[0x27b24] = "zhòng"; /* 笤 */
dict[0x27b26] = "chǎn"; /* 符 */
dict[0x27b27] = "chuáng"; /* 笧 */
dict[0x27b28] = "huì"; /* 笨 */
dict[0x27b29] = "zá"; /* 笩 */
dict[0x27b2a] = "gùn"; /* 笪 */
dict[0x27b2b] = "jiǎn"; /* 笫 */
dict[0x27b2c] = "yá"; /* 第 */
dict[0x27b2e] = "guà"; /* 笮 */
dict[0x27b30] = "xiàng,xiǎng"; /* 笰 */
dict[0x27b31] = "hè"; /* 笱 */
dict[0x27b3b] = "tà"; /* 笻 */
dict[0x27b43] = "dàn"; /* 筃 */
dict[0x27b47] = "mián"; /* 筇 */
dict[0x27b48] = "níng,nìng"; /* 筈 */
dict[0x27b4a] = "méng"; /* 筊 */
dict[0x27b4c] = "liè"; /* 筌 */
dict[0x27b4d] = "zhòu"; /* 筍 */
dict[0x27b4e] = "pū"; /* 筎 */
dict[0x27b4f] = "tāi"; /* 筏 */
dict[0x27b53] = "yíng"; /* 筓 */
dict[0x27b54] = "téng"; /* 答 */
dict[0x27b55] = "guó"; /* 筕 */
dict[0x27b5a] = "qiáng"; /* 筚 */
dict[0x27b5c] = "lǜ"; /* 筜 */
dict[0x27b5d] = "sà"; /* 筝 */
dict[0x27b5e] = "liè"; /* 筞 */
dict[0x27b5f] = "chí"; /* 筟 */
dict[0x27b60] = "xiě"; /* 筠 */
dict[0x27b63] = "guó"; /* 筣 */
dict[0x27b64] = "bào,báo"; /* 筤 */
dict[0x27b65] = "luò"; /* 筥 */
dict[0x27b66] = "juàn,xuān"; /* 筦 */
dict[0x27b6a] = "è"; /* 筪 */
dict[0x27b6d] = "yìng"; /* 筭 */
dict[0x27b73] = "hé"; /* 筳 */
dict[0x27b75] = "mèi"; /* 筵 */
dict[0x27b78] = "xiè"; /* 筸 */
dict[0x27b79] = "pín"; /* 筹 */
dict[0x27b7b] = "hān"; /* 筻 */
dict[0x27b7c] = "chèn"; /* 筼 */
dict[0x27b7d] = "shàn"; /* 筽 */
dict[0x27b7e] = "huì"; /* 签 */
dict[0x27b86] = "yīng"; /* 箆 */
dict[0x27b87] = "mài"; /* 箇 */
dict[0x27b88] = "jiǎn"; /* 箈 */
dict[0x27b8d] = "ān"; /* 箍 */
dict[0x27b91] = "tà"; /* 箑 */
dict[0x27b92] = "yī"; /* 箒 */
dict[0x27b93] = "tuí"; /* 箓 */
dict[0x27b97] = "liú"; /* 算 */
dict[0x27b99] = "zuó"; /* 箙 */
dict[0x27b9a] = "mài"; /* 箚 */
dict[0x27b9b] = "lí"; /* 箛 */
dict[0x27b9d] = "pín"; /* 箝 */
dict[0x27b9e] = "xuè"; /* 箞 */
dict[0x27ba0] = "nèn"; /* 箠 */
dict[0x27ba1] = "dòu"; /* 管 */
dict[0x27ba4] = "lǎn"; /* 箤 */
dict[0x27baa] = "zhān"; /* 箪 */
dict[0x27bab] = "jué"; /* 箫 */
dict[0x27bac] = "zhēn,jué"; /* 箬 */
dict[0x27bad] = "jí"; /* 箭 */
dict[0x27bae] = "qiān"; /* 箮 */
dict[0x27baf] = "hóng"; /* 箯 */
dict[0x27bb0] = "hān"; /* 箰 */
dict[0x27bb1] = "fén"; /* 箱 */
dict[0x27bb3] = "hān"; /* 箳 */
dict[0x27bb4] = "hóng"; /* 箴 */
dict[0x27bb5] = "hé"; /* 箵 */
dict[0x27bb6] = "hóu"; /* 箶 */
dict[0x27bba] = "zhàn"; /* 箺 */
dict[0x27bbb] = "chóu,xiāo"; /* 箻 */
dict[0x27bbc] = "tài"; /* 箼 */
dict[0x27bbd] = "qiàn"; /* 箽 */
dict[0x27bbf] = "shè"; /* 箿 */
dict[0x27bc0] = "yīng"; /* 節 */
dict[0x27bc3] = "qīn"; /* 篃 */
dict[0x27bc6] = "huò"; /* 篆 */
dict[0x27bc8] = "xì"; /* 篈 */
dict[0x27bc9] = "hè"; /* 築 */
dict[0x27bca] = "xì"; /* 篊 */
dict[0x27bcb] = "xiā"; /* 篋 */
dict[0x27bcc] = "hāo"; /* 篌 */
dict[0x27bcd] = "lào"; /* 篍 */
dict[0x27bcf] = "lì"; /* 篏 */
dict[0x27bd2] = "chēng"; /* 篒 */
dict[0x27bd6] = "jùn"; /* 篖 */
dict[0x27bd7] = "xī"; /* 篗 */
dict[0x27bd8] = "hǎn"; /* 篘 */
dict[0x27bde] = "dòu,dōu"; /* 篞 */
dict[0x27be0] = "dōu"; /* 篠 */
dict[0x27be1] = "wān,yuè"; /* 篡 */
dict[0x27be4] = "dōu"; /* 篤 */
dict[0x27be5] = "zài"; /* 篥 */
dict[0x27be6] = "juàn"; /* 篦 */
dict[0x27be8] = "lǒu"; /* 篨 */
dict[0x27be9] = "chù"; /* 篩 */
dict[0x27beb] = "zhēng"; /* 篫 */
dict[0x27bef] = "qí"; /* 篯 */
dict[0x27bf0] = "kàn"; /* 篰 */
dict[0x27bf1] = "huò,yù"; /* 篱 */
dict[0x27bf2] = "lái"; /* 篲 */
dict[0x27bf7] = "jǐn"; /* 篷 */
dict[0x27bfa] = "gāi"; /* 篺 */
dict[0x27bfc] = "shòu"; /* 篼 */
dict[0x27bfe] = "dōng"; /* 篾 */
dict[0x27c02] = "tā"; /* 簂 */
dict[0x27c03] = "lóu"; /* 簃 */
dict[0x27c04] = "tuān"; /* 簄 */
dict[0x27c07] = "yú"; /* 簇 */
dict[0x27c08] = "wù"; /* 簈 */
dict[0x27c0a] = "tián"; /* 簊 */
dict[0x27c12] = "guó"; /* 簒 */
dict[0x27c18] = "tán"; /* 簘 */
dict[0x27c19] = "qí"; /* 簙 */
dict[0x27c20] = "liè"; /* 簠 */
dict[0x27c21] = "lì"; /* 簡 */
dict[0x27c23] = "xūn"; /* 簣 */
dict[0x27c28] = "gèng"; /* 簨 */
dict[0x27c29] = "tīng"; /* 簩 */
dict[0x27c2a] = "hàn"; /* 簪 */
dict[0x27c2b] = "chù"; /* 簫 */
dict[0x27c2d] = "tún"; /* 簭 */
dict[0x27c2f] = "xióng"; /* 簯 */
dict[0x27c30] = "yóu"; /* 簰 */
dict[0x27c31] = "mò"; /* 簱 */
dict[0x27c32] = "chǐ"; /* 簲 */
dict[0x27c34] = "hǔ"; /* 簴 */
dict[0x27c35] = "dú,zhuó"; /* 簵 */
dict[0x27c37] = "mǔ"; /* 簷 */
dict[0x27c38] = "ài"; /* 簸 */
dict[0x27c39] = "nà"; /* 簹 */
dict[0x27c3b] = "líng"; /* 簻 */
dict[0x27c3f] = "ài"; /* 簿 */
dict[0x27c40] = "xiān"; /* 籀 */
dict[0x27c44] = "kǎn"; /* 籄 */
dict[0x27c45] = "sì"; /* 籅 */
dict[0x27c46] = "sān"; /* 籆 */
dict[0x27c4a] = "yì"; /* 籊 */
dict[0x27c4f] = "yì"; /* 籏 */
dict[0x27c50] = "xiào,xiāo"; /* 籐 */
dict[0x27c52] = "zhī,zhuō"; /* 籒 */
dict[0x27c53] = "dòu"; /* 籓 */
dict[0x27c58] = "mài"; /* 籘 */
dict[0x27c5c] = "lún"; /* 籜 */
dict[0x27c5d] = "jué,jùn"; /* 籝 */
dict[0x27c61] = "qiāng"; /* 籡 */
dict[0x27c62] = "líng"; /* 籢 */
dict[0x27c69] = "pián"; /* 籩 */
dict[0x27c6a] = "còu"; /* 籪 */
dict[0x27c6b] = "duò"; /* 籫 */
dict[0x27c6c] = "yǔ"; /* 籬 */
dict[0x27c70] = "zhuō"; /* 籰 */
dict[0x27c72] = "xì"; /* 籲 */
dict[0x27c73] = "huài"; /* 米 */
dict[0x27c74] = "míng"; /* 籴 */
dict[0x27c75] = "táng"; /* 籵 */
dict[0x27c79] = "pū"; /* 籹 */
dict[0x27c7b] = "mì"; /* 类 */
dict[0x27c7c] = "mán"; /* 籼 */
dict[0x27c7e] = "guāi"; /* 籾 */
dict[0x27c80] = "qiān"; /* 粀 */
dict[0x27c82] = "lín"; /* 粂 */
dict[0x27c83] = "mǐn"; /* 粃 */
dict[0x27c84] = "wěi"; /* 粄 */
dict[0x27c85] = "céng"; /* 粅 */
dict[0x27c87] = "hù"; /* 粇 */
dict[0x27c88] = "suí"; /* 粈 */
dict[0x27c8b] = "jù"; /* 粋 */
dict[0x27c8c] = "shà"; /* 粌 */
dict[0x27c8d] = "méng"; /* 粍 */
dict[0x27c95] = "lóu"; /* 粕 */
dict[0x27c97] = "wéi"; /* 粗 */
dict[0x27c98] = "xī"; /* 粘 */
dict[0x27c99] = "lìng"; /* 粙 */
dict[0x27c9c] = "bì"; /* 粜 */
dict[0x27c9d] = "wèi"; /* 粝 */
dict[0x27ca1] = "lì"; /* 粡 */
dict[0x27ca2] = "zhé"; /* 粢 */
dict[0x27ca4] = "yóng"; /* 粤 */
dict[0x27ca5] = "hú"; /* 粥 */
dict[0x27ca6] = "wán,hé"; /* 粦 */
dict[0x27ca7] = "bā"; /* 粧 */
dict[0x27ca8] = "jiān"; /* 粨 */
dict[0x27cad] = "zuǒ"; /* 粭 */
dict[0x27cae] = "zhǎn"; /* 粮 */
dict[0x27caf] = "bō"; /* 粯 */
dict[0x27cb0] = "qiū,chū"; /* 粰 */
dict[0x27cb1] = "yāng"; /* 粱 */
dict[0x27cb4] = "dōng"; /* 粴 */
dict[0x27cb5] = "qú"; /* 粵 */
dict[0x27cba] = "pí"; /* 粺 */
dict[0x27cbb] = "zhǎi"; /* 粻 */
dict[0x27cbe] = "shān"; /* 精 */
dict[0x27cbf] = "gòu"; /* 粿 */
dict[0x27cc0] = "biào,nǎo"; /* 糀 */
dict[0x27cc1] = "yí"; /* 糁 */
dict[0x27cc2] = "fú"; /* 糂 */
dict[0x27cc4] = "xìn"; /* 糄 */
dict[0x27cc5] = "shì,shǐ"; /* 糅 */
dict[0x27cc6] = "tōng,tóng"; /* 糆 */
dict[0x27cc9] = "dīng"; /* 糉 */
dict[0x27ccc] = "tū"; /* 糌 */
dict[0x27ccd] = "xiāo"; /* 糍 */
dict[0x27cce] = "wú"; /* 糎 */
dict[0x27ccf] = "péi"; /* 糏 */
dict[0x27cd0] = "huī,xī"; /* 糐 */
dict[0x27cd2] = "mào"; /* 糒 */
dict[0x27cd5] = "lái"; /* 糕 */
dict[0x27cd9] = "sì"; /* 糙 */
dict[0x27cda] = "cuǐ"; /* 糚 */
dict[0x27cdb] = "shà"; /* 糛 */
dict[0x27cdc] = "zhǒu"; /* 糜 */
dict[0x27cdd] = "zhào"; /* 糝 */
dict[0x27cde] = "wéi"; /* 糞 */
dict[0x27cdf] = "lái"; /* 糟 */
dict[0x27ce0] = "bì,bǐ"; /* 糠 */
dict[0x27ce3] = "dǒng"; /* 糣 */
dict[0x27ce6] = "nǎo"; /* 糦 */
dict[0x27ce7] = "xiē"; /* 糧 */
dict[0x27ce8] = "rǎo"; /* 糨 */
dict[0x27ce9] = "tuàn"; /* 糩 */
dict[0x27cea] = "wèi"; /* 糪 */
dict[0x27ceb] = "yóu,jiū,qiú,yòu"; /* 糫 */
dict[0x27cec] = "méi"; /* 糬 */
dict[0x27ced] = "yuán"; /* 糭 */
dict[0x27cee] = "zhòng"; /* 糮 */
dict[0x27cf6] = "sōu"; /* 糶 */
dict[0x27cf8] = "gú"; /* 糸 */
dict[0x27cf9] = "shào"; /* 糹 */
dict[0x27cfa] = "nǎo"; /* 糺 */
dict[0x27cfb] = "zhǎo"; /* 系 */
dict[0x27cfc] = "pí"; /* 糼 */
dict[0x27cff] = "tōng"; /* 糿 */
dict[0x27d01] = "chī"; /* 紁 */
dict[0x27d02] = "péng"; /* 紂 */
dict[0x27d03] = "chán"; /* 紃 */
dict[0x27d04] = "yōng"; /* 約 */
dict[0x27d05] = "shuǎng"; /* 紅 */
dict[0x27d07] = "wǔ"; /* 紇 */
dict[0x27d09] = "pí"; /* 紉 */
dict[0x27d0a] = "huàn"; /* 紊 */
dict[0x27d0c] = "fú"; /* 紌 */
dict[0x27d0e] = "biào"; /* 紎 */
dict[0x27d13] = "náo"; /* 紓 */
dict[0x27d15] = "biào"; /* 紕 */
dict[0x27d16] = "wèi"; /* 紖 */
dict[0x27d17] = "yōng"; /* 紗 */
dict[0x27d19] = "nǎo"; /* 紙 */
dict[0x27d1a] = "guài"; /* 級 */
dict[0x27d20] = "lì"; /* 素 */
dict[0x27d22] = "xìn"; /* 索 */
dict[0x27d23] = "yán"; /* 紣 */
dict[0x27d24] = "pò"; /* 紤 */
dict[0x27d25] = "péi"; /* 紥 */
dict[0x27d2a] = "suǒ"; /* 紪 */
dict[0x27d2c] = "rèn"; /* 紬 */
dict[0x27d2d] = "shǎn"; /* 紭 */
dict[0x27d32] = "suǒ"; /* 紲 */
dict[0x27d38] = "dān"; /* 紸 */
dict[0x27d3a] = "mèn"; /* 紺 */
dict[0x27d43] = "shǒu"; /* 絃 */
dict[0x27d48] = "gòu"; /* 絈 */
dict[0x27d4a] = "hān,hàn,tàn"; /* 絊 */
dict[0x27d4b] = "shì"; /* 絋 */
dict[0x27d4c] = "yǎng"; /* 経 */
dict[0x27d4e] = "gǔ"; /* 絎 */
dict[0x27d51] = "gǔ"; /* 絑 */
dict[0x27d5b] = "kē"; /* 絛 */
dict[0x27d5e] = "jū"; /* 絞 */
dict[0x27d60] = "pài"; /* 絠 */
dict[0x27d61] = "cè"; /* 絡 */
dict[0x27d62] = "bāo"; /* 絢 */
dict[0x27d63] = "xiōng,mín"; /* 絣 */
dict[0x27d64] = "cái,zhù"; /* 絤 */
dict[0x27d67] = "lǐn"; /* 絧 */
dict[0x27d68] = "ài"; /* 絨 */
dict[0x27d6c] = "mì,shèn"; /* 絬 */
dict[0x27d6d] = "lǎi"; /* 絭 */
dict[0x27d71] = "xiāo"; /* 統 */
dict[0x27d73] = "shé"; /* 絳 */
dict[0x27d74] = "zhù"; /* 絴 */
dict[0x27d7b] = "huó"; /* 絻 */
dict[0x27d7c] = "nì"; /* 絼 */
dict[0x27d84] = "zhèng"; /* 綄 */
dict[0x27d86] = "lìn"; /* 綆 */
dict[0x27d87] = "zhá"; /* 綇 */
dict[0x27d8a] = "yún"; /* 綊 */
dict[0x27d8d] = "xù"; /* 綍 */
dict[0x27d94] = "chéng"; /* 綔 */
dict[0x27d95] = "wǒ"; /* 綕 */
dict[0x27d96] = "xī"; /* 綖 */
dict[0x27d99] = "bèi"; /* 継 */
dict[0x27d9c] = "shāng,shǎng"; /* 綜 */
dict[0x27da0] = "yù"; /* 綠 */
dict[0x27da1] = "mì"; /* 綡 */
dict[0x27db2] = "duǎn,zhuàn"; /* 網 */
dict[0x27db5] = "chà"; /* 綵 */
dict[0x27db7] = "zé"; /* 綷 */
dict[0x27db8] = "chèng"; /* 綸 */
dict[0x27dba] = "tíng"; /* 綺 */
dict[0x27dc5] = "yí"; /* 緅 */
dict[0x27dcb] = "yāo"; /* 緋 */
dict[0x27dce] = "kū"; /* 緎 */
dict[0x27dd0] = "fén"; /* 緐 */
dict[0x27dd1] = "xié"; /* 緑 */
dict[0x27dd2] = "chèng"; /* 緒 */
dict[0x27ddb] = "kuì"; /* 緛 */
dict[0x27ddf] = "bīn"; /* 緟 */
dict[0x27de1] = "lóu,lòu"; /* 緡 */
dict[0x27de5] = "yì"; /* 緥 */
dict[0x27de6] = "mì"; /* 緦 */
dict[0x27de7] = "xiè"; /* 緧 */
dict[0x27df1] = "guī"; /* 緱 */
dict[0x27df3] = "luó"; /* 緳 */
dict[0x27df4] = "huò"; /* 練 */
dict[0x27df6] = "shàn"; /* 緶 */
dict[0x27dfe] = "jú"; /* 緾 */
dict[0x27dff] = "dū"; /* 緿 */
dict[0x27e02] = "xiān"; /* 縂 */
dict[0x27e05] = "zhǐ"; /* 縅 */
dict[0x27e08] = "bìn"; /* 縈 */
dict[0x27e15] = "zhǐ"; /* 縕 */
dict[0x27e16] = "zhuàn,lián"; /* 縖 */
dict[0x27e17] = "xué"; /* 縗 */
dict[0x27e18] = "liàn,biǎn,jiǎn"; /* 縘 */
dict[0x27e19] = "suì"; /* 縙 */
dict[0x27e26] = "làn"; /* 縦 */
dict[0x27e27] = "jù"; /* 縧 */
dict[0x27e28] = "mián"; /* 縨 */
dict[0x27e29] = "xùn"; /* 縩 */
dict[0x27e2a] = "zhàn"; /* 縪 */
dict[0x27e2b] = "gùn"; /* 縫 */
dict[0x27e2e] = "wéi"; /* 縮 */
dict[0x27e32] = "zhì"; /* 縲 */
dict[0x27e3d] = "wèi"; /* 總 */
dict[0x27e3e] = "quǎn,xuàn"; /* 績 */
dict[0x27e3f] = "chài"; /* 縿 */
dict[0x27e48] = "réng"; /* 繈 */
dict[0x27e4a] = "yuè"; /* 繊 */
dict[0x27e4c] = "zī"; /* 繌 */
dict[0x27e50] = "luò"; /* 繐 */
dict[0x27e5b] = "zhī"; /* 繛 */
dict[0x27e5e] = "nǎn,niǎn"; /* 繞 */
dict[0x27e63] = "hān"; /* 繣 */
dict[0x27e68] = "xī"; /* 繨 */
dict[0x27e69] = "lín"; /* 繩 */
dict[0x27e6c] = "yān"; /* 繬 */
dict[0x27e6d] = "xù"; /* 繭 */
dict[0x27e72] = "hù"; /* 繲 */
dict[0x27e73] = "gàn"; /* 繳 */
dict[0x27e74] = "xù,huò"; /* 繴 */
dict[0x27e76] = "xì"; /* 繶 */
dict[0x27e7a] = "cuì"; /* 繺 */
dict[0x27e7d] = "xì"; /* 繽 */
dict[0x27e7e] = "hú"; /* 繾 */
dict[0x27e85] = "yān"; /* 纅 */
dict[0x27e86] = "zǒu"; /* 纆 */
dict[0x27e8d] = "péi"; /* 纍 */
dict[0x27e8e] = "yì"; /* 纎 */
dict[0x27e8f] = "chí"; /* 纏 */
dict[0x27e90] = "jué"; /* 纐 */
dict[0x27e92] = "zú"; /* 纒 */
dict[0x27e9c] = "jiào"; /* 纜 */
dict[0x27e9d] = "yì"; /* 纝 */
dict[0x27e9f] = "tǎn"; /* 纟 */
dict[0x27ea0] = "chì"; /* 纠 */
dict[0x27ea1] = "bá"; /* 纡 */
dict[0x27ea2] = "tòu,yì"; /* 红 */
dict[0x27ea3] = "zōng"; /* 纣 */
dict[0x27ea4] = "qiú,jū"; /* 纤 */
dict[0x27ea7] = "chì"; /* 级 */
dict[0x27ea8] = "xǐ"; /* 纨 */
dict[0x27eab] = "qǐ"; /* 纫 */
dict[0x27eb0] = "nì"; /* 纰 */
dict[0x27eb2] = "cū"; /* 纲 */
dict[0x27eb4] = "wǔ"; /* 纴 */
dict[0x27eb6] = "chù"; /* 纶 */
dict[0x27eb7] = "sū"; /* 纷 */
dict[0x27eb8] = "yóng"; /* 纸 */
dict[0x27eb9] = "jǔ"; /* 纹 */
dict[0x27eba] = "bá"; /* 纺 */
dict[0x27ebc] = "cǐ"; /* 纼 */
dict[0x27ebd] = "dì"; /* 纽 */
dict[0x27ebe] = "pǎn"; /* 纾 */
dict[0x27ebf] = "chì,yì"; /* 线 */
dict[0x27ec1] = "qiǔ"; /* 绁 */
dict[0x27ec3] = "yán,qù"; /* 练 */
dict[0x27ecd] = "zhǎi"; /* 绍 */
dict[0x27ed2] = "xiàn"; /* 绒 */
dict[0x27ed3] = "bèng"; /* 结 */
dict[0x27ed4] = "kuāng"; /* 绔 */
dict[0x27ed5] = "qì"; /* 绕 */
dict[0x27ed6] = "zhōu"; /* 绖 */
dict[0x27ed7] = "jú"; /* 绗 */
dict[0x27ed8] = "qiè"; /* 绘 */
dict[0x27ed9] = "mò,pò"; /* 给 */
dict[0x27eda] = "yuán"; /* 绚 */
dict[0x27edc] = "guì,kuǐ"; /* 络 */
dict[0x27edd] = "zuī"; /* 绝 */
dict[0x27ee7] = "qiè"; /* 继 */
dict[0x27ef0] = "hú,zào"; /* 绰 */
dict[0x27ef1] = "qiú"; /* 绱 */
dict[0x27ef2] = "hái,kuī"; /* 绲 */
dict[0x27ef3] = "fù"; /* 绳 */
dict[0x27ef4] = "làng"; /* 维 */
dict[0x27ef5] = "shà"; /* 绵 */
dict[0x27ef6] = "xī"; /* 绶 */
dict[0x27ef7] = "bū"; /* 绷 */
dict[0x27ef8] = "shì"; /* 绸 */
dict[0x27ef9] = "yǒng"; /* 绹 */
dict[0x27efa] = "guāng,kuāng"; /* 绺 */
dict[0x27efc] = "niè"; /* 综 */
dict[0x27eff] = "hǒu"; /* 绿 */
dict[0x27f0a] = "mì"; /* 缊 */
dict[0x27f0e] = "è"; /* 缎 */
dict[0x27f0f] = "xián"; /* 缏 */
dict[0x27f10] = "yǔn,qūn"; /* 缐 */
dict[0x27f11] = "xù"; /* 缑 */
dict[0x27f12] = "qǐn"; /* 缒 */
dict[0x27f13] = "dōng"; /* 缓 */
dict[0x27f14] = "léng"; /* 缔 */
dict[0x27f15] = "qì"; /* 缕 */
dict[0x27f16] = "lán"; /* 编 */
dict[0x27f17] = "fú"; /* 缗 */
dict[0x27f18] = "qǐ"; /* 缘 */
dict[0x27f19] = "chǒng"; /* 缙 */
dict[0x27f1c] = "cù"; /* 缜 */
dict[0x27f1f] = "mò"; /* 缟 */
dict[0x27f20] = "bēi"; /* 缠 */
dict[0x27f24] = "dào"; /* 缤 */
dict[0x27f28] = "jié,jué"; /* 缨 */
dict[0x27f29] = "chòng,dòng"; /* 缩 */
dict[0x27f2a] = "chì"; /* 缪 */
dict[0x27f2b] = "yù"; /* 缫 */
dict[0x27f2c] = "cuī"; /* 缬 */
dict[0x27f2d] = "sù,sōu,sǒu,qiù"; /* 缭 */
dict[0x27f2e] = "tì"; /* 缮 */
dict[0x27f2f] = "shù,yú"; /* 缯 */
dict[0x27f30] = "zhá"; /* 缰 */
dict[0x27f31] = "fú,bí"; /* 缱 */
dict[0x27f33] = "chè"; /* 缳 */
dict[0x27f34] = "fó,zhì"; /* 缴 */
dict[0x27f35] = "hóu"; /* 缵 */
dict[0x27f36] = "zhá"; /* 缶 */
dict[0x27f44] = "jié"; /* 罄 */
dict[0x27f45] = "zhá"; /* 罅 */
dict[0x27f46] = "zhān"; /* 罆 */
dict[0x27f49] = "yǎn"; /* 罉 */
dict[0x27f4a] = "hái"; /* 罊 */
dict[0x27f4b] = "wǔ"; /* 罋 */
dict[0x27f4c] = "huá"; /* 罌 */
dict[0x27f4d] = "diān,diàn"; /* 罍 */
dict[0x27f4e] = "yáo"; /* 罎 */
dict[0x27f4f] = "sōu"; /* 罏 */
dict[0x27f50] = "qiān"; /* 罐 */
dict[0x27f51] = "jí"; /* 网 */
dict[0x27f52] = "xiòng"; /* 罒 */
dict[0x27f53] = "qì"; /* 罓 */
dict[0x27f54] = "jūn"; /* 罔 */
dict[0x27f56] = "hái"; /* 罖 */
dict[0x27f5e] = "yǎn"; /* 罞 */
dict[0x27f5f] = "jié"; /* 罟 */
dict[0x27f60] = "cuī"; /* 罠 */
dict[0x27f62] = "tuán"; /* 罢 */
dict[0x27f63] = "zhāng"; /* 罣 */
dict[0x27f64] = "piāo"; /* 罤 */
dict[0x27f65] = "lù"; /* 罥 */
dict[0x27f66] = "zhī"; /* 罦 */
dict[0x27f67] = "chù"; /* 罧 */
dict[0x27f68] = "mì"; /* 罨 */
dict[0x27f69] = "qiāng"; /* 罩 */
dict[0x27f6b] = "liàn"; /* 罫 */
dict[0x27f6f] = "jiàn"; /* 罯 */
dict[0x27f72] = "lì"; /* 署 */
dict[0x27f76] = "é"; /* 罶 */
dict[0x27f77] = "sù"; /* 罷 */
dict[0x27f78] = "jué,guì"; /* 罸 */
dict[0x27f7b] = "jú"; /* 罻 */
dict[0x27f7c] = "tán"; /* 罼 */
dict[0x27f7d] = "liáo"; /* 罽 */
dict[0x27f7e] = "sān,cún"; /* 罾 */
dict[0x27f7f] = "dòng"; /* 罿 */
dict[0x27f81] = "zá"; /* 羁 */
dict[0x27f82] = "zhí"; /* 羂 */
dict[0x27f86] = "xuàn"; /* 羆 */
dict[0x27f87] = "líng"; /* 羇 */
dict[0x27f8a] = "dēng"; /* 羊 */
dict[0x27f8d] = "zhān,zhàn,chán"; /* 羍 */
dict[0x27f8e] = "xuān"; /* 美 */
dict[0x27f8f] = "qǐn"; /* 羏 */
dict[0x27f90] = "jiào"; /* 羐 */
dict[0x27f91] = "pì"; /* 羑 */
dict[0x27f94] = "hǎn"; /* 羔 */
dict[0x27f9a] = "yú"; /* 羚 */
dict[0x27f9b] = "guó"; /* 羛 */
dict[0x27f9d] = "xún"; /* 羝 */
dict[0x27fa0] = "xún"; /* 羠 */
dict[0x27fa1] = "chán"; /* 羡 */
dict[0x27fa2] = "jié,jí"; /* 羢 */
dict[0x27fa3] = "jú"; /* 羣 */
dict[0x27fa4] = "yǎn"; /* 群 */
dict[0x27fa5] = "dú"; /* 羥 */
dict[0x27fa7] = "hòng"; /* 羧 */
dict[0x27fa8] = "xiàn,xiǎn"; /* 羨 */
dict[0x27fa9] = "xún,xuàn"; /* 義 */
dict[0x27fab] = "biān"; /* 羫 */
dict[0x27fae] = "líng"; /* 羮 */
dict[0x27faf] = "jié"; /* 羯 */
dict[0x27fb0] = "yì"; /* 羰 */
dict[0x27fb1] = "qú"; /* 羱 */
dict[0x27fb2] = "gān"; /* 羲 */
dict[0x27fb3] = "fēng"; /* 羳 */
dict[0x27fb5] = "jué"; /* 羵 */
dict[0x27fb6] = "qū"; /* 羶 */
dict[0x27fbb] = "jiù"; /* 羻 */
dict[0x27fbd] = "jì"; /* 羽 */
dict[0x27fbe] = "jǐ"; /* 羾 */
dict[0x27fc5] = "xí"; /* 翅 */
dict[0x27fc6] = "pāng"; /* 翆 */
dict[0x27fc9] = "kù,wù"; /* 翉 */
dict[0x27fcb] = "kù"; /* 翋 */
dict[0x27fcc] = "zhà"; /* 翌 */
dict[0x27fcf] = "bà"; /* 翏 */
dict[0x27fd2] = "chěn"; /* 習 */
dict[0x27fd3] = "hù"; /* 翓 */
dict[0x27fd4] = "nù"; /* 翔 */
dict[0x27fd5] = "é"; /* 翕 */
dict[0x27fd6] = "xiōng"; /* 翖 */
dict[0x27fd7] = "dǔn"; /* 翗 */
dict[0x27fd8] = "shēng"; /* 翘 */
dict[0x27fd9] = "wán"; /* 翙 */
dict[0x27fda] = "fēn"; /* 翚 */
dict[0x27fdd] = "xī"; /* 翝 */
dict[0x27fde] = "zī"; /* 翞 */
dict[0x27fe0] = "hù,dì"; /* 翠 */
dict[0x27fe5] = "bié"; /* 翥 */
dict[0x27fe7] = "tuò"; /* 翧 */
dict[0x27fe8] = "bǎn"; /* 翨 */
dict[0x27fe9] = "gé"; /* 翩 */
dict[0x27feb] = "kē"; /* 翫 */
dict[0x27ff2] = "zhuì,bó"; /* 翲 */
dict[0x27ff3] = "fú,fèi"; /* 翳 */
dict[0x27ff4] = "mò"; /* 翴 */
dict[0x27ff5] = "jiá"; /* 翵 */
dict[0x27ff6] = "tuó"; /* 翶 */
dict[0x27ff7] = "yù"; /* 翷 */
dict[0x27ff9] = "mǔ"; /* 翹 */
dict[0x27ffa] = "jué"; /* 翺 */
dict[0x27ffb] = "jú"; /* 翻 */
dict[0x27ffc] = "guā"; /* 翼 */
dict[0x27ffd] = "pǒ"; /* 翽 */
dict[0x28000] = "nǐ,niǎn"; /* 耀 */
dict[0x28004] = "wǎ"; /* 耄 */
dict[0x28005] = "yǎn"; /* 者 */
dict[0x28014] = "chǒu"; /* 耔 */
dict[0x28015] = "kuāng"; /* 耕 */
dict[0x28016] = "hài"; /* 耖 */
dict[0x28018] = "xiáng"; /* 耘 */
dict[0x28019] = "xī"; /* 耙 */
dict[0x2801b] = "cún"; /* 耛 */
dict[0x2801c] = "tōng"; /* 耜 */
dict[0x2801d] = "ruò"; /* 耝 */
dict[0x2801f] = "duó"; /* 耟 */
dict[0x28020] = "chè"; /* 耠 */
dict[0x28024] = "lèi"; /* 耤 */
dict[0x28025] = "zī"; /* 耥 */
dict[0x28027] = "zhěng"; /* 耧 */
dict[0x28028] = "zuǒ"; /* 耨 */
dict[0x2802b] = "kāng"; /* 耫 */
dict[0x2802c] = "zài"; /* 耬 */
dict[0x2802e] = "yuān,xuān"; /* 耮 */
dict[0x2802f] = "qióng"; /* 耯 */
dict[0x28033] = "fá"; /* 耳 */
dict[0x28034] = "xún"; /* 耴 */
dict[0x28035] = "zhuàng"; /* 耵 */
dict[0x28036] = "jì"; /* 耶 */
dict[0x28038] = "chā"; /* 耸 */
dict[0x28040] = "shū,chōu"; /* 聀 */
dict[0x28041] = "xuàn"; /* 聁 */
dict[0x28042] = "xié"; /* 聂 */
dict[0x28043] = "tī"; /* 聃 */
dict[0x28044] = "hàn"; /* 聄 */
dict[0x28045] = "xiān"; /* 聅 */
dict[0x28046] = "shān"; /* 聆 */
dict[0x28047] = "tùn"; /* 聇 */
dict[0x28048] = "háng,gēng"; /* 聈 */
dict[0x28049] = "kǔn"; /* 聉 */
dict[0x2804a] = "cén"; /* 聊 */
dict[0x2804b] = "dōu"; /* 聋 */
dict[0x2804c] = "nuó"; /* 职 */
dict[0x2804d] = "yàn"; /* 聍 */
dict[0x2804e] = "chéng,jìng"; /* 聎 */
dict[0x2804f] = "pū"; /* 聏 */
dict[0x28050] = "qì"; /* 聐 */
dict[0x28051] = "yuè"; /* 聑 */
dict[0x28052] = "fū"; /* 聒 */
dict[0x28057] = "tǐng"; /* 聗 */
dict[0x2805f] = "wǒ"; /* 聟 */
dict[0x28060] = "shēng"; /* 聠 */
dict[0x28061] = "tuǒ"; /* 聡 */
dict[0x28076] = "yǎ,yā"; /* 聶 */
dict[0x28077] = "zhì"; /* 職 */
dict[0x28078] = "lù,lì"; /* 聸 */
dict[0x28079] = "yǎn"; /* 聹 */
dict[0x2807a] = "jū"; /* 聺 */
dict[0x2807d] = "dé"; /* 聽 */
dict[0x2807f] = "chù,zhuó"; /* 聿 */
dict[0x28080] = "zǔ"; /* 肀 */
dict[0x28081] = "è"; /* 肁 */
dict[0x28082] = "zhí,xuě"; /* 肂 */
dict[0x28083] = "péng"; /* 肃 */
dict[0x28085] = "biē"; /* 肅 */
dict[0x28087] = "dǐ"; /* 肇 */
dict[0x2808a] = "zhōu"; /* 肊 */
dict[0x2808b] = "jī"; /* 肋 */
dict[0x28090] = "lái"; /* 肐 */
dict[0x28092] = "yè"; /* 肒 */
dict[0x2809c] = "háo"; /* 肜 */
dict[0x2809d] = "pán"; /* 肝 */
dict[0x2809e] = "tàn"; /* 肞 */
dict[0x2809f] = "kāng"; /* 肟 */
dict[0x280a0] = "xū,lǚ"; /* 肠 */
dict[0x280a1] = "zòu"; /* 股 */
dict[0x280a2] = "jì"; /* 肢 */
dict[0x280a3] = "wù"; /* 肣 */
dict[0x280a6] = "chuàn"; /* 肦 */
dict[0x280a9] = "pò"; /* 肩 */
dict[0x280aa] = "yǎn"; /* 肪 */
dict[0x280ab] = "tuò"; /* 肫 */
dict[0x280ad] = "dú"; /* 肭 */
dict[0x280af] = "pián"; /* 肯 */
dict[0x280b0] = "chì"; /* 肰 */
dict[0x280b1] = "hùn"; /* 肱 */
dict[0x280b2] = "pīng"; /* 育 */
dict[0x280b4] = "cōng"; /* 肴 */
dict[0x280b5] = "zhǎ"; /* 肵 */
dict[0x280bb] = "dǎo"; /* 肻 */
dict[0x280bd] = "dàn"; /* 肽 */
dict[0x280be] = "nàn"; /* 肾 */
dict[0x280c3] = "è"; /* 胃 */
dict[0x280c4] = "wèi"; /* 胄 */
dict[0x280c5] = "bāi"; /* 胅 */
dict[0x280c7] = "jiāng"; /* 胇 */
dict[0x280c9] = "zhì"; /* 胉 */
dict[0x280d3] = "chá"; /* 胓 */
dict[0x280d5] = "chù"; /* 胕 */
dict[0x280d6] = "kuà"; /* 胖 */
dict[0x280d7] = "téng"; /* 胗 */
dict[0x280d8] = "zōu,qū"; /* 胘 */
dict[0x280d9] = "lì"; /* 胙 */
dict[0x280da] = "tà"; /* 胚 */
dict[0x280db] = "sà"; /* 胛 */
dict[0x280de] = "pán"; /* 胞 */
dict[0x280df] = "pán"; /* 胟 */
dict[0x280e3] = "sào"; /* 胣 */
dict[0x280e4] = "qiāo,kào"; /* 胤 */
dict[0x280e9] = "xiàn"; /* 胩 */
dict[0x280ed] = "zú"; /* 胭 */
dict[0x280ef] = "zhì"; /* 胯 */
dict[0x280f0] = "yǎn"; /* 胰 */
dict[0x280f2] = "jié"; /* 胲 */
dict[0x280f3] = "néng"; /* 胳 */
dict[0x28105] = "qū"; /* 脅 */
dict[0x28107] = "dèng,téng"; /* 脇 */
dict[0x28108] = "liáng"; /* 脈 */
dict[0x28109] = "chǎn"; /* 脉 */
dict[0x2810a] = "qiè"; /* 脊 */
dict[0x2810b] = "lòu"; /* 脋 */
dict[0x2810c] = "dié,xiè"; /* 脌 */
dict[0x2810d] = "cuī"; /* 脍 */
dict[0x28110] = "jǐ"; /* 脐 */
dict[0x28113] = "cháo"; /* 脓 */
dict[0x28114] = "shuàn"; /* 脔 */
dict[0x28115] = "zú"; /* 脕 */
dict[0x28117] = "kāng"; /* 脗 */
dict[0x2811a] = "qiāng"; /* 脚 */
dict[0x2811b] = "lí"; /* 脛 */
dict[0x2812e] = "shuāi"; /* 脮 */
dict[0x2812f] = "yù"; /* 脯 */
dict[0x28130] = "zhāng"; /* 脰 */
dict[0x28131] = "lěi"; /* 脱 */
dict[0x28145] = "pó"; /* 腅 */
dict[0x2814a] = "zhé,chè"; /* 腊 */
dict[0x2814b] = "xiào"; /* 腋 */
dict[0x2814d] = "tǎn"; /* 腍 */
dict[0x2814e] = "cuì"; /* 腎 */
dict[0x2814f] = "lán"; /* 腏 */
dict[0x28151] = "xū"; /* 腑 */
dict[0x28152] = "shù,chú"; /* 腒 */
dict[0x28153] = "zhǎ,dá"; /* 腓 */
dict[0x28154] = "cán"; /* 腔 */
dict[0x28157] = "bǐ"; /* 腗 */
dict[0x28158] = "pèng"; /* 腘 */
dict[0x2815d] = "chéng"; /* 腝 */
dict[0x28163] = "qiáo"; /* 腣 */
dict[0x28164] = "jī"; /* 腤 */
dict[0x2816a] = "zhāi"; /* 腪 */
dict[0x2816d] = "tán"; /* 腭 */
dict[0x28181] = "tiǎn,yǎn"; /* 膁 */
dict[0x28182] = "sà"; /* 膂 */
dict[0x28183] = "jīn"; /* 膃 */
dict[0x28184] = "zhù"; /* 膄 */
dict[0x28185] = "duò"; /* 膅 */
dict[0x28187] = "chà"; /* 膇 */
dict[0x28188] = "juàn"; /* 膈 */
dict[0x28189] = "táng"; /* 膉 */
dict[0x2818a] = "bèng"; /* 膊 */
dict[0x2818b] = "zhī"; /* 膋 */
dict[0x2818c] = "fán"; /* 膌 */
dict[0x2818d] = "liè"; /* 膍 */
dict[0x2818e] = "zéi"; /* 膎 */
dict[0x2818f] = "suì"; /* 膏 */
dict[0x28193] = "qín"; /* 膓 */
dict[0x28199] = "sè"; /* 膙 */
dict[0x281a7] = "zhì"; /* 膧 */
dict[0x281a8] = "tuí"; /* 膨 */
dict[0x281aa] = "qīng"; /* 膪 */
dict[0x281ac] = "chuò"; /* 膬 */
dict[0x281b0] = "tà,dà"; /* 膰 */
dict[0x281b1] = "bìng"; /* 膱 */
dict[0x281b2] = "wěn"; /* 膲 */
dict[0x281b5] = "pǒ"; /* 膵 */
dict[0x281bd] = "mó"; /* 膽 */
dict[0x281be] = "cā"; /* 膾 */
dict[0x281c1] = "kuàng"; /* 臁 */
dict[0x281c3] = "cuó,zuān"; /* 臃 */
dict[0x281c4] = "rǎo"; /* 臄 */
dict[0x281c5] = "bào"; /* 臅 */
dict[0x281c6] = "lài"; /* 臆 */
dict[0x281cd] = "niǎn"; /* 臍 */
dict[0x281ce] = "lí"; /* 臎 */
dict[0x281d5] = "jiǎo"; /* 臕 */
dict[0x281d6] = "lú"; /* 臖 */
dict[0x281d7] = "lì"; /* 臗 */
dict[0x281d8] = "lóng"; /* 臘 */
dict[0x281d9] = "guì"; /* 臙 */
dict[0x281dd] = "chǎn"; /* 臝 */
dict[0x281e4] = "xiān"; /* 臤 */
dict[0x281e6] = "chàn"; /* 臦 */
dict[0x281e8] = "xiè"; /* 臨 */
dict[0x281e9] = "zhàn"; /* 臩 */
dict[0x281ef] = "shuāng"; /* 臯 */
dict[0x281fb] = "mǐ"; /* 臻 */
dict[0x281fc] = "luán"; /* 臼 */
dict[0x281fd] = "luò"; /* 臽 */
dict[0x28200] = "diān"; /* 舀 */
dict[0x28206] = "lán"; /* 舆 */
dict[0x28207] = "làn"; /* 與 */
dict[0x28208] = "dié"; /* 興 */
dict[0x2820a] = "wān"; /* 舊 */
dict[0x2820b] = "yuè"; /* 舋 */
dict[0x2820c] = "luán"; /* 舌 */
dict[0x2820e] = "luán"; /* 舎 */
dict[0x28213] = "léng"; /* 舓 */
dict[0x28215] = "wǎi"; /* 舕 */
dict[0x28217] = "nèn"; /* 舗 */
dict[0x28218] = "shǎo"; /* 舘 */
dict[0x28219] = "xiè,zhī"; /* 舙 */
dict[0x2821a] = "pí"; /* 舚 */
dict[0x28225] = "máo"; /* 舥 */
dict[0x28227] = "yǐn"; /* 舧 */
dict[0x28229] = "bó"; /* 舩 */
dict[0x2822b] = "zhù"; /* 舫 */
dict[0x2822e] = "chōng"; /* 舮 */
dict[0x28236] = "mǔ"; /* 舶 */
dict[0x28237] = "tuó"; /* 舷 */
dict[0x28239] = "tǒng"; /* 船 */
dict[0x2823a] = "yé"; /* 舺 */
dict[0x28241] = "huàng"; /* 艁 */
dict[0x28243] = "rèn"; /* 艃 */
dict[0x28245] = "yè"; /* 艅 */
dict[0x2824b] = "tuó"; /* 艋 */
dict[0x28256] = "zuān"; /* 艖 */
dict[0x2825a] = "ā"; /* 艚 */
dict[0x2825c] = "zhōu"; /* 艜 */
dict[0x2825d] = "wān"; /* 艝 */
dict[0x28261] = "duǒ"; /* 艡 */
dict[0x28262] = "zhòng"; /* 艢 */
dict[0x28263] = "hā"; /* 艣 */
dict[0x28264] = "huáng"; /* 艤 */
dict[0x28265] = "miàn,tǐ"; /* 艥 */
dict[0x28269] = "chūn"; /* 艩 */
dict[0x2826a] = "qiè"; /* 艪 */
dict[0x2826b] = "gōng,qiōng"; /* 艫 */
dict[0x2826c] = "tíng"; /* 艬 */
dict[0x2826d] = "méi"; /* 艭 */
dict[0x28271] = "tàng"; /* 艱 */
dict[0x28274] = "róng"; /* 艴 */
dict[0x28277] = "róng"; /* 艷 */
dict[0x28278] = "qí"; /* 艸 */
dict[0x28279] = "guó"; /* 艹 */
dict[0x2827d] = "xiàng"; /* 艽 */
dict[0x2827e] = "tián"; /* 艾 */
dict[0x28285] = "xiāo"; /* 芅 */
dict[0x28288] = "zhān"; /* 芈 */
dict[0x28289] = "cuì"; /* 芉 */
dict[0x28294] = "lán"; /* 芔 */
dict[0x28298] = "shēn,qū"; /* 芘 */
dict[0x2829a] = "lěi"; /* 芚 */
dict[0x2829b] = "lì"; /* 芛 */
dict[0x2829d] = "chān"; /* 芝 */
dict[0x2829e] = "niè"; /* 芞 */
dict[0x2829f] = "luán"; /* 芟 */
dict[0x282a1] = "tīng"; /* 芡 */
dict[0x282a2] = "huì,sháo"; /* 芢 */
dict[0x282a7] = "gōng"; /* 芧 */
dict[0x282b0] = "qì"; /* 芰 */
dict[0x282b1] = "yú"; /* 花 */
dict[0x282b3] = "xīn"; /* 芳 */
dict[0x282b8] = "yuè"; /* 芸 */
dict[0x282b9] = "bā"; /* 芹 */
dict[0x282ba] = "dài"; /* 芺 */
dict[0x282bb] = "jī"; /* 芻 */
dict[0x282bc] = "xuàn"; /* 芼 */
dict[0x282bf] = "jué"; /* 芿 */
dict[0x282c0] = "niǔ"; /* 苀 */
dict[0x282c8] = "dù"; /* 苈 */
dict[0x282c9] = "jí"; /* 苉 */
dict[0x282d0] = "pā"; /* 苐 */
dict[0x282d1] = "gǒng"; /* 苑 */
dict[0x282d2] = "bèn"; /* 苒 */
dict[0x282d4] = "kēng,jú"; /* 苔 */
dict[0x282d5] = "yàng,ǎng"; /* 苕 */
dict[0x282d6] = "liǔ"; /* 苖 */
dict[0x282d7] = "ní"; /* 苗 */
dict[0x282d8] = "zhà"; /* 苘 */
dict[0x282d9] = "yìn"; /* 苙 */
dict[0x282da] = "niǎn,ruǎn"; /* 苚 */
dict[0x282db] = "pào"; /* 苛 */
dict[0x282dd] = "gōng"; /* 苝 */
dict[0x282de] = "bù"; /* 苞 */
dict[0x282df] = "hé"; /* 苟 */
dict[0x282e0] = "rǒng"; /* 苠 */
dict[0x282e1] = "guì"; /* 苡 */
dict[0x282e5] = "bì"; /* 若 */
dict[0x282e6] = "xī"; /* 苦 */
dict[0x282e7] = "jú"; /* 苧 */
dict[0x282e8] = "hún"; /* 苨 */
dict[0x282e9] = "bì,fú"; /* 苩 */
dict[0x282eb] = "tiāo"; /* 苫 */
dict[0x282ec] = "zhěng,chèng"; /* 苬 */
dict[0x282ef] = "yì"; /* 苯 */
dict[0x282f0] = "cì"; /* 苰 */
dict[0x282f2] = "bìng"; /* 苲 */
dict[0x282f7] = "gōng"; /* 苷 */
dict[0x282fa] = "fá"; /* 苺 */
dict[0x282fd] = "yáng"; /* 苽 */
dict[0x282fe] = "xǔ"; /* 苾 */
dict[0x28301] = "hōng,chūn"; /* 茁 */
dict[0x28304] = "zàng"; /* 茄 */
dict[0x28305] = "chái"; /* 茅 */
dict[0x28306] = "hóng"; /* 茆 */
dict[0x28308] = "tián"; /* 茈 */
dict[0x2830c] = "zhī"; /* 茌 */
dict[0x2830d] = "xīng"; /* 茍 */
dict[0x2830e] = "xú"; /* 茎 */
dict[0x28311] = "zhèn"; /* 茑 */
dict[0x28314] = "wǎn,wàn"; /* 茔 */
dict[0x28318] = "jùn"; /* 茘 */
dict[0x2831d] = "wò,huò"; /* 茝 */
dict[0x28320] = "lù"; /* 茠 */
dict[0x28322] = "zhēng"; /* 茢 */
dict[0x28323] = "rǒng"; /* 茣 */
dict[0x28324] = "chéng,chèng"; /* 茤 */
dict[0x28325] = "fú"; /* 茥 */
dict[0x28327] = "è"; /* 茧 */
dict[0x28328] = "tāo"; /* 茨 */
dict[0x28329] = "táng"; /* 茩 */
dict[0x2832b] = "juān"; /* 茫 */
dict[0x2832c] = "chào"; /* 茬 */
dict[0x2832d] = "tà"; /* 茭 */
dict[0x2832e] = "dǐ"; /* 茮 */
dict[0x28330] = "zōng"; /* 茰 */
dict[0x28332] = "mǐn"; /* 茲 */
dict[0x28333] = "kēng"; /* 茳 */
dict[0x28334] = "tuī"; /* 茴 */
dict[0x28336] = "kēng"; /* 茶 */
dict[0x28345] = "rǒng"; /* 荅 */
dict[0x28346] = "yūn"; /* 荆 */
dict[0x28347] = "hé"; /* 荇 */
dict[0x28348] = "zǒng"; /* 荈 */
dict[0x28349] = "cōng,zǒng"; /* 草 */
dict[0x2834a] = "qiū"; /* 荊 */
dict[0x2834e] = "mù"; /* 荎 */
dict[0x2834f] = "duó"; /* 荏 */
dict[0x28350] = "xǔ"; /* 荐 */
dict[0x28351] = "kēng"; /* 荑 */
dict[0x28352] = "xiàn,jiàn"; /* 荒 */
dict[0x2835b] = "dú"; /* 荛 */
dict[0x2835c] = "kǎn"; /* 荜 */
dict[0x2835e] = "yīng"; /* 荞 */
dict[0x28362] = "zī"; /* 荢 */
dict[0x28367] = "huáng"; /* 荧 */
dict[0x28369] = "péng"; /* 荩 */
dict[0x2836b] = "lì"; /* 荫 */
dict[0x2836d] = "bó,pò"; /* 荭 */
dict[0x2836e] = "gé,lì"; /* 荮 */
dict[0x2836f] = "jú"; /* 药 */
dict[0x28370] = "kē"; /* 荰 */
dict[0x28372] = "hú,gǔn"; /* 荲 */
dict[0x28373] = "diāo,yáo"; /* 荳 */
dict[0x28374] = "táng"; /* 荴 */
dict[0x28376] = "qióng"; /* 荶 */
dict[0x28377] = "rǒng"; /* 荷 */
dict[0x28378] = "liǔ"; /* 荸 */
dict[0x28379] = "huì"; /* 荹 */
dict[0x2837a] = "jī"; /* 荺 */
dict[0x2837d] = "gǔn"; /* 荽 */
dict[0x28389] = "zhì"; /* 莉 */
dict[0x2838b] = "táng,chēng"; /* 莋 */
dict[0x2838c] = "zhǐ"; /* 莌 */
dict[0x2838d] = "kāng,liáng"; /* 莍 */
dict[0x28394] = "yàng"; /* 莔 */
dict[0x28396] = "tǎng,chǎng"; /* 莖 */
dict[0x28397] = "hōng"; /* 莗 */
dict[0x2839b] = "liáng"; /* 莛 */
dict[0x2839d] = "cáo"; /* 莝 */
dict[0x283a1] = "nǎi"; /* 莡 */
dict[0x283a2] = "zǒng"; /* 莢 */
dict[0x283a4] = "dèng"; /* 莤 */
dict[0x283a6] = "jiāo"; /* 莦 */
dict[0x283a7] = "péng"; /* 莧 */
dict[0x283a9] = "guāng"; /* 莩 */
dict[0x283ab] = "jiàn"; /* 莫 */
dict[0x283ac] = "jiào"; /* 莬 */
dict[0x283ad] = "nuó"; /* 莭 */
dict[0x283ae] = "zǎo"; /* 莮 */
dict[0x283b3] = "péng"; /* 莳 */
dict[0x283b4] = "dāng"; /* 莴 */
dict[0x283b6] = "qú"; /* 莶 */
dict[0x283b7] = "lián"; /* 获 */
dict[0x283b8] = "mù"; /* 莸 */
dict[0x283b9] = "lǎn"; /* 莹 */
dict[0x283be] = "fén"; /* 莾 */
dict[0x283c2] = "hún,xuān"; /* 菂 */
dict[0x283c6] = "kuāng"; /* 菆 */
dict[0x283c8] = "yǐn"; /* 菈 */
dict[0x283c9] = "shuàn"; /* 菉 */
dict[0x283ca] = "jiàn"; /* 菊 */
dict[0x283d2] = "luò,léi"; /* 菒 */
dict[0x283d4] = "lù,dú"; /* 菔 */
dict[0x283da] = "gé"; /* 菚 */
dict[0x283db] = "rǎng,niǎn"; /* 菛 */
dict[0x283de] = "pín"; /* 菞 */
dict[0x283e0] = "lóng"; /* 菠 */
dict[0x283e4] = "zhěn"; /* 菤 */
dict[0x283e5] = "xiàn"; /* 菥 */
dict[0x283e8] = "lìn"; /* 菨 */
dict[0x283e9] = "lián"; /* 菩 */
dict[0x283ea] = "shān"; /* 菪 */
dict[0x283eb] = "bó"; /* 菫 */
dict[0x283ec] = "lì"; /* 菬 */
dict[0x283f3] = "xié"; /* 菳 */
dict[0x283f4] = "gé"; /* 菴 */
dict[0x283f5] = "mǐn"; /* 菵 */
dict[0x283f6] = "lián"; /* 菶 */
dict[0x283f9] = "jué"; /* 菹 */
dict[0x283fa] = "zhōu"; /* 菺 */
dict[0x283ff] = "kē"; /* 菿 */
dict[0x28401] = "dié"; /* 萁 */
dict[0x28403] = "zhé"; /* 萃 */
dict[0x28406] = "jī"; /* 萆 */
dict[0x2840b] = "qiān"; /* 萋 */
dict[0x2840d] = "shēn"; /* 萍 */
dict[0x28410] = "yǐn"; /* 萐 */
dict[0x28411] = "jiè"; /* 萑 */
dict[0x28414] = "shēn"; /* 萔 */
dict[0x28415] = "shēn,cí"; /* 萕 */
dict[0x28416] = "sǎ"; /* 萖 */
dict[0x2841b] = "xì"; /* 萛 */
dict[0x28421] = "kù"; /* 萡 */
dict[0x28423] = "qú"; /* 萣 */
dict[0x28425] = "gé"; /* 营 */
dict[0x28426] = "bàn"; /* 萦 */
dict[0x28428] = "bì"; /* 萨 */
dict[0x28429] = "qiān"; /* 萩 */
dict[0x28430] = "bīn"; /* 萰 */
dict[0x28431] = "bàn"; /* 萱 */
dict[0x28433] = "zuò"; /* 萳 */
dict[0x28434] = "pì"; /* 萴 */
dict[0x28436] = "huò"; /* 萶 */
dict[0x2843e] = "bàn,biàn"; /* 萾 */
dict[0x2844a] = "nóng"; /* 葊 */
dict[0x2844c] = "chén"; /* 葌 */
dict[0x2844e] = "pēng"; /* 葎 */
dict[0x28451] = "fǔ"; /* 葑 */
dict[0x28452] = "tú"; /* 葒 */
dict[0x2845c] = "pǐ"; /* 葜 */
dict[0x2845d] = "pò"; /* 葝 */
dict[0x28460] = "chǐ"; /* 葠 */
dict[0x28463] = "xuè"; /* 董 */
dict[0x28464] = "qì"; /* 葤 */
dict[0x28465] = "wù"; /* 葥 */
dict[0x28468] = "zhì"; /* 葨 */
dict[0x28469] = "dì"; /* 葩 */
dict[0x2846a] = "cōng"; /* 葪 */
dict[0x2846b] = "yóu"; /* 葫 */
dict[0x2846d] = "xǐ"; /* 葭 */
dict[0x28478] = "ěr"; /* 葸 */
dict[0x2847c] = "dì"; /* 葼 */
dict[0x2847d] = "zhuó"; /* 葽 */
dict[0x2847f] = "zǒu"; /* 葿 */
dict[0x28480] = "cóng"; /* 蒀 */
dict[0x28483] = "pàn"; /* 蒃 */
dict[0x28484] = "yǎn"; /* 蒄 */
dict[0x28485] = "qì"; /* 蒅 */
dict[0x28486] = "rǒng"; /* 蒆 */
dict[0x28487] = "jiǎ"; /* 蒇 */
dict[0x28488] = "chí"; /* 蒈 */
dict[0x28489] = "zhì,zhuì,suì"; /* 蒉 */
dict[0x2848a] = "qiú"; /* 蒊 */
dict[0x2848b] = "yuè"; /* 蒋 */
dict[0x2848c] = "zhēng"; /* 蒌 */
dict[0x2848d] = "shì"; /* 蒍 */
dict[0x28491] = "háo"; /* 蒑 */
dict[0x28499] = "tuō,hòu"; /* 蒙 */
dict[0x2849c] = "bié"; /* 蒜 */
dict[0x2849e] = "kàn"; /* 蒞 */
dict[0x284a2] = "chuò"; /* 蒢 */
dict[0x284a4] = "cǐ"; /* 蒤 */
dict[0x284a5] = "hòu"; /* 蒥 */
dict[0x284a6] = "yǐn"; /* 蒦 */
dict[0x284a7] = "shì"; /* 蒧 */
dict[0x284a8] = "nài"; /* 蒨 */
dict[0x284a9] = "ruǎn"; /* 蒩 */
dict[0x284ab] = "yáng,nì"; /* 蒫 */
dict[0x284ac] = "chī"; /* 蒬 */
dict[0x284ae] = "cī"; /* 蒮 */
dict[0x284b1] = "gōng"; /* 蒱 */
dict[0x284b2] = "mí,xuè"; /* 蒲 */
dict[0x284b4] = "jǐ"; /* 蒴 */
dict[0x284bc] = "gèn"; /* 蒼 */
dict[0x284bd] = "zào,suō"; /* 蒽 */
dict[0x284c1] = "běng"; /* 蓁 */
dict[0x284c7] = "xǐn"; /* 蓇 */
dict[0x284c8] = "kuò"; /* 蓈 */
dict[0x284ca] = "dié"; /* 蓊 */
dict[0x284cd] = "tíng"; /* 蓍 */
dict[0x284da] = "shuì"; /* 蓚 */
dict[0x284de] = "dài"; /* 蓞 */
dict[0x284e0] = "dì"; /* 蓠 */
dict[0x284e6] = "lǐ"; /* 蓦 */
dict[0x284e8] = "yǒng"; /* 蓨 */
dict[0x284e9] = "jiāo"; /* 蓩 */
dict[0x284ec] = "tá"; /* 蓬 */
dict[0x284ed] = "qǔ,còu"; /* 蓭 */
dict[0x284ee] = "yín"; /* 蓮 */
dict[0x284ef] = "yuān"; /* 蓯 */
dict[0x284f0] = "jié"; /* 蓰 */
dict[0x284f2] = "qiān"; /* 蓲 */
dict[0x284f3] = "yāo"; /* 蓳 */
dict[0x284f4] = "yà"; /* 蓴 */
dict[0x284f7] = "qīng"; /* 蓷 */
dict[0x284ff] = "péi"; /* 蓿 */
dict[0x28517] = "jiā"; /* 蔗 */
dict[0x28519] = "tòu"; /* 蔙 */
dict[0x2851b] = "tī"; /* 蔛 */
dict[0x28521] = "dùn,tún,chuàn,chuán"; /* 蔡 */
dict[0x28522] = "chǎn"; /* 蔢 */
dict[0x28523] = "jiā,jià"; /* 蔣 */
dict[0x28524] = "chì"; /* 蔤 */
dict[0x28525] = "jiān,jīn"; /* 蔥 */
dict[0x28526] = "shù"; /* 蔦 */
dict[0x2852f] = "tà"; /* 蔯 */
dict[0x28535] = "dùn"; /* 蔵 */
dict[0x28555] = "zhī"; /* 蕕 */
dict[0x28557] = "yuán"; /* 蕗 */
dict[0x2855a] = "hū"; /* 蕚 */
dict[0x2855c] = "liè"; /* 蕜 */
dict[0x28560] = "zé"; /* 蕠 */
dict[0x28562] = "chù"; /* 蕢 */
dict[0x28566] = "qiù"; /* 蕦 */
dict[0x28567] = "bēng"; /* 蕧 */
dict[0x28579] = "huán"; /* 蕹 */
dict[0x2857a] = "kuā"; /* 蕺 */
dict[0x2857b] = "shēng"; /* 蕻 */
dict[0x2857d] = "jié"; /* 蕽 */
dict[0x2857f] = "wǎng"; /* 蕿 */
dict[0x28583] = "hū"; /* 薃 */
dict[0x2858a] = "zé,jī"; /* 薊 */
dict[0x2858b] = "zǎn,zhì"; /* 薋 */
dict[0x2858c] = "yàng"; /* 薌 */
dict[0x2858e] = "chǐ"; /* 薎 */
dict[0x2858f] = "jiù"; /* 薏 */
dict[0x2859a] = "liáo"; /* 薚 */
dict[0x2859b] = "yū"; /* 薛 */
dict[0x285a0] = "biǎn,biàn"; /* 薠 */
dict[0x285a2] = "kuáng"; /* 薢 */
dict[0x285ac] = "chòu"; /* 薬 */
dict[0x285ad] = "yá"; /* 薭 */
dict[0x285ae] = "zhuó"; /* 薮 */
dict[0x285b0] = "qiè"; /* 薰 */
dict[0x285b1] = "xiàn"; /* 薱 */
dict[0x285b3] = "yuān"; /* 薳 */
dict[0x285b4] = "wǔ"; /* 薴 */
dict[0x285b5] = "jiǎo"; /* 薵 */
dict[0x285b6] = "xiàng"; /* 薶 */
dict[0x285b7] = "shà"; /* 薷 */
dict[0x285b9] = "zhì"; /* 薹 */
dict[0x285bc] = "chòng"; /* 薼 */
dict[0x285be] = "biān"; /* 薾 */
dict[0x285bf] = "wēi"; /* 薿 */
dict[0x285d3] = "dào"; /* 藓 */
dict[0x285dd] = "yù,jú"; /* 藝 */
dict[0x285de] = "tuí"; /* 藞 */
dict[0x285e1] = "chào"; /* 藡 */
dict[0x285e5] = "huì"; /* 藥 */
dict[0x285e6] = "qiǎn"; /* 藦 */
dict[0x285e8] = "wěi"; /* 藨 */
dict[0x285f0] = "yóu"; /* 藰 */
dict[0x285fc] = "dì,dài"; /* 藼 */
dict[0x285fe] = "dà"; /* 藾 */
dict[0x28601] = "yóu"; /* 蘁 */
dict[0x28602] = "jiù"; /* 蘂 */
dict[0x28603] = "tuí"; /* 蘃 */
dict[0x28604] = "zǎn"; /* 蘄 */
dict[0x28607] = "huì"; /* 蘇 */
dict[0x28609] = "shà"; /* 蘉 */
dict[0x2860c] = "huò"; /* 蘌 */
dict[0x28614] = "yáo"; /* 蘔 */
dict[0x28615] = "yǔ"; /* 蘕 */
dict[0x28619] = "xiàn"; /* 蘙 */
dict[0x2861e] = "xiàn"; /* 蘞 */
dict[0x28622] = "biān"; /* 蘢 */
dict[0x2862c] = "dì"; /* 蘬 */
dict[0x2862e] = "jiù"; /* 蘮 */
dict[0x28632] = "huì"; /* 蘲 */
dict[0x28634] = "kào"; /* 蘴 */
dict[0x28635] = "yóu"; /* 蘵 */
dict[0x28637] = "miǎo"; /* 蘷 */
dict[0x28638] = "lì"; /* 蘸 */
dict[0x2863c] = "chuán"; /* 蘼 */
dict[0x2863e] = "chí"; /* 蘾 */
dict[0x28640] = "huò"; /* 虀 */
dict[0x28642] = "yóu"; /* 虂 */
dict[0x28644] = "yuè"; /* 虄 */
dict[0x2864e] = "tà"; /* 虎 */
dict[0x2864f] = "zàn"; /* 虏 */
dict[0x28653] = "niè"; /* 虓 */
dict[0x28654] = "zhù"; /* 虔 */
dict[0x28661] = "xiǎn"; /* 虡 */
dict[0x28668] = "yì"; /* 虨 */
dict[0x28669] = "shí"; /* 虩 */
dict[0x2866b] = "kǒu"; /* 虫 */
dict[0x2866c] = "qǐ"; /* 虬 */
dict[0x2866d] = "tǔ"; /* 虭 */
dict[0x2866e] = "fán"; /* 虮 */
dict[0x2866f] = "cūn"; /* 虯 */
dict[0x28672] = "tún,cūn"; /* 虲 */
dict[0x28673] = "chā"; /* 虳 */
dict[0x28674] = "cái,zài"; /* 虴 */
dict[0x28675] = "xiàng"; /* 虵 */
dict[0x28676] = "pèi"; /* 虶 */
dict[0x28677] = "jǐng"; /* 虷 */
dict[0x28678] = "qí,zhī"; /* 虸 */
dict[0x28679] = "shǎo"; /* 虹 */
dict[0x2867a] = "niǔ"; /* 虺 */
dict[0x2867b] = "nuó"; /* 虻 */
dict[0x2867d] = "qín"; /* 虽 */
dict[0x2868d] = "bì,bèi"; /* 蚍 */
dict[0x28693] = "bì,fèi,fú"; /* 蚓 */
dict[0x28694] = "bāo"; /* 蚔 */
dict[0x28695] = "biàn"; /* 蚕 */
dict[0x28696] = "zī"; /* 蚖 */
dict[0x28698] = "wèi"; /* 蚘 */
dict[0x28699] = "háo"; /* 蚙 */
dict[0x286a1] = "jǐn"; /* 蚡 */
dict[0x286a3] = "zhèng"; /* 蚣 */
dict[0x286a7] = "qié"; /* 蚧 */
dict[0x286ae] = "hào"; /* 蚮 */
dict[0x286af] = "tóng"; /* 蚯 */
dict[0x286b0] = "zǎo"; /* 蚰 */
dict[0x286b1] = "shèng"; /* 蚱 */
dict[0x286b2] = "cún"; /* 蚲 */
dict[0x286b3] = "huāng"; /* 蚳 */
dict[0x286b4] = "rú"; /* 蚴 */
dict[0x286b5] = "zài"; /* 蚵 */
dict[0x286b6] = "nián"; /* 蚶 */
dict[0x286be] = "xiān"; /* 蚾 */
dict[0x286c8] = "quán"; /* 蛈 */
dict[0x286c9] = "jì"; /* 蛉 */
dict[0x286ca] = "yín"; /* 蛊 */
dict[0x286cb] = "lǐ"; /* 蛋 */
dict[0x286cc] = "máng"; /* 蛌 */
dict[0x286cd] = "shào"; /* 蛍 */
dict[0x286ce] = "hàn"; /* 蛎 */
dict[0x286cf] = "cuò"; /* 蛏 */
dict[0x286d0] = "jùn"; /* 蛐 */
dict[0x286d1] = "jì"; /* 蛑 */
dict[0x286d2] = "bù"; /* 蛒 */
dict[0x286d3] = "lòng"; /* 蛓 */
dict[0x286d4] = "fǒu"; /* 蛔 */
dict[0x286d5] = "yóu"; /* 蛕 */
dict[0x286d6] = "kuài"; /* 蛖 */
dict[0x286dc] = "xiàng"; /* 蛜 */
dict[0x286e1] = "yún"; /* 蛡 */
dict[0x286e3] = "qín"; /* 蛣 */
dict[0x286e4] = "huí"; /* 蛤 */
dict[0x286e5] = "pú"; /* 蛥 */
dict[0x286eb] = "lí"; /* 蛫 */
dict[0x286ec] = "péi"; /* 蛬 */
dict[0x286ed] = "shū,shè"; /* 蛭 */
dict[0x286ee] = "jū"; /* 蛮 */
dict[0x286ef] = "yí"; /* 蛯 */
dict[0x286f0] = "zhēng"; /* 蛰 */
dict[0x286f1] = "chóng"; /* 蛱 */
dict[0x286f2] = "nián"; /* 蛲 */
dict[0x286f3] = "xí,jí"; /* 蛳 */
dict[0x286f5] = "hǔ"; /* 蛵 */
dict[0x286f6] = "róu,shòu"; /* 蛶 */
dict[0x28702] = "dǎng"; /* 蜂 */
dict[0x2870c] = "huàn"; /* 蜌 */
dict[0x2870d] = "qiào"; /* 蜍 */
dict[0x2870e] = "zhī"; /* 蜎 */
dict[0x2870f] = "yíng"; /* 蜏 */
dict[0x28710] = "xǐ"; /* 蜐 */
dict[0x28711] = "qiāo"; /* 蜑 */
dict[0x28712] = "jì"; /* 蜒 */
dict[0x28713] = "zhēng"; /* 蜓 */
dict[0x28714] = "huáng"; /* 蜔 */
dict[0x28716] = "yú"; /* 蜖 */
dict[0x28717] = "zōu"; /* 蜗 */
dict[0x28718] = "méi"; /* 蜘 */
dict[0x2871b] = "sōu"; /* 蜛 */
dict[0x2871c] = "shěng"; /* 蜜 */
dict[0x28729] = "quán"; /* 蜩 */
dict[0x2872b] = "hòu"; /* 蜫 */
dict[0x28730] = "jiāng"; /* 蜰 */
dict[0x28731] = "hé"; /* 蜱 */
dict[0x28733] = "tóng"; /* 蜳 */
dict[0x28734] = "hé"; /* 蜴 */
dict[0x28735] = "wēn"; /* 蜵 */
dict[0x28736] = "yì"; /* 蜶 */
dict[0x28737] = "páng"; /* 蜷 */
dict[0x2873a] = "wēng"; /* 蜺 */
dict[0x2873b] = "qián"; /* 蜻 */
dict[0x2873c] = "lì"; /* 蜼 */
dict[0x2873d] = "yí"; /* 蜽 */
dict[0x2873e] = "chuàng"; /* 蜾 */
dict[0x2873f] = "xù"; /* 蜿 */
dict[0x28740] = "wěi"; /* 蝀 */
dict[0x28746] = "gē"; /* 蝆 */
dict[0x28748] = "yǔ"; /* 蝈 */
dict[0x2874b] = "zhài"; /* 蝋 */
dict[0x2874c] = "gān"; /* 蝌 */
dict[0x2874d] = "qiān"; /* 蝍 */
dict[0x2874e] = "kāng"; /* 蝎 */
dict[0x2874f] = "lí"; /* 蝏 */
dict[0x28750] = "shēn"; /* 蝐 */
dict[0x28751] = "guàn"; /* 蝑 */
dict[0x28753] = "piáo"; /* 蝓 */
dict[0x28756] = "lí"; /* 蝖 */
dict[0x28758] = "hǔ"; /* 蝘 */
dict[0x2875b] = "tú"; /* 蝛 */
dict[0x2875c] = "shùn"; /* 蝜 */
dict[0x2875e] = "hù"; /* 蝞 */
dict[0x2875f] = "lí"; /* 蝟 */
dict[0x28762] = "lòu"; /* 蝢 */
dict[0x28766] = "dàng"; /* 蝦 */
dict[0x28768] = "zuò"; /* 蝨 */
dict[0x28769] = "shān"; /* 蝩 */
dict[0x2876b] = "shè,xì"; /* 蝫 */
dict[0x2876d] = "féng"; /* 蝭 */
dict[0x2876e] = "jù,zōu"; /* 蝮 */
dict[0x2876f] = "tóng"; /* 蝯 */
dict[0x28770] = "jiǎo"; /* 蝰 */
dict[0x28771] = "qiáo"; /* 蝱 */
dict[0x28772] = "gāo,hào"; /* 蝲 */
dict[0x28773] = "zī"; /* 蝳 */
dict[0x28774] = "huáng"; /* 蝴 */
dict[0x28775] = "shān"; /* 蝵 */
dict[0x28778] = "tán"; /* 蝸 */
dict[0x2878c] = "tuō"; /* 螌 */
dict[0x2878e] = "lìng"; /* 螎 */
dict[0x28790] = "chéng"; /* 螐 */
dict[0x28791] = "wèng"; /* 螑 */
dict[0x28792] = "zuó"; /* 螒 */
dict[0x28793] = "yù"; /* 螓 */
dict[0x28795] = "zhú,chù"; /* 螕 */
dict[0x28797] = "qún"; /* 螗 */
dict[0x28798] = "xǐ"; /* 螘 */
dict[0x28799] = "qú"; /* 螙 */
dict[0x2879b] = "gé"; /* 螛 */
dict[0x287a0] = "xiàng"; /* 螠 */
dict[0x287a2] = "qī"; /* 螢 */
dict[0x287a3] = "xū"; /* 螣 */
dict[0x287a8] = "gài"; /* 螨 */
dict[0x287a9] = "què"; /* 螩 */
dict[0x287aa] = "chóu,shòu"; /* 螪 */
dict[0x287ab] = "méng"; /* 螫 */
dict[0x287b0] = "xiāng"; /* 螰 */
dict[0x287b2] = "shēn"; /* 螲 */
dict[0x287b3] = "qú"; /* 螳 */
dict[0x287b6] = "qiāo"; /* 螶 */
dict[0x287b7] = "cán"; /* 螷 */
dict[0x287ba] = "lì"; /* 螺 */
dict[0x287bb] = "fū"; /* 螻 */
dict[0x287bc] = "wàn"; /* 螼 */
dict[0x287bd] = "léi"; /* 螽 */
dict[0x287be] = "xīng"; /* 螾 */
dict[0x287bf] = "láng"; /* 螿 */
dict[0x287c2] = "shì"; /* 蟂 */
dict[0x287c3] = "zhēng"; /* 蟃 */
dict[0x287c4] = "fán"; /* 蟄 */
dict[0x287ca] = "zhì"; /* 蟊 */
dict[0x287cf] = "yín"; /* 蟏 */
dict[0x287d0] = "táng"; /* 蟐 */
dict[0x287d1] = "lì"; /* 蟑 */
dict[0x287d6] = "mó"; /* 蟖 */
dict[0x287d7] = "wěi"; /* 蟗 */
dict[0x287d9] = "yīng"; /* 蟙 */
dict[0x287da] = "ráng"; /* 蟚 */
dict[0x287e0] = "què,jué,quān"; /* 蟠 */
dict[0x287e5] = "luǒ"; /* 蟥 */
dict[0x287e6] = "qiān"; /* 蟦 */
dict[0x287f2] = "dài"; /* 蟲 */
dict[0x287f4] = "yìn"; /* 蟴 */
dict[0x287f5] = "bǐ"; /* 蟵 */
dict[0x287f6] = "gē"; /* 蟶 */
dict[0x287f8] = "wèn"; /* 蟸 */
dict[0x287f9] = "yǎn"; /* 蟹 */
dict[0x287fa] = "miǎn"; /* 蟺 */
dict[0x287fc] = "gǎng"; /* 蟼 */
dict[0x287fd] = "qiú"; /* 蟽 */
dict[0x287fe] = "zhī"; /* 蟾 */
dict[0x2880b] = "gū"; /* 蠋 */
dict[0x2880c] = "tóng"; /* 蠌 */
dict[0x2880e] = "líng"; /* 蠎 */
dict[0x2880f] = "tí"; /* 蠏 */
dict[0x28810] = "cí"; /* 蠐 */
dict[0x28811] = "yí,tuó"; /* 蠑 */
dict[0x28812] = "fàn"; /* 蠒 */
dict[0x28813] = "pō"; /* 蠓 */
dict[0x28814] = "bì"; /* 蠔 */
dict[0x28816] = "bào"; /* 蠖 */
dict[0x2881f] = "pēng"; /* 蠟 */
dict[0x28821] = "suān"; /* 蠡 */
dict[0x28824] = "sōng,nóng"; /* 蠤 */
dict[0x28825] = "wéi"; /* 蠥 */
dict[0x28826] = "xiáo"; /* 蠦 */
dict[0x2882c] = "hào"; /* 蠬 */
dict[0x2882d] = "yǎn"; /* 蠭 */
dict[0x28836] = "yí"; /* 蠶 */
dict[0x28837] = "zāo"; /* 蠷 */
dict[0x28838] = "yǐng"; /* 蠸 */
dict[0x28839] = "nǎn"; /* 蠹 */
dict[0x2883f] = "zā"; /* 蠿 */
dict[0x28841] = "tiǎn"; /* 衁 */
dict[0x28842] = "xī"; /* 衂 */
dict[0x28843] = "jiào"; /* 衃 */
dict[0x28844] = "yán"; /* 衄 */
dict[0x2884c] = "néi"; /* 行 */
dict[0x2884d] = "tǎn"; /* 衍 */
dict[0x2884e] = "yàn"; /* 衎 */
dict[0x2884f] = "tiǎn"; /* 衏 */
dict[0x28850] = "zhì"; /* 衐 */
dict[0x28851] = "chōu,chóu"; /* 衑 */
dict[0x28852] = "táo"; /* 衒 */
dict[0x28853] = "jiàng"; /* 術 */
dict[0x28857] = "zhà"; /* 街 */
dict[0x2885e] = "miǎn"; /* 衞 */
dict[0x28861] = "wǔ"; /* 衡 */
dict[0x28862] = "yǐn"; /* 衢 */
dict[0x28863] = "yàn"; /* 衣 */
dict[0x28864] = "lǎo"; /* 衤 */
dict[0x28869] = "pō"; /* 衩 */
dict[0x2886b] = "hùn"; /* 衫 */
dict[0x2886c] = "hǎi"; /* 衬 */
dict[0x2886d] = "mú"; /* 衭 */
dict[0x2886e] = "cōng"; /* 衮 */
dict[0x28871] = "kù,dǐng"; /* 衱 */
dict[0x28872] = "chōu"; /* 衲 */
dict[0x28874] = "yǒu"; /* 衴 */
dict[0x28878] = "zhuó"; /* 衸 */
dict[0x2887b] = "sōu"; /* 衻 */
dict[0x28882] = "yìn"; /* 袂 */
dict[0x28885] = "zuì"; /* 袅 */
dict[0x28886] = "sāng"; /* 袆 */
dict[0x28887] = "liù"; /* 袇 */
dict[0x28888] = "hàn"; /* 袈 */
dict[0x28889] = "wèi"; /* 袉 */
dict[0x2888a] = "méng"; /* 袊 */
dict[0x2888b] = "hú"; /* 袋 */
dict[0x2888c] = "lì"; /* 袌 */
dict[0x2888e] = "mì,yīn"; /* 袎 */
dict[0x28890] = "bāng"; /* 袐 */
dict[0x28891] = "jiǎn"; /* 袑 */
dict[0x28898] = "xī"; /* 袘 */
dict[0x2889c] = "què"; /* 袜 */
dict[0x288a0] = "méng"; /* 袠 */
dict[0x288a1] = "bì"; /* 袡 */
dict[0x288a2] = "mú"; /* 袢 */
dict[0x288a3] = "hǒng"; /* 袣 */
dict[0x288a4] = "hù"; /* 袤 */
dict[0x288a5] = "mí"; /* 袥 */
dict[0x288a6] = "shài,zhà"; /* 袦 */
dict[0x288a9] = "shāng"; /* 袩 */
dict[0x288aa] = "chào"; /* 袪 */
dict[0x288ac] = "zhuó,tú"; /* 袬 */
dict[0x288ae] = "zhī"; /* 袮 */
dict[0x288af] = "niàn"; /* 袯 */
dict[0x288b5] = "jì"; /* 袵 */
dict[0x288b8] = "kē"; /* 袸 */
dict[0x288b9] = "zhēng"; /* 袹 */
dict[0x288bf] = "dān"; /* 袿 */
dict[0x288c0] = "liǎo"; /* 裀 */
dict[0x288c1] = "zhǎn"; /* 裁 */
dict[0x288c2] = "gǒng"; /* 裂 */
dict[0x288c3] = "láo"; /* 裃 */
dict[0x288c4] = "huā"; /* 裄 */
dict[0x288c5] = "chuài"; /* 装 */
dict[0x288c7] = "jiǎn"; /* 裇 */
dict[0x288c8] = "kuì"; /* 裈 */
dict[0x288c9] = "gàn"; /* 裉 */
dict[0x288cd] = "shē"; /* 裍 */
dict[0x288d4] = "chěn"; /* 裔 */
dict[0x288d5] = "tǎn"; /* 裕 */
dict[0x288d7] = "hú"; /* 裗 */
dict[0x288d8] = "méng"; /* 裘 */
dict[0x288d9] = "pào"; /* 裙 */
dict[0x288da] = "zhǎn"; /* 裚 */
dict[0x288db] = "cháng"; /* 裛 */
dict[0x288dd] = "gǎn,jiǎn"; /* 裝 */
dict[0x288e0] = "yì"; /* 裠 */
dict[0x288e2] = "suì"; /* 裢 */
dict[0x288e6] = "xù"; /* 裦 */
dict[0x288e7] = "jì"; /* 裧 */
dict[0x288e8] = "làn"; /* 裨 */
dict[0x288ec] = "yí"; /* 裬 */
dict[0x288ef] = "mì"; /* 裯 */
dict[0x288f1] = "miè"; /* 裱 */
dict[0x288f5] = "cuán"; /* 裵 */
dict[0x288f8] = "lǎn"; /* 裸 */
dict[0x288fb] = "yān,yǎn"; /* 裻 */
dict[0x288fe] = "mí"; /* 裾 */
dict[0x28902] = "yǒng"; /* 褂 */
dict[0x28903] = "cáng,zā"; /* 褃 */
dict[0x28904] = "jiǎn"; /* 褄 */
dict[0x28907] = "sōu,zāo"; /* 複 */
dict[0x2890b] = "lǎn"; /* 褋 */
dict[0x2890e] = "yán"; /* 褎 */
dict[0x28911] = "juàn"; /* 褑 */
dict[0x28915] = "è"; /* 褕 */
dict[0x28918] = "fèn"; /* 褘 */
dict[0x2891a] = "fèn"; /* 褚 */
dict[0x2891d] = "fèn"; /* 褝 */
dict[0x28921] = "guàng"; /* 褡 */
dict[0x28922] = "mái"; /* 褢 */
dict[0x28924] = "liě"; /* 褤 */
dict[0x28929] = "chōng"; /* 褩 */
dict[0x2892b] = "lí"; /* 褫 */
dict[0x28931] = "zhí"; /* 褱 */
dict[0x28932] = "lí"; /* 褲 */
dict[0x28934] = "xiè"; /* 褴 */
dict[0x28937] = "chóu"; /* 褷 */
dict[0x28939] = "jí"; /* 褹 */
dict[0x2893d] = "pī"; /* 褽 */
dict[0x28942] = "jié"; /* 襂 */
dict[0x28947] = "zhǒu,zhù"; /* 襇 */
dict[0x2894d] = "xiōng"; /* 襍 */
dict[0x28951] = "kuàng,gǒng"; /* 襑 */
dict[0x28959] = "jǐng"; /* 襙 */
dict[0x2895b] = "hù"; /* 襛 */
dict[0x2895e] = "qián"; /* 襞 */
dict[0x28963] = "cén"; /* 襣 */
dict[0x28966] = "qí"; /* 襦 */
dict[0x28967] = "wǎn,fàn,biān"; /* 襧 */
dict[0x28968] = "máo"; /* 襨 */
dict[0x2896a] = "dǒu"; /* 襪 */
dict[0x28974] = "kǒu"; /* 襴 */
dict[0x28976] = "dài"; /* 襶 */
dict[0x28978] = "náo"; /* 襸 */
dict[0x2897a] = "hóng"; /* 襺 */
dict[0x28982] = "lǎi"; /* 覂 */
dict[0x28983] = "duǒ,duò"; /* 覃 */
dict[0x28984] = "qiān"; /* 覄 */
dict[0x28986] = "yín"; /* 覆 */
dict[0x28995] = "xíng"; /* 覕 */
dict[0x28996] = "lòu"; /* 視 */
dict[0x28997] = "huī"; /* 覗 */
dict[0x2899b] = "fù"; /* 覛 */
dict[0x2899c] = "máo"; /* 覜 */
dict[0x2899e] = "zhōu"; /* 覞 */
dict[0x289a1] = "yóng,yáng"; /* 覡 */
dict[0x289ad] = "láo"; /* 覭 */
dict[0x289ae] = "jí"; /* 覮 */
dict[0x289af] = "yì"; /* 覯 */
dict[0x289b0] = "liú"; /* 覰 */
dict[0x289b1] = "cōng"; /* 覱 */
dict[0x289b3] = "nǎn"; /* 観 */
dict[0x289d0] = "tūn"; /* 觐 */
dict[0x289d1] = "xiàng"; /* 觑 */
dict[0x289d5] = "biàn"; /* 觕 */
dict[0x289d6] = "chuáng"; /* 觖 */
dict[0x289d7] = "wù"; /* 觗 */
dict[0x289d9] = "jū"; /* 觙 */
dict[0x289e5] = "xiē"; /* 觥 */
dict[0x289e6] = "pī"; /* 触 */
dict[0x289e7] = "zhuó"; /* 觧 */
dict[0x289e8] = "ruì,zhuì"; /* 觨 */
dict[0x289ea] = "sào"; /* 觪 */
dict[0x289eb] = "zì"; /* 觫 */
dict[0x289ed] = "zhèng"; /* 觭 */
dict[0x289f0] = "zú"; /* 觰 */
dict[0x289f1] = "qū"; /* 觱 */
dict[0x289f3] = "chì"; /* 觳 */
dict[0x289f5] = "zhì"; /* 觵 */
dict[0x28a0f] = "bō"; /* 訏 */
dict[0x28a15] = "sǎn"; /* 訕 */
dict[0x28a17] = "quàn"; /* 託 */
dict[0x28a18] = "qiān"; /* 記 */
dict[0x28a19] = "yā"; /* 訙 */
dict[0x28a1a] = "chào"; /* 訚 */
dict[0x28a1b] = "hé"; /* 訛 */
dict[0x28a1c] = "rǔ"; /* 訜 */
dict[0x28a20] = "jū"; /* 訠 */
dict[0x28a21] = "wù"; /* 訡 */
dict[0x28a22] = "chuī"; /* 訢 */
dict[0x28a2c] = "chì"; /* 訬 */
dict[0x28a2d] = "kuàng,gǒng"; /* 設 */
dict[0x28a2f] = "còu,zhòu"; /* 訯 */
dict[0x28a30] = "ruàn"; /* 訰 */
dict[0x28a31] = "kuò"; /* 許 */
dict[0x28a32] = "chí"; /* 訲 */
dict[0x28a33] = "zú"; /* 訳 */
dict[0x28a34] = "jiāo"; /* 訴 */
dict[0x28a36] = "yú"; /* 訶 */
dict[0x28a37] = "tú"; /* 訷 */
dict[0x28a38] = "méng"; /* 訸 */
dict[0x28a39] = "dā"; /* 訹 */
dict[0x28a3a] = "shuò,xuē"; /* 診 */
dict[0x28a40] = "hóu"; /* 詀 */
dict[0x28a65] = "fēng"; /* 詥 */
dict[0x28a66] = "gǒu"; /* 試 */
dict[0x28a67] = "dōng"; /* 詧 */
dict[0x28a68] = "chǎ"; /* 詨 */
dict[0x28a69] = "mào"; /* 詩 */
dict[0x28a6a] = "chǎn"; /* 詪 */
dict[0x28a6b] = "biān"; /* 詫 */
dict[0x28a6c] = "yù"; /* 詬 */
dict[0x28a6f] = "wán"; /* 詯 */
dict[0x28a70] = "zú"; /* 詰 */
dict[0x28a72] = "zī"; /* 該 */
dict[0x28a74] = "chuān"; /* 詴 */
dict[0x28a75] = "wǎn"; /* 詵 */
dict[0x28a76] = "wā"; /* 詶 */
dict[0x28a78] = "quān,juān"; /* 詸 */
dict[0x28a7b] = "wǎn"; /* 詻 */
dict[0x28a7d] = "xià"; /* 詽 */
dict[0x28a84] = "yìng"; /* 誄 */
dict[0x28a85] = "jiàn"; /* 誅 */
dict[0x28a88] = "wěi"; /* 誈 */
dict[0x28a89] = "tí"; /* 誉 */
dict[0x28a8a] = "sāo"; /* 誊 */
dict[0x28a8c] = "qí"; /* 誌 */
dict[0x28a8d] = "shā"; /* 認 */
dict[0x28a8e] = "yù"; /* 誎 */
dict[0x28a8f] = "jí"; /* 誏 */
dict[0x28a90] = "dòu,tōu"; /* 誐 */
dict[0x28a91] = "chǎn"; /* 誑 */
dict[0x28a92] = "tuán"; /* 誒 */
dict[0x28a95] = "liú"; /* 誕 */
dict[0x28a97] = "zhuì"; /* 誗 */
dict[0x28ab3] = "ruàn"; /* 誳 */
dict[0x28ab6] = "yàn"; /* 誶 */
dict[0x28ab7] = "gǔ"; /* 誷 */
dict[0x28ab9] = "lì"; /* 誹 */
dict[0x28aba] = "chā"; /* 誺 */
dict[0x28abe] = "dì"; /* 誾 */
dict[0x28ac0] = "zhǎn"; /* 諀 */
dict[0x28ac1] = "pō"; /* 諁 */
dict[0x28ad2] = "lòu"; /* 諒 */
dict[0x28ad4] = "zhì,xiè"; /* 諔 */
dict[0x28b01] = "lián"; /* 謁 */
dict[0x28b05] = "luǒ"; /* 謅 */
dict[0x28b0d] = "duò,duì"; /* 謍 */
dict[0x28b10] = "jué"; /* 謐 */
dict[0x28b11] = "lì"; /* 謑 */
dict[0x28b12] = "lán"; /* 謒 */
dict[0x28b14] = "ruàn"; /* 謔 */
dict[0x28b15] = "gū"; /* 謕 */
dict[0x28b16] = "chán"; /* 謖 */
dict[0x28b17] = "xū"; /* 謗 */
dict[0x28b1a] = "zhǐ"; /* 謚 */
dict[0x28b1d] = "zhì,xiè"; /* 謝 */
dict[0x28b41] = "xuè"; /* 譁 */
dict[0x28b42] = "bō"; /* 譂 */
dict[0x28b43] = "chēng"; /* 譃 */
dict[0x28b45] = "zhù"; /* 譅 */
dict[0x28b46] = "hēi"; /* 譆 */
dict[0x28b49] = "bān"; /* 證 */
dict[0x28b4c] = "péng"; /* 譌 */
dict[0x28b53] = "dié"; /* 譓 */
dict[0x28b56] = "zhǎn"; /* 譖 */
dict[0x28b57] = "guó"; /* 譗 */
dict[0x28b5a] = "biāo"; /* 譚 */
dict[0x28b5b] = "là,gě"; /* 譛 */
dict[0x28b7a] = "jīn"; /* 譺 */
dict[0x28b81] = "yuè"; /* 讁 */
dict[0x28b82] = "gǎi"; /* 讂 */
dict[0x28b92] = "mèng"; /* 讒 */
dict[0x28b94] = "yù"; /* 讔 */
dict[0x28baa] = "xǐ"; /* 讪 */
dict[0x28bac] = "piāo"; /* 讬 */
dict[0x28bad] = "sī"; /* 训 */
dict[0x28baf] = "tiě"; /* 讯 */
dict[0x28bb4] = "dèng"; /* 讴 */
dict[0x28bb8] = "chuō"; /* 许 */
dict[0x28bb9] = "dí"; /* 讹 */
dict[0x28bba] = "jī"; /* 论 */
dict[0x28bbb] = "chán"; /* 讻 */
dict[0x28bbf] = "zhuó"; /* 访 */
dict[0x28bc0] = "jī"; /* 诀 */
dict[0x28bd3] = "cài"; /* 诓 */
dict[0x28bde] = "jiàng"; /* 诞 */
dict[0x28bdf] = "huò"; /* 诟 */
dict[0x28bf2] = "tóu"; /* 诲 */
dict[0x28bfd] = "lí"; /* 诽 */
dict[0x28c02] = "qiàn"; /* 谂 */
dict[0x28c06] = "chuō"; /* 谆 */
dict[0x28c0b] = "lǎi"; /* 谋 */
dict[0x28c0f] = "tà"; /* 谏 */
dict[0x28c11] = "diào"; /* 谑 */
dict[0x28c13] = "jiǎn"; /* 谓 */
dict[0x28c1b] = "zhǐ"; /* 谛 */
dict[0x28c1c] = "jué"; /* 谜 */
dict[0x28c1e] = "mó"; /* 谞 */
dict[0x28c20] = "luó"; /* 谠 */
dict[0x28c26] = "bǎo"; /* 谦 */
dict[0x28c2d] = "zuǎn"; /* 谭 */
dict[0x28c35] = "zhē"; /* 谵 */
dict[0x28c38] = "yú"; /* 谸 */
dict[0x28c3b] = "bǎo"; /* 谻 */
dict[0x28c3e] = "mǎ"; /* 谾 */
dict[0x28c4e] = "tōu"; /* 豎 */
dict[0x28c50] = "lòu"; /* 豐 */
dict[0x28c55] = "gǎi"; /* 豕 */
dict[0x28c59] = "kūn"; /* 豙 */
dict[0x28c5a] = "duàn"; /* 豚 */
dict[0x28c5b] = "sōng"; /* 豛 */
dict[0x28c5c] = "qí"; /* 豜 */
dict[0x28c5d] = "yǎng"; /* 豝 */
dict[0x28c61] = "shì"; /* 象 */
dict[0x28c63] = "gǎi"; /* 豣 */
dict[0x28c64] = "kūn"; /* 豤 */
dict[0x28c66] = "dào"; /* 豦 */
dict[0x28c67] = "yǎo,ǎo"; /* 豧 */
dict[0x28c6b] = "qián"; /* 豫 */
dict[0x28c6d] = "shāo"; /* 豭 */
dict[0x28c6e] = "cháng"; /* 豮 */
dict[0x28c6f] = "miǔ"; /* 豯 */
dict[0x28c71] = "mó"; /* 豱 */
dict[0x28c75] = "nǎo"; /* 豵 */
dict[0x28c78] = "cōng"; /* 豸 */
dict[0x28c7a] = "niè"; /* 豺 */
dict[0x28c7b] = "zhāo"; /* 豻 */
dict[0x28c7c] = "cén"; /* 豼 */
dict[0x28c7f] = "sōng"; /* 豿 */
dict[0x28c80] = "niè"; /* 貀 */
dict[0x28c81] = "cì"; /* 貁 */
dict[0x28c84] = "jùn"; /* 貄 */
dict[0x28c86] = "shāo"; /* 貆 */
dict[0x28c88] = "zhú"; /* 貈 */
dict[0x28c89] = "duǒ,tuǒ,shèng"; /* 貉 */
dict[0x28c8a] = "àn"; /* 貊 */
dict[0x28c8b] = "bī"; /* 貋 */
dict[0x28c8e] = "tì"; /* 貎 */
dict[0x28c90] = "pǐ"; /* 貐 */
dict[0x28c91] = "xiá"; /* 貑 */
dict[0x28c92] = "qiú"; /* 貒 */
dict[0x28c93] = "shěng"; /* 貓 */
dict[0x28c97] = "tāng"; /* 貗 */
dict[0x28c9b] = "mán,mián"; /* 貛 */
dict[0x28c9c] = "piān"; /* 貜 */
dict[0x28c9e] = "tì"; /* 貞 */
dict[0x28c9f] = "róng"; /* 貟 */
dict[0x28ca7] = "cōng"; /* 貧 */
dict[0x28caa] = "jī"; /* 貪 */
dict[0x28cab] = "féng"; /* 貫 */
dict[0x28cac] = "wù"; /* 責 */
dict[0x28cad] = "jiào"; /* 貭 */
dict[0x28cae] = "láo"; /* 貮 */
dict[0x28caf] = "zēng"; /* 貯 */
dict[0x28cb0] = "péng"; /* 貰 */
dict[0x28cb1] = "cǎn"; /* 貱 */
dict[0x28cb3] = "nóng"; /* 貳 */
dict[0x28cb5] = "chǎn"; /* 貵 */
dict[0x28cbe] = "mán,mián"; /* 貾 */
dict[0x28cbf] = "guì"; /* 貿 */
dict[0x28cc0] = "niào"; /* 賀 */
dict[0x28cc1] = "chōng"; /* 賁 */
dict[0x28cc2] = "chàn"; /* 賂 */
dict[0x28cc6] = "nàng"; /* 賆 */
dict[0x28cc9] = "xiā"; /* 賉 */
dict[0x28cca] = "jiū"; /* 賊 */
dict[0x28ccb] = "jǐ"; /* 賋 */
dict[0x28ccc] = "zhèn"; /* 賌 */
dict[0x28cd1] = "tǐng"; /* 賑 */
dict[0x28cd4] = "mén"; /* 賔 */
dict[0x28cd5] = "yuè"; /* 賕 */
dict[0x28cd7] = "zhōng"; /* 賗 */
dict[0x28cd8] = "tún"; /* 賘 */
dict[0x28cd9] = "ruì"; /* 賙 */
dict[0x28cda] = "xiè,fēn"; /* 賚 */
dict[0x28cdb] = "xī"; /* 賛 */
dict[0x28cdd] = "tǐng,rùn"; /* 賝 */
dict[0x28cde] = "niǔ"; /* 賞 */
dict[0x28ce0] = "wǎng"; /* 賠 */
dict[0x28ce1] = "jiān,guān"; /* 賡 */
dict[0x28ce3] = "fēn"; /* 賣 */
dict[0x28cf2] = "biàn,bì"; /* 賲 */
dict[0x28cf7] = "yí"; /* 賷 */
dict[0x28cfa] = "dié"; /* 賺 */
dict[0x28cfb] = "jī"; /* 賻 */
dict[0x28cfc] = "gǎn"; /* 購 */
dict[0x28cff] = "jiān,xì,mǎ"; /* 賿 */
dict[0x28d00] = "jiōng"; /* 贀 */
dict[0x28d06] = "kāi"; /* 贆 */
dict[0x28d0a] = "què,guān"; /* 贊 */
dict[0x28d0c] = "nán"; /* 贌 */
dict[0x28d0d] = "móu"; /* 贍 */
dict[0x28d0e] = "xù"; /* 贎 */
dict[0x28d0f] = "sǒng"; /* 贏 */
dict[0x28d10] = "shèn"; /* 贐 */
dict[0x28d11] = "kuāng"; /* 贑 */
dict[0x28d12] = "què"; /* 贒 */
dict[0x28d13] = "wéi"; /* 贓 */
dict[0x28d17] = "dié"; /* 贗 */
dict[0x28d18] = "nán"; /* 贘 */
dict[0x28d1a] = "ruò"; /* 贚 */
dict[0x28d1b] = "gōng"; /* 贛 */
dict[0x28d1c] = "dòu,yòu"; /* 贜 */
dict[0x28d1e] = "niǎn"; /* 贞 */
dict[0x28d21] = "chāo"; /* 贡 */
dict[0x28d22] = "hé"; /* 财 */
dict[0x28d23] = "yàn"; /* 责 */
dict[0x28d29] = "tú"; /* 贩 */
dict[0x28d2a] = "bǔ"; /* 贪 */
dict[0x28d2c] = "hú"; /* 贬 */
dict[0x28d2d] = "yǒng"; /* 购 */
dict[0x28d2f] = "shǐ"; /* 贯 */
dict[0x28d30] = "chù"; /* 贰 */
dict[0x28d39] = "xiāo"; /* 费 */
dict[0x28d3a] = "mén"; /* 贺 */
dict[0x28d3b] = "lǐ"; /* 贻 */
dict[0x28d3c] = "tí"; /* 贼 */
dict[0x28d3e] = "jiān"; /* 贾 */
dict[0x28d42] = "zhǐ"; /* 赂 */
dict[0x28d43] = "guā,yuè"; /* 赃 */
dict[0x28d44] = "guǎn"; /* 资 */
dict[0x28d46] = "qì"; /* 赆 */
dict[0x28d48] = "fēi"; /* 赈 */
dict[0x28d49] = "yǔ"; /* 赉 */
dict[0x28d4a] = "zhé"; /* 赊 */
dict[0x28d4b] = "wěi"; /* 赋 */
dict[0x28d4c] = "ě"; /* 赌 */
dict[0x28d4d] = "chān"; /* 赍 */
dict[0x28d4e] = "xī,qí"; /* 赎 */
dict[0x28d50] = "gǔ"; /* 赐 */
dict[0x28d57] = "què"; /* 赗 */
dict[0x28d58] = "huì"; /* 赘 */
dict[0x28d5a] = "xié"; /* 赚 */
dict[0x28d5b] = "yīng"; /* 赛 */
dict[0x28d5d] = "tà"; /* 赝 */
dict[0x28d5e] = "wāi"; /* 赞 */
dict[0x28d5f] = "fú"; /* 赟 */
dict[0x28d60] = "jiè"; /* 赠 */
dict[0x28d61] = "pì"; /* 赡 */
dict[0x28d64] = "xī"; /* 赤 */
dict[0x28d65] = "shěng"; /* 赥 */
dict[0x28d66] = "yú"; /* 赦 */
dict[0x28d67] = "kuā"; /* 赧 */
dict[0x28d69] = "pì"; /* 赩 */
dict[0x28d6a] = "xié"; /* 赪 */
dict[0x28d6b] = "nüè"; /* 赫 */
dict[0x28d6c] = "xiàn"; /* 赬 */
dict[0x28d6d] = "jiàn"; /* 赭 */
dict[0x28d6e] = "xù"; /* 赮 */
dict[0x28d70] = "bì"; /* 走 */
dict[0x28d74] = "nán"; /* 赴 */
dict[0x28d76] = "liáng"; /* 赶 */
dict[0x28d78] = "pián"; /* 赸 */
dict[0x28d7c] = "jìng"; /* 赼 */
dict[0x28d80] = "tǎ"; /* 趀 */
dict[0x28d81] = "yàn"; /* 趁 */
dict[0x28d82] = "ài"; /* 趂 */
dict[0x28d85] = "xiāo"; /* 超 */
dict[0x28d86] = "qiāng"; /* 趆 */
dict[0x28d87] = "wǔ"; /* 趇 */
dict[0x28d88] = "táng"; /* 趈 */
dict[0x28d8a] = "jùn"; /* 越 */
dict[0x28d90] = "kuò"; /* 趐 */
dict[0x28d94] = "quē,què"; /* 趔 */
dict[0x28d97] = "làng"; /* 趗 */
dict[0x28d99] = "něng"; /* 趙 */
dict[0x28d9c] = "dòu,dǒu"; /* 趜 */
dict[0x28d9d] = "shú"; /* 趝 */
dict[0x28d9f] = "jiǎo"; /* 趟 */
dict[0x28da0] = "niè"; /* 趠 */
dict[0x28da2] = "yú"; /* 趢 */
dict[0x28da8] = "cè"; /* 趨 */
dict[0x28daa] = "jiǎo,liú"; /* 趪 */
dict[0x28dac] = "huà"; /* 趬 */
dict[0x28dad] = "wén"; /* 趭 */
dict[0x28dae] = "yē"; /* 趮 */
dict[0x28daf] = "é"; /* 趯 */
dict[0x28db0] = "guāng"; /* 趰 */
dict[0x28db1] = "huā"; /* 趱 */
dict[0x28db2] = "jiāo"; /* 趲 */
dict[0x28dba] = "lèi"; /* 趺 */
dict[0x28dbc] = "shāng"; /* 趼 */
dict[0x28dbd] = "yòng"; /* 趽 */
dict[0x28dbf] = "dēng"; /* 趿 */
dict[0x28dc0] = "guān"; /* 跀 */
dict[0x28dc1] = "niú"; /* 跁 */
dict[0x28dc3] = "suì"; /* 跃 */
dict[0x28dc4] = "xiàng"; /* 跄 */
dict[0x28dc6] = "sà"; /* 跆 */
dict[0x28dc7] = "chāng"; /* 跇 */
dict[0x28dce] = "rùn"; /* 跎 */
dict[0x28dd0] = "yūn"; /* 跐 */
dict[0x28dd2] = "fēn"; /* 跒 */
dict[0x28dd3] = "jiàn"; /* 跓 */
dict[0x28dd4] = "xù"; /* 跔 */
dict[0x28dd8] = "xì"; /* 跘 */
dict[0x28dd9] = "shú"; /* 跙 */
dict[0x28de5] = "xié"; /* 跥 */
dict[0x28de6] = "lì"; /* 跦 */
dict[0x28de9] = "tóu"; /* 跩 */
dict[0x28dec] = "mǐ"; /* 跬 */
dict[0x28ded] = "chǎn"; /* 跭 */
dict[0x28dee] = "huō"; /* 跮 */
dict[0x28df1] = "zhuǎn"; /* 跱 */
dict[0x28df2] = "yuè"; /* 跲 */
dict[0x28dfb] = "lán"; /* 跻 */
dict[0x28dfd] = "yán"; /* 跽 */
dict[0x28dfe] = "dàng"; /* 跾 */
dict[0x28e0f] = "fù"; /* 踏 */
dict[0x28e10] = "réng"; /* 踐 */
dict[0x28e11] = "qiǎo"; /* 踑 */
dict[0x28e12] = "qí"; /* 踒 */
dict[0x28e13] = "diāo"; /* 踓 */
dict[0x28e14] = "qí,wéi"; /* 踔 */
dict[0x28e17] = "hàn"; /* 踗 */
dict[0x28e18] = "yuán"; /* 踘 */
dict[0x28e19] = "yóu"; /* 踙 */
dict[0x28e1a] = "jí"; /* 踚 */
dict[0x28e1b] = "gài"; /* 踛 */
dict[0x28e1c] = "hāi"; /* 踜 */
dict[0x28e1d] = "shì"; /* 踝 */
dict[0x28e29] = "wèn"; /* 踩 */
dict[0x28e2c] = "zhèn"; /* 踬 */
dict[0x28e2d] = "pō"; /* 踭 */
dict[0x28e2e] = "yán,yǔn"; /* 踮 */
dict[0x28e2f] = "gū"; /* 踯 */
dict[0x28e30] = "jù"; /* 踰 */
dict[0x28e31] = "tiàn,niǎn"; /* 踱 */
dict[0x28e37] = "è"; /* 踷 */
dict[0x28e3a] = "yā"; /* 踺 */
dict[0x28e3b] = "lìn"; /* 踻 */
dict[0x28e3c] = "bì"; /* 踼 */
dict[0x28e40] = "zǐ"; /* 蹀 */
dict[0x28e41] = "hóng"; /* 蹁 */
dict[0x28e43] = "duǒ,duò"; /* 蹃 */
dict[0x28e45] = "duì"; /* 蹅 */
dict[0x28e46] = "xuàn"; /* 蹆 */
dict[0x28e48] = "shǎn,yáng"; /* 蹈 */
dict[0x28e4a] = "shǎn"; /* 蹊 */
dict[0x28e4b] = "yáo"; /* 蹋 */
dict[0x28e4c] = "rǎn"; /* 蹌 */
dict[0x28e54] = "tuó"; /* 蹔 */
dict[0x28e57] = "bīng"; /* 蹗 */
dict[0x28e58] = "xù"; /* 蹘 */
dict[0x28e59] = "tūn"; /* 蹙 */
dict[0x28e5a] = "chéng"; /* 蹚 */
dict[0x28e5c] = "dòu"; /* 蹜 */
dict[0x28e5d] = "yì,yà"; /* 蹝 */
dict[0x28e5f] = "lòu"; /* 蹟 */
dict[0x28e61] = "chè"; /* 蹡 */
dict[0x28e75] = "juǎn"; /* 蹵 */
dict[0x28e76] = "jī"; /* 蹶 */
dict[0x28e78] = "zhào"; /* 蹸 */
dict[0x28e79] = "bēng,bèng"; /* 蹹 */
dict[0x28e7b] = "tiǎn"; /* 蹻 */
dict[0x28e80] = "pēng"; /* 躀 */
dict[0x28e85] = "fù"; /* 躅 */
dict[0x28e96] = "tuǒ"; /* 躖 */
dict[0x28e98] = "xián"; /* 躘 */
dict[0x28e99] = "nì"; /* 躙 */
dict[0x28e9a] = "lóng"; /* 躚 */
dict[0x28e9d] = "zhuó"; /* 躝 */
dict[0x28e9f] = "zhēng"; /* 躟 */
dict[0x28ea0] = "shǔn"; /* 躠 */
dict[0x28ea1] = "zōng"; /* 躡 */
dict[0x28ea2] = "fēng"; /* 躢 */
dict[0x28ea3] = "duàn"; /* 躣 */
dict[0x28ea4] = "pì"; /* 躤 */
dict[0x28ea5] = "yǎn"; /* 躥 */
dict[0x28ea6] = "sǒu"; /* 躦 */
dict[0x28ea7] = "qiú"; /* 躧 */
dict[0x28ea8] = "è"; /* 躨 */
dict[0x28ea9] = "qián"; /* 躩 */
dict[0x28eab] = "qiǎn"; /* 身 */
dict[0x28ead] = "cā"; /* 躭 */
dict[0x28eae] = "xùn"; /* 躮 */
dict[0x28eb5] = "zhuì"; /* 躵 */
dict[0x28eb8] = "mǎo"; /* 躸 */
dict[0x28eb9] = "jiǎo"; /* 躹 */
dict[0x28ebf] = "zhǎn"; /* 躿 */
dict[0x28ec0] = "pí,bī"; /* 軀 */
dict[0x28ec1] = "xī"; /* 軁 */
dict[0x28ec2] = "yàn"; /* 軂 */
dict[0x28ec3] = "fèi"; /* 軃 */
dict[0x28ec4] = "niè"; /* 軄 */
dict[0x28ec6] = "zhì"; /* 軆 */
dict[0x28ec8] = "suǒ"; /* 軈 */
dict[0x28eca] = "yì"; /* 車 */
dict[0x28ecc] = "lěi"; /* 軌 */
dict[0x28ecd] = "xù"; /* 軍 */
dict[0x28ecf] = "yì"; /* 軏 */
dict[0x28ed2] = "wēi"; /* 軒 */
dict[0x28ed5] = "jī"; /* 軕 */
dict[0x28ed6] = "chēn"; /* 軖 */
dict[0x28ed7] = "dié"; /* 軗 */
dict[0x28ee3] = "yuán"; /* 軣 */
dict[0x28ee4] = "shǎn"; /* 軤 */
dict[0x28ee5] = "xí"; /* 軥 */
dict[0x28ee7] = "liú"; /* 軧 */
dict[0x28ee8] = "suǒ"; /* 軨 */
dict[0x28ee9] = "qīng"; /* 軩 */
dict[0x28ef1] = "bēng"; /* 軱 */
dict[0x28ef2] = "xià"; /* 軲 */
dict[0x28ef3] = "yàn,yān"; /* 軳 */
dict[0x28ef5] = "cuī,zuī,duì"; /* 軵 */
dict[0x28ef6] = "qīng"; /* 軶 */
dict[0x28ef7] = "kāng"; /* 軷 */
dict[0x28efa] = "qīng"; /* 軺 */
dict[0x28efb] = "lóu"; /* 軻 */
dict[0x28efc] = "bī"; /* 軼 */
dict[0x28f07] = "lóng"; /* 輇 */
dict[0x28f08] = "zhàn"; /* 輈 */
dict[0x28f09] = "cuàn"; /* 載 */
dict[0x28f0a] = "wú"; /* 輊 */
dict[0x28f0b] = "xū"; /* 輋 */
dict[0x28f0c] = "chēn"; /* 輌 */
dict[0x28f0d] = "háo"; /* 輍 */
dict[0x28f0e] = "jué"; /* 輎 */
dict[0x28f10] = "chèn"; /* 輐 */
dict[0x28f11] = "chá"; /* 輑 */
dict[0x28f12] = "chǎn"; /* 輒 */
dict[0x28f13] = "zhí"; /* 輓 */
dict[0x28f14] = "xún"; /* 輔 */
dict[0x28f24] = "chén"; /* 輤 */
dict[0x28f25] = "yè,gé"; /* 輥 */
dict[0x28f2a] = "chǔ"; /* 輪 */
dict[0x28f2b] = "qú"; /* 輫 */
dict[0x28f2c] = "xiè"; /* 輬 */
dict[0x28f2e] = "zhàn"; /* 輮 */
dict[0x28f2f] = "kěn"; /* 輯 */
dict[0x28f31] = "jué"; /* 輱 */
dict[0x28f3d] = "qú"; /* 輽 */
dict[0x28f3f] = "méng"; /* 輿 */
dict[0x28f40] = "yè"; /* 轀 */
dict[0x28f41] = "zōu,cóng"; /* 轁 */
dict[0x28f42] = "pú"; /* 轂 */
dict[0x28f44] = "shì"; /* 轄 */
dict[0x28f49] = "shǔ"; /* 轉 */
dict[0x28f4a] = "chán"; /* 轊 */
dict[0x28f4c] = "yǐn"; /* 轌 */
dict[0x28f4d] = "dú"; /* 轍 */
dict[0x28f4f] = "guō"; /* 轏 */
dict[0x28f50] = "lù,yáng"; /* 轐 */
dict[0x28f51] = "yān"; /* 轑 */
dict[0x28f56] = "niǎo"; /* 轖 */
dict[0x28f57] = "bīn,pín"; /* 轗 */
dict[0x28f5d] = "ài"; /* 轝 */
dict[0x28f5f] = "tuí"; /* 轟 */
dict[0x28f65] = "zhì"; /* 轥 */
dict[0x28f66] = "nì"; /* 车 */
dict[0x28f67] = "huān"; /* 轧 */
dict[0x28f68] = "qián"; /* 轨 */
dict[0x28f6f] = "xià"; /* 软 */
dict[0x28f72] = "líng"; /* 轲 */
dict[0x28f75] = "suì"; /* 轵 */
dict[0x28f77] = "lián"; /* 轷 */
dict[0x28f78] = "sì"; /* 轸 */
dict[0x28f79] = "yì,lì"; /* 轹 */
dict[0x28f7b] = "lì"; /* 轻 */
dict[0x28f7c] = "sì"; /* 轼 */
dict[0x28f7f] = "dài"; /* 轿 */
dict[0x28f82] = "wèi"; /* 辂 */
dict[0x28f85] = "cì"; /* 辅 */
dict[0x28f89] = "jiǔ"; /* 辉 */
dict[0x28f8a] = "hóng"; /* 辊 */
dict[0x28f8c] = "yú"; /* 辌 */
dict[0x28f8e] = "kuí"; /* 辎 */
dict[0x28f92] = "háng"; /* 辒 */
dict[0x28f93] = "gē,yì"; /* 输 */
dict[0x28f94] = "fàng"; /* 辔 */
dict[0x28f97] = "kuí,xié"; /* 辗 */
dict[0x28f9a] = "guī,fū"; /* 辚 */
dict[0x28f9b] = "chǐ,qí"; /* 辛 */
dict[0x28f9e] = "jiǔ"; /* 辞 */
dict[0x28fa1] = "suī,huǎng"; /* 辡 */
dict[0x28fa4] = "dié"; /* 辤 */
dict[0x28fa6] = "chī"; /* 辦 */
dict[0x28fac] = "suǐ"; /* 辬 */
dict[0x28faf] = "rú"; /* 辯 */
dict[0x28fb0] = "qín"; /* 辰 */
dict[0x28fb4] = "guī"; /* 辴 */
dict[0x28fbb] = "zhuī"; /* 辻 */
dict[0x28fbe] = "tiào"; /* 达 */
dict[0x28fc1] = "yuè"; /* 迁 */
dict[0x28fc7] = "zuǐ"; /* 过 */
dict[0x28fcf] = "wú"; /* 迏 */
dict[0x28fd0] = "cuǐ"; /* 运 */
dict[0x28fdb] = "zhì,xī"; /* 进 */
dict[0x28fe0] = "shuì"; /* 迠 */
dict[0x28fe1] = "chún"; /* 迡 */
dict[0x28fe2] = "dōng"; /* 迢 */
dict[0x28fed] = "wéi"; /* 迭 */
dict[0x28ff3] = "yīng"; /* 迳 */
dict[0x28fff] = "chǒng"; /* 迿 */
dict[0x2900b] = "rún"; /* 逋 */
dict[0x29016] = "jí"; /* 逖 */
dict[0x2901c] = "diāo"; /* 逜 */
dict[0x2901e] = "cāng"; /* 逞 */
dict[0x29020] = "kòu,gǔ"; /* 造 */
dict[0x29023] = "wéi"; /* 連 */
dict[0x29027] = "cán"; /* 逧 */
dict[0x2902a] = "má"; /* 逪 */
dict[0x2902b] = "òu"; /* 逫 */
dict[0x29032] = "sǎn"; /* 進 */
dict[0x29036] = "wéi,huī,mí"; /* 逶 */
dict[0x2903c] = "sǎn"; /* 逼 */
dict[0x2903f] = "jīn"; /* 逿 */
dict[0x2904c] = "wéi"; /* 遌 */
dict[0x2905e] = "cài"; /* 遞 */
dict[0x2905f] = "lí"; /* 遟 */
dict[0x2906f] = "yuè"; /* 遯 */
dict[0x29074] = "yūn"; /* 遴 */
dict[0x29077] = "chēng"; /* 遷 */
dict[0x29079] = "yú"; /* 遹 */
dict[0x2907a] = "shān"; /* 遺 */
dict[0x2907f] = "nüè"; /* 避 */
dict[0x29082] = "hū"; /* 邂 */
dict[0x29083] = "shài"; /* 邃 */
dict[0x29084] = "tún"; /* 還 */
dict[0x29086] = "fǒu,fù"; /* 邆 */
dict[0x29088] = "qìn"; /* 邈 */
dict[0x29089] = "xū,chēn"; /* 邉 */
dict[0x2908d] = "chuān"; /* 邍 */
dict[0x2908e] = "fù"; /* 邎 */
dict[0x29092] = "yì,ài"; /* 邒 */
dict[0x29093] = "dōng"; /* 邓 */
dict[0x29094] = "fú"; /* 邔 */
dict[0x29095] = "fú"; /* 邕 */
dict[0x29096] = "zé"; /* 邖 */
dict[0x29097] = "pù"; /* 邗 */
dict[0x29099] = "líng"; /* 邙 */
dict[0x2909d] = "shài,yīng"; /* 邝 */
dict[0x2909e] = "pào"; /* 邞 */
dict[0x290a2] = "yín,ái"; /* 邢 */
dict[0x290a3] = "luò"; /* 那 */
dict[0x290a4] = "huà"; /* 邤 */
dict[0x290a5] = "yìn"; /* 邥 */
dict[0x290a6] = "bèng"; /* 邦 */
dict[0x290a7] = "yū"; /* 邧 */
dict[0x290a8] = "shè"; /* 邨 */
dict[0x290aa] = "xiè"; /* 邪 */
dict[0x290ab] = "chǔ"; /* 邫 */
dict[0x290b4] = "shè"; /* 邴 */
dict[0x290b5] = "diàn"; /* 邵 */
dict[0x290b9] = "yì"; /* 邹 */
dict[0x290bb] = "chè"; /* 邻 */
dict[0x290bc] = "gěng"; /* 邼 */
dict[0x290bd] = "lóng"; /* 邽 */
dict[0x290be] = "píng"; /* 邾 */
dict[0x290bf] = "yǔn"; /* 邿 */
dict[0x290c0] = "yàn"; /* 郀 */
dict[0x290c1] = "mò"; /* 郁 */
dict[0x290c3] = "suī"; /* 郃 */
dict[0x290cb] = "jìng"; /* 郋 */
dict[0x290cd] = "sòng"; /* 郍 */
dict[0x290ce] = "páng"; /* 郎 */
dict[0x290d0] = "yá"; /* 郐 */
dict[0x290d1] = "sè"; /* 郑 */
dict[0x290d2] = "duǒ"; /* 郒 */
dict[0x290d4] = "jiān"; /* 郔 */
dict[0x290d5] = "chuáng"; /* 郕 */
dict[0x290d6] = "xiè"; /* 郖 */
dict[0x290d8] = "tuán"; /* 郘 */
dict[0x290d9] = "gōng"; /* 郙 */
dict[0x290da] = "xuàn"; /* 郚 */
dict[0x290dc] = "lā"; /* 郜 */
dict[0x290de] = "líng"; /* 郞 */
dict[0x290e0] = "dài"; /* 郠 */
dict[0x290e1] = "zhá"; /* 郡 */
dict[0x290ec] = "yīn"; /* 郬 */
dict[0x290ed] = "sōng"; /* 郭 */
dict[0x290ef] = "yǔ"; /* 郯 */
dict[0x290f0] = "tuó"; /* 郰 */
dict[0x290f1] = "tuó"; /* 郱 */
dict[0x290f4] = "bà"; /* 郴 */
dict[0x290f5] = "rǎn"; /* 郵 */
dict[0x290f6] = "bó"; /* 郶 */
dict[0x290f7] = "dài"; /* 郷 */
dict[0x290f9] = "zhá,zhǎ"; /* 郹 */
dict[0x290fa] = "hóu"; /* 郺 */
dict[0x290fe] = "huǐ"; /* 郾 */
dict[0x29105] = "lú"; /* 鄅 */
dict[0x2910a] = "lìng"; /* 鄊 */
dict[0x2910b] = "rú"; /* 鄋 */
dict[0x29115] = "dàn"; /* 鄕 */
dict[0x29116] = "méng"; /* 鄖 */
dict[0x29117] = "xià"; /* 鄗 */
dict[0x29118] = "wěng"; /* 鄘 */
dict[0x29119] = "hán"; /* 鄙 */
dict[0x2911a] = "zī"; /* 鄚 */
dict[0x2911b] = "zhèn"; /* 鄛 */
dict[0x2911c] = "sè"; /* 鄜 */
dict[0x2911d] = "cuó"; /* 鄝 */
dict[0x2911e] = "lì"; /* 鄞 */
dict[0x29120] = "diān"; /* 鄠 */
dict[0x29121] = "lián"; /* 鄡 */
dict[0x29122] = "gòu"; /* 鄢 */
dict[0x29126] = "péng"; /* 鄦 */
dict[0x2912a] = "yīng"; /* 鄪 */
dict[0x2912c] = "hòu"; /* 鄬 */
dict[0x2912e] = "duì"; /* 鄮 */
dict[0x2912f] = "wù"; /* 鄯 */
dict[0x29137] = "piào"; /* 鄷 */
dict[0x29138] = "hè"; /* 鄸 */
dict[0x2913a] = "lóng"; /* 鄺 */
dict[0x2913b] = "mò"; /* 鄻 */
dict[0x2913c] = "fěi"; /* 鄼 */
dict[0x2913d] = "lǚ"; /* 鄽 */
dict[0x2913e] = "zé"; /* 鄾 */
dict[0x2913f] = "bó"; /* 鄿 */
dict[0x29140] = "diàn,zhí"; /* 酀 */
dict[0x29141] = "mǎng"; /* 酁 */
dict[0x29143] = "zhuàng,chóng"; /* 酃 */
dict[0x29144] = "lù"; /* 酄 */
dict[0x29145] = "pāng"; /* 酅 */
dict[0x29146] = "duì"; /* 酆 */
dict[0x29147] = "bù"; /* 酇 */
dict[0x29149] = "zhōng"; /* 酉 */
dict[0x2914c] = "chēn"; /* 酌 */
dict[0x2914d] = "màn"; /* 配 */
dict[0x29156] = "xī"; /* 酖 */
dict[0x2915d] = "ǎn"; /* 酝 */
dict[0x2915e] = "zhōng,chòng"; /* 酞 */
dict[0x29160] = "nàn"; /* 酠 */
dict[0x29161] = "tuò"; /* 酡 */
dict[0x29162] = "hé"; /* 酢 */
dict[0x29163] = "duì"; /* 酣 */
dict[0x29165] = "duì"; /* 酥 */
dict[0x29166] = "wān,dān"; /* 酦 */
dict[0x29167] = "zhōng"; /* 酧 */
dict[0x29168] = "cén,shèn"; /* 酨 */
dict[0x29169] = "lì"; /* 酩 */
dict[0x2916a] = "shuāng"; /* 酪 */
dict[0x2916e] = "cén"; /* 酮 */
dict[0x29170] = "sī"; /* 酰 */
dict[0x29172] = "duì"; /* 酲 */
dict[0x29174] = "hūn"; /* 酴 */
dict[0x29178] = "liù"; /* 酸 */
dict[0x2917c] = "jiān,jiàn"; /* 酼 */
dict[0x2917d] = "nóng"; /* 酽 */
dict[0x2917e] = "dàn"; /* 酾 */
dict[0x2917f] = "fù"; /* 酿 */
dict[0x29180] = "huò"; /* 醀 */
dict[0x29181] = "huì,wèi"; /* 醁 */
dict[0x29182] = "cí"; /* 醂 */
dict[0x29184] = "yǒng"; /* 醄 */
dict[0x29185] = "sà"; /* 醅 */
dict[0x29186] = "tíng"; /* 醆 */
dict[0x2918e] = "liù"; /* 醎 */
dict[0x29191] = "suān"; /* 醑 */
dict[0x29192] = "líng"; /* 醒 */
dict[0x29193] = "mán,màn"; /* 醓 */
dict[0x29194] = "diàn"; /* 醔 */
dict[0x29198] = "pāo"; /* 醘 */
dict[0x2919a] = "líng"; /* 醚 */
dict[0x2919c] = "líng"; /* 醜 */
dict[0x2919d] = "lì"; /* 醝 */
dict[0x2919f] = "nóu"; /* 醟 */
dict[0x291a3] = "liè"; /* 醣 */
dict[0x291a4] = "shǎn"; /* 醤 */
dict[0x291a6] = "fèi"; /* 醦 */
dict[0x291a9] = "shù"; /* 醩 */
dict[0x291ab] = "shǎn"; /* 醫 */
dict[0x291ae] = "líng"; /* 醮 */
dict[0x291af] = "zhàn,jiān"; /* 醯 */
dict[0x291b1] = "bīn"; /* 醱 */
dict[0x291b2] = "lí"; /* 醲 */
dict[0x291b5] = "sī,xiàn"; /* 醵 */
dict[0x291b6] = "ráng"; /* 醶 */
dict[0x291b7] = "jiān"; /* 醷 */
dict[0x291b8] = "zhuó"; /* 醸 */
dict[0x291bb] = "líng"; /* 醻 */
dict[0x291bc] = "líng"; /* 醼 */
dict[0x291bd] = "mèng"; /* 醽 */
dict[0x291bf] = "shuāng"; /* 醿 */
dict[0x291c4] = "líng"; /* 釄 */
dict[0x291c7] = "hùn"; /* 采 */
dict[0x291ce] = "líng"; /* 野 */
dict[0x291cf] = "jiān"; /* 量 */
dict[0x291d0] = "qú"; /* 釐 */
dict[0x291d4] = "nóng"; /* 釔 */
dict[0x291d5] = "jìng"; /* 釕 */
dict[0x291d6] = "chēn"; /* 釖 */
dict[0x291dc] = "zhēn,chēng"; /* 釜 */
dict[0x291dd] = "qìng"; /* 針 */
dict[0x291df] = "qìng"; /* 釟 */
dict[0x291e0] = "è,yǎn"; /* 釠 */
dict[0x291e3] = "sè"; /* 釣 */
dict[0x291e9] = "bèi"; /* 釩 */
dict[0x291eb] = "fēi"; /* 釫 */
dict[0x291ee] = "fèi"; /* 釮 */
dict[0x291ef] = "féi"; /* 釯 */
dict[0x291f4] = "fāng"; /* 釴 */
dict[0x291f5] = "kǔ"; /* 釵 */
dict[0x291fa] = "zá"; /* 釺 */
dict[0x291fb] = "huì"; /* 釻 */
dict[0x291fd] = "féi"; /* 釽 */
dict[0x29201] = "duì"; /* 鈁 */
dict[0x29206] = "pā"; /* 鈆 */
dict[0x29207] = "niǔ"; /* 鈇 */
dict[0x29208] = "pàng"; /* 鈈 */
dict[0x29209] = "dàn"; /* 鈉 */
dict[0x2920a] = "dān,dàn"; /* 鈊 */
dict[0x2920b] = "ài"; /* 鈋 */
dict[0x2920d] = "tiǎn"; /* 鈍 */
dict[0x2920e] = "chǎo"; /* 鈎 */
dict[0x2920f] = "ǎo,yǒu"; /* 鈏 */
dict[0x29210] = "mèi"; /* 鈐 */
dict[0x29211] = "nǎn"; /* 鈑 */
dict[0x29214] = "bò"; /* 鈔 */
dict[0x29215] = "yù,chì"; /* 鈕 */
dict[0x29216] = "xiān,hān"; /* 鈖 */
dict[0x29217] = "mài"; /* 鈗 */
dict[0x2921a] = "pīng"; /* 鈚 */
dict[0x2921c] = "duī"; /* 鈜 */
dict[0x2921e] = "dào"; /* 鈞 */
dict[0x29221] = "xìng"; /* 鈡 */
dict[0x29222] = "nì,nǜ"; /* 鈢 */
dict[0x29223] = "hān"; /* 鈣 */
dict[0x29224] = "chù"; /* 鈤 */
dict[0x29225] = "shuǎ"; /* 鈥 */
dict[0x29226] = "mǎn"; /* 鈦 */
dict[0x2922c] = "wàn"; /* 鈬 */
dict[0x2922d] = "yì"; /* 鈭 */
dict[0x2922e] = "diào"; /* 鈮 */
dict[0x2922f] = "yān"; /* 鈯 */
dict[0x29231] = "wò"; /* 鈱 */
dict[0x29232] = "suàn"; /* 鈲 */
dict[0x29234] = "ǎn"; /* 鈴 */
dict[0x29235] = "lán"; /* 鈵 */
dict[0x29236] = "nǎn"; /* 鈶 */
dict[0x29238] = "qiǔ"; /* 鈸 */
dict[0x29239] = "miàn"; /* 鈹 */
dict[0x2923a] = "nuǒ"; /* 鈺 */
dict[0x2923b] = "cán"; /* 鈻 */
dict[0x2923c] = "cǎn"; /* 鈼 */
dict[0x29240] = "làn"; /* 鉀 */
dict[0x29241] = "tiǎn"; /* 鉁 */
dict[0x29242] = "yè"; /* 鉂 */
dict[0x29244] = "niǎn"; /* 鉄 */
dict[0x29246] = "shuǎ"; /* 鉆 */
dict[0x2924b] = "cí"; /* 鉋 */
dict[0x2924d] = "jiǎn"; /* 鉍 */
dict[0x29250] = "gàn"; /* 鉐 */
dict[0x29254] = "jiàn"; /* 鉔 */
dict[0x29255] = "guó"; /* 鉕 */
dict[0x29257] = "zhān"; /* 鉗 */
dict[0x29259] = "luǒ"; /* 鉙 */
dict[0x2925c] = "hàng"; /* 鉜 */
dict[0x2925d] = "guì"; /* 鉝 */
dict[0x29261] = "jiá"; /* 鉡 */
dict[0x29262] = "jǐ"; /* 鉢 */
dict[0x29265] = "xuàn"; /* 鉥 */
dict[0x29267] = "fēng"; /* 鉧 */
dict[0x2926b] = "bì"; /* 鉫 */
dict[0x2926c] = "qí,chí"; /* 鉬 */
dict[0x2926f] = "yuán"; /* 鉯 */
dict[0x29270] = "àng"; /* 鉰 */
dict[0x29271] = "dī"; /* 鉱 */
dict[0x29274] = "è"; /* 鉴 */
dict[0x29275] = "fén"; /* 鉵 */
dict[0x29278] = "jù"; /* 鉸 */
dict[0x29279] = "nǐ"; /* 鉹 */
dict[0x2927a] = "tuó"; /* 鉺 */
dict[0x2927c] = "shēn"; /* 鉼 */
dict[0x2927d] = "fú"; /* 鉽 */
dict[0x2927e] = "xiá"; /* 鉾 */
dict[0x2927f] = "qú"; /* 鉿 */
dict[0x29280] = "pò"; /* 銀 */
dict[0x29281] = "wǎn"; /* 銁 */
dict[0x29282] = "líng"; /* 銂 */
dict[0x29283] = "mà"; /* 銃 */
dict[0x29284] = "zhòu"; /* 銄 */
dict[0x29285] = "bào"; /* 銅 */
dict[0x29287] = "yù"; /* 銇 */
dict[0x2928c] = "běng"; /* 銌 */
dict[0x2928d] = "mài"; /* 銍 */
dict[0x2928f] = "jiā"; /* 銏 */
dict[0x29291] = "yǎng"; /* 銑 */
dict[0x29293] = "kuǎ,kù"; /* 銓 */
dict[0x29294] = "jiào"; /* 銔 */
dict[0x29296] = "bǐng"; /* 銖 */
dict[0x2929a] = "luò"; /* 銚 */
dict[0x2929b] = "guǐ"; /* 銛 */
dict[0x2929c] = "duò"; /* 銜 */
dict[0x2929d] = "zhì"; /* 銝 */
dict[0x292a1] = "zhèn"; /* 銡 */
dict[0x292a2] = "è"; /* 銢 */
dict[0x292a3] = "zhū"; /* 銣 */
dict[0x292a4] = "bá"; /* 銤 */
dict[0x292a8] = "zhèn"; /* 銨 */
dict[0x292a9] = "fēng,féng"; /* 銩 */
dict[0x292aa] = "dòu"; /* 銪 */
dict[0x292ab] = "niǎn"; /* 銫 */
dict[0x292ac] = "bù"; /* 銬 */
dict[0x292ad] = "duì"; /* 銭 */
dict[0x292ae] = "shā,suō"; /* 銮 */
dict[0x292af] = "sè"; /* 銯 */
dict[0x292b0] = "bì"; /* 銰 */
dict[0x292b4] = "zhì"; /* 銴 */
dict[0x292b5] = "zhé"; /* 銵 */
dict[0x292b6] = "bù"; /* 銶 */
dict[0x292ba] = "jué"; /* 銺 */
dict[0x292bb] = "xùn"; /* 銻 */
dict[0x292bf] = "xì"; /* 銿 */
dict[0x292c1] = "zhuó"; /* 鋁 */
dict[0x292c2] = "bài"; /* 鋂 */
dict[0x292c3] = "yáo,táo"; /* 鋃 */
dict[0x292c4] = "chǒu"; /* 鋄 */
dict[0x292c5] = "tà"; /* 鋅 */
dict[0x292c6] = "qiān"; /* 鋆 */
dict[0x292c8] = "nào"; /* 鋈 */
dict[0x292c9] = "yù"; /* 鋉 */
dict[0x292ca] = "è"; /* 鋊 */
dict[0x292cb] = "jiān"; /* 鋋 */
dict[0x292cc] = "yì"; /* 鋌 */
dict[0x292cd] = "xiāo"; /* 鋍 */
dict[0x292cf] = "niè"; /* 鋏 */
dict[0x292d2] = "bīng"; /* 鋒 */
dict[0x292d4] = "xié"; /* 鋔 */
dict[0x292d7] = "guǒ"; /* 鋗 */
dict[0x292d8] = "wā,xié"; /* 鋘 */
dict[0x292d9] = "diào"; /* 鋙 */
dict[0x292dc] = "jū"; /* 鋜 */
dict[0x292dd] = "suǒ"; /* 鋝 */
dict[0x292de] = "dié"; /* 鋞 */
dict[0x292df] = "fú,fù"; /* 鋟 */
dict[0x292e0] = "miǎn"; /* 鋠 */
dict[0x292e1] = "shì"; /* 鋡 */
dict[0x292e2] = "xuàn,yùn"; /* 鋢 */
dict[0x292e3] = "tí"; /* 鋣 */
dict[0x292e4] = "yù"; /* 鋤 */
dict[0x292e7] = "xié,kài"; /* 鋧 */
dict[0x292e8] = "fú"; /* 鋨 */
dict[0x292e9] = "zhì"; /* 鋩 */
dict[0x292ea] = "nǐ"; /* 鋪 */
dict[0x292eb] = "xuàn"; /* 鋫 */
dict[0x292ec] = "yáng"; /* 鋬 */
dict[0x292ee] = "fěng,bāng"; /* 鋮 */
dict[0x292ef] = "zòng"; /* 鋯 */
dict[0x292f0] = "zhòu"; /* 鋰 */
dict[0x292f1] = "xuān"; /* 鋱 */
dict[0x292f5] = "zhū"; /* 鋵 */
dict[0x292f7] = "la"; /* 鋷 */
dict[0x292f9] = "yìng"; /* 鋹 */
dict[0x292fa] = "gào"; /* 鋺 */
dict[0x292fb] = "kuò"; /* 鋻 */
dict[0x292fd] = "é"; /* 鋽 */
dict[0x292fe] = "wéi,wěi,xuē"; /* 鋾 */
dict[0x292ff] = "méi"; /* 鋿 */
dict[0x29303] = "huái,guì"; /* 錃 */
dict[0x29304] = "chǒu,zhōu"; /* 錄 */
dict[0x29306] = "suǒ"; /* 錆 */
dict[0x29307] = "tà"; /* 錇 */
dict[0x29308] = "suǒ"; /* 錈 */
dict[0x29309] = "tà"; /* 錉 */
dict[0x2930a] = "xuè"; /* 錊 */
dict[0x2930c] = "gǒng"; /* 錌 */
dict[0x2930d] = "jiǎ"; /* 錍 */
dict[0x2930f] = "bó,fú,bù,fù"; /* 錏 */
dict[0x29310] = "tà"; /* 錐 */
dict[0x29311] = "yuǎn"; /* 錑 */
dict[0x29318] = "tà"; /* 錘 */
dict[0x2931d] = "chuí"; /* 錝 */
dict[0x29320] = "xiōng"; /* 錠 */
dict[0x29321] = "hé,juē"; /* 錡 */
dict[0x29322] = "suō"; /* 錢 */
dict[0x29326] = "xǐ"; /* 錦 */
dict[0x29327] = "mò"; /* 錧 */
dict[0x29328] = "chóng"; /* 錨 */
dict[0x29329] = "suī"; /* 錩 */
dict[0x2932a] = "zé"; /* 錪 */
dict[0x2932b] = "lù"; /* 錫 */
dict[0x2932c] = "zhāng"; /* 錬 */
dict[0x2932d] = "luò"; /* 錭 */
dict[0x2932e] = "xù"; /* 錮 */
dict[0x2932f] = "jiān"; /* 錯 */
dict[0x29330] = "shān"; /* 錰 */
dict[0x29332] = "xù"; /* 録 */
dict[0x2933e] = "jiǎng"; /* 錾 */
dict[0x29341] = "bèi"; /* 鍁 */
dict[0x29342] = "bào"; /* 鍂 */
dict[0x29343] = "mái"; /* 鍃 */
dict[0x29345] = "tóng"; /* 鍅 */
dict[0x29346] = "xì"; /* 鍆 */
dict[0x29349] = "róng"; /* 鍉 */
dict[0x2934b] = "shéng"; /* 鍋 */
dict[0x2934c] = "zhòu"; /* 鍌 */
dict[0x2934e] = "jiān"; /* 鍎 */
dict[0x2934f] = "fù"; /* 鍏 */
dict[0x29350] = "dèng"; /* 鍐 */
dict[0x29353] = "yōng"; /* 鍓 */
dict[0x29354] = "jū,qū"; /* 鍔 */
dict[0x29356] = "yì"; /* 鍖 */
dict[0x29357] = "bāng"; /* 鍗 */
dict[0x29359] = "sè"; /* 鍙 */
dict[0x2935a] = "suì"; /* 鍚 */
dict[0x2935c] = "duó"; /* 鍜 */
dict[0x2935d] = "xiè"; /* 鍝 */
dict[0x29361] = "huán"; /* 鍡 */
dict[0x29365] = "rǔ"; /* 鍥 */
dict[0x29366] = "nǐ"; /* 鍦 */
dict[0x29367] = "zhòu"; /* 鍧 */
dict[0x29368] = "guì"; /* 鍨 */
dict[0x2936a] = "luò"; /* 鍪 */
dict[0x29372] = "zhī,chàn"; /* 鍲 */
dict[0x29373] = "xù"; /* 鍳 */
dict[0x29375] = "zhī"; /* 鍵 */
dict[0x29377] = "quē"; /* 鍷 */
dict[0x29378] = "jū"; /* 鍸 */
dict[0x2937b] = "yuán"; /* 鍻 */
dict[0x2937c] = "lú"; /* 鍼 */
dict[0x2937f] = "bó"; /* 鍿 */
dict[0x29382] = "róng"; /* 鎂 */
dict[0x29383] = "xiè"; /* 鎃 */
dict[0x29389] = "xǐ"; /* 鎉 */
dict[0x2938a] = "luó"; /* 鎊 */
dict[0x2938d] = "xiǎn"; /* 鎍 */
dict[0x2938e] = "gé"; /* 鎎 */
dict[0x29391] = "zuān"; /* 鎑 */
dict[0x29392] = "hàn,jiān"; /* 鎒 */
dict[0x29394] = "jiāo"; /* 鎔 */
dict[0x29395] = "sǎ"; /* 鎕 */
dict[0x29396] = "qín,qián"; /* 鎖 */
dict[0x29397] = "qūn"; /* 鎗 */
dict[0x29398] = "páo"; /* 鎘 */
dict[0x29399] = "yuè"; /* 鎙 */
dict[0x2939a] = "chè"; /* 鎚 */
dict[0x2939b] = "fú"; /* 鎛 */
dict[0x2939c] = "pēi"; /* 鎜 */
dict[0x2939f] = "mèi,mò,wà"; /* 鎟 */
dict[0x293a2] = "tāo"; /* 鎢 */
dict[0x293a4] = "kēn"; /* 鎤 */
dict[0x293a5] = "xì"; /* 鎥 */
dict[0x293ab] = "duò"; /* 鎫 */
dict[0x293ad] = "yì"; /* 鎭 */
dict[0x293b0] = "suì"; /* 鎰 */
dict[0x293b2] = "xiá"; /* 鎲 */
dict[0x293b3] = "juān"; /* 鎳 */
dict[0x293b5] = "wéi"; /* 鎵 */
dict[0x293b7] = "yì"; /* 鎷 */
dict[0x293b9] = "yù"; /* 鎹 */
dict[0x293bb] = "bài"; /* 鎻 */
dict[0x293bc] = "tuó"; /* 鎼 */
dict[0x293bd] = "tà"; /* 鎽 */
dict[0x293be] = "páo"; /* 鎾 */
dict[0x293c2] = "bǐng,bì"; /* 鏂 */
dict[0x293c5] = "yùn"; /* 鏅 */
dict[0x293c6] = "yùn"; /* 鏆 */
dict[0x293c7] = "duàn"; /* 鏇 */
dict[0x293c8] = "ruǎn"; /* 鏈 */
dict[0x293c9] = "wéi"; /* 鏉 */
dict[0x293cf] = "wěi"; /* 鏏 */
dict[0x293d0] = "guì,wěi"; /* 鏐 */
dict[0x293d1] = "hán"; /* 鏑 */
dict[0x293d2] = "dá"; /* 鏒 */
dict[0x293d3] = "xiá"; /* 鏓 */
dict[0x293d6] = "hùn"; /* 鏖 */
dict[0x293d7] = "juǎn"; /* 鏗 */
dict[0x293d8] = "suī"; /* 鏘 */
dict[0x293da] = "suì"; /* 鏚 */
dict[0x293dd] = "lóu"; /* 鏝 */
dict[0x293de] = "bài"; /* 鏞 */
dict[0x293df] = "yù"; /* 鏟 */
dict[0x293e0] = "zhèng"; /* 鏠 */
dict[0x293e1] = "guì"; /* 鏡 */
dict[0x293e3] = "kuī"; /* 鏣 */
dict[0x293e4] = "gāo"; /* 鏤 */
dict[0x293e5] = "dān"; /* 鏥 */
dict[0x293e9] = "xiǎn"; /* 鏩 */
dict[0x293ea] = "zhái"; /* 鏪 */
dict[0x293eb] = "sè"; /* 鏫 */
dict[0x293ec] = "wěi"; /* 鏬 */
dict[0x293ed] = "kē"; /* 鏭 */
dict[0x293ee] = "bǔ"; /* 鏮 */
dict[0x293ef] = "bó"; /* 鏯 */
dict[0x293f2] = "suì"; /* 鏲 */
dict[0x293f4] = "yù"; /* 鏴 */
dict[0x293f5] = "bǔ,bù"; /* 鏵 */
dict[0x293f6] = "jiū"; /* 鏶 */
dict[0x293f7] = "jiū,jiào"; /* 鏷 */
dict[0x293f9] = "juàn"; /* 鏹 */
dict[0x293fa] = "jué"; /* 鏺 */
dict[0x293fc] = "nà"; /* 鏼 */
dict[0x29401] = "xiè"; /* 鐁 */
dict[0x29405] = "sà"; /* 鐅 */
dict[0x29406] = "jī"; /* 鐆 */
dict[0x29409] = "xiè"; /* 鐉 */
dict[0x2940c] = "duì"; /* 鐌 */
dict[0x2940d] = "zǐ"; /* 鐍 */
dict[0x29418] = "yuǎn"; /* 鐘 */
dict[0x29419] = "qìn"; /* 鐙 */
dict[0x2941a] = "fú"; /* 鐚 */
dict[0x2941b] = "péng"; /* 鐛 */
dict[0x2941c] = "páo"; /* 鐜 */
dict[0x2941e] = "yìn"; /* 鐞 */
dict[0x29420] = "hōng"; /* 鐠 */
dict[0x29421] = "zú"; /* 鐡 */
dict[0x29423] = "gōng"; /* 鐣 */
dict[0x29424] = "dòng"; /* 鐤 */
dict[0x29425] = "hē"; /* 鐥 */
dict[0x29426] = "wò"; /* 鐦 */
dict[0x29428] = "pāng"; /* 鐨 */
dict[0x2942b] = "sù"; /* 鐫 */
dict[0x2942c] = "kǎn"; /* 鐬 */
dict[0x2942d] = "niè"; /* 鐭 */
dict[0x2942e] = "háo"; /* 鐮 */
dict[0x2942f] = "fèng"; /* 鐯 */
dict[0x29430] = "è"; /* 鐰 */
dict[0x29431] = "yè"; /* 鐱 */
dict[0x29434] = "tíng"; /* 鐴 */
dict[0x29435] = "dòng"; /* 鐵 */
dict[0x29436] = "zhé"; /* 鐶 */
dict[0x29437] = "sāng"; /* 鐷 */
dict[0x2943b] = "mò"; /* 鐻 */
dict[0x2943c] = "sù"; /* 鐼 */
dict[0x2943e] = "lè"; /* 鐾 */
dict[0x29440] = "pǔ"; /* 鑀 */
dict[0x29441] = "é"; /* 鑁 */
dict[0x29442] = "zhuó"; /* 鑂 */
dict[0x29443] = "yè"; /* 鑃 */
dict[0x29447] = "xiāng"; /* 鑇 */
dict[0x29448] = "guàng"; /* 鑈 */
dict[0x29449] = "rěn"; /* 鑉 */
dict[0x2944a] = "líng"; /* 鑊 */
dict[0x2944d] = "ào"; /* 鑍 */
dict[0x2944e] = "shùn"; /* 鑎 */
dict[0x29450] = "chāi"; /* 鑐 */
dict[0x29452] = "duó"; /* 鑒 */
dict[0x29453] = "qióng"; /* 鑓 */
dict[0x29454] = "kū,yà"; /* 鑔 */
dict[0x29455] = "xū"; /* 鑕 */
dict[0x29456] = "huán"; /* 鑖 */
dict[0x29457] = "yāo"; /* 鑗 */
dict[0x29458] = "zhèn"; /* 鑘 */
dict[0x29459] = "tǐng"; /* 鑙 */
dict[0x2945a] = "běng,lèi"; /* 鑚 */
dict[0x2945d] = "áng"; /* 鑝 */
dict[0x2945f] = "kān,qiān"; /* 鑟 */
dict[0x29461] = "kū,gěn"; /* 鑡 */
dict[0x29462] = "péi,bāi"; /* 鑢 */
dict[0x29463] = "yòu"; /* 鑣 */
dict[0x29464] = "ǎo"; /* 鑤 */
dict[0x29465] = "mén"; /* 鑥 */
dict[0x29466] = "mò"; /* 鑦 */
dict[0x2946c] = "fǔ,guī"; /* 鑬 */
dict[0x2946d] = "qīng"; /* 鑭 */
dict[0x2946e] = "là"; /* 鑮 */
dict[0x2946f] = "dǒu"; /* 鑯 */
dict[0x29470] = "tǎn"; /* 鑰 */
dict[0x29473] = "qiǎn"; /* 鑳 */
dict[0x29474] = "yào"; /* 鑴 */
dict[0x29475] = "wèi"; /* 鑵 */
dict[0x29476] = "hú,kū"; /* 鑶 */
dict[0x29477] = "mò"; /* 鑷 */
dict[0x29478] = "hē"; /* 鑸 */
dict[0x29479] = "xuàn"; /* 鑹 */
dict[0x2947b] = "bì,pó"; /* 鑻 */
dict[0x2947c] = "pō"; /* 鑼 */
dict[0x2947e] = "dī"; /* 鑾 */
dict[0x29480] = "zhěn"; /* 钀 */
dict[0x29482] = "shī"; /* 钂 */
dict[0x29483] = "kǎn"; /* 钃 */
dict[0x29484] = "cè"; /* 钄 */
dict[0x29487] = "xū"; /* 钇 */
dict[0x29488] = "zhěn"; /* 针 */
dict[0x2948a] = "zhǔ"; /* 钊 */
dict[0x2948f] = "huì"; /* 钏 */
dict[0x29490] = "chǐ"; /* 钐 */
dict[0x29493] = "hǒng"; /* 钓 */
dict[0x29494] = "nóu"; /* 钔 */
dict[0x29495] = "niè,pò,è"; /* 钕 */
dict[0x29496] = "yàn"; /* 钖 */
dict[0x29498] = "chǒng"; /* 钘 */
dict[0x29499] = "fǔ,guì"; /* 钙 */
dict[0x2949a] = "guāng"; /* 钚 */
dict[0x2949b] = "qī"; /* 钛 */
dict[0x2949c] = "duǒ"; /* 钜 */
dict[0x2949d] = "gěn"; /* 钝 */
dict[0x2949e] = "tǐng"; /* 钞 */
dict[0x294a2] = "tǎn"; /* 钢 */
dict[0x294a3] = "qiǎn"; /* 钣 */
dict[0x294a6] = "jiù,xìn"; /* 钦 */
dict[0x294a7] = "xū"; /* 钧 */
dict[0x294a8] = "qǐ"; /* 钨 */
dict[0x294aa] = "zhèn"; /* 钪 */
dict[0x294ae] = "qiú"; /* 钮 */
dict[0x294b0] = "ě"; /* 钰 */
dict[0x294b3] = "huì"; /* 钳 */
dict[0x294b4] = "hòng"; /* 钴 */
dict[0x294b5] = "qǐng"; /* 钵 */
dict[0x294b7] = "chē,rǒng"; /* 钷 */
dict[0x294ba] = "fù"; /* 钺 */
dict[0x294bc] = "hōng"; /* 钼 */
dict[0x294bd] = "xī"; /* 钽 */
dict[0x294be] = "wú"; /* 钾 */
dict[0x294bf] = "máng"; /* 钿 */
dict[0x294c2] = "tī"; /* 铂 */
dict[0x294c5] = "hōng"; /* 铅 */
dict[0x294d0] = "bó"; /* 铐 */
dict[0x294d2] = "qǐn"; /* 铒 */
dict[0x294d3] = "gěn"; /* 铓 */
dict[0x294d6] = "fú"; /* 铖 */
dict[0x294d7] = "kuǐ"; /* 铗 */
dict[0x294dd] = "bié"; /* 铝 */
dict[0x294de] = "jìng"; /* 铞 */
dict[0x294df] = "kǎn"; /* 铟 */
dict[0x294e0] = "guī"; /* 铠 */
dict[0x294e2] = "gǎo"; /* 铢 */
dict[0x294e3] = "xū"; /* 铣 */
dict[0x294e4] = "àn"; /* 铤 */
dict[0x294e5] = "yuè"; /* 铥 */
dict[0x294e6] = "wù"; /* 铦 */
dict[0x294e7] = "yí"; /* 铧 */
dict[0x294e8] = "jīng"; /* 铨 */
dict[0x294ea] = "lù"; /* 铪 */
dict[0x294eb] = "quán"; /* 铫 */
dict[0x294ec] = "tuí"; /* 铬 */
dict[0x294ee] = "jì"; /* 铮 */
dict[0x294f8] = "guī"; /* 铸 */
dict[0x294fa] = "jiǒng"; /* 铺 */
dict[0x294fb] = "jué"; /* 铻 */
dict[0x294fc] = "piē"; /* 铼 */
dict[0x294fd] = "kūn"; /* 铽 */
dict[0x29500] = "wài"; /* 销 */
dict[0x29501] = "huì"; /* 锁 */
dict[0x29502] = "dùn"; /* 锂 */
dict[0x29503] = "yuǎn"; /* 锃 */
dict[0x29504] = "jié"; /* 锄 */
dict[0x29506] = "guì"; /* 锆 */
dict[0x29507] = "gǎo"; /* 锇 */
dict[0x29508] = "pò"; /* 锈 */
dict[0x29509] = "mén,mín,hūn"; /* 锉 */
dict[0x2950a] = "zhuàn"; /* 锊 */
dict[0x2950b] = "hàng"; /* 锋 */
dict[0x29514] = "yóng"; /* 锔 */
dict[0x29515] = "qiú"; /* 锕 */
dict[0x29517] = "lèi,lì"; /* 锗 */
dict[0x29518] = "áng"; /* 锘 */
dict[0x29519] = "pǐ,xìn"; /* 错 */
dict[0x2951a] = "wēng,wěng"; /* 锚 */
dict[0x2951d] = "qìn"; /* 锝 */
dict[0x2951e] = "hán"; /* 锞 */
dict[0x2951f] = "qǐn"; /* 锟 */
dict[0x29520] = "miè"; /* 锠 */
dict[0x29521] = "dōu"; /* 锡 */
dict[0x29522] = "mí"; /* 锢 */
dict[0x29523] = "zhān"; /* 锣 */
dict[0x29525] = "qǐng"; /* 锥 */
dict[0x29526] = "yí"; /* 锦 */
dict[0x2952e] = "bān"; /* 键 */
dict[0x29531] = "juān"; /* 锱 */
dict[0x29533] = "zé"; /* 锳 */
dict[0x29534] = "xù"; /* 锴 */
dict[0x29535] = "lán"; /* 锵 */
dict[0x29536] = "má"; /* 锶 */
dict[0x29537] = "má"; /* 锷 */
dict[0x29538] = "ōu"; /* 锸 */
dict[0x29539] = "bēi"; /* 锹 */
dict[0x2953b] = "póu"; /* 锻 */
dict[0x2953c] = "xù"; /* 锼 */
dict[0x29540] = "ào"; /* 镀 */
dict[0x29544] = "xìn"; /* 镄 */
dict[0x29546] = "hǒng"; /* 镆 */
dict[0x29549] = "hǒng"; /* 镉 */
dict[0x2954a] = "zhǎn"; /* 镊 */
dict[0x2954c] = "sěn"; /* 镌 */
dict[0x2954d] = "gǎo,háo"; /* 镍 */
dict[0x2954f] = "pó,fán"; /* 镏 */
dict[0x29550] = "liào"; /* 镐 */
dict[0x29555] = "wài"; /* 镕 */
dict[0x29556] = "xuān"; /* 镖 */
dict[0x2955c] = "kuí"; /* 镜 */
dict[0x2955f] = "è"; /* 镟 */
dict[0x29560] = "hàn"; /* 镠 */
dict[0x29561] = "sè"; /* 镡 */
dict[0x29564] = "dàn"; /* 镤 */
dict[0x2956a] = "xuān"; /* 镪 */
dict[0x2956c] = "è"; /* 镬 */
dict[0x2956d] = "gài"; /* 镭 */
dict[0x2956f] = "dāo"; /* 镯 */
dict[0x29571] = "měng"; /* 镱 */
dict[0x29572] = "yī"; /* 镲 */
dict[0x29573] = "nǐng"; /* 镳 */
dict[0x29575] = "pín"; /* 镵 */
dict[0x29579] = "cāng"; /* 镹 */
dict[0x2957a] = "wài"; /* 镺 */
dict[0x2957e] = "yuàn"; /* 镾 */
dict[0x29580] = "è"; /* 門 */
dict[0x29581] = "niè,yá"; /* 閁 */
dict[0x29584] = "yǐn"; /* 閄 */
dict[0x29587] = "qiāo"; /* 閇 */
dict[0x29589] = "hōng"; /* 閉 */
dict[0x2958a] = "líng"; /* 閊 */
dict[0x2958c] = "chān"; /* 閌 */
dict[0x2958d] = "yǐng"; /* 閍 */
dict[0x29592] = "guān"; /* 閒 */
dict[0x29593] = "pín"; /* 間 */
dict[0x29594] = "niǎo"; /* 閔 */
dict[0x2959b] = "péng"; /* 閛 */
dict[0x2959d] = "liáo"; /* 閝 */
dict[0x295a0] = "bèi"; /* 閠 */
dict[0x295a3] = "xín,bá"; /* 閣 */
dict[0x295a4] = "tún"; /* 閤 */
dict[0x295a5] = "chāo"; /* 閥 */
dict[0x295a6] = "gān"; /* 閦 */
dict[0x295a8] = "hū"; /* 閨 */
dict[0x295a9] = "wǎng"; /* 閩 */
dict[0x295ac] = "fú"; /* 閬 */
dict[0x295ad] = "pèi"; /* 閭 */
dict[0x295af] = "náo"; /* 閯 */
dict[0x295b0] = "xún,xín"; /* 閰 */
dict[0x295b1] = "xuè"; /* 閱 */
dict[0x295b4] = "liǔ"; /* 閴 */
dict[0x295b5] = "líng"; /* 閵 */
dict[0x295b6] = "xuè"; /* 閶 */
dict[0x295b7] = "qū"; /* 閷 */
dict[0x295b8] = "háo"; /* 閸 */
dict[0x295b9] = "yí"; /* 閹 */
dict[0x295ba] = "hàn"; /* 閺 */
dict[0x295bc] = "fú"; /* 閼 */
dict[0x295bd] = "bá"; /* 閽 */
dict[0x295be] = "yí"; /* 閾 */
dict[0x295c0] = "bó"; /* 闀 */
dict[0x295c4] = "hōng"; /* 闄 */
dict[0x295c5] = "lì"; /* 闅 */
dict[0x295c9] = "sà"; /* 闉 */
dict[0x295ca] = "xī"; /* 闊 */
dict[0x295ce] = "shì"; /* 闎 */
dict[0x295cf] = "piāo"; /* 闏 */
dict[0x295d0] = "huà"; /* 闐 */
dict[0x295d1] = "yí"; /* 闑 */
dict[0x295d2] = "bó"; /* 闒 */
dict[0x295d3] = "bó"; /* 闓 */
dict[0x295d4] = "něi"; /* 闔 */
dict[0x295d5] = "qiú"; /* 闕 */
dict[0x295d8] = "wěi"; /* 闘 */
dict[0x295d9] = "chè"; /* 闙 */
dict[0x295da] = "yóu"; /* 闚 */
dict[0x295dc] = "wèi"; /* 關 */
dict[0x295dd] = "huǐ"; /* 闝 */
dict[0x295de] = "sà"; /* 闞 */
dict[0x295e2] = "hòng"; /* 闢 */
dict[0x295e3] = "sōu"; /* 闣 */
dict[0x295e4] = "hàn"; /* 闤 */
dict[0x295e5] = "páo"; /* 闥 */
dict[0x295e7] = "fáng"; /* 闧 */
dict[0x295e9] = "liú"; /* 闩 */
dict[0x295ea] = "zhòu"; /* 闪 */
dict[0x295eb] = "pí"; /* 闫 */
dict[0x295ed] = "lì"; /* 闭 */
dict[0x295f0] = "chuí"; /* 闰 */
dict[0x295f1] = "xī"; /* 闱 */
dict[0x295f2] = "zhēng"; /* 闲 */
dict[0x295f4] = "bèng"; /* 间 */
dict[0x295f5] = "zhěng"; /* 闵 */
dict[0x295f6] = "suì"; /* 闶 */
dict[0x295f7] = "yǎn"; /* 闷 */
dict[0x295fa] = "yáng"; /* 闺 */
dict[0x295fc] = "qīng"; /* 闼 */
dict[0x295fd] = "wù"; /* 闽 */
dict[0x295fe] = "liǎng"; /* 闾 */
dict[0x29600] = "zhào"; /* 阀 */
dict[0x29601] = "liáng"; /* 阁 */
dict[0x29605] = "jiē"; /* 阅 */
dict[0x29607] = "hōng"; /* 阇 */
dict[0x29608] = "yōu"; /* 阈 */
dict[0x2960a] = "là"; /* 阊 */
dict[0x2960b] = "hòu"; /* 阋 */
dict[0x2960d] = "yuàn"; /* 阍 */
dict[0x2960e] = "hóng"; /* 阎 */
dict[0x2960f] = "yè"; /* 阏 */
dict[0x29611] = "yǐng,yīng"; /* 阑 */
dict[0x29612] = "xuǎn,juān"; /* 阒 */
dict[0x29613] = "yóu"; /* 阓 */
dict[0x29618] = "quán"; /* 阘 */
dict[0x2961c] = "táng"; /* 阜 */
dict[0x2961d] = "suǒ"; /* 阝 */
dict[0x2961f] = "lì"; /* 队 */
dict[0x29620] = "sōu"; /* 阠 */
dict[0x29621] = "lì"; /* 阡 */
dict[0x29624] = "yù"; /* 阤 */
dict[0x29625] = "kǎi"; /* 阥 */
dict[0x29627] = "yì"; /* 阧 */
dict[0x2962d] = "xiū"; /* 阭 */
dict[0x2962e] = "áo"; /* 阮 */
dict[0x2962f] = "tuán"; /* 阯 */
dict[0x29630] = "sù"; /* 阰 */
dict[0x29631] = "shuài"; /* 阱 */
dict[0x29633] = "yù"; /* 阳 */
dict[0x29635] = "fēng"; /* 阵 */
dict[0x29639] = "sù"; /* 阹 */
dict[0x2963a] = "tuí"; /* 阺 */
dict[0x2963b] = "yù"; /* 阻 */
dict[0x2963c] = "zhēng"; /* 阼 */
dict[0x2963d] = "zhēng"; /* 阽 */
dict[0x2963f] = "táo"; /* 阿 */
dict[0x29644] = "liú"; /* 附 */
dict[0x29646] = "chéng"; /* 陆 */
dict[0x29647] = "suí"; /* 陇 */
dict[0x29648] = "sāo"; /* 陈 */
dict[0x2964f] = "gǔ"; /* 陏 */
dict[0x29650] = "fēng"; /* 限 */
dict[0x29651] = "liè"; /* 陑 */
dict[0x29652] = "piāo,piào"; /* 陒 */
dict[0x29656] = "lì"; /* 陖 */
dict[0x29658] = "lóng"; /* 陘 */
dict[0x29659] = "chū"; /* 陙 */
dict[0x2965a] = "xiāo"; /* 陚 */
dict[0x2965b] = "hōng"; /* 陛 */
dict[0x2965c] = "xiè"; /* 陜 */
dict[0x2965d] = "shè"; /* 陝 */
dict[0x29660] = "lóng"; /* 陠 */
dict[0x29661] = "hōu"; /* 陡 */
dict[0x29662] = "xuán,shī"; /* 院 */
dict[0x29663] = "fēng"; /* 陣 */
dict[0x29672] = "fēi"; /* 陲 */
dict[0x29677] = "niù"; /* 陷 */
dict[0x29678] = "mǎng"; /* 陸 */
dict[0x2967a] = "yì"; /* 険 */
dict[0x2967d] = "huán,xuān"; /* 陽 */
dict[0x2967e] = "zhī"; /* 陾 */
dict[0x29682] = "yì"; /* 隂 */
dict[0x29684] = "yù"; /* 隄 */
dict[0x29687] = "yí"; /* 隇 */
dict[0x29688] = "yuē"; /* 隈 */
dict[0x29689] = "chí"; /* 隉 */
dict[0x2968f] = "sūn"; /* 随 */
dict[0x29695] = "yǐn,qiāng"; /* 隕 */
dict[0x29696] = "niù"; /* 隖 */
dict[0x29697] = "rǒng"; /* 隗 */
dict[0x2969b] = "nà"; /* 際 */
dict[0x296a3] = "tián"; /* 隣 */
dict[0x296a5] = "bā"; /* 隥 */
dict[0x296a9] = "hú"; /* 隩 */
dict[0x296aa] = "ěr"; /* 險 */
dict[0x296ab] = "zhēng"; /* 隫 */
dict[0x296ac] = "è"; /* 隬 */
dict[0x296ad] = "póu"; /* 隭 */
dict[0x296ae] = "jī,nì"; /* 隮 */
dict[0x296af] = "ní"; /* 隯 */
dict[0x296b1] = "jiǒng"; /* 隱 */
dict[0x296b2] = "jiá"; /* 隲 */
dict[0x296b5] = "gān"; /* 隵 */
dict[0x296b9] = "líng"; /* 隹 */
dict[0x296bb] = "zuì"; /* 隻 */
dict[0x296be] = "bèi"; /* 难 */
dict[0x296bf] = "yù"; /* 隿 */
dict[0x296c5] = "shū"; /* 雅 */
dict[0x296c6] = "yǐ"; /* 集 */
dict[0x296c7] = "pāi"; /* 雇 */
dict[0x296cb] = "nǎo"; /* 雋 */
dict[0x296cc] = "shì"; /* 雌 */
dict[0x296ce] = "mǎn"; /* 雎 */
dict[0x296cf] = "shì"; /* 雏 */
dict[0x296d1] = "tí"; /* 雑 */
dict[0x296d8] = "gōng"; /* 雘 */
dict[0x296dd] = "lèi"; /* 雝 */
dict[0x296de] = "bǎo,něi,piǎo"; /* 雞 */
dict[0x296df] = "yuān,mán"; /* 雟 */
dict[0x296e0] = "zuō"; /* 雠 */
dict[0x296e1] = "láng,náng"; /* 雡 */
dict[0x296e2] = "xiū"; /* 離 */
dict[0x296e5] = "zài"; /* 雥 */
dict[0x296e6] = "chèng"; /* 雦 */
dict[0x296e7] = "jiān"; /* 雧 */
dict[0x296e8] = "mào"; /* 雨 */
dict[0x296e9] = "jiá"; /* 雩 */
dict[0x296ea] = "yù"; /* 雪 */
dict[0x296ed] = "yù"; /* 雭 */
dict[0x296ee] = "yí"; /* 雮 */
dict[0x296f2] = "māng"; /* 雲 */
dict[0x296f3] = "zài,cān"; /* 雳 */
dict[0x296f5] = "zhuì"; /* 雵 */
dict[0x296f6] = "tí"; /* 零 */
dict[0x296f9] = "xì"; /* 雹 */
dict[0x296fa] = "jú"; /* 雺 */
dict[0x296fb] = "zàn,zuǎn,zhān"; /* 電 */
dict[0x296fc] = "lù"; /* 雼 */
dict[0x296fd] = "táo"; /* 雽 */
dict[0x296ff] = "xíng"; /* 雿 */
dict[0x29700] = "zhuì,duī"; /* 需 */
dict[0x29701] = "líng"; /* 霁 */
dict[0x29703] = "jù"; /* 霃 */
dict[0x29706] = "jī"; /* 霆 */
dict[0x29707] = "juàn,juǎn"; /* 震 */
dict[0x29708] = "yù"; /* 霈 */
dict[0x2970a] = "zī"; /* 霊 */
dict[0x2970c] = "yuē"; /* 霌 */
dict[0x2970d] = "dōng"; /* 霍 */
dict[0x29712] = "nǎng"; /* 霒 */
dict[0x29716] = "chóng"; /* 霖 */
dict[0x2971f] = "àng"; /* 霟 */
dict[0x29720] = "mǎn"; /* 霠 */
dict[0x29723] = "gēng"; /* 霣 */
dict[0x29725] = "bō"; /* 霥 */
dict[0x29726] = "dìng"; /* 霦 */
dict[0x29727] = "wěi"; /* 霧 */
dict[0x2972c] = "quán"; /* 霬 */
dict[0x2972d] = "kē"; /* 霭 */
dict[0x29730] = "pì"; /* 霰 */
dict[0x29731] = "kǎn,sǎn"; /* 霱 */
dict[0x29732] = "fú"; /* 露 */
dict[0x29733] = "yǒng"; /* 霳 */
dict[0x29735] = "tuán"; /* 霵 */
dict[0x29736] = "tǒu"; /* 霶 */
dict[0x29737] = "yòu,niù"; /* 霷 */
dict[0x29738] = "yāo"; /* 霸 */
dict[0x2973a] = "yē"; /* 霺 */
dict[0x2973d] = "yàn"; /* 霽 */
dict[0x29748] = "xián"; /* 靈 */
dict[0x2974a] = "tí"; /* 靊 */
dict[0x2974c] = "suì"; /* 靌 */
dict[0x2974d] = "hóu"; /* 靍 */
dict[0x29750] = "cí"; /* 靐 */
dict[0x29751] = "xuān"; /* 靑 */
dict[0x29754] = "xǔ"; /* 靔 */
dict[0x29755] = "wù"; /* 靕 */
dict[0x29756] = "cān"; /* 靖 */
dict[0x29757] = "yù"; /* 靗 */
dict[0x2975a] = "chǎn"; /* 靚 */
dict[0x2975b] = "xiá"; /* 靛 */
dict[0x2975d] = "kào,gāo"; /* 靝 */
dict[0x2975e] = "cāng"; /* 非 */
dict[0x2975f] = "chā"; /* 靟 */
dict[0x29760] = "qiǔ"; /* 靠 */
dict[0x29763] = "dā"; /* 靣 */
dict[0x29765] = "sù"; /* 靥 */
dict[0x29766] = "zhāi"; /* 靦 */
dict[0x29768] = "huā"; /* 靨 */
dict[0x29777] = "wū"; /* 靷 */
dict[0x29778] = "yuān"; /* 靸 */
dict[0x2977d] = "jiàng"; /* 靽 */
dict[0x2977e] = "xiǎng"; /* 靾 */
dict[0x2977f] = "zhāi"; /* 靿 */
dict[0x29780] = "sǎn,chěn,càn"; /* 鞀 */
dict[0x29781] = "mó,mí"; /* 鞁 */
dict[0x29783] = "shǎng,xiǎng"; /* 鞃 */
dict[0x29784] = "cáo"; /* 鞄 */
dict[0x29785] = "suī"; /* 鞅 */
dict[0x29786] = "chuáng"; /* 鞆 */
dict[0x29787] = "mí"; /* 鞇 */
dict[0x29788] = "zhú"; /* 鞈 */
dict[0x29789] = "chóng"; /* 鞉 */
dict[0x2978a] = "jì"; /* 鞊 */
dict[0x2978b] = "chóng"; /* 鞋 */
dict[0x29791] = "fēn"; /* 鞑 */
dict[0x29799] = "lián"; /* 鞙 */
dict[0x2979e] = "hài"; /* 鞞 */
dict[0x297a3] = "tāo"; /* 鞣 */
dict[0x297a4] = "dūn"; /* 鞤 */
dict[0x297a5] = "xiǎng"; /* 鞥 */
dict[0x297a6] = "chēng"; /* 鞦 */
dict[0x297a7] = "shǎng"; /* 鞧 */
dict[0x297a8] = "lì"; /* 鞨 */
dict[0x297a9] = "huáng"; /* 鞩 */
dict[0x297ac] = "dèng"; /* 鞬 */
dict[0x297b6] = "zā"; /* 鞶 */
dict[0x297b7] = "liù"; /* 鞷 */
dict[0x297ba] = "huò"; /* 鞺 */
dict[0x297bb] = "lín"; /* 鞻 */
dict[0x297be] = "dú,yì"; /* 鞾 */
dict[0x297bf] = "hàn"; /* 鞿 */
dict[0x297c0] = "yōng,yǒng"; /* 韀 */
dict[0x297c1] = "yuàn,xuàn"; /* 韁 */
dict[0x297c2] = "guò"; /* 韂 */
dict[0x297c3] = "líng"; /* 韃 */
dict[0x297c5] = "liǎn"; /* 韅 */
dict[0x297c7] = "ào"; /* 韇 */
dict[0x297c8] = "dāng"; /* 韈 */
dict[0x297c9] = "yì"; /* 韉 */
dict[0x297ca] = "nóng"; /* 韊 */
dict[0x297cb] = "shàn"; /* 韋 */
dict[0x297cd] = "xìn"; /* 韍 */
dict[0x297d0] = "dá"; /* 韐 */
dict[0x297d1] = "yù"; /* 韑 */
dict[0x297d2] = "cān"; /* 韒 */
dict[0x297d3] = "wò"; /* 韓 */
dict[0x297d4] = "chá"; /* 韔 */
dict[0x297d5] = "bó"; /* 韕 */
dict[0x297d7] = "jiǎn"; /* 韗 */
dict[0x297de] = "méng"; /* 韞 */
dict[0x297df] = "wěi"; /* 韟 */
dict[0x297e0] = "mó"; /* 韠 */
dict[0x297e5] = "shuì,juǎn"; /* 韥 */
dict[0x297e6] = "jié"; /* 韦 */
dict[0x297e7] = "shuò"; /* 韧 */
dict[0x297e8] = "huò"; /* 韨 */
dict[0x297eb] = "chuò"; /* 韫 */
dict[0x297ed] = "lóng"; /* 韭 */
dict[0x297ee] = "huài"; /* 韮 */
dict[0x297f0] = "tuō"; /* 韰 */
dict[0x297f3] = "yú"; /* 音 */
dict[0x297f4] = "sǎn"; /* 韴 */
dict[0x297f6] = "chàn,jié"; /* 韶 */
dict[0x297f7] = "yōng"; /* 韷 */
dict[0x297f8] = "huò"; /* 韸 */
dict[0x297fa] = "lǎn"; /* 韺 */
dict[0x29811] = "dǐng"; /* 頑 */
dict[0x2981a] = "hái"; /* 頚 */
dict[0x2981f] = "wǔ"; /* 頟 */
dict[0x29826] = "qǐ,shǒu"; /* 頦 */
dict[0x29828] = "jī,qǐ"; /* 頨 */
dict[0x2982e] = "kuí"; /* 頮 */
dict[0x2982f] = "wéi"; /* 頯 */
dict[0x29836] = "shǒu"; /* 頶 */
dict[0x29837] = "fú"; /* 頷 */
dict[0x29839] = "tuán"; /* 頹 */
dict[0x2983b] = "bié,hān"; /* 頻 */
dict[0x2983d] = "tán"; /* 頽 */
dict[0x2983e] = "hāng"; /* 頾 */
dict[0x2983f] = "piē"; /* 頿 */
dict[0x29843] = "yú"; /* 顃 */
dict[0x29844] = "tán,xiāng"; /* 顄 */
dict[0x2984c] = "xiāng"; /* 題 */
dict[0x2984e] = "xiū"; /* 顎 */
dict[0x29853] = "wěng"; /* 顓 */
dict[0x29854] = "hài"; /* 顔 */
dict[0x29855] = "péng"; /* 顕 */
dict[0x2985d] = "tán"; /* 顝 */
dict[0x2985f] = "bié"; /* 顟 */
dict[0x29860] = "xiāng"; /* 顠 */
dict[0x29863] = "yǐ"; /* 顣 */
dict[0x29866] = "piáo"; /* 顦 */
dict[0x29867] = "huán"; /* 顧 */
dict[0x29868] = "mǔ"; /* 顨 */
dict[0x29869] = "bā"; /* 顩 */
dict[0x2986b] = "fàn"; /* 顫 */
dict[0x2986d] = "bó"; /* 顭 */
dict[0x2986f] = "dīng"; /* 顯 */
dict[0x29877] = "fēn,fèi"; /* 顷 */
dict[0x2987a] = "jiè"; /* 顺 */
dict[0x2987e] = "suó"; /* 顾 */
dict[0x29884] = "wàn"; /* 预 */
dict[0x29885] = "gē"; /* 颅 */
dict[0x29888] = "fēn"; /* 颈 */
dict[0x2988a] = "tuó"; /* 颊 */
dict[0x2988c] = "wén"; /* 颌 */
dict[0x2988d] = "guā"; /* 颍 */
dict[0x2988e] = "duō"; /* 颎 */
dict[0x29890] = "zhé"; /* 颐 */
dict[0x29891] = "cǐ"; /* 频 */
dict[0x29892] = "yǎo"; /* 颒 */
dict[0x29894] = "bàn"; /* 颔 */
dict[0x29895] = "bù"; /* 颕 */
dict[0x29896] = "mò"; /* 颖 */
dict[0x29898] = "pǒ"; /* 题 */
dict[0x2989b] = "gé"; /* 颛 */
dict[0x2989e] = "liú"; /* 颞 */
dict[0x298a1] = "rǎn"; /* 颡 */
dict[0x298a8] = "gān"; /* 風 */
dict[0x298aa] = "hú"; /* 颪 */
dict[0x298ab] = "móu"; /* 颫 */
dict[0x298ae] = "xiū"; /* 颮 */
dict[0x298af] = "huāng"; /* 颯 */
dict[0x298b0] = "fú"; /* 颰 */
dict[0x298b1] = "huí"; /* 颱 */
dict[0x298b2] = "shì"; /* 颲 */
dict[0x298b3] = "qú"; /* 颳 */
dict[0x298b4] = "jié,jí"; /* 颴 */
dict[0x298b5] = "tuō"; /* 颵 */
dict[0x298b6] = "yú"; /* 颶 */
dict[0x298b7] = "mò"; /* 颷 */
dict[0x298b8] = "zhōu"; /* 颸 */
dict[0x298b9] = "jiù"; /* 颹 */
dict[0x298bb] = "shú"; /* 颻 */
dict[0x298bc] = "kuāng"; /* 颼 */
dict[0x298bd] = "qióng"; /* 颽 */
dict[0x298be] = "liè"; /* 颾 */
dict[0x298bf] = "fù"; /* 颿 */
dict[0x298ca] = "xù"; /* 飊 */
dict[0x298d6] = "lìn"; /* 飖 */
dict[0x298d8] = "niè"; /* 飘 */
dict[0x298da] = "pī,bǐ"; /* 飚 */
dict[0x298dc] = "fù"; /* 飜 */
dict[0x298dd] = "bù"; /* 飝 */
dict[0x298de] = "yì,sà"; /* 飞 */
dict[0x298e1] = "bó"; /* 飡 */
dict[0x298e3] = "é,ě"; /* 飣 */
dict[0x298e9] = "zhé"; /* 飩 */
dict[0x298eb] = "lì"; /* 飫 */
dict[0x298ee] = "tù"; /* 飮 */
dict[0x298ef] = "dá"; /* 飯 */
dict[0x298f1] = "lù"; /* 飱 */
dict[0x298f2] = "yān"; /* 飲 */
dict[0x298f3] = "dōng"; /* 飳 */
dict[0x298f4] = "qiè"; /* 飴 */
dict[0x298f5] = "wǎn"; /* 飵 */
dict[0x298f6] = "mǐng"; /* 飶 */
dict[0x298f7] = "zuī,zhù"; /* 飷 */
dict[0x298f8] = "fù"; /* 飸 */
dict[0x298f9] = "qū"; /* 飹 */
dict[0x298fa] = "bēn"; /* 飺 */
dict[0x298fb] = "ǎo"; /* 飻 */
dict[0x298fc] = "qiāng"; /* 飼 */
dict[0x29901] = "qūn"; /* 餁 */
dict[0x29908] = "què"; /* 餈 */
dict[0x29909] = "huá,táo"; /* 餉 */
dict[0x2990a] = "xiàn,jiàn"; /* 養 */
dict[0x2990b] = "kùn"; /* 餋 */
dict[0x2990f] = "cuì"; /* 餏 */
dict[0x29912] = "yí"; /* 餒 */
dict[0x29916] = "chī,ér"; /* 餖 */
dict[0x29917] = "zòng"; /* 餗 */
dict[0x29918] = "nǎo"; /* 餘 */
dict[0x29919] = "chéng"; /* 餙 */
dict[0x2991a] = "duān"; /* 餚 */
dict[0x2991b] = "yóng"; /* 餛 */
dict[0x2991c] = "zhě"; /* 餜 */
dict[0x2991e] = "tàn"; /* 餞 */
dict[0x2991f] = "yáng"; /* 餟 */
dict[0x29920] = "xié"; /* 餠 */
dict[0x29921] = "xuān"; /* 餡 */
dict[0x29923] = "duàn"; /* 餣 */
dict[0x29924] = "shuǎ"; /* 餤 */
dict[0x29925] = "xián"; /* 餥 */
dict[0x29926] = "xián"; /* 餦 */
dict[0x29929] = "é"; /* 餩 */
dict[0x29932] = "lā"; /* 餲 */
dict[0x29938] = "wèi"; /* 餸 */
dict[0x29939] = "yōu"; /* 餹 */
dict[0x2993a] = "yú"; /* 餺 */
dict[0x2993d] = "tī"; /* 餽 */
dict[0x2993f] = "jīn"; /* 餿 */
dict[0x29941] = "táng"; /* 饁 */
dict[0x29942] = "qí"; /* 饂 */
dict[0x29943] = "méng"; /* 饃 */
dict[0x29944] = "diān"; /* 饄 */
dict[0x29945] = "tāo"; /* 饅 */
dict[0x29946] = "lǜ"; /* 饆 */
dict[0x29947] = "zhàn"; /* 饇 */
dict[0x29948] = "wēn"; /* 饈 */
dict[0x29949] = "jì"; /* 饉 */
dict[0x2994a] = "āo,jiāo"; /* 饊 */
dict[0x2994b] = "òu,dú"; /* 饋 */
dict[0x2994c] = "qià"; /* 饌 */
dict[0x2994d] = "xīng"; /* 饍 */
dict[0x29950] = "shī"; /* 饐 */
dict[0x29951] = "tǎ"; /* 饑 */
dict[0x29954] = "mò"; /* 饔 */
dict[0x29958] = "yóu"; /* 饘 */
dict[0x29960] = "zhá"; /* 饠 */
dict[0x29963] = "yáo"; /* 饣 */
dict[0x2996b] = "chōng"; /* 饫 */
dict[0x2996c] = "lí"; /* 饬 */
dict[0x2996d] = "yú"; /* 饭 */
dict[0x2996e] = "chǎn"; /* 饮 */
dict[0x2996f] = "yī"; /* 饯 */
dict[0x29972] = "chì"; /* 饲 */
dict[0x29974] = "lí"; /* 饴 */
dict[0x2997d] = "tú"; /* 饽 */
dict[0x2997f] = "zú"; /* 饿 */
dict[0x29982] = "xián"; /* 馂 */
dict[0x29987] = "xì"; /* 馇 */
dict[0x29989] = "bié"; /* 馉 */
dict[0x2998a] = "hán,qiān"; /* 馊 */
dict[0x2998b] = "qí"; /* 馋 */
dict[0x2998c] = "sāng,shuāng"; /* 馌 */
dict[0x2998e] = "fēi,fěi"; /* 馎 */
dict[0x29990] = "shàn,huō"; /* 馐 */
dict[0x29998] = "huān"; /* 馘 */
dict[0x299a0] = "bàng"; /* 馠 */
dict[0x299a1] = "yú"; /* 馡 */
dict[0x299a2] = "yú"; /* 馢 */
dict[0x299a4] = "jí"; /* 馤 */
dict[0x299b1] = "kuǎi"; /* 馱 */
dict[0x299b2] = "zōng"; /* 馲 */
dict[0x299b7] = "tiě"; /* 馷 */
dict[0x299b9] = "xiàn"; /* 馹 */
dict[0x299ba] = "méng"; /* 馺 */
dict[0x299c0] = "tiě"; /* 駀 */
dict[0x299c1] = "zhòu"; /* 駁 */
dict[0x299c3] = "lì"; /* 駃 */
dict[0x299c4] = "zhì"; /* 駄 */
dict[0x299c5] = "fán"; /* 駅 */
dict[0x299c6] = "liè,là"; /* 駆 */
dict[0x299c7] = "cài"; /* 駇 */
dict[0x299c8] = "dú"; /* 駈 */
dict[0x299c9] = "guāng"; /* 駉 */
dict[0x299ca] = "xiòng"; /* 駊 */
dict[0x299cb] = "lí"; /* 駋 */
dict[0x299cc] = "qì"; /* 駌 */
dict[0x299cf] = "jué"; /* 駏 */
dict[0x299d0] = "tuō"; /* 駐 */
dict[0x299d2] = "jù"; /* 駒 */
dict[0x299d3] = "xiāo"; /* 駓 */
dict[0x299d8] = "qú"; /* 駘 */
dict[0x299dc] = "zhuǎn"; /* 駜 */
dict[0x299e1] = "jué"; /* 駡 */
dict[0x299ec] = "rǎn"; /* 駬 */
dict[0x299fb] = "wǎn"; /* 駻 */
dict[0x29a11] = "tīng"; /* 騑 */
dict[0x29a12] = "jī"; /* 騒 */
dict[0x29a13] = "qiān"; /* 験 */
dict[0x29a14] = "hú,huá"; /* 騔 */
dict[0x29a17] = "yú"; /* 騗 */
dict[0x29a18] = "qì,gē"; /* 騘 */
dict[0x29a19] = "yú"; /* 騙 */
dict[0x29a1a] = "wā"; /* 騚 */
dict[0x29a1c] = "bǎ"; /* 騜 */
dict[0x29a1d] = "qí"; /* 騝 */
dict[0x29a1e] = "sǎ"; /* 騞 */
dict[0x29a1f] = "qiāo"; /* 騟 */
dict[0x29a20] = "yà"; /* 騠 */
dict[0x29a21] = "xiǎn,sǎn"; /* 騡 */
dict[0x29a28] = "cī"; /* 騨 */
dict[0x29a29] = "fàn"; /* 騩 */
dict[0x29a2b] = "kǔn"; /* 騫 */
dict[0x29a2c] = "gǔn"; /* 騬 */
dict[0x29a2d] = "quē"; /* 騭 */
dict[0x29a2e] = "è"; /* 騮 */
dict[0x29a2f] = "qióng"; /* 騯 */
dict[0x29a32] = "mà"; /* 騲 */
dict[0x29a33] = "kū,dū"; /* 騳 */
dict[0x29a34] = "yǎo"; /* 騴 */
dict[0x29a37] = "quē"; /* 騷 */
dict[0x29a38] = "chū"; /* 騸 */
dict[0x29a39] = "jiǎ"; /* 騹 */
dict[0x29a3b] = "zhǔ"; /* 騻 */
dict[0x29a3d] = "duī"; /* 騽 */
dict[0x29a3e] = "wá"; /* 騾 */
dict[0x29a40] = "nǎo"; /* 驀 */
dict[0x29a44] = "yán"; /* 驄 */
dict[0x29a45] = "tóng"; /* 驅 */
dict[0x29a4b] = "xíng,jìng"; /* 驋 */
dict[0x29a4c] = "gǔn"; /* 驌 */
dict[0x29a4d] = "pīng"; /* 驍 */
dict[0x29a51] = "yǔ"; /* 驑 */
dict[0x29a52] = "hè"; /* 驒 */
dict[0x29a54] = "zhuó"; /* 驔 */
dict[0x29a57] = "shē"; /* 驗 */
dict[0x29a58] = "yǔ"; /* 驘 */
dict[0x29a5b] = "jì"; /* 驛 */
dict[0x29a5d] = "qiāng"; /* 驝 */
dict[0x29a5e] = "shuì"; /* 驞 */
dict[0x29a5f] = "chuò"; /* 驟 */
dict[0x29a60] = "zú"; /* 驠 */
dict[0x29a61] = "léng"; /* 驡 */
dict[0x29a62] = "ní"; /* 驢 */
dict[0x29a64] = "wā"; /* 驤 */
dict[0x29a65] = "zhá"; /* 驥 */
dict[0x29a67] = "dàn"; /* 驧 */
dict[0x29a6e] = "dù"; /* 驮 */
dict[0x29a6f] = "biàn"; /* 驯 */
dict[0x29a70] = "jiē,hái"; /* 驰 */
dict[0x29a71] = "qià"; /* 驱 */
dict[0x29a72] = "hé"; /* 驲 */
dict[0x29a73] = "chòng"; /* 驳 */
dict[0x29a74] = "yán"; /* 驴 */
dict[0x29a76] = "yàn"; /* 驶 */
dict[0x29a7a] = "sóng"; /* 驺 */
dict[0x29a7b] = "téng"; /* 驻 */
dict[0x29a7c] = "yǎo"; /* 驼 */
dict[0x29a7e] = "kāo"; /* 驾 */
dict[0x29a80] = "zhuī"; /* 骀 */
dict[0x29a81] = "guì"; /* 骁 */
dict[0x29a82] = "ái"; /* 骂 */
dict[0x29a83] = "hài"; /* 骃 */
dict[0x29a86] = "tǐ"; /* 骆 */
dict[0x29a88] = "suǒ"; /* 骈 */
dict[0x29a89] = "xù"; /* 骉 */
dict[0x29a8a] = "biāo"; /* 骊 */
dict[0x29a8c] = "fèng"; /* 验 */
dict[0x29a8d] = "qū,shū"; /* 骍 */
dict[0x29a8e] = "mǎng"; /* 骎 */
dict[0x29a90] = "guó"; /* 骐 */
dict[0x29a96] = "bì"; /* 骖 */
dict[0x29a97] = "jué"; /* 骗 */
dict[0x29a98] = "chuáng"; /* 骘 */
dict[0x29a9b] = "pú"; /* 骛 */
dict[0x29a9f] = "yì"; /* 骟 */
dict[0x29aa2] = "qiān"; /* 骢 */
dict[0x29aa3] = "yì"; /* 骣 */
dict[0x29aa4] = "è"; /* 骤 */
dict[0x29aa5] = "líng"; /* 骥 */
dict[0x29aa6] = "suǐ"; /* 骦 */
dict[0x29aa7] = "bì"; /* 骧 */
dict[0x29aad] = "huò"; /* 骭 */
dict[0x29aae] = "mǒ,mó"; /* 骮 */
dict[0x29ab1] = "xūn"; /* 骱 */
dict[0x29ab4] = "yàn"; /* 骴 */
dict[0x29ab8] = "lì"; /* 骸 */
dict[0x29aba] = "tán"; /* 骺 */
dict[0x29abe] = "luán"; /* 骾 */
dict[0x29ac0] = "kài"; /* 髀 */
dict[0x29ac1] = "mào"; /* 髁 */
dict[0x29ac2] = "xiāo"; /* 髂 */
dict[0x29ac7] = "ǎi"; /* 髇 */
dict[0x29aca] = "tǎ"; /* 髊 */
dict[0x29acd] = "mèi"; /* 髍 */
dict[0x29acf] = "guō,yōng"; /* 髏 */
dict[0x29ad3] = "gǎo"; /* 髓 */
dict[0x29ad4] = "náo"; /* 體 */
dict[0x29ad5] = "háo"; /* 髕 */
dict[0x29ad6] = "guō"; /* 髖 */
dict[0x29ada] = "háo"; /* 髚 */
dict[0x29ae0] = "quē"; /* 髠 */
dict[0x29ae5] = "cáo"; /* 髥 */
dict[0x29ae6] = "sào"; /* 髦 */
dict[0x29aeb] = "pí"; /* 髫 */
dict[0x29af2] = "xiē"; /* 髲 */
dict[0x29af3] = "xiāo"; /* 髳 */
dict[0x29af4] = "jú"; /* 髴 */
dict[0x29af9] = "chéng"; /* 髹 */
dict[0x29afa] = "nǎo"; /* 髺 */
dict[0x29b00] = "nèi"; /* 鬀 */
dict[0x29b0d] = "mǔ"; /* 鬍 */
dict[0x29b0f] = "shāo"; /* 鬏 */
dict[0x29b11] = "diān,chān"; /* 鬑 */
dict[0x29b14] = "líng"; /* 鬔 */
dict[0x29b16] = "zhěn"; /* 鬖 */
dict[0x29b17] = "yǎo"; /* 鬗 */
dict[0x29b19] = "fù,fū"; /* 鬙 */
dict[0x29b1a] = "qián,gàn"; /* 鬚 */
dict[0x29b1b] = "qióng"; /* 鬛 */
dict[0x29b1c] = "jú"; /* 鬜 */
dict[0x29b1d] = "bìng,fǎng"; /* 鬝 */
dict[0x29b1e] = "máo,mán,mián"; /* 鬞 */
dict[0x29b1f] = "zhà"; /* 鬟 */
dict[0x29b20] = "tāi"; /* 鬠 */
dict[0x29b2b] = "zhǎi"; /* 鬫 */
dict[0x29b2d] = "shī"; /* 鬭 */
dict[0x29b2e] = "yòng"; /* 鬮 */
dict[0x29b30] = "qióng"; /* 鬰 */
dict[0x29b31] = "dào"; /* 鬱 */
dict[0x29b32] = "tì"; /* 鬲 */
dict[0x29b33] = "zhuǐ"; /* 鬳 */
dict[0x29b35] = "yìn"; /* 鬵 */
dict[0x29b37] = "nǎo"; /* 鬷 */
dict[0x29b38] = "bō"; /* 鬸 */
dict[0x29b39] = "kuāng"; /* 鬹 */
dict[0x29b3a] = "zhǐ"; /* 鬺 */
dict[0x29b3b] = "duǒ"; /* 鬻 */
dict[0x29b3c] = "cōng"; /* 鬼 */
dict[0x29b3d] = "bǎo"; /* 鬽 */
dict[0x29b47] = "lí"; /* 魇 */
dict[0x29b4a] = "jú"; /* 魊 */
dict[0x29b4b] = "wén,kūn"; /* 魋 */
dict[0x29b4c] = "liè"; /* 魌 */
dict[0x29b4f] = "wǒ"; /* 魏 */
dict[0x29b50] = "shǐ"; /* 魐 */
dict[0x29b51] = "niǎo"; /* 魑 */
dict[0x29b52] = "máng"; /* 魒 */
dict[0x29b53] = "jiū"; /* 魓 */
dict[0x29b58] = "xiū"; /* 魘 */
dict[0x29b5b] = "jiǎo"; /* 魛 */
dict[0x29b5d] = "wō"; /* 魝 */
dict[0x29b5f] = "dào"; /* 魟 */
dict[0x29b61] = "xī"; /* 魡 */
dict[0x29b62] = "àn"; /* 魢 */
dict[0x29b63] = "dá"; /* 魣 */
dict[0x29b64] = "zǒng,zōng"; /* 魤 */
dict[0x29b65] = "hàn"; /* 魥 */
dict[0x29b66] = "chuí"; /* 魦 */
dict[0x29b67] = "bī,bān"; /* 魧 */
dict[0x29b69] = "dòng"; /* 魩 */
dict[0x29b6b] = "zhǎng"; /* 魫 */
dict[0x29b6f] = "yā"; /* 魯 */
dict[0x29b72] = "dí"; /* 魲 */
dict[0x29b73] = "huō"; /* 魳 */
dict[0x29b77] = "mín"; /* 魷 */
dict[0x29b7a] = "fù"; /* 魺 */
dict[0x29b7c] = "bǎo"; /* 魼 */
dict[0x29b7d] = "kè"; /* 魽 */
dict[0x29b7e] = "máo"; /* 魾 */
dict[0x29b7f] = "rè"; /* 魿 */
dict[0x29b80] = "zōng,zǒng,sōng"; /* 鮀 */
dict[0x29b81] = "qià"; /* 鮁 */
dict[0x29b82] = "xiā"; /* 鮂 */
dict[0x29b83] = "sōu"; /* 鮃 */
dict[0x29b84] = "xiū"; /* 鮄 */
dict[0x29b85] = "nà"; /* 鮅 */
dict[0x29b89] = "mán,mián"; /* 鮉 */
dict[0x29b8e] = "zhā"; /* 鮎 */
dict[0x29b8f] = "chán"; /* 鮏 */
dict[0x29b90] = "shè"; /* 鮐 */
dict[0x29b91] = "wǒ"; /* 鮑 */
dict[0x29b96] = "ái"; /* 鮖 */
dict[0x29b97] = "bàng,péng,fǎng"; /* 鮗 */
dict[0x29b98] = "hāo"; /* 鮘 */
dict[0x29b9a] = "sāo"; /* 鮚 */
dict[0x29b9b] = "suǒ"; /* 鮛 */
dict[0x29b9c] = "tì"; /* 鮜 */
dict[0x29b9d] = "yà"; /* 鮝 */
dict[0x29b9f] = "bìng"; /* 鮟 */
dict[0x29ba0] = "róng"; /* 鮠 */
dict[0x29bab] = "shā"; /* 鮫 */
dict[0x29bac] = "wěng"; /* 鮬 */
dict[0x29baf] = "áo"; /* 鮯 */
dict[0x29bb1] = "zhuāng"; /* 鮱 */
dict[0x29bb3] = "piào,piǎo,piē"; /* 鮳 */
dict[0x29bb4] = "suī,cuǐ"; /* 鮴 */
dict[0x29bb5] = "yī"; /* 鮵 */
dict[0x29bb6] = "sōu"; /* 鮶 */
dict[0x29bb7] = "dōu"; /* 鮷 */
dict[0x29bb8] = "sōu,nà"; /* 鮸 */
dict[0x29bb9] = "luó"; /* 鮹 */
dict[0x29bc3] = "fèi,bì"; /* 鯃 */
dict[0x29bc4] = "zùn"; /* 鯄 */
dict[0x29bc6] = "nào"; /* 鯆 */
dict[0x29bc7] = "dēng"; /* 鯇 */
dict[0x29bc8] = "zhí"; /* 鯈 */
dict[0x29bc9] = "cuō"; /* 鯉 */
dict[0x29bca] = "liáo"; /* 鯊 */
dict[0x29bcb] = "jǐ"; /* 鯋 */
dict[0x29bcc] = "bō"; /* 鯌 */
dict[0x29bcd] = "cóng"; /* 鯍 */
dict[0x29bce] = "chéng"; /* 鯎 */
dict[0x29bcf] = "bǔ"; /* 鯏 */
dict[0x29bd1] = "sān"; /* 鯑 */
dict[0x29bd8] = "jiào"; /* 鯘 */
dict[0x29bdb] = "yào"; /* 鯛 */
dict[0x29bdc] = "lǔ"; /* 鯜 */
dict[0x29bde] = "càn"; /* 鯞 */
dict[0x29be8] = "nǐ"; /* 鯨 */
dict[0x29beb] = "bìn"; /* 鯫 */
dict[0x29bf0] = "jié,jì"; /* 鯰 */
dict[0x29bf1] = "pú"; /* 鯱 */
dict[0x29bf2] = "zhuàng"; /* 鯲 */
dict[0x29bf3] = "zàn,zuǎn,zā"; /* 鯳 */
dict[0x29bfa] = "lì"; /* 鯺 */
dict[0x29bfd] = "là"; /* 鯽 */
dict[0x29c00] = "chōng"; /* 鰀 */
dict[0x29c03] = "zhàn"; /* 鰃 */
dict[0x29c0d] = "biàn"; /* 鰍 */
dict[0x29c0e] = "wēng"; /* 鰎 */
dict[0x29c13] = "hòng"; /* 鰓 */
dict[0x29c17] = "pīn"; /* 鰗 */
dict[0x29c19] = "sè"; /* 鰙 */
dict[0x29c1e] = "nǐ"; /* 鰞 */
dict[0x29c1f] = "fēn"; /* 鰟 */
dict[0x29c20] = "xǔ"; /* 鰠 */
dict[0x29c22] = "shǐ"; /* 鰢 */
dict[0x29c24] = "jù"; /* 鰤 */
dict[0x29c28] = "jué"; /* 鰨 */
dict[0x29c2a] = "yù"; /* 鰪 */
dict[0x29c2b] = "guō"; /* 鰫 */
dict[0x29c2c] = "guō,wāi"; /* 鰬 */
dict[0x29c2d] = "guō"; /* 鰭 */
dict[0x29c2f] = "hú"; /* 鰯 */
dict[0x29c31] = "shāng"; /* 鰱 */
dict[0x29c32] = "lì,fèi"; /* 鰲 */
dict[0x29c33] = "xié"; /* 鰳 */
dict[0x29c34] = "ér"; /* 鰴 */
dict[0x29c35] = "yuán"; /* 鰵 */
dict[0x29c36] = "hái,bèn"; /* 鰶 */
dict[0x29c39] = "jìng"; /* 鰹 */
dict[0x29c3b] = "kè"; /* 鰻 */
dict[0x29c3d] = "zōng"; /* 鰽 */
dict[0x29c3e] = "fèi"; /* 鰾 */
dict[0x29c40] = "pēng"; /* 鱀 */
dict[0x29c41] = "gēng"; /* 鱁 */
dict[0x29c43] = "jiān"; /* 鱃 */
dict[0x29c44] = "ní"; /* 鱄 */
dict[0x29c46] = "xián"; /* 鱆 */
dict[0x29c47] = "lì"; /* 鱇 */
dict[0x29c48] = "chǎo"; /* 鱈 */
dict[0x29c4a] = "ér,xiàn"; /* 鱊 */
dict[0x29c4b] = "gēng,pēng"; /* 鱋 */
dict[0x29c4c] = "yù"; /* 鱌 */
dict[0x29c4d] = "hú"; /* 鱍 */
dict[0x29c4e] = "fèi"; /* 鱎 */
dict[0x29c4f] = "áo"; /* 鱏 */
dict[0x29c53] = "ěr"; /* 鱓 */
dict[0x29c58] = "kè"; /* 鱘 */
dict[0x29c59] = "kù"; /* 鱙 */
dict[0x29c5a] = "bó"; /* 鱚 */
dict[0x29c5d] = "yè"; /* 鱝 */
dict[0x29c5e] = "jiào"; /* 鱞 */
dict[0x29c61] = "zhān"; /* 鱡 */
dict[0x29c66] = "chǎo"; /* 鱦 */
dict[0x29c67] = "gēng"; /* 鱧 */
dict[0x29c68] = "rù"; /* 鱨 */
dict[0x29c6a] = "yuè"; /* 鱪 */
dict[0x29c6b] = "sù"; /* 鱫 */
dict[0x29c6c] = "lín"; /* 鱬 */
dict[0x29c71] = "yù"; /* 鱱 */
dict[0x29c72] = "yuè"; /* 鱲 */
dict[0x29c73] = "zhāi"; /* 鱳 */
dict[0x29c74] = "xiāo"; /* 鱴 */
dict[0x29c77] = "miè"; /* 鱷 */
dict[0x29c78] = "miè"; /* 鱸 */
dict[0x29c7b] = "guǐ"; /* 鱻 */
dict[0x29c7c] = "jiū"; /* 鱼 */
dict[0x29c7e] = "tuò"; /* 鱾 */
dict[0x29c81] = "xí"; /* 鲁 */
dict[0x29c82] = "wěi"; /* 鲂 */
dict[0x29c83] = "zhuó"; /* 鲃 */
dict[0x29c84] = "wèi"; /* 鲄 */
dict[0x29c85] = "kuí"; /* 鲅 */
dict[0x29c88] = "mèi,wéi"; /* 鲈 */
dict[0x29c89] = "mèi"; /* 鲉 */
dict[0x29c8a] = "hào"; /* 鲊 */
dict[0x29c8b] = "hāng"; /* 鲋 */
dict[0x29c8c] = "fāng"; /* 鲌 */
dict[0x29c8d] = "niú"; /* 鲍 */
dict[0x29c8e] = "yòu"; /* 鲎 */
dict[0x29c8f] = "huà"; /* 鲏 */
dict[0x29ca0] = "zhú"; /* 鲠 */
dict[0x29ca1] = "guǐ"; /* 鲡 */
dict[0x29ca2] = "bì,mèi"; /* 鲢 */
dict[0x29ca3] = "jiǎ"; /* 鲣 */
dict[0x29ca4] = "tiáo"; /* 鲤 */
dict[0x29ca6] = "lǜ"; /* 鲦 */
dict[0x29ca7] = "kǒng"; /* 鲧 */
dict[0x29ca8] = "zuǐ"; /* 鲨 */
dict[0x29ca9] = "líng"; /* 鲩 */
dict[0x29caa] = "qí"; /* 鲪 */
dict[0x29cac] = "zhú"; /* 鲬 */
dict[0x29cb1] = "gǔ"; /* 鲱 */
dict[0x29cb2] = "zù"; /* 鲲 */
dict[0x29cb4] = "yāng"; /* 鲴 */
dict[0x29cb5] = "sū"; /* 鲵 */
dict[0x29cb7] = "kuí"; /* 鲷 */
dict[0x29cb9] = "chāng"; /* 鲹 */
dict[0x29cbb] = "yáo"; /* 鲻 */
dict[0x29cbe] = "yù"; /* 鲾 */
dict[0x29cc5] = "shū"; /* 鳅 */
dict[0x29cc6] = "lài"; /* 鳆 */
dict[0x29cc7] = "yì"; /* 鳇 */
dict[0x29cc8] = "dōu"; /* 鳈 */
dict[0x29ccb] = "hū"; /* 鳋 */
dict[0x29ccc] = "wú"; /* 鳌 */
dict[0x29ccd] = "yǐng"; /* 鳍 */
dict[0x29cce] = "fú"; /* 鳎 */
dict[0x29ccf] = "zhuàn"; /* 鳏 */
dict[0x29cd0] = "fǔ"; /* 鳐 */
dict[0x29cd1] = "yòu"; /* 鳑 */
dict[0x29cd2] = "sù"; /* 鳒 */
dict[0x29cd3] = "lǐ"; /* 鳓 */
dict[0x29cd4] = "yào"; /* 鳔 */
dict[0x29cd5] = "tuì,tì"; /* 鳕 */
dict[0x29cdd] = "guì"; /* 鳝 */
dict[0x29ce1] = "lǜ"; /* 鳡 */
dict[0x29ce2] = "yàn"; /* 鳢 */
dict[0x29ce3] = "qí"; /* 鳣 */
dict[0x29ce4] = "làng,chāng"; /* 鳤 */
dict[0x29ce5] = "zhú"; /* 鳥 */
dict[0x29ce7] = "guǐ"; /* 鳧 */
dict[0x29ce8] = "hū"; /* 鳨 */
dict[0x29ce9] = "chī"; /* 鳩 */
dict[0x29cef] = "jīng"; /* 鳯 */
dict[0x29cf2] = "chǐ"; /* 鳲 */
dict[0x29cf5] = "jú"; /* 鳵 */
dict[0x29cf6] = "zhá"; /* 鳶 */
dict[0x29cf8] = "miáo"; /* 鳸 */
dict[0x29d00] = "zhū"; /* 鴀 */
dict[0x29d01] = "gān"; /* 鴁 */
dict[0x29d02] = "xiōng"; /* 鴂 */
dict[0x29d03] = "jí"; /* 鴃 */
dict[0x29d07] = "shài"; /* 鴇 */
dict[0x29d08] = "mèi"; /* 鴈 */
dict[0x29d09] = "yùn"; /* 鴉 */
dict[0x29d0d] = "shòu"; /* 鴍 */
dict[0x29d10] = "lǜ"; /* 鴐 */
dict[0x29d11] = "yòu"; /* 鴑 */
dict[0x29d12] = "jiàng"; /* 鴒 */
dict[0x29d13] = "nuó"; /* 鴓 */
dict[0x29d18] = "jù"; /* 鴘 */
dict[0x29d19] = "yòu"; /* 鴙 */
dict[0x29d1c] = "yì"; /* 鴜 */
dict[0x29d1d] = "téng"; /* 鴝 */
dict[0x29d1e] = "wéi"; /* 鴞 */
dict[0x29d1f] = "chě"; /* 鴟 */
dict[0x29d20] = "lìn"; /* 鴠 */
dict[0x29d21] = "gù"; /* 鴡 */
dict[0x29d23] = "lì"; /* 鴣 */
dict[0x29d24] = "liào"; /* 鴤 */
dict[0x29d27] = "jiāo"; /* 鴧 */
dict[0x29d28] = "yáng"; /* 鴨 */
dict[0x29d29] = "biāo"; /* 鴩 */
dict[0x29d2a] = "qí"; /* 鴪 */
dict[0x29d2e] = "yì"; /* 鴮 */
dict[0x29d31] = "bīn"; /* 鴱 */
dict[0x29d32] = "méng"; /* 鴲 */
dict[0x29d33] = "chà"; /* 鴳 */
dict[0x29d34] = "nuó"; /* 鴴 */
dict[0x29d35] = "gān"; /* 鴵 */
dict[0x29d39] = "qú"; /* 鴹 */
dict[0x29d3a] = "dí"; /* 鴺 */
dict[0x29d3b] = "léi"; /* 鴻 */
dict[0x29d40] = "líng"; /* 鵀 */
dict[0x29d44] = "huān"; /* 鵄 */
dict[0x29d45] = "qú"; /* 鵅 */
dict[0x29d47] = "luó"; /* 鵇 */
dict[0x29d49] = "kuí"; /* 鵉 */
dict[0x29d4b] = "yú"; /* 鵋 */
dict[0x29d4d] = "qiú"; /* 鵍 */
dict[0x29d4e] = "yǔ,yú"; /* 鵎 */
dict[0x29d4f] = "huà"; /* 鵏 */
dict[0x29d53] = "lèi"; /* 鵓 */
dict[0x29d55] = "rèn,dāo"; /* 鵕 */
dict[0x29d56] = "xiǎo"; /* 鵖 */
dict[0x29d57] = "sì"; /* 鵗 */
dict[0x29d5a] = "dù"; /* 鵚 */
dict[0x29d5b] = "biē"; /* 鵛 */
dict[0x29d60] = "niú,wěi"; /* 鵠 */
dict[0x29d62] = "hè,zā"; /* 鵢 */
dict[0x29d63] = "pēi"; /* 鵣 */
dict[0x29d65] = "fèi"; /* 鵥 */
dict[0x29d66] = "mù"; /* 鵦 */
dict[0x29d69] = "fū"; /* 鵩 */
dict[0x29d6c] = "hú"; /* 鵬 */
dict[0x29d6d] = "wáng"; /* 鵭 */
dict[0x29d6e] = "shā,xiǎo"; /* 鵮 */
dict[0x29d70] = "jiāo,qiū"; /* 鵰 */
dict[0x29d71] = "wǔ"; /* 鵱 */
dict[0x29d79] = "fù"; /* 鵹 */
dict[0x29d81] = "bǐng"; /* 鶁 */
dict[0x29d82] = "zhù"; /* 鶂 */
dict[0x29d84] = "zhú"; /* 鶄 */
dict[0x29d85] = "chī"; /* 鶅 */
dict[0x29d87] = "shěn"; /* 鶇 */
dict[0x29d88] = "hū"; /* 鶈 */
dict[0x29d89] = "bū"; /* 鶉 */
dict[0x29d8e] = "rǎn"; /* 鶎 */
dict[0x29d91] = "lǔ"; /* 鶑 */
dict[0x29d96] = "mù"; /* 鶖 */
dict[0x29d98] = "lì"; /* 鶘 */
dict[0x29d9b] = "jiā"; /* 鶛 */
dict[0x29d9e] = "mà,háng"; /* 鶞 */
dict[0x29da1] = "méng"; /* 鶡 */
dict[0x29da2] = "móu"; /* 鶢 */
dict[0x29da3] = "zhōu"; /* 鶣 */
dict[0x29da4] = "xiǎn"; /* 鶤 */
dict[0x29da5] = "huǐ,hóng"; /* 鶥 */
dict[0x29da6] = "guài"; /* 鶦 */
dict[0x29da7] = "jiù"; /* 鶧 */
dict[0x29da9] = "mù"; /* 鶩 */
dict[0x29daa] = "chī"; /* 鶪 */
dict[0x29dab] = "rù,xuè"; /* 鶫 */
dict[0x29dad] = "wú"; /* 鶭 */
dict[0x29daf] = "rú"; /* 鶯 */
dict[0x29db1] = "zhà"; /* 鶱 */
dict[0x29dc1] = "nuǒ"; /* 鷁 */
dict[0x29dc2] = "xié"; /* 鷂 */
dict[0x29dc4] = "jiàng"; /* 鷄 */
dict[0x29dcb] = "lǐ"; /* 鷋 */
dict[0x29dcc] = "shū"; /* 鷌 */
dict[0x29dcd] = "yì"; /* 鷍 */
dict[0x29dce] = "dí"; /* 鷎 */
dict[0x29dcf] = "qíng"; /* 鷏 */
dict[0x29dd0] = "jú"; /* 鷐 */
dict[0x29dd1] = "yǎn"; /* 鷑 */
dict[0x29dd3] = "zhì"; /* 鷓 */
dict[0x29dd5] = "láng"; /* 鷕 */
dict[0x29dd6] = "bù"; /* 鷖 */
dict[0x29dd7] = "kuáng"; /* 鷗 */
dict[0x29dd8] = "yì"; /* 鷘 */
dict[0x29dda] = "bó"; /* 鷚 */
dict[0x29de7] = "chì"; /* 鷧 */
dict[0x29ded] = "jiàng"; /* 鷭 */
dict[0x29def] = "wò"; /* 鷯 */
dict[0x29df0] = "xùn"; /* 鷰 */
dict[0x29df5] = "tūn"; /* 鷵 */
dict[0x29df6] = "máng"; /* 鷶 */
dict[0x29df8] = "fáng"; /* 鷸 */
dict[0x29df9] = "zhuó"; /* 鷹 */
dict[0x29dfb] = "qià"; /* 鷻 */
dict[0x29dfc] = "shèng"; /* 鷼 */
dict[0x29dfd] = "tǎ"; /* 鷽 */
dict[0x29dfe] = "qí"; /* 鷾 */
dict[0x29e00] = "pèng"; /* 鸀 */
dict[0x29e01] = "biē"; /* 鸁 */
dict[0x29e02] = "fèn,pèn"; /* 鸂 */
dict[0x29e03] = "tù"; /* 鸃 */
dict[0x29e04] = "huà"; /* 鸄 */
dict[0x29e07] = "è"; /* 鸇 */
dict[0x29e0b] = "è,yā"; /* 鸋 */
dict[0x29e0e] = "dìng"; /* 鸎 */
dict[0x29e10] = "rú"; /* 鸐 */
dict[0x29e16] = "è"; /* 鸖 */
dict[0x29e1e] = "yàn,qí"; /* 鸞 */
dict[0x29e1f] = "sì"; /* 鸟 */
dict[0x29e22] = "lí"; /* 鸢 */
dict[0x29e25] = "yíng"; /* 鸥 */
dict[0x29e26] = "ní"; /* 鸦 */
dict[0x29e27] = "ní"; /* 鸧 */
dict[0x29e28] = "yí"; /* 鸨 */
dict[0x29e29] = "huàn"; /* 鸩 */
dict[0x29e38] = "qī"; /* 鸸 */
dict[0x29e39] = "mí"; /* 鸹 */
dict[0x29e3e] = "yé"; /* 鸾 */
dict[0x29e3f] = "pō"; /* 鸿 */
dict[0x29e40] = "còu"; /* 鹀 */
dict[0x29e42] = "wèi"; /* 鹂 */
dict[0x29e44] = "hài"; /* 鹄 */
dict[0x29e45] = "yīng"; /* 鹅 */
dict[0x29e47] = "tíng"; /* 鹇 */
dict[0x29e48] = "zhì"; /* 鹈 */
dict[0x29e49] = "fēi"; /* 鹉 */
dict[0x29e4a] = "yóu"; /* 鹊 */
dict[0x29e4d] = "kuí"; /* 鹍 */
dict[0x29e4e] = "àn"; /* 鹎 */
dict[0x29e4f] = "bà"; /* 鹏 */
dict[0x29e51] = "hàn"; /* 鹑 */
dict[0x29e5d] = "dú"; /* 鹝 */
dict[0x29e5e] = "nán"; /* 鹞 */
dict[0x29e5f] = "nài"; /* 鹟 */
dict[0x29e62] = "jīng"; /* 鹢 */
dict[0x29e65] = "wēi"; /* 鹥 */
dict[0x29e71] = "chù"; /* 鹱 */
dict[0x29e73] = "suǒ"; /* 鹳 */
dict[0x29e74] = "tāo"; /* 鹴 */
dict[0x29e75] = "qí"; /* 鹵 */
dict[0x29e76] = "táng"; /* 鹶 */
dict[0x29e77] = "wěi"; /* 鹷 */
dict[0x29e78] = "gǎn"; /* 鹸 */
dict[0x29e7a] = "gé"; /* 鹺 */
dict[0x29e7c] = "hàn"; /* 鹼 */
dict[0x29e7e] = "nà"; /* 鹾 */
dict[0x29e7f] = "gé"; /* 鹿 */
dict[0x29e80] = "jì"; /* 麀 */
dict[0x29e84] = "zhēng"; /* 麄 */
dict[0x29e97] = "tǎ,dá"; /* 麗 */
dict[0x29e9b] = "sī"; /* 麛 */
dict[0x29e9d] = "nì"; /* 麝 */
dict[0x29e9e] = "sǎng"; /* 麞 */
dict[0x29eab] = "xié"; /* 麫 */
dict[0x29eaf] = "zú"; /* 麯 */
dict[0x29eb0] = "yú,wú"; /* 麰 */
dict[0x29eb1] = "nì"; /* 麱 */
dict[0x29eb2] = "qī"; /* 麲 */
dict[0x29eb5] = "shēn"; /* 麵 */
dict[0x29ebc] = "bū"; /* 麼 */
dict[0x29ec9] = "zhì"; /* 黉 */
dict[0x29ecb] = "kūn"; /* 黋 */
dict[0x29ecc] = "lí"; /* 黌 */
dict[0x29ece] = "guā"; /* 黎 */
dict[0x29ed6] = "yǎn"; /* 黖 */
dict[0x29ed7] = "bù"; /* 黗 */
dict[0x29ed8] = "jiàn"; /* 默 */
dict[0x29eda] = "wú"; /* 黚 */
dict[0x29edb] = "cén,jīn"; /* 黛 */
dict[0x29edc] = "lín"; /* 黜 */
dict[0x29edd] = "zhuàn"; /* 黝 */
dict[0x29edf] = "huī"; /* 黟 */
dict[0x29ee1] = "tóng"; /* 黡 */
dict[0x29ee2] = "zhǎ"; /* 黢 */
dict[0x29ee4] = "hēi"; /* 黤 */
dict[0x29ee7] = "guǒ"; /* 黧 */
dict[0x29ef1] = "jǐng"; /* 黱 */
dict[0x29ef3] = "lí"; /* 黳 */
dict[0x29ef5] = "dié"; /* 黵 */
dict[0x29ef7] = "yíng"; /* 黷 */
dict[0x29efc] = "zhì"; /* 黼 */
dict[0x29f02] = "wěi"; /* 鼂 */
dict[0x29f04] = "jì"; /* 鼄 */
dict[0x29f05] = "rǒng"; /* 鼅 */
dict[0x29f08] = "ào,yǒu"; /* 鼈 */
dict[0x29f09] = "dāng,hān"; /* 鼉 */
dict[0x29f0a] = "luó"; /* 鼊 */
dict[0x29f0b] = "yè"; /* 鼋 */
dict[0x29f0c] = "wēi"; /* 鼌 */
dict[0x29f12] = "qiáng"; /* 鼒 */
dict[0x29f14] = "nián"; /* 鼔 */
dict[0x29f19] = "gé"; /* 鼙 */
dict[0x29f1a] = "jì"; /* 鼚 */
dict[0x29f26] = "zòu"; /* 鼦 */
dict[0x29f28] = "yí"; /* 鼨 */
dict[0x29f2a] = "yú"; /* 鼪 */
dict[0x29f2b] = "zhǎ"; /* 鼫 */
dict[0x29f2d] = "liè"; /* 鼭 */
dict[0x29f34] = "yè"; /* 鼴 */
dict[0x29f3c] = "zhān"; /* 鼼 */
dict[0x29f40] = "chóu"; /* 齀 */
dict[0x29f41] = "biāo"; /* 齁 */
dict[0x29f46] = "xù"; /* 齆 */
dict[0x29f47] = "yōu"; /* 齇 */
dict[0x29f4d] = "xiè"; /* 齍 */
dict[0x29f4e] = "wéi"; /* 齎 */
dict[0x29f4f] = "lì"; /* 齏 */
dict[0x29f5b] = "bó"; /* 齛 */
dict[0x29f5c] = "jiǎn"; /* 齜 */
dict[0x29f5d] = "chán"; /* 齝 */
dict[0x29f5e] = "kūn"; /* 齞 */
dict[0x29f61] = "qíng"; /* 齡 */
dict[0x29f67] = "shuāng"; /* 齧 */
dict[0x29f68] = "xī"; /* 齨 */
dict[0x29f69] = "qú"; /* 齩 */
dict[0x29f70] = "luó"; /* 齰 */
dict[0x29f73] = "dǎng"; /* 齳 */
dict[0x29f74] = "nián"; /* 齴 */
dict[0x29f75] = "lǐ"; /* 齵 */
dict[0x29f77] = "bà"; /* 齷 */
dict[0x29f92] = "xiāo"; /* 龒 */
dict[0x29f93] = "xiāo"; /* 龓 */
dict[0x29f94] = "cì"; /* 龔 */
dict[0x29f95] = "chì"; /* 龕 */
dict[0x29f97] = "diāo,jiāo"; /* 龗 */
dict[0x29f98] = "yì"; /* 龘 */
dict[0x29f9a] = "dīng"; /* 龚 */
dict[0x29f9d] = "hàn,yàn"; /* 龝 */
dict[0x29f9e] = "wán"; /* 龞 */
dict[0x29fa0] = "yǐ"; /* 龠 */
dict[0x29fa1] = "bào"; /* 龡 */
dict[0x29fa2] = "yì,yuān"; /* 龢 */
dict[0x29fa7] = "xùn"; /* 龧 */
dict[0x29fac] = "xiáng"; /* 龬 */
dict[0x29fb3] = "bí"; /* 龳 */
dict[0x29fb4] = "jiè"; /* 龴 */
dict[0x29fb6] = "jié"; /* 龶 */
dict[0x29fb7] = "gē"; /* 龷 */
dict[0x29fb8] = "zè,yàn"; /* 龸 */
dict[0x29fba] = "zhèn"; /* 龺 */
dict[0x29fbb] = "hú"; /* 龻 */
dict[0x29fbc] = "xī"; /* 龼 */
dict[0x29fbd] = "xīn"; /* 龽 */
dict[0x29fbe] = "xiāo,jiāo"; /* 龾 */
dict[0x29fbf] = "fù"; /* 龿 */
dict[0x29fc0] = "zhòng"; /* 鿀 */
dict[0x29fc2] = "mào"; /* 鿂 */
dict[0x29fc3] = "xīn"; /* 鿃 */
dict[0x29fc4] = "qiāng"; /* 鿄 */
dict[0x29fc5] = "xióng"; /* 鿅 */
dict[0x29fc8] = "fén,fēn"; /* 鿈 */
dict[0x29fc9] = "bān"; /* 鿉 */
dict[0x29fca] = "huān"; /* 鿊 */
dict[0x29fd1] = "jiāo"; /* 鿑 */
dict[0x29fd3] = "bào"; /* 鿓 */
dict[0x29fd4] = "yā"; /* 鿔 */
dict[0x29fd5] = "yáo"; /* 鿕 */
dict[0x29fdb] = "xì"; /* 鿛 */
dict[0x29fdd] = "jù"; /* 鿝 */
dict[0x29fdf] = "qù"; /* 鿟 */
dict[0x29fe0] = "yuè"; /* 鿠 */
dict[0x29fe1] = "tái"; /* 鿡 */
dict[0x29fe2] = "tǒu"; /* 鿢 */
dict[0x29fe3] = "mò"; /* 鿣 */
dict[0x29fe4] = "zhá"; /* 鿤 */
dict[0x29fe5] = "qú"; /* 鿥 */
dict[0x29fe7] = "fū"; /* 鿧 */
dict[0x29fe9] = "qú,duó"; /* 鿩 */
dict[0x29fea] = "chì"; /* 鿪 */
dict[0x29fec] = "yóu"; /* 鿬 */
dict[0x29ff7] = "tí"; /* 鿷 */
dict[0x29ffa] = "wā"; /* 鿺 */
dict[0x29ffd] = "tuó"; /* 鿽 */
dict[0x2a001] = "gē"; /* ꀁ */
dict[0x2a008] = "yuān"; /* ꀈ */
dict[0x2a009] = "gē,kě"; /* ꀉ */
dict[0x2a00a] = "qú,gōu,gòu"; /* ꀊ */
dict[0x2a00f] = "jù,jiū"; /* ꀏ */
dict[0x2a010] = "fú"; /* ꀐ */
dict[0x2a012] = "dié"; /* ꀒ */
dict[0x2a013] = "yí"; /* ꀓ */
dict[0x2a014] = "shī"; /* ꀔ */
dict[0x2a015] = "yì"; /* ꀕ */
dict[0x2a016] = "qiū"; /* ꀖ */
dict[0x2a017] = "guǐ"; /* ꀗ */
dict[0x2a018] = "jiàng"; /* ꀘ */
dict[0x2a01a] = "sōng"; /* ꀚ */
dict[0x2a01b] = "qióng"; /* ꀛ */
dict[0x2a01d] = "è,yuān"; /* ꀝ */
dict[0x2a01e] = "huāng"; /* ꀞ */
dict[0x2a01f] = "huí"; /* ꀟ */
dict[0x2a020] = "xún"; /* ꀠ */
dict[0x2a023] = "jú"; /* ꀣ */
dict[0x2a025] = "zhái"; /* ꀥ */
dict[0x2a026] = "chì"; /* ꀦ */
dict[0x2a027] = "lǎo"; /* ꀧ */
dict[0x2a029] = "qí,dàn,chú"; /* ꀩ */
dict[0x2a02a] = "xiū"; /* ꀪ */
dict[0x2a02c] = "huī"; /* ꀬ */
dict[0x2a02d] = "tóng"; /* ꀭ */
dict[0x2a03a] = "fù"; /* ꀺ */
dict[0x2a03d] = "xún,xīn"; /* ꀽ */
dict[0x2a03e] = "jié"; /* ꀾ */
dict[0x2a03f] = "mǐ"; /* ꀿ */
dict[0x2a040] = "yù"; /* ꁀ */
dict[0x2a048] = "zhuàng"; /* ꁈ */
dict[0x2a049] = "jiāo"; /* ꁉ */
dict[0x2a04a] = "zhì,zhé"; /* ꁊ */
dict[0x2a04b] = "chéng"; /* ꁋ */
dict[0x2a04d] = "jié"; /* ꁍ */
dict[0x2a04e] = "xiāo"; /* ꁎ */
dict[0x2a04f] = "chén"; /* ꁏ */
dict[0x2a050] = "lí"; /* ꁐ */
dict[0x2a051] = "yuè"; /* ꁑ */
dict[0x2a053] = "zhì"; /* ꁓ */
dict[0x2a054] = "láo"; /* ꁔ */
dict[0x2a055] = "wò"; /* ꁕ */
dict[0x2a056] = "qú"; /* ꁖ */
dict[0x2a058] = "wāng"; /* ꁘ */
dict[0x2a05a] = "yī"; /* ꁚ */
dict[0x2a05b] = "yì"; /* ꁛ */
dict[0x2a05c] = "láng"; /* ꁜ */
dict[0x2a05e] = "tóu"; /* ꁞ */
dict[0x2a05f] = "ān,hàn"; /* ꁟ */
dict[0x2a060] = "jué"; /* ꁠ */
dict[0x2a061] = "yàn"; /* ꁡ */
dict[0x2a065] = "jù"; /* ꁥ */
dict[0x2a067] = "zhèn,chén"; /* ꁧ */
dict[0x2a069] = "zhì,tí"; /* ꁩ */
dict[0x2a06a] = "mǎng"; /* ꁪ */
dict[0x2a06e] = "xiù"; /* ꁮ */
dict[0x2a071] = "chuáng"; /* ꁱ */
dict[0x2a072] = "chū"; /* ꁲ */
dict[0x2a078] = "qiāng"; /* ꁸ */
dict[0x2a079] = "fēi"; /* ꁹ */
dict[0x2a07a] = "cháng,chǎng"; /* ꁺ */
dict[0x2a07c] = "mián"; /* ꁼ */
dict[0x2a07d] = "sù"; /* ꁽ */
dict[0x2a07e] = "ǎo,wò"; /* ꁾ */
dict[0x2a080] = "fǔ"; /* ꂀ */
dict[0x2a083] = "bēi"; /* ꂃ */
dict[0x2a084] = "wèi"; /* ꂄ */
dict[0x2a085] = "zhī"; /* ꂅ */
dict[0x2a086] = "mín"; /* ꂆ */
dict[0x2a087] = "chāng"; /* ꂇ */
dict[0x2a088] = "yán"; /* ꂈ */
dict[0x2a089] = "yù"; /* ꂉ */
dict[0x2a08b] = "fù"; /* ꂋ */
dict[0x2a08c] = "tà"; /* ꂌ */
dict[0x2a08d] = "jǐ"; /* ꂍ */
dict[0x2a08f] = "fèi"; /* ꂏ */
dict[0x2a092] = "hú"; /* ꂒ */
dict[0x2a093] = "jū"; /* ꂓ */
dict[0x2a095] = "yǔ"; /* ꂕ */
dict[0x2a09a] = "lù"; /* ꂚ */
dict[0x2a09b] = "qí"; /* ꂛ */
dict[0x2a09c] = "méi"; /* ꂜ */
dict[0x2a09f] = "biē"; /* ꂟ */
dict[0x2a0a0] = "guǒ"; /* ꂠ */
dict[0x2a0a4] = "mìng"; /* ꂤ */
dict[0x2a0a6] = "wǎn,yuān"; /* ꂦ */
dict[0x2a0a7] = "wǎn"; /* ꂧ */
dict[0x2a0b4] = "jīng"; /* ꂴ */
dict[0x2a0b5] = "yù"; /* ꂵ */
dict[0x2a0b6] = "xián"; /* ꂶ */
dict[0x2a0b9] = "chūn"; /* ꂹ */
dict[0x2a0ba] = "jí"; /* ꂺ */
dict[0x2a0bc] = "xiāng"; /* ꂼ */
dict[0x2a0bd] = "pén"; /* ꂽ */
dict[0x2a0be] = "fù"; /* ꂾ */
dict[0x2a0bf] = "tí"; /* ꂿ */
dict[0x2a0c2] = "liú"; /* ꃂ */
dict[0x2a0c4] = "sāi"; /* ꃄ */
dict[0x2a0c5] = "xuē"; /* ꃅ */
dict[0x2a0c6] = "zòu"; /* ꃆ */
dict[0x2a0c8] = "jié"; /* ꃈ */
dict[0x2a0cb] = "zhān,jiān"; /* ꃋ */
dict[0x2a0cd] = "yú"; /* ꃍ */
dict[0x2a0ce] = "yú"; /* ꃎ */
dict[0x2a0cf] = "méi"; /* ꃏ */
dict[0x2a0d0] = "miǎo"; /* ꃐ */
dict[0x2a0d1] = "mào"; /* ꃑ */
dict[0x2a0d2] = "duó"; /* ꃒ */
dict[0x2a0d3] = "fù"; /* ꃓ */
dict[0x2a0db] = "jiàn"; /* ꃛ */
dict[0x2a0e6] = "miáo"; /* ꃦ */
dict[0x2a0e7] = "miǎo"; /* ꃧ */
dict[0x2a0e8] = "āo"; /* ꃨ */
dict[0x2a0ed] = "kè"; /* ꃭ */
dict[0x2a0f6] = "hóu"; /* ꃶ */
dict[0x2a0fa] = "gòu"; /* ꃺ */
dict[0x2a0fc] = "xī"; /* ꃼ */
dict[0x2a0fe] = "róng"; /* ꃾ */
dict[0x2a0ff] = "gē"; /* ꃿ */
dict[0x2a100] = "pán"; /* ꄀ */
dict[0x2a101] = "yuán"; /* ꄁ */
dict[0x2a102] = "xià"; /* ꄂ */
dict[0x2a105] = "shā"; /* ꄅ */
dict[0x2a106] = "pī,pí"; /* ꄆ */
dict[0x2a108] = "qíng"; /* ꄈ */
dict[0x2a109] = "yōng"; /* ꄉ */
dict[0x2a10a] = "qú"; /* ꄊ */
dict[0x2a10c] = "gòng"; /* ꄌ */
dict[0x2a10e] = "gé"; /* ꄎ */
dict[0x2a10f] = "xiān"; /* ꄏ */
dict[0x2a111] = "sù"; /* ꄑ */
dict[0x2a115] = "bān"; /* ꄕ */
dict[0x2a116] = "qí"; /* ꄖ */
dict[0x2a117] = "hòu"; /* ꄗ */
dict[0x2a11b] = "xī"; /* ꄛ */
dict[0x2a11d] = "wū"; /* ꄝ */
dict[0x2a120] = "chì"; /* ꄠ */
dict[0x2a12d] = "qī"; /* ꄭ */
dict[0x2a12e] = "hù,gù"; /* ꄮ */
dict[0x2a12f] = "guī"; /* ꄯ */
dict[0x2a131] = "dí"; /* ꄱ */
dict[0x2a132] = "shāng"; /* ꄲ */
dict[0x2a133] = "mài"; /* ꄳ */
dict[0x2a134] = "mǐn"; /* ꄴ */
dict[0x2a135] = "jì"; /* ꄵ */
dict[0x2a136] = "xí"; /* ꄶ */
dict[0x2a137] = "xiān"; /* ꄷ */
dict[0x2a138] = "jí"; /* ꄸ */
dict[0x2a139] = "cháng"; /* ꄹ */
dict[0x2a13a] = "kòu"; /* ꄺ */
dict[0x2a13b] = "chōng,zhuāng"; /* ꄻ */
dict[0x2a13c] = "yǎo"; /* ꄼ */
dict[0x2a140] = "nán"; /* ꅀ */
dict[0x2a142] = "zhāng"; /* ꅂ */
dict[0x2a143] = "piǎo,piāo"; /* ꅃ */
dict[0x2a144] = "sù"; /* ꅄ */
dict[0x2a145] = "lüè"; /* ꅅ */
dict[0x2a146] = "lí"; /* ꅆ */
dict[0x2a147] = "mèng"; /* ꅇ */
dict[0x2a148] = "chōng"; /* ꅈ */
dict[0x2a149] = "tiān"; /* ꅉ */
dict[0x2a14b] = "líng"; /* ꅋ */
dict[0x2a14d] = "chì"; /* ꅍ */
dict[0x2a156] = "chōng,zhuāng"; /* ꅖ */
dict[0x2a159] = "chì"; /* ꅙ */
dict[0x2a15d] = "niǎo"; /* ꅝ */
dict[0x2a15f] = "yóng"; /* ꅟ */
dict[0x2a161] = "liù"; /* ꅡ */
dict[0x2a16e] = "mì"; /* ꅮ */
dict[0x2a170] = "shū"; /* ꅰ */
dict[0x2a172] = "xì"; /* ꅲ */
dict[0x2a173] = "liú"; /* ꅳ */
dict[0x2a174] = "è"; /* ꅴ */
dict[0x2a175] = "zī"; /* ꅵ */
dict[0x2a178] = "jié"; /* ꅸ */
dict[0x2a179] = "jī"; /* ꅹ */
dict[0x2a17a] = "hōu"; /* ꅺ */
dict[0x2a17b] = "shèng"; /* ꅻ */
dict[0x2a17c] = "lì"; /* ꅼ */
dict[0x2a17e] = "qī"; /* ꅾ */
dict[0x2a180] = "zhōu"; /* ꆀ */
dict[0x2a181] = "sī"; /* ꆁ */
dict[0x2a182] = "qú"; /* ꆂ */
dict[0x2a184] = "jiāo"; /* ꆄ */
dict[0x2a18b] = "xié"; /* ꆋ */
dict[0x2a193] = "sī"; /* ꆓ */
dict[0x2a196] = "yì"; /* ꆖ */
dict[0x2a197] = "sī"; /* ꆗ */
dict[0x2a19b] = "xū"; /* ꆛ */
dict[0x2a1a0] = "fù"; /* ꆠ */
dict[0x2a1a9] = "jiù"; /* ꆩ */
dict[0x2a1ab] = "qú"; /* ꆫ */
dict[0x2a1af] = "nóng"; /* ꆯ */
dict[0x2a1b0] = "yà"; /* ꆰ */
dict[0x2a1b1] = "liú"; /* ꆱ */
dict[0x2a1b2] = "jiǎ,zhān"; /* ꆲ */
dict[0x2a1b3] = "guī"; /* ꆳ */
dict[0x2a1b4] = "kuí"; /* ꆴ */
dict[0x2a1b5] = "chì"; /* ꆵ */
dict[0x2a1b6] = "càn"; /* ꆶ */
dict[0x2a1b7] = "chú"; /* ꆷ */
dict[0x2a1b9] = "guō"; /* ꆹ */
dict[0x2a1bb] = "dǎn"; /* ꆻ */
dict[0x2a1bf] = "jiàn"; /* ꆿ */
dict[0x2a1c1] = "dāng"; /* ꇁ */
dict[0x2a1c2] = "hòu"; /* ꇂ */
dict[0x2a1c4] = "kòu,kū"; /* ꇄ */
dict[0x2a1c6] = "chù,dú"; /* ꇆ */
dict[0x2a1c7] = "qiān"; /* ꇇ */
dict[0x2a1c8] = "ài"; /* ꇈ */
dict[0x2a1ca] = "pì"; /* ꇊ */
dict[0x2a1d1] = "xùn"; /* ꇑ */
dict[0x2a1d2] = "jīng"; /* ꇒ */
dict[0x2a1d3] = "mèng"; /* ꇓ */
dict[0x2a1d5] = "bīn"; /* ꇕ */
dict[0x2a1d6] = "lán"; /* ꇖ */
dict[0x2a1d7] = "gǔ"; /* ꇗ */
dict[0x2a1d8] = "chóu,táo"; /* ꇘ */
dict[0x2a1db] = "yōng"; /* ꇛ */
dict[0x2a1dc] = "guá"; /* ꇜ */
dict[0x2a1dd] = "yú"; /* ꇝ */
dict[0x2a1de] = "zhòu"; /* ꇞ */
dict[0x2a1ec] = "yù"; /* ꇬ */
dict[0x2a1ed] = "cài"; /* ꇭ */
dict[0x2a1ef] = "liú"; /* ꇯ */
dict[0x2a1f0] = "bǔ"; /* ꇰ */
dict[0x2a1f1] = "luò"; /* ꇱ */
dict[0x2a1f2] = "jié"; /* ꇲ */
dict[0x2a1f3] = "zhēn"; /* ꇳ */
dict[0x2a1f4] = "miè"; /* ꇴ */
dict[0x2a1f5] = "guǎng"; /* ꇵ */
dict[0x2a1f7] = "jiá"; /* ꇷ */
dict[0x2a1f9] = "là"; /* ꇹ */
dict[0x2a200] = "shòu"; /* ꈀ */
dict[0x2a201] = "zhēn"; /* ꈁ */
dict[0x2a203] = "guō"; /* ꈃ */
dict[0x2a205] = "jú"; /* ꈅ */
dict[0x2a206] = "mèng"; /* ꈆ */
dict[0x2a207] = "qián"; /* ꈇ */
dict[0x2a208] = "lài"; /* ꈈ */
dict[0x2a20a] = "hé"; /* ꈊ */
dict[0x2a20b] = "tuán"; /* ꈋ */
dict[0x2a211] = "huī"; /* ꈑ */
dict[0x2a212] = "lú"; /* ꈒ */
dict[0x2a218] = "hōng"; /* ꈘ */
dict[0x2a21c] = "lǚ"; /* ꈜ */
dict[0x2a21f] = "jiá"; /* ꈟ */
dict[0x2a225] = "guī"; /* ꈥ */
dict[0x2a228] = "yī"; /* ꈨ */
dict[0x2a229] = "huān"; /* ꈩ */
dict[0x2a230] = "luó"; /* ꈰ */
dict[0x2a234] = "jué"; /* ꈴ */
dict[0x2a238] = "guàn"; /* ꈸ */
dict[0x2a23b] = "quán"; /* ꈻ */
dict[0x2a23c] = "niǎo"; /* ꈼ */
dict[0x2a23f] = "mán"; /* ꈿ */
dict[0x2a253] = "niǎo"; /* ꉓ */
dict[0x2a256] = "lǔ"; /* ꉖ */
dict[0x2a257] = "chì"; /* ꉗ */
dict[0x2a258] = "tóu"; /* ꉘ */
dict[0x2a25a] = "jiē"; /* ꉚ */
dict[0x2a25c] = "zhān"; /* ꉜ */
dict[0x2a262] = "jīn"; /* ꉢ */
dict[0x2a263] = "lǔ"; /* ꉣ */
dict[0x2a264] = "cuó"; /* ꉤ */
dict[0x2a266] = "jiàn,jiǎn,gàn"; /* ꉦ */
dict[0x2a267] = "tàn"; /* ꉧ */
dict[0x2a268] = "chāng"; /* ꉨ */
dict[0x2a26a] = "cì"; /* ꉪ */
dict[0x2a26d] = "wāi"; /* ꉭ */
dict[0x2a26e] = "còu"; /* ꉮ */
dict[0x2a26f] = "kàn"; /* ꉯ */
dict[0x2a271] = "biàn"; /* ꉱ */
dict[0x2a277] = "tán"; /* ꉷ */
dict[0x2a278] = "wēn"; /* ꉸ */
dict[0x2a27b] = "qiān"; /* ꉻ */
dict[0x2a27f] = "gàn"; /* ꉿ */
dict[0x2a282] = "huì"; /* ꊂ */
dict[0x2a284] = "gǎn,gàn"; /* ꊄ */
dict[0x2a286] = "jì"; /* ꊆ */
dict[0x2a287] = "gàn,tàn"; /* ꊇ */
dict[0x2a289] = "huái"; /* ꊉ */
dict[0x2a28b] = "jǐ"; /* ꊋ */
dict[0x2a28d] = "sì"; /* ꊍ */
dict[0x2a290] = "fū"; /* ꊐ */
dict[0x2a295] = "pí"; /* ꊕ */
dict[0x2a297] = "cā"; /* ꊗ */
dict[0x2a29c] = "bèn"; /* ꊜ */
dict[0x2a2a2] = "shǐ"; /* ꊢ */
dict[0x2a2a5] = "huán"; /* ꊥ */
dict[0x2a2a7] = "guī"; /* ꊧ */
dict[0x2a2a8] = "jǐ"; /* ꊨ */
dict[0x2a2aa] = "ǒu"; /* ꊪ */
dict[0x2a2b3] = "páo"; /* ꊳ */
dict[0x2a2b5] = "yǐng"; /* ꊵ */
dict[0x2a2b6] = "tǐng"; /* ꊶ */
dict[0x2a2b7] = "xiào"; /* ꊷ */
dict[0x2a2b9] = "zhù"; /* ꊹ */
dict[0x2a2bb] = "yú"; /* ꊻ */
dict[0x2a2c1] = "jiàn"; /* ꋁ */
dict[0x2a2c4] = "qǔ"; /* ꋄ */
dict[0x2a2c5] = "wǎn"; /* ꋅ */
dict[0x2a2c6] = "kūn"; /* ꋆ */
dict[0x2a2c7] = "zhuī"; /* ꋇ */
dict[0x2a2c9] = "yù"; /* ꋉ */
dict[0x2a2ca] = "guǒ"; /* ꋊ */
dict[0x2a2cb] = "píng"; /* ꋋ */
dict[0x2a2cc] = "zuǐ"; /* ꋌ */
dict[0x2a2cd] = "zú"; /* ꋍ */
dict[0x2a2cf] = "zhū"; /* ꋏ */
dict[0x2a2d0] = "nuàn"; /* ꋐ */
dict[0x2a2d1] = "zhū"; /* ꋑ */
dict[0x2a2d6] = "piāo"; /* ꋖ */
dict[0x2a2d7] = "mí"; /* ꋗ */
dict[0x2a2dc] = "bì"; /* ꋜ */
dict[0x2a2dd] = "sù"; /* ꋝ */
dict[0x2a2e1] = "pú"; /* ꋡ */
dict[0x2a2e2] = "mí"; /* ꋢ */
dict[0x2a2e7] = "shè"; /* ꋧ */
dict[0x2a2eb] = "yè"; /* ꋫ */
dict[0x2a2ec] = "yǔ"; /* ꋬ */
dict[0x2a2ee] = "yù"; /* ꋮ */
dict[0x2a2f0] = "zhǔ"; /* ꋰ */
dict[0x2a2f3] = "líng"; /* ꋳ */
dict[0x2a2fa] = "nòu"; /* ꋺ */
dict[0x2a2fb] = "chén"; /* ꋻ */
dict[0x2a2fe] = "líng"; /* ꋾ */
dict[0x2a300] = "liǎo"; /* ꌀ */
dict[0x2a302] = "tuō"; /* ꌂ */
dict[0x2a304] = "bǐ"; /* ꌄ */
dict[0x2a305] = "nà"; /* ꌅ */
dict[0x2a306] = "qú"; /* ꌆ */
dict[0x2a308] = "pí"; /* ꌈ */
dict[0x2a309] = "dǒu"; /* ꌉ */
dict[0x2a30a] = "niè"; /* ꌊ */
dict[0x2a30b] = "tún"; /* ꌋ */
dict[0x2a30d] = "jī"; /* ꌍ */
dict[0x2a30f] = "líng"; /* ꌏ */
dict[0x2a313] = "kù"; /* ꌓ */
dict[0x2a314] = "sù"; /* ꌔ */
dict[0x2a318] = "tǒu"; /* ꌘ */
dict[0x2a31e] = "nái"; /* ꌞ */
dict[0x2a31f] = "zé"; /* ꌟ */
dict[0x2a322] = "tǒng"; /* ꌢ */
dict[0x2a323] = "gé"; /* ꌣ */
dict[0x2a324] = "duī"; /* ꌤ */
dict[0x2a327] = "jié"; /* ꌧ */
dict[0x2a329] = "tián"; /* ꌩ */
dict[0x2a32a] = "tiào"; /* ꌪ */
dict[0x2a32b] = "chí"; /* ꌫ */
dict[0x2a32c] = "qū,chǎo"; /* ꌬ */
dict[0x2a32e] = "shā,suō"; /* ꌮ */
dict[0x2a330] = "bó"; /* ꌰ */
dict[0x2a331] = "lí"; /* ꌱ */
dict[0x2a333] = "luò"; /* ꌳ */
dict[0x2a335] = "liáo"; /* ꌵ */
dict[0x2a336] = "shù"; /* ꌶ */
dict[0x2a337] = "děng"; /* ꌷ */
dict[0x2a339] = "chī"; /* ꌹ */
dict[0x2a33a] = "miè"; /* ꌺ */
dict[0x2a33c] = "táo"; /* ꌼ */
dict[0x2a33d] = "hún"; /* ꌽ */
dict[0x2a33f] = "nié"; /* ꌿ */
dict[0x2a341] = "jùn"; /* ꍁ */
dict[0x2a342] = "hù"; /* ꍂ */
dict[0x2a344] = "lù"; /* ꍄ */
dict[0x2a345] = "yè"; /* ꍅ */
dict[0x2a347] = "mò,chǎo"; /* ꍇ */
dict[0x2a348] = "chào"; /* ꍈ */
dict[0x2a34c] = "suò"; /* ꍌ */
dict[0x2a34e] = "kē"; /* ꍎ */
dict[0x2a34f] = "fù"; /* ꍏ */
dict[0x2a351] = "chǎo"; /* ꍑ */
dict[0x2a354] = "suǒ"; /* ꍔ */
dict[0x2a357] = "qiū"; /* ꍗ */
dict[0x2a35b] = "sù,xiè"; /* ꍛ */
dict[0x2a35d] = "yùn"; /* ꍝ */
dict[0x2a35f] = "suǒ"; /* ꍟ */
dict[0x2a360] = "kū"; /* ꍠ */
dict[0x2a361] = "bó"; /* ꍡ */
dict[0x2a363] = "lǒu"; /* ꍣ */
dict[0x2a364] = "mò"; /* ꍤ */
dict[0x2a366] = "liǎn"; /* ꍦ */
dict[0x2a367] = "xuàn"; /* ꍧ */
dict[0x2a368] = "suǒ"; /* ꍨ */
dict[0x2a369] = "mán"; /* ꍩ */
dict[0x2a36a] = "bì"; /* ꍪ */
dict[0x2a372] = "tì"; /* ꍲ */
dict[0x2a374] = "lián"; /* ꍴ */
dict[0x2a375] = "tán"; /* ꍵ */
dict[0x2a376] = "shàn"; /* ꍶ */
dict[0x2a378] = "qú"; /* ꍸ */
dict[0x2a379] = "dú"; /* ꍹ */
dict[0x2a37a] = "huán,huàn"; /* ꍺ */
dict[0x2a37b] = "sào"; /* ꍻ */
dict[0x2a37f] = "kuàng"; /* ꍿ */
dict[0x2a383] = "niè"; /* ꎃ */
dict[0x2a385] = "niè"; /* ꎅ */
dict[0x2a386] = "luó"; /* ꎆ */
dict[0x2a387] = "zuó"; /* ꎇ */
dict[0x2a38a] = "chǎo"; /* ꎊ */
dict[0x2a38b] = "tiè"; /* ꎋ */
dict[0x2a392] = "shuò"; /* ꎒ */
dict[0x2a394] = "mǐ"; /* ꎔ */
dict[0x2a397] = "mí"; /* ꎗ */
dict[0x2a39b] = "wǎn"; /* ꎛ */
dict[0x2a39d] = "bèn"; /* ꎝ */
dict[0x2a39e] = "qiāng"; /* ꎞ */
dict[0x2a3a0] = "mǒ"; /* ꎠ */
dict[0x2a3a3] = "liú"; /* ꎣ */
dict[0x2a3a4] = "wò"; /* ꎤ */
dict[0x2a3a6] = "měi"; /* ꎦ */
dict[0x2a3a8] = "tóu"; /* ꎨ */
dict[0x2a3ab] = "mǔ"; /* ꎫ */
dict[0x2a3ad] = "méi"; /* ꎭ */
dict[0x2a3ae] = "huī"; /* ꎮ */
dict[0x2a3b2] = "zuò"; /* ꎲ */
dict[0x2a3b4] = "tún"; /* ꎴ */
dict[0x2a3b5] = "kàng"; /* ꎵ */
dict[0x2a3b6] = "tún"; /* ꎶ */
dict[0x2a3ba] = "chè"; /* ꎺ */
dict[0x2a3bb] = "zhèng"; /* ꎻ */
dict[0x2a3bd] = "chōng"; /* ꎽ */
dict[0x2a3be] = "tiān"; /* ꎾ */
dict[0x2a3c0] = "zhì"; /* ꏀ */
dict[0x2a3c1] = "chán"; /* ꏁ */
dict[0x2a3c2] = "chán"; /* ꏂ */
dict[0x2a3c5] = "qīng"; /* ꏅ */
dict[0x2a3c6] = "tūn"; /* ꏆ */
dict[0x2a3c7] = "huǐ"; /* ꏇ */
dict[0x2a3c8] = "què"; /* ꏈ */
dict[0x2a3c9] = "zhān"; /* ꏉ */
dict[0x2a3ca] = "jiān,miǎn"; /* ꏊ */
dict[0x2a3cb] = "chán"; /* ꏋ */
dict[0x2a3cd] = "huáng"; /* ꏍ */
dict[0x2a3cf] = "huī"; /* ꏏ */
dict[0x2a3d0] = "chí"; /* ꏐ */
dict[0x2a3d2] = "huáng"; /* ꏒ */
dict[0x2a3d3] = "héng"; /* ꏓ */
dict[0x2a3d4] = "yǔn"; /* ꏔ */
dict[0x2a3d6] = "tuān"; /* ꏖ */
dict[0x2a3d7] = "biān"; /* ꏗ */
dict[0x2a3d9] = "huáng"; /* ꏙ */
dict[0x2a3da] = "yǔn"; /* ꏚ */
dict[0x2a3df] = "mò"; /* ꏟ */
dict[0x2a3e0] = "gōng"; /* ꏠ */
dict[0x2a3e2] = "gōng"; /* ꏢ */
dict[0x2a3e4] = "guì"; /* ꏤ */
dict[0x2a3e6] = "chán"; /* ꏦ */
dict[0x2a3e8] = "què"; /* ꏨ */
dict[0x2a3e9] = "ruì"; /* ꏩ */
dict[0x2a3ea] = "kuàng"; /* ꏪ */
dict[0x2a3eb] = "piào"; /* ꏫ */
dict[0x2a3ee] = "rǔ"; /* ꏮ */
dict[0x2a3f2] = "niǔ"; /* ꏲ */
dict[0x2a3f3] = "hù"; /* ꏳ */
dict[0x2a3f4] = "jǐn"; /* ꏴ */
dict[0x2a3f5] = "nì,lí"; /* ꏵ */
dict[0x2a3f6] = "bào"; /* ꏶ */
dict[0x2a3f8] = "nǐ,chī"; /* ꏸ */
dict[0x2a3fa] = "bì"; /* ꏺ */
dict[0x2a3fb] = "hú"; /* ꏻ */
dict[0x2a3fc] = "lí"; /* ꏼ */
dict[0x2a3ff] = "zhū"; /* ꏿ */
dict[0x2a400] = "nǎ"; /* ꐀ */
dict[0x2a402] = "quǎn"; /* ꐂ */
dict[0x2a403] = "fěng"; /* ꐃ */
dict[0x2a404] = "bǐ"; /* ꐄ */
dict[0x2a405] = "lí"; /* ꐅ */
dict[0x2a406] = "bié"; /* ꐆ */
dict[0x2a407] = "nián"; /* ꐇ */
dict[0x2a408] = "dǒng"; /* ꐈ */
dict[0x2a40b] = "lián"; /* ꐋ */
dict[0x2a40c] = "nì"; /* ꐌ */
dict[0x2a40d] = "lián"; /* ꐍ */
dict[0x2a40e] = "má"; /* ꐎ */
dict[0x2a40f] = "zhé,zhí"; /* ꐏ */
dict[0x2a413] = "jiā"; /* ꐓ */
dict[0x2a414] = "yí"; /* ꐔ */
dict[0x2a416] = "lǒng"; /* ꐖ */
dict[0x2a418] = "yì,yān"; /* ꐘ */
dict[0x2a41d] = "dài,tài"; /* ꐝ */
dict[0x2a41e] = "dù"; /* ꐞ */
dict[0x2a423] = "yǐ"; /* ꐣ */
dict[0x2a425] = "tài"; /* ꐥ */
dict[0x2a426] = "hāng"; /* ꐦ */
dict[0x2a427] = "shù"; /* ꐧ */
dict[0x2a42c] = "wán"; /* ꐬ */
dict[0x2a42e] = "sù"; /* ꐮ */
dict[0x2a42f] = "yǎo"; /* ꐯ */
dict[0x2a430] = "èr"; /* ꐰ */
dict[0x2a432] = "zhèn"; /* ꐲ */
dict[0x2a43a] = "dòu"; /* ꐺ */
dict[0x2a43b] = "jiān"; /* ꐻ */
dict[0x2a43f] = "pāng"; /* ꐿ */
dict[0x2a440] = "huī"; /* ꑀ */
dict[0x2a442] = "chà"; /* ꑂ */
dict[0x2a443] = "shān"; /* ꑃ */
dict[0x2a444] = "lú"; /* ꑄ */
dict[0x2a446] = "yù"; /* ꑆ */
dict[0x2a448] = "yàn"; /* ꑈ */
dict[0x2a449] = "wǎn"; /* ꑉ */
dict[0x2a44a] = "qiào"; /* ꑊ */
dict[0x2a44b] = "luō"; /* ꑋ */
dict[0x2a44c] = "yù"; /* ꑌ */
dict[0x2a44f] = "tú"; /* ꑏ */
dict[0x2a450] = "wèi"; /* ꑐ */
dict[0x2a452] = "tùn"; /* ꑒ */
dict[0x2a455] = "hǔn"; /* ꑕ */
dict[0x2a456] = "bēn"; /* ꑖ */
dict[0x2a457] = "qiè"; /* ꑗ */
dict[0x2a459] = "jīn,qián"; /* ꑙ */
dict[0x2a45a] = "lái,lí"; /* ꑚ */
dict[0x2a45c] = "zhǐ"; /* ꑜ */
dict[0x2a45d] = "yú"; /* ꑝ */
dict[0x2a45f] = "cì"; /* ꑟ */
dict[0x2a466] = "yè"; /* ꑦ */
dict[0x2a467] = "dié"; /* ꑧ */
dict[0x2a468] = "chà"; /* ꑨ */
dict[0x2a469] = "diàn"; /* ꑩ */
dict[0x2a46a] = "mán"; /* ꑪ */
dict[0x2a46c] = "dèng"; /* ꑬ */
dict[0x2a46d] = "wēi"; /* ꑭ */
dict[0x2a46e] = "niǎn"; /* ꑮ */
dict[0x2a46f] = "lèi"; /* ꑯ */
dict[0x2a470] = "bīng"; /* ꑰ */
dict[0x2a471] = "wū,wò"; /* ꑱ */
dict[0x2a472] = "yuè"; /* ꑲ */
dict[0x2a473] = "zhěn"; /* ꑳ */
dict[0x2a476] = "róu"; /* ꑶ */
dict[0x2a477] = "wài"; /* ꑷ */
dict[0x2a478] = "mì,yān"; /* ꑸ */
dict[0x2a479] = "jiè"; /* ꑹ */
dict[0x2a47b] = "hóu"; /* ꑻ */
dict[0x2a47d] = "zhài"; /* ꑽ */
dict[0x2a47e] = "rǔ"; /* ꑾ */
dict[0x2a47f] = "zī"; /* ꑿ */
dict[0x2a480] = "pán"; /* ꒀ */
dict[0x2a482] = "mò"; /* ꒂ */
dict[0x2a484] = "mì"; /* ꒄ */
dict[0x2a486] = "qī"; /* ꒆ */
dict[0x2a487] = "mò"; /* ꒇ */
dict[0x2a489] = "dì"; /* ꒉ */
dict[0x2a48a] = "zhī"; /* ꒊ */
dict[0x2a48b] = "bān,pán"; /* ꒋ */
dict[0x2a48d] = "miè"; /* ꒍ */
dict[0x2a48f] = "lù"; /* ꒏ */
dict[0x2a491] = "qī"; /* ꒑ */
dict[0x2a492] = "chōng"; /* ꒒ */
dict[0x2a494] = "lí"; /* ꒔ */
dict[0x2a495] = "yì"; /* ꒕ */
dict[0x2a498] = "dèng"; /* ꒘ */
dict[0x2a499] = "cuō"; /* ꒙ */
dict[0x2a49b] = "duì"; /* ꒛ */
dict[0x2a49c] = "mà"; /* ꒜ */
dict[0x2a49d] = "yǎn"; /* ꒝ */
dict[0x2a49f] = "zèng"; /* ꒟ */
dict[0x2a4a0] = "yǎn,ǎn,àn"; /* ꒠ */
dict[0x2a4a1] = "duì,dài"; /* ꒡ */
dict[0x2a4a2] = "pū"; /* ꒢ */
dict[0x2a4a5] = "yuè"; /* ꒥ */
dict[0x2a4a9] = "huò"; /* ꒩ */
dict[0x2a4aa] = "mài"; /* ꒪ */
dict[0x2a4ab] = "jiǎn"; /* ꒫ */
dict[0x2a4ac] = "nóng"; /* ꒬ */
dict[0x2a4ad] = "qín"; /* ꒭ */
dict[0x2a4af] = "qín"; /* ꒯ */
dict[0x2a4b2] = "yè"; /* ꒲ */
dict[0x2a4b4] = "tái"; /* ꒴ */
dict[0x2a4b9] = "jiān"; /* ꒹ */
dict[0x2a4bc] = "chá"; /* ꒼ */
dict[0x2a4be] = "dàn"; /* ꒾ */
dict[0x2a4bf] = "téng"; /* ꒿ */
dict[0x2a4c0] = "lì"; /* ꓀ */
dict[0x2a4c3] = "niǎng"; /* ꓃ */
dict[0x2a4c4] = "chán"; /* ꓄ */
dict[0x2a4c5] = "zāng"; /* ꓅ */
dict[0x2a4ca] = "yù"; /* ꓊ */
dict[0x2a4cb] = "mǐ"; /* ꓋ */
dict[0x2a4cc] = "zuì"; /* ꓌ */
dict[0x2a4cd] = "biān"; /* ꓍ */
dict[0x2a4d0] = "chǔ"; /* ꓐ */
dict[0x2a4d8] = "rán"; /* ꓘ */
dict[0x2a4da] = "rán"; /* ꓚ */
dict[0x2a4db] = "yāng"; /* ꓛ */
dict[0x2a4dc] = "bǒ"; /* ꓜ */
dict[0x2a4e1] = "cù"; /* ꓡ */
dict[0x2a4ec] = "mí"; /* ꓬ */
dict[0x2a4ee] = "kě"; /* ꓮ */
dict[0x2a4f0] = "cù"; /* ꓰ */
dict[0x2a4f7] = "xí"; /* ꓷ */
dict[0x2a4f9] = "má"; /* ꓹ */
dict[0x2a4fb] = "shī"; /* ꓻ */
dict[0x2a4fc] = "diān"; /* ꓼ */
dict[0x2a4ff] = "shī"; /* ꓿ */
dict[0x2a502] = "dǐng"; /* ꔂ */
dict[0x2a503] = "jiōng"; /* ꔃ */
dict[0x2a505] = "yuán"; /* ꔅ */
dict[0x2a506] = "gān"; /* ꔆ */
dict[0x2a50a] = "huì"; /* ꔊ */
dict[0x2a50b] = "jī"; /* ꔋ */
dict[0x2a50d] = "péng"; /* ꔍ */
dict[0x2a50f] = "dēng"; /* ꔏ */
dict[0x2a511] = "bèng"; /* ꔑ */
dict[0x2a514] = "pāng,péng"; /* ꔔ */
dict[0x2a515] = "tà,lóng"; /* ꔕ */
dict[0x2a517] = "yuān"; /* ꔗ */
dict[0x2a518] = "gāo"; /* ꔘ */
dict[0x2a519] = "yuān"; /* ꔙ */
dict[0x2a51f] = "jiā"; /* ꔟ */
dict[0x2a523] = "kōng"; /* ꔣ */
dict[0x2a526] = "dòng"; /* ꔦ */
dict[0x2a529] = "xián"; /* ꔩ */
dict[0x2a52a] = "qì"; /* ꔪ */
dict[0x2a52c] = "sāng"; /* ꔬ */
dict[0x2a530] = "yìn"; /* ꔰ */
dict[0x2a533] = "lóng"; /* ꔳ */
dict[0x2a536] = "tēng"; /* ꔶ */
dict[0x2a537] = "lóng"; /* ꔷ */
dict[0x2a53a] = "rèn"; /* ꔺ */
dict[0x2a53d] = "yìn"; /* ꔽ */
dict[0x2a53e] = "píng"; /* ꔾ */
dict[0x2a53f] = "pū"; /* ꔿ */
dict[0x2a540] = "yuán"; /* ꕀ */
dict[0x2a541] = "rǒng,chén"; /* ꕁ */
dict[0x2a543] = "fāng"; /* ꕃ */
dict[0x2a547] = "hāng"; /* ꕇ */
dict[0x2a548] = "mí"; /* ꕈ */
dict[0x2a549] = "hú"; /* ꕉ */
dict[0x2a54a] = "zī"; /* ꕊ */
dict[0x2a54c] = "líng"; /* ꕌ */
dict[0x2a54d] = "jiōng"; /* ꕍ */
dict[0x2a54e] = "rǒng"; /* ꕎ */
dict[0x2a552] = "píng"; /* ꕒ */
dict[0x2a553] = "guāng"; /* ꕓ */
dict[0x2a554] = "ěr"; /* ꕔ */
dict[0x2a55a] = "liú"; /* ꕚ */
dict[0x2a55d] = "cù"; /* ꕝ */
dict[0x2a55e] = "jùn"; /* ꕞ */
dict[0x2a566] = "xiǔ"; /* ꕦ */
dict[0x2a568] = "ér"; /* ꕨ */
dict[0x2a569] = "tì"; /* ꕩ */
dict[0x2a56b] = "yáng"; /* ꕫ */
dict[0x2a56d] = "ài"; /* ꕭ */
dict[0x2a56e] = "hú"; /* ꕮ */
dict[0x2a56f] = "xí,xié"; /* ꕯ */
dict[0x2a571] = "hú"; /* ꕱ */
dict[0x2a573] = "sī"; /* ꕳ */
dict[0x2a574] = "lǐ"; /* ꕴ */
dict[0x2a576] = "yì"; /* ꕶ */
dict[0x2a577] = "gǔ"; /* ꕷ */
dict[0x2a579] = "táng"; /* ꕹ */
dict[0x2a580] = "què"; /* ꖀ */
dict[0x2a581] = "zōng"; /* ꖁ */
dict[0x2a582] = "lí"; /* ꖂ */
dict[0x2a584] = "jiào"; /* ꖄ */
dict[0x2a587] = "fán"; /* ꖇ */
dict[0x2a588] = "pú"; /* ꖈ */
dict[0x2a589] = "sī"; /* ꖉ */
dict[0x2a58b] = "jié"; /* ꖋ */
dict[0x2a58c] = "lú"; /* ꖌ */
dict[0x2a58d] = "lì"; /* ꖍ */
dict[0x2a58e] = "chán"; /* ꖎ */
dict[0x2a590] = "yào,yà"; /* ꖐ */
dict[0x2a595] = "huī"; /* ꖕ */
dict[0x2a599] = "hōu"; /* ꖙ */

export default dict;
